
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire716c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire716c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2tbKl", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $c3YnH = parcelRequire("c3YnH");
function $1cc766ccf0672393$var$emptyFunction() {}
function $1cc766ccf0672393$var$emptyFunctionWithReset() {}
$1cc766ccf0672393$var$emptyFunctionWithReset.resetWarningCache = $1cc766ccf0672393$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $c3YnH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $1cc766ccf0672393$var$emptyFunctionWithReset,
        resetWarningCache: $1cc766ccf0672393$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("c3YnH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $8c849a51633fc8b0$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $8c849a51633fc8b0$var$ReactPropTypesSecret;

});


parcelRegister("3pCEE", function(module, exports) {

var $ksFZL = parcelRequire("ksFZL");

var $b2LMJ = parcelRequire("b2LMJ");

var $4wJiQ = parcelRequire("4wJiQ");

var $kkUMX = parcelRequire("kkUMX");

var $emaCp = parcelRequire("emaCp");

var $eikvB = parcelRequire("eikvB");

var $6t0Zx = parcelRequire("6t0Zx");
function $27c1b0e942ce910b$var$_regeneratorRuntime() {
    "use strict";
    var r = $b2LMJ(), e = r.m($27c1b0e942ce910b$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $6t0Zx(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $27c1b0e942ce910b$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $ksFZL(r, e);
            },
            AsyncIterator: $emaCp,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $kkUMX : $4wJiQ)(a(r), e, t, o, u);
            },
            keys: $eikvB,
            values: $6t0Zx
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $27c1b0e942ce910b$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ksFZL", function(module, exports) {
function $03d81ce53d26901c$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $03d81ce53d26901c$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("b2LMJ", function(module, exports) {

var $8PVmt = parcelRequire("8PVmt");
function $80a4f2b8b3c1e910$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $8PVmt(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($8PVmt(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $8PVmt(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $8PVmt(u, "constructor", GeneratorFunctionPrototype), $8PVmt(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $8PVmt(GeneratorFunctionPrototype, o, "GeneratorFunction"), $8PVmt(u), $8PVmt(u, o, "Generator"), $8PVmt(u, n, function() {
        return this;
    }), $8PVmt(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $80a4f2b8b3c1e910$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $80a4f2b8b3c1e910$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8PVmt", function(module, exports) {
function $66ef94f66cb55e47$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $66ef94f66cb55e47$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        function o(r, n) {
            $66ef94f66cb55e47$var$_regeneratorDefine(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        }
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $66ef94f66cb55e47$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $66ef94f66cb55e47$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4wJiQ", function(module, exports) {

var $kkUMX = parcelRequire("kkUMX");
function $34bd4acb671fcc6c$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $kkUMX(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $34bd4acb671fcc6c$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kkUMX", function(module, exports) {

var $b2LMJ = parcelRequire("b2LMJ");

var $emaCp = parcelRequire("emaCp");
function $ece1b9ef632aef86$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $emaCp($b2LMJ().w(r, e, t, o), n || Promise);
}
module.exports = $ece1b9ef632aef86$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("emaCp", function(module, exports) {

var $ksFZL = parcelRequire("ksFZL");

var $8PVmt = parcelRequire("8PVmt");
function $a73b5b5ed8323bd7$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $ksFZL ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($8PVmt($a73b5b5ed8323bd7$var$AsyncIterator.prototype), $8PVmt($a73b5b5ed8323bd7$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $8PVmt(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $a73b5b5ed8323bd7$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("eikvB", function(module, exports) {
function $a682a7bd8fb87219$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $a682a7bd8fb87219$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6t0Zx", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $4b56386cf354bcec$var$_typeof = $crtHL.default;
function $4b56386cf354bcec$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($4b56386cf354bcec$var$_typeof(e) + " is not iterable");
}
module.exports = $4b56386cf354bcec$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("crtHL", function(module, exports) {
function $90ef0c6889924fa4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $90ef0c6889924fa4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $90ef0c6889924fa4$var$_typeof(o);
}
module.exports = $90ef0c6889924fa4$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("hkfo9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
parcelRequire("7ikhG");
var $3aPmr = parcelRequire("3aPmr");
function $c9d03dc9568b637b$var$useIsMounted() {
    var ref = $3aPmr.useRef(false);
    $3aPmr.useEffect(function() {
        ref.current = true;
        return function() {
            ref.current = false;
        };
    }, []);
    return $3aPmr.useCallback(function() {
        return ref.current;
    }, [
        ref
    ]);
}
module.exports.default = $c9d03dc9568b637b$var$useIsMounted;

});
parcelRegister("7ikhG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "useSyncExternalStore", function () { return $54f9f2e439a2f9ff$export$306c0aa65ff9ec16; });
$parcel$export(module.exports, "startTransition", function () { return $54f9f2e439a2f9ff$export$7568632d0d33d16d; });
$parcel$export(module.exports, "useDeferredValue", function () { return $54f9f2e439a2f9ff$export$6a7bc4e911dc01cf; });
$parcel$export(module.exports, "useTransition", function () { return $54f9f2e439a2f9ff$export$7b286972b8d8ccbf; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $54f9f2e439a2f9ff$export$aaabe4eda9ed9969; });
$parcel$export(module.exports, "PureComponent", function () { return $54f9f2e439a2f9ff$export$221d75b3f55bb0bd; });
$parcel$export(module.exports, "memo", function () { return $54f9f2e439a2f9ff$export$7c73462e0d25e514; });
$parcel$export(module.exports, "forwardRef", function () { return $54f9f2e439a2f9ff$export$257a8862b851cb5b; });
$parcel$export(module.exports, "Children", function () { return $54f9f2e439a2f9ff$export$dca3b0875bd9a954; });
$parcel$export(module.exports, "Suspense", function () { return $54f9f2e439a2f9ff$export$74bf444e3cd11ea5; });
$parcel$export(module.exports, "lazy", function () { return $54f9f2e439a2f9ff$export$488013bae63b21da; });
$parcel$export(module.exports, "SuspenseList", function () { return $54f9f2e439a2f9ff$export$998bcd577473dd93; });
$parcel$export(module.exports, "createPortal", function () { return $54f9f2e439a2f9ff$export$d39a5bbd09211389; });
$parcel$export(module.exports, "render", function () { return $54f9f2e439a2f9ff$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $54f9f2e439a2f9ff$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $54f9f2e439a2f9ff$export$ae55be85d98224ed; });
$parcel$export(module.exports, "version", function () { return $54f9f2e439a2f9ff$export$83d89fbfd8236492; });
$parcel$export(module.exports, "createFactory", function () { return $54f9f2e439a2f9ff$export$d38cd72104c1f0e9; });
$parcel$export(module.exports, "isValidElement", function () { return $54f9f2e439a2f9ff$export$a8257692ac88316c; });
$parcel$export(module.exports, "isFragment", function () { return $54f9f2e439a2f9ff$export$9522e17588c12572; });
$parcel$export(module.exports, "isMemo", function () { return $54f9f2e439a2f9ff$export$56885ab8b9c456ab; });
$parcel$export(module.exports, "cloneElement", function () { return $54f9f2e439a2f9ff$export$e530037191fcd5d7; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $54f9f2e439a2f9ff$export$502457920280e6be; });
$parcel$export(module.exports, "findDOMNode", function () { return $54f9f2e439a2f9ff$export$466bfc07425424d5; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $54f9f2e439a2f9ff$export$c78a37762a8d58e1; });
$parcel$export(module.exports, "flushSync", function () { return $54f9f2e439a2f9ff$export$cd75ccfd720a3cd4; });
$parcel$export(module.exports, "StrictMode", function () { return $54f9f2e439a2f9ff$export$5f8d39834fd61797; });
$parcel$export(module.exports, "isElement", function () { return $54f9f2e439a2f9ff$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "default", function () { return $54f9f2e439a2f9ff$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Component", function () { return (parcelRequire("7Do5B")).Component; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("7Do5B")).Fragment; });
$parcel$export(module.exports, "createContext", function () { return (parcelRequire("7Do5B")).createContext; });
$parcel$export(module.exports, "createElement", function () { return (parcelRequire("7Do5B")).createElement; });
$parcel$export(module.exports, "createRef", function () { return (parcelRequire("7Do5B")).createRef; });

var $7Do5B = parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");
function $54f9f2e439a2f9ff$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $54f9f2e439a2f9ff$var$E(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $54f9f2e439a2f9ff$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $3aPmr.useState)({
        t: {
            __: e,
            u: t
        }
    }), u = r[0].t, o = r[1];
    return (0, $3aPmr.useLayoutEffect)(function() {
        u.__ = e, u.u = t, $54f9f2e439a2f9ff$var$x(u) && o({
            t: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $3aPmr.useEffect)(function() {
        return $54f9f2e439a2f9ff$var$x(u) && o({
            t: u
        }), n(function() {
            $54f9f2e439a2f9ff$var$x(u) && o({
                t: u
            });
        });
    }, [
        n
    ]), e;
}
function $54f9f2e439a2f9ff$var$x(n) {
    var t, e, r = n.u, u = n.__;
    try {
        var o = r();
        return !((t = u) === (e = o) && (0 !== t || 1 / t == 1 / e) || t != t && e != e);
    } catch (n) {
        return !0;
    }
}
function $54f9f2e439a2f9ff$export$7568632d0d33d16d(n) {
    n();
}
function $54f9f2e439a2f9ff$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $54f9f2e439a2f9ff$export$7b286972b8d8ccbf() {
    return [
        !1,
        $54f9f2e439a2f9ff$export$7568632d0d33d16d
    ];
}
var $54f9f2e439a2f9ff$export$aaabe4eda9ed9969 = (0, $3aPmr.useLayoutEffect);
function $54f9f2e439a2f9ff$export$221d75b3f55bb0bd(n, t) {
    this.props = n, this.context = t;
}
function $54f9f2e439a2f9ff$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $54f9f2e439a2f9ff$var$E(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $7Do5B.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($54f9f2e439a2f9ff$export$221d75b3f55bb0bd.prototype = new (0, $7Do5B.Component)).isPureReactComponent = !0, $54f9f2e439a2f9ff$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $54f9f2e439a2f9ff$var$E(this.props, n) || $54f9f2e439a2f9ff$var$E(this.state, t);
};
var $54f9f2e439a2f9ff$var$T = (0, $7Do5B.options).__b;
(0, $7Do5B.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $54f9f2e439a2f9ff$var$T && $54f9f2e439a2f9ff$var$T(n);
};
var $54f9f2e439a2f9ff$var$A = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $54f9f2e439a2f9ff$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $54f9f2e439a2f9ff$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $54f9f2e439a2f9ff$var$A, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $54f9f2e439a2f9ff$var$L = function(n, t) {
    return null == n ? null : (0, $7Do5B.toChildArray)((0, $7Do5B.toChildArray)(n).map(t));
}, $54f9f2e439a2f9ff$export$dca3b0875bd9a954 = {
    map: $54f9f2e439a2f9ff$var$L,
    forEach: $54f9f2e439a2f9ff$var$L,
    count: function(n) {
        return n ? (0, $7Do5B.toChildArray)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $7Do5B.toChildArray)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $7Do5B.toChildArray)
}, $54f9f2e439a2f9ff$var$F = (0, $7Do5B.options).__e;
(0, $7Do5B.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $54f9f2e439a2f9ff$var$F(n, t, e, r);
};
var $54f9f2e439a2f9ff$var$U = (0, $7Do5B.options).unmount;
function $54f9f2e439a2f9ff$var$V(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $54f9f2e439a2f9ff$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c.__e = !0, n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $54f9f2e439a2f9ff$var$V(n, t, e);
    })), n;
}
function $54f9f2e439a2f9ff$var$W(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $54f9f2e439a2f9ff$var$W(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $54f9f2e439a2f9ff$export$74bf444e3cd11ea5() {
    this.__u = 0, this.o = null, this.__b = null;
}
function $54f9f2e439a2f9ff$var$j(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $54f9f2e439a2f9ff$export$488013bae63b21da(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, $7Do5B.createElement)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $54f9f2e439a2f9ff$export$998bcd577473dd93() {
    this.i = null, this.l = null;
}
(0, $7Do5B.options).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && 32 & n.__u && (n.type = null), $54f9f2e439a2f9ff$var$U && $54f9f2e439a2f9ff$var$U(n);
}, ($54f9f2e439a2f9ff$export$74bf444e3cd11ea5.prototype = new (0, $7Do5B.Component)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.o && (r.o = []), r.o.push(e);
    var u = $54f9f2e439a2f9ff$var$j(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $54f9f2e439a2f9ff$var$W(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.o.pop();)t.forceUpdate();
        }
    };
    r.__u++ || 32 & t.__u || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $54f9f2e439a2f9ff$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.o = [];
}, $54f9f2e439a2f9ff$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $54f9f2e439a2f9ff$var$V(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $7Do5B.createElement)((0, $7Do5B.Fragment), null, n.fallback);
    return i && (i.__u &= -33), [
        (0, $7Do5B.createElement)((0, $7Do5B.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var $54f9f2e439a2f9ff$var$H = function(n, t, e) {
    if (++e[1] === e[0] && n.l.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.l.size)) for(e = n.i; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.i = e = e[2];
    }
};
function $54f9f2e439a2f9ff$var$Z(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $54f9f2e439a2f9ff$var$Y(n) {
    var e = this, r = n.h;
    if (e.componentWillUnmount = function() {
        (0, $7Do5B.render)(null, e.v), e.v = null, e.h = null;
    }, e.h && e.h !== r && e.componentWillUnmount(), !e.v) {
        for(var u = e.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        e.h = r, e.v = {
            nodeType: 1,
            parentNode: r,
            childNodes: [],
            __k: {
                __m: u.__m
            },
            contains: function() {
                return !0;
            },
            insertBefore: function(n, t) {
                this.childNodes.push(n), e.h.insertBefore(n, t);
            },
            removeChild: function(n) {
                this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.h.removeChild(n);
            }
        };
    }
    (0, $7Do5B.render)((0, $7Do5B.createElement)($54f9f2e439a2f9ff$var$Z, {
        context: e.context
    }, n.__v), e.v);
}
function $54f9f2e439a2f9ff$export$d39a5bbd09211389(n, e) {
    var r = (0, $7Do5B.createElement)($54f9f2e439a2f9ff$var$Y, {
        __v: n,
        h: e
    });
    return r.containerInfo = e, r;
}
($54f9f2e439a2f9ff$export$998bcd577473dd93.prototype = new (0, $7Do5B.Component)).__a = function(n) {
    var t = this, e = $54f9f2e439a2f9ff$var$j(t.__v), r = t.l.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $54f9f2e439a2f9ff$var$H(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $54f9f2e439a2f9ff$export$998bcd577473dd93.prototype.render = function(n) {
    this.i = null, this.l = new Map;
    var t = (0, $7Do5B.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.l.set(t[e], this.i = [
        1,
        0,
        this.i
    ]);
    return n.children;
}, $54f9f2e439a2f9ff$export$998bcd577473dd93.prototype.componentDidUpdate = $54f9f2e439a2f9ff$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.l.forEach(function(t, e) {
        $54f9f2e439a2f9ff$var$H(n, e, t);
    });
};
var $54f9f2e439a2f9ff$var$q = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $54f9f2e439a2f9ff$var$G = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $54f9f2e439a2f9ff$var$J = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $54f9f2e439a2f9ff$var$K = /[A-Z0-9]/g, $54f9f2e439a2f9ff$var$Q = "undefined" != typeof document, $54f9f2e439a2f9ff$var$X = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $54f9f2e439a2f9ff$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $7Do5B.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $54f9f2e439a2f9ff$export$fa8d919ba61d84db(n, t, e) {
    return (0, $7Do5B.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $7Do5B.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $7Do5B.Component).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $54f9f2e439a2f9ff$var$en = (0, $7Do5B.options).event;
function $54f9f2e439a2f9ff$var$rn() {}
function $54f9f2e439a2f9ff$var$un() {
    return this.cancelBubble;
}
function $54f9f2e439a2f9ff$var$on() {
    return this.defaultPrevented;
}
(0, $7Do5B.options).event = function(n) {
    return $54f9f2e439a2f9ff$var$en && (n = $54f9f2e439a2f9ff$var$en(n)), n.persist = $54f9f2e439a2f9ff$var$rn, n.isPropagationStopped = $54f9f2e439a2f9ff$var$un, n.isDefaultPrevented = $54f9f2e439a2f9ff$var$on, n.nativeEvent = n;
};
var $54f9f2e439a2f9ff$var$ln, $54f9f2e439a2f9ff$var$cn = {
    enumerable: !1,
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $54f9f2e439a2f9ff$var$fn = (0, $7Do5B.options).vnode;
(0, $7Do5B.options).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var t = n.props, e = n.type, u = {}, o = -1 === e.indexOf("-");
        for(var i in t){
            var l = t[i];
            if (!("value" === i && "defaultValue" in t && null == l || $54f9f2e439a2f9ff$var$Q && "children" === i && "noscript" === e || "class" === i || "className" === i)) {
                var c = i.toLowerCase();
                "defaultValue" === i && "value" in t && null == t.value ? i = "value" : "download" === i && !0 === l ? l = "" : "translate" === c && "no" === l ? l = !1 : "o" === c[0] && "n" === c[1] ? "ondoubleclick" === c ? i = "ondblclick" : "onchange" !== c || "input" !== e && "textarea" !== e || $54f9f2e439a2f9ff$var$X(t.type) ? "onfocus" === c ? i = "onfocusin" : "onblur" === c ? i = "onfocusout" : $54f9f2e439a2f9ff$var$J.test(i) && (i = c) : c = i = "oninput" : o && $54f9f2e439a2f9ff$var$G.test(i) ? i = i.replace($54f9f2e439a2f9ff$var$K, "-$&").toLowerCase() : null === l && (l = void 0), "oninput" === c && u[i = c] && (i = "oninputCapture"), u[i] = l;
            }
        }
        "select" == e && u.multiple && Array.isArray(u.value) && (u.value = (0, $7Do5B.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == e && null != u.defaultValue && (u.value = (0, $7Do5B.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), t.class && !t.className ? (u.class = t.class, Object.defineProperty(u, "className", $54f9f2e439a2f9ff$var$cn)) : (t.className && !t.class || t.class && t.className) && (u.class = u.className = t.className), n.props = u;
    }(n), n.$$typeof = $54f9f2e439a2f9ff$var$q, $54f9f2e439a2f9ff$var$fn && $54f9f2e439a2f9ff$var$fn(n);
};
var $54f9f2e439a2f9ff$var$an = (0, $7Do5B.options).__r;
(0, $7Do5B.options).__r = function(n) {
    $54f9f2e439a2f9ff$var$an && $54f9f2e439a2f9ff$var$an(n), $54f9f2e439a2f9ff$var$ln = n.__c;
};
var $54f9f2e439a2f9ff$var$sn = (0, $7Do5B.options).diffed;
(0, $7Do5B.options).diffed = function(n) {
    $54f9f2e439a2f9ff$var$sn && $54f9f2e439a2f9ff$var$sn(n);
    var t = n.props, e = n.__e;
    null != e && "textarea" === n.type && "value" in t && t.value !== e.value && (e.value = null == t.value ? "" : t.value), $54f9f2e439a2f9ff$var$ln = null;
};
var $54f9f2e439a2f9ff$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $54f9f2e439a2f9ff$var$ln.__n[n.__c].props.value;
            },
            useCallback: (0, $3aPmr.useCallback),
            useContext: (0, $3aPmr.useContext),
            useDebugValue: (0, $3aPmr.useDebugValue),
            useDeferredValue: $54f9f2e439a2f9ff$export$6a7bc4e911dc01cf,
            useEffect: (0, $3aPmr.useEffect),
            useId: (0, $3aPmr.useId),
            useImperativeHandle: (0, $3aPmr.useImperativeHandle),
            useInsertionEffect: $54f9f2e439a2f9ff$export$aaabe4eda9ed9969,
            useLayoutEffect: (0, $3aPmr.useLayoutEffect),
            useMemo: (0, $3aPmr.useMemo),
            useReducer: (0, $3aPmr.useReducer),
            useRef: (0, $3aPmr.useRef),
            useState: (0, $3aPmr.useState),
            useSyncExternalStore: $54f9f2e439a2f9ff$export$306c0aa65ff9ec16,
            useTransition: $54f9f2e439a2f9ff$export$7b286972b8d8ccbf
        }
    }
}, $54f9f2e439a2f9ff$export$83d89fbfd8236492 = "18.3.1";
function $54f9f2e439a2f9ff$export$d38cd72104c1f0e9(n) {
    return (0, $7Do5B.createElement).bind(null, n);
}
function $54f9f2e439a2f9ff$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $54f9f2e439a2f9ff$var$q;
}
function $54f9f2e439a2f9ff$export$9522e17588c12572(n) {
    return $54f9f2e439a2f9ff$export$a8257692ac88316c(n) && n.type === (0, $7Do5B.Fragment);
}
function $54f9f2e439a2f9ff$export$56885ab8b9c456ab(n) {
    return !!n && !!n.displayName && ("string" == typeof n.displayName || n.displayName instanceof String) && n.displayName.startsWith("Memo(");
}
function $54f9f2e439a2f9ff$export$e530037191fcd5d7(n) {
    return $54f9f2e439a2f9ff$export$a8257692ac88316c(n) ? (0, $7Do5B.cloneElement).apply(null, arguments) : n;
}
function $54f9f2e439a2f9ff$export$502457920280e6be(n) {
    return !!n.__k && ((0, $7Do5B.render)(null, n), !0);
}
function $54f9f2e439a2f9ff$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $54f9f2e439a2f9ff$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $54f9f2e439a2f9ff$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $54f9f2e439a2f9ff$export$5f8d39834fd61797 = (0, $7Do5B.Fragment), $54f9f2e439a2f9ff$export$45a5e7f76e0caa8d = $54f9f2e439a2f9ff$export$a8257692ac88316c, $54f9f2e439a2f9ff$export$2e2bcd8739ae039 = {
    useState: (0, $3aPmr.useState),
    useId: (0, $3aPmr.useId),
    useReducer: (0, $3aPmr.useReducer),
    useEffect: (0, $3aPmr.useEffect),
    useLayoutEffect: (0, $3aPmr.useLayoutEffect),
    useInsertionEffect: $54f9f2e439a2f9ff$export$aaabe4eda9ed9969,
    useTransition: $54f9f2e439a2f9ff$export$7b286972b8d8ccbf,
    useDeferredValue: $54f9f2e439a2f9ff$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $54f9f2e439a2f9ff$export$306c0aa65ff9ec16,
    startTransition: $54f9f2e439a2f9ff$export$7568632d0d33d16d,
    useRef: (0, $3aPmr.useRef),
    useImperativeHandle: (0, $3aPmr.useImperativeHandle),
    useMemo: (0, $3aPmr.useMemo),
    useCallback: (0, $3aPmr.useCallback),
    useContext: (0, $3aPmr.useContext),
    useDebugValue: (0, $3aPmr.useDebugValue),
    version: "18.3.1",
    Children: $54f9f2e439a2f9ff$export$dca3b0875bd9a954,
    render: $54f9f2e439a2f9ff$export$b3890eb0ae9dca99,
    hydrate: $54f9f2e439a2f9ff$export$fa8d919ba61d84db,
    unmountComponentAtNode: $54f9f2e439a2f9ff$export$502457920280e6be,
    createPortal: $54f9f2e439a2f9ff$export$d39a5bbd09211389,
    createElement: (0, $7Do5B.createElement),
    createContext: (0, $7Do5B.createContext),
    createFactory: $54f9f2e439a2f9ff$export$d38cd72104c1f0e9,
    cloneElement: $54f9f2e439a2f9ff$export$e530037191fcd5d7,
    createRef: (0, $7Do5B.createRef),
    Fragment: (0, $7Do5B.Fragment),
    isValidElement: $54f9f2e439a2f9ff$export$a8257692ac88316c,
    isElement: $54f9f2e439a2f9ff$export$45a5e7f76e0caa8d,
    isFragment: $54f9f2e439a2f9ff$export$9522e17588c12572,
    isMemo: $54f9f2e439a2f9ff$export$56885ab8b9c456ab,
    findDOMNode: $54f9f2e439a2f9ff$export$466bfc07425424d5,
    Component: (0, $7Do5B.Component),
    PureComponent: $54f9f2e439a2f9ff$export$221d75b3f55bb0bd,
    memo: $54f9f2e439a2f9ff$export$7c73462e0d25e514,
    forwardRef: $54f9f2e439a2f9ff$export$257a8862b851cb5b,
    flushSync: $54f9f2e439a2f9ff$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $54f9f2e439a2f9ff$export$c78a37762a8d58e1,
    StrictMode: $54f9f2e439a2f9ff$export$5f8d39834fd61797,
    Suspense: $54f9f2e439a2f9ff$export$74bf444e3cd11ea5,
    SuspenseList: $54f9f2e439a2f9ff$export$998bcd577473dd93,
    lazy: $54f9f2e439a2f9ff$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $54f9f2e439a2f9ff$export$ae55be85d98224ed
};
$parcel$exportWildcard(module.exports, $3aPmr);

});
parcelRegister("7Do5B", function(module, exports) {

$parcel$export(module.exports, "options", function () { return $58eedc976c0db041$export$41c562ebe57d11e2; });
$parcel$export(module.exports, "createElement", function () { return $58eedc976c0db041$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "createRef", function () { return $58eedc976c0db041$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "Fragment", function () { return $58eedc976c0db041$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Component", function () { return $58eedc976c0db041$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "toChildArray", function () { return $58eedc976c0db041$export$47e4c5b300681277; });
$parcel$export(module.exports, "render", function () { return $58eedc976c0db041$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $58eedc976c0db041$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "cloneElement", function () { return $58eedc976c0db041$export$e530037191fcd5d7; });
$parcel$export(module.exports, "createContext", function () { return $58eedc976c0db041$export$fd42f52fd3ae1109; });
$parcel$export(module.exports, "h", function () { return $58eedc976c0db041$export$c8a8987d4410bf2d; });
var $58eedc976c0db041$var$n, $58eedc976c0db041$export$41c562ebe57d11e2, $58eedc976c0db041$var$u, $58eedc976c0db041$export$a8257692ac88316c, $58eedc976c0db041$var$i, $58eedc976c0db041$var$r, $58eedc976c0db041$var$o, $58eedc976c0db041$var$e, $58eedc976c0db041$var$f, $58eedc976c0db041$var$c, $58eedc976c0db041$var$s, $58eedc976c0db041$var$a, $58eedc976c0db041$var$h, $58eedc976c0db041$var$p = {}, $58eedc976c0db041$var$v = [], $58eedc976c0db041$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $58eedc976c0db041$var$w = Array.isArray;
function $58eedc976c0db041$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $58eedc976c0db041$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $58eedc976c0db041$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $58eedc976c0db041$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $58eedc976c0db041$var$m(l, e, i, r, null);
}
function $58eedc976c0db041$var$m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$58eedc976c0db041$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $58eedc976c0db041$export$41c562ebe57d11e2.vnode && $58eedc976c0db041$export$41c562ebe57d11e2.vnode(e), e;
}
function $58eedc976c0db041$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $58eedc976c0db041$export$ffb0004e005737fa(n) {
    return n.children;
}
function $58eedc976c0db041$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $58eedc976c0db041$var$S(n, l) {
    if (null == l) return n.__ ? $58eedc976c0db041$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $58eedc976c0db041$var$S(n) : null;
}
function $58eedc976c0db041$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $58eedc976c0db041$var$C(n);
    }
}
function $58eedc976c0db041$var$M(n) {
    (!n.__d && (n.__d = !0) && $58eedc976c0db041$var$i.push(n) && !$58eedc976c0db041$var$$.__r++ || $58eedc976c0db041$var$r != $58eedc976c0db041$export$41c562ebe57d11e2.debounceRendering) && (($58eedc976c0db041$var$r = $58eedc976c0db041$export$41c562ebe57d11e2.debounceRendering) || $58eedc976c0db041$var$o)($58eedc976c0db041$var$$);
}
function $58eedc976c0db041$var$$() {
    for(var n, u, t, r, o, f, c, s = 1; $58eedc976c0db041$var$i.length;)$58eedc976c0db041$var$i.length > s && $58eedc976c0db041$var$i.sort($58eedc976c0db041$var$e), n = $58eedc976c0db041$var$i.shift(), s = $58eedc976c0db041$var$i.length, n.__d && (t = void 0, o = (r = (u = n).__v).__e, f = [], c = [], u.__P && ((t = $58eedc976c0db041$var$d({}, r)).__v = r.__v + 1, $58eedc976c0db041$export$41c562ebe57d11e2.vnode && $58eedc976c0db041$export$41c562ebe57d11e2.vnode(t), $58eedc976c0db041$var$O(u.__P, t, r, u.__n, u.__P.namespaceURI, 32 & r.__u ? [
        o
    ] : null, f, null == o ? $58eedc976c0db041$var$S(r) : o, !!(32 & r.__u), c), t.__v = r.__v, t.__.__k[t.__i] = t, $58eedc976c0db041$var$N(f, t, c), t.__e != o && $58eedc976c0db041$var$C(t)));
    $58eedc976c0db041$var$$.__r = 0;
}
function $58eedc976c0db041$var$I(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, w, d, g, _ = t && t.__k || $58eedc976c0db041$var$v, m = l.length;
    for(f = $58eedc976c0db041$var$P(u, l, _, f, m), a = 0; a < m; a++)null != (y = u.__k[a]) && (h = -1 == y.__i ? $58eedc976c0db041$var$p : _[y.__i] || $58eedc976c0db041$var$p, y.__i = a, g = $58eedc976c0db041$var$O(n, y, h, i, r, o, e, f, c, s), w = y.__e, y.ref && h.ref != y.ref && (h.ref && $58eedc976c0db041$var$B(h.ref, null, y), s.push(y.ref, y.__c || w, y)), null == d && null != w && (d = w), 4 & y.__u || h.__k === y.__k ? f = $58eedc976c0db041$var$A(y, f, n) : "function" == typeof y.type && void 0 !== g ? f = g : w && (f = w.nextSibling), y.__u &= -7);
    return u.__e = d, f;
}
function $58eedc976c0db041$var$P(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? (f = r + h, (o = n.__k[r] = "string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? $58eedc976c0db041$var$m(null, o, null, null, null) : $58eedc976c0db041$var$w(o) ? $58eedc976c0db041$var$m($58eedc976c0db041$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : null == o.constructor && o.__b > 0 ? $58eedc976c0db041$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : o).__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = $58eedc976c0db041$var$L(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $58eedc976c0db041$var$S(e)), $58eedc976c0db041$var$D(e, e));
    return t;
}
function $58eedc976c0db041$var$A(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $58eedc976c0db041$var$A(t[i], l, u));
        return l;
    }
    n.__e != l && (l && n.type && !u.contains(l) && (l = $58eedc976c0db041$var$S(n)), u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $58eedc976c0db041$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($58eedc976c0db041$var$w(n) ? n.some(function(n) {
        $58eedc976c0db041$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $58eedc976c0db041$var$L(n, l, u, t) {
    var i, r, o, e = n.key, f = n.type, c = l[u], s = null != c && 0 == (2 & c.__u);
    if (null === c && null == n.key || s && e == c.key && f == c.type) return u;
    if (t > (s ? 1 : 0)) {
        for(i = u - 1, r = u + 1; i >= 0 || r < l.length;)if (null != (c = l[o = i >= 0 ? i-- : r++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return o;
    }
    return -1;
}
function $58eedc976c0db041$var$T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $58eedc976c0db041$var$y.test(l) ? u : u + "px";
}
function $58eedc976c0db041$var$j(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $58eedc976c0db041$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $58eedc976c0db041$var$T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($58eedc976c0db041$var$f, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = $58eedc976c0db041$var$c, n.addEventListener(l, r ? $58eedc976c0db041$var$a : $58eedc976c0db041$var$s, r)) : n.removeEventListener(l, r ? $58eedc976c0db041$var$a : $58eedc976c0db041$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $58eedc976c0db041$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $58eedc976c0db041$var$c++;
            else if (u.t < t.u) return;
            return t($58eedc976c0db041$export$41c562ebe57d11e2.event ? $58eedc976c0db041$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $58eedc976c0db041$var$O(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, v, y, _, m, b, S, C, M, $, P, A, H, L, T, j = u.type;
    if (null != u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $58eedc976c0db041$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof j) try {
        if (b = u.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new j(b, M) : (u.__c = h = new $58eedc976c0db041$export$16fa2f45be04daa8(b, M), h.constructor = j, h.render = $58eedc976c0db041$var$E), C && C.sub(h), h.props = b, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $58eedc976c0db041$var$d({}, h.__s)), $58eedc976c0db041$var$d(h.__s, j.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = u, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M) || u.__v == t.__v) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $ = 0; $ < h._sb.length; $++)h.__h.push(h._sb[$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = $58eedc976c0db041$export$41c562ebe57d11e2.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $58eedc976c0db041$var$d($58eedc976c0db041$var$d({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, y)), L = a, null != a && a.type === $58eedc976c0db041$export$ffb0004e005737fa && null == a.key && (L = $58eedc976c0db041$var$V(a.props.children)), f = $58eedc976c0db041$var$I(n, $58eedc976c0db041$var$w(L) ? L : [
            L
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else {
                for(T = o.length; T--;)$58eedc976c0db041$var$g(o[T]);
                $58eedc976c0db041$var$z(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || $58eedc976c0db041$var$z(u);
        $58eedc976c0db041$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $58eedc976c0db041$var$q(t.__e, u, t, i, r, o, e, c, s);
    return (a = $58eedc976c0db041$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $58eedc976c0db041$var$z(n) {
    n && n.__c && (n.__c.__e = !0), n && n.__k && n.__k.forEach($58eedc976c0db041$var$z);
}
function $58eedc976c0db041$var$N(n, u, t) {
    for(var i = 0; i < t.length; i++)$58eedc976c0db041$var$B(t[i], t[++i], t[++i]);
    $58eedc976c0db041$export$41c562ebe57d11e2.__c && $58eedc976c0db041$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $58eedc976c0db041$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $58eedc976c0db041$var$V(n) {
    return "object" != typeof n || null == n || n.__b && n.__b > 0 ? n : $58eedc976c0db041$var$w(n) ? n.map($58eedc976c0db041$var$V) : $58eedc976c0db041$var$d({}, n);
}
function $58eedc976c0db041$var$q(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, d, _, m, b = i.props, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((d = e[a]) && "setAttribute" in d == !!x && (x ? d.localName == x : 3 == d.nodeType)) {
            u = d, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && ($58eedc976c0db041$export$41c562ebe57d11e2.__m && $58eedc976c0db041$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) b === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && $58eedc976c0db041$var$n.call(u.childNodes), b = i.props || $58eedc976c0db041$var$p, !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(d = u.attributes[a]).name] = d.value;
        for(a in b)if (d = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = d;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $58eedc976c0db041$var$j(u, a, null, d, o);
        }
        for(a in k)d = k[a], "children" == a ? y = d : "dangerouslySetInnerHTML" == a ? h = d : "value" == a ? _ = d : "checked" == a ? m = d : c && "function" != typeof d || b[a] === d || $58eedc976c0db041$var$j(u, a, d, b[a], o);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $58eedc976c0db041$var$I("template" == t.type ? u.content : u, $58eedc976c0db041$var$w(y) ? y : [
            y
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $58eedc976c0db041$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$58eedc976c0db041$var$g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ != b[a]) && $58eedc976c0db041$var$j(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && $58eedc976c0db041$var$j(u, a, m, b[a], o));
    }
    return u;
}
function $58eedc976c0db041$var$B(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $58eedc976c0db041$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $58eedc976c0db041$var$D(n, u, t) {
    var i, r;
    if ($58eedc976c0db041$export$41c562ebe57d11e2.unmount && $58eedc976c0db041$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $58eedc976c0db041$var$B(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $58eedc976c0db041$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $58eedc976c0db041$var$D(i[r], u, t || "function" != typeof n.type);
    t || $58eedc976c0db041$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $58eedc976c0db041$var$E(n, l, u) {
    return this.constructor(n, u);
}
function $58eedc976c0db041$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $58eedc976c0db041$export$41c562ebe57d11e2.__ && $58eedc976c0db041$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $58eedc976c0db041$var$O(t, u = (!r && i || t).__k = $58eedc976c0db041$export$c8a8987d4410bf2d($58eedc976c0db041$export$ffb0004e005737fa, null, [
        u
    ]), o || $58eedc976c0db041$var$p, $58eedc976c0db041$var$p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $58eedc976c0db041$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $58eedc976c0db041$var$N(e, u, f);
}
function $58eedc976c0db041$export$fa8d919ba61d84db(n, l) {
    $58eedc976c0db041$export$b3890eb0ae9dca99(n, l, $58eedc976c0db041$export$fa8d919ba61d84db);
}
function $58eedc976c0db041$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $58eedc976c0db041$var$d({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $58eedc976c0db041$var$n.call(arguments, 2) : t), $58eedc976c0db041$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $58eedc976c0db041$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $58eedc976c0db041$var$M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $58eedc976c0db041$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$58eedc976c0db041$var$n = $58eedc976c0db041$var$v.slice, $58eedc976c0db041$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $58eedc976c0db041$var$u = 0, $58eedc976c0db041$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $58eedc976c0db041$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $58eedc976c0db041$var$d({}, this.state), "function" == typeof n && (n = n($58eedc976c0db041$var$d({}, u), this.props)), n && $58eedc976c0db041$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $58eedc976c0db041$var$M(this));
}, $58eedc976c0db041$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $58eedc976c0db041$var$M(this));
}, $58eedc976c0db041$export$16fa2f45be04daa8.prototype.render = $58eedc976c0db041$export$ffb0004e005737fa, $58eedc976c0db041$var$i = [], $58eedc976c0db041$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $58eedc976c0db041$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $58eedc976c0db041$var$$.__r = 0, $58eedc976c0db041$var$f = /(PointerCapture)$|Capture$/i, $58eedc976c0db041$var$c = 0, $58eedc976c0db041$var$s = $58eedc976c0db041$var$F(!1), $58eedc976c0db041$var$a = $58eedc976c0db041$var$F(!0), $58eedc976c0db041$var$h = 0;

});

parcelRegister("3aPmr", function(module, exports) {

$parcel$export(module.exports, "useState", function () { return $24fa25825a717dc7$export$60241385465d0a34; });
$parcel$export(module.exports, "useReducer", function () { return $24fa25825a717dc7$export$13e3392192263954; });
$parcel$export(module.exports, "useEffect", function () { return $24fa25825a717dc7$export$6d9c69b0de29b591; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $24fa25825a717dc7$export$e5c5a5f917a5871c; });
$parcel$export(module.exports, "useRef", function () { return $24fa25825a717dc7$export$b8f5890fc79d6aca; });
$parcel$export(module.exports, "useMemo", function () { return $24fa25825a717dc7$export$1538c33de8887b59; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $24fa25825a717dc7$export$d5a552a76deda3c2; });
$parcel$export(module.exports, "useCallback", function () { return $24fa25825a717dc7$export$35808ee640e87ca7; });
$parcel$export(module.exports, "useContext", function () { return $24fa25825a717dc7$export$fae74005e78b1a27; });
$parcel$export(module.exports, "useDebugValue", function () { return $24fa25825a717dc7$export$dc8fbce3eb94dc1e; });
$parcel$export(module.exports, "useErrorBoundary", function () { return $24fa25825a717dc7$export$c052f6604b7d51fe; });
$parcel$export(module.exports, "useId", function () { return $24fa25825a717dc7$export$f680877a34711e37; });

var $7Do5B = parcelRequire("7Do5B");
var $24fa25825a717dc7$var$t, $24fa25825a717dc7$var$r, $24fa25825a717dc7$var$u, $24fa25825a717dc7$var$i, $24fa25825a717dc7$var$o = 0, $24fa25825a717dc7$var$f = [], $24fa25825a717dc7$var$c = (0, $7Do5B.options), $24fa25825a717dc7$var$e = $24fa25825a717dc7$var$c.__b, $24fa25825a717dc7$var$a = $24fa25825a717dc7$var$c.__r, $24fa25825a717dc7$var$v = $24fa25825a717dc7$var$c.diffed, $24fa25825a717dc7$var$l = $24fa25825a717dc7$var$c.__c, $24fa25825a717dc7$var$m = $24fa25825a717dc7$var$c.unmount, $24fa25825a717dc7$var$s = $24fa25825a717dc7$var$c.__;
function $24fa25825a717dc7$var$p(n, t) {
    $24fa25825a717dc7$var$c.__h && $24fa25825a717dc7$var$c.__h($24fa25825a717dc7$var$r, n, $24fa25825a717dc7$var$o || t), $24fa25825a717dc7$var$o = 0;
    var u = $24fa25825a717dc7$var$r.__H || ($24fa25825a717dc7$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $24fa25825a717dc7$export$60241385465d0a34(n) {
    return $24fa25825a717dc7$var$o = 1, $24fa25825a717dc7$export$13e3392192263954($24fa25825a717dc7$var$D, n);
}
function $24fa25825a717dc7$export$13e3392192263954(n, u, i) {
    var o = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $24fa25825a717dc7$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $24fa25825a717dc7$var$r, !$24fa25825a717dc7$var$r.__f)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = o.__c.props !== n;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c && c.call(this, n, t, r) || i;
        };
        $24fa25825a717dc7$var$r.__f = !0;
        var c = $24fa25825a717dc7$var$r.shouldComponentUpdate, e = $24fa25825a717dc7$var$r.componentWillUpdate;
        $24fa25825a717dc7$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $24fa25825a717dc7$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $24fa25825a717dc7$export$6d9c69b0de29b591(n, u) {
    var i = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 3);
    !$24fa25825a717dc7$var$c.__s && $24fa25825a717dc7$var$C(i.__H, u) && (i.__ = n, i.u = u, $24fa25825a717dc7$var$r.__H.__h.push(i));
}
function $24fa25825a717dc7$export$e5c5a5f917a5871c(n, u) {
    var i = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 4);
    !$24fa25825a717dc7$var$c.__s && $24fa25825a717dc7$var$C(i.__H, u) && (i.__ = n, i.u = u, $24fa25825a717dc7$var$r.__h.push(i));
}
function $24fa25825a717dc7$export$b8f5890fc79d6aca(n) {
    return $24fa25825a717dc7$var$o = 5, $24fa25825a717dc7$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $24fa25825a717dc7$export$d5a552a76deda3c2(n, t, r) {
    $24fa25825a717dc7$var$o = 6, $24fa25825a717dc7$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var r = n(t());
            return function() {
                n(null), r && "function" == typeof r && r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $24fa25825a717dc7$export$1538c33de8887b59(n, r) {
    var u = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 7);
    return $24fa25825a717dc7$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $24fa25825a717dc7$export$35808ee640e87ca7(n, t) {
    return $24fa25825a717dc7$var$o = 8, $24fa25825a717dc7$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $24fa25825a717dc7$export$fae74005e78b1a27(n) {
    var u = $24fa25825a717dc7$var$r.context[n.__c], i = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($24fa25825a717dc7$var$r)), u.props.value) : n.__;
}
function $24fa25825a717dc7$export$dc8fbce3eb94dc1e(n, t) {
    $24fa25825a717dc7$var$c.useDebugValue && $24fa25825a717dc7$var$c.useDebugValue(t ? t(n) : n);
}
function $24fa25825a717dc7$export$c052f6604b7d51fe(n) {
    var u = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 10), i = $24fa25825a717dc7$export$60241385465d0a34();
    return u.__ = n, $24fa25825a717dc7$var$r.componentDidCatch || ($24fa25825a717dc7$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $24fa25825a717dc7$export$f680877a34711e37() {
    var n = $24fa25825a717dc7$var$p($24fa25825a717dc7$var$t++, 11);
    if (!n.__) {
        for(var u = $24fa25825a717dc7$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $24fa25825a717dc7$var$j() {
    for(var n; n = $24fa25825a717dc7$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($24fa25825a717dc7$var$z), n.__H.__h.forEach($24fa25825a717dc7$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $24fa25825a717dc7$var$c.__e(t, n.__v);
    }
}
$24fa25825a717dc7$var$c.__b = function(n) {
    $24fa25825a717dc7$var$r = null, $24fa25825a717dc7$var$e && $24fa25825a717dc7$var$e(n);
}, $24fa25825a717dc7$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $24fa25825a717dc7$var$s && $24fa25825a717dc7$var$s(n, t);
}, $24fa25825a717dc7$var$c.__r = function(n) {
    $24fa25825a717dc7$var$a && $24fa25825a717dc7$var$a(n), $24fa25825a717dc7$var$t = 0;
    var i = ($24fa25825a717dc7$var$r = n.__c).__H;
    i && ($24fa25825a717dc7$var$u === $24fa25825a717dc7$var$r ? (i.__h = [], $24fa25825a717dc7$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.forEach($24fa25825a717dc7$var$z), i.__h.forEach($24fa25825a717dc7$var$B), i.__h = [], $24fa25825a717dc7$var$t = 0)), $24fa25825a717dc7$var$u = $24fa25825a717dc7$var$r;
}, $24fa25825a717dc7$var$c.diffed = function(n) {
    $24fa25825a717dc7$var$v && $24fa25825a717dc7$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $24fa25825a717dc7$var$f.push(t) && $24fa25825a717dc7$var$i === $24fa25825a717dc7$var$c.requestAnimationFrame || (($24fa25825a717dc7$var$i = $24fa25825a717dc7$var$c.requestAnimationFrame) || $24fa25825a717dc7$var$w)($24fa25825a717dc7$var$j)), t.__H.__.forEach(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $24fa25825a717dc7$var$u = $24fa25825a717dc7$var$r = null;
}, $24fa25825a717dc7$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($24fa25825a717dc7$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $24fa25825a717dc7$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $24fa25825a717dc7$var$c.__e(r, n.__v);
        }
    }), $24fa25825a717dc7$var$l && $24fa25825a717dc7$var$l(n, t);
}, $24fa25825a717dc7$var$c.unmount = function(n) {
    $24fa25825a717dc7$var$m && $24fa25825a717dc7$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $24fa25825a717dc7$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $24fa25825a717dc7$var$c.__e(t, r.__v));
};
var $24fa25825a717dc7$var$k = "function" == typeof requestAnimationFrame;
function $24fa25825a717dc7$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $24fa25825a717dc7$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    $24fa25825a717dc7$var$k && (t = requestAnimationFrame(r));
}
function $24fa25825a717dc7$var$z(n) {
    var t = $24fa25825a717dc7$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $24fa25825a717dc7$var$r = t;
}
function $24fa25825a717dc7$var$B(n) {
    var t = $24fa25825a717dc7$var$r;
    n.__c = n.__(), $24fa25825a717dc7$var$r = t;
}
function $24fa25825a717dc7$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $24fa25825a717dc7$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});




var $7Do5B = parcelRequire("7Do5B");
var $eb3c8b789a252a22$var$t = /["&<]/;
function $eb3c8b789a252a22$var$n(r) {
    if (0 === r.length || !1 === $eb3c8b789a252a22$var$t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var $eb3c8b789a252a22$var$o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $eb3c8b789a252a22$var$f = 0, $eb3c8b789a252a22$var$i = Array.isArray;
function $eb3c8b789a252a22$export$34b9dba7ce09269b(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, p = t;
    if ("ref" in p) for(c in p = {}, t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: --$eb3c8b789a252a22$var$f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, $7Do5B.options).vnode && (0, $7Do5B.options).vnode(l), l;
}
function $eb3c8b789a252a22$export$45700d561b2268ac(r) {
    var t = $eb3c8b789a252a22$export$34b9dba7ce09269b((0, $7Do5B.Fragment), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var $eb3c8b789a252a22$var$c = {}, $eb3c8b789a252a22$var$p = /[A-Z]/g;
function $eb3c8b789a252a22$export$991f6ffe102e5bac(e, t) {
    if ((0, $7Do5B.options).attr) {
        var f = (0, $7Do5B.options).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if (t = function(r) {
        return null !== r && "object" == typeof r && "function" == typeof r.valueOf ? r.valueOf() : r;
    }(t), "ref" === e || "key" === e) return "";
    if ("style" === e && "object" == typeof t) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : $eb3c8b789a252a22$var$c[u] || ($eb3c8b789a252a22$var$c[u] = u.replace($eb3c8b789a252a22$var$p, "-$&").toLowerCase()), s = ";";
                "number" != typeof a || l.startsWith("--") || $eb3c8b789a252a22$var$o.test(l) || (s = "px;"), i = i + l + ":" + a + s;
            }
        }
        return e + '="' + $eb3c8b789a252a22$var$n(i) + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == typeof t ? "" : !0 === t ? e : e + '="' + $eb3c8b789a252a22$var$n("" + t) + '"';
}
function $eb3c8b789a252a22$export$40e96e718441efeb(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == typeof r) {
        if (void 0 === r.constructor) return r;
        if ($eb3c8b789a252a22$var$i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = $eb3c8b789a252a22$export$40e96e718441efeb(r[e]);
            return r;
        }
    }
    return $eb3c8b789a252a22$var$n("" + r);
}



var $7Do5B = parcelRequire("7Do5B");

var $7Do5B = parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");
var $8ea79db61ca199dd$var$a = {};
function $8ea79db61ca199dd$var$c(n, t) {
    for(var r in t)n[r] = t[r];
    return n;
}
function $8ea79db61ca199dd$export$78e3044358792147(n, t, r) {
    var i, o = /(?:\?([^#]*))?(#.*)?$/, e = n.match(o), u = {};
    if (e && e[1]) for(var f = e[1].split("&"), c = 0; c < f.length; c++){
        var s = f[c].split("=");
        u[decodeURIComponent(s[0])] = decodeURIComponent(s.slice(1).join("="));
    }
    n = $8ea79db61ca199dd$var$d(n.replace(o, "")), t = $8ea79db61ca199dd$var$d(t || "");
    for(var h = Math.max(n.length, t.length), v = 0; v < h; v++)if (t[v] && ":" === t[v].charAt(0)) {
        var l = t[v].replace(/(^:|[+*?]+$)/g, ""), p = (t[v].match(/[+*?]+$/) || $8ea79db61ca199dd$var$a)[0] || "", m = ~p.indexOf("+"), y = ~p.indexOf("*"), U = n[v] || "";
        if (!U && !y && (p.indexOf("?") < 0 || m)) {
            i = !1;
            break;
        }
        if (u[l] = decodeURIComponent(U), m || y) {
            u[l] = n.slice(v).map(decodeURIComponent).join("/");
            break;
        }
    } else if (t[v] !== n[v]) {
        i = !1;
        break;
    }
    return (!0 === r.default || !1 !== i) && u;
}
function $8ea79db61ca199dd$var$h(n, t) {
    return n.rank < t.rank ? 1 : n.rank > t.rank ? -1 : n.index - t.index;
}
function $8ea79db61ca199dd$var$v(n, t) {
    return n.index = t, n.rank = function(n) {
        return n.props.default ? 0 : $8ea79db61ca199dd$var$d(n.props.path).map($8ea79db61ca199dd$var$l).join("");
    }(n), n.props;
}
function $8ea79db61ca199dd$var$d(n) {
    return n.replace(/(^\/+|\/+$)/g, "").split("/");
}
function $8ea79db61ca199dd$var$l(n) {
    return ":" == n.charAt(0) ? 1 + "*+?".indexOf(n.charAt(n.length - 1)) || 4 : 5;
}
var $8ea79db61ca199dd$var$p = {}, $8ea79db61ca199dd$var$m = [], $8ea79db61ca199dd$var$y = [], $8ea79db61ca199dd$var$U = null, $8ea79db61ca199dd$var$g = {
    url: $8ea79db61ca199dd$export$dc90482e4ef07afd()
}, $8ea79db61ca199dd$var$k = (0, $7Do5B.createContext)($8ea79db61ca199dd$var$g);
function $8ea79db61ca199dd$export$9a302a45f65d0572() {
    var n = (0, $3aPmr.useContext)($8ea79db61ca199dd$var$k);
    if (n === $8ea79db61ca199dd$var$g) {
        var t = (0, $3aPmr.useState)()[1];
        (0, $3aPmr.useEffect)(function() {
            return $8ea79db61ca199dd$var$y.push(t), function() {
                return $8ea79db61ca199dd$var$y.splice($8ea79db61ca199dd$var$y.indexOf(t), 1);
            };
        }, []);
    }
    return [
        n,
        $8ea79db61ca199dd$export$4cb887bfde2d34ca
    ];
}
function $8ea79db61ca199dd$export$dc90482e4ef07afd() {
    var n;
    return "" + ((n = $8ea79db61ca199dd$var$U && $8ea79db61ca199dd$var$U.location ? $8ea79db61ca199dd$var$U.location : $8ea79db61ca199dd$var$U && $8ea79db61ca199dd$var$U.getCurrentLocation ? $8ea79db61ca199dd$var$U.getCurrentLocation() : "undefined" != typeof location ? location : $8ea79db61ca199dd$var$p).pathname || "") + (n.search || "");
}
function $8ea79db61ca199dd$export$4cb887bfde2d34ca(n, t) {
    return void 0 === t && (t = !1), "string" != typeof n && n.url && (t = n.replace, n = n.url), function(n) {
        for(var t = $8ea79db61ca199dd$var$m.length; t--;)if ($8ea79db61ca199dd$var$m[t].canRoute(n)) return !0;
        return !1;
    }(n) && function(n, t) {
        void 0 === t && (t = "push"), $8ea79db61ca199dd$var$U && $8ea79db61ca199dd$var$U[t] ? $8ea79db61ca199dd$var$U[t](n) : "undefined" != typeof history && history[t + "State"] && history[t + "State"](null, null, n);
    }(n, t ? "replace" : "push"), $8ea79db61ca199dd$var$I(n);
}
function $8ea79db61ca199dd$var$I(n) {
    for(var t = !1, r = 0; r < $8ea79db61ca199dd$var$m.length; r++)$8ea79db61ca199dd$var$m[r].routeTo(n) && (t = !0);
    return t;
}
function $8ea79db61ca199dd$var$M(n) {
    if (n && n.getAttribute) {
        var t = n.getAttribute("href"), r = n.getAttribute("target");
        if (t && t.match(/^\//g) && (!r || r.match(/^_?self$/i))) return $8ea79db61ca199dd$export$4cb887bfde2d34ca(t);
    }
}
function $8ea79db61ca199dd$var$b(n) {
    return n.stopImmediatePropagation && n.stopImmediatePropagation(), n.stopPropagation && n.stopPropagation(), n.preventDefault(), !1;
}
function $8ea79db61ca199dd$var$W(n) {
    if (!(n.ctrlKey || n.metaKey || n.altKey || n.shiftKey || n.button)) {
        var t = n.target;
        do if ("a" === t.localName && t.getAttribute("href")) {
            if (t.hasAttribute("data-native") || t.hasAttribute("native")) return;
            if ($8ea79db61ca199dd$var$M(t)) return $8ea79db61ca199dd$var$b(n);
        }
        while (t = t.parentNode);
    }
}
var $8ea79db61ca199dd$var$w = !1;
function $8ea79db61ca199dd$export$55185c17a0fcbe46(n) {
    n.history && ($8ea79db61ca199dd$var$U = n.history), this.state = {
        url: n.url || $8ea79db61ca199dd$export$dc90482e4ef07afd()
    };
}
$8ea79db61ca199dd$var$c($8ea79db61ca199dd$export$55185c17a0fcbe46.prototype = new (0, $7Do5B.Component), {
    shouldComponentUpdate: function(n) {
        return !0 !== n.static || n.url !== this.props.url || n.onChange !== this.props.onChange;
    },
    canRoute: function(n) {
        var t = (0, $7Do5B.toChildArray)(this.props.children);
        return void 0 !== this.g(t, n);
    },
    routeTo: function(n) {
        this.setState({
            url: n
        });
        var t = this.canRoute(n);
        return this.p || this.forceUpdate(), t;
    },
    componentWillMount: function() {
        this.p = !0;
    },
    componentDidMount: function() {
        var n = this;
        $8ea79db61ca199dd$var$w || ($8ea79db61ca199dd$var$w = !0, $8ea79db61ca199dd$var$U || addEventListener("popstate", function() {
            $8ea79db61ca199dd$var$I($8ea79db61ca199dd$export$dc90482e4ef07afd());
        }), addEventListener("click", $8ea79db61ca199dd$var$W)), $8ea79db61ca199dd$var$m.push(this), $8ea79db61ca199dd$var$U && (this.u = $8ea79db61ca199dd$var$U.listen(function(t) {
            var r = t.location || t;
            n.routeTo("" + (r.pathname || "") + (r.search || ""));
        })), this.p = !1;
    },
    componentWillUnmount: function() {
        "function" == typeof this.u && this.u(), $8ea79db61ca199dd$var$m.splice($8ea79db61ca199dd$var$m.indexOf(this), 1);
    },
    componentWillUpdate: function() {
        this.p = !0;
    },
    componentDidUpdate: function() {
        this.p = !1;
    },
    g: function(n, t) {
        n = n.filter($8ea79db61ca199dd$var$v).sort($8ea79db61ca199dd$var$h);
        for(var r = 0; r < n.length; r++){
            var i = n[r], o = $8ea79db61ca199dd$export$78e3044358792147(t, i.props.path, i.props);
            if (o) return [
                i,
                o
            ];
        }
    },
    render: function(n, t) {
        var e, u, f = n.onChange, a = t.url, s = this.c, h = this.g((0, $7Do5B.toChildArray)(n.children), a);
        if (h && (u = (0, $7Do5B.cloneElement)(h[0], $8ea79db61ca199dd$var$c($8ea79db61ca199dd$var$c({
            url: a,
            matches: e = h[1]
        }, e), {
            key: void 0,
            ref: void 0
        }))), a !== (s && s.url)) {
            $8ea79db61ca199dd$var$c($8ea79db61ca199dd$var$g, s = this.c = {
                url: a,
                previous: s && s.url,
                current: u,
                path: u ? u.props.path : null,
                matches: e
            }), s.router = this, s.active = u ? [
                u
            ] : [];
            for(var v = $8ea79db61ca199dd$var$y.length; v--;)$8ea79db61ca199dd$var$y[v]({});
            "function" == typeof f && f(s);
        }
        return (0, $7Do5B.h)($8ea79db61ca199dd$var$k.Provider, {
            value: s
        }, u);
    }
});
var $8ea79db61ca199dd$export$a6c7ac8248d6e38a = function(n) {
    return (0, $7Do5B.h)("a", $8ea79db61ca199dd$var$c({
        onClick: $8ea79db61ca199dd$var$W
    }, n));
}, $8ea79db61ca199dd$export$e7b0ac011bb776c6 = function(n) {
    return (0, $7Do5B.h)(n.component, n);
};



parcelRequire("7Do5B");

var $7Do5B = parcelRequire("7Do5B");

var $f28553f68a34bb68$var$s = [
    "className",
    "activeClass",
    "activeClassName",
    "path"
];
function $f28553f68a34bb68$export$f421feb8fad20413(a) {
    var e = (0, $8ea79db61ca199dd$export$9a302a45f65d0572)()[0];
    return a.children({
        url: e.url,
        path: e.path,
        matches: !1 !== (0, $8ea79db61ca199dd$export$78e3044358792147)(e.path || e.url, a.path, {})
    });
}
function $f28553f68a34bb68$export$a6c7ac8248d6e38a(l) {
    var c = l.className, n = l.activeClass, u = l.activeClassName, i = l.path, p = function(a, t) {
        if (null == a) return {};
        var r, e, s = {}, l = Object.keys(a);
        for(e = 0; e < l.length; e++)t.indexOf(r = l[e]) >= 0 || (s[r] = a[r]);
        return s;
    }(l, $f28553f68a34bb68$var$s), h = (0, $8ea79db61ca199dd$export$9a302a45f65d0572)()[0], f = i && h.path && (0, $8ea79db61ca199dd$export$78e3044358792147)(h.path, i, {}) || (0, $8ea79db61ca199dd$export$78e3044358792147)(h.url, p.href, {}), o = p.class || c || "", m = f && (n || u) || "";
    return p.class = o + (o && m && " ") + m, (0, $7Do5B.h)((0, $8ea79db61ca199dd$export$a6c7ac8248d6e38a), p);
}



var $3aPmr = parcelRequire("3aPmr");
// const BASE_AUTH_URL = "https://report.keralty.myintelli.net";
// const URL_REFRESH_TOKEN = BASE_AUTH_URL + "jwt/refresh/";
const $c683ce1247b5bc0f$var$STORAGE_KEY = "TOKEN_AUTH";
const { fetch: $c683ce1247b5bc0f$var$originalFetch } = window;
const $c683ce1247b5bc0f$var$createTokenProvider = ()=>{
    let observers = [];
    const getTokenInternal = ()=>{
        const data = localStorage.getItem($c683ce1247b5bc0f$var$STORAGE_KEY);
        const token = data && JSON.parse(data) || null;
        return token;
    };
    const getUser = ()=>{
        return !!_token ? _token.user : null;
    };
    let _token = getTokenInternal();
    const getExpirationDate = (jwtToken)=>{
        if (!jwtToken) return null;
        const jwt = JSON.parse(atob(jwtToken.split(".")[1]));
        return jwt && jwt.exp && jwt.exp * 1000 || null;
    };
    const isExpired = (exp)=>{
        if (!exp) return false;
        return Date.now() > exp;
    };
    const getToken = async ()=>{
        if (!_token) return null;
        if (isExpired(getExpirationDate(_token.token))) setToken(null);
        return _token && _token.token;
    };
    const isLoggedIn = ()=>{
        return !!getTokenInternal();
    };
    const subscribe = (observer)=>{
        observers.push(observer);
    };
    const unsubscribe = (observer)=>{
        observers = observers.filter((_observer)=>_observer !== observer);
    };
    const notify = ()=>{
        const isLogged = isLoggedIn();
        observers.forEach((observer)=>observer(isLogged));
    };
    const setToken = (token)=>{
        if (token) localStorage.setItem($c683ce1247b5bc0f$var$STORAGE_KEY, JSON.stringify(token));
        else localStorage.removeItem($c683ce1247b5bc0f$var$STORAGE_KEY);
        _token = getTokenInternal();
        notify();
    };
    return {
        getToken: getToken,
        isLoggedIn: isLoggedIn,
        setToken: setToken,
        subscribe: subscribe,
        unsubscribe: unsubscribe,
        getUser: getUser
    };
};
const $c683ce1247b5bc0f$var$createAuthProvider = ()=>{
    const tokenProvider = $c683ce1247b5bc0f$var$createTokenProvider();
    const login = (newTokens)=>{
        tokenProvider.setToken(newTokens);
    };
    const logout = ()=>{
        tokenProvider.setToken(null);
    };
    const http = async (...args)=>{
        let [resource, config = {}] = args;
        // request interceptor here
        const token = await tokenProvider.getToken();
        const new_config = {
            ...config,
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
        const response = await $c683ce1247b5bc0f$var$originalFetch(resource, new_config);
        // response interceptor here
        if (!response.ok && response.status === 401) {
            logout();
            window.location = "/login";
            return Promise.reject(response);
        }
        return response;
    };
    const useAuth = ()=>{
        const [isLogged, setIsLogged] = (0, $3aPmr.useState)(tokenProvider.isLoggedIn());
        const [user, setUser] = (0, $3aPmr.useState)(tokenProvider.getUser());
        const listener = (0, $3aPmr.useCallback)((newIsLogged)=>{
            setIsLogged(newIsLogged);
        }, [
            setIsLogged
        ]);
        (0, $3aPmr.useEffect)(()=>{
            tokenProvider.subscribe(listener);
            return ()=>{
                tokenProvider.unsubscribe(listener);
            };
        }, [
            listener
        ]);
        return [
            isLogged,
            user
        ];
    };
    return [
        useAuth,
        http,
        login,
        logout
    ];
};
const [$c683ce1247b5bc0f$export$1d39dc5b47e56ff0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527, $c683ce1247b5bc0f$export$596d806903d1f59e, $c683ce1247b5bc0f$export$a0973bcfe11b05c9] = $c683ce1247b5bc0f$var$createAuthProvider();


const $96253dbc841a0a6f$var$Layout = ({ children: children, breadcrumbs: breadcrumbs = [], searchBar: searchBar = null })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("nav", {
                class: "navbar is-link",
                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "container",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "navbar-brand",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                    class: "navbar-item brand-text",
                                    href: "../index.html",
                                    children: "Admin"
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "navbar-burger burger",
                                    "data-target": "navMenu",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {}),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {}),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            id: "navMenu",
                            class: "navbar-menu",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                class: "navbar-start",
                                style: {
                                    margin: "0 auto"
                                },
                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "navbar-item",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "control has-icons-left",
                                        children: [
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                                onInput: searchBar,
                                                class: "input",
                                                type: "search",
                                                placeholder: ""
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon is-left",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                    class: "material-icons",
                                                    children: "search"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                class: "container",
                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "columns",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "column is-2",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("aside", {
                                class: "menu is-hidden-mobile",
                                children: [
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                        class: "menu-label",
                                        children: "Administracion"
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("ul", {
                                        class: "menu-list",
                                        children: [
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $f28553f68a34bb68$export$a6c7ac8248d6e38a), {
                                                    activeClassName: "is-active",
                                                    href: "/",
                                                    children: "Reportes"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $f28553f68a34bb68$export$a6c7ac8248d6e38a), {
                                                    activeClassName: "is-active",
                                                    href: "/headers",
                                                    children: "Cabeceras"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $f28553f68a34bb68$export$a6c7ac8248d6e38a), {
                                                    activeClassName: "is-active",
                                                    href: "/filters",
                                                    children: "Filtros"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $f28553f68a34bb68$export$a6c7ac8248d6e38a), {
                                                    activeClassName: "is-active",
                                                    href: "/components",
                                                    children: "Componentes"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $f28553f68a34bb68$export$a6c7ac8248d6e38a), {
                                                    activeClassName: "is-active",
                                                    href: "/modules",
                                                    children: "Modulos"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $f28553f68a34bb68$export$a6c7ac8248d6e38a), {
                                                    activeClassName: "is-active",
                                                    href: "/stats",
                                                    children: "Reportes mas descargados"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $f28553f68a34bb68$export$a6c7ac8248d6e38a), {
                                                    activeClassName: "is-active",
                                                    href: "/tags",
                                                    children: "Tipos de etiquetas"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $f28553f68a34bb68$export$a6c7ac8248d6e38a), {
                                                    activeClassName: "is-active",
                                                    href: "/subtags",
                                                    children: "Etiquetas"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $f28553f68a34bb68$export$a6c7ac8248d6e38a), {
                                                    activeClassName: "is-active",
                                                    href: "/parent-reports",
                                                    children: "Padre de reportes"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                        class: "menu-label",
                                        children: "Traducciones"
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("ul", {
                                        class: "menu-list",
                                        children: [
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $f28553f68a34bb68$export$a6c7ac8248d6e38a), {
                                                    activeClassName: "is-active",
                                                    href: "/languages/",
                                                    children: "Idiomas"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $f28553f68a34bb68$export$a6c7ac8248d6e38a), {
                                                    activeClassName: "is-active",
                                                    href: "/words/",
                                                    children: "Palabras"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                        class: "menu-label",
                                        children: "Usuario"
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("ul", {
                                        class: "menu-list",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                                            onClick: ()=>{
                                                (0, $c683ce1247b5bc0f$export$a0973bcfe11b05c9)();
                                                window.location = "/login";
                                            },
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                children: "Salir"
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "column is-10",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                children: children
                            })
                        })
                    ]
                })
            })
        ]
    });
var $96253dbc841a0a6f$export$2e2bcd8739ae039 = $96253dbc841a0a6f$var$Layout;




var $3aPmr = parcelRequire("3aPmr");

var $3aPmr = parcelRequire("3aPmr");
const $f51453fda9f7f538$export$fadfbce9325ec320 = "...";
const $f51453fda9f7f538$var$range = (start, end)=>{
    let length = end - start + 1;
    return Array.from({
        length: length
    }, (_, idx)=>idx + start);
};
const $f51453fda9f7f538$export$f80c710216eae131 = ({ totalCount: totalCount, pageSize: pageSize, siblingCount: siblingCount = 1, currentPage: currentPage })=>{
    const paginationRange = (0, $3aPmr.useMemo)(()=>{
        const totalPageCount = Math.ceil(totalCount / pageSize);
        // Pages count is determined as siblingCount + firstPage + lastPage + currentPage + 2*DOTS
        const totalPageNumbers = siblingCount + 5;
        /*
      Case 1:
      If the number of pages is less than the page numbers we want to show in our
      paginationComponent, we return the range [1..totalPageCount]
    */ if (totalPageNumbers >= totalPageCount) return $f51453fda9f7f538$var$range(1, totalPageCount);
        /*
        Calculate left and right sibling index and make sure they are within range 1 and totalPageCount
    */ const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
        const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);
        /*
      We do not show dots just when there is just one page number to be inserted between the extremes of sibling and the page limits i.e 1 and totalPageCount. Hence we are using leftSiblingIndex > 2 and rightSiblingIndex < totalPageCount - 2
    */ const shouldShowLeftDots = leftSiblingIndex > 2;
        const shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;
        const firstPageIndex = 1;
        const lastPageIndex = totalPageCount;
        /*
        Case 2: No left dots to show, but rights dots to be shown
    */ if (!shouldShowLeftDots && shouldShowRightDots) {
            let leftItemCount = 3 + 2 * siblingCount;
            let leftRange = $f51453fda9f7f538$var$range(1, leftItemCount);
            return [
                ...leftRange,
                $f51453fda9f7f538$export$fadfbce9325ec320,
                totalPageCount
            ];
        }
        /*
        Case 3: No right dots to show, but left dots to be shown
    */ if (shouldShowLeftDots && !shouldShowRightDots) {
            let rightItemCount = 3 + 2 * siblingCount;
            let rightRange = $f51453fda9f7f538$var$range(totalPageCount - rightItemCount + 1, totalPageCount);
            return [
                firstPageIndex,
                $f51453fda9f7f538$export$fadfbce9325ec320,
                ...rightRange
            ];
        }
        /*
        Case 4: Both left and right dots to be shown
    */ if (shouldShowLeftDots && shouldShowRightDots) {
            let middleRange = $f51453fda9f7f538$var$range(leftSiblingIndex, rightSiblingIndex);
            return [
                firstPageIndex,
                $f51453fda9f7f538$export$fadfbce9325ec320,
                ...middleRange,
                $f51453fda9f7f538$export$fadfbce9325ec320,
                lastPageIndex
            ];
        }
    }, [
        totalCount,
        pageSize,
        siblingCount,
        currentPage
    ]);
    return paginationRange;
};
const $f51453fda9f7f538$export$21805fee57372823 = (value, delay)=>{
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = (0, $3aPmr.useState)(value);
    (0, $3aPmr.useEffect)(()=>{
        // Update debounced value after delay
        const handler = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return ()=>{
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ] // Only re-call effect if value or delay changes
    );
    return debouncedValue;
};




var $7Do5B = parcelRequire("7Do5B");
var $44a44312232fffaa$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($44a44312232fffaa$exports) {
        classNames.default = classNames;
        $44a44312232fffaa$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


class $974023f5106cfc4f$export$2e2bcd8739ae039 extends (0, $7Do5B.Component) {
    state = {
        active: false
    };
    componentDidMount() {
        const node = this.base;
        const parent = node.parentNode;
        if (parent) {
            parent.addEventListener("mouseover", ()=>{
                const pos = parent.getBoundingClientRect();
                node.style.top = `${pos.top + pos.height}px`;
                node.style.left = `${pos.left + parseInt(pos.width / 2 - node.offsetWidth / 2)}px`;
                if (!this.state.active) this.setState({
                    active: true
                });
            });
            parent.addEventListener("mouseout", ()=>{
                if (this.state.active) this.setState({
                    active: false
                });
            });
        }
    }
    render() {
        const cls = {
            tooltip: true,
            active: this.state.active
        };
        if (this.props.className) cls[this.props.className] = true;
        return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))(cls),
            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                className: "in",
                children: this.props.label
            })
        });
    }
}




parcelRequire("7Do5B");


const $22b2f8f41c3b0593$var$Paginator = ({ total: total, page: page, setCurrentPage: setCurrentPage, pageSize: pageSize })=>{
    const paginationRange = (0, $f51453fda9f7f538$export$f80c710216eae131)({
        currentPage: page,
        totalCount: total,
        siblingCount: 1,
        pageSize: pageSize
    });
    let lastPage = paginationRange[paginationRange.length - 1];
    const goToPreviousPage = ()=>{
        if (page > 1) return setCurrentPage((page)=>page - 1);
    };
    const goToNextPage = ()=>{
        if (page < lastPage) return setCurrentPage((page)=>page + 1);
    };
    const goToPage = (page)=>setCurrentPage(page);
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("nav", {
        class: "pagination is-small is-centered",
        role: "navigation",
        "aria-label": "pagination",
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                onClick: goToPreviousPage,
                class: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))("pagination-previous", {
                    "is-disabled": page === 1
                }),
                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                    class: "material-icons",
                    children: "chevron_left"
                })
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                onClick: goToNextPage,
                class: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))("pagination-next", {
                    "is-disabled": page === lastPage
                }),
                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                    class: "material-icons",
                    children: "chevron_right"
                })
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("ul", {
                class: "pagination-list",
                children: paginationRange.map((pageNumber)=>{
                    if (pageNumber === (0, $f51453fda9f7f538$export$fadfbce9325ec320)) return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                            class: "pagination-ellipsis",
                            children: "\u2026"
                        })
                    });
                    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                            onClick: ()=>goToPage(pageNumber),
                            class: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))("pagination-link", {
                                "is-current": pageNumber === page
                            }),
                            children: pageNumber
                        })
                    });
                })
            })
        ]
    });
};
var $22b2f8f41c3b0593$export$2e2bcd8739ae039 = $22b2f8f41c3b0593$var$Paginator;



var $45d29d2a9970da25$exports = {};
var $30cb065ea47a1f86$exports = {};
function $30cb065ea47a1f86$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$30cb065ea47a1f86$exports = $30cb065ea47a1f86$var$_objectWithoutPropertiesLoose, $30cb065ea47a1f86$exports.__esModule = true, $30cb065ea47a1f86$exports["default"] = $30cb065ea47a1f86$exports;


function $45d29d2a9970da25$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $30cb065ea47a1f86$exports(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$45d29d2a9970da25$exports = $45d29d2a9970da25$var$_objectWithoutProperties, $45d29d2a9970da25$exports.__esModule = true, $45d29d2a9970da25$exports["default"] = $45d29d2a9970da25$exports;


var $2d5b1ac1574da936$exports = {};
function $2d5b1ac1574da936$var$_extends() {
    return $2d5b1ac1574da936$exports = $2d5b1ac1574da936$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2d5b1ac1574da936$exports.__esModule = true, $2d5b1ac1574da936$exports["default"] = $2d5b1ac1574da936$exports, $2d5b1ac1574da936$var$_extends.apply(null, arguments);
}
$2d5b1ac1574da936$exports = $2d5b1ac1574da936$var$_extends, $2d5b1ac1574da936$exports.__esModule = true, $2d5b1ac1574da936$exports["default"] = $2d5b1ac1574da936$exports;


var $aec0ef34f2c5a862$exports = {};
var $efbf14b6e6102ff5$exports = {};
function $efbf14b6e6102ff5$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$efbf14b6e6102ff5$exports = $efbf14b6e6102ff5$var$_arrayWithHoles, $efbf14b6e6102ff5$exports.__esModule = true, $efbf14b6e6102ff5$exports["default"] = $efbf14b6e6102ff5$exports;


var $c291ac134490aa92$exports = {};
function $c291ac134490aa92$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$c291ac134490aa92$exports = $c291ac134490aa92$var$_iterableToArrayLimit, $c291ac134490aa92$exports.__esModule = true, $c291ac134490aa92$exports["default"] = $c291ac134490aa92$exports;


var $036c4d1914e85e94$exports = {};
var $5195fd8f0d7eac4d$exports = {};
function $5195fd8f0d7eac4d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$5195fd8f0d7eac4d$exports = $5195fd8f0d7eac4d$var$_arrayLikeToArray, $5195fd8f0d7eac4d$exports.__esModule = true, $5195fd8f0d7eac4d$exports["default"] = $5195fd8f0d7eac4d$exports;


function $036c4d1914e85e94$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5195fd8f0d7eac4d$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5195fd8f0d7eac4d$exports(r, a) : void 0;
    }
}
$036c4d1914e85e94$exports = $036c4d1914e85e94$var$_unsupportedIterableToArray, $036c4d1914e85e94$exports.__esModule = true, $036c4d1914e85e94$exports["default"] = $036c4d1914e85e94$exports;


var $046c0957b668f83c$exports = {};
function $046c0957b668f83c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$046c0957b668f83c$exports = $046c0957b668f83c$var$_nonIterableRest, $046c0957b668f83c$exports.__esModule = true, $046c0957b668f83c$exports["default"] = $046c0957b668f83c$exports;


function $aec0ef34f2c5a862$var$_slicedToArray(r, e) {
    return $efbf14b6e6102ff5$exports(r) || $c291ac134490aa92$exports(r, e) || $036c4d1914e85e94$exports(r, e) || $046c0957b668f83c$exports();
}
$aec0ef34f2c5a862$exports = $aec0ef34f2c5a862$var$_slicedToArray, $aec0ef34f2c5a862$exports.__esModule = true, $aec0ef34f2c5a862$exports["default"] = $aec0ef34f2c5a862$exports;


var $9425c93b578bde03$exports = {};
var $a15197716c9fc410$exports = {};

function $a15197716c9fc410$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $5195fd8f0d7eac4d$exports(r);
}
$a15197716c9fc410$exports = $a15197716c9fc410$var$_arrayWithoutHoles, $a15197716c9fc410$exports.__esModule = true, $a15197716c9fc410$exports["default"] = $a15197716c9fc410$exports;


var $1a1674df30a2d79d$exports = {};
function $1a1674df30a2d79d$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$1a1674df30a2d79d$exports = $1a1674df30a2d79d$var$_iterableToArray, $1a1674df30a2d79d$exports.__esModule = true, $1a1674df30a2d79d$exports["default"] = $1a1674df30a2d79d$exports;



var $89459a34ed9af2cc$exports = {};
function $89459a34ed9af2cc$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$89459a34ed9af2cc$exports = $89459a34ed9af2cc$var$_nonIterableSpread, $89459a34ed9af2cc$exports.__esModule = true, $89459a34ed9af2cc$exports["default"] = $89459a34ed9af2cc$exports;


function $9425c93b578bde03$var$_toConsumableArray(r) {
    return $a15197716c9fc410$exports(r) || $1a1674df30a2d79d$exports(r) || $036c4d1914e85e94$exports(r) || $89459a34ed9af2cc$exports();
}
$9425c93b578bde03$exports = $9425c93b578bde03$var$_toConsumableArray, $9425c93b578bde03$exports.__esModule = true, $9425c93b578bde03$exports["default"] = $9425c93b578bde03$exports;


var $e23ae39501459ba4$exports = {};
var $5555d428bd3bf37b$exports = {};

var $crtHL = parcelRequire("crtHL");
var $5555d428bd3bf37b$var$_typeof = $crtHL.default;
var $210013a7b1d5e66c$exports = {};

var $crtHL = parcelRequire("crtHL");
var $210013a7b1d5e66c$var$_typeof = $crtHL.default;
function $210013a7b1d5e66c$var$toPrimitive(t, r) {
    if ("object" != $210013a7b1d5e66c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $210013a7b1d5e66c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$210013a7b1d5e66c$exports = $210013a7b1d5e66c$var$toPrimitive, $210013a7b1d5e66c$exports.__esModule = true, $210013a7b1d5e66c$exports["default"] = $210013a7b1d5e66c$exports;


function $5555d428bd3bf37b$var$toPropertyKey(t) {
    var i = $210013a7b1d5e66c$exports(t, "string");
    return "symbol" == $5555d428bd3bf37b$var$_typeof(i) ? i : i + "";
}
$5555d428bd3bf37b$exports = $5555d428bd3bf37b$var$toPropertyKey, $5555d428bd3bf37b$exports.__esModule = true, $5555d428bd3bf37b$exports["default"] = $5555d428bd3bf37b$exports;


function $e23ae39501459ba4$var$_defineProperty(e, r, t) {
    return (r = $5555d428bd3bf37b$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$e23ae39501459ba4$exports = $e23ae39501459ba4$var$_defineProperty, $e23ae39501459ba4$exports.__esModule = true, $e23ae39501459ba4$exports["default"] = $e23ae39501459ba4$exports;


function $b230bc0d4245014d$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


function $3a7da7f4c81a8554$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $3a7da7f4c81a8554$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3a7da7f4c81a8554$export$2e2bcd8739ae039(o);
}



function $94d637ce061dd3ca$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $d0643fe154cb74c1$export$2e2bcd8739ae039(t) {
    var i = (0, $94d637ce061dd3ca$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $eebcda4657ff09bb$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $d0643fe154cb74c1$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $eebcda4657ff09bb$export$2e2bcd8739ae039(e, r, t) {
    return r && $eebcda4657ff09bb$var$_defineProperties(e.prototype, r), t && $eebcda4657ff09bb$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


var $a6a0f7da525baef5$exports = {};
function $a6a0f7da525baef5$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$a6a0f7da525baef5$exports = $a6a0f7da525baef5$var$_assertThisInitialized, $a6a0f7da525baef5$exports.__esModule = true, $a6a0f7da525baef5$exports["default"] = $a6a0f7da525baef5$exports;


function $ca073d81f2a471af$export$2e2bcd8739ae039(t, e) {
    return $ca073d81f2a471af$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $ca073d81f2a471af$export$2e2bcd8739ae039(t, e);
}


function $5751042f9a4a77f6$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $ca073d81f2a471af$export$2e2bcd8739ae039)(t, e);
}



function $cb0e0834598ff6d6$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $c345de07753d2fca$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(t);
}


function $ea07a931d040ec2a$export$2e2bcd8739ae039(t) {
    return $ea07a931d040ec2a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $ea07a931d040ec2a$export$2e2bcd8739ae039(t);
}



var $7ikhG = parcelRequire("7ikhG");
var $7Do5B = parcelRequire("7Do5B");
var $16d5efbf3de5c533$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $16d5efbf3de5c533$var$isEqual(first, second) {
    if (first === second) return true;
    if ($16d5efbf3de5c533$var$safeIsNaN(first) && $16d5efbf3de5c533$var$safeIsNaN(second)) return true;
    return false;
}
function $16d5efbf3de5c533$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$16d5efbf3de5c533$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $16d5efbf3de5c533$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $16d5efbf3de5c533$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $16d5efbf3de5c533$export$2e2bcd8739ae039 = $16d5efbf3de5c533$var$memoizeOne;



function $c375c92967c25393$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $ca073d81f2a471af$export$2e2bcd8739ae039)(t, o);
}


parcelRequire("7ikhG");
var $7Do5B = parcelRequire("7Do5B");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $86a6e99f63d83d4a$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $86a6e99f63d83d4a$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    return tag;
}
var $86a6e99f63d83d4a$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $86a6e99f63d83d4a$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $86a6e99f63d83d4a$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


function $b8e67db547fa4322$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $b8e67db547fa4322$export$2e2bcd8739ae039 = $b8e67db547fa4322$var$stylis_min;


var $7b912907d813459f$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $7b912907d813459f$export$2e2bcd8739ae039 = $7b912907d813459f$var$weakMemoize;


// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $56abe1b292bdd894$var$delimiter = '/*|*/';
var $56abe1b292bdd894$var$needle = $56abe1b292bdd894$var$delimiter + '}';
function $56abe1b292bdd894$var$toSheet(block) {
    if (block) $56abe1b292bdd894$var$Sheet.current.insert(block + '}');
}
var $56abe1b292bdd894$var$Sheet = {
    current: null
};
var $56abe1b292bdd894$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $56abe1b292bdd894$var$Sheet.current.insert(content + ';');
                    return '';
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return '';
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $56abe1b292bdd894$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $56abe1b292bdd894$var$Sheet.current.insert(selectors[0] + content);
                    return '';
                default:
                    return content + (at === 0 ? $56abe1b292bdd894$var$delimiter : '');
            }
        case -2:
            content.split($56abe1b292bdd894$var$needle).forEach($56abe1b292bdd894$var$toSheet);
    }
};
var $56abe1b292bdd894$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $b8e67db547fa4322$export$2e2bcd8739ae039)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(' ').forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($56abe1b292bdd894$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $56abe1b292bdd894$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $86a6e99f63d83d4a$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $56abe1b292bdd894$export$2e2bcd8739ae039 = $56abe1b292bdd894$var$createCache;


var $42841827f7191b24$exports = {};
var $69fde538af35e679$exports = {};
function $69fde538af35e679$var$_setPrototypeOf(t, e) {
    return $69fde538af35e679$exports = $69fde538af35e679$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $69fde538af35e679$exports.__esModule = true, $69fde538af35e679$exports["default"] = $69fde538af35e679$exports, $69fde538af35e679$var$_setPrototypeOf(t, e);
}
$69fde538af35e679$exports = $69fde538af35e679$var$_setPrototypeOf, $69fde538af35e679$exports.__esModule = true, $69fde538af35e679$exports["default"] = $69fde538af35e679$exports;


function $42841827f7191b24$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $69fde538af35e679$exports(t, o);
}
$42841827f7191b24$exports = $42841827f7191b24$var$_inheritsLoose, $42841827f7191b24$exports.__esModule = true, $42841827f7191b24$exports["default"] = $42841827f7191b24$exports;


parcelRequire("7ikhG");
var $7Do5B = parcelRequire("7Do5B");
var $7ikhG = parcelRequire("7ikhG");

var $16a9a2d54e7269c3$var$isBrowser = true;
function $16a9a2d54e7269c3$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $16a9a2d54e7269c3$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $16a9a2d54e7269c3$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3c68ff8ffafd964c$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $3c68ff8ffafd964c$export$2e2bcd8739ae039 = $3c68ff8ffafd964c$var$murmur2;


var $19dce821df45b550$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $19dce821df45b550$export$2e2bcd8739ae039 = $19dce821df45b550$var$unitlessKeys;


function $757ea4c9ef9a7a6c$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $757ea4c9ef9a7a6c$export$2e2bcd8739ae039 = $757ea4c9ef9a7a6c$var$memoize;


var $3e8a3deaa58d9295$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $3e8a3deaa58d9295$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $3e8a3deaa58d9295$var$hyphenateRegex = /[A-Z]|^ms/g;
var $3e8a3deaa58d9295$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $3e8a3deaa58d9295$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $3e8a3deaa58d9295$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $3e8a3deaa58d9295$var$processStyleName = (0, $757ea4c9ef9a7a6c$export$2e2bcd8739ae039)(function(styleName) {
    return $3e8a3deaa58d9295$var$isCustomProperty(styleName) ? styleName : styleName.replace($3e8a3deaa58d9295$var$hyphenateRegex, '-$&').toLowerCase();
});
var $3e8a3deaa58d9295$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($3e8a3deaa58d9295$var$animationRegex, function(match, p1, p2) {
                $3e8a3deaa58d9295$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $3e8a3deaa58d9295$var$cursor
                };
                return p1;
            });
    }
    if ((0, $19dce821df45b550$export$2e2bcd8739ae039)[key] !== 1 && !$3e8a3deaa58d9295$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $3e8a3deaa58d9295$var$contentValuePattern, $3e8a3deaa58d9295$var$contentValues, $3e8a3deaa58d9295$var$oldProcessStyleValue, $3e8a3deaa58d9295$var$msPattern, $3e8a3deaa58d9295$var$hyphenPattern, $3e8a3deaa58d9295$var$hyphenatedCache;
var $3e8a3deaa58d9295$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $3e8a3deaa58d9295$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $3e8a3deaa58d9295$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $3e8a3deaa58d9295$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $3e8a3deaa58d9295$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $3e8a3deaa58d9295$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $3e8a3deaa58d9295$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $3e8a3deaa58d9295$var$cursor;
                var result = interpolation(mergedProps);
                $3e8a3deaa58d9295$var$cursor = previousCursor;
                return $3e8a3deaa58d9295$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $3e8a3deaa58d9295$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $3e8a3deaa58d9295$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($3e8a3deaa58d9295$var$isProcessableValue(value)) string += $3e8a3deaa58d9295$var$processStyleName(_key) + ":" + $3e8a3deaa58d9295$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($3e8a3deaa58d9295$var$isProcessableValue(value[_i])) string += $3e8a3deaa58d9295$var$processStyleName(_key) + ":" + $3e8a3deaa58d9295$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $3e8a3deaa58d9295$var$handleInterpolation(mergedProps, registered, value, false);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $3e8a3deaa58d9295$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $3e8a3deaa58d9295$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $3e8a3deaa58d9295$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $3e8a3deaa58d9295$var$cursor;
var $3e8a3deaa58d9295$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $3e8a3deaa58d9295$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $3e8a3deaa58d9295$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $3e8a3deaa58d9295$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $3e8a3deaa58d9295$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $3e8a3deaa58d9295$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $3c68ff8ffafd964c$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $3e8a3deaa58d9295$var$cursor
    };
};


var $8b0bcb3a24c30fa0$export$dda1d9f60106f0e9 = Object.prototype.hasOwnProperty;
var $8b0bcb3a24c30fa0$var$EmotionCacheContext = /*#__PURE__*/ (0, $7Do5B.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? (0, $56abe1b292bdd894$export$2e2bcd8739ae039)() : null);
var $8b0bcb3a24c30fa0$export$971d5caa766a69d7 = /*#__PURE__*/ (0, $7Do5B.createContext)({});
var $8b0bcb3a24c30fa0$export$e7094788287c5e9b = $8b0bcb3a24c30fa0$var$EmotionCacheContext.Provider;
var $8b0bcb3a24c30fa0$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return /*#__PURE__*/ (0, $7Do5B.createElement)($8b0bcb3a24c30fa0$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return /*#__PURE__*/ (0, $7ikhG.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $8b0bcb3a24c30fa0$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $8b0bcb3a24c30fa0$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $8b0bcb3a24c30fa0$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $8b0bcb3a24c30fa0$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($8b0bcb3a24c30fa0$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$8b0bcb3a24c30fa0$var$typePropName] = type; // TODO: check if this still works with all of those different JSX functions
    var error, match;
    return newProps;
};
var $8b0bcb3a24c30fa0$var$Noop = function Noop() {
    return null;
};
var $8b0bcb3a24c30fa0$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$8b0bcb3a24c30fa0$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $16a9a2d54e7269c3$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $3e8a3deaa58d9295$export$6321afa313b251b5)(registeredStyles);
    var labelFromStack;
    var rules = (0, $16a9a2d54e7269c3$export$6f077d94b33a01aa)(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($8b0bcb3a24c30fa0$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $8b0bcb3a24c30fa0$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $7Do5B.createElement)(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/ (0, $7Do5B.createElement)($8b0bcb3a24c30fa0$var$Noop, null);
    return /*#__PURE__*/ (0, $7Do5B.createElement)((0, $7Do5B.Fragment), null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef
var $8b0bcb3a24c30fa0$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $8b0bcb3a24c30fa0$export$efccba1c4a2ef57b(function(props, cache, ref) {
    if (typeof props.css === 'function') return /*#__PURE__*/ (0, $7Do5B.createElement)($8b0bcb3a24c30fa0$export$971d5caa766a69d7.Consumer, null, function(theme) {
        return $8b0bcb3a24c30fa0$var$render(cache, props, theme, ref);
    });
    return $8b0bcb3a24c30fa0$var$render(cache, props, null, ref);
});






function $c20939fbec481e9e$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $3e8a3deaa58d9295$export$6321afa313b251b5)(args);
}
var $c20939fbec481e9e$export$2e2bcd8739ae039 = $c20939fbec481e9e$var$css;


var $6b09c71374678d25$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $8b0bcb3a24c30fa0$export$dda1d9f60106f0e9).call(props, 'css')) // $FlowFixMe
    return (0, $7Do5B.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $8b0bcb3a24c30fa0$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $8b0bcb3a24c30fa0$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $7Do5B.createElement).apply(null, createElementArgArray);
};
var $6b09c71374678d25$var$warnedAboutCssPropForGlobal = false;
var $6b09c71374678d25$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $8b0bcb3a24c30fa0$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === 'function') return /*#__PURE__*/ (0, $7Do5B.createElement)((0, $8b0bcb3a24c30fa0$export$971d5caa766a69d7).Consumer, null, function(theme) {
        var serialized = (0, $3e8a3deaa58d9295$export$6321afa313b251b5)([
            styles(theme)
        ]);
        return /*#__PURE__*/ (0, $7Do5B.createElement)($6b09c71374678d25$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $3e8a3deaa58d9295$export$6321afa313b251b5)([
        styles
    ]);
    return /*#__PURE__*/ (0, $7Do5B.createElement)($6b09c71374678d25$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $6b09c71374678d25$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, $c375c92967c25393$export$2e2bcd8739ae039)(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $86a6e99f63d83d4a$export$9d753cd7ae895cce)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $16a9a2d54e7269c3$export$6f077d94b33a01aa)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $7Do5B.Component));
var $6b09c71374678d25$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $c20939fbec481e9e$export$2e2bcd8739ae039).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $6b09c71374678d25$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $6b09c71374678d25$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $16a9a2d54e7269c3$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $6b09c71374678d25$var$Noop = function Noop() {
    return null;
};
var $6b09c71374678d25$export$9b9c0f9d9f3552b8 = (0, $8b0bcb3a24c30fa0$export$efccba1c4a2ef57b)(function(props, context) {
    return /*#__PURE__*/ (0, $7Do5B.createElement)((0, $8b0bcb3a24c30fa0$export$971d5caa766a69d7).Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $3e8a3deaa58d9295$export$6321afa313b251b5)(args, context.registered);
            (0, $16a9a2d54e7269c3$export$6f077d94b33a01aa)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $6b09c71374678d25$var$merge(context.registered, css, $6b09c71374678d25$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        var possiblyStyleElement = /*#__PURE__*/ (0, $7Do5B.createElement)($6b09c71374678d25$var$Noop, null);
        return /*#__PURE__*/ (0, $7Do5B.createElement)((0, $7Do5B.Fragment), null, possiblyStyleElement, ele);
    });
});


parcelRequire("7ikhG");
parcelRequire("crtHL");
function $cd488cd9c287f883$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $95fb0a49c8a38020$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}


function $39ab41060f0dd572$export$2e2bcd8739ae039() {
    return $39ab41060f0dd572$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $39ab41060f0dd572$export$2e2bcd8739ae039.apply(null, arguments);
}



function $1c78c172f6af0e63$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $d0643fe154cb74c1$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}







parcelRequire("7ikhG");
var $7Do5B = parcelRequire("7Do5B");


var $7ikhG = parcelRequire("7ikhG");


function $7c4bf992c3b23621$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}


var $e49941725dc27c5e$exports = {};
'use strict';
Object.defineProperty($e49941725dc27c5e$exports, "__esModule", {
    value: true
});
var $e49941725dc27c5e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $e49941725dc27c5e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $7ikhG = parcelRequire("7ikhG");
var $e49941725dc27c5e$var$_react2 = $e49941725dc27c5e$var$_interopRequireDefault($7ikhG);
var $aa40b802dd2fccfc$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa40b802dd2fccfc$var$ReactIs, $aa40b802dd2fccfc$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$aa40b802dd2fccfc$exports = (parcelRequire("2tbKl"))();


var $e49941725dc27c5e$var$_propTypes2 = $e49941725dc27c5e$var$_interopRequireDefault($aa40b802dd2fccfc$exports);
function $e49941725dc27c5e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e49941725dc27c5e$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $e49941725dc27c5e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e49941725dc27c5e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e49941725dc27c5e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e49941725dc27c5e$var$sizerStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    visibility: 'hidden',
    height: 0,
    overflow: 'scroll',
    whiteSpace: 'pre'
};
var $e49941725dc27c5e$var$INPUT_PROPS_BLACKLIST = [
    'extraWidth',
    'injectStyles',
    'inputClassName',
    'inputRef',
    'inputStyle',
    'minWidth',
    'onAutosize',
    'placeholderIsMinWidth'
];
var $e49941725dc27c5e$var$cleanInputProps = function cleanInputProps(inputProps) {
    $e49941725dc27c5e$var$INPUT_PROPS_BLACKLIST.forEach(function(field) {
        return delete inputProps[field];
    });
    return inputProps;
};
var $e49941725dc27c5e$var$copyStyles = function copyStyles(styles, node) {
    node.style.fontSize = styles.fontSize;
    node.style.fontFamily = styles.fontFamily;
    node.style.fontWeight = styles.fontWeight;
    node.style.fontStyle = styles.fontStyle;
    node.style.letterSpacing = styles.letterSpacing;
    node.style.textTransform = styles.textTransform;
};
var $e49941725dc27c5e$var$isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
var $e49941725dc27c5e$var$generateId = function generateId() {
    // we only need an auto-generated ID for stylesheet injection, which is only
    // used for IE. so if the browser is not IE, this should return undefined.
    return $e49941725dc27c5e$var$isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};
var $e49941725dc27c5e$var$AutosizeInput = function(_Component) {
    $e49941725dc27c5e$var$_inherits(AutosizeInput, _Component);
    $e49941725dc27c5e$var$_createClass(AutosizeInput, null, [
        {
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(props, state) {
                var id = props.id;
                return id !== state.prevId ? {
                    inputId: id || $e49941725dc27c5e$var$generateId(),
                    prevId: id
                } : null;
            }
        }
    ]);
    function AutosizeInput(props) {
        $e49941725dc27c5e$var$_classCallCheck(this, AutosizeInput);
        var _this = $e49941725dc27c5e$var$_possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
        _this.inputRef = function(el) {
            _this.input = el;
            if (typeof _this.props.inputRef === 'function') _this.props.inputRef(el);
        };
        _this.placeHolderSizerRef = function(el) {
            _this.placeHolderSizer = el;
        };
        _this.sizerRef = function(el) {
            _this.sizer = el;
        };
        _this.state = {
            inputWidth: props.minWidth,
            inputId: props.id || $e49941725dc27c5e$var$generateId(),
            prevId: props.id
        };
        return _this;
    }
    $e49941725dc27c5e$var$_createClass(AutosizeInput, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.mounted = true;
                this.copyInputStyles();
                this.updateInputWidth();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                if (prevState.inputWidth !== this.state.inputWidth) {
                    if (typeof this.props.onAutosize === 'function') this.props.onAutosize(this.state.inputWidth);
                }
                this.updateInputWidth();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.mounted = false;
            }
        },
        {
            key: 'copyInputStyles',
            value: function copyInputStyles() {
                if (!this.mounted || !window.getComputedStyle) return;
                var inputStyles = this.input && window.getComputedStyle(this.input);
                if (!inputStyles) return;
                $e49941725dc27c5e$var$copyStyles(inputStyles, this.sizer);
                if (this.placeHolderSizer) $e49941725dc27c5e$var$copyStyles(inputStyles, this.placeHolderSizer);
            }
        },
        {
            key: 'updateInputWidth',
            value: function updateInputWidth() {
                if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') return;
                var newInputWidth = void 0;
                if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
                else newInputWidth = this.sizer.scrollWidth + 2;
                // add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
                var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
                newInputWidth += extraWidth;
                if (newInputWidth < this.props.minWidth) newInputWidth = this.props.minWidth;
                if (newInputWidth !== this.state.inputWidth) this.setState({
                    inputWidth: newInputWidth
                });
            }
        },
        {
            key: 'getInput',
            value: function getInput() {
                return this.input;
            }
        },
        {
            key: 'focus',
            value: function focus() {
                this.input.focus();
            }
        },
        {
            key: 'blur',
            value: function blur() {
                this.input.blur();
            }
        },
        {
            key: 'select',
            value: function select() {
                this.input.select();
            }
        },
        {
            key: 'renderStyles',
            value: function renderStyles() {
                // this method injects styles to hide IE's clear indicator, which messes
                // with input size detection. the stylesheet is only injected when the
                // browser is IE, and can also be disabled by the `injectStyles` prop.
                var injectStyles = this.props.injectStyles;
                return $e49941725dc27c5e$var$isIE && injectStyles ? $e49941725dc27c5e$var$_react2.default.createElement('style', {
                    dangerouslySetInnerHTML: {
                        __html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
                    }
                }) : null;
            }
        },
        {
            key: 'render',
            value: function render() {
                var sizerValue = [
                    this.props.defaultValue,
                    this.props.value,
                    ''
                ].reduce(function(previousValue, currentValue) {
                    if (previousValue !== null && previousValue !== undefined) return previousValue;
                    return currentValue;
                });
                var wrapperStyle = $e49941725dc27c5e$var$_extends({}, this.props.style);
                if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
                var inputStyle = $e49941725dc27c5e$var$_extends({
                    boxSizing: 'content-box',
                    width: this.state.inputWidth + 'px'
                }, this.props.inputStyle);
                var inputProps = $e49941725dc27c5e$var$_objectWithoutProperties(this.props, []);
                $e49941725dc27c5e$var$cleanInputProps(inputProps);
                inputProps.className = this.props.inputClassName;
                inputProps.id = this.state.inputId;
                inputProps.style = inputStyle;
                return $e49941725dc27c5e$var$_react2.default.createElement('div', {
                    className: this.props.className,
                    style: wrapperStyle
                }, this.renderStyles(), $e49941725dc27c5e$var$_react2.default.createElement('input', $e49941725dc27c5e$var$_extends({}, inputProps, {
                    ref: this.inputRef
                })), $e49941725dc27c5e$var$_react2.default.createElement('div', {
                    ref: this.sizerRef,
                    style: $e49941725dc27c5e$var$sizerStyle
                }, sizerValue), this.props.placeholder ? $e49941725dc27c5e$var$_react2.default.createElement('div', {
                    ref: this.placeHolderSizerRef,
                    style: $e49941725dc27c5e$var$sizerStyle
                }, this.props.placeholder) : null);
            }
        }
    ]);
    return AutosizeInput;
}($7ikhG.Component);
$e49941725dc27c5e$var$AutosizeInput.propTypes = {
    className: $e49941725dc27c5e$var$_propTypes2.default.string,
    defaultValue: $e49941725dc27c5e$var$_propTypes2.default.any,
    extraWidth: $e49941725dc27c5e$var$_propTypes2.default.oneOfType([
        $e49941725dc27c5e$var$_propTypes2.default.number,
        $e49941725dc27c5e$var$_propTypes2.default.string
    ]),
    id: $e49941725dc27c5e$var$_propTypes2.default.string,
    injectStyles: $e49941725dc27c5e$var$_propTypes2.default.bool,
    inputClassName: $e49941725dc27c5e$var$_propTypes2.default.string,
    inputRef: $e49941725dc27c5e$var$_propTypes2.default.func,
    inputStyle: $e49941725dc27c5e$var$_propTypes2.default.object,
    minWidth: $e49941725dc27c5e$var$_propTypes2.default.oneOfType([
        $e49941725dc27c5e$var$_propTypes2.default.number,
        $e49941725dc27c5e$var$_propTypes2.default.string
    ]),
    onAutosize: $e49941725dc27c5e$var$_propTypes2.default.func,
    onChange: $e49941725dc27c5e$var$_propTypes2.default.func,
    placeholder: $e49941725dc27c5e$var$_propTypes2.default.string,
    placeholderIsMinWidth: $e49941725dc27c5e$var$_propTypes2.default.bool,
    style: $e49941725dc27c5e$var$_propTypes2.default.object,
    value: $e49941725dc27c5e$var$_propTypes2.default.any // field value
};
$e49941725dc27c5e$var$AutosizeInput.defaultProps = {
    minWidth: 1,
    injectStyles: true
};
$e49941725dc27c5e$exports.default = $e49941725dc27c5e$var$AutosizeInput;


// ==============================
// NO OP
// ==============================
var $aadb423f5e5b4fc5$export$a9c23c6ac3fc3eca = function noop() {};
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $aadb423f5e5b4fc5$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $aadb423f5e5b4fc5$export$df995fae86a55f06(prefix, state, className) {
    var arr = [
        className
    ];
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($aadb423f5e5b4fc5$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
} // ==============================
// Clean Value
// ==============================
var $aadb423f5e5b4fc5$export$e7094788287c5e9b = function cleanValue(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if ((0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
}; // ==============================
// Handle Input Change
// ==============================
function $aadb423f5e5b4fc5$export$2329c99376c9d0a4(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
} // ==============================
// Scroll Helpers
// ==============================
function $aadb423f5e5b4fc5$export$ebd11618f299a286(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------
function $aadb423f5e5b4fc5$var$getScrollTop(el) {
    if ($aadb423f5e5b4fc5$export$ebd11618f299a286(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $aadb423f5e5b4fc5$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($aadb423f5e5b4fc5$export$ebd11618f299a286(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------
function $aadb423f5e5b4fc5$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    var docEl = document.documentElement; // suck it, flow...
    if (style.position === 'fixed') return docEl;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return docEl;
} // Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $aadb423f5e5b4fc5$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $aadb423f5e5b4fc5$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $aadb423f5e5b4fc5$export$a9c23c6ac3fc3eca;
    var start = $aadb423f5e5b4fc5$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $aadb423f5e5b4fc5$var$easeOutCubic(currentTime, start, change, duration);
        $aadb423f5e5b4fc5$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
} // Scroll Into View
// ------------------------------
function $aadb423f5e5b4fc5$export$96f57966bedc81b4(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $aadb423f5e5b4fc5$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $aadb423f5e5b4fc5$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $aadb423f5e5b4fc5$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// Touch Capability Detector
// ==============================
function $aadb423f5e5b4fc5$export$efccba1c4a2ef57b() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
} // ==============================
// Mobile Device Detector
// ==============================
function $aadb423f5e5b4fc5$export$d141bba7fdc215a3() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
function $aadb423f5e5b4fc5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aadb423f5e5b4fc5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $aadb423f5e5b4fc5$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $aadb423f5e5b4fc5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aadb423f5e5b4fc5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $aadb423f5e5b4fc5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c345de07753d2fca$export$2e2bcd8739ae039)(this, result);
    };
}
function $aadb423f5e5b4fc5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $aadb423f5e5b4fc5$var$getMenuPlacement(_ref) {
    var maxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, placement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, theme = _ref.theme;
    var spacing = theme.spacing;
    var scrollParent = $aadb423f5e5b4fc5$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: maxHeight
    }; // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = window.innerHeight;
    var scrollTop = $aadb423f5e5b4fc5$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(placement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: maxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $aadb423f5e5b4fc5$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: maxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $aadb423f5e5b4fc5$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                 // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            } // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (placement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = maxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            } // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (placement === 'bottom') {
                $aadb423f5e5b4fc5$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: maxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: maxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $aadb423f5e5b4fc5$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: maxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $aadb423f5e5b4fc5$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            } // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: maxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(placement, "\"."));
    } // fulfil contract with flow: implicit return value of undefined
    return defaultState;
} // Menu Component
// ------------------------------
function $aadb423f5e5b4fc5$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $aadb423f5e5b4fc5$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $aadb423f5e5b4fc5$export$953cecd6e717a553 = function menuCSS(_ref2) {
    var _ref3;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return _ref3 = {
        label: 'menu'
    }, (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(_ref3, $aadb423f5e5b4fc5$var$alignToControl(placement), '100%'), (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(_ref3, "backgroundColor", colors.neutral0), (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(_ref3, "borderRadius", borderRadius), (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(_ref3, "marginBottom", spacing.menuGutter), (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(_ref3, "marginTop", spacing.menuGutter), (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(_ref3, "position", 'absolute'), (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(_ref3, "width", '100%'), (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(_ref3, "zIndex", 1), _ref3;
};
var $aadb423f5e5b4fc5$var$PortalPlacementContext = /*#__PURE__*/ (0, $7Do5B.createContext)({
    getPortalPlacement: null
}); // NOTE: internal only
var $aadb423f5e5b4fc5$export$3a1a48c8f6ef640e = /*#__PURE__*/ function(_Component) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(MenuPlacer, _Component);
    var _super = $aadb423f5e5b4fc5$var$_createSuper(MenuPlacer);
    function MenuPlacer() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, MenuPlacer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            maxHeight: _this.props.maxMenuHeight,
            placement: null
        };
        _this.getPlacement = function(ref) {
            var _this$props = _this.props, minMenuHeight = _this$props.minMenuHeight, maxMenuHeight = _this$props.maxMenuHeight, menuPlacement = _this$props.menuPlacement, menuPosition = _this$props.menuPosition, menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView, theme = _this$props.theme;
            if (!ref) return; // DO NOT scroll if position is fixed
            var isFixedPosition = menuPosition === 'fixed';
            var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            var state = $aadb423f5e5b4fc5$var$getMenuPlacement({
                maxHeight: maxMenuHeight,
                menuEl: ref,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                theme: theme
            });
            var getPortalPlacement = _this.context.getPortalPlacement;
            if (getPortalPlacement) getPortalPlacement(state);
            _this.setState(state);
        };
        _this.getUpdatedProps = function() {
            var menuPlacement = _this.props.menuPlacement;
            var placement = _this.state.placement || $aadb423f5e5b4fc5$var$coercePlacement(menuPlacement);
            return $aadb423f5e5b4fc5$var$_objectSpread($aadb423f5e5b4fc5$var$_objectSpread({}, _this.props), {}, {
                placement: placement,
                maxHeight: _this.state.maxHeight
            });
        };
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(MenuPlacer, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children({
                    ref: this.getPlacement,
                    placerProps: this.getUpdatedProps()
                });
            }
        }
    ]);
    return MenuPlacer;
}((0, $7Do5B.Component));
$aadb423f5e5b4fc5$export$3a1a48c8f6ef640e.contextType = $aadb423f5e5b4fc5$var$PortalPlacementContext;
var $aadb423f5e5b4fc5$var$Menu = function Menu(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        css: getStyles('menu', props),
        className: cx({
            menu: true
        }, className)
    }, innerProps, {
        ref: innerRef
    }), children);
};
// Menu List
// ==============================
var $aadb423f5e5b4fc5$export$342063e11d6c3cad = function menuListCSS(_ref4) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return {
        maxHeight: maxHeight,
        overflowY: 'auto',
        paddingBottom: baseUnit,
        paddingTop: baseUnit,
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    };
};
var $aadb423f5e5b4fc5$var$MenuList = function MenuList(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isMulti = props.isMulti, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        css: getStyles('menuList', props),
        className: cx({
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }, className),
        ref: innerRef
    }, innerProps), children);
}; // ==============================
// Menu Notices
// ==============================
var $aadb423f5e5b4fc5$var$noticeCSS = function noticeCSS(_ref5) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
        textAlign: 'center'
    };
};
var $aadb423f5e5b4fc5$export$43caf9889c228507 = $aadb423f5e5b4fc5$var$noticeCSS;
var $aadb423f5e5b4fc5$export$35e795649ee09318 = $aadb423f5e5b4fc5$var$noticeCSS;
var $aadb423f5e5b4fc5$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        css: getStyles('noOptionsMessage', props),
        className: cx({
            'menu-notice': true,
            'menu-notice--no-options': true
        }, className)
    }, innerProps), children);
};
$aadb423f5e5b4fc5$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $aadb423f5e5b4fc5$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        css: getStyles('loadingMessage', props),
        className: cx({
            'menu-notice': true,
            'menu-notice--loading': true
        }, className)
    }, innerProps), children);
};
$aadb423f5e5b4fc5$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================
var $aadb423f5e5b4fc5$export$7ccc53e8f1e7dfc5 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $aadb423f5e5b4fc5$var$MenuPortal = /*#__PURE__*/ function(_Component2) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(MenuPortal, _Component2);
    var _super2 = $aadb423f5e5b4fc5$var$_createSuper(MenuPortal);
    function MenuPortal() {
        var _this2;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, MenuPortal);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        _this2.state = {
            placement: null
        };
        _this2.getPortalPlacement = function(_ref7) {
            var placement = _ref7.placement;
            var initialPlacement = $aadb423f5e5b4fc5$var$coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed
            if (placement !== initialPlacement) _this2.setState({
                placement: placement
            });
        };
        return _this2;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(MenuPortal, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, appendTo = _this$props2.appendTo, children = _this$props2.children, controlElement = _this$props2.controlElement, menuPlacement = _this$props2.menuPlacement, position = _this$props2.menuPosition, getStyles = _this$props2.getStyles;
                var isFixed = position === 'fixed'; // bail early if required elements aren't present
                if (!appendTo && !isFixed || !controlElement) return null;
                var placement = this.state.placement || $aadb423f5e5b4fc5$var$coercePlacement(menuPlacement);
                var rect = $aadb423f5e5b4fc5$var$getBoundingClientObj(controlElement);
                var scrollDistance = isFixed ? 0 : window.pageYOffset;
                var offset = rect[placement] + scrollDistance;
                var state = {
                    offset: offset,
                    position: position,
                    rect: rect
                }; // same wrapper element whether fixed or portalled
                var menuWrapper = (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", {
                    css: getStyles('menuPortal', state)
                }, children);
                return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)($aadb423f5e5b4fc5$var$PortalPlacementContext.Provider, {
                    value: {
                        getPortalPlacement: this.getPortalPlacement
                    }
                }, appendTo ? /*#__PURE__*/ (0, $7ikhG.createPortal)(menuWrapper, appendTo) : menuWrapper);
            }
        }
    ]);
    return MenuPortal;
}((0, $7Do5B.Component));
var $aadb423f5e5b4fc5$var$isArray = Array.isArray;
var $aadb423f5e5b4fc5$var$keyList = Object.keys;
var $aadb423f5e5b4fc5$var$hasProp = Object.prototype.hasOwnProperty;
function $aadb423f5e5b4fc5$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && (0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(a) == 'object' && (0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(b) == 'object') {
        var arrA = $aadb423f5e5b4fc5$var$isArray(a), arrB = $aadb423f5e5b4fc5$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$aadb423f5e5b4fc5$var$equal(a[i], b[i])) return false;
            }
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $aadb423f5e5b4fc5$var$keyList(a);
        length = keys.length;
        if (length !== $aadb423f5e5b4fc5$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!$aadb423f5e5b4fc5$var$hasProp.call(b, keys[i])) return false;
        } // end fast-deep-equal
        // Custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$aadb423f5e5b4fc5$var$equal(a[key], b[key])) return false;
            }
        } // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
} // end fast-deep-equal
function $aadb423f5e5b4fc5$export$ef35774e6d314e91(a, b) {
    try {
        return $aadb423f5e5b4fc5$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        } // some other error. we should definitely know about these
        throw error;
    }
}
var $aadb423f5e5b4fc5$export$407448d2b89b1813 = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : null,
        pointerEvents: isDisabled ? 'none' : null,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $aadb423f5e5b4fc5$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        css: getStyles('container', props),
        className: cx({
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }, className)
    }, innerProps), children);
}; // ==============================
// Value Container
// ==============================
var $aadb423f5e5b4fc5$export$90a7f3efeed30595 = function valueContainerCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        flexWrap: 'wrap',
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    };
};
var $aadb423f5e5b4fc5$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, isMulti = props.isMulti, getStyles = props.getStyles, hasValue = props.hasValue;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", {
        css: getStyles('valueContainer', props),
        className: cx({
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        }, className)
    }, children);
}; // ==============================
// Indicator Container
// ==============================
var $aadb423f5e5b4fc5$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $aadb423f5e5b4fc5$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", {
        css: getStyles('indicatorsContainer', props),
        className: cx({
            indicators: true
        }, className)
    }, children);
};
function $aadb423f5e5b4fc5$var$_templateObject() {
    var data = (0, $7c4bf992c3b23621$export$2e2bcd8739ae039)([
        "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
    ]);
    $aadb423f5e5b4fc5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $aadb423f5e5b4fc5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $aadb423f5e5b4fc5$var$_ref2 = {
    name: "19bqh2r",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;"
};
// ==============================
// Dropdown & Clear Icons
// ==============================
var $aadb423f5e5b4fc5$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $95fb0a49c8a38020$export$2e2bcd8739ae039)(_ref, [
        "size"
    ]);
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("svg", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $aadb423f5e5b4fc5$var$_ref2
    }, props));
};
var $aadb423f5e5b4fc5$var$CrossIcon = function CrossIcon(props) {
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)($aadb423f5e5b4fc5$var$Svg, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $aadb423f5e5b4fc5$var$DownChevron = function DownChevron(props) {
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)($aadb423f5e5b4fc5$var$Svg, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================
var $aadb423f5e5b4fc5$var$baseCSS = function baseCSS(_ref3) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return {
        label: 'indicatorContainer',
        color: isFocused ? colors.neutral60 : colors.neutral20,
        display: 'flex',
        padding: baseUnit * 2,
        transition: 'color 150ms',
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    };
};
var $aadb423f5e5b4fc5$export$4368d992c4eafac0 = $aadb423f5e5b4fc5$var$baseCSS;
var $aadb423f5e5b4fc5$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, innerProps, {
        css: getStyles('dropdownIndicator', props),
        className: cx({
            indicator: true,
            'dropdown-indicator': true
        }, className)
    }), children || (0, $6b09c71374678d25$export$c8a8987d4410bf2d)($aadb423f5e5b4fc5$var$DownChevron, null));
};
var $aadb423f5e5b4fc5$export$db3b6bfb95261072 = $aadb423f5e5b4fc5$var$baseCSS;
var $aadb423f5e5b4fc5$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, innerProps, {
        css: getStyles('clearIndicator', props),
        className: cx({
            indicator: true,
            'clear-indicator': true
        }, className)
    }), children || (0, $6b09c71374678d25$export$c8a8987d4410bf2d)($aadb423f5e5b4fc5$var$CrossIcon, null));
}; // ==============================
// Separator
// ==============================
var $aadb423f5e5b4fc5$export$2d1720544b23b823 = function indicatorSeparatorCSS(_ref4) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return {
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2,
        width: 1
    };
};
var $aadb423f5e5b4fc5$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("span", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, innerProps, {
        css: getStyles('indicatorSeparator', props),
        className: cx({
            'indicator-separator': true
        }, className)
    }));
}; // ==============================
// Loading
// ==============================
var $aadb423f5e5b4fc5$var$loadingDotAnimations = (0, $6b09c71374678d25$export$d25ddfdf17c3ad3e)($aadb423f5e5b4fc5$var$_templateObject());
var $aadb423f5e5b4fc5$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return {
        label: 'loadingIndicator',
        color: isFocused ? colors.neutral60 : colors.neutral20,
        display: 'flex',
        padding: baseUnit * 2,
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    };
};
var $aadb423f5e5b4fc5$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $c20939fbec481e9e$export$2e2bcd8739ae039)({
            animation: "".concat($aadb423f5e5b4fc5$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : null,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "")
    });
};
var $aadb423f5e5b4fc5$var$LoadingIndicator = function LoadingIndicator(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, innerProps, {
        css: getStyles('loadingIndicator', props),
        className: cx({
            indicator: true,
            'loading-indicator': true
        }, className)
    }), (0, $6b09c71374678d25$export$c8a8987d4410bf2d)($aadb423f5e5b4fc5$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $6b09c71374678d25$export$c8a8987d4410bf2d)($aadb423f5e5b4fc5$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $6b09c71374678d25$export$c8a8987d4410bf2d)($aadb423f5e5b4fc5$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$aadb423f5e5b4fc5$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $aadb423f5e5b4fc5$export$8b22cf2602fb60ce = function css(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return {
        label: 'control',
        alignItems: 'center',
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms',
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    };
};
var $aadb423f5e5b4fc5$var$Control = function Control(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, className = props.className, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        ref: innerRef,
        css: getStyles('control', props),
        className: cx({
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }, className)
    }, innerProps), children);
};
function $aadb423f5e5b4fc5$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aadb423f5e5b4fc5$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $aadb423f5e5b4fc5$var$ownKeys$1(Object(source), true).forEach(function(key) {
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $aadb423f5e5b4fc5$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $aadb423f5e5b4fc5$export$39b482c5e57630a8 = function groupCSS(_ref) {
    var spacing = _ref.theme.spacing;
    return {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $aadb423f5e5b4fc5$var$Group = function Group(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, Heading = props.Heading, headingProps = props.headingProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", {
        css: getStyles('group', props),
        className: cx({
            group: true
        }, className)
    }, (0, $6b09c71374678d25$export$c8a8987d4410bf2d)(Heading, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        cx: cx
    }), label), (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", null, children));
};
var $aadb423f5e5b4fc5$export$f1e1789686576879 = function groupHeadingCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
        label: 'group',
        color: '#999',
        cursor: 'default',
        display: 'block',
        fontSize: '75%',
        fontWeight: '500',
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    };
};
var $aadb423f5e5b4fc5$var$GroupHeading = function GroupHeading(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, theme = props.theme, selectProps = props.selectProps, cleanProps = (0, $95fb0a49c8a38020$export$2e2bcd8739ae039)(props, [
        "className",
        "cx",
        "getStyles",
        "theme",
        "selectProps"
    ]);
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        css: getStyles('groupHeading', $aadb423f5e5b4fc5$var$_objectSpread$1({
            theme: theme
        }, cleanProps)),
        className: cx({
            'group-heading': true
        }, className)
    }, cleanProps));
};
function $aadb423f5e5b4fc5$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aadb423f5e5b4fc5$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $aadb423f5e5b4fc5$var$ownKeys$2(Object(source), true).forEach(function(key) {
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $aadb423f5e5b4fc5$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $aadb423f5e5b4fc5$export$dda1d9f60106f0e9 = function inputCSS(_ref) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        visibility: isDisabled ? 'hidden' : 'visible',
        color: colors.neutral80
    };
};
var $aadb423f5e5b4fc5$var$inputStyle = function inputStyle(isHidden) {
    return {
        label: 'input',
        background: 0,
        border: 0,
        fontSize: 'inherit',
        opacity: isHidden ? 0 : 1,
        outline: 0,
        padding: 0,
        color: 'inherit'
    };
};
var $aadb423f5e5b4fc5$var$Input = function Input(_ref2) {
    var className = _ref2.className, cx = _ref2.cx, getStyles = _ref2.getStyles, innerRef = _ref2.innerRef, isHidden = _ref2.isHidden, isDisabled = _ref2.isDisabled, theme = _ref2.theme, selectProps = _ref2.selectProps, props = (0, $95fb0a49c8a38020$export$2e2bcd8739ae039)(_ref2, [
        "className",
        "cx",
        "getStyles",
        "innerRef",
        "isHidden",
        "isDisabled",
        "theme",
        "selectProps"
    ]);
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", {
        css: getStyles('input', $aadb423f5e5b4fc5$var$_objectSpread$2({
            theme: theme
        }, props))
    }, (0, $6b09c71374678d25$export$c8a8987d4410bf2d)((0, (/*@__PURE__*/$parcel$interopDefault($e49941725dc27c5e$exports))), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, className),
        inputRef: innerRef,
        inputStyle: $aadb423f5e5b4fc5$var$inputStyle(isHidden),
        disabled: isDisabled
    }, props)));
};
function $aadb423f5e5b4fc5$var$ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aadb423f5e5b4fc5$var$_objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $aadb423f5e5b4fc5$var$ownKeys$3(Object(source), true).forEach(function(key) {
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $aadb423f5e5b4fc5$var$ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $aadb423f5e5b4fc5$export$ae1af26003f05816 = function multiValueCSS(_ref) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return {
        label: 'multiValue',
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        display: 'flex',
        margin: spacing.baseUnit / 2,
        minWidth: 0 // resolves flex/text-overflow bug
    };
};
var $aadb423f5e5b4fc5$export$ffb5f4729a158638 = function multiValueLabelCSS(_ref2) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        overflow: 'hidden',
        padding: 3,
        paddingLeft: 6,
        textOverflow: cropWithEllipsis ? 'ellipsis' : null,
        whiteSpace: 'nowrap'
    };
};
var $aadb423f5e5b4fc5$export$9e5f44173e64f162 = function multiValueRemoveCSS(_ref3) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return {
        alignItems: 'center',
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused && colors.dangerLight,
        display: 'flex',
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    };
};
var $aadb423f5e5b4fc5$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $aadb423f5e5b4fc5$var$MultiValueContainer = $aadb423f5e5b4fc5$var$MultiValueGeneric;
var $aadb423f5e5b4fc5$var$MultiValueLabel = $aadb423f5e5b4fc5$var$MultiValueGeneric;
function $aadb423f5e5b4fc5$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", innerProps, children || (0, $6b09c71374678d25$export$c8a8987d4410bf2d)($aadb423f5e5b4fc5$var$CrossIcon, {
        size: 14
    }));
}
var $aadb423f5e5b4fc5$var$MultiValue = function MultiValue(props) {
    var children = props.children, className = props.className, components = props.components, cx = props.cx, data = props.data, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)((0, $6b09c71374678d25$export$9b9c0f9d9f3552b8), null, function(_ref6) {
        var css = _ref6.css, emotionCx = _ref6.cx;
        return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)(Container, {
            data: data,
            innerProps: $aadb423f5e5b4fc5$var$_objectSpread$3($aadb423f5e5b4fc5$var$_objectSpread$3({}, innerProps), {}, {
                className: emotionCx(css(getStyles('multiValue', props)), cx({
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }, className))
            }),
            selectProps: selectProps
        }, (0, $6b09c71374678d25$export$c8a8987d4410bf2d)(Label, {
            data: data,
            innerProps: {
                className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
                    'multi-value__label': true
                }, className))
            },
            selectProps: selectProps
        }, children), (0, $6b09c71374678d25$export$c8a8987d4410bf2d)(Remove, {
            data: data,
            innerProps: $aadb423f5e5b4fc5$var$_objectSpread$3({
                className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
                    'multi-value__remove': true
                }, className))
            }, removeProps),
            selectProps: selectProps
        }));
    });
};
$aadb423f5e5b4fc5$var$MultiValue.defaultProps = {
    cropWithEllipsis: true
};
var $aadb423f5e5b4fc5$export$2408f22a0fab9ae5 = function optionCSS(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: 'option',
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
        }
    };
};
var $aadb423f5e5b4fc5$var$Option = function Option(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        css: getStyles('option', props),
        className: cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className),
        ref: innerRef
    }, innerProps), children);
};
var $aadb423f5e5b4fc5$export$625550452a3fa3ec = function placeholderCSS(_ref) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: 'placeholder',
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2,
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)'
    };
};
var $aadb423f5e5b4fc5$var$Placeholder = function Placeholder(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        css: getStyles('placeholder', props),
        className: cx({
            placeholder: true
        }, className)
    }, innerProps), children);
};
var $aadb423f5e5b4fc5$export$3b14a55fb2447963 = function css(_ref) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: 'singleValue',
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2,
        maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
        overflow: 'hidden',
        position: 'absolute',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        top: '50%',
        transform: 'translateY(-50%)'
    };
};
var $aadb423f5e5b4fc5$var$SingleValue = function SingleValue(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        css: getStyles('singleValue', props),
        className: cx({
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }, className)
    }, innerProps), children);
};
function $aadb423f5e5b4fc5$var$ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aadb423f5e5b4fc5$var$_objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $aadb423f5e5b4fc5$var$ownKeys$4(Object(source), true).forEach(function(key) {
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $aadb423f5e5b4fc5$var$ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $aadb423f5e5b4fc5$export$d66501df72047452 = {
    ClearIndicator: $aadb423f5e5b4fc5$var$ClearIndicator,
    Control: $aadb423f5e5b4fc5$var$Control,
    DropdownIndicator: $aadb423f5e5b4fc5$var$DropdownIndicator,
    DownChevron: $aadb423f5e5b4fc5$var$DownChevron,
    CrossIcon: $aadb423f5e5b4fc5$var$CrossIcon,
    Group: $aadb423f5e5b4fc5$var$Group,
    GroupHeading: $aadb423f5e5b4fc5$var$GroupHeading,
    IndicatorsContainer: $aadb423f5e5b4fc5$var$IndicatorsContainer,
    IndicatorSeparator: $aadb423f5e5b4fc5$var$IndicatorSeparator,
    Input: $aadb423f5e5b4fc5$var$Input,
    LoadingIndicator: $aadb423f5e5b4fc5$var$LoadingIndicator,
    Menu: $aadb423f5e5b4fc5$var$Menu,
    MenuList: $aadb423f5e5b4fc5$var$MenuList,
    MenuPortal: $aadb423f5e5b4fc5$var$MenuPortal,
    LoadingMessage: $aadb423f5e5b4fc5$var$LoadingMessage,
    NoOptionsMessage: $aadb423f5e5b4fc5$var$NoOptionsMessage,
    MultiValue: $aadb423f5e5b4fc5$var$MultiValue,
    MultiValueContainer: $aadb423f5e5b4fc5$var$MultiValueContainer,
    MultiValueLabel: $aadb423f5e5b4fc5$var$MultiValueLabel,
    MultiValueRemove: $aadb423f5e5b4fc5$var$MultiValueRemove,
    Option: $aadb423f5e5b4fc5$var$Option,
    Placeholder: $aadb423f5e5b4fc5$var$Placeholder,
    SelectContainer: $aadb423f5e5b4fc5$var$SelectContainer,
    SingleValue: $aadb423f5e5b4fc5$var$SingleValue,
    ValueContainer: $aadb423f5e5b4fc5$var$ValueContainer
};
var $aadb423f5e5b4fc5$export$4a5767248b18ef41 = function defaultComponents(props) {
    return $aadb423f5e5b4fc5$var$_objectSpread$4($aadb423f5e5b4fc5$var$_objectSpread$4({}, $aadb423f5e5b4fc5$export$d66501df72047452), props.components);
};




function $ed0f0b97866d6cfa$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $e1872ee01ca16b60$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $9031f7f2924753e9$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $708ce1d4f20bd938$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $9031f7f2924753e9$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $9031f7f2924753e9$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $172debecf3a06e01$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $4a9275f4284d6709$export$2e2bcd8739ae039(r, e) {
    return (0, $ed0f0b97866d6cfa$export$2e2bcd8739ae039)(r) || (0, $e1872ee01ca16b60$export$2e2bcd8739ae039)(r, e) || (0, $708ce1d4f20bd938$export$2e2bcd8739ae039)(r, e) || (0, $172debecf3a06e01$export$2e2bcd8739ae039)();
}



function $63b81041f3d12ee7$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $9031f7f2924753e9$export$2e2bcd8739ae039)(r);
}


function $90a8d1a06a2704aa$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $1ceafd62b5589195$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $e8694aff92b422dc$export$2e2bcd8739ae039(r) {
    return (0, $63b81041f3d12ee7$export$2e2bcd8739ae039)(r) || (0, $90a8d1a06a2704aa$export$2e2bcd8739ae039)(r) || (0, $708ce1d4f20bd938$export$2e2bcd8739ae039)(r) || (0, $1ceafd62b5589195$export$2e2bcd8739ae039)();
}









parcelRequire("7ikhG");
var $7Do5B = parcelRequire("7Do5B");
var $7ikhG = parcelRequire("7ikhG");



var $7ikhG = parcelRequire("7ikhG");


var $39f9a147bda2d929$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $39f9a147bda2d929$var$anyDiacritic = new RegExp('[' + $39f9a147bda2d929$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $39f9a147bda2d929$var$diacriticToBase = {};
for(var $39f9a147bda2d929$var$i = 0; $39f9a147bda2d929$var$i < $39f9a147bda2d929$var$diacritics.length; $39f9a147bda2d929$var$i++){
    var $39f9a147bda2d929$var$diacritic = $39f9a147bda2d929$var$diacritics[$39f9a147bda2d929$var$i];
    for(var $39f9a147bda2d929$var$j = 0; $39f9a147bda2d929$var$j < $39f9a147bda2d929$var$diacritic.letters.length; $39f9a147bda2d929$var$j++)$39f9a147bda2d929$var$diacriticToBase[$39f9a147bda2d929$var$diacritic.letters[$39f9a147bda2d929$var$j]] = $39f9a147bda2d929$var$diacritic.base;
}
var $39f9a147bda2d929$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($39f9a147bda2d929$var$anyDiacritic, function(match) {
        return $39f9a147bda2d929$var$diacriticToBase[match];
    });
};
function $39f9a147bda2d929$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $39f9a147bda2d929$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $39f9a147bda2d929$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $39f9a147bda2d929$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $39f9a147bda2d929$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $39f9a147bda2d929$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $39f9a147bda2d929$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        var _ignoreCase$ignoreAcc = $39f9a147bda2d929$var$_objectSpread({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $39f9a147bda2d929$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $39f9a147bda2d929$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $39f9a147bda2d929$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $39f9a147bda2d929$var$stripDiacritics(input);
            candidate = $39f9a147bda2d929$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
function $39f9a147bda2d929$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $39f9a147bda2d929$var$_ref = {
    name: "1laao21-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;"
};
var $39f9a147bda2d929$var$A11yText = function A11yText(props) {
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("span", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        css: $39f9a147bda2d929$var$_ref
    }, props));
};
function $39f9a147bda2d929$var$DummyInput(_ref) {
    var inProp = _ref.in, out = _ref.out, onExited = _ref.onExited, appear = _ref.appear, enter = _ref.enter, exit = _ref.exit, innerRef = _ref.innerRef, emotion = _ref.emotion, props = (0, $95fb0a49c8a38020$export$2e2bcd8739ae039)(_ref, [
        "in",
        "out",
        "onExited",
        "appear",
        "enter",
        "exit",
        "innerRef",
        "emotion"
    ]);
    return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("input", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        ref: innerRef
    }, props, {
        css: /*#__PURE__*/ (0, $c20939fbec481e9e$export$2e2bcd8739ae039)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            fontSize: 'inherit',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(0)'
        }, "")
    }));
}
function $39f9a147bda2d929$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $39f9a147bda2d929$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c345de07753d2fca$export$2e2bcd8739ae039)(this, result);
    };
}
function $39f9a147bda2d929$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $39f9a147bda2d929$var$NodeResolver = /*#__PURE__*/ function(_Component) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(NodeResolver, _Component);
    var _super = $39f9a147bda2d929$var$_createSuper(NodeResolver);
    function NodeResolver() {
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, NodeResolver);
        return _super.apply(this, arguments);
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(NodeResolver, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.innerRef((0, $7ikhG.findDOMNode)(this));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}((0, $7Do5B.Component));
var $39f9a147bda2d929$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $39f9a147bda2d929$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $39f9a147bda2d929$var$preventTouchMove(e) {
    e.preventDefault();
}
function $39f9a147bda2d929$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $39f9a147bda2d929$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $39f9a147bda2d929$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
function $39f9a147bda2d929$var$_createSuper$1(Derived) {
    var hasNativeReflectConstruct = $39f9a147bda2d929$var$_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c345de07753d2fca$export$2e2bcd8739ae039)(this, result);
    };
}
function $39f9a147bda2d929$var$_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $39f9a147bda2d929$var$canUseDOM = !!(window.document && window.document.createElement);
var $39f9a147bda2d929$var$activeScrollLocks = 0;
var $39f9a147bda2d929$var$ScrollLock = /*#__PURE__*/ function(_Component) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(ScrollLock, _Component);
    var _super = $39f9a147bda2d929$var$_createSuper$1(ScrollLock);
    function ScrollLock() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, ScrollLock);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.originalStyles = {};
        _this.listenerOptions = {
            capture: false,
            passive: false
        };
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(ScrollLock, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                if (!$39f9a147bda2d929$var$canUseDOM) return;
                var _this$props = this.props, accountForScrollbars = _this$props.accountForScrollbars, touchScrollTarget = _this$props.touchScrollTarget;
                var target = document.body;
                var targetStyle = target && target.style;
                if (accountForScrollbars) // store any styles already applied to the body
                $39f9a147bda2d929$var$STYLE_KEYS.forEach(function(key) {
                    var val = targetStyle && targetStyle[key];
                    _this2.originalStyles[key] = val;
                });
                 // apply the lock styles and padding if this is the first scroll lock
                if (accountForScrollbars && $39f9a147bda2d929$var$activeScrollLocks < 1) {
                    var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
                    var clientWidth = document.body ? document.body.clientWidth : 0;
                    var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                    Object.keys($39f9a147bda2d929$var$LOCK_STYLES).forEach(function(key) {
                        var val = $39f9a147bda2d929$var$LOCK_STYLES[key];
                        if (targetStyle) targetStyle[key] = val;
                    });
                    if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
                } // account for touch devices
                if (target && $39f9a147bda2d929$var$isTouchDevice()) {
                    // Mobile Safari ignores { overflow: hidden } declaration on the body.
                    target.addEventListener('touchmove', $39f9a147bda2d929$var$preventTouchMove, this.listenerOptions); // Allow scroll on provided target
                    if (touchScrollTarget) {
                        touchScrollTarget.addEventListener('touchstart', $39f9a147bda2d929$var$preventInertiaScroll, this.listenerOptions);
                        touchScrollTarget.addEventListener('touchmove', $39f9a147bda2d929$var$allowTouchMove, this.listenerOptions);
                    }
                } // increment active scroll locks
                $39f9a147bda2d929$var$activeScrollLocks += 1;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this3 = this;
                if (!$39f9a147bda2d929$var$canUseDOM) return;
                var _this$props2 = this.props, accountForScrollbars = _this$props2.accountForScrollbars, touchScrollTarget = _this$props2.touchScrollTarget;
                var target = document.body;
                var targetStyle = target && target.style; // safely decrement active scroll locks
                $39f9a147bda2d929$var$activeScrollLocks = Math.max($39f9a147bda2d929$var$activeScrollLocks - 1, 0); // reapply original body styles, if any
                if (accountForScrollbars && $39f9a147bda2d929$var$activeScrollLocks < 1) $39f9a147bda2d929$var$STYLE_KEYS.forEach(function(key) {
                    var val = _this3.originalStyles[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                 // remove touch listeners
                if (target && $39f9a147bda2d929$var$isTouchDevice()) {
                    target.removeEventListener('touchmove', $39f9a147bda2d929$var$preventTouchMove, this.listenerOptions);
                    if (touchScrollTarget) {
                        touchScrollTarget.removeEventListener('touchstart', $39f9a147bda2d929$var$preventInertiaScroll, this.listenerOptions);
                        touchScrollTarget.removeEventListener('touchmove', $39f9a147bda2d929$var$allowTouchMove, this.listenerOptions);
                    }
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
    return ScrollLock;
}((0, $7Do5B.Component));
$39f9a147bda2d929$var$ScrollLock.defaultProps = {
    accountForScrollbars: true
};
function $39f9a147bda2d929$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $39f9a147bda2d929$var$_createSuper$2(Derived) {
    var hasNativeReflectConstruct = $39f9a147bda2d929$var$_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c345de07753d2fca$export$2e2bcd8739ae039)(this, result);
    };
}
function $39f9a147bda2d929$var$_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $39f9a147bda2d929$var$_ref$1 = {
    name: "1dsbpcp",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0;"
};
// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
var $39f9a147bda2d929$var$ScrollBlock = /*#__PURE__*/ function(_PureComponent) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(ScrollBlock, _PureComponent);
    var _super = $39f9a147bda2d929$var$_createSuper$2(ScrollBlock);
    function ScrollBlock() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, ScrollBlock);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            touchScrollTarget: null
        };
        _this.getScrollTarget = function(ref) {
            if (ref === _this.state.touchScrollTarget) return;
            _this.setState({
                touchScrollTarget: ref
            });
        };
        _this.blurSelectInput = function() {
            if (document.activeElement) document.activeElement.blur();
        };
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(ScrollBlock, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, isEnabled = _this$props.isEnabled;
                var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled
                if (!isEnabled) return children;
                /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */ return (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", null, (0, $6b09c71374678d25$export$c8a8987d4410bf2d)("div", {
                    onClick: this.blurSelectInput,
                    css: $39f9a147bda2d929$var$_ref$1
                }), (0, $6b09c71374678d25$export$c8a8987d4410bf2d)($39f9a147bda2d929$var$NodeResolver, {
                    innerRef: this.getScrollTarget
                }, children), touchScrollTarget ? (0, $6b09c71374678d25$export$c8a8987d4410bf2d)($39f9a147bda2d929$var$ScrollLock, {
                    touchScrollTarget: touchScrollTarget
                }) : null);
            }
        }
    ]);
    return ScrollBlock;
}((0, $7ikhG.PureComponent));
function $39f9a147bda2d929$var$_createSuper$3(Derived) {
    var hasNativeReflectConstruct = $39f9a147bda2d929$var$_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c345de07753d2fca$export$2e2bcd8739ae039)(this, result);
    };
}
function $39f9a147bda2d929$var$_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $39f9a147bda2d929$var$ScrollCaptor = /*#__PURE__*/ function(_Component) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(ScrollCaptor, _Component);
    var _super = $39f9a147bda2d929$var$_createSuper$3(ScrollCaptor);
    function ScrollCaptor() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, ScrollCaptor);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.isBottom = false;
        _this.isTop = false;
        _this.scrollTarget = void 0;
        _this.touchStart = void 0;
        _this.cancelScroll = function(event) {
            event.preventDefault();
            event.stopPropagation();
        };
        _this.handleEventDelta = function(event, delta) {
            var _this$props = _this.props, onBottomArrive = _this$props.onBottomArrive, onBottomLeave = _this$props.onBottomLeave, onTopArrive = _this$props.onTopArrive, onTopLeave = _this$props.onTopLeave;
            var _this$scrollTarget = _this.scrollTarget, scrollTop = _this$scrollTarget.scrollTop, scrollHeight = _this$scrollTarget.scrollHeight, clientHeight = _this$scrollTarget.clientHeight;
            var target = _this.scrollTarget;
            var isDeltaPositive = delta > 0;
            var availableScroll = scrollHeight - clientHeight - scrollTop;
            var shouldCancelScroll = false; // reset bottom/top flags
            if (availableScroll > delta && _this.isBottom) {
                if (onBottomLeave) onBottomLeave(event);
                _this.isBottom = false;
            }
            if (isDeltaPositive && _this.isTop) {
                if (onTopLeave) onTopLeave(event);
                _this.isTop = false;
            } // bottom limit
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !_this.isBottom) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                _this.isBottom = true; // top limit
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !_this.isTop) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                _this.isTop = true;
            } // cancel scroll
            if (shouldCancelScroll) _this.cancelScroll(event);
        };
        _this.onWheel = function(event) {
            _this.handleEventDelta(event, event.deltaY);
        };
        _this.onTouchStart = function(event) {
            // set touch start so we can calculate touchmove delta
            _this.touchStart = event.changedTouches[0].clientY;
        };
        _this.onTouchMove = function(event) {
            var deltaY = _this.touchStart - event.changedTouches[0].clientY;
            _this.handleEventDelta(event, deltaY);
        };
        _this.getScrollTarget = function(ref) {
            _this.scrollTarget = ref;
        };
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(ScrollCaptor, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListening(this.scrollTarget);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListening(this.scrollTarget);
            }
        },
        {
            key: "startListening",
            value: function startListening(el) {
                // bail early if no element is available to attach to
                if (!el) return; // all the if statements are to appease Flow 😢
                if (typeof el.addEventListener === 'function') el.addEventListener('wheel', this.onWheel, false);
                if (typeof el.addEventListener === 'function') el.addEventListener('touchstart', this.onTouchStart, false);
                if (typeof el.addEventListener === 'function') el.addEventListener('touchmove', this.onTouchMove, false);
            }
        },
        {
            key: "stopListening",
            value: function stopListening(el) {
                if (!el) return; // all the if statements are to appease Flow 😢
                if (typeof el.removeEventListener === 'function') el.removeEventListener('wheel', this.onWheel, false);
                if (typeof el.removeEventListener === 'function') el.removeEventListener('touchstart', this.onTouchStart, false);
                if (typeof el.removeEventListener === 'function') el.removeEventListener('touchmove', this.onTouchMove, false);
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, $7ikhG.default).createElement($39f9a147bda2d929$var$NodeResolver, {
                    innerRef: this.getScrollTarget
                }, this.props.children);
            }
        }
    ]);
    return ScrollCaptor;
}((0, $7Do5B.Component));
function $39f9a147bda2d929$var$ScrollCaptorSwitch(_ref) {
    var _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, props = (0, $95fb0a49c8a38020$export$2e2bcd8739ae039)(_ref, [
        "isEnabled"
    ]);
    return isEnabled ? /*#__PURE__*/ (0, $7ikhG.default).createElement($39f9a147bda2d929$var$ScrollCaptor, props) : props.children;
}
var $39f9a147bda2d929$var$instructionsAriaMessage = function instructionsAriaMessage(event) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var isSearchable = context.isSearchable, isMulti = context.isMulti, label = context.label, isDisabled = context.isDisabled, tabSelectsValue = context.tabSelectsValue;
    switch(event){
        case 'menu':
            return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
        case 'input':
            return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
        case 'value':
            return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
    }
};
var $39f9a147bda2d929$var$valueEventAriaMessage = function valueEventAriaMessage(event, context) {
    var value = context.value, isDisabled = context.isDisabled;
    if (!value) return;
    switch(event){
        case 'deselect-option':
        case 'pop-value':
        case 'remove-value':
            return "option ".concat(value, ", deselected.");
        case 'select-option':
            return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
    }
};
var $39f9a147bda2d929$var$valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
    var focusedValue = _ref.focusedValue, getOptionLabel = _ref.getOptionLabel, selectValue = _ref.selectValue;
    return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
};
var $39f9a147bda2d929$var$optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
    var focusedOption = _ref2.focusedOption, getOptionLabel = _ref2.getOptionLabel, options = _ref2.options;
    return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? ' disabled' : '', ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
};
var $39f9a147bda2d929$var$resultsAriaMessage = function resultsAriaMessage(_ref3) {
    var inputValue = _ref3.inputValue, screenReaderMessage = _ref3.screenReaderMessage;
    return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
};
var $39f9a147bda2d929$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $39f9a147bda2d929$var$getOptionLabel = function getOptionLabel(option) {
    return option.label;
};
var $39f9a147bda2d929$var$getOptionValue = function getOptionValue(option) {
    return option.value;
};
var $39f9a147bda2d929$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
function $39f9a147bda2d929$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $39f9a147bda2d929$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $39f9a147bda2d929$var$ownKeys$1(Object(source), true).forEach(function(key) {
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $39f9a147bda2d929$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $39f9a147bda2d929$var$defaultStyles = {
    clearIndicator: (0, $aadb423f5e5b4fc5$export$db3b6bfb95261072),
    container: (0, $aadb423f5e5b4fc5$export$407448d2b89b1813),
    control: (0, $aadb423f5e5b4fc5$export$8b22cf2602fb60ce),
    dropdownIndicator: (0, $aadb423f5e5b4fc5$export$4368d992c4eafac0),
    group: (0, $aadb423f5e5b4fc5$export$39b482c5e57630a8),
    groupHeading: (0, $aadb423f5e5b4fc5$export$f1e1789686576879),
    indicatorsContainer: (0, $aadb423f5e5b4fc5$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $aadb423f5e5b4fc5$export$2d1720544b23b823),
    input: (0, $aadb423f5e5b4fc5$export$dda1d9f60106f0e9),
    loadingIndicator: (0, $aadb423f5e5b4fc5$export$882b5998b3b9117c),
    loadingMessage: (0, $aadb423f5e5b4fc5$export$35e795649ee09318),
    menu: (0, $aadb423f5e5b4fc5$export$953cecd6e717a553),
    menuList: (0, $aadb423f5e5b4fc5$export$342063e11d6c3cad),
    menuPortal: (0, $aadb423f5e5b4fc5$export$7ccc53e8f1e7dfc5),
    multiValue: (0, $aadb423f5e5b4fc5$export$ae1af26003f05816),
    multiValueLabel: (0, $aadb423f5e5b4fc5$export$ffb5f4729a158638),
    multiValueRemove: (0, $aadb423f5e5b4fc5$export$9e5f44173e64f162),
    noOptionsMessage: (0, $aadb423f5e5b4fc5$export$43caf9889c228507),
    option: (0, $aadb423f5e5b4fc5$export$2408f22a0fab9ae5),
    placeholder: (0, $aadb423f5e5b4fc5$export$625550452a3fa3ec),
    singleValue: (0, $aadb423f5e5b4fc5$export$3b14a55fb2447963),
    valueContainer: (0, $aadb423f5e5b4fc5$export$90a7f3efeed30595)
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles
function $39f9a147bda2d929$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = $39f9a147bda2d929$var$_objectSpread$1({}, source); // massage in target styles
    Object.keys(target).forEach(function(key) {
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $39f9a147bda2d929$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $39f9a147bda2d929$var$borderRadius = 4; // Used to calculate consistent margin/padding on elements
var $39f9a147bda2d929$var$baseUnit = 4; // The minimum height of the control
var $39f9a147bda2d929$var$controlHeight = 38; // The amount of space between the control and menu */
var $39f9a147bda2d929$var$menuGutter = $39f9a147bda2d929$var$baseUnit * 2;
var $39f9a147bda2d929$var$spacing = {
    baseUnit: $39f9a147bda2d929$var$baseUnit,
    controlHeight: $39f9a147bda2d929$var$controlHeight,
    menuGutter: $39f9a147bda2d929$var$menuGutter
};
var $39f9a147bda2d929$export$407448d2b89b1813 = {
    borderRadius: $39f9a147bda2d929$var$borderRadius,
    colors: $39f9a147bda2d929$var$colors,
    spacing: $39f9a147bda2d929$var$spacing
};
function $39f9a147bda2d929$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $39f9a147bda2d929$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $39f9a147bda2d929$var$ownKeys$2(Object(source), true).forEach(function(key) {
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $39f9a147bda2d929$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $39f9a147bda2d929$var$_createSuper$4(Derived) {
    var hasNativeReflectConstruct = $39f9a147bda2d929$var$_isNativeReflectConstruct$4();
    return function _createSuperInternal() {
        var Super = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c345de07753d2fca$export$2e2bcd8739ae039)(this, result);
    };
}
function $39f9a147bda2d929$var$_isNativeReflectConstruct$4() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $39f9a147bda2d929$export$4368d992c4eafac0 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $aadb423f5e5b4fc5$export$efccba1c4a2ef57b)(),
    captureMenuScroll: !(0, $aadb423f5e5b4fc5$export$efccba1c4a2ef57b)(),
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $39f9a147bda2d929$export$db3b6bfb95261072(),
    formatGroupLabel: $39f9a147bda2d929$var$formatGroupLabel,
    getOptionLabel: $39f9a147bda2d929$var$getOptionLabel,
    getOptionValue: $39f9a147bda2d929$var$getOptionValue,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $39f9a147bda2d929$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $aadb423f5e5b4fc5$export$d141bba7fdc215a3)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: '0',
    tabSelectsValue: true
};
var $39f9a147bda2d929$var$instanceId = 1;
var $39f9a147bda2d929$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(Select, _Component);
    var _super = $39f9a147bda2d929$var$_createSuper$4(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaLiveSelection: '',
            ariaLiveContext: '',
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            menuOptions: {
                render: [],
                focusable: []
            },
            selectValue: []
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.clearFocusValueOnUpdate = false;
        _this.commonProps = void 0;
        _this.components = void 0;
        _this.hasGroups = false;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.inputIsHiddenAfterUpdate = void 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.cacheComponents = function(components) {
            _this.components = (0, $aadb423f5e5b4fc5$export$4a5767248b18ef41)({
                components: components
            });
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            onChange(newValue, $39f9a147bda2d929$var$_objectSpread$2($39f9a147bda2d929$var$_objectSpread$2({}, actionMeta), {}, {
                name: name
            }));
        };
        _this.setValue = function(newValue) {
            var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
            var option = arguments.length > 2 ? arguments[2] : undefined;
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti;
            _this.onInputChange('', {
                action: 'set-value'
            });
            if (closeMenuOnSelect) {
                _this.inputIsHiddenAfterUpdate = !isMulti;
                _this.onMenuClose();
            } // when the select value should change, we should reset focusedValue
            _this.clearFocusValueOnUpdate = true;
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti;
            var selectValue = _this.state.selectValue;
            if (isMulti) {
                if (_this.isOptionSelected(newValue, selectValue)) {
                    var candidate = _this.getOptionValue(newValue);
                    _this.setValue(selectValue.filter(function(i) {
                        return _this.getOptionValue(i) !== candidate;
                    }), 'deselect-option', newValue);
                    _this.announceAriaLiveSelection({
                        event: 'deselect-option',
                        context: {
                            value: _this.getOptionLabel(newValue)
                        }
                    });
                } else if (!_this.isOptionDisabled(newValue, selectValue)) {
                    _this.setValue([].concat((0, $e8694aff92b422dc$export$2e2bcd8739ae039)(selectValue), [
                        newValue
                    ]), 'select-option', newValue);
                    _this.announceAriaLiveSelection({
                        event: 'select-option',
                        context: {
                            value: _this.getOptionLabel(newValue)
                        }
                    });
                } else // announce that option is disabled
                _this.announceAriaLiveSelection({
                    event: 'select-option',
                    context: {
                        value: _this.getOptionLabel(newValue),
                        isDisabled: true
                    }
                });
            } else if (!_this.isOptionDisabled(newValue, selectValue)) {
                _this.setValue(newValue, 'select-option');
                _this.announceAriaLiveSelection({
                    event: 'select-option',
                    context: {
                        value: _this.getOptionLabel(newValue)
                    }
                });
            } else // announce that option is disabled
            _this.announceAriaLiveSelection({
                event: 'select-option',
                context: {
                    value: _this.getOptionLabel(newValue),
                    isDisabled: true
                }
            });
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValue = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            _this.onChange(newValue.length ? newValue : null, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.announceAriaLiveSelection({
                event: 'remove-value',
                context: {
                    value: removedValue ? _this.getOptionLabel(removedValue) : ''
                }
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            _this.onChange(null, {
                action: 'clear'
            });
        };
        _this.popValue = function() {
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValue = selectValue.slice(0, selectValue.length - 1);
            _this.announceAriaLiveSelection({
                event: 'pop-value',
                context: {
                    value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
                }
            });
            _this.onChange(newValue.length ? newValue : null, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $aadb423f5e5b4fc5$export$df995fae86a55f06).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return _this.props.getOptionLabel(data);
        };
        _this.getOptionValue = function(data) {
            return _this.props.getOptionValue(data);
        };
        _this.getStyles = function(key, props) {
            var base = $39f9a147bda2d929$var$defaultStyles[key](props);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getActiveDescendentId = function() {
            var menuIsOpen = _this.props.menuIsOpen;
            var _this$state = _this.state, menuOptions = _this$state.menuOptions, focusedOption = _this$state.focusedOption;
            if (!focusedOption || !menuIsOpen) return undefined;
            var index = menuOptions.focusable.indexOf(focusedOption);
            var option = menuOptions.render[index];
            return option && option.key;
        };
        _this.announceAriaLiveSelection = function(_ref2) {
            var event = _ref2.event, context = _ref2.context;
            _this.setState({
                ariaLiveSelection: $39f9a147bda2d929$var$valueEventAriaMessage(event, context)
            });
        };
        _this.announceAriaLiveContext = function(_ref3) {
            var event = _ref3.event, context = _ref3.context;
            _this.setState({
                ariaLiveContext: $39f9a147bda2d929$var$instructionsAriaMessage(event, $39f9a147bda2d929$var$_objectSpread$2($39f9a147bda2d929$var$_objectSpread$2({}, context), {}, {
                    label: _this.props['aria-label']
                }))
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.inputIsHiddenAfterUpdate = !isMulti;
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $aadb423f5e5b4fc5$export$ebd11618f299a286)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref4) {
            var touches = _ref4.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref5) {
            var touches = _ref5.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return; // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
             // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var inputValue = event.currentTarget.value;
            _this.inputIsHiddenAfterUpdate = false;
            _this.onInputChange(inputValue, {
                action: 'input-change'
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            var _this$props5 = _this.props, isSearchable = _this$props5.isSearchable, isMulti = _this$props5.isMulti;
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.inputIsHiddenAfterUpdate = false;
            _this.announceAriaLiveContext({
                event: 'input',
                context: {
                    isSearchable: isSearchable,
                    isMulti: isMulti
                }
            });
            _this.setState({
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur'
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            var _this$props6 = _this.props, hideSelectedOptions = _this$props6.hideSelectedOptions, isMulti = _this$props6.isMulti;
            if (hideSelectedOptions === undefined) return isMulti;
            return hideSelectedOptions;
        };
        _this.onKeyDown = function(event) {
            var _this$props7 = _this.props, isMulti = _this$props7.isMulti, backspaceRemovesValue = _this$props7.backspaceRemovesValue, escapeClearsValue = _this$props7.escapeClearsValue, inputValue = _this$props7.inputValue, isClearable = _this$props7.isClearable, isDisabled = _this$props7.isDisabled, menuIsOpen = _this$props7.menuIsOpen, onKeyDown = _this$props7.onKeyDown, tabSelectsValue = _this$props7.tabSelectsValue, openMenuOnFocus = _this$props7.openMenuOnFocus;
            var _this$state2 = _this.state, focusedOption = _this$state2.focusedOption, focusedValue = _this$state2.focusedValue, selectValue = _this$state2.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            } // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.inputIsHiddenAfterUpdate = false;
                        _this.onInputChange('', {
                            action: 'menu-close'
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.buildMenuOptions = function(props, selectValue) {
            var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue, options = props.options;
            var toOption = function toOption(option, id) {
                var isDisabled = _this.isOptionDisabled(option, selectValue);
                var isSelected = _this.isOptionSelected(option, selectValue);
                var label = _this.getOptionLabel(option);
                var value = _this.getOptionValue(option);
                if (_this.shouldHideSelectedOptions() && isSelected || !_this.filterOption({
                    label: label,
                    value: value,
                    data: option
                }, inputValue)) return;
                var onHover = isDisabled ? undefined : function() {
                    return _this.onOptionHover(option);
                };
                var onSelect = isDisabled ? undefined : function() {
                    return _this.selectOption(option);
                };
                var optionId = "".concat(_this.getElementId('option'), "-").concat(id);
                return {
                    innerProps: {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    },
                    data: option,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: 'option',
                    value: value
                };
            };
            return options.reduce(function(acc, item, itemIndex) {
                if (item.options) {
                    // TODO needs a tidier implementation
                    if (!_this.hasGroups) _this.hasGroups = true;
                    var items = item.options;
                    var children = items.map(function(child, i) {
                        var option = toOption(child, "".concat(itemIndex, "-").concat(i));
                        if (option) acc.focusable.push(child);
                        return option;
                    }).filter(Boolean);
                    if (children.length) {
                        var groupId = "".concat(_this.getElementId('group'), "-").concat(itemIndex);
                        acc.render.push({
                            type: 'group',
                            key: groupId,
                            data: item,
                            options: children
                        });
                    }
                } else {
                    var option = toOption(item, "".concat(itemIndex));
                    if (option) {
                        acc.render.push(option);
                        acc.focusable.push(item);
                    }
                }
                return acc;
            }, {
                render: [],
                focusable: []
            });
        };
        var _value = _props.value;
        _this.cacheComponents = (0, $16d5efbf3de5c533$export$2e2bcd8739ae039)(_this.cacheComponents, (0, $aadb423f5e5b4fc5$export$ef35774e6d314e91)).bind((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this));
        _this.cacheComponents(_props.components);
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$39f9a147bda2d929$var$instanceId);
        var _selectValue = (0, $aadb423f5e5b4fc5$export$e7094788287c5e9b)(_value);
        _this.buildMenuOptions = (0, $16d5efbf3de5c533$export$2e2bcd8739ae039)(_this.buildMenuOptions, function(newArgs, lastArgs) {
            var _ref6 = newArgs, _ref7 = (0, $4a9275f4284d6709$export$2e2bcd8739ae039)(_ref6, 2), newProps = _ref7[0], newSelectValue = _ref7[1];
            var _ref8 = lastArgs, _ref9 = (0, $4a9275f4284d6709$export$2e2bcd8739ae039)(_ref8, 2), lastProps = _ref9[0], lastSelectValue = _ref9[1];
            return newSelectValue === lastSelectValue && newProps.inputValue === lastProps.inputValue && newProps.options === lastProps.options;
        }).bind((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this));
        var _menuOptions = _props.menuIsOpen ? _this.buildMenuOptions(_props, _selectValue) : {
            render: [],
            focusable: []
        };
        _this.state.menuOptions = _menuOptions;
        _this.state.selectValue = _selectValue;
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                var _this$props8 = this.props, options = _this$props8.options, value = _this$props8.value, menuIsOpen = _this$props8.menuIsOpen, inputValue = _this$props8.inputValue; // re-cache custom components
                this.cacheComponents(nextProps.components); // rebuild the menu options
                if (nextProps.value !== value || nextProps.options !== options || nextProps.menuIsOpen !== menuIsOpen || nextProps.inputValue !== inputValue) {
                    var selectValue = (0, $aadb423f5e5b4fc5$export$e7094788287c5e9b)(nextProps.value);
                    var menuOptions = nextProps.menuIsOpen ? this.buildMenuOptions(nextProps, selectValue) : {
                        render: [],
                        focusable: []
                    };
                    var focusedValue = this.getNextFocusedValue(selectValue);
                    var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
                    this.setState({
                        menuOptions: menuOptions,
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue
                    });
                } // some updates should toggle the state of the input visibility
                if (this.inputIsHiddenAfterUpdate != null) {
                    this.setState({
                        inputIsHidden: this.inputIsHiddenAfterUpdate
                    });
                    delete this.inputIsHiddenAfterUpdate;
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props9 = this.props, isDisabled = _this$props9.isDisabled, menuIsOpen = _this$props9.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                 // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $aadb423f5e5b4fc5$export$96f57966bedc81b4)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            // ==============================
            // Consumer Handlers
            // ==============================
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                var _this$props10 = this.props, isSearchable = _this$props10.isSearchable, isMulti = _this$props10.isMulti;
                this.announceAriaLiveContext({
                    event: 'input',
                    context: {
                        isSearchable: isSearchable,
                        isMulti: isMulti
                    }
                });
                this.onInputChange('', {
                    action: 'menu-close'
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            } // ==============================
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            } // aliased for consumers
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, isFocused = _this$state3.isFocused;
                var menuOptions = this.buildMenuOptions(this.props, selectValue);
                var _this$props11 = this.props, isMulti = _this$props11.isMulti, tabSelectsValue = _this$props11.tabSelectsValue;
                var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;
                if (!isMulti) {
                    var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                } // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.inputIsHiddenAfterUpdate = false;
                this.setState({
                    menuOptions: menuOptions,
                    focusedValue: null,
                    focusedOption: menuOptions.focusable[openAtIndex]
                }, function() {
                    _this2.onMenuOpen();
                    _this2.announceAriaLiveContext({
                        event: 'menu',
                        context: {
                            tabSelectsValue: tabSelectsValue
                        }
                    });
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$props12 = this.props, isMulti = _this$props12.isMulti, isSearchable = _this$props12.isSearchable;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing
                if (!isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) {
                    focusedIndex = -1;
                    this.announceAriaLiveContext({
                        event: 'value'
                    });
                }
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                if (nextFocus === -1) this.announceAriaLiveContext({
                    event: 'input',
                    context: {
                        isSearchable: isSearchable,
                        isMulti: isMulti
                    }
                });
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var _this$props13 = this.props, pageSize = _this$props13.pageSize, tabSelectsValue = _this$props13.tabSelectsValue;
                var _this$state5 = this.state, focusedOption = _this$state5.focusedOption, menuOptions = _this$state5.menuOptions;
                var options = menuOptions.focusable;
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) {
                    focusedIndex = -1;
                    this.announceAriaLiveContext({
                        event: 'menu',
                        context: {
                            tabSelectsValue: tabSelectsValue
                        }
                    });
                }
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
                this.announceAriaLiveContext({
                    event: 'menu',
                    context: {
                        isDisabled: $39f9a147bda2d929$var$isOptionDisabled(options[nextFocus]),
                        tabSelectsValue: tabSelectsValue
                    }
                });
            }
        },
        {
            key: "getTheme",
            // ==============================
            // Getters
            // ==============================
            value: function getTheme() {
                // Use the default theme if there are no customizations.
                if (!this.props.theme) return $39f9a147bda2d929$export$407448d2b89b1813;
                 // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($39f9a147bda2d929$export$407448d2b89b1813);
                 // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return $39f9a147bda2d929$var$_objectSpread$2($39f9a147bda2d929$var$_objectSpread$2({}, $39f9a147bda2d929$export$407448d2b89b1813), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getValue = this.getValue, setValue = this.setValue, selectOption = this.selectOption, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    cx: cx,
                    clearValue: clearValue,
                    getStyles: getStyles,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    setValue: setValue,
                    selectProps: props,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "getNextFocusedValue",
            value: function getNextFocusedValue(nextSelectValue) {
                if (this.clearFocusValueOnUpdate) {
                    this.clearFocusValueOnUpdate = false;
                    return null;
                }
                var _this$state6 = this.state, focusedValue = _this$state6.focusedValue, lastSelectValue = _this$state6.selectValue;
                var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
                if (lastFocusedIndex > -1) {
                    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
                    if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
                    return focusedValue;
                    else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
                    // reference, so return the new value at the same index
                    return nextSelectValue[lastFocusedIndex];
                }
                return null;
            }
        },
        {
            key: "getNextFocusedOption",
            value: function getNextFocusedOption(options) {
                var lastFocusedOption = this.state.focusedOption;
                return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.state.menuOptions.render.length;
            }
        },
        {
            key: "countOptions",
            value: function countOptions() {
                return this.state.menuOptions.focusable.length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props14 = this.props, isClearable = _this$props14.isClearable, isMulti = _this$props14.isMulti; // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                var _this3 = this;
                if (selectValue.indexOf(option) > -1) return true;
                if (typeof this.props.isOptionSelected === 'function') return this.props.isOptionSelected(option, selectValue);
                var candidate = this.getOptionValue(option);
                return selectValue.some(function(i) {
                    return _this3.getOptionValue(i) === candidate;
                });
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            } // ==============================
        },
        {
            key: "startListeningComposition",
            // ==============================
            // Composition Handlers
            // ==============================
            value: function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            // ==============================
            // Touch Handlers
            // ==============================
            value: function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "constructAriaLiveMessage",
            // ==============================
            // Renderers
            // ==============================
            value: function constructAriaLiveMessage() {
                var _this$state7 = this.state, ariaLiveContext = _this$state7.ariaLiveContext, selectValue = _this$state7.selectValue, focusedValue = _this$state7.focusedValue, focusedOption = _this$state7.focusedOption;
                var _this$props15 = this.props, options = _this$props15.options, menuIsOpen = _this$props15.menuIsOpen, inputValue = _this$props15.inputValue, screenReaderStatus = _this$props15.screenReaderStatus; // An aria live message representing the currently focused value in the select.
                var focusedValueMsg = focusedValue ? $39f9a147bda2d929$var$valueFocusAriaMessage({
                    focusedValue: focusedValue,
                    getOptionLabel: this.getOptionLabel,
                    selectValue: selectValue
                }) : ''; // An aria live message representing the currently focused option in the select.
                var focusedOptionMsg = focusedOption && menuIsOpen ? $39f9a147bda2d929$var$optionFocusAriaMessage({
                    focusedOption: focusedOption,
                    getOptionLabel: this.getOptionLabel,
                    options: options
                }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.
                var resultsMsg = $39f9a147bda2d929$var$resultsAriaMessage({
                    inputValue: inputValue,
                    screenReaderMessage: screenReaderStatus({
                        count: this.countOptions()
                    })
                });
                return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
            }
        },
        {
            key: "renderInput",
            value: function renderInput() {
                var _this$props16 = this.props, isDisabled = _this$props16.isDisabled, isSearchable = _this$props16.isSearchable, inputId = _this$props16.inputId, inputValue = _this$props16.inputValue, tabIndex = _this$props16.tabIndex, form = _this$props16.form;
                var Input = this.components.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = {
                    'aria-autocomplete': 'list',
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby']
                };
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, $7ikhG.default).createElement($39f9a147bda2d929$var$DummyInput, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $aadb423f5e5b4fc5$export$a9c23c6ac3fc3eca),
                    onFocus: this.onInputFocus,
                    readOnly: true,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    form: form,
                    value: ""
                }, ariaAttributes));
                var _this$commonProps = this.commonProps, cx = _this$commonProps.cx, theme = _this$commonProps.theme, selectProps = _this$commonProps.selectProps;
                return /*#__PURE__*/ (0, $7ikhG.default).createElement(Input, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    cx: cx,
                    getStyles: this.getStyles,
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    selectProps: selectProps,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    theme: theme,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this4 = this;
                var _this$components = this.components, MultiValue = _this$components.MultiValue, MultiValueContainer = _this$components.MultiValueContainer, MultiValueLabel = _this$components.MultiValueLabel, MultiValueRemove = _this$components.MultiValueRemove, SingleValue = _this$components.SingleValue, Placeholder = _this$components.Placeholder;
                var commonProps = this.commonProps;
                var _this$props17 = this.props, controlShouldRenderValue = _this$props17.controlShouldRenderValue, isDisabled = _this$props17.isDisabled, isMulti = _this$props17.isMulti, inputValue = _this$props17.inputValue, placeholder = _this$props17.placeholder;
                var _this$state8 = this.state, selectValue = _this$state8.selectValue, focusedValue = _this$state8.focusedValue, isFocused = _this$state8.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, $7ikhG.default).createElement(Placeholder, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), placeholder);
                if (isMulti) {
                    var selectValues = selectValue.map(function(opt, index) {
                        var isOptionFocused = opt === focusedValue;
                        return /*#__PURE__*/ (0, $7ikhG.default).createElement(MultiValue, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, commonProps, {
                            components: {
                                Container: MultiValueContainer,
                                Label: MultiValueLabel,
                                Remove: MultiValueRemove
                            },
                            isFocused: isOptionFocused,
                            isDisabled: isDisabled,
                            key: "".concat(_this4.getOptionValue(opt)).concat(index),
                            index: index,
                            removeProps: {
                                onClick: function onClick() {
                                    return _this4.removeValue(opt);
                                },
                                onTouchEnd: function onTouchEnd() {
                                    return _this4.removeValue(opt);
                                },
                                onMouseDown: function onMouseDown(e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            },
                            data: opt
                        }), _this4.formatOptionLabel(opt, 'value'));
                    });
                    return selectValues;
                }
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, $7ikhG.default).createElement(SingleValue, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var ClearIndicator = this.components.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props18 = this.props, isDisabled = _this$props18.isDisabled, isLoading = _this$props18.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, $7ikhG.default).createElement(ClearIndicator, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var LoadingIndicator = this.components.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props19 = this.props, isDisabled = _this$props19.isDisabled, isLoading = _this$props19.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, $7ikhG.default).createElement(LoadingIndicator, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$components2 = this.components, DropdownIndicator = _this$components2.DropdownIndicator, IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ (0, $7ikhG.default).createElement(IndicatorSeparator, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var DropdownIndicator = this.components.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, $7ikhG.default).createElement(DropdownIndicator, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this5 = this;
                var _this$components3 = this.components, Group = _this$components3.Group, GroupHeading = _this$components3.GroupHeading, Menu = _this$components3.Menu, MenuList = _this$components3.MenuList, MenuPortal = _this$components3.MenuPortal, LoadingMessage = _this$components3.LoadingMessage, NoOptionsMessage = _this$components3.NoOptionsMessage, Option = _this$components3.Option;
                var commonProps = this.commonProps;
                var _this$state9 = this.state, focusedOption = _this$state9.focusedOption, menuOptions = _this$state9.menuOptions;
                var _this$props20 = this.props, captureMenuScroll = _this$props20.captureMenuScroll, inputValue = _this$props20.inputValue, isLoading = _this$props20.isLoading, loadingMessage = _this$props20.loadingMessage, minMenuHeight = _this$props20.minMenuHeight, maxMenuHeight = _this$props20.maxMenuHeight, menuIsOpen = _this$props20.menuIsOpen, menuPlacement = _this$props20.menuPlacement, menuPosition = _this$props20.menuPosition, menuPortalTarget = _this$props20.menuPortalTarget, menuShouldBlockScroll = _this$props20.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props20.menuShouldScrollIntoView, noOptionsMessage = _this$props20.noOptionsMessage, onMenuScrollToTop = _this$props20.onMenuScrollToTop, onMenuScrollToBottom = _this$props20.onMenuScrollToBottom;
                if (!menuIsOpen) return null; // TODO: Internal Option Type here
                var render = function render(props) {
                    // for performance, the menu options in state aren't changed when the
                    // focused option changes so we calculate additional props based on that
                    var isFocused = focusedOption === props.data;
                    props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
                    return /*#__PURE__*/ (0, $7ikhG.default).createElement(Option, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, commonProps, props, {
                        isFocused: isFocused
                    }), _this5.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = menuOptions.render.map(function(item) {
                    if (item.type === 'group') {
                        var type = item.type, group = (0, $95fb0a49c8a38020$export$2e2bcd8739ae039)(item, [
                            "type"
                        ]);
                        var headingId = "".concat(item.key, "-heading");
                        return /*#__PURE__*/ (0, $7ikhG.default).createElement(Group, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, commonProps, group, {
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this5.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option);
                        }));
                    } else if (item.type === 'option') return render(item);
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, $7ikhG.default).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, $7ikhG.default).createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, $7ikhG.default).createElement((0, $aadb423f5e5b4fc5$export$3a1a48c8f6ef640e), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref10) {
                    var ref = _ref10.ref, _ref10$placerProps = _ref10.placerProps, placement = _ref10$placerProps.placement, maxHeight = _ref10$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, $7ikhG.default).createElement(Menu, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this5.onMenuMouseDown,
                            onMouseMove: _this5.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, $7ikhG.default).createElement($39f9a147bda2d929$var$ScrollCaptorSwitch, {
                        isEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom
                    }, /*#__PURE__*/ (0, $7ikhG.default).createElement($39f9a147bda2d929$var$ScrollBlock, {
                        isEnabled: menuShouldBlockScroll
                    }, /*#__PURE__*/ (0, $7ikhG.default).createElement(MenuList, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, commonProps, {
                        innerRef: _this5.getMenuListRef,
                        isLoading: isLoading,
                        maxHeight: maxHeight
                    }), menuUI))));
                }); // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, $7ikhG.default).createElement(MenuPortal, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this6 = this;
                var _this$props21 = this.props, delimiter = _this$props21.delimiter, isDisabled = _this$props21.isDisabled, isMulti = _this$props21.isMulti, name = _this$props21.name;
                var selectValue = this.state.selectValue;
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this6.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, $7ikhG.default).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, $7ikhG.default).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this6.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, $7ikhG.default).createElement("input", {
                            name: name,
                            type: "hidden"
                        });
                        return /*#__PURE__*/ (0, $7ikhG.default).createElement("div", null, input);
                    }
                } else {
                    var _value2 = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ (0, $7ikhG.default).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value2
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                if (!this.state.isFocused) return null;
                return /*#__PURE__*/ (0, $7ikhG.default).createElement($39f9a147bda2d929$var$A11yText, {
                    "aria-live": "polite"
                }, /*#__PURE__*/ (0, $7ikhG.default).createElement("span", {
                    id: "aria-selection-event"
                }, "\xA0", this.state.ariaLiveSelection), /*#__PURE__*/ (0, $7ikhG.default).createElement("span", {
                    id: "aria-context"
                }, "\xA0", this.constructAriaLiveMessage()));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$components4 = this.components, Control = _this$components4.Control, IndicatorsContainer = _this$components4.IndicatorsContainer, SelectContainer = _this$components4.SelectContainer, ValueContainer = _this$components4.ValueContainer;
                var _this$props22 = this.props, className = _this$props22.className, id = _this$props22.id, isDisabled = _this$props22.isDisabled, menuIsOpen = _this$props22.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ (0, $7ikhG.default).createElement(SelectContainer, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ (0, $7ikhG.default).createElement(Control, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ (0, $7ikhG.default).createElement(ValueContainer, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, $7ikhG.default).createElement(IndicatorsContainer, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ]);
    return Select;
}((0, $7Do5B.Component));
$39f9a147bda2d929$export$25ce5a424b770e84.defaultProps = $39f9a147bda2d929$export$4368d992c4eafac0;



var $80a500d5a5e7c6c2$exports = {};
function $80a500d5a5e7c6c2$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
$80a500d5a5e7c6c2$exports = $80a500d5a5e7c6c2$var$_taggedTemplateLiteral, $80a500d5a5e7c6c2$exports.__esModule = true, $80a500d5a5e7c6c2$exports["default"] = $80a500d5a5e7c6c2$exports;











var $7ikhG = parcelRequire("7ikhG");
var $7Do5B = parcelRequire("7Do5B");
function $bc3b2d1add562064$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bc3b2d1add562064$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c345de07753d2fca$export$2e2bcd8739ae039)(this, result);
    };
}
function $bc3b2d1add562064$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $bc3b2d1add562064$var$defaultProps = {
    defaultInputValue: '',
    defaultMenuIsOpen: false,
    defaultValue: null
};
var $bc3b2d1add562064$export$953cecd6e717a553 = function manageState(SelectComponent) {
    var _class, _temp;
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(StateManager, _Component);
        var _super = $bc3b2d1add562064$var$_createSuper(StateManager);
        function StateManager() {
            var _this;
            (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, StateManager);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            _this.select = void 0;
            _this.state = {
                inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
                menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
                value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
            };
            _this.onChange = function(value, actionMeta) {
                _this.callProp('onChange', value, actionMeta);
                _this.setState({
                    value: value
                });
            };
            _this.onInputChange = function(value, actionMeta) {
                // TODO: for backwards compatibility, we allow the prop to return a new
                // value, but now inputValue is a controllable prop we probably shouldn't
                var newValue = _this.callProp('onInputChange', value, actionMeta);
                _this.setState({
                    inputValue: newValue !== undefined ? newValue : value
                });
            };
            _this.onMenuOpen = function() {
                _this.callProp('onMenuOpen');
                _this.setState({
                    menuIsOpen: true
                });
            };
            _this.onMenuClose = function() {
                _this.callProp('onMenuClose');
                _this.setState({
                    menuIsOpen: false
                });
            };
            return _this;
        }
        (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(StateManager, [
            {
                key: "focus",
                value: function focus() {
                    this.select.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    this.select.blur();
                } // FIXME: untyped flow code, return any
            },
            {
                key: "getProp",
                value: function getProp(key) {
                    return this.props[key] !== undefined ? this.props[key] : this.state[key];
                } // FIXME: untyped flow code, return any
            },
            {
                key: "callProp",
                value: function callProp(name) {
                    if (typeof this.props[name] === 'function') {
                        var _this$props;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        return (_this$props = this.props)[name].apply(_this$props, args);
                    }
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var _this$props2 = this.props, defaultInputValue = _this$props2.defaultInputValue, defaultMenuIsOpen = _this$props2.defaultMenuIsOpen, defaultValue = _this$props2.defaultValue, props = (0, $95fb0a49c8a38020$export$2e2bcd8739ae039)(_this$props2, [
                        "defaultInputValue",
                        "defaultMenuIsOpen",
                        "defaultValue"
                    ]);
                    return /*#__PURE__*/ (0, $7ikhG.default).createElement(SelectComponent, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
                        ref: function ref(_ref) {
                            _this2.select = _ref;
                        },
                        inputValue: this.getProp('inputValue'),
                        menuIsOpen: this.getProp('menuIsOpen'),
                        onChange: this.onChange,
                        onInputChange: this.onInputChange,
                        onMenuClose: this.onMenuClose,
                        onMenuOpen: this.onMenuOpen,
                        value: this.getProp('value')
                    }));
                }
            }
        ]);
        return StateManager;
    }((0, $7Do5B.Component)), _class.defaultProps = $bc3b2d1add562064$var$defaultProps, _temp;
};



function $305d4b79df7521f3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $305d4b79df7521f3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c345de07753d2fca$export$2e2bcd8739ae039)(this, result);
    };
}
function $305d4b79df7521f3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $305d4b79df7521f3$export$a7deb1594c5ce10e = /*#__PURE__*/ function(_Component) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(NonceProvider, _Component);
    var _super = $305d4b79df7521f3$var$_createSuper(NonceProvider);
    function NonceProvider(props) {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, NonceProvider);
        _this = _super.call(this, props);
        _this.createEmotionCache = function(nonce) {
            return (0, $56abe1b292bdd894$export$2e2bcd8739ae039)({
                nonce: nonce
            });
        };
        _this.createEmotionCache = (0, $16d5efbf3de5c533$export$2e2bcd8739ae039)(_this.createEmotionCache);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(NonceProvider, [
        {
            key: "render",
            value: function render() {
                var emotionCache = this.createEmotionCache(this.props.nonce);
                return /*#__PURE__*/ (0, $7ikhG.default).createElement((0, $8b0bcb3a24c30fa0$export$e7094788287c5e9b), {
                    value: emotionCache
                }, this.props.children);
            }
        }
    ]);
    return NonceProvider;
}((0, $7Do5B.Component));
var $305d4b79df7521f3$var$index = (0, $bc3b2d1add562064$export$953cecd6e717a553)((0, $39f9a147bda2d929$export$25ce5a424b770e84));
var $305d4b79df7521f3$export$2e2bcd8739ae039 = $305d4b79df7521f3$var$index;


var $39292a9b5a7ccf44$exports = {};

function $39292a9b5a7ccf44$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $39292a9b5a7ccf44$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $39292a9b5a7ccf44$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e23ae39501459ba4$exports(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $39292a9b5a7ccf44$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
$39292a9b5a7ccf44$exports = $39292a9b5a7ccf44$var$_objectSpread2, $39292a9b5a7ccf44$exports.__esModule = true, $39292a9b5a7ccf44$exports["default"] = $39292a9b5a7ccf44$exports;






parcelRequire("7ikhG");
var $3aPmr = parcelRequire("3aPmr");
var $f1ffc181de632b16$exports = {};
// TODO(Babel 8): Remove this file.

var $f1ffc181de632b16$var$runtime = (parcelRequire("3pCEE"))();
$f1ffc181de632b16$exports = $f1ffc181de632b16$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $f1ffc181de632b16$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $f1ffc181de632b16$var$runtime;
    else Function("r", "regeneratorRuntime = r")($f1ffc181de632b16$var$runtime);
}






var $9dca52b7b9a5d7e7$exports = {};
function $9dca52b7b9a5d7e7$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $9dca52b7b9a5d7e7$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $9dca52b7b9a5d7e7$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $9dca52b7b9a5d7e7$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
$9dca52b7b9a5d7e7$exports = $9dca52b7b9a5d7e7$var$_asyncToGenerator, $9dca52b7b9a5d7e7$exports.__esModule = true, $9dca52b7b9a5d7e7$exports["default"] = $9dca52b7b9a5d7e7$exports;


parcelRequire("7ikhG");
var $3aPmr = parcelRequire("3aPmr");
var $ab5a582fd45cd691$var$e = setTimeout;
function $ab5a582fd45cd691$var$t(t, n) {
    var u = n.useCachedSetTimeout ? $ab5a582fd45cd691$var$e : setTimeout;
    return new Promise(function(e) {
        u(e, t);
    });
}
function $ab5a582fd45cd691$var$n(e) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, u = n.useCachedSetTimeout, r = $ab5a582fd45cd691$var$t(e, {
        useCachedSetTimeout: u
    });
    function o(e) {
        return r.then(function() {
            return e;
        });
    }
    return o.then = function() {
        return r.then.apply(r, arguments);
    }, o.catch = Promise.resolve().catch, o;
}
var $ab5a582fd45cd691$export$2e2bcd8739ae039 = $ab5a582fd45cd691$var$n;


var $00409f53d1c268aa$exports = {};
"use strict";
var $00409f53d1c268aa$var$__importDefault = $00409f53d1c268aa$exports && $00409f53d1c268aa$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($00409f53d1c268aa$exports, "__esModule", {
    value: true
});

var $00409f53d1c268aa$var$use_is_mounted_1 = $00409f53d1c268aa$var$__importDefault((parcelRequire("hkfo9")));
$00409f53d1c268aa$exports.default = $00409f53d1c268aa$var$use_is_mounted_1.default;


var $ef749260be68d347$var$AVAILABLE_DELTA = 10;
var $ef749260be68d347$export$5b3e8eb6ace1bd76 = function defaultShouldLoadMore(scrollHeight, clientHeight, scrollTop) {
    var bottomBorder = scrollHeight - clientHeight - $ef749260be68d347$var$AVAILABLE_DELTA;
    return bottomBorder < scrollTop;
};



var $64e6c68b5f90ef24$export$ff2913fe327a89c6 = function defaultReduceOptions(prevOptions, loadedOptions) {
    return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($9425c93b578bde03$exports)))(prevOptions), (0, (/*@__PURE__*/$parcel$interopDefault($9425c93b578bde03$exports)))(loadedOptions));
};


var $6e4c3bb18bccf50f$var$errorText = '[react-select-async-paginate] response of "loadOptions" should be an object with "options" prop, which contains array of options.';
var $6e4c3bb18bccf50f$export$fcee8a88e10e2f31 = function validateResponse(console1, response) {
    if (!response) {
        console1.error($6e4c3bb18bccf50f$var$errorText, 'Received:', response);
        throw new Error($6e4c3bb18bccf50f$var$errorText);
    }
    if (!Array.isArray(response.options)) {
        console1.error($6e4c3bb18bccf50f$var$errorText, 'Received:', response);
        throw new Error($6e4c3bb18bccf50f$var$errorText);
    }
};
var $6e4c3bb18bccf50f$export$16f5741d95b27c4b = function getInitialOptionsCache(_ref) {
    var options = _ref.options, defaultOptions = _ref.defaultOptions, additional = _ref.additional, defaultAdditional = _ref.defaultAdditional;
    var initialOptions = defaultOptions === true ? null : defaultOptions instanceof Array ? defaultOptions : options;
    if (initialOptions) return {
        '': {
            isFirstLoad: false,
            isLoading: false,
            options: initialOptions,
            hasMore: true,
            additional: defaultAdditional || additional
        }
    };
    return {};
};
var $6e4c3bb18bccf50f$export$34a87f4e876e484b = function getInitialCache(params) {
    return {
        isFirstLoad: true,
        options: [],
        hasMore: true,
        isLoading: false,
        additional: params.additional
    };
};
var $6e4c3bb18bccf50f$export$a926693c5c3a9dc4 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9dca52b7b9a5d7e7$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f1ffc181de632b16$exports))).mark(function _callee(paramsRef, optionsCacheRef, debounceTimeout, sleepParam, setOptionsCache, validateResponseParam, reduceOptions) {
        var currentInputValue, isCacheEmpty, currentOptions, newInputValue, response, hasError, loadOptions, _response, options, hasMore, newAdditional;
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1ffc181de632b16$exports))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    currentInputValue = paramsRef.current.inputValue;
                    isCacheEmpty = !optionsCacheRef.current[currentInputValue];
                    currentOptions = isCacheEmpty ? $6e4c3bb18bccf50f$export$34a87f4e876e484b(paramsRef.current) : optionsCacheRef.current[currentInputValue];
                    if (!(currentOptions.isLoading || !currentOptions.hasMore)) {
                        _context.next = 5;
                        break;
                    }
                    return _context.abrupt("return");
                case 5:
                    setOptionsCache(function(prevOptionsCache) {
                        return (0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))({}, prevOptionsCache), {}, (0, (/*@__PURE__*/$parcel$interopDefault($e23ae39501459ba4$exports)))({}, currentInputValue, (0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))({}, currentOptions), {}, {
                            isLoading: true
                        })));
                    });
                    if (!(debounceTimeout > 0)) {
                        _context.next = 13;
                        break;
                    }
                    _context.next = 9;
                    return sleepParam(debounceTimeout);
                case 9:
                    newInputValue = paramsRef.current.inputValue;
                    if (!(currentInputValue !== newInputValue)) {
                        _context.next = 13;
                        break;
                    }
                    setOptionsCache(function(prevOptionsCache) {
                        if (isCacheEmpty) {
                            var itemForDelete = prevOptionsCache[currentInputValue], restCache = (0, (/*@__PURE__*/$parcel$interopDefault($45d29d2a9970da25$exports)))(prevOptionsCache, [
                                currentInputValue
                            ].map((0, (/*@__PURE__*/$parcel$interopDefault($5555d428bd3bf37b$exports)))));
                            return restCache;
                        }
                        return (0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))({}, prevOptionsCache), {}, (0, (/*@__PURE__*/$parcel$interopDefault($e23ae39501459ba4$exports)))({}, currentInputValue, (0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))({}, currentOptions), {}, {
                            isLoading: false
                        })));
                    });
                    return _context.abrupt("return");
                case 13:
                    _context.prev = 13;
                    loadOptions = paramsRef.current.loadOptions;
                    _context.next = 17;
                    return loadOptions(currentInputValue, currentOptions.options, currentOptions.additional);
                case 17:
                    response = _context.sent;
                    hasError = false;
                    _context.next = 24;
                    break;
                case 21:
                    _context.prev = 21;
                    _context.t0 = _context["catch"](13);
                    hasError = true;
                case 24:
                    if (!hasError) {
                        _context.next = 27;
                        break;
                    }
                    setOptionsCache(function(prevOptionsCache) {
                        return (0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))({}, prevOptionsCache), {}, (0, (/*@__PURE__*/$parcel$interopDefault($e23ae39501459ba4$exports)))({}, currentInputValue, (0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))({}, currentOptions), {}, {
                            isLoading: false
                        })));
                    });
                    return _context.abrupt("return");
                case 27:
                    validateResponseParam(console, response);
                    _response = response, options = _response.options, hasMore = _response.hasMore; // eslint-disable-next-line no-prototype-builtins
                    newAdditional = response.hasOwnProperty('additional') ? response.additional : currentOptions.additional;
                    setOptionsCache(function(prevOptionsCache) {
                        return (0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))({}, prevOptionsCache), {}, (0, (/*@__PURE__*/$parcel$interopDefault($e23ae39501459ba4$exports)))({}, currentInputValue, (0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))({}, currentOptions), {}, {
                            options: reduceOptions(currentOptions.options, options, newAdditional),
                            hasMore: !!hasMore,
                            isLoading: false,
                            isFirstLoad: false,
                            additional: newAdditional
                        })));
                    });
                case 31:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                13,
                21
            ]
        ]);
    }));
    return function requestOptions(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
        return _ref2.apply(this, arguments);
    };
}();
var $6e4c3bb18bccf50f$export$683b895b063ae4c = function increaseStateId(prevStateId) {
    return prevStateId + 1;
};
var $6e4c3bb18bccf50f$export$96392e3b9e1ae1ae = function useAsyncPaginateBasePure(useRefParam, useStateParam, useEffectParam, useCallbackParam, useIsMountedParam, validateResponseParam, getInitialOptionsCacheParam, requestOptionsParam, params) {
    var deps = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : [];
    var defaultOptions = params.defaultOptions, _params$loadOptionsOn = params.loadOptionsOnMenuOpen, loadOptionsOnMenuOpen = _params$loadOptionsOn === void 0 ? true : _params$loadOptionsOn, _params$debounceTimeo = params.debounceTimeout, debounceTimeout = _params$debounceTimeo === void 0 ? 0 : _params$debounceTimeo, inputValue = params.inputValue, menuIsOpen = params.menuIsOpen, _params$filterOption = params.filterOption, filterOption = _params$filterOption === void 0 ? null : _params$filterOption, _params$reduceOptions = params.reduceOptions, reduceOptions = _params$reduceOptions === void 0 ? (0, $64e6c68b5f90ef24$export$ff2913fe327a89c6) : _params$reduceOptions, _params$shouldLoadMor = params.shouldLoadMore, shouldLoadMore = _params$shouldLoadMor === void 0 ? (0, $ef749260be68d347$export$5b3e8eb6ace1bd76) : _params$shouldLoadMor;
    var isMounted = useIsMountedParam();
    var isInitRef = useRefParam(true);
    var paramsRef = useRefParam(params);
    paramsRef.current = params;
    var setStateId = useStateParam(0)[1];
    var optionsCacheRef = useRefParam(null);
    if (optionsCacheRef.current === null) optionsCacheRef.current = getInitialOptionsCacheParam(params);
    var callRequestOptions = useCallbackParam(function() {
        requestOptionsParam(paramsRef, optionsCacheRef, debounceTimeout, (0, $ab5a582fd45cd691$export$2e2bcd8739ae039), function(reduceState) {
            optionsCacheRef.current = reduceState(optionsCacheRef.current);
            if (isMounted()) setStateId($6e4c3bb18bccf50f$export$683b895b063ae4c);
        }, validateResponseParam, reduceOptions);
    }, []);
    var handleScrolledToBottom = useCallbackParam(function() {
        var currentInputValue = paramsRef.current.inputValue;
        var currentOptions = optionsCacheRef.current[currentInputValue];
        if (currentOptions) callRequestOptions();
    }, []);
    useEffectParam(function() {
        if (isInitRef.current) isInitRef.current = false;
        else {
            optionsCacheRef.current = {};
            setStateId($6e4c3bb18bccf50f$export$683b895b063ae4c);
        }
        if (defaultOptions === true) callRequestOptions();
    }, deps);
    useEffectParam(function() {
        if (menuIsOpen && !optionsCacheRef.current[inputValue]) callRequestOptions();
    }, [
        inputValue
    ]);
    useEffectParam(function() {
        if (menuIsOpen && !optionsCacheRef.current[''] && loadOptionsOnMenuOpen) callRequestOptions();
    }, [
        menuIsOpen
    ]);
    var currentOptions = optionsCacheRef.current[inputValue] || $6e4c3bb18bccf50f$export$34a87f4e876e484b(params);
    return {
        handleScrolledToBottom: handleScrolledToBottom,
        shouldLoadMore: shouldLoadMore,
        filterOption: filterOption,
        isLoading: currentOptions.isLoading,
        isFirstLoad: currentOptions.isFirstLoad,
        options: currentOptions.options
    };
};
var $6e4c3bb18bccf50f$export$1bc6bc7e15a5c0d3 = function useAsyncPaginateBase(params) {
    var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return $6e4c3bb18bccf50f$export$96392e3b9e1ae1ae((0, $3aPmr.useRef), (0, $3aPmr.useState), (0, $3aPmr.useEffect), (0, $3aPmr.useCallback), (0, (/*@__PURE__*/$parcel$interopDefault($00409f53d1c268aa$exports))), $6e4c3bb18bccf50f$export$fcee8a88e10e2f31, $6e4c3bb18bccf50f$export$16f5741d95b27c4b, $6e4c3bb18bccf50f$export$a926693c5c3a9dc4, params, deps);
};


var $411e5fa63c43f7b9$export$5db20574a85d309b = function useAsyncPaginatePure(useStateParam, useCallbackParam, useAsyncPaginateBaseParam, params) {
    var deps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var inputValueParam = params.inputValue, menuIsOpenParam = params.menuIsOpen, defaultInputValueParam = params.defaultInputValue, defaultMenuIsOpenParam = params.defaultMenuIsOpen, onInputChangeParam = params.onInputChange, onMenuCloseParam = params.onMenuClose, onMenuOpenParam = params.onMenuOpen;
    var _useStateParam = useStateParam(defaultInputValueParam || ''), _useStateParam2 = (0, (/*@__PURE__*/$parcel$interopDefault($aec0ef34f2c5a862$exports)))(_useStateParam, 2), inputValueState = _useStateParam2[0], setInputValue = _useStateParam2[1];
    var _useStateParam3 = useStateParam(!!defaultMenuIsOpenParam), _useStateParam4 = (0, (/*@__PURE__*/$parcel$interopDefault($aec0ef34f2c5a862$exports)))(_useStateParam3, 2), menuIsOpenState = _useStateParam4[0], setMenuIsOpen = _useStateParam4[1];
    var inputValue = typeof inputValueParam === 'string' ? inputValueParam : inputValueState;
    var menuIsOpen = typeof menuIsOpenParam === 'boolean' ? menuIsOpenParam : menuIsOpenState;
    var onInputChange = useCallbackParam(function(nextInputValue, actionMeta) {
        if (onInputChangeParam) onInputChangeParam(nextInputValue, actionMeta);
        setInputValue(nextInputValue);
    }, [
        onInputChangeParam
    ]);
    var onMenuClose = useCallbackParam(function() {
        if (onMenuCloseParam) onMenuCloseParam();
        setMenuIsOpen(false);
    }, [
        onMenuCloseParam
    ]);
    var onMenuOpen = useCallbackParam(function() {
        if (onMenuOpenParam) onMenuOpenParam();
        setMenuIsOpen(true);
    }, [
        onMenuOpenParam
    ]);
    var baseResult = useAsyncPaginateBaseParam((0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))({}, params), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen
    }), deps);
    return (0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))({}, baseResult), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen
    });
};
var $411e5fa63c43f7b9$export$59c1df8d705d4a91 = function useAsyncPaginate(params) {
    var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return $411e5fa63c43f7b9$export$5db20574a85d309b((0, $3aPmr.useState), (0, $3aPmr.useCallback), (0, $6e4c3bb18bccf50f$export$1bc6bc7e15a5c0d3), params, deps);
};



parcelRequire("7ikhG");
var $3aPmr = parcelRequire("3aPmr");



parcelRequire("7ikhG");
var $3aPmr = parcelRequire("3aPmr");
var $b9545e566241952c$exports = {};
"use strict";
Object.defineProperty($b9545e566241952c$exports, "__esModule", {
    value: true
});
function $b9545e566241952c$var$composeRefs() {
    var refs = [];
    for(var _i = 0; _i < arguments.length; _i++)refs[_i] = arguments[_i];
    if (refs.length === 2) return $b9545e566241952c$var$composeTwoRefs(refs[0], refs[1]) || null;
    var composedRef = refs.slice(1).reduce(function(semiCombinedRef, refToInclude) {
        return $b9545e566241952c$var$composeTwoRefs(semiCombinedRef, refToInclude);
    }, refs[0]);
    return composedRef || null;
}
$b9545e566241952c$exports.default = $b9545e566241952c$var$composeRefs;
var $b9545e566241952c$var$composedRefCache = new WeakMap();
function $b9545e566241952c$var$composeTwoRefs(ref1, ref2) {
    if (ref1 && ref2) {
        var ref1Cache = $b9545e566241952c$var$composedRefCache.get(ref1) || new WeakMap();
        $b9545e566241952c$var$composedRefCache.set(ref1, ref1Cache);
        var composedRef = ref1Cache.get(ref2) || function(instance) {
            $b9545e566241952c$var$updateRef(ref1, instance);
            $b9545e566241952c$var$updateRef(ref2, instance);
        };
        ref1Cache.set(ref2, composedRef);
        return composedRef;
    }
    if (!ref1) return ref2;
    else return ref1;
}
function $b9545e566241952c$var$updateRef(ref, instance) {
    if (typeof ref === 'function') ref(instance);
    else ref.current = instance;
}


var $48671c6e9279e7bb$export$db19f26c352b7194 = 300;
var $48671c6e9279e7bb$export$6221d452fabeeca6 = function wrapMenuList(MenuList) {
    var WrappedMenuList = function WrappedMenuList(props) {
        var _props$selectProps = props.selectProps, handleScrolledToBottom = _props$selectProps.handleScrolledToBottom, shouldLoadMore = _props$selectProps.shouldLoadMore, innerRef = props.innerRef, useEffectProp = props.useEffect, useRefProp = props.useRef, useCallbackProp = props.useCallback, setTimeoutProp = props.setTimeout, clearTimeoutProp = props.clearTimeout;
        var checkTimeoutRef = useRefProp(null);
        var menuListRef = useRefProp(null);
        var shouldHandle = useCallbackProp(function() {
            var el = menuListRef.current; // menu not rendered
            if (!el) return false;
            var scrollTop = el.scrollTop, scrollHeight = el.scrollHeight, clientHeight = el.clientHeight;
            return shouldLoadMore(scrollHeight, clientHeight, scrollTop);
        }, [
            shouldLoadMore
        ]);
        var checkAndHandle = useCallbackProp(function() {
            if (shouldHandle()) {
                if (handleScrolledToBottom) handleScrolledToBottom();
            }
        }, [
            shouldHandle,
            handleScrolledToBottom
        ]);
        var setCheckAndHandleTimeout = useCallbackProp(function() {
            checkAndHandle();
            checkTimeoutRef.current = setTimeoutProp(setCheckAndHandleTimeout, $48671c6e9279e7bb$export$db19f26c352b7194);
        }, [
            checkAndHandle
        ]);
        useEffectProp(function() {
            setCheckAndHandleTimeout();
            return function() {
                if (checkTimeoutRef.current) clearTimeoutProp(checkTimeoutRef.current);
            };
        }, []);
        return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)(MenuList, (0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))({}, props), {}, {
            innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($b9545e566241952c$exports)))(innerRef, menuListRef)
        }));
    };
    WrappedMenuList.defaultProps = {
        useEffect: (0, $3aPmr.useEffect),
        useRef: (0, $3aPmr.useRef),
        useCallback: (0, $3aPmr.useCallback),
        setTimeout: setTimeout,
        clearTimeout: clearTimeout
    };
    return WrappedMenuList;
};


var $d4d427523d4b34b1$export$d4c4e98c5044dc8 = (0, $48671c6e9279e7bb$export$6221d452fabeeca6)((0, $aadb423f5e5b4fc5$export$d66501df72047452).MenuList);
var $d4d427523d4b34b1$export$16d015f1488aca92 = function useComponentsPure(useMemoParam, components) {
    return useMemoParam(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))({
            MenuList: $d4d427523d4b34b1$export$d4c4e98c5044dc8
        }, components);
    }, [
        components
    ]);
};
var $d4d427523d4b34b1$export$7c355de7fd01eb66 = function useComponents(components) {
    return $d4d427523d4b34b1$export$16d015f1488aca92((0, $3aPmr.useMemo), components);
};


function $34b9552e0403251d$export$cfb48882cd279b8a(SelectComponent) {
    var WithAsyncPaginate = function WithAsyncPaginate(props) {
        var components = props.components, selectRef = props.selectRef, useComponentsProp = props.useComponents, useAsyncPaginateProp = props.useAsyncPaginate, cacheUniqs = props.cacheUniqs, rest = (0, (/*@__PURE__*/$parcel$interopDefault($45d29d2a9970da25$exports)))(props, [
            "components",
            "selectRef",
            "useComponents",
            "useAsyncPaginate",
            "cacheUniqs"
        ]);
        var asyncPaginateProps = useAsyncPaginateProp(rest, cacheUniqs);
        var processedComponents = useComponentsProp(components);
        return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)(SelectComponent, (0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))({}, props), asyncPaginateProps), {}, {
            components: processedComponents,
            ref: selectRef
        }));
    };
    WithAsyncPaginate.defaultProps = {
        selectRef: null,
        cacheUniqs: [],
        components: {},
        useComponents: (0, $d4d427523d4b34b1$export$7c355de7fd01eb66),
        useAsyncPaginate: (0, $411e5fa63c43f7b9$export$59c1df8d705d4a91)
    };
    return WithAsyncPaginate;
}




var $67e1b5c32d356e15$export$ae55ee42145434d8 = function reduceGroupedOptions(prevOptions, loadedOptions) {
    var res = prevOptions.slice();
    var mapLabelToIndex = {};
    var prevOptionsIndex = 0;
    var prevOptionsLength = prevOptions.length;
    loadedOptions.forEach(function(group) {
        var label = group.label;
        var groupIndex = mapLabelToIndex[label];
        if (typeof groupIndex !== 'number') {
            for(; prevOptionsIndex < prevOptionsLength && typeof mapLabelToIndex[label] !== 'number'; ++prevOptionsIndex){
                var prevGroup = prevOptions[prevOptionsIndex];
                mapLabelToIndex[prevGroup.label] = prevOptionsIndex;
            }
            groupIndex = mapLabelToIndex[label];
        }
        if (typeof groupIndex !== 'number') {
            mapLabelToIndex[label] = res.length;
            res.push(group);
            return;
        }
        res[groupIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($39292a9b5a7ccf44$exports)))({}, res[groupIndex]), {}, {
            options: res[groupIndex].options.concat(group.options)
        });
    });
    return res;
};





var $ea3e1723cd1809aa$export$62ae509949bd1704 = (0, $34b9552e0403251d$export$cfb48882cd279b8a)((0, $305d4b79df7521f3$export$2e2bcd8739ae039));


const $9058870313d532dc$export$2d48554cdda41283 = "";


const $839564c0329102fb$var$Reports = ()=>{
    const [data, setData] = (0, $3aPmr.useState)({
        records: [],
        total: 0,
        per_page: 20
    });
    const [query, setQuery] = (0, $3aPmr.useState)("");
    const [clientId, setClientId] = (0, $3aPmr.useState)("");
    const [page, setCurrentPage] = (0, $3aPmr.useState)(1);
    const debouncedSearchTerm = (0, $f51453fda9f7f538$export$21805fee57372823)(query, 500);
    const handleDelete = (id)=>{
        let result = confirm("\xbfEst\xe1s seguro de querer eliminar este objeto? ");
        if (result) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/reports/${id}`, {
            method: "DELETE"
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            fetchData();
        });
    };
    const cloneReport = (id)=>{
        let result = confirm("\xbfEst\xe1s seguro de querer clonar este objeto? ");
        if (result) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/reports/${id}/clone`, {
            method: "POST"
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            fetchData();
        });
    };
    const fetchData = ()=>{
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/reports?page=${page}&q=${query}&client_id=${clientId}`).then((resp)=>{
            if (resp.ok) return resp.json();
            throw new Error("something went wrong while requesting posts");
        }).then((data)=>setData(data));
    };
    const loadOptions = async (search, loadedOptions, { page: page })=>{
        const response = await (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/clients/?q=${search}&page=${page}`);
        const responseJSON = await response.json();
        const options = responseJSON.records.map((el)=>({
                value: el.id_client,
                label: el.client
            }));
        return {
            options: options,
            hasMore: responseJSON.total_pages > responseJSON.page,
            additional: {
                page: page + 1
            }
        };
    };
    (0, $3aPmr.useEffect)(()=>{
        setCurrentPage(1);
        fetchData();
    }, [
        debouncedSearchTerm,
        clientId
    ]);
    (0, $3aPmr.useEffect)(()=>{
        fetchData();
    }, [
        page
    ]);
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $96253dbc841a0a6f$export$2e2bcd8739ae039), {
        breadcrumbs: [
            "Reportes"
        ],
        searchBar: (e)=>setQuery(e.target.value),
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
            className: "columns is-multiline",
            style: {
                margin: "1rem 0"
            },
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "column is-12",
                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "card events-card",
                        children: [
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                class: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                        class: "card-header-title",
                                        children: "Reportes"
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                        style: {
                                            width: "30%"
                                        },
                                        class: "card-header-icon",
                                        "aria-label": "more options",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ea3e1723cd1809aa$export$62ae509949bd1704), {
                                            isClearable: true,
                                            loadOptions: loadOptions,
                                            additional: {
                                                page: 1
                                            },
                                            // styles={{
                                            //   menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            // }}
                                            menuPortalTarget: document.body,
                                            onChange: (val)=>{
                                                if (val != null) setClientId(val?.value);
                                                else setClientId("");
                                            },
                                            placeholder: "Filtrar por",
                                            styles: {
                                                container: (provided, state)=>({
                                                        ...provided,
                                                        width: "100%"
                                                    })
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                class: "card-table",
                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "content",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("table", {
                                        class: "table is-fullwidth is-striped",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tbody", {
                                            children: data.records.length ? data.records.map((item)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                            width: "5%"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                            children: item.id
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                class: !item.active ? "inactive-text" : "",
                                                                children: item.name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                            class: "level-right actions",
                                                            children: [
                                                                item.clients_allowed.length ? /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                    href: "#",
                                                                    class: "button is-small is-light is-primary",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                            label: "Permitidos: " + item.clients_allowed.map((el)=>el.name.replace("CLIENT_", "")).join(", "),
                                                                            className: "custom-class"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                            class: "material-icons",
                                                                            children: "supervised_user_circle"
                                                                        })
                                                                    ]
                                                                }) : null,
                                                                item.clients_not_allowed.length ? /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                    href: "#",
                                                                    class: "button is-small is-light is-danger",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                            label: "Ocultos: " + item.clients_not_allowed.map((el)=>el.name.replace("CLIENT_", "")).join(", "),
                                                                            className: "custom-class"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                            class: "material-icons",
                                                                            children: "supervised_user_circle"
                                                                        })
                                                                    ]
                                                                }) : null,
                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                    class: "button is-small is-warning is-light",
                                                                    onClick: ()=>cloneReport(item.id),
                                                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                        class: "material-icons",
                                                                        children: "repeat"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                    class: "button is-small is-link",
                                                                    href: "/reports/" + item.id,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                            label: "Editar",
                                                                            className: "custom-class"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                            class: "material-icons",
                                                                            children: "edit_note"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                    class: "button is-small is-danger",
                                                                    onClick: ()=>handleDelete(item.id),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                            label: "Eliminar",
                                                                            className: "custom-class"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                            class: "material-icons",
                                                                            children: "delete"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, item.id)) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                style: "text-align: center;",
                                                children: "No hay datos para mostrar"
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("footer", {
                                class: "card-footer",
                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                    href: "/reports/create",
                                    class: "card-footer-item",
                                    children: "Crear reporte"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "column is-12",
                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "card",
                        children: [
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                class: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                        class: "card-header-title",
                                        children: "Paginas"
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                        href: "#",
                                        class: "card-header-icon",
                                        "aria-label": "more options",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                            class: "icon",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                class: "fa fa-angle-down",
                                                "aria-hidden": "true"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                class: "card-content",
                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $22b2f8f41c3b0593$export$2e2bcd8739ae039), {
                                        total: data.total,
                                        page: page,
                                        setCurrentPage: setCurrentPage,
                                        pageSize: data.per_page
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $839564c0329102fb$export$2e2bcd8739ae039 = $839564c0329102fb$var$Reports;



var $7Do5B = parcelRequire("7Do5B");
parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");

var $7ikhG = parcelRequire("7ikhG");
var $ee9f4a2880885da1$var$isCheckBoxInput = (element)=>element.type === 'checkbox';
var $ee9f4a2880885da1$var$isDateObject = (value1)=>value1 instanceof Date;
var $ee9f4a2880885da1$var$isNullOrUndefined = (value1)=>value1 == null;
const $ee9f4a2880885da1$var$isObjectType = (value1)=>typeof value1 === 'object';
var $ee9f4a2880885da1$var$isObject = (value1)=>!$ee9f4a2880885da1$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $ee9f4a2880885da1$var$isObjectType(value1) && !$ee9f4a2880885da1$var$isDateObject(value1);
var $ee9f4a2880885da1$var$getEventValue = (event)=>$ee9f4a2880885da1$var$isObject(event) && event.target ? $ee9f4a2880885da1$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $ee9f4a2880885da1$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $ee9f4a2880885da1$var$isNameInFieldArray = (names, name)=>names.has($ee9f4a2880885da1$var$getNodeParentName(name));
var $ee9f4a2880885da1$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $ee9f4a2880885da1$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var $ee9f4a2880885da1$var$isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function $ee9f4a2880885da1$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    const isFileListInstance = typeof FileList !== 'undefined' ? data instanceof FileList : false;
    if (data instanceof Date) copy = new Date(data);
    else if (!($ee9f4a2880885da1$var$isWeb && (data instanceof Blob || isFileListInstance)) && (isArray || $ee9f4a2880885da1$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$ee9f4a2880885da1$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $ee9f4a2880885da1$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $ee9f4a2880885da1$var$isKey = (value1)=>/^\w*$/.test(value1);
var $ee9f4a2880885da1$var$isUndefined = (val)=>val === undefined;
var $ee9f4a2880885da1$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $ee9f4a2880885da1$var$stringToPath = (input)=>$ee9f4a2880885da1$var$compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
var $ee9f4a2880885da1$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$ee9f4a2880885da1$var$isObject(object)) return defaultValue;
    const result = ($ee9f4a2880885da1$var$isKey(path) ? [
        path
    ] : $ee9f4a2880885da1$var$stringToPath(path)).reduce((result, key)=>$ee9f4a2880885da1$var$isNullOrUndefined(result) ? result : result[key], object);
    return $ee9f4a2880885da1$var$isUndefined(result) || result === object ? $ee9f4a2880885da1$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $ee9f4a2880885da1$var$isBoolean = (value1)=>typeof value1 === 'boolean';
var $ee9f4a2880885da1$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $ee9f4a2880885da1$var$isKey(path) ? [
        path
    ] : $ee9f4a2880885da1$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $ee9f4a2880885da1$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        object[key] = newValue;
        object = object[key];
    }
};
const $ee9f4a2880885da1$var$EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change'
};
const $ee9f4a2880885da1$var$VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const $ee9f4a2880885da1$var$INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
const $ee9f4a2880885da1$var$HookFormContext = (0, $7ikhG.default).createContext(null);
$ee9f4a2880885da1$var$HookFormContext.displayName = 'HookFormContext';
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $ee9f4a2880885da1$export$4d957a5e1be13b03 = ()=>(0, $7ikhG.default).useContext($ee9f4a2880885da1$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $ee9f4a2880885da1$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, $7ikhG.default).createElement($ee9f4a2880885da1$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $ee9f4a2880885da1$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $ee9f4a2880885da1$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $ee9f4a2880885da1$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
const $ee9f4a2880885da1$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, $7ikhG.default).useLayoutEffect : (0, $7ikhG.default).useEffect;
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $ee9f4a2880885da1$export$606f11b2eb45ecc6(props) {
    const methods = $ee9f4a2880885da1$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, $7ikhG.default).useState(control._formState);
    const _localProxyFormState = (0, $7ikhG.default).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    $ee9f4a2880885da1$var$useIsomorphicLayoutEffect(()=>control._subscribe({
            name: name,
            formState: _localProxyFormState.current,
            exact: exact,
            callback: (formState)=>{
                !disabled && updateFormState({
                    ...control._formState,
                    ...formState
                });
            }
        }), [
        name,
        disabled,
        exact
    ]);
    (0, $7ikhG.default).useEffect(()=>{
        _localProxyFormState.current.isValid && control._setValid(true);
    }, [
        control
    ]);
    return (0, $7ikhG.default).useMemo(()=>$ee9f4a2880885da1$var$getProxyFormState(formState, control, _localProxyFormState.current, false), [
        formState,
        control
    ]);
}
var $ee9f4a2880885da1$var$isString = (value1)=>typeof value1 === 'string';
var $ee9f4a2880885da1$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($ee9f4a2880885da1$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $ee9f4a2880885da1$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $ee9f4a2880885da1$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
var $ee9f4a2880885da1$var$isPrimitive = (value1)=>$ee9f4a2880885da1$var$isNullOrUndefined(value1) || !$ee9f4a2880885da1$var$isObjectType(value1);
function $ee9f4a2880885da1$var$deepEqual(object1, object2, _internal_visited = new WeakSet()) {
    if ($ee9f4a2880885da1$var$isPrimitive(object1) || $ee9f4a2880885da1$var$isPrimitive(object2)) return object1 === object2;
    if ($ee9f4a2880885da1$var$isDateObject(object1) && $ee9f4a2880885da1$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    if (_internal_visited.has(object1) || _internal_visited.has(object2)) return true;
    _internal_visited.add(object1);
    _internal_visited.add(object2);
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== 'ref') {
            const val2 = object2[key];
            if ($ee9f4a2880885da1$var$isDateObject(val1) && $ee9f4a2880885da1$var$isDateObject(val2) || $ee9f4a2880885da1$var$isObject(val1) && $ee9f4a2880885da1$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$ee9f4a2880885da1$var$deepEqual(val1, val2, _internal_visited) : val1 !== val2) return false;
        }
    }
    return true;
}
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $ee9f4a2880885da1$export$3c773aa2b84f29e0(props) {
    const methods = $ee9f4a2880885da1$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact, compute: compute } = props || {};
    const _defaultValue = (0, $7ikhG.default).useRef(defaultValue);
    const _compute = (0, $7ikhG.default).useRef(compute);
    const _computeFormValues = (0, $7ikhG.default).useRef(undefined);
    _compute.current = compute;
    const defaultValueMemo = (0, $7ikhG.default).useMemo(()=>control._getWatch(name, _defaultValue.current), [
        control,
        name
    ]);
    const [value1, updateValue] = (0, $7ikhG.default).useState(_compute.current ? _compute.current(defaultValueMemo) : defaultValueMemo);
    $ee9f4a2880885da1$var$useIsomorphicLayoutEffect(()=>control._subscribe({
            name: name,
            formState: {
                values: true
            },
            exact: exact,
            callback: (formState)=>{
                if (!disabled) {
                    const formValues = $ee9f4a2880885da1$var$generateWatchOutput(name, control._names, formState.values || control._formValues, false, _defaultValue.current);
                    if (_compute.current) {
                        const computedFormValues = _compute.current(formValues);
                        if (!$ee9f4a2880885da1$var$deepEqual(computedFormValues, _computeFormValues.current)) {
                            updateValue(computedFormValues);
                            _computeFormValues.current = computedFormValues;
                        }
                    } else updateValue(formValues);
                }
            }
        }), [
        control,
        disabled,
        name,
        exact
    ]);
    (0, $7ikhG.default).useEffect(()=>control._removeUnmounted());
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $ee9f4a2880885da1$export$e8c786024a2b0a79(props) {
    const methods = $ee9f4a2880885da1$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister, defaultValue: defaultValue } = props;
    const isArrayField = $ee9f4a2880885da1$var$isNameInFieldArray(control._names.array, name);
    const defaultValueMemo = (0, $7ikhG.default).useMemo(()=>$ee9f4a2880885da1$export$3988ae62b71be9a3(control._formValues, name, $ee9f4a2880885da1$export$3988ae62b71be9a3(control._defaultValues, name, defaultValue)), [
        control,
        name,
        defaultValue
    ]);
    const value1 = $ee9f4a2880885da1$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: defaultValueMemo,
        exact: true
    });
    const formState = $ee9f4a2880885da1$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: true
    });
    const _props = (0, $7ikhG.default).useRef(props);
    const _registerProps = (0, $7ikhG.default).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$ee9f4a2880885da1$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    _props.current = props;
    const fieldState = (0, $7ikhG.default).useMemo(()=>Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$ee9f4a2880885da1$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$ee9f4a2880885da1$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$ee9f4a2880885da1$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$ee9f4a2880885da1$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$ee9f4a2880885da1$export$3988ae62b71be9a3(formState.errors, name)
            }
        }), [
        formState,
        name
    ]);
    const onChange = (0, $7ikhG.default).useCallback((event)=>_registerProps.current.onChange({
            target: {
                value: $ee9f4a2880885da1$var$getEventValue(event),
                name: name
            },
            type: $ee9f4a2880885da1$var$EVENTS.CHANGE
        }), [
        name
    ]);
    const onBlur = (0, $7ikhG.default).useCallback(()=>_registerProps.current.onBlur({
            target: {
                value: $ee9f4a2880885da1$export$3988ae62b71be9a3(control._formValues, name),
                name: name
            },
            type: $ee9f4a2880885da1$var$EVENTS.BLUR
        }), [
        name,
        control._formValues
    ]);
    const ref = (0, $7ikhG.default).useCallback((elm)=>{
        const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(control._fields, name);
        if (field && elm) field._f.ref = {
            focus: ()=>elm.focus && elm.focus(),
            select: ()=>elm.select && elm.select(),
            setCustomValidity: (message)=>elm.setCustomValidity(message),
            reportValidity: ()=>elm.reportValidity()
        };
    }, [
        control._fields,
        name
    ]);
    const field = (0, $7ikhG.default).useMemo(()=>({
            name: name,
            value: value1,
            ...$ee9f4a2880885da1$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: onChange,
            onBlur: onBlur,
            ref: ref
        }), [
        name,
        disabled,
        formState.disabled,
        onChange,
        onBlur,
        ref,
        value1
    ]);
    (0, $7ikhG.default).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        control.register(name, {
            ..._props.current.rules,
            ...$ee9f4a2880885da1$var$isBoolean(_props.current.disabled) ? {
                disabled: _props.current.disabled
            } : {}
        });
        const updateMounted = (name, value1)=>{
            const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $ee9f4a2880885da1$var$cloneObject($ee9f4a2880885da1$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $ee9f4a2880885da1$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($ee9f4a2880885da1$var$isUndefined($ee9f4a2880885da1$export$3988ae62b71be9a3(control._formValues, name))) $ee9f4a2880885da1$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        !isArrayField && control.register(name);
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, $7ikhG.default).useEffect(()=>{
        control._setDisabledField({
            disabled: disabled,
            name: name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return (0, $7ikhG.default).useMemo(()=>({
            field: field,
            formState: formState,
            fieldState: fieldState
        }), [
        field,
        formState,
        fieldState
    ]);
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $ee9f4a2880885da1$export$bd0bf19f25da8474 = (props)=>props.render($ee9f4a2880885da1$export$e8c786024a2b0a79(props));
const $ee9f4a2880885da1$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($ee9f4a2880885da1$var$isObjectType(obj[key]) && obj[key] !== null) {
        const nested = $ee9f4a2880885da1$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const $ee9f4a2880885da1$var$POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $ee9f4a2880885da1$export$a7fed597f4b8afd8(props) {
    const methods = $ee9f4a2880885da1$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, $7ikhG.default).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $ee9f4a2880885da1$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = $ee9f4a2880885da1$var$flatten(control._formValues);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers['Content-Type'],
                    encType
                ].some((value1)=>value1 && value1.includes('json'));
                const response = await fetch(String(action), {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType && encType !== 'multipart/form-data' ? {
                            'Content-Type': encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError('root.server', {
                type: type
            });
        }
    };
    (0, $7ikhG.default).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, $7ikhG.default).createElement((0, $7ikhG.default).Fragment, null, render({
        submit: submit
    })) : (0, $7ikhG.default).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $ee9f4a2880885da1$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $ee9f4a2880885da1$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $ee9f4a2880885da1$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $ee9f4a2880885da1$var$isEmptyObject = (value1)=>$ee9f4a2880885da1$var$isObject(value1) && !Object.keys(value1).length;
var $ee9f4a2880885da1$var$isFileInput = (element)=>element.type === 'file';
var $ee9f4a2880885da1$var$isFunction = (value1)=>typeof value1 === 'function';
var $ee9f4a2880885da1$var$isHTMLElement = (value1)=>{
    if (!$ee9f4a2880885da1$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $ee9f4a2880885da1$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $ee9f4a2880885da1$var$isRadioInput = (element)=>element.type === 'radio';
var $ee9f4a2880885da1$var$isRadioOrCheckbox = (ref)=>$ee9f4a2880885da1$var$isRadioInput(ref) || $ee9f4a2880885da1$var$isCheckBoxInput(ref);
var $ee9f4a2880885da1$var$live = (ref)=>$ee9f4a2880885da1$var$isHTMLElement(ref) && ref.isConnected;
function $ee9f4a2880885da1$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $ee9f4a2880885da1$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $ee9f4a2880885da1$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$ee9f4a2880885da1$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $ee9f4a2880885da1$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $ee9f4a2880885da1$var$isKey(path) ? [
        path
    ] : $ee9f4a2880885da1$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $ee9f4a2880885da1$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($ee9f4a2880885da1$var$isObject(childObject) && $ee9f4a2880885da1$var$isEmptyObject(childObject) || Array.isArray(childObject) && $ee9f4a2880885da1$var$isEmptyArray(childObject))) $ee9f4a2880885da1$var$unset(object, paths.slice(0, -1));
    return object;
}
var $ee9f4a2880885da1$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($ee9f4a2880885da1$var$isFunction(data[key])) return true;
    }
    return false;
};
function $ee9f4a2880885da1$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($ee9f4a2880885da1$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $ee9f4a2880885da1$var$isObject(data[key]) && !$ee9f4a2880885da1$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $ee9f4a2880885da1$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$ee9f4a2880885da1$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $ee9f4a2880885da1$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($ee9f4a2880885da1$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $ee9f4a2880885da1$var$isObject(data[key]) && !$ee9f4a2880885da1$var$objectHasFunction(data[key])) {
            if ($ee9f4a2880885da1$var$isUndefined(formValues) || $ee9f4a2880885da1$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $ee9f4a2880885da1$var$markFieldsDirty(data[key], []) : {
                ...$ee9f4a2880885da1$var$markFieldsDirty(data[key])
            };
            else $ee9f4a2880885da1$var$getDirtyFieldsFromDefaultValues(data[key], $ee9f4a2880885da1$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$ee9f4a2880885da1$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $ee9f4a2880885da1$var$getDirtyFields = (defaultValues, formValues)=>$ee9f4a2880885da1$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $ee9f4a2880885da1$var$markFieldsDirty(formValues));
const $ee9f4a2880885da1$var$defaultResult = {
    value: false,
    isValid: false
};
const $ee9f4a2880885da1$var$validResult = {
    value: true,
    isValid: true
};
var $ee9f4a2880885da1$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$ee9f4a2880885da1$var$isUndefined(options[0].attributes.value) ? $ee9f4a2880885da1$var$isUndefined(options[0].value) || options[0].value === '' ? $ee9f4a2880885da1$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $ee9f4a2880885da1$var$validResult : $ee9f4a2880885da1$var$defaultResult;
    }
    return $ee9f4a2880885da1$var$defaultResult;
};
var $ee9f4a2880885da1$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$ee9f4a2880885da1$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === '' ? NaN : value1 ? +value1 : value1 : valueAsDate && $ee9f4a2880885da1$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
const $ee9f4a2880885da1$var$defaultReturn = {
    isValid: false,
    value: null
};
var $ee9f4a2880885da1$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $ee9f4a2880885da1$var$defaultReturn) : $ee9f4a2880885da1$var$defaultReturn;
function $ee9f4a2880885da1$var$getFieldValue(_f) {
    const ref = _f.ref;
    if ($ee9f4a2880885da1$var$isFileInput(ref)) return ref.files;
    if ($ee9f4a2880885da1$var$isRadioInput(ref)) return $ee9f4a2880885da1$var$getRadioValue(_f.refs).value;
    if ($ee9f4a2880885da1$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($ee9f4a2880885da1$var$isCheckBoxInput(ref)) return $ee9f4a2880885da1$var$getCheckboxValue(_f.refs).value;
    return $ee9f4a2880885da1$var$getFieldValueAs($ee9f4a2880885da1$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $ee9f4a2880885da1$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
        field && $ee9f4a2880885da1$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $ee9f4a2880885da1$var$isRegex = (value1)=>value1 instanceof RegExp;
var $ee9f4a2880885da1$var$getRuleValue = (rule)=>$ee9f4a2880885da1$var$isUndefined(rule) ? rule : $ee9f4a2880885da1$var$isRegex(rule) ? rule.source : $ee9f4a2880885da1$var$isObject(rule) ? $ee9f4a2880885da1$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $ee9f4a2880885da1$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $ee9f4a2880885da1$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $ee9f4a2880885da1$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $ee9f4a2880885da1$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $ee9f4a2880885da1$var$VALIDATION_MODE.all,
        isOnTouch: mode === $ee9f4a2880885da1$var$VALIDATION_MODE.onTouched
    });
const $ee9f4a2880885da1$var$ASYNC_FUNCTION = 'AsyncFunction';
var $ee9f4a2880885da1$var$hasPromiseValidation = (fieldReference)=>!!fieldReference && !!fieldReference.validate && !!($ee9f4a2880885da1$var$isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === $ee9f4a2880885da1$var$ASYNC_FUNCTION || $ee9f4a2880885da1$var$isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === $ee9f4a2880885da1$var$ASYNC_FUNCTION));
var $ee9f4a2880885da1$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
var $ee9f4a2880885da1$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $ee9f4a2880885da1$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($ee9f4a2880885da1$var$iterateFieldsByAction(currentField, action)) break;
                }
            } else if ($ee9f4a2880885da1$var$isObject(currentField)) {
                if ($ee9f4a2880885da1$var$iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
function $ee9f4a2880885da1$var$schemaErrorLookup(errors, _fields, name) {
    const error = $ee9f4a2880885da1$export$3988ae62b71be9a3(errors, name);
    if (error || $ee9f4a2880885da1$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split('.');
    while(names.length){
        const fieldName = names.join('.');
        const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $ee9f4a2880885da1$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        if (foundError && foundError.root && foundError.root.type) return {
            name: `${fieldName}.root`,
            error: foundError.root
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $ee9f4a2880885da1$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $ee9f4a2880885da1$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $ee9f4a2880885da1$var$VALIDATION_MODE.all));
};
var $ee9f4a2880885da1$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $ee9f4a2880885da1$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
var $ee9f4a2880885da1$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $ee9f4a2880885da1$var$unsetEmptyArray = (ref, name)=>!$ee9f4a2880885da1$var$compact($ee9f4a2880885da1$export$3988ae62b71be9a3(ref, name)).length && $ee9f4a2880885da1$var$unset(ref, name);
var $ee9f4a2880885da1$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $ee9f4a2880885da1$var$convertToArrayPayload($ee9f4a2880885da1$export$3988ae62b71be9a3(errors, name));
    $ee9f4a2880885da1$export$adaa4cf7ef1b65be(fieldArrayErrors, 'root', error[name]);
    $ee9f4a2880885da1$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $ee9f4a2880885da1$var$isMessage = (value1)=>$ee9f4a2880885da1$var$isString(value1);
function $ee9f4a2880885da1$var$getValidateError(result, ref, type = 'validate') {
    if ($ee9f4a2880885da1$var$isMessage(result) || Array.isArray(result) && result.every($ee9f4a2880885da1$var$isMessage) || $ee9f4a2880885da1$var$isBoolean(result) && !result) return {
        type: type,
        message: $ee9f4a2880885da1$var$isMessage(result) ? result : '',
        ref: ref
    };
}
var $ee9f4a2880885da1$var$getValueAndMessage = (validationData)=>$ee9f4a2880885da1$var$isObject(validationData) && !$ee9f4a2880885da1$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var $ee9f4a2880885da1$var$validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount } = field._f;
    const inputValue = $ee9f4a2880885da1$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabledFieldNames.has(name)) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($ee9f4a2880885da1$var$isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $ee9f4a2880885da1$var$isRadioInput(ref);
    const isCheckBox = $ee9f4a2880885da1$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $ee9f4a2880885da1$var$isFileInput(ref)) && $ee9f4a2880885da1$var$isUndefined(ref.value) && $ee9f4a2880885da1$var$isUndefined(inputValue) || $ee9f4a2880885da1$var$isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $ee9f4a2880885da1$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $ee9f4a2880885da1$var$INPUT_VALIDATION_RULES.maxLength, minType = $ee9f4a2880885da1$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $ee9f4a2880885da1$var$isNullOrUndefined(inputValue)) || $ee9f4a2880885da1$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$ee9f4a2880885da1$var$getCheckboxValue(refs).isValid || isRadio && !$ee9f4a2880885da1$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $ee9f4a2880885da1$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $ee9f4a2880885da1$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $ee9f4a2880885da1$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($ee9f4a2880885da1$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$ee9f4a2880885da1$var$isNullOrUndefined(min) || !$ee9f4a2880885da1$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $ee9f4a2880885da1$var$getValueAndMessage(max);
        const minOutput = $ee9f4a2880885da1$var$getValueAndMessage(min);
        if (!$ee9f4a2880885da1$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$ee9f4a2880885da1$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$ee9f4a2880885da1$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if ($ee9f4a2880885da1$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($ee9f4a2880885da1$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $ee9f4a2880885da1$var$INPUT_VALIDATION_RULES.max, $ee9f4a2880885da1$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($ee9f4a2880885da1$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $ee9f4a2880885da1$var$getValueAndMessage(maxLength);
        const minLengthOutput = $ee9f4a2880885da1$var$getValueAndMessage(minLength);
        const exceedMax = !$ee9f4a2880885da1$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$ee9f4a2880885da1$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $ee9f4a2880885da1$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $ee9f4a2880885da1$var$getValueAndMessage(pattern);
        if ($ee9f4a2880885da1$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $ee9f4a2880885da1$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($ee9f4a2880885da1$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($ee9f4a2880885da1$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $ee9f4a2880885da1$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($ee9f4a2880885da1$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($ee9f4a2880885da1$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$ee9f4a2880885da1$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $ee9f4a2880885da1$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$ee9f4a2880885da1$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
const $ee9f4a2880885da1$var$defaultOptions = {
    mode: $ee9f4a2880885da1$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $ee9f4a2880885da1$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $ee9f4a2880885da1$export$1361f5e0e4cca3c3(props = {}) {
    let _options = {
        ...$ee9f4a2880885da1$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isReady: false,
        isLoading: $ee9f4a2880885da1$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $ee9f4a2880885da1$var$isObject(_options.defaultValues) || $ee9f4a2880885da1$var$isObject(_options.values) ? $ee9f4a2880885da1$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $ee9f4a2880885da1$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    let _proxySubscribeFormState = {
        ..._proxyFormState
    };
    const _subjects = {
        array: $ee9f4a2880885da1$var$createSubject(),
        state: $ee9f4a2880885da1$var$createSubject()
    };
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $ee9f4a2880885da1$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _setValid = async (shouldUpdateValid)=>{
        if (!_options.disabled && (_proxyFormState.isValid || _proxySubscribeFormState.isValid || shouldUpdateValid)) {
            const isValid = _options.resolver ? $ee9f4a2880885da1$var$isEmptyObject((await _runSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields || _proxySubscribeFormState.isValidating || _proxySubscribeFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $ee9f4a2880885da1$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$ee9f4a2880885da1$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _setFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $ee9f4a2880885da1$var$unsetEmptyArray(_formState.errors, name);
            }
            if ((_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && shouldUpdateFieldsAndState && Array.isArray($ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) _formState.dirtyFields = $ee9f4a2880885da1$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $ee9f4a2880885da1$export$3988ae62b71be9a3(_formValues, name, $ee9f4a2880885da1$var$isUndefined(value1) ? $ee9f4a2880885da1$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $ee9f4a2880885da1$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $ee9f4a2880885da1$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _setValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!_options.disabled) {
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = $ee9f4a2880885da1$var$deepEqual($ee9f4a2880885da1$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                isPreviousDirty = !!$ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.dirtyFields, name);
                isCurrentFieldPristine ? $ee9f4a2880885da1$var$unset(_formState.dirtyFields, name) : $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || (_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && $ee9f4a2880885da1$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(_options.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $ee9f4a2880885da1$var$unset(_formState.errors, name);
        }
        if ((error ? !$ee9f4a2880885da1$var$deepEqual(previousFieldError, error) : previousFieldError) || !$ee9f4a2880885da1$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $ee9f4a2880885da1$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _runSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $ee9f4a2880885da1$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _runSchema(names);
        if (names) for (const name of names){
            const error = $ee9f4a2880885da1$export$3988ae62b71be9a3(errors, name);
            error ? $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $ee9f4a2880885da1$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $ee9f4a2880885da1$var$hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ], true);
                    const fieldError = await $ee9f4a2880885da1$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($ee9f4a2880885da1$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $ee9f4a2880885da1$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $ee9f4a2880885da1$var$unset(_formState.errors, _f.name));
                }
                !$ee9f4a2880885da1$var$isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$ee9f4a2880885da1$var$live(ref)) : !$ee9f4a2880885da1$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!_options.disabled && (name && data && $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formValues, name, data), !$ee9f4a2880885da1$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$ee9f4a2880885da1$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $ee9f4a2880885da1$var$isUndefined(defaultValue) ? _defaultValues : $ee9f4a2880885da1$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$ee9f4a2880885da1$var$compact($ee9f4a2880885da1$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? $ee9f4a2880885da1$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formValues, name, $ee9f4a2880885da1$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $ee9f4a2880885da1$var$isHTMLElement(fieldReference.ref) && $ee9f4a2880885da1$var$isNullOrUndefined(value1) ? '' : value1;
                if ($ee9f4a2880885da1$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($ee9f4a2880885da1$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.forEach((checkboxRef)=>{
                        if (!checkboxRef.defaultChecked || !checkboxRef.disabled) {
                            if (Array.isArray(fieldValue)) checkboxRef.checked = !!fieldValue.find((data)=>data === checkboxRef.value);
                            else checkboxRef.checked = fieldValue === checkboxRef.value || !!fieldValue;
                        }
                    });
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($ee9f4a2880885da1$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = '';
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.state.next({
                        name: name,
                        values: $ee9f4a2880885da1$var$cloneObject(_formValues)
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            if (!value1.hasOwnProperty(fieldKey)) return;
            const fieldValue = value1[fieldKey];
            const fieldName = name + '.' + fieldKey;
            const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || $ee9f4a2880885da1$var$isObject(fieldValue) || field && !field._f) && !$ee9f4a2880885da1$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $ee9f4a2880885da1$var$cloneObject(value1);
        $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: $ee9f4a2880885da1$var$cloneObject(_formValues)
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields || _proxySubscribeFormState.isDirty || _proxySubscribeFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $ee9f4a2880885da1$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$ee9f4a2880885da1$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $ee9f4a2880885da1$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState,
            name: name
        });
        _subjects.state.next({
            name: _state.mount ? name : undefined,
            values: $ee9f4a2880885da1$var$cloneObject(_formValues)
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $ee9f4a2880885da1$var$isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || $ee9f4a2880885da1$var$deepEqual(fieldValue, $ee9f4a2880885da1$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        const validationModeBeforeSubmit = $ee9f4a2880885da1$var$getValidationModes(_options.mode);
        const validationModeAfterSubmit = $ee9f4a2880885da1$var$getValidationModes(_options.reValidateMode);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type ? $ee9f4a2880885da1$var$getFieldValue(field._f) : $ee9f4a2880885da1$var$getEventValue(event);
            const isBlurEvent = event.type === $ee9f4a2880885da1$var$EVENTS.BLUR || event.type === $ee9f4a2880885da1$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$ee9f4a2880885da1$var$hasValidation(field._f) && !_options.resolver && !$ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $ee9f4a2880885da1$var$skipValidation(isBlurEvent, $ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $ee9f4a2880885da1$var$isWatched(name, _names, isBlurEvent);
            $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
            const shouldRender = !$ee9f4a2880885da1$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.state.next({
                name: name,
                type: event.type,
                values: $ee9f4a2880885da1$var$cloneObject(_formValues)
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) {
                    if (_options.mode === 'onBlur') {
                        if (isBlurEvent) _setValid();
                    } else if (!isBlurEvent) _setValid();
                }
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _runSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $ee9f4a2880885da1$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $ee9f4a2880885da1$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $ee9f4a2880885da1$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $ee9f4a2880885da1$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $ee9f4a2880885da1$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($ee9f4a2880885da1$var$isUndefined(name) ? name : fieldNames);
            isValid = $ee9f4a2880885da1$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$ee9f4a2880885da1$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _setValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$ee9f4a2880885da1$var$isString(name) || (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $ee9f4a2880885da1$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        return $ee9f4a2880885da1$var$isUndefined(fieldNames) ? values : $ee9f4a2880885da1$var$isString(fieldNames) ? $ee9f4a2880885da1$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$ee9f4a2880885da1$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$ee9f4a2880885da1$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$ee9f4a2880885da1$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $ee9f4a2880885da1$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$ee9f4a2880885da1$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && $ee9f4a2880885da1$var$convertToArrayPayload(name).forEach((inputName)=>$ee9f4a2880885da1$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type, ...restOfErrorTree } = currentError;
        $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$ee9f4a2880885da1$var$isFunction(name) ? _subjects.state.subscribe({
            next: (payload)=>'values' in payload && name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const _subscribe = (props)=>_subjects.state.subscribe({
            next: (formState)=>{
                if ($ee9f4a2880885da1$var$shouldSubscribeByName(props.name, formState.name, props.exact) && $ee9f4a2880885da1$var$shouldRenderFormState(formState, props.formState || _proxyFormState, _setFormState, props.reRenderRoot)) props.callback({
                    values: {
                        ..._formValues
                    },
                    ..._formState,
                    ...formState,
                    defaultValues: _defaultValues
                });
            }
        }).unsubscribe;
    const subscribe = (props)=>{
        _state.mount = true;
        _proxySubscribeFormState = {
            ..._proxySubscribeFormState,
            ...props.formState
        };
        return _subscribe({
            ...props,
            formState: _proxySubscribeFormState
        });
    };
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $ee9f4a2880885da1$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $ee9f4a2880885da1$var$unset(_fields, fieldName);
                $ee9f4a2880885da1$var$unset(_formValues, fieldName);
            }
            !options.keepError && $ee9f4a2880885da1$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $ee9f4a2880885da1$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $ee9f4a2880885da1$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $ee9f4a2880885da1$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $ee9f4a2880885da1$var$unset(_defaultValues, fieldName);
        }
        _subjects.state.next({
            values: $ee9f4a2880885da1$var$cloneObject(_formValues)
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _setValid();
    };
    const _setDisabledField = ({ disabled: disabled, name: name })=>{
        if ($ee9f4a2880885da1$var$isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
    };
    const register = (name, options = {})=>{
        let field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $ee9f4a2880885da1$var$isBoolean(options.disabled) || $ee9f4a2880885da1$var$isBoolean(_options.disabled);
        $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _setDisabledField({
            disabled: $ee9f4a2880885da1$var$isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || _options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $ee9f4a2880885da1$var$getRuleValue(options.min),
                max: $ee9f4a2880885da1$var$getRuleValue(options.max),
                minLength: $ee9f4a2880885da1$var$getRuleValue(options.minLength),
                maxLength: $ee9f4a2880885da1$var$getRuleValue(options.maxLength),
                pattern: $ee9f4a2880885da1$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $ee9f4a2880885da1$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
                    const radioOrCheckbox = $ee9f4a2880885da1$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($ee9f4a2880885da1$var$live),
                                    fieldRef,
                                    ...Array.isArray($ee9f4a2880885da1$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($ee9f4a2880885da1$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $ee9f4a2880885da1$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($ee9f4a2880885da1$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $ee9f4a2880885da1$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $ee9f4a2880885da1$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _runSchema();
                _formState.errors = errors;
                fieldValues = $ee9f4a2880885da1$var$cloneObject(values);
            } else await executeBuiltInValidation(_fields);
            if (_names.disabled.size) for (const name of _names.disabled)$ee9f4a2880885da1$var$unset(fieldValues, name);
            $ee9f4a2880885da1$var$unset(_formState.errors, 'root');
            if ($ee9f4a2880885da1$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $ee9f4a2880885da1$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name)) {
            if ($ee9f4a2880885da1$var$isUndefined(options.defaultValue)) setValue(name, $ee9f4a2880885da1$var$cloneObject($ee9f4a2880885da1$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_defaultValues, name, $ee9f4a2880885da1$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $ee9f4a2880885da1$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $ee9f4a2880885da1$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $ee9f4a2880885da1$var$cloneObject($ee9f4a2880885da1$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $ee9f4a2880885da1$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _setValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $ee9f4a2880885da1$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $ee9f4a2880885da1$var$cloneObject(updatedValues);
        const isEmptyResetValues = $ee9f4a2880885da1$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys($ee9f4a2880885da1$var$getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck))$ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $ee9f4a2880885da1$export$adaa4cf7ef1b65be(values, fieldName, $ee9f4a2880885da1$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $ee9f4a2880885da1$export$3988ae62b71be9a3(values, fieldName));
            } else {
                if ($ee9f4a2880885da1$var$isWeb && $ee9f4a2880885da1$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($ee9f4a2880885da1$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest('form');
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                if (keepStateOptions.keepFieldsRef) for (const fieldName of _names.mount)setValue(fieldName, $ee9f4a2880885da1$export$3988ae62b71be9a3(values, fieldName));
                else _fields = {};
            }
            _formValues = _options.shouldUnregister ? keepStateOptions.keepDefaultValues ? $ee9f4a2880885da1$var$cloneObject(_defaultValues) : {} : $ee9f4a2880885da1$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.state.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ''
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!_options.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$ee9f4a2880885da1$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $ee9f4a2880885da1$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $ee9f4a2880885da1$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($ee9f4a2880885da1$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && $ee9f4a2880885da1$var$isFunction(fieldRef.select) && fieldRef.select();
            }
        }
    };
    const _setFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$ee9f4a2880885da1$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    const methods = {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _subscribe: _subscribe,
            _runSchema: _runSchema,
            _focusError: _focusError,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _setValid: _setValid,
            _setFieldArray: _setFieldArray,
            _setDisabledField: _setDisabledField,
            _setErrors: _setErrors,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _removeUnmounted: _removeUnmounted,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        subscribe: subscribe,
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
    return {
        ...methods,
        formControl: methods
    };
}
var $ee9f4a2880885da1$var$generateId = ()=>{
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $ee9f4a2880885da1$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $ee9f4a2880885da1$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$ee9f4a2880885da1$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var $ee9f4a2880885da1$var$appendAt = (data, value1)=>[
        ...data,
        ...$ee9f4a2880885da1$var$convertToArrayPayload(value1)
    ];
var $ee9f4a2880885da1$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $ee9f4a2880885da1$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$ee9f4a2880885da1$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $ee9f4a2880885da1$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($ee9f4a2880885da1$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $ee9f4a2880885da1$var$prependAt = (data, value1)=>[
        ...$ee9f4a2880885da1$var$convertToArrayPayload(value1),
        ...$ee9f4a2880885da1$var$convertToArrayPayload(data)
    ];
function $ee9f4a2880885da1$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $ee9f4a2880885da1$var$compact(temp).length ? temp : [];
}
var $ee9f4a2880885da1$var$removeArrayAt = (data, index)=>$ee9f4a2880885da1$var$isUndefined(index) ? [] : $ee9f4a2880885da1$var$removeAtIndexes(data, $ee9f4a2880885da1$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $ee9f4a2880885da1$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
var $ee9f4a2880885da1$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $ee9f4a2880885da1$export$310131896651d559(props) {
    const methods = $ee9f4a2880885da1$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = 'id', shouldUnregister: shouldUnregister, rules: rules } = props;
    const [fields, setFields] = (0, $7ikhG.default).useState(control._getFieldArray(name));
    const ids = (0, $7ikhG.default).useRef(control._getFieldArray(name).map($ee9f4a2880885da1$var$generateId));
    const _fieldIds = (0, $7ikhG.default).useRef(fields);
    const _actioned = (0, $7ikhG.default).useRef(false);
    _fieldIds.current = fields;
    control._names.array.add(name);
    (0, $7ikhG.default).useMemo(()=>rules && control.register(name, rules), [
        control,
        rules,
        name
    ]);
    $ee9f4a2880885da1$var$useIsomorphicLayoutEffect(()=>control._subjects.array.subscribe({
            next: ({ values: values, name: fieldArrayName })=>{
                if (fieldArrayName === name || !fieldArrayName) {
                    const fieldValues = $ee9f4a2880885da1$export$3988ae62b71be9a3(values, name);
                    if (Array.isArray(fieldValues)) {
                        setFields(fieldValues);
                        ids.current = fieldValues.map($ee9f4a2880885da1$var$generateId);
                    }
                }
            }
        }).unsubscribe, [
        control,
        name
    ]);
    const updateValues = (0, $7ikhG.default).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._setFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $ee9f4a2880885da1$var$convertToArrayPayload($ee9f4a2880885da1$var$cloneObject(value1));
        const updatedFieldArrayValues = $ee9f4a2880885da1$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $ee9f4a2880885da1$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $ee9f4a2880885da1$var$appendAt(ids.current, appendValue.map($ee9f4a2880885da1$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $ee9f4a2880885da1$var$appendAt, {
            argA: $ee9f4a2880885da1$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $ee9f4a2880885da1$var$convertToArrayPayload($ee9f4a2880885da1$var$cloneObject(value1));
        const updatedFieldArrayValues = $ee9f4a2880885da1$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $ee9f4a2880885da1$var$getFocusFieldName(name, 0, options);
        ids.current = $ee9f4a2880885da1$var$prependAt(ids.current, prependValue.map($ee9f4a2880885da1$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $ee9f4a2880885da1$var$prependAt, {
            argA: $ee9f4a2880885da1$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $ee9f4a2880885da1$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $ee9f4a2880885da1$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        !Array.isArray($ee9f4a2880885da1$export$3988ae62b71be9a3(control._fields, name)) && $ee9f4a2880885da1$export$adaa4cf7ef1b65be(control._fields, name, undefined);
        control._setFieldArray(name, updatedFieldArrayValues, $ee9f4a2880885da1$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $ee9f4a2880885da1$var$convertToArrayPayload($ee9f4a2880885da1$var$cloneObject(value1));
        const updatedFieldArrayValues = $ee9f4a2880885da1$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $ee9f4a2880885da1$var$getFocusFieldName(name, index, options);
        ids.current = $ee9f4a2880885da1$var$insert(ids.current, index, insertValue.map($ee9f4a2880885da1$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $ee9f4a2880885da1$var$insert, {
            argA: index,
            argB: $ee9f4a2880885da1$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $ee9f4a2880885da1$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $ee9f4a2880885da1$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $ee9f4a2880885da1$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $ee9f4a2880885da1$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $ee9f4a2880885da1$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $ee9f4a2880885da1$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $ee9f4a2880885da1$var$cloneObject(value1);
        const updatedFieldArrayValues = $ee9f4a2880885da1$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $ee9f4a2880885da1$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, updatedFieldArrayValues, $ee9f4a2880885da1$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $ee9f4a2880885da1$var$convertToArrayPayload($ee9f4a2880885da1$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($ee9f4a2880885da1$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, $7ikhG.default).useEffect(()=>{
        control._state.action = false;
        $ee9f4a2880885da1$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$ee9f4a2880885da1$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted) && !$ee9f4a2880885da1$var$getValidationModes(control._options.reValidateMode).isOnSubmit) {
            if (control._options.resolver) control._runSchema([
                name
            ]).then((result)=>{
                const error = $ee9f4a2880885da1$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $ee9f4a2880885da1$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $ee9f4a2880885da1$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $ee9f4a2880885da1$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($ee9f4a2880885da1$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $ee9f4a2880885da1$var$getValidationModes(control._options.mode).isOnSubmit)) $ee9f4a2880885da1$var$validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === $ee9f4a2880885da1$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$ee9f4a2880885da1$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $ee9f4a2880885da1$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.state.next({
            name: name,
            values: $ee9f4a2880885da1$var$cloneObject(control._formValues)
        });
        control._names.focus && $ee9f4a2880885da1$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = '';
        control._setValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, $7ikhG.default).useEffect(()=>{
        !$ee9f4a2880885da1$export$3988ae62b71be9a3(control._formValues, name) && control._setFieldArray(name);
        return ()=>{
            const updateMounted = (name, value1)=>{
                const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) field._f.mount = value1;
            };
            control._options.shouldUnregister || shouldUnregister ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, $7ikhG.default).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, $7ikhG.default).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, $7ikhG.default).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, $7ikhG.default).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, $7ikhG.default).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, $7ikhG.default).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, $7ikhG.default).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, $7ikhG.default).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, $7ikhG.default).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $ee9f4a2880885da1$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $ee9f4a2880885da1$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, $7ikhG.default).useRef(undefined);
    const _values = (0, $7ikhG.default).useRef(undefined);
    const [formState, updateFormState] = (0, $7ikhG.default).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $ee9f4a2880885da1$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        isReady: false,
        defaultValues: $ee9f4a2880885da1$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) {
        if (props.formControl) {
            _formControl.current = {
                ...props.formControl,
                formState: formState
            };
            if (props.defaultValues && !$ee9f4a2880885da1$var$isFunction(props.defaultValues)) props.formControl.reset(props.defaultValues, props.resetOptions);
        } else {
            const { formControl: formControl, ...rest } = $ee9f4a2880885da1$export$1361f5e0e4cca3c3(props);
            _formControl.current = {
                ...rest,
                formState: formState
            };
        }
    }
    const control = _formControl.current.control;
    control._options = props;
    $ee9f4a2880885da1$var$useIsomorphicLayoutEffect(()=>{
        const sub = control._subscribe({
            formState: control._proxyFormState,
            callback: ()=>updateFormState({
                    ...control._formState
                }),
            reRenderRoot: true
        });
        updateFormState((data)=>({
                ...data,
                isReady: true
            }));
        control._formState.isReady = true;
        return sub;
    }, [
        control
    ]);
    (0, $7ikhG.default).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, $7ikhG.default).useEffect(()=>{
        if (props.mode) control._options.mode = props.mode;
        if (props.reValidateMode) control._options.reValidateMode = props.reValidateMode;
    }, [
        control,
        props.mode,
        props.reValidateMode
    ]);
    (0, $7ikhG.default).useEffect(()=>{
        if (props.errors) {
            control._setErrors(props.errors);
            control._focusError();
        }
    }, [
        control,
        props.errors
    ]);
    (0, $7ikhG.default).useEffect(()=>{
        props.shouldUnregister && control._subjects.state.next({
            values: control._getWatch()
        });
    }, [
        control,
        props.shouldUnregister
    ]);
    (0, $7ikhG.default).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, $7ikhG.default).useEffect(()=>{
        if (props.values && !$ee9f4a2880885da1$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, {
                keepFieldsRef: true,
                ...control._options.resetOptions
            });
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        control,
        props.values
    ]);
    (0, $7ikhG.default).useEffect(()=>{
        if (!control._state.mount) {
            control._setValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $ee9f4a2880885da1$var$getProxyFormState(formState, control);
    return _formControl.current;
}






var $7ikhG = parcelRequire("7ikhG");
var $3aPmr = parcelRequire("3aPmr");
parcelRequire("7ikhG");
var $3aPmr = parcelRequire("3aPmr");
// These are filled with ranges (rangeFrom[i] up to but not including
// rangeTo[i]) of code points that count as extending characters.
let $f3fbde23a9f558dd$var$rangeFrom = [], $f3fbde23a9f558dd$var$rangeTo = [];
(()=>{
    // Compressed representation of the Grapheme_Cluster_Break=Extend
    // information from
    // http://www.unicode.org/Public/16.0.0/ucd/auxiliary/GraphemeBreakProperty.txt.
    // Each pair of elements represents a range, as an offet from the
    // previous range and a length. Numbers are in base-36, with the empty
    // string being a shorthand for 1.
    let numbers = "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((s)=>s ? parseInt(s, 36) : 1);
    for(let i = 0, n = 0; i < numbers.length; i++)(i % 2 ? $f3fbde23a9f558dd$var$rangeTo : $f3fbde23a9f558dd$var$rangeFrom).push(n = n + numbers[i]);
})();
function $f3fbde23a9f558dd$export$5ff7ae0b7231f50b(code) {
    if (code < 768) return false;
    for(let from = 0, to = $f3fbde23a9f558dd$var$rangeFrom.length;;){
        let mid = from + to >> 1;
        if (code < $f3fbde23a9f558dd$var$rangeFrom[mid]) to = mid;
        else if (code >= $f3fbde23a9f558dd$var$rangeTo[mid]) from = mid + 1;
        else return true;
        if (from == to) return false;
    }
}
function $f3fbde23a9f558dd$var$isRegionalIndicator(code) {
    return code >= 0x1F1E6 && code <= 0x1F1FF;
}
function $f3fbde23a9f558dd$var$check(code) {
    for(let i = 0; i < $f3fbde23a9f558dd$var$rangeFrom.length; i++){
        if ($f3fbde23a9f558dd$var$rangeTo[i] > code) return $f3fbde23a9f558dd$var$rangeFrom[i] <= code;
    }
    return false;
}
const $f3fbde23a9f558dd$var$ZWJ = 0x200d;
function $f3fbde23a9f558dd$export$a0fa439fd515e1ed(str, pos, forward = true, includeExtending = true) {
    return (forward ? $f3fbde23a9f558dd$var$nextClusterBreak : $f3fbde23a9f558dd$var$prevClusterBreak)(str, pos, includeExtending);
}
function $f3fbde23a9f558dd$var$nextClusterBreak(str, pos, includeExtending) {
    if (pos == str.length) return pos;
    // If pos is in the middle of a surrogate pair, move to its start
    if (pos && $f3fbde23a9f558dd$var$surrogateLow(str.charCodeAt(pos)) && $f3fbde23a9f558dd$var$surrogateHigh(str.charCodeAt(pos - 1))) pos--;
    let prev = $f3fbde23a9f558dd$var$codePointAt(str, pos);
    pos += $f3fbde23a9f558dd$var$codePointSize(prev);
    while(pos < str.length){
        let next = $f3fbde23a9f558dd$var$codePointAt(str, pos);
        if (prev == $f3fbde23a9f558dd$var$ZWJ || next == $f3fbde23a9f558dd$var$ZWJ || includeExtending && $f3fbde23a9f558dd$export$5ff7ae0b7231f50b(next)) {
            pos += $f3fbde23a9f558dd$var$codePointSize(next);
            prev = next;
        } else if ($f3fbde23a9f558dd$var$isRegionalIndicator(next)) {
            let countBefore = 0, i = pos - 2;
            while(i >= 0 && $f3fbde23a9f558dd$var$isRegionalIndicator($f3fbde23a9f558dd$var$codePointAt(str, i))){
                countBefore++;
                i -= 2;
            }
            if (countBefore % 2 == 0) break;
            else pos += 2;
        } else break;
    }
    return pos;
}
function $f3fbde23a9f558dd$var$prevClusterBreak(str, pos, includeExtending) {
    while(pos > 0){
        let found = $f3fbde23a9f558dd$var$nextClusterBreak(str, pos - 2, includeExtending);
        if (found < pos) return found;
        pos--;
    }
    return 0;
}
function $f3fbde23a9f558dd$var$codePointAt(str, pos) {
    let code0 = str.charCodeAt(pos);
    if (!$f3fbde23a9f558dd$var$surrogateHigh(code0) || pos + 1 == str.length) return code0;
    let code1 = str.charCodeAt(pos + 1);
    if (!$f3fbde23a9f558dd$var$surrogateLow(code1)) return code0;
    return (code0 - 0xd800 << 10) + (code1 - 0xdc00) + 0x10000;
}
function $f3fbde23a9f558dd$var$surrogateLow(ch) {
    return ch >= 0xDC00 && ch < 0xE000;
}
function $f3fbde23a9f558dd$var$surrogateHigh(ch) {
    return ch >= 0xD800 && ch < 0xDC00;
}
function $f3fbde23a9f558dd$var$codePointSize(code) {
    return code < 0x10000 ? 1 : 2;
}


/**
The data structure for documents. @nonabstract
*/ class $6b8f387faea0a4dd$export$5f1af8db9871e1d6 {
    /**
    Get the line description around the given position.
    */ lineAt(pos) {
        if (pos < 0 || pos > this.length) throw new RangeError(`Invalid position ${pos} in document of length ${this.length}`);
        return this.lineInner(pos, false, 1, 0);
    }
    /**
    Get the description for the given (1-based) line number.
    */ line(n) {
        if (n < 1 || n > this.lines) throw new RangeError(`Invalid line number ${n} in ${this.lines}-line document`);
        return this.lineInner(n, true, 1, 0);
    }
    /**
    Replace a range of the text with the given content.
    */ replace(from, to, text) {
        [from, to] = $6b8f387faea0a4dd$var$clip(this, from, to);
        let parts = [];
        this.decompose(0, from, parts, 2 /* Open.To */ );
        if (text.length) text.decompose(0, text.length, parts, 3 /* Open.To */ );
        this.decompose(to, this.length, parts, 1 /* Open.From */ );
        return $6b8f387faea0a4dd$var$TextNode.from(parts, this.length - (to - from) + text.length);
    }
    /**
    Append another document to this one.
    */ append(other) {
        return this.replace(this.length, this.length, other);
    }
    /**
    Retrieve the text between the given points.
    */ slice(from, to = this.length) {
        [from, to] = $6b8f387faea0a4dd$var$clip(this, from, to);
        let parts = [];
        this.decompose(from, to, parts, 0);
        return $6b8f387faea0a4dd$var$TextNode.from(parts, to - from);
    }
    /**
    Test whether this text is equal to another instance.
    */ eq(other) {
        if (other == this) return true;
        if (other.length != this.length || other.lines != this.lines) return false;
        let start = this.scanIdentical(other, 1), end = this.length - this.scanIdentical(other, -1);
        let a = new $6b8f387faea0a4dd$var$RawTextCursor(this), b = new $6b8f387faea0a4dd$var$RawTextCursor(other);
        for(let skip = start, pos = start;;){
            a.next(skip);
            b.next(skip);
            skip = 0;
            if (a.lineBreak != b.lineBreak || a.done != b.done || a.value != b.value) return false;
            pos += a.value.length;
            if (a.done || pos >= end) return true;
        }
    }
    /**
    Iterate over the text. When `dir` is `-1`, iteration happens
    from end to start. This will return lines and the breaks between
    them as separate strings.
    */ iter(dir = 1) {
        return new $6b8f387faea0a4dd$var$RawTextCursor(this, dir);
    }
    /**
    Iterate over a range of the text. When `from` > `to`, the
    iterator will run in reverse.
    */ iterRange(from, to = this.length) {
        return new $6b8f387faea0a4dd$var$PartialTextCursor(this, from, to);
    }
    /**
    Return a cursor that iterates over the given range of lines,
    _without_ returning the line breaks between, and yielding empty
    strings for empty lines.
    
    When `from` and `to` are given, they should be 1-based line numbers.
    */ iterLines(from, to) {
        let inner;
        if (from == null) inner = this.iter();
        else {
            if (to == null) to = this.lines + 1;
            let start = this.line(from).from;
            inner = this.iterRange(start, Math.max(start, to == this.lines + 1 ? this.length : to <= 1 ? 0 : this.line(to - 1).to));
        }
        return new $6b8f387faea0a4dd$var$LineCursor(inner);
    }
    /**
    Return the document as a string, using newline characters to
    separate lines.
    */ toString() {
        return this.sliceString(0);
    }
    /**
    Convert the document to an array of lines (which can be
    deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
    */ toJSON() {
        let lines = [];
        this.flatten(lines);
        return lines;
    }
    /**
    @internal
    */ constructor(){}
    /**
    Create a `Text` instance for the given array of lines.
    */ static of(text) {
        if (text.length == 0) throw new RangeError("A document must have at least one line");
        if (text.length == 1 && !text[0]) return $6b8f387faea0a4dd$export$5f1af8db9871e1d6.empty;
        return text.length <= 32 /* Tree.Branch */  ? new $6b8f387faea0a4dd$var$TextLeaf(text) : $6b8f387faea0a4dd$var$TextNode.from($6b8f387faea0a4dd$var$TextLeaf.split(text, []));
    }
}
// Leaves store an array of line strings. There are always line breaks
// between these strings. Leaves are limited in size and have to be
// contained in TextNode instances for bigger documents.
class $6b8f387faea0a4dd$var$TextLeaf extends $6b8f387faea0a4dd$export$5f1af8db9871e1d6 {
    constructor(text, length = $6b8f387faea0a4dd$var$textLength(text)){
        super();
        this.text = text;
        this.length = length;
    }
    get lines() {
        return this.text.length;
    }
    get children() {
        return null;
    }
    lineInner(target, isLine, line, offset) {
        for(let i = 0;; i++){
            let string = this.text[i], end = offset + string.length;
            if ((isLine ? line : end) >= target) return new $6b8f387faea0a4dd$export$17d680238e50603e(offset, end, line, string);
            offset = end + 1;
            line++;
        }
    }
    decompose(from, to, target, open) {
        let text = from <= 0 && to >= this.length ? this : new $6b8f387faea0a4dd$var$TextLeaf($6b8f387faea0a4dd$var$sliceText(this.text, from, to), Math.min(to, this.length) - Math.max(0, from));
        if (open & 1 /* Open.From */ ) {
            let prev = target.pop();
            let joined = $6b8f387faea0a4dd$var$appendText(text.text, prev.text.slice(), 0, text.length);
            if (joined.length <= 32 /* Tree.Branch */ ) target.push(new $6b8f387faea0a4dd$var$TextLeaf(joined, prev.length + text.length));
            else {
                let mid = joined.length >> 1;
                target.push(new $6b8f387faea0a4dd$var$TextLeaf(joined.slice(0, mid)), new $6b8f387faea0a4dd$var$TextLeaf(joined.slice(mid)));
            }
        } else target.push(text);
    }
    replace(from, to, text) {
        if (!(text instanceof $6b8f387faea0a4dd$var$TextLeaf)) return super.replace(from, to, text);
        [from, to] = $6b8f387faea0a4dd$var$clip(this, from, to);
        let lines = $6b8f387faea0a4dd$var$appendText(this.text, $6b8f387faea0a4dd$var$appendText(text.text, $6b8f387faea0a4dd$var$sliceText(this.text, 0, from)), to);
        let newLen = this.length + text.length - (to - from);
        if (lines.length <= 32 /* Tree.Branch */ ) return new $6b8f387faea0a4dd$var$TextLeaf(lines, newLen);
        return $6b8f387faea0a4dd$var$TextNode.from($6b8f387faea0a4dd$var$TextLeaf.split(lines, []), newLen);
    }
    sliceString(from, to = this.length, lineSep = "\n") {
        [from, to] = $6b8f387faea0a4dd$var$clip(this, from, to);
        let result = "";
        for(let pos = 0, i = 0; pos <= to && i < this.text.length; i++){
            let line = this.text[i], end = pos + line.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += line.slice(Math.max(0, from - pos), to - pos);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        for (let line of this.text)target.push(line);
    }
    scanIdentical() {
        return 0;
    }
    static split(text, target) {
        let part = [], len = -1;
        for (let line of text){
            part.push(line);
            len += line.length + 1;
            if (part.length == 32 /* Tree.Branch */ ) {
                target.push(new $6b8f387faea0a4dd$var$TextLeaf(part, len));
                part = [];
                len = -1;
            }
        }
        if (len > -1) target.push(new $6b8f387faea0a4dd$var$TextLeaf(part, len));
        return target;
    }
}
// Nodes provide the tree structure of the `Text` type. They store a
// number of other nodes or leaves, taking care to balance themselves
// on changes. There are implied line breaks _between_ the children of
// a node (but not before the first or after the last child).
class $6b8f387faea0a4dd$var$TextNode extends $6b8f387faea0a4dd$export$5f1af8db9871e1d6 {
    constructor(children, length){
        super();
        this.children = children;
        this.length = length;
        this.lines = 0;
        for (let child of children)this.lines += child.lines;
    }
    lineInner(target, isLine, line, offset) {
        for(let i = 0;; i++){
            let child = this.children[i], end = offset + child.length, endLine = line + child.lines - 1;
            if ((isLine ? endLine : end) >= target) return child.lineInner(target, isLine, line, offset);
            offset = end + 1;
            line = endLine + 1;
        }
    }
    decompose(from, to, target, open) {
        for(let i = 0, pos = 0; pos <= to && i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (from <= end && to >= pos) {
                let childOpen = open & ((pos <= from ? 1 /* Open.From */  : 0) | (end >= to ? 2 /* Open.To */  : 0));
                if (pos >= from && end <= to && !childOpen) target.push(child);
                else child.decompose(from - pos, to - pos, target, childOpen);
            }
            pos = end + 1;
        }
    }
    replace(from, to, text) {
        [from, to] = $6b8f387faea0a4dd$var$clip(this, from, to);
        if (text.lines < this.lines) for(let i = 0, pos = 0; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            // Fast path: if the change only affects one child and the
            // child's size remains in the acceptable range, only update
            // that child
            if (from >= pos && to <= end) {
                let updated = child.replace(from - pos, to - pos, text);
                let totalLines = this.lines - child.lines + updated.lines;
                if (updated.lines < totalLines >> 4 && updated.lines > totalLines >> 6) {
                    let copy = this.children.slice();
                    copy[i] = updated;
                    return new $6b8f387faea0a4dd$var$TextNode(copy, this.length - (to - from) + text.length);
                }
                return super.replace(pos, end, updated);
            }
            pos = end + 1;
        }
        return super.replace(from, to, text);
    }
    sliceString(from, to = this.length, lineSep = "\n") {
        [from, to] = $6b8f387faea0a4dd$var$clip(this, from, to);
        let result = "";
        for(let i = 0, pos = 0; i < this.children.length && pos <= to; i++){
            let child = this.children[i], end = pos + child.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += child.sliceString(from - pos, to - pos, lineSep);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        for (let child of this.children)child.flatten(target);
    }
    scanIdentical(other, dir) {
        if (!(other instanceof $6b8f387faea0a4dd$var$TextNode)) return 0;
        let length = 0;
        let [iA, iB, eA, eB] = dir > 0 ? [
            0,
            0,
            this.children.length,
            other.children.length
        ] : [
            this.children.length - 1,
            other.children.length - 1,
            -1,
            -1
        ];
        for(;; iA += dir, iB += dir){
            if (iA == eA || iB == eB) return length;
            let chA = this.children[iA], chB = other.children[iB];
            if (chA != chB) return length + chA.scanIdentical(chB, dir);
            length += chA.length + 1;
        }
    }
    static from(children, length = children.reduce((l, ch)=>l + ch.length + 1, -1)) {
        let lines = 0;
        for (let ch of children)lines += ch.lines;
        if (lines < 32 /* Tree.Branch */ ) {
            let flat = [];
            for (let ch of children)ch.flatten(flat);
            return new $6b8f387faea0a4dd$var$TextLeaf(flat, length);
        }
        let chunk = Math.max(32 /* Tree.Branch */ , lines >> 5 /* Tree.BranchShift */ ), maxChunk = chunk << 1, minChunk = chunk >> 1;
        let chunked = [], currentLines = 0, currentLen = -1, currentChunk = [];
        function add(child) {
            let last;
            if (child.lines > maxChunk && child instanceof $6b8f387faea0a4dd$var$TextNode) for (let node of child.children)add(node);
            else if (child.lines > minChunk && (currentLines > minChunk || !currentLines)) {
                flush();
                chunked.push(child);
            } else if (child instanceof $6b8f387faea0a4dd$var$TextLeaf && currentLines && (last = currentChunk[currentChunk.length - 1]) instanceof $6b8f387faea0a4dd$var$TextLeaf && child.lines + last.lines <= 32 /* Tree.Branch */ ) {
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk[currentChunk.length - 1] = new $6b8f387faea0a4dd$var$TextLeaf(last.text.concat(child.text), last.length + 1 + child.length);
            } else {
                if (currentLines + child.lines > chunk) flush();
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk.push(child);
            }
        }
        function flush() {
            if (currentLines == 0) return;
            chunked.push(currentChunk.length == 1 ? currentChunk[0] : $6b8f387faea0a4dd$var$TextNode.from(currentChunk, currentLen));
            currentLen = -1;
            currentLines = currentChunk.length = 0;
        }
        for (let child of children)add(child);
        flush();
        return chunked.length == 1 ? chunked[0] : new $6b8f387faea0a4dd$var$TextNode(chunked, length);
    }
}
$6b8f387faea0a4dd$export$5f1af8db9871e1d6.empty = /*@__PURE__*/ new $6b8f387faea0a4dd$var$TextLeaf([
    ""
], 0);
function $6b8f387faea0a4dd$var$textLength(text) {
    let length = -1;
    for (let line of text)length += line.length + 1;
    return length;
}
function $6b8f387faea0a4dd$var$appendText(text, target, from = 0, to = 1e9) {
    for(let pos = 0, i = 0, first = true; i < text.length && pos <= to; i++){
        let line = text[i], end = pos + line.length;
        if (end >= from) {
            if (end > to) line = line.slice(0, to - pos);
            if (pos < from) line = line.slice(from - pos);
            if (first) {
                target[target.length - 1] += line;
                first = false;
            } else target.push(line);
        }
        pos = end + 1;
    }
    return target;
}
function $6b8f387faea0a4dd$var$sliceText(text, from, to) {
    return $6b8f387faea0a4dd$var$appendText(text, [
        ""
    ], from, to);
}
class $6b8f387faea0a4dd$var$RawTextCursor {
    constructor(text, dir = 1){
        this.dir = dir;
        this.done = false;
        this.lineBreak = false;
        this.value = "";
        this.nodes = [
            text
        ];
        this.offsets = [
            dir > 0 ? 1 : (text instanceof $6b8f387faea0a4dd$var$TextLeaf ? text.text.length : text.children.length) << 1
        ];
    }
    nextInner(skip, dir) {
        this.done = this.lineBreak = false;
        for(;;){
            let last = this.nodes.length - 1;
            let top = this.nodes[last], offsetValue = this.offsets[last], offset = offsetValue >> 1;
            let size = top instanceof $6b8f387faea0a4dd$var$TextLeaf ? top.text.length : top.children.length;
            if (offset == (dir > 0 ? size : 0)) {
                if (last == 0) {
                    this.done = true;
                    this.value = "";
                    return this;
                }
                if (dir > 0) this.offsets[last - 1]++;
                this.nodes.pop();
                this.offsets.pop();
            } else if ((offsetValue & 1) == (dir > 0 ? 0 : 1)) {
                this.offsets[last] += dir;
                if (skip == 0) {
                    this.lineBreak = true;
                    this.value = "\n";
                    return this;
                }
                skip--;
            } else if (top instanceof $6b8f387faea0a4dd$var$TextLeaf) {
                // Move to the next string
                let next = top.text[offset + (dir < 0 ? -1 : 0)];
                this.offsets[last] += dir;
                if (next.length > Math.max(0, skip)) {
                    this.value = skip == 0 ? next : dir > 0 ? next.slice(skip) : next.slice(0, next.length - skip);
                    return this;
                }
                skip -= next.length;
            } else {
                let next = top.children[offset + (dir < 0 ? -1 : 0)];
                if (skip > next.length) {
                    skip -= next.length;
                    this.offsets[last] += dir;
                } else {
                    if (dir < 0) this.offsets[last]--;
                    this.nodes.push(next);
                    this.offsets.push(dir > 0 ? 1 : (next instanceof $6b8f387faea0a4dd$var$TextLeaf ? next.text.length : next.children.length) << 1);
                }
            }
        }
    }
    next(skip = 0) {
        if (skip < 0) {
            this.nextInner(-skip, -this.dir);
            skip = this.value.length;
        }
        return this.nextInner(skip, this.dir);
    }
}
class $6b8f387faea0a4dd$var$PartialTextCursor {
    constructor(text, start, end){
        this.value = "";
        this.done = false;
        this.cursor = new $6b8f387faea0a4dd$var$RawTextCursor(text, start > end ? -1 : 1);
        this.pos = start > end ? text.length : 0;
        this.from = Math.min(start, end);
        this.to = Math.max(start, end);
    }
    nextInner(skip, dir) {
        if (dir < 0 ? this.pos <= this.from : this.pos >= this.to) {
            this.value = "";
            this.done = true;
            return this;
        }
        skip += Math.max(0, dir < 0 ? this.pos - this.to : this.from - this.pos);
        let limit = dir < 0 ? this.pos - this.from : this.to - this.pos;
        if (skip > limit) skip = limit;
        limit -= skip;
        let { value: value } = this.cursor.next(skip);
        this.pos += (value.length + skip) * dir;
        this.value = value.length <= limit ? value : dir < 0 ? value.slice(value.length - limit) : value.slice(0, limit);
        this.done = !this.value;
        return this;
    }
    next(skip = 0) {
        if (skip < 0) skip = Math.max(skip, this.from - this.pos);
        else if (skip > 0) skip = Math.min(skip, this.to - this.pos);
        return this.nextInner(skip, this.cursor.dir);
    }
    get lineBreak() {
        return this.cursor.lineBreak && this.value != "";
    }
}
class $6b8f387faea0a4dd$var$LineCursor {
    constructor(inner){
        this.inner = inner;
        this.afterBreak = true;
        this.value = "";
        this.done = false;
    }
    next(skip = 0) {
        let { done: done, lineBreak: lineBreak, value: value } = this.inner.next(skip);
        if (done && this.afterBreak) {
            this.value = "";
            this.afterBreak = false;
        } else if (done) {
            this.done = true;
            this.value = "";
        } else if (lineBreak) {
            if (this.afterBreak) this.value = "";
            else {
                this.afterBreak = true;
                this.next();
            }
        } else {
            this.value = value;
            this.afterBreak = false;
        }
        return this;
    }
    get lineBreak() {
        return false;
    }
}
if (typeof Symbol != "undefined") {
    $6b8f387faea0a4dd$export$5f1af8db9871e1d6.prototype[Symbol.iterator] = function() {
        return this.iter();
    };
    $6b8f387faea0a4dd$var$RawTextCursor.prototype[Symbol.iterator] = $6b8f387faea0a4dd$var$PartialTextCursor.prototype[Symbol.iterator] = $6b8f387faea0a4dd$var$LineCursor.prototype[Symbol.iterator] = function() {
        return this;
    };
}
/**
This type describes a line in the document. It is created
on-demand when lines are [queried](https://codemirror.net/6/docs/ref/#state.Text.lineAt).
*/ class $6b8f387faea0a4dd$export$17d680238e50603e {
    /**
    @internal
    */ constructor(/**
    The position of the start of the line.
    */ from, /**
    The position at the end of the line (_before_ the line break,
    or at the end of document for the last line).
    */ to, /**
    This line's line number (1-based).
    */ number, /**
    The line's content.
    */ text){
        this.from = from;
        this.to = to;
        this.number = number;
        this.text = text;
    }
    /**
    The length of the line (not including any line break after it).
    */ get length() {
        return this.to - this.from;
    }
}
function $6b8f387faea0a4dd$var$clip(text, from, to) {
    from = Math.max(0, Math.min(text.length, from));
    return [
        from,
        Math.max(from, Math.min(text.length, to))
    ];
}
/**
Returns a next grapheme cluster break _after_ (not equal to)
`pos`, if `forward` is true, or before otherwise. Returns `pos`
itself if no further cluster break is available in the string.
Moves across surrogate pairs, extending characters (when
`includeExtending` is true), characters joined with zero-width
joiners, and flag emoji.
*/ function $6b8f387faea0a4dd$export$a0fa439fd515e1ed(str, pos, forward = true, includeExtending = true) {
    return (0, $f3fbde23a9f558dd$export$a0fa439fd515e1ed)(str, pos, forward, includeExtending);
}
function $6b8f387faea0a4dd$var$surrogateLow(ch) {
    return ch >= 0xDC00 && ch < 0xE000;
}
function $6b8f387faea0a4dd$var$surrogateHigh(ch) {
    return ch >= 0xD800 && ch < 0xDC00;
}
/**
Find the code point at the given position in a string (like the
[`codePointAt`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/codePointAt)
string method).
*/ function $6b8f387faea0a4dd$export$42977f40461e1360(str, pos) {
    let code0 = str.charCodeAt(pos);
    if (!$6b8f387faea0a4dd$var$surrogateHigh(code0) || pos + 1 == str.length) return code0;
    let code1 = str.charCodeAt(pos + 1);
    if (!$6b8f387faea0a4dd$var$surrogateLow(code1)) return code0;
    return (code0 - 0xd800 << 10) + (code1 - 0xdc00) + 0x10000;
}
/**
Given a Unicode codepoint, return the JavaScript string that
respresents it (like
[`String.fromCodePoint`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint)).
*/ function $6b8f387faea0a4dd$export$73bfc63873071f74(code) {
    if (code <= 0xffff) return String.fromCharCode(code);
    code -= 0x10000;
    return String.fromCharCode((code >> 10) + 0xd800, (code & 1023) + 0xdc00);
}
/**
The amount of positions a character takes up in a JavaScript string.
*/ function $6b8f387faea0a4dd$export$a870abf234f6353c(code) {
    return code < 0x10000 ? 1 : 2;
}
const $6b8f387faea0a4dd$var$DefaultSplit = /\r\n?|\n/;
/**
Distinguishes different ways in which positions can be mapped.
*/ var $6b8f387faea0a4dd$export$39cf3280165f92aa = /*@__PURE__*/ function(MapMode) {
    /**
    Map a position to a valid new position, even when its context
    was deleted.
    */ MapMode[MapMode["Simple"] = 0] = "Simple";
    /**
    Return null if deletion happens across the position.
    */ MapMode[MapMode["TrackDel"] = 1] = "TrackDel";
    /**
    Return null if the character _before_ the position is deleted.
    */ MapMode[MapMode["TrackBefore"] = 2] = "TrackBefore";
    /**
    Return null if the character _after_ the position is deleted.
    */ MapMode[MapMode["TrackAfter"] = 3] = "TrackAfter";
    return MapMode;
}($6b8f387faea0a4dd$export$39cf3280165f92aa || ($6b8f387faea0a4dd$export$39cf3280165f92aa = {}));
/**
A change description is a variant of [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet)
that doesn't store the inserted text. As such, it can't be
applied, but is cheaper to store and manipulate.
*/ class $6b8f387faea0a4dd$export$34b6a936f2bb06a2 {
    // Sections are encoded as pairs of integers. The first is the
    // length in the current document, and the second is -1 for
    // unaffected sections, and the length of the replacement content
    // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
    // 0), and a replacement two positive numbers.
    /**
    @internal
    */ constructor(/**
    @internal
    */ sections){
        this.sections = sections;
    }
    /**
    The length of the document before the change.
    */ get length() {
        let result = 0;
        for(let i = 0; i < this.sections.length; i += 2)result += this.sections[i];
        return result;
    }
    /**
    The length of the document after the change.
    */ get newLength() {
        let result = 0;
        for(let i = 0; i < this.sections.length; i += 2){
            let ins = this.sections[i + 1];
            result += ins < 0 ? this.sections[i] : ins;
        }
        return result;
    }
    /**
    False when there are actual changes in this set.
    */ get empty() {
        return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
    }
    /**
    Iterate over the unchanged parts left by these changes. `posA`
    provides the position of the range in the old document, `posB`
    the new position in the changed document.
    */ iterGaps(f) {
        for(let i = 0, posA = 0, posB = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) {
                f(posA, posB, len);
                posB += len;
            } else posB += ins;
            posA += len;
        }
    }
    /**
    Iterate over the ranges changed by these changes. (See
    [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
    variant that also provides you with the inserted text.)
    `fromA`/`toA` provides the extent of the change in the starting
    document, `fromB`/`toB` the extent of the replacement in the
    changed document.
    
    When `individual` is true, adjacent changes (which are kept
    separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
    reported separately.
    */ iterChangedRanges(f, individual = false) {
        $6b8f387faea0a4dd$var$iterChanges(this, f, individual);
    }
    /**
    Get a description of the inverted form of these changes.
    */ get invertedDesc() {
        let sections = [];
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) sections.push(len, ins);
            else sections.push(ins, len);
        }
        return new $6b8f387faea0a4dd$export$34b6a936f2bb06a2(sections);
    }
    /**
    Compute the combined effect of applying another set of changes
    after this one. The length of the document after this set should
    match the length before `other`.
    */ composeDesc(other) {
        return this.empty ? other : other.empty ? this : $6b8f387faea0a4dd$var$composeSets(this, other);
    }
    /**
    Map this description, which should start with the same document
    as `other`, over another set of changes, so that it can be
    applied after it. When `before` is true, map as if the changes
    in `this` happened before the ones in `other`.
    */ mapDesc(other, before = false) {
        return other.empty ? this : $6b8f387faea0a4dd$var$mapSet(this, other, before);
    }
    mapPos(pos, assoc = -1, mode = $6b8f387faea0a4dd$export$39cf3280165f92aa.Simple) {
        let posA = 0, posB = 0;
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++], endA = posA + len;
            if (ins < 0) {
                if (endA > pos) return posB + (pos - posA);
                posB += len;
            } else {
                if (mode != $6b8f387faea0a4dd$export$39cf3280165f92aa.Simple && endA >= pos && (mode == $6b8f387faea0a4dd$export$39cf3280165f92aa.TrackDel && posA < pos && endA > pos || mode == $6b8f387faea0a4dd$export$39cf3280165f92aa.TrackBefore && posA < pos || mode == $6b8f387faea0a4dd$export$39cf3280165f92aa.TrackAfter && endA > pos)) return null;
                if (endA > pos || endA == pos && assoc < 0 && !len) return pos == posA || assoc < 0 ? posB : posB + ins;
                posB += ins;
            }
            posA = endA;
        }
        if (pos > posA) throw new RangeError(`Position ${pos} is out of range for changeset of length ${posA}`);
        return posB;
    }
    /**
    Check whether these changes touch a given range. When one of the
    changes entirely covers the range, the string `"cover"` is
    returned.
    */ touchesRange(from, to = from) {
        for(let i = 0, pos = 0; i < this.sections.length && pos <= to;){
            let len = this.sections[i++], ins = this.sections[i++], end = pos + len;
            if (ins >= 0 && pos <= to && end >= from) return pos < from && end > to ? "cover" : true;
            pos = end;
        }
        return false;
    }
    /**
    @internal
    */ toString() {
        let result = "";
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            result += (result ? " " : "") + len + (ins >= 0 ? ":" + ins : "");
        }
        return result;
    }
    /**
    Serialize this change desc to a JSON-representable value.
    */ toJSON() {
        return this.sections;
    }
    /**
    Create a change desc from its JSON representation (as produced
    by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json) || json.length % 2 || json.some((a)=>typeof a != "number")) throw new RangeError("Invalid JSON representation of ChangeDesc");
        return new $6b8f387faea0a4dd$export$34b6a936f2bb06a2(json);
    }
    /**
    @internal
    */ static create(sections) {
        return new $6b8f387faea0a4dd$export$34b6a936f2bb06a2(sections);
    }
}
/**
A change set represents a group of modifications to a document. It
stores the document length, and can only be applied to documents
with exactly that length.
*/ class $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c extends $6b8f387faea0a4dd$export$34b6a936f2bb06a2 {
    constructor(sections, /**
    @internal
    */ inserted){
        super(sections);
        this.inserted = inserted;
    }
    /**
    Apply the changes to a document, returning the modified
    document.
    */ apply(doc) {
        if (this.length != doc.length) throw new RangeError("Applying change set to a document with the wrong length");
        $6b8f387faea0a4dd$var$iterChanges(this, (fromA, toA, fromB, _toB, text)=>doc = doc.replace(fromB, fromB + (toA - fromA), text), false);
        return doc;
    }
    mapDesc(other, before = false) {
        return $6b8f387faea0a4dd$var$mapSet(this, other, before, true);
    }
    /**
    Given the document as it existed _before_ the changes, return a
    change set that represents the inverse of this set, which could
    be used to go from the document created by the changes back to
    the document as it existed before the changes.
    */ invert(doc) {
        let sections = this.sections.slice(), inserted = [];
        for(let i = 0, pos = 0; i < sections.length; i += 2){
            let len = sections[i], ins = sections[i + 1];
            if (ins >= 0) {
                sections[i] = ins;
                sections[i + 1] = len;
                let index = i >> 1;
                while(inserted.length < index)inserted.push($6b8f387faea0a4dd$export$5f1af8db9871e1d6.empty);
                inserted.push(len ? doc.slice(pos, pos + len) : $6b8f387faea0a4dd$export$5f1af8db9871e1d6.empty);
            }
            pos += len;
        }
        return new $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c(sections, inserted);
    }
    /**
    Combine two subsequent change sets into a single set. `other`
    must start in the document produced by `this`. If `this` goes
    `docA` → `docB` and `other` represents `docB` → `docC`, the
    returned value will represent the change `docA` → `docC`.
    */ compose(other) {
        return this.empty ? other : other.empty ? this : $6b8f387faea0a4dd$var$composeSets(this, other, true);
    }
    /**
    Given another change set starting in the same document, maps this
    change set over the other, producing a new change set that can be
    applied to the document produced by applying `other`. When
    `before` is `true`, order changes as if `this` comes before
    `other`, otherwise (the default) treat `other` as coming first.
    
    Given two changes `A` and `B`, `A.compose(B.map(A))` and
    `B.compose(A.map(B, true))` will produce the same document. This
    provides a basic form of [operational
    transformation](https://en.wikipedia.org/wiki/Operational_transformation),
    and can be used for collaborative editing.
    */ map(other, before = false) {
        return other.empty ? this : $6b8f387faea0a4dd$var$mapSet(this, other, before, true);
    }
    /**
    Iterate over the changed ranges in the document, calling `f` for
    each, with the range in the original document (`fromA`-`toA`)
    and the range that replaces it in the new document
    (`fromB`-`toB`).
    
    When `individual` is true, adjacent changes are reported
    separately.
    */ iterChanges(f, individual = false) {
        $6b8f387faea0a4dd$var$iterChanges(this, f, individual);
    }
    /**
    Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
    set.
    */ get desc() {
        return $6b8f387faea0a4dd$export$34b6a936f2bb06a2.create(this.sections);
    }
    /**
    @internal
    */ filter(ranges) {
        let resultSections = [], resultInserted = [], filteredSections = [];
        let iter = new $6b8f387faea0a4dd$var$SectionIter(this);
        done: for(let i = 0, pos = 0;;){
            let next = i == ranges.length ? 1e9 : ranges[i++];
            while(pos < next || pos == next && iter.len == 0){
                if (iter.done) break done;
                let len = Math.min(iter.len, next - pos);
                $6b8f387faea0a4dd$var$addSection(filteredSections, len, -1);
                let ins = iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0;
                $6b8f387faea0a4dd$var$addSection(resultSections, len, ins);
                if (ins > 0) $6b8f387faea0a4dd$var$addInsert(resultInserted, resultSections, iter.text);
                iter.forward(len);
                pos += len;
            }
            let end = ranges[i++];
            while(pos < end){
                if (iter.done) break done;
                let len = Math.min(iter.len, end - pos);
                $6b8f387faea0a4dd$var$addSection(resultSections, len, -1);
                $6b8f387faea0a4dd$var$addSection(filteredSections, len, iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0);
                iter.forward(len);
                pos += len;
            }
        }
        return {
            changes: new $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c(resultSections, resultInserted),
            filtered: $6b8f387faea0a4dd$export$34b6a936f2bb06a2.create(filteredSections)
        };
    }
    /**
    Serialize this change set to a JSON-representable value.
    */ toJSON() {
        let parts = [];
        for(let i = 0; i < this.sections.length; i += 2){
            let len = this.sections[i], ins = this.sections[i + 1];
            if (ins < 0) parts.push(len);
            else if (ins == 0) parts.push([
                len
            ]);
            else parts.push([
                len
            ].concat(this.inserted[i >> 1].toJSON()));
        }
        return parts;
    }
    /**
    Create a change set for the given changes, for a document of the
    given length, using `lineSep` as line separator.
    */ static of(changes, length, lineSep) {
        let sections = [], inserted = [], pos = 0;
        let total = null;
        function flush(force = false) {
            if (!force && !sections.length) return;
            if (pos < length) $6b8f387faea0a4dd$var$addSection(sections, length - pos, -1);
            let set = new $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c(sections, inserted);
            total = total ? total.compose(set.map(total)) : set;
            sections = [];
            inserted = [];
            pos = 0;
        }
        function process(spec) {
            if (Array.isArray(spec)) for (let sub of spec)process(sub);
            else if (spec instanceof $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c) {
                if (spec.length != length) throw new RangeError(`Mismatched change set length (got ${spec.length}, expected ${length})`);
                flush();
                total = total ? total.compose(spec.map(total)) : spec;
            } else {
                let { from: from, to: to = from, insert: insert } = spec;
                if (from > to || from < 0 || to > length) throw new RangeError(`Invalid change range ${from} to ${to} (in doc of length ${length})`);
                let insText = !insert ? $6b8f387faea0a4dd$export$5f1af8db9871e1d6.empty : typeof insert == "string" ? $6b8f387faea0a4dd$export$5f1af8db9871e1d6.of(insert.split(lineSep || $6b8f387faea0a4dd$var$DefaultSplit)) : insert;
                let insLen = insText.length;
                if (from == to && insLen == 0) return;
                if (from < pos) flush();
                if (from > pos) $6b8f387faea0a4dd$var$addSection(sections, from - pos, -1);
                $6b8f387faea0a4dd$var$addSection(sections, to - from, insLen);
                $6b8f387faea0a4dd$var$addInsert(inserted, sections, insText);
                pos = to;
            }
        }
        process(changes);
        flush(!total);
        return total;
    }
    /**
    Create an empty changeset of the given length.
    */ static empty(length) {
        return new $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c(length ? [
            length,
            -1
        ] : [], []);
    }
    /**
    Create a changeset from its JSON representation (as produced by
    [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json)) throw new RangeError("Invalid JSON representation of ChangeSet");
        let sections = [], inserted = [];
        for(let i = 0; i < json.length; i++){
            let part = json[i];
            if (typeof part == "number") sections.push(part, -1);
            else if (!Array.isArray(part) || typeof part[0] != "number" || part.some((e, i)=>i && typeof e != "string")) throw new RangeError("Invalid JSON representation of ChangeSet");
            else if (part.length == 1) sections.push(part[0], 0);
            else {
                while(inserted.length < i)inserted.push($6b8f387faea0a4dd$export$5f1af8db9871e1d6.empty);
                inserted[i] = $6b8f387faea0a4dd$export$5f1af8db9871e1d6.of(part.slice(1));
                sections.push(part[0], inserted[i].length);
            }
        }
        return new $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c(sections, inserted);
    }
    /**
    @internal
    */ static createSet(sections, inserted) {
        return new $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c(sections, inserted);
    }
}
function $6b8f387faea0a4dd$var$addSection(sections, len, ins, forceJoin = false) {
    if (len == 0 && ins <= 0) return;
    let last = sections.length - 2;
    if (last >= 0 && ins <= 0 && ins == sections[last + 1]) sections[last] += len;
    else if (last >= 0 && len == 0 && sections[last] == 0) sections[last + 1] += ins;
    else if (forceJoin) {
        sections[last] += len;
        sections[last + 1] += ins;
    } else sections.push(len, ins);
}
function $6b8f387faea0a4dd$var$addInsert(values, sections, value) {
    if (value.length == 0) return;
    let index = sections.length - 2 >> 1;
    if (index < values.length) values[values.length - 1] = values[values.length - 1].append(value);
    else {
        while(values.length < index)values.push($6b8f387faea0a4dd$export$5f1af8db9871e1d6.empty);
        values.push(value);
    }
}
function $6b8f387faea0a4dd$var$iterChanges(desc, f, individual) {
    let inserted = desc.inserted;
    for(let posA = 0, posB = 0, i = 0; i < desc.sections.length;){
        let len = desc.sections[i++], ins = desc.sections[i++];
        if (ins < 0) {
            posA += len;
            posB += len;
        } else {
            let endA = posA, endB = posB, text = $6b8f387faea0a4dd$export$5f1af8db9871e1d6.empty;
            for(;;){
                endA += len;
                endB += ins;
                if (ins && inserted) text = text.append(inserted[i - 2 >> 1]);
                if (individual || i == desc.sections.length || desc.sections[i + 1] < 0) break;
                len = desc.sections[i++];
                ins = desc.sections[i++];
            }
            f(posA, endA, posB, endB, text);
            posA = endA;
            posB = endB;
        }
    }
}
function $6b8f387faea0a4dd$var$mapSet(setA, setB, before, mkSet = false) {
    // Produce a copy of setA that applies to the document after setB
    // has been applied (assuming both start at the same document).
    let sections = [], insert = mkSet ? [] : null;
    let a = new $6b8f387faea0a4dd$var$SectionIter(setA), b = new $6b8f387faea0a4dd$var$SectionIter(setB);
    // Iterate over both sets in parallel. inserted tracks, for changes
    // in A that have to be processed piece-by-piece, whether their
    // content has been inserted already, and refers to the section
    // index.
    for(let inserted = -1;;){
        if (a.done && b.len || b.done && a.len) throw new Error("Mismatched change set lengths");
        else if (a.ins == -1 && b.ins == -1) {
            // Move across ranges skipped by both sets.
            let len = Math.min(a.len, b.len);
            $6b8f387faea0a4dd$var$addSection(sections, len, -1);
            a.forward(len);
            b.forward(len);
        } else if (b.ins >= 0 && (a.ins < 0 || inserted == a.i || a.off == 0 && (b.len < a.len || b.len == a.len && !before))) {
            // If there's a change in B that comes before the next change in
            // A (ordered by start pos, then len, then before flag), skip
            // that (and process any changes in A it covers).
            let len = b.len;
            $6b8f387faea0a4dd$var$addSection(sections, b.ins, -1);
            while(len){
                let piece = Math.min(a.len, len);
                if (a.ins >= 0 && inserted < a.i && a.len <= piece) {
                    $6b8f387faea0a4dd$var$addSection(sections, 0, a.ins);
                    if (insert) $6b8f387faea0a4dd$var$addInsert(insert, sections, a.text);
                    inserted = a.i;
                }
                a.forward(piece);
                len -= piece;
            }
            b.next();
        } else if (a.ins >= 0) {
            // Process the part of a change in A up to the start of the next
            // non-deletion change in B (if overlapping).
            let len = 0, left = a.len;
            while(left){
                if (b.ins == -1) {
                    let piece = Math.min(left, b.len);
                    len += piece;
                    left -= piece;
                    b.forward(piece);
                } else if (b.ins == 0 && b.len < left) {
                    left -= b.len;
                    b.next();
                } else break;
            }
            $6b8f387faea0a4dd$var$addSection(sections, len, inserted < a.i ? a.ins : 0);
            if (insert && inserted < a.i) $6b8f387faea0a4dd$var$addInsert(insert, sections, a.text);
            inserted = a.i;
            a.forward(a.len - left);
        } else if (a.done && b.done) return insert ? $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c.createSet(sections, insert) : $6b8f387faea0a4dd$export$34b6a936f2bb06a2.create(sections);
        else throw new Error("Mismatched change set lengths");
    }
}
function $6b8f387faea0a4dd$var$composeSets(setA, setB, mkSet = false) {
    let sections = [];
    let insert = mkSet ? [] : null;
    let a = new $6b8f387faea0a4dd$var$SectionIter(setA), b = new $6b8f387faea0a4dd$var$SectionIter(setB);
    for(let open = false;;){
        if (a.done && b.done) return insert ? $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c.createSet(sections, insert) : $6b8f387faea0a4dd$export$34b6a936f2bb06a2.create(sections);
        else if (a.ins == 0) {
            $6b8f387faea0a4dd$var$addSection(sections, a.len, 0, open);
            a.next();
        } else if (b.len == 0 && !b.done) {
            $6b8f387faea0a4dd$var$addSection(sections, 0, b.ins, open);
            if (insert) $6b8f387faea0a4dd$var$addInsert(insert, sections, b.text);
            b.next();
        } else if (a.done || b.done) throw new Error("Mismatched change set lengths");
        else {
            let len = Math.min(a.len2, b.len), sectionLen = sections.length;
            if (a.ins == -1) {
                let insB = b.ins == -1 ? -1 : b.off ? 0 : b.ins;
                $6b8f387faea0a4dd$var$addSection(sections, len, insB, open);
                if (insert && insB) $6b8f387faea0a4dd$var$addInsert(insert, sections, b.text);
            } else if (b.ins == -1) {
                $6b8f387faea0a4dd$var$addSection(sections, a.off ? 0 : a.len, len, open);
                if (insert) $6b8f387faea0a4dd$var$addInsert(insert, sections, a.textBit(len));
            } else {
                $6b8f387faea0a4dd$var$addSection(sections, a.off ? 0 : a.len, b.off ? 0 : b.ins, open);
                if (insert && !b.off) $6b8f387faea0a4dd$var$addInsert(insert, sections, b.text);
            }
            open = (a.ins > len || b.ins >= 0 && b.len > len) && (open || sections.length > sectionLen);
            a.forward2(len);
            b.forward(len);
        }
    }
}
class $6b8f387faea0a4dd$var$SectionIter {
    constructor(set){
        this.set = set;
        this.i = 0;
        this.next();
    }
    next() {
        let { sections: sections } = this.set;
        if (this.i < sections.length) {
            this.len = sections[this.i++];
            this.ins = sections[this.i++];
        } else {
            this.len = 0;
            this.ins = -2;
        }
        this.off = 0;
    }
    get done() {
        return this.ins == -2;
    }
    get len2() {
        return this.ins < 0 ? this.len : this.ins;
    }
    get text() {
        let { inserted: inserted } = this.set, index = this.i - 2 >> 1;
        return index >= inserted.length ? $6b8f387faea0a4dd$export$5f1af8db9871e1d6.empty : inserted[index];
    }
    textBit(len) {
        let { inserted: inserted } = this.set, index = this.i - 2 >> 1;
        return index >= inserted.length && !len ? $6b8f387faea0a4dd$export$5f1af8db9871e1d6.empty : inserted[index].slice(this.off, len == null ? undefined : this.off + len);
    }
    forward(len) {
        if (len == this.len) this.next();
        else {
            this.len -= len;
            this.off += len;
        }
    }
    forward2(len) {
        if (this.ins == -1) this.forward(len);
        else if (len == this.ins) this.next();
        else {
            this.ins -= len;
            this.off += len;
        }
    }
}
/**
A single selection range. When
[`allowMultipleSelections`](https://codemirror.net/6/docs/ref/#state.EditorState^allowMultipleSelections)
is enabled, a [selection](https://codemirror.net/6/docs/ref/#state.EditorSelection) may hold
multiple ranges. By default, selections hold exactly one range.
*/ class $6b8f387faea0a4dd$export$7bd1839c3c5d5bd4 {
    constructor(/**
    The lower boundary of the range.
    */ from, /**
    The upper boundary of the range.
    */ to, flags){
        this.from = from;
        this.to = to;
        this.flags = flags;
    }
    /**
    The anchor of the range—the side that doesn't move when you
    extend it.
    */ get anchor() {
        return this.flags & 32 /* RangeFlag.Inverted */  ? this.to : this.from;
    }
    /**
    The head of the range, which is moved when the range is
    [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
    */ get head() {
        return this.flags & 32 /* RangeFlag.Inverted */  ? this.from : this.to;
    }
    /**
    True when `anchor` and `head` are at the same position.
    */ get empty() {
        return this.from == this.to;
    }
    /**
    If this is a cursor that is explicitly associated with the
    character on one of its sides, this returns the side. -1 means
    the character before its position, 1 the character after, and 0
    means no association.
    */ get assoc() {
        return this.flags & 8 /* RangeFlag.AssocBefore */  ? -1 : this.flags & 16 /* RangeFlag.AssocAfter */  ? 1 : 0;
    }
    /**
    The bidirectional text level associated with this cursor, if
    any.
    */ get bidiLevel() {
        let level = this.flags & 7 /* RangeFlag.BidiLevelMask */ ;
        return level == 7 ? null : level;
    }
    /**
    The goal column (stored vertical offset) associated with a
    cursor. This is used to preserve the vertical position when
    [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
    lines of different length.
    */ get goalColumn() {
        let value = this.flags >> 6 /* RangeFlag.GoalColumnOffset */ ;
        return value == 16777215 /* RangeFlag.NoGoalColumn */  ? undefined : value;
    }
    /**
    Map this range through a change, producing a valid range in the
    updated document.
    */ map(change, assoc = -1) {
        let from, to;
        if (this.empty) from = to = change.mapPos(this.from, assoc);
        else {
            from = change.mapPos(this.from, 1);
            to = change.mapPos(this.to, -1);
        }
        return from == this.from && to == this.to ? this : new $6b8f387faea0a4dd$export$7bd1839c3c5d5bd4(from, to, this.flags);
    }
    /**
    Extend this range to cover at least `from` to `to`.
    */ extend(from, to = from) {
        if (from <= this.anchor && to >= this.anchor) return $6b8f387faea0a4dd$export$3bb1bd44aee62999.range(from, to);
        let head = Math.abs(from - this.anchor) > Math.abs(to - this.anchor) ? from : to;
        return $6b8f387faea0a4dd$export$3bb1bd44aee62999.range(this.anchor, head);
    }
    /**
    Compare this range to another range.
    */ eq(other, includeAssoc = false) {
        return this.anchor == other.anchor && this.head == other.head && (!includeAssoc || !this.empty || this.assoc == other.assoc);
    }
    /**
    Return a JSON-serializable object representing the range.
    */ toJSON() {
        return {
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    Convert a JSON representation of a range to a `SelectionRange`
    instance.
    */ static fromJSON(json) {
        if (!json || typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid JSON representation for SelectionRange");
        return $6b8f387faea0a4dd$export$3bb1bd44aee62999.range(json.anchor, json.head);
    }
    /**
    @internal
    */ static create(from, to, flags) {
        return new $6b8f387faea0a4dd$export$7bd1839c3c5d5bd4(from, to, flags);
    }
}
/**
An editor selection holds one or more selection ranges.
*/ class $6b8f387faea0a4dd$export$3bb1bd44aee62999 {
    constructor(/**
    The ranges in the selection, sorted by position. Ranges cannot
    overlap (but they may touch, if they aren't empty).
    */ ranges, /**
    The index of the _main_ range in the selection (which is
    usually the range that was added last).
    */ mainIndex){
        this.ranges = ranges;
        this.mainIndex = mainIndex;
    }
    /**
    Map a selection through a change. Used to adjust the selection
    position for changes.
    */ map(change, assoc = -1) {
        if (change.empty) return this;
        return $6b8f387faea0a4dd$export$3bb1bd44aee62999.create(this.ranges.map((r)=>r.map(change, assoc)), this.mainIndex);
    }
    /**
    Compare this selection to another selection. By default, ranges
    are compared only by position. When `includeAssoc` is true,
    cursor ranges must also have the same
    [`assoc`](https://codemirror.net/6/docs/ref/#state.SelectionRange.assoc) value.
    */ eq(other, includeAssoc = false) {
        if (this.ranges.length != other.ranges.length || this.mainIndex != other.mainIndex) return false;
        for(let i = 0; i < this.ranges.length; i++)if (!this.ranges[i].eq(other.ranges[i], includeAssoc)) return false;
        return true;
    }
    /**
    Get the primary selection range. Usually, you should make sure
    your code applies to _all_ ranges, by using methods like
    [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
    */ get main() {
        return this.ranges[this.mainIndex];
    }
    /**
    Make sure the selection only has one range. Returns a selection
    holding only the main range from this selection.
    */ asSingle() {
        return this.ranges.length == 1 ? this : new $6b8f387faea0a4dd$export$3bb1bd44aee62999([
            this.main
        ], 0);
    }
    /**
    Extend this selection with an extra range.
    */ addRange(range, main = true) {
        return $6b8f387faea0a4dd$export$3bb1bd44aee62999.create([
            range
        ].concat(this.ranges), main ? 0 : this.mainIndex + 1);
    }
    /**
    Replace a given range with another range, and then normalize the
    selection to merge and sort ranges if necessary.
    */ replaceRange(range, which = this.mainIndex) {
        let ranges = this.ranges.slice();
        ranges[which] = range;
        return $6b8f387faea0a4dd$export$3bb1bd44aee62999.create(ranges, this.mainIndex);
    }
    /**
    Convert this selection to an object that can be serialized to
    JSON.
    */ toJSON() {
        return {
            ranges: this.ranges.map((r)=>r.toJSON()),
            main: this.mainIndex
        };
    }
    /**
    Create a selection from a JSON representation.
    */ static fromJSON(json) {
        if (!json || !Array.isArray(json.ranges) || typeof json.main != "number" || json.main >= json.ranges.length) throw new RangeError("Invalid JSON representation for EditorSelection");
        return new $6b8f387faea0a4dd$export$3bb1bd44aee62999(json.ranges.map((r)=>$6b8f387faea0a4dd$export$7bd1839c3c5d5bd4.fromJSON(r)), json.main);
    }
    /**
    Create a selection holding a single range.
    */ static single(anchor, head = anchor) {
        return new $6b8f387faea0a4dd$export$3bb1bd44aee62999([
            $6b8f387faea0a4dd$export$3bb1bd44aee62999.range(anchor, head)
        ], 0);
    }
    /**
    Sort and merge the given set of ranges, creating a valid
    selection.
    */ static create(ranges, mainIndex = 0) {
        if (ranges.length == 0) throw new RangeError("A selection needs at least one range");
        for(let pos = 0, i = 0; i < ranges.length; i++){
            let range = ranges[i];
            if (range.empty ? range.from <= pos : range.from < pos) return $6b8f387faea0a4dd$export$3bb1bd44aee62999.normalized(ranges.slice(), mainIndex);
            pos = range.to;
        }
        return new $6b8f387faea0a4dd$export$3bb1bd44aee62999(ranges, mainIndex);
    }
    /**
    Create a cursor selection range at the given position. You can
    safely ignore the optional arguments in most situations.
    */ static cursor(pos, assoc = 0, bidiLevel, goalColumn) {
        return $6b8f387faea0a4dd$export$7bd1839c3c5d5bd4.create(pos, pos, (assoc == 0 ? 0 : assoc < 0 ? 8 /* RangeFlag.AssocBefore */  : 16 /* RangeFlag.AssocAfter */ ) | (bidiLevel == null ? 7 : Math.min(6, bidiLevel)) | (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 16777215 /* RangeFlag.NoGoalColumn */ ) << 6 /* RangeFlag.GoalColumnOffset */ );
    }
    /**
    Create a selection range.
    */ static range(anchor, head, goalColumn, bidiLevel) {
        let flags = (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 16777215 /* RangeFlag.NoGoalColumn */ ) << 6 /* RangeFlag.GoalColumnOffset */  | (bidiLevel == null ? 7 : Math.min(6, bidiLevel));
        return head < anchor ? $6b8f387faea0a4dd$export$7bd1839c3c5d5bd4.create(head, anchor, 48 /* RangeFlag.AssocAfter */  | flags) : $6b8f387faea0a4dd$export$7bd1839c3c5d5bd4.create(anchor, head, (head > anchor ? 8 /* RangeFlag.AssocBefore */  : 0) | flags);
    }
    /**
    @internal
    */ static normalized(ranges, mainIndex = 0) {
        let main = ranges[mainIndex];
        ranges.sort((a, b)=>a.from - b.from);
        mainIndex = ranges.indexOf(main);
        for(let i = 1; i < ranges.length; i++){
            let range = ranges[i], prev = ranges[i - 1];
            if (range.empty ? range.from <= prev.to : range.from < prev.to) {
                let from = prev.from, to = Math.max(range.to, prev.to);
                if (i <= mainIndex) mainIndex--;
                ranges.splice(--i, 2, range.anchor > range.head ? $6b8f387faea0a4dd$export$3bb1bd44aee62999.range(to, from) : $6b8f387faea0a4dd$export$3bb1bd44aee62999.range(from, to));
            }
        }
        return new $6b8f387faea0a4dd$export$3bb1bd44aee62999(ranges, mainIndex);
    }
}
function $6b8f387faea0a4dd$var$checkSelection(selection, docLength) {
    for (let range of selection.ranges)if (range.to > docLength) throw new RangeError("Selection points outside of document");
}
let $6b8f387faea0a4dd$var$nextID = 0;
/**
A facet is a labeled value that is associated with an editor
state. It takes inputs from any number of extensions, and combines
those into a single output value.

Examples of uses of facets are the [tab
size](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize), [editor
attributes](https://codemirror.net/6/docs/ref/#view.EditorView^editorAttributes), and [update
listeners](https://codemirror.net/6/docs/ref/#view.EditorView^updateListener).

Note that `Facet` instances can be used anywhere where
[`FacetReader`](https://codemirror.net/6/docs/ref/#state.FacetReader) is expected.
*/ class $6b8f387faea0a4dd$export$ef7d5e9b79fa1504 {
    constructor(/**
    @internal
    */ combine, /**
    @internal
    */ compareInput, /**
    @internal
    */ compare, isStatic, enables){
        this.combine = combine;
        this.compareInput = compareInput;
        this.compare = compare;
        this.isStatic = isStatic;
        /**
        @internal
        */ this.id = $6b8f387faea0a4dd$var$nextID++;
        this.default = combine([]);
        this.extensions = typeof enables == "function" ? enables(this) : enables;
    }
    /**
    Returns a facet reader for this facet, which can be used to
    [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
    */ get reader() {
        return this;
    }
    /**
    Define a new facet.
    */ static define(config = {}) {
        return new $6b8f387faea0a4dd$export$ef7d5e9b79fa1504(config.combine || ((a)=>a), config.compareInput || ((a, b)=>a === b), config.compare || (!config.combine ? $6b8f387faea0a4dd$var$sameArray : (a, b)=>a === b), !!config.static, config.enables);
    }
    /**
    Returns an extension that adds the given value to this facet.
    */ of(value) {
        return new $6b8f387faea0a4dd$var$FacetProvider([], this, 0 /* Provider.Static */ , value);
    }
    /**
    Create an extension that computes a value for the facet from a
    state. You must take care to declare the parts of the state that
    this value depends on, since your function is only called again
    for a new state when one of those parts changed.
    
    In cases where your value depends only on a single field, you'll
    want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
    */ compute(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new $6b8f387faea0a4dd$var$FacetProvider(deps, this, 1 /* Provider.Single */ , get);
    }
    /**
    Create an extension that computes zero or more values for this
    facet from a state.
    */ computeN(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new $6b8f387faea0a4dd$var$FacetProvider(deps, this, 2 /* Provider.Multi */ , get);
    }
    from(field, get) {
        if (!get) get = (x)=>x;
        return this.compute([
            field
        ], (state)=>get(state.field(field)));
    }
}
function $6b8f387faea0a4dd$var$sameArray(a, b) {
    return a == b || a.length == b.length && a.every((e, i)=>e === b[i]);
}
class $6b8f387faea0a4dd$var$FacetProvider {
    constructor(dependencies, facet, type, value){
        this.dependencies = dependencies;
        this.facet = facet;
        this.type = type;
        this.value = value;
        this.id = $6b8f387faea0a4dd$var$nextID++;
    }
    dynamicSlot(addresses) {
        var _a;
        let getter = this.value;
        let compare = this.facet.compareInput;
        let id = this.id, idx = addresses[id] >> 1, multi = this.type == 2 /* Provider.Multi */ ;
        let depDoc = false, depSel = false, depAddrs = [];
        for (let dep of this.dependencies){
            if (dep == "doc") depDoc = true;
            else if (dep == "selection") depSel = true;
            else if ((((_a = addresses[dep.id]) !== null && _a !== void 0 ? _a : 1) & 1) == 0) depAddrs.push(addresses[dep.id]);
        }
        return {
            create (state) {
                state.values[idx] = getter(state);
                return 1 /* SlotStatus.Changed */ ;
            },
            update (state, tr) {
                if (depDoc && tr.docChanged || depSel && (tr.docChanged || tr.selection) || $6b8f387faea0a4dd$var$ensureAll(state, depAddrs)) {
                    let newVal = getter(state);
                    if (multi ? !$6b8f387faea0a4dd$var$compareArray(newVal, state.values[idx], compare) : !compare(newVal, state.values[idx])) {
                        state.values[idx] = newVal;
                        return 1 /* SlotStatus.Changed */ ;
                    }
                }
                return 0;
            },
            reconfigure: (state, oldState)=>{
                let newVal, oldAddr = oldState.config.address[id];
                if (oldAddr != null) {
                    let oldVal = $6b8f387faea0a4dd$var$getAddr(oldState, oldAddr);
                    if (this.dependencies.every((dep)=>{
                        return dep instanceof $6b8f387faea0a4dd$export$ef7d5e9b79fa1504 ? oldState.facet(dep) === state.facet(dep) : dep instanceof $6b8f387faea0a4dd$export$34381b1ce2130245 ? oldState.field(dep, false) == state.field(dep, false) : true;
                    }) || (multi ? $6b8f387faea0a4dd$var$compareArray(newVal = getter(state), oldVal, compare) : compare(newVal = getter(state), oldVal))) {
                        state.values[idx] = oldVal;
                        return 0;
                    }
                } else newVal = getter(state);
                state.values[idx] = newVal;
                return 1 /* SlotStatus.Changed */ ;
            }
        };
    }
}
function $6b8f387faea0a4dd$var$compareArray(a, b, compare) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!compare(a[i], b[i])) return false;
    return true;
}
function $6b8f387faea0a4dd$var$ensureAll(state, addrs) {
    let changed = false;
    for (let addr of addrs)if ($6b8f387faea0a4dd$var$ensureAddr(state, addr) & 1 /* SlotStatus.Changed */ ) changed = true;
    return changed;
}
function $6b8f387faea0a4dd$var$dynamicFacetSlot(addresses, facet, providers) {
    let providerAddrs = providers.map((p)=>addresses[p.id]);
    let providerTypes = providers.map((p)=>p.type);
    let dynamic = providerAddrs.filter((p)=>!(p & 1));
    let idx = addresses[facet.id] >> 1;
    function get(state) {
        let values = [];
        for(let i = 0; i < providerAddrs.length; i++){
            let value = $6b8f387faea0a4dd$var$getAddr(state, providerAddrs[i]);
            if (providerTypes[i] == 2 /* Provider.Multi */ ) for (let val of value)values.push(val);
            else values.push(value);
        }
        return facet.combine(values);
    }
    return {
        create (state) {
            for (let addr of providerAddrs)$6b8f387faea0a4dd$var$ensureAddr(state, addr);
            state.values[idx] = get(state);
            return 1 /* SlotStatus.Changed */ ;
        },
        update (state, tr) {
            if (!$6b8f387faea0a4dd$var$ensureAll(state, dynamic)) return 0;
            let value = get(state);
            if (facet.compare(value, state.values[idx])) return 0;
            state.values[idx] = value;
            return 1 /* SlotStatus.Changed */ ;
        },
        reconfigure (state, oldState) {
            let depChanged = $6b8f387faea0a4dd$var$ensureAll(state, providerAddrs);
            let oldProviders = oldState.config.facets[facet.id], oldValue = oldState.facet(facet);
            if (oldProviders && !depChanged && $6b8f387faea0a4dd$var$sameArray(providers, oldProviders)) {
                state.values[idx] = oldValue;
                return 0;
            }
            let value = get(state);
            if (facet.compare(value, oldValue)) {
                state.values[idx] = oldValue;
                return 0;
            }
            state.values[idx] = value;
            return 1 /* SlotStatus.Changed */ ;
        }
    };
}
const $6b8f387faea0a4dd$var$initField = /*@__PURE__*/ $6b8f387faea0a4dd$export$ef7d5e9b79fa1504.define({
    static: true
});
/**
Fields can store additional information in an editor state, and
keep it in sync with the rest of the state.
*/ class $6b8f387faea0a4dd$export$34381b1ce2130245 {
    constructor(/**
    @internal
    */ id, createF, updateF, compareF, /**
    @internal
    */ spec){
        this.id = id;
        this.createF = createF;
        this.updateF = updateF;
        this.compareF = compareF;
        this.spec = spec;
        /**
        @internal
        */ this.provides = undefined;
    }
    /**
    Define a state field.
    */ static define(config) {
        let field = new $6b8f387faea0a4dd$export$34381b1ce2130245($6b8f387faea0a4dd$var$nextID++, config.create, config.update, config.compare || ((a, b)=>a === b), config);
        if (config.provide) field.provides = config.provide(field);
        return field;
    }
    create(state) {
        let init = state.facet($6b8f387faea0a4dd$var$initField).find((i)=>i.field == this);
        return ((init === null || init === void 0 ? void 0 : init.create) || this.createF)(state);
    }
    /**
    @internal
    */ slot(addresses) {
        let idx = addresses[this.id] >> 1;
        return {
            create: (state)=>{
                state.values[idx] = this.create(state);
                return 1 /* SlotStatus.Changed */ ;
            },
            update: (state, tr)=>{
                let oldVal = state.values[idx];
                let value = this.updateF(oldVal, tr);
                if (this.compareF(oldVal, value)) return 0;
                state.values[idx] = value;
                return 1 /* SlotStatus.Changed */ ;
            },
            reconfigure: (state, oldState)=>{
                let init = state.facet($6b8f387faea0a4dd$var$initField), oldInit = oldState.facet($6b8f387faea0a4dd$var$initField), reInit;
                if ((reInit = init.find((i)=>i.field == this)) && reInit != oldInit.find((i)=>i.field == this)) {
                    state.values[idx] = reInit.create(state);
                    return 1 /* SlotStatus.Changed */ ;
                }
                if (oldState.config.address[this.id] != null) {
                    state.values[idx] = oldState.field(this);
                    return 0;
                }
                state.values[idx] = this.create(state);
                return 1 /* SlotStatus.Changed */ ;
            }
        };
    }
    /**
    Returns an extension that enables this field and overrides the
    way it is initialized. Can be useful when you need to provide a
    non-default starting value for the field.
    */ init(create) {
        return [
            this,
            $6b8f387faea0a4dd$var$initField.of({
                field: this,
                create: create
            })
        ];
    }
    /**
    State field instances can be used as
    [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
    given state.
    */ get extension() {
        return this;
    }
}
const $6b8f387faea0a4dd$var$Prec_ = {
    lowest: 4,
    low: 3,
    default: 2,
    high: 1,
    highest: 0
};
function $6b8f387faea0a4dd$var$prec(value) {
    return (ext)=>new $6b8f387faea0a4dd$var$PrecExtension(ext, value);
}
/**
By default extensions are registered in the order they are found
in the flattened form of nested array that was provided.
Individual extension values can be assigned a precedence to
override this. Extensions that do not have a precedence set get
the precedence of the nearest parent with a precedence, or
[`default`](https://codemirror.net/6/docs/ref/#state.Prec.default) if there is no such parent. The
final ordering of extensions is determined by first sorting by
precedence and then by order within each precedence.
*/ const $6b8f387faea0a4dd$export$b92464a736444411 = {
    /**
    The highest precedence level, for extensions that should end up
    near the start of the precedence ordering.
    */ highest: /*@__PURE__*/ $6b8f387faea0a4dd$var$prec($6b8f387faea0a4dd$var$Prec_.highest),
    /**
    A higher-than-default precedence, for extensions that should
    come before those with default precedence.
    */ high: /*@__PURE__*/ $6b8f387faea0a4dd$var$prec($6b8f387faea0a4dd$var$Prec_.high),
    /**
    The default precedence, which is also used for extensions
    without an explicit precedence.
    */ default: /*@__PURE__*/ $6b8f387faea0a4dd$var$prec($6b8f387faea0a4dd$var$Prec_.default),
    /**
    A lower-than-default precedence.
    */ low: /*@__PURE__*/ $6b8f387faea0a4dd$var$prec($6b8f387faea0a4dd$var$Prec_.low),
    /**
    The lowest precedence level. Meant for things that should end up
    near the end of the extension order.
    */ lowest: /*@__PURE__*/ $6b8f387faea0a4dd$var$prec($6b8f387faea0a4dd$var$Prec_.lowest)
};
class $6b8f387faea0a4dd$var$PrecExtension {
    constructor(inner, prec){
        this.inner = inner;
        this.prec = prec;
    }
}
/**
Extension compartments can be used to make a configuration
dynamic. By [wrapping](https://codemirror.net/6/docs/ref/#state.Compartment.of) part of your
configuration in a compartment, you can later
[replace](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure) that part through a
transaction.
*/ class $6b8f387faea0a4dd$export$d51c0172eb2c2431 {
    /**
    Create an instance of this compartment to add to your [state
    configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
    */ of(ext) {
        return new $6b8f387faea0a4dd$var$CompartmentInstance(this, ext);
    }
    /**
    Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
    reconfigures this compartment.
    */ reconfigure(content) {
        return $6b8f387faea0a4dd$export$d51c0172eb2c2431.reconfigure.of({
            compartment: this,
            extension: content
        });
    }
    /**
    Get the current content of the compartment in the state, or
    `undefined` if it isn't present.
    */ get(state) {
        return state.config.compartments.get(this);
    }
}
class $6b8f387faea0a4dd$var$CompartmentInstance {
    constructor(compartment, inner){
        this.compartment = compartment;
        this.inner = inner;
    }
}
class $6b8f387faea0a4dd$var$Configuration {
    constructor(base, compartments, dynamicSlots, address, staticValues, facets){
        this.base = base;
        this.compartments = compartments;
        this.dynamicSlots = dynamicSlots;
        this.address = address;
        this.staticValues = staticValues;
        this.facets = facets;
        this.statusTemplate = [];
        while(this.statusTemplate.length < dynamicSlots.length)this.statusTemplate.push(0 /* SlotStatus.Unresolved */ );
    }
    staticFacet(facet) {
        let addr = this.address[facet.id];
        return addr == null ? facet.default : this.staticValues[addr >> 1];
    }
    static resolve(base, compartments, oldState) {
        let fields = [];
        let facets = Object.create(null);
        let newCompartments = new Map();
        for (let ext of $6b8f387faea0a4dd$var$flatten(base, compartments, newCompartments))if (ext instanceof $6b8f387faea0a4dd$export$34381b1ce2130245) fields.push(ext);
        else (facets[ext.facet.id] || (facets[ext.facet.id] = [])).push(ext);
        let address = Object.create(null);
        let staticValues = [];
        let dynamicSlots = [];
        for (let field of fields){
            address[field.id] = dynamicSlots.length << 1;
            dynamicSlots.push((a)=>field.slot(a));
        }
        let oldFacets = oldState === null || oldState === void 0 ? void 0 : oldState.config.facets;
        for(let id in facets){
            let providers = facets[id], facet = providers[0].facet;
            let oldProviders = oldFacets && oldFacets[id] || [];
            if (providers.every((p)=>p.type == 0 /* Provider.Static */ )) {
                address[facet.id] = staticValues.length << 1 | 1;
                if ($6b8f387faea0a4dd$var$sameArray(oldProviders, providers)) staticValues.push(oldState.facet(facet));
                else {
                    let value = facet.combine(providers.map((p)=>p.value));
                    staticValues.push(oldState && facet.compare(value, oldState.facet(facet)) ? oldState.facet(facet) : value);
                }
            } else {
                for (let p of providers)if (p.type == 0 /* Provider.Static */ ) {
                    address[p.id] = staticValues.length << 1 | 1;
                    staticValues.push(p.value);
                } else {
                    address[p.id] = dynamicSlots.length << 1;
                    dynamicSlots.push((a)=>p.dynamicSlot(a));
                }
                address[facet.id] = dynamicSlots.length << 1;
                dynamicSlots.push((a)=>$6b8f387faea0a4dd$var$dynamicFacetSlot(a, facet, providers));
            }
        }
        let dynamic = dynamicSlots.map((f)=>f(address));
        return new $6b8f387faea0a4dd$var$Configuration(base, newCompartments, dynamic, address, staticValues, facets);
    }
}
function $6b8f387faea0a4dd$var$flatten(extension, compartments, newCompartments) {
    let result = [
        [],
        [],
        [],
        [],
        []
    ];
    let seen = new Map();
    function inner(ext, prec) {
        let known = seen.get(ext);
        if (known != null) {
            if (known <= prec) return;
            let found = result[known].indexOf(ext);
            if (found > -1) result[known].splice(found, 1);
            if (ext instanceof $6b8f387faea0a4dd$var$CompartmentInstance) newCompartments.delete(ext.compartment);
        }
        seen.set(ext, prec);
        if (Array.isArray(ext)) for (let e of ext)inner(e, prec);
        else if (ext instanceof $6b8f387faea0a4dd$var$CompartmentInstance) {
            if (newCompartments.has(ext.compartment)) throw new RangeError(`Duplicate use of compartment in extensions`);
            let content = compartments.get(ext.compartment) || ext.inner;
            newCompartments.set(ext.compartment, content);
            inner(content, prec);
        } else if (ext instanceof $6b8f387faea0a4dd$var$PrecExtension) inner(ext.inner, ext.prec);
        else if (ext instanceof $6b8f387faea0a4dd$export$34381b1ce2130245) {
            result[prec].push(ext);
            if (ext.provides) inner(ext.provides, prec);
        } else if (ext instanceof $6b8f387faea0a4dd$var$FacetProvider) {
            result[prec].push(ext);
            if (ext.facet.extensions) inner(ext.facet.extensions, $6b8f387faea0a4dd$var$Prec_.default);
        } else {
            let content = ext.extension;
            if (!content) throw new Error(`Unrecognized extension value in extension set (${ext}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
            inner(content, prec);
        }
    }
    inner(extension, $6b8f387faea0a4dd$var$Prec_.default);
    return result.reduce((a, b)=>a.concat(b));
}
function $6b8f387faea0a4dd$var$ensureAddr(state, addr) {
    if (addr & 1) return 2 /* SlotStatus.Computed */ ;
    let idx = addr >> 1;
    let status = state.status[idx];
    if (status == 4 /* SlotStatus.Computing */ ) throw new Error("Cyclic dependency between fields and/or facets");
    if (status & 2 /* SlotStatus.Computed */ ) return status;
    state.status[idx] = 4 /* SlotStatus.Computing */ ;
    let changed = state.computeSlot(state, state.config.dynamicSlots[idx]);
    return state.status[idx] = 2 /* SlotStatus.Computed */  | changed;
}
function $6b8f387faea0a4dd$var$getAddr(state, addr) {
    return addr & 1 ? state.config.staticValues[addr >> 1] : state.values[addr >> 1];
}
const $6b8f387faea0a4dd$var$languageData = /*@__PURE__*/ $6b8f387faea0a4dd$export$ef7d5e9b79fa1504.define();
const $6b8f387faea0a4dd$var$allowMultipleSelections = /*@__PURE__*/ $6b8f387faea0a4dd$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.some((v)=>v),
    static: true
});
const $6b8f387faea0a4dd$var$lineSeparator = /*@__PURE__*/ $6b8f387faea0a4dd$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : undefined,
    static: true
});
const $6b8f387faea0a4dd$var$changeFilter = /*@__PURE__*/ $6b8f387faea0a4dd$export$ef7d5e9b79fa1504.define();
const $6b8f387faea0a4dd$var$transactionFilter = /*@__PURE__*/ $6b8f387faea0a4dd$export$ef7d5e9b79fa1504.define();
const $6b8f387faea0a4dd$var$transactionExtender = /*@__PURE__*/ $6b8f387faea0a4dd$export$ef7d5e9b79fa1504.define();
const $6b8f387faea0a4dd$var$readOnly = /*@__PURE__*/ $6b8f387faea0a4dd$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : false
});
/**
Annotations are tagged values that are used to add metadata to
transactions in an extensible way. They should be used to model
things that effect the entire transaction (such as its [time
stamp](https://codemirror.net/6/docs/ref/#state.Transaction^time) or information about its
[origin](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent)). For effects that happen
_alongside_ the other changes made by the transaction, [state
effects](https://codemirror.net/6/docs/ref/#state.StateEffect) are more appropriate.
*/ class $6b8f387faea0a4dd$export$9279461326b8700a {
    /**
    @internal
    */ constructor(/**
    The annotation type.
    */ type, /**
    The value of this annotation.
    */ value){
        this.type = type;
        this.value = value;
    }
    /**
    Define a new type of annotation.
    */ static define() {
        return new $6b8f387faea0a4dd$export$f50c3066a53a6f2c();
    }
}
/**
Marker that identifies a type of [annotation](https://codemirror.net/6/docs/ref/#state.Annotation).
*/ class $6b8f387faea0a4dd$export$f50c3066a53a6f2c {
    /**
    Create an instance of this annotation.
    */ of(value) {
        return new $6b8f387faea0a4dd$export$9279461326b8700a(this, value);
    }
}
/**
Representation of a type of state effect. Defined with
[`StateEffect.define`](https://codemirror.net/6/docs/ref/#state.StateEffect^define).
*/ class $6b8f387faea0a4dd$export$e41ff6bd17cc4417 {
    /**
    @internal
    */ constructor(// The `any` types in these function types are there to work
    // around TypeScript issue #37631, where the type guard on
    // `StateEffect.is` mysteriously stops working when these properly
    // have type `Value`.
    /**
    @internal
    */ map){
        this.map = map;
    }
    /**
    Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
    type.
    */ of(value) {
        return new $6b8f387faea0a4dd$export$95000d4efaa4321f(this, value);
    }
}
/**
State effects can be used to represent additional effects
associated with a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction.effects). They
are often useful to model changes to custom [state
fields](https://codemirror.net/6/docs/ref/#state.StateField), when those changes aren't implicit in
document or selection changes.
*/ class $6b8f387faea0a4dd$export$95000d4efaa4321f {
    /**
    @internal
    */ constructor(/**
    @internal
    */ type, /**
    The value of this effect.
    */ value){
        this.type = type;
        this.value = value;
    }
    /**
    Map this effect through a position mapping. Will return
    `undefined` when that ends up deleting the effect.
    */ map(mapping) {
        let mapped = this.type.map(this.value, mapping);
        return mapped === undefined ? undefined : mapped == this.value ? this : new $6b8f387faea0a4dd$export$95000d4efaa4321f(this.type, mapped);
    }
    /**
    Tells you whether this effect object is of a given
    [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
    */ is(type) {
        return this.type == type;
    }
    /**
    Define a new effect type. The type parameter indicates the type
    of values that his effect holds. It should be a type that
    doesn't include `undefined`, since that is used in
    [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
    removed.
    */ static define(spec = {}) {
        return new $6b8f387faea0a4dd$export$e41ff6bd17cc4417(spec.map || ((v)=>v));
    }
    /**
    Map an array of effects through a change set.
    */ static mapEffects(effects, mapping) {
        if (!effects.length) return effects;
        let result = [];
        for (let effect of effects){
            let mapped = effect.map(mapping);
            if (mapped) result.push(mapped);
        }
        return result;
    }
}
/**
This effect can be used to reconfigure the root extensions of
the editor. Doing this will discard any extensions
[appended](https://codemirror.net/6/docs/ref/#state.StateEffect^appendConfig), but does not reset
the content of [reconfigured](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure)
compartments.
*/ $6b8f387faea0a4dd$export$95000d4efaa4321f.reconfigure = /*@__PURE__*/ $6b8f387faea0a4dd$export$95000d4efaa4321f.define();
/**
Append extensions to the top-level configuration of the editor.
*/ $6b8f387faea0a4dd$export$95000d4efaa4321f.appendConfig = /*@__PURE__*/ $6b8f387faea0a4dd$export$95000d4efaa4321f.define();
/**
Changes to the editor state are grouped into transactions.
Typically, a user action creates a single transaction, which may
contain any number of document changes, may change the selection,
or have other effects. Create a transaction by calling
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update), or immediately
dispatch one by calling
[`EditorView.dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch).
*/ class $6b8f387faea0a4dd$export$febc5573c75cefb0 {
    constructor(/**
    The state from which the transaction starts.
    */ startState, /**
    The document changes made by this transaction.
    */ changes, /**
    The selection set by this transaction, or undefined if it
    doesn't explicitly set a selection.
    */ selection, /**
    The effects added to the transaction.
    */ effects, /**
    @internal
    */ annotations, /**
    Whether the selection should be scrolled into view after this
    transaction is dispatched.
    */ scrollIntoView){
        this.startState = startState;
        this.changes = changes;
        this.selection = selection;
        this.effects = effects;
        this.annotations = annotations;
        this.scrollIntoView = scrollIntoView;
        /**
        @internal
        */ this._doc = null;
        /**
        @internal
        */ this._state = null;
        if (selection) $6b8f387faea0a4dd$var$checkSelection(selection, changes.newLength);
        if (!annotations.some((a)=>a.type == $6b8f387faea0a4dd$export$febc5573c75cefb0.time)) this.annotations = annotations.concat($6b8f387faea0a4dd$export$febc5573c75cefb0.time.of(Date.now()));
    }
    /**
    @internal
    */ static create(startState, changes, selection, effects, annotations, scrollIntoView) {
        return new $6b8f387faea0a4dd$export$febc5573c75cefb0(startState, changes, selection, effects, annotations, scrollIntoView);
    }
    /**
    The new document produced by the transaction. Contrary to
    [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
    force the entire new state to be computed right away, so it is
    recommended that [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
    when they need to look at the new document.
    */ get newDoc() {
        return this._doc || (this._doc = this.changes.apply(this.startState.doc));
    }
    /**
    The new selection produced by the transaction. If
    [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
    this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
    current selection through the changes made by the transaction.
    */ get newSelection() {
        return this.selection || this.startState.selection.map(this.changes);
    }
    /**
    The new state created by the transaction. Computed on demand
    (but retained for subsequent access), so it is recommended not to
    access it in [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
    */ get state() {
        if (!this._state) this.startState.applyTransaction(this);
        return this._state;
    }
    /**
    Get the value of the given annotation type, if any.
    */ annotation(type) {
        for (let ann of this.annotations)if (ann.type == type) return ann.value;
        return undefined;
    }
    /**
    Indicates whether the transaction changed the document.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Indicates whether this transaction reconfigures the state
    (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
    with a top-level configuration
    [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
    */ get reconfigured() {
        return this.startState.config != this.state.config;
    }
    /**
    Returns true if the transaction has a [user
    event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
    or more specific than `event`. For example, if the transaction
    has `"select.pointer"` as user event, `"select"` and
    `"select.pointer"` will match it.
    */ isUserEvent(event) {
        let e = this.annotation($6b8f387faea0a4dd$export$febc5573c75cefb0.userEvent);
        return !!(e && (e == event || e.length > event.length && e.slice(0, event.length) == event && e[event.length] == "."));
    }
}
/**
Annotation used to store transaction timestamps. Automatically
added to every transaction, holding `Date.now()`.
*/ $6b8f387faea0a4dd$export$febc5573c75cefb0.time = /*@__PURE__*/ $6b8f387faea0a4dd$export$9279461326b8700a.define();
/**
Annotation used to associate a transaction with a user interface
event. Holds a string identifying the event, using a
dot-separated format to support attaching more specific
information. The events used by the core libraries are:

 - `"input"` when content is entered
   - `"input.type"` for typed input
     - `"input.type.compose"` for composition
   - `"input.paste"` for pasted input
   - `"input.drop"` when adding content with drag-and-drop
   - `"input.complete"` when autocompleting
 - `"delete"` when the user deletes content
   - `"delete.selection"` when deleting the selection
   - `"delete.forward"` when deleting forward from the selection
   - `"delete.backward"` when deleting backward from the selection
   - `"delete.cut"` when cutting to the clipboard
 - `"move"` when content is moved
   - `"move.drop"` when content is moved within the editor through drag-and-drop
 - `"select"` when explicitly changing the selection
   - `"select.pointer"` when selecting with a mouse or other pointing device
 - `"undo"` and `"redo"` for history actions

Use [`isUserEvent`](https://codemirror.net/6/docs/ref/#state.Transaction.isUserEvent) to check
whether the annotation matches a given event.
*/ $6b8f387faea0a4dd$export$febc5573c75cefb0.userEvent = /*@__PURE__*/ $6b8f387faea0a4dd$export$9279461326b8700a.define();
/**
Annotation indicating whether a transaction should be added to
the undo history or not.
*/ $6b8f387faea0a4dd$export$febc5573c75cefb0.addToHistory = /*@__PURE__*/ $6b8f387faea0a4dd$export$9279461326b8700a.define();
/**
Annotation indicating (when present and true) that a transaction
represents a change made by some other actor, not the user. This
is used, for example, to tag other people's changes in
collaborative editing.
*/ $6b8f387faea0a4dd$export$febc5573c75cefb0.remote = /*@__PURE__*/ $6b8f387faea0a4dd$export$9279461326b8700a.define();
function $6b8f387faea0a4dd$var$joinRanges(a, b) {
    let result = [];
    for(let iA = 0, iB = 0;;){
        let from, to;
        if (iA < a.length && (iB == b.length || b[iB] >= a[iA])) {
            from = a[iA++];
            to = a[iA++];
        } else if (iB < b.length) {
            from = b[iB++];
            to = b[iB++];
        } else return result;
        if (!result.length || result[result.length - 1] < from) result.push(from, to);
        else if (result[result.length - 1] < to) result[result.length - 1] = to;
    }
}
function $6b8f387faea0a4dd$var$mergeTransaction(a, b, sequential) {
    var _a;
    let mapForA, mapForB, changes;
    if (sequential) {
        mapForA = b.changes;
        mapForB = $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c.empty(b.changes.length);
        changes = a.changes.compose(b.changes);
    } else {
        mapForA = b.changes.map(a.changes);
        mapForB = a.changes.mapDesc(b.changes, true);
        changes = a.changes.compose(mapForA);
    }
    return {
        changes: changes,
        selection: b.selection ? b.selection.map(mapForB) : (_a = a.selection) === null || _a === void 0 ? void 0 : _a.map(mapForA),
        effects: $6b8f387faea0a4dd$export$95000d4efaa4321f.mapEffects(a.effects, mapForA).concat($6b8f387faea0a4dd$export$95000d4efaa4321f.mapEffects(b.effects, mapForB)),
        annotations: a.annotations.length ? a.annotations.concat(b.annotations) : b.annotations,
        scrollIntoView: a.scrollIntoView || b.scrollIntoView
    };
}
function $6b8f387faea0a4dd$var$resolveTransactionInner(state, spec, docSize) {
    let sel = spec.selection, annotations = $6b8f387faea0a4dd$var$asArray(spec.annotations);
    if (spec.userEvent) annotations = annotations.concat($6b8f387faea0a4dd$export$febc5573c75cefb0.userEvent.of(spec.userEvent));
    return {
        changes: spec.changes instanceof $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c ? spec.changes : $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c.of(spec.changes || [], docSize, state.facet($6b8f387faea0a4dd$var$lineSeparator)),
        selection: sel && (sel instanceof $6b8f387faea0a4dd$export$3bb1bd44aee62999 ? sel : $6b8f387faea0a4dd$export$3bb1bd44aee62999.single(sel.anchor, sel.head)),
        effects: $6b8f387faea0a4dd$var$asArray(spec.effects),
        annotations: annotations,
        scrollIntoView: !!spec.scrollIntoView
    };
}
function $6b8f387faea0a4dd$var$resolveTransaction(state, specs, filter) {
    let s = $6b8f387faea0a4dd$var$resolveTransactionInner(state, specs.length ? specs[0] : {}, state.doc.length);
    if (specs.length && specs[0].filter === false) filter = false;
    for(let i = 1; i < specs.length; i++){
        if (specs[i].filter === false) filter = false;
        let seq = !!specs[i].sequential;
        s = $6b8f387faea0a4dd$var$mergeTransaction(s, $6b8f387faea0a4dd$var$resolveTransactionInner(state, specs[i], seq ? s.changes.newLength : state.doc.length), seq);
    }
    let tr = $6b8f387faea0a4dd$export$febc5573c75cefb0.create(state, s.changes, s.selection, s.effects, s.annotations, s.scrollIntoView);
    return $6b8f387faea0a4dd$var$extendTransaction(filter ? $6b8f387faea0a4dd$var$filterTransaction(tr) : tr);
}
// Finish a transaction by applying filters if necessary.
function $6b8f387faea0a4dd$var$filterTransaction(tr) {
    let state = tr.startState;
    // Change filters
    let result = true;
    for (let filter of state.facet($6b8f387faea0a4dd$var$changeFilter)){
        let value = filter(tr);
        if (value === false) {
            result = false;
            break;
        }
        if (Array.isArray(value)) result = result === true ? value : $6b8f387faea0a4dd$var$joinRanges(result, value);
    }
    if (result !== true) {
        let changes, back;
        if (result === false) {
            back = tr.changes.invertedDesc;
            changes = $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c.empty(state.doc.length);
        } else {
            let filtered = tr.changes.filter(result);
            changes = filtered.changes;
            back = filtered.filtered.mapDesc(filtered.changes).invertedDesc;
        }
        tr = $6b8f387faea0a4dd$export$febc5573c75cefb0.create(state, changes, tr.selection && tr.selection.map(back), $6b8f387faea0a4dd$export$95000d4efaa4321f.mapEffects(tr.effects, back), tr.annotations, tr.scrollIntoView);
    }
    // Transaction filters
    let filters = state.facet($6b8f387faea0a4dd$var$transactionFilter);
    for(let i = filters.length - 1; i >= 0; i--){
        let filtered = filters[i](tr);
        if (filtered instanceof $6b8f387faea0a4dd$export$febc5573c75cefb0) tr = filtered;
        else if (Array.isArray(filtered) && filtered.length == 1 && filtered[0] instanceof $6b8f387faea0a4dd$export$febc5573c75cefb0) tr = filtered[0];
        else tr = $6b8f387faea0a4dd$var$resolveTransaction(state, $6b8f387faea0a4dd$var$asArray(filtered), false);
    }
    return tr;
}
function $6b8f387faea0a4dd$var$extendTransaction(tr) {
    let state = tr.startState, extenders = state.facet($6b8f387faea0a4dd$var$transactionExtender), spec = tr;
    for(let i = extenders.length - 1; i >= 0; i--){
        let extension = extenders[i](tr);
        if (extension && Object.keys(extension).length) spec = $6b8f387faea0a4dd$var$mergeTransaction(spec, $6b8f387faea0a4dd$var$resolveTransactionInner(state, extension, tr.changes.newLength), true);
    }
    return spec == tr ? tr : $6b8f387faea0a4dd$export$febc5573c75cefb0.create(state, tr.changes, tr.selection, spec.effects, spec.annotations, spec.scrollIntoView);
}
const $6b8f387faea0a4dd$var$none = [];
function $6b8f387faea0a4dd$var$asArray(value) {
    return value == null ? $6b8f387faea0a4dd$var$none : Array.isArray(value) ? value : [
        value
    ];
}
/**
The categories produced by a [character
categorizer](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer). These are used
do things like selecting by word.
*/ var $6b8f387faea0a4dd$export$239a3d59567c1401 = /*@__PURE__*/ function(CharCategory) {
    /**
    Word characters.
    */ CharCategory[CharCategory["Word"] = 0] = "Word";
    /**
    Whitespace.
    */ CharCategory[CharCategory["Space"] = 1] = "Space";
    /**
    Anything else.
    */ CharCategory[CharCategory["Other"] = 2] = "Other";
    return CharCategory;
}($6b8f387faea0a4dd$export$239a3d59567c1401 || ($6b8f387faea0a4dd$export$239a3d59567c1401 = {}));
const $6b8f387faea0a4dd$var$nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let $6b8f387faea0a4dd$var$wordChar;
try {
    $6b8f387faea0a4dd$var$wordChar = /*@__PURE__*/ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch (_) {}
function $6b8f387faea0a4dd$var$hasWordChar(str) {
    if ($6b8f387faea0a4dd$var$wordChar) return $6b8f387faea0a4dd$var$wordChar.test(str);
    for(let i = 0; i < str.length; i++){
        let ch = str[i];
        if (/\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || $6b8f387faea0a4dd$var$nonASCIISingleCaseWordChar.test(ch))) return true;
    }
    return false;
}
function $6b8f387faea0a4dd$var$makeCategorizer(wordChars) {
    return (char)=>{
        if (!/\S/.test(char)) return $6b8f387faea0a4dd$export$239a3d59567c1401.Space;
        if ($6b8f387faea0a4dd$var$hasWordChar(char)) return $6b8f387faea0a4dd$export$239a3d59567c1401.Word;
        for(let i = 0; i < wordChars.length; i++)if (char.indexOf(wordChars[i]) > -1) return $6b8f387faea0a4dd$export$239a3d59567c1401.Word;
        return $6b8f387faea0a4dd$export$239a3d59567c1401.Other;
    };
}
/**
The editor state class is a persistent (immutable) data structure.
To update a state, you [create](https://codemirror.net/6/docs/ref/#state.EditorState.update) a
[transaction](https://codemirror.net/6/docs/ref/#state.Transaction), which produces a _new_ state
instance, without modifying the original object.

As such, _never_ mutate properties of a state directly. That'll
just break things.
*/ class $6b8f387faea0a4dd$export$afa855cbfaff27f2 {
    constructor(/**
    @internal
    */ config, /**
    The current document.
    */ doc, /**
    The current selection.
    */ selection, /**
    @internal
    */ values, computeSlot, tr){
        this.config = config;
        this.doc = doc;
        this.selection = selection;
        this.values = values;
        this.status = config.statusTemplate.slice();
        this.computeSlot = computeSlot;
        // Fill in the computed state immediately, so that further queries
        // for it made during the update return this state
        if (tr) tr._state = this;
        for(let i = 0; i < this.config.dynamicSlots.length; i++)$6b8f387faea0a4dd$var$ensureAddr(this, i << 1);
        this.computeSlot = null;
    }
    field(field, require = true) {
        let addr = this.config.address[field.id];
        if (addr == null) {
            if (require) throw new RangeError("Field is not present in this state");
            return undefined;
        }
        $6b8f387faea0a4dd$var$ensureAddr(this, addr);
        return $6b8f387faea0a4dd$var$getAddr(this, addr);
    }
    /**
    Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
    state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
    can be passed. Unless
    [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
    [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
    are assumed to start in the _current_ document (not the document
    produced by previous specs), and its
    [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
    [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
    to the document created by its _own_ changes. The resulting
    transaction contains the combined effect of all the different
    specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
    specs take precedence over earlier ones.
    */ update(...specs) {
        return $6b8f387faea0a4dd$var$resolveTransaction(this, specs, true);
    }
    /**
    @internal
    */ applyTransaction(tr) {
        let conf = this.config, { base: base, compartments: compartments } = conf;
        for (let effect of tr.effects){
            if (effect.is($6b8f387faea0a4dd$export$d51c0172eb2c2431.reconfigure)) {
                if (conf) {
                    compartments = new Map;
                    conf.compartments.forEach((val, key)=>compartments.set(key, val));
                    conf = null;
                }
                compartments.set(effect.value.compartment, effect.value.extension);
            } else if (effect.is($6b8f387faea0a4dd$export$95000d4efaa4321f.reconfigure)) {
                conf = null;
                base = effect.value;
            } else if (effect.is($6b8f387faea0a4dd$export$95000d4efaa4321f.appendConfig)) {
                conf = null;
                base = $6b8f387faea0a4dd$var$asArray(base).concat(effect.value);
            }
        }
        let startValues;
        if (!conf) {
            conf = $6b8f387faea0a4dd$var$Configuration.resolve(base, compartments, this);
            let intermediateState = new $6b8f387faea0a4dd$export$afa855cbfaff27f2(conf, this.doc, this.selection, conf.dynamicSlots.map(()=>null), (state, slot)=>slot.reconfigure(state, this), null);
            startValues = intermediateState.values;
        } else startValues = tr.startState.values.slice();
        let selection = tr.startState.facet($6b8f387faea0a4dd$var$allowMultipleSelections) ? tr.newSelection : tr.newSelection.asSingle();
        new $6b8f387faea0a4dd$export$afa855cbfaff27f2(conf, tr.newDoc, selection, startValues, (state, slot)=>slot.update(state, tr), tr);
    }
    /**
    Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
    replaces every selection range with the given content.
    */ replaceSelection(text) {
        if (typeof text == "string") text = this.toText(text);
        return this.changeByRange((range)=>({
                changes: {
                    from: range.from,
                    to: range.to,
                    insert: text
                },
                range: $6b8f387faea0a4dd$export$3bb1bd44aee62999.cursor(range.from + text.length)
            }));
    }
    /**
    Create a set of changes and a new selection by running the given
    function for each range in the active selection. The function
    can return an optional set of changes (in the coordinate space
    of the start document), plus an updated range (in the coordinate
    space of the document produced by the call's own changes). This
    method will merge all the changes and ranges into a single
    changeset and selection, and return it as a [transaction
    spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
    [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
    */ changeByRange(f) {
        let sel = this.selection;
        let result1 = f(sel.ranges[0]);
        let changes = this.changes(result1.changes), ranges = [
            result1.range
        ];
        let effects = $6b8f387faea0a4dd$var$asArray(result1.effects);
        for(let i = 1; i < sel.ranges.length; i++){
            let result = f(sel.ranges[i]);
            let newChanges = this.changes(result.changes), newMapped = newChanges.map(changes);
            for(let j = 0; j < i; j++)ranges[j] = ranges[j].map(newMapped);
            let mapBy = changes.mapDesc(newChanges, true);
            ranges.push(result.range.map(mapBy));
            changes = changes.compose(newMapped);
            effects = $6b8f387faea0a4dd$export$95000d4efaa4321f.mapEffects(effects, newMapped).concat($6b8f387faea0a4dd$export$95000d4efaa4321f.mapEffects($6b8f387faea0a4dd$var$asArray(result.effects), mapBy));
        }
        return {
            changes: changes,
            selection: $6b8f387faea0a4dd$export$3bb1bd44aee62999.create(ranges, sel.mainIndex),
            effects: effects
        };
    }
    /**
    Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
    description, taking the state's document length and line
    separator into account.
    */ changes(spec = []) {
        if (spec instanceof $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c) return spec;
        return $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c.of(spec, this.doc.length, this.facet($6b8f387faea0a4dd$export$afa855cbfaff27f2.lineSeparator));
    }
    /**
    Using the state's [line
    separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
    [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
    */ toText(string) {
        return $6b8f387faea0a4dd$export$5f1af8db9871e1d6.of(string.split(this.facet($6b8f387faea0a4dd$export$afa855cbfaff27f2.lineSeparator) || $6b8f387faea0a4dd$var$DefaultSplit));
    }
    /**
    Return the given range of the document as a string.
    */ sliceDoc(from = 0, to = this.doc.length) {
        return this.doc.sliceString(from, to, this.lineBreak);
    }
    /**
    Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
    */ facet(facet) {
        let addr = this.config.address[facet.id];
        if (addr == null) return facet.default;
        $6b8f387faea0a4dd$var$ensureAddr(this, addr);
        return $6b8f387faea0a4dd$var$getAddr(this, addr);
    }
    /**
    Convert this state to a JSON-serializable object. When custom
    fields should be serialized, you can pass them in as an object
    mapping property names (in the resulting object, which should
    not use `doc` or `selection`) to fields.
    */ toJSON(fields) {
        let result = {
            doc: this.sliceDoc(),
            selection: this.selection.toJSON()
        };
        if (fields) for(let prop in fields){
            let value = fields[prop];
            if (value instanceof $6b8f387faea0a4dd$export$34381b1ce2130245 && this.config.address[value.id] != null) result[prop] = value.spec.toJSON(this.field(fields[prop]), this);
        }
        return result;
    }
    /**
    Deserialize a state from its JSON representation. When custom
    fields should be deserialized, pass the same object you passed
    to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
    third argument.
    */ static fromJSON(json, config = {}, fields) {
        if (!json || typeof json.doc != "string") throw new RangeError("Invalid JSON representation for EditorState");
        let fieldInit = [];
        if (fields) {
            for(let prop in fields)if (Object.prototype.hasOwnProperty.call(json, prop)) {
                let field = fields[prop], value = json[prop];
                fieldInit.push(field.init((state)=>field.spec.fromJSON(value, state)));
            }
        }
        return $6b8f387faea0a4dd$export$afa855cbfaff27f2.create({
            doc: json.doc,
            selection: $6b8f387faea0a4dd$export$3bb1bd44aee62999.fromJSON(json.selection),
            extensions: config.extensions ? fieldInit.concat([
                config.extensions
            ]) : fieldInit
        });
    }
    /**
    Create a new state. You'll usually only need this when
    initializing an editor—updated states are created by applying
    transactions.
    */ static create(config = {}) {
        let configuration = $6b8f387faea0a4dd$var$Configuration.resolve(config.extensions || [], new Map);
        let doc = config.doc instanceof $6b8f387faea0a4dd$export$5f1af8db9871e1d6 ? config.doc : $6b8f387faea0a4dd$export$5f1af8db9871e1d6.of((config.doc || "").split(configuration.staticFacet($6b8f387faea0a4dd$export$afa855cbfaff27f2.lineSeparator) || $6b8f387faea0a4dd$var$DefaultSplit));
        let selection = !config.selection ? $6b8f387faea0a4dd$export$3bb1bd44aee62999.single(0) : config.selection instanceof $6b8f387faea0a4dd$export$3bb1bd44aee62999 ? config.selection : $6b8f387faea0a4dd$export$3bb1bd44aee62999.single(config.selection.anchor, config.selection.head);
        $6b8f387faea0a4dd$var$checkSelection(selection, doc.length);
        if (!configuration.staticFacet($6b8f387faea0a4dd$var$allowMultipleSelections)) selection = selection.asSingle();
        return new $6b8f387faea0a4dd$export$afa855cbfaff27f2(configuration, doc, selection, configuration.dynamicSlots.map(()=>null), (state, slot)=>slot.create(state), null);
    }
    /**
    The size (in columns) of a tab in the document, determined by
    the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
    */ get tabSize() {
        return this.facet($6b8f387faea0a4dd$export$afa855cbfaff27f2.tabSize);
    }
    /**
    Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
    string for this state.
    */ get lineBreak() {
        return this.facet($6b8f387faea0a4dd$export$afa855cbfaff27f2.lineSeparator) || "\n";
    }
    /**
    Returns true when the editor is
    [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
    */ get readOnly() {
        return this.facet($6b8f387faea0a4dd$var$readOnly);
    }
    /**
    Look up a translation for the given phrase (via the
    [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
    original string if no translation is found.
    
    If additional arguments are passed, they will be inserted in
    place of markers like `$1` (for the first value) and `$2`, etc.
    A single `$` is equivalent to `$1`, and `$$` will produce a
    literal dollar sign.
    */ phrase(phrase, ...insert) {
        for (let map of this.facet($6b8f387faea0a4dd$export$afa855cbfaff27f2.phrases))if (Object.prototype.hasOwnProperty.call(map, phrase)) {
            phrase = map[phrase];
            break;
        }
        if (insert.length) phrase = phrase.replace(/\$(\$|\d*)/g, (m, i)=>{
            if (i == "$") return "$";
            let n = +(i || 1);
            return !n || n > insert.length ? m : insert[n - 1];
        });
        return phrase;
    }
    /**
    Find the values for a given language data field, provided by the
    the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
    
    Examples of language data fields are...
    
    - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
      comment syntax.
    - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
      for providing language-specific completion sources.
    - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
      characters that should be considered part of words in this
      language.
    - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
      bracket closing behavior.
    */ languageDataAt(name, pos, side = -1) {
        let values = [];
        for (let provider of this.facet($6b8f387faea0a4dd$var$languageData)){
            for (let result of provider(this, pos, side))if (Object.prototype.hasOwnProperty.call(result, name)) values.push(result[name]);
        }
        return values;
    }
    /**
    Return a function that can categorize strings (expected to
    represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
    into one of:
    
     - Word (contains an alphanumeric character or a character
       explicitly listed in the local language's `"wordChars"`
       language data, which should be a string)
     - Space (contains only whitespace)
     - Other (anything else)
    */ charCategorizer(at) {
        return $6b8f387faea0a4dd$var$makeCategorizer(this.languageDataAt("wordChars", at).join(""));
    }
    /**
    Find the word at the given position, meaning the range
    containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
    around it. If no word characters are adjacent to the position,
    this returns null.
    */ wordAt(pos) {
        let { text: text, from: from, length: length } = this.doc.lineAt(pos);
        let cat = this.charCategorizer(pos);
        let start = pos - from, end = pos - from;
        while(start > 0){
            let prev = $6b8f387faea0a4dd$export$a0fa439fd515e1ed(text, start, false);
            if (cat(text.slice(prev, start)) != $6b8f387faea0a4dd$export$239a3d59567c1401.Word) break;
            start = prev;
        }
        while(end < length){
            let next = $6b8f387faea0a4dd$export$a0fa439fd515e1ed(text, end);
            if (cat(text.slice(end, next)) != $6b8f387faea0a4dd$export$239a3d59567c1401.Word) break;
            end = next;
        }
        return start == end ? null : $6b8f387faea0a4dd$export$3bb1bd44aee62999.range(start + from, end + from);
    }
}
/**
A facet that, when enabled, causes the editor to allow multiple
ranges to be selected. Be careful though, because by default the
editor relies on the native DOM selection, which cannot handle
multiple selections. An extension like
[`drawSelection`](https://codemirror.net/6/docs/ref/#view.drawSelection) can be used to make
secondary selections visible to the user.
*/ $6b8f387faea0a4dd$export$afa855cbfaff27f2.allowMultipleSelections = $6b8f387faea0a4dd$var$allowMultipleSelections;
/**
Configures the tab size to use in this state. The first
(highest-precedence) value of the facet is used. If no value is
given, this defaults to 4.
*/ $6b8f387faea0a4dd$export$afa855cbfaff27f2.tabSize = /*@__PURE__*/ $6b8f387faea0a4dd$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : 4
});
/**
The line separator to use. By default, any of `"\n"`, `"\r\n"`
and `"\r"` is treated as a separator when splitting lines, and
lines are joined with `"\n"`.

When you configure a value here, only that precise separator
will be used, allowing you to round-trip documents through the
editor without normalizing line separators.
*/ $6b8f387faea0a4dd$export$afa855cbfaff27f2.lineSeparator = $6b8f387faea0a4dd$var$lineSeparator;
/**
This facet controls the value of the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) getter, which is
consulted by commands and extensions that implement editing
functionality to determine whether they should apply. It
defaults to false, but when its highest-precedence value is
`true`, such functionality disables itself.

Not to be confused with
[`EditorView.editable`](https://codemirror.net/6/docs/ref/#view.EditorView^editable), which
controls whether the editor's DOM is set to be editable (and
thus focusable).
*/ $6b8f387faea0a4dd$export$afa855cbfaff27f2.readOnly = $6b8f387faea0a4dd$var$readOnly;
/**
Registers translation phrases. The
[`phrase`](https://codemirror.net/6/docs/ref/#state.EditorState.phrase) method will look through
all objects registered with this facet to find translations for
its argument.
*/ $6b8f387faea0a4dd$export$afa855cbfaff27f2.phrases = /*@__PURE__*/ $6b8f387faea0a4dd$export$ef7d5e9b79fa1504.define({
    compare (a, b) {
        let kA = Object.keys(a), kB = Object.keys(b);
        return kA.length == kB.length && kA.every((k)=>a[k] == b[k]);
    }
});
/**
A facet used to register [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) providers.
*/ $6b8f387faea0a4dd$export$afa855cbfaff27f2.languageData = $6b8f387faea0a4dd$var$languageData;
/**
Facet used to register change filters, which are called for each
transaction (unless explicitly
[disabled](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter)), and can suppress
part of the transaction's changes.

Such a function can return `true` to indicate that it doesn't
want to do anything, `false` to completely stop the changes in
the transaction, or a set of ranges in which changes should be
suppressed. Such ranges are represented as an array of numbers,
with each pair of two numbers indicating the start and end of a
range. So for example `[10, 20, 100, 110]` suppresses changes
between 10 and 20, and between 100 and 110.
*/ $6b8f387faea0a4dd$export$afa855cbfaff27f2.changeFilter = $6b8f387faea0a4dd$var$changeFilter;
/**
Facet used to register a hook that gets a chance to update or
replace transaction specs before they are applied. This will
only be applied for transactions that don't have
[`filter`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter) set to `false`. You
can either return a single transaction spec (possibly the input
transaction), or an array of specs (which will be combined in
the same way as the arguments to
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update)).

When possible, it is recommended to avoid accessing
[`Transaction.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state) in a filter,
since it will force creation of a state that will then be
discarded again, if the transaction is actually filtered.

(This functionality should be used with care. Indiscriminately
modifying transaction is likely to break something or degrade
the user experience.)
*/ $6b8f387faea0a4dd$export$afa855cbfaff27f2.transactionFilter = $6b8f387faea0a4dd$var$transactionFilter;
/**
This is a more limited form of
[`transactionFilter`](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter),
which can only add
[annotations](https://codemirror.net/6/docs/ref/#state.TransactionSpec.annotations) and
[effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects). _But_, this type
of filter runs even if the transaction has disabled regular
[filtering](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter), making it suitable
for effects that don't need to touch the changes or selection,
but do want to process every transaction.

Extenders run _after_ filters, when both are present.
*/ $6b8f387faea0a4dd$export$afa855cbfaff27f2.transactionExtender = $6b8f387faea0a4dd$var$transactionExtender;
$6b8f387faea0a4dd$export$d51c0172eb2c2431.reconfigure = /*@__PURE__*/ $6b8f387faea0a4dd$export$95000d4efaa4321f.define();
/**
Utility function for combining behaviors to fill in a config
object from an array of provided configs. `defaults` should hold
default values for all optional fields in `Config`.

The function will, by default, error
when a field gets two values that aren't `===`-equal, but you can
provide combine functions per field to do something else.
*/ function $6b8f387faea0a4dd$export$4e19c0b693794a7e(configs, defaults, combine = {}) {
    let result = {};
    for (let config of configs)for (let key of Object.keys(config)){
        let value = config[key], current = result[key];
        if (current === undefined) result[key] = value;
        else if (current === value || value === undefined) ; // No conflict
        else if (Object.hasOwnProperty.call(combine, key)) result[key] = combine[key](current, value);
        else throw new Error("Config merge conflict for field " + key);
    }
    for(let key in defaults)if (result[key] === undefined) result[key] = defaults[key];
    return result;
}
/**
Each range is associated with a value, which must inherit from
this class.
*/ class $6b8f387faea0a4dd$export$d60f08ed93a48611 {
    /**
    Compare this value with another value. Used when comparing
    rangesets. The default implementation compares by identity.
    Unless you are only creating a fixed number of unique instances
    of your value type, it is a good idea to implement this
    properly.
    */ eq(other) {
        return this == other;
    }
    /**
    Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
    */ range(from, to = from) {
        return $6b8f387faea0a4dd$export$9a58ef0d7ad3278c.create(from, to, this);
    }
}
$6b8f387faea0a4dd$export$d60f08ed93a48611.prototype.startSide = $6b8f387faea0a4dd$export$d60f08ed93a48611.prototype.endSide = 0;
$6b8f387faea0a4dd$export$d60f08ed93a48611.prototype.point = false;
$6b8f387faea0a4dd$export$d60f08ed93a48611.prototype.mapMode = $6b8f387faea0a4dd$export$39cf3280165f92aa.TrackDel;
/**
A range associates a value with a range of positions.
*/ class $6b8f387faea0a4dd$export$9a58ef0d7ad3278c {
    constructor(/**
    The range's start position.
    */ from, /**
    Its end position.
    */ to, /**
    The value associated with this range.
    */ value){
        this.from = from;
        this.to = to;
        this.value = value;
    }
    /**
    @internal
    */ static create(from, to, value) {
        return new $6b8f387faea0a4dd$export$9a58ef0d7ad3278c(from, to, value);
    }
}
function $6b8f387faea0a4dd$var$cmpRange(a, b) {
    return a.from - b.from || a.value.startSide - b.value.startSide;
}
class $6b8f387faea0a4dd$var$Chunk {
    constructor(from, to, value, // Chunks are marked with the largest point that occurs
    // in them (or -1 for no points), so that scans that are
    // only interested in points (such as the
    // heightmap-related logic) can skip range-only chunks.
    maxPoint){
        this.from = from;
        this.to = to;
        this.value = value;
        this.maxPoint = maxPoint;
    }
    get length() {
        return this.to[this.to.length - 1];
    }
    // Find the index of the given position and side. Use the ranges'
    // `from` pos when `end == false`, `to` when `end == true`.
    findIndex(pos, side, end, startAt = 0) {
        let arr = end ? this.to : this.from;
        for(let lo = startAt, hi = arr.length;;){
            if (lo == hi) return lo;
            let mid = lo + hi >> 1;
            let diff = arr[mid] - pos || (end ? this.value[mid].endSide : this.value[mid].startSide) - side;
            if (mid == lo) return diff >= 0 ? lo : hi;
            if (diff >= 0) hi = mid;
            else lo = mid + 1;
        }
    }
    between(offset, from, to, f) {
        for(let i = this.findIndex(from, -1000000000 /* C.Far */ , true), e = this.findIndex(to, 1000000000 /* C.Far */ , false, i); i < e; i++)if (f(this.from[i] + offset, this.to[i] + offset, this.value[i]) === false) return false;
    }
    map(offset, changes) {
        let value = [], from = [], to = [], newPos = -1, maxPoint = -1;
        for(let i = 0; i < this.value.length; i++){
            let val = this.value[i], curFrom = this.from[i] + offset, curTo = this.to[i] + offset, newFrom, newTo;
            if (curFrom == curTo) {
                let mapped = changes.mapPos(curFrom, val.startSide, val.mapMode);
                if (mapped == null) continue;
                newFrom = newTo = mapped;
                if (val.startSide != val.endSide) {
                    newTo = changes.mapPos(curFrom, val.endSide);
                    if (newTo < newFrom) continue;
                }
            } else {
                newFrom = changes.mapPos(curFrom, val.startSide);
                newTo = changes.mapPos(curTo, val.endSide);
                if (newFrom > newTo || newFrom == newTo && val.startSide > 0 && val.endSide <= 0) continue;
            }
            if ((newTo - newFrom || val.endSide - val.startSide) < 0) continue;
            if (newPos < 0) newPos = newFrom;
            if (val.point) maxPoint = Math.max(maxPoint, newTo - newFrom);
            value.push(val);
            from.push(newFrom - newPos);
            to.push(newTo - newPos);
        }
        return {
            mapped: value.length ? new $6b8f387faea0a4dd$var$Chunk(from, to, value, maxPoint) : null,
            pos: newPos
        };
    }
}
/**
A range set stores a collection of [ranges](https://codemirror.net/6/docs/ref/#state.Range) in a
way that makes them efficient to [map](https://codemirror.net/6/docs/ref/#state.RangeSet.map) and
[update](https://codemirror.net/6/docs/ref/#state.RangeSet.update). This is an immutable data
structure.
*/ class $6b8f387faea0a4dd$export$34cb5241245008dd {
    constructor(/**
    @internal
    */ chunkPos, /**
    @internal
    */ chunk, /**
    @internal
    */ nextLayer, /**
    @internal
    */ maxPoint){
        this.chunkPos = chunkPos;
        this.chunk = chunk;
        this.nextLayer = nextLayer;
        this.maxPoint = maxPoint;
    }
    /**
    @internal
    */ static create(chunkPos, chunk, nextLayer, maxPoint) {
        return new $6b8f387faea0a4dd$export$34cb5241245008dd(chunkPos, chunk, nextLayer, maxPoint);
    }
    /**
    @internal
    */ get length() {
        let last = this.chunk.length - 1;
        return last < 0 ? 0 : Math.max(this.chunkEnd(last), this.nextLayer.length);
    }
    /**
    The number of ranges in the set.
    */ get size() {
        if (this.isEmpty) return 0;
        let size = this.nextLayer.size;
        for (let chunk of this.chunk)size += chunk.value.length;
        return size;
    }
    /**
    @internal
    */ chunkEnd(index) {
        return this.chunkPos[index] + this.chunk[index].length;
    }
    /**
    Update the range set, optionally adding new ranges or filtering
    out existing ones.
    
    (Note: The type parameter is just there as a kludge to work
    around TypeScript variance issues that prevented `RangeSet<X>`
    from being a subtype of `RangeSet<Y>` when `X` is a subtype of
    `Y`.)
    */ update(updateSpec) {
        let { add: add = [], sort: sort = false, filterFrom: filterFrom = 0, filterTo: filterTo = this.length } = updateSpec;
        let filter = updateSpec.filter;
        if (add.length == 0 && !filter) return this;
        if (sort) add = add.slice().sort($6b8f387faea0a4dd$var$cmpRange);
        if (this.isEmpty) return add.length ? $6b8f387faea0a4dd$export$34cb5241245008dd.of(add) : this;
        let cur = new $6b8f387faea0a4dd$var$LayerCursor(this, null, -1).goto(0), i = 0, spill = [];
        let builder = new $6b8f387faea0a4dd$export$89e09ce03c7e8594();
        while(cur.value || i < add.length){
            if (i < add.length && (cur.from - add[i].from || cur.startSide - add[i].value.startSide) >= 0) {
                let range = add[i++];
                if (!builder.addInner(range.from, range.to, range.value)) spill.push(range);
            } else if (cur.rangeIndex == 1 && cur.chunkIndex < this.chunk.length && (i == add.length || this.chunkEnd(cur.chunkIndex) < add[i].from) && (!filter || filterFrom > this.chunkEnd(cur.chunkIndex) || filterTo < this.chunkPos[cur.chunkIndex]) && builder.addChunk(this.chunkPos[cur.chunkIndex], this.chunk[cur.chunkIndex])) cur.nextChunk();
            else {
                if (!filter || filterFrom > cur.to || filterTo < cur.from || filter(cur.from, cur.to, cur.value)) {
                    if (!builder.addInner(cur.from, cur.to, cur.value)) spill.push($6b8f387faea0a4dd$export$9a58ef0d7ad3278c.create(cur.from, cur.to, cur.value));
                }
                cur.next();
            }
        }
        return builder.finishInner(this.nextLayer.isEmpty && !spill.length ? $6b8f387faea0a4dd$export$34cb5241245008dd.empty : this.nextLayer.update({
            add: spill,
            filter: filter,
            filterFrom: filterFrom,
            filterTo: filterTo
        }));
    }
    /**
    Map this range set through a set of changes, return the new set.
    */ map(changes) {
        if (changes.empty || this.isEmpty) return this;
        let chunks = [], chunkPos = [], maxPoint = -1;
        for(let i = 0; i < this.chunk.length; i++){
            let start = this.chunkPos[i], chunk = this.chunk[i];
            let touch = changes.touchesRange(start, start + chunk.length);
            if (touch === false) {
                maxPoint = Math.max(maxPoint, chunk.maxPoint);
                chunks.push(chunk);
                chunkPos.push(changes.mapPos(start));
            } else if (touch === true) {
                let { mapped: mapped, pos: pos } = chunk.map(start, changes);
                if (mapped) {
                    maxPoint = Math.max(maxPoint, mapped.maxPoint);
                    chunks.push(mapped);
                    chunkPos.push(pos);
                }
            }
        }
        let next = this.nextLayer.map(changes);
        return chunks.length == 0 ? next : new $6b8f387faea0a4dd$export$34cb5241245008dd(chunkPos, chunks, next || $6b8f387faea0a4dd$export$34cb5241245008dd.empty, maxPoint);
    }
    /**
    Iterate over the ranges that touch the region `from` to `to`,
    calling `f` for each. There is no guarantee that the ranges will
    be reported in any specific order. When the callback returns
    `false`, iteration stops.
    */ between(from, to, f) {
        if (this.isEmpty) return;
        for(let i = 0; i < this.chunk.length; i++){
            let start = this.chunkPos[i], chunk = this.chunk[i];
            if (to >= start && from <= start + chunk.length && chunk.between(start, from - start, to - start, f) === false) return;
        }
        this.nextLayer.between(from, to, f);
    }
    /**
    Iterate over the ranges in this set, in order, including all
    ranges that end at or after `from`.
    */ iter(from = 0) {
        return $6b8f387faea0a4dd$var$HeapCursor.from([
            this
        ]).goto(from);
    }
    /**
    @internal
    */ get isEmpty() {
        return this.nextLayer == this;
    }
    /**
    Iterate over the ranges in a collection of sets, in order,
    starting from `from`.
    */ static iter(sets, from = 0) {
        return $6b8f387faea0a4dd$var$HeapCursor.from(sets).goto(from);
    }
    /**
    Iterate over two groups of sets, calling methods on `comparator`
    to notify it of possible differences.
    */ static compare(oldSets, newSets, /**
    This indicates how the underlying data changed between these
    ranges, and is needed to synchronize the iteration.
    */ textDiff, comparator, /**
    Can be used to ignore all non-point ranges, and points below
    the given size. When -1, all ranges are compared.
    */ minPointSize = -1) {
        let a = oldSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        let b = newSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        let sharedChunks = $6b8f387faea0a4dd$var$findSharedChunks(a, b, textDiff);
        let sideA = new $6b8f387faea0a4dd$var$SpanCursor(a, sharedChunks, minPointSize);
        let sideB = new $6b8f387faea0a4dd$var$SpanCursor(b, sharedChunks, minPointSize);
        textDiff.iterGaps((fromA, fromB, length)=>$6b8f387faea0a4dd$var$compare(sideA, fromA, sideB, fromB, length, comparator));
        if (textDiff.empty && textDiff.length == 0) $6b8f387faea0a4dd$var$compare(sideA, 0, sideB, 0, 0, comparator);
    }
    /**
    Compare the contents of two groups of range sets, returning true
    if they are equivalent in the given range.
    */ static eq(oldSets, newSets, from = 0, to) {
        if (to == null) to = 999999999;
        let a = oldSets.filter((set)=>!set.isEmpty && newSets.indexOf(set) < 0);
        let b = newSets.filter((set)=>!set.isEmpty && oldSets.indexOf(set) < 0);
        if (a.length != b.length) return false;
        if (!a.length) return true;
        let sharedChunks = $6b8f387faea0a4dd$var$findSharedChunks(a, b);
        let sideA = new $6b8f387faea0a4dd$var$SpanCursor(a, sharedChunks, 0).goto(from), sideB = new $6b8f387faea0a4dd$var$SpanCursor(b, sharedChunks, 0).goto(from);
        for(;;){
            if (sideA.to != sideB.to || !$6b8f387faea0a4dd$var$sameValues(sideA.active, sideB.active) || sideA.point && (!sideB.point || !sideA.point.eq(sideB.point))) return false;
            if (sideA.to > to) return true;
            sideA.next();
            sideB.next();
        }
    }
    /**
    Iterate over a group of range sets at the same time, notifying
    the iterator about the ranges covering every given piece of
    content. Returns the open count (see
    [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
    of the iteration.
    */ static spans(sets, from, to, iterator, /**
    When given and greater than -1, only points of at least this
    size are taken into account.
    */ minPointSize = -1) {
        let cursor = new $6b8f387faea0a4dd$var$SpanCursor(sets, null, minPointSize).goto(from), pos = from;
        let openRanges = cursor.openStart;
        for(;;){
            let curTo = Math.min(cursor.to, to);
            if (cursor.point) {
                let active = cursor.activeForPoint(cursor.to);
                let openCount = cursor.pointFrom < from ? active.length + 1 : cursor.point.startSide < 0 ? active.length : Math.min(active.length, openRanges);
                iterator.point(pos, curTo, cursor.point, active, openCount, cursor.pointRank);
                openRanges = Math.min(cursor.openEnd(curTo), active.length);
            } else if (curTo > pos) {
                iterator.span(pos, curTo, cursor.active, openRanges);
                openRanges = cursor.openEnd(curTo);
            }
            if (cursor.to > to) return openRanges + (cursor.point && cursor.to > to ? 1 : 0);
            pos = cursor.to;
            cursor.next();
        }
    }
    /**
    Create a range set for the given range or array of ranges. By
    default, this expects the ranges to be _sorted_ (by start
    position and, if two start at the same position,
    `value.startSide`). You can pass `true` as second argument to
    cause the method to sort them.
    */ static of(ranges, sort = false) {
        let build = new $6b8f387faea0a4dd$export$89e09ce03c7e8594();
        for (let range of ranges instanceof $6b8f387faea0a4dd$export$9a58ef0d7ad3278c ? [
            ranges
        ] : sort ? $6b8f387faea0a4dd$var$lazySort(ranges) : ranges)build.add(range.from, range.to, range.value);
        return build.finish();
    }
    /**
    Join an array of range sets into a single set.
    */ static join(sets) {
        if (!sets.length) return $6b8f387faea0a4dd$export$34cb5241245008dd.empty;
        let result = sets[sets.length - 1];
        for(let i = sets.length - 2; i >= 0; i--)for(let layer = sets[i]; layer != $6b8f387faea0a4dd$export$34cb5241245008dd.empty; layer = layer.nextLayer)result = new $6b8f387faea0a4dd$export$34cb5241245008dd(layer.chunkPos, layer.chunk, result, Math.max(layer.maxPoint, result.maxPoint));
        return result;
    }
}
/**
The empty set of ranges.
*/ $6b8f387faea0a4dd$export$34cb5241245008dd.empty = /*@__PURE__*/ new $6b8f387faea0a4dd$export$34cb5241245008dd([], [], null, -1);
function $6b8f387faea0a4dd$var$lazySort(ranges) {
    if (ranges.length > 1) for(let prev = ranges[0], i = 1; i < ranges.length; i++){
        let cur = ranges[i];
        if ($6b8f387faea0a4dd$var$cmpRange(prev, cur) > 0) return ranges.slice().sort($6b8f387faea0a4dd$var$cmpRange);
        prev = cur;
    }
    return ranges;
}
$6b8f387faea0a4dd$export$34cb5241245008dd.empty.nextLayer = $6b8f387faea0a4dd$export$34cb5241245008dd.empty;
/**
A range set builder is a data structure that helps build up a
[range set](https://codemirror.net/6/docs/ref/#state.RangeSet) directly, without first allocating
an array of [`Range`](https://codemirror.net/6/docs/ref/#state.Range) objects.
*/ class $6b8f387faea0a4dd$export$89e09ce03c7e8594 {
    finishChunk(newArrays) {
        this.chunks.push(new $6b8f387faea0a4dd$var$Chunk(this.from, this.to, this.value, this.maxPoint));
        this.chunkPos.push(this.chunkStart);
        this.chunkStart = -1;
        this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint);
        this.maxPoint = -1;
        if (newArrays) {
            this.from = [];
            this.to = [];
            this.value = [];
        }
    }
    /**
    Create an empty builder.
    */ constructor(){
        this.chunks = [];
        this.chunkPos = [];
        this.chunkStart = -1;
        this.last = null;
        this.lastFrom = -1000000000 /* C.Far */ ;
        this.lastTo = -1000000000 /* C.Far */ ;
        this.from = [];
        this.to = [];
        this.value = [];
        this.maxPoint = -1;
        this.setMaxPoint = -1;
        this.nextLayer = null;
    }
    /**
    Add a range. Ranges should be added in sorted (by `from` and
    `value.startSide`) order.
    */ add(from, to, value) {
        if (!this.addInner(from, to, value)) (this.nextLayer || (this.nextLayer = new $6b8f387faea0a4dd$export$89e09ce03c7e8594)).add(from, to, value);
    }
    /**
    @internal
    */ addInner(from, to, value) {
        let diff = from - this.lastTo || value.startSide - this.last.endSide;
        if (diff <= 0 && (from - this.lastFrom || value.startSide - this.last.startSide) < 0) throw new Error("Ranges must be added sorted by `from` position and `startSide`");
        if (diff < 0) return false;
        if (this.from.length == 250 /* C.ChunkSize */ ) this.finishChunk(true);
        if (this.chunkStart < 0) this.chunkStart = from;
        this.from.push(from - this.chunkStart);
        this.to.push(to - this.chunkStart);
        this.last = value;
        this.lastFrom = from;
        this.lastTo = to;
        this.value.push(value);
        if (value.point) this.maxPoint = Math.max(this.maxPoint, to - from);
        return true;
    }
    /**
    @internal
    */ addChunk(from, chunk) {
        if ((from - this.lastTo || chunk.value[0].startSide - this.last.endSide) < 0) return false;
        if (this.from.length) this.finishChunk(true);
        this.setMaxPoint = Math.max(this.setMaxPoint, chunk.maxPoint);
        this.chunks.push(chunk);
        this.chunkPos.push(from);
        let last = chunk.value.length - 1;
        this.last = chunk.value[last];
        this.lastFrom = chunk.from[last] + from;
        this.lastTo = chunk.to[last] + from;
        return true;
    }
    /**
    Finish the range set. Returns the new set. The builder can't be
    used anymore after this has been called.
    */ finish() {
        return this.finishInner($6b8f387faea0a4dd$export$34cb5241245008dd.empty);
    }
    /**
    @internal
    */ finishInner(next) {
        if (this.from.length) this.finishChunk(false);
        if (this.chunks.length == 0) return next;
        let result = $6b8f387faea0a4dd$export$34cb5241245008dd.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(next) : next, this.setMaxPoint);
        this.from = null; // Make sure further `add` calls produce errors
        return result;
    }
}
function $6b8f387faea0a4dd$var$findSharedChunks(a, b, textDiff) {
    let inA = new Map();
    for (let set of a)for(let i = 0; i < set.chunk.length; i++)if (set.chunk[i].maxPoint <= 0) inA.set(set.chunk[i], set.chunkPos[i]);
    let shared = new Set();
    for (let set of b)for(let i = 0; i < set.chunk.length; i++){
        let known = inA.get(set.chunk[i]);
        if (known != null && (textDiff ? textDiff.mapPos(known) : known) == set.chunkPos[i] && !(textDiff === null || textDiff === void 0 ? void 0 : textDiff.touchesRange(known, known + set.chunk[i].length))) shared.add(set.chunk[i]);
    }
    return shared;
}
class $6b8f387faea0a4dd$var$LayerCursor {
    constructor(layer, skip, minPoint, rank = 0){
        this.layer = layer;
        this.skip = skip;
        this.minPoint = minPoint;
        this.rank = rank;
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    get endSide() {
        return this.value ? this.value.endSide : 0;
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        this.chunkIndex = this.rangeIndex = 0;
        this.gotoInner(pos, side, false);
        return this;
    }
    gotoInner(pos, side, forward) {
        while(this.chunkIndex < this.layer.chunk.length){
            let next = this.layer.chunk[this.chunkIndex];
            if (!(this.skip && this.skip.has(next) || this.layer.chunkEnd(this.chunkIndex) < pos || next.maxPoint < this.minPoint)) break;
            this.chunkIndex++;
            forward = false;
        }
        if (this.chunkIndex < this.layer.chunk.length) {
            let rangeIndex = this.layer.chunk[this.chunkIndex].findIndex(pos - this.layer.chunkPos[this.chunkIndex], side, true);
            if (!forward || this.rangeIndex < rangeIndex) this.setRangeIndex(rangeIndex);
        }
        this.next();
    }
    forward(pos, side) {
        if ((this.to - pos || this.endSide - side) < 0) this.gotoInner(pos, side, true);
    }
    next() {
        for(;;)if (this.chunkIndex == this.layer.chunk.length) {
            this.from = this.to = 1000000000 /* C.Far */ ;
            this.value = null;
            break;
        } else {
            let chunkPos = this.layer.chunkPos[this.chunkIndex], chunk = this.layer.chunk[this.chunkIndex];
            let from = chunkPos + chunk.from[this.rangeIndex];
            this.from = from;
            this.to = chunkPos + chunk.to[this.rangeIndex];
            this.value = chunk.value[this.rangeIndex];
            this.setRangeIndex(this.rangeIndex + 1);
            if (this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint) break;
        }
    }
    setRangeIndex(index) {
        if (index == this.layer.chunk[this.chunkIndex].value.length) {
            this.chunkIndex++;
            if (this.skip) while(this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]))this.chunkIndex++;
            this.rangeIndex = 0;
        } else this.rangeIndex = index;
    }
    nextChunk() {
        this.chunkIndex++;
        this.rangeIndex = 0;
        this.next();
    }
    compare(other) {
        return this.from - other.from || this.startSide - other.startSide || this.rank - other.rank || this.to - other.to || this.endSide - other.endSide;
    }
}
class $6b8f387faea0a4dd$var$HeapCursor {
    constructor(heap){
        this.heap = heap;
    }
    static from(sets, skip = null, minPoint = -1) {
        let heap = [];
        for(let i = 0; i < sets.length; i++){
            for(let cur = sets[i]; !cur.isEmpty; cur = cur.nextLayer)if (cur.maxPoint >= minPoint) heap.push(new $6b8f387faea0a4dd$var$LayerCursor(cur, skip, minPoint, i));
        }
        return heap.length == 1 ? heap[0] : new $6b8f387faea0a4dd$var$HeapCursor(heap);
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        for (let cur of this.heap)cur.goto(pos, side);
        for(let i = this.heap.length >> 1; i >= 0; i--)$6b8f387faea0a4dd$var$heapBubble(this.heap, i);
        this.next();
        return this;
    }
    forward(pos, side) {
        for (let cur of this.heap)cur.forward(pos, side);
        for(let i = this.heap.length >> 1; i >= 0; i--)$6b8f387faea0a4dd$var$heapBubble(this.heap, i);
        if ((this.to - pos || this.value.endSide - side) < 0) this.next();
    }
    next() {
        if (this.heap.length == 0) {
            this.from = this.to = 1000000000 /* C.Far */ ;
            this.value = null;
            this.rank = -1;
        } else {
            let top = this.heap[0];
            this.from = top.from;
            this.to = top.to;
            this.value = top.value;
            this.rank = top.rank;
            if (top.value) top.next();
            $6b8f387faea0a4dd$var$heapBubble(this.heap, 0);
        }
    }
}
function $6b8f387faea0a4dd$var$heapBubble(heap, index) {
    for(let cur = heap[index];;){
        let childIndex = (index << 1) + 1;
        if (childIndex >= heap.length) break;
        let child = heap[childIndex];
        if (childIndex + 1 < heap.length && child.compare(heap[childIndex + 1]) >= 0) {
            child = heap[childIndex + 1];
            childIndex++;
        }
        if (cur.compare(child) < 0) break;
        heap[childIndex] = cur;
        heap[index] = child;
        index = childIndex;
    }
}
class $6b8f387faea0a4dd$var$SpanCursor {
    constructor(sets, skip, minPoint){
        this.minPoint = minPoint;
        this.active = [];
        this.activeTo = [];
        this.activeRank = [];
        this.minActive = -1;
        // A currently active point range, if any
        this.point = null;
        this.pointFrom = 0;
        this.pointRank = 0;
        this.to = -1000000000 /* C.Far */ ;
        this.endSide = 0;
        // The amount of open active ranges at the start of the iterator.
        // Not including points.
        this.openStart = -1;
        this.cursor = $6b8f387faea0a4dd$var$HeapCursor.from(sets, skip, minPoint);
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        this.cursor.goto(pos, side);
        this.active.length = this.activeTo.length = this.activeRank.length = 0;
        this.minActive = -1;
        this.to = pos;
        this.endSide = side;
        this.openStart = -1;
        this.next();
        return this;
    }
    forward(pos, side) {
        while(this.minActive > -1 && (this.activeTo[this.minActive] - pos || this.active[this.minActive].endSide - side) < 0)this.removeActive(this.minActive);
        this.cursor.forward(pos, side);
    }
    removeActive(index) {
        $6b8f387faea0a4dd$var$remove(this.active, index);
        $6b8f387faea0a4dd$var$remove(this.activeTo, index);
        $6b8f387faea0a4dd$var$remove(this.activeRank, index);
        this.minActive = $6b8f387faea0a4dd$var$findMinIndex(this.active, this.activeTo);
    }
    addActive(trackOpen) {
        let i = 0, { value: value, to: to, rank: rank } = this.cursor;
        // Organize active marks by rank first, then by size
        while(i < this.activeRank.length && (rank - this.activeRank[i] || to - this.activeTo[i]) > 0)i++;
        $6b8f387faea0a4dd$var$insert(this.active, i, value);
        $6b8f387faea0a4dd$var$insert(this.activeTo, i, to);
        $6b8f387faea0a4dd$var$insert(this.activeRank, i, rank);
        if (trackOpen) $6b8f387faea0a4dd$var$insert(trackOpen, i, this.cursor.from);
        this.minActive = $6b8f387faea0a4dd$var$findMinIndex(this.active, this.activeTo);
    }
    // After calling this, if `this.point` != null, the next range is a
    // point. Otherwise, it's a regular range, covered by `this.active`.
    next() {
        let from = this.to, wasPoint = this.point;
        this.point = null;
        let trackOpen = this.openStart < 0 ? [] : null;
        for(;;){
            let a = this.minActive;
            if (a > -1 && (this.activeTo[a] - this.cursor.from || this.active[a].endSide - this.cursor.startSide) < 0) {
                if (this.activeTo[a] > from) {
                    this.to = this.activeTo[a];
                    this.endSide = this.active[a].endSide;
                    break;
                }
                this.removeActive(a);
                if (trackOpen) $6b8f387faea0a4dd$var$remove(trackOpen, a);
            } else if (!this.cursor.value) {
                this.to = this.endSide = 1000000000 /* C.Far */ ;
                break;
            } else if (this.cursor.from > from) {
                this.to = this.cursor.from;
                this.endSide = this.cursor.startSide;
                break;
            } else {
                let nextVal = this.cursor.value;
                if (!nextVal.point) {
                    this.addActive(trackOpen);
                    this.cursor.next();
                } else if (wasPoint && this.cursor.to == this.to && this.cursor.from < this.cursor.to) // Ignore any non-empty points that end precisely at the end of the prev point
                this.cursor.next();
                else {
                    this.point = nextVal;
                    this.pointFrom = this.cursor.from;
                    this.pointRank = this.cursor.rank;
                    this.to = this.cursor.to;
                    this.endSide = nextVal.endSide;
                    this.cursor.next();
                    this.forward(this.to, this.endSide);
                    break;
                }
            }
        }
        if (trackOpen) {
            this.openStart = 0;
            for(let i = trackOpen.length - 1; i >= 0 && trackOpen[i] < from; i--)this.openStart++;
        }
    }
    activeForPoint(to) {
        if (!this.active.length) return this.active;
        let active = [];
        for(let i = this.active.length - 1; i >= 0; i--){
            if (this.activeRank[i] < this.pointRank) break;
            if (this.activeTo[i] > to || this.activeTo[i] == to && this.active[i].endSide >= this.point.endSide) active.push(this.active[i]);
        }
        return active.reverse();
    }
    openEnd(to) {
        let open = 0;
        for(let i = this.activeTo.length - 1; i >= 0 && this.activeTo[i] > to; i--)open++;
        return open;
    }
}
function $6b8f387faea0a4dd$var$compare(a, startA, b, startB, length, comparator) {
    a.goto(startA);
    b.goto(startB);
    let endB = startB + length;
    let pos = startB, dPos = startB - startA;
    for(;;){
        let dEnd = a.to + dPos - b.to, diff = dEnd || a.endSide - b.endSide;
        let end = diff < 0 ? a.to + dPos : b.to, clipEnd = Math.min(end, endB);
        if (a.point || b.point) {
            if (!(a.point && b.point && (a.point == b.point || a.point.eq(b.point)) && $6b8f387faea0a4dd$var$sameValues(a.activeForPoint(a.to), b.activeForPoint(b.to)))) comparator.comparePoint(pos, clipEnd, a.point, b.point);
        } else if (clipEnd > pos && !$6b8f387faea0a4dd$var$sameValues(a.active, b.active)) comparator.compareRange(pos, clipEnd, a.active, b.active);
        if (end > endB) break;
        if ((dEnd || a.openEnd != b.openEnd) && comparator.boundChange) comparator.boundChange(end);
        pos = end;
        if (diff <= 0) a.next();
        if (diff >= 0) b.next();
    }
}
function $6b8f387faea0a4dd$var$sameValues(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (a[i] != b[i] && !a[i].eq(b[i])) return false;
    return true;
}
function $6b8f387faea0a4dd$var$remove(array, index) {
    for(let i = index, e = array.length - 1; i < e; i++)array[i] = array[i + 1];
    array.pop();
}
function $6b8f387faea0a4dd$var$insert(array, index, value) {
    for(let i = array.length - 1; i >= index; i--)array[i + 1] = array[i];
    array[index] = value;
}
function $6b8f387faea0a4dd$var$findMinIndex(value, array) {
    let found = -1, foundPos = 1000000000 /* C.Far */ ;
    for(let i = 0; i < array.length; i++)if ((array[i] - foundPos || value[i].endSide - value[found].endSide) < 0) {
        found = i;
        foundPos = array[i];
    }
    return found;
}
/**
Count the column position at the given offset into the string,
taking extending characters and tab size into account.
*/ function $6b8f387faea0a4dd$export$20b4ab289374d0ac(string, tabSize, to = string.length) {
    let n = 0;
    for(let i = 0; i < to && i < string.length;)if (string.charCodeAt(i) == 9) {
        n += tabSize - n % tabSize;
        i++;
    } else {
        n++;
        i = $6b8f387faea0a4dd$export$a0fa439fd515e1ed(string, i);
    }
    return n;
}
/**
Find the offset that corresponds to the given column position in a
string, taking extending characters and tab size into account. By
default, the string length is returned when it is too short to
reach the column. Pass `strict` true to make it return -1 in that
situation.
*/ function $6b8f387faea0a4dd$export$718b3d71c384ca05(string, col, tabSize, strict) {
    for(let i = 0, n = 0;;){
        if (n >= col) return i;
        if (i == string.length) break;
        n += string.charCodeAt(i) == 9 ? tabSize - n % tabSize : 1;
        i = $6b8f387faea0a4dd$export$a0fa439fd515e1ed(string, i);
    }
    return strict === true ? -1 : string.length;
}



const $efbdc34cfdde3fb8$var$C = "\u037c";
const $efbdc34cfdde3fb8$var$COUNT = typeof Symbol == "undefined" ? "__" + $efbdc34cfdde3fb8$var$C : Symbol.for($efbdc34cfdde3fb8$var$C);
const $efbdc34cfdde3fb8$var$SET = typeof Symbol == "undefined" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet");
const $efbdc34cfdde3fb8$var$top = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : {};
class $efbdc34cfdde3fb8$export$b920c662d2efee20 {
    // :: (Object<Style>, ?{finish: ?(string) → string})
    // Create a style module from the given spec.
    //
    // When `finish` is given, it is called on regular (non-`@`)
    // selectors (after `&` expansion) to compute the final selector.
    constructor(spec, options){
        this.rules = [];
        let { finish: finish } = options || {};
        function splitSelector(selector) {
            return /^@/.test(selector) ? [
                selector
            ] : selector.split(/,\s*/);
        }
        function render(selectors, spec, target, isKeyframes) {
            let local = [], isAt = /^@(\w+)\b/.exec(selectors[0]), keyframes = isAt && isAt[1] == "keyframes";
            if (isAt && spec == null) return target.push(selectors[0] + ";");
            for(let prop in spec){
                let value = spec[prop];
                if (/&/.test(prop)) render(prop.split(/,\s*/).map((part)=>selectors.map((sel)=>part.replace(/&/, sel))).reduce((a, b)=>a.concat(b)), value, target);
                else if (value && typeof value == "object") {
                    if (!isAt) throw new RangeError("The value of a property (" + prop + ") should be a primitive value.");
                    render(splitSelector(prop), value, local, keyframes);
                } else if (value != null) local.push(prop.replace(/_.*/, "").replace(/[A-Z]/g, (l)=>"-" + l.toLowerCase()) + ": " + value + ";");
            }
            if (local.length || keyframes) target.push((finish && !isAt && !isKeyframes ? selectors.map(finish) : selectors).join(", ") + " {" + local.join(" ") + "}");
        }
        for(let prop in spec)render(splitSelector(prop), spec[prop], this.rules);
    }
    // :: () → string
    // Returns a string containing the module's CSS rules.
    getRules() {
        return this.rules.join("\n");
    }
    // :: () → string
    // Generate a new unique CSS class name.
    static newName() {
        let id = $efbdc34cfdde3fb8$var$top[$efbdc34cfdde3fb8$var$COUNT] || 1;
        $efbdc34cfdde3fb8$var$top[$efbdc34cfdde3fb8$var$COUNT] = id + 1;
        return $efbdc34cfdde3fb8$var$C + id.toString(36);
    }
    // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
    //
    // Mount the given set of modules in the given DOM root, which ensures
    // that the CSS rules defined by the module are available in that
    // context.
    //
    // Rules are only added to the document once per root.
    //
    // Rule order will follow the order of the modules, so that rules from
    // modules later in the array take precedence of those from earlier
    // modules. If you call this function multiple times for the same root
    // in a way that changes the order of already mounted modules, the old
    // order will be changed.
    //
    // If a Content Security Policy nonce is provided, it is added to
    // the `<style>` tag generated by the library.
    static mount(root, modules, options) {
        let set = root[$efbdc34cfdde3fb8$var$SET], nonce = options && options.nonce;
        if (!set) set = new $efbdc34cfdde3fb8$var$StyleSet(root, nonce);
        else if (nonce) set.setNonce(nonce);
        set.mount(Array.isArray(modules) ? modules : [
            modules
        ], root);
    }
}
let $efbdc34cfdde3fb8$var$adoptedSet = new Map //<Document, StyleSet>
;
class $efbdc34cfdde3fb8$var$StyleSet {
    constructor(root, nonce){
        let doc = root.ownerDocument || root, win = doc.defaultView;
        if (!root.head && root.adoptedStyleSheets && win.CSSStyleSheet) {
            let adopted = $efbdc34cfdde3fb8$var$adoptedSet.get(doc);
            if (adopted) return root[$efbdc34cfdde3fb8$var$SET] = adopted;
            this.sheet = new win.CSSStyleSheet;
            $efbdc34cfdde3fb8$var$adoptedSet.set(doc, this);
        } else {
            this.styleTag = doc.createElement("style");
            if (nonce) this.styleTag.setAttribute("nonce", nonce);
        }
        this.modules = [];
        root[$efbdc34cfdde3fb8$var$SET] = this;
    }
    mount(modules, root) {
        let sheet = this.sheet;
        let pos = 0 /* Current rule offset */ , j = 0 /* Index into this.modules */ ;
        for(let i = 0; i < modules.length; i++){
            let mod = modules[i], index = this.modules.indexOf(mod);
            if (index < j && index > -1) {
                this.modules.splice(index, 1);
                j--;
                index = -1;
            }
            if (index == -1) {
                this.modules.splice(j++, 0, mod);
                if (sheet) for(let k = 0; k < mod.rules.length; k++)sheet.insertRule(mod.rules[k], pos++);
            } else {
                while(j < index)pos += this.modules[j++].rules.length;
                pos += mod.rules.length;
                j++;
            }
        }
        if (sheet) {
            if (root.adoptedStyleSheets.indexOf(this.sheet) < 0) root.adoptedStyleSheets = [
                this.sheet,
                ...root.adoptedStyleSheets
            ];
        } else {
            let text = "";
            for(let i = 0; i < this.modules.length; i++)text += this.modules[i].getRules() + "\n";
            this.styleTag.textContent = text;
            let target = root.head || root;
            if (this.styleTag.parentNode != target) target.insertBefore(this.styleTag, target.firstChild);
        }
    }
    setNonce(nonce) {
        if (this.styleTag && this.styleTag.getAttribute("nonce") != nonce) this.styleTag.setAttribute("nonce", nonce);
    }
} // Style::Object<union<Style,string>>
 //
 // A style is an object that, in the simple case, maps CSS property
 // names to strings holding their values, as in `{color: "red",
 // fontWeight: "bold"}`. The property names can be given in
 // camel-case—the library will insert a dash before capital letters
 // when converting them to CSS.
 //
 // If you include an underscore in a property name, it and everything
 // after it will be removed from the output, which can be useful when
 // providing a property multiple times, for browser compatibility
 // reasons.
 //
 // A property in a style object can also be a sub-selector, which
 // extends the current context to add a pseudo-selector or a child
 // selector. Such a property should contain a `&` character, which
 // will be replaced by the current selector. For example `{"&:before":
 // {content: '"hi"'}}`. Sub-selectors and regular properties can
 // freely be mixed in a given object. Any property containing a `&` is
 // assumed to be a sub-selector.
 //
 // Finally, a property can specify an @-block to be wrapped around the
 // styles defined inside the object that's the property's value. For
 // example to create a media query you can do `{"@media screen and
 // (min-width: 400px)": {...}}`.


var $4f3764513e325a7f$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $4f3764513e325a7f$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: "\""
};
var $4f3764513e325a7f$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $4f3764513e325a7f$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $4f3764513e325a7f$var$i = 0; $4f3764513e325a7f$var$i < 10; $4f3764513e325a7f$var$i++)$4f3764513e325a7f$export$e2253033e6e1df16[48 + $4f3764513e325a7f$var$i] = $4f3764513e325a7f$export$e2253033e6e1df16[96 + $4f3764513e325a7f$var$i] = String($4f3764513e325a7f$var$i);
// The function keys
for(var $4f3764513e325a7f$var$i = 1; $4f3764513e325a7f$var$i <= 24; $4f3764513e325a7f$var$i++)$4f3764513e325a7f$export$e2253033e6e1df16[$4f3764513e325a7f$var$i + 111] = "F" + $4f3764513e325a7f$var$i;
// And the alphabetic keys
for(var $4f3764513e325a7f$var$i = 65; $4f3764513e325a7f$var$i <= 90; $4f3764513e325a7f$var$i++){
    $4f3764513e325a7f$export$e2253033e6e1df16[$4f3764513e325a7f$var$i] = String.fromCharCode($4f3764513e325a7f$var$i + 32);
    $4f3764513e325a7f$export$fba63a578e423eb[$4f3764513e325a7f$var$i] = String.fromCharCode($4f3764513e325a7f$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $4f3764513e325a7f$var$code in $4f3764513e325a7f$export$e2253033e6e1df16)if (!$4f3764513e325a7f$export$fba63a578e423eb.hasOwnProperty($4f3764513e325a7f$var$code)) $4f3764513e325a7f$export$fba63a578e423eb[$4f3764513e325a7f$var$code] = $4f3764513e325a7f$export$e2253033e6e1df16[$4f3764513e325a7f$var$code];
function $4f3764513e325a7f$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $4f3764513e325a7f$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $4f3764513e325a7f$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $4f3764513e325a7f$export$fba63a578e423eb : $4f3764513e325a7f$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}


function $2a4351068134afec$export$2e2bcd8739ae039() {
    var elt = arguments[0];
    if (typeof elt == "string") elt = document.createElement(elt);
    var i = 1, next = arguments[1];
    if (next && typeof next == "object" && next.nodeType == null && !Array.isArray(next)) {
        for(var name in next)if (Object.prototype.hasOwnProperty.call(next, name)) {
            var value = next[name];
            if (typeof value == "string") elt.setAttribute(name, value);
            else if (value != null) elt[name] = value;
        }
        i++;
    }
    for(; i < arguments.length; i++)$2a4351068134afec$var$add(elt, arguments[i]);
    return elt;
}
function $2a4351068134afec$var$add(elt, child) {
    if (typeof child == "string") elt.appendChild(document.createTextNode(child));
    else if (child == null) ;
    else if (child.nodeType != null) elt.appendChild(child);
    else if (Array.isArray(child)) for(var i = 0; i < child.length; i++)$2a4351068134afec$var$add(elt, child[i]);
    else throw new RangeError("Unsupported child node: " + child);
}


function $1d528cc0e08a0656$var$getSelection(root) {
    let target;
    // Browsers differ on whether shadow roots have a getSelection
    // method. If it exists, use that, otherwise, call it on the
    // document.
    if (root.nodeType == 11) target = root.getSelection ? root : root.ownerDocument;
    else target = root;
    return target.getSelection();
}
function $1d528cc0e08a0656$var$contains(dom, node) {
    return node ? dom == node || dom.contains(node.nodeType != 1 ? node.parentNode : node) : false;
}
function $1d528cc0e08a0656$var$hasSelection(dom, selection) {
    if (!selection.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return $1d528cc0e08a0656$var$contains(dom, selection.anchorNode);
    } catch (_) {
        return false;
    }
}
function $1d528cc0e08a0656$var$clientRectsFor(dom) {
    if (dom.nodeType == 3) return $1d528cc0e08a0656$var$textRange(dom, 0, dom.nodeValue.length).getClientRects();
    else if (dom.nodeType == 1) return dom.getClientRects();
    else return [];
}
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
function $1d528cc0e08a0656$var$isEquivalentPosition(node, off, targetNode, targetOff) {
    return targetNode ? $1d528cc0e08a0656$var$scanFor(node, off, targetNode, targetOff, -1) || $1d528cc0e08a0656$var$scanFor(node, off, targetNode, targetOff, 1) : false;
}
function $1d528cc0e08a0656$var$domIndex(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
}
function $1d528cc0e08a0656$var$isBlockElement(node) {
    return node.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(node.nodeName);
}
function $1d528cc0e08a0656$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $1d528cc0e08a0656$var$maxOffset(node))) {
            if (node.nodeName == "DIV") return false;
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1) return false;
            off = $1d528cc0e08a0656$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.nodeType == 1 && node.contentEditable == "false") return false;
            off = dir < 0 ? $1d528cc0e08a0656$var$maxOffset(node) : 0;
        } else return false;
    }
}
function $1d528cc0e08a0656$var$maxOffset(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $1d528cc0e08a0656$var$flattenRect(rect, left) {
    let x = left ? rect.left : rect.right;
    return {
        left: x,
        right: x,
        top: rect.top,
        bottom: rect.bottom
    };
}
function $1d528cc0e08a0656$var$windowRect(win) {
    let vp = win.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: win.innerWidth,
        top: 0,
        bottom: win.innerHeight
    };
}
function $1d528cc0e08a0656$var$getScale(elt, rect) {
    let scaleX = rect.width / elt.offsetWidth;
    let scaleY = rect.height / elt.offsetHeight;
    if (scaleX > 0.995 && scaleX < 1.005 || !isFinite(scaleX) || Math.abs(rect.width - elt.offsetWidth) < 1) scaleX = 1;
    if (scaleY > 0.995 && scaleY < 1.005 || !isFinite(scaleY) || Math.abs(rect.height - elt.offsetHeight) < 1) scaleY = 1;
    return {
        scaleX: scaleX,
        scaleY: scaleY
    };
}
function $1d528cc0e08a0656$var$scrollRectIntoView(dom, rect, side, x, y, xMargin, yMargin, ltr) {
    let doc = dom.ownerDocument, win = doc.defaultView || window;
    for(let cur = dom, stop = false; cur && !stop;){
        if (cur.nodeType == 1) {
            let bounding, top = cur == doc.body;
            let scaleX = 1, scaleY = 1;
            if (top) bounding = $1d528cc0e08a0656$var$windowRect(win);
            else {
                if (/^(fixed|sticky)$/.test(getComputedStyle(cur).position)) stop = true;
                if (cur.scrollHeight <= cur.clientHeight && cur.scrollWidth <= cur.clientWidth) {
                    cur = cur.assignedSlot || cur.parentNode;
                    continue;
                }
                let rect = cur.getBoundingClientRect();
                ({ scaleX: scaleX, scaleY: scaleY } = $1d528cc0e08a0656$var$getScale(cur, rect));
                // Make sure scrollbar width isn't included in the rectangle
                bounding = {
                    left: rect.left,
                    right: rect.left + cur.clientWidth * scaleX,
                    top: rect.top,
                    bottom: rect.top + cur.clientHeight * scaleY
                };
            }
            let moveX = 0, moveY = 0;
            if (y == "nearest") {
                if (rect.top < bounding.top) {
                    moveY = rect.top - (bounding.top + yMargin);
                    if (side > 0 && rect.bottom > bounding.bottom + moveY) moveY = rect.bottom - bounding.bottom + yMargin;
                } else if (rect.bottom > bounding.bottom) {
                    moveY = rect.bottom - bounding.bottom + yMargin;
                    if (side < 0 && rect.top - moveY < bounding.top) moveY = rect.top - (bounding.top + yMargin);
                }
            } else {
                let rectHeight = rect.bottom - rect.top, boundingHeight = bounding.bottom - bounding.top;
                let targetTop = y == "center" && rectHeight <= boundingHeight ? rect.top + rectHeight / 2 - boundingHeight / 2 : y == "start" || y == "center" && side < 0 ? rect.top - yMargin : rect.bottom - boundingHeight + yMargin;
                moveY = targetTop - bounding.top;
            }
            if (x == "nearest") {
                if (rect.left < bounding.left) {
                    moveX = rect.left - (bounding.left + xMargin);
                    if (side > 0 && rect.right > bounding.right + moveX) moveX = rect.right - bounding.right + xMargin;
                } else if (rect.right > bounding.right) {
                    moveX = rect.right - bounding.right + xMargin;
                    if (side < 0 && rect.left < bounding.left + moveX) moveX = rect.left - (bounding.left + xMargin);
                }
            } else {
                let targetLeft = x == "center" ? rect.left + (rect.right - rect.left) / 2 - (bounding.right - bounding.left) / 2 : x == "start" == ltr ? rect.left - xMargin : rect.right - (bounding.right - bounding.left) + xMargin;
                moveX = targetLeft - bounding.left;
            }
            if (moveX || moveY) {
                if (top) win.scrollBy(moveX, moveY);
                else {
                    let movedX = 0, movedY = 0;
                    if (moveY) {
                        let start = cur.scrollTop;
                        cur.scrollTop += moveY / scaleY;
                        movedY = (cur.scrollTop - start) * scaleY;
                    }
                    if (moveX) {
                        let start = cur.scrollLeft;
                        cur.scrollLeft += moveX / scaleX;
                        movedX = (cur.scrollLeft - start) * scaleX;
                    }
                    rect = {
                        left: rect.left - movedX,
                        top: rect.top - movedY,
                        right: rect.right - movedX,
                        bottom: rect.bottom - movedY
                    };
                    if (movedX && Math.abs(movedX - moveX) < 1) x = "nearest";
                    if (movedY && Math.abs(movedY - moveY) < 1) y = "nearest";
                }
            }
            if (top) break;
            if (rect.top < bounding.top || rect.bottom > bounding.bottom || rect.left < bounding.left || rect.right > bounding.right) rect = {
                left: Math.max(rect.left, bounding.left),
                right: Math.min(rect.right, bounding.right),
                top: Math.max(rect.top, bounding.top),
                bottom: Math.min(rect.bottom, bounding.bottom)
            };
            cur = cur.assignedSlot || cur.parentNode;
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
}
function $1d528cc0e08a0656$var$scrollableParents(dom) {
    let doc = dom.ownerDocument, x, y;
    for(let cur = dom.parentNode; cur;){
        if (cur == doc.body || x && y) break;
        else if (cur.nodeType == 1) {
            if (!y && cur.scrollHeight > cur.clientHeight) y = cur;
            if (!x && cur.scrollWidth > cur.clientWidth) x = cur;
            cur = cur.assignedSlot || cur.parentNode;
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
    return {
        x: x,
        y: y
    };
}
class $1d528cc0e08a0656$var$DOMSelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    eq(domSel) {
        return this.anchorNode == domSel.anchorNode && this.anchorOffset == domSel.anchorOffset && this.focusNode == domSel.focusNode && this.focusOffset == domSel.focusOffset;
    }
    setRange(range) {
        let { anchorNode: anchorNode, focusNode: focusNode } = range;
        // Clip offsets to node size to avoid crashes when Safari reports bogus offsets (#1152)
        this.set(anchorNode, Math.min(range.anchorOffset, anchorNode ? $1d528cc0e08a0656$var$maxOffset(anchorNode) : 0), focusNode, Math.min(range.focusOffset, focusNode ? $1d528cc0e08a0656$var$maxOffset(focusNode) : 0));
    }
    set(anchorNode, anchorOffset, focusNode, focusOffset) {
        this.anchorNode = anchorNode;
        this.anchorOffset = anchorOffset;
        this.focusNode = focusNode;
        this.focusOffset = focusOffset;
    }
}
let $1d528cc0e08a0656$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $1d528cc0e08a0656$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($1d528cc0e08a0656$var$preventScrollSupported) return dom.focus($1d528cc0e08a0656$var$preventScrollSupported);
    let stack = [];
    for(let cur = dom; cur; cur = cur.parentNode){
        stack.push(cur, cur.scrollTop, cur.scrollLeft);
        if (cur == cur.ownerDocument) break;
    }
    dom.focus($1d528cc0e08a0656$var$preventScrollSupported == null ? {
        get preventScroll () {
            $1d528cc0e08a0656$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$1d528cc0e08a0656$var$preventScrollSupported) {
        $1d528cc0e08a0656$var$preventScrollSupported = false;
        for(let i = 0; i < stack.length;){
            let elt = stack[i++], top = stack[i++], left = stack[i++];
            if (elt.scrollTop != top) elt.scrollTop = top;
            if (elt.scrollLeft != left) elt.scrollLeft = left;
        }
    }
}
let $1d528cc0e08a0656$var$scratchRange;
function $1d528cc0e08a0656$var$textRange(node, from, to = from) {
    let range = $1d528cc0e08a0656$var$scratchRange || ($1d528cc0e08a0656$var$scratchRange = document.createRange());
    range.setEnd(node, to);
    range.setStart(node, from);
    return range;
}
function $1d528cc0e08a0656$var$dispatchKey(elt, name, code, mods) {
    let options = {
        key: name,
        code: name,
        keyCode: code,
        which: code,
        cancelable: true
    };
    if (mods) ({ altKey: options.altKey, ctrlKey: options.ctrlKey, shiftKey: options.shiftKey, metaKey: options.metaKey } = mods);
    let down = new KeyboardEvent("keydown", options);
    down.synthetic = true;
    elt.dispatchEvent(down);
    let up = new KeyboardEvent("keyup", options);
    up.synthetic = true;
    elt.dispatchEvent(up);
    return down.defaultPrevented || up.defaultPrevented;
}
function $1d528cc0e08a0656$var$getRoot(node) {
    while(node){
        if (node && (node.nodeType == 9 || node.nodeType == 11 && node.host)) return node;
        node = node.assignedSlot || node.parentNode;
    }
    return null;
}
function $1d528cc0e08a0656$var$clearAttributes(node) {
    while(node.attributes.length)node.removeAttributeNode(node.attributes[0]);
}
function $1d528cc0e08a0656$var$atElementStart(doc, selection) {
    let node = selection.focusNode, offset = selection.focusOffset;
    if (!node || selection.anchorNode != node || selection.anchorOffset != offset) return false;
    // Safari can report bogus offsets (#1152)
    offset = Math.min(offset, $1d528cc0e08a0656$var$maxOffset(node));
    for(;;){
        if (offset) {
            if (node.nodeType != 1) return false;
            let prev = node.childNodes[offset - 1];
            if (prev.contentEditable == "false") offset--;
            else {
                node = prev;
                offset = $1d528cc0e08a0656$var$maxOffset(node);
            }
        } else if (node == doc) return true;
        else {
            offset = $1d528cc0e08a0656$var$domIndex(node);
            node = node.parentNode;
        }
    }
}
function $1d528cc0e08a0656$var$isScrolledToBottom(elt) {
    return elt.scrollTop > Math.max(1, elt.scrollHeight - elt.clientHeight - 4);
}
function $1d528cc0e08a0656$var$textNodeBefore(startNode, startOffset) {
    for(let node = startNode, offset = startOffset;;){
        if (node.nodeType == 3 && offset > 0) return {
            node: node,
            offset: offset
        };
        else if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $1d528cc0e08a0656$var$maxOffset(node);
        } else if (node.parentNode && !$1d528cc0e08a0656$var$isBlockElement(node)) {
            offset = $1d528cc0e08a0656$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $1d528cc0e08a0656$var$textNodeAfter(startNode, startOffset) {
    for(let node = startNode, offset = startOffset;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return {
            node: node,
            offset: offset
        };
        else if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$1d528cc0e08a0656$var$isBlockElement(node)) {
            offset = $1d528cc0e08a0656$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
class $1d528cc0e08a0656$var$DOMPos {
    constructor(node, offset, precise = true){
        this.node = node;
        this.offset = offset;
        this.precise = precise;
    }
    static before(dom, precise) {
        return new $1d528cc0e08a0656$var$DOMPos(dom.parentNode, $1d528cc0e08a0656$var$domIndex(dom), precise);
    }
    static after(dom, precise) {
        return new $1d528cc0e08a0656$var$DOMPos(dom.parentNode, $1d528cc0e08a0656$var$domIndex(dom) + 1, precise);
    }
}
const $1d528cc0e08a0656$var$noChildren = [];
class $1d528cc0e08a0656$var$ContentView {
    constructor(){
        this.parent = null;
        this.dom = null;
        this.flags = 2 /* ViewFlag.NodeDirty */ ;
    }
    get overrideDOMText() {
        return null;
    }
    get posAtStart() {
        return this.parent ? this.parent.posBefore(this) : 0;
    }
    get posAtEnd() {
        return this.posAtStart + this.length;
    }
    posBefore(view) {
        let pos = this.posAtStart;
        for (let child of this.children){
            if (child == view) return pos;
            pos += child.length + child.breakAfter;
        }
        throw new RangeError("Invalid child in posBefore");
    }
    posAfter(view) {
        return this.posBefore(view) + view.length;
    }
    sync(view, track) {
        if (this.flags & 2 /* ViewFlag.NodeDirty */ ) {
            let parent = this.dom;
            let prev = null, next;
            for (let child of this.children){
                if (child.flags & 7 /* ViewFlag.Dirty */ ) {
                    if (!child.dom && (next = prev ? prev.nextSibling : parent.firstChild)) {
                        let contentView = $1d528cc0e08a0656$var$ContentView.get(next);
                        if (!contentView || !contentView.parent && contentView.canReuseDOM(child)) child.reuseDOM(next);
                    }
                    child.sync(view, track);
                    child.flags &= -8 /* ViewFlag.Dirty */ ;
                }
                next = prev ? prev.nextSibling : parent.firstChild;
                if (track && !track.written && track.node == parent && next != child.dom) track.written = true;
                if (child.dom.parentNode == parent) while(next && next != child.dom)next = $1d528cc0e08a0656$var$rm$1(next);
                else parent.insertBefore(child.dom, next);
                prev = child.dom;
            }
            next = prev ? prev.nextSibling : parent.firstChild;
            if (next && track && track.node == parent) track.written = true;
            while(next)next = $1d528cc0e08a0656$var$rm$1(next);
        } else if (this.flags & 1 /* ViewFlag.ChildDirty */ ) {
            for (let child of this.children)if (child.flags & 7 /* ViewFlag.Dirty */ ) {
                child.sync(view, track);
                child.flags &= -8 /* ViewFlag.Dirty */ ;
            }
        }
    }
    reuseDOM(_dom) {}
    localPosFromDOM(node, offset) {
        let after;
        if (node == this.dom) after = this.dom.childNodes[offset];
        else {
            let bias = $1d528cc0e08a0656$var$maxOffset(node) == 0 ? 0 : offset == 0 ? -1 : 1;
            for(;;){
                let parent = node.parentNode;
                if (parent == this.dom) break;
                if (bias == 0 && parent.firstChild != parent.lastChild) {
                    if (node == parent.firstChild) bias = -1;
                    else bias = 1;
                }
                node = parent;
            }
            if (bias < 0) after = node;
            else after = node.nextSibling;
        }
        if (after == this.dom.firstChild) return 0;
        while(after && !$1d528cc0e08a0656$var$ContentView.get(after))after = after.nextSibling;
        if (!after) return this.length;
        for(let i = 0, pos = 0;; i++){
            let child = this.children[i];
            if (child.dom == after) return pos;
            pos += child.length + child.breakAfter;
        }
    }
    domBoundsAround(from, to, offset = 0) {
        let fromI = -1, fromStart = -1, toI = -1, toEnd = -1;
        for(let i = 0, pos = offset, prevEnd = offset; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (pos < from && end > to) return child.domBoundsAround(from, to, pos);
            if (end >= from && fromI == -1) {
                fromI = i;
                fromStart = pos;
            }
            if (pos > to && child.dom.parentNode == this.dom) {
                toI = i;
                toEnd = prevEnd;
                break;
            }
            prevEnd = end;
            pos = end + child.breakAfter;
        }
        return {
            from: fromStart,
            to: toEnd < 0 ? offset + this.length : toEnd,
            startDOM: (fromI ? this.children[fromI - 1].dom.nextSibling : null) || this.dom.firstChild,
            endDOM: toI < this.children.length && toI >= 0 ? this.children[toI].dom : null
        };
    }
    markDirty(andParent = false) {
        this.flags |= 2 /* ViewFlag.NodeDirty */ ;
        this.markParentsDirty(andParent);
    }
    markParentsDirty(childList) {
        for(let parent = this.parent; parent; parent = parent.parent){
            if (childList) parent.flags |= 2 /* ViewFlag.NodeDirty */ ;
            if (parent.flags & 1 /* ViewFlag.ChildDirty */ ) return;
            parent.flags |= 1 /* ViewFlag.ChildDirty */ ;
            childList = false;
        }
    }
    setParent(parent) {
        if (this.parent != parent) {
            this.parent = parent;
            if (this.flags & 7 /* ViewFlag.Dirty */ ) this.markParentsDirty(true);
        }
    }
    setDOM(dom) {
        if (this.dom == dom) return;
        if (this.dom) this.dom.cmView = null;
        this.dom = dom;
        dom.cmView = this;
    }
    get rootView() {
        for(let v = this;;){
            let parent = v.parent;
            if (!parent) return v;
            v = parent;
        }
    }
    replaceChildren(from, to, children = $1d528cc0e08a0656$var$noChildren) {
        this.markDirty();
        for(let i = from; i < to; i++){
            let child = this.children[i];
            if (child.parent == this && children.indexOf(child) < 0) child.destroy();
        }
        if (children.length < 250) this.children.splice(from, to - from, ...children);
        else this.children = [].concat(this.children.slice(0, from), children, this.children.slice(to));
        for(let i = 0; i < children.length; i++)children[i].setParent(this);
    }
    ignoreMutation(_rec) {
        return false;
    }
    ignoreEvent(_event) {
        return false;
    }
    childCursor(pos = this.length) {
        return new $1d528cc0e08a0656$var$ChildCursor(this.children, pos, this.children.length);
    }
    childPos(pos, bias = 1) {
        return this.childCursor().findPos(pos, bias);
    }
    toString() {
        let name = this.constructor.name.replace("View", "");
        return name + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (name == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
    }
    static get(node) {
        return node.cmView;
    }
    get isEditable() {
        return true;
    }
    get isWidget() {
        return false;
    }
    get isHidden() {
        return false;
    }
    merge(from, to, source, hasStart, openStart, openEnd) {
        return false;
    }
    become(other) {
        return false;
    }
    canReuseDOM(other) {
        return other.constructor == this.constructor && !((this.flags | other.flags) & 8 /* ViewFlag.Composition */ );
    }
    // When this is a zero-length view with a side, this should return a
    // number <= 0 to indicate it is before its position, or a
    // number > 0 when after its position.
    getSide() {
        return 0;
    }
    destroy() {
        for (let child of this.children)if (child.parent == this) child.destroy();
        this.parent = null;
    }
}
$1d528cc0e08a0656$var$ContentView.prototype.breakAfter = 0;
// Remove a DOM node and return its next sibling.
function $1d528cc0e08a0656$var$rm$1(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
class $1d528cc0e08a0656$var$ChildCursor {
    constructor(children, pos, i){
        this.children = children;
        this.pos = pos;
        this.i = i;
        this.off = 0;
    }
    findPos(pos, bias = 1) {
        for(;;){
            if (pos > this.pos || pos == this.pos && (bias > 0 || this.i == 0 || this.children[this.i - 1].breakAfter)) {
                this.off = pos - this.pos;
                return this;
            }
            let next = this.children[--this.i];
            this.pos -= next.length + next.breakAfter;
        }
    }
}
function $1d528cc0e08a0656$var$replaceRange(parent, fromI, fromOff, toI, toOff, insert, breakAtStart, openStart, openEnd) {
    let { children: children } = parent;
    let before = children.length ? children[fromI] : null;
    let last = insert.length ? insert[insert.length - 1] : null;
    let breakAtEnd = last ? last.breakAfter : breakAtStart;
    // Change within a single child
    if (fromI == toI && before && !breakAtStart && !breakAtEnd && insert.length < 2 && before.merge(fromOff, toOff, insert.length ? last : null, fromOff == 0, openStart, openEnd)) return;
    if (toI < children.length) {
        let after = children[toI];
        // Make sure the end of the child after the update is preserved in `after`
        if (after && (toOff < after.length || after.breakAfter && (last === null || last === void 0 ? void 0 : last.breakAfter))) {
            // If we're splitting a child, separate part of it to avoid that
            // being mangled when updating the child before the update.
            if (fromI == toI) {
                after = after.split(toOff);
                toOff = 0;
            }
            // If the element after the replacement should be merged with
            // the last replacing element, update `content`
            if (!breakAtEnd && last && after.merge(0, toOff, last, true, 0, openEnd)) insert[insert.length - 1] = after;
            else {
                // Remove the start of the after element, if necessary, and
                // add it to `content`.
                if (toOff || after.children.length && !after.children[0].length) after.merge(0, toOff, null, false, 0, openEnd);
                insert.push(after);
            }
        } else if (after === null || after === void 0 ? void 0 : after.breakAfter) {
            // The element at `toI` is entirely covered by this range.
            // Preserve its line break, if any.
            if (last) last.breakAfter = 1;
            else breakAtStart = 1;
        }
        // Since we've handled the next element from the current elements
        // now, make sure `toI` points after that.
        toI++;
    }
    if (before) {
        before.breakAfter = breakAtStart;
        if (fromOff > 0) {
            if (!breakAtStart && insert.length && before.merge(fromOff, before.length, insert[0], false, openStart, 0)) before.breakAfter = insert.shift().breakAfter;
            else if (fromOff < before.length || before.children.length && before.children[before.children.length - 1].length == 0) before.merge(fromOff, before.length, null, false, openStart, 0);
            fromI++;
        }
    }
    // Try to merge widgets on the boundaries of the replacement
    while(fromI < toI && insert.length){
        if (children[toI - 1].become(insert[insert.length - 1])) {
            toI--;
            insert.pop();
            openEnd = insert.length ? 0 : openStart;
        } else if (children[fromI].become(insert[0])) {
            fromI++;
            insert.shift();
            openStart = insert.length ? 0 : openEnd;
        } else break;
    }
    if (!insert.length && fromI && toI < children.length && !children[fromI - 1].breakAfter && children[toI].merge(0, 0, children[fromI - 1], false, openStart, openEnd)) fromI--;
    if (fromI < toI || insert.length) parent.replaceChildren(fromI, toI, insert);
}
function $1d528cc0e08a0656$var$mergeChildrenInto(parent, from, to, insert, openStart, openEnd) {
    let cur = parent.childCursor();
    let { i: toI, off: toOff } = cur.findPos(to, 1);
    let { i: fromI, off: fromOff } = cur.findPos(from, -1);
    let dLen = from - to;
    for (let view of insert)dLen += view.length;
    parent.length += dLen;
    $1d528cc0e08a0656$var$replaceRange(parent, fromI, fromOff, toI, toOff, insert, 0, openStart, openEnd);
}
let $1d528cc0e08a0656$var$nav = typeof navigator != "undefined" ? navigator : {
    userAgent: "",
    vendor: "",
    platform: ""
};
let $1d528cc0e08a0656$var$doc = typeof document != "undefined" ? document : {
    documentElement: {
        style: {}
    }
};
const $1d528cc0e08a0656$var$ie_edge = /*@__PURE__*/ /Edge\/(\d+)/.exec($1d528cc0e08a0656$var$nav.userAgent);
const $1d528cc0e08a0656$var$ie_upto10 = /*@__PURE__*/ /MSIE \d/.test($1d528cc0e08a0656$var$nav.userAgent);
const $1d528cc0e08a0656$var$ie_11up = /*@__PURE__*/ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($1d528cc0e08a0656$var$nav.userAgent);
const $1d528cc0e08a0656$var$ie = !!($1d528cc0e08a0656$var$ie_upto10 || $1d528cc0e08a0656$var$ie_11up || $1d528cc0e08a0656$var$ie_edge);
const $1d528cc0e08a0656$var$gecko = !$1d528cc0e08a0656$var$ie && /*@__PURE__*/ /gecko\/(\d+)/i.test($1d528cc0e08a0656$var$nav.userAgent);
const $1d528cc0e08a0656$var$chrome = !$1d528cc0e08a0656$var$ie && /*@__PURE__*/ /Chrome\/(\d+)/.exec($1d528cc0e08a0656$var$nav.userAgent);
const $1d528cc0e08a0656$var$webkit = "webkitFontSmoothing" in $1d528cc0e08a0656$var$doc.documentElement.style;
const $1d528cc0e08a0656$var$safari = !$1d528cc0e08a0656$var$ie && /*@__PURE__*/ /Apple Computer/.test($1d528cc0e08a0656$var$nav.vendor);
const $1d528cc0e08a0656$var$ios = $1d528cc0e08a0656$var$safari && /*@__PURE__*/ (/Mobile\/\w+/.test($1d528cc0e08a0656$var$nav.userAgent) || $1d528cc0e08a0656$var$nav.maxTouchPoints > 2);
var $1d528cc0e08a0656$var$browser = {
    mac: $1d528cc0e08a0656$var$ios || /*@__PURE__*/ /Mac/.test($1d528cc0e08a0656$var$nav.platform),
    windows: /*@__PURE__*/ /Win/.test($1d528cc0e08a0656$var$nav.platform),
    linux: /*@__PURE__*/ /Linux|X11/.test($1d528cc0e08a0656$var$nav.platform),
    ie: $1d528cc0e08a0656$var$ie,
    ie_version: $1d528cc0e08a0656$var$ie_upto10 ? $1d528cc0e08a0656$var$doc.documentMode || 6 : $1d528cc0e08a0656$var$ie_11up ? +$1d528cc0e08a0656$var$ie_11up[1] : $1d528cc0e08a0656$var$ie_edge ? +$1d528cc0e08a0656$var$ie_edge[1] : 0,
    gecko: $1d528cc0e08a0656$var$gecko,
    gecko_version: $1d528cc0e08a0656$var$gecko ? +/*@__PURE__*/ (/Firefox\/(\d+)/.exec($1d528cc0e08a0656$var$nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    chrome: !!$1d528cc0e08a0656$var$chrome,
    chrome_version: $1d528cc0e08a0656$var$chrome ? +$1d528cc0e08a0656$var$chrome[1] : 0,
    ios: $1d528cc0e08a0656$var$ios,
    android: /*@__PURE__*/ /Android\b/.test($1d528cc0e08a0656$var$nav.userAgent),
    webkit: $1d528cc0e08a0656$var$webkit,
    safari: $1d528cc0e08a0656$var$safari,
    webkit_version: $1d528cc0e08a0656$var$webkit ? +/*@__PURE__*/ (/\bAppleWebKit\/(\d+)/.exec($1d528cc0e08a0656$var$nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    tabSize: $1d528cc0e08a0656$var$doc.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
const $1d528cc0e08a0656$var$MaxJoinLen = 256;
class $1d528cc0e08a0656$var$TextView extends $1d528cc0e08a0656$var$ContentView {
    constructor(text){
        super();
        this.text = text;
    }
    get length() {
        return this.text.length;
    }
    createDOM(textDOM) {
        this.setDOM(textDOM || document.createTextNode(this.text));
    }
    sync(view, track) {
        if (!this.dom) this.createDOM();
        if (this.dom.nodeValue != this.text) {
            if (track && track.node == this.dom) track.written = true;
            this.dom.nodeValue = this.text;
        }
    }
    reuseDOM(dom) {
        if (dom.nodeType == 3) this.createDOM(dom);
    }
    merge(from, to, source) {
        if (this.flags & 8 /* ViewFlag.Composition */  || source && (!(source instanceof $1d528cc0e08a0656$var$TextView) || this.length - (to - from) + source.length > $1d528cc0e08a0656$var$MaxJoinLen || source.flags & 8 /* ViewFlag.Composition */ )) return false;
        this.text = this.text.slice(0, from) + (source ? source.text : "") + this.text.slice(to);
        this.markDirty();
        return true;
    }
    split(from) {
        let result = new $1d528cc0e08a0656$var$TextView(this.text.slice(from));
        this.text = this.text.slice(0, from);
        this.markDirty();
        result.flags |= this.flags & 8 /* ViewFlag.Composition */ ;
        return result;
    }
    localPosFromDOM(node, offset) {
        return node == this.dom ? offset : offset ? this.text.length : 0;
    }
    domAtPos(pos) {
        return new $1d528cc0e08a0656$var$DOMPos(this.dom, pos);
    }
    domBoundsAround(_from, _to, offset) {
        return {
            from: offset,
            to: offset + this.length,
            startDOM: this.dom,
            endDOM: this.dom.nextSibling
        };
    }
    coordsAt(pos, side) {
        return $1d528cc0e08a0656$var$textCoords(this.dom, pos, side);
    }
}
class $1d528cc0e08a0656$var$MarkView extends $1d528cc0e08a0656$var$ContentView {
    constructor(mark, children = [], length = 0){
        super();
        this.mark = mark;
        this.children = children;
        this.length = length;
        for (let ch of children)ch.setParent(this);
    }
    setAttrs(dom) {
        $1d528cc0e08a0656$var$clearAttributes(dom);
        if (this.mark.class) dom.className = this.mark.class;
        if (this.mark.attrs) for(let name in this.mark.attrs)dom.setAttribute(name, this.mark.attrs[name]);
        return dom;
    }
    canReuseDOM(other) {
        return super.canReuseDOM(other) && !((this.flags | other.flags) & 8 /* ViewFlag.Composition */ );
    }
    reuseDOM(node) {
        if (node.nodeName == this.mark.tagName.toUpperCase()) {
            this.setDOM(node);
            this.flags |= 6 /* ViewFlag.NodeDirty */ ;
        }
    }
    sync(view, track) {
        if (!this.dom) this.setDOM(this.setAttrs(document.createElement(this.mark.tagName)));
        else if (this.flags & 4 /* ViewFlag.AttrsDirty */ ) this.setAttrs(this.dom);
        super.sync(view, track);
    }
    merge(from, to, source, _hasStart, openStart, openEnd) {
        if (source && (!(source instanceof $1d528cc0e08a0656$var$MarkView && source.mark.eq(this.mark)) || from && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        $1d528cc0e08a0656$var$mergeChildrenInto(this, from, to, source ? source.children.slice() : [], openStart - 1, openEnd - 1);
        this.markDirty();
        return true;
    }
    split(from) {
        let result = [], off = 0, detachFrom = -1, i = 0;
        for (let elt of this.children){
            let end = off + elt.length;
            if (end > from) result.push(off < from ? elt.split(from - off) : elt);
            if (detachFrom < 0 && off >= from) detachFrom = i;
            off = end;
            i++;
        }
        let length = this.length - from;
        this.length = from;
        if (detachFrom > -1) {
            this.children.length = detachFrom;
            this.markDirty();
        }
        return new $1d528cc0e08a0656$var$MarkView(this.mark, result, length);
    }
    domAtPos(pos) {
        return $1d528cc0e08a0656$var$inlineDOMAtPos(this, pos);
    }
    coordsAt(pos, side) {
        return $1d528cc0e08a0656$var$coordsInChildren(this, pos, side);
    }
}
function $1d528cc0e08a0656$var$textCoords(text, pos, side) {
    let length = text.nodeValue.length;
    if (pos > length) pos = length;
    let from = pos, to = pos, flatten = 0;
    if (pos == 0 && side < 0 || pos == length && side >= 0) {
        if (!($1d528cc0e08a0656$var$browser.chrome || $1d528cc0e08a0656$var$browser.gecko)) {
            if (pos) {
                from--;
                flatten = 1;
            } else if (to < length) {
                to++;
                flatten = -1;
            }
        }
    } else {
        if (side < 0) from--;
        else if (to < length) to++;
    }
    let rects = $1d528cc0e08a0656$var$textRange(text, from, to).getClientRects();
    if (!rects.length) return null;
    let rect = rects[(flatten ? flatten < 0 : side >= 0) ? 0 : rects.length - 1];
    if ($1d528cc0e08a0656$var$browser.safari && !flatten && rect.width == 0) rect = Array.prototype.find.call(rects, (r)=>r.width) || rect;
    return flatten ? $1d528cc0e08a0656$var$flattenRect(rect, flatten < 0) : rect || null;
}
// Also used for collapsed ranges that don't have a placeholder widget!
class $1d528cc0e08a0656$var$WidgetView extends $1d528cc0e08a0656$var$ContentView {
    static create(widget, length, side) {
        return new $1d528cc0e08a0656$var$WidgetView(widget, length, side);
    }
    constructor(widget, length, side){
        super();
        this.widget = widget;
        this.length = length;
        this.side = side;
        this.prevWidget = null;
    }
    split(from) {
        let result = $1d528cc0e08a0656$var$WidgetView.create(this.widget, this.length - from, this.side);
        this.length -= from;
        return result;
    }
    sync(view) {
        if (!this.dom || !this.widget.updateDOM(this.dom, view)) {
            if (this.dom && this.prevWidget) this.prevWidget.destroy(this.dom);
            this.prevWidget = null;
            this.setDOM(this.widget.toDOM(view));
            if (!this.widget.editable) this.dom.contentEditable = "false";
        }
    }
    getSide() {
        return this.side;
    }
    merge(from, to, source, hasStart, openStart, openEnd) {
        if (source && (!(source instanceof $1d528cc0e08a0656$var$WidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        this.length = from + (source ? source.length : 0) + (this.length - to);
        return true;
    }
    become(other) {
        if (other instanceof $1d528cc0e08a0656$var$WidgetView && other.side == this.side && this.widget.constructor == other.widget.constructor) {
            if (!this.widget.compare(other.widget)) this.markDirty(true);
            if (this.dom && !this.prevWidget) this.prevWidget = this.widget;
            this.widget = other.widget;
            this.length = other.length;
            return true;
        }
        return false;
    }
    ignoreMutation() {
        return true;
    }
    ignoreEvent(event) {
        return this.widget.ignoreEvent(event);
    }
    get overrideDOMText() {
        if (this.length == 0) return (0, $6b8f387faea0a4dd$export$5f1af8db9871e1d6).empty;
        let top = this;
        while(top.parent)top = top.parent;
        let { view: view } = top, text = view && view.state.doc, start = this.posAtStart;
        return text ? text.slice(start, start + this.length) : (0, $6b8f387faea0a4dd$export$5f1af8db9871e1d6).empty;
    }
    domAtPos(pos) {
        return (this.length ? pos == 0 : this.side > 0) ? $1d528cc0e08a0656$var$DOMPos.before(this.dom) : $1d528cc0e08a0656$var$DOMPos.after(this.dom, pos == this.length);
    }
    domBoundsAround() {
        return null;
    }
    coordsAt(pos, side) {
        let custom = this.widget.coordsAt(this.dom, pos, side);
        if (custom) return custom;
        let rects = this.dom.getClientRects(), rect = null;
        if (!rects.length) return null;
        let fromBack = this.side ? this.side < 0 : pos > 0;
        for(let i = fromBack ? rects.length - 1 : 0;; i += fromBack ? -1 : 1){
            rect = rects[i];
            if (pos > 0 ? i == 0 : i == rects.length - 1 || rect.top < rect.bottom) break;
        }
        return $1d528cc0e08a0656$var$flattenRect(rect, !fromBack);
    }
    get isEditable() {
        return false;
    }
    get isWidget() {
        return true;
    }
    get isHidden() {
        return this.widget.isHidden;
    }
    destroy() {
        super.destroy();
        if (this.dom) this.widget.destroy(this.dom);
    }
}
// These are drawn around uneditable widgets to avoid a number of
// browser bugs that show up when the cursor is directly next to
// uneditable inline content.
class $1d528cc0e08a0656$var$WidgetBufferView extends $1d528cc0e08a0656$var$ContentView {
    constructor(side){
        super();
        this.side = side;
    }
    get length() {
        return 0;
    }
    merge() {
        return false;
    }
    become(other) {
        return other instanceof $1d528cc0e08a0656$var$WidgetBufferView && other.side == this.side;
    }
    split() {
        return new $1d528cc0e08a0656$var$WidgetBufferView(this.side);
    }
    sync() {
        if (!this.dom) {
            let dom = document.createElement("img");
            dom.className = "cm-widgetBuffer";
            dom.setAttribute("aria-hidden", "true");
            this.setDOM(dom);
        }
    }
    getSide() {
        return this.side;
    }
    domAtPos(pos) {
        return this.side > 0 ? $1d528cc0e08a0656$var$DOMPos.before(this.dom) : $1d528cc0e08a0656$var$DOMPos.after(this.dom);
    }
    localPosFromDOM() {
        return 0;
    }
    domBoundsAround() {
        return null;
    }
    coordsAt(pos) {
        return this.dom.getBoundingClientRect();
    }
    get overrideDOMText() {
        return (0, $6b8f387faea0a4dd$export$5f1af8db9871e1d6).empty;
    }
    get isHidden() {
        return true;
    }
}
$1d528cc0e08a0656$var$TextView.prototype.children = $1d528cc0e08a0656$var$WidgetView.prototype.children = $1d528cc0e08a0656$var$WidgetBufferView.prototype.children = $1d528cc0e08a0656$var$noChildren;
function $1d528cc0e08a0656$var$inlineDOMAtPos(parent, pos) {
    let dom = parent.dom, { children: children } = parent, i = 0;
    for(let off = 0; i < children.length; i++){
        let child = children[i], end = off + child.length;
        if (end == off && child.getSide() <= 0) continue;
        if (pos > off && pos < end && child.dom.parentNode == dom) return child.domAtPos(pos - off);
        if (pos <= off) break;
        off = end;
    }
    for(let j = i; j > 0; j--){
        let prev = children[j - 1];
        if (prev.dom.parentNode == dom) return prev.domAtPos(prev.length);
    }
    for(let j = i; j < children.length; j++){
        let next = children[j];
        if (next.dom.parentNode == dom) return next.domAtPos(0);
    }
    return new $1d528cc0e08a0656$var$DOMPos(dom, 0);
}
// Assumes `view`, if a mark view, has precisely 1 child.
function $1d528cc0e08a0656$var$joinInlineInto(parent, view, open) {
    let last, { children: children } = parent;
    if (open > 0 && view instanceof $1d528cc0e08a0656$var$MarkView && children.length && (last = children[children.length - 1]) instanceof $1d528cc0e08a0656$var$MarkView && last.mark.eq(view.mark)) $1d528cc0e08a0656$var$joinInlineInto(last, view.children[0], open - 1);
    else {
        children.push(view);
        view.setParent(parent);
    }
    parent.length += view.length;
}
function $1d528cc0e08a0656$var$coordsInChildren(view, pos, side) {
    let before = null, beforePos = -1, after = null, afterPos = -1;
    function scan(view, pos) {
        for(let i = 0, off = 0; i < view.children.length && off <= pos; i++){
            let child = view.children[i], end = off + child.length;
            if (end >= pos) {
                if (child.children.length) scan(child, pos - off);
                else if ((!after || after.isHidden && (side > 0 || $1d528cc0e08a0656$var$onSameLine(after, child))) && (end > pos || off == end && child.getSide() > 0)) {
                    after = child;
                    afterPos = pos - off;
                } else if (off < pos || off == end && child.getSide() < 0 && !child.isHidden) {
                    before = child;
                    beforePos = pos - off;
                }
            }
            off = end;
        }
    }
    scan(view, pos);
    let target = (side < 0 ? before : after) || before || after;
    if (target) return target.coordsAt(Math.max(0, target == before ? beforePos : afterPos), side);
    return $1d528cc0e08a0656$var$fallbackRect(view);
}
function $1d528cc0e08a0656$var$fallbackRect(view) {
    let last = view.dom.lastChild;
    if (!last) return view.dom.getBoundingClientRect();
    let rects = $1d528cc0e08a0656$var$clientRectsFor(last);
    return rects[rects.length - 1] || null;
}
function $1d528cc0e08a0656$var$onSameLine(a, b) {
    let posA = a.coordsAt(0, 1), posB = b.coordsAt(0, 1);
    return posA && posB && posB.top < posA.bottom;
}
function $1d528cc0e08a0656$var$combineAttrs(source, target) {
    for(let name in source){
        if (name == "class" && target.class) target.class += " " + source.class;
        else if (name == "style" && target.style) target.style += ";" + source.style;
        else target[name] = source[name];
    }
    return target;
}
const $1d528cc0e08a0656$var$noAttrs = /*@__PURE__*/ Object.create(null);
function $1d528cc0e08a0656$var$attrsEq(a, b, ignore) {
    if (a == b) return true;
    if (!a) a = $1d528cc0e08a0656$var$noAttrs;
    if (!b) b = $1d528cc0e08a0656$var$noAttrs;
    let keysA = Object.keys(a), keysB = Object.keys(b);
    if (keysA.length - (ignore && keysA.indexOf(ignore) > -1 ? 1 : 0) != keysB.length - (ignore && keysB.indexOf(ignore) > -1 ? 1 : 0)) return false;
    for (let key of keysA){
        if (key != ignore && (keysB.indexOf(key) == -1 || a[key] !== b[key])) return false;
    }
    return true;
}
function $1d528cc0e08a0656$var$updateAttrs(dom, prev, attrs) {
    let changed = false;
    if (prev) {
        for(let name in prev)if (!(attrs && name in attrs)) {
            changed = true;
            if (name == "style") dom.style.cssText = "";
            else dom.removeAttribute(name);
        }
    }
    if (attrs) {
        for(let name in attrs)if (!(prev && prev[name] == attrs[name])) {
            changed = true;
            if (name == "style") dom.style.cssText = attrs[name];
            else dom.setAttribute(name, attrs[name]);
        }
    }
    return changed;
}
function $1d528cc0e08a0656$var$getAttrs(dom) {
    let attrs = Object.create(null);
    for(let i = 0; i < dom.attributes.length; i++){
        let attr = dom.attributes[i];
        attrs[attr.name] = attr.value;
    }
    return attrs;
}
/**
Widgets added to the content are described by subclasses of this
class. Using a description object like that makes it possible to
delay creating of the DOM structure for a widget until it is
needed, and to avoid redrawing widgets even if the decorations
that define them are recreated.
*/ class $1d528cc0e08a0656$export$95cdd842edb044c5 {
    /**
    Compare this instance to another instance of the same type.
    (TypeScript can't express this, but only instances of the same
    specific class will be passed to this method.) This is used to
    avoid redrawing widgets when they are replaced by a new
    decoration of the same type. The default implementation just
    returns `false`, which will cause new instances of the widget to
    always be redrawn.
    */ eq(widget) {
        return false;
    }
    /**
    Update a DOM element created by a widget of the same type (but
    different, non-`eq` content) to reflect this widget. May return
    true to indicate that it could update, false to indicate it
    couldn't (in which case the widget will be redrawn). The default
    implementation just returns false.
    */ updateDOM(dom, view) {
        return false;
    }
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    The estimated height this widget will have, to be used when
    estimating the height of content that hasn't been drawn. May
    return -1 to indicate you don't know. The default implementation
    returns -1.
    */ get estimatedHeight() {
        return -1;
    }
    /**
    For inline widgets that are displayed inline (as opposed to
    `inline-block`) and introduce line breaks (through `<br>` tags
    or textual newlines), this must indicate the amount of line
    breaks they introduce. Defaults to 0.
    */ get lineBreaks() {
        return 0;
    }
    /**
    Can be used to configure which kinds of events inside the widget
    should be ignored by the editor. The default is to ignore all
    events.
    */ ignoreEvent(event) {
        return true;
    }
    /**
    Override the way screen coordinates for positions at/in the
    widget are found. `pos` will be the offset into the widget, and
    `side` the side of the position that is being queried—less than
    zero for before, greater than zero for after, and zero for
    directly at that position.
    */ coordsAt(dom, pos, side) {
        return null;
    }
    /**
    @internal
    */ get isHidden() {
        return false;
    }
    /**
    @internal
    */ get editable() {
        return false;
    }
    /**
    This is called when the an instance of the widget is removed
    from the editor view.
    */ destroy(dom) {}
}
/**
The different types of blocks that can occur in an editor view.
*/ var $1d528cc0e08a0656$export$48808c686fe495c4 = /*@__PURE__*/ function(BlockType) {
    /**
    A line of text.
    */ BlockType[BlockType["Text"] = 0] = "Text";
    /**
    A block widget associated with the position after it.
    */ BlockType[BlockType["WidgetBefore"] = 1] = "WidgetBefore";
    /**
    A block widget associated with the position before it.
    */ BlockType[BlockType["WidgetAfter"] = 2] = "WidgetAfter";
    /**
    A block widget [replacing](https://codemirror.net/6/docs/ref/#view.Decoration^replace) a range of content.
    */ BlockType[BlockType["WidgetRange"] = 3] = "WidgetRange";
    return BlockType;
}($1d528cc0e08a0656$export$48808c686fe495c4 || ($1d528cc0e08a0656$export$48808c686fe495c4 = {}));
/**
A decoration provides information on how to draw or style a piece
of content. You'll usually use it wrapped in a
[`Range`](https://codemirror.net/6/docs/ref/#state.Range), which adds a start and end position.
@nonabstract
*/ class $1d528cc0e08a0656$export$10e30b733df217ea extends (0, $6b8f387faea0a4dd$export$d60f08ed93a48611) {
    constructor(/**
    @internal
    */ startSide, /**
    @internal
    */ endSide, /**
    @internal
    */ widget, /**
    The config object used to create this decoration. You can
    include additional properties in there to store metadata about
    your decoration.
    */ spec){
        super();
        this.startSide = startSide;
        this.endSide = endSide;
        this.widget = widget;
        this.spec = spec;
    }
    /**
    @internal
    */ get heightRelevant() {
        return false;
    }
    /**
    Create a mark decoration, which influences the styling of the
    content in its range. Nested mark decorations will cause nested
    DOM elements to be created. Nesting order is determined by
    precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
    the higher-precedence decorations creating the inner DOM nodes.
    Such elements are split on line boundaries and on the boundaries
    of lower-precedence decorations.
    */ static mark(spec) {
        return new $1d528cc0e08a0656$var$MarkDecoration(spec);
    }
    /**
    Create a widget decoration, which displays a DOM element at the
    given position.
    */ static widget(spec) {
        let side = Math.max(-10000, Math.min(10000, spec.side || 0)), block = !!spec.block;
        side += block && !spec.inlineOrder ? side > 0 ? 300000000 /* Side.BlockAfter */  : -400000000 /* Side.BlockBefore */  : side > 0 ? 100000000 /* Side.InlineAfter */  : -100000000 /* Side.InlineBefore */ ;
        return new $1d528cc0e08a0656$var$PointDecoration(spec, side, side, block, spec.widget || null, false);
    }
    /**
    Create a replace decoration which replaces the given range with
    a widget, or simply hides it.
    */ static replace(spec) {
        let block = !!spec.block, startSide, endSide;
        if (spec.isBlockGap) {
            startSide = -500000000 /* Side.GapStart */ ;
            endSide = 400000000 /* Side.GapEnd */ ;
        } else {
            let { start: start, end: end } = $1d528cc0e08a0656$var$getInclusive(spec, block);
            startSide = (start ? block ? -300000000 /* Side.BlockIncStart */  : -1 /* Side.InlineIncStart */  : 500000000 /* Side.NonIncStart */ ) - 1;
            endSide = (end ? block ? 200000000 /* Side.BlockIncEnd */  : 1 /* Side.InlineIncEnd */  : -600000000 /* Side.NonIncEnd */ ) + 1;
        }
        return new $1d528cc0e08a0656$var$PointDecoration(spec, startSide, endSide, block, spec.widget || null, true);
    }
    /**
    Create a line decoration, which can add DOM attributes to the
    line starting at the given position.
    */ static line(spec) {
        return new $1d528cc0e08a0656$var$LineDecoration(spec);
    }
    /**
    Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
    decorated range or ranges. If the ranges aren't already sorted,
    pass `true` for `sort` to make the library sort them for you.
    */ static set(of, sort = false) {
        return (0, $6b8f387faea0a4dd$export$34cb5241245008dd).of(of, sort);
    }
    /**
    @internal
    */ hasHeight() {
        return this.widget ? this.widget.estimatedHeight > -1 : false;
    }
}
/**
The empty set of decorations.
*/ $1d528cc0e08a0656$export$10e30b733df217ea.none = (0, $6b8f387faea0a4dd$export$34cb5241245008dd).empty;
class $1d528cc0e08a0656$var$MarkDecoration extends $1d528cc0e08a0656$export$10e30b733df217ea {
    constructor(spec){
        let { start: start, end: end } = $1d528cc0e08a0656$var$getInclusive(spec);
        super(start ? -1 /* Side.InlineIncStart */  : 500000000 /* Side.NonIncStart */ , end ? 1 /* Side.InlineIncEnd */  : -600000000 /* Side.NonIncEnd */ , null, spec);
        this.tagName = spec.tagName || "span";
        this.class = spec.class || "";
        this.attrs = spec.attributes || null;
    }
    eq(other) {
        var _a, _b;
        return this == other || other instanceof $1d528cc0e08a0656$var$MarkDecoration && this.tagName == other.tagName && (this.class || ((_a = this.attrs) === null || _a === void 0 ? void 0 : _a.class)) == (other.class || ((_b = other.attrs) === null || _b === void 0 ? void 0 : _b.class)) && $1d528cc0e08a0656$var$attrsEq(this.attrs, other.attrs, "class");
    }
    range(from, to = from) {
        if (from >= to) throw new RangeError("Mark decorations may not be empty");
        return super.range(from, to);
    }
}
$1d528cc0e08a0656$var$MarkDecoration.prototype.point = false;
class $1d528cc0e08a0656$var$LineDecoration extends $1d528cc0e08a0656$export$10e30b733df217ea {
    constructor(spec){
        super(-200000000 /* Side.Line */ , -200000000 /* Side.Line */ , null, spec);
    }
    eq(other) {
        return other instanceof $1d528cc0e08a0656$var$LineDecoration && this.spec.class == other.spec.class && $1d528cc0e08a0656$var$attrsEq(this.spec.attributes, other.spec.attributes);
    }
    range(from, to = from) {
        if (to != from) throw new RangeError("Line decoration ranges must be zero-length");
        return super.range(from, to);
    }
}
$1d528cc0e08a0656$var$LineDecoration.prototype.mapMode = (0, $6b8f387faea0a4dd$export$39cf3280165f92aa).TrackBefore;
$1d528cc0e08a0656$var$LineDecoration.prototype.point = true;
class $1d528cc0e08a0656$var$PointDecoration extends $1d528cc0e08a0656$export$10e30b733df217ea {
    constructor(spec, startSide, endSide, block, widget, isReplace){
        super(startSide, endSide, widget, spec);
        this.block = block;
        this.isReplace = isReplace;
        this.mapMode = !block ? (0, $6b8f387faea0a4dd$export$39cf3280165f92aa).TrackDel : startSide <= 0 ? (0, $6b8f387faea0a4dd$export$39cf3280165f92aa).TrackBefore : (0, $6b8f387faea0a4dd$export$39cf3280165f92aa).TrackAfter;
    }
    // Only relevant when this.block == true
    get type() {
        return this.startSide != this.endSide ? $1d528cc0e08a0656$export$48808c686fe495c4.WidgetRange : this.startSide <= 0 ? $1d528cc0e08a0656$export$48808c686fe495c4.WidgetBefore : $1d528cc0e08a0656$export$48808c686fe495c4.WidgetAfter;
    }
    get heightRelevant() {
        return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
    }
    eq(other) {
        return other instanceof $1d528cc0e08a0656$var$PointDecoration && $1d528cc0e08a0656$var$widgetsEq(this.widget, other.widget) && this.block == other.block && this.startSide == other.startSide && this.endSide == other.endSide;
    }
    range(from, to = from) {
        if (this.isReplace && (from > to || from == to && this.startSide > 0 && this.endSide <= 0)) throw new RangeError("Invalid range for replacement decoration");
        if (!this.isReplace && to != from) throw new RangeError("Widget decorations can only have zero-length ranges");
        return super.range(from, to);
    }
}
$1d528cc0e08a0656$var$PointDecoration.prototype.point = true;
function $1d528cc0e08a0656$var$getInclusive(spec, block = false) {
    let { inclusiveStart: start, inclusiveEnd: end } = spec;
    if (start == null) start = spec.inclusive;
    if (end == null) end = spec.inclusive;
    return {
        start: start !== null && start !== void 0 ? start : block,
        end: end !== null && end !== void 0 ? end : block
    };
}
function $1d528cc0e08a0656$var$widgetsEq(a, b) {
    return a == b || !!(a && b && a.compare(b));
}
function $1d528cc0e08a0656$var$addRange(from, to, ranges, margin = 0) {
    let last = ranges.length - 1;
    if (last >= 0 && ranges[last] + margin >= from) ranges[last] = Math.max(ranges[last], to);
    else ranges.push(from, to);
}
class $1d528cc0e08a0656$var$LineView extends $1d528cc0e08a0656$var$ContentView {
    constructor(){
        super(...arguments);
        this.children = [];
        this.length = 0;
        this.prevAttrs = undefined;
        this.attrs = null;
        this.breakAfter = 0;
    }
    // Consumes source
    merge(from, to, source, hasStart, openStart, openEnd) {
        if (source) {
            if (!(source instanceof $1d528cc0e08a0656$var$LineView)) return false;
            if (!this.dom) source.transferDOM(this); // Reuse source.dom when appropriate
        }
        if (hasStart) this.setDeco(source ? source.attrs : null);
        $1d528cc0e08a0656$var$mergeChildrenInto(this, from, to, source ? source.children.slice() : [], openStart, openEnd);
        return true;
    }
    split(at) {
        let end = new $1d528cc0e08a0656$var$LineView;
        end.breakAfter = this.breakAfter;
        if (this.length == 0) return end;
        let { i: i, off: off } = this.childPos(at);
        if (off) {
            end.append(this.children[i].split(off), 0);
            this.children[i].merge(off, this.children[i].length, null, false, 0, 0);
            i++;
        }
        for(let j = i; j < this.children.length; j++)end.append(this.children[j], 0);
        while(i > 0 && this.children[i - 1].length == 0)this.children[--i].destroy();
        this.children.length = i;
        this.markDirty();
        this.length = at;
        return end;
    }
    transferDOM(other) {
        if (!this.dom) return;
        this.markDirty();
        other.setDOM(this.dom);
        other.prevAttrs = this.prevAttrs === undefined ? this.attrs : this.prevAttrs;
        this.prevAttrs = undefined;
        this.dom = null;
    }
    setDeco(attrs) {
        if (!$1d528cc0e08a0656$var$attrsEq(this.attrs, attrs)) {
            if (this.dom) {
                this.prevAttrs = this.attrs;
                this.markDirty();
            }
            this.attrs = attrs;
        }
    }
    append(child, openStart) {
        $1d528cc0e08a0656$var$joinInlineInto(this, child, openStart);
    }
    // Only called when building a line view in ContentBuilder
    addLineDeco(deco) {
        let attrs = deco.spec.attributes, cls = deco.spec.class;
        if (attrs) this.attrs = $1d528cc0e08a0656$var$combineAttrs(attrs, this.attrs || {});
        if (cls) this.attrs = $1d528cc0e08a0656$var$combineAttrs({
            class: cls
        }, this.attrs || {});
    }
    domAtPos(pos) {
        return $1d528cc0e08a0656$var$inlineDOMAtPos(this, pos);
    }
    reuseDOM(node) {
        if (node.nodeName == "DIV") {
            this.setDOM(node);
            this.flags |= 6 /* ViewFlag.NodeDirty */ ;
        }
    }
    sync(view, track) {
        var _a;
        if (!this.dom) {
            this.setDOM(document.createElement("div"));
            this.dom.className = "cm-line";
            this.prevAttrs = this.attrs ? null : undefined;
        } else if (this.flags & 4 /* ViewFlag.AttrsDirty */ ) {
            $1d528cc0e08a0656$var$clearAttributes(this.dom);
            this.dom.className = "cm-line";
            this.prevAttrs = this.attrs ? null : undefined;
        }
        if (this.prevAttrs !== undefined) {
            $1d528cc0e08a0656$var$updateAttrs(this.dom, this.prevAttrs, this.attrs);
            this.dom.classList.add("cm-line");
            this.prevAttrs = undefined;
        }
        super.sync(view, track);
        let last = this.dom.lastChild;
        while(last && $1d528cc0e08a0656$var$ContentView.get(last) instanceof $1d528cc0e08a0656$var$MarkView)last = last.lastChild;
        if (!last || !this.length || last.nodeName != "BR" && ((_a = $1d528cc0e08a0656$var$ContentView.get(last)) === null || _a === void 0 ? void 0 : _a.isEditable) == false && (!$1d528cc0e08a0656$var$browser.ios || !this.children.some((ch)=>ch instanceof $1d528cc0e08a0656$var$TextView))) {
            let hack = document.createElement("BR");
            hack.cmIgnore = true;
            this.dom.appendChild(hack);
        }
    }
    measureTextSize() {
        if (this.children.length == 0 || this.length > 20) return null;
        let totalWidth = 0, textHeight;
        for (let child of this.children){
            if (!(child instanceof $1d528cc0e08a0656$var$TextView) || /[^ -~]/.test(child.text)) return null;
            let rects = $1d528cc0e08a0656$var$clientRectsFor(child.dom);
            if (rects.length != 1) return null;
            totalWidth += rects[0].width;
            textHeight = rects[0].height;
        }
        return !totalWidth ? null : {
            lineHeight: this.dom.getBoundingClientRect().height,
            charWidth: totalWidth / this.length,
            textHeight: textHeight
        };
    }
    coordsAt(pos, side) {
        let rect = $1d528cc0e08a0656$var$coordsInChildren(this, pos, side);
        // Correct rectangle height for empty lines when the returned
        // height is larger than the text height.
        if (!this.children.length && rect && this.parent) {
            let { heightOracle: heightOracle } = this.parent.view.viewState, height = rect.bottom - rect.top;
            if (Math.abs(height - heightOracle.lineHeight) < 2 && heightOracle.textHeight < height) {
                let dist = (height - heightOracle.textHeight) / 2;
                return {
                    top: rect.top + dist,
                    bottom: rect.bottom - dist,
                    left: rect.left,
                    right: rect.left
                };
            }
        }
        return rect;
    }
    become(other) {
        return other instanceof $1d528cc0e08a0656$var$LineView && this.children.length == 0 && other.children.length == 0 && $1d528cc0e08a0656$var$attrsEq(this.attrs, other.attrs) && this.breakAfter == other.breakAfter;
    }
    covers() {
        return true;
    }
    static find(docView, pos) {
        for(let i = 0, off = 0; i < docView.children.length; i++){
            let block = docView.children[i], end = off + block.length;
            if (end >= pos) {
                if (block instanceof $1d528cc0e08a0656$var$LineView) return block;
                if (end > pos) break;
            }
            off = end + block.breakAfter;
        }
        return null;
    }
}
class $1d528cc0e08a0656$var$BlockWidgetView extends $1d528cc0e08a0656$var$ContentView {
    constructor(widget, length, deco){
        super();
        this.widget = widget;
        this.length = length;
        this.deco = deco;
        this.breakAfter = 0;
        this.prevWidget = null;
    }
    merge(from, to, source, _takeDeco, openStart, openEnd) {
        if (source && (!(source instanceof $1d528cc0e08a0656$var$BlockWidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        this.length = from + (source ? source.length : 0) + (this.length - to);
        return true;
    }
    domAtPos(pos) {
        return pos == 0 ? $1d528cc0e08a0656$var$DOMPos.before(this.dom) : $1d528cc0e08a0656$var$DOMPos.after(this.dom, pos == this.length);
    }
    split(at) {
        let len = this.length - at;
        this.length = at;
        let end = new $1d528cc0e08a0656$var$BlockWidgetView(this.widget, len, this.deco);
        end.breakAfter = this.breakAfter;
        return end;
    }
    get children() {
        return $1d528cc0e08a0656$var$noChildren;
    }
    sync(view) {
        if (!this.dom || !this.widget.updateDOM(this.dom, view)) {
            if (this.dom && this.prevWidget) this.prevWidget.destroy(this.dom);
            this.prevWidget = null;
            this.setDOM(this.widget.toDOM(view));
            if (!this.widget.editable) this.dom.contentEditable = "false";
        }
    }
    get overrideDOMText() {
        return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : (0, $6b8f387faea0a4dd$export$5f1af8db9871e1d6).empty;
    }
    domBoundsAround() {
        return null;
    }
    become(other) {
        if (other instanceof $1d528cc0e08a0656$var$BlockWidgetView && other.widget.constructor == this.widget.constructor) {
            if (!other.widget.compare(this.widget)) this.markDirty(true);
            if (this.dom && !this.prevWidget) this.prevWidget = this.widget;
            this.widget = other.widget;
            this.length = other.length;
            this.deco = other.deco;
            this.breakAfter = other.breakAfter;
            return true;
        }
        return false;
    }
    ignoreMutation() {
        return true;
    }
    ignoreEvent(event) {
        return this.widget.ignoreEvent(event);
    }
    get isEditable() {
        return false;
    }
    get isWidget() {
        return true;
    }
    coordsAt(pos, side) {
        let custom = this.widget.coordsAt(this.dom, pos, side);
        if (custom) return custom;
        if (this.widget instanceof $1d528cc0e08a0656$var$BlockGapWidget) return null;
        return $1d528cc0e08a0656$var$flattenRect(this.dom.getBoundingClientRect(), this.length ? pos == 0 : side <= 0);
    }
    destroy() {
        super.destroy();
        if (this.dom) this.widget.destroy(this.dom);
    }
    covers(side) {
        let { startSide: startSide, endSide: endSide } = this.deco;
        return startSide == endSide ? false : side < 0 ? startSide < 0 : endSide > 0;
    }
}
class $1d528cc0e08a0656$var$BlockGapWidget extends $1d528cc0e08a0656$export$95cdd842edb044c5 {
    constructor(height){
        super();
        this.height = height;
    }
    toDOM() {
        let elt = document.createElement("div");
        elt.className = "cm-gap";
        this.updateDOM(elt);
        return elt;
    }
    eq(other) {
        return other.height == this.height;
    }
    updateDOM(elt) {
        elt.style.height = this.height + "px";
        return true;
    }
    get editable() {
        return true;
    }
    get estimatedHeight() {
        return this.height;
    }
    ignoreEvent() {
        return false;
    }
}
class $1d528cc0e08a0656$var$ContentBuilder {
    constructor(doc, pos, end, disallowBlockEffectsFor){
        this.doc = doc;
        this.pos = pos;
        this.end = end;
        this.disallowBlockEffectsFor = disallowBlockEffectsFor;
        this.content = [];
        this.curLine = null;
        this.breakAtStart = 0;
        this.pendingBuffer = 0 /* Buf.No */ ;
        this.bufferMarks = [];
        // Set to false directly after a widget that covers the position after it
        this.atCursorPos = true;
        this.openStart = -1;
        this.openEnd = -1;
        this.text = "";
        this.textOff = 0;
        this.cursor = doc.iter();
        this.skip = pos;
    }
    posCovered() {
        if (this.content.length == 0) return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
        let last = this.content[this.content.length - 1];
        return !(last.breakAfter || last instanceof $1d528cc0e08a0656$var$BlockWidgetView && last.deco.endSide < 0);
    }
    getLine() {
        if (!this.curLine) {
            this.content.push(this.curLine = new $1d528cc0e08a0656$var$LineView);
            this.atCursorPos = true;
        }
        return this.curLine;
    }
    flushBuffer(active = this.bufferMarks) {
        if (this.pendingBuffer) {
            this.curLine.append($1d528cc0e08a0656$var$wrapMarks(new $1d528cc0e08a0656$var$WidgetBufferView(-1), active), active.length);
            this.pendingBuffer = 0 /* Buf.No */ ;
        }
    }
    addBlockWidget(view) {
        this.flushBuffer();
        this.curLine = null;
        this.content.push(view);
    }
    finish(openEnd) {
        if (this.pendingBuffer && openEnd <= this.bufferMarks.length) this.flushBuffer();
        else this.pendingBuffer = 0 /* Buf.No */ ;
        if (!this.posCovered() && !(openEnd && this.content.length && this.content[this.content.length - 1] instanceof $1d528cc0e08a0656$var$BlockWidgetView)) this.getLine();
    }
    buildText(length, active, openStart) {
        while(length > 0){
            if (this.textOff == this.text.length) {
                let { value: value, lineBreak: lineBreak, done: done } = this.cursor.next(this.skip);
                this.skip = 0;
                if (done) throw new Error("Ran out of text content when drawing inline views");
                if (lineBreak) {
                    if (!this.posCovered()) this.getLine();
                    if (this.content.length) this.content[this.content.length - 1].breakAfter = 1;
                    else this.breakAtStart = 1;
                    this.flushBuffer();
                    this.curLine = null;
                    this.atCursorPos = true;
                    length--;
                    continue;
                } else {
                    this.text = value;
                    this.textOff = 0;
                }
            }
            let take = Math.min(this.text.length - this.textOff, length, 512 /* T.Chunk */ );
            this.flushBuffer(active.slice(active.length - openStart));
            this.getLine().append($1d528cc0e08a0656$var$wrapMarks(new $1d528cc0e08a0656$var$TextView(this.text.slice(this.textOff, this.textOff + take)), active), openStart);
            this.atCursorPos = true;
            this.textOff += take;
            length -= take;
            openStart = 0;
        }
    }
    span(from, to, active, openStart) {
        this.buildText(to - from, active, openStart);
        this.pos = to;
        if (this.openStart < 0) this.openStart = openStart;
    }
    point(from, to, deco, active, openStart, index) {
        if (this.disallowBlockEffectsFor[index] && deco instanceof $1d528cc0e08a0656$var$PointDecoration) {
            if (deco.block) throw new RangeError("Block decorations may not be specified via plugins");
            if (to > this.doc.lineAt(this.pos).to) throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
        }
        let len = to - from;
        if (deco instanceof $1d528cc0e08a0656$var$PointDecoration) {
            if (deco.block) {
                if (deco.startSide > 0 && !this.posCovered()) this.getLine();
                this.addBlockWidget(new $1d528cc0e08a0656$var$BlockWidgetView(deco.widget || $1d528cc0e08a0656$var$NullWidget.block, len, deco));
            } else {
                let view = $1d528cc0e08a0656$var$WidgetView.create(deco.widget || $1d528cc0e08a0656$var$NullWidget.inline, len, len ? 0 : deco.startSide);
                let cursorBefore = this.atCursorPos && !view.isEditable && openStart <= active.length && (from < to || deco.startSide > 0);
                let cursorAfter = !view.isEditable && (from < to || openStart > active.length || deco.startSide <= 0);
                let line = this.getLine();
                if (this.pendingBuffer == 2 /* Buf.IfCursor */  && !cursorBefore && !view.isEditable) this.pendingBuffer = 0 /* Buf.No */ ;
                this.flushBuffer(active);
                if (cursorBefore) {
                    line.append($1d528cc0e08a0656$var$wrapMarks(new $1d528cc0e08a0656$var$WidgetBufferView(1), active), openStart);
                    openStart = active.length + Math.max(0, openStart - active.length);
                }
                line.append($1d528cc0e08a0656$var$wrapMarks(view, active), openStart);
                this.atCursorPos = cursorAfter;
                this.pendingBuffer = !cursorAfter ? 0 /* Buf.No */  : from < to || openStart > active.length ? 1 /* Buf.Yes */  : 2 /* Buf.IfCursor */ ;
                if (this.pendingBuffer) this.bufferMarks = active.slice();
            }
        } else if (this.doc.lineAt(this.pos).from == this.pos) this.getLine().addLineDeco(deco);
        if (len) {
            // Advance the iterator past the replaced content
            if (this.textOff + len <= this.text.length) this.textOff += len;
            else {
                this.skip += len - (this.text.length - this.textOff);
                this.text = "";
                this.textOff = 0;
            }
            this.pos = to;
        }
        if (this.openStart < 0) this.openStart = openStart;
    }
    static build(text, from, to, decorations, dynamicDecorationMap) {
        let builder = new $1d528cc0e08a0656$var$ContentBuilder(text, from, to, dynamicDecorationMap);
        builder.openEnd = (0, $6b8f387faea0a4dd$export$34cb5241245008dd).spans(decorations, from, to, builder);
        if (builder.openStart < 0) builder.openStart = builder.openEnd;
        builder.finish(builder.openEnd);
        return builder;
    }
}
function $1d528cc0e08a0656$var$wrapMarks(view, active) {
    for (let mark of active)view = new $1d528cc0e08a0656$var$MarkView(mark, [
        view
    ], view.length);
    return view;
}
class $1d528cc0e08a0656$var$NullWidget extends $1d528cc0e08a0656$export$95cdd842edb044c5 {
    constructor(tag){
        super();
        this.tag = tag;
    }
    eq(other) {
        return other.tag == this.tag;
    }
    toDOM() {
        return document.createElement(this.tag);
    }
    updateDOM(elt) {
        return elt.nodeName.toLowerCase() == this.tag;
    }
    get isHidden() {
        return true;
    }
}
$1d528cc0e08a0656$var$NullWidget.inline = /*@__PURE__*/ new $1d528cc0e08a0656$var$NullWidget("span");
$1d528cc0e08a0656$var$NullWidget.block = /*@__PURE__*/ new $1d528cc0e08a0656$var$NullWidget("div");
/**
Used to indicate [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
*/ var $1d528cc0e08a0656$export$cacd6541cfeeb6c1 = /*@__PURE__*/ function(Direction) {
    // (These are chosen to match the base levels, in bidi algorithm
    // terms, of spans in that direction.)
    /**
    Left-to-right.
    */ Direction[Direction["LTR"] = 0] = "LTR";
    /**
    Right-to-left.
    */ Direction[Direction["RTL"] = 1] = "RTL";
    return Direction;
}($1d528cc0e08a0656$export$cacd6541cfeeb6c1 || ($1d528cc0e08a0656$export$cacd6541cfeeb6c1 = {}));
const $1d528cc0e08a0656$var$LTR = $1d528cc0e08a0656$export$cacd6541cfeeb6c1.LTR, $1d528cc0e08a0656$var$RTL = $1d528cc0e08a0656$export$cacd6541cfeeb6c1.RTL;
// Decode a string with each type encoded as log2(type)
function $1d528cc0e08a0656$var$dec(str) {
    let result = [];
    for(let i = 0; i < str.length; i++)result.push(1 << +str[i]);
    return result;
}
// Character types for codepoints 0 to 0xf8
const $1d528cc0e08a0656$var$LowTypes = /*@__PURE__*/ $1d528cc0e08a0656$var$dec("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008");
// Character types for codepoints 0x600 to 0x6f9
const $1d528cc0e08a0656$var$ArabicTypes = /*@__PURE__*/ $1d528cc0e08a0656$var$dec("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333");
const $1d528cc0e08a0656$var$Brackets = /*@__PURE__*/ Object.create(null), $1d528cc0e08a0656$var$BracketStack = [];
// There's a lot more in
// https://www.unicode.org/Public/UCD/latest/ucd/BidiBrackets.txt,
// which are left out to keep code size down.
for (let p of [
    "()",
    "[]",
    "{}"
]){
    let l = /*@__PURE__*/ p.charCodeAt(0), r = /*@__PURE__*/ p.charCodeAt(1);
    $1d528cc0e08a0656$var$Brackets[l] = r;
    $1d528cc0e08a0656$var$Brackets[r] = -l;
}
function $1d528cc0e08a0656$var$charType(ch) {
    return ch <= 0xf7 ? $1d528cc0e08a0656$var$LowTypes[ch] : 0x590 <= ch && ch <= 0x5f4 ? 2 /* T.R */  : 0x600 <= ch && ch <= 0x6f9 ? $1d528cc0e08a0656$var$ArabicTypes[ch - 0x600] : 0x6ee <= ch && ch <= 0x8ac ? 4 /* T.AL */  : 0x2000 <= ch && ch <= 0x200c ? 256 /* T.NI */  : 0xfb50 <= ch && ch <= 0xfdff ? 4 /* T.AL */  : 1 /* T.L */ ;
}
const $1d528cc0e08a0656$var$BidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
/**
Represents a contiguous range of text that has a single direction
(as in left-to-right or right-to-left).
*/ class $1d528cc0e08a0656$export$e1ed96b746bb516a {
    /**
    The direction of this span.
    */ get dir() {
        return this.level % 2 ? $1d528cc0e08a0656$var$RTL : $1d528cc0e08a0656$var$LTR;
    }
    /**
    @internal
    */ constructor(/**
    The start of the span (relative to the start of the line).
    */ from, /**
    The end of the span.
    */ to, /**
    The ["bidi
    level"](https://unicode.org/reports/tr9/#Basic_Display_Algorithm)
    of the span (in this context, 0 means
    left-to-right, 1 means right-to-left, 2 means left-to-right
    number inside right-to-left text).
    */ level){
        this.from = from;
        this.to = to;
        this.level = level;
    }
    /**
    @internal
    */ side(end, dir) {
        return this.dir == dir == end ? this.to : this.from;
    }
    /**
    @internal
    */ forward(forward, dir) {
        return forward == (this.dir == dir);
    }
    /**
    @internal
    */ static find(order, index, level, assoc) {
        let maybe = -1;
        for(let i = 0; i < order.length; i++){
            let span = order[i];
            if (span.from <= index && span.to >= index) {
                if (span.level == level) return i;
                // When multiple spans match, if assoc != 0, take the one that
                // covers that side, otherwise take the one with the minimum
                // level.
                if (maybe < 0 || (assoc != 0 ? assoc < 0 ? span.from < index : span.to > index : order[maybe].level > span.level)) maybe = i;
            }
        }
        if (maybe < 0) throw new RangeError("Index out of range");
        return maybe;
    }
}
function $1d528cc0e08a0656$var$isolatesEq(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++){
        let iA = a[i], iB = b[i];
        if (iA.from != iB.from || iA.to != iB.to || iA.direction != iB.direction || !$1d528cc0e08a0656$var$isolatesEq(iA.inner, iB.inner)) return false;
    }
    return true;
}
// Reused array of character types
const $1d528cc0e08a0656$var$types = [];
// Fill in the character types (in `types`) from `from` to `to` and
// apply W normalization rules.
function $1d528cc0e08a0656$var$computeCharTypes(line, rFrom, rTo, isolates, outerType) {
    for(let iI = 0; iI <= isolates.length; iI++){
        let from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        let prevType = iI ? 256 /* T.NI */  : outerType;
        // W1. Examine each non-spacing mark (NSM) in the level run, and
        // change the type of the NSM to the type of the previous
        // character. If the NSM is at the start of the level run, it will
        // get the type of sor.
        // W2. Search backwards from each instance of a European number
        // until the first strong type (R, L, AL, or sor) is found. If an
        // AL is found, change the type of the European number to Arabic
        // number.
        // W3. Change all ALs to R.
        // (Left after this: L, R, EN, AN, ET, CS, NI)
        for(let i = from, prev = prevType, prevStrong = prevType; i < to; i++){
            let type = $1d528cc0e08a0656$var$charType(line.charCodeAt(i));
            if (type == 512 /* T.NSM */ ) type = prev;
            else if (type == 8 /* T.EN */  && prevStrong == 4 /* T.AL */ ) type = 16 /* T.AN */ ;
            $1d528cc0e08a0656$var$types[i] = type == 4 /* T.AL */  ? 2 /* T.R */  : type;
            if (type & 7 /* T.Strong */ ) prevStrong = type;
            prev = type;
        }
        // W5. A sequence of European terminators adjacent to European
        // numbers changes to all European numbers.
        // W6. Otherwise, separators and terminators change to Other
        // Neutral.
        // W7. Search backwards from each instance of a European number
        // until the first strong type (R, L, or sor) is found. If an L is
        // found, then change the type of the European number to L.
        // (Left after this: L, R, EN+AN, NI)
        for(let i = from, prev = prevType, prevStrong = prevType; i < to; i++){
            let type = $1d528cc0e08a0656$var$types[i];
            if (type == 128 /* T.CS */ ) {
                if (i < to - 1 && prev == $1d528cc0e08a0656$var$types[i + 1] && prev & 24 /* T.Num */ ) type = $1d528cc0e08a0656$var$types[i] = prev;
                else $1d528cc0e08a0656$var$types[i] = 256 /* T.NI */ ;
            } else if (type == 64 /* T.ET */ ) {
                let end = i + 1;
                while(end < to && $1d528cc0e08a0656$var$types[end] == 64 /* T.ET */ )end++;
                let replace = i && prev == 8 /* T.EN */  || end < rTo && $1d528cc0e08a0656$var$types[end] == 8 /* T.EN */  ? prevStrong == 1 /* T.L */  ? 1 /* T.L */  : 8 /* T.EN */  : 256 /* T.NI */ ;
                for(let j = i; j < end; j++)$1d528cc0e08a0656$var$types[j] = replace;
                i = end - 1;
            } else if (type == 8 /* T.EN */  && prevStrong == 1 /* T.L */ ) $1d528cc0e08a0656$var$types[i] = 1 /* T.L */ ;
            prev = type;
            if (type & 7 /* T.Strong */ ) prevStrong = type;
        }
    }
}
// Process brackets throughout a run sequence.
function $1d528cc0e08a0656$var$processBracketPairs(line, rFrom, rTo, isolates, outerType) {
    let oppositeType = outerType == 1 /* T.L */  ? 2 /* T.R */  : 1 /* T.L */ ;
    for(let iI = 0, sI = 0, context = 0; iI <= isolates.length; iI++){
        let from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        // N0. Process bracket pairs in an isolating run sequence
        // sequentially in the logical order of the text positions of the
        // opening paired brackets using the logic given below. Within this
        // scope, bidirectional types EN and AN are treated as R.
        for(let i = from, ch, br, type; i < to; i++){
            // Keeps [startIndex, type, strongSeen] triples for each open
            // bracket on BracketStack.
            if (br = $1d528cc0e08a0656$var$Brackets[ch = line.charCodeAt(i)]) {
                if (br < 0) {
                    for(let sJ = sI - 3; sJ >= 0; sJ -= 3)if ($1d528cc0e08a0656$var$BracketStack[sJ + 1] == -br) {
                        let flags = $1d528cc0e08a0656$var$BracketStack[sJ + 2];
                        let type = flags & 2 /* Bracketed.EmbedInside */  ? outerType : !(flags & 4 /* Bracketed.OppositeInside */ ) ? 0 : flags & 1 /* Bracketed.OppositeBefore */  ? oppositeType : outerType;
                        if (type) $1d528cc0e08a0656$var$types[i] = $1d528cc0e08a0656$var$types[$1d528cc0e08a0656$var$BracketStack[sJ]] = type;
                        sI = sJ;
                        break;
                    }
                } else if ($1d528cc0e08a0656$var$BracketStack.length == 189 /* Bracketed.MaxDepth */ ) break;
                else {
                    $1d528cc0e08a0656$var$BracketStack[sI++] = i;
                    $1d528cc0e08a0656$var$BracketStack[sI++] = ch;
                    $1d528cc0e08a0656$var$BracketStack[sI++] = context;
                }
            } else if ((type = $1d528cc0e08a0656$var$types[i]) == 2 /* T.R */  || type == 1 /* T.L */ ) {
                let embed = type == outerType;
                context = embed ? 0 : 1 /* Bracketed.OppositeBefore */ ;
                for(let sJ = sI - 3; sJ >= 0; sJ -= 3){
                    let cur = $1d528cc0e08a0656$var$BracketStack[sJ + 2];
                    if (cur & 2 /* Bracketed.EmbedInside */ ) break;
                    if (embed) $1d528cc0e08a0656$var$BracketStack[sJ + 2] |= 2 /* Bracketed.EmbedInside */ ;
                    else {
                        if (cur & 4 /* Bracketed.OppositeInside */ ) break;
                        $1d528cc0e08a0656$var$BracketStack[sJ + 2] |= 4 /* Bracketed.OppositeInside */ ;
                    }
                }
            }
        }
    }
}
function $1d528cc0e08a0656$var$processNeutrals(rFrom, rTo, isolates, outerType) {
    for(let iI = 0, prev = outerType; iI <= isolates.length; iI++){
        let from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        // N1. A sequence of neutrals takes the direction of the
        // surrounding strong text if the text on both sides has the same
        // direction. European and Arabic numbers act as if they were R in
        // terms of their influence on neutrals. Start-of-level-run (sor)
        // and end-of-level-run (eor) are used at level run boundaries.
        // N2. Any remaining neutrals take the embedding direction.
        // (Left after this: L, R, EN+AN)
        for(let i = from; i < to;){
            let type = $1d528cc0e08a0656$var$types[i];
            if (type == 256 /* T.NI */ ) {
                let end = i + 1;
                for(;;){
                    if (end == to) {
                        if (iI == isolates.length) break;
                        end = isolates[iI++].to;
                        to = iI < isolates.length ? isolates[iI].from : rTo;
                    } else if ($1d528cc0e08a0656$var$types[end] == 256 /* T.NI */ ) end++;
                    else break;
                }
                let beforeL = prev == 1 /* T.L */ ;
                let afterL = (end < rTo ? $1d528cc0e08a0656$var$types[end] : outerType) == 1 /* T.L */ ;
                let replace = beforeL == afterL ? beforeL ? 1 /* T.L */  : 2 /* T.R */  : outerType;
                for(let j = end, jI = iI, fromJ = jI ? isolates[jI - 1].to : rFrom; j > i;){
                    if (j == fromJ) {
                        j = isolates[--jI].from;
                        fromJ = jI ? isolates[jI - 1].to : rFrom;
                    }
                    $1d528cc0e08a0656$var$types[--j] = replace;
                }
                i = end;
            } else {
                prev = type;
                i++;
            }
        }
    }
}
// Find the contiguous ranges of character types in a given range, and
// emit spans for them. Flip the order of the spans as appropriate
// based on the level, and call through to compute the spans for
// isolates at the proper point.
function $1d528cc0e08a0656$var$emitSpans(line, from, to, level, baseLevel, isolates, order) {
    let ourType = level % 2 ? 2 /* T.R */  : 1 /* T.L */ ;
    if (level % 2 == baseLevel % 2) for(let iCh = from, iI = 0; iCh < to;){
        // Scan a section of characters in direction ourType, unless
        // there's another type of char right after iCh, in which case
        // we scan a section of other characters (which, if ourType ==
        // T.L, may contain both T.R and T.AN chars).
        let sameDir = true, isNum = false;
        if (iI == isolates.length || iCh < isolates[iI].from) {
            let next = $1d528cc0e08a0656$var$types[iCh];
            if (next != ourType) {
                sameDir = false;
                isNum = next == 16 /* T.AN */ ;
            }
        }
        // Holds an array of isolates to pass to a recursive call if we
        // must recurse (to distinguish T.AN inside an RTL section in
        // LTR text), null if we can emit directly
        let recurse = !sameDir && ourType == 1 /* T.L */  ? [] : null;
        let localLevel = sameDir ? level : level + 1;
        let iScan = iCh;
        run: for(;;){
            if (iI < isolates.length && iScan == isolates[iI].from) {
                if (isNum) break run;
                let iso = isolates[iI];
                // Scan ahead to verify that there is another char in this dir after the isolate(s)
                if (!sameDir) for(let upto = iso.to, jI = iI + 1;;){
                    if (upto == to) break run;
                    if (jI < isolates.length && isolates[jI].from == upto) upto = isolates[jI++].to;
                    else if ($1d528cc0e08a0656$var$types[upto] == ourType) break run;
                    else break;
                }
                iI++;
                if (recurse) recurse.push(iso);
                else {
                    if (iso.from > iCh) order.push(new $1d528cc0e08a0656$export$e1ed96b746bb516a(iCh, iso.from, localLevel));
                    let dirSwap = iso.direction == $1d528cc0e08a0656$var$LTR != !(localLevel % 2);
                    $1d528cc0e08a0656$var$computeSectionOrder(line, dirSwap ? level + 1 : level, baseLevel, iso.inner, iso.from, iso.to, order);
                    iCh = iso.to;
                }
                iScan = iso.to;
            } else if (iScan == to || (sameDir ? $1d528cc0e08a0656$var$types[iScan] != ourType : $1d528cc0e08a0656$var$types[iScan] == ourType)) break;
            else iScan++;
        }
        if (recurse) $1d528cc0e08a0656$var$emitSpans(line, iCh, iScan, level + 1, baseLevel, recurse, order);
        else if (iCh < iScan) order.push(new $1d528cc0e08a0656$export$e1ed96b746bb516a(iCh, iScan, localLevel));
        iCh = iScan;
    }
    else // Iterate in reverse to flip the span order. Same code again, but
    // going from the back of the section to the front
    for(let iCh = to, iI = isolates.length; iCh > from;){
        let sameDir = true, isNum = false;
        if (!iI || iCh > isolates[iI - 1].to) {
            let next = $1d528cc0e08a0656$var$types[iCh - 1];
            if (next != ourType) {
                sameDir = false;
                isNum = next == 16 /* T.AN */ ;
            }
        }
        let recurse = !sameDir && ourType == 1 /* T.L */  ? [] : null;
        let localLevel = sameDir ? level : level + 1;
        let iScan = iCh;
        run: for(;;){
            if (iI && iScan == isolates[iI - 1].to) {
                if (isNum) break run;
                let iso = isolates[--iI];
                // Scan ahead to verify that there is another char in this dir after the isolate(s)
                if (!sameDir) for(let upto = iso.from, jI = iI;;){
                    if (upto == from) break run;
                    if (jI && isolates[jI - 1].to == upto) upto = isolates[--jI].from;
                    else if ($1d528cc0e08a0656$var$types[upto - 1] == ourType) break run;
                    else break;
                }
                if (recurse) recurse.push(iso);
                else {
                    if (iso.to < iCh) order.push(new $1d528cc0e08a0656$export$e1ed96b746bb516a(iso.to, iCh, localLevel));
                    let dirSwap = iso.direction == $1d528cc0e08a0656$var$LTR != !(localLevel % 2);
                    $1d528cc0e08a0656$var$computeSectionOrder(line, dirSwap ? level + 1 : level, baseLevel, iso.inner, iso.from, iso.to, order);
                    iCh = iso.from;
                }
                iScan = iso.from;
            } else if (iScan == from || (sameDir ? $1d528cc0e08a0656$var$types[iScan - 1] != ourType : $1d528cc0e08a0656$var$types[iScan - 1] == ourType)) break;
            else iScan--;
        }
        if (recurse) $1d528cc0e08a0656$var$emitSpans(line, iScan, iCh, level + 1, baseLevel, recurse, order);
        else if (iScan < iCh) order.push(new $1d528cc0e08a0656$export$e1ed96b746bb516a(iScan, iCh, localLevel));
        iCh = iScan;
    }
}
function $1d528cc0e08a0656$var$computeSectionOrder(line, level, baseLevel, isolates, from, to, order) {
    let outerType = level % 2 ? 2 /* T.R */  : 1 /* T.L */ ;
    $1d528cc0e08a0656$var$computeCharTypes(line, from, to, isolates, outerType);
    $1d528cc0e08a0656$var$processBracketPairs(line, from, to, isolates, outerType);
    $1d528cc0e08a0656$var$processNeutrals(from, to, isolates, outerType);
    $1d528cc0e08a0656$var$emitSpans(line, from, to, level, baseLevel, isolates, order);
}
function $1d528cc0e08a0656$var$computeOrder(line, direction, isolates) {
    if (!line) return [
        new $1d528cc0e08a0656$export$e1ed96b746bb516a(0, 0, direction == $1d528cc0e08a0656$var$RTL ? 1 : 0)
    ];
    if (direction == $1d528cc0e08a0656$var$LTR && !isolates.length && !$1d528cc0e08a0656$var$BidiRE.test(line)) return $1d528cc0e08a0656$var$trivialOrder(line.length);
    if (isolates.length) while(line.length > $1d528cc0e08a0656$var$types.length)$1d528cc0e08a0656$var$types[$1d528cc0e08a0656$var$types.length] = 256 /* T.NI */ ; // Make sure types array has no gaps
    let order = [], level = direction == $1d528cc0e08a0656$var$LTR ? 0 : 1;
    $1d528cc0e08a0656$var$computeSectionOrder(line, level, level, isolates, 0, line.length, order);
    return order;
}
function $1d528cc0e08a0656$var$trivialOrder(length) {
    return [
        new $1d528cc0e08a0656$export$e1ed96b746bb516a(0, length, 0)
    ];
}
let $1d528cc0e08a0656$var$movedOver = "";
// This implementation moves strictly visually, without concern for a
// traversal visiting every logical position in the string. It will
// still do so for simple input, but situations like multiple isolates
// with the same level next to each other, or text going against the
// main dir at the end of the line, will make some positions
// unreachable with this motion. Each visible cursor position will
// correspond to the lower-level bidi span that touches it.
//
// The alternative would be to solve an order globally for a given
// line, making sure that it includes every position, but that would
// require associating non-canonical (higher bidi span level)
// positions with a given visual position, which is likely to confuse
// people. (And would generally be a lot more complicated.)
function $1d528cc0e08a0656$var$moveVisually(line, order, dir, start, forward) {
    var _a;
    let startIndex = start.head - line.from;
    let spanI = $1d528cc0e08a0656$export$e1ed96b746bb516a.find(order, startIndex, (_a = start.bidiLevel) !== null && _a !== void 0 ? _a : -1, start.assoc);
    let span = order[spanI], spanEnd = span.side(forward, dir);
    // End of span
    if (startIndex == spanEnd) {
        let nextI = spanI += forward ? 1 : -1;
        if (nextI < 0 || nextI >= order.length) return null;
        span = order[spanI = nextI];
        startIndex = span.side(!forward, dir);
        spanEnd = span.side(forward, dir);
    }
    let nextIndex = (0, $6b8f387faea0a4dd$export$a0fa439fd515e1ed)(line.text, startIndex, span.forward(forward, dir));
    if (nextIndex < span.from || nextIndex > span.to) nextIndex = spanEnd;
    $1d528cc0e08a0656$var$movedOver = line.text.slice(Math.min(startIndex, nextIndex), Math.max(startIndex, nextIndex));
    let nextSpan = spanI == (forward ? order.length - 1 : 0) ? null : order[spanI + (forward ? 1 : -1)];
    if (nextSpan && nextIndex == spanEnd && nextSpan.level + (forward ? 0 : 1) < span.level) return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(nextSpan.side(!forward, dir) + line.from, nextSpan.forward(forward, dir) ? 1 : -1, nextSpan.level);
    return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(nextIndex + line.from, span.forward(forward, dir) ? -1 : 1, span.level);
}
function $1d528cc0e08a0656$var$autoDirection(text, from, to) {
    for(let i = from; i < to; i++){
        let type = $1d528cc0e08a0656$var$charType(text.charCodeAt(i));
        if (type == 1 /* T.L */ ) return $1d528cc0e08a0656$var$LTR;
        if (type == 2 /* T.R */  || type == 4 /* T.AL */ ) return $1d528cc0e08a0656$var$RTL;
    }
    return $1d528cc0e08a0656$var$LTR;
}
const $1d528cc0e08a0656$var$clickAddsSelectionRange = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
const $1d528cc0e08a0656$var$dragMovesSelection$1 = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
const $1d528cc0e08a0656$var$mouseSelectionStyle = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
const $1d528cc0e08a0656$var$exceptionSink = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
const $1d528cc0e08a0656$var$updateListener = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
const $1d528cc0e08a0656$var$inputHandler = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
const $1d528cc0e08a0656$var$focusChangeEffect = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
const $1d528cc0e08a0656$var$clipboardInputFilter = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
const $1d528cc0e08a0656$var$clipboardOutputFilter = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
const $1d528cc0e08a0656$var$perLineTextDirection = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
const $1d528cc0e08a0656$var$nativeSelectionHidden = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
const $1d528cc0e08a0656$var$scrollHandler = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
class $1d528cc0e08a0656$var$ScrollTarget {
    constructor(range, y = "nearest", x = "nearest", yMargin = 5, xMargin = 5, // This data structure is abused to also store precise scroll
    // snapshots, instead of a `scrollIntoView` request. When this
    // flag is `true`, `range` points at a position in the reference
    // line, `yMargin` holds the difference between the top of that
    // line and the top of the editor, and `xMargin` holds the
    // editor's `scrollLeft`.
    isSnapshot = false){
        this.range = range;
        this.y = y;
        this.x = x;
        this.yMargin = yMargin;
        this.xMargin = xMargin;
        this.isSnapshot = isSnapshot;
    }
    map(changes) {
        return changes.empty ? this : new $1d528cc0e08a0656$var$ScrollTarget(this.range.map(changes), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
    }
    clip(state) {
        return this.range.to <= state.doc.length ? this : new $1d528cc0e08a0656$var$ScrollTarget((0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(state.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
    }
}
const $1d528cc0e08a0656$var$scrollIntoView = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define({
    map: (t, ch)=>t.map(ch)
});
const $1d528cc0e08a0656$var$setEditContextFormatting = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define();
/**
Log or report an unhandled exception in client code. Should
probably only be used by extension code that allows client code to
provide functions, and calls those functions in a context where an
exception can't be propagated to calling code in a reasonable way
(for example when in an event handler).

Either calls a handler registered with
[`EditorView.exceptionSink`](https://codemirror.net/6/docs/ref/#view.EditorView^exceptionSink),
`window.onerror`, if defined, or `console.error` (in which case
it'll pass `context`, when given, as first argument).
*/ function $1d528cc0e08a0656$export$f86b2a1a2ce291b3(state, exception, context) {
    let handler = state.facet($1d528cc0e08a0656$var$exceptionSink);
    if (handler.length) handler[0](exception);
    else if (window.onerror && window.onerror(String(exception), context, undefined, undefined, exception)) ;
    else if (context) console.error(context + ":", exception);
    else console.error(exception);
}
const $1d528cc0e08a0656$var$editable = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.length ? values[0] : true
});
let $1d528cc0e08a0656$var$nextPluginID = 0;
const $1d528cc0e08a0656$var$viewPlugin = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine (plugins) {
        return plugins.filter((p, i)=>{
            for(let j = 0; j < i; j++)if (plugins[j].plugin == p.plugin) return false;
            return true;
        });
    }
});
/**
View plugins associate stateful values with a view. They can
influence the way the content is drawn, and are notified of things
that happen in the view. They optionally take an argument, in
which case you need to call [`of`](https://codemirror.net/6/docs/ref/#view.ViewPlugin.of) to create
an extension for the plugin. When the argument type is undefined,
you can use the plugin instance as an extension directly.
*/ class $1d528cc0e08a0656$export$44d5eccfd62adda7 {
    constructor(/**
    @internal
    */ id, /**
    @internal
    */ create, /**
    @internal
    */ domEventHandlers, /**
    @internal
    */ domEventObservers, buildExtensions){
        this.id = id;
        this.create = create;
        this.domEventHandlers = domEventHandlers;
        this.domEventObservers = domEventObservers;
        this.baseExtensions = buildExtensions(this);
        this.extension = this.baseExtensions.concat($1d528cc0e08a0656$var$viewPlugin.of({
            plugin: this,
            arg: undefined
        }));
    }
    /**
    Create an extension for this plugin with the given argument.
    */ of(arg) {
        return this.baseExtensions.concat($1d528cc0e08a0656$var$viewPlugin.of({
            plugin: this,
            arg: arg
        }));
    }
    /**
    Define a plugin from a constructor function that creates the
    plugin's value, given an editor view.
    */ static define(create, spec) {
        const { eventHandlers: eventHandlers, eventObservers: eventObservers, provide: provide, decorations: deco } = spec || {};
        return new $1d528cc0e08a0656$export$44d5eccfd62adda7($1d528cc0e08a0656$var$nextPluginID++, create, eventHandlers, eventObservers, (plugin)=>{
            let ext = [];
            if (deco) ext.push($1d528cc0e08a0656$var$decorations.of((view)=>{
                let pluginInst = view.plugin(plugin);
                return pluginInst ? deco(pluginInst) : $1d528cc0e08a0656$export$10e30b733df217ea.none;
            }));
            if (provide) ext.push(provide(plugin));
            return ext;
        });
    }
    /**
    Create a plugin for a class whose constructor takes a single
    editor view as argument.
    */ static fromClass(cls, spec) {
        return $1d528cc0e08a0656$export$44d5eccfd62adda7.define((view, arg)=>new cls(view, arg), spec);
    }
}
class $1d528cc0e08a0656$var$PluginInstance {
    constructor(spec){
        this.spec = spec;
        // When starting an update, all plugins have this field set to the
        // update object, indicating they need to be updated. When finished
        // updating, it is set to `null`. Retrieving a plugin that needs to
        // be updated with `view.plugin` forces an eager update.
        this.mustUpdate = null;
        // This is null when the plugin is initially created, but
        // initialized on the first update.
        this.value = null;
    }
    get plugin() {
        return this.spec && this.spec.plugin;
    }
    update(view) {
        if (!this.value) {
            if (this.spec) try {
                this.value = this.spec.plugin.create(view, this.spec.arg);
            } catch (e) {
                $1d528cc0e08a0656$export$f86b2a1a2ce291b3(view.state, e, "CodeMirror plugin crashed");
                this.deactivate();
            }
        } else if (this.mustUpdate) {
            let update = this.mustUpdate;
            this.mustUpdate = null;
            if (this.value.update) try {
                this.value.update(update);
            } catch (e) {
                $1d528cc0e08a0656$export$f86b2a1a2ce291b3(update.state, e, "CodeMirror plugin crashed");
                if (this.value.destroy) try {
                    this.value.destroy();
                } catch (_) {}
                this.deactivate();
            }
        }
        return this;
    }
    destroy(view) {
        var _a;
        if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.destroy) try {
            this.value.destroy();
        } catch (e) {
            $1d528cc0e08a0656$export$f86b2a1a2ce291b3(view.state, e, "CodeMirror plugin crashed");
        }
    }
    deactivate() {
        this.spec = this.value = null;
    }
}
const $1d528cc0e08a0656$var$editorAttributes = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
const $1d528cc0e08a0656$var$contentAttributes = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
// Provide decorations
const $1d528cc0e08a0656$var$decorations = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
const $1d528cc0e08a0656$var$outerDecorations = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
const $1d528cc0e08a0656$var$atomicRanges = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
const $1d528cc0e08a0656$var$bidiIsolatedRanges = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
function $1d528cc0e08a0656$var$getIsolatedRanges(view, line) {
    let isolates = view.state.facet($1d528cc0e08a0656$var$bidiIsolatedRanges);
    if (!isolates.length) return isolates;
    let sets = isolates.map((i)=>i instanceof Function ? i(view) : i);
    let result = [];
    (0, $6b8f387faea0a4dd$export$34cb5241245008dd).spans(sets, line.from, line.to, {
        point () {},
        span (fromDoc, toDoc, active, open) {
            let from = fromDoc - line.from, to = toDoc - line.from;
            let level = result;
            for(let i = active.length - 1; i >= 0; i--, open--){
                let direction = active[i].spec.bidiIsolate, update;
                if (direction == null) direction = $1d528cc0e08a0656$var$autoDirection(line.text, from, to);
                if (open > 0 && level.length && (update = level[level.length - 1]).to == from && update.direction == direction) {
                    update.to = to;
                    level = update.inner;
                } else {
                    let add = {
                        from: from,
                        to: to,
                        direction: direction,
                        inner: []
                    };
                    level.push(add);
                    level = add.inner;
                }
            }
        }
    });
    return result;
}
const $1d528cc0e08a0656$var$scrollMargins = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
function $1d528cc0e08a0656$var$getScrollMargins(view) {
    let left = 0, right = 0, top = 0, bottom = 0;
    for (let source of view.state.facet($1d528cc0e08a0656$var$scrollMargins)){
        let m = source(view);
        if (m) {
            if (m.left != null) left = Math.max(left, m.left);
            if (m.right != null) right = Math.max(right, m.right);
            if (m.top != null) top = Math.max(top, m.top);
            if (m.bottom != null) bottom = Math.max(bottom, m.bottom);
        }
    }
    return {
        left: left,
        right: right,
        top: top,
        bottom: bottom
    };
}
const $1d528cc0e08a0656$var$styleModule = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
class $1d528cc0e08a0656$var$ChangedRange {
    constructor(fromA, toA, fromB, toB){
        this.fromA = fromA;
        this.toA = toA;
        this.fromB = fromB;
        this.toB = toB;
    }
    join(other) {
        return new $1d528cc0e08a0656$var$ChangedRange(Math.min(this.fromA, other.fromA), Math.max(this.toA, other.toA), Math.min(this.fromB, other.fromB), Math.max(this.toB, other.toB));
    }
    addToSet(set) {
        let i = set.length, me = this;
        for(; i > 0; i--){
            let range = set[i - 1];
            if (range.fromA > me.toA) continue;
            if (range.toA < me.fromA) break;
            me = me.join(range);
            set.splice(i - 1, 1);
        }
        set.splice(i, 0, me);
        return set;
    }
    static extendWithRanges(diff, ranges) {
        if (ranges.length == 0) return diff;
        let result = [];
        for(let dI = 0, rI = 0, posA = 0, posB = 0;; dI++){
            let next = dI == diff.length ? null : diff[dI], off = posA - posB;
            let end = next ? next.fromB : 1e9;
            while(rI < ranges.length && ranges[rI] < end){
                let from = ranges[rI], to = ranges[rI + 1];
                let fromB = Math.max(posB, from), toB = Math.min(end, to);
                if (fromB <= toB) new $1d528cc0e08a0656$var$ChangedRange(fromB + off, toB + off, fromB, toB).addToSet(result);
                if (to > end) break;
                else rI += 2;
            }
            if (!next) return result;
            new $1d528cc0e08a0656$var$ChangedRange(next.fromA, next.toA, next.fromB, next.toB).addToSet(result);
            posA = next.toA;
            posB = next.toB;
        }
    }
}
/**
View [plugins](https://codemirror.net/6/docs/ref/#view.ViewPlugin) are given instances of this
class, which describe what happened, whenever the view is updated.
*/ class $1d528cc0e08a0656$export$b5b084f95c87edf7 {
    constructor(/**
    The editor view that the update is associated with.
    */ view, /**
    The new editor state.
    */ state, /**
    The transactions involved in the update. May be empty.
    */ transactions){
        this.view = view;
        this.state = state;
        this.transactions = transactions;
        /**
        @internal
        */ this.flags = 0;
        this.startState = view.state;
        this.changes = (0, $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c).empty(this.startState.doc.length);
        for (let tr of transactions)this.changes = this.changes.compose(tr.changes);
        let changedRanges = [];
        this.changes.iterChangedRanges((fromA, toA, fromB, toB)=>changedRanges.push(new $1d528cc0e08a0656$var$ChangedRange(fromA, toA, fromB, toB)));
        this.changedRanges = changedRanges;
    }
    /**
    @internal
    */ static create(view, state, transactions) {
        return new $1d528cc0e08a0656$export$b5b084f95c87edf7(view, state, transactions);
    }
    /**
    Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
    [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
    update.
    */ get viewportChanged() {
        return (this.flags & 4 /* UpdateFlag.Viewport */ ) > 0;
    }
    /**
    Returns true when
    [`viewportChanged`](https://codemirror.net/6/docs/ref/#view.ViewUpdate.viewportChanged) is true
    and the viewport change is not just the result of mapping it in
    response to document changes.
    */ get viewportMoved() {
        return (this.flags & 8 /* UpdateFlag.ViewportMoved */ ) > 0;
    }
    /**
    Indicates whether the height of a block element in the editor
    changed in this update.
    */ get heightChanged() {
        return (this.flags & 2 /* UpdateFlag.Height */ ) > 0;
    }
    /**
    Returns true when the document was modified or the size of the
    editor, or elements within the editor, changed.
    */ get geometryChanged() {
        return this.docChanged || (this.flags & 18 /* UpdateFlag.Height */ ) > 0;
    }
    /**
    True when this update indicates a focus change.
    */ get focusChanged() {
        return (this.flags & 1 /* UpdateFlag.Focus */ ) > 0;
    }
    /**
    Whether the document changed in this update.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Whether the selection was explicitly set in this update.
    */ get selectionSet() {
        return this.transactions.some((tr)=>tr.selection);
    }
    /**
    @internal
    */ get empty() {
        return this.flags == 0 && this.transactions.length == 0;
    }
}
class $1d528cc0e08a0656$var$DocView extends $1d528cc0e08a0656$var$ContentView {
    get length() {
        return this.view.state.doc.length;
    }
    constructor(view){
        super();
        this.view = view;
        this.decorations = [];
        this.dynamicDecorationMap = [
            false
        ];
        this.domChanged = null;
        this.hasComposition = null;
        this.markedForComposition = new Set;
        this.editContextFormatting = $1d528cc0e08a0656$export$10e30b733df217ea.none;
        this.lastCompositionAfterCursor = false;
        // Track a minimum width for the editor. When measuring sizes in
        // measureVisibleLineHeights, this is updated to point at the width
        // of a given element and its extent in the document. When a change
        // happens in that range, these are reset. That way, once we've seen
        // a line/element of a given length, we keep the editor wide enough
        // to fit at least that element, until it is changed, at which point
        // we forget it again.
        this.minWidth = 0;
        this.minWidthFrom = 0;
        this.minWidthTo = 0;
        // Track whether the DOM selection was set in a lossy way, so that
        // we don't mess it up when reading it back it
        this.impreciseAnchor = null;
        this.impreciseHead = null;
        this.forceSelection = false;
        // Used by the resize observer to ignore resizes that we caused
        // ourselves
        this.lastUpdate = Date.now();
        this.setDOM(view.contentDOM);
        this.children = [
            new $1d528cc0e08a0656$var$LineView
        ];
        this.children[0].setParent(this);
        this.updateDeco();
        this.updateInner([
            new $1d528cc0e08a0656$var$ChangedRange(0, 0, 0, view.state.doc.length)
        ], 0, null);
    }
    // Update the document view to a given state.
    update(update) {
        var _a;
        let changedRanges = update.changedRanges;
        if (this.minWidth > 0 && changedRanges.length) {
            if (!changedRanges.every(({ fromA: fromA, toA: toA })=>toA < this.minWidthFrom || fromA > this.minWidthTo)) this.minWidth = this.minWidthFrom = this.minWidthTo = 0;
            else {
                this.minWidthFrom = update.changes.mapPos(this.minWidthFrom, 1);
                this.minWidthTo = update.changes.mapPos(this.minWidthTo, 1);
            }
        }
        this.updateEditContextFormatting(update);
        let readCompositionAt = -1;
        if (this.view.inputState.composing >= 0 && !this.view.observer.editContext) {
            if ((_a = this.domChanged) === null || _a === void 0 ? void 0 : _a.newSel) readCompositionAt = this.domChanged.newSel.head;
            else if (!$1d528cc0e08a0656$var$touchesComposition(update.changes, this.hasComposition) && !update.selectionSet) readCompositionAt = update.state.selection.main.head;
        }
        let composition = readCompositionAt > -1 ? $1d528cc0e08a0656$var$findCompositionRange(this.view, update.changes, readCompositionAt) : null;
        this.domChanged = null;
        if (this.hasComposition) {
            this.markedForComposition.clear();
            let { from: from, to: to } = this.hasComposition;
            changedRanges = new $1d528cc0e08a0656$var$ChangedRange(from, to, update.changes.mapPos(from, -1), update.changes.mapPos(to, 1)).addToSet(changedRanges.slice());
        }
        this.hasComposition = composition ? {
            from: composition.range.fromB,
            to: composition.range.toB
        } : null;
        // When the DOM nodes around the selection are moved to another
        // parent, Chrome sometimes reports a different selection through
        // getSelection than the one that it actually shows to the user.
        // This forces a selection update when lines are joined to work
        // around that. Issue #54
        if (($1d528cc0e08a0656$var$browser.ie || $1d528cc0e08a0656$var$browser.chrome) && !composition && update && update.state.doc.lines != update.startState.doc.lines) this.forceSelection = true;
        let prevDeco = this.decorations, deco = this.updateDeco();
        let decoDiff = $1d528cc0e08a0656$var$findChangedDeco(prevDeco, deco, update.changes);
        changedRanges = $1d528cc0e08a0656$var$ChangedRange.extendWithRanges(changedRanges, decoDiff);
        if (!(this.flags & 7 /* ViewFlag.Dirty */ ) && changedRanges.length == 0) return false;
        else {
            this.updateInner(changedRanges, update.startState.doc.length, composition);
            if (update.transactions.length) this.lastUpdate = Date.now();
            return true;
        }
    }
    // Used by update and the constructor do perform the actual DOM
    // update
    updateInner(changes, oldLength, composition) {
        this.view.viewState.mustMeasureContent = true;
        this.updateChildren(changes, oldLength, composition);
        let { observer: observer } = this.view;
        observer.ignore(()=>{
            // Lock the height during redrawing, since Chrome sometimes
            // messes with the scroll position during DOM mutation (though
            // no relayout is triggered and I cannot imagine how it can
            // recompute the scroll position without a layout)
            this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px";
            this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
            // Chrome will sometimes, when DOM mutations occur directly
            // around the selection, get confused and report a different
            // selection from the one it displays (issue #218). This tries
            // to detect that situation.
            let track = $1d528cc0e08a0656$var$browser.chrome || $1d528cc0e08a0656$var$browser.ios ? {
                node: observer.selectionRange.focusNode,
                written: false
            } : undefined;
            this.sync(this.view, track);
            this.flags &= -8 /* ViewFlag.Dirty */ ;
            if (track && (track.written || observer.selectionRange.focusNode != track.node)) this.forceSelection = true;
            this.dom.style.height = "";
        });
        this.markedForComposition.forEach((cView)=>cView.flags &= -9 /* ViewFlag.Composition */ );
        let gaps = [];
        if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) {
            for (let child of this.children)if (child instanceof $1d528cc0e08a0656$var$BlockWidgetView && child.widget instanceof $1d528cc0e08a0656$var$BlockGapWidget) gaps.push(child.dom);
        }
        observer.updateGaps(gaps);
    }
    updateChildren(changes, oldLength, composition) {
        let ranges = composition ? composition.range.addToSet(changes.slice()) : changes;
        let cursor = this.childCursor(oldLength);
        for(let i = ranges.length - 1;; i--){
            let next = i >= 0 ? ranges[i] : null;
            if (!next) break;
            let { fromA: fromA, toA: toA, fromB: fromB, toB: toB } = next, content, breakAtStart, openStart, openEnd;
            if (composition && composition.range.fromB < toB && composition.range.toB > fromB) {
                let before = $1d528cc0e08a0656$var$ContentBuilder.build(this.view.state.doc, fromB, composition.range.fromB, this.decorations, this.dynamicDecorationMap);
                let after = $1d528cc0e08a0656$var$ContentBuilder.build(this.view.state.doc, composition.range.toB, toB, this.decorations, this.dynamicDecorationMap);
                breakAtStart = before.breakAtStart;
                openStart = before.openStart;
                openEnd = after.openEnd;
                let compLine = this.compositionView(composition);
                if (after.breakAtStart) compLine.breakAfter = 1;
                else if (after.content.length && compLine.merge(compLine.length, compLine.length, after.content[0], false, after.openStart, 0)) {
                    compLine.breakAfter = after.content[0].breakAfter;
                    after.content.shift();
                }
                if (before.content.length && compLine.merge(0, 0, before.content[before.content.length - 1], true, 0, before.openEnd)) before.content.pop();
                content = before.content.concat(compLine).concat(after.content);
            } else ({ content: content, breakAtStart: breakAtStart, openStart: openStart, openEnd: openEnd } = $1d528cc0e08a0656$var$ContentBuilder.build(this.view.state.doc, fromB, toB, this.decorations, this.dynamicDecorationMap));
            let { i: toI, off: toOff } = cursor.findPos(toA, 1);
            let { i: fromI, off: fromOff } = cursor.findPos(fromA, -1);
            $1d528cc0e08a0656$var$replaceRange(this, fromI, fromOff, toI, toOff, content, breakAtStart, openStart, openEnd);
        }
        if (composition) this.fixCompositionDOM(composition);
    }
    updateEditContextFormatting(update) {
        this.editContextFormatting = this.editContextFormatting.map(update.changes);
        for (let tr of update.transactions)for (let effect of tr.effects)if (effect.is($1d528cc0e08a0656$var$setEditContextFormatting)) this.editContextFormatting = effect.value;
    }
    compositionView(composition) {
        let cur = new $1d528cc0e08a0656$var$TextView(composition.text.nodeValue);
        cur.flags |= 8 /* ViewFlag.Composition */ ;
        for (let { deco: deco } of composition.marks)cur = new $1d528cc0e08a0656$var$MarkView(deco, [
            cur
        ], cur.length);
        let line = new $1d528cc0e08a0656$var$LineView;
        line.append(cur, 0);
        return line;
    }
    fixCompositionDOM(composition) {
        let fix = (dom, cView)=>{
            cView.flags |= 8 /* ViewFlag.Composition */  | (cView.children.some((c)=>c.flags & 7 /* ViewFlag.Dirty */ ) ? 1 /* ViewFlag.ChildDirty */  : 0);
            this.markedForComposition.add(cView);
            let prev = $1d528cc0e08a0656$var$ContentView.get(dom);
            if (prev && prev != cView) prev.dom = null;
            cView.setDOM(dom);
        };
        let pos = this.childPos(composition.range.fromB, 1);
        let cView = this.children[pos.i];
        fix(composition.line, cView);
        for(let i = composition.marks.length - 1; i >= -1; i--){
            pos = cView.childPos(pos.off, 1);
            cView = cView.children[pos.i];
            fix(i >= 0 ? composition.marks[i].node : composition.text, cView);
        }
    }
    // Sync the DOM selection to this.state.selection
    updateSelection(mustRead = false, fromPointer = false) {
        if (mustRead || !this.view.observer.selectionRange.focusNode) this.view.observer.readSelectionRange();
        let activeElt = this.view.root.activeElement, focused = activeElt == this.dom;
        let selectionNotFocus = !focused && !(this.view.state.facet($1d528cc0e08a0656$var$editable) || this.dom.tabIndex > -1) && $1d528cc0e08a0656$var$hasSelection(this.dom, this.view.observer.selectionRange) && !(activeElt && this.dom.contains(activeElt));
        if (!(focused || fromPointer || selectionNotFocus)) return;
        let force = this.forceSelection;
        this.forceSelection = false;
        let main = this.view.state.selection.main;
        let anchor = this.moveToLine(this.domAtPos(main.anchor));
        let head = main.empty ? anchor : this.moveToLine(this.domAtPos(main.head));
        // Always reset on Firefox when next to an uneditable node to
        // avoid invisible cursor bugs (#111)
        if ($1d528cc0e08a0656$var$browser.gecko && main.empty && !this.hasComposition && $1d528cc0e08a0656$var$betweenUneditable(anchor)) {
            let dummy = document.createTextNode("");
            this.view.observer.ignore(()=>anchor.node.insertBefore(dummy, anchor.node.childNodes[anchor.offset] || null));
            anchor = head = new $1d528cc0e08a0656$var$DOMPos(dummy, 0);
            force = true;
        }
        let domSel = this.view.observer.selectionRange;
        // If the selection is already here, or in an equivalent position, don't touch it
        if (force || !domSel.focusNode || (!$1d528cc0e08a0656$var$isEquivalentPosition(anchor.node, anchor.offset, domSel.anchorNode, domSel.anchorOffset) || !$1d528cc0e08a0656$var$isEquivalentPosition(head.node, head.offset, domSel.focusNode, domSel.focusOffset)) && !this.suppressWidgetCursorChange(domSel, main)) {
            this.view.observer.ignore(()=>{
                // Chrome Android will hide the virtual keyboard when tapping
                // inside an uneditable node, and not bring it back when we
                // move the cursor to its proper position. This tries to
                // restore the keyboard by cycling focus.
                if ($1d528cc0e08a0656$var$browser.android && $1d528cc0e08a0656$var$browser.chrome && this.dom.contains(domSel.focusNode) && $1d528cc0e08a0656$var$inUneditable(domSel.focusNode, this.dom)) {
                    this.dom.blur();
                    this.dom.focus({
                        preventScroll: true
                    });
                }
                let rawSel = $1d528cc0e08a0656$var$getSelection(this.view.root);
                if (!rawSel) ;
                else if (main.empty) {
                    // Work around https://bugzilla.mozilla.org/show_bug.cgi?id=1612076
                    if ($1d528cc0e08a0656$var$browser.gecko) {
                        let nextTo = $1d528cc0e08a0656$var$nextToUneditable(anchor.node, anchor.offset);
                        if (nextTo && nextTo != 3 /* NextTo.After */ ) {
                            let text = (nextTo == 1 /* NextTo.Before */  ? $1d528cc0e08a0656$var$textNodeBefore : $1d528cc0e08a0656$var$textNodeAfter)(anchor.node, anchor.offset);
                            if (text) anchor = new $1d528cc0e08a0656$var$DOMPos(text.node, text.offset);
                        }
                    }
                    rawSel.collapse(anchor.node, anchor.offset);
                    if (main.bidiLevel != null && rawSel.caretBidiLevel !== undefined) rawSel.caretBidiLevel = main.bidiLevel;
                } else if (rawSel.extend) {
                    // Selection.extend can be used to create an 'inverted' selection
                    // (one where the focus is before the anchor), but not all
                    // browsers support it yet.
                    rawSel.collapse(anchor.node, anchor.offset);
                    // Safari will ignore the call above when the editor is
                    // hidden, and then raise an error on the call to extend
                    // (#940).
                    try {
                        rawSel.extend(head.node, head.offset);
                    } catch (_) {}
                } else {
                    // Primitive (IE) way
                    let range = document.createRange();
                    if (main.anchor > main.head) [anchor, head] = [
                        head,
                        anchor
                    ];
                    range.setEnd(head.node, head.offset);
                    range.setStart(anchor.node, anchor.offset);
                    rawSel.removeAllRanges();
                    rawSel.addRange(range);
                }
                if (selectionNotFocus && this.view.root.activeElement == this.dom) {
                    this.dom.blur();
                    if (activeElt) activeElt.focus();
                }
            });
            this.view.observer.setSelectionRange(anchor, head);
        }
        this.impreciseAnchor = anchor.precise ? null : new $1d528cc0e08a0656$var$DOMPos(domSel.anchorNode, domSel.anchorOffset);
        this.impreciseHead = head.precise ? null : new $1d528cc0e08a0656$var$DOMPos(domSel.focusNode, domSel.focusOffset);
    }
    // If a zero-length widget is inserted next to the cursor during
    // composition, avoid moving it across it and disrupting the
    // composition.
    suppressWidgetCursorChange(sel, cursor) {
        return this.hasComposition && cursor.empty && $1d528cc0e08a0656$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset) && this.posFromDOM(sel.focusNode, sel.focusOffset) == cursor.head;
    }
    enforceCursorAssoc() {
        if (this.hasComposition) return;
        let { view: view } = this, cursor = view.state.selection.main;
        let sel = $1d528cc0e08a0656$var$getSelection(view.root);
        let { anchorNode: anchorNode, anchorOffset: anchorOffset } = view.observer.selectionRange;
        if (!sel || !cursor.empty || !cursor.assoc || !sel.modify) return;
        let line = $1d528cc0e08a0656$var$LineView.find(this, cursor.head);
        if (!line) return;
        let lineStart = line.posAtStart;
        if (cursor.head == lineStart || cursor.head == lineStart + line.length) return;
        let before = this.coordsAt(cursor.head, -1), after = this.coordsAt(cursor.head, 1);
        if (!before || !after || before.bottom > after.top) return;
        let dom = this.domAtPos(cursor.head + cursor.assoc);
        sel.collapse(dom.node, dom.offset);
        sel.modify("move", cursor.assoc < 0 ? "forward" : "backward", "lineboundary");
        // This can go wrong in corner cases like single-character lines,
        // so check and reset if necessary.
        view.observer.readSelectionRange();
        let newRange = view.observer.selectionRange;
        if (view.docView.posFromDOM(newRange.anchorNode, newRange.anchorOffset) != cursor.from) sel.collapse(anchorNode, anchorOffset);
    }
    // If a position is in/near a block widget, move it to a nearby text
    // line, since we don't want the cursor inside a block widget.
    moveToLine(pos) {
        // Block widgets will return positions before/after them, which
        // are thus directly in the document DOM element.
        let dom = this.dom, newPos;
        if (pos.node != dom) return pos;
        for(let i = pos.offset; !newPos && i < dom.childNodes.length; i++){
            let view = $1d528cc0e08a0656$var$ContentView.get(dom.childNodes[i]);
            if (view instanceof $1d528cc0e08a0656$var$LineView) newPos = view.domAtPos(0);
        }
        for(let i = pos.offset - 1; !newPos && i >= 0; i--){
            let view = $1d528cc0e08a0656$var$ContentView.get(dom.childNodes[i]);
            if (view instanceof $1d528cc0e08a0656$var$LineView) newPos = view.domAtPos(view.length);
        }
        return newPos ? new $1d528cc0e08a0656$var$DOMPos(newPos.node, newPos.offset, true) : pos;
    }
    nearest(dom) {
        for(let cur = dom; cur;){
            let domView = $1d528cc0e08a0656$var$ContentView.get(cur);
            if (domView && domView.rootView == this) return domView;
            cur = cur.parentNode;
        }
        return null;
    }
    posFromDOM(node, offset) {
        let view = this.nearest(node);
        if (!view) throw new RangeError("Trying to find position for a DOM position outside of the document");
        return view.localPosFromDOM(node, offset) + view.posAtStart;
    }
    domAtPos(pos) {
        let { i: i, off: off } = this.childCursor().findPos(pos, -1);
        for(; i < this.children.length - 1;){
            let child = this.children[i];
            if (off < child.length || child instanceof $1d528cc0e08a0656$var$LineView) break;
            i++;
            off = 0;
        }
        return this.children[i].domAtPos(off);
    }
    coordsAt(pos, side) {
        let best = null, bestPos = 0;
        for(let off = this.length, i = this.children.length - 1; i >= 0; i--){
            let child = this.children[i], end = off - child.breakAfter, start = end - child.length;
            if (end < pos) break;
            if (start <= pos && (start < pos || child.covers(-1)) && (end > pos || child.covers(1)) && (!best || child instanceof $1d528cc0e08a0656$var$LineView && !(best instanceof $1d528cc0e08a0656$var$LineView && side >= 0))) {
                best = child;
                bestPos = start;
            } else if (best && start == pos && end == pos && child instanceof $1d528cc0e08a0656$var$BlockWidgetView && Math.abs(side) < 2) {
                if (child.deco.startSide < 0) break;
                else if (i) best = null;
            }
            off = start;
        }
        return best ? best.coordsAt(pos - bestPos, side) : null;
    }
    coordsForChar(pos) {
        let { i: i, off: off } = this.childPos(pos, 1), child = this.children[i];
        if (!(child instanceof $1d528cc0e08a0656$var$LineView)) return null;
        while(child.children.length){
            let { i: i, off: childOff } = child.childPos(off, 1);
            for(;; i++){
                if (i == child.children.length) return null;
                if ((child = child.children[i]).length) break;
            }
            off = childOff;
        }
        if (!(child instanceof $1d528cc0e08a0656$var$TextView)) return null;
        let end = (0, $6b8f387faea0a4dd$export$a0fa439fd515e1ed)(child.text, off);
        if (end == off) return null;
        let rects = $1d528cc0e08a0656$var$textRange(child.dom, off, end).getClientRects();
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (i == rects.length - 1 || rect.top < rect.bottom && rect.left < rect.right) return rect;
        }
        return null;
    }
    measureVisibleLineHeights(viewport) {
        let result = [], { from: from, to: to } = viewport;
        let contentWidth = this.view.contentDOM.clientWidth;
        let isWider = contentWidth > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1;
        let widest = -1, ltr = this.view.textDirection == $1d528cc0e08a0656$export$cacd6541cfeeb6c1.LTR;
        for(let pos = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (end > to) break;
            if (pos >= from) {
                let childRect = child.dom.getBoundingClientRect();
                result.push(childRect.height);
                if (isWider) {
                    let last = child.dom.lastChild;
                    let rects = last ? $1d528cc0e08a0656$var$clientRectsFor(last) : [];
                    if (rects.length) {
                        let rect = rects[rects.length - 1];
                        let width = ltr ? rect.right - childRect.left : childRect.right - rect.left;
                        if (width > widest) {
                            widest = width;
                            this.minWidth = contentWidth;
                            this.minWidthFrom = pos;
                            this.minWidthTo = end;
                        }
                    }
                }
            }
            pos = end + child.breakAfter;
        }
        return result;
    }
    textDirectionAt(pos) {
        let { i: i } = this.childPos(pos, 1);
        return getComputedStyle(this.children[i].dom).direction == "rtl" ? $1d528cc0e08a0656$export$cacd6541cfeeb6c1.RTL : $1d528cc0e08a0656$export$cacd6541cfeeb6c1.LTR;
    }
    measureTextSize() {
        for (let child of this.children)if (child instanceof $1d528cc0e08a0656$var$LineView) {
            let measure = child.measureTextSize();
            if (measure) return measure;
        }
        // If no workable line exists, force a layout of a measurable element
        let dummy = document.createElement("div"), lineHeight, charWidth, textHeight;
        dummy.className = "cm-line";
        dummy.style.width = "99999px";
        dummy.style.position = "absolute";
        dummy.textContent = "abc def ghi jkl mno pqr stu";
        this.view.observer.ignore(()=>{
            this.dom.appendChild(dummy);
            let rect = $1d528cc0e08a0656$var$clientRectsFor(dummy.firstChild)[0];
            lineHeight = dummy.getBoundingClientRect().height;
            charWidth = rect ? rect.width / 27 : 7;
            textHeight = rect ? rect.height : lineHeight;
            dummy.remove();
        });
        return {
            lineHeight: lineHeight,
            charWidth: charWidth,
            textHeight: textHeight
        };
    }
    childCursor(pos = this.length) {
        // Move back to start of last element when possible, so that
        // `ChildCursor.findPos` doesn't have to deal with the edge case
        // of being after the last element.
        let i = this.children.length;
        if (i) pos -= this.children[--i].length;
        return new $1d528cc0e08a0656$var$ChildCursor(this.children, pos, i);
    }
    computeBlockGapDeco() {
        let deco = [], vs = this.view.viewState;
        for(let pos = 0, i = 0;; i++){
            let next = i == vs.viewports.length ? null : vs.viewports[i];
            let end = next ? next.from - 1 : this.length;
            if (end > pos) {
                let height = (vs.lineBlockAt(end).bottom - vs.lineBlockAt(pos).top) / this.view.scaleY;
                deco.push($1d528cc0e08a0656$export$10e30b733df217ea.replace({
                    widget: new $1d528cc0e08a0656$var$BlockGapWidget(height),
                    block: true,
                    inclusive: true,
                    isBlockGap: true
                }).range(pos, end));
            }
            if (!next) break;
            pos = next.to + 1;
        }
        return $1d528cc0e08a0656$export$10e30b733df217ea.set(deco);
    }
    updateDeco() {
        let i = 1;
        let allDeco = this.view.state.facet($1d528cc0e08a0656$var$decorations).map((d)=>{
            let dynamic = this.dynamicDecorationMap[i++] = typeof d == "function";
            return dynamic ? d(this.view) : d;
        });
        let dynamicOuter = false, outerDeco = this.view.state.facet($1d528cc0e08a0656$var$outerDecorations).map((d, i)=>{
            let dynamic = typeof d == "function";
            if (dynamic) dynamicOuter = true;
            return dynamic ? d(this.view) : d;
        });
        if (outerDeco.length) {
            this.dynamicDecorationMap[i++] = dynamicOuter;
            allDeco.push((0, $6b8f387faea0a4dd$export$34cb5241245008dd).join(outerDeco));
        }
        this.decorations = [
            this.editContextFormatting,
            ...allDeco,
            this.computeBlockGapDeco(),
            this.view.viewState.lineGapDeco
        ];
        while(i < this.decorations.length)this.dynamicDecorationMap[i++] = false;
        return this.decorations;
    }
    scrollIntoView(target) {
        if (target.isSnapshot) {
            let ref = this.view.viewState.lineBlockAt(target.range.head);
            this.view.scrollDOM.scrollTop = ref.top - target.yMargin;
            this.view.scrollDOM.scrollLeft = target.xMargin;
            return;
        }
        for (let handler of this.view.state.facet($1d528cc0e08a0656$var$scrollHandler))try {
            if (handler(this.view, target.range, target)) return true;
        } catch (e) {
            $1d528cc0e08a0656$export$f86b2a1a2ce291b3(this.view.state, e, "scroll handler");
        }
        let { range: range } = target;
        let rect = this.coordsAt(range.head, range.empty ? range.assoc : range.head > range.anchor ? -1 : 1), other;
        if (!rect) return;
        if (!range.empty && (other = this.coordsAt(range.anchor, range.anchor > range.head ? -1 : 1))) rect = {
            left: Math.min(rect.left, other.left),
            top: Math.min(rect.top, other.top),
            right: Math.max(rect.right, other.right),
            bottom: Math.max(rect.bottom, other.bottom)
        };
        let margins = $1d528cc0e08a0656$var$getScrollMargins(this.view);
        let targetRect = {
            left: rect.left - margins.left,
            top: rect.top - margins.top,
            right: rect.right + margins.right,
            bottom: rect.bottom + margins.bottom
        };
        let { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = this.view.scrollDOM;
        $1d528cc0e08a0656$var$scrollRectIntoView(this.view.scrollDOM, targetRect, range.head < range.anchor ? -1 : 1, target.x, target.y, Math.max(Math.min(target.xMargin, offsetWidth), -offsetWidth), Math.max(Math.min(target.yMargin, offsetHeight), -offsetHeight), this.view.textDirection == $1d528cc0e08a0656$export$cacd6541cfeeb6c1.LTR);
    }
}
function $1d528cc0e08a0656$var$betweenUneditable(pos) {
    return pos.node.nodeType == 1 && pos.node.firstChild && (pos.offset == 0 || pos.node.childNodes[pos.offset - 1].contentEditable == "false") && (pos.offset == pos.node.childNodes.length || pos.node.childNodes[pos.offset].contentEditable == "false");
}
function $1d528cc0e08a0656$var$findCompositionNode(view, headPos) {
    let sel = view.observer.selectionRange;
    if (!sel.focusNode) return null;
    let textBefore = $1d528cc0e08a0656$var$textNodeBefore(sel.focusNode, sel.focusOffset);
    let textAfter = $1d528cc0e08a0656$var$textNodeAfter(sel.focusNode, sel.focusOffset);
    let textNode = textBefore || textAfter;
    if (textAfter && textBefore && textAfter.node != textBefore.node) {
        let descAfter = $1d528cc0e08a0656$var$ContentView.get(textAfter.node);
        if (!descAfter || descAfter instanceof $1d528cc0e08a0656$var$TextView && descAfter.text != textAfter.node.nodeValue) textNode = textAfter;
        else if (view.docView.lastCompositionAfterCursor) {
            let descBefore = $1d528cc0e08a0656$var$ContentView.get(textBefore.node);
            if (!(!descBefore || descBefore instanceof $1d528cc0e08a0656$var$TextView && descBefore.text != textBefore.node.nodeValue)) textNode = textAfter;
        }
    }
    view.docView.lastCompositionAfterCursor = textNode != textBefore;
    if (!textNode) return null;
    let from = headPos - textNode.offset;
    return {
        from: from,
        to: from + textNode.node.nodeValue.length,
        node: textNode.node
    };
}
function $1d528cc0e08a0656$var$findCompositionRange(view, changes, headPos) {
    let found = $1d528cc0e08a0656$var$findCompositionNode(view, headPos);
    if (!found) return null;
    let { node: textNode, from: from, to: to } = found, text = textNode.nodeValue;
    // Don't try to preserve multi-line compositions
    if (/[\n\r]/.test(text)) return null;
    if (view.state.doc.sliceString(found.from, found.to) != text) return null;
    let inv = changes.invertedDesc;
    let range = new $1d528cc0e08a0656$var$ChangedRange(inv.mapPos(from), inv.mapPos(to), from, to);
    let marks = [];
    for(let parent = textNode.parentNode;; parent = parent.parentNode){
        let parentView = $1d528cc0e08a0656$var$ContentView.get(parent);
        if (parentView instanceof $1d528cc0e08a0656$var$MarkView) marks.push({
            node: parent,
            deco: parentView.mark
        });
        else if (parentView instanceof $1d528cc0e08a0656$var$LineView || parent.nodeName == "DIV" && parent.parentNode == view.contentDOM) return {
            range: range,
            text: textNode,
            marks: marks,
            line: parent
        };
        else if (parent != view.contentDOM) marks.push({
            node: parent,
            deco: new $1d528cc0e08a0656$var$MarkDecoration({
                inclusive: true,
                attributes: $1d528cc0e08a0656$var$getAttrs(parent),
                tagName: parent.tagName.toLowerCase()
            })
        });
        else return null;
    }
}
function $1d528cc0e08a0656$var$nextToUneditable(node, offset) {
    if (node.nodeType != 1) return 0;
    return (offset && node.childNodes[offset - 1].contentEditable == "false" ? 1 /* NextTo.Before */  : 0) | (offset < node.childNodes.length && node.childNodes[offset].contentEditable == "false" ? 2 /* NextTo.After */  : 0);
}
let $1d528cc0e08a0656$var$DecorationComparator$1 = class DecorationComparator {
    constructor(){
        this.changes = [];
    }
    compareRange(from, to) {
        $1d528cc0e08a0656$var$addRange(from, to, this.changes);
    }
    comparePoint(from, to) {
        $1d528cc0e08a0656$var$addRange(from, to, this.changes);
    }
    boundChange(pos) {
        $1d528cc0e08a0656$var$addRange(pos, pos, this.changes);
    }
};
function $1d528cc0e08a0656$var$findChangedDeco(a, b, diff) {
    let comp = new $1d528cc0e08a0656$var$DecorationComparator$1;
    (0, $6b8f387faea0a4dd$export$34cb5241245008dd).compare(a, b, diff, comp);
    return comp.changes;
}
function $1d528cc0e08a0656$var$inUneditable(node, inside) {
    for(let cur = node; cur && cur != inside; cur = cur.assignedSlot || cur.parentNode){
        if (cur.nodeType == 1 && cur.contentEditable == 'false') return true;
    }
    return false;
}
function $1d528cc0e08a0656$var$touchesComposition(changes, composition) {
    let touched = false;
    if (composition) changes.iterChangedRanges((from, to)=>{
        if (from < composition.to && to > composition.from) touched = true;
    });
    return touched;
}
function $1d528cc0e08a0656$var$groupAt(state, pos, bias = 1) {
    let categorize = state.charCategorizer(pos);
    let line = state.doc.lineAt(pos), linePos = pos - line.from;
    if (line.length == 0) return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(pos);
    if (linePos == 0) bias = 1;
    else if (linePos == line.length) bias = -1;
    let from = linePos, to = linePos;
    if (bias < 0) from = (0, $6b8f387faea0a4dd$export$a0fa439fd515e1ed)(line.text, linePos, false);
    else to = (0, $6b8f387faea0a4dd$export$a0fa439fd515e1ed)(line.text, linePos);
    let cat = categorize(line.text.slice(from, to));
    while(from > 0){
        let prev = (0, $6b8f387faea0a4dd$export$a0fa439fd515e1ed)(line.text, from, false);
        if (categorize(line.text.slice(prev, from)) != cat) break;
        from = prev;
    }
    while(to < line.length){
        let next = (0, $6b8f387faea0a4dd$export$a0fa439fd515e1ed)(line.text, to);
        if (categorize(line.text.slice(to, next)) != cat) break;
        to = next;
    }
    return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(from + line.from, to + line.from);
}
// Search the DOM for the {node, offset} position closest to the given
// coordinates. Very inefficient and crude, but can usually be avoided
// by calling caret(Position|Range)FromPoint instead.
function $1d528cc0e08a0656$var$getdx(x, rect) {
    return rect.left > x ? rect.left - x : Math.max(0, x - rect.right);
}
function $1d528cc0e08a0656$var$getdy(y, rect) {
    return rect.top > y ? rect.top - y : Math.max(0, y - rect.bottom);
}
function $1d528cc0e08a0656$var$yOverlap(a, b) {
    return a.top < b.bottom - 1 && a.bottom > b.top + 1;
}
function $1d528cc0e08a0656$var$upTop(rect, top) {
    return top < rect.top ? {
        top: top,
        left: rect.left,
        right: rect.right,
        bottom: rect.bottom
    } : rect;
}
function $1d528cc0e08a0656$var$upBot(rect, bottom) {
    return bottom > rect.bottom ? {
        top: rect.top,
        left: rect.left,
        right: rect.right,
        bottom: bottom
    } : rect;
}
function $1d528cc0e08a0656$var$domPosAtCoords(parent, x, y) {
    let closest, closestRect, closestX, closestY, closestOverlap = false;
    let above, below, aboveRect, belowRect;
    for(let child = parent.firstChild; child; child = child.nextSibling){
        let rects = $1d528cc0e08a0656$var$clientRectsFor(child);
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (closestRect && $1d528cc0e08a0656$var$yOverlap(closestRect, rect)) rect = $1d528cc0e08a0656$var$upTop($1d528cc0e08a0656$var$upBot(rect, closestRect.bottom), closestRect.top);
            let dx = $1d528cc0e08a0656$var$getdx(x, rect), dy = $1d528cc0e08a0656$var$getdy(y, rect);
            if (dx == 0 && dy == 0) return child.nodeType == 3 ? $1d528cc0e08a0656$var$domPosInText(child, x, y) : $1d528cc0e08a0656$var$domPosAtCoords(child, x, y);
            if (!closest || closestY > dy || closestY == dy && closestX > dx) {
                closest = child;
                closestRect = rect;
                closestX = dx;
                closestY = dy;
                closestOverlap = !dx ? true : x < rect.left ? i > 0 : i < rects.length - 1;
            }
            if (dx == 0) {
                if (y > rect.bottom && (!aboveRect || aboveRect.bottom < rect.bottom)) {
                    above = child;
                    aboveRect = rect;
                } else if (y < rect.top && (!belowRect || belowRect.top > rect.top)) {
                    below = child;
                    belowRect = rect;
                }
            } else if (aboveRect && $1d528cc0e08a0656$var$yOverlap(aboveRect, rect)) aboveRect = $1d528cc0e08a0656$var$upBot(aboveRect, rect.bottom);
            else if (belowRect && $1d528cc0e08a0656$var$yOverlap(belowRect, rect)) belowRect = $1d528cc0e08a0656$var$upTop(belowRect, rect.top);
        }
    }
    if (aboveRect && aboveRect.bottom >= y) {
        closest = above;
        closestRect = aboveRect;
    } else if (belowRect && belowRect.top <= y) {
        closest = below;
        closestRect = belowRect;
    }
    if (!closest) return {
        node: parent,
        offset: 0
    };
    let clipX = Math.max(closestRect.left, Math.min(closestRect.right, x));
    if (closest.nodeType == 3) return $1d528cc0e08a0656$var$domPosInText(closest, clipX, y);
    if (closestOverlap && closest.contentEditable != "false") return $1d528cc0e08a0656$var$domPosAtCoords(closest, clipX, y);
    let offset = Array.prototype.indexOf.call(parent.childNodes, closest) + (x >= (closestRect.left + closestRect.right) / 2 ? 1 : 0);
    return {
        node: parent,
        offset: offset
    };
}
function $1d528cc0e08a0656$var$domPosInText(node, x, y) {
    let len = node.nodeValue.length;
    let closestOffset = -1, closestDY = 1e9, generalSide = 0;
    for(let i = 0; i < len; i++){
        let rects = $1d528cc0e08a0656$var$textRange(node, i, i + 1).getClientRects();
        for(let j = 0; j < rects.length; j++){
            let rect = rects[j];
            if (rect.top == rect.bottom) continue;
            if (!generalSide) generalSide = x - rect.left;
            let dy = (rect.top > y ? rect.top - y : y - rect.bottom) - 1;
            if (rect.left - 1 <= x && rect.right + 1 >= x && dy < closestDY) {
                let right = x >= (rect.left + rect.right) / 2, after = right;
                if ($1d528cc0e08a0656$var$browser.chrome || $1d528cc0e08a0656$var$browser.gecko) {
                    // Check for RTL on browsers that support getting client
                    // rects for empty ranges.
                    let rectBefore = $1d528cc0e08a0656$var$textRange(node, i).getBoundingClientRect();
                    if (rectBefore.left == rect.right) after = !right;
                }
                if (dy <= 0) return {
                    node: node,
                    offset: i + (after ? 1 : 0)
                };
                closestOffset = i + (after ? 1 : 0);
                closestDY = dy;
            }
        }
    }
    return {
        node: node,
        offset: closestOffset > -1 ? closestOffset : generalSide > 0 ? node.nodeValue.length : 0
    };
}
function $1d528cc0e08a0656$var$posAtCoords(view, coords, precise, bias = -1) {
    var _a, _b;
    let content = view.contentDOM.getBoundingClientRect(), docTop = content.top + view.viewState.paddingTop;
    let block, { docHeight: docHeight } = view.viewState;
    let { x: x, y: y } = coords, yOffset = y - docTop;
    if (yOffset < 0) return 0;
    if (yOffset > docHeight) return view.state.doc.length;
    // Scan for a text block near the queried y position
    for(let halfLine = view.viewState.heightOracle.textHeight / 2, bounced = false;;){
        block = view.elementAtHeight(yOffset);
        if (block.type == $1d528cc0e08a0656$export$48808c686fe495c4.Text) break;
        for(;;){
            // Move the y position out of this block
            yOffset = bias > 0 ? block.bottom + halfLine : block.top - halfLine;
            if (yOffset >= 0 && yOffset <= docHeight) break;
            // If the document consists entirely of replaced widgets, we
            // won't find a text block, so return 0
            if (bounced) return precise ? null : 0;
            bounced = true;
            bias = -bias;
        }
    }
    y = docTop + yOffset;
    let lineStart = block.from;
    // If this is outside of the rendered viewport, we can't determine a position
    if (lineStart < view.viewport.from) return view.viewport.from == 0 ? 0 : precise ? null : $1d528cc0e08a0656$var$posAtCoordsImprecise(view, content, block, x, y);
    if (lineStart > view.viewport.to) return view.viewport.to == view.state.doc.length ? view.state.doc.length : precise ? null : $1d528cc0e08a0656$var$posAtCoordsImprecise(view, content, block, x, y);
    // Prefer ShadowRootOrDocument.elementFromPoint if present, fall back to document if not
    let doc = view.dom.ownerDocument;
    let root = view.root.elementFromPoint ? view.root : doc;
    let element = root.elementFromPoint(x, y);
    if (element && !view.contentDOM.contains(element)) element = null;
    // If the element is unexpected, clip x at the sides of the content area and try again
    if (!element) {
        x = Math.max(content.left + 1, Math.min(content.right - 1, x));
        element = root.elementFromPoint(x, y);
        if (element && !view.contentDOM.contains(element)) element = null;
    }
    // There's visible editor content under the point, so we can try
    // using caret(Position|Range)FromPoint as a shortcut
    let node, offset = -1;
    if (element && ((_a = view.docView.nearest(element)) === null || _a === void 0 ? void 0 : _a.isEditable) != false) {
        if (doc.caretPositionFromPoint) {
            let pos = doc.caretPositionFromPoint(x, y);
            if (pos) ({ offsetNode: node, offset: offset } = pos);
        } else if (doc.caretRangeFromPoint) {
            let range = doc.caretRangeFromPoint(x, y);
            if (range) {
                ({ startContainer: node, startOffset: offset } = range);
                if (!view.contentDOM.contains(node) || $1d528cc0e08a0656$var$browser.safari && $1d528cc0e08a0656$var$isSuspiciousSafariCaretResult(node, offset, x) || $1d528cc0e08a0656$var$browser.chrome && $1d528cc0e08a0656$var$isSuspiciousChromeCaretResult(node, offset, x)) node = undefined;
            }
        }
        // Chrome will return offsets into <input> elements without child
        // nodes, which will lead to a null deref below, so clip the
        // offset to the node size.
        if (node) offset = Math.min($1d528cc0e08a0656$var$maxOffset(node), offset);
    }
    // No luck, do our own (potentially expensive) search
    if (!node || !view.docView.dom.contains(node)) {
        let line = $1d528cc0e08a0656$var$LineView.find(view.docView, lineStart);
        if (!line) return yOffset > block.top + block.height / 2 ? block.to : block.from;
        ({ node: node, offset: offset } = $1d528cc0e08a0656$var$domPosAtCoords(line.dom, x, y));
    }
    let nearest = view.docView.nearest(node);
    if (!nearest) return null;
    if (nearest.isWidget && ((_b = nearest.dom) === null || _b === void 0 ? void 0 : _b.nodeType) == 1) {
        let rect = nearest.dom.getBoundingClientRect();
        return coords.y < rect.top || coords.y <= rect.bottom && coords.x <= (rect.left + rect.right) / 2 ? nearest.posAtStart : nearest.posAtEnd;
    } else return nearest.localPosFromDOM(node, offset) + nearest.posAtStart;
}
function $1d528cc0e08a0656$var$posAtCoordsImprecise(view, contentRect, block, x, y) {
    let into = Math.round((x - contentRect.left) * view.defaultCharacterWidth);
    if (view.lineWrapping && block.height > view.defaultLineHeight * 1.5) {
        let textHeight = view.viewState.heightOracle.textHeight;
        let line = Math.floor((y - block.top - (view.defaultLineHeight - textHeight) * 0.5) / textHeight);
        into += line * view.viewState.heightOracle.lineLength;
    }
    let content = view.state.sliceDoc(block.from, block.to);
    return block.from + (0, $6b8f387faea0a4dd$export$718b3d71c384ca05)(content, into, view.state.tabSize);
}
// In case of a high line height, Safari's caretRangeFromPoint treats
// the space between lines as belonging to the last character of the
// line before. This is used to detect such a result so that it can be
// ignored (issue #401).
function $1d528cc0e08a0656$var$isSuspiciousSafariCaretResult(node, offset, x) {
    let len, scan = node;
    if (node.nodeType != 3 || offset != (len = node.nodeValue.length)) return false;
    for(;;){
        let next = scan.nextSibling;
        if (next) {
            if (next.nodeName == "BR") break;
            return false;
        } else {
            let parent = scan.parentNode;
            if (!parent || parent.nodeName == "DIV") break;
            scan = parent;
        }
    }
    return $1d528cc0e08a0656$var$textRange(node, len - 1, len).getBoundingClientRect().right > x;
}
// Chrome will move positions between lines to the start of the next line
function $1d528cc0e08a0656$var$isSuspiciousChromeCaretResult(node, offset, x) {
    if (offset != 0) return false;
    for(let cur = node;;){
        let parent = cur.parentNode;
        if (!parent || parent.nodeType != 1 || parent.firstChild != cur) return false;
        if (parent.classList.contains("cm-line")) break;
        cur = parent;
    }
    let rect = node.nodeType == 1 ? node.getBoundingClientRect() : $1d528cc0e08a0656$var$textRange(node, 0, Math.max(node.nodeValue.length, 1)).getBoundingClientRect();
    return x - rect.left > 5;
}
function $1d528cc0e08a0656$var$blockAt(view, pos, side) {
    let line = view.lineBlockAt(pos);
    if (Array.isArray(line.type)) {
        let best;
        for (let l of line.type){
            if (l.from > pos) break;
            if (l.to < pos) continue;
            if (l.from < pos && l.to > pos) return l;
            if (!best || l.type == $1d528cc0e08a0656$export$48808c686fe495c4.Text && (best.type != l.type || (side < 0 ? l.from < pos : l.to > pos))) best = l;
        }
        return best || line;
    }
    return line;
}
function $1d528cc0e08a0656$var$moveToLineBoundary(view, start, forward, includeWrap) {
    let line = $1d528cc0e08a0656$var$blockAt(view, start.head, start.assoc || -1);
    let coords = !includeWrap || line.type != $1d528cc0e08a0656$export$48808c686fe495c4.Text || !(view.lineWrapping || line.widgetLineBreaks) ? null : view.coordsAtPos(start.assoc < 0 && start.head > line.from ? start.head - 1 : start.head);
    if (coords) {
        let editorRect = view.dom.getBoundingClientRect();
        let direction = view.textDirectionAt(line.from);
        let pos = view.posAtCoords({
            x: forward == (direction == $1d528cc0e08a0656$export$cacd6541cfeeb6c1.LTR) ? editorRect.right - 1 : editorRect.left + 1,
            y: (coords.top + coords.bottom) / 2
        });
        if (pos != null) return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(pos, forward ? -1 : 1);
    }
    return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(forward ? line.to : line.from, forward ? -1 : 1);
}
function $1d528cc0e08a0656$var$moveByChar(view, start, forward, by) {
    let line = view.state.doc.lineAt(start.head), spans = view.bidiSpans(line);
    let direction = view.textDirectionAt(line.from);
    for(let cur = start, check = null;;){
        let next = $1d528cc0e08a0656$var$moveVisually(line, spans, direction, cur, forward), char = $1d528cc0e08a0656$var$movedOver;
        if (!next) {
            if (line.number == (forward ? view.state.doc.lines : 1)) return cur;
            char = "\n";
            line = view.state.doc.line(line.number + (forward ? 1 : -1));
            spans = view.bidiSpans(line);
            next = view.visualLineSide(line, !forward);
        }
        if (!check) {
            if (!by) return next;
            check = by(char);
        } else if (!check(char)) return cur;
        cur = next;
    }
}
function $1d528cc0e08a0656$var$byGroup(view, pos, start) {
    let categorize = view.state.charCategorizer(pos);
    let cat = categorize(start);
    return (next)=>{
        let nextCat = categorize(next);
        if (cat == (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Space) cat = nextCat;
        return cat == nextCat;
    };
}
function $1d528cc0e08a0656$var$moveVertically(view, start, forward, distance) {
    let startPos = start.head, dir = forward ? 1 : -1;
    if (startPos == (forward ? view.state.doc.length : 0)) return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(startPos, start.assoc);
    let goal = start.goalColumn, startY;
    let rect = view.contentDOM.getBoundingClientRect();
    let startCoords = view.coordsAtPos(startPos, start.assoc || -1), docTop = view.documentTop;
    if (startCoords) {
        if (goal == null) goal = startCoords.left - rect.left;
        startY = dir < 0 ? startCoords.top : startCoords.bottom;
    } else {
        let line = view.viewState.lineBlockAt(startPos);
        if (goal == null) goal = Math.min(rect.right - rect.left, view.defaultCharacterWidth * (startPos - line.from));
        startY = (dir < 0 ? line.top : line.bottom) + docTop;
    }
    let resolvedGoal = rect.left + goal;
    let dist = distance !== null && distance !== void 0 ? distance : view.viewState.heightOracle.textHeight >> 1;
    for(let extra = 0;; extra += 10){
        let curY = startY + (dist + extra) * dir;
        let pos = $1d528cc0e08a0656$var$posAtCoords(view, {
            x: resolvedGoal,
            y: curY
        }, false, dir);
        if (curY < rect.top || curY > rect.bottom || (dir < 0 ? pos < startPos : pos > startPos)) {
            let charRect = view.docView.coordsForChar(pos);
            let assoc = !charRect || curY < charRect.top ? -1 : 1;
            return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(pos, assoc, undefined, goal);
        }
    }
}
function $1d528cc0e08a0656$var$skipAtomicRanges(atoms, pos, bias) {
    for(;;){
        let moved = 0;
        for (let set of atoms)set.between(pos - 1, pos + 1, (from, to, value)=>{
            if (pos > from && pos < to) {
                let side = moved || bias || (pos - from < to - pos ? -1 : 1);
                pos = side < 0 ? from : to;
                moved = side;
            }
        });
        if (!moved) return pos;
    }
}
function $1d528cc0e08a0656$var$skipAtoms(view, oldPos, pos) {
    let newPos = $1d528cc0e08a0656$var$skipAtomicRanges(view.state.facet($1d528cc0e08a0656$var$atomicRanges).map((f)=>f(view)), pos.from, oldPos.head > pos.from ? -1 : 1);
    return newPos == pos.from ? pos : (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(newPos, newPos < pos.from ? 1 : -1);
}
const $1d528cc0e08a0656$var$LineBreakPlaceholder = "\uffff";
class $1d528cc0e08a0656$var$DOMReader {
    constructor(points, state){
        this.points = points;
        this.text = "";
        this.lineSeparator = state.facet((0, $6b8f387faea0a4dd$export$afa855cbfaff27f2).lineSeparator);
    }
    append(text) {
        this.text += text;
    }
    lineBreak() {
        this.text += $1d528cc0e08a0656$var$LineBreakPlaceholder;
    }
    readRange(start, end) {
        if (!start) return this;
        let parent = start.parentNode;
        for(let cur = start;;){
            this.findPointBefore(parent, cur);
            let oldLen = this.text.length;
            this.readNode(cur);
            let next = cur.nextSibling;
            if (next == end) break;
            let view = $1d528cc0e08a0656$var$ContentView.get(cur), nextView = $1d528cc0e08a0656$var$ContentView.get(next);
            if (view && nextView ? view.breakAfter : (view ? view.breakAfter : $1d528cc0e08a0656$var$isBlockElement(cur)) || $1d528cc0e08a0656$var$isBlockElement(next) && (cur.nodeName != "BR" || cur.cmIgnore) && this.text.length > oldLen) this.lineBreak();
            cur = next;
        }
        this.findPointBefore(parent, end);
        return this;
    }
    readTextNode(node) {
        let text = node.nodeValue;
        for (let point of this.points)if (point.node == node) point.pos = this.text.length + Math.min(point.offset, text.length);
        for(let off = 0, re = this.lineSeparator ? null : /\r\n?|\n/g;;){
            let nextBreak = -1, breakSize = 1, m;
            if (this.lineSeparator) {
                nextBreak = text.indexOf(this.lineSeparator, off);
                breakSize = this.lineSeparator.length;
            } else if (m = re.exec(text)) {
                nextBreak = m.index;
                breakSize = m[0].length;
            }
            this.append(text.slice(off, nextBreak < 0 ? text.length : nextBreak));
            if (nextBreak < 0) break;
            this.lineBreak();
            if (breakSize > 1) {
                for (let point of this.points)if (point.node == node && point.pos > this.text.length) point.pos -= breakSize - 1;
            }
            off = nextBreak + breakSize;
        }
    }
    readNode(node) {
        if (node.cmIgnore) return;
        let view = $1d528cc0e08a0656$var$ContentView.get(node);
        let fromView = view && view.overrideDOMText;
        if (fromView != null) {
            this.findPointInside(node, fromView.length);
            for(let i = fromView.iter(); !i.next().done;)if (i.lineBreak) this.lineBreak();
            else this.append(i.value);
        } else if (node.nodeType == 3) this.readTextNode(node);
        else if (node.nodeName == "BR") {
            if (node.nextSibling) this.lineBreak();
        } else if (node.nodeType == 1) this.readRange(node.firstChild, null);
    }
    findPointBefore(node, next) {
        for (let point of this.points)if (point.node == node && node.childNodes[point.offset] == next) point.pos = this.text.length;
    }
    findPointInside(node, length) {
        for (let point of this.points)if (node.nodeType == 3 ? point.node == node : node.contains(point.node)) point.pos = this.text.length + ($1d528cc0e08a0656$var$isAtEnd(node, point.node, point.offset) ? length : 0);
    }
}
function $1d528cc0e08a0656$var$isAtEnd(parent, node, offset) {
    for(;;){
        if (!node || offset < $1d528cc0e08a0656$var$maxOffset(node)) return false;
        if (node == parent) return true;
        offset = $1d528cc0e08a0656$var$domIndex(node) + 1;
        node = node.parentNode;
    }
}
class $1d528cc0e08a0656$var$DOMPoint {
    constructor(node, offset){
        this.node = node;
        this.offset = offset;
        this.pos = -1;
    }
}
class $1d528cc0e08a0656$var$DOMChange {
    constructor(view, start, end, typeOver){
        this.typeOver = typeOver;
        this.bounds = null;
        this.text = "";
        this.domChanged = start > -1;
        let { impreciseHead: iHead, impreciseAnchor: iAnchor } = view.docView;
        if (view.state.readOnly && start > -1) // Ignore changes when the editor is read-only
        this.newSel = null;
        else if (start > -1 && (this.bounds = view.docView.domBoundsAround(start, end, 0))) {
            let selPoints = iHead || iAnchor ? [] : $1d528cc0e08a0656$var$selectionPoints(view);
            let reader = new $1d528cc0e08a0656$var$DOMReader(selPoints, view.state);
            reader.readRange(this.bounds.startDOM, this.bounds.endDOM);
            this.text = reader.text;
            this.newSel = $1d528cc0e08a0656$var$selectionFromPoints(selPoints, this.bounds.from);
        } else {
            let domSel = view.observer.selectionRange;
            let head = iHead && iHead.node == domSel.focusNode && iHead.offset == domSel.focusOffset || !$1d528cc0e08a0656$var$contains(view.contentDOM, domSel.focusNode) ? view.state.selection.main.head : view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
            let anchor = iAnchor && iAnchor.node == domSel.anchorNode && iAnchor.offset == domSel.anchorOffset || !$1d528cc0e08a0656$var$contains(view.contentDOM, domSel.anchorNode) ? view.state.selection.main.anchor : view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset);
            // iOS will refuse to select the block gaps when doing
            // select-all.
            // Chrome will put the selection *inside* them, confusing
            // posFromDOM
            let vp = view.viewport;
            if (($1d528cc0e08a0656$var$browser.ios || $1d528cc0e08a0656$var$browser.chrome) && view.state.selection.main.empty && head != anchor && (vp.from > 0 || vp.to < view.state.doc.length)) {
                let from = Math.min(head, anchor), to = Math.max(head, anchor);
                let offFrom = vp.from - from, offTo = vp.to - to;
                if ((offFrom == 0 || offFrom == 1 || from == 0) && (offTo == 0 || offTo == -1 || to == view.state.doc.length)) {
                    head = 0;
                    anchor = view.state.doc.length;
                }
            }
            this.newSel = (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).single(anchor, head);
        }
    }
}
function $1d528cc0e08a0656$var$applyDOMChange(view, domChange) {
    let change;
    let { newSel: newSel } = domChange, sel = view.state.selection.main;
    let lastKey = view.inputState.lastKeyTime > Date.now() - 100 ? view.inputState.lastKeyCode : -1;
    if (domChange.bounds) {
        let { from: from, to: to } = domChange.bounds;
        let preferredPos = sel.from, preferredSide = null;
        // Prefer anchoring to end when Backspace is pressed (or, on
        // Android, when something was deleted)
        if (lastKey === 8 || $1d528cc0e08a0656$var$browser.android && domChange.text.length < to - from) {
            preferredPos = sel.to;
            preferredSide = "end";
        }
        let diff = $1d528cc0e08a0656$var$findDiff(view.state.doc.sliceString(from, to, $1d528cc0e08a0656$var$LineBreakPlaceholder), domChange.text, preferredPos - from, preferredSide);
        if (diff) {
            // Chrome inserts two newlines when pressing shift-enter at the
            // end of a line. DomChange drops one of those.
            if ($1d528cc0e08a0656$var$browser.chrome && lastKey == 13 && diff.toB == diff.from + 2 && domChange.text.slice(diff.from, diff.toB) == $1d528cc0e08a0656$var$LineBreakPlaceholder + $1d528cc0e08a0656$var$LineBreakPlaceholder) diff.toB--;
            change = {
                from: from + diff.from,
                to: from + diff.toA,
                insert: (0, $6b8f387faea0a4dd$export$5f1af8db9871e1d6).of(domChange.text.slice(diff.from, diff.toB).split($1d528cc0e08a0656$var$LineBreakPlaceholder))
            };
        }
    } else if (newSel && (!view.hasFocus && view.state.facet($1d528cc0e08a0656$var$editable) || newSel.main.eq(sel))) newSel = null;
    if (!change && !newSel) return false;
    if (!change && domChange.typeOver && !sel.empty && newSel && newSel.main.empty) // Heuristic to notice typing over a selected character
    change = {
        from: sel.from,
        to: sel.to,
        insert: view.state.doc.slice(sel.from, sel.to)
    };
    else if (($1d528cc0e08a0656$var$browser.mac || $1d528cc0e08a0656$var$browser.android) && change && change.from == change.to && change.from == sel.head - 1 && /^\. ?$/.test(change.insert.toString()) && view.contentDOM.getAttribute("autocorrect") == "off") {
        // Detect insert-period-on-double-space Mac and Android behavior,
        // and transform it into a regular space insert.
        if (newSel && change.insert.length == 2) newSel = (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).single(newSel.main.anchor - 1, newSel.main.head - 1);
        change = {
            from: change.from,
            to: change.to,
            insert: (0, $6b8f387faea0a4dd$export$5f1af8db9871e1d6).of([
                change.insert.toString().replace(".", " ")
            ])
        };
    } else if (change && change.from >= sel.from && change.to <= sel.to && (change.from != sel.from || change.to != sel.to) && sel.to - sel.from - (change.to - change.from) <= 4) // If the change is inside the selection and covers most of it,
    // assume it is a selection replace (with identical characters at
    // the start/end not included in the diff)
    change = {
        from: sel.from,
        to: sel.to,
        insert: view.state.doc.slice(sel.from, change.from).append(change.insert).append(view.state.doc.slice(change.to, sel.to))
    };
    else if ($1d528cc0e08a0656$var$browser.chrome && change && change.from == change.to && change.from == sel.head && change.insert.toString() == "\n " && view.lineWrapping) {
        // In Chrome, if you insert a space at the start of a wrapped
        // line, it will actually insert a newline and a space, causing a
        // bogus new line to be created in CodeMirror (#968)
        if (newSel) newSel = (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).single(newSel.main.anchor - 1, newSel.main.head - 1);
        change = {
            from: sel.from,
            to: sel.to,
            insert: (0, $6b8f387faea0a4dd$export$5f1af8db9871e1d6).of([
                " "
            ])
        };
    }
    if (change) return $1d528cc0e08a0656$var$applyDOMChangeInner(view, change, newSel, lastKey);
    else if (newSel && !newSel.main.eq(sel)) {
        let scrollIntoView = false, userEvent = "select";
        if (view.inputState.lastSelectionTime > Date.now() - 50) {
            if (view.inputState.lastSelectionOrigin == "select") scrollIntoView = true;
            userEvent = view.inputState.lastSelectionOrigin;
        }
        view.dispatch({
            selection: newSel,
            scrollIntoView: scrollIntoView,
            userEvent: userEvent
        });
        return true;
    } else return false;
}
function $1d528cc0e08a0656$var$applyDOMChangeInner(view, change, newSel, lastKey = -1) {
    if ($1d528cc0e08a0656$var$browser.ios && view.inputState.flushIOSKey(change)) return true;
    let sel = view.state.selection.main;
    // Android browsers don't fire reasonable key events for enter,
    // backspace, or delete. So this detects changes that look like
    // they're caused by those keys, and reinterprets them as key
    // events. (Some of these keys are also handled by beforeinput
    // events and the pendingAndroidKey mechanism, but that's not
    // reliable in all situations.)
    if ($1d528cc0e08a0656$var$browser.android && (change.to == sel.to && // GBoard will sometimes remove a space it just inserted
    // after a completion when you press enter
    (change.from == sel.from || change.from == sel.from - 1 && view.state.sliceDoc(change.from, sel.from) == " ") && change.insert.length == 1 && change.insert.lines == 2 && $1d528cc0e08a0656$var$dispatchKey(view.contentDOM, "Enter", 13) || (change.from == sel.from - 1 && change.to == sel.to && change.insert.length == 0 || lastKey == 8 && change.insert.length < change.to - change.from && change.to > sel.head) && $1d528cc0e08a0656$var$dispatchKey(view.contentDOM, "Backspace", 8) || change.from == sel.from && change.to == sel.to + 1 && change.insert.length == 0 && $1d528cc0e08a0656$var$dispatchKey(view.contentDOM, "Delete", 46))) return true;
    let text = change.insert.toString();
    if (view.inputState.composing >= 0) view.inputState.composing++;
    let defaultTr;
    let defaultInsert = ()=>defaultTr || (defaultTr = $1d528cc0e08a0656$var$applyDefaultInsert(view, change, newSel));
    if (!view.state.facet($1d528cc0e08a0656$var$inputHandler).some((h)=>h(view, change.from, change.to, text, defaultInsert))) view.dispatch(defaultInsert());
    return true;
}
function $1d528cc0e08a0656$var$applyDefaultInsert(view, change, newSel) {
    let tr, startState = view.state, sel = startState.selection.main;
    if (change.from >= sel.from && change.to <= sel.to && change.to - change.from >= (sel.to - sel.from) / 3 && (!newSel || newSel.main.empty && newSel.main.from == change.from + change.insert.length) && view.inputState.composing < 0) {
        let before = sel.from < change.from ? startState.sliceDoc(sel.from, change.from) : "";
        let after = sel.to > change.to ? startState.sliceDoc(change.to, sel.to) : "";
        tr = startState.replaceSelection(view.state.toText(before + change.insert.sliceString(0, undefined, view.state.lineBreak) + after));
    } else {
        let changes = startState.changes(change);
        let mainSel = newSel && newSel.main.to <= changes.newLength ? newSel.main : undefined;
        // Try to apply a composition change to all cursors
        if (startState.selection.ranges.length > 1 && view.inputState.composing >= 0 && change.to <= sel.to && change.to >= sel.to - 10) {
            let replaced = view.state.sliceDoc(change.from, change.to);
            let compositionRange, composition = newSel && $1d528cc0e08a0656$var$findCompositionNode(view, newSel.main.head);
            if (composition) {
                let dLen = change.insert.length - (change.to - change.from);
                compositionRange = {
                    from: composition.from,
                    to: composition.to - dLen
                };
            } else compositionRange = view.state.doc.lineAt(sel.head);
            let offset = sel.to - change.to, size = sel.to - sel.from;
            tr = startState.changeByRange((range)=>{
                if (range.from == sel.from && range.to == sel.to) return {
                    changes: changes,
                    range: mainSel || range.map(changes)
                };
                let to = range.to - offset, from = to - replaced.length;
                if (range.to - range.from != size || view.state.sliceDoc(from, to) != replaced || // Unfortunately, there's no way to make multiple
                // changes in the same node work without aborting
                // composition, so cursors in the composition range are
                // ignored.
                range.to >= compositionRange.from && range.from <= compositionRange.to) return {
                    range: range
                };
                let rangeChanges = startState.changes({
                    from: from,
                    to: to,
                    insert: change.insert
                }), selOff = range.to - sel.to;
                return {
                    changes: rangeChanges,
                    range: !mainSel ? range.map(rangeChanges) : (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(Math.max(0, mainSel.anchor + selOff), Math.max(0, mainSel.head + selOff))
                };
            });
        } else tr = {
            changes: changes,
            selection: mainSel && startState.selection.replaceRange(mainSel)
        };
    }
    let userEvent = "input.type";
    if (view.composing || view.inputState.compositionPendingChange && view.inputState.compositionEndedAt > Date.now() - 50) {
        view.inputState.compositionPendingChange = false;
        userEvent += ".compose";
        if (view.inputState.compositionFirstChange) {
            userEvent += ".start";
            view.inputState.compositionFirstChange = false;
        }
    }
    return startState.update(tr, {
        userEvent: userEvent,
        scrollIntoView: true
    });
}
function $1d528cc0e08a0656$var$findDiff(a, b, preferredPos, preferredSide) {
    let minLen = Math.min(a.length, b.length);
    let from = 0;
    while(from < minLen && a.charCodeAt(from) == b.charCodeAt(from))from++;
    if (from == minLen && a.length == b.length) return null;
    let toA = a.length, toB = b.length;
    while(toA > 0 && toB > 0 && a.charCodeAt(toA - 1) == b.charCodeAt(toB - 1)){
        toA--;
        toB--;
    }
    if (preferredSide == "end") {
        let adjust = Math.max(0, from - Math.min(toA, toB));
        preferredPos -= toA + adjust - from;
    }
    if (toA < from && a.length < b.length) {
        let move = preferredPos <= from && preferredPos >= toA ? from - preferredPos : 0;
        from -= move;
        toB = from + (toB - toA);
        toA = from;
    } else if (toB < from) {
        let move = preferredPos <= from && preferredPos >= toB ? from - preferredPos : 0;
        from -= move;
        toA = from + (toA - toB);
        toB = from;
    }
    return {
        from: from,
        toA: toA,
        toB: toB
    };
}
function $1d528cc0e08a0656$var$selectionPoints(view) {
    let result = [];
    if (view.root.activeElement != view.contentDOM) return result;
    let { anchorNode: anchorNode, anchorOffset: anchorOffset, focusNode: focusNode, focusOffset: focusOffset } = view.observer.selectionRange;
    if (anchorNode) {
        result.push(new $1d528cc0e08a0656$var$DOMPoint(anchorNode, anchorOffset));
        if (focusNode != anchorNode || focusOffset != anchorOffset) result.push(new $1d528cc0e08a0656$var$DOMPoint(focusNode, focusOffset));
    }
    return result;
}
function $1d528cc0e08a0656$var$selectionFromPoints(points, base) {
    if (points.length == 0) return null;
    let anchor = points[0].pos, head = points.length == 2 ? points[1].pos : anchor;
    return anchor > -1 && head > -1 ? (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).single(anchor + base, head + base) : null;
}
class $1d528cc0e08a0656$var$InputState {
    setSelectionOrigin(origin) {
        this.lastSelectionOrigin = origin;
        this.lastSelectionTime = Date.now();
    }
    constructor(view){
        this.view = view;
        this.lastKeyCode = 0;
        this.lastKeyTime = 0;
        this.lastTouchTime = 0;
        this.lastFocusTime = 0;
        this.lastScrollTop = 0;
        this.lastScrollLeft = 0;
        // On iOS, some keys need to have their default behavior happen
        // (after which we retroactively handle them and reset the DOM) to
        // avoid messing up the virtual keyboard state.
        this.pendingIOSKey = undefined;
        /**
        When enabled (>-1), tab presses are not given to key handlers,
        leaving the browser's default behavior. If >0, the mode expires
        at that timestamp, and any other keypress clears it.
        Esc enables temporary tab focus mode for two seconds when not
        otherwise handled.
        */ this.tabFocusMode = -1;
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastContextMenu = 0;
        this.scrollHandlers = [];
        this.handlers = Object.create(null);
        // -1 means not in a composition. Otherwise, this counts the number
        // of changes made during the composition. The count is used to
        // avoid treating the start state of the composition, before any
        // changes have been made, as part of the composition.
        this.composing = -1;
        // Tracks whether the next change should be marked as starting the
        // composition (null means no composition, true means next is the
        // first, false means first has already been marked for this
        // composition)
        this.compositionFirstChange = null;
        // End time of the previous composition
        this.compositionEndedAt = 0;
        // Used in a kludge to detect when an Enter keypress should be
        // considered part of the composition on Safari, which fires events
        // in the wrong order
        this.compositionPendingKey = false;
        // Used to categorize changes as part of a composition, even when
        // the mutation events fire shortly after the compositionend event
        this.compositionPendingChange = false;
        this.mouseSelection = null;
        // When a drag from the editor is active, this points at the range
        // being dragged.
        this.draggedContent = null;
        this.handleEvent = this.handleEvent.bind(this);
        this.notifiedFocused = view.hasFocus;
        // On Safari adding an input event handler somehow prevents an
        // issue where the composition vanishes when you press enter.
        if ($1d528cc0e08a0656$var$browser.safari) view.contentDOM.addEventListener("input", ()=>null);
        if ($1d528cc0e08a0656$var$browser.gecko) $1d528cc0e08a0656$var$firefoxCopyCutHack(view.contentDOM.ownerDocument);
    }
    handleEvent(event) {
        if (!$1d528cc0e08a0656$var$eventBelongsToEditor(this.view, event) || this.ignoreDuringComposition(event)) return;
        if (event.type == "keydown" && this.keydown(event)) return;
        if (this.view.updateState != 0 /* UpdateState.Idle */ ) Promise.resolve().then(()=>this.runHandlers(event.type, event));
        else this.runHandlers(event.type, event);
    }
    runHandlers(type, event) {
        let handlers = this.handlers[type];
        if (handlers) {
            for (let observer of handlers.observers)observer(this.view, event);
            for (let handler of handlers.handlers){
                if (event.defaultPrevented) break;
                if (handler(this.view, event)) {
                    event.preventDefault();
                    break;
                }
            }
        }
    }
    ensureHandlers(plugins) {
        let handlers = $1d528cc0e08a0656$var$computeHandlers(plugins), prev = this.handlers, dom = this.view.contentDOM;
        for(let type in handlers)if (type != "scroll") {
            let passive = !handlers[type].handlers.length;
            let exists = prev[type];
            if (exists && passive != !exists.handlers.length) {
                dom.removeEventListener(type, this.handleEvent);
                exists = null;
            }
            if (!exists) dom.addEventListener(type, this.handleEvent, {
                passive: passive
            });
        }
        for(let type in prev)if (type != "scroll" && !handlers[type]) dom.removeEventListener(type, this.handleEvent);
        this.handlers = handlers;
    }
    keydown(event) {
        // Must always run, even if a custom handler handled the event
        this.lastKeyCode = event.keyCode;
        this.lastKeyTime = Date.now();
        if (event.keyCode == 9 && this.tabFocusMode > -1 && (!this.tabFocusMode || Date.now() <= this.tabFocusMode)) return true;
        if (this.tabFocusMode > 0 && event.keyCode != 27 && $1d528cc0e08a0656$var$modifierCodes.indexOf(event.keyCode) < 0) this.tabFocusMode = -1;
        // Chrome for Android usually doesn't fire proper key events, but
        // occasionally does, usually surrounded by a bunch of complicated
        // composition changes. When an enter or backspace key event is
        // seen, hold off on handling DOM events for a bit, and then
        // dispatch it.
        if ($1d528cc0e08a0656$var$browser.android && $1d528cc0e08a0656$var$browser.chrome && !event.synthetic && (event.keyCode == 13 || event.keyCode == 8)) {
            this.view.observer.delayAndroidKey(event.key, event.keyCode);
            return true;
        }
        // Preventing the default behavior of Enter on iOS makes the
        // virtual keyboard get stuck in the wrong (lowercase)
        // state. So we let it go through, and then, in
        // applyDOMChange, notify key handlers of it and reset to
        // the state they produce.
        let pending;
        if ($1d528cc0e08a0656$var$browser.ios && !event.synthetic && !event.altKey && !event.metaKey && ((pending = $1d528cc0e08a0656$var$PendingKeys.find((key)=>key.keyCode == event.keyCode)) && !event.ctrlKey || $1d528cc0e08a0656$var$EmacsyPendingKeys.indexOf(event.key) > -1 && event.ctrlKey && !event.shiftKey)) {
            this.pendingIOSKey = pending || event;
            setTimeout(()=>this.flushIOSKey(), 250);
            return true;
        }
        if (event.keyCode != 229) this.view.observer.forceFlush();
        return false;
    }
    flushIOSKey(change) {
        let key = this.pendingIOSKey;
        if (!key) return false;
        // This looks like an autocorrection before Enter
        if (key.key == "Enter" && change && change.from < change.to && /^\S+$/.test(change.insert.toString())) return false;
        this.pendingIOSKey = undefined;
        return $1d528cc0e08a0656$var$dispatchKey(this.view.contentDOM, key.key, key.keyCode, key instanceof KeyboardEvent ? key : undefined);
    }
    ignoreDuringComposition(event) {
        if (!/^key/.test(event.type)) return false;
        if (this.composing > 0) return true;
        // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
        // On some input method editors (IMEs), the Enter key is used to
        // confirm character selection. On Safari, when Enter is pressed,
        // compositionend and keydown events are sometimes emitted in the
        // wrong order. The key event should still be ignored, even when
        // it happens after the compositionend event.
        if ($1d528cc0e08a0656$var$browser.safari && !$1d528cc0e08a0656$var$browser.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100) {
            this.compositionPendingKey = false;
            return true;
        }
        return false;
    }
    startMouseSelection(mouseSelection) {
        if (this.mouseSelection) this.mouseSelection.destroy();
        this.mouseSelection = mouseSelection;
    }
    update(update) {
        this.view.observer.update(update);
        if (this.mouseSelection) this.mouseSelection.update(update);
        if (this.draggedContent && update.docChanged) this.draggedContent = this.draggedContent.map(update.changes);
        if (update.transactions.length) this.lastKeyCode = this.lastSelectionTime = 0;
    }
    destroy() {
        if (this.mouseSelection) this.mouseSelection.destroy();
    }
}
function $1d528cc0e08a0656$var$bindHandler(plugin, handler) {
    return (view, event)=>{
        try {
            return handler.call(plugin, event, view);
        } catch (e) {
            $1d528cc0e08a0656$export$f86b2a1a2ce291b3(view.state, e);
        }
    };
}
function $1d528cc0e08a0656$var$computeHandlers(plugins) {
    let result = Object.create(null);
    function record(type) {
        return result[type] || (result[type] = {
            observers: [],
            handlers: []
        });
    }
    for (let plugin of plugins){
        let spec = plugin.spec, handlers = spec && spec.plugin.domEventHandlers, observers = spec && spec.plugin.domEventObservers;
        if (handlers) for(let type in handlers){
            let f = handlers[type];
            if (f) record(type).handlers.push($1d528cc0e08a0656$var$bindHandler(plugin.value, f));
        }
        if (observers) for(let type in observers){
            let f = observers[type];
            if (f) record(type).observers.push($1d528cc0e08a0656$var$bindHandler(plugin.value, f));
        }
    }
    for(let type in $1d528cc0e08a0656$var$handlers)record(type).handlers.push($1d528cc0e08a0656$var$handlers[type]);
    for(let type in $1d528cc0e08a0656$var$observers)record(type).observers.push($1d528cc0e08a0656$var$observers[type]);
    return result;
}
const $1d528cc0e08a0656$var$PendingKeys = [
    {
        key: "Backspace",
        keyCode: 8,
        inputType: "deleteContentBackward"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertParagraph"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertLineBreak"
    },
    {
        key: "Delete",
        keyCode: 46,
        inputType: "deleteContentForward"
    }
];
const $1d528cc0e08a0656$var$EmacsyPendingKeys = "dthko";
// Key codes for modifier keys
const $1d528cc0e08a0656$var$modifierCodes = [
    16,
    17,
    18,
    20,
    91,
    92,
    224,
    225
];
const $1d528cc0e08a0656$var$dragScrollMargin = 6;
function $1d528cc0e08a0656$var$dragScrollSpeed(dist) {
    return Math.max(0, dist) * 0.7 + 8;
}
function $1d528cc0e08a0656$var$dist(a, b) {
    return Math.max(Math.abs(a.clientX - b.clientX), Math.abs(a.clientY - b.clientY));
}
class $1d528cc0e08a0656$var$MouseSelection {
    constructor(view, startEvent, style, mustSelect){
        this.view = view;
        this.startEvent = startEvent;
        this.style = style;
        this.mustSelect = mustSelect;
        this.scrollSpeed = {
            x: 0,
            y: 0
        };
        this.scrolling = -1;
        this.lastEvent = startEvent;
        this.scrollParents = $1d528cc0e08a0656$var$scrollableParents(view.contentDOM);
        this.atoms = view.state.facet($1d528cc0e08a0656$var$atomicRanges).map((f)=>f(view));
        let doc = view.contentDOM.ownerDocument;
        doc.addEventListener("mousemove", this.move = this.move.bind(this));
        doc.addEventListener("mouseup", this.up = this.up.bind(this));
        this.extend = startEvent.shiftKey;
        this.multiple = view.state.facet((0, $6b8f387faea0a4dd$export$afa855cbfaff27f2).allowMultipleSelections) && $1d528cc0e08a0656$var$addsSelectionRange(view, startEvent);
        this.dragging = $1d528cc0e08a0656$var$isInPrimarySelection(view, startEvent) && $1d528cc0e08a0656$var$getClickType(startEvent) == 1 ? null : false;
    }
    start(event) {
        // When clicking outside of the selection, immediately apply the
        // effect of starting the selection
        if (this.dragging === false) this.select(event);
    }
    move(event) {
        if (event.buttons == 0) return this.destroy();
        if (this.dragging || this.dragging == null && $1d528cc0e08a0656$var$dist(this.startEvent, event) < 10) return;
        this.select(this.lastEvent = event);
        let sx = 0, sy = 0;
        let left = 0, top = 0, right = this.view.win.innerWidth, bottom = this.view.win.innerHeight;
        if (this.scrollParents.x) ({ left: left, right: right } = this.scrollParents.x.getBoundingClientRect());
        if (this.scrollParents.y) ({ top: top, bottom: bottom } = this.scrollParents.y.getBoundingClientRect());
        let margins = $1d528cc0e08a0656$var$getScrollMargins(this.view);
        if (event.clientX - margins.left <= left + $1d528cc0e08a0656$var$dragScrollMargin) sx = -$1d528cc0e08a0656$var$dragScrollSpeed(left - event.clientX);
        else if (event.clientX + margins.right >= right - $1d528cc0e08a0656$var$dragScrollMargin) sx = $1d528cc0e08a0656$var$dragScrollSpeed(event.clientX - right);
        if (event.clientY - margins.top <= top + $1d528cc0e08a0656$var$dragScrollMargin) sy = -$1d528cc0e08a0656$var$dragScrollSpeed(top - event.clientY);
        else if (event.clientY + margins.bottom >= bottom - $1d528cc0e08a0656$var$dragScrollMargin) sy = $1d528cc0e08a0656$var$dragScrollSpeed(event.clientY - bottom);
        this.setScrollSpeed(sx, sy);
    }
    up(event) {
        if (this.dragging == null) this.select(this.lastEvent);
        if (!this.dragging) event.preventDefault();
        this.destroy();
    }
    destroy() {
        this.setScrollSpeed(0, 0);
        let doc = this.view.contentDOM.ownerDocument;
        doc.removeEventListener("mousemove", this.move);
        doc.removeEventListener("mouseup", this.up);
        this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
    }
    setScrollSpeed(sx, sy) {
        this.scrollSpeed = {
            x: sx,
            y: sy
        };
        if (sx || sy) {
            if (this.scrolling < 0) this.scrolling = setInterval(()=>this.scroll(), 50);
        } else if (this.scrolling > -1) {
            clearInterval(this.scrolling);
            this.scrolling = -1;
        }
    }
    scroll() {
        let { x: x, y: y } = this.scrollSpeed;
        if (x && this.scrollParents.x) {
            this.scrollParents.x.scrollLeft += x;
            x = 0;
        }
        if (y && this.scrollParents.y) {
            this.scrollParents.y.scrollTop += y;
            y = 0;
        }
        if (x || y) this.view.win.scrollBy(x, y);
        if (this.dragging === false) this.select(this.lastEvent);
    }
    skipAtoms(sel) {
        let ranges = null;
        for(let i = 0; i < sel.ranges.length; i++){
            let range = sel.ranges[i], updated = null;
            if (range.empty) {
                let pos = $1d528cc0e08a0656$var$skipAtomicRanges(this.atoms, range.from, 0);
                if (pos != range.from) updated = (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(pos, -1);
            } else {
                let from = $1d528cc0e08a0656$var$skipAtomicRanges(this.atoms, range.from, -1);
                let to = $1d528cc0e08a0656$var$skipAtomicRanges(this.atoms, range.to, 1);
                if (from != range.from || to != range.to) updated = (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(range.from == range.anchor ? from : to, range.from == range.head ? from : to);
            }
            if (updated) {
                if (!ranges) ranges = sel.ranges.slice();
                ranges[i] = updated;
            }
        }
        return ranges ? (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).create(ranges, sel.mainIndex) : sel;
    }
    select(event) {
        let { view: view } = this, selection = this.skipAtoms(this.style.get(event, this.extend, this.multiple));
        if (this.mustSelect || !selection.eq(view.state.selection, this.dragging === false)) this.view.dispatch({
            selection: selection,
            userEvent: "select.pointer"
        });
        this.mustSelect = false;
    }
    update(update) {
        if (update.transactions.some((tr)=>tr.isUserEvent("input.type"))) this.destroy();
        else if (this.style.update(update)) setTimeout(()=>this.select(this.lastEvent), 20);
    }
}
function $1d528cc0e08a0656$var$addsSelectionRange(view, event) {
    let facet = view.state.facet($1d528cc0e08a0656$var$clickAddsSelectionRange);
    return facet.length ? facet[0](event) : $1d528cc0e08a0656$var$browser.mac ? event.metaKey : event.ctrlKey;
}
function $1d528cc0e08a0656$var$dragMovesSelection(view, event) {
    let facet = view.state.facet($1d528cc0e08a0656$var$dragMovesSelection$1);
    return facet.length ? facet[0](event) : $1d528cc0e08a0656$var$browser.mac ? !event.altKey : !event.ctrlKey;
}
function $1d528cc0e08a0656$var$isInPrimarySelection(view, event) {
    let { main: main } = view.state.selection;
    if (main.empty) return false;
    // On boundary clicks, check whether the coordinates are inside the
    // selection's client rectangles
    let sel = $1d528cc0e08a0656$var$getSelection(view.root);
    if (!sel || sel.rangeCount == 0) return true;
    let rects = sel.getRangeAt(0).getClientRects();
    for(let i = 0; i < rects.length; i++){
        let rect = rects[i];
        if (rect.left <= event.clientX && rect.right >= event.clientX && rect.top <= event.clientY && rect.bottom >= event.clientY) return true;
    }
    return false;
}
function $1d528cc0e08a0656$var$eventBelongsToEditor(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target, cView; node != view.contentDOM; node = node.parentNode)if (!node || node.nodeType == 11 || (cView = $1d528cc0e08a0656$var$ContentView.get(node)) && cView.ignoreEvent(event)) return false;
    return true;
}
const $1d528cc0e08a0656$var$handlers = /*@__PURE__*/ Object.create(null);
const $1d528cc0e08a0656$var$observers = /*@__PURE__*/ Object.create(null);
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $1d528cc0e08a0656$var$brokenClipboardAPI = $1d528cc0e08a0656$var$browser.ie && $1d528cc0e08a0656$var$browser.ie_version < 15 || $1d528cc0e08a0656$var$browser.ios && $1d528cc0e08a0656$var$browser.webkit_version < 604;
function $1d528cc0e08a0656$var$capturePaste(view) {
    let parent = view.dom.parentNode;
    if (!parent) return;
    let target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    setTimeout(()=>{
        view.focus();
        target.remove();
        $1d528cc0e08a0656$var$doPaste(view, target.value);
    }, 50);
}
function $1d528cc0e08a0656$var$textFilter(state, facet, text) {
    for (let filter of state.facet(facet))text = filter(text, state);
    return text;
}
function $1d528cc0e08a0656$var$doPaste(view, input) {
    input = $1d528cc0e08a0656$var$textFilter(view.state, $1d528cc0e08a0656$var$clipboardInputFilter, input);
    let { state: state } = view, changes, i = 1, text = state.toText(input);
    let byLine = text.lines == state.selection.ranges.length;
    let linewise = $1d528cc0e08a0656$var$lastLinewiseCopy != null && state.selection.ranges.every((r)=>r.empty) && $1d528cc0e08a0656$var$lastLinewiseCopy == text.toString();
    if (linewise) {
        let lastLine = -1;
        changes = state.changeByRange((range)=>{
            let line = state.doc.lineAt(range.from);
            if (line.from == lastLine) return {
                range: range
            };
            lastLine = line.from;
            let insert = state.toText((byLine ? text.line(i++).text : input) + state.lineBreak);
            return {
                changes: {
                    from: line.from,
                    insert: insert
                },
                range: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(range.from + insert.length)
            };
        });
    } else if (byLine) changes = state.changeByRange((range)=>{
        let line = text.line(i++);
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: line.text
            },
            range: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(range.from + line.length)
        };
    });
    else changes = state.replaceSelection(text);
    view.dispatch(changes, {
        userEvent: "input.paste",
        scrollIntoView: true
    });
}
$1d528cc0e08a0656$var$observers.scroll = (view)=>{
    view.inputState.lastScrollTop = view.scrollDOM.scrollTop;
    view.inputState.lastScrollLeft = view.scrollDOM.scrollLeft;
};
$1d528cc0e08a0656$var$handlers.keydown = (view, event)=>{
    view.inputState.setSelectionOrigin("select");
    if (event.keyCode == 27 && view.inputState.tabFocusMode != 0) view.inputState.tabFocusMode = Date.now() + 2000;
    return false;
};
$1d528cc0e08a0656$var$observers.touchstart = (view, e)=>{
    view.inputState.lastTouchTime = Date.now();
    view.inputState.setSelectionOrigin("select.pointer");
};
$1d528cc0e08a0656$var$observers.touchmove = (view)=>{
    view.inputState.setSelectionOrigin("select.pointer");
};
$1d528cc0e08a0656$var$handlers.mousedown = (view, event)=>{
    view.observer.flush();
    if (view.inputState.lastTouchTime > Date.now() - 2000) return false; // Ignore touch interaction
    let style = null;
    for (let makeStyle of view.state.facet($1d528cc0e08a0656$var$mouseSelectionStyle)){
        style = makeStyle(view, event);
        if (style) break;
    }
    if (!style && event.button == 0) style = $1d528cc0e08a0656$var$basicMouseSelection(view, event);
    if (style) {
        let mustFocus = !view.hasFocus;
        view.inputState.startMouseSelection(new $1d528cc0e08a0656$var$MouseSelection(view, event, style, mustFocus));
        if (mustFocus) view.observer.ignore(()=>{
            $1d528cc0e08a0656$var$focusPreventScroll(view.contentDOM);
            let active = view.root.activeElement;
            if (active && !active.contains(view.contentDOM)) active.blur();
        });
        let mouseSel = view.inputState.mouseSelection;
        if (mouseSel) {
            mouseSel.start(event);
            return mouseSel.dragging === false;
        }
    }
    return false;
};
function $1d528cc0e08a0656$var$rangeForClick(view, pos, bias, type) {
    if (type == 1) return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(pos, bias);
    else if (type == 2) return $1d528cc0e08a0656$var$groupAt(view.state, pos, bias);
    else {
        let visual = $1d528cc0e08a0656$var$LineView.find(view.docView, pos), line = view.state.doc.lineAt(visual ? visual.posAtEnd : pos);
        let from = visual ? visual.posAtStart : line.from, to = visual ? visual.posAtEnd : line.to;
        if (to < view.state.doc.length && to == line.to) to++;
        return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(from, to);
    }
}
let $1d528cc0e08a0656$var$inside = (x, y, rect)=>y >= rect.top && y <= rect.bottom && x >= rect.left && x <= rect.right;
// Try to determine, for the given coordinates, associated with the
// given position, whether they are related to the element before or
// the element after the position.
function $1d528cc0e08a0656$var$findPositionSide(view, pos, x, y) {
    let line = $1d528cc0e08a0656$var$LineView.find(view.docView, pos);
    if (!line) return 1;
    let off = pos - line.posAtStart;
    // Line boundaries point into the line
    if (off == 0) return 1;
    if (off == line.length) return -1;
    // Positions on top of an element point at that element
    let before = line.coordsAt(off, -1);
    if (before && $1d528cc0e08a0656$var$inside(x, y, before)) return -1;
    let after = line.coordsAt(off, 1);
    if (after && $1d528cc0e08a0656$var$inside(x, y, after)) return 1;
    // This is probably a line wrap point. Pick before if the point is
    // above its bottom.
    return before && before.bottom >= y ? -1 : 1;
}
function $1d528cc0e08a0656$var$queryPos(view, event) {
    let pos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    return {
        pos: pos,
        bias: $1d528cc0e08a0656$var$findPositionSide(view, pos, event.clientX, event.clientY)
    };
}
const $1d528cc0e08a0656$var$BadMouseDetail = $1d528cc0e08a0656$var$browser.ie && $1d528cc0e08a0656$var$browser.ie_version <= 11;
let $1d528cc0e08a0656$var$lastMouseDown = null, $1d528cc0e08a0656$var$lastMouseDownCount = 0, $1d528cc0e08a0656$var$lastMouseDownTime = 0;
function $1d528cc0e08a0656$var$getClickType(event) {
    if (!$1d528cc0e08a0656$var$BadMouseDetail) return event.detail;
    let last = $1d528cc0e08a0656$var$lastMouseDown, lastTime = $1d528cc0e08a0656$var$lastMouseDownTime;
    $1d528cc0e08a0656$var$lastMouseDown = event;
    $1d528cc0e08a0656$var$lastMouseDownTime = Date.now();
    return $1d528cc0e08a0656$var$lastMouseDownCount = !last || lastTime > Date.now() - 400 && Math.abs(last.clientX - event.clientX) < 2 && Math.abs(last.clientY - event.clientY) < 2 ? ($1d528cc0e08a0656$var$lastMouseDownCount + 1) % 3 : 1;
}
function $1d528cc0e08a0656$var$basicMouseSelection(view, event) {
    let start = $1d528cc0e08a0656$var$queryPos(view, event), type = $1d528cc0e08a0656$var$getClickType(event);
    let startSel = view.state.selection;
    return {
        update (update) {
            if (update.docChanged) {
                start.pos = update.changes.mapPos(start.pos);
                startSel = startSel.map(update.changes);
            }
        },
        get (event, extend, multiple) {
            let cur = $1d528cc0e08a0656$var$queryPos(view, event), removed;
            let range = $1d528cc0e08a0656$var$rangeForClick(view, cur.pos, cur.bias, type);
            if (start.pos != cur.pos && !extend) {
                let startRange = $1d528cc0e08a0656$var$rangeForClick(view, start.pos, start.bias, type);
                let from = Math.min(startRange.from, range.from), to = Math.max(startRange.to, range.to);
                range = from < range.from ? (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(from, to) : (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(to, from);
            }
            if (extend) return startSel.replaceRange(startSel.main.extend(range.from, range.to));
            else if (multiple && type == 1 && startSel.ranges.length > 1 && (removed = $1d528cc0e08a0656$var$removeRangeAround(startSel, cur.pos))) return removed;
            else if (multiple) return startSel.addRange(range);
            else return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).create([
                range
            ]);
        }
    };
}
function $1d528cc0e08a0656$var$removeRangeAround(sel, pos) {
    for(let i = 0; i < sel.ranges.length; i++){
        let { from: from, to: to } = sel.ranges[i];
        if (from <= pos && to >= pos) return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).create(sel.ranges.slice(0, i).concat(sel.ranges.slice(i + 1)), sel.mainIndex == i ? 0 : sel.mainIndex - (sel.mainIndex > i ? 1 : 0));
    }
    return null;
}
$1d528cc0e08a0656$var$handlers.dragstart = (view, event)=>{
    let { selection: { main: range } } = view.state;
    if (event.target.draggable) {
        let cView = view.docView.nearest(event.target);
        if (cView && cView.isWidget) {
            let from = cView.posAtStart, to = from + cView.length;
            if (from >= range.to || to <= range.from) range = (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(from, to);
        }
    }
    let { inputState: inputState } = view;
    if (inputState.mouseSelection) inputState.mouseSelection.dragging = true;
    inputState.draggedContent = range;
    if (event.dataTransfer) {
        event.dataTransfer.setData("Text", $1d528cc0e08a0656$var$textFilter(view.state, $1d528cc0e08a0656$var$clipboardOutputFilter, view.state.sliceDoc(range.from, range.to)));
        event.dataTransfer.effectAllowed = "copyMove";
    }
    return false;
};
$1d528cc0e08a0656$var$handlers.dragend = (view)=>{
    view.inputState.draggedContent = null;
    return false;
};
function $1d528cc0e08a0656$var$dropText(view, event, text, direct) {
    text = $1d528cc0e08a0656$var$textFilter(view.state, $1d528cc0e08a0656$var$clipboardInputFilter, text);
    if (!text) return;
    let dropPos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    let { draggedContent: draggedContent } = view.inputState;
    let del = direct && draggedContent && $1d528cc0e08a0656$var$dragMovesSelection(view, event) ? {
        from: draggedContent.from,
        to: draggedContent.to
    } : null;
    let ins = {
        from: dropPos,
        insert: text
    };
    let changes = view.state.changes(del ? [
        del,
        ins
    ] : ins);
    view.focus();
    view.dispatch({
        changes: changes,
        selection: {
            anchor: changes.mapPos(dropPos, -1),
            head: changes.mapPos(dropPos, 1)
        },
        userEvent: del ? "move.drop" : "input.drop"
    });
    view.inputState.draggedContent = null;
}
$1d528cc0e08a0656$var$handlers.drop = (view, event)=>{
    if (!event.dataTransfer) return false;
    if (view.state.readOnly) return true;
    let files = event.dataTransfer.files;
    if (files && files.length) {
        let text = Array(files.length), read = 0;
        let finishFile = ()=>{
            if (++read == files.length) $1d528cc0e08a0656$var$dropText(view, event, text.filter((s)=>s != null).join(view.state.lineBreak), false);
        };
        for(let i = 0; i < files.length; i++){
            let reader = new FileReader;
            reader.onerror = finishFile;
            reader.onload = ()=>{
                if (!/[\x00-\x08\x0e-\x1f]{2}/.test(reader.result)) text[i] = reader.result;
                finishFile();
            };
            reader.readAsText(files[i]);
        }
        return true;
    } else {
        let text = event.dataTransfer.getData("Text");
        if (text) {
            $1d528cc0e08a0656$var$dropText(view, event, text, true);
            return true;
        }
    }
    return false;
};
$1d528cc0e08a0656$var$handlers.paste = (view, event)=>{
    if (view.state.readOnly) return true;
    view.observer.flush();
    let data = $1d528cc0e08a0656$var$brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        $1d528cc0e08a0656$var$doPaste(view, data.getData("text/plain") || data.getData("text/uri-list"));
        return true;
    } else {
        $1d528cc0e08a0656$var$capturePaste(view);
        return false;
    }
};
function $1d528cc0e08a0656$var$captureCopy(view, text) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    let parent = view.dom.parentNode;
    if (!parent) return;
    let target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.value = text;
    target.focus();
    target.selectionEnd = text.length;
    target.selectionStart = 0;
    setTimeout(()=>{
        target.remove();
        view.focus();
    }, 50);
}
function $1d528cc0e08a0656$var$copiedRange(state) {
    let content = [], ranges = [], linewise = false;
    for (let range of state.selection.ranges)if (!range.empty) {
        content.push(state.sliceDoc(range.from, range.to));
        ranges.push(range);
    }
    if (!content.length) {
        // Nothing selected, do a line-wise copy
        let upto = -1;
        for (let { from: from } of state.selection.ranges){
            let line = state.doc.lineAt(from);
            if (line.number > upto) {
                content.push(line.text);
                ranges.push({
                    from: line.from,
                    to: Math.min(state.doc.length, line.to + 1)
                });
            }
            upto = line.number;
        }
        linewise = true;
    }
    return {
        text: $1d528cc0e08a0656$var$textFilter(state, $1d528cc0e08a0656$var$clipboardOutputFilter, content.join(state.lineBreak)),
        ranges: ranges,
        linewise: linewise
    };
}
let $1d528cc0e08a0656$var$lastLinewiseCopy = null;
$1d528cc0e08a0656$var$handlers.copy = $1d528cc0e08a0656$var$handlers.cut = (view, event)=>{
    let { text: text, ranges: ranges, linewise: linewise } = $1d528cc0e08a0656$var$copiedRange(view.state);
    if (!text && !linewise) return false;
    $1d528cc0e08a0656$var$lastLinewiseCopy = linewise ? text : null;
    if (event.type == "cut" && !view.state.readOnly) view.dispatch({
        changes: ranges,
        scrollIntoView: true,
        userEvent: "delete.cut"
    });
    let data = $1d528cc0e08a0656$var$brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        data.clearData();
        data.setData("text/plain", text);
        return true;
    } else {
        $1d528cc0e08a0656$var$captureCopy(view, text);
        return false;
    }
};
const $1d528cc0e08a0656$var$isFocusChange = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$9279461326b8700a).define();
function $1d528cc0e08a0656$var$focusChangeTransaction(state, focus) {
    let effects = [];
    for (let getEffect of state.facet($1d528cc0e08a0656$var$focusChangeEffect)){
        let effect = getEffect(state, focus);
        if (effect) effects.push(effect);
    }
    return effects.length ? state.update({
        effects: effects,
        annotations: $1d528cc0e08a0656$var$isFocusChange.of(true)
    }) : null;
}
function $1d528cc0e08a0656$var$updateForFocusChange(view) {
    setTimeout(()=>{
        let focus = view.hasFocus;
        if (focus != view.inputState.notifiedFocused) {
            let tr = $1d528cc0e08a0656$var$focusChangeTransaction(view.state, focus);
            if (tr) view.dispatch(tr);
            else view.update([]);
        }
    }, 10);
}
$1d528cc0e08a0656$var$observers.focus = (view)=>{
    view.inputState.lastFocusTime = Date.now();
    // When focusing reset the scroll position, move it back to where it was
    if (!view.scrollDOM.scrollTop && (view.inputState.lastScrollTop || view.inputState.lastScrollLeft)) {
        view.scrollDOM.scrollTop = view.inputState.lastScrollTop;
        view.scrollDOM.scrollLeft = view.inputState.lastScrollLeft;
    }
    $1d528cc0e08a0656$var$updateForFocusChange(view);
};
$1d528cc0e08a0656$var$observers.blur = (view)=>{
    view.observer.clearSelectionRange();
    $1d528cc0e08a0656$var$updateForFocusChange(view);
};
$1d528cc0e08a0656$var$observers.compositionstart = $1d528cc0e08a0656$var$observers.compositionupdate = (view)=>{
    if (view.observer.editContext) return; // Composition handled by edit context
    if (view.inputState.compositionFirstChange == null) view.inputState.compositionFirstChange = true;
    if (view.inputState.composing < 0) // FIXME possibly set a timeout to clear it again on Android
    view.inputState.composing = 0;
};
$1d528cc0e08a0656$var$observers.compositionend = (view)=>{
    if (view.observer.editContext) return; // Composition handled by edit context
    view.inputState.composing = -1;
    view.inputState.compositionEndedAt = Date.now();
    view.inputState.compositionPendingKey = true;
    view.inputState.compositionPendingChange = view.observer.pendingRecords().length > 0;
    view.inputState.compositionFirstChange = null;
    if ($1d528cc0e08a0656$var$browser.chrome && $1d528cc0e08a0656$var$browser.android) // Delay flushing for a bit on Android because it'll often fire a
    // bunch of contradictory changes in a row at end of compositon
    view.observer.flushSoon();
    else if (view.inputState.compositionPendingChange) // If we found pending records, schedule a flush.
    Promise.resolve().then(()=>view.observer.flush());
    else // Otherwise, make sure that, if no changes come in soon, the
    // composition view is cleared.
    setTimeout(()=>{
        if (view.inputState.composing < 0 && view.docView.hasComposition) view.update([]);
    }, 50);
};
$1d528cc0e08a0656$var$observers.contextmenu = (view)=>{
    view.inputState.lastContextMenu = Date.now();
};
$1d528cc0e08a0656$var$handlers.beforeinput = (view, event)=>{
    var _a, _b;
    // In EditContext mode, we must handle insertReplacementText events
    // directly, to make spell checking corrections work
    if (event.inputType == "insertReplacementText" && view.observer.editContext) {
        let text = (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.getData("text/plain"), ranges = event.getTargetRanges();
        if (text && ranges.length) {
            let r = ranges[0];
            let from = view.posAtDOM(r.startContainer, r.startOffset), to = view.posAtDOM(r.endContainer, r.endOffset);
            $1d528cc0e08a0656$var$applyDOMChangeInner(view, {
                from: from,
                to: to,
                insert: view.state.toText(text)
            }, null);
            return true;
        }
    }
    // Because Chrome Android doesn't fire useful key events, use
    // beforeinput to detect backspace (and possibly enter and delete,
    // but those usually don't even seem to fire beforeinput events at
    // the moment) and fake a key event for it.
    //
    // (preventDefault on beforeinput, though supported in the spec,
    // seems to do nothing at all on Chrome).
    let pending;
    if ($1d528cc0e08a0656$var$browser.chrome && $1d528cc0e08a0656$var$browser.android && (pending = $1d528cc0e08a0656$var$PendingKeys.find((key)=>key.inputType == event.inputType))) {
        view.observer.delayAndroidKey(pending.key, pending.keyCode);
        if (pending.key == "Backspace" || pending.key == "Delete") {
            let startViewHeight = ((_b = window.visualViewport) === null || _b === void 0 ? void 0 : _b.height) || 0;
            setTimeout(()=>{
                var _a;
                // Backspacing near uneditable nodes on Chrome Android sometimes
                // closes the virtual keyboard. This tries to crudely detect
                // that and refocus to get it back.
                if ((((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || 0) > startViewHeight + 10 && view.hasFocus) {
                    view.contentDOM.blur();
                    view.focus();
                }
            }, 100);
        }
    }
    if ($1d528cc0e08a0656$var$browser.ios && event.inputType == "deleteContentForward") // For some reason, DOM changes (and beforeinput) happen _before_
    // the key event for ctrl-d on iOS when using an external
    // keyboard.
    view.observer.flushSoon();
    // Safari will occasionally forget to fire compositionend at the end of a dead-key composition
    if ($1d528cc0e08a0656$var$browser.safari && event.inputType == "insertText" && view.inputState.composing >= 0) setTimeout(()=>$1d528cc0e08a0656$var$observers.compositionend(view, event), 20);
    return false;
};
const $1d528cc0e08a0656$var$appliedFirefoxHack = /*@__PURE__*/ new Set;
// In Firefox, when cut/copy handlers are added to the document, that
// somehow avoids a bug where those events aren't fired when the
// selection is empty. See https://github.com/codemirror/dev/issues/1082
// and https://bugzilla.mozilla.org/show_bug.cgi?id=995961
function $1d528cc0e08a0656$var$firefoxCopyCutHack(doc) {
    if (!$1d528cc0e08a0656$var$appliedFirefoxHack.has(doc)) {
        $1d528cc0e08a0656$var$appliedFirefoxHack.add(doc);
        doc.addEventListener("copy", ()=>{});
        doc.addEventListener("cut", ()=>{});
    }
}
const $1d528cc0e08a0656$var$wrappingWhiteSpace = [
    "pre-wrap",
    "normal",
    "pre-line",
    "break-spaces"
];
// Used to track, during updateHeight, if any actual heights changed
let $1d528cc0e08a0656$var$heightChangeFlag = false;
function $1d528cc0e08a0656$var$clearHeightChangeFlag() {
    $1d528cc0e08a0656$var$heightChangeFlag = false;
}
class $1d528cc0e08a0656$var$HeightOracle {
    constructor(lineWrapping){
        this.lineWrapping = lineWrapping;
        this.doc = (0, $6b8f387faea0a4dd$export$5f1af8db9871e1d6).empty;
        this.heightSamples = {};
        this.lineHeight = 14; // The height of an entire line (line-height)
        this.charWidth = 7;
        this.textHeight = 14; // The height of the actual font (font-size)
        this.lineLength = 30;
    }
    heightForGap(from, to) {
        let lines = this.doc.lineAt(to).number - this.doc.lineAt(from).number + 1;
        if (this.lineWrapping) lines += Math.max(0, Math.ceil((to - from - lines * this.lineLength * 0.5) / this.lineLength));
        return this.lineHeight * lines;
    }
    heightForLine(length) {
        if (!this.lineWrapping) return this.lineHeight;
        let lines = 1 + Math.max(0, Math.ceil((length - this.lineLength) / Math.max(1, this.lineLength - 5)));
        return lines * this.lineHeight;
    }
    setDoc(doc) {
        this.doc = doc;
        return this;
    }
    mustRefreshForWrapping(whiteSpace) {
        return $1d528cc0e08a0656$var$wrappingWhiteSpace.indexOf(whiteSpace) > -1 != this.lineWrapping;
    }
    mustRefreshForHeights(lineHeights) {
        let newHeight = false;
        for(let i = 0; i < lineHeights.length; i++){
            let h = lineHeights[i];
            if (h < 0) i++;
            else if (!this.heightSamples[Math.floor(h * 10)]) {
                newHeight = true;
                this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return newHeight;
    }
    refresh(whiteSpace, lineHeight, charWidth, textHeight, lineLength, knownHeights) {
        let lineWrapping = $1d528cc0e08a0656$var$wrappingWhiteSpace.indexOf(whiteSpace) > -1;
        let changed = Math.round(lineHeight) != Math.round(this.lineHeight) || this.lineWrapping != lineWrapping;
        this.lineWrapping = lineWrapping;
        this.lineHeight = lineHeight;
        this.charWidth = charWidth;
        this.textHeight = textHeight;
        this.lineLength = lineLength;
        if (changed) {
            this.heightSamples = {};
            for(let i = 0; i < knownHeights.length; i++){
                let h = knownHeights[i];
                if (h < 0) i++;
                else this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return changed;
    }
}
// This object is used by `updateHeight` to make DOM measurements
// arrive at the right nides. The `heights` array is a sequence of
// block heights, starting from position `from`.
class $1d528cc0e08a0656$var$MeasuredHeights {
    constructor(from, heights){
        this.from = from;
        this.heights = heights;
        this.index = 0;
    }
    get more() {
        return this.index < this.heights.length;
    }
}
/**
Record used to represent information about a block-level element
in the editor view.
*/ class $1d528cc0e08a0656$export$ddfdc4ccfe9512bd {
    /**
    @internal
    */ constructor(/**
    The start of the element in the document.
    */ from, /**
    The length of the element.
    */ length, /**
    The top position of the element (relative to the top of the
    document).
    */ top, /**
    Its height.
    */ height, /**
    @internal Weird packed field that holds an array of children
    for composite blocks, a decoration for block widgets, and a
    number indicating the amount of widget-create line breaks for
    text blocks.
    */ _content){
        this.from = from;
        this.length = length;
        this.top = top;
        this.height = height;
        this._content = _content;
    }
    /**
    The type of element this is. When querying lines, this may be
    an array of all the blocks that make up the line.
    */ get type() {
        return typeof this._content == "number" ? $1d528cc0e08a0656$export$48808c686fe495c4.Text : Array.isArray(this._content) ? this._content : this._content.type;
    }
    /**
    The end of the element as a document position.
    */ get to() {
        return this.from + this.length;
    }
    /**
    The bottom position of the element.
    */ get bottom() {
        return this.top + this.height;
    }
    /**
    If this is a widget block, this will return the widget
    associated with it.
    */ get widget() {
        return this._content instanceof $1d528cc0e08a0656$var$PointDecoration ? this._content.widget : null;
    }
    /**
    If this is a textblock, this holds the number of line breaks
    that appear in widgets inside the block.
    */ get widgetLineBreaks() {
        return typeof this._content == "number" ? this._content : 0;
    }
    /**
    @internal
    */ join(other) {
        let content = (Array.isArray(this._content) ? this._content : [
            this
        ]).concat(Array.isArray(other._content) ? other._content : [
            other
        ]);
        return new $1d528cc0e08a0656$export$ddfdc4ccfe9512bd(this.from, this.length + other.length, this.top, this.height + other.height, content);
    }
}
var $1d528cc0e08a0656$var$QueryType = /*@__PURE__*/ function(QueryType) {
    QueryType[QueryType["ByPos"] = 0] = "ByPos";
    QueryType[QueryType["ByHeight"] = 1] = "ByHeight";
    QueryType[QueryType["ByPosNoHeight"] = 2] = "ByPosNoHeight";
    return QueryType;
}($1d528cc0e08a0656$var$QueryType || ($1d528cc0e08a0656$var$QueryType = {}));
const $1d528cc0e08a0656$var$Epsilon = 1e-3;
class $1d528cc0e08a0656$var$HeightMap {
    constructor(length, height, flags = 2 /* Flag.Outdated */ ){
        this.length = length;
        this.height = height;
        this.flags = flags;
    }
    get outdated() {
        return (this.flags & 2 /* Flag.Outdated */ ) > 0;
    }
    set outdated(value) {
        this.flags = (value ? 2 /* Flag.Outdated */  : 0) | this.flags & -3 /* Flag.Outdated */ ;
    }
    setHeight(height) {
        if (this.height != height) {
            if (Math.abs(this.height - height) > $1d528cc0e08a0656$var$Epsilon) $1d528cc0e08a0656$var$heightChangeFlag = true;
            this.height = height;
        }
    }
    // Base case is to replace a leaf node, which simply builds a tree
    // from the new nodes and returns that (HeightMapBranch and
    // HeightMapGap override this to actually use from/to)
    replace(_from, _to, nodes) {
        return $1d528cc0e08a0656$var$HeightMap.of(nodes);
    }
    // Again, these are base cases, and are overridden for branch and gap nodes.
    decomposeLeft(_to, result) {
        result.push(this);
    }
    decomposeRight(_from, result) {
        result.push(this);
    }
    applyChanges(decorations, oldDoc, oracle, changes) {
        let me = this, doc = oracle.doc;
        for(let i = changes.length - 1; i >= 0; i--){
            let { fromA: fromA, toA: toA, fromB: fromB, toB: toB } = changes[i];
            let start = me.lineAt(fromA, $1d528cc0e08a0656$var$QueryType.ByPosNoHeight, oracle.setDoc(oldDoc), 0, 0);
            let end = start.to >= toA ? start : me.lineAt(toA, $1d528cc0e08a0656$var$QueryType.ByPosNoHeight, oracle, 0, 0);
            toB += end.to - toA;
            toA = end.to;
            while(i > 0 && start.from <= changes[i - 1].toA){
                fromA = changes[i - 1].fromA;
                fromB = changes[i - 1].fromB;
                i--;
                if (fromA < start.from) start = me.lineAt(fromA, $1d528cc0e08a0656$var$QueryType.ByPosNoHeight, oracle, 0, 0);
            }
            fromB += start.from - fromA;
            fromA = start.from;
            let nodes = $1d528cc0e08a0656$var$NodeBuilder.build(oracle.setDoc(doc), decorations, fromB, toB);
            me = $1d528cc0e08a0656$var$replace(me, me.replace(fromA, toA, nodes));
        }
        return me.updateHeight(oracle, 0);
    }
    static empty() {
        return new $1d528cc0e08a0656$var$HeightMapText(0, 0);
    }
    // nodes uses null values to indicate the position of line breaks.
    // There are never line breaks at the start or end of the array, or
    // two line breaks next to each other, and the array isn't allowed
    // to be empty (same restrictions as return value from the builder).
    static of(nodes) {
        if (nodes.length == 1) return nodes[0];
        let i = 0, j = nodes.length, before = 0, after = 0;
        for(;;){
            if (i == j) {
                if (before > after * 2) {
                    let split = nodes[i - 1];
                    if (split.break) nodes.splice(--i, 1, split.left, null, split.right);
                    else nodes.splice(--i, 1, split.left, split.right);
                    j += 1 + split.break;
                    before -= split.size;
                } else if (after > before * 2) {
                    let split = nodes[j];
                    if (split.break) nodes.splice(j, 1, split.left, null, split.right);
                    else nodes.splice(j, 1, split.left, split.right);
                    j += 2 + split.break;
                    after -= split.size;
                } else break;
            } else if (before < after) {
                let next = nodes[i++];
                if (next) before += next.size;
            } else {
                let next = nodes[--j];
                if (next) after += next.size;
            }
        }
        let brk = 0;
        if (nodes[i - 1] == null) {
            brk = 1;
            i--;
        } else if (nodes[i] == null) {
            brk = 1;
            j++;
        }
        return new $1d528cc0e08a0656$var$HeightMapBranch($1d528cc0e08a0656$var$HeightMap.of(nodes.slice(0, i)), brk, $1d528cc0e08a0656$var$HeightMap.of(nodes.slice(j)));
    }
}
function $1d528cc0e08a0656$var$replace(old, val) {
    if (old == val) return old;
    if (old.constructor != val.constructor) $1d528cc0e08a0656$var$heightChangeFlag = true;
    return val;
}
$1d528cc0e08a0656$var$HeightMap.prototype.size = 1;
class $1d528cc0e08a0656$var$HeightMapBlock extends $1d528cc0e08a0656$var$HeightMap {
    constructor(length, height, deco){
        super(length, height);
        this.deco = deco;
    }
    blockAt(_height, _oracle, top, offset) {
        return new $1d528cc0e08a0656$export$ddfdc4ccfe9512bd(offset, this.length, top, this.height, this.deco || 0);
    }
    lineAt(_value, _type, oracle, top, offset) {
        return this.blockAt(0, oracle, top, offset);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        if (from <= offset + this.length && to >= offset) f(this.blockAt(0, oracle, top, offset));
    }
    updateHeight(oracle, offset = 0, _force = false, measured) {
        if (measured && measured.from <= offset && measured.more) this.setHeight(measured.heights[measured.index++]);
        this.outdated = false;
        return this;
    }
    toString() {
        return `block(${this.length})`;
    }
}
class $1d528cc0e08a0656$var$HeightMapText extends $1d528cc0e08a0656$var$HeightMapBlock {
    constructor(length, height){
        super(length, height, null);
        this.collapsed = 0; // Amount of collapsed content in the line
        this.widgetHeight = 0; // Maximum inline widget height
        this.breaks = 0; // Number of widget-introduced line breaks on the line
    }
    blockAt(_height, _oracle, top, offset) {
        return new $1d528cc0e08a0656$export$ddfdc4ccfe9512bd(offset, this.length, top, this.height, this.breaks);
    }
    replace(_from, _to, nodes) {
        let node = nodes[0];
        if (nodes.length == 1 && (node instanceof $1d528cc0e08a0656$var$HeightMapText || node instanceof $1d528cc0e08a0656$var$HeightMapGap && node.flags & 4 /* Flag.SingleLine */ ) && Math.abs(this.length - node.length) < 10) {
            if (node instanceof $1d528cc0e08a0656$var$HeightMapGap) node = new $1d528cc0e08a0656$var$HeightMapText(node.length, this.height);
            else node.height = this.height;
            if (!this.outdated) node.outdated = false;
            return node;
        } else return $1d528cc0e08a0656$var$HeightMap.of(nodes);
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        if (measured && measured.from <= offset && measured.more) this.setHeight(measured.heights[measured.index++]);
        else if (force || this.outdated) this.setHeight(Math.max(this.widgetHeight, oracle.heightForLine(this.length - this.collapsed)) + this.breaks * oracle.lineHeight);
        this.outdated = false;
        return this;
    }
    toString() {
        return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
    }
}
class $1d528cc0e08a0656$var$HeightMapGap extends $1d528cc0e08a0656$var$HeightMap {
    constructor(length){
        super(length, 0);
    }
    heightMetrics(oracle, offset) {
        let firstLine = oracle.doc.lineAt(offset).number, lastLine = oracle.doc.lineAt(offset + this.length).number;
        let lines = lastLine - firstLine + 1;
        let perLine, perChar = 0;
        if (oracle.lineWrapping) {
            let totalPerLine = Math.min(this.height, oracle.lineHeight * lines);
            perLine = totalPerLine / lines;
            if (this.length > lines + 1) perChar = (this.height - totalPerLine) / (this.length - lines - 1);
        } else perLine = this.height / lines;
        return {
            firstLine: firstLine,
            lastLine: lastLine,
            perLine: perLine,
            perChar: perChar
        };
    }
    blockAt(height, oracle, top, offset) {
        let { firstLine: firstLine, lastLine: lastLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        if (oracle.lineWrapping) {
            let guess = offset + (height < oracle.lineHeight ? 0 : Math.round(Math.max(0, Math.min(1, (height - top) / this.height)) * this.length));
            let line = oracle.doc.lineAt(guess), lineHeight = perLine + line.length * perChar;
            let lineTop = Math.max(top, height - lineHeight / 2);
            return new $1d528cc0e08a0656$export$ddfdc4ccfe9512bd(line.from, line.length, lineTop, lineHeight, 0);
        } else {
            let line = Math.max(0, Math.min(lastLine - firstLine, Math.floor((height - top) / perLine)));
            let { from: from, length: length } = oracle.doc.line(firstLine + line);
            return new $1d528cc0e08a0656$export$ddfdc4ccfe9512bd(from, length, top + perLine * line, perLine, 0);
        }
    }
    lineAt(value, type, oracle, top, offset) {
        if (type == $1d528cc0e08a0656$var$QueryType.ByHeight) return this.blockAt(value, oracle, top, offset);
        if (type == $1d528cc0e08a0656$var$QueryType.ByPosNoHeight) {
            let { from: from, to: to } = oracle.doc.lineAt(value);
            return new $1d528cc0e08a0656$export$ddfdc4ccfe9512bd(from, to - from, 0, 0, 0);
        }
        let { firstLine: firstLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        let line = oracle.doc.lineAt(value), lineHeight = perLine + line.length * perChar;
        let linesAbove = line.number - firstLine;
        let lineTop = top + perLine * linesAbove + perChar * (line.from - offset - linesAbove);
        return new $1d528cc0e08a0656$export$ddfdc4ccfe9512bd(line.from, line.length, Math.max(top, Math.min(lineTop, top + this.height - lineHeight)), lineHeight, 0);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        from = Math.max(from, offset);
        to = Math.min(to, offset + this.length);
        let { firstLine: firstLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        for(let pos = from, lineTop = top; pos <= to;){
            let line = oracle.doc.lineAt(pos);
            if (pos == from) {
                let linesAbove = line.number - firstLine;
                lineTop += perLine * linesAbove + perChar * (from - offset - linesAbove);
            }
            let lineHeight = perLine + perChar * line.length;
            f(new $1d528cc0e08a0656$export$ddfdc4ccfe9512bd(line.from, line.length, lineTop, lineHeight, 0));
            lineTop += lineHeight;
            pos = line.to + 1;
        }
    }
    replace(from, to, nodes) {
        let after = this.length - to;
        if (after > 0) {
            let last = nodes[nodes.length - 1];
            if (last instanceof $1d528cc0e08a0656$var$HeightMapGap) nodes[nodes.length - 1] = new $1d528cc0e08a0656$var$HeightMapGap(last.length + after);
            else nodes.push(null, new $1d528cc0e08a0656$var$HeightMapGap(after - 1));
        }
        if (from > 0) {
            let first = nodes[0];
            if (first instanceof $1d528cc0e08a0656$var$HeightMapGap) nodes[0] = new $1d528cc0e08a0656$var$HeightMapGap(from + first.length);
            else nodes.unshift(new $1d528cc0e08a0656$var$HeightMapGap(from - 1), null);
        }
        return $1d528cc0e08a0656$var$HeightMap.of(nodes);
    }
    decomposeLeft(to, result) {
        result.push(new $1d528cc0e08a0656$var$HeightMapGap(to - 1), null);
    }
    decomposeRight(from, result) {
        result.push(null, new $1d528cc0e08a0656$var$HeightMapGap(this.length - from - 1));
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        let end = offset + this.length;
        if (measured && measured.from <= offset + this.length && measured.more) {
            // Fill in part of this gap with measured lines. We know there
            // can't be widgets or collapsed ranges in those lines, because
            // they would already have been added to the heightmap (gaps
            // only contain plain text).
            let nodes = [], pos = Math.max(offset, measured.from), singleHeight = -1;
            if (measured.from > offset) nodes.push(new $1d528cc0e08a0656$var$HeightMapGap(measured.from - offset - 1).updateHeight(oracle, offset));
            while(pos <= end && measured.more){
                let len = oracle.doc.lineAt(pos).length;
                if (nodes.length) nodes.push(null);
                let height = measured.heights[measured.index++];
                if (singleHeight == -1) singleHeight = height;
                else if (Math.abs(height - singleHeight) >= $1d528cc0e08a0656$var$Epsilon) singleHeight = -2;
                let line = new $1d528cc0e08a0656$var$HeightMapText(len, height);
                line.outdated = false;
                nodes.push(line);
                pos += len + 1;
            }
            if (pos <= end) nodes.push(null, new $1d528cc0e08a0656$var$HeightMapGap(end - pos).updateHeight(oracle, pos));
            let result = $1d528cc0e08a0656$var$HeightMap.of(nodes);
            if (singleHeight < 0 || Math.abs(result.height - this.height) >= $1d528cc0e08a0656$var$Epsilon || Math.abs(singleHeight - this.heightMetrics(oracle, offset).perLine) >= $1d528cc0e08a0656$var$Epsilon) $1d528cc0e08a0656$var$heightChangeFlag = true;
            return $1d528cc0e08a0656$var$replace(this, result);
        } else if (force || this.outdated) {
            this.setHeight(oracle.heightForGap(offset, offset + this.length));
            this.outdated = false;
        }
        return this;
    }
    toString() {
        return `gap(${this.length})`;
    }
}
class $1d528cc0e08a0656$var$HeightMapBranch extends $1d528cc0e08a0656$var$HeightMap {
    constructor(left, brk, right){
        super(left.length + brk + right.length, left.height + right.height, brk | (left.outdated || right.outdated ? 2 /* Flag.Outdated */  : 0));
        this.left = left;
        this.right = right;
        this.size = left.size + right.size;
    }
    get break() {
        return this.flags & 1 /* Flag.Break */ ;
    }
    blockAt(height, oracle, top, offset) {
        let mid = top + this.left.height;
        return height < mid ? this.left.blockAt(height, oracle, top, offset) : this.right.blockAt(height, oracle, mid, offset + this.left.length + this.break);
    }
    lineAt(value, type, oracle, top, offset) {
        let rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        let left = type == $1d528cc0e08a0656$var$QueryType.ByHeight ? value < rightTop : value < rightOffset;
        let base = left ? this.left.lineAt(value, type, oracle, top, offset) : this.right.lineAt(value, type, oracle, rightTop, rightOffset);
        if (this.break || (left ? base.to < rightOffset : base.from > rightOffset)) return base;
        let subQuery = type == $1d528cc0e08a0656$var$QueryType.ByPosNoHeight ? $1d528cc0e08a0656$var$QueryType.ByPosNoHeight : $1d528cc0e08a0656$var$QueryType.ByPos;
        if (left) return base.join(this.right.lineAt(rightOffset, subQuery, oracle, rightTop, rightOffset));
        else return this.left.lineAt(rightOffset, subQuery, oracle, top, offset).join(base);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        let rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        if (this.break) {
            if (from < rightOffset) this.left.forEachLine(from, to, oracle, top, offset, f);
            if (to >= rightOffset) this.right.forEachLine(from, to, oracle, rightTop, rightOffset, f);
        } else {
            let mid = this.lineAt(rightOffset, $1d528cc0e08a0656$var$QueryType.ByPos, oracle, top, offset);
            if (from < mid.from) this.left.forEachLine(from, mid.from - 1, oracle, top, offset, f);
            if (mid.to >= from && mid.from <= to) f(mid);
            if (to > mid.to) this.right.forEachLine(mid.to + 1, to, oracle, rightTop, rightOffset, f);
        }
    }
    replace(from, to, nodes) {
        let rightStart = this.left.length + this.break;
        if (to < rightStart) return this.balanced(this.left.replace(from, to, nodes), this.right);
        if (from > this.left.length) return this.balanced(this.left, this.right.replace(from - rightStart, to - rightStart, nodes));
        let result = [];
        if (from > 0) this.decomposeLeft(from, result);
        let left = result.length;
        for (let node of nodes)result.push(node);
        if (from > 0) $1d528cc0e08a0656$var$mergeGaps(result, left - 1);
        if (to < this.length) {
            let right = result.length;
            this.decomposeRight(to, result);
            $1d528cc0e08a0656$var$mergeGaps(result, right);
        }
        return $1d528cc0e08a0656$var$HeightMap.of(result);
    }
    decomposeLeft(to, result) {
        let left = this.left.length;
        if (to <= left) return this.left.decomposeLeft(to, result);
        result.push(this.left);
        if (this.break) {
            left++;
            if (to >= left) result.push(null);
        }
        if (to > left) this.right.decomposeLeft(to - left, result);
    }
    decomposeRight(from, result) {
        let left = this.left.length, right = left + this.break;
        if (from >= right) return this.right.decomposeRight(from - right, result);
        if (from < left) this.left.decomposeRight(from, result);
        if (this.break && from < right) result.push(null);
        result.push(this.right);
    }
    balanced(left, right) {
        if (left.size > 2 * right.size || right.size > 2 * left.size) return $1d528cc0e08a0656$var$HeightMap.of(this.break ? [
            left,
            null,
            right
        ] : [
            left,
            right
        ]);
        this.left = $1d528cc0e08a0656$var$replace(this.left, left);
        this.right = $1d528cc0e08a0656$var$replace(this.right, right);
        this.setHeight(left.height + right.height);
        this.outdated = left.outdated || right.outdated;
        this.size = left.size + right.size;
        this.length = left.length + this.break + right.length;
        return this;
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        let { left: left, right: right } = this, rightStart = offset + left.length + this.break, rebalance = null;
        if (measured && measured.from <= offset + left.length && measured.more) rebalance = left = left.updateHeight(oracle, offset, force, measured);
        else left.updateHeight(oracle, offset, force);
        if (measured && measured.from <= rightStart + right.length && measured.more) rebalance = right = right.updateHeight(oracle, rightStart, force, measured);
        else right.updateHeight(oracle, rightStart, force);
        if (rebalance) return this.balanced(left, right);
        this.height = this.left.height + this.right.height;
        this.outdated = false;
        return this;
    }
    toString() {
        return this.left + (this.break ? " " : "-") + this.right;
    }
}
function $1d528cc0e08a0656$var$mergeGaps(nodes, around) {
    let before, after;
    if (nodes[around] == null && (before = nodes[around - 1]) instanceof $1d528cc0e08a0656$var$HeightMapGap && (after = nodes[around + 1]) instanceof $1d528cc0e08a0656$var$HeightMapGap) nodes.splice(around - 1, 3, new $1d528cc0e08a0656$var$HeightMapGap(before.length + 1 + after.length));
}
const $1d528cc0e08a0656$var$relevantWidgetHeight = 5;
class $1d528cc0e08a0656$var$NodeBuilder {
    constructor(pos, oracle){
        this.pos = pos;
        this.oracle = oracle;
        this.nodes = [];
        this.lineStart = -1;
        this.lineEnd = -1;
        this.covering = null;
        this.writtenTo = pos;
    }
    get isCovered() {
        return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
    }
    span(_from, to) {
        if (this.lineStart > -1) {
            let end = Math.min(to, this.lineEnd), last = this.nodes[this.nodes.length - 1];
            if (last instanceof $1d528cc0e08a0656$var$HeightMapText) last.length += end - this.pos;
            else if (end > this.pos || !this.isCovered) this.nodes.push(new $1d528cc0e08a0656$var$HeightMapText(end - this.pos, -1));
            this.writtenTo = end;
            if (to > end) {
                this.nodes.push(null);
                this.writtenTo++;
                this.lineStart = -1;
            }
        }
        this.pos = to;
    }
    point(from, to, deco) {
        if (from < to || deco.heightRelevant) {
            let height = deco.widget ? deco.widget.estimatedHeight : 0;
            let breaks = deco.widget ? deco.widget.lineBreaks : 0;
            if (height < 0) height = this.oracle.lineHeight;
            let len = to - from;
            if (deco.block) this.addBlock(new $1d528cc0e08a0656$var$HeightMapBlock(len, height, deco));
            else if (len || breaks || height >= $1d528cc0e08a0656$var$relevantWidgetHeight) this.addLineDeco(height, breaks, len);
        } else if (to > from) this.span(from, to);
        if (this.lineEnd > -1 && this.lineEnd < this.pos) this.lineEnd = this.oracle.doc.lineAt(this.pos).to;
    }
    enterLine() {
        if (this.lineStart > -1) return;
        let { from: from, to: to } = this.oracle.doc.lineAt(this.pos);
        this.lineStart = from;
        this.lineEnd = to;
        if (this.writtenTo < from) {
            if (this.writtenTo < from - 1 || this.nodes[this.nodes.length - 1] == null) this.nodes.push(this.blankContent(this.writtenTo, from - 1));
            this.nodes.push(null);
        }
        if (this.pos > from) this.nodes.push(new $1d528cc0e08a0656$var$HeightMapText(this.pos - from, -1));
        this.writtenTo = this.pos;
    }
    blankContent(from, to) {
        let gap = new $1d528cc0e08a0656$var$HeightMapGap(to - from);
        if (this.oracle.doc.lineAt(from).to == to) gap.flags |= 4 /* Flag.SingleLine */ ;
        return gap;
    }
    ensureLine() {
        this.enterLine();
        let last = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
        if (last instanceof $1d528cc0e08a0656$var$HeightMapText) return last;
        let line = new $1d528cc0e08a0656$var$HeightMapText(0, -1);
        this.nodes.push(line);
        return line;
    }
    addBlock(block) {
        this.enterLine();
        let deco = block.deco;
        if (deco && deco.startSide > 0 && !this.isCovered) this.ensureLine();
        this.nodes.push(block);
        this.writtenTo = this.pos = this.pos + block.length;
        if (deco && deco.endSide > 0) this.covering = block;
    }
    addLineDeco(height, breaks, length) {
        let line = this.ensureLine();
        line.length += length;
        line.collapsed += length;
        line.widgetHeight = Math.max(line.widgetHeight, height);
        line.breaks += breaks;
        this.writtenTo = this.pos = this.pos + length;
    }
    finish(from) {
        let last = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
        if (this.lineStart > -1 && !(last instanceof $1d528cc0e08a0656$var$HeightMapText) && !this.isCovered) this.nodes.push(new $1d528cc0e08a0656$var$HeightMapText(0, -1));
        else if (this.writtenTo < this.pos || last == null) this.nodes.push(this.blankContent(this.writtenTo, this.pos));
        let pos = from;
        for (let node of this.nodes){
            if (node instanceof $1d528cc0e08a0656$var$HeightMapText) node.updateHeight(this.oracle, pos);
            pos += node ? node.length : 1;
        }
        return this.nodes;
    }
    // Always called with a region that on both sides either stretches
    // to a line break or the end of the document.
    // The returned array uses null to indicate line breaks, but never
    // starts or ends in a line break, or has multiple line breaks next
    // to each other.
    static build(oracle, decorations, from, to) {
        let builder = new $1d528cc0e08a0656$var$NodeBuilder(from, oracle);
        (0, $6b8f387faea0a4dd$export$34cb5241245008dd).spans(decorations, from, to, builder, 0);
        return builder.finish(from);
    }
}
function $1d528cc0e08a0656$var$heightRelevantDecoChanges(a, b, diff) {
    let comp = new $1d528cc0e08a0656$var$DecorationComparator;
    (0, $6b8f387faea0a4dd$export$34cb5241245008dd).compare(a, b, diff, comp, 0);
    return comp.changes;
}
class $1d528cc0e08a0656$var$DecorationComparator {
    constructor(){
        this.changes = [];
    }
    compareRange() {}
    comparePoint(from, to, a, b) {
        if (from < to || a && a.heightRelevant || b && b.heightRelevant) $1d528cc0e08a0656$var$addRange(from, to, this.changes, 5);
    }
}
function $1d528cc0e08a0656$var$visiblePixelRange(dom, paddingTop) {
    let rect = dom.getBoundingClientRect();
    let doc = dom.ownerDocument, win = doc.defaultView || window;
    let left = Math.max(0, rect.left), right = Math.min(win.innerWidth, rect.right);
    let top = Math.max(0, rect.top), bottom = Math.min(win.innerHeight, rect.bottom);
    for(let parent = dom.parentNode; parent && parent != doc.body;){
        if (parent.nodeType == 1) {
            let elt = parent;
            let style = window.getComputedStyle(elt);
            if ((elt.scrollHeight > elt.clientHeight || elt.scrollWidth > elt.clientWidth) && style.overflow != "visible") {
                let parentRect = elt.getBoundingClientRect();
                left = Math.max(left, parentRect.left);
                right = Math.min(right, parentRect.right);
                top = Math.max(top, parentRect.top);
                bottom = Math.min(parent == dom.parentNode ? win.innerHeight : bottom, parentRect.bottom);
            }
            parent = style.position == "absolute" || style.position == "fixed" ? elt.offsetParent : elt.parentNode;
        } else if (parent.nodeType == 11) parent = parent.host;
        else break;
    }
    return {
        left: left - rect.left,
        right: Math.max(left, right) - rect.left,
        top: top - (rect.top + paddingTop),
        bottom: Math.max(top, bottom) - (rect.top + paddingTop)
    };
}
function $1d528cc0e08a0656$var$inWindow(elt) {
    let rect = elt.getBoundingClientRect(), win = elt.ownerDocument.defaultView || window;
    return rect.left < win.innerWidth && rect.right > 0 && rect.top < win.innerHeight && rect.bottom > 0;
}
function $1d528cc0e08a0656$var$fullPixelRange(dom, paddingTop) {
    let rect = dom.getBoundingClientRect();
    return {
        left: 0,
        right: rect.right - rect.left,
        top: paddingTop,
        bottom: rect.bottom - (rect.top + paddingTop)
    };
}
// Line gaps are placeholder widgets used to hide pieces of overlong
// lines within the viewport, as a kludge to keep the editor
// responsive when a ridiculously long line is loaded into it.
class $1d528cc0e08a0656$var$LineGap {
    constructor(from, to, size, displaySize){
        this.from = from;
        this.to = to;
        this.size = size;
        this.displaySize = displaySize;
    }
    static same(a, b) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++){
            let gA = a[i], gB = b[i];
            if (gA.from != gB.from || gA.to != gB.to || gA.size != gB.size) return false;
        }
        return true;
    }
    draw(viewState, wrapping) {
        return $1d528cc0e08a0656$export$10e30b733df217ea.replace({
            widget: new $1d528cc0e08a0656$var$LineGapWidget(this.displaySize * (wrapping ? viewState.scaleY : viewState.scaleX), wrapping)
        }).range(this.from, this.to);
    }
}
class $1d528cc0e08a0656$var$LineGapWidget extends $1d528cc0e08a0656$export$95cdd842edb044c5 {
    constructor(size, vertical){
        super();
        this.size = size;
        this.vertical = vertical;
    }
    eq(other) {
        return other.size == this.size && other.vertical == this.vertical;
    }
    toDOM() {
        let elt = document.createElement("div");
        if (this.vertical) elt.style.height = this.size + "px";
        else {
            elt.style.width = this.size + "px";
            elt.style.height = "2px";
            elt.style.display = "inline-block";
        }
        return elt;
    }
    get estimatedHeight() {
        return this.vertical ? this.size : -1;
    }
}
class $1d528cc0e08a0656$var$ViewState {
    constructor(state){
        this.state = state;
        // These are contentDOM-local coordinates
        this.pixelViewport = {
            left: 0,
            right: window.innerWidth,
            top: 0,
            bottom: 0
        };
        this.inView = true;
        this.paddingTop = 0; // Padding above the document, scaled
        this.paddingBottom = 0; // Padding below the document, scaled
        this.contentDOMWidth = 0; // contentDOM.getBoundingClientRect().width
        this.contentDOMHeight = 0; // contentDOM.getBoundingClientRect().height
        this.editorHeight = 0; // scrollDOM.clientHeight, unscaled
        this.editorWidth = 0; // scrollDOM.clientWidth, unscaled
        this.scrollTop = 0; // Last seen scrollDOM.scrollTop, scaled
        this.scrolledToBottom = false;
        // The CSS-transformation scale of the editor (transformed size /
        // concrete size)
        this.scaleX = 1;
        this.scaleY = 1;
        // The vertical position (document-relative) to which to anchor the
        // scroll position. -1 means anchor to the end of the document.
        this.scrollAnchorPos = 0;
        // The height at the anchor position. Set by the DOM update phase.
        // -1 means no height available.
        this.scrollAnchorHeight = -1;
        // See VP.MaxDOMHeight
        this.scaler = $1d528cc0e08a0656$var$IdScaler;
        this.scrollTarget = null;
        // Briefly set to true when printing, to disable viewport limiting
        this.printing = false;
        // Flag set when editor content was redrawn, so that the next
        // measure stage knows it must read DOM layout
        this.mustMeasureContent = true;
        this.defaultTextDirection = $1d528cc0e08a0656$export$cacd6541cfeeb6c1.LTR;
        this.visibleRanges = [];
        // Cursor 'assoc' is only significant when the cursor is on a line
        // wrap point, where it must stick to the character that it is
        // associated with. Since browsers don't provide a reasonable
        // interface to set or query this, when a selection is set that
        // might cause this to be significant, this flag is set. The next
        // measure phase will check whether the cursor is on a line-wrapping
        // boundary and, if so, reset it to make sure it is positioned in
        // the right place.
        this.mustEnforceCursorAssoc = false;
        let guessWrapping = state.facet($1d528cc0e08a0656$var$contentAttributes).some((v)=>typeof v != "function" && v.class == "cm-lineWrapping");
        this.heightOracle = new $1d528cc0e08a0656$var$HeightOracle(guessWrapping);
        this.stateDeco = state.facet($1d528cc0e08a0656$var$decorations).filter((d)=>typeof d != "function");
        this.heightMap = $1d528cc0e08a0656$var$HeightMap.empty().applyChanges(this.stateDeco, (0, $6b8f387faea0a4dd$export$5f1af8db9871e1d6).empty, this.heightOracle.setDoc(state.doc), [
            new $1d528cc0e08a0656$var$ChangedRange(0, 0, 0, state.doc.length)
        ]);
        for(let i = 0; i < 2; i++){
            this.viewport = this.getViewport(0, null);
            if (!this.updateForViewport()) break;
        }
        this.updateViewportLines();
        this.lineGaps = this.ensureLineGaps([]);
        this.lineGapDeco = $1d528cc0e08a0656$export$10e30b733df217ea.set(this.lineGaps.map((gap)=>gap.draw(this, false)));
        this.computeVisibleRanges();
    }
    updateForViewport() {
        let viewports = [
            this.viewport
        ], { main: main } = this.state.selection;
        for(let i = 0; i <= 1; i++){
            let pos = i ? main.head : main.anchor;
            if (!viewports.some(({ from: from, to: to })=>pos >= from && pos <= to)) {
                let { from: from, to: to } = this.lineBlockAt(pos);
                viewports.push(new $1d528cc0e08a0656$var$Viewport(from, to));
            }
        }
        this.viewports = viewports.sort((a, b)=>a.from - b.from);
        return this.updateScaler();
    }
    updateScaler() {
        let scaler = this.scaler;
        this.scaler = this.heightMap.height <= 7000000 /* VP.MaxDOMHeight */  ? $1d528cc0e08a0656$var$IdScaler : new $1d528cc0e08a0656$var$BigScaler(this.heightOracle, this.heightMap, this.viewports);
        return scaler.eq(this.scaler) ? 0 : 2 /* UpdateFlag.Height */ ;
    }
    updateViewportLines() {
        this.viewportLines = [];
        this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (block)=>{
            this.viewportLines.push($1d528cc0e08a0656$var$scaleBlock(block, this.scaler));
        });
    }
    update(update, scrollTarget = null) {
        this.state = update.state;
        let prevDeco = this.stateDeco;
        this.stateDeco = this.state.facet($1d528cc0e08a0656$var$decorations).filter((d)=>typeof d != "function");
        let contentChanges = update.changedRanges;
        let heightChanges = $1d528cc0e08a0656$var$ChangedRange.extendWithRanges(contentChanges, $1d528cc0e08a0656$var$heightRelevantDecoChanges(prevDeco, this.stateDeco, update ? update.changes : (0, $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c).empty(this.state.doc.length)));
        let prevHeight = this.heightMap.height;
        let scrollAnchor = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
        $1d528cc0e08a0656$var$clearHeightChangeFlag();
        this.heightMap = this.heightMap.applyChanges(this.stateDeco, update.startState.doc, this.heightOracle.setDoc(this.state.doc), heightChanges);
        if (this.heightMap.height != prevHeight || $1d528cc0e08a0656$var$heightChangeFlag) update.flags |= 2 /* UpdateFlag.Height */ ;
        if (scrollAnchor) {
            this.scrollAnchorPos = update.changes.mapPos(scrollAnchor.from, -1);
            this.scrollAnchorHeight = scrollAnchor.top;
        } else {
            this.scrollAnchorPos = -1;
            this.scrollAnchorHeight = prevHeight;
        }
        let viewport = heightChanges.length ? this.mapViewport(this.viewport, update.changes) : this.viewport;
        if (scrollTarget && (scrollTarget.range.head < viewport.from || scrollTarget.range.head > viewport.to) || !this.viewportIsAppropriate(viewport)) viewport = this.getViewport(0, scrollTarget);
        let viewportChange = viewport.from != this.viewport.from || viewport.to != this.viewport.to;
        this.viewport = viewport;
        update.flags |= this.updateForViewport();
        if (viewportChange || !update.changes.empty || update.flags & 2 /* UpdateFlag.Height */ ) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000) this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, update.changes)));
        update.flags |= this.computeVisibleRanges(update.changes);
        if (scrollTarget) this.scrollTarget = scrollTarget;
        if (!this.mustEnforceCursorAssoc && update.selectionSet && update.view.lineWrapping && update.state.selection.main.empty && update.state.selection.main.assoc && !update.state.facet($1d528cc0e08a0656$var$nativeSelectionHidden)) this.mustEnforceCursorAssoc = true;
    }
    measure(view) {
        let dom = view.contentDOM, style = window.getComputedStyle(dom);
        let oracle = this.heightOracle;
        let whiteSpace = style.whiteSpace;
        this.defaultTextDirection = style.direction == "rtl" ? $1d528cc0e08a0656$export$cacd6541cfeeb6c1.RTL : $1d528cc0e08a0656$export$cacd6541cfeeb6c1.LTR;
        let refresh = this.heightOracle.mustRefreshForWrapping(whiteSpace);
        let domRect = dom.getBoundingClientRect();
        let measureContent = refresh || this.mustMeasureContent || this.contentDOMHeight != domRect.height;
        this.contentDOMHeight = domRect.height;
        this.mustMeasureContent = false;
        let result = 0, bias = 0;
        if (domRect.width && domRect.height) {
            let { scaleX: scaleX, scaleY: scaleY } = $1d528cc0e08a0656$var$getScale(dom, domRect);
            if (scaleX > .005 && Math.abs(this.scaleX - scaleX) > .005 || scaleY > .005 && Math.abs(this.scaleY - scaleY) > .005) {
                this.scaleX = scaleX;
                this.scaleY = scaleY;
                result |= 16 /* UpdateFlag.Geometry */ ;
                refresh = measureContent = true;
            }
        }
        // Vertical padding
        let paddingTop = (parseInt(style.paddingTop) || 0) * this.scaleY;
        let paddingBottom = (parseInt(style.paddingBottom) || 0) * this.scaleY;
        if (this.paddingTop != paddingTop || this.paddingBottom != paddingBottom) {
            this.paddingTop = paddingTop;
            this.paddingBottom = paddingBottom;
            result |= 18 /* UpdateFlag.Height */ ;
        }
        if (this.editorWidth != view.scrollDOM.clientWidth) {
            if (oracle.lineWrapping) measureContent = true;
            this.editorWidth = view.scrollDOM.clientWidth;
            result |= 16 /* UpdateFlag.Geometry */ ;
        }
        let scrollTop = view.scrollDOM.scrollTop * this.scaleY;
        if (this.scrollTop != scrollTop) {
            this.scrollAnchorHeight = -1;
            this.scrollTop = scrollTop;
        }
        this.scrolledToBottom = $1d528cc0e08a0656$var$isScrolledToBottom(view.scrollDOM);
        // Pixel viewport
        let pixelViewport = (this.printing ? $1d528cc0e08a0656$var$fullPixelRange : $1d528cc0e08a0656$var$visiblePixelRange)(dom, this.paddingTop);
        let dTop = pixelViewport.top - this.pixelViewport.top, dBottom = pixelViewport.bottom - this.pixelViewport.bottom;
        this.pixelViewport = pixelViewport;
        let inView = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
        if (inView != this.inView) {
            this.inView = inView;
            if (inView) measureContent = true;
        }
        if (!this.inView && !this.scrollTarget && !$1d528cc0e08a0656$var$inWindow(view.dom)) return 0;
        let contentWidth = domRect.width;
        if (this.contentDOMWidth != contentWidth || this.editorHeight != view.scrollDOM.clientHeight) {
            this.contentDOMWidth = domRect.width;
            this.editorHeight = view.scrollDOM.clientHeight;
            result |= 16 /* UpdateFlag.Geometry */ ;
        }
        if (measureContent) {
            let lineHeights = view.docView.measureVisibleLineHeights(this.viewport);
            if (oracle.mustRefreshForHeights(lineHeights)) refresh = true;
            if (refresh || oracle.lineWrapping && Math.abs(contentWidth - this.contentDOMWidth) > oracle.charWidth) {
                let { lineHeight: lineHeight, charWidth: charWidth, textHeight: textHeight } = view.docView.measureTextSize();
                refresh = lineHeight > 0 && oracle.refresh(whiteSpace, lineHeight, charWidth, textHeight, Math.max(5, contentWidth / charWidth), lineHeights);
                if (refresh) {
                    view.docView.minWidth = 0;
                    result |= 16 /* UpdateFlag.Geometry */ ;
                }
            }
            if (dTop > 0 && dBottom > 0) bias = Math.max(dTop, dBottom);
            else if (dTop < 0 && dBottom < 0) bias = Math.min(dTop, dBottom);
            $1d528cc0e08a0656$var$clearHeightChangeFlag();
            for (let vp of this.viewports){
                let heights = vp.from == this.viewport.from ? lineHeights : view.docView.measureVisibleLineHeights(vp);
                this.heightMap = (refresh ? $1d528cc0e08a0656$var$HeightMap.empty().applyChanges(this.stateDeco, (0, $6b8f387faea0a4dd$export$5f1af8db9871e1d6).empty, this.heightOracle, [
                    new $1d528cc0e08a0656$var$ChangedRange(0, 0, 0, view.state.doc.length)
                ]) : this.heightMap).updateHeight(oracle, 0, refresh, new $1d528cc0e08a0656$var$MeasuredHeights(vp.from, heights));
            }
            if ($1d528cc0e08a0656$var$heightChangeFlag) result |= 2 /* UpdateFlag.Height */ ;
        }
        let viewportChange = !this.viewportIsAppropriate(this.viewport, bias) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
        if (viewportChange) {
            if (result & 2 /* UpdateFlag.Height */ ) result |= this.updateScaler();
            this.viewport = this.getViewport(bias, this.scrollTarget);
            result |= this.updateForViewport();
        }
        if (result & 2 /* UpdateFlag.Height */  || viewportChange) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000) this.updateLineGaps(this.ensureLineGaps(refresh ? [] : this.lineGaps, view));
        result |= this.computeVisibleRanges();
        if (this.mustEnforceCursorAssoc) {
            this.mustEnforceCursorAssoc = false;
            // This is done in the read stage, because moving the selection
            // to a line end is going to trigger a layout anyway, so it
            // can't be a pure write. It should be rare that it does any
            // writing.
            view.docView.enforceCursorAssoc();
        }
        return result;
    }
    get visibleTop() {
        return this.scaler.fromDOM(this.pixelViewport.top);
    }
    get visibleBottom() {
        return this.scaler.fromDOM(this.pixelViewport.bottom);
    }
    getViewport(bias, scrollTarget) {
        // This will divide VP.Margin between the top and the
        // bottom, depending on the bias (the change in viewport position
        // since the last update). It'll hold a number between 0 and 1
        let marginTop = 0.5 - Math.max(-0.5, Math.min(0.5, bias / 1000 /* VP.Margin */  / 2));
        let map = this.heightMap, oracle = this.heightOracle;
        let { visibleTop: visibleTop, visibleBottom: visibleBottom } = this;
        let viewport = new $1d528cc0e08a0656$var$Viewport(map.lineAt(visibleTop - marginTop * 1000 /* VP.Margin */ , $1d528cc0e08a0656$var$QueryType.ByHeight, oracle, 0, 0).from, map.lineAt(visibleBottom + (1 - marginTop) * 1000 /* VP.Margin */ , $1d528cc0e08a0656$var$QueryType.ByHeight, oracle, 0, 0).to);
        // If scrollTarget is given, make sure the viewport includes that position
        if (scrollTarget) {
            let { head: head } = scrollTarget.range;
            if (head < viewport.from || head > viewport.to) {
                let viewHeight = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top);
                let block = map.lineAt(head, $1d528cc0e08a0656$var$QueryType.ByPos, oracle, 0, 0), topPos;
                if (scrollTarget.y == "center") topPos = (block.top + block.bottom) / 2 - viewHeight / 2;
                else if (scrollTarget.y == "start" || scrollTarget.y == "nearest" && head < viewport.from) topPos = block.top;
                else topPos = block.bottom - viewHeight;
                viewport = new $1d528cc0e08a0656$var$Viewport(map.lineAt(topPos - 500, $1d528cc0e08a0656$var$QueryType.ByHeight, oracle, 0, 0).from, map.lineAt(topPos + viewHeight + 500, $1d528cc0e08a0656$var$QueryType.ByHeight, oracle, 0, 0).to);
            }
        }
        return viewport;
    }
    mapViewport(viewport, changes) {
        let from = changes.mapPos(viewport.from, -1), to = changes.mapPos(viewport.to, 1);
        return new $1d528cc0e08a0656$var$Viewport(this.heightMap.lineAt(from, $1d528cc0e08a0656$var$QueryType.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(to, $1d528cc0e08a0656$var$QueryType.ByPos, this.heightOracle, 0, 0).to);
    }
    // Checks if a given viewport covers the visible part of the
    // document and not too much beyond that.
    viewportIsAppropriate({ from: from, to: to }, bias = 0) {
        if (!this.inView) return true;
        let { top: top } = this.heightMap.lineAt(from, $1d528cc0e08a0656$var$QueryType.ByPos, this.heightOracle, 0, 0);
        let { bottom: bottom } = this.heightMap.lineAt(to, $1d528cc0e08a0656$var$QueryType.ByPos, this.heightOracle, 0, 0);
        let { visibleTop: visibleTop, visibleBottom: visibleBottom } = this;
        return (from == 0 || top <= visibleTop - Math.max(10 /* VP.MinCoverMargin */ , Math.min(-bias, 250 /* VP.MaxCoverMargin */ ))) && (to == this.state.doc.length || bottom >= visibleBottom + Math.max(10 /* VP.MinCoverMargin */ , Math.min(bias, 250 /* VP.MaxCoverMargin */ ))) && top > visibleTop - 2000 /* VP.Margin */  && bottom < visibleBottom + 2000 /* VP.Margin */ ;
    }
    mapLineGaps(gaps, changes) {
        if (!gaps.length || changes.empty) return gaps;
        let mapped = [];
        for (let gap of gaps)if (!changes.touchesRange(gap.from, gap.to)) mapped.push(new $1d528cc0e08a0656$var$LineGap(changes.mapPos(gap.from), changes.mapPos(gap.to), gap.size, gap.displaySize));
        return mapped;
    }
    // Computes positions in the viewport where the start or end of a
    // line should be hidden, trying to reuse existing line gaps when
    // appropriate to avoid unneccesary redraws.
    // Uses crude character-counting for the positioning and sizing,
    // since actual DOM coordinates aren't always available and
    // predictable. Relies on generous margins (see LG.Margin) to hide
    // the artifacts this might produce from the user.
    ensureLineGaps(current, mayMeasure) {
        let wrapping = this.heightOracle.lineWrapping;
        let margin = wrapping ? 10000 /* LG.MarginWrap */  : 2000 /* LG.Margin */ , halfMargin = margin >> 1, doubleMargin = margin << 1;
        // The non-wrapping logic won't work at all in predominantly right-to-left text.
        if (this.defaultTextDirection != $1d528cc0e08a0656$export$cacd6541cfeeb6c1.LTR && !wrapping) return [];
        let gaps = [];
        let addGap = (from, to, line, structure)=>{
            if (to - from < halfMargin) return;
            let sel = this.state.selection.main, avoid = [
                sel.from
            ];
            if (!sel.empty) avoid.push(sel.to);
            for (let pos of avoid)if (pos > from && pos < to) {
                addGap(from, pos - 10 /* LG.SelectionMargin */ , line, structure);
                addGap(pos + 10 /* LG.SelectionMargin */ , to, line, structure);
                return;
            }
            let gap = $1d528cc0e08a0656$var$find(current, (gap)=>gap.from >= line.from && gap.to <= line.to && Math.abs(gap.from - from) < halfMargin && Math.abs(gap.to - to) < halfMargin && !avoid.some((pos)=>gap.from < pos && gap.to > pos));
            if (!gap) {
                // When scrolling down, snap gap ends to line starts to avoid shifts in wrapping
                if (to < line.to && mayMeasure && wrapping && mayMeasure.visibleRanges.some((r)=>r.from <= to && r.to >= to)) {
                    let lineStart = mayMeasure.moveToLineBoundary((0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(to), false, true).head;
                    if (lineStart > from) to = lineStart;
                }
                let size = this.gapSize(line, from, to, structure);
                let displaySize = wrapping || size < 2000000 /* VP.MaxHorizGap */  ? size : 2000000 /* VP.MaxHorizGap */ ;
                gap = new $1d528cc0e08a0656$var$LineGap(from, to, size, displaySize);
            }
            gaps.push(gap);
        };
        let checkLine = (line)=>{
            if (line.length < doubleMargin || line.type != $1d528cc0e08a0656$export$48808c686fe495c4.Text) return;
            let structure = $1d528cc0e08a0656$var$lineStructure(line.from, line.to, this.stateDeco);
            if (structure.total < doubleMargin) return;
            let target = this.scrollTarget ? this.scrollTarget.range.head : null;
            let viewFrom, viewTo;
            if (wrapping) {
                let marginHeight = margin / this.heightOracle.lineLength * this.heightOracle.lineHeight;
                let top, bot;
                if (target != null) {
                    let targetFrac = $1d528cc0e08a0656$var$findFraction(structure, target);
                    let spaceFrac = ((this.visibleBottom - this.visibleTop) / 2 + marginHeight) / line.height;
                    top = targetFrac - spaceFrac;
                    bot = targetFrac + spaceFrac;
                } else {
                    top = (this.visibleTop - line.top - marginHeight) / line.height;
                    bot = (this.visibleBottom - line.top + marginHeight) / line.height;
                }
                viewFrom = $1d528cc0e08a0656$var$findPosition(structure, top);
                viewTo = $1d528cc0e08a0656$var$findPosition(structure, bot);
            } else {
                let totalWidth = structure.total * this.heightOracle.charWidth;
                let marginWidth = margin * this.heightOracle.charWidth;
                let horizOffset = 0;
                if (totalWidth > 2000000 /* VP.MaxHorizGap */ ) {
                    for (let old of current)if (old.from >= line.from && old.from < line.to && old.size != old.displaySize && old.from * this.heightOracle.charWidth + horizOffset < this.pixelViewport.left) horizOffset = old.size - old.displaySize;
                }
                let pxLeft = this.pixelViewport.left + horizOffset, pxRight = this.pixelViewport.right + horizOffset;
                let left, right;
                if (target != null) {
                    let targetFrac = $1d528cc0e08a0656$var$findFraction(structure, target);
                    let spaceFrac = ((pxRight - pxLeft) / 2 + marginWidth) / totalWidth;
                    left = targetFrac - spaceFrac;
                    right = targetFrac + spaceFrac;
                } else {
                    left = (pxLeft - marginWidth) / totalWidth;
                    right = (pxRight + marginWidth) / totalWidth;
                }
                viewFrom = $1d528cc0e08a0656$var$findPosition(structure, left);
                viewTo = $1d528cc0e08a0656$var$findPosition(structure, right);
            }
            if (viewFrom > line.from) addGap(line.from, viewFrom, line, structure);
            if (viewTo < line.to) addGap(viewTo, line.to, line, structure);
        };
        for (let line of this.viewportLines)if (Array.isArray(line.type)) line.type.forEach(checkLine);
        else checkLine(line);
        return gaps;
    }
    gapSize(line, from, to, structure) {
        let fraction = $1d528cc0e08a0656$var$findFraction(structure, to) - $1d528cc0e08a0656$var$findFraction(structure, from);
        if (this.heightOracle.lineWrapping) return line.height * fraction;
        else return structure.total * this.heightOracle.charWidth * fraction;
    }
    updateLineGaps(gaps) {
        if (!$1d528cc0e08a0656$var$LineGap.same(gaps, this.lineGaps)) {
            this.lineGaps = gaps;
            this.lineGapDeco = $1d528cc0e08a0656$export$10e30b733df217ea.set(gaps.map((gap)=>gap.draw(this, this.heightOracle.lineWrapping)));
        }
    }
    computeVisibleRanges(changes) {
        let deco = this.stateDeco;
        if (this.lineGaps.length) deco = deco.concat(this.lineGapDeco);
        let ranges = [];
        (0, $6b8f387faea0a4dd$export$34cb5241245008dd).spans(deco, this.viewport.from, this.viewport.to, {
            span (from, to) {
                ranges.push({
                    from: from,
                    to: to
                });
            },
            point () {}
        }, 20);
        let changed = 0;
        if (ranges.length != this.visibleRanges.length) changed = 12 /* UpdateFlag.Viewport */ ;
        else for(let i = 0; i < ranges.length && !(changed & 8 /* UpdateFlag.ViewportMoved */ ); i++){
            let old = this.visibleRanges[i], nw = ranges[i];
            if (old.from != nw.from || old.to != nw.to) {
                changed |= 4 /* UpdateFlag.Viewport */ ;
                if (!(changes && changes.mapPos(old.from, -1) == nw.from && changes.mapPos(old.to, 1) == nw.to)) changed |= 8 /* UpdateFlag.ViewportMoved */ ;
            }
        }
        this.visibleRanges = ranges;
        return changed;
    }
    lineBlockAt(pos) {
        return pos >= this.viewport.from && pos <= this.viewport.to && this.viewportLines.find((b)=>b.from <= pos && b.to >= pos) || $1d528cc0e08a0656$var$scaleBlock(this.heightMap.lineAt(pos, $1d528cc0e08a0656$var$QueryType.ByPos, this.heightOracle, 0, 0), this.scaler);
    }
    lineBlockAtHeight(height) {
        return height >= this.viewportLines[0].top && height <= this.viewportLines[this.viewportLines.length - 1].bottom && this.viewportLines.find((l)=>l.top <= height && l.bottom >= height) || $1d528cc0e08a0656$var$scaleBlock(this.heightMap.lineAt(this.scaler.fromDOM(height), $1d528cc0e08a0656$var$QueryType.ByHeight, this.heightOracle, 0, 0), this.scaler);
    }
    scrollAnchorAt(scrollTop) {
        let block = this.lineBlockAtHeight(scrollTop + 8);
        return block.from >= this.viewport.from || this.viewportLines[0].top - scrollTop > 200 ? block : this.viewportLines[0];
    }
    elementAtHeight(height) {
        return $1d528cc0e08a0656$var$scaleBlock(this.heightMap.blockAt(this.scaler.fromDOM(height), this.heightOracle, 0, 0), this.scaler);
    }
    get docHeight() {
        return this.scaler.toDOM(this.heightMap.height);
    }
    get contentHeight() {
        return this.docHeight + this.paddingTop + this.paddingBottom;
    }
}
class $1d528cc0e08a0656$var$Viewport {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
function $1d528cc0e08a0656$var$lineStructure(from, to, stateDeco) {
    let ranges = [], pos = from, total = 0;
    (0, $6b8f387faea0a4dd$export$34cb5241245008dd).spans(stateDeco, from, to, {
        span () {},
        point (from, to) {
            if (from > pos) {
                ranges.push({
                    from: pos,
                    to: from
                });
                total += from - pos;
            }
            pos = to;
        }
    }, 20); // We're only interested in collapsed ranges of a significant size
    if (pos < to) {
        ranges.push({
            from: pos,
            to: to
        });
        total += to - pos;
    }
    return {
        total: total,
        ranges: ranges
    };
}
function $1d528cc0e08a0656$var$findPosition({ total: total, ranges: ranges }, ratio) {
    if (ratio <= 0) return ranges[0].from;
    if (ratio >= 1) return ranges[ranges.length - 1].to;
    let dist = Math.floor(total * ratio);
    for(let i = 0;; i++){
        let { from: from, to: to } = ranges[i], size = to - from;
        if (dist <= size) return from + dist;
        dist -= size;
    }
}
function $1d528cc0e08a0656$var$findFraction(structure, pos) {
    let counted = 0;
    for (let { from: from, to: to } of structure.ranges){
        if (pos <= to) {
            counted += pos - from;
            break;
        }
        counted += to - from;
    }
    return counted / structure.total;
}
function $1d528cc0e08a0656$var$find(array, f) {
    for (let val of array)if (f(val)) return val;
    return undefined;
}
// Don't scale when the document height is within the range of what
// the DOM can handle.
const $1d528cc0e08a0656$var$IdScaler = {
    toDOM (n) {
        return n;
    },
    fromDOM (n) {
        return n;
    },
    scale: 1,
    eq (other) {
        return other == this;
    }
};
// When the height is too big (> VP.MaxDOMHeight), scale down the
// regions outside the viewports so that the total height is
// VP.MaxDOMHeight.
class $1d528cc0e08a0656$var$BigScaler {
    constructor(oracle, heightMap, viewports){
        let vpHeight = 0, base = 0, domBase = 0;
        this.viewports = viewports.map(({ from: from, to: to })=>{
            let top = heightMap.lineAt(from, $1d528cc0e08a0656$var$QueryType.ByPos, oracle, 0, 0).top;
            let bottom = heightMap.lineAt(to, $1d528cc0e08a0656$var$QueryType.ByPos, oracle, 0, 0).bottom;
            vpHeight += bottom - top;
            return {
                from: from,
                to: to,
                top: top,
                bottom: bottom,
                domTop: 0,
                domBottom: 0
            };
        });
        this.scale = (7000000 /* VP.MaxDOMHeight */  - vpHeight) / (heightMap.height - vpHeight);
        for (let obj of this.viewports){
            obj.domTop = domBase + (obj.top - base) * this.scale;
            domBase = obj.domBottom = obj.domTop + (obj.bottom - obj.top);
            base = obj.bottom;
        }
    }
    toDOM(n) {
        for(let i = 0, base = 0, domBase = 0;; i++){
            let vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.top) return domBase + (n - base) * this.scale;
            if (n <= vp.bottom) return vp.domTop + (n - vp.top);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
    fromDOM(n) {
        for(let i = 0, base = 0, domBase = 0;; i++){
            let vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.domTop) return base + (n - domBase) / this.scale;
            if (n <= vp.domBottom) return vp.top + (n - vp.domTop);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
    eq(other) {
        if (!(other instanceof $1d528cc0e08a0656$var$BigScaler)) return false;
        return this.scale == other.scale && this.viewports.length == other.viewports.length && this.viewports.every((vp, i)=>vp.from == other.viewports[i].from && vp.to == other.viewports[i].to);
    }
}
function $1d528cc0e08a0656$var$scaleBlock(block, scaler) {
    if (scaler.scale == 1) return block;
    let bTop = scaler.toDOM(block.top), bBottom = scaler.toDOM(block.bottom);
    return new $1d528cc0e08a0656$export$ddfdc4ccfe9512bd(block.from, block.length, bTop, bBottom - bTop, Array.isArray(block._content) ? block._content.map((b)=>$1d528cc0e08a0656$var$scaleBlock(b, scaler)) : block._content);
}
const $1d528cc0e08a0656$var$theme = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine: (strs)=>strs.join(" ")
});
const $1d528cc0e08a0656$var$darkTheme = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.indexOf(true) > -1
});
const $1d528cc0e08a0656$var$baseThemeID = /*@__PURE__*/ (0, $efbdc34cfdde3fb8$export$b920c662d2efee20).newName(), $1d528cc0e08a0656$var$baseLightID = /*@__PURE__*/ (0, $efbdc34cfdde3fb8$export$b920c662d2efee20).newName(), $1d528cc0e08a0656$var$baseDarkID = /*@__PURE__*/ (0, $efbdc34cfdde3fb8$export$b920c662d2efee20).newName();
const $1d528cc0e08a0656$var$lightDarkIDs = {
    "&light": "." + $1d528cc0e08a0656$var$baseLightID,
    "&dark": "." + $1d528cc0e08a0656$var$baseDarkID
};
function $1d528cc0e08a0656$var$buildTheme(main, spec, scopes) {
    return new (0, $efbdc34cfdde3fb8$export$b920c662d2efee20)(spec, {
        finish (sel) {
            return /&/.test(sel) ? sel.replace(/&\w*/, (m)=>{
                if (m == "&") return main;
                if (!scopes || !scopes[m]) throw new RangeError(`Unsupported selector: ${m}`);
                return scopes[m];
            }) : main + " " + sel;
        }
    });
}
const $1d528cc0e08a0656$var$baseTheme$1 = /*@__PURE__*/ $1d528cc0e08a0656$var$buildTheme("." + $1d528cc0e08a0656$var$baseThemeID, {
    "&": {
        position: "relative !important",
        boxSizing: "border-box",
        "&.cm-focused": {
            // Provide a simple default outline to make sure a focused
            // editor is visually distinct. Can't leave the default behavior
            // because that will apply to the content element, which is
            // inside the scrollable container and doesn't include the
            // gutters. We also can't use an 'auto' outline, since those
            // are, for some reason, drawn behind the element content, which
            // will cause things like the active line background to cover
            // the outline (#297).
            outline: "1px dotted #212121"
        },
        display: "flex !important",
        flexDirection: "column"
    },
    ".cm-scroller": {
        display: "flex !important",
        alignItems: "flex-start !important",
        fontFamily: "monospace",
        lineHeight: 1.4,
        height: "100%",
        overflowX: "auto",
        position: "relative",
        zIndex: 0,
        overflowAnchor: "none"
    },
    ".cm-content": {
        margin: 0,
        flexGrow: 2,
        flexShrink: 0,
        display: "block",
        whiteSpace: "pre",
        wordWrap: "normal",
        boxSizing: "border-box",
        minHeight: "100%",
        padding: "4px 0",
        outline: "none",
        "&[contenteditable=true]": {
            WebkitUserModify: "read-write-plaintext-only"
        }
    },
    ".cm-lineWrapping": {
        whiteSpace_fallback: "pre-wrap",
        whiteSpace: "break-spaces",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        flexShrink: 1
    },
    "&light .cm-content": {
        caretColor: "black"
    },
    "&dark .cm-content": {
        caretColor: "white"
    },
    ".cm-line": {
        display: "block",
        padding: "0 2px 0 6px"
    },
    ".cm-layer": {
        position: "absolute",
        left: 0,
        top: 0,
        contain: "size style",
        "& > *": {
            position: "absolute"
        }
    },
    "&light .cm-selectionBackground": {
        background: "#d9d9d9"
    },
    "&dark .cm-selectionBackground": {
        background: "#222"
    },
    "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#d7d4f0"
    },
    "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#233"
    },
    ".cm-cursorLayer": {
        pointerEvents: "none"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
        animation: "steps(1) cm-blink 1.2s infinite"
    },
    // Two animations defined so that we can switch between them to
    // restart the animation without forcing another style
    // recomputation.
    "@keyframes cm-blink": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    "@keyframes cm-blink2": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    ".cm-cursor, .cm-dropCursor": {
        borderLeft: "1.2px solid black",
        marginLeft: "-0.6px",
        pointerEvents: "none"
    },
    ".cm-cursor": {
        display: "none"
    },
    "&dark .cm-cursor": {
        borderLeftColor: "#ddd"
    },
    ".cm-dropCursor": {
        position: "absolute"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
        display: "block"
    },
    ".cm-iso": {
        unicodeBidi: "isolate"
    },
    ".cm-announced": {
        position: "fixed",
        top: "-10000px"
    },
    "@media print": {
        ".cm-announced": {
            display: "none"
        }
    },
    "&light .cm-activeLine": {
        backgroundColor: "#cceeff44"
    },
    "&dark .cm-activeLine": {
        backgroundColor: "#99eeff33"
    },
    "&light .cm-specialChar": {
        color: "red"
    },
    "&dark .cm-specialChar": {
        color: "#f78"
    },
    ".cm-gutters": {
        flexShrink: 0,
        display: "flex",
        height: "100%",
        boxSizing: "border-box",
        zIndex: 200
    },
    ".cm-gutters-before": {
        insetInlineStart: 0
    },
    ".cm-gutters-after": {
        insetInlineEnd: 0
    },
    "&light .cm-gutters": {
        backgroundColor: "#f5f5f5",
        color: "#6c6c6c",
        border: "0px solid #ddd",
        "&.cm-gutters-before": {
            borderRightWidth: "1px"
        },
        "&.cm-gutters-after": {
            borderLeftWidth: "1px"
        }
    },
    "&dark .cm-gutters": {
        backgroundColor: "#333338",
        color: "#ccc"
    },
    ".cm-gutter": {
        display: "flex !important",
        flexDirection: "column",
        flexShrink: 0,
        boxSizing: "border-box",
        minHeight: "100%",
        overflow: "hidden"
    },
    ".cm-gutterElement": {
        boxSizing: "border-box"
    },
    ".cm-lineNumbers .cm-gutterElement": {
        padding: "0 3px 0 5px",
        minWidth: "20px",
        textAlign: "right",
        whiteSpace: "nowrap"
    },
    "&light .cm-activeLineGutter": {
        backgroundColor: "#e2f2ff"
    },
    "&dark .cm-activeLineGutter": {
        backgroundColor: "#222227"
    },
    ".cm-panels": {
        boxSizing: "border-box",
        position: "sticky",
        left: 0,
        right: 0,
        zIndex: 300
    },
    "&light .cm-panels": {
        backgroundColor: "#f5f5f5",
        color: "black"
    },
    "&light .cm-panels-top": {
        borderBottom: "1px solid #ddd"
    },
    "&light .cm-panels-bottom": {
        borderTop: "1px solid #ddd"
    },
    "&dark .cm-panels": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-dialog": {
        padding: "2px 19px 4px 6px",
        position: "relative",
        "& label": {
            fontSize: "80%"
        }
    },
    ".cm-dialog-close": {
        position: "absolute",
        top: "3px",
        right: "4px",
        backgroundColor: "inherit",
        border: "none",
        font: "inherit",
        fontSize: "14px",
        padding: "0"
    },
    ".cm-tab": {
        display: "inline-block",
        overflow: "hidden",
        verticalAlign: "bottom"
    },
    ".cm-widgetBuffer": {
        verticalAlign: "text-top",
        height: "1em",
        width: 0,
        display: "inline"
    },
    ".cm-placeholder": {
        color: "#888",
        display: "inline-block",
        verticalAlign: "top",
        userSelect: "none"
    },
    ".cm-highlightSpace": {
        backgroundImage: "radial-gradient(circle at 50% 55%, #aaa 20%, transparent 5%)",
        backgroundPosition: "center"
    },
    ".cm-highlightTab": {
        backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
        backgroundSize: "auto 100%",
        backgroundPosition: "right 90%",
        backgroundRepeat: "no-repeat"
    },
    ".cm-trailingSpace": {
        backgroundColor: "#ff332255"
    },
    ".cm-button": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        padding: ".2em 1em",
        borderRadius: "1px"
    },
    "&light .cm-button": {
        backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
        }
    },
    "&dark .cm-button": {
        backgroundImage: "linear-gradient(#393939, #111)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#111, #333)"
        }
    },
    ".cm-textfield": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        border: "1px solid silver",
        padding: ".2em .5em"
    },
    "&light .cm-textfield": {
        backgroundColor: "white"
    },
    "&dark .cm-textfield": {
        border: "1px solid #555",
        backgroundColor: "inherit"
    }
}, $1d528cc0e08a0656$var$lightDarkIDs);
const $1d528cc0e08a0656$var$observeOptions = {
    childList: true,
    characterData: true,
    subtree: true,
    attributes: true,
    characterDataOldValue: true
};
// IE11 has very broken mutation observers, so we also listen to
// DOMCharacterDataModified there
const $1d528cc0e08a0656$var$useCharData = $1d528cc0e08a0656$var$browser.ie && $1d528cc0e08a0656$var$browser.ie_version <= 11;
class $1d528cc0e08a0656$var$DOMObserver {
    constructor(view){
        this.view = view;
        this.active = false;
        this.editContext = null;
        // The known selection. Kept in our own object, as opposed to just
        // directly accessing the selection because:
        //  - Safari doesn't report the right selection in shadow DOM
        //  - Reading from the selection forces a DOM layout
        //  - This way, we can ignore selectionchange events if we have
        //    already seen the 'new' selection
        this.selectionRange = new $1d528cc0e08a0656$var$DOMSelectionState;
        // Set when a selection change is detected, cleared on flush
        this.selectionChanged = false;
        this.delayedFlush = -1;
        this.resizeTimeout = -1;
        this.queue = [];
        this.delayedAndroidKey = null;
        this.flushingAndroidKey = -1;
        this.lastChange = 0;
        this.scrollTargets = [];
        this.intersection = null;
        this.resizeScroll = null;
        this.intersecting = false;
        this.gapIntersection = null;
        this.gaps = [];
        this.printQuery = null;
        // Timeout for scheduling check of the parents that need scroll handlers
        this.parentCheck = -1;
        this.dom = view.contentDOM;
        this.observer = new MutationObserver((mutations)=>{
            for (let mut of mutations)this.queue.push(mut);
            // IE11 will sometimes (on typing over a selection or
            // backspacing out a single character text node) call the
            // observer callback before actually updating the DOM.
            //
            // Unrelatedly, iOS Safari will, when ending a composition,
            // sometimes first clear it, deliver the mutations, and then
            // reinsert the finished text. CodeMirror's handling of the
            // deletion will prevent the reinsertion from happening,
            // breaking composition.
            if (($1d528cc0e08a0656$var$browser.ie && $1d528cc0e08a0656$var$browser.ie_version <= 11 || $1d528cc0e08a0656$var$browser.ios && view.composing) && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if (window.EditContext && $1d528cc0e08a0656$var$browser.android && view.constructor.EDIT_CONTEXT !== false && // Chrome <126 doesn't support inverted selections in edit context (#1392)
        !($1d528cc0e08a0656$var$browser.chrome && $1d528cc0e08a0656$var$browser.chrome_version < 126)) {
            this.editContext = new $1d528cc0e08a0656$var$EditContextManager(view);
            if (view.state.facet($1d528cc0e08a0656$var$editable)) view.contentDOM.editContext = this.editContext.editContext;
        }
        if ($1d528cc0e08a0656$var$useCharData) this.onCharData = (event)=>{
            this.queue.push({
                target: event.target,
                type: "characterData",
                oldValue: event.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPrint = this.onPrint.bind(this);
        this.onScroll = this.onScroll.bind(this);
        if (window.matchMedia) this.printQuery = window.matchMedia("print");
        if (typeof ResizeObserver == "function") {
            this.resizeScroll = new ResizeObserver(()=>{
                var _a;
                if (((_a = this.view.docView) === null || _a === void 0 ? void 0 : _a.lastUpdate) < Date.now() - 75) this.onResize();
            });
            this.resizeScroll.observe(view.scrollDOM);
        }
        this.addWindowListeners(this.win = view.win);
        this.start();
        if (typeof IntersectionObserver == "function") {
            this.intersection = new IntersectionObserver((entries)=>{
                if (this.parentCheck < 0) this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1000);
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0 != this.intersecting) {
                    this.intersecting = !this.intersecting;
                    if (this.intersecting != this.view.inView) this.onScrollChanged(document.createEvent("Event"));
                }
            }, {
                threshold: [
                    0,
                    .001
                ]
            });
            this.intersection.observe(this.dom);
            this.gapIntersection = new IntersectionObserver((entries)=>{
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0) this.onScrollChanged(document.createEvent("Event"));
            }, {});
        }
        this.listenForScroll();
        this.readSelectionRange();
    }
    onScrollChanged(e) {
        this.view.inputState.runHandlers("scroll", e);
        if (this.intersecting) this.view.measure();
    }
    onScroll(e) {
        if (this.intersecting) this.flush(false);
        if (this.editContext) this.view.requestMeasure(this.editContext.measureReq);
        this.onScrollChanged(e);
    }
    onResize() {
        if (this.resizeTimeout < 0) this.resizeTimeout = setTimeout(()=>{
            this.resizeTimeout = -1;
            this.view.requestMeasure();
        }, 50);
    }
    onPrint(event) {
        if ((event.type == "change" || !event.type) && !event.matches) return;
        this.view.viewState.printing = true;
        this.view.measure();
        setTimeout(()=>{
            this.view.viewState.printing = false;
            this.view.requestMeasure();
        }, 500);
    }
    updateGaps(gaps) {
        if (this.gapIntersection && (gaps.length != this.gaps.length || this.gaps.some((g, i)=>g != gaps[i]))) {
            this.gapIntersection.disconnect();
            for (let gap of gaps)this.gapIntersection.observe(gap);
            this.gaps = gaps;
        }
    }
    onSelectionChange(event) {
        let wasChanged = this.selectionChanged;
        if (!this.readSelectionRange() || this.delayedAndroidKey) return;
        let { view: view } = this, sel = this.selectionRange;
        if (view.state.facet($1d528cc0e08a0656$var$editable) ? view.root.activeElement != this.dom : !$1d528cc0e08a0656$var$hasSelection(this.dom, sel)) return;
        let context = sel.anchorNode && view.docView.nearest(sel.anchorNode);
        if (context && context.ignoreEvent(event)) {
            if (!wasChanged) this.selectionChanged = false;
            return;
        }
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        // Chrome Android has a similar issue when backspacing out a
        // selection (#645).
        if (($1d528cc0e08a0656$var$browser.ie && $1d528cc0e08a0656$var$browser.ie_version <= 11 || $1d528cc0e08a0656$var$browser.android && $1d528cc0e08a0656$var$browser.chrome) && !view.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
        sel.focusNode && $1d528cc0e08a0656$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) this.flushSoon();
        else this.flush(false);
    }
    readSelectionRange() {
        let { view: view } = this;
        // The Selection object is broken in shadow roots in Safari. See
        // https://github.com/codemirror/dev/issues/414
        let selection = $1d528cc0e08a0656$var$getSelection(view.root);
        if (!selection) return false;
        let range = $1d528cc0e08a0656$var$browser.safari && view.root.nodeType == 11 && view.root.activeElement == this.dom && $1d528cc0e08a0656$var$safariSelectionRangeHack(this.view, selection) || selection;
        if (!range || this.selectionRange.eq(range)) return false;
        let local = $1d528cc0e08a0656$var$hasSelection(this.dom, range);
        // Detect the situation where the browser has, on focus, moved the
        // selection to the start of the content element. Reset it to the
        // position from the editor state.
        if (local && !this.selectionChanged && view.inputState.lastFocusTime > Date.now() - 200 && view.inputState.lastTouchTime < Date.now() - 300 && $1d528cc0e08a0656$var$atElementStart(this.dom, range)) {
            this.view.inputState.lastFocusTime = 0;
            view.docView.updateSelection();
            return false;
        }
        this.selectionRange.setRange(range);
        if (local) this.selectionChanged = true;
        return true;
    }
    setSelectionRange(anchor, head) {
        this.selectionRange.set(anchor.node, anchor.offset, head.node, head.offset);
        this.selectionChanged = false;
    }
    clearSelectionRange() {
        this.selectionRange.set(null, 0, null, 0);
    }
    listenForScroll() {
        this.parentCheck = -1;
        let i = 0, changed = null;
        for(let dom = this.dom; dom;){
            if (dom.nodeType == 1) {
                if (!changed && i < this.scrollTargets.length && this.scrollTargets[i] == dom) i++;
                else if (!changed) changed = this.scrollTargets.slice(0, i);
                if (changed) changed.push(dom);
                dom = dom.assignedSlot || dom.parentNode;
            } else if (dom.nodeType == 11) dom = dom.host;
            else break;
        }
        if (i < this.scrollTargets.length && !changed) changed = this.scrollTargets.slice(0, i);
        if (changed) {
            for (let dom of this.scrollTargets)dom.removeEventListener("scroll", this.onScroll);
            for (let dom of this.scrollTargets = changed)dom.addEventListener("scroll", this.onScroll);
        }
    }
    ignore(f) {
        if (!this.active) return f();
        try {
            this.stop();
            return f();
        } finally{
            this.start();
            this.clear();
        }
    }
    start() {
        if (this.active) return;
        this.observer.observe(this.dom, $1d528cc0e08a0656$var$observeOptions);
        if ($1d528cc0e08a0656$var$useCharData) this.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.active = true;
    }
    stop() {
        if (!this.active) return;
        this.active = false;
        this.observer.disconnect();
        if ($1d528cc0e08a0656$var$useCharData) this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
    }
    // Throw away any pending changes
    clear() {
        this.processRecords();
        this.queue.length = 0;
        this.selectionChanged = false;
    }
    // Chrome Android, especially in combination with GBoard, not only
    // doesn't reliably fire regular key events, but also often
    // surrounds the effect of enter or backspace with a bunch of
    // composition events that, when interrupted, cause text duplication
    // or other kinds of corruption. This hack makes the editor back off
    // from handling DOM changes for a moment when such a key is
    // detected (via beforeinput or keydown), and then tries to flush
    // them or, if that has no effect, dispatches the given key.
    delayAndroidKey(key, keyCode) {
        var _a;
        if (!this.delayedAndroidKey) {
            let flush = ()=>{
                let key = this.delayedAndroidKey;
                if (key) {
                    this.clearDelayedAndroidKey();
                    this.view.inputState.lastKeyCode = key.keyCode;
                    this.view.inputState.lastKeyTime = Date.now();
                    let flushed = this.flush();
                    if (!flushed && key.force) $1d528cc0e08a0656$var$dispatchKey(this.dom, key.key, key.keyCode);
                }
            };
            this.flushingAndroidKey = this.view.win.requestAnimationFrame(flush);
        }
        // Since backspace beforeinput is sometimes signalled spuriously,
        // Enter always takes precedence.
        if (!this.delayedAndroidKey || key == "Enter") this.delayedAndroidKey = {
            key: key,
            keyCode: keyCode,
            // Only run the key handler when no changes are detected if
            // this isn't coming right after another change, in which case
            // it is probably part of a weird chain of updates, and should
            // be ignored if it returns the DOM to its previous state.
            force: this.lastChange < Date.now() - 50 || !!((_a = this.delayedAndroidKey) === null || _a === void 0 ? void 0 : _a.force)
        };
    }
    clearDelayedAndroidKey() {
        this.win.cancelAnimationFrame(this.flushingAndroidKey);
        this.delayedAndroidKey = null;
        this.flushingAndroidKey = -1;
    }
    flushSoon() {
        if (this.delayedFlush < 0) this.delayedFlush = this.view.win.requestAnimationFrame(()=>{
            this.delayedFlush = -1;
            this.flush();
        });
    }
    forceFlush() {
        if (this.delayedFlush >= 0) {
            this.view.win.cancelAnimationFrame(this.delayedFlush);
            this.delayedFlush = -1;
        }
        this.flush();
    }
    pendingRecords() {
        for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    processRecords() {
        let records = this.pendingRecords();
        if (records.length) this.queue = [];
        let from = -1, to = -1, typeOver = false;
        for (let record of records){
            let range = this.readMutation(record);
            if (!range) continue;
            if (range.typeOver) typeOver = true;
            if (from == -1) ({ from: from, to: to } = range);
            else {
                from = Math.min(range.from, from);
                to = Math.max(range.to, to);
            }
        }
        return {
            from: from,
            to: to,
            typeOver: typeOver
        };
    }
    readChange() {
        let { from: from, to: to, typeOver: typeOver } = this.processRecords();
        let newSel = this.selectionChanged && $1d528cc0e08a0656$var$hasSelection(this.dom, this.selectionRange);
        if (from < 0 && !newSel) return null;
        if (from > -1) this.lastChange = Date.now();
        this.view.inputState.lastFocusTime = 0;
        this.selectionChanged = false;
        let change = new $1d528cc0e08a0656$var$DOMChange(this.view, from, to, typeOver);
        this.view.docView.domChanged = {
            newSel: change.newSel ? change.newSel.main : null
        };
        return change;
    }
    // Apply pending changes, if any
    flush(readSelection = true) {
        // Completely hold off flushing when pending keys are set—the code
        // managing those will make sure processRecords is called and the
        // view is resynchronized after
        if (this.delayedFlush >= 0 || this.delayedAndroidKey) return false;
        if (readSelection) this.readSelectionRange();
        let domChange = this.readChange();
        if (!domChange) {
            this.view.requestMeasure();
            return false;
        }
        let startState = this.view.state;
        let handled = $1d528cc0e08a0656$var$applyDOMChange(this.view, domChange);
        // The view wasn't updated but DOM/selection changes were seen. Reset the view.
        if (this.view.state == startState && (domChange.domChanged || domChange.newSel && !domChange.newSel.main.eq(this.view.state.selection.main))) this.view.update([]);
        return handled;
    }
    readMutation(rec) {
        let cView = this.view.docView.nearest(rec.target);
        if (!cView || cView.ignoreMutation(rec)) return null;
        cView.markDirty(rec.type == "attributes");
        if (rec.type == "attributes") cView.flags |= 4 /* ViewFlag.AttrsDirty */ ;
        if (rec.type == "childList") {
            let childBefore = $1d528cc0e08a0656$var$findChild(cView, rec.previousSibling || rec.target.previousSibling, -1);
            let childAfter = $1d528cc0e08a0656$var$findChild(cView, rec.nextSibling || rec.target.nextSibling, 1);
            return {
                from: childBefore ? cView.posAfter(childBefore) : cView.posAtStart,
                to: childAfter ? cView.posBefore(childAfter) : cView.posAtEnd,
                typeOver: false
            };
        } else if (rec.type == "characterData") return {
            from: cView.posAtStart,
            to: cView.posAtEnd,
            typeOver: rec.target.nodeValue == rec.oldValue
        };
        else return null;
    }
    setWindow(win) {
        if (win != this.win) {
            this.removeWindowListeners(this.win);
            this.win = win;
            this.addWindowListeners(this.win);
        }
    }
    addWindowListeners(win) {
        win.addEventListener("resize", this.onResize);
        if (this.printQuery) {
            if (this.printQuery.addEventListener) this.printQuery.addEventListener("change", this.onPrint);
            else this.printQuery.addListener(this.onPrint);
        } else win.addEventListener("beforeprint", this.onPrint);
        win.addEventListener("scroll", this.onScroll);
        win.document.addEventListener("selectionchange", this.onSelectionChange);
    }
    removeWindowListeners(win) {
        win.removeEventListener("scroll", this.onScroll);
        win.removeEventListener("resize", this.onResize);
        if (this.printQuery) {
            if (this.printQuery.removeEventListener) this.printQuery.removeEventListener("change", this.onPrint);
            else this.printQuery.removeListener(this.onPrint);
        } else win.removeEventListener("beforeprint", this.onPrint);
        win.document.removeEventListener("selectionchange", this.onSelectionChange);
    }
    update(update) {
        if (this.editContext) {
            this.editContext.update(update);
            if (update.startState.facet($1d528cc0e08a0656$var$editable) != update.state.facet($1d528cc0e08a0656$var$editable)) update.view.contentDOM.editContext = update.state.facet($1d528cc0e08a0656$var$editable) ? this.editContext.editContext : null;
        }
    }
    destroy() {
        var _a, _b, _c;
        this.stop();
        (_a = this.intersection) === null || _a === void 0 || _a.disconnect();
        (_b = this.gapIntersection) === null || _b === void 0 || _b.disconnect();
        (_c = this.resizeScroll) === null || _c === void 0 || _c.disconnect();
        for (let dom of this.scrollTargets)dom.removeEventListener("scroll", this.onScroll);
        this.removeWindowListeners(this.win);
        clearTimeout(this.parentCheck);
        clearTimeout(this.resizeTimeout);
        this.win.cancelAnimationFrame(this.delayedFlush);
        this.win.cancelAnimationFrame(this.flushingAndroidKey);
        if (this.editContext) {
            this.view.contentDOM.editContext = null;
            this.editContext.destroy();
        }
    }
}
function $1d528cc0e08a0656$var$findChild(cView, dom, dir) {
    while(dom){
        let curView = $1d528cc0e08a0656$var$ContentView.get(dom);
        if (curView && curView.parent == cView) return curView;
        let parent = dom.parentNode;
        dom = parent != cView.dom ? parent : dir > 0 ? dom.nextSibling : dom.previousSibling;
    }
    return null;
}
function $1d528cc0e08a0656$var$buildSelectionRangeFromRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let curAnchor = view.docView.domAtPos(view.state.selection.main.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($1d528cc0e08a0656$var$isEquivalentPosition(curAnchor.node, curAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug (#414)
function $1d528cc0e08a0656$var$safariSelectionRangeHack(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $1d528cc0e08a0656$var$buildSelectionRangeFromRange(view, range);
    }
    let found = null;
    // Because Safari (at least in 2018-2021) doesn't provide regular
    // access to the selection inside a shadowroot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    view.contentDOM.addEventListener("beforeinput", read, true);
    view.dom.ownerDocument.execCommand("indent");
    view.contentDOM.removeEventListener("beforeinput", read, true);
    return found ? $1d528cc0e08a0656$var$buildSelectionRangeFromRange(view, found) : null;
}
class $1d528cc0e08a0656$var$EditContextManager {
    constructor(view){
        // The document window for which the text in the context is
        // maintained. For large documents, this may be smaller than the
        // editor document. This window always includes the selection head.
        this.from = 0;
        this.to = 0;
        // When applying a transaction, this is used to compare the change
        // made to the context content to the change in the transaction in
        // order to make the minimal changes to the context (since touching
        // that sometimes breaks series of multiple edits made for a single
        // user action on some Android keyboards)
        this.pendingContextChange = null;
        this.handlers = Object.create(null);
        // Kludge to work around the fact that EditContext does not respond
        // well to having its content updated during a composition (see #1472)
        this.composing = null;
        this.resetRange(view.state);
        let context = this.editContext = new window.EditContext({
            text: view.state.doc.sliceString(this.from, this.to),
            selectionStart: this.toContextPos(Math.max(this.from, Math.min(this.to, view.state.selection.main.anchor))),
            selectionEnd: this.toContextPos(view.state.selection.main.head)
        });
        this.handlers.textupdate = (e)=>{
            let main = view.state.selection.main, { anchor: anchor, head: head } = main;
            let from = this.toEditorPos(e.updateRangeStart), to = this.toEditorPos(e.updateRangeEnd);
            if (view.inputState.composing >= 0 && !this.composing) this.composing = {
                contextBase: e.updateRangeStart,
                editorBase: from,
                drifted: false
            };
            let change = {
                from: from,
                to: to,
                insert: (0, $6b8f387faea0a4dd$export$5f1af8db9871e1d6).of(e.text.split("\n"))
            };
            // If the window doesn't include the anchor, assume changes
            // adjacent to a side go up to the anchor.
            if (change.from == this.from && anchor < this.from) change.from = anchor;
            else if (change.to == this.to && anchor > this.to) change.to = anchor;
            // Edit contexts sometimes fire empty changes
            if (change.from == change.to && !change.insert.length) {
                let newSel = (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).single(this.toEditorPos(e.selectionStart), this.toEditorPos(e.selectionEnd));
                if (!newSel.main.eq(main)) view.dispatch({
                    selection: newSel,
                    userEvent: "select"
                });
                return;
            }
            if (($1d528cc0e08a0656$var$browser.mac || $1d528cc0e08a0656$var$browser.android) && change.from == head - 1 && /^\. ?$/.test(e.text) && view.contentDOM.getAttribute("autocorrect") == "off") change = {
                from: from,
                to: to,
                insert: (0, $6b8f387faea0a4dd$export$5f1af8db9871e1d6).of([
                    e.text.replace(".", " ")
                ])
            };
            this.pendingContextChange = change;
            if (!view.state.readOnly) {
                let newLen = this.to - this.from + (change.to - change.from + change.insert.length);
                $1d528cc0e08a0656$var$applyDOMChangeInner(view, change, (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).single(this.toEditorPos(e.selectionStart, newLen), this.toEditorPos(e.selectionEnd, newLen)));
            }
            // If the transaction didn't flush our change, revert it so
            // that the context is in sync with the editor state again.
            if (this.pendingContextChange) {
                this.revertPending(view.state);
                this.setSelection(view.state);
            }
        };
        this.handlers.characterboundsupdate = (e)=>{
            let rects = [], prev = null;
            for(let i = this.toEditorPos(e.rangeStart), end = this.toEditorPos(e.rangeEnd); i < end; i++){
                let rect = view.coordsForChar(i);
                prev = rect && new DOMRect(rect.left, rect.top, rect.right - rect.left, rect.bottom - rect.top) || prev || new DOMRect;
                rects.push(prev);
            }
            context.updateCharacterBounds(e.rangeStart, rects);
        };
        this.handlers.textformatupdate = (e)=>{
            let deco = [];
            for (let format of e.getTextFormats()){
                let lineStyle = format.underlineStyle, thickness = format.underlineThickness;
                if (lineStyle != "None" && thickness != "None") {
                    let from = this.toEditorPos(format.rangeStart), to = this.toEditorPos(format.rangeEnd);
                    if (from < to) {
                        let style = `text-decoration: underline ${lineStyle == "Dashed" ? "dashed " : lineStyle == "Squiggle" ? "wavy " : ""}${thickness == "Thin" ? 1 : 2}px`;
                        deco.push($1d528cc0e08a0656$export$10e30b733df217ea.mark({
                            attributes: {
                                style: style
                            }
                        }).range(from, to));
                    }
                }
            }
            view.dispatch({
                effects: $1d528cc0e08a0656$var$setEditContextFormatting.of($1d528cc0e08a0656$export$10e30b733df217ea.set(deco))
            });
        };
        this.handlers.compositionstart = ()=>{
            if (view.inputState.composing < 0) {
                view.inputState.composing = 0;
                view.inputState.compositionFirstChange = true;
            }
        };
        this.handlers.compositionend = ()=>{
            view.inputState.composing = -1;
            view.inputState.compositionFirstChange = null;
            if (this.composing) {
                let { drifted: drifted } = this.composing;
                this.composing = null;
                if (drifted) this.reset(view.state);
            }
        };
        for(let event in this.handlers)context.addEventListener(event, this.handlers[event]);
        this.measureReq = {
            read: (view)=>{
                this.editContext.updateControlBounds(view.contentDOM.getBoundingClientRect());
                let sel = $1d528cc0e08a0656$var$getSelection(view.root);
                if (sel && sel.rangeCount) this.editContext.updateSelectionBounds(sel.getRangeAt(0).getBoundingClientRect());
            }
        };
    }
    applyEdits(update) {
        let off = 0, abort = false, pending = this.pendingContextChange;
        update.changes.iterChanges((fromA, toA, _fromB, _toB, insert)=>{
            if (abort) return;
            let dLen = insert.length - (toA - fromA);
            if (pending && toA >= pending.to) {
                if (pending.from == fromA && pending.to == toA && pending.insert.eq(insert)) {
                    pending = this.pendingContextChange = null; // Match
                    off += dLen;
                    this.to += dLen;
                    return;
                } else {
                    pending = null;
                    this.revertPending(update.state);
                }
            }
            fromA += off;
            toA += off;
            if (toA <= this.from) {
                this.from += dLen;
                this.to += dLen;
            } else if (fromA < this.to) {
                if (fromA < this.from || toA > this.to || this.to - this.from + insert.length > 30000 /* CxVp.MaxSize */ ) {
                    abort = true;
                    return;
                }
                this.editContext.updateText(this.toContextPos(fromA), this.toContextPos(toA), insert.toString());
                this.to += dLen;
            }
            off += dLen;
        });
        if (pending && !abort) this.revertPending(update.state);
        return !abort;
    }
    update(update) {
        let reverted = this.pendingContextChange, startSel = update.startState.selection.main;
        if (this.composing && (this.composing.drifted || !update.changes.touchesRange(startSel.from, startSel.to) && update.transactions.some((tr)=>!tr.isUserEvent("input.type") && tr.changes.touchesRange(this.from, this.to)))) {
            this.composing.drifted = true;
            this.composing.editorBase = update.changes.mapPos(this.composing.editorBase);
        } else if (!this.applyEdits(update) || !this.rangeIsValid(update.state)) {
            this.pendingContextChange = null;
            this.reset(update.state);
        } else if (update.docChanged || update.selectionSet || reverted) this.setSelection(update.state);
        if (update.geometryChanged || update.docChanged || update.selectionSet) update.view.requestMeasure(this.measureReq);
    }
    resetRange(state) {
        let { head: head } = state.selection.main;
        this.from = Math.max(0, head - 10000 /* CxVp.Margin */ );
        this.to = Math.min(state.doc.length, head + 10000 /* CxVp.Margin */ );
    }
    reset(state) {
        this.resetRange(state);
        this.editContext.updateText(0, this.editContext.text.length, state.doc.sliceString(this.from, this.to));
        this.setSelection(state);
    }
    revertPending(state) {
        let pending = this.pendingContextChange;
        this.pendingContextChange = null;
        this.editContext.updateText(this.toContextPos(pending.from), this.toContextPos(pending.from + pending.insert.length), state.doc.sliceString(pending.from, pending.to));
    }
    setSelection(state) {
        let { main: main } = state.selection;
        let start = this.toContextPos(Math.max(this.from, Math.min(this.to, main.anchor)));
        let end = this.toContextPos(main.head);
        if (this.editContext.selectionStart != start || this.editContext.selectionEnd != end) this.editContext.updateSelection(start, end);
    }
    rangeIsValid(state) {
        let { head: head } = state.selection.main;
        return !(this.from > 0 && head - this.from < 500 /* CxVp.MinMargin */  || this.to < state.doc.length && this.to - head < 500 /* CxVp.MinMargin */  || this.to - this.from > 30000);
    }
    toEditorPos(contextPos, clipLen = this.to - this.from) {
        contextPos = Math.min(contextPos, clipLen);
        let c = this.composing;
        return c && c.drifted ? c.editorBase + (contextPos - c.contextBase) : contextPos + this.from;
    }
    toContextPos(editorPos) {
        let c = this.composing;
        return c && c.drifted ? c.contextBase + (editorPos - c.editorBase) : editorPos - this.from;
    }
    destroy() {
        for(let event in this.handlers)this.editContext.removeEventListener(event, this.handlers[event]);
    }
}
// The editor's update state machine looks something like this:
//
//     Idle → Updating ⇆ Idle (unchecked) → Measuring → Idle
//                                         ↑      ↓
//                                         Updating (measure)
//
// The difference between 'Idle' and 'Idle (unchecked)' lies in
// whether a layout check has been scheduled. A regular update through
// the `update` method updates the DOM in a write-only fashion, and
// relies on a check (scheduled with `requestAnimationFrame`) to make
// sure everything is where it should be and the viewport covers the
// visible code. That check continues to measure and then optionally
// update until it reaches a coherent state.
/**
An editor view represents the editor's user interface. It holds
the editable DOM surface, and possibly other elements such as the
line number gutter. It handles events and dispatches state
transactions for editing actions.
*/ class $1d528cc0e08a0656$export$eece2fccabbb77c5 {
    /**
    The current editor state.
    */ get state() {
        return this.viewState.state;
    }
    /**
    To be able to display large documents without consuming too much
    memory or overloading the browser, CodeMirror only draws the
    code that is visible (plus a margin around it) to the DOM. This
    property tells you the extent of the current drawn viewport, in
    document positions.
    */ get viewport() {
        return this.viewState.viewport;
    }
    /**
    When there are, for example, large collapsed ranges in the
    viewport, its size can be a lot bigger than the actual visible
    content. Thus, if you are doing something like styling the
    content in the viewport, it is preferable to only do so for
    these ranges, which are the subset of the viewport that is
    actually drawn.
    */ get visibleRanges() {
        return this.viewState.visibleRanges;
    }
    /**
    Returns false when the editor is entirely scrolled out of view
    or otherwise hidden.
    */ get inView() {
        return this.viewState.inView;
    }
    /**
    Indicates whether the user is currently composing text via
    [IME](https://en.wikipedia.org/wiki/Input_method), and at least
    one change has been made in the current composition.
    */ get composing() {
        return !!this.inputState && this.inputState.composing > 0;
    }
    /**
    Indicates whether the user is currently in composing state. Note
    that on some platforms, like Android, this will be the case a
    lot, since just putting the cursor on a word starts a
    composition there.
    */ get compositionStarted() {
        return !!this.inputState && this.inputState.composing >= 0;
    }
    /**
    The document or shadow root that the view lives in.
    */ get root() {
        return this._root;
    }
    /**
    @internal
    */ get win() {
        return this.dom.ownerDocument.defaultView || window;
    }
    /**
    Construct a new view. You'll want to either provide a `parent`
    option, or put `view.dom` into your document after creating a
    view, so that the user can see the editor.
    */ constructor(config = {}){
        var _a;
        this.plugins = [];
        this.pluginMap = new Map;
        this.editorAttrs = {};
        this.contentAttrs = {};
        this.bidiCache = [];
        this.destroyed = false;
        /**
        @internal
        */ this.updateState = 2 /* UpdateState.Updating */ ;
        /**
        @internal
        */ this.measureScheduled = -1;
        /**
        @internal
        */ this.measureRequests = [];
        this.contentDOM = document.createElement("div");
        this.scrollDOM = document.createElement("div");
        this.scrollDOM.tabIndex = -1;
        this.scrollDOM.className = "cm-scroller";
        this.scrollDOM.appendChild(this.contentDOM);
        this.announceDOM = document.createElement("div");
        this.announceDOM.className = "cm-announced";
        this.announceDOM.setAttribute("aria-live", "polite");
        this.dom = document.createElement("div");
        this.dom.appendChild(this.announceDOM);
        this.dom.appendChild(this.scrollDOM);
        if (config.parent) config.parent.appendChild(this.dom);
        let { dispatch: dispatch } = config;
        this.dispatchTransactions = config.dispatchTransactions || dispatch && ((trs)=>trs.forEach((tr)=>dispatch(tr, this))) || ((trs)=>this.update(trs));
        this.dispatch = this.dispatch.bind(this);
        this._root = config.root || $1d528cc0e08a0656$var$getRoot(config.parent) || document;
        this.viewState = new $1d528cc0e08a0656$var$ViewState(config.state || (0, $6b8f387faea0a4dd$export$afa855cbfaff27f2).create(config));
        if (config.scrollTo && config.scrollTo.is($1d528cc0e08a0656$var$scrollIntoView)) this.viewState.scrollTarget = config.scrollTo.value.clip(this.viewState.state);
        this.plugins = this.state.facet($1d528cc0e08a0656$var$viewPlugin).map((spec)=>new $1d528cc0e08a0656$var$PluginInstance(spec));
        for (let plugin of this.plugins)plugin.update(this);
        this.observer = new $1d528cc0e08a0656$var$DOMObserver(this);
        this.inputState = new $1d528cc0e08a0656$var$InputState(this);
        this.inputState.ensureHandlers(this.plugins);
        this.docView = new $1d528cc0e08a0656$var$DocView(this);
        this.mountStyles();
        this.updateAttrs();
        this.updateState = 0 /* UpdateState.Idle */ ;
        this.requestMeasure();
        if ((_a = document.fonts) === null || _a === void 0 ? void 0 : _a.ready) document.fonts.ready.then(()=>this.requestMeasure());
    }
    dispatch(...input) {
        let trs = input.length == 1 && input[0] instanceof (0, $6b8f387faea0a4dd$export$febc5573c75cefb0) ? input : input.length == 1 && Array.isArray(input[0]) ? input[0] : [
            this.state.update(...input)
        ];
        this.dispatchTransactions(trs, this);
    }
    /**
    Update the view for the given array of transactions. This will
    update the visible document and selection to match the state
    produced by the transactions, and notify view plugins of the
    change. You should usually call
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
    as a primitive.
    */ update(transactions) {
        if (this.updateState != 0 /* UpdateState.Idle */ ) throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
        let redrawn = false, attrsChanged = false, update;
        let state = this.state;
        for (let tr of transactions){
            if (tr.startState != state) throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
            state = tr.state;
        }
        if (this.destroyed) {
            this.viewState.state = state;
            return;
        }
        let focus = this.hasFocus, focusFlag = 0, dispatchFocus = null;
        if (transactions.some((tr)=>tr.annotation($1d528cc0e08a0656$var$isFocusChange))) {
            this.inputState.notifiedFocused = focus;
            // If a focus-change transaction is being dispatched, set this update flag.
            focusFlag = 1 /* UpdateFlag.Focus */ ;
        } else if (focus != this.inputState.notifiedFocused) {
            this.inputState.notifiedFocused = focus;
            // Schedule a separate focus transaction if necessary, otherwise
            // add a flag to this update
            dispatchFocus = $1d528cc0e08a0656$var$focusChangeTransaction(state, focus);
            if (!dispatchFocus) focusFlag = 1 /* UpdateFlag.Focus */ ;
        }
        // If there was a pending DOM change, eagerly read it and try to
        // apply it after the given transactions.
        let pendingKey = this.observer.delayedAndroidKey, domChange = null;
        if (pendingKey) {
            this.observer.clearDelayedAndroidKey();
            domChange = this.observer.readChange();
            // Only try to apply DOM changes if the transactions didn't
            // change the doc or selection.
            if (domChange && !this.state.doc.eq(state.doc) || !this.state.selection.eq(state.selection)) domChange = null;
        } else this.observer.clear();
        // When the phrases change, redraw the editor
        if (state.facet((0, $6b8f387faea0a4dd$export$afa855cbfaff27f2).phrases) != this.state.facet((0, $6b8f387faea0a4dd$export$afa855cbfaff27f2).phrases)) return this.setState(state);
        update = $1d528cc0e08a0656$export$b5b084f95c87edf7.create(this, state, transactions);
        update.flags |= focusFlag;
        let scrollTarget = this.viewState.scrollTarget;
        try {
            this.updateState = 2 /* UpdateState.Updating */ ;
            for (let tr of transactions){
                if (scrollTarget) scrollTarget = scrollTarget.map(tr.changes);
                if (tr.scrollIntoView) {
                    let { main: main } = tr.state.selection;
                    scrollTarget = new $1d528cc0e08a0656$var$ScrollTarget(main.empty ? main : (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(main.head, main.head > main.anchor ? -1 : 1));
                }
                for (let e of tr.effects)if (e.is($1d528cc0e08a0656$var$scrollIntoView)) scrollTarget = e.value.clip(this.state);
            }
            this.viewState.update(update, scrollTarget);
            this.bidiCache = $1d528cc0e08a0656$var$CachedOrder.update(this.bidiCache, update.changes);
            if (!update.empty) {
                this.updatePlugins(update);
                this.inputState.update(update);
            }
            redrawn = this.docView.update(update);
            if (this.state.facet($1d528cc0e08a0656$var$styleModule) != this.styleModules) this.mountStyles();
            attrsChanged = this.updateAttrs();
            this.showAnnouncements(transactions);
            this.docView.updateSelection(redrawn, transactions.some((tr)=>tr.isUserEvent("select.pointer")));
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
        }
        if (update.startState.facet($1d528cc0e08a0656$var$theme) != update.state.facet($1d528cc0e08a0656$var$theme)) this.viewState.mustMeasureContent = true;
        if (redrawn || attrsChanged || scrollTarget || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) this.requestMeasure();
        if (redrawn) this.docViewUpdate();
        if (!update.empty) for (let listener of this.state.facet($1d528cc0e08a0656$var$updateListener))try {
            listener(update);
        } catch (e) {
            $1d528cc0e08a0656$export$f86b2a1a2ce291b3(this.state, e, "update listener");
        }
        if (dispatchFocus || domChange) Promise.resolve().then(()=>{
            if (dispatchFocus && this.state == dispatchFocus.startState) this.dispatch(dispatchFocus);
            if (domChange) {
                if (!$1d528cc0e08a0656$var$applyDOMChange(this, domChange) && pendingKey.force) $1d528cc0e08a0656$var$dispatchKey(this.contentDOM, pendingKey.key, pendingKey.keyCode);
            }
        });
    }
    /**
    Reset the view to the given state. (This will cause the entire
    document to be redrawn and all view plugins to be reinitialized,
    so you should probably only use it when the new state isn't
    derived from the old state. Otherwise, use
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
    */ setState(newState) {
        if (this.updateState != 0 /* UpdateState.Idle */ ) throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
        if (this.destroyed) {
            this.viewState.state = newState;
            return;
        }
        this.updateState = 2 /* UpdateState.Updating */ ;
        let hadFocus = this.hasFocus;
        try {
            for (let plugin of this.plugins)plugin.destroy(this);
            this.viewState = new $1d528cc0e08a0656$var$ViewState(newState);
            this.plugins = newState.facet($1d528cc0e08a0656$var$viewPlugin).map((spec)=>new $1d528cc0e08a0656$var$PluginInstance(spec));
            this.pluginMap.clear();
            for (let plugin of this.plugins)plugin.update(this);
            this.docView.destroy();
            this.docView = new $1d528cc0e08a0656$var$DocView(this);
            this.inputState.ensureHandlers(this.plugins);
            this.mountStyles();
            this.updateAttrs();
            this.bidiCache = [];
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
        }
        if (hadFocus) this.focus();
        this.requestMeasure();
    }
    updatePlugins(update) {
        let prevSpecs = update.startState.facet($1d528cc0e08a0656$var$viewPlugin), specs = update.state.facet($1d528cc0e08a0656$var$viewPlugin);
        if (prevSpecs != specs) {
            let newPlugins = [];
            for (let spec of specs){
                let found = prevSpecs.indexOf(spec);
                if (found < 0) newPlugins.push(new $1d528cc0e08a0656$var$PluginInstance(spec));
                else {
                    let plugin = this.plugins[found];
                    plugin.mustUpdate = update;
                    newPlugins.push(plugin);
                }
            }
            for (let plugin of this.plugins)if (plugin.mustUpdate != update) plugin.destroy(this);
            this.plugins = newPlugins;
            this.pluginMap.clear();
        } else for (let p of this.plugins)p.mustUpdate = update;
        for(let i = 0; i < this.plugins.length; i++)this.plugins[i].update(this);
        if (prevSpecs != specs) this.inputState.ensureHandlers(this.plugins);
    }
    docViewUpdate() {
        for (let plugin of this.plugins){
            let val = plugin.value;
            if (val && val.docViewUpdate) try {
                val.docViewUpdate(this);
            } catch (e) {
                $1d528cc0e08a0656$export$f86b2a1a2ce291b3(this.state, e, "doc view update listener");
            }
        }
    }
    /**
    @internal
    */ measure(flush = true) {
        if (this.destroyed) return;
        if (this.measureScheduled > -1) this.win.cancelAnimationFrame(this.measureScheduled);
        if (this.observer.delayedAndroidKey) {
            this.measureScheduled = -1;
            this.requestMeasure();
            return;
        }
        this.measureScheduled = 0; // Prevent requestMeasure calls from scheduling another animation frame
        if (flush) this.observer.forceFlush();
        let updated = null;
        let sDOM = this.scrollDOM, scrollTop = sDOM.scrollTop * this.scaleY;
        let { scrollAnchorPos: scrollAnchorPos, scrollAnchorHeight: scrollAnchorHeight } = this.viewState;
        if (Math.abs(scrollTop - this.viewState.scrollTop) > 1) scrollAnchorHeight = -1;
        this.viewState.scrollAnchorHeight = -1;
        try {
            for(let i = 0;; i++){
                if (scrollAnchorHeight < 0) {
                    if ($1d528cc0e08a0656$var$isScrolledToBottom(sDOM)) {
                        scrollAnchorPos = -1;
                        scrollAnchorHeight = this.viewState.heightMap.height;
                    } else {
                        let block = this.viewState.scrollAnchorAt(scrollTop);
                        scrollAnchorPos = block.from;
                        scrollAnchorHeight = block.top;
                    }
                }
                this.updateState = 1 /* UpdateState.Measuring */ ;
                let changed = this.viewState.measure(this);
                if (!changed && !this.measureRequests.length && this.viewState.scrollTarget == null) break;
                if (i > 5) {
                    console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
                    break;
                }
                let measuring = [];
                // Only run measure requests in this cycle when the viewport didn't change
                if (!(changed & 4 /* UpdateFlag.Viewport */ )) [this.measureRequests, measuring] = [
                    measuring,
                    this.measureRequests
                ];
                let measured = measuring.map((m)=>{
                    try {
                        return m.read(this);
                    } catch (e) {
                        $1d528cc0e08a0656$export$f86b2a1a2ce291b3(this.state, e);
                        return $1d528cc0e08a0656$var$BadMeasure;
                    }
                });
                let update = $1d528cc0e08a0656$export$b5b084f95c87edf7.create(this, this.state, []), redrawn = false;
                update.flags |= changed;
                if (!updated) updated = update;
                else updated.flags |= changed;
                this.updateState = 2 /* UpdateState.Updating */ ;
                if (!update.empty) {
                    this.updatePlugins(update);
                    this.inputState.update(update);
                    this.updateAttrs();
                    redrawn = this.docView.update(update);
                    if (redrawn) this.docViewUpdate();
                }
                for(let i = 0; i < measuring.length; i++)if (measured[i] != $1d528cc0e08a0656$var$BadMeasure) try {
                    let m = measuring[i];
                    if (m.write) m.write(measured[i], this);
                } catch (e) {
                    $1d528cc0e08a0656$export$f86b2a1a2ce291b3(this.state, e);
                }
                if (redrawn) this.docView.updateSelection(true);
                if (!update.viewportChanged && this.measureRequests.length == 0) {
                    if (this.viewState.editorHeight) {
                        if (this.viewState.scrollTarget) {
                            this.docView.scrollIntoView(this.viewState.scrollTarget);
                            this.viewState.scrollTarget = null;
                            scrollAnchorHeight = -1;
                            continue;
                        } else {
                            let newAnchorHeight = scrollAnchorPos < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(scrollAnchorPos).top;
                            let diff = newAnchorHeight - scrollAnchorHeight;
                            if (diff > 1 || diff < -1) {
                                scrollTop = scrollTop + diff;
                                sDOM.scrollTop = scrollTop / this.scaleY;
                                scrollAnchorHeight = -1;
                                continue;
                            }
                        }
                    }
                    break;
                }
            }
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
            this.measureScheduled = -1;
        }
        if (updated && !updated.empty) for (let listener of this.state.facet($1d528cc0e08a0656$var$updateListener))listener(updated);
    }
    /**
    Get the CSS classes for the currently active editor themes.
    */ get themeClasses() {
        return $1d528cc0e08a0656$var$baseThemeID + " " + (this.state.facet($1d528cc0e08a0656$var$darkTheme) ? $1d528cc0e08a0656$var$baseDarkID : $1d528cc0e08a0656$var$baseLightID) + " " + this.state.facet($1d528cc0e08a0656$var$theme);
    }
    updateAttrs() {
        let editorAttrs = $1d528cc0e08a0656$var$attrsFromFacet(this, $1d528cc0e08a0656$var$editorAttributes, {
            class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
        });
        let contentAttrs = {
            spellcheck: "false",
            autocorrect: "off",
            autocapitalize: "off",
            writingsuggestions: "false",
            translate: "no",
            contenteditable: !this.state.facet($1d528cc0e08a0656$var$editable) ? "false" : "true",
            class: "cm-content",
            style: `${$1d528cc0e08a0656$var$browser.tabSize}: ${this.state.tabSize}`,
            role: "textbox",
            "aria-multiline": "true"
        };
        if (this.state.readOnly) contentAttrs["aria-readonly"] = "true";
        $1d528cc0e08a0656$var$attrsFromFacet(this, $1d528cc0e08a0656$var$contentAttributes, contentAttrs);
        let changed = this.observer.ignore(()=>{
            let changedContent = $1d528cc0e08a0656$var$updateAttrs(this.contentDOM, this.contentAttrs, contentAttrs);
            let changedEditor = $1d528cc0e08a0656$var$updateAttrs(this.dom, this.editorAttrs, editorAttrs);
            return changedContent || changedEditor;
        });
        this.editorAttrs = editorAttrs;
        this.contentAttrs = contentAttrs;
        return changed;
    }
    showAnnouncements(trs) {
        let first = true;
        for (let tr of trs)for (let effect of tr.effects)if (effect.is($1d528cc0e08a0656$export$eece2fccabbb77c5.announce)) {
            if (first) this.announceDOM.textContent = "";
            first = false;
            let div = this.announceDOM.appendChild(document.createElement("div"));
            div.textContent = effect.value;
        }
    }
    mountStyles() {
        this.styleModules = this.state.facet($1d528cc0e08a0656$var$styleModule);
        let nonce = this.state.facet($1d528cc0e08a0656$export$eece2fccabbb77c5.cspNonce);
        (0, $efbdc34cfdde3fb8$export$b920c662d2efee20).mount(this.root, this.styleModules.concat($1d528cc0e08a0656$var$baseTheme$1).reverse(), nonce ? {
            nonce: nonce
        } : undefined);
    }
    readMeasured() {
        if (this.updateState == 2 /* UpdateState.Updating */ ) throw new Error("Reading the editor layout isn't allowed during an update");
        if (this.updateState == 0 /* UpdateState.Idle */  && this.measureScheduled > -1) this.measure(false);
    }
    /**
    Schedule a layout measurement, optionally providing callbacks to
    do custom DOM measuring followed by a DOM write phase. Using
    this is preferable reading DOM layout directly from, for
    example, an event handler, because it'll make sure measuring and
    drawing done by other components is synchronized, avoiding
    unnecessary DOM layout computations.
    */ requestMeasure(request) {
        if (this.measureScheduled < 0) this.measureScheduled = this.win.requestAnimationFrame(()=>this.measure());
        if (request) {
            if (this.measureRequests.indexOf(request) > -1) return;
            if (request.key != null) {
                for(let i = 0; i < this.measureRequests.length; i++)if (this.measureRequests[i].key === request.key) {
                    this.measureRequests[i] = request;
                    return;
                }
            }
            this.measureRequests.push(request);
        }
    }
    /**
    Get the value of a specific plugin, if present. Note that
    plugins that crash can be dropped from a view, so even when you
    know you registered a given plugin, it is recommended to check
    the return value of this method.
    */ plugin(plugin) {
        let known = this.pluginMap.get(plugin);
        if (known === undefined || known && known.plugin != plugin) this.pluginMap.set(plugin, known = this.plugins.find((p)=>p.plugin == plugin) || null);
        return known && known.update(this).value;
    }
    /**
    The top position of the document, in screen coordinates. This
    may be negative when the editor is scrolled down. Points
    directly to the top of the first line, not above the padding.
    */ get documentTop() {
        return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
    }
    /**
    Reports the padding above and below the document.
    */ get documentPadding() {
        return {
            top: this.viewState.paddingTop,
            bottom: this.viewState.paddingBottom
        };
    }
    /**
    If the editor is transformed with CSS, this provides the scale
    along the X axis. Otherwise, it will just be 1. Note that
    transforms other than translation and scaling are not supported.
    */ get scaleX() {
        return this.viewState.scaleX;
    }
    /**
    Provide the CSS transformed scale along the Y axis.
    */ get scaleY() {
        return this.viewState.scaleY;
    }
    /**
    Find the text line or block widget at the given vertical
    position (which is interpreted as relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
    */ elementAtHeight(height) {
        this.readMeasured();
        return this.viewState.elementAtHeight(height);
    }
    /**
    Find the line block (see
    [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) at the given
    height, again interpreted relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
    */ lineBlockAtHeight(height) {
        this.readMeasured();
        return this.viewState.lineBlockAtHeight(height);
    }
    /**
    Get the extent and vertical position of all [line
    blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
    are relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
    */ get viewportLineBlocks() {
        return this.viewState.viewportLines;
    }
    /**
    Find the line block around the given document position. A line
    block is a range delimited on both sides by either a
    non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line break, or the
    start/end of the document. It will usually just hold a line of
    text, but may be broken into multiple textblocks by block
    widgets.
    */ lineBlockAt(pos) {
        return this.viewState.lineBlockAt(pos);
    }
    /**
    The editor's total content height.
    */ get contentHeight() {
        return this.viewState.contentHeight;
    }
    /**
    Move a cursor position by [grapheme
    cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
    the motion is away from the line start, or towards it. In
    bidirectional text, the line is traversed in visual order, using
    the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
    When the start position was the last one on the line, the
    returned position will be across the line break. If there is no
    further line, the original position is returned.
    
    By default, this method moves over a single cluster. The
    optional `by` argument can be used to move across more. It will
    be called with the first cluster as argument, and should return
    a predicate that determines, for each subsequent cluster,
    whether it should also be moved over.
    */ moveByChar(start, forward, by) {
        return $1d528cc0e08a0656$var$skipAtoms(this, start, $1d528cc0e08a0656$var$moveByChar(this, start, forward, by));
    }
    /**
    Move a cursor position across the next group of either
    [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
    non-whitespace characters.
    */ moveByGroup(start, forward) {
        return $1d528cc0e08a0656$var$skipAtoms(this, start, $1d528cc0e08a0656$var$moveByChar(this, start, forward, (initial)=>$1d528cc0e08a0656$var$byGroup(this, start.head, initial)));
    }
    /**
    Get the cursor position visually at the start or end of a line.
    Note that this may differ from the _logical_ position at its
    start or end (which is simply at `line.from`/`line.to`) if text
    at the start or end goes against the line's base text direction.
    */ visualLineSide(line, end) {
        let order = this.bidiSpans(line), dir = this.textDirectionAt(line.from);
        let span = order[end ? order.length - 1 : 0];
        return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(span.side(end, dir) + line.from, span.forward(!end, dir) ? 1 : -1);
    }
    /**
    Move to the next line boundary in the given direction. If
    `includeWrap` is true, line wrapping is on, and there is a
    further wrap point on the current line, the wrap point will be
    returned. Otherwise this function will return the start or end
    of the line.
    */ moveToLineBoundary(start, forward, includeWrap = true) {
        return $1d528cc0e08a0656$var$moveToLineBoundary(this, start, forward, includeWrap);
    }
    /**
    Move a cursor position vertically. When `distance` isn't given,
    it defaults to moving to the next line (including wrapped
    lines). Otherwise, `distance` should provide a positive distance
    in pixels.
    
    When `start` has a
    [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
    motion will use that as a target horizontal position. Otherwise,
    the cursor's own horizontal position is used. The returned
    cursor will have its goal column set to whichever column was
    used.
    */ moveVertically(start, forward, distance) {
        return $1d528cc0e08a0656$var$skipAtoms(this, start, $1d528cc0e08a0656$var$moveVertically(this, start, forward, distance));
    }
    /**
    Find the DOM parent node and offset (child offset if `node` is
    an element, character offset when it is a text node) at the
    given document position.
    
    Note that for positions that aren't currently in
    `visibleRanges`, the resulting DOM position isn't necessarily
    meaningful (it may just point before or after a placeholder
    element).
    */ domAtPos(pos) {
        return this.docView.domAtPos(pos);
    }
    /**
    Find the document position at the given DOM node. Can be useful
    for associating positions with DOM events. Will raise an error
    when `node` isn't part of the editor content.
    */ posAtDOM(node, offset = 0) {
        return this.docView.posFromDOM(node, offset);
    }
    posAtCoords(coords, precise = true) {
        this.readMeasured();
        return $1d528cc0e08a0656$var$posAtCoords(this, coords, precise);
    }
    /**
    Get the screen coordinates at the given document position.
    `side` determines whether the coordinates are based on the
    element before (-1) or after (1) the position (if no element is
    available on the given side, the method will transparently use
    another strategy to get reasonable coordinates).
    */ coordsAtPos(pos, side = 1) {
        this.readMeasured();
        let rect = this.docView.coordsAt(pos, side);
        if (!rect || rect.left == rect.right) return rect;
        let line = this.state.doc.lineAt(pos), order = this.bidiSpans(line);
        let span = order[$1d528cc0e08a0656$export$e1ed96b746bb516a.find(order, pos - line.from, -1, side)];
        return $1d528cc0e08a0656$var$flattenRect(rect, span.dir == $1d528cc0e08a0656$export$cacd6541cfeeb6c1.LTR == side > 0);
    }
    /**
    Return the rectangle around a given character. If `pos` does not
    point in front of a character that is in the viewport and
    rendered (i.e. not replaced, not a line break), this will return
    null. For space characters that are a line wrap point, this will
    return the position before the line break.
    */ coordsForChar(pos) {
        this.readMeasured();
        return this.docView.coordsForChar(pos);
    }
    /**
    The default width of a character in the editor. May not
    accurately reflect the width of all characters (given variable
    width fonts or styling of invididual ranges).
    */ get defaultCharacterWidth() {
        return this.viewState.heightOracle.charWidth;
    }
    /**
    The default height of a line in the editor. May not be accurate
    for all lines.
    */ get defaultLineHeight() {
        return this.viewState.heightOracle.lineHeight;
    }
    /**
    The text direction
    ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
    CSS property) of the editor's content element.
    */ get textDirection() {
        return this.viewState.defaultTextDirection;
    }
    /**
    Find the text direction of the block at the given position, as
    assigned by CSS. If
    [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
    isn't enabled, or the given position is outside of the viewport,
    this will always return the same as
    [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
    this may trigger a DOM layout.
    */ textDirectionAt(pos) {
        let perLine = this.state.facet($1d528cc0e08a0656$var$perLineTextDirection);
        if (!perLine || pos < this.viewport.from || pos > this.viewport.to) return this.textDirection;
        this.readMeasured();
        return this.docView.textDirectionAt(pos);
    }
    /**
    Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
    (as determined by the
    [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
    CSS property of its content element).
    */ get lineWrapping() {
        return this.viewState.heightOracle.lineWrapping;
    }
    /**
    Returns the bidirectional text structure of the given line
    (which should be in the current document) as an array of span
    objects. The order of these spans matches the [text
    direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
    left-to-right, the leftmost spans come first, otherwise the
    rightmost spans come first.
    */ bidiSpans(line) {
        if (line.length > $1d528cc0e08a0656$var$MaxBidiLine) return $1d528cc0e08a0656$var$trivialOrder(line.length);
        let dir = this.textDirectionAt(line.from), isolates;
        for (let entry of this.bidiCache){
            if (entry.from == line.from && entry.dir == dir && (entry.fresh || $1d528cc0e08a0656$var$isolatesEq(entry.isolates, isolates = $1d528cc0e08a0656$var$getIsolatedRanges(this, line)))) return entry.order;
        }
        if (!isolates) isolates = $1d528cc0e08a0656$var$getIsolatedRanges(this, line);
        let order = $1d528cc0e08a0656$var$computeOrder(line.text, dir, isolates);
        this.bidiCache.push(new $1d528cc0e08a0656$var$CachedOrder(line.from, line.to, dir, isolates, true, order));
        return order;
    }
    /**
    Check whether the editor has focus.
    */ get hasFocus() {
        var _a;
        // Safari return false for hasFocus when the context menu is open
        // or closing, which leads us to ignore selection changes from the
        // context menu because it looks like the editor isn't focused.
        // This kludges around that.
        return (this.dom.ownerDocument.hasFocus() || $1d528cc0e08a0656$var$browser.safari && ((_a = this.inputState) === null || _a === void 0 ? void 0 : _a.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
    }
    /**
    Put focus on the editor.
    */ focus() {
        this.observer.ignore(()=>{
            $1d528cc0e08a0656$var$focusPreventScroll(this.contentDOM);
            this.docView.updateSelection();
        });
    }
    /**
    Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
    necessary when moving the editor's existing DOM to a new window or shadow root.
    */ setRoot(root) {
        if (this._root != root) {
            this._root = root;
            this.observer.setWindow((root.nodeType == 9 ? root : root.ownerDocument).defaultView || window);
            this.mountStyles();
        }
    }
    /**
    Clean up this editor view, removing its element from the
    document, unregistering event handlers, and notifying
    plugins. The view instance can no longer be used after
    calling this.
    */ destroy() {
        if (this.root.activeElement == this.contentDOM) this.contentDOM.blur();
        for (let plugin of this.plugins)plugin.destroy(this);
        this.plugins = [];
        this.inputState.destroy();
        this.docView.destroy();
        this.dom.remove();
        this.observer.destroy();
        if (this.measureScheduled > -1) this.win.cancelAnimationFrame(this.measureScheduled);
        this.destroyed = true;
    }
    /**
    Returns an effect that can be
    [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
    cause it to scroll the given position or range into view.
    */ static scrollIntoView(pos, options = {}) {
        return $1d528cc0e08a0656$var$scrollIntoView.of(new $1d528cc0e08a0656$var$ScrollTarget(typeof pos == "number" ? (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(pos) : pos, options.y, options.x, options.yMargin, options.xMargin));
    }
    /**
    Return an effect that resets the editor to its current (at the
    time this method was called) scroll position. Note that this
    only affects the editor's own scrollable element, not parents.
    See also
    [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
    
    The effect should be used with a document identical to the one
    it was created for. Failing to do so is not an error, but may
    not scroll to the expected position. You can
    [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
    */ scrollSnapshot() {
        let { scrollTop: scrollTop, scrollLeft: scrollLeft } = this.scrollDOM;
        let ref = this.viewState.scrollAnchorAt(scrollTop);
        return $1d528cc0e08a0656$var$scrollIntoView.of(new $1d528cc0e08a0656$var$ScrollTarget((0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(ref.from), "start", "start", ref.top - scrollTop, scrollLeft, true));
    }
    /**
    Enable or disable tab-focus mode, which disables key bindings
    for Tab and Shift-Tab, letting the browser's default
    focus-changing behavior go through instead. This is useful to
    prevent trapping keyboard users in your editor.
    
    Without argument, this toggles the mode. With a boolean, it
    enables (true) or disables it (false). Given a number, it
    temporarily enables the mode until that number of milliseconds
    have passed or another non-Tab key is pressed.
    */ setTabFocusMode(to) {
        if (to == null) this.inputState.tabFocusMode = this.inputState.tabFocusMode < 0 ? 0 : -1;
        else if (typeof to == "boolean") this.inputState.tabFocusMode = to ? 0 : -1;
        else if (this.inputState.tabFocusMode != 0) this.inputState.tabFocusMode = Date.now() + to;
    }
    /**
    Returns an extension that can be used to add DOM event handlers.
    The value should be an object mapping event names to handler
    functions. For any given event, such functions are ordered by
    extension precedence, and the first handler to return true will
    be assumed to have handled that event, and no other handlers or
    built-in behavior will be activated for it. These are registered
    on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
    for `scroll` handlers, which will be called any time the
    editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
    its parent nodes is scrolled.
    */ static domEventHandlers(handlers) {
        return $1d528cc0e08a0656$export$44d5eccfd62adda7.define(()=>({}), {
            eventHandlers: handlers
        });
    }
    /**
    Create an extension that registers DOM event observers. Contrary
    to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
    observers can't be prevented from running by a higher-precedence
    handler returning true. They also don't prevent other handlers
    and observers from running when they return true, and should not
    call `preventDefault`.
    */ static domEventObservers(observers) {
        return $1d528cc0e08a0656$export$44d5eccfd62adda7.define(()=>({}), {
            eventObservers: observers
        });
    }
    /**
    Create a theme extension. The first argument can be a
    [`style-mod`](https://github.com/marijnh/style-mod#documentation)
    style spec providing the styles for the theme. These will be
    prefixed with a generated class for the style.
    
    Because the selectors will be prefixed with a scope class, rule
    that directly match the editor's [wrapper
    element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
    added—need to be explicitly differentiated by adding an `&` to
    the selector for that element—for example
    `&.cm-focused`.
    
    When `dark` is set to true, the theme will be marked as dark,
    which will cause the `&dark` rules from [base
    themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
    `&light` when a light theme is active).
    */ static theme(spec, options) {
        let prefix = (0, $efbdc34cfdde3fb8$export$b920c662d2efee20).newName();
        let result = [
            $1d528cc0e08a0656$var$theme.of(prefix),
            $1d528cc0e08a0656$var$styleModule.of($1d528cc0e08a0656$var$buildTheme(`.${prefix}`, spec))
        ];
        if (options && options.dark) result.push($1d528cc0e08a0656$var$darkTheme.of(true));
        return result;
    }
    /**
    Create an extension that adds styles to the base theme. Like
    with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
    place of the editor wrapper element when directly targeting
    that. You can also use `&dark` or `&light` instead to only
    target editors with a dark or light theme.
    */ static baseTheme(spec) {
        return (0, $6b8f387faea0a4dd$export$b92464a736444411).lowest($1d528cc0e08a0656$var$styleModule.of($1d528cc0e08a0656$var$buildTheme("." + $1d528cc0e08a0656$var$baseThemeID, spec, $1d528cc0e08a0656$var$lightDarkIDs)));
    }
    /**
    Retrieve an editor view instance from the view's DOM
    representation.
    */ static findFromDOM(dom) {
        var _a;
        let content = dom.querySelector(".cm-content");
        let cView = content && $1d528cc0e08a0656$var$ContentView.get(content) || $1d528cc0e08a0656$var$ContentView.get(dom);
        return ((_a = cView === null || cView === void 0 ? void 0 : cView.rootView) === null || _a === void 0 ? void 0 : _a.view) || null;
    }
}
/**
Facet to add a [style
module](https://github.com/marijnh/style-mod#documentation) to
an editor view. The view will ensure that the module is
mounted in its [document
root](https://codemirror.net/6/docs/ref/#view.EditorView.constructor^config.root).
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.styleModule = $1d528cc0e08a0656$var$styleModule;
/**
An input handler can override the way changes to the editable
DOM content are handled. Handlers are passed the document
positions between which the change was found, and the new
content. When one returns true, no further input handlers are
called and the default behavior is prevented.

The `insert` argument can be used to get the default transaction
that would be applied for this input. This can be useful when
dispatching the custom behavior as a separate transaction.
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.inputHandler = $1d528cc0e08a0656$var$inputHandler;
/**
Functions provided in this facet will be used to transform text
pasted or dropped into the editor.
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.clipboardInputFilter = $1d528cc0e08a0656$var$clipboardInputFilter;
/**
Transform text copied or dragged from the editor.
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.clipboardOutputFilter = $1d528cc0e08a0656$var$clipboardOutputFilter;
/**
Scroll handlers can override how things are scrolled into view.
If they return `true`, no further handling happens for the
scrolling. If they return false, the default scroll behavior is
applied. Scroll handlers should never initiate editor updates.
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.scrollHandler = $1d528cc0e08a0656$var$scrollHandler;
/**
This facet can be used to provide functions that create effects
to be dispatched when the editor's focus state changes.
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.focusChangeEffect = $1d528cc0e08a0656$var$focusChangeEffect;
/**
By default, the editor assumes all its content has the same
[text direction](https://codemirror.net/6/docs/ref/#view.Direction). Configure this with a `true`
value to make it read the text direction of every (rendered)
line separately.
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.perLineTextDirection = $1d528cc0e08a0656$var$perLineTextDirection;
/**
Allows you to provide a function that should be called when the
library catches an exception from an extension (mostly from view
plugins, but may be used by other extensions to route exceptions
from user-code-provided callbacks). This is mostly useful for
debugging and logging. See [`logException`](https://codemirror.net/6/docs/ref/#view.logException).
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.exceptionSink = $1d528cc0e08a0656$var$exceptionSink;
/**
A facet that can be used to register a function to be called
every time the view updates.
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.updateListener = $1d528cc0e08a0656$var$updateListener;
/**
Facet that controls whether the editor content DOM is editable.
When its highest-precedence value is `false`, the element will
not have its `contenteditable` attribute set. (Note that this
doesn't affect API calls that change the editor content, even
when those are bound to keys or buttons. See the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) facet for that.)
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.editable = $1d528cc0e08a0656$var$editable;
/**
Allows you to influence the way mouse selection happens. The
functions in this facet will be called for a `mousedown` event
on the editor, and can return an object that overrides the way a
selection is computed from that mouse click or drag.
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.mouseSelectionStyle = $1d528cc0e08a0656$var$mouseSelectionStyle;
/**
Facet used to configure whether a given selection drag event
should move or copy the selection. The given predicate will be
called with the `mousedown` event, and can return `true` when
the drag should move the content.
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.dragMovesSelection = $1d528cc0e08a0656$var$dragMovesSelection$1;
/**
Facet used to configure whether a given selecting click adds a
new range to the existing selection or replaces it entirely. The
default behavior is to check `event.metaKey` on macOS, and
`event.ctrlKey` elsewhere.
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.clickAddsSelectionRange = $1d528cc0e08a0656$var$clickAddsSelectionRange;
/**
A facet that determines which [decorations](https://codemirror.net/6/docs/ref/#view.Decoration)
are shown in the view. Decorations can be provided in two
ways—directly, or via a function that takes an editor view.

Only decoration sets provided directly are allowed to influence
the editor's vertical layout structure. The ones provided as
functions are called _after_ the new viewport has been computed,
and thus **must not** introduce block widgets or replacing
decorations that cover line breaks.

If you want decorated ranges to behave like atomic units for
cursor motion and deletion purposes, also provide the range set
containing the decorations to
[`EditorView.atomicRanges`](https://codemirror.net/6/docs/ref/#view.EditorView^atomicRanges).
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.decorations = $1d528cc0e08a0656$var$decorations;
/**
Facet that works much like
[`decorations`](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), but puts its
inputs at the very bottom of the precedence stack, meaning mark
decorations provided here will only be split by other, partially
overlapping \`outerDecorations\` ranges, and wrap around all
regular decorations. Use this for mark elements that should, as
much as possible, remain in one piece.
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.outerDecorations = $1d528cc0e08a0656$var$outerDecorations;
/**
Used to provide ranges that should be treated as atoms as far as
cursor motion is concerned. This causes methods like
[`moveByChar`](https://codemirror.net/6/docs/ref/#view.EditorView.moveByChar) and
[`moveVertically`](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) (and the
commands built on top of them) to skip across such regions when
a selection endpoint would enter them. This does _not_ prevent
direct programmatic [selection
updates](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) from moving into such
regions.
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.atomicRanges = $1d528cc0e08a0656$var$atomicRanges;
/**
When range decorations add a `unicode-bidi: isolate` style, they
should also include a
[`bidiIsolate`](https://codemirror.net/6/docs/ref/#view.MarkDecorationSpec.bidiIsolate) property
in their decoration spec, and be exposed through this facet, so
that the editor can compute the proper text order. (Other values
for `unicode-bidi`, except of course `normal`, are not
supported.)
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.bidiIsolatedRanges = $1d528cc0e08a0656$var$bidiIsolatedRanges;
/**
Facet that allows extensions to provide additional scroll
margins (space around the sides of the scrolling element that
should be considered invisible). This can be useful when the
plugin introduces elements that cover part of that element (for
example a horizontally fixed gutter).
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.scrollMargins = $1d528cc0e08a0656$var$scrollMargins;
/**
This facet records whether a dark theme is active. The extension
returned by [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme) automatically
includes an instance of this when the `dark` option is set to
true.
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.darkTheme = $1d528cc0e08a0656$var$darkTheme;
/**
Provides a Content Security Policy nonce to use when creating
the style sheets for the editor. Holds the empty string when no
nonce has been provided.
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.cspNonce = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.length ? values[0] : ""
});
/**
Facet that provides additional DOM attributes for the editor's
editable DOM element.
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.contentAttributes = $1d528cc0e08a0656$var$contentAttributes;
/**
Facet that provides DOM attributes for the editor's outer
element.
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.editorAttributes = $1d528cc0e08a0656$var$editorAttributes;
/**
An extension that enables line wrapping in the editor (by
setting CSS `white-space` to `pre-wrap` in the content).
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.lineWrapping = /*@__PURE__*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.contentAttributes.of({
    "class": "cm-lineWrapping"
});
/**
State effect used to include screen reader announcements in a
transaction. These will be added to the DOM in a visually hidden
element with `aria-live="polite"` set, and should be used to
describe effects that are visually obvious but may not be
noticed by screen reader users (such as moving to the next
search match).
*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.announce = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define();
// Maximum line length for which we compute accurate bidi info
const $1d528cc0e08a0656$var$MaxBidiLine = 4096;
const $1d528cc0e08a0656$var$BadMeasure = {};
class $1d528cc0e08a0656$var$CachedOrder {
    constructor(from, to, dir, isolates, fresh, order){
        this.from = from;
        this.to = to;
        this.dir = dir;
        this.isolates = isolates;
        this.fresh = fresh;
        this.order = order;
    }
    static update(cache, changes) {
        if (changes.empty && !cache.some((c)=>c.fresh)) return cache;
        let result = [], lastDir = cache.length ? cache[cache.length - 1].dir : $1d528cc0e08a0656$export$cacd6541cfeeb6c1.LTR;
        for(let i = Math.max(0, cache.length - 10); i < cache.length; i++){
            let entry = cache[i];
            if (entry.dir == lastDir && !changes.touchesRange(entry.from, entry.to)) result.push(new $1d528cc0e08a0656$var$CachedOrder(changes.mapPos(entry.from, 1), changes.mapPos(entry.to, -1), entry.dir, entry.isolates, false, entry.order));
        }
        return result;
    }
}
function $1d528cc0e08a0656$var$attrsFromFacet(view, facet, base) {
    for(let sources = view.state.facet(facet), i = sources.length - 1; i >= 0; i--){
        let source = sources[i], value = typeof source == "function" ? source(view) : source;
        if (value) $1d528cc0e08a0656$var$combineAttrs(value, base);
    }
    return base;
}
const $1d528cc0e08a0656$var$currentPlatform = $1d528cc0e08a0656$var$browser.mac ? "mac" : $1d528cc0e08a0656$var$browser.windows ? "win" : $1d528cc0e08a0656$var$browser.linux ? "linux" : "key";
function $1d528cc0e08a0656$var$normalizeKeyName(name, platform) {
    const parts = name.split(/-(?!$)/);
    let result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; ++i){
        const mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if (platform == "mac") meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $1d528cc0e08a0656$var$modifiers(name, event, shift) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift !== false && event.shiftKey) name = "Shift-" + name;
    return name;
}
const $1d528cc0e08a0656$var$handleKeyEvents = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$b92464a736444411).default(/*@__PURE__*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.domEventHandlers({
    keydown (event, view) {
        return $1d528cc0e08a0656$var$runHandlers($1d528cc0e08a0656$var$getKeymap(view.state), event, view, "editor");
    }
}));
/**
Facet used for registering keymaps.

You can add multiple keymaps to an editor. Their priorities
determine their precedence (the ones specified early or with high
priority get checked first). When a handler has returned `true`
for a given key, no further handlers are called.
*/ const $1d528cc0e08a0656$export$5043418e2ef368d5 = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    enables: $1d528cc0e08a0656$var$handleKeyEvents
});
const $1d528cc0e08a0656$var$Keymaps = /*@__PURE__*/ new WeakMap();
// This is hidden behind an indirection, rather than directly computed
// by the facet, to keep internal types out of the facet's type.
function $1d528cc0e08a0656$var$getKeymap(state) {
    let bindings = state.facet($1d528cc0e08a0656$export$5043418e2ef368d5);
    let map = $1d528cc0e08a0656$var$Keymaps.get(bindings);
    if (!map) $1d528cc0e08a0656$var$Keymaps.set(bindings, map = $1d528cc0e08a0656$var$buildKeymap(bindings.reduce((a, b)=>a.concat(b), [])));
    return map;
}
/**
Run the key handlers registered for a given scope. The event
object should be a `"keydown"` event. Returns true if any of the
handlers handled it.
*/ function $1d528cc0e08a0656$export$bce154f45536286e(view, event, scope) {
    return $1d528cc0e08a0656$var$runHandlers($1d528cc0e08a0656$var$getKeymap(view.state), event, view, scope);
}
let $1d528cc0e08a0656$var$storedPrefix = null;
const $1d528cc0e08a0656$var$PrefixTimeout = 4000;
function $1d528cc0e08a0656$var$buildKeymap(bindings, platform = $1d528cc0e08a0656$var$currentPlatform) {
    let bound = Object.create(null);
    let isPrefix = Object.create(null);
    let checkPrefix = (name, is)=>{
        let current = isPrefix[name];
        if (current == null) isPrefix[name] = is;
        else if (current != is) throw new Error("Key binding " + name + " is used both as a regular binding and as a multi-stroke prefix");
    };
    let add = (scope, key, command, preventDefault, stopPropagation)=>{
        var _a, _b;
        let scopeObj = bound[scope] || (bound[scope] = Object.create(null));
        let parts = key.split(/ (?!$)/).map((k)=>$1d528cc0e08a0656$var$normalizeKeyName(k, platform));
        for(let i = 1; i < parts.length; i++){
            let prefix = parts.slice(0, i).join(" ");
            checkPrefix(prefix, true);
            if (!scopeObj[prefix]) scopeObj[prefix] = {
                preventDefault: true,
                stopPropagation: false,
                run: [
                    (view)=>{
                        let ourObj = $1d528cc0e08a0656$var$storedPrefix = {
                            view: view,
                            prefix: prefix,
                            scope: scope
                        };
                        setTimeout(()=>{
                            if ($1d528cc0e08a0656$var$storedPrefix == ourObj) $1d528cc0e08a0656$var$storedPrefix = null;
                        }, $1d528cc0e08a0656$var$PrefixTimeout);
                        return true;
                    }
                ]
            };
        }
        let full = parts.join(" ");
        checkPrefix(full, false);
        let binding = scopeObj[full] || (scopeObj[full] = {
            preventDefault: false,
            stopPropagation: false,
            run: ((_b = (_a = scopeObj._any) === null || _a === void 0 ? void 0 : _a.run) === null || _b === void 0 ? void 0 : _b.slice()) || []
        });
        if (command) binding.run.push(command);
        if (preventDefault) binding.preventDefault = true;
        if (stopPropagation) binding.stopPropagation = true;
    };
    for (let b of bindings){
        let scopes = b.scope ? b.scope.split(" ") : [
            "editor"
        ];
        if (b.any) for (let scope of scopes){
            let scopeObj = bound[scope] || (bound[scope] = Object.create(null));
            if (!scopeObj._any) scopeObj._any = {
                preventDefault: false,
                stopPropagation: false,
                run: []
            };
            let { any: any } = b;
            for(let key in scopeObj)scopeObj[key].run.push((view)=>any(view, $1d528cc0e08a0656$var$currentKeyEvent));
        }
        let name = b[platform] || b.key;
        if (!name) continue;
        for (let scope of scopes){
            add(scope, name, b.run, b.preventDefault, b.stopPropagation);
            if (b.shift) add(scope, "Shift-" + name, b.shift, b.preventDefault, b.stopPropagation);
        }
    }
    return bound;
}
let $1d528cc0e08a0656$var$currentKeyEvent = null;
function $1d528cc0e08a0656$var$runHandlers(map, event, view, scope) {
    $1d528cc0e08a0656$var$currentKeyEvent = event;
    let name = (0, $4f3764513e325a7f$export$fb33aafd75404f4c)(event);
    let charCode = (0, $6b8f387faea0a4dd$export$42977f40461e1360)(name, 0), isChar = (0, $6b8f387faea0a4dd$export$a870abf234f6353c)(charCode) == name.length && name != " ";
    let prefix = "", handled = false, prevented = false, stopPropagation = false;
    if ($1d528cc0e08a0656$var$storedPrefix && $1d528cc0e08a0656$var$storedPrefix.view == view && $1d528cc0e08a0656$var$storedPrefix.scope == scope) {
        prefix = $1d528cc0e08a0656$var$storedPrefix.prefix + " ";
        if ($1d528cc0e08a0656$var$modifierCodes.indexOf(event.keyCode) < 0) {
            prevented = true;
            $1d528cc0e08a0656$var$storedPrefix = null;
        }
    }
    let ran = new Set;
    let runFor = (binding)=>{
        if (binding) {
            for (let cmd of binding.run)if (!ran.has(cmd)) {
                ran.add(cmd);
                if (cmd(view)) {
                    if (binding.stopPropagation) stopPropagation = true;
                    return true;
                }
            }
            if (binding.preventDefault) {
                if (binding.stopPropagation) stopPropagation = true;
                prevented = true;
            }
        }
        return false;
    };
    let scopeObj = map[scope], baseName, shiftName;
    if (scopeObj) {
        if (runFor(scopeObj[prefix + $1d528cc0e08a0656$var$modifiers(name, event, !isChar)])) handled = true;
        else if (isChar && (event.altKey || event.metaKey || event.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
        !($1d528cc0e08a0656$var$browser.windows && event.ctrlKey && event.altKey) && // Alt-combinations on macOS tend to be typed characters
        !($1d528cc0e08a0656$var$browser.mac && event.altKey && !event.ctrlKey) && (baseName = (0, $4f3764513e325a7f$export$e2253033e6e1df16)[event.keyCode]) && baseName != name) {
            if (runFor(scopeObj[prefix + $1d528cc0e08a0656$var$modifiers(baseName, event, true)])) handled = true;
            else if (event.shiftKey && (shiftName = (0, $4f3764513e325a7f$export$fba63a578e423eb)[event.keyCode]) != name && shiftName != baseName && runFor(scopeObj[prefix + $1d528cc0e08a0656$var$modifiers(shiftName, event, false)])) handled = true;
        } else if (isChar && event.shiftKey && runFor(scopeObj[prefix + $1d528cc0e08a0656$var$modifiers(name, event, true)])) handled = true;
        if (!handled && runFor(scopeObj._any)) handled = true;
    }
    if (prevented) handled = true;
    if (handled && stopPropagation) event.stopPropagation();
    $1d528cc0e08a0656$var$currentKeyEvent = null;
    return handled;
}
/**
Implementation of [`LayerMarker`](https://codemirror.net/6/docs/ref/#view.LayerMarker) that creates
a rectangle at a given set of coordinates.
*/ class $1d528cc0e08a0656$export$9ddce7bd14f42a78 {
    /**
    Create a marker with the given class and dimensions. If `width`
    is null, the DOM element will get no width style.
    */ constructor(className, /**
    The left position of the marker (in pixels, document-relative).
    */ left, /**
    The top position of the marker.
    */ top, /**
    The width of the marker, or null if it shouldn't get a width assigned.
    */ width, /**
    The height of the marker.
    */ height){
        this.className = className;
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
    }
    draw() {
        let elt = document.createElement("div");
        elt.className = this.className;
        this.adjust(elt);
        return elt;
    }
    update(elt, prev) {
        if (prev.className != this.className) return false;
        this.adjust(elt);
        return true;
    }
    adjust(elt) {
        elt.style.left = this.left + "px";
        elt.style.top = this.top + "px";
        if (this.width != null) elt.style.width = this.width + "px";
        elt.style.height = this.height + "px";
    }
    eq(p) {
        return this.left == p.left && this.top == p.top && this.width == p.width && this.height == p.height && this.className == p.className;
    }
    /**
    Create a set of rectangles for the given selection range,
    assigning them theclass`className`. Will create a single
    rectangle for empty ranges, and a set of selection-style
    rectangles covering the range's content (in a bidi-aware
    way) for non-empty ones.
    */ static forRange(view, className, range) {
        if (range.empty) {
            let pos = view.coordsAtPos(range.head, range.assoc || 1);
            if (!pos) return [];
            let base = $1d528cc0e08a0656$var$getBase(view);
            return [
                new $1d528cc0e08a0656$export$9ddce7bd14f42a78(className, pos.left - base.left, pos.top - base.top, null, pos.bottom - pos.top)
            ];
        } else return $1d528cc0e08a0656$var$rectanglesForRange(view, className, range);
    }
}
function $1d528cc0e08a0656$var$getBase(view) {
    let rect = view.scrollDOM.getBoundingClientRect();
    let left = view.textDirection == $1d528cc0e08a0656$export$cacd6541cfeeb6c1.LTR ? rect.left : rect.right - view.scrollDOM.clientWidth * view.scaleX;
    return {
        left: left - view.scrollDOM.scrollLeft * view.scaleX,
        top: rect.top - view.scrollDOM.scrollTop * view.scaleY
    };
}
function $1d528cc0e08a0656$var$wrappedLine(view, pos, side, inside) {
    let coords = view.coordsAtPos(pos, side * 2);
    if (!coords) return inside;
    let editorRect = view.dom.getBoundingClientRect();
    let y = (coords.top + coords.bottom) / 2;
    let left = view.posAtCoords({
        x: editorRect.left + 1,
        y: y
    });
    let right = view.posAtCoords({
        x: editorRect.right - 1,
        y: y
    });
    if (left == null || right == null) return inside;
    return {
        from: Math.max(inside.from, Math.min(left, right)),
        to: Math.min(inside.to, Math.max(left, right))
    };
}
function $1d528cc0e08a0656$var$rectanglesForRange(view, className, range) {
    if (range.to <= view.viewport.from || range.from >= view.viewport.to) return [];
    let from = Math.max(range.from, view.viewport.from), to = Math.min(range.to, view.viewport.to);
    let ltr = view.textDirection == $1d528cc0e08a0656$export$cacd6541cfeeb6c1.LTR;
    let content = view.contentDOM, contentRect = content.getBoundingClientRect(), base = $1d528cc0e08a0656$var$getBase(view);
    let lineElt = content.querySelector(".cm-line"), lineStyle = lineElt && window.getComputedStyle(lineElt);
    let leftSide = contentRect.left + (lineStyle ? parseInt(lineStyle.paddingLeft) + Math.min(0, parseInt(lineStyle.textIndent)) : 0);
    let rightSide = contentRect.right - (lineStyle ? parseInt(lineStyle.paddingRight) : 0);
    let startBlock = $1d528cc0e08a0656$var$blockAt(view, from, 1), endBlock = $1d528cc0e08a0656$var$blockAt(view, to, -1);
    let visualStart = startBlock.type == $1d528cc0e08a0656$export$48808c686fe495c4.Text ? startBlock : null;
    let visualEnd = endBlock.type == $1d528cc0e08a0656$export$48808c686fe495c4.Text ? endBlock : null;
    if (visualStart && (view.lineWrapping || startBlock.widgetLineBreaks)) visualStart = $1d528cc0e08a0656$var$wrappedLine(view, from, 1, visualStart);
    if (visualEnd && (view.lineWrapping || endBlock.widgetLineBreaks)) visualEnd = $1d528cc0e08a0656$var$wrappedLine(view, to, -1, visualEnd);
    if (visualStart && visualEnd && visualStart.from == visualEnd.from && visualStart.to == visualEnd.to) return pieces(drawForLine(range.from, range.to, visualStart));
    else {
        let top = visualStart ? drawForLine(range.from, null, visualStart) : drawForWidget(startBlock, false);
        let bottom = visualEnd ? drawForLine(null, range.to, visualEnd) : drawForWidget(endBlock, true);
        let between = [];
        if ((visualStart || startBlock).to < (visualEnd || endBlock).from - (visualStart && visualEnd ? 1 : 0) || startBlock.widgetLineBreaks > 1 && top.bottom + view.defaultLineHeight / 2 < bottom.top) between.push(piece(leftSide, top.bottom, rightSide, bottom.top));
        else if (top.bottom < bottom.top && view.elementAtHeight((top.bottom + bottom.top) / 2).type == $1d528cc0e08a0656$export$48808c686fe495c4.Text) top.bottom = bottom.top = (top.bottom + bottom.top) / 2;
        return pieces(top).concat(between).concat(pieces(bottom));
    }
    function piece(left, top, right, bottom) {
        return new $1d528cc0e08a0656$export$9ddce7bd14f42a78(className, left - base.left, top - base.top, right - left, bottom - top);
    }
    function pieces({ top: top, bottom: bottom, horizontal: horizontal }) {
        let pieces = [];
        for(let i = 0; i < horizontal.length; i += 2)pieces.push(piece(horizontal[i], top, horizontal[i + 1], bottom));
        return pieces;
    }
    // Gets passed from/to in line-local positions
    function drawForLine(from, to, line) {
        let top = 1e9, bottom = -1000000000, horizontal = [];
        function addSpan(from, fromOpen, to, toOpen, dir) {
            // Passing 2/-2 is a kludge to force the view to return
            // coordinates on the proper side of block widgets, since
            // normalizing the side there, though appropriate for most
            // coordsAtPos queries, would break selection drawing.
            let fromCoords = view.coordsAtPos(from, from == line.to ? -2 : 2);
            let toCoords = view.coordsAtPos(to, to == line.from ? 2 : -2);
            if (!fromCoords || !toCoords) return;
            top = Math.min(fromCoords.top, toCoords.top, top);
            bottom = Math.max(fromCoords.bottom, toCoords.bottom, bottom);
            if (dir == $1d528cc0e08a0656$export$cacd6541cfeeb6c1.LTR) horizontal.push(ltr && fromOpen ? leftSide : fromCoords.left, ltr && toOpen ? rightSide : toCoords.right);
            else horizontal.push(!ltr && toOpen ? leftSide : toCoords.left, !ltr && fromOpen ? rightSide : fromCoords.right);
        }
        let start = from !== null && from !== void 0 ? from : line.from, end = to !== null && to !== void 0 ? to : line.to;
        // Split the range by visible range and document line
        for (let r of view.visibleRanges)if (r.to > start && r.from < end) for(let pos = Math.max(r.from, start), endPos = Math.min(r.to, end);;){
            let docLine = view.state.doc.lineAt(pos);
            for (let span of view.bidiSpans(docLine)){
                let spanFrom = span.from + docLine.from, spanTo = span.to + docLine.from;
                if (spanFrom >= endPos) break;
                if (spanTo > pos) addSpan(Math.max(spanFrom, pos), from == null && spanFrom <= start, Math.min(spanTo, endPos), to == null && spanTo >= end, span.dir);
            }
            pos = docLine.to + 1;
            if (pos >= endPos) break;
        }
        if (horizontal.length == 0) addSpan(start, from == null, end, to == null, view.textDirection);
        return {
            top: top,
            bottom: bottom,
            horizontal: horizontal
        };
    }
    function drawForWidget(block, top) {
        let y = contentRect.top + (top ? block.top : block.bottom);
        return {
            top: y,
            bottom: y,
            horizontal: []
        };
    }
}
function $1d528cc0e08a0656$var$sameMarker(a, b) {
    return a.constructor == b.constructor && a.eq(b);
}
class $1d528cc0e08a0656$var$LayerView {
    constructor(view, layer){
        this.view = view;
        this.layer = layer;
        this.drawn = [];
        this.scaleX = 1;
        this.scaleY = 1;
        this.measureReq = {
            read: this.measure.bind(this),
            write: this.draw.bind(this)
        };
        this.dom = view.scrollDOM.appendChild(document.createElement("div"));
        this.dom.classList.add("cm-layer");
        if (layer.above) this.dom.classList.add("cm-layer-above");
        if (layer.class) this.dom.classList.add(layer.class);
        this.scale();
        this.dom.setAttribute("aria-hidden", "true");
        this.setOrder(view.state);
        view.requestMeasure(this.measureReq);
        if (layer.mount) layer.mount(this.dom, view);
    }
    update(update) {
        if (update.startState.facet($1d528cc0e08a0656$var$layerOrder) != update.state.facet($1d528cc0e08a0656$var$layerOrder)) this.setOrder(update.state);
        if (this.layer.update(update, this.dom) || update.geometryChanged) {
            this.scale();
            update.view.requestMeasure(this.measureReq);
        }
    }
    docViewUpdate(view) {
        if (this.layer.updateOnDocViewUpdate !== false) view.requestMeasure(this.measureReq);
    }
    setOrder(state) {
        let pos = 0, order = state.facet($1d528cc0e08a0656$var$layerOrder);
        while(pos < order.length && order[pos] != this.layer)pos++;
        this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - pos);
    }
    measure() {
        return this.layer.markers(this.view);
    }
    scale() {
        let { scaleX: scaleX, scaleY: scaleY } = this.view;
        if (scaleX != this.scaleX || scaleY != this.scaleY) {
            this.scaleX = scaleX;
            this.scaleY = scaleY;
            this.dom.style.transform = `scale(${1 / scaleX}, ${1 / scaleY})`;
        }
    }
    draw(markers) {
        if (markers.length != this.drawn.length || markers.some((p, i)=>!$1d528cc0e08a0656$var$sameMarker(p, this.drawn[i]))) {
            let old = this.dom.firstChild, oldI = 0;
            for (let marker of markers)if (marker.update && old && marker.constructor && this.drawn[oldI].constructor && marker.update(old, this.drawn[oldI])) {
                old = old.nextSibling;
                oldI++;
            } else this.dom.insertBefore(marker.draw(), old);
            while(old){
                let next = old.nextSibling;
                old.remove();
                old = next;
            }
            this.drawn = markers;
        }
    }
    destroy() {
        if (this.layer.destroy) this.layer.destroy(this.dom, this.view);
        this.dom.remove();
    }
}
const $1d528cc0e08a0656$var$layerOrder = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
/**
Define a layer.
*/ function $1d528cc0e08a0656$export$50a222d9023da98b(config) {
    return [
        $1d528cc0e08a0656$export$44d5eccfd62adda7.define((v)=>new $1d528cc0e08a0656$var$LayerView(v, config)),
        $1d528cc0e08a0656$var$layerOrder.of(config)
    ];
}
const $1d528cc0e08a0656$var$selectionConfig = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6b8f387faea0a4dd$export$4e19c0b693794a7e)(configs, {
            cursorBlinkRate: 1200,
            drawRangeCursor: true
        }, {
            cursorBlinkRate: (a, b)=>Math.min(a, b),
            drawRangeCursor: (a, b)=>a || b
        });
    }
});
/**
Returns an extension that hides the browser's native selection and
cursor, replacing the selection with a background behind the text
(with the `cm-selectionBackground` class), and the
cursors with elements overlaid over the code (using
`cm-cursor-primary` and `cm-cursor-secondary`).

This allows the editor to display secondary selection ranges, and
tends to produce a type of selection more in line with that users
expect in a text editor (the native selection styling will often
leave gaps between lines and won't fill the horizontal space after
a line when the selection continues past it).

It does have a performance cost, in that it requires an extra DOM
layout cycle for many updates (the selection is drawn based on DOM
layout information that's only available after laying out the
content).
*/ function $1d528cc0e08a0656$export$17a3d0ab3687347d(config = {}) {
    return [
        $1d528cc0e08a0656$var$selectionConfig.of(config),
        $1d528cc0e08a0656$var$cursorLayer,
        $1d528cc0e08a0656$var$selectionLayer,
        $1d528cc0e08a0656$var$hideNativeSelection,
        $1d528cc0e08a0656$var$nativeSelectionHidden.of(true)
    ];
}
/**
Retrieve the [`drawSelection`](https://codemirror.net/6/docs/ref/#view.drawSelection) configuration
for this state. (Note that this will return a set of defaults even
if `drawSelection` isn't enabled.)
*/ function $1d528cc0e08a0656$export$74e411a7b5f41f23(state) {
    return state.facet($1d528cc0e08a0656$var$selectionConfig);
}
function $1d528cc0e08a0656$var$configChanged(update) {
    return update.startState.facet($1d528cc0e08a0656$var$selectionConfig) != update.state.facet($1d528cc0e08a0656$var$selectionConfig);
}
const $1d528cc0e08a0656$var$cursorLayer = /*@__PURE__*/ $1d528cc0e08a0656$export$50a222d9023da98b({
    above: true,
    markers (view) {
        let { state: state } = view, conf = state.facet($1d528cc0e08a0656$var$selectionConfig);
        let cursors = [];
        for (let r of state.selection.ranges){
            let prim = r == state.selection.main;
            if (r.empty || conf.drawRangeCursor) {
                let className = prim ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary";
                let cursor = r.empty ? r : (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(r.head, r.head > r.anchor ? -1 : 1);
                for (let piece of $1d528cc0e08a0656$export$9ddce7bd14f42a78.forRange(view, className, cursor))cursors.push(piece);
            }
        }
        return cursors;
    },
    update (update, dom) {
        if (update.transactions.some((tr)=>tr.selection)) dom.style.animationName = dom.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink";
        let confChange = $1d528cc0e08a0656$var$configChanged(update);
        if (confChange) $1d528cc0e08a0656$var$setBlinkRate(update.state, dom);
        return update.docChanged || update.selectionSet || confChange;
    },
    mount (dom, view) {
        $1d528cc0e08a0656$var$setBlinkRate(view.state, dom);
    },
    class: "cm-cursorLayer"
});
function $1d528cc0e08a0656$var$setBlinkRate(state, dom) {
    dom.style.animationDuration = state.facet($1d528cc0e08a0656$var$selectionConfig).cursorBlinkRate + "ms";
}
const $1d528cc0e08a0656$var$selectionLayer = /*@__PURE__*/ $1d528cc0e08a0656$export$50a222d9023da98b({
    above: false,
    markers (view) {
        return view.state.selection.ranges.map((r)=>r.empty ? [] : $1d528cc0e08a0656$export$9ddce7bd14f42a78.forRange(view, "cm-selectionBackground", r)).reduce((a, b)=>a.concat(b));
    },
    update (update, dom) {
        return update.docChanged || update.selectionSet || update.viewportChanged || $1d528cc0e08a0656$var$configChanged(update);
    },
    class: "cm-selectionLayer"
});
const $1d528cc0e08a0656$var$hideNativeSelection = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$b92464a736444411).highest(/*@__PURE__*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.theme({
    ".cm-line": {
        "& ::selection, &::selection": {
            backgroundColor: "transparent !important"
        },
        caretColor: "transparent !important"
    },
    ".cm-content": {
        caretColor: "transparent !important",
        "& :focus": {
            caretColor: "initial !important",
            "&::selection, & ::selection": {
                backgroundColor: "Highlight !important"
            }
        }
    }
}));
const $1d528cc0e08a0656$var$setDropCursorPos = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define({
    map (pos, mapping) {
        return pos == null ? null : mapping.mapPos(pos);
    }
});
const $1d528cc0e08a0656$var$dropCursorPos = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$34381b1ce2130245).define({
    create () {
        return null;
    },
    update (pos, tr) {
        if (pos != null) pos = tr.changes.mapPos(pos);
        return tr.effects.reduce((pos, e)=>e.is($1d528cc0e08a0656$var$setDropCursorPos) ? e.value : pos, pos);
    }
});
const $1d528cc0e08a0656$var$drawDropCursor = /*@__PURE__*/ $1d528cc0e08a0656$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.cursor = null;
        this.measureReq = {
            read: this.readPos.bind(this),
            write: this.drawCursor.bind(this)
        };
    }
    update(update) {
        var _a;
        let cursorPos = update.state.field($1d528cc0e08a0656$var$dropCursorPos);
        if (cursorPos == null) {
            if (this.cursor != null) {
                (_a = this.cursor) === null || _a === void 0 || _a.remove();
                this.cursor = null;
            }
        } else {
            if (!this.cursor) {
                this.cursor = this.view.scrollDOM.appendChild(document.createElement("div"));
                this.cursor.className = "cm-dropCursor";
            }
            if (update.startState.field($1d528cc0e08a0656$var$dropCursorPos) != cursorPos || update.docChanged || update.geometryChanged) this.view.requestMeasure(this.measureReq);
        }
    }
    readPos() {
        let { view: view } = this;
        let pos = view.state.field($1d528cc0e08a0656$var$dropCursorPos);
        let rect = pos != null && view.coordsAtPos(pos);
        if (!rect) return null;
        let outer = view.scrollDOM.getBoundingClientRect();
        return {
            left: rect.left - outer.left + view.scrollDOM.scrollLeft * view.scaleX,
            top: rect.top - outer.top + view.scrollDOM.scrollTop * view.scaleY,
            height: rect.bottom - rect.top
        };
    }
    drawCursor(pos) {
        if (this.cursor) {
            let { scaleX: scaleX, scaleY: scaleY } = this.view;
            if (pos) {
                this.cursor.style.left = pos.left / scaleX + "px";
                this.cursor.style.top = pos.top / scaleY + "px";
                this.cursor.style.height = pos.height / scaleY + "px";
            } else this.cursor.style.left = "-100000px";
        }
    }
    destroy() {
        if (this.cursor) this.cursor.remove();
    }
    setDropPos(pos) {
        if (this.view.state.field($1d528cc0e08a0656$var$dropCursorPos) != pos) this.view.dispatch({
            effects: $1d528cc0e08a0656$var$setDropCursorPos.of(pos)
        });
    }
}, {
    eventObservers: {
        dragover (event) {
            this.setDropPos(this.view.posAtCoords({
                x: event.clientX,
                y: event.clientY
            }));
        },
        dragleave (event) {
            if (event.target == this.view.contentDOM || !this.view.contentDOM.contains(event.relatedTarget)) this.setDropPos(null);
        },
        dragend () {
            this.setDropPos(null);
        },
        drop () {
            this.setDropPos(null);
        }
    }
});
/**
Draws a cursor at the current drop position when something is
dragged over the editor.
*/ function $1d528cc0e08a0656$export$b8e3092a3bfa2062() {
    return [
        $1d528cc0e08a0656$var$dropCursorPos,
        $1d528cc0e08a0656$var$drawDropCursor
    ];
}
function $1d528cc0e08a0656$var$iterMatches(doc, re, from, to, f) {
    re.lastIndex = 0;
    for(let cursor = doc.iterRange(from, to), pos = from, m; !cursor.next().done; pos += cursor.value.length){
        if (!cursor.lineBreak) while(m = re.exec(cursor.value))f(pos + m.index, m);
    }
}
function $1d528cc0e08a0656$var$matchRanges(view, maxLength) {
    let visible = view.visibleRanges;
    if (visible.length == 1 && visible[0].from == view.viewport.from && visible[0].to == view.viewport.to) return visible;
    let result = [];
    for (let { from: from, to: to } of visible){
        from = Math.max(view.state.doc.lineAt(from).from, from - maxLength);
        to = Math.min(view.state.doc.lineAt(to).to, to + maxLength);
        if (result.length && result[result.length - 1].to >= from) result[result.length - 1].to = to;
        else result.push({
            from: from,
            to: to
        });
    }
    return result;
}
/**
Helper class used to make it easier to maintain decorations on
visible code that matches a given regular expression. To be used
in a [view plugin](https://codemirror.net/6/docs/ref/#view.ViewPlugin). Instances of this object
represent a matching configuration.
*/ class $1d528cc0e08a0656$export$9b928b0ca20b25cb {
    /**
    Create a decorator.
    */ constructor(config){
        const { regexp: regexp, decoration: decoration, decorate: decorate, boundary: boundary, maxLength: maxLength = 1000 } = config;
        if (!regexp.global) throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
        this.regexp = regexp;
        if (decorate) this.addMatch = (match, view, from, add)=>decorate(add, from, from + match[0].length, match, view);
        else if (typeof decoration == "function") this.addMatch = (match, view, from, add)=>{
            let deco = decoration(match, view, from);
            if (deco) add(from, from + match[0].length, deco);
        };
        else if (decoration) this.addMatch = (match, _view, from, add)=>add(from, from + match[0].length, decoration);
        else throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
        this.boundary = boundary;
        this.maxLength = maxLength;
    }
    /**
    Compute the full set of decorations for matches in the given
    view's viewport. You'll want to call this when initializing your
    plugin.
    */ createDeco(view) {
        let build = new (0, $6b8f387faea0a4dd$export$89e09ce03c7e8594)(), add = build.add.bind(build);
        for (let { from: from, to: to } of $1d528cc0e08a0656$var$matchRanges(view, this.maxLength))$1d528cc0e08a0656$var$iterMatches(view.state.doc, this.regexp, from, to, (from, m)=>this.addMatch(m, view, from, add));
        return build.finish();
    }
    /**
    Update a set of decorations for a view update. `deco` _must_ be
    the set of decorations produced by _this_ `MatchDecorator` for
    the view state before the update.
    */ updateDeco(update, deco) {
        let changeFrom = 1e9, changeTo = -1;
        if (update.docChanged) update.changes.iterChanges((_f, _t, from, to)=>{
            if (to >= update.view.viewport.from && from <= update.view.viewport.to) {
                changeFrom = Math.min(from, changeFrom);
                changeTo = Math.max(to, changeTo);
            }
        });
        if (update.viewportMoved || changeTo - changeFrom > 1000) return this.createDeco(update.view);
        if (changeTo > -1) return this.updateRange(update.view, deco.map(update.changes), changeFrom, changeTo);
        return deco;
    }
    updateRange(view, deco, updateFrom, updateTo) {
        for (let r of view.visibleRanges){
            let from = Math.max(r.from, updateFrom), to = Math.min(r.to, updateTo);
            if (to >= from) {
                let fromLine = view.state.doc.lineAt(from), toLine = fromLine.to < to ? view.state.doc.lineAt(to) : fromLine;
                let start = Math.max(r.from, fromLine.from), end = Math.min(r.to, toLine.to);
                if (this.boundary) {
                    for(; from > fromLine.from; from--)if (this.boundary.test(fromLine.text[from - 1 - fromLine.from])) {
                        start = from;
                        break;
                    }
                    for(; to < toLine.to; to++)if (this.boundary.test(toLine.text[to - toLine.from])) {
                        end = to;
                        break;
                    }
                }
                let ranges = [], m;
                let add = (from, to, deco)=>ranges.push(deco.range(from, to));
                if (fromLine == toLine) {
                    this.regexp.lastIndex = start - fromLine.from;
                    while((m = this.regexp.exec(fromLine.text)) && m.index < end - fromLine.from)this.addMatch(m, view, m.index + fromLine.from, add);
                } else $1d528cc0e08a0656$var$iterMatches(view.state.doc, this.regexp, start, end, (from, m)=>this.addMatch(m, view, from, add));
                deco = deco.update({
                    filterFrom: start,
                    filterTo: end,
                    filter: (from, to)=>from < start || to > end,
                    add: ranges
                });
            }
        }
        return deco;
    }
}
const $1d528cc0e08a0656$var$UnicodeRegexpSupport = /x/.unicode != null ? "gu" : "g";
const $1d528cc0e08a0656$var$Specials = /*@__PURE__*/ new RegExp("[\u0000-\u0008\u000a-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\u202d\u202e\u2066\u2067\u2069\ufeff\ufff9-\ufffc]", $1d528cc0e08a0656$var$UnicodeRegexpSupport);
const $1d528cc0e08a0656$var$Names = {
    0: "null",
    7: "bell",
    8: "backspace",
    10: "newline",
    11: "vertical tab",
    13: "carriage return",
    27: "escape",
    8203: "zero width space",
    8204: "zero width non-joiner",
    8205: "zero width joiner",
    8206: "left-to-right mark",
    8207: "right-to-left mark",
    8232: "line separator",
    8237: "left-to-right override",
    8238: "right-to-left override",
    8294: "left-to-right isolate",
    8295: "right-to-left isolate",
    8297: "pop directional isolate",
    8233: "paragraph separator",
    65279: "zero width no-break space",
    65532: "object replacement"
};
let $1d528cc0e08a0656$var$_supportsTabSize = null;
function $1d528cc0e08a0656$var$supportsTabSize() {
    var _a;
    if ($1d528cc0e08a0656$var$_supportsTabSize == null && typeof document != "undefined" && document.body) {
        let styles = document.body.style;
        $1d528cc0e08a0656$var$_supportsTabSize = ((_a = styles.tabSize) !== null && _a !== void 0 ? _a : styles.MozTabSize) != null;
    }
    return $1d528cc0e08a0656$var$_supportsTabSize || false;
}
const $1d528cc0e08a0656$var$specialCharConfig = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        let config = (0, $6b8f387faea0a4dd$export$4e19c0b693794a7e)(configs, {
            render: null,
            specialChars: $1d528cc0e08a0656$var$Specials,
            addSpecialChars: null
        });
        if (config.replaceTabs = !$1d528cc0e08a0656$var$supportsTabSize()) config.specialChars = new RegExp("\t|" + config.specialChars.source, $1d528cc0e08a0656$var$UnicodeRegexpSupport);
        if (config.addSpecialChars) config.specialChars = new RegExp(config.specialChars.source + "|" + config.addSpecialChars.source, $1d528cc0e08a0656$var$UnicodeRegexpSupport);
        return config;
    }
});
/**
Returns an extension that installs highlighting of special
characters.
*/ function $1d528cc0e08a0656$export$76dc0899547f659c(/**
Configuration options.
*/ config = {}) {
    return [
        $1d528cc0e08a0656$var$specialCharConfig.of(config),
        $1d528cc0e08a0656$var$specialCharPlugin()
    ];
}
let $1d528cc0e08a0656$var$_plugin = null;
function $1d528cc0e08a0656$var$specialCharPlugin() {
    return $1d528cc0e08a0656$var$_plugin || ($1d528cc0e08a0656$var$_plugin = $1d528cc0e08a0656$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.decorations = $1d528cc0e08a0656$export$10e30b733df217ea.none;
            this.decorationCache = Object.create(null);
            this.decorator = this.makeDecorator(view.state.facet($1d528cc0e08a0656$var$specialCharConfig));
            this.decorations = this.decorator.createDeco(view);
        }
        makeDecorator(conf) {
            return new $1d528cc0e08a0656$export$9b928b0ca20b25cb({
                regexp: conf.specialChars,
                decoration: (m, view, pos)=>{
                    let { doc: doc } = view.state;
                    let code = (0, $6b8f387faea0a4dd$export$42977f40461e1360)(m[0], 0);
                    if (code == 9) {
                        let line = doc.lineAt(pos);
                        let size = view.state.tabSize, col = (0, $6b8f387faea0a4dd$export$20b4ab289374d0ac)(line.text, size, pos - line.from);
                        return $1d528cc0e08a0656$export$10e30b733df217ea.replace({
                            widget: new $1d528cc0e08a0656$var$TabWidget((size - col % size) * this.view.defaultCharacterWidth / this.view.scaleX)
                        });
                    }
                    return this.decorationCache[code] || (this.decorationCache[code] = $1d528cc0e08a0656$export$10e30b733df217ea.replace({
                        widget: new $1d528cc0e08a0656$var$SpecialCharWidget(conf, code)
                    }));
                },
                boundary: conf.replaceTabs ? undefined : /[^]/
            });
        }
        update(update) {
            let conf = update.state.facet($1d528cc0e08a0656$var$specialCharConfig);
            if (update.startState.facet($1d528cc0e08a0656$var$specialCharConfig) != conf) {
                this.decorator = this.makeDecorator(conf);
                this.decorations = this.decorator.createDeco(update.view);
            } else this.decorations = this.decorator.updateDeco(update, this.decorations);
        }
    }, {
        decorations: (v)=>v.decorations
    }));
}
const $1d528cc0e08a0656$var$DefaultPlaceholder = "\u2022";
// Assigns placeholder characters from the Control Pictures block to
// ASCII control characters
function $1d528cc0e08a0656$var$placeholder$1(code) {
    if (code >= 32) return $1d528cc0e08a0656$var$DefaultPlaceholder;
    if (code == 10) return "\u2424";
    return String.fromCharCode(9216 + code);
}
class $1d528cc0e08a0656$var$SpecialCharWidget extends $1d528cc0e08a0656$export$95cdd842edb044c5 {
    constructor(options, code){
        super();
        this.options = options;
        this.code = code;
    }
    eq(other) {
        return other.code == this.code;
    }
    toDOM(view) {
        let ph = $1d528cc0e08a0656$var$placeholder$1(this.code);
        let desc = view.state.phrase("Control character") + " " + ($1d528cc0e08a0656$var$Names[this.code] || "0x" + this.code.toString(16));
        let custom = this.options.render && this.options.render(this.code, desc, ph);
        if (custom) return custom;
        let span = document.createElement("span");
        span.textContent = ph;
        span.title = desc;
        span.setAttribute("aria-label", desc);
        span.className = "cm-specialChar";
        return span;
    }
    ignoreEvent() {
        return false;
    }
}
class $1d528cc0e08a0656$var$TabWidget extends $1d528cc0e08a0656$export$95cdd842edb044c5 {
    constructor(width){
        super();
        this.width = width;
    }
    eq(other) {
        return other.width == this.width;
    }
    toDOM() {
        let span = document.createElement("span");
        span.textContent = "\t";
        span.className = "cm-tab";
        span.style.width = this.width + "px";
        return span;
    }
    ignoreEvent() {
        return false;
    }
}
const $1d528cc0e08a0656$var$plugin = /*@__PURE__*/ $1d528cc0e08a0656$export$44d5eccfd62adda7.fromClass(class {
    constructor(){
        this.height = 1000;
        this.attrs = {
            style: "padding-bottom: 1000px"
        };
    }
    update(update) {
        let { view: view } = update;
        let height = view.viewState.editorHeight - view.defaultLineHeight - view.documentPadding.top - 0.5;
        if (height >= 0 && height != this.height) {
            this.height = height;
            this.attrs = {
                style: `padding-bottom: ${height}px`
            };
        }
    }
});
/**
Returns an extension that makes sure the content has a bottom
margin equivalent to the height of the editor, minus one line
height, so that every line in the document can be scrolled to the
top of the editor.

This is only meaningful when the editor is scrollable, and should
not be enabled in editors that take the size of their content.
*/ function $1d528cc0e08a0656$export$1f905ef5d6deb4f() {
    return [
        $1d528cc0e08a0656$var$plugin,
        $1d528cc0e08a0656$var$contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin($1d528cc0e08a0656$var$plugin)) === null || _a === void 0 ? void 0 : _a.attrs) || null;
        })
    ];
}
/**
Mark lines that have a cursor on them with the `"cm-activeLine"`
DOM class.
*/ function $1d528cc0e08a0656$export$1a7e096bee9035c() {
    return $1d528cc0e08a0656$var$activeLineHighlighter;
}
const $1d528cc0e08a0656$var$lineDeco = /*@__PURE__*/ $1d528cc0e08a0656$export$10e30b733df217ea.line({
    class: "cm-activeLine"
});
const $1d528cc0e08a0656$var$activeLineHighlighter = /*@__PURE__*/ $1d528cc0e08a0656$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.decorations = this.getDeco(view);
    }
    update(update) {
        if (update.docChanged || update.selectionSet) this.decorations = this.getDeco(update.view);
    }
    getDeco(view) {
        let lastLineStart = -1, deco = [];
        for (let r of view.state.selection.ranges){
            let line = view.lineBlockAt(r.head);
            if (line.from > lastLineStart) {
                deco.push($1d528cc0e08a0656$var$lineDeco.range(line.from));
                lastLineStart = line.from;
            }
        }
        return $1d528cc0e08a0656$export$10e30b733df217ea.set(deco);
    }
}, {
    decorations: (v)=>v.decorations
});
class $1d528cc0e08a0656$var$Placeholder extends $1d528cc0e08a0656$export$95cdd842edb044c5 {
    constructor(content){
        super();
        this.content = content;
    }
    toDOM(view) {
        let wrap = document.createElement("span");
        wrap.className = "cm-placeholder";
        wrap.style.pointerEvents = "none";
        wrap.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : typeof this.content == "function" ? this.content(view) : this.content.cloneNode(true));
        wrap.setAttribute("aria-hidden", "true");
        return wrap;
    }
    coordsAt(dom) {
        let rects = dom.firstChild ? $1d528cc0e08a0656$var$clientRectsFor(dom.firstChild) : [];
        if (!rects.length) return null;
        let style = window.getComputedStyle(dom.parentNode);
        let rect = $1d528cc0e08a0656$var$flattenRect(rects[0], style.direction != "rtl");
        let lineHeight = parseInt(style.lineHeight);
        if (rect.bottom - rect.top > lineHeight * 1.5) return {
            left: rect.left,
            right: rect.right,
            top: rect.top,
            bottom: rect.top + lineHeight
        };
        return rect;
    }
    ignoreEvent() {
        return false;
    }
}
/**
Extension that enables a placeholder—a piece of example content
to show when the editor is empty.
*/ function $1d528cc0e08a0656$export$c7187bbd1a7a9244(content) {
    let plugin = $1d528cc0e08a0656$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.placeholder = content ? $1d528cc0e08a0656$export$10e30b733df217ea.set([
                $1d528cc0e08a0656$export$10e30b733df217ea.widget({
                    widget: new $1d528cc0e08a0656$var$Placeholder(content),
                    side: 1
                }).range(0)
            ]) : $1d528cc0e08a0656$export$10e30b733df217ea.none;
        }
        get decorations() {
            return this.view.state.doc.length ? $1d528cc0e08a0656$export$10e30b733df217ea.none : this.placeholder;
        }
    }, {
        decorations: (v)=>v.decorations
    });
    return typeof content == "string" ? [
        plugin,
        $1d528cc0e08a0656$export$eece2fccabbb77c5.contentAttributes.of({
            "aria-placeholder": content
        })
    ] : plugin;
}
// Don't compute precise column positions for line offsets above this
// (since it could get expensive). Assume offset==column for them.
const $1d528cc0e08a0656$var$MaxOff = 2000;
function $1d528cc0e08a0656$var$rectangleFor(state, a, b) {
    let startLine = Math.min(a.line, b.line), endLine = Math.max(a.line, b.line);
    let ranges = [];
    if (a.off > $1d528cc0e08a0656$var$MaxOff || b.off > $1d528cc0e08a0656$var$MaxOff || a.col < 0 || b.col < 0) {
        let startOff = Math.min(a.off, b.off), endOff = Math.max(a.off, b.off);
        for(let i = startLine; i <= endLine; i++){
            let line = state.doc.line(i);
            if (line.length <= endOff) ranges.push((0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(line.from + startOff, line.to + endOff));
        }
    } else {
        let startCol = Math.min(a.col, b.col), endCol = Math.max(a.col, b.col);
        for(let i = startLine; i <= endLine; i++){
            let line = state.doc.line(i);
            let start = (0, $6b8f387faea0a4dd$export$718b3d71c384ca05)(line.text, startCol, state.tabSize, true);
            if (start < 0) ranges.push((0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(line.to));
            else {
                let end = (0, $6b8f387faea0a4dd$export$718b3d71c384ca05)(line.text, endCol, state.tabSize);
                ranges.push((0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(line.from + start, line.from + end));
            }
        }
    }
    return ranges;
}
function $1d528cc0e08a0656$var$absoluteColumn(view, x) {
    let ref = view.coordsAtPos(view.viewport.from);
    return ref ? Math.round(Math.abs((ref.left - x) / view.defaultCharacterWidth)) : -1;
}
function $1d528cc0e08a0656$var$getPos(view, event) {
    let offset = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    let line = view.state.doc.lineAt(offset), off = offset - line.from;
    let col = off > $1d528cc0e08a0656$var$MaxOff ? -1 : off == line.length ? $1d528cc0e08a0656$var$absoluteColumn(view, event.clientX) : (0, $6b8f387faea0a4dd$export$20b4ab289374d0ac)(line.text, view.state.tabSize, offset - line.from);
    return {
        line: line.number,
        col: col,
        off: off
    };
}
function $1d528cc0e08a0656$var$rectangleSelectionStyle(view, event) {
    let start = $1d528cc0e08a0656$var$getPos(view, event), startSel = view.state.selection;
    if (!start) return null;
    return {
        update (update) {
            if (update.docChanged) {
                let newStart = update.changes.mapPos(update.startState.doc.line(start.line).from);
                let newLine = update.state.doc.lineAt(newStart);
                start = {
                    line: newLine.number,
                    col: start.col,
                    off: Math.min(start.off, newLine.length)
                };
                startSel = startSel.map(update.changes);
            }
        },
        get (event, _extend, multiple) {
            let cur = $1d528cc0e08a0656$var$getPos(view, event);
            if (!cur) return startSel;
            let ranges = $1d528cc0e08a0656$var$rectangleFor(view.state, start, cur);
            if (!ranges.length) return startSel;
            if (multiple) return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).create(ranges.concat(startSel.ranges));
            else return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).create(ranges);
        }
    };
}
/**
Create an extension that enables rectangular selections. By
default, it will react to left mouse drag with the Alt key held
down. When such a selection occurs, the text within the rectangle
that was dragged over will be selected, as one selection
[range](https://codemirror.net/6/docs/ref/#state.SelectionRange) per line.
*/ function $1d528cc0e08a0656$export$dd482925db1aabd3(options) {
    let filter = (options === null || options === void 0 ? void 0 : options.eventFilter) || ((e)=>e.altKey && e.button == 0);
    return $1d528cc0e08a0656$export$eece2fccabbb77c5.mouseSelectionStyle.of((view, event)=>filter(event) ? $1d528cc0e08a0656$var$rectangleSelectionStyle(view, event) : null);
}
const $1d528cc0e08a0656$var$keys = {
    Alt: [
        18,
        (e)=>!!e.altKey
    ],
    Control: [
        17,
        (e)=>!!e.ctrlKey
    ],
    Shift: [
        16,
        (e)=>!!e.shiftKey
    ],
    Meta: [
        91,
        (e)=>!!e.metaKey
    ]
};
const $1d528cc0e08a0656$var$showCrosshair = {
    style: "cursor: crosshair"
};
/**
Returns an extension that turns the pointer cursor into a
crosshair when a given modifier key, defaulting to Alt, is held
down. Can serve as a visual hint that rectangular selection is
going to happen when paired with
[`rectangularSelection`](https://codemirror.net/6/docs/ref/#view.rectangularSelection).
*/ function $1d528cc0e08a0656$export$9b6525222ac3b7fb(options = {}) {
    let [code, getter] = $1d528cc0e08a0656$var$keys[options.key || "Alt"];
    let plugin = $1d528cc0e08a0656$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.isDown = false;
        }
        set(isDown) {
            if (this.isDown != isDown) {
                this.isDown = isDown;
                this.view.update([]);
            }
        }
    }, {
        eventObservers: {
            keydown (e) {
                this.set(e.keyCode == code || getter(e));
            },
            keyup (e) {
                if (e.keyCode == code || !getter(e)) this.set(false);
            },
            mousemove (e) {
                this.set(getter(e));
            }
        }
    });
    return [
        plugin,
        $1d528cc0e08a0656$export$eece2fccabbb77c5.contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin(plugin)) === null || _a === void 0 ? void 0 : _a.isDown) ? $1d528cc0e08a0656$var$showCrosshair : null;
        })
    ];
}
const $1d528cc0e08a0656$var$Outside = "-10000px";
class $1d528cc0e08a0656$var$TooltipViewManager {
    constructor(view, facet, createTooltipView, removeTooltipView){
        this.facet = facet;
        this.createTooltipView = createTooltipView;
        this.removeTooltipView = removeTooltipView;
        this.input = view.state.facet(facet);
        this.tooltips = this.input.filter((t)=>t);
        let prev = null;
        this.tooltipViews = this.tooltips.map((t)=>prev = createTooltipView(t, prev));
    }
    update(update, above) {
        var _a;
        let input = update.state.facet(this.facet);
        let tooltips = input.filter((x)=>x);
        if (input === this.input) {
            for (let t of this.tooltipViews)if (t.update) t.update(update);
            return false;
        }
        let tooltipViews = [], newAbove = above ? [] : null;
        for(let i = 0; i < tooltips.length; i++){
            let tip = tooltips[i], known = -1;
            if (!tip) continue;
            for(let i = 0; i < this.tooltips.length; i++){
                let other = this.tooltips[i];
                if (other && other.create == tip.create) known = i;
            }
            if (known < 0) {
                tooltipViews[i] = this.createTooltipView(tip, i ? tooltipViews[i - 1] : null);
                if (newAbove) newAbove[i] = !!tip.above;
            } else {
                let tooltipView = tooltipViews[i] = this.tooltipViews[known];
                if (newAbove) newAbove[i] = above[known];
                if (tooltipView.update) tooltipView.update(update);
            }
        }
        for (let t of this.tooltipViews)if (tooltipViews.indexOf(t) < 0) {
            this.removeTooltipView(t);
            (_a = t.destroy) === null || _a === void 0 || _a.call(t);
        }
        if (above) {
            newAbove.forEach((val, i)=>above[i] = val);
            above.length = newAbove.length;
        }
        this.input = input;
        this.tooltips = tooltips;
        this.tooltipViews = tooltipViews;
        return true;
    }
}
/**
Creates an extension that configures tooltip behavior.
*/ function $1d528cc0e08a0656$export$1fc29293196e3bc(config = {}) {
    return $1d528cc0e08a0656$var$tooltipConfig.of(config);
}
function $1d528cc0e08a0656$var$windowSpace(view) {
    let docElt = view.dom.ownerDocument.documentElement;
    return {
        top: 0,
        left: 0,
        bottom: docElt.clientHeight,
        right: docElt.clientWidth
    };
}
const $1d528cc0e08a0656$var$tooltipConfig = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine: (values)=>{
        var _a, _b, _c;
        return {
            position: $1d528cc0e08a0656$var$browser.ios ? "absolute" : ((_a = values.find((conf)=>conf.position)) === null || _a === void 0 ? void 0 : _a.position) || "fixed",
            parent: ((_b = values.find((conf)=>conf.parent)) === null || _b === void 0 ? void 0 : _b.parent) || null,
            tooltipSpace: ((_c = values.find((conf)=>conf.tooltipSpace)) === null || _c === void 0 ? void 0 : _c.tooltipSpace) || $1d528cc0e08a0656$var$windowSpace
        };
    }
});
const $1d528cc0e08a0656$var$knownHeight = /*@__PURE__*/ new WeakMap();
const $1d528cc0e08a0656$var$tooltipPlugin = /*@__PURE__*/ $1d528cc0e08a0656$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.above = [];
        this.inView = true;
        this.madeAbsolute = false;
        this.lastTransaction = 0;
        this.measureTimeout = -1;
        let config = view.state.facet($1d528cc0e08a0656$var$tooltipConfig);
        this.position = config.position;
        this.parent = config.parent;
        this.classes = view.themeClasses;
        this.createContainer();
        this.measureReq = {
            read: this.readMeasure.bind(this),
            write: this.writeMeasure.bind(this),
            key: this
        };
        this.resizeObserver = typeof ResizeObserver == "function" ? new ResizeObserver(()=>this.measureSoon()) : null;
        this.manager = new $1d528cc0e08a0656$var$TooltipViewManager(view, $1d528cc0e08a0656$export$dba11b50e1aa3c12, (t, p)=>this.createTooltip(t, p), (t)=>{
            if (this.resizeObserver) this.resizeObserver.unobserve(t.dom);
            t.dom.remove();
        });
        this.above = this.manager.tooltips.map((t)=>!!t.above);
        this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((entries)=>{
            if (Date.now() > this.lastTransaction - 50 && entries.length > 0 && entries[entries.length - 1].intersectionRatio < 1) this.measureSoon();
        }, {
            threshold: [
                1
            ]
        }) : null;
        this.observeIntersection();
        view.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this));
        this.maybeMeasure();
    }
    createContainer() {
        if (this.parent) {
            this.container = document.createElement("div");
            this.container.style.position = "relative";
            this.container.className = this.view.themeClasses;
            this.parent.appendChild(this.container);
        } else this.container = this.view.dom;
    }
    observeIntersection() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            for (let tooltip of this.manager.tooltipViews)this.intersectionObserver.observe(tooltip.dom);
        }
    }
    measureSoon() {
        if (this.measureTimeout < 0) this.measureTimeout = setTimeout(()=>{
            this.measureTimeout = -1;
            this.maybeMeasure();
        }, 50);
    }
    update(update) {
        if (update.transactions.length) this.lastTransaction = Date.now();
        let updated = this.manager.update(update, this.above);
        if (updated) this.observeIntersection();
        let shouldMeasure = updated || update.geometryChanged;
        let newConfig = update.state.facet($1d528cc0e08a0656$var$tooltipConfig);
        if (newConfig.position != this.position && !this.madeAbsolute) {
            this.position = newConfig.position;
            for (let t of this.manager.tooltipViews)t.dom.style.position = this.position;
            shouldMeasure = true;
        }
        if (newConfig.parent != this.parent) {
            if (this.parent) this.container.remove();
            this.parent = newConfig.parent;
            this.createContainer();
            for (let t of this.manager.tooltipViews)this.container.appendChild(t.dom);
            shouldMeasure = true;
        } else if (this.parent && this.view.themeClasses != this.classes) this.classes = this.container.className = this.view.themeClasses;
        if (shouldMeasure) this.maybeMeasure();
    }
    createTooltip(tooltip, prev) {
        let tooltipView = tooltip.create(this.view);
        let before = prev ? prev.dom : null;
        tooltipView.dom.classList.add("cm-tooltip");
        if (tooltip.arrow && !tooltipView.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
            let arrow = document.createElement("div");
            arrow.className = "cm-tooltip-arrow";
            tooltipView.dom.appendChild(arrow);
        }
        tooltipView.dom.style.position = this.position;
        tooltipView.dom.style.top = $1d528cc0e08a0656$var$Outside;
        tooltipView.dom.style.left = "0px";
        this.container.insertBefore(tooltipView.dom, before);
        if (tooltipView.mount) tooltipView.mount(this.view);
        if (this.resizeObserver) this.resizeObserver.observe(tooltipView.dom);
        return tooltipView;
    }
    destroy() {
        var _a, _b, _c;
        this.view.win.removeEventListener("resize", this.measureSoon);
        for (let tooltipView of this.manager.tooltipViews){
            tooltipView.dom.remove();
            (_a = tooltipView.destroy) === null || _a === void 0 || _a.call(tooltipView);
        }
        if (this.parent) this.container.remove();
        (_b = this.resizeObserver) === null || _b === void 0 || _b.disconnect();
        (_c = this.intersectionObserver) === null || _c === void 0 || _c.disconnect();
        clearTimeout(this.measureTimeout);
    }
    readMeasure() {
        let scaleX = 1, scaleY = 1, makeAbsolute = false;
        if (this.position == "fixed" && this.manager.tooltipViews.length) {
            let { dom: dom } = this.manager.tooltipViews[0];
            if ($1d528cc0e08a0656$var$browser.gecko) // Firefox sets the element's `offsetParent` to the
            // transformed element when a transform interferes with fixed
            // positioning.
            makeAbsolute = dom.offsetParent != this.container.ownerDocument.body;
            else if (dom.style.top == $1d528cc0e08a0656$var$Outside && dom.style.left == "0px") {
                // On other browsers, we have to awkwardly try and use other
                // information to detect a transform.
                let rect = dom.getBoundingClientRect();
                makeAbsolute = Math.abs(rect.top + 10000) > 1 || Math.abs(rect.left) > 1;
            }
        }
        if (makeAbsolute || this.position == "absolute") {
            if (this.parent) {
                let rect = this.parent.getBoundingClientRect();
                if (rect.width && rect.height) {
                    scaleX = rect.width / this.parent.offsetWidth;
                    scaleY = rect.height / this.parent.offsetHeight;
                }
            } else ({ scaleX: scaleX, scaleY: scaleY } = this.view.viewState);
        }
        let visible = this.view.scrollDOM.getBoundingClientRect(), margins = $1d528cc0e08a0656$var$getScrollMargins(this.view);
        return {
            visible: {
                left: visible.left + margins.left,
                top: visible.top + margins.top,
                right: visible.right - margins.right,
                bottom: visible.bottom - margins.bottom
            },
            parent: this.parent ? this.container.getBoundingClientRect() : this.view.dom.getBoundingClientRect(),
            pos: this.manager.tooltips.map((t, i)=>{
                let tv = this.manager.tooltipViews[i];
                return tv.getCoords ? tv.getCoords(t.pos) : this.view.coordsAtPos(t.pos);
            }),
            size: this.manager.tooltipViews.map(({ dom: dom })=>dom.getBoundingClientRect()),
            space: this.view.state.facet($1d528cc0e08a0656$var$tooltipConfig).tooltipSpace(this.view),
            scaleX: scaleX,
            scaleY: scaleY,
            makeAbsolute: makeAbsolute
        };
    }
    writeMeasure(measured) {
        var _a;
        if (measured.makeAbsolute) {
            this.madeAbsolute = true;
            this.position = "absolute";
            for (let t of this.manager.tooltipViews)t.dom.style.position = "absolute";
        }
        let { visible: visible, space: space, scaleX: scaleX, scaleY: scaleY } = measured;
        let others = [];
        for(let i = 0; i < this.manager.tooltips.length; i++){
            let tooltip = this.manager.tooltips[i], tView = this.manager.tooltipViews[i], { dom: dom } = tView;
            let pos = measured.pos[i], size = measured.size[i];
            // Hide tooltips that are outside of the editor.
            if (!pos || tooltip.clip !== false && (pos.bottom <= Math.max(visible.top, space.top) || pos.top >= Math.min(visible.bottom, space.bottom) || pos.right < Math.max(visible.left, space.left) - .1 || pos.left > Math.min(visible.right, space.right) + .1)) {
                dom.style.top = $1d528cc0e08a0656$var$Outside;
                continue;
            }
            let arrow = tooltip.arrow ? tView.dom.querySelector(".cm-tooltip-arrow") : null;
            let arrowHeight = arrow ? 7 /* Arrow.Size */  : 0;
            let width = size.right - size.left, height = (_a = $1d528cc0e08a0656$var$knownHeight.get(tView)) !== null && _a !== void 0 ? _a : size.bottom - size.top;
            let offset = tView.offset || $1d528cc0e08a0656$var$noOffset, ltr = this.view.textDirection == $1d528cc0e08a0656$export$cacd6541cfeeb6c1.LTR;
            let left = size.width > space.right - space.left ? ltr ? space.left : space.right - size.width : ltr ? Math.max(space.left, Math.min(pos.left - (arrow ? 14 /* Arrow.Offset */  : 0) + offset.x, space.right - width)) : Math.min(Math.max(space.left, pos.left - width + (arrow ? 14 /* Arrow.Offset */  : 0) - offset.x), space.right - width);
            let above = this.above[i];
            if (!tooltip.strictSide && (above ? pos.top - height - arrowHeight - offset.y < space.top : pos.bottom + height + arrowHeight + offset.y > space.bottom) && above == space.bottom - pos.bottom > pos.top - space.top) above = this.above[i] = !above;
            let spaceVert = (above ? pos.top - space.top : space.bottom - pos.bottom) - arrowHeight;
            if (spaceVert < height && tView.resize !== false) {
                if (spaceVert < this.view.defaultLineHeight) {
                    dom.style.top = $1d528cc0e08a0656$var$Outside;
                    continue;
                }
                $1d528cc0e08a0656$var$knownHeight.set(tView, height);
                dom.style.height = (height = spaceVert) / scaleY + "px";
            } else if (dom.style.height) dom.style.height = "";
            let top = above ? pos.top - height - arrowHeight - offset.y : pos.bottom + arrowHeight + offset.y;
            let right = left + width;
            if (tView.overlap !== true) {
                for (let r of others)if (r.left < right && r.right > left && r.top < top + height && r.bottom > top) top = above ? r.top - height - 2 - arrowHeight : r.bottom + arrowHeight + 2;
            }
            if (this.position == "absolute") {
                dom.style.top = (top - measured.parent.top) / scaleY + "px";
                $1d528cc0e08a0656$var$setLeftStyle(dom, (left - measured.parent.left) / scaleX);
            } else {
                dom.style.top = top / scaleY + "px";
                $1d528cc0e08a0656$var$setLeftStyle(dom, left / scaleX);
            }
            if (arrow) {
                let arrowLeft = pos.left + (ltr ? offset.x : -offset.x) - (left + 14 /* Arrow.Offset */  - 7 /* Arrow.Size */ );
                arrow.style.left = arrowLeft / scaleX + "px";
            }
            if (tView.overlap !== true) others.push({
                left: left,
                top: top,
                right: right,
                bottom: top + height
            });
            dom.classList.toggle("cm-tooltip-above", above);
            dom.classList.toggle("cm-tooltip-below", !above);
            if (tView.positioned) tView.positioned(measured.space);
        }
    }
    maybeMeasure() {
        if (this.manager.tooltips.length) {
            if (this.view.inView) this.view.requestMeasure(this.measureReq);
            if (this.inView != this.view.inView) {
                this.inView = this.view.inView;
                if (!this.inView) for (let tv of this.manager.tooltipViews)tv.dom.style.top = $1d528cc0e08a0656$var$Outside;
            }
        }
    }
}, {
    eventObservers: {
        scroll () {
            this.maybeMeasure();
        }
    }
});
function $1d528cc0e08a0656$var$setLeftStyle(elt, value) {
    let current = parseInt(elt.style.left, 10);
    if (isNaN(current) || Math.abs(value - current) > 1) elt.style.left = value + "px";
}
const $1d528cc0e08a0656$var$baseTheme = /*@__PURE__*/ $1d528cc0e08a0656$export$eece2fccabbb77c5.baseTheme({
    ".cm-tooltip": {
        zIndex: 500,
        boxSizing: "border-box"
    },
    "&light .cm-tooltip": {
        border: "1px solid #bbb",
        backgroundColor: "#f5f5f5"
    },
    "&light .cm-tooltip-section:not(:first-child)": {
        borderTop: "1px solid #bbb"
    },
    "&dark .cm-tooltip": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-tooltip-arrow": {
        height: `${7 /* Arrow.Size */ }px`,
        width: `${14}px`,
        position: "absolute",
        zIndex: -1,
        overflow: "hidden",
        "&:before, &:after": {
            content: "''",
            position: "absolute",
            width: 0,
            height: 0,
            borderLeft: `${7 /* Arrow.Size */ }px solid transparent`,
            borderRight: `${7 /* Arrow.Size */ }px solid transparent`
        },
        ".cm-tooltip-above &": {
            bottom: `-${7 /* Arrow.Size */ }px`,
            "&:before": {
                borderTop: `${7 /* Arrow.Size */ }px solid #bbb`
            },
            "&:after": {
                borderTop: `${7 /* Arrow.Size */ }px solid #f5f5f5`,
                bottom: "1px"
            }
        },
        ".cm-tooltip-below &": {
            top: `-${7 /* Arrow.Size */ }px`,
            "&:before": {
                borderBottom: `${7 /* Arrow.Size */ }px solid #bbb`
            },
            "&:after": {
                borderBottom: `${7 /* Arrow.Size */ }px solid #f5f5f5`,
                top: "1px"
            }
        }
    },
    "&dark .cm-tooltip .cm-tooltip-arrow": {
        "&:before": {
            borderTopColor: "#333338",
            borderBottomColor: "#333338"
        },
        "&:after": {
            borderTopColor: "transparent",
            borderBottomColor: "transparent"
        }
    }
});
const $1d528cc0e08a0656$var$noOffset = {
    x: 0,
    y: 0
};
/**
Facet to which an extension can add a value to show a tooltip.
*/ const $1d528cc0e08a0656$export$dba11b50e1aa3c12 = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    enables: [
        $1d528cc0e08a0656$var$tooltipPlugin,
        $1d528cc0e08a0656$var$baseTheme
    ]
});
const $1d528cc0e08a0656$var$showHoverTooltip = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine: (inputs)=>inputs.reduce((a, i)=>a.concat(i), [])
});
class $1d528cc0e08a0656$var$HoverTooltipHost {
    // Needs to be static so that host tooltip instances always match
    static create(view) {
        return new $1d528cc0e08a0656$var$HoverTooltipHost(view);
    }
    constructor(view){
        this.view = view;
        this.mounted = false;
        this.dom = document.createElement("div");
        this.dom.classList.add("cm-tooltip-hover");
        this.manager = new $1d528cc0e08a0656$var$TooltipViewManager(view, $1d528cc0e08a0656$var$showHoverTooltip, (t, p)=>this.createHostedView(t, p), (t)=>t.dom.remove());
    }
    createHostedView(tooltip, prev) {
        let hostedView = tooltip.create(this.view);
        hostedView.dom.classList.add("cm-tooltip-section");
        this.dom.insertBefore(hostedView.dom, prev ? prev.dom.nextSibling : this.dom.firstChild);
        if (this.mounted && hostedView.mount) hostedView.mount(this.view);
        return hostedView;
    }
    mount(view) {
        for (let hostedView of this.manager.tooltipViews)if (hostedView.mount) hostedView.mount(view);
        this.mounted = true;
    }
    positioned(space) {
        for (let hostedView of this.manager.tooltipViews)if (hostedView.positioned) hostedView.positioned(space);
    }
    update(update) {
        this.manager.update(update);
    }
    destroy() {
        var _a;
        for (let t of this.manager.tooltipViews)(_a = t.destroy) === null || _a === void 0 || _a.call(t);
    }
    passProp(name) {
        let value = undefined;
        for (let view of this.manager.tooltipViews){
            let given = view[name];
            if (given !== undefined) {
                if (value === undefined) value = given;
                else if (value !== given) return undefined;
            }
        }
        return value;
    }
    get offset() {
        return this.passProp("offset");
    }
    get getCoords() {
        return this.passProp("getCoords");
    }
    get overlap() {
        return this.passProp("overlap");
    }
    get resize() {
        return this.passProp("resize");
    }
}
const $1d528cc0e08a0656$var$showHoverTooltipHost = /*@__PURE__*/ $1d528cc0e08a0656$export$dba11b50e1aa3c12.compute([
    $1d528cc0e08a0656$var$showHoverTooltip
], (state)=>{
    let tooltips = state.facet($1d528cc0e08a0656$var$showHoverTooltip);
    if (tooltips.length === 0) return null;
    return {
        pos: Math.min(...tooltips.map((t)=>t.pos)),
        end: Math.max(...tooltips.map((t)=>{
            var _a;
            return (_a = t.end) !== null && _a !== void 0 ? _a : t.pos;
        })),
        create: $1d528cc0e08a0656$var$HoverTooltipHost.create,
        above: tooltips[0].above,
        arrow: tooltips.some((t)=>t.arrow)
    };
});
class $1d528cc0e08a0656$var$HoverPlugin {
    constructor(view, source, field, setHover, hoverTime){
        this.view = view;
        this.source = source;
        this.field = field;
        this.setHover = setHover;
        this.hoverTime = hoverTime;
        this.hoverTimeout = -1;
        this.restartTimeout = -1;
        this.pending = null;
        this.lastMove = {
            x: 0,
            y: 0,
            target: view.dom,
            time: 0
        };
        this.checkHover = this.checkHover.bind(this);
        view.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this));
        view.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
    }
    update() {
        if (this.pending) {
            this.pending = null;
            clearTimeout(this.restartTimeout);
            this.restartTimeout = setTimeout(()=>this.startHover(), 20);
        }
    }
    get active() {
        return this.view.state.field(this.field);
    }
    checkHover() {
        this.hoverTimeout = -1;
        if (this.active.length) return;
        let hovered = Date.now() - this.lastMove.time;
        if (hovered < this.hoverTime) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - hovered);
        else this.startHover();
    }
    startHover() {
        clearTimeout(this.restartTimeout);
        let { view: view, lastMove: lastMove } = this;
        let desc = view.docView.nearest(lastMove.target);
        if (!desc) return;
        let pos, side = 1;
        if (desc instanceof $1d528cc0e08a0656$var$WidgetView) pos = desc.posAtStart;
        else {
            pos = view.posAtCoords(lastMove);
            if (pos == null) return;
            let posCoords = view.coordsAtPos(pos);
            if (!posCoords || lastMove.y < posCoords.top || lastMove.y > posCoords.bottom || lastMove.x < posCoords.left - view.defaultCharacterWidth || lastMove.x > posCoords.right + view.defaultCharacterWidth) return;
            let bidi = view.bidiSpans(view.state.doc.lineAt(pos)).find((s)=>s.from <= pos && s.to >= pos);
            let rtl = bidi && bidi.dir == $1d528cc0e08a0656$export$cacd6541cfeeb6c1.RTL ? -1 : 1;
            side = lastMove.x < posCoords.left ? -rtl : rtl;
        }
        let open = this.source(view, pos, side);
        if (open === null || open === void 0 ? void 0 : open.then) {
            let pending = this.pending = {
                pos: pos
            };
            open.then((result)=>{
                if (this.pending == pending) {
                    this.pending = null;
                    if (result && !(Array.isArray(result) && !result.length)) view.dispatch({
                        effects: this.setHover.of(Array.isArray(result) ? result : [
                            result
                        ])
                    });
                }
            }, (e)=>$1d528cc0e08a0656$export$f86b2a1a2ce291b3(view.state, e, "hover tooltip"));
        } else if (open && !(Array.isArray(open) && !open.length)) view.dispatch({
            effects: this.setHover.of(Array.isArray(open) ? open : [
                open
            ])
        });
    }
    get tooltip() {
        let plugin = this.view.plugin($1d528cc0e08a0656$var$tooltipPlugin);
        let index = plugin ? plugin.manager.tooltips.findIndex((t)=>t.create == $1d528cc0e08a0656$var$HoverTooltipHost.create) : -1;
        return index > -1 ? plugin.manager.tooltipViews[index] : null;
    }
    mousemove(event) {
        var _a, _b;
        this.lastMove = {
            x: event.clientX,
            y: event.clientY,
            target: event.target,
            time: Date.now()
        };
        if (this.hoverTimeout < 0) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime);
        let { active: active, tooltip: tooltip } = this;
        if (active.length && tooltip && !$1d528cc0e08a0656$var$isInTooltip(tooltip.dom, event) || this.pending) {
            let { pos: pos } = active[0] || this.pending, end = (_b = (_a = active[0]) === null || _a === void 0 ? void 0 : _a.end) !== null && _b !== void 0 ? _b : pos;
            if (pos == end ? this.view.posAtCoords(this.lastMove) != pos : !$1d528cc0e08a0656$var$isOverRange(this.view, pos, end, event.clientX, event.clientY)) {
                this.view.dispatch({
                    effects: this.setHover.of([])
                });
                this.pending = null;
            }
        }
    }
    mouseleave(event) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = -1;
        let { active: active } = this;
        if (active.length) {
            let { tooltip: tooltip } = this;
            let inTooltip = tooltip && tooltip.dom.contains(event.relatedTarget);
            if (!inTooltip) this.view.dispatch({
                effects: this.setHover.of([])
            });
            else this.watchTooltipLeave(tooltip.dom);
        }
    }
    watchTooltipLeave(tooltip) {
        let watch = (event)=>{
            tooltip.removeEventListener("mouseleave", watch);
            if (this.active.length && !this.view.dom.contains(event.relatedTarget)) this.view.dispatch({
                effects: this.setHover.of([])
            });
        };
        tooltip.addEventListener("mouseleave", watch);
    }
    destroy() {
        clearTimeout(this.hoverTimeout);
        this.view.dom.removeEventListener("mouseleave", this.mouseleave);
        this.view.dom.removeEventListener("mousemove", this.mousemove);
    }
}
const $1d528cc0e08a0656$var$tooltipMargin = 4;
function $1d528cc0e08a0656$var$isInTooltip(tooltip, event) {
    let { left: left, right: right, top: top, bottom: bottom } = tooltip.getBoundingClientRect(), arrow;
    if (arrow = tooltip.querySelector(".cm-tooltip-arrow")) {
        let arrowRect = arrow.getBoundingClientRect();
        top = Math.min(arrowRect.top, top);
        bottom = Math.max(arrowRect.bottom, bottom);
    }
    return event.clientX >= left - $1d528cc0e08a0656$var$tooltipMargin && event.clientX <= right + $1d528cc0e08a0656$var$tooltipMargin && event.clientY >= top - $1d528cc0e08a0656$var$tooltipMargin && event.clientY <= bottom + $1d528cc0e08a0656$var$tooltipMargin;
}
function $1d528cc0e08a0656$var$isOverRange(view, from, to, x, y, margin) {
    let rect = view.scrollDOM.getBoundingClientRect();
    let docBottom = view.documentTop + view.documentPadding.top + view.contentHeight;
    if (rect.left > x || rect.right < x || rect.top > y || Math.min(rect.bottom, docBottom) < y) return false;
    let pos = view.posAtCoords({
        x: x,
        y: y
    }, false);
    return pos >= from && pos <= to;
}
/**
Set up a hover tooltip, which shows up when the pointer hovers
over ranges of text. The callback is called when the mouse hovers
over the document text. It should, if there is a tooltip
associated with position `pos`, return the tooltip description
(either directly or in a promise). The `side` argument indicates
on which side of the position the pointer is—it will be -1 if the
pointer is before the position, 1 if after the position.

Note that all hover tooltips are hosted within a single tooltip
container element. This allows multiple tooltips over the same
range to be "merged" together without overlapping.

The return value is a valid [editor extension](https://codemirror.net/6/docs/ref/#state.Extension)
but also provides an `active` property holding a state field that
can be used to read the currently active tooltips produced by this
extension.
*/ function $1d528cc0e08a0656$export$69f8d9e63c4aa884(source, options = {}) {
    let setHover = (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define();
    let hoverState = (0, $6b8f387faea0a4dd$export$34381b1ce2130245).define({
        create () {
            return [];
        },
        update (value, tr) {
            if (value.length) {
                if (options.hideOnChange && (tr.docChanged || tr.selection)) value = [];
                else if (options.hideOn) value = value.filter((v)=>!options.hideOn(tr, v));
                if (tr.docChanged) {
                    let mapped = [];
                    for (let tooltip of value){
                        let newPos = tr.changes.mapPos(tooltip.pos, -1, (0, $6b8f387faea0a4dd$export$39cf3280165f92aa).TrackDel);
                        if (newPos != null) {
                            let copy = Object.assign(Object.create(null), tooltip);
                            copy.pos = newPos;
                            if (copy.end != null) copy.end = tr.changes.mapPos(copy.end);
                            mapped.push(copy);
                        }
                    }
                    value = mapped;
                }
            }
            for (let effect of tr.effects){
                if (effect.is(setHover)) value = effect.value;
                if (effect.is($1d528cc0e08a0656$var$closeHoverTooltipEffect)) value = [];
            }
            return value;
        },
        provide: (f)=>$1d528cc0e08a0656$var$showHoverTooltip.from(f)
    });
    return {
        active: hoverState,
        extension: [
            hoverState,
            $1d528cc0e08a0656$export$44d5eccfd62adda7.define((view)=>new $1d528cc0e08a0656$var$HoverPlugin(view, source, hoverState, setHover, options.hoverTime || 300 /* Hover.Time */ )),
            $1d528cc0e08a0656$var$showHoverTooltipHost
        ]
    };
}
/**
Get the active tooltip view for a given tooltip, if available.
*/ function $1d528cc0e08a0656$export$46455b4476d4b8e1(view, tooltip) {
    let plugin = view.plugin($1d528cc0e08a0656$var$tooltipPlugin);
    if (!plugin) return null;
    let found = plugin.manager.tooltips.indexOf(tooltip);
    return found < 0 ? null : plugin.manager.tooltipViews[found];
}
/**
Returns true if any hover tooltips are currently active.
*/ function $1d528cc0e08a0656$export$7864d875805bc1b0(state) {
    return state.facet($1d528cc0e08a0656$var$showHoverTooltip).some((x)=>x);
}
const $1d528cc0e08a0656$var$closeHoverTooltipEffect = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define();
/**
Transaction effect that closes all hover tooltips.
*/ const $1d528cc0e08a0656$export$f6974094db6525a = /*@__PURE__*/ $1d528cc0e08a0656$var$closeHoverTooltipEffect.of(null);
/**
Tell the tooltip extension to recompute the position of the active
tooltips. This can be useful when something happens (such as a
re-positioning or CSS change affecting the editor) that could
invalidate the existing tooltip positions.
*/ function $1d528cc0e08a0656$export$912859096d593b90(view) {
    let plugin = view.plugin($1d528cc0e08a0656$var$tooltipPlugin);
    if (plugin) plugin.maybeMeasure();
}
const $1d528cc0e08a0656$var$panelConfig = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        let topContainer, bottomContainer;
        for (let c of configs){
            topContainer = topContainer || c.topContainer;
            bottomContainer = bottomContainer || c.bottomContainer;
        }
        return {
            topContainer: topContainer,
            bottomContainer: bottomContainer
        };
    }
});
/**
Configures the panel-managing extension.
*/ function $1d528cc0e08a0656$export$8128819a2322681a(config) {
    return config ? [
        $1d528cc0e08a0656$var$panelConfig.of(config)
    ] : [];
}
/**
Get the active panel created by the given constructor, if any.
This can be useful when you need access to your panels' DOM
structure.
*/ function $1d528cc0e08a0656$export$7361ed18ff57179e(view, panel) {
    let plugin = view.plugin($1d528cc0e08a0656$var$panelPlugin);
    let index = plugin ? plugin.specs.indexOf(panel) : -1;
    return index > -1 ? plugin.panels[index] : null;
}
const $1d528cc0e08a0656$var$panelPlugin = /*@__PURE__*/ $1d528cc0e08a0656$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.input = view.state.facet($1d528cc0e08a0656$export$e89c3c9af31c1e3b);
        this.specs = this.input.filter((s)=>s);
        this.panels = this.specs.map((spec)=>spec(view));
        let conf = view.state.facet($1d528cc0e08a0656$var$panelConfig);
        this.top = new $1d528cc0e08a0656$var$PanelGroup(view, true, conf.topContainer);
        this.bottom = new $1d528cc0e08a0656$var$PanelGroup(view, false, conf.bottomContainer);
        this.top.sync(this.panels.filter((p)=>p.top));
        this.bottom.sync(this.panels.filter((p)=>!p.top));
        for (let p of this.panels){
            p.dom.classList.add("cm-panel");
            if (p.mount) p.mount();
        }
    }
    update(update) {
        let conf = update.state.facet($1d528cc0e08a0656$var$panelConfig);
        if (this.top.container != conf.topContainer) {
            this.top.sync([]);
            this.top = new $1d528cc0e08a0656$var$PanelGroup(update.view, true, conf.topContainer);
        }
        if (this.bottom.container != conf.bottomContainer) {
            this.bottom.sync([]);
            this.bottom = new $1d528cc0e08a0656$var$PanelGroup(update.view, false, conf.bottomContainer);
        }
        this.top.syncClasses();
        this.bottom.syncClasses();
        let input = update.state.facet($1d528cc0e08a0656$export$e89c3c9af31c1e3b);
        if (input != this.input) {
            let specs = input.filter((x)=>x);
            let panels = [], top = [], bottom = [], mount = [];
            for (let spec of specs){
                let known = this.specs.indexOf(spec), panel;
                if (known < 0) {
                    panel = spec(update.view);
                    mount.push(panel);
                } else {
                    panel = this.panels[known];
                    if (panel.update) panel.update(update);
                }
                panels.push(panel);
                (panel.top ? top : bottom).push(panel);
            }
            this.specs = specs;
            this.panels = panels;
            this.top.sync(top);
            this.bottom.sync(bottom);
            for (let p of mount){
                p.dom.classList.add("cm-panel");
                if (p.mount) p.mount();
            }
        } else {
            for (let p of this.panels)if (p.update) p.update(update);
        }
    }
    destroy() {
        this.top.sync([]);
        this.bottom.sync([]);
    }
}, {
    provide: (plugin)=>$1d528cc0e08a0656$export$eece2fccabbb77c5.scrollMargins.of((view)=>{
            let value = view.plugin(plugin);
            return value && {
                top: value.top.scrollMargin(),
                bottom: value.bottom.scrollMargin()
            };
        })
});
class $1d528cc0e08a0656$var$PanelGroup {
    constructor(view, top, container){
        this.view = view;
        this.top = top;
        this.container = container;
        this.dom = undefined;
        this.classes = "";
        this.panels = [];
        this.syncClasses();
    }
    sync(panels) {
        for (let p of this.panels)if (p.destroy && panels.indexOf(p) < 0) p.destroy();
        this.panels = panels;
        this.syncDOM();
    }
    syncDOM() {
        if (this.panels.length == 0) {
            if (this.dom) {
                this.dom.remove();
                this.dom = undefined;
            }
            return;
        }
        if (!this.dom) {
            this.dom = document.createElement("div");
            this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom";
            this.dom.style[this.top ? "top" : "bottom"] = "0";
            let parent = this.container || this.view.dom;
            parent.insertBefore(this.dom, this.top ? parent.firstChild : null);
        }
        let curDOM = this.dom.firstChild;
        for (let panel of this.panels)if (panel.dom.parentNode == this.dom) {
            while(curDOM != panel.dom)curDOM = $1d528cc0e08a0656$var$rm(curDOM);
            curDOM = curDOM.nextSibling;
        } else this.dom.insertBefore(panel.dom, curDOM);
        while(curDOM)curDOM = $1d528cc0e08a0656$var$rm(curDOM);
    }
    scrollMargin() {
        return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
    }
    syncClasses() {
        if (!this.container || this.classes == this.view.themeClasses) return;
        for (let cls of this.classes.split(" "))if (cls) this.container.classList.remove(cls);
        for (let cls of (this.classes = this.view.themeClasses).split(" "))if (cls) this.container.classList.add(cls);
    }
}
function $1d528cc0e08a0656$var$rm(node) {
    let next = node.nextSibling;
    node.remove();
    return next;
}
/**
Opening a panel is done by providing a constructor function for
the panel through this facet. (The panel is closed again when its
constructor is no longer provided.) Values of `null` are ignored.
*/ const $1d528cc0e08a0656$export$e89c3c9af31c1e3b = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    enables: $1d528cc0e08a0656$var$panelPlugin
});
/**
Show a panel above or below the editor to show the user a message
or prompt them for input. Returns an effect that can be dispatched
to close the dialog, and a promise that resolves when the dialog
is closed or a form inside of it is submitted.

You are encouraged, if your handling of the result of the promise
dispatches a transaction, to include the `close` effect in it. If
you don't, this function will automatically dispatch a separate
transaction right after.
*/ function $1d528cc0e08a0656$export$61e0a65f251cfdb3(view, config) {
    let resolve;
    let promise = new Promise((r)=>resolve = r);
    let panelCtor = (view)=>$1d528cc0e08a0656$var$createDialog(view, config, resolve);
    if (view.state.field($1d528cc0e08a0656$var$dialogField, false)) view.dispatch({
        effects: $1d528cc0e08a0656$var$openDialogEffect.of(panelCtor)
    });
    else view.dispatch({
        effects: (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).appendConfig.of($1d528cc0e08a0656$var$dialogField.init(()=>[
                panelCtor
            ]))
    });
    let close = $1d528cc0e08a0656$var$closeDialogEffect.of(panelCtor);
    return {
        close: close,
        result: promise.then((form)=>{
            let queue = view.win.queueMicrotask || ((f)=>view.win.setTimeout(f, 10));
            queue(()=>{
                if (view.state.field($1d528cc0e08a0656$var$dialogField).indexOf(panelCtor) > -1) view.dispatch({
                    effects: close
                });
            });
            return form;
        })
    };
}
/**
Find the [`Panel`](https://codemirror.net/6/docs/ref/#view.Panel) for an open dialog, using a class
name as identifier.
*/ function $1d528cc0e08a0656$export$add6d5f54f9ab5a8(view, className) {
    let dialogs = view.state.field($1d528cc0e08a0656$var$dialogField, false) || [];
    for (let open of dialogs){
        let panel = $1d528cc0e08a0656$export$7361ed18ff57179e(view, open);
        if (panel && panel.dom.classList.contains(className)) return panel;
    }
    return null;
}
const $1d528cc0e08a0656$var$dialogField = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$34381b1ce2130245).define({
    create () {
        return [];
    },
    update (dialogs, tr) {
        for (let e of tr.effects){
            if (e.is($1d528cc0e08a0656$var$openDialogEffect)) dialogs = [
                e.value
            ].concat(dialogs);
            else if (e.is($1d528cc0e08a0656$var$closeDialogEffect)) dialogs = dialogs.filter((d)=>d != e.value);
        }
        return dialogs;
    },
    provide: (f)=>$1d528cc0e08a0656$export$e89c3c9af31c1e3b.computeN([
            f
        ], (state)=>state.field(f))
});
const $1d528cc0e08a0656$var$openDialogEffect = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define();
const $1d528cc0e08a0656$var$closeDialogEffect = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define();
function $1d528cc0e08a0656$var$createDialog(view, config, result) {
    let content = config.content ? config.content(view, ()=>done(null)) : null;
    if (!content) {
        content = (0, $2a4351068134afec$export$2e2bcd8739ae039)("form");
        if (config.input) {
            let input = (0, $2a4351068134afec$export$2e2bcd8739ae039)("input", config.input);
            if (/^(text|password|number|email|tel|url)$/.test(input.type)) input.classList.add("cm-textfield");
            if (!input.name) input.name = "input";
            content.appendChild((0, $2a4351068134afec$export$2e2bcd8739ae039)("label", (config.label || "") + ": ", input));
        } else content.appendChild(document.createTextNode(config.label || ""));
        content.appendChild(document.createTextNode(" "));
        content.appendChild((0, $2a4351068134afec$export$2e2bcd8739ae039)("button", {
            class: "cm-button",
            type: "submit"
        }, config.submitLabel || "OK"));
    }
    let forms = content.nodeName == "FORM" ? [
        content
    ] : content.querySelectorAll("form");
    for(let i = 0; i < forms.length; i++){
        let form = forms[i];
        form.addEventListener("keydown", (event)=>{
            if (event.keyCode == 27) {
                event.preventDefault();
                done(null);
            } else if (event.keyCode == 13) {
                event.preventDefault();
                done(form);
            }
        });
        form.addEventListener("submit", (event)=>{
            event.preventDefault();
            done(form);
        });
    }
    let panel = (0, $2a4351068134afec$export$2e2bcd8739ae039)("div", content, (0, $2a4351068134afec$export$2e2bcd8739ae039)("button", {
        onclick: ()=>done(null),
        "aria-label": view.state.phrase("close"),
        class: "cm-dialog-close",
        type: "button"
    }, [
        "\xd7"
    ]));
    if (config.class) panel.className = config.class;
    panel.classList.add("cm-dialog");
    function done(form) {
        if (panel.contains(panel.ownerDocument.activeElement)) view.focus();
        result(form);
    }
    return {
        dom: panel,
        top: config.top,
        mount: ()=>{
            if (config.focus) {
                let focus;
                if (typeof config.focus == "string") focus = content.querySelector(config.focus);
                else focus = content.querySelector("input") || content.querySelector("button");
                if (focus && "select" in focus) focus.select();
                else if (focus && "focus" in focus) focus.focus();
            }
        }
    };
}
/**
A gutter marker represents a bit of information attached to a line
in a specific gutter. Your own custom markers have to extend this
class.
*/ class $1d528cc0e08a0656$export$591ab4c909549043 extends (0, $6b8f387faea0a4dd$export$d60f08ed93a48611) {
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    Compare this marker to another marker of the same type.
    */ eq(other) {
        return false;
    }
    /**
    Called if the marker has a `toDOM` method and its representation
    was removed from a gutter.
    */ destroy(dom) {}
}
$1d528cc0e08a0656$export$591ab4c909549043.prototype.elementClass = "";
$1d528cc0e08a0656$export$591ab4c909549043.prototype.toDOM = undefined;
$1d528cc0e08a0656$export$591ab4c909549043.prototype.mapMode = (0, $6b8f387faea0a4dd$export$39cf3280165f92aa).TrackBefore;
$1d528cc0e08a0656$export$591ab4c909549043.prototype.startSide = $1d528cc0e08a0656$export$591ab4c909549043.prototype.endSide = -1;
$1d528cc0e08a0656$export$591ab4c909549043.prototype.point = true;
/**
Facet used to add a class to all gutter elements for a given line.
Markers given to this facet should _only_ define an
[`elementclass`](https://codemirror.net/6/docs/ref/#view.GutterMarker.elementClass), not a
[`toDOM`](https://codemirror.net/6/docs/ref/#view.GutterMarker.toDOM) (or the marker will appear
in all gutters for the line).
*/ const $1d528cc0e08a0656$export$113bd64f27ac1172 = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
/**
Facet used to add a class to all gutter elements next to a widget.
Should not provide widgets with a `toDOM` method.
*/ const $1d528cc0e08a0656$export$6dd229d2c0925f7a = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
const $1d528cc0e08a0656$var$defaults = {
    class: "",
    renderEmptyElements: false,
    elementStyle: "",
    markers: ()=>(0, $6b8f387faea0a4dd$export$34cb5241245008dd).empty,
    lineMarker: ()=>null,
    widgetMarker: ()=>null,
    lineMarkerChange: null,
    initialSpacer: null,
    updateSpacer: null,
    domEventHandlers: {},
    side: "before"
};
const $1d528cc0e08a0656$var$activeGutters = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
/**
Define an editor gutter. The order in which the gutters appear is
determined by their extension priority.
*/ function $1d528cc0e08a0656$export$f2b922cb4a245974(config) {
    return [
        $1d528cc0e08a0656$export$ec15ef01b8fbae61(),
        $1d528cc0e08a0656$var$activeGutters.of({
            ...$1d528cc0e08a0656$var$defaults,
            ...config
        })
    ];
}
const $1d528cc0e08a0656$var$unfixGutters = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
/**
The gutter-drawing plugin is automatically enabled when you add a
gutter, but you can use this function to explicitly configure it.

Unless `fixed` is explicitly set to `false`, the gutters are
fixed, meaning they don't scroll along with the content
horizontally (except on Internet Explorer, which doesn't support
CSS [`position:
sticky`](https://developer.mozilla.org/en-US/docs/Web/CSS/position#sticky)).
*/ function $1d528cc0e08a0656$export$ec15ef01b8fbae61(config) {
    let result = [
        $1d528cc0e08a0656$var$gutterView
    ];
    if (config && config.fixed === false) result.push($1d528cc0e08a0656$var$unfixGutters.of(true));
    return result;
}
const $1d528cc0e08a0656$var$gutterView = /*@__PURE__*/ $1d528cc0e08a0656$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.domAfter = null;
        this.prevViewport = view.viewport;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutters cm-gutters-before";
        this.dom.setAttribute("aria-hidden", "true");
        this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px";
        this.gutters = view.state.facet($1d528cc0e08a0656$var$activeGutters).map((conf)=>new $1d528cc0e08a0656$var$SingleGutterView(view, conf));
        this.fixed = !view.state.facet($1d528cc0e08a0656$var$unfixGutters);
        for (let gutter of this.gutters)if (gutter.config.side == "after") this.getDOMAfter().appendChild(gutter.dom);
        else this.dom.appendChild(gutter.dom);
        if (this.fixed) // FIXME IE11 fallback, which doesn't support position: sticky,
        // by using position: relative + event handlers that realign the
        // gutter (or just force fixed=false on IE11?)
        this.dom.style.position = "sticky";
        this.syncGutters(false);
        view.scrollDOM.insertBefore(this.dom, view.contentDOM);
    }
    getDOMAfter() {
        if (!this.domAfter) {
            this.domAfter = document.createElement("div");
            this.domAfter.className = "cm-gutters cm-gutters-after";
            this.domAfter.setAttribute("aria-hidden", "true");
            this.domAfter.style.minHeight = this.view.contentHeight / this.view.scaleY + "px";
            this.domAfter.style.position = this.fixed ? "sticky" : "";
            this.view.scrollDOM.appendChild(this.domAfter);
        }
        return this.domAfter;
    }
    update(update) {
        if (this.updateGutters(update)) {
            // Detach during sync when the viewport changed significantly
            // (such as during scrolling), since for large updates that is
            // faster.
            let vpA = this.prevViewport, vpB = update.view.viewport;
            let vpOverlap = Math.min(vpA.to, vpB.to) - Math.max(vpA.from, vpB.from);
            this.syncGutters(vpOverlap < (vpB.to - vpB.from) * 0.8);
        }
        if (update.geometryChanged) {
            let min = this.view.contentHeight / this.view.scaleY + "px";
            this.dom.style.minHeight = min;
            if (this.domAfter) this.domAfter.style.minHeight = min;
        }
        if (this.view.state.facet($1d528cc0e08a0656$var$unfixGutters) != !this.fixed) {
            this.fixed = !this.fixed;
            this.dom.style.position = this.fixed ? "sticky" : "";
            if (this.domAfter) this.domAfter.style.position = this.fixed ? "sticky" : "";
        }
        this.prevViewport = update.view.viewport;
    }
    syncGutters(detach) {
        let after = this.dom.nextSibling;
        if (detach) {
            this.dom.remove();
            if (this.domAfter) this.domAfter.remove();
        }
        let lineClasses = (0, $6b8f387faea0a4dd$export$34cb5241245008dd).iter(this.view.state.facet($1d528cc0e08a0656$export$113bd64f27ac1172), this.view.viewport.from);
        let classSet = [];
        let contexts = this.gutters.map((gutter)=>new $1d528cc0e08a0656$var$UpdateContext(gutter, this.view.viewport, -this.view.documentPadding.top));
        for (let line of this.view.viewportLineBlocks){
            if (classSet.length) classSet = [];
            if (Array.isArray(line.type)) {
                let first = true;
                for (let b of line.type){
                    if (b.type == $1d528cc0e08a0656$export$48808c686fe495c4.Text && first) {
                        $1d528cc0e08a0656$var$advanceCursor(lineClasses, classSet, b.from);
                        for (let cx of contexts)cx.line(this.view, b, classSet);
                        first = false;
                    } else if (b.widget) for (let cx of contexts)cx.widget(this.view, b);
                }
            } else if (line.type == $1d528cc0e08a0656$export$48808c686fe495c4.Text) {
                $1d528cc0e08a0656$var$advanceCursor(lineClasses, classSet, line.from);
                for (let cx of contexts)cx.line(this.view, line, classSet);
            } else if (line.widget) for (let cx of contexts)cx.widget(this.view, line);
        }
        for (let cx of contexts)cx.finish();
        if (detach) {
            this.view.scrollDOM.insertBefore(this.dom, after);
            if (this.domAfter) this.view.scrollDOM.appendChild(this.domAfter);
        }
    }
    updateGutters(update) {
        let prev = update.startState.facet($1d528cc0e08a0656$var$activeGutters), cur = update.state.facet($1d528cc0e08a0656$var$activeGutters);
        let change = update.docChanged || update.heightChanged || update.viewportChanged || !(0, $6b8f387faea0a4dd$export$34cb5241245008dd).eq(update.startState.facet($1d528cc0e08a0656$export$113bd64f27ac1172), update.state.facet($1d528cc0e08a0656$export$113bd64f27ac1172), update.view.viewport.from, update.view.viewport.to);
        if (prev == cur) {
            for (let gutter of this.gutters)if (gutter.update(update)) change = true;
        } else {
            change = true;
            let gutters = [];
            for (let conf of cur){
                let known = prev.indexOf(conf);
                if (known < 0) gutters.push(new $1d528cc0e08a0656$var$SingleGutterView(this.view, conf));
                else {
                    this.gutters[known].update(update);
                    gutters.push(this.gutters[known]);
                }
            }
            for (let g of this.gutters){
                g.dom.remove();
                if (gutters.indexOf(g) < 0) g.destroy();
            }
            for (let g of gutters)if (g.config.side == "after") this.getDOMAfter().appendChild(g.dom);
            else this.dom.appendChild(g.dom);
            this.gutters = gutters;
        }
        return change;
    }
    destroy() {
        for (let view of this.gutters)view.destroy();
        this.dom.remove();
        if (this.domAfter) this.domAfter.remove();
    }
}, {
    provide: (plugin)=>$1d528cc0e08a0656$export$eece2fccabbb77c5.scrollMargins.of((view)=>{
            let value = view.plugin(plugin);
            if (!value || value.gutters.length == 0 || !value.fixed) return null;
            let before = value.dom.offsetWidth * view.scaleX, after = value.domAfter ? value.domAfter.offsetWidth * view.scaleX : 0;
            return view.textDirection == $1d528cc0e08a0656$export$cacd6541cfeeb6c1.LTR ? {
                left: before,
                right: after
            } : {
                right: before,
                left: after
            };
        })
});
function $1d528cc0e08a0656$var$asArray(val) {
    return Array.isArray(val) ? val : [
        val
    ];
}
function $1d528cc0e08a0656$var$advanceCursor(cursor, collect, pos) {
    while(cursor.value && cursor.from <= pos){
        if (cursor.from == pos) collect.push(cursor.value);
        cursor.next();
    }
}
class $1d528cc0e08a0656$var$UpdateContext {
    constructor(gutter, viewport, height){
        this.gutter = gutter;
        this.height = height;
        this.i = 0;
        this.cursor = (0, $6b8f387faea0a4dd$export$34cb5241245008dd).iter(gutter.markers, viewport.from);
    }
    addElement(view, block, markers) {
        let { gutter: gutter } = this, above = (block.top - this.height) / view.scaleY, height = block.height / view.scaleY;
        if (this.i == gutter.elements.length) {
            let newElt = new $1d528cc0e08a0656$var$GutterElement(view, height, above, markers);
            gutter.elements.push(newElt);
            gutter.dom.appendChild(newElt.dom);
        } else gutter.elements[this.i].update(view, height, above, markers);
        this.height = block.bottom;
        this.i++;
    }
    line(view, line, extraMarkers) {
        let localMarkers = [];
        $1d528cc0e08a0656$var$advanceCursor(this.cursor, localMarkers, line.from);
        if (extraMarkers.length) localMarkers = localMarkers.concat(extraMarkers);
        let forLine = this.gutter.config.lineMarker(view, line, localMarkers);
        if (forLine) localMarkers.unshift(forLine);
        let gutter = this.gutter;
        if (localMarkers.length == 0 && !gutter.config.renderEmptyElements) return;
        this.addElement(view, line, localMarkers);
    }
    widget(view, block) {
        let marker = this.gutter.config.widgetMarker(view, block.widget, block), markers = marker ? [
            marker
        ] : null;
        for (let cls of view.state.facet($1d528cc0e08a0656$export$6dd229d2c0925f7a)){
            let marker = cls(view, block.widget, block);
            if (marker) (markers || (markers = [])).push(marker);
        }
        if (markers) this.addElement(view, block, markers);
    }
    finish() {
        let gutter = this.gutter;
        while(gutter.elements.length > this.i){
            let last = gutter.elements.pop();
            gutter.dom.removeChild(last.dom);
            last.destroy();
        }
    }
}
class $1d528cc0e08a0656$var$SingleGutterView {
    constructor(view, config){
        this.view = view;
        this.config = config;
        this.elements = [];
        this.spacer = null;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
        for(let prop in config.domEventHandlers)this.dom.addEventListener(prop, (event)=>{
            let target = event.target, y;
            if (target != this.dom && this.dom.contains(target)) {
                while(target.parentNode != this.dom)target = target.parentNode;
                let rect = target.getBoundingClientRect();
                y = (rect.top + rect.bottom) / 2;
            } else y = event.clientY;
            let line = view.lineBlockAtHeight(y - view.documentTop);
            if (config.domEventHandlers[prop](view, line, event)) event.preventDefault();
        });
        this.markers = $1d528cc0e08a0656$var$asArray(config.markers(view));
        if (config.initialSpacer) {
            this.spacer = new $1d528cc0e08a0656$var$GutterElement(view, 0, 0, [
                config.initialSpacer(view)
            ]);
            this.dom.appendChild(this.spacer.dom);
            this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none";
        }
    }
    update(update) {
        let prevMarkers = this.markers;
        this.markers = $1d528cc0e08a0656$var$asArray(this.config.markers(update.view));
        if (this.spacer && this.config.updateSpacer) {
            let updated = this.config.updateSpacer(this.spacer.markers[0], update);
            if (updated != this.spacer.markers[0]) this.spacer.update(update.view, 0, 0, [
                updated
            ]);
        }
        let vp = update.view.viewport;
        return !(0, $6b8f387faea0a4dd$export$34cb5241245008dd).eq(this.markers, prevMarkers, vp.from, vp.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(update) : false);
    }
    destroy() {
        for (let elt of this.elements)elt.destroy();
    }
}
class $1d528cc0e08a0656$var$GutterElement {
    constructor(view, height, above, markers){
        this.height = -1;
        this.above = 0;
        this.markers = [];
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutterElement";
        this.update(view, height, above, markers);
    }
    update(view, height, above, markers) {
        if (this.height != height) {
            this.height = height;
            this.dom.style.height = height + "px";
        }
        if (this.above != above) this.dom.style.marginTop = (this.above = above) ? above + "px" : "";
        if (!$1d528cc0e08a0656$var$sameMarkers(this.markers, markers)) this.setMarkers(view, markers);
    }
    setMarkers(view, markers) {
        let cls = "cm-gutterElement", domPos = this.dom.firstChild;
        for(let iNew = 0, iOld = 0;;){
            let skipTo = iOld, marker = iNew < markers.length ? markers[iNew++] : null, matched = false;
            if (marker) {
                let c = marker.elementClass;
                if (c) cls += " " + c;
                for(let i = iOld; i < this.markers.length; i++)if (this.markers[i].compare(marker)) {
                    skipTo = i;
                    matched = true;
                    break;
                }
            } else skipTo = this.markers.length;
            while(iOld < skipTo){
                let next = this.markers[iOld++];
                if (next.toDOM) {
                    next.destroy(domPos);
                    let after = domPos.nextSibling;
                    domPos.remove();
                    domPos = after;
                }
            }
            if (!marker) break;
            if (marker.toDOM) {
                if (matched) domPos = domPos.nextSibling;
                else this.dom.insertBefore(marker.toDOM(view), domPos);
            }
            if (matched) iOld++;
        }
        this.dom.className = cls;
        this.markers = markers;
    }
    destroy() {
        this.setMarkers(null, []); // First argument not used unless creating markers
    }
}
function $1d528cc0e08a0656$var$sameMarkers(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].compare(b[i])) return false;
    return true;
}
/**
Facet used to provide markers to the line number gutter.
*/ const $1d528cc0e08a0656$export$dd0c91e0a7121f5f = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
/**
Facet used to create markers in the line number gutter next to widgets.
*/ const $1d528cc0e08a0656$export$510194e22d36ff6c = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
const $1d528cc0e08a0656$var$lineNumberConfig = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine (values) {
        return (0, $6b8f387faea0a4dd$export$4e19c0b693794a7e)(values, {
            formatNumber: String,
            domEventHandlers: {}
        }, {
            domEventHandlers (a, b) {
                let result = Object.assign({}, a);
                for(let event in b){
                    let exists = result[event], add = b[event];
                    result[event] = exists ? (view, line, event)=>exists(view, line, event) || add(view, line, event) : add;
                }
                return result;
            }
        });
    }
});
class $1d528cc0e08a0656$var$NumberMarker extends $1d528cc0e08a0656$export$591ab4c909549043 {
    constructor(number){
        super();
        this.number = number;
    }
    eq(other) {
        return this.number == other.number;
    }
    toDOM() {
        return document.createTextNode(this.number);
    }
}
function $1d528cc0e08a0656$var$formatNumber(view, number) {
    return view.state.facet($1d528cc0e08a0656$var$lineNumberConfig).formatNumber(number, view.state);
}
const $1d528cc0e08a0656$var$lineNumberGutter = /*@__PURE__*/ $1d528cc0e08a0656$var$activeGutters.compute([
    $1d528cc0e08a0656$var$lineNumberConfig
], (state)=>({
        class: "cm-lineNumbers",
        renderEmptyElements: false,
        markers (view) {
            return view.state.facet($1d528cc0e08a0656$export$dd0c91e0a7121f5f);
        },
        lineMarker (view, line, others) {
            if (others.some((m)=>m.toDOM)) return null;
            return new $1d528cc0e08a0656$var$NumberMarker($1d528cc0e08a0656$var$formatNumber(view, view.state.doc.lineAt(line.from).number));
        },
        widgetMarker: (view, widget, block)=>{
            for (let m of view.state.facet($1d528cc0e08a0656$export$510194e22d36ff6c)){
                let result = m(view, widget, block);
                if (result) return result;
            }
            return null;
        },
        lineMarkerChange: (update)=>update.startState.facet($1d528cc0e08a0656$var$lineNumberConfig) != update.state.facet($1d528cc0e08a0656$var$lineNumberConfig),
        initialSpacer (view) {
            return new $1d528cc0e08a0656$var$NumberMarker($1d528cc0e08a0656$var$formatNumber(view, $1d528cc0e08a0656$var$maxLineNumber(view.state.doc.lines)));
        },
        updateSpacer (spacer, update) {
            let max = $1d528cc0e08a0656$var$formatNumber(update.view, $1d528cc0e08a0656$var$maxLineNumber(update.view.state.doc.lines));
            return max == spacer.number ? spacer : new $1d528cc0e08a0656$var$NumberMarker(max);
        },
        domEventHandlers: state.facet($1d528cc0e08a0656$var$lineNumberConfig).domEventHandlers,
        side: "before"
    }));
/**
Create a line number gutter extension.
*/ function $1d528cc0e08a0656$export$1a8cf111682eaa7d(config = {}) {
    return [
        $1d528cc0e08a0656$var$lineNumberConfig.of(config),
        $1d528cc0e08a0656$export$ec15ef01b8fbae61(),
        $1d528cc0e08a0656$var$lineNumberGutter
    ];
}
function $1d528cc0e08a0656$var$maxLineNumber(lines) {
    let last = 9;
    while(last < lines)last = last * 10 + 9;
    return last;
}
const $1d528cc0e08a0656$var$activeLineGutterMarker = /*@__PURE__*/ new class extends $1d528cc0e08a0656$export$591ab4c909549043 {
    constructor(){
        super(...arguments);
        this.elementClass = "cm-activeLineGutter";
    }
};
const $1d528cc0e08a0656$var$activeLineGutterHighlighter = /*@__PURE__*/ $1d528cc0e08a0656$export$113bd64f27ac1172.compute([
    "selection"
], (state)=>{
    let marks = [], last = -1;
    for (let range of state.selection.ranges){
        let linePos = state.doc.lineAt(range.head).from;
        if (linePos > last) {
            last = linePos;
            marks.push($1d528cc0e08a0656$var$activeLineGutterMarker.range(linePos));
        }
    }
    return (0, $6b8f387faea0a4dd$export$34cb5241245008dd).of(marks);
});
/**
Returns an extension that adds a `cm-activeLineGutter` class to
all gutter elements on the [active
line](https://codemirror.net/6/docs/ref/#view.highlightActiveLine).
*/ function $1d528cc0e08a0656$export$93b52f08bb2c759c() {
    return $1d528cc0e08a0656$var$activeLineGutterHighlighter;
}
function $1d528cc0e08a0656$var$matcher(decorator) {
    return $1d528cc0e08a0656$export$44d5eccfd62adda7.define((view)=>({
            decorations: decorator.createDeco(view),
            update (u) {
                this.decorations = decorator.updateDeco(u, this.decorations);
            }
        }), {
        decorations: (v)=>v.decorations
    });
}
const $1d528cc0e08a0656$var$tabDeco = /*@__PURE__*/ $1d528cc0e08a0656$export$10e30b733df217ea.mark({
    class: "cm-highlightTab"
});
const $1d528cc0e08a0656$var$spaceDeco = /*@__PURE__*/ $1d528cc0e08a0656$export$10e30b733df217ea.mark({
    class: "cm-highlightSpace"
});
const $1d528cc0e08a0656$var$whitespaceHighlighter = /*@__PURE__*/ $1d528cc0e08a0656$var$matcher(/*@__PURE__*/ new $1d528cc0e08a0656$export$9b928b0ca20b25cb({
    regexp: /\t| /g,
    decoration: (match)=>match[0] == "\t" ? $1d528cc0e08a0656$var$tabDeco : $1d528cc0e08a0656$var$spaceDeco,
    boundary: /\S/
}));
/**
Returns an extension that highlights whitespace, adding a
`cm-highlightSpace` class to stretches of spaces, and a
`cm-highlightTab` class to individual tab characters. By default,
the former are shown as faint dots, and the latter as arrows.
*/ function $1d528cc0e08a0656$export$beeff585f23bdb79() {
    return $1d528cc0e08a0656$var$whitespaceHighlighter;
}
const $1d528cc0e08a0656$var$trailingHighlighter = /*@__PURE__*/ $1d528cc0e08a0656$var$matcher(/*@__PURE__*/ new $1d528cc0e08a0656$export$9b928b0ca20b25cb({
    regexp: /\s+$/g,
    decoration: /*@__PURE__*/ $1d528cc0e08a0656$export$10e30b733df217ea.mark({
        class: "cm-trailingSpace"
    })
}));
/**
Returns an extension that adds a `cm-trailingSpace` class to all
trailing whitespace.
*/ function $1d528cc0e08a0656$export$6e66b0e142f44c26() {
    return $1d528cc0e08a0656$var$trailingHighlighter;
}
/**
@internal
*/ const $1d528cc0e08a0656$export$91afc2cf83e15b44 = {
    HeightMap: $1d528cc0e08a0656$var$HeightMap,
    HeightOracle: $1d528cc0e08a0656$var$HeightOracle,
    MeasuredHeights: $1d528cc0e08a0656$var$MeasuredHeights,
    QueryType: $1d528cc0e08a0656$var$QueryType,
    ChangedRange: $1d528cc0e08a0656$var$ChangedRange,
    computeOrder: $1d528cc0e08a0656$var$computeOrder,
    moveVisually: $1d528cc0e08a0656$var$moveVisually,
    clearHeightChangeFlag: $1d528cc0e08a0656$var$clearHeightChangeFlag,
    getHeightChangeFlag: ()=>$1d528cc0e08a0656$var$heightChangeFlag
};




/**
The default maximum length of a `TreeBuffer` node.
*/ const $a7a41eb5193c1110$export$de305a849879ffa = 1024;
let $a7a41eb5193c1110$var$nextPropID = 0;
class $a7a41eb5193c1110$var$Range {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
/**
Each [node type](#common.NodeType) or [individual tree](#common.Tree)
can have metadata associated with it in props. Instances of this
class represent prop names.
*/ class $a7a41eb5193c1110$export$b8034b9bc18acd90 {
    /**
    Create a new node prop type.
    */ constructor(config = {}){
        this.id = $a7a41eb5193c1110$var$nextPropID++;
        this.perNode = !!config.perNode;
        this.deserialize = config.deserialize || (()=>{
            throw new Error("This node type doesn't define a deserialize function");
        });
    }
    /**
    This is meant to be used with
    [`NodeSet.extend`](#common.NodeSet.extend) or
    [`LRParser.configure`](#lr.ParserConfig.props) to compute
    prop values for each node type in the set. Takes a [match
    object](#common.NodeType^match) or function that returns undefined
    if the node type doesn't get this prop, and the prop's value if
    it does.
    */ add(match) {
        if (this.perNode) throw new RangeError("Can't add per-node props to node types");
        if (typeof match != "function") match = $a7a41eb5193c1110$export$f06e977173f1857c.match(match);
        return (type)=>{
            let result = match(type);
            return result === undefined ? null : [
                this,
                result
            ];
        };
    }
}
/**
Prop that is used to describe matching delimiters. For opening
delimiters, this holds an array of node names (written as a
space-separated string when declaring this prop in a grammar)
for the node types of closing delimiters that match it.
*/ $a7a41eb5193c1110$export$b8034b9bc18acd90.closedBy = new $a7a41eb5193c1110$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/**
The inverse of [`closedBy`](#common.NodeProp^closedBy). This is
attached to closing delimiters, holding an array of node names
of types of matching opening delimiters.
*/ $a7a41eb5193c1110$export$b8034b9bc18acd90.openedBy = new $a7a41eb5193c1110$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/**
Used to assign node types to groups (for example, all node
types that represent an expression could be tagged with an
`"Expression"` group).
*/ $a7a41eb5193c1110$export$b8034b9bc18acd90.group = new $a7a41eb5193c1110$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/**
Attached to nodes to indicate these should be
[displayed](https://codemirror.net/docs/ref/#language.syntaxTree)
in a bidirectional text isolate, so that direction-neutral
characters on their sides don't incorrectly get associated with
surrounding text. You'll generally want to set this for nodes
that contain arbitrary text, like strings and comments, and for
nodes that appear _inside_ arbitrary text, like HTML tags. When
not given a value, in a grammar declaration, defaults to
`"auto"`.
*/ $a7a41eb5193c1110$export$b8034b9bc18acd90.isolate = new $a7a41eb5193c1110$export$b8034b9bc18acd90({
    deserialize: (value)=>{
        if (value && value != "rtl" && value != "ltr" && value != "auto") throw new RangeError("Invalid value for isolate: " + value);
        return value || "auto";
    }
});
/**
The hash of the [context](#lr.ContextTracker.constructor)
that the node was parsed in, if any. Used to limit reuse of
contextual nodes.
*/ $a7a41eb5193c1110$export$b8034b9bc18acd90.contextHash = new $a7a41eb5193c1110$export$b8034b9bc18acd90({
    perNode: true
});
/**
The distance beyond the end of the node that the tokenizer
looked ahead for any of the tokens inside the node. (The LR
parser only stores this when it is larger than 25, for
efficiency reasons.)
*/ $a7a41eb5193c1110$export$b8034b9bc18acd90.lookAhead = new $a7a41eb5193c1110$export$b8034b9bc18acd90({
    perNode: true
});
/**
This per-node prop is used to replace a given node, or part of a
node, with another tree. This is useful to include trees from
different languages in mixed-language parsers.
*/ $a7a41eb5193c1110$export$b8034b9bc18acd90.mounted = new $a7a41eb5193c1110$export$b8034b9bc18acd90({
    perNode: true
});
/**
A mounted tree, which can be [stored](#common.NodeProp^mounted) on
a tree node to indicate that parts of its content are
represented by another tree.
*/ class $a7a41eb5193c1110$export$358cdd8bd77577cc {
    constructor(/**
    The inner tree.
    */ tree, /**
    If this is null, this tree replaces the entire node (it will
    be included in the regular iteration instead of its host
    node). If not, only the given ranges are considered to be
    covered by this tree. This is used for trees that are mixed in
    a way that isn't strictly hierarchical. Such mounted trees are
    only entered by [`resolveInner`](#common.Tree.resolveInner)
    and [`enter`](#common.SyntaxNode.enter).
    */ overlay, /**
    The parser used to create this subtree.
    */ parser){
        this.tree = tree;
        this.overlay = overlay;
        this.parser = parser;
    }
    /**
    @internal
    */ static get(tree) {
        return tree && tree.props && tree.props[$a7a41eb5193c1110$export$b8034b9bc18acd90.mounted.id];
    }
}
const $a7a41eb5193c1110$var$noProps = Object.create(null);
/**
Each node in a syntax tree has a node type associated with it.
*/ class $a7a41eb5193c1110$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name of the node type. Not necessarily unique, but if the
    grammar was written properly, different node types with the
    same name within a node set should play the same semantic
    role.
    */ name, /**
    @internal
    */ props, /**
    The id of this node in its set. Corresponds to the term ids
    used in the parser.
    */ id, /**
    @internal
    */ flags = 0){
        this.name = name;
        this.props = props;
        this.id = id;
        this.flags = flags;
    }
    /**
    Define a node type.
    */ static define(spec) {
        let props = spec.props && spec.props.length ? Object.create(null) : $a7a41eb5193c1110$var$noProps;
        let flags = (spec.top ? 1 /* NodeFlag.Top */  : 0) | (spec.skipped ? 2 /* NodeFlag.Skipped */  : 0) | (spec.error ? 4 /* NodeFlag.Error */  : 0) | (spec.name == null ? 8 /* NodeFlag.Anonymous */  : 0);
        let type = new $a7a41eb5193c1110$export$f06e977173f1857c(spec.name || "", props, spec.id, flags);
        if (spec.props) for (let src of spec.props){
            if (!Array.isArray(src)) src = src(type);
            if (src) {
                if (src[0].perNode) throw new RangeError("Can't store a per-node prop on a node type");
                props[src[0].id] = src[1];
            }
        }
        return type;
    }
    /**
    Retrieves a node prop for this type. Will return `undefined` if
    the prop isn't present on this node.
    */ prop(prop) {
        return this.props[prop.id];
    }
    /**
    True when this is the top node of a grammar.
    */ get isTop() {
        return (this.flags & 1 /* NodeFlag.Top */ ) > 0;
    }
    /**
    True when this node is produced by a skip rule.
    */ get isSkipped() {
        return (this.flags & 2 /* NodeFlag.Skipped */ ) > 0;
    }
    /**
    Indicates whether this is an error node.
    */ get isError() {
        return (this.flags & 4 /* NodeFlag.Error */ ) > 0;
    }
    /**
    When true, this node type doesn't correspond to a user-declared
    named node, for example because it is used to cache repetition.
    */ get isAnonymous() {
        return (this.flags & 8 /* NodeFlag.Anonymous */ ) > 0;
    }
    /**
    Returns true when this node's name or one of its
    [groups](#common.NodeProp^group) matches the given string.
    */ is(name) {
        if (typeof name == 'string') {
            if (this.name == name) return true;
            let group = this.prop($a7a41eb5193c1110$export$b8034b9bc18acd90.group);
            return group ? group.indexOf(name) > -1 : false;
        }
        return this.id == name;
    }
    /**
    Create a function from node types to arbitrary values by
    specifying an object whose property names are node or
    [group](#common.NodeProp^group) names. Often useful with
    [`NodeProp.add`](#common.NodeProp.add). You can put multiple
    names, separated by spaces, in a single property name to map
    multiple node names to a single value.
    */ static match(map) {
        let direct = Object.create(null);
        for(let prop in map)for (let name of prop.split(" "))direct[name] = map[prop];
        return (node)=>{
            for(let groups = node.prop($a7a41eb5193c1110$export$b8034b9bc18acd90.group), i = -1; i < (groups ? groups.length : 0); i++){
                let found = direct[i < 0 ? node.name : groups[i]];
                if (found) return found;
            }
        };
    }
}
/**
An empty dummy node type to use when no actual type is available.
*/ $a7a41eb5193c1110$export$f06e977173f1857c.none = new $a7a41eb5193c1110$export$f06e977173f1857c("", Object.create(null), 0, 8 /* NodeFlag.Anonymous */ );
/**
A node set holds a collection of node types. It is used to
compactly represent trees by storing their type ids, rather than a
full pointer to the type object, in a numeric array. Each parser
[has](#lr.LRParser.nodeSet) a node set, and [tree
buffers](#common.TreeBuffer) can only store collections of nodes
from the same set. A set can have a maximum of 2**16 (65536) node
types in it, so that the ids fit into 16-bit typed array slots.
*/ class $a7a41eb5193c1110$export$7fad5fb00d8de02c {
    /**
    Create a set with the given types. The `id` property of each
    type should correspond to its position within the array.
    */ constructor(/**
    The node types in this set, by id.
    */ types){
        this.types = types;
        for(let i = 0; i < types.length; i++)if (types[i].id != i) throw new RangeError("Node type ids should correspond to array positions when creating a node set");
    }
    /**
    Create a copy of this set with some node properties added. The
    arguments to this method can be created with
    [`NodeProp.add`](#common.NodeProp.add).
    */ extend(...props) {
        let newTypes = [];
        for (let type of this.types){
            let newProps = null;
            for (let source of props){
                let add = source(type);
                if (add) {
                    if (!newProps) newProps = Object.assign({}, type.props);
                    newProps[add[0].id] = add[1];
                }
            }
            newTypes.push(newProps ? new $a7a41eb5193c1110$export$f06e977173f1857c(type.name, newProps, type.id, type.flags) : type);
        }
        return new $a7a41eb5193c1110$export$7fad5fb00d8de02c(newTypes);
    }
}
const $a7a41eb5193c1110$var$CachedNode = new WeakMap(), $a7a41eb5193c1110$var$CachedInnerNode = new WeakMap();
/**
Options that control iteration. Can be combined with the `|`
operator to enable multiple ones.
*/ var $a7a41eb5193c1110$export$b0e28367f55837aa;
(function(IterMode) {
    /**
    When enabled, iteration will only visit [`Tree`](#common.Tree)
    objects, not nodes packed into
    [`TreeBuffer`](#common.TreeBuffer)s.
    */ IterMode[IterMode["ExcludeBuffers"] = 1] = "ExcludeBuffers";
    /**
    Enable this to make iteration include anonymous nodes (such as
    the nodes that wrap repeated grammar constructs into a balanced
    tree).
    */ IterMode[IterMode["IncludeAnonymous"] = 2] = "IncludeAnonymous";
    /**
    By default, regular [mounted](#common.NodeProp^mounted) nodes
    replace their base node in iteration. Enable this to ignore them
    instead.
    */ IterMode[IterMode["IgnoreMounts"] = 4] = "IgnoreMounts";
    /**
    This option only applies in
    [`enter`](#common.SyntaxNode.enter)-style methods. It tells the
    library to not enter mounted overlays if one covers the given
    position.
    */ IterMode[IterMode["IgnoreOverlays"] = 8] = "IgnoreOverlays";
})($a7a41eb5193c1110$export$b0e28367f55837aa || ($a7a41eb5193c1110$export$b0e28367f55837aa = {}));
/**
A piece of syntax tree. There are two ways to approach these
trees: the way they are actually stored in memory, and the
convenient way.

Syntax trees are stored as a tree of `Tree` and `TreeBuffer`
objects. By packing detail information into `TreeBuffer` leaf
nodes, the representation is made a lot more memory-efficient.

However, when you want to actually work with tree nodes, this
representation is very awkward, so most client code will want to
use the [`TreeCursor`](#common.TreeCursor) or
[`SyntaxNode`](#common.SyntaxNode) interface instead, which provides
a view on some part of this data structure, and can be used to
move around to adjacent nodes.
*/ class $a7a41eb5193c1110$export$7fbedc92909ed28e {
    /**
    Construct a new tree. See also [`Tree.build`](#common.Tree^build).
    */ constructor(/**
    The type of the top node.
    */ type, /**
    This node's child nodes.
    */ children, /**
    The positions (offsets relative to the start of this tree) of
    the children.
    */ positions, /**
    The total length of this tree
    */ length, /**
    Per-node [node props](#common.NodeProp) to associate with this node.
    */ props){
        this.type = type;
        this.children = children;
        this.positions = positions;
        this.length = length;
        /**
        @internal
        */ this.props = null;
        if (props && props.length) {
            this.props = Object.create(null);
            for (let [prop, value] of props)this.props[typeof prop == "number" ? prop : prop.id] = value;
        }
    }
    /**
    @internal
    */ toString() {
        let mounted = $a7a41eb5193c1110$export$358cdd8bd77577cc.get(this);
        if (mounted && !mounted.overlay) return mounted.tree.toString();
        let children = "";
        for (let ch of this.children){
            let str = ch.toString();
            if (str) {
                if (children) children += ",";
                children += str;
            }
        }
        return !this.type.name ? children : (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (children.length ? "(" + children + ")" : "");
    }
    /**
    Get a [tree cursor](#common.TreeCursor) positioned at the top of
    the tree. Mode can be used to [control](#common.IterMode) which
    nodes the cursor visits.
    */ cursor(mode = 0) {
        return new $a7a41eb5193c1110$export$3ae4554f36e54a34(this.topNode, mode);
    }
    /**
    Get a [tree cursor](#common.TreeCursor) pointing into this tree
    at the given position and side (see
    [`moveTo`](#common.TreeCursor.moveTo).
    */ cursorAt(pos, side = 0, mode = 0) {
        let scope = $a7a41eb5193c1110$var$CachedNode.get(this) || this.topNode;
        let cursor = new $a7a41eb5193c1110$export$3ae4554f36e54a34(scope);
        cursor.moveTo(pos, side);
        $a7a41eb5193c1110$var$CachedNode.set(this, cursor._tree);
        return cursor;
    }
    /**
    Get a [syntax node](#common.SyntaxNode) object for the top of the
    tree.
    */ get topNode() {
        return new $a7a41eb5193c1110$var$TreeNode(this, 0, 0, null);
    }
    /**
    Get the [syntax node](#common.SyntaxNode) at the given position.
    If `side` is -1, this will move into nodes that end at the
    position. If 1, it'll move into nodes that start at the
    position. With 0, it'll only enter nodes that cover the position
    from both sides.
    
    Note that this will not enter
    [overlays](#common.MountedTree.overlay), and you often want
    [`resolveInner`](#common.Tree.resolveInner) instead.
    */ resolve(pos, side = 0) {
        let node = $a7a41eb5193c1110$var$resolveNode($a7a41eb5193c1110$var$CachedNode.get(this) || this.topNode, pos, side, false);
        $a7a41eb5193c1110$var$CachedNode.set(this, node);
        return node;
    }
    /**
    Like [`resolve`](#common.Tree.resolve), but will enter
    [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
    pointing into the innermost overlaid tree at the given position
    (with parent links going through all parent structure, including
    the host trees).
    */ resolveInner(pos, side = 0) {
        let node = $a7a41eb5193c1110$var$resolveNode($a7a41eb5193c1110$var$CachedInnerNode.get(this) || this.topNode, pos, side, true);
        $a7a41eb5193c1110$var$CachedInnerNode.set(this, node);
        return node;
    }
    /**
    In some situations, it can be useful to iterate through all
    nodes around a position, including those in overlays that don't
    directly cover the position. This method gives you an iterator
    that will produce all nodes, from small to big, around the given
    position.
    */ resolveStack(pos, side = 0) {
        return $a7a41eb5193c1110$var$stackIterator(this, pos, side);
    }
    /**
    Iterate over the tree and its children, calling `enter` for any
    node that touches the `from`/`to` region (if given) before
    running over such a node's children, and `leave` (if given) when
    leaving the node. When `enter` returns `false`, that node will
    not have its children iterated over (or `leave` called).
    */ iterate(spec) {
        let { enter: enter, leave: leave, from: from = 0, to: to = this.length } = spec;
        let mode = spec.mode || 0, anon = (mode & $a7a41eb5193c1110$export$b0e28367f55837aa.IncludeAnonymous) > 0;
        for(let c = this.cursor(mode | $a7a41eb5193c1110$export$b0e28367f55837aa.IncludeAnonymous);;){
            let entered = false;
            if (c.from <= to && c.to >= from && (!anon && c.type.isAnonymous || enter(c) !== false)) {
                if (c.firstChild()) continue;
                entered = true;
            }
            for(;;){
                if (entered && leave && (anon || !c.type.isAnonymous)) leave(c);
                if (c.nextSibling()) break;
                if (!c.parent()) return;
                entered = true;
            }
        }
    }
    /**
    Get the value of the given [node prop](#common.NodeProp) for this
    node. Works with both per-node and per-type props.
    */ prop(prop) {
        return !prop.perNode ? this.type.prop(prop) : this.props ? this.props[prop.id] : undefined;
    }
    /**
    Returns the node's [per-node props](#common.NodeProp.perNode) in a
    format that can be passed to the [`Tree`](#common.Tree)
    constructor.
    */ get propValues() {
        let result = [];
        if (this.props) for(let id in this.props)result.push([
            +id,
            this.props[id]
        ]);
        return result;
    }
    /**
    Balance the direct children of this tree, producing a copy of
    which may have children grouped into subtrees with type
    [`NodeType.none`](#common.NodeType^none).
    */ balance(config = {}) {
        return this.children.length <= 8 /* Balance.BranchFactor */  ? this : $a7a41eb5193c1110$var$balanceRange($a7a41eb5193c1110$export$f06e977173f1857c.none, this.children, this.positions, 0, this.children.length, 0, this.length, (children, positions, length)=>new $a7a41eb5193c1110$export$7fbedc92909ed28e(this.type, children, positions, length, this.propValues), config.makeTree || ((children, positions, length)=>new $a7a41eb5193c1110$export$7fbedc92909ed28e($a7a41eb5193c1110$export$f06e977173f1857c.none, children, positions, length)));
    }
    /**
    Build a tree from a postfix-ordered buffer of node information,
    or a cursor over such a buffer.
    */ static build(data) {
        return $a7a41eb5193c1110$var$buildTree(data);
    }
}
/**
The empty tree
*/ $a7a41eb5193c1110$export$7fbedc92909ed28e.empty = new $a7a41eb5193c1110$export$7fbedc92909ed28e($a7a41eb5193c1110$export$f06e977173f1857c.none, [], [], 0);
class $a7a41eb5193c1110$var$FlatBufferCursor {
    constructor(buffer, index){
        this.buffer = buffer;
        this.index = index;
    }
    get id() {
        return this.buffer[this.index - 4];
    }
    get start() {
        return this.buffer[this.index - 3];
    }
    get end() {
        return this.buffer[this.index - 2];
    }
    get size() {
        return this.buffer[this.index - 1];
    }
    get pos() {
        return this.index;
    }
    next() {
        this.index -= 4;
    }
    fork() {
        return new $a7a41eb5193c1110$var$FlatBufferCursor(this.buffer, this.index);
    }
}
/**
Tree buffers contain (type, start, end, endIndex) quads for each
node. In such a buffer, nodes are stored in prefix order (parents
before children, with the endIndex of the parent indicating which
children belong to it).
*/ class $a7a41eb5193c1110$export$33300581b70be371 {
    /**
    Create a tree buffer.
    */ constructor(/**
    The buffer's content.
    */ buffer, /**
    The total length of the group of nodes in the buffer.
    */ length, /**
    The node set used in this buffer.
    */ set){
        this.buffer = buffer;
        this.length = length;
        this.set = set;
    }
    /**
    @internal
    */ get type() {
        return $a7a41eb5193c1110$export$f06e977173f1857c.none;
    }
    /**
    @internal
    */ toString() {
        let result = [];
        for(let index = 0; index < this.buffer.length;){
            result.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result.join(",");
    }
    /**
    @internal
    */ childString(index) {
        let id = this.buffer[index], endIndex = this.buffer[index + 3];
        let type = this.set.types[id], result = type.name;
        if (/\W/.test(result) && !type.isError) result = JSON.stringify(result);
        index += 4;
        if (endIndex == index) return result;
        let children = [];
        while(index < endIndex){
            children.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result + "(" + children.join(",") + ")";
    }
    /**
    @internal
    */ findChild(startIndex, endIndex, dir, pos, side) {
        let { buffer: buffer } = this, pick = -1;
        for(let i = startIndex; i != endIndex; i = buffer[i + 3])if ($a7a41eb5193c1110$var$checkSide(side, pos, buffer[i + 1], buffer[i + 2])) {
            pick = i;
            if (dir > 0) break;
        }
        return pick;
    }
    /**
    @internal
    */ slice(startI, endI, from) {
        let b = this.buffer;
        let copy = new Uint16Array(endI - startI), len = 0;
        for(let i = startI, j = 0; i < endI;){
            copy[j++] = b[i++];
            copy[j++] = b[i++] - from;
            let to = copy[j++] = b[i++] - from;
            copy[j++] = b[i++] - startI;
            len = Math.max(len, to);
        }
        return new $a7a41eb5193c1110$export$33300581b70be371(copy, len, this.set);
    }
}
function $a7a41eb5193c1110$var$checkSide(side, pos, from, to) {
    switch(side){
        case -2 /* Side.Before */ :
            return from < pos;
        case -1 /* Side.AtOrBefore */ :
            return to >= pos && from < pos;
        case 0 /* Side.Around */ :
            return from < pos && to > pos;
        case 1 /* Side.AtOrAfter */ :
            return from <= pos && to > pos;
        case 2 /* Side.After */ :
            return to > pos;
        case 4 /* Side.DontCare */ :
            return true;
    }
}
function $a7a41eb5193c1110$var$resolveNode(node, pos, side, overlays) {
    var _a;
    // Move up to a node that actually holds the position, if possible
    while(node.from == node.to || (side < 1 ? node.from >= pos : node.from > pos) || (side > -1 ? node.to <= pos : node.to < pos)){
        let parent = !overlays && node instanceof $a7a41eb5193c1110$var$TreeNode && node.index < 0 ? null : node.parent;
        if (!parent) return node;
        node = parent;
    }
    let mode = overlays ? 0 : $a7a41eb5193c1110$export$b0e28367f55837aa.IgnoreOverlays;
    // Must go up out of overlays when those do not overlap with pos
    if (overlays) {
        for(let scan = node, parent = scan.parent; parent; scan = parent, parent = scan.parent)if (scan instanceof $a7a41eb5193c1110$var$TreeNode && scan.index < 0 && ((_a = parent.enter(pos, side, mode)) === null || _a === void 0 ? void 0 : _a.from) != scan.from) node = parent;
    }
    for(;;){
        let inner = node.enter(pos, side, mode);
        if (!inner) return node;
        node = inner;
    }
}
class $a7a41eb5193c1110$var$BaseNode {
    cursor(mode = 0) {
        return new $a7a41eb5193c1110$export$3ae4554f36e54a34(this, mode);
    }
    getChild(type, before = null, after = null) {
        let r = $a7a41eb5193c1110$var$getChildren(this, type, before, after);
        return r.length ? r[0] : null;
    }
    getChildren(type, before = null, after = null) {
        return $a7a41eb5193c1110$var$getChildren(this, type, before, after);
    }
    resolve(pos, side = 0) {
        return $a7a41eb5193c1110$var$resolveNode(this, pos, side, false);
    }
    resolveInner(pos, side = 0) {
        return $a7a41eb5193c1110$var$resolveNode(this, pos, side, true);
    }
    matchContext(context) {
        return $a7a41eb5193c1110$var$matchNodeContext(this.parent, context);
    }
    enterUnfinishedNodesBefore(pos) {
        let scan = this.childBefore(pos), node = this;
        while(scan){
            let last = scan.lastChild;
            if (!last || last.to != scan.to) break;
            if (last.type.isError && last.from == last.to) {
                node = scan;
                scan = last.prevSibling;
            } else scan = last;
        }
        return node;
    }
    get node() {
        return this;
    }
    get next() {
        return this.parent;
    }
}
class $a7a41eb5193c1110$var$TreeNode extends $a7a41eb5193c1110$var$BaseNode {
    constructor(_tree, from, // Index in parent node, set to -1 if the node is not a direct child of _parent.node (overlay)
    index, _parent){
        super();
        this._tree = _tree;
        this.from = from;
        this.index = index;
        this._parent = _parent;
    }
    get type() {
        return this._tree.type;
    }
    get name() {
        return this._tree.type.name;
    }
    get to() {
        return this.from + this._tree.length;
    }
    nextChild(i, dir, pos, side, mode = 0) {
        for(let parent = this;;){
            for(let { children: children, positions: positions } = parent._tree, e = dir > 0 ? children.length : -1; i != e; i += dir){
                let next = children[i], start = positions[i] + parent.from;
                if (!$a7a41eb5193c1110$var$checkSide(side, pos, start, start + next.length)) continue;
                if (next instanceof $a7a41eb5193c1110$export$33300581b70be371) {
                    if (mode & $a7a41eb5193c1110$export$b0e28367f55837aa.ExcludeBuffers) continue;
                    let index = next.findChild(0, next.buffer.length, dir, pos - start, side);
                    if (index > -1) return new $a7a41eb5193c1110$var$BufferNode(new $a7a41eb5193c1110$var$BufferContext(parent, next, i, start), null, index);
                } else if (mode & $a7a41eb5193c1110$export$b0e28367f55837aa.IncludeAnonymous || !next.type.isAnonymous || $a7a41eb5193c1110$var$hasChild(next)) {
                    let mounted;
                    if (!(mode & $a7a41eb5193c1110$export$b0e28367f55837aa.IgnoreMounts) && (mounted = $a7a41eb5193c1110$export$358cdd8bd77577cc.get(next)) && !mounted.overlay) return new $a7a41eb5193c1110$var$TreeNode(mounted.tree, start, i, parent);
                    let inner = new $a7a41eb5193c1110$var$TreeNode(next, start, i, parent);
                    return mode & $a7a41eb5193c1110$export$b0e28367f55837aa.IncludeAnonymous || !inner.type.isAnonymous ? inner : inner.nextChild(dir < 0 ? next.children.length - 1 : 0, dir, pos, side);
                }
            }
            if (mode & $a7a41eb5193c1110$export$b0e28367f55837aa.IncludeAnonymous || !parent.type.isAnonymous) return null;
            if (parent.index >= 0) i = parent.index + dir;
            else i = dir < 0 ? -1 : parent._parent._tree.children.length;
            parent = parent._parent;
            if (!parent) return null;
        }
    }
    get firstChild() {
        return this.nextChild(0, 1, 0, 4 /* Side.DontCare */ );
    }
    get lastChild() {
        return this.nextChild(this._tree.children.length - 1, -1, 0, 4 /* Side.DontCare */ );
    }
    childAfter(pos) {
        return this.nextChild(0, 1, pos, 2 /* Side.After */ );
    }
    childBefore(pos) {
        return this.nextChild(this._tree.children.length - 1, -1, pos, -2 /* Side.Before */ );
    }
    enter(pos, side, mode = 0) {
        let mounted;
        if (!(mode & $a7a41eb5193c1110$export$b0e28367f55837aa.IgnoreOverlays) && (mounted = $a7a41eb5193c1110$export$358cdd8bd77577cc.get(this._tree)) && mounted.overlay) {
            let rPos = pos - this.from;
            for (let { from: from, to: to } of mounted.overlay){
                if ((side > 0 ? from <= rPos : from < rPos) && (side < 0 ? to >= rPos : to > rPos)) return new $a7a41eb5193c1110$var$TreeNode(mounted.tree, mounted.overlay[0].from + this.from, -1, this);
            }
        }
        return this.nextChild(0, 1, pos, side, mode);
    }
    nextSignificantParent() {
        let val = this;
        while(val.type.isAnonymous && val._parent)val = val._parent;
        return val;
    }
    get parent() {
        return this._parent ? this._parent.nextSignificantParent() : null;
    }
    get nextSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4 /* Side.DontCare */ ) : null;
    }
    get prevSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4 /* Side.DontCare */ ) : null;
    }
    get tree() {
        return this._tree;
    }
    toTree() {
        return this._tree;
    }
    /**
    @internal
    */ toString() {
        return this._tree.toString();
    }
}
function $a7a41eb5193c1110$var$getChildren(node, type, before, after) {
    let cur = node.cursor(), result = [];
    if (!cur.firstChild()) return result;
    if (before != null) for(let found = false; !found;){
        found = cur.type.is(before);
        if (!cur.nextSibling()) return result;
    }
    for(;;){
        if (after != null && cur.type.is(after)) return result;
        if (cur.type.is(type)) result.push(cur.node);
        if (!cur.nextSibling()) return after == null ? result : [];
    }
}
function $a7a41eb5193c1110$var$matchNodeContext(node, context, i = context.length - 1) {
    for(let p = node; i >= 0; p = p.parent){
        if (!p) return false;
        if (!p.type.isAnonymous) {
            if (context[i] && context[i] != p.name) return false;
            i--;
        }
    }
    return true;
}
class $a7a41eb5193c1110$var$BufferContext {
    constructor(parent, buffer, index, start){
        this.parent = parent;
        this.buffer = buffer;
        this.index = index;
        this.start = start;
    }
}
class $a7a41eb5193c1110$var$BufferNode extends $a7a41eb5193c1110$var$BaseNode {
    get name() {
        return this.type.name;
    }
    get from() {
        return this.context.start + this.context.buffer.buffer[this.index + 1];
    }
    get to() {
        return this.context.start + this.context.buffer.buffer[this.index + 2];
    }
    constructor(context, _parent, index){
        super();
        this.context = context;
        this._parent = _parent;
        this.index = index;
        this.type = context.buffer.set.types[context.buffer.buffer[index]];
    }
    child(dir, pos, side) {
        let { buffer: buffer } = this.context;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.context.start, side);
        return index < 0 ? null : new $a7a41eb5193c1110$var$BufferNode(this.context, this, index);
    }
    get firstChild() {
        return this.child(1, 0, 4 /* Side.DontCare */ );
    }
    get lastChild() {
        return this.child(-1, 0, 4 /* Side.DontCare */ );
    }
    childAfter(pos) {
        return this.child(1, pos, 2 /* Side.After */ );
    }
    childBefore(pos) {
        return this.child(-1, pos, -2 /* Side.Before */ );
    }
    enter(pos, side, mode = 0) {
        if (mode & $a7a41eb5193c1110$export$b0e28367f55837aa.ExcludeBuffers) return null;
        let { buffer: buffer } = this.context;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], side > 0 ? 1 : -1, pos - this.context.start, side);
        return index < 0 ? null : new $a7a41eb5193c1110$var$BufferNode(this.context, this, index);
    }
    get parent() {
        return this._parent || this.context.parent.nextSignificantParent();
    }
    externalSibling(dir) {
        return this._parent ? null : this.context.parent.nextChild(this.context.index + dir, dir, 0, 4 /* Side.DontCare */ );
    }
    get nextSibling() {
        let { buffer: buffer } = this.context;
        let after = buffer.buffer[this.index + 3];
        if (after < (this._parent ? buffer.buffer[this._parent.index + 3] : buffer.buffer.length)) return new $a7a41eb5193c1110$var$BufferNode(this.context, this._parent, after);
        return this.externalSibling(1);
    }
    get prevSibling() {
        let { buffer: buffer } = this.context;
        let parentStart = this._parent ? this._parent.index + 4 : 0;
        if (this.index == parentStart) return this.externalSibling(-1);
        return new $a7a41eb5193c1110$var$BufferNode(this.context, this._parent, buffer.findChild(parentStart, this.index, -1, 0, 4 /* Side.DontCare */ ));
    }
    get tree() {
        return null;
    }
    toTree() {
        let children = [], positions = [];
        let { buffer: buffer } = this.context;
        let startI = this.index + 4, endI = buffer.buffer[this.index + 3];
        if (endI > startI) {
            let from = buffer.buffer[this.index + 1];
            children.push(buffer.slice(startI, endI, from));
            positions.push(0);
        }
        return new $a7a41eb5193c1110$export$7fbedc92909ed28e(this.type, children, positions, this.to - this.from);
    }
    /**
    @internal
    */ toString() {
        return this.context.buffer.childString(this.index);
    }
}
function $a7a41eb5193c1110$var$iterStack(heads) {
    if (!heads.length) return null;
    let pick = 0, picked = heads[0];
    for(let i = 1; i < heads.length; i++){
        let node = heads[i];
        if (node.from > picked.from || node.to < picked.to) {
            picked = node;
            pick = i;
        }
    }
    let next = picked instanceof $a7a41eb5193c1110$var$TreeNode && picked.index < 0 ? null : picked.parent;
    let newHeads = heads.slice();
    if (next) newHeads[pick] = next;
    else newHeads.splice(pick, 1);
    return new $a7a41eb5193c1110$var$StackIterator(newHeads, picked);
}
class $a7a41eb5193c1110$var$StackIterator {
    constructor(heads, node){
        this.heads = heads;
        this.node = node;
    }
    get next() {
        return $a7a41eb5193c1110$var$iterStack(this.heads);
    }
}
function $a7a41eb5193c1110$var$stackIterator(tree, pos, side) {
    let inner = tree.resolveInner(pos, side), layers = null;
    for(let scan = inner instanceof $a7a41eb5193c1110$var$TreeNode ? inner : inner.context.parent; scan; scan = scan.parent)if (scan.index < 0) {
        let parent = scan.parent;
        (layers || (layers = [
            inner
        ])).push(parent.resolve(pos, side));
        scan = parent;
    } else {
        let mount = $a7a41eb5193c1110$export$358cdd8bd77577cc.get(scan.tree);
        // Relevant overlay branching off
        if (mount && mount.overlay && mount.overlay[0].from <= pos && mount.overlay[mount.overlay.length - 1].to >= pos) {
            let root = new $a7a41eb5193c1110$var$TreeNode(mount.tree, mount.overlay[0].from + scan.from, -1, scan);
            (layers || (layers = [
                inner
            ])).push($a7a41eb5193c1110$var$resolveNode(root, pos, side, false));
        }
    }
    return layers ? $a7a41eb5193c1110$var$iterStack(layers) : inner;
}
/**
A tree cursor object focuses on a given node in a syntax tree, and
allows you to move to adjacent nodes.
*/ class $a7a41eb5193c1110$export$3ae4554f36e54a34 {
    /**
    Shorthand for `.type.name`.
    */ get name() {
        return this.type.name;
    }
    /**
    @internal
    */ constructor(node, /**
    @internal
    */ mode = 0){
        this.mode = mode;
        /**
        @internal
        */ this.buffer = null;
        this.stack = [];
        /**
        @internal
        */ this.index = 0;
        this.bufferNode = null;
        if (node instanceof $a7a41eb5193c1110$var$TreeNode) this.yieldNode(node);
        else {
            this._tree = node.context.parent;
            this.buffer = node.context;
            for(let n = node._parent; n; n = n._parent)this.stack.unshift(n.index);
            this.bufferNode = node;
            this.yieldBuf(node.index);
        }
    }
    yieldNode(node) {
        if (!node) return false;
        this._tree = node;
        this.type = node.type;
        this.from = node.from;
        this.to = node.to;
        return true;
    }
    yieldBuf(index, type) {
        this.index = index;
        let { start: start, buffer: buffer } = this.buffer;
        this.type = type || buffer.set.types[buffer.buffer[index]];
        this.from = start + buffer.buffer[index + 1];
        this.to = start + buffer.buffer[index + 2];
        return true;
    }
    /**
    @internal
    */ yield(node) {
        if (!node) return false;
        if (node instanceof $a7a41eb5193c1110$var$TreeNode) {
            this.buffer = null;
            return this.yieldNode(node);
        }
        this.buffer = node.context;
        return this.yieldBuf(node.index, node.type);
    }
    /**
    @internal
    */ toString() {
        return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
    }
    /**
    @internal
    */ enterChild(dir, pos, side) {
        if (!this.buffer) return this.yield(this._tree.nextChild(dir < 0 ? this._tree._tree.children.length - 1 : 0, dir, pos, side, this.mode));
        let { buffer: buffer } = this.buffer;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.buffer.start, side);
        if (index < 0) return false;
        this.stack.push(this.index);
        return this.yieldBuf(index);
    }
    /**
    Move the cursor to this node's first child. When this returns
    false, the node has no child, and the cursor has not been moved.
    */ firstChild() {
        return this.enterChild(1, 0, 4 /* Side.DontCare */ );
    }
    /**
    Move the cursor to this node's last child.
    */ lastChild() {
        return this.enterChild(-1, 0, 4 /* Side.DontCare */ );
    }
    /**
    Move the cursor to the first child that ends after `pos`.
    */ childAfter(pos) {
        return this.enterChild(1, pos, 2 /* Side.After */ );
    }
    /**
    Move to the last child that starts before `pos`.
    */ childBefore(pos) {
        return this.enterChild(-1, pos, -2 /* Side.Before */ );
    }
    /**
    Move the cursor to the child around `pos`. If side is -1 the
    child may end at that position, when 1 it may start there. This
    will also enter [overlaid](#common.MountedTree.overlay)
    [mounted](#common.NodeProp^mounted) trees unless `overlays` is
    set to false.
    */ enter(pos, side, mode = this.mode) {
        if (!this.buffer) return this.yield(this._tree.enter(pos, side, mode));
        return mode & $a7a41eb5193c1110$export$b0e28367f55837aa.ExcludeBuffers ? false : this.enterChild(1, pos, side);
    }
    /**
    Move to the node's parent node, if this isn't the top node.
    */ parent() {
        if (!this.buffer) return this.yieldNode(this.mode & $a7a41eb5193c1110$export$b0e28367f55837aa.IncludeAnonymous ? this._tree._parent : this._tree.parent);
        if (this.stack.length) return this.yieldBuf(this.stack.pop());
        let parent = this.mode & $a7a41eb5193c1110$export$b0e28367f55837aa.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
        this.buffer = null;
        return this.yieldNode(parent);
    }
    /**
    @internal
    */ sibling(dir) {
        if (!this.buffer) return !this._tree._parent ? false : this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + dir, dir, 0, 4 /* Side.DontCare */ , this.mode));
        let { buffer: buffer } = this.buffer, d = this.stack.length - 1;
        if (dir < 0) {
            let parentStart = d < 0 ? 0 : this.stack[d] + 4;
            if (this.index != parentStart) return this.yieldBuf(buffer.findChild(parentStart, this.index, -1, 0, 4 /* Side.DontCare */ ));
        } else {
            let after = buffer.buffer[this.index + 3];
            if (after < (d < 0 ? buffer.buffer.length : buffer.buffer[this.stack[d] + 3])) return this.yieldBuf(after);
        }
        return d < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + dir, dir, 0, 4 /* Side.DontCare */ , this.mode)) : false;
    }
    /**
    Move to this node's next sibling, if any.
    */ nextSibling() {
        return this.sibling(1);
    }
    /**
    Move to this node's previous sibling, if any.
    */ prevSibling() {
        return this.sibling(-1);
    }
    atLastNode(dir) {
        let index, parent, { buffer: buffer } = this;
        if (buffer) {
            if (dir > 0) {
                if (this.index < buffer.buffer.buffer.length) return false;
            } else {
                for(let i = 0; i < this.index; i++)if (buffer.buffer.buffer[i + 3] < this.index) return false;
            }
            ({ index: index, parent: parent } = buffer);
        } else ({ index: index, _parent: parent } = this._tree);
        for(; parent; { index: index, _parent: parent } = parent){
            if (index > -1) for(let i = index + dir, e = dir < 0 ? -1 : parent._tree.children.length; i != e; i += dir){
                let child = parent._tree.children[i];
                if (this.mode & $a7a41eb5193c1110$export$b0e28367f55837aa.IncludeAnonymous || child instanceof $a7a41eb5193c1110$export$33300581b70be371 || !child.type.isAnonymous || $a7a41eb5193c1110$var$hasChild(child)) return false;
            }
        }
        return true;
    }
    move(dir, enter) {
        if (enter && this.enterChild(dir, 0, 4 /* Side.DontCare */ )) return true;
        for(;;){
            if (this.sibling(dir)) return true;
            if (this.atLastNode(dir) || !this.parent()) return false;
        }
    }
    /**
    Move to the next node in a
    [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
    traversal, going from a node to its first child or, if the
    current node is empty or `enter` is false, its next sibling or
    the next sibling of the first parent node that has one.
    */ next(enter = true) {
        return this.move(1, enter);
    }
    /**
    Move to the next node in a last-to-first pre-order traversal. A
    node is followed by its last child or, if it has none, its
    previous sibling or the previous sibling of the first parent
    node that has one.
    */ prev(enter = true) {
        return this.move(-1, enter);
    }
    /**
    Move the cursor to the innermost node that covers `pos`. If
    `side` is -1, it will enter nodes that end at `pos`. If it is 1,
    it will enter nodes that start at `pos`.
    */ moveTo(pos, side = 0) {
        // Move up to a node that actually holds the position, if possible
        while(this.from == this.to || (side < 1 ? this.from >= pos : this.from > pos) || (side > -1 ? this.to <= pos : this.to < pos))if (!this.parent()) break;
        // Then scan down into child nodes as far as possible
        while(this.enterChild(1, pos, side));
        return this;
    }
    /**
    Get a [syntax node](#common.SyntaxNode) at the cursor's current
    position.
    */ get node() {
        if (!this.buffer) return this._tree;
        let cache = this.bufferNode, result = null, depth = 0;
        if (cache && cache.context == this.buffer) scan: for(let index = this.index, d = this.stack.length; d >= 0;){
            for(let c = cache; c; c = c._parent)if (c.index == index) {
                if (index == this.index) return c;
                result = c;
                depth = d + 1;
                break scan;
            }
            index = this.stack[--d];
        }
        for(let i = depth; i < this.stack.length; i++)result = new $a7a41eb5193c1110$var$BufferNode(this.buffer, result, this.stack[i]);
        return this.bufferNode = new $a7a41eb5193c1110$var$BufferNode(this.buffer, result, this.index);
    }
    /**
    Get the [tree](#common.Tree) that represents the current node, if
    any. Will return null when the node is in a [tree
    buffer](#common.TreeBuffer).
    */ get tree() {
        return this.buffer ? null : this._tree._tree;
    }
    /**
    Iterate over the current node and all its descendants, calling
    `enter` when entering a node and `leave`, if given, when leaving
    one. When `enter` returns `false`, any children of that node are
    skipped, and `leave` isn't called for it.
    */ iterate(enter, leave) {
        for(let depth = 0;;){
            let mustLeave = false;
            if (this.type.isAnonymous || enter(this) !== false) {
                if (this.firstChild()) {
                    depth++;
                    continue;
                }
                if (!this.type.isAnonymous) mustLeave = true;
            }
            for(;;){
                if (mustLeave && leave) leave(this);
                mustLeave = this.type.isAnonymous;
                if (!depth) return;
                if (this.nextSibling()) break;
                this.parent();
                depth--;
                mustLeave = true;
            }
        }
    }
    /**
    Test whether the current node matches a given context—a sequence
    of direct parent node names. Empty strings in the context array
    are treated as wildcards.
    */ matchContext(context) {
        if (!this.buffer) return $a7a41eb5193c1110$var$matchNodeContext(this.node.parent, context);
        let { buffer: buffer } = this.buffer, { types: types } = buffer.set;
        for(let i = context.length - 1, d = this.stack.length - 1; i >= 0; d--){
            if (d < 0) return $a7a41eb5193c1110$var$matchNodeContext(this._tree, context, i);
            let type = types[buffer.buffer[this.stack[d]]];
            if (!type.isAnonymous) {
                if (context[i] && context[i] != type.name) return false;
                i--;
            }
        }
        return true;
    }
}
function $a7a41eb5193c1110$var$hasChild(tree) {
    return tree.children.some((ch)=>ch instanceof $a7a41eb5193c1110$export$33300581b70be371 || !ch.type.isAnonymous || $a7a41eb5193c1110$var$hasChild(ch));
}
function $a7a41eb5193c1110$var$buildTree(data) {
    var _a;
    let { buffer: buffer, nodeSet: nodeSet, maxBufferLength: maxBufferLength = $a7a41eb5193c1110$export$de305a849879ffa, reused: reused = [], minRepeatType: minRepeatType = nodeSet.types.length } = data;
    let cursor = Array.isArray(buffer) ? new $a7a41eb5193c1110$var$FlatBufferCursor(buffer, buffer.length) : buffer;
    let types = nodeSet.types;
    let contextHash = 0, lookAhead = 0;
    function takeNode(parentStart, minPos, children, positions, inRepeat, depth) {
        let { id: id, start: start, end: end, size: size } = cursor;
        let lookAheadAtStart = lookAhead, contextAtStart = contextHash;
        while(size < 0){
            cursor.next();
            if (size == -1 /* SpecialRecord.Reuse */ ) {
                let node = reused[id];
                children.push(node);
                positions.push(start - parentStart);
                return;
            } else if (size == -3 /* SpecialRecord.ContextChange */ ) {
                contextHash = id;
                return;
            } else if (size == -4 /* SpecialRecord.LookAhead */ ) {
                lookAhead = id;
                return;
            } else throw new RangeError(`Unrecognized record size: ${size}`);
        }
        let type = types[id], node, buffer;
        let startPos = start - parentStart;
        if (end - start <= maxBufferLength && (buffer = findBufferSize(cursor.pos - minPos, inRepeat))) {
            // Small enough for a buffer, and no reused nodes inside
            let data = new Uint16Array(buffer.size - buffer.skip);
            let endPos = cursor.pos - buffer.size, index = data.length;
            while(cursor.pos > endPos)index = copyToBuffer(buffer.start, data, index);
            node = new $a7a41eb5193c1110$export$33300581b70be371(data, end - buffer.start, nodeSet);
            startPos = buffer.start - parentStart;
        } else {
            let endPos = cursor.pos - size;
            cursor.next();
            let localChildren = [], localPositions = [];
            let localInRepeat = id >= minRepeatType ? id : -1;
            let lastGroup = 0, lastEnd = end;
            while(cursor.pos > endPos){
                if (localInRepeat >= 0 && cursor.id == localInRepeat && cursor.size >= 0) {
                    if (cursor.end <= lastEnd - maxBufferLength) {
                        makeRepeatLeaf(localChildren, localPositions, start, lastGroup, cursor.end, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
                        lastGroup = localChildren.length;
                        lastEnd = cursor.end;
                    }
                    cursor.next();
                } else if (depth > 2500 /* CutOff.Depth */ ) takeFlatNode(start, endPos, localChildren, localPositions);
                else takeNode(start, endPos, localChildren, localPositions, localInRepeat, depth + 1);
            }
            if (localInRepeat >= 0 && lastGroup > 0 && lastGroup < localChildren.length) makeRepeatLeaf(localChildren, localPositions, start, lastGroup, start, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
            localChildren.reverse();
            localPositions.reverse();
            if (localInRepeat > -1 && lastGroup > 0) {
                let make = makeBalanced(type, contextAtStart);
                node = $a7a41eb5193c1110$var$balanceRange(type, localChildren, localPositions, 0, localChildren.length, 0, end - start, make, make);
            } else node = makeTree(type, localChildren, localPositions, end - start, lookAheadAtStart - end, contextAtStart);
        }
        children.push(node);
        positions.push(startPos);
    }
    function takeFlatNode(parentStart, minPos, children, positions) {
        let nodes = []; // Temporary, inverted array of leaf nodes found, with absolute positions
        let nodeCount = 0, stopAt = -1;
        while(cursor.pos > minPos){
            let { id: id, start: start, end: end, size: size } = cursor;
            if (size > 4) cursor.next();
            else if (stopAt > -1 && start < stopAt) break;
            else {
                if (stopAt < 0) stopAt = end - maxBufferLength;
                nodes.push(id, start, end);
                nodeCount++;
                cursor.next();
            }
        }
        if (nodeCount) {
            let buffer = new Uint16Array(nodeCount * 4);
            let start = nodes[nodes.length - 2];
            for(let i = nodes.length - 3, j = 0; i >= 0; i -= 3){
                buffer[j++] = nodes[i];
                buffer[j++] = nodes[i + 1] - start;
                buffer[j++] = nodes[i + 2] - start;
                buffer[j++] = j;
            }
            children.push(new $a7a41eb5193c1110$export$33300581b70be371(buffer, nodes[2] - start, nodeSet));
            positions.push(start - parentStart);
        }
    }
    function makeBalanced(type, contextHash) {
        return (children, positions, length)=>{
            let lookAhead = 0, lastI = children.length - 1, last, lookAheadProp;
            if (lastI >= 0 && (last = children[lastI]) instanceof $a7a41eb5193c1110$export$7fbedc92909ed28e) {
                if (!lastI && last.type == type && last.length == length) return last;
                if (lookAheadProp = last.prop($a7a41eb5193c1110$export$b8034b9bc18acd90.lookAhead)) lookAhead = positions[lastI] + last.length + lookAheadProp;
            }
            return makeTree(type, children, positions, length, lookAhead, contextHash);
        };
    }
    function makeRepeatLeaf(children, positions, base, i, from, to, type, lookAhead, contextHash) {
        let localChildren = [], localPositions = [];
        while(children.length > i){
            localChildren.push(children.pop());
            localPositions.push(positions.pop() + base - from);
        }
        children.push(makeTree(nodeSet.types[type], localChildren, localPositions, to - from, lookAhead - to, contextHash));
        positions.push(from - base);
    }
    function makeTree(type, children, positions, length, lookAhead, contextHash, props) {
        if (contextHash) {
            let pair = [
                $a7a41eb5193c1110$export$b8034b9bc18acd90.contextHash,
                contextHash
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        if (lookAhead > 25) {
            let pair = [
                $a7a41eb5193c1110$export$b8034b9bc18acd90.lookAhead,
                lookAhead
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        return new $a7a41eb5193c1110$export$7fbedc92909ed28e(type, children, positions, length, props);
    }
    function findBufferSize(maxSize, inRepeat) {
        // Scan through the buffer to find previous siblings that fit
        // together in a TreeBuffer, and don't contain any reused nodes
        // (which can't be stored in a buffer).
        // If `inRepeat` is > -1, ignore node boundaries of that type for
        // nesting, but make sure the end falls either at the start
        // (`maxSize`) or before such a node.
        let fork = cursor.fork();
        let size = 0, start = 0, skip = 0, minStart = fork.end - maxBufferLength;
        let result = {
            size: 0,
            start: 0,
            skip: 0
        };
        scan: for(let minPos = fork.pos - maxSize; fork.pos > minPos;){
            let nodeSize = fork.size;
            // Pretend nested repeat nodes of the same type don't exist
            if (fork.id == inRepeat && nodeSize >= 0) {
                // Except that we store the current state as a valid return
                // value.
                result.size = size;
                result.start = start;
                result.skip = skip;
                skip += 4;
                size += 4;
                fork.next();
                continue;
            }
            let startPos = fork.pos - nodeSize;
            if (nodeSize < 0 || startPos < minPos || fork.start < minStart) break;
            let localSkipped = fork.id >= minRepeatType ? 4 : 0;
            let nodeStart = fork.start;
            fork.next();
            while(fork.pos > startPos){
                if (fork.size < 0) {
                    if (fork.size == -3 /* SpecialRecord.ContextChange */ ) localSkipped += 4;
                    else break scan;
                } else if (fork.id >= minRepeatType) localSkipped += 4;
                fork.next();
            }
            start = nodeStart;
            size += nodeSize;
            skip += localSkipped;
        }
        if (inRepeat < 0 || size == maxSize) {
            result.size = size;
            result.start = start;
            result.skip = skip;
        }
        return result.size > 4 ? result : undefined;
    }
    function copyToBuffer(bufferStart, buffer, index) {
        let { id: id, start: start, end: end, size: size } = cursor;
        cursor.next();
        if (size >= 0 && id < minRepeatType) {
            let startIndex = index;
            if (size > 4) {
                let endPos = cursor.pos - (size - 4);
                while(cursor.pos > endPos)index = copyToBuffer(bufferStart, buffer, index);
            }
            buffer[--index] = startIndex;
            buffer[--index] = end - bufferStart;
            buffer[--index] = start - bufferStart;
            buffer[--index] = id;
        } else if (size == -3 /* SpecialRecord.ContextChange */ ) contextHash = id;
        else if (size == -4 /* SpecialRecord.LookAhead */ ) lookAhead = id;
        return index;
    }
    let children = [], positions = [];
    while(cursor.pos > 0)takeNode(data.start || 0, data.bufferStart || 0, children, positions, -1, 0);
    let length = (_a = data.length) !== null && _a !== void 0 ? _a : children.length ? positions[0] + children[0].length : 0;
    return new $a7a41eb5193c1110$export$7fbedc92909ed28e(types[data.topID], children.reverse(), positions.reverse(), length);
}
const $a7a41eb5193c1110$var$nodeSizeCache = new WeakMap;
function $a7a41eb5193c1110$var$nodeSize(balanceType, node) {
    if (!balanceType.isAnonymous || node instanceof $a7a41eb5193c1110$export$33300581b70be371 || node.type != balanceType) return 1;
    let size = $a7a41eb5193c1110$var$nodeSizeCache.get(node);
    if (size == null) {
        size = 1;
        for (let child of node.children){
            if (child.type != balanceType || !(child instanceof $a7a41eb5193c1110$export$7fbedc92909ed28e)) {
                size = 1;
                break;
            }
            size += $a7a41eb5193c1110$var$nodeSize(balanceType, child);
        }
        $a7a41eb5193c1110$var$nodeSizeCache.set(node, size);
    }
    return size;
}
function $a7a41eb5193c1110$var$balanceRange(// The type the balanced tree's inner nodes.
balanceType, // The direct children and their positions
children, positions, // The index range in children/positions to use
from, to, // The start position of the nodes, relative to their parent.
start, // Length of the outer node
length, // Function to build the top node of the balanced tree
mkTop, // Function to build internal nodes for the balanced tree
mkTree) {
    let total = 0;
    for(let i = from; i < to; i++)total += $a7a41eb5193c1110$var$nodeSize(balanceType, children[i]);
    let maxChild = Math.ceil(total * 1.5 / 8 /* Balance.BranchFactor */ );
    let localChildren = [], localPositions = [];
    function divide(children, positions, from, to, offset) {
        for(let i = from; i < to;){
            let groupFrom = i, groupStart = positions[i], groupSize = $a7a41eb5193c1110$var$nodeSize(balanceType, children[i]);
            i++;
            for(; i < to; i++){
                let nextSize = $a7a41eb5193c1110$var$nodeSize(balanceType, children[i]);
                if (groupSize + nextSize >= maxChild) break;
                groupSize += nextSize;
            }
            if (i == groupFrom + 1) {
                if (groupSize > maxChild) {
                    let only = children[groupFrom]; // Only trees can have a size > 1
                    divide(only.children, only.positions, 0, only.children.length, positions[groupFrom] + offset);
                    continue;
                }
                localChildren.push(children[groupFrom]);
            } else {
                let length = positions[i - 1] + children[i - 1].length - groupStart;
                localChildren.push($a7a41eb5193c1110$var$balanceRange(balanceType, children, positions, groupFrom, i, groupStart, length, null, mkTree));
            }
            localPositions.push(groupStart + offset - start);
        }
    }
    divide(children, positions, from, to, 0);
    return (mkTop || mkTree)(localChildren, localPositions, length);
}
/**
Provides a way to associate values with pieces of trees. As long
as that part of the tree is reused, the associated values can be
retrieved from an updated tree.
*/ class $a7a41eb5193c1110$export$7f13b5dc44c541ae {
    constructor(){
        this.map = new WeakMap();
    }
    setBuffer(buffer, index, value) {
        let inner = this.map.get(buffer);
        if (!inner) this.map.set(buffer, inner = new Map);
        inner.set(index, value);
    }
    getBuffer(buffer, index) {
        let inner = this.map.get(buffer);
        return inner && inner.get(index);
    }
    /**
    Set the value for this syntax node.
    */ set(node, value) {
        if (node instanceof $a7a41eb5193c1110$var$BufferNode) this.setBuffer(node.context.buffer, node.index, value);
        else if (node instanceof $a7a41eb5193c1110$var$TreeNode) this.map.set(node.tree, value);
    }
    /**
    Retrieve value for this syntax node, if it exists in the map.
    */ get(node) {
        return node instanceof $a7a41eb5193c1110$var$BufferNode ? this.getBuffer(node.context.buffer, node.index) : node instanceof $a7a41eb5193c1110$var$TreeNode ? this.map.get(node.tree) : undefined;
    }
    /**
    Set the value for the node that a cursor currently points to.
    */ cursorSet(cursor, value) {
        if (cursor.buffer) this.setBuffer(cursor.buffer.buffer, cursor.index, value);
        else this.map.set(cursor.tree, value);
    }
    /**
    Retrieve the value for the node that a cursor currently points
    to.
    */ cursorGet(cursor) {
        return cursor.buffer ? this.getBuffer(cursor.buffer.buffer, cursor.index) : this.map.get(cursor.tree);
    }
}
/**
Tree fragments are used during [incremental
parsing](#common.Parser.startParse) to track parts of old trees
that can be reused in a new parse. An array of fragments is used
to track regions of an old tree whose nodes might be reused in new
parses. Use the static
[`applyChanges`](#common.TreeFragment^applyChanges) method to
update fragments for document changes.
*/ class $a7a41eb5193c1110$export$3ae2ede6dca97077 {
    /**
    Construct a tree fragment. You'll usually want to use
    [`addTree`](#common.TreeFragment^addTree) and
    [`applyChanges`](#common.TreeFragment^applyChanges) instead of
    calling this directly.
    */ constructor(/**
    The start of the unchanged range pointed to by this fragment.
    This refers to an offset in the _updated_ document (as opposed
    to the original tree).
    */ from, /**
    The end of the unchanged range.
    */ to, /**
    The tree that this fragment is based on.
    */ tree, /**
    The offset between the fragment's tree and the document that
    this fragment can be used against. Add this when going from
    document to tree positions, subtract it to go from tree to
    document positions.
    */ offset, openStart = false, openEnd = false){
        this.from = from;
        this.to = to;
        this.tree = tree;
        this.offset = offset;
        this.open = (openStart ? 1 /* Open.Start */  : 0) | (openEnd ? 2 /* Open.End */  : 0);
    }
    /**
    Whether the start of the fragment represents the start of a
    parse, or the end of a change. (In the second case, it may not
    be safe to reuse some nodes at the start, depending on the
    parsing algorithm.)
    */ get openStart() {
        return (this.open & 1 /* Open.Start */ ) > 0;
    }
    /**
    Whether the end of the fragment represents the end of a
    full-document parse, or the start of a change.
    */ get openEnd() {
        return (this.open & 2 /* Open.End */ ) > 0;
    }
    /**
    Create a set of fragments from a freshly parsed tree, or update
    an existing set of fragments by replacing the ones that overlap
    with a tree with content from the new tree. When `partial` is
    true, the parse is treated as incomplete, and the resulting
    fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
    true.
    */ static addTree(tree, fragments = [], partial = false) {
        let result = [
            new $a7a41eb5193c1110$export$3ae2ede6dca97077(0, tree.length, tree, 0, false, partial)
        ];
        for (let f of fragments)if (f.to > tree.length) result.push(f);
        return result;
    }
    /**
    Apply a set of edits to an array of fragments, removing or
    splitting fragments as necessary to remove edited ranges, and
    adjusting offsets for fragments that moved.
    */ static applyChanges(fragments, changes, minGap = 128) {
        if (!changes.length) return fragments;
        let result = [];
        let fI = 1, nextF = fragments.length ? fragments[0] : null;
        for(let cI = 0, pos = 0, off = 0;; cI++){
            let nextC = cI < changes.length ? changes[cI] : null;
            let nextPos = nextC ? nextC.fromA : 1e9;
            if (nextPos - pos >= minGap) while(nextF && nextF.from < nextPos){
                let cut = nextF;
                if (pos >= cut.from || nextPos <= cut.to || off) {
                    let fFrom = Math.max(cut.from, pos) - off, fTo = Math.min(cut.to, nextPos) - off;
                    cut = fFrom >= fTo ? null : new $a7a41eb5193c1110$export$3ae2ede6dca97077(fFrom, fTo, cut.tree, cut.offset + off, cI > 0, !!nextC);
                }
                if (cut) result.push(cut);
                if (nextF.to > nextPos) break;
                nextF = fI < fragments.length ? fragments[fI++] : null;
            }
            if (!nextC) break;
            pos = nextC.toA;
            off = nextC.toA - nextC.toB;
        }
        return result;
    }
}
/**
A superclass that parsers should extend.
*/ class $a7a41eb5193c1110$export$7acfa6ed01010e37 {
    /**
    Start a parse, returning a [partial parse](#common.PartialParse)
    object. [`fragments`](#common.TreeFragment) can be passed in to
    make the parse incremental.
    
    By default, the entire input is parsed. You can pass `ranges`,
    which should be a sorted array of non-empty, non-overlapping
    ranges, to parse only those ranges. The tree returned in that
    case will start at `ranges[0].from`.
    */ startParse(input, fragments, ranges) {
        if (typeof input == "string") input = new $a7a41eb5193c1110$var$StringInput(input);
        ranges = !ranges ? [
            new $a7a41eb5193c1110$var$Range(0, input.length)
        ] : ranges.length ? ranges.map((r)=>new $a7a41eb5193c1110$var$Range(r.from, r.to)) : [
            new $a7a41eb5193c1110$var$Range(0, 0)
        ];
        return this.createParse(input, fragments || [], ranges);
    }
    /**
    Run a full parse, returning the resulting tree.
    */ parse(input, fragments, ranges) {
        let parse = this.startParse(input, fragments, ranges);
        for(;;){
            let done = parse.advance();
            if (done) return done;
        }
    }
}
class $a7a41eb5193c1110$var$StringInput {
    constructor(string){
        this.string = string;
    }
    get length() {
        return this.string.length;
    }
    chunk(from) {
        return this.string.slice(from);
    }
    get lineChunks() {
        return false;
    }
    read(from, to) {
        return this.string.slice(from, to);
    }
}
/**
Create a parse wrapper that, after the inner parse completes,
scans its tree for mixed language regions with the `nest`
function, runs the resulting [inner parses](#common.NestedParse),
and then [mounts](#common.NodeProp^mounted) their results onto the
tree.
*/ function $a7a41eb5193c1110$export$5dcc455959c76221(nest) {
    return (parse, input, fragments, ranges)=>new $a7a41eb5193c1110$var$MixedParse(parse, nest, input, fragments, ranges);
}
class $a7a41eb5193c1110$var$InnerParse {
    constructor(parser, parse, overlay, target, from){
        this.parser = parser;
        this.parse = parse;
        this.overlay = overlay;
        this.target = target;
        this.from = from;
    }
}
function $a7a41eb5193c1110$var$checkRanges(ranges) {
    if (!ranges.length || ranges.some((r)=>r.from >= r.to)) throw new RangeError("Invalid inner parse ranges given: " + JSON.stringify(ranges));
}
class $a7a41eb5193c1110$var$ActiveOverlay {
    constructor(parser, predicate, mounts, index, start, target, prev){
        this.parser = parser;
        this.predicate = predicate;
        this.mounts = mounts;
        this.index = index;
        this.start = start;
        this.target = target;
        this.prev = prev;
        this.depth = 0;
        this.ranges = [];
    }
}
const $a7a41eb5193c1110$var$stoppedInner = new $a7a41eb5193c1110$export$b8034b9bc18acd90({
    perNode: true
});
class $a7a41eb5193c1110$var$MixedParse {
    constructor(base, nest, input, fragments, ranges){
        this.nest = nest;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.inner = [];
        this.innerDone = 0;
        this.baseTree = null;
        this.stoppedAt = null;
        this.baseParse = base;
    }
    advance() {
        if (this.baseParse) {
            let done = this.baseParse.advance();
            if (!done) return null;
            this.baseParse = null;
            this.baseTree = done;
            this.startInner();
            if (this.stoppedAt != null) for (let inner of this.inner)inner.parse.stopAt(this.stoppedAt);
        }
        if (this.innerDone == this.inner.length) {
            let result = this.baseTree;
            if (this.stoppedAt != null) result = new $a7a41eb5193c1110$export$7fbedc92909ed28e(result.type, result.children, result.positions, result.length, result.propValues.concat([
                [
                    $a7a41eb5193c1110$var$stoppedInner,
                    this.stoppedAt
                ]
            ]));
            return result;
        }
        let inner = this.inner[this.innerDone], done = inner.parse.advance();
        if (done) {
            this.innerDone++;
            // This is a somewhat dodgy but super helpful hack where we
            // patch up nodes created by the inner parse (and thus
            // presumably not aliased anywhere else) to hold the information
            // about the inner parse.
            let props = Object.assign(Object.create(null), inner.target.props);
            props[$a7a41eb5193c1110$export$b8034b9bc18acd90.mounted.id] = new $a7a41eb5193c1110$export$358cdd8bd77577cc(done, inner.overlay, inner.parser);
            inner.target.props = props;
        }
        return null;
    }
    get parsedPos() {
        if (this.baseParse) return 0;
        let pos = this.input.length;
        for(let i = this.innerDone; i < this.inner.length; i++)if (this.inner[i].from < pos) pos = Math.min(pos, this.inner[i].parse.parsedPos);
        return pos;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
        if (this.baseParse) this.baseParse.stopAt(pos);
        else for(let i = this.innerDone; i < this.inner.length; i++)this.inner[i].parse.stopAt(pos);
    }
    startInner() {
        let fragmentCursor = new $a7a41eb5193c1110$var$FragmentCursor(this.fragments);
        let overlay = null;
        let covered = null;
        let cursor = new $a7a41eb5193c1110$export$3ae4554f36e54a34(new $a7a41eb5193c1110$var$TreeNode(this.baseTree, this.ranges[0].from, 0, null), $a7a41eb5193c1110$export$b0e28367f55837aa.IncludeAnonymous | $a7a41eb5193c1110$export$b0e28367f55837aa.IgnoreMounts);
        scan: for(let nest, isCovered;;){
            let enter = true, range;
            if (this.stoppedAt != null && cursor.from >= this.stoppedAt) enter = false;
            else if (fragmentCursor.hasNode(cursor)) {
                if (overlay) {
                    let match = overlay.mounts.find((m)=>m.frag.from <= cursor.from && m.frag.to >= cursor.to && m.mount.overlay);
                    if (match) for (let r of match.mount.overlay){
                        let from = r.from + match.pos, to = r.to + match.pos;
                        if (from >= cursor.from && to <= cursor.to && !overlay.ranges.some((r)=>r.from < to && r.to > from)) overlay.ranges.push({
                            from: from,
                            to: to
                        });
                    }
                }
                enter = false;
            } else if (covered && (isCovered = $a7a41eb5193c1110$var$checkCover(covered.ranges, cursor.from, cursor.to))) enter = isCovered != 2 /* Cover.Full */ ;
            else if (!cursor.type.isAnonymous && (nest = this.nest(cursor, this.input)) && (cursor.from < cursor.to || !nest.overlay)) {
                if (!cursor.tree) $a7a41eb5193c1110$var$materialize(cursor);
                let oldMounts = fragmentCursor.findMounts(cursor.from, nest.parser);
                if (typeof nest.overlay == "function") overlay = new $a7a41eb5193c1110$var$ActiveOverlay(nest.parser, nest.overlay, oldMounts, this.inner.length, cursor.from, cursor.tree, overlay);
                else {
                    let ranges = $a7a41eb5193c1110$var$punchRanges(this.ranges, nest.overlay || (cursor.from < cursor.to ? [
                        new $a7a41eb5193c1110$var$Range(cursor.from, cursor.to)
                    ] : []));
                    if (ranges.length) $a7a41eb5193c1110$var$checkRanges(ranges);
                    if (ranges.length || !nest.overlay) this.inner.push(new $a7a41eb5193c1110$var$InnerParse(nest.parser, ranges.length ? nest.parser.startParse(this.input, $a7a41eb5193c1110$var$enterFragments(oldMounts, ranges), ranges) : nest.parser.startParse(""), nest.overlay ? nest.overlay.map((r)=>new $a7a41eb5193c1110$var$Range(r.from - cursor.from, r.to - cursor.from)) : null, cursor.tree, ranges.length ? ranges[0].from : cursor.from));
                    if (!nest.overlay) enter = false;
                    else if (ranges.length) covered = {
                        ranges: ranges,
                        depth: 0,
                        prev: covered
                    };
                }
            } else if (overlay && (range = overlay.predicate(cursor))) {
                if (range === true) range = new $a7a41eb5193c1110$var$Range(cursor.from, cursor.to);
                if (range.from < range.to) {
                    let last = overlay.ranges.length - 1;
                    if (last >= 0 && overlay.ranges[last].to == range.from) overlay.ranges[last] = {
                        from: overlay.ranges[last].from,
                        to: range.to
                    };
                    else overlay.ranges.push(range);
                }
            }
            if (enter && cursor.firstChild()) {
                if (overlay) overlay.depth++;
                if (covered) covered.depth++;
            } else for(;;){
                if (cursor.nextSibling()) break;
                if (!cursor.parent()) break scan;
                if (overlay && !--overlay.depth) {
                    let ranges = $a7a41eb5193c1110$var$punchRanges(this.ranges, overlay.ranges);
                    if (ranges.length) {
                        $a7a41eb5193c1110$var$checkRanges(ranges);
                        this.inner.splice(overlay.index, 0, new $a7a41eb5193c1110$var$InnerParse(overlay.parser, overlay.parser.startParse(this.input, $a7a41eb5193c1110$var$enterFragments(overlay.mounts, ranges), ranges), overlay.ranges.map((r)=>new $a7a41eb5193c1110$var$Range(r.from - overlay.start, r.to - overlay.start)), overlay.target, ranges[0].from));
                    }
                    overlay = overlay.prev;
                }
                if (covered && !--covered.depth) covered = covered.prev;
            }
        }
    }
}
function $a7a41eb5193c1110$var$checkCover(covered, from, to) {
    for (let range of covered){
        if (range.from >= to) break;
        if (range.to > from) return range.from <= from && range.to >= to ? 2 /* Cover.Full */  : 1 /* Cover.Partial */ ;
    }
    return 0 /* Cover.None */ ;
}
// Take a piece of buffer and convert it into a stand-alone
// TreeBuffer.
function $a7a41eb5193c1110$var$sliceBuf(buf, startI, endI, nodes, positions, off) {
    if (startI < endI) {
        let from = buf.buffer[startI + 1];
        nodes.push(buf.slice(startI, endI, from));
        positions.push(from - off);
    }
}
// This function takes a node that's in a buffer, and converts it, and
// its parent buffer nodes, into a Tree. This is again acting on the
// assumption that the trees and buffers have been constructed by the
// parse that was ran via the mix parser, and thus aren't shared with
// any other code, making violations of the immutability safe.
function $a7a41eb5193c1110$var$materialize(cursor) {
    let { node: node } = cursor, stack = [];
    let buffer = node.context.buffer;
    // Scan up to the nearest tree
    do {
        stack.push(cursor.index);
        cursor.parent();
    }while (!cursor.tree);
    // Find the index of the buffer in that tree
    let base = cursor.tree, i = base.children.indexOf(buffer);
    let buf = base.children[i], b = buf.buffer, newStack = [
        i
    ];
    // Split a level in the buffer, putting the nodes before and after
    // the child that contains `node` into new buffers.
    function split(startI, endI, type, innerOffset, length, stackPos) {
        let targetI = stack[stackPos];
        let children = [], positions = [];
        $a7a41eb5193c1110$var$sliceBuf(buf, startI, targetI, children, positions, innerOffset);
        let from = b[targetI + 1], to = b[targetI + 2];
        newStack.push(children.length);
        let child = stackPos ? split(targetI + 4, b[targetI + 3], buf.set.types[b[targetI]], from, to - from, stackPos - 1) : node.toTree();
        children.push(child);
        positions.push(from - innerOffset);
        $a7a41eb5193c1110$var$sliceBuf(buf, b[targetI + 3], endI, children, positions, innerOffset);
        return new $a7a41eb5193c1110$export$7fbedc92909ed28e(type, children, positions, length);
    }
    base.children[i] = split(0, b.length, $a7a41eb5193c1110$export$f06e977173f1857c.none, 0, buf.length, stack.length - 1);
    // Move the cursor back to the target node
    for (let index of newStack){
        let tree = cursor.tree.children[index], pos = cursor.tree.positions[index];
        cursor.yield(new $a7a41eb5193c1110$var$TreeNode(tree, pos + cursor.from, index, cursor._tree));
    }
}
class $a7a41eb5193c1110$var$StructureCursor {
    constructor(root, offset){
        this.offset = offset;
        this.done = false;
        this.cursor = root.cursor($a7a41eb5193c1110$export$b0e28367f55837aa.IncludeAnonymous | $a7a41eb5193c1110$export$b0e28367f55837aa.IgnoreMounts);
    }
    // Move to the first node (in pre-order) that starts at or after `pos`.
    moveTo(pos) {
        let { cursor: cursor } = this, p = pos - this.offset;
        while(!this.done && cursor.from < p){
            if (cursor.to >= pos && cursor.enter(p, 1, $a7a41eb5193c1110$export$b0e28367f55837aa.IgnoreOverlays | $a7a41eb5193c1110$export$b0e28367f55837aa.ExcludeBuffers)) ;
            else if (!cursor.next(false)) this.done = true;
        }
    }
    hasNode(cursor) {
        this.moveTo(cursor.from);
        if (!this.done && this.cursor.from + this.offset == cursor.from && this.cursor.tree) for(let tree = this.cursor.tree;;){
            if (tree == cursor.tree) return true;
            if (tree.children.length && tree.positions[0] == 0 && tree.children[0] instanceof $a7a41eb5193c1110$export$7fbedc92909ed28e) tree = tree.children[0];
            else break;
        }
        return false;
    }
}
class $a7a41eb5193c1110$var$FragmentCursor {
    constructor(fragments){
        var _a;
        this.fragments = fragments;
        this.curTo = 0;
        this.fragI = 0;
        if (fragments.length) {
            let first = this.curFrag = fragments[0];
            this.curTo = (_a = first.tree.prop($a7a41eb5193c1110$var$stoppedInner)) !== null && _a !== void 0 ? _a : first.to;
            this.inner = new $a7a41eb5193c1110$var$StructureCursor(first.tree, -first.offset);
        } else this.curFrag = this.inner = null;
    }
    hasNode(node) {
        while(this.curFrag && node.from >= this.curTo)this.nextFrag();
        return this.curFrag && this.curFrag.from <= node.from && this.curTo >= node.to && this.inner.hasNode(node);
    }
    nextFrag() {
        var _a;
        this.fragI++;
        if (this.fragI == this.fragments.length) this.curFrag = this.inner = null;
        else {
            let frag = this.curFrag = this.fragments[this.fragI];
            this.curTo = (_a = frag.tree.prop($a7a41eb5193c1110$var$stoppedInner)) !== null && _a !== void 0 ? _a : frag.to;
            this.inner = new $a7a41eb5193c1110$var$StructureCursor(frag.tree, -frag.offset);
        }
    }
    findMounts(pos, parser) {
        var _a;
        let result = [];
        if (this.inner) {
            this.inner.cursor.moveTo(pos, 1);
            for(let pos = this.inner.cursor.node; pos; pos = pos.parent){
                let mount = (_a = pos.tree) === null || _a === void 0 ? void 0 : _a.prop($a7a41eb5193c1110$export$b8034b9bc18acd90.mounted);
                if (mount && mount.parser == parser) for(let i = this.fragI; i < this.fragments.length; i++){
                    let frag = this.fragments[i];
                    if (frag.from >= pos.to) break;
                    if (frag.tree == this.curFrag.tree) result.push({
                        frag: frag,
                        pos: pos.from - frag.offset,
                        mount: mount
                    });
                }
            }
        }
        return result;
    }
}
function $a7a41eb5193c1110$var$punchRanges(outer, ranges) {
    let copy = null, current = ranges;
    for(let i = 1, j = 0; i < outer.length; i++){
        let gapFrom = outer[i - 1].to, gapTo = outer[i].from;
        for(; j < current.length; j++){
            let r = current[j];
            if (r.from >= gapTo) break;
            if (r.to <= gapFrom) continue;
            if (!copy) current = copy = ranges.slice();
            if (r.from < gapFrom) {
                copy[j] = new $a7a41eb5193c1110$var$Range(r.from, gapFrom);
                if (r.to > gapTo) copy.splice(j + 1, 0, new $a7a41eb5193c1110$var$Range(gapTo, r.to));
            } else if (r.to > gapTo) copy[j--] = new $a7a41eb5193c1110$var$Range(gapTo, r.to);
            else copy.splice(j--, 1);
        }
    }
    return current;
}
function $a7a41eb5193c1110$var$findCoverChanges(a, b, from, to) {
    let iA = 0, iB = 0, inA = false, inB = false, pos = -1000000000;
    let result = [];
    for(;;){
        let nextA = iA == a.length ? 1e9 : inA ? a[iA].to : a[iA].from;
        let nextB = iB == b.length ? 1e9 : inB ? b[iB].to : b[iB].from;
        if (inA != inB) {
            let start = Math.max(pos, from), end = Math.min(nextA, nextB, to);
            if (start < end) result.push(new $a7a41eb5193c1110$var$Range(start, end));
        }
        pos = Math.min(nextA, nextB);
        if (pos == 1e9) break;
        if (nextA == pos) {
            if (!inA) inA = true;
            else {
                inA = false;
                iA++;
            }
        }
        if (nextB == pos) {
            if (!inB) inB = true;
            else {
                inB = false;
                iB++;
            }
        }
    }
    return result;
}
// Given a number of fragments for the outer tree, and a set of ranges
// to parse, find fragments for inner trees mounted around those
// ranges, if any.
function $a7a41eb5193c1110$var$enterFragments(mounts, ranges) {
    let result = [];
    for (let { pos: pos, mount: mount, frag: frag } of mounts){
        let startPos = pos + (mount.overlay ? mount.overlay[0].from : 0), endPos = startPos + mount.tree.length;
        let from = Math.max(frag.from, startPos), to = Math.min(frag.to, endPos);
        if (mount.overlay) {
            let overlay = mount.overlay.map((r)=>new $a7a41eb5193c1110$var$Range(r.from + pos, r.to + pos));
            let changes = $a7a41eb5193c1110$var$findCoverChanges(ranges, overlay, from, to);
            for(let i = 0, pos = from;; i++){
                let last = i == changes.length, end = last ? to : changes[i].from;
                if (end > pos) result.push(new $a7a41eb5193c1110$export$3ae2ede6dca97077(pos, end, mount.tree, -startPos, frag.from >= pos || frag.openStart, frag.to <= end || frag.openEnd));
                if (last) break;
                pos = changes[i].to;
            }
        } else result.push(new $a7a41eb5193c1110$export$3ae2ede6dca97077(from, to, mount.tree, -startPos, frag.from >= startPos || frag.openStart, frag.to <= endPos || frag.openEnd));
    }
    return result;
}





let $6b8758376c12ba5a$var$nextTagID = 0;
/**
Highlighting tags are markers that denote a highlighting category.
They are [associated](#highlight.styleTags) with parts of a syntax
tree by a language mode, and then mapped to an actual CSS style by
a [highlighter](#highlight.Highlighter).

Because syntax tree node types and highlight styles have to be
able to talk the same language, CodeMirror uses a mostly _closed_
[vocabulary](#highlight.tags) of syntax tags (as opposed to
traditional open string-based systems, which make it hard for
highlighting themes to cover all the tokens produced by the
various languages).

It _is_ possible to [define](#highlight.Tag^define) your own
highlighting tags for system-internal use (where you control both
the language package and the highlighter), but such tags will not
be picked up by regular highlighters (though you can derive them
from standard tags to allow highlighters to fall back to those).
*/ class $6b8758376c12ba5a$export$3288d34c523a1192 {
    /**
    @internal
    */ constructor(/**
    The optional name of the base tag @internal
    */ name, /**
    The set of this tag and all its parent tags, starting with
    this one itself and sorted in order of decreasing specificity.
    */ set, /**
    The base unmodified tag that this one is based on, if it's
    modified @internal
    */ base, /**
    The modifiers applied to this.base @internal
    */ modified){
        this.name = name;
        this.set = set;
        this.base = base;
        this.modified = modified;
        /**
        @internal
        */ this.id = $6b8758376c12ba5a$var$nextTagID++;
    }
    toString() {
        let { name: name } = this;
        for (let mod of this.modified)if (mod.name) name = `${mod.name}(${name})`;
        return name;
    }
    static define(nameOrParent, parent) {
        let name = typeof nameOrParent == "string" ? nameOrParent : "?";
        if (nameOrParent instanceof $6b8758376c12ba5a$export$3288d34c523a1192) parent = nameOrParent;
        if (parent === null || parent === void 0 ? void 0 : parent.base) throw new Error("Can not derive from a modified tag");
        let tag = new $6b8758376c12ba5a$export$3288d34c523a1192(name, [], null, []);
        tag.set.push(tag);
        if (parent) for (let t of parent.set)tag.set.push(t);
        return tag;
    }
    /**
    Define a tag _modifier_, which is a function that, given a tag,
    will return a tag that is a subtag of the original. Applying the
    same modifier to a twice tag will return the same value (`m1(t1)
    == m1(t1)`) and applying multiple modifiers will, regardless or
    order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
    
    When multiple modifiers are applied to a given base tag, each
    smaller set of modifiers is registered as a parent, so that for
    example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
    `m1(m3(t1)`, and so on.
    */ static defineModifier(name) {
        let mod = new $6b8758376c12ba5a$var$Modifier(name);
        return (tag)=>{
            if (tag.modified.indexOf(mod) > -1) return tag;
            return $6b8758376c12ba5a$var$Modifier.get(tag.base || tag, tag.modified.concat(mod).sort((a, b)=>a.id - b.id));
        };
    }
}
let $6b8758376c12ba5a$var$nextModifierID = 0;
class $6b8758376c12ba5a$var$Modifier {
    constructor(name){
        this.name = name;
        this.instances = [];
        this.id = $6b8758376c12ba5a$var$nextModifierID++;
    }
    static get(base, mods) {
        if (!mods.length) return base;
        let exists = mods[0].instances.find((t)=>t.base == base && $6b8758376c12ba5a$var$sameArray(mods, t.modified));
        if (exists) return exists;
        let set = [], tag = new $6b8758376c12ba5a$export$3288d34c523a1192(base.name, set, base, mods);
        for (let m of mods)m.instances.push(tag);
        let configs = $6b8758376c12ba5a$var$powerSet(mods);
        for (let parent of base.set)if (!parent.modified.length) for (let config of configs)set.push($6b8758376c12ba5a$var$Modifier.get(parent, config));
        return tag;
    }
}
function $6b8758376c12ba5a$var$sameArray(a, b) {
    return a.length == b.length && a.every((x, i)=>x == b[i]);
}
function $6b8758376c12ba5a$var$powerSet(array) {
    let sets = [
        []
    ];
    for(let i = 0; i < array.length; i++)for(let j = 0, e = sets.length; j < e; j++)sets.push(sets[j].concat(array[i]));
    return sets.sort((a, b)=>b.length - a.length);
}
/**
This function is used to add a set of tags to a language syntax
via [`NodeSet.extend`](#common.NodeSet.extend) or
[`LRParser.configure`](#lr.LRParser.configure).

The argument object maps node selectors to [highlighting
tags](#highlight.Tag) or arrays of tags.

Node selectors may hold one or more (space-separated) node paths.
Such a path can be a [node name](#common.NodeType.name), or
multiple node names (or `*` wildcards) separated by slash
characters, as in `"Block/Declaration/VariableName"`. Such a path
matches the final node but only if its direct parent nodes are the
other nodes mentioned. A `*` in such a path matches any parent,
but only a single level—wildcards that match multiple parents
aren't supported, both for efficiency reasons and because Lezer
trees make it rather hard to reason about what they would match.)

A path can be ended with `/...` to indicate that the tag assigned
to the node should also apply to all child nodes, even if they
match their own style (by default, only the innermost style is
used).

When a path ends in `!`, as in `Attribute!`, no further matching
happens for the node's child nodes, and the entire node gets the
given style.

In this notation, node names that contain `/`, `!`, `*`, or `...`
must be quoted as JSON strings.

For example:

```javascript
parser.withProps(
  styleTags({
    // Style Number and BigNumber nodes
    "Number BigNumber": tags.number,
    // Style Escape nodes whose parent is String
    "String/Escape": tags.escape,
    // Style anything inside Attributes nodes
    "Attributes!": tags.meta,
    // Add a style to all content inside Italic nodes
    "Italic/...": tags.emphasis,
    // Style InvalidString nodes as both `string` and `invalid`
    "InvalidString": [tags.string, tags.invalid],
    // Style the node named "/" as punctuation
    '"/"': tags.punctuation
  })
)
```
*/ function $6b8758376c12ba5a$export$c537e79bb7b94295(spec) {
    let byName = Object.create(null);
    for(let prop in spec){
        let tags = spec[prop];
        if (!Array.isArray(tags)) tags = [
            tags
        ];
        for (let part of prop.split(" "))if (part) {
            let pieces = [], mode = 2 /* Mode.Normal */ , rest = part;
            for(let pos = 0;;){
                if (rest == "..." && pos > 0 && pos + 3 == part.length) {
                    mode = 1 /* Mode.Inherit */ ;
                    break;
                }
                let m = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(rest);
                if (!m) throw new RangeError("Invalid path: " + part);
                pieces.push(m[0] == "*" ? "" : m[0][0] == '"' ? JSON.parse(m[0]) : m[0]);
                pos += m[0].length;
                if (pos == part.length) break;
                let next = part[pos++];
                if (pos == part.length && next == "!") {
                    mode = 0 /* Mode.Opaque */ ;
                    break;
                }
                if (next != "/") throw new RangeError("Invalid path: " + part);
                rest = part.slice(pos);
            }
            let last = pieces.length - 1, inner = pieces[last];
            if (!inner) throw new RangeError("Invalid path: " + part);
            let rule = new $6b8758376c12ba5a$var$Rule(tags, mode, last > 0 ? pieces.slice(0, last) : null);
            byName[inner] = rule.sort(byName[inner]);
        }
    }
    return $6b8758376c12ba5a$var$ruleNodeProp.add(byName);
}
const $6b8758376c12ba5a$var$ruleNodeProp = new (0, $a7a41eb5193c1110$export$b8034b9bc18acd90)();
class $6b8758376c12ba5a$var$Rule {
    constructor(tags, mode, context, next){
        this.tags = tags;
        this.mode = mode;
        this.context = context;
        this.next = next;
    }
    get opaque() {
        return this.mode == 0 /* Mode.Opaque */ ;
    }
    get inherit() {
        return this.mode == 1 /* Mode.Inherit */ ;
    }
    sort(other) {
        if (!other || other.depth < this.depth) {
            this.next = other;
            return this;
        }
        other.next = this.sort(other.next);
        return other;
    }
    get depth() {
        return this.context ? this.context.length : 0;
    }
}
$6b8758376c12ba5a$var$Rule.empty = new $6b8758376c12ba5a$var$Rule([], 2 /* Mode.Normal */ , null);
/**
Define a [highlighter](#highlight.Highlighter) from an array of
tag/class pairs. Classes associated with more specific tags will
take precedence.
*/ function $6b8758376c12ba5a$export$b7f6332ce20f80fb(tags, options) {
    let map = Object.create(null);
    for (let style of tags){
        if (!Array.isArray(style.tag)) map[style.tag.id] = style.class;
        else for (let tag of style.tag)map[tag.id] = style.class;
    }
    let { scope: scope, all: all = null } = options || {};
    return {
        style: (tags)=>{
            let cls = all;
            for (let tag of tags)for (let sub of tag.set){
                let tagClass = map[sub.id];
                if (tagClass) {
                    cls = cls ? cls + " " + tagClass : tagClass;
                    break;
                }
            }
            return cls;
        },
        scope: scope
    };
}
function $6b8758376c12ba5a$var$highlightTags(highlighters, tags) {
    let result = null;
    for (let highlighter of highlighters){
        let value = highlighter.style(tags);
        if (value) result = result ? result + " " + value : value;
    }
    return result;
}
/**
Highlight the given [tree](#common.Tree) with the given
[highlighter](#highlight.Highlighter). Often, the higher-level
[`highlightCode`](#highlight.highlightCode) function is easier to
use.
*/ function $6b8758376c12ba5a$export$af82b3d076119fad(tree, highlighter, /**
Assign styling to a region of the text. Will be called, in order
of position, for any ranges where more than zero classes apply.
`classes` is a space separated string of CSS classes.
*/ putStyle, /**
The start of the range to highlight.
*/ from = 0, /**
The end of the range.
*/ to = tree.length) {
    let builder = new $6b8758376c12ba5a$var$HighlightBuilder(from, Array.isArray(highlighter) ? highlighter : [
        highlighter
    ], putStyle);
    builder.highlightRange(tree.cursor(), from, to, "", builder.highlighters);
    builder.flush(to);
}
/**
Highlight the given tree with the given highlighter, calling
`putText` for every piece of text, either with a set of classes or
with the empty string when unstyled, and `putBreak` for every line
break.
*/ function $6b8758376c12ba5a$export$e443a046766e80e8(code, tree, highlighter, putText, putBreak, from = 0, to = code.length) {
    let pos = from;
    function writeTo(p, classes) {
        if (p <= pos) return;
        for(let text = code.slice(pos, p), i = 0;;){
            let nextBreak = text.indexOf("\n", i);
            let upto = nextBreak < 0 ? text.length : nextBreak;
            if (upto > i) putText(text.slice(i, upto), classes);
            if (nextBreak < 0) break;
            putBreak();
            i = nextBreak + 1;
        }
        pos = p;
    }
    $6b8758376c12ba5a$export$af82b3d076119fad(tree, highlighter, (from, to, classes)=>{
        writeTo(from, "");
        writeTo(to, classes);
    }, from, to);
    writeTo(to, "");
}
class $6b8758376c12ba5a$var$HighlightBuilder {
    constructor(at, highlighters, span){
        this.at = at;
        this.highlighters = highlighters;
        this.span = span;
        this.class = "";
    }
    startSpan(at, cls) {
        if (cls != this.class) {
            this.flush(at);
            if (at > this.at) this.at = at;
            this.class = cls;
        }
    }
    flush(to) {
        if (to > this.at && this.class) this.span(this.at, to, this.class);
    }
    highlightRange(cursor, from, to, inheritedClass, highlighters) {
        let { type: type, from: start, to: end } = cursor;
        if (start >= to || end <= from) return;
        if (type.isTop) highlighters = this.highlighters.filter((h)=>!h.scope || h.scope(type));
        let cls = inheritedClass;
        let rule = $6b8758376c12ba5a$export$1519d79cc79711ec(cursor) || $6b8758376c12ba5a$var$Rule.empty;
        let tagCls = $6b8758376c12ba5a$var$highlightTags(highlighters, rule.tags);
        if (tagCls) {
            if (cls) cls += " ";
            cls += tagCls;
            if (rule.mode == 1 /* Mode.Inherit */ ) inheritedClass += (inheritedClass ? " " : "") + tagCls;
        }
        this.startSpan(Math.max(from, start), cls);
        if (rule.opaque) return;
        let mounted = cursor.tree && cursor.tree.prop((0, $a7a41eb5193c1110$export$b8034b9bc18acd90).mounted);
        if (mounted && mounted.overlay) {
            let inner = cursor.node.enter(mounted.overlay[0].from + start, 1);
            let innerHighlighters = this.highlighters.filter((h)=>!h.scope || h.scope(mounted.tree.type));
            let hasChild = cursor.firstChild();
            for(let i = 0, pos = start;; i++){
                let next = i < mounted.overlay.length ? mounted.overlay[i] : null;
                let nextPos = next ? next.from + start : end;
                let rangeFrom = Math.max(from, pos), rangeTo = Math.min(to, nextPos);
                if (rangeFrom < rangeTo && hasChild) while(cursor.from < rangeTo){
                    this.highlightRange(cursor, rangeFrom, rangeTo, inheritedClass, highlighters);
                    this.startSpan(Math.min(rangeTo, cursor.to), cls);
                    if (cursor.to >= nextPos || !cursor.nextSibling()) break;
                }
                if (!next || nextPos > to) break;
                pos = next.to + start;
                if (pos > from) {
                    this.highlightRange(inner.cursor(), Math.max(from, next.from + start), Math.min(to, pos), "", innerHighlighters);
                    this.startSpan(Math.min(to, pos), cls);
                }
            }
            if (hasChild) cursor.parent();
        } else if (cursor.firstChild()) {
            if (mounted) inheritedClass = "";
            do {
                if (cursor.to <= from) continue;
                if (cursor.from >= to) break;
                this.highlightRange(cursor, from, to, inheritedClass, highlighters);
                this.startSpan(Math.min(to, cursor.to), cls);
            }while (cursor.nextSibling());
            cursor.parent();
        }
    }
}
/**
Match a syntax node's [highlight rules](#highlight.styleTags). If
there's a match, return its set of tags, and whether it is
opaque (uses a `!`) or applies to all child nodes (`/...`).
*/ function $6b8758376c12ba5a$export$1519d79cc79711ec(node) {
    let rule = node.type.prop($6b8758376c12ba5a$var$ruleNodeProp);
    while(rule && rule.context && !node.matchContext(rule.context))rule = rule.next;
    return rule || null;
}
const $6b8758376c12ba5a$var$t = $6b8758376c12ba5a$export$3288d34c523a1192.define;
const $6b8758376c12ba5a$var$comment = $6b8758376c12ba5a$var$t(), $6b8758376c12ba5a$var$name = $6b8758376c12ba5a$var$t(), $6b8758376c12ba5a$var$typeName = $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$name), $6b8758376c12ba5a$var$propertyName = $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$name), $6b8758376c12ba5a$var$literal = $6b8758376c12ba5a$var$t(), $6b8758376c12ba5a$var$string = $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$literal), $6b8758376c12ba5a$var$number = $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$literal), $6b8758376c12ba5a$var$content = $6b8758376c12ba5a$var$t(), $6b8758376c12ba5a$var$heading = $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$content), $6b8758376c12ba5a$var$keyword = $6b8758376c12ba5a$var$t(), $6b8758376c12ba5a$var$operator = $6b8758376c12ba5a$var$t(), $6b8758376c12ba5a$var$punctuation = $6b8758376c12ba5a$var$t(), $6b8758376c12ba5a$var$bracket = $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$punctuation), $6b8758376c12ba5a$var$meta = $6b8758376c12ba5a$var$t();
/**
The default set of highlighting [tags](#highlight.Tag).

This collection is heavily biased towards programming languages,
and necessarily incomplete. A full ontology of syntactic
constructs would fill a stack of books, and be impractical to
write themes for. So try to make do with this set. If all else
fails, [open an
issue](https://github.com/codemirror/codemirror.next) to propose a
new tag, or [define](#highlight.Tag^define) a local custom tag for
your use case.

Note that it is not obligatory to always attach the most specific
tag possible to an element—if your grammar can't easily
distinguish a certain type of element (such as a local variable),
it is okay to style it as its more general variant (a variable).

For tags that extend some parent tag, the documentation links to
the parent.
*/ const $6b8758376c12ba5a$export$8b7a896ae75accbf = {
    comment: /**
    A comment.
    */ $6b8758376c12ba5a$var$comment,
    /**
    A line [comment](#highlight.tags.comment).
    */ lineComment: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$comment),
    /**
    A block [comment](#highlight.tags.comment).
    */ blockComment: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$comment),
    /**
    A documentation [comment](#highlight.tags.comment).
    */ docComment: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$comment),
    name: /**
    Any kind of identifier.
    */ $6b8758376c12ba5a$var$name,
    /**
    The [name](#highlight.tags.name) of a variable.
    */ variableName: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$name),
    /**
    A type [name](#highlight.tags.name).
    */ typeName: $6b8758376c12ba5a$var$typeName,
    /**
    A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
    */ tagName: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$typeName),
    /**
    A property or field [name](#highlight.tags.name).
    */ propertyName: $6b8758376c12ba5a$var$propertyName,
    /**
    An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
    */ attributeName: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$propertyName),
    /**
    The [name](#highlight.tags.name) of a class.
    */ className: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$name),
    /**
    A label [name](#highlight.tags.name).
    */ labelName: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$name),
    /**
    A namespace [name](#highlight.tags.name).
    */ namespace: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$name),
    /**
    The [name](#highlight.tags.name) of a macro.
    */ macroName: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$name),
    literal: /**
    A literal value.
    */ $6b8758376c12ba5a$var$literal,
    string: /**
    A string [literal](#highlight.tags.literal).
    */ $6b8758376c12ba5a$var$string,
    /**
    A documentation [string](#highlight.tags.string).
    */ docString: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$string),
    /**
    A character literal (subtag of [string](#highlight.tags.string)).
    */ character: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$string),
    /**
    An attribute value (subtag of [string](#highlight.tags.string)).
    */ attributeValue: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$string),
    number: /**
    A number [literal](#highlight.tags.literal).
    */ $6b8758376c12ba5a$var$number,
    /**
    An integer [number](#highlight.tags.number) literal.
    */ integer: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$number),
    /**
    A floating-point [number](#highlight.tags.number) literal.
    */ float: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$number),
    /**
    A boolean [literal](#highlight.tags.literal).
    */ bool: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$literal),
    /**
    Regular expression [literal](#highlight.tags.literal).
    */ regexp: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$literal),
    /**
    An escape [literal](#highlight.tags.literal), for example a
    backslash escape in a string.
    */ escape: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$literal),
    /**
    A color [literal](#highlight.tags.literal).
    */ color: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$literal),
    /**
    A URL [literal](#highlight.tags.literal).
    */ url: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$literal),
    keyword: /**
    A language keyword.
    */ $6b8758376c12ba5a$var$keyword,
    /**
    The [keyword](#highlight.tags.keyword) for the self or this
    object.
    */ self: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$keyword),
    /**
    The [keyword](#highlight.tags.keyword) for null.
    */ null: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) denoting some atomic value.
    */ atom: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that represents a unit.
    */ unit: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$keyword),
    /**
    A modifier [keyword](#highlight.tags.keyword).
    */ modifier: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that acts as an operator.
    */ operatorKeyword: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$keyword),
    /**
    A control-flow related [keyword](#highlight.tags.keyword).
    */ controlKeyword: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that defines something.
    */ definitionKeyword: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) related to defining or
    interfacing with modules.
    */ moduleKeyword: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$keyword),
    operator: /**
    An operator.
    */ $6b8758376c12ba5a$var$operator,
    /**
    An [operator](#highlight.tags.operator) that dereferences something.
    */ derefOperator: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$operator),
    /**
    Arithmetic-related [operator](#highlight.tags.operator).
    */ arithmeticOperator: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$operator),
    /**
    Logical [operator](#highlight.tags.operator).
    */ logicOperator: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$operator),
    /**
    Bit [operator](#highlight.tags.operator).
    */ bitwiseOperator: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$operator),
    /**
    Comparison [operator](#highlight.tags.operator).
    */ compareOperator: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$operator),
    /**
    [Operator](#highlight.tags.operator) that updates its operand.
    */ updateOperator: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$operator),
    /**
    [Operator](#highlight.tags.operator) that defines something.
    */ definitionOperator: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$operator),
    /**
    Type-related [operator](#highlight.tags.operator).
    */ typeOperator: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$operator),
    /**
    Control-flow [operator](#highlight.tags.operator).
    */ controlOperator: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$operator),
    punctuation: /**
    Program or markup punctuation.
    */ $6b8758376c12ba5a$var$punctuation,
    /**
    [Punctuation](#highlight.tags.punctuation) that separates
    things.
    */ separator: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$punctuation),
    bracket: /**
    Bracket-style [punctuation](#highlight.tags.punctuation).
    */ $6b8758376c12ba5a$var$bracket,
    /**
    Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
    tokens).
    */ angleBracket: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$bracket),
    /**
    Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
    tokens).
    */ squareBracket: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$bracket),
    /**
    Parentheses (usually `(` and `)` tokens). Subtag of
    [bracket](#highlight.tags.bracket).
    */ paren: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$bracket),
    /**
    Braces (usually `{` and `}` tokens). Subtag of
    [bracket](#highlight.tags.bracket).
    */ brace: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$bracket),
    content: /**
    Content, for example plain text in XML or markup documents.
    */ $6b8758376c12ba5a$var$content,
    heading: /**
    [Content](#highlight.tags.content) that represents a heading.
    */ $6b8758376c12ba5a$var$heading,
    /**
    A level 1 [heading](#highlight.tags.heading).
    */ heading1: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$heading),
    /**
    A level 2 [heading](#highlight.tags.heading).
    */ heading2: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$heading),
    /**
    A level 3 [heading](#highlight.tags.heading).
    */ heading3: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$heading),
    /**
    A level 4 [heading](#highlight.tags.heading).
    */ heading4: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$heading),
    /**
    A level 5 [heading](#highlight.tags.heading).
    */ heading5: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$heading),
    /**
    A level 6 [heading](#highlight.tags.heading).
    */ heading6: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$heading),
    /**
    A prose [content](#highlight.tags.content) separator (such as a horizontal rule).
    */ contentSeparator: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$content),
    /**
    [Content](#highlight.tags.content) that represents a list.
    */ list: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$content),
    /**
    [Content](#highlight.tags.content) that represents a quote.
    */ quote: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$content),
    /**
    [Content](#highlight.tags.content) that is emphasized.
    */ emphasis: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$content),
    /**
    [Content](#highlight.tags.content) that is styled strong.
    */ strong: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$content),
    /**
    [Content](#highlight.tags.content) that is part of a link.
    */ link: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$content),
    /**
    [Content](#highlight.tags.content) that is styled as code or
    monospace.
    */ monospace: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$content),
    /**
    [Content](#highlight.tags.content) that has a strike-through
    style.
    */ strikethrough: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$content),
    /**
    Inserted text in a change-tracking format.
    */ inserted: $6b8758376c12ba5a$var$t(),
    /**
    Deleted text.
    */ deleted: $6b8758376c12ba5a$var$t(),
    /**
    Changed text.
    */ changed: $6b8758376c12ba5a$var$t(),
    /**
    An invalid or unsyntactic element.
    */ invalid: $6b8758376c12ba5a$var$t(),
    meta: /**
    Metadata or meta-instruction.
    */ $6b8758376c12ba5a$var$meta,
    /**
    [Metadata](#highlight.tags.meta) that applies to the entire
    document.
    */ documentMeta: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$meta),
    /**
    [Metadata](#highlight.tags.meta) that annotates or adds
    attributes to a given syntactic element.
    */ annotation: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$meta),
    /**
    Processing instruction or preprocessor directive. Subtag of
    [meta](#highlight.tags.meta).
    */ processingInstruction: $6b8758376c12ba5a$var$t($6b8758376c12ba5a$var$meta),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates that a
    given element is being defined. Expected to be used with the
    various [name](#highlight.tags.name) tags.
    */ definition: $6b8758376c12ba5a$export$3288d34c523a1192.defineModifier("definition"),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates that
    something is constant. Mostly expected to be used with
    [variable names](#highlight.tags.variableName).
    */ constant: $6b8758376c12ba5a$export$3288d34c523a1192.defineModifier("constant"),
    /**
    [Modifier](#highlight.Tag^defineModifier) used to indicate that
    a [variable](#highlight.tags.variableName) or [property
    name](#highlight.tags.propertyName) is being called or defined
    as a function.
    */ function: $6b8758376c12ba5a$export$3288d34c523a1192.defineModifier("function"),
    /**
    [Modifier](#highlight.Tag^defineModifier) that can be applied to
    [names](#highlight.tags.name) to indicate that they belong to
    the language's standard environment.
    */ standard: $6b8758376c12ba5a$export$3288d34c523a1192.defineModifier("standard"),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates a given
    [names](#highlight.tags.name) is local to some scope.
    */ local: $6b8758376c12ba5a$export$3288d34c523a1192.defineModifier("local"),
    /**
    A generic variant [modifier](#highlight.Tag^defineModifier) that
    can be used to tag language-specific alternative variants of
    some common tag. It is recommended for themes to define special
    forms of at least the [string](#highlight.tags.string) and
    [variable name](#highlight.tags.variableName) tags, since those
    come up a lot.
    */ special: $6b8758376c12ba5a$export$3288d34c523a1192.defineModifier("special")
};
for(let name in $6b8758376c12ba5a$export$8b7a896ae75accbf){
    let val = $6b8758376c12ba5a$export$8b7a896ae75accbf[name];
    if (val instanceof $6b8758376c12ba5a$export$3288d34c523a1192) val.name = name;
}
/**
This is a highlighter that adds stable, predictable classes to
tokens, for styling with external CSS.

The following tags are mapped to their name prefixed with `"tok-"`
(for example `"tok-comment"`):

* [`link`](#highlight.tags.link)
* [`heading`](#highlight.tags.heading)
* [`emphasis`](#highlight.tags.emphasis)
* [`strong`](#highlight.tags.strong)
* [`keyword`](#highlight.tags.keyword)
* [`atom`](#highlight.tags.atom)
* [`bool`](#highlight.tags.bool)
* [`url`](#highlight.tags.url)
* [`labelName`](#highlight.tags.labelName)
* [`inserted`](#highlight.tags.inserted)
* [`deleted`](#highlight.tags.deleted)
* [`literal`](#highlight.tags.literal)
* [`string`](#highlight.tags.string)
* [`number`](#highlight.tags.number)
* [`variableName`](#highlight.tags.variableName)
* [`typeName`](#highlight.tags.typeName)
* [`namespace`](#highlight.tags.namespace)
* [`className`](#highlight.tags.className)
* [`macroName`](#highlight.tags.macroName)
* [`propertyName`](#highlight.tags.propertyName)
* [`operator`](#highlight.tags.operator)
* [`comment`](#highlight.tags.comment)
* [`meta`](#highlight.tags.meta)
* [`punctuation`](#highlight.tags.punctuation)
* [`invalid`](#highlight.tags.invalid)

In addition, these mappings are provided:

* [`regexp`](#highlight.tags.regexp),
  [`escape`](#highlight.tags.escape), and
  [`special`](#highlight.tags.special)[`(string)`](#highlight.tags.string)
  are mapped to `"tok-string2"`
* [`special`](#highlight.tags.special)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName2"`
* [`local`](#highlight.tags.local)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName tok-local"`
* [`definition`](#highlight.tags.definition)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName tok-definition"`
* [`definition`](#highlight.tags.definition)[`(propertyName)`](#highlight.tags.propertyName)
  to `"tok-propertyName tok-definition"`
*/ const $6b8758376c12ba5a$export$bf3ffb24fb17216c = $6b8758376c12ba5a$export$b7f6332ce20f80fb([
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.link,
        class: "tok-link"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.heading,
        class: "tok-heading"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.emphasis,
        class: "tok-emphasis"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.strong,
        class: "tok-strong"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.keyword,
        class: "tok-keyword"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.atom,
        class: "tok-atom"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.bool,
        class: "tok-bool"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.url,
        class: "tok-url"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.labelName,
        class: "tok-labelName"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.inserted,
        class: "tok-inserted"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.deleted,
        class: "tok-deleted"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.literal,
        class: "tok-literal"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.string,
        class: "tok-string"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.number,
        class: "tok-number"
    },
    {
        tag: [
            $6b8758376c12ba5a$export$8b7a896ae75accbf.regexp,
            $6b8758376c12ba5a$export$8b7a896ae75accbf.escape,
            $6b8758376c12ba5a$export$8b7a896ae75accbf.special($6b8758376c12ba5a$export$8b7a896ae75accbf.string)
        ],
        class: "tok-string2"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.variableName,
        class: "tok-variableName"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.local($6b8758376c12ba5a$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName tok-local"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.definition($6b8758376c12ba5a$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName tok-definition"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.special($6b8758376c12ba5a$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName2"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.definition($6b8758376c12ba5a$export$8b7a896ae75accbf.propertyName),
        class: "tok-propertyName tok-definition"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.typeName,
        class: "tok-typeName"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.namespace,
        class: "tok-namespace"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.className,
        class: "tok-className"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.macroName,
        class: "tok-macroName"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.propertyName,
        class: "tok-propertyName"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.operator,
        class: "tok-operator"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.comment,
        class: "tok-comment"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.meta,
        class: "tok-meta"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.invalid,
        class: "tok-invalid"
    },
    {
        tag: $6b8758376c12ba5a$export$8b7a896ae75accbf.punctuation,
        class: "tok-punctuation"
    }
]);



var $deda11ebd5d0815e$var$_a;
/**
Node prop stored in a parser's top syntax node to provide the
facet that stores language-specific data for that language.
*/ const $deda11ebd5d0815e$export$27a2e78097f753f7 = /*@__PURE__*/ new (0, $a7a41eb5193c1110$export$b8034b9bc18acd90)();
/**
Helper function to define a facet (to be added to the top syntax
node(s) for a language via
[`languageDataProp`](https://codemirror.net/6/docs/ref/#language.languageDataProp)), that will be
used to associate language data with the language. You
probably only need this when subclassing
[`Language`](https://codemirror.net/6/docs/ref/#language.Language).
*/ function $deda11ebd5d0815e$export$b57f683f43553b99(baseData) {
    return (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
        combine: baseData ? (values)=>values.concat(baseData) : undefined
    });
}
/**
Syntax node prop used to register sublanguages. Should be added to
the top level node type for the language.
*/ const $deda11ebd5d0815e$export$4afc6f37514bbb67 = /*@__PURE__*/ new (0, $a7a41eb5193c1110$export$b8034b9bc18acd90)();
/**
A language object manages parsing and per-language
[metadata](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt). Parse data is
managed as a [Lezer](https://lezer.codemirror.net) tree. The class
can be used directly, via the [`LRLanguage`](https://codemirror.net/6/docs/ref/#language.LRLanguage)
subclass for [Lezer](https://lezer.codemirror.net/) LR parsers, or
via the [`StreamLanguage`](https://codemirror.net/6/docs/ref/#language.StreamLanguage) subclass
for stream parsers.
*/ class $deda11ebd5d0815e$export$ce4fe1c9e6520c1a {
    /**
    Construct a language object. If you need to invoke this
    directly, first define a data facet with
    [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
    configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
    to the language's outer syntax node.
    */ constructor(/**
    The [language data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) facet
    used for this language.
    */ data, parser, extraExtensions = [], /**
    A language name.
    */ name = ""){
        this.data = data;
        this.name = name;
        // Kludge to define EditorState.tree as a debugging helper,
        // without the EditorState package actually knowing about
        // languages and lezer trees.
        if (!(0, $6b8f387faea0a4dd$export$afa855cbfaff27f2).prototype.hasOwnProperty("tree")) Object.defineProperty((0, $6b8f387faea0a4dd$export$afa855cbfaff27f2).prototype, "tree", {
            get () {
                return $deda11ebd5d0815e$export$7fc98e56a4ca6be1(this);
            }
        });
        this.parser = parser;
        this.extension = [
            $deda11ebd5d0815e$export$789c912f57fe164c.of(this),
            (0, $6b8f387faea0a4dd$export$afa855cbfaff27f2).languageData.of((state, pos, side)=>{
                let top = $deda11ebd5d0815e$var$topNodeAt(state, pos, side), data = top.type.prop($deda11ebd5d0815e$export$27a2e78097f753f7);
                if (!data) return [];
                let base = state.facet(data), sub = top.type.prop($deda11ebd5d0815e$export$4afc6f37514bbb67);
                if (sub) {
                    let innerNode = top.resolve(pos - top.from, side);
                    for (let sublang of sub)if (sublang.test(innerNode, state)) {
                        let data = state.facet(sublang.facet);
                        return sublang.type == "replace" ? data : data.concat(base);
                    }
                }
                return base;
            })
        ].concat(extraExtensions);
    }
    /**
    Query whether this language is active at the given position.
    */ isActiveAt(state, pos, side = -1) {
        return $deda11ebd5d0815e$var$topNodeAt(state, pos, side).type.prop($deda11ebd5d0815e$export$27a2e78097f753f7) == this.data;
    }
    /**
    Find the document regions that were parsed using this language.
    The returned regions will _include_ any nested languages rooted
    in this language, when those exist.
    */ findRegions(state) {
        let lang = state.facet($deda11ebd5d0815e$export$789c912f57fe164c);
        if ((lang === null || lang === void 0 ? void 0 : lang.data) == this.data) return [
            {
                from: 0,
                to: state.doc.length
            }
        ];
        if (!lang || !lang.allowsNesting) return [];
        let result = [];
        let explore = (tree, from)=>{
            if (tree.prop($deda11ebd5d0815e$export$27a2e78097f753f7) == this.data) {
                result.push({
                    from: from,
                    to: from + tree.length
                });
                return;
            }
            let mount = tree.prop((0, $a7a41eb5193c1110$export$b8034b9bc18acd90).mounted);
            if (mount) {
                if (mount.tree.prop($deda11ebd5d0815e$export$27a2e78097f753f7) == this.data) {
                    if (mount.overlay) for (let r of mount.overlay)result.push({
                        from: r.from + from,
                        to: r.to + from
                    });
                    else result.push({
                        from: from,
                        to: from + tree.length
                    });
                    return;
                } else if (mount.overlay) {
                    let size = result.length;
                    explore(mount.tree, mount.overlay[0].from + from);
                    if (result.length > size) return;
                }
            }
            for(let i = 0; i < tree.children.length; i++){
                let ch = tree.children[i];
                if (ch instanceof (0, $a7a41eb5193c1110$export$7fbedc92909ed28e)) explore(ch, tree.positions[i] + from);
            }
        };
        explore($deda11ebd5d0815e$export$7fc98e56a4ca6be1(state), 0);
        return result;
    }
    /**
    Indicates whether this language allows nested languages. The
    default implementation returns true.
    */ get allowsNesting() {
        return true;
    }
}
/**
@internal
*/ $deda11ebd5d0815e$export$ce4fe1c9e6520c1a.setState = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define();
function $deda11ebd5d0815e$var$topNodeAt(state, pos, side) {
    let topLang = state.facet($deda11ebd5d0815e$export$789c912f57fe164c), tree = $deda11ebd5d0815e$export$7fc98e56a4ca6be1(state).topNode;
    if (!topLang || topLang.allowsNesting) {
        for(let node = tree; node; node = node.enter(pos, side, (0, $a7a41eb5193c1110$export$b0e28367f55837aa).ExcludeBuffers))if (node.type.isTop) tree = node;
    }
    return tree;
}
/**
A subclass of [`Language`](https://codemirror.net/6/docs/ref/#language.Language) for use with Lezer
[LR parsers](https://lezer.codemirror.net/docs/ref#lr.LRParser)
parsers.
*/ class $deda11ebd5d0815e$export$b243968d9fb6db03 extends $deda11ebd5d0815e$export$ce4fe1c9e6520c1a {
    constructor(data, parser, name){
        super(data, parser, [], name);
        this.parser = parser;
    }
    /**
    Define a language from a parser.
    */ static define(spec) {
        let data = $deda11ebd5d0815e$export$b57f683f43553b99(spec.languageData);
        return new $deda11ebd5d0815e$export$b243968d9fb6db03(data, spec.parser.configure({
            props: [
                $deda11ebd5d0815e$export$27a2e78097f753f7.add((type)=>type.isTop ? data : undefined)
            ]
        }), spec.name);
    }
    /**
    Create a new instance of this language with a reconfigured
    version of its parser and optionally a new name.
    */ configure(options, name) {
        return new $deda11ebd5d0815e$export$b243968d9fb6db03(this.data, this.parser.configure(options), name || this.name);
    }
    get allowsNesting() {
        return this.parser.hasWrappers();
    }
}
/**
Get the syntax tree for a state, which is the current (possibly
incomplete) parse tree of the active
[language](https://codemirror.net/6/docs/ref/#language.Language), or the empty tree if there is no
language available.
*/ function $deda11ebd5d0815e$export$7fc98e56a4ca6be1(state) {
    let field = state.field($deda11ebd5d0815e$export$ce4fe1c9e6520c1a.state, false);
    return field ? field.tree : (0, $a7a41eb5193c1110$export$7fbedc92909ed28e).empty;
}
/**
Try to get a parse tree that spans at least up to `upto`. The
method will do at most `timeout` milliseconds of work to parse
up to that point if the tree isn't already available.
*/ function $deda11ebd5d0815e$export$8694796f3a52e973(state, upto, timeout = 50) {
    var _a;
    let parse = (_a = state.field($deda11ebd5d0815e$export$ce4fe1c9e6520c1a.state, false)) === null || _a === void 0 ? void 0 : _a.context;
    if (!parse) return null;
    let oldVieport = parse.viewport;
    parse.updateViewport({
        from: 0,
        to: upto
    });
    let result = parse.isDone(upto) || parse.work(timeout, upto) ? parse.tree : null;
    parse.updateViewport(oldVieport);
    return result;
}
/**
Queries whether there is a full syntax tree available up to the
given document position. If there isn't, the background parse
process _might_ still be working and update the tree further, but
there is no guarantee of that—the parser will [stop
working](https://codemirror.net/6/docs/ref/#language.syntaxParserRunning) when it has spent a
certain amount of time or has moved beyond the visible viewport.
Always returns false if no language has been enabled.
*/ function $deda11ebd5d0815e$export$2c95b013b0941e86(state, upto = state.doc.length) {
    var _a;
    return ((_a = state.field($deda11ebd5d0815e$export$ce4fe1c9e6520c1a.state, false)) === null || _a === void 0 ? void 0 : _a.context.isDone(upto)) || false;
}
/**
Move parsing forward, and update the editor state afterwards to
reflect the new tree. Will work for at most `timeout`
milliseconds. Returns true if the parser managed get to the given
position in that time.
*/ function $deda11ebd5d0815e$export$b3bcb61c35026d72(view, upto = view.viewport.to, timeout = 100) {
    let success = $deda11ebd5d0815e$export$8694796f3a52e973(view.state, upto, timeout);
    if (success != $deda11ebd5d0815e$export$7fc98e56a4ca6be1(view.state)) view.dispatch({});
    return !!success;
}
/**
Tells you whether the language parser is planning to do more
parsing work (in a `requestIdleCallback` pseudo-thread) or has
stopped running, either because it parsed the entire document,
because it spent too much time and was cut off, or because there
is no language parser enabled.
*/ function $deda11ebd5d0815e$export$23c0ee92d6189d3f(view) {
    var _a;
    return ((_a = view.plugin($deda11ebd5d0815e$var$parseWorker)) === null || _a === void 0 ? void 0 : _a.isWorking()) || false;
}
/**
Lezer-style
[`Input`](https://lezer.codemirror.net/docs/ref#common.Input)
object for a [`Text`](https://codemirror.net/6/docs/ref/#state.Text) object.
*/ class $deda11ebd5d0815e$export$78c262ab5af874ad {
    /**
    Create an input object for the given document.
    */ constructor(doc){
        this.doc = doc;
        this.cursorPos = 0;
        this.string = "";
        this.cursor = doc.iter();
    }
    get length() {
        return this.doc.length;
    }
    syncTo(pos) {
        this.string = this.cursor.next(pos - this.cursorPos).value;
        this.cursorPos = pos + this.string.length;
        return this.cursorPos - this.string.length;
    }
    chunk(pos) {
        this.syncTo(pos);
        return this.string;
    }
    get lineChunks() {
        return true;
    }
    read(from, to) {
        let stringStart = this.cursorPos - this.string.length;
        if (from < stringStart || to >= this.cursorPos) return this.doc.sliceString(from, to);
        else return this.string.slice(from - stringStart, to - stringStart);
    }
}
let $deda11ebd5d0815e$var$currentContext = null;
/**
A parse context provided to parsers working on the editor content.
*/ class $deda11ebd5d0815e$export$3fcb7c01ff2a41fa {
    constructor(parser, /**
    The current editor state.
    */ state, /**
    Tree fragments that can be reused by incremental re-parses.
    */ fragments = [], /**
    @internal
    */ tree, /**
    @internal
    */ treeLen, /**
    The current editor viewport (or some overapproximation
    thereof). Intended to be used for opportunistically avoiding
    work (in which case
    [`skipUntilInView`](https://codemirror.net/6/docs/ref/#language.ParseContext.skipUntilInView)
    should be called to make sure the parser is restarted when the
    skipped region becomes visible).
    */ viewport, /**
    @internal
    */ skipped, /**
    This is where skipping parsers can register a promise that,
    when resolved, will schedule a new parse. It is cleared when
    the parse worker picks up the promise. @internal
    */ scheduleOn){
        this.parser = parser;
        this.state = state;
        this.fragments = fragments;
        this.tree = tree;
        this.treeLen = treeLen;
        this.viewport = viewport;
        this.skipped = skipped;
        this.scheduleOn = scheduleOn;
        this.parse = null;
        /**
        @internal
        */ this.tempSkipped = [];
    }
    /**
    @internal
    */ static create(parser, state, viewport) {
        return new $deda11ebd5d0815e$export$3fcb7c01ff2a41fa(parser, state, [], (0, $a7a41eb5193c1110$export$7fbedc92909ed28e).empty, 0, viewport, [], null);
    }
    startParse() {
        return this.parser.startParse(new $deda11ebd5d0815e$export$78c262ab5af874ad(this.state.doc), this.fragments);
    }
    /**
    @internal
    */ work(until, upto) {
        if (upto != null && upto >= this.state.doc.length) upto = undefined;
        if (this.tree != (0, $a7a41eb5193c1110$export$7fbedc92909ed28e).empty && this.isDone(upto !== null && upto !== void 0 ? upto : this.state.doc.length)) {
            this.takeTree();
            return true;
        }
        return this.withContext(()=>{
            var _a;
            if (typeof until == "number") {
                let endTime = Date.now() + until;
                until = ()=>Date.now() > endTime;
            }
            if (!this.parse) this.parse = this.startParse();
            if (upto != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > upto) && upto < this.state.doc.length) this.parse.stopAt(upto);
            for(;;){
                let done = this.parse.advance();
                if (done) {
                    this.fragments = this.withoutTempSkipped((0, $a7a41eb5193c1110$export$3ae2ede6dca97077).addTree(done, this.fragments, this.parse.stoppedAt != null));
                    this.treeLen = (_a = this.parse.stoppedAt) !== null && _a !== void 0 ? _a : this.state.doc.length;
                    this.tree = done;
                    this.parse = null;
                    if (this.treeLen < (upto !== null && upto !== void 0 ? upto : this.state.doc.length)) this.parse = this.startParse();
                    else return true;
                }
                if (until()) return false;
            }
        });
    }
    /**
    @internal
    */ takeTree() {
        let pos, tree;
        if (this.parse && (pos = this.parse.parsedPos) >= this.treeLen) {
            if (this.parse.stoppedAt == null || this.parse.stoppedAt > pos) this.parse.stopAt(pos);
            this.withContext(()=>{
                while(!(tree = this.parse.advance()));
            });
            this.treeLen = pos;
            this.tree = tree;
            this.fragments = this.withoutTempSkipped((0, $a7a41eb5193c1110$export$3ae2ede6dca97077).addTree(this.tree, this.fragments, true));
            this.parse = null;
        }
    }
    withContext(f) {
        let prev = $deda11ebd5d0815e$var$currentContext;
        $deda11ebd5d0815e$var$currentContext = this;
        try {
            return f();
        } finally{
            $deda11ebd5d0815e$var$currentContext = prev;
        }
    }
    withoutTempSkipped(fragments) {
        for(let r; r = this.tempSkipped.pop();)fragments = $deda11ebd5d0815e$var$cutFragments(fragments, r.from, r.to);
        return fragments;
    }
    /**
    @internal
    */ changes(changes, newState) {
        let { fragments: fragments, tree: tree, treeLen: treeLen, viewport: viewport, skipped: skipped } = this;
        this.takeTree();
        if (!changes.empty) {
            let ranges = [];
            changes.iterChangedRanges((fromA, toA, fromB, toB)=>ranges.push({
                    fromA: fromA,
                    toA: toA,
                    fromB: fromB,
                    toB: toB
                }));
            fragments = (0, $a7a41eb5193c1110$export$3ae2ede6dca97077).applyChanges(fragments, ranges);
            tree = (0, $a7a41eb5193c1110$export$7fbedc92909ed28e).empty;
            treeLen = 0;
            viewport = {
                from: changes.mapPos(viewport.from, -1),
                to: changes.mapPos(viewport.to, 1)
            };
            if (this.skipped.length) {
                skipped = [];
                for (let r of this.skipped){
                    let from = changes.mapPos(r.from, 1), to = changes.mapPos(r.to, -1);
                    if (from < to) skipped.push({
                        from: from,
                        to: to
                    });
                }
            }
        }
        return new $deda11ebd5d0815e$export$3fcb7c01ff2a41fa(this.parser, newState, fragments, tree, treeLen, viewport, skipped, this.scheduleOn);
    }
    /**
    @internal
    */ updateViewport(viewport) {
        if (this.viewport.from == viewport.from && this.viewport.to == viewport.to) return false;
        this.viewport = viewport;
        let startLen = this.skipped.length;
        for(let i = 0; i < this.skipped.length; i++){
            let { from: from, to: to } = this.skipped[i];
            if (from < viewport.to && to > viewport.from) {
                this.fragments = $deda11ebd5d0815e$var$cutFragments(this.fragments, from, to);
                this.skipped.splice(i--, 1);
            }
        }
        if (this.skipped.length >= startLen) return false;
        this.reset();
        return true;
    }
    /**
    @internal
    */ reset() {
        if (this.parse) {
            this.takeTree();
            this.parse = null;
        }
    }
    /**
    Notify the parse scheduler that the given region was skipped
    because it wasn't in view, and the parse should be restarted
    when it comes into view.
    */ skipUntilInView(from, to) {
        this.skipped.push({
            from: from,
            to: to
        });
    }
    /**
    Returns a parser intended to be used as placeholder when
    asynchronously loading a nested parser. It'll skip its input and
    mark it as not-really-parsed, so that the next update will parse
    it again.
    
    When `until` is given, a reparse will be scheduled when that
    promise resolves.
    */ static getSkippingParser(until) {
        return new class extends (0, $a7a41eb5193c1110$export$7acfa6ed01010e37) {
            createParse(input, fragments, ranges) {
                let from = ranges[0].from, to = ranges[ranges.length - 1].to;
                let parser = {
                    parsedPos: from,
                    advance () {
                        let cx = $deda11ebd5d0815e$var$currentContext;
                        if (cx) {
                            for (let r of ranges)cx.tempSkipped.push(r);
                            if (until) cx.scheduleOn = cx.scheduleOn ? Promise.all([
                                cx.scheduleOn,
                                until
                            ]) : until;
                        }
                        this.parsedPos = to;
                        return new (0, $a7a41eb5193c1110$export$7fbedc92909ed28e)((0, $a7a41eb5193c1110$export$f06e977173f1857c).none, [], [], to - from);
                    },
                    stoppedAt: null,
                    stopAt () {}
                };
                return parser;
            }
        };
    }
    /**
    @internal
    */ isDone(upto) {
        upto = Math.min(upto, this.state.doc.length);
        let frags = this.fragments;
        return this.treeLen >= upto && frags.length && frags[0].from == 0 && frags[0].to >= upto;
    }
    /**
    Get the context for the current parse, or `null` if no editor
    parse is in progress.
    */ static get() {
        return $deda11ebd5d0815e$var$currentContext;
    }
}
function $deda11ebd5d0815e$var$cutFragments(fragments, from, to) {
    return (0, $a7a41eb5193c1110$export$3ae2ede6dca97077).applyChanges(fragments, [
        {
            fromA: from,
            toA: to,
            fromB: from,
            toB: to
        }
    ]);
}
class $deda11ebd5d0815e$var$LanguageState {
    constructor(// A mutable parse state that is used to preserve work done during
    // the lifetime of a state when moving to the next state.
    context){
        this.context = context;
        this.tree = context.tree;
    }
    apply(tr) {
        if (!tr.docChanged && this.tree == this.context.tree) return this;
        let newCx = this.context.changes(tr.changes, tr.state);
        // If the previous parse wasn't done, go forward only up to its
        // end position or the end of the viewport, to avoid slowing down
        // state updates with parse work beyond the viewport.
        let upto = this.context.treeLen == tr.startState.doc.length ? undefined : Math.max(tr.changes.mapPos(this.context.treeLen), newCx.viewport.to);
        if (!newCx.work(20 /* Work.Apply */ , upto)) newCx.takeTree();
        return new $deda11ebd5d0815e$var$LanguageState(newCx);
    }
    static init(state) {
        let vpTo = Math.min(3000 /* Work.InitViewport */ , state.doc.length);
        let parseState = $deda11ebd5d0815e$export$3fcb7c01ff2a41fa.create(state.facet($deda11ebd5d0815e$export$789c912f57fe164c).parser, state, {
            from: 0,
            to: vpTo
        });
        if (!parseState.work(20 /* Work.Apply */ , vpTo)) parseState.takeTree();
        return new $deda11ebd5d0815e$var$LanguageState(parseState);
    }
}
$deda11ebd5d0815e$export$ce4fe1c9e6520c1a.state = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$34381b1ce2130245).define({
    create: $deda11ebd5d0815e$var$LanguageState.init,
    update (value, tr) {
        for (let e of tr.effects)if (e.is($deda11ebd5d0815e$export$ce4fe1c9e6520c1a.setState)) return e.value;
        if (tr.startState.facet($deda11ebd5d0815e$export$789c912f57fe164c) != tr.state.facet($deda11ebd5d0815e$export$789c912f57fe164c)) return $deda11ebd5d0815e$var$LanguageState.init(tr.state);
        return value.apply(tr);
    }
});
let $deda11ebd5d0815e$var$requestIdle = (callback)=>{
    let timeout = setTimeout(()=>callback(), 500 /* Work.MaxPause */ );
    return ()=>clearTimeout(timeout);
};
if (typeof requestIdleCallback != "undefined") $deda11ebd5d0815e$var$requestIdle = (callback)=>{
    let idle = -1, timeout = setTimeout(()=>{
        idle = requestIdleCallback(callback, {
            timeout: 400 /* Work.MinPause */ 
        });
    }, 100 /* Work.MinPause */ );
    return ()=>idle < 0 ? clearTimeout(timeout) : cancelIdleCallback(idle);
};
const $deda11ebd5d0815e$var$isInputPending = typeof navigator != "undefined" && (($deda11ebd5d0815e$var$_a = navigator.scheduling) === null || $deda11ebd5d0815e$var$_a === void 0 ? void 0 : $deda11ebd5d0815e$var$_a.isInputPending) ? ()=>navigator.scheduling.isInputPending() : null;
const $deda11ebd5d0815e$var$parseWorker = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$44d5eccfd62adda7).fromClass(class ParseWorker {
    constructor(view){
        this.view = view;
        this.working = null;
        this.workScheduled = 0;
        // End of the current time chunk
        this.chunkEnd = -1;
        // Milliseconds of budget left for this chunk
        this.chunkBudget = -1;
        this.work = this.work.bind(this);
        this.scheduleWork();
    }
    update(update) {
        let cx = this.view.state.field($deda11ebd5d0815e$export$ce4fe1c9e6520c1a.state).context;
        if (cx.updateViewport(update.view.viewport) || this.view.viewport.to > cx.treeLen) this.scheduleWork();
        if (update.docChanged || update.selectionSet) {
            if (this.view.hasFocus) this.chunkBudget += 50 /* Work.ChangeBonus */ ;
            this.scheduleWork();
        }
        this.checkAsyncSchedule(cx);
    }
    scheduleWork() {
        if (this.working) return;
        let { state: state } = this.view, field = state.field($deda11ebd5d0815e$export$ce4fe1c9e6520c1a.state);
        if (field.tree != field.context.tree || !field.context.isDone(state.doc.length)) this.working = $deda11ebd5d0815e$var$requestIdle(this.work);
    }
    work(deadline) {
        this.working = null;
        let now = Date.now();
        if (this.chunkEnd < now && (this.chunkEnd < 0 || this.view.hasFocus)) {
            this.chunkEnd = now + 30000 /* Work.ChunkTime */ ;
            this.chunkBudget = 3000 /* Work.ChunkBudget */ ;
        }
        if (this.chunkBudget <= 0) return; // No more budget
        let { state: state, viewport: { to: vpTo } } = this.view, field = state.field($deda11ebd5d0815e$export$ce4fe1c9e6520c1a.state);
        if (field.tree == field.context.tree && field.context.isDone(vpTo + 100000 /* Work.MaxParseAhead */ )) return;
        let endTime = Date.now() + Math.min(this.chunkBudget, 100 /* Work.Slice */ , deadline && !$deda11ebd5d0815e$var$isInputPending ? Math.max(25 /* Work.MinSlice */ , deadline.timeRemaining() - 5) : 1e9);
        let viewportFirst = field.context.treeLen < vpTo && state.doc.length > vpTo + 1000;
        let done = field.context.work(()=>{
            return $deda11ebd5d0815e$var$isInputPending && $deda11ebd5d0815e$var$isInputPending() || Date.now() > endTime;
        }, vpTo + (viewportFirst ? 0 : 100000 /* Work.MaxParseAhead */ ));
        this.chunkBudget -= Date.now() - now;
        if (done || this.chunkBudget <= 0) {
            field.context.takeTree();
            this.view.dispatch({
                effects: $deda11ebd5d0815e$export$ce4fe1c9e6520c1a.setState.of(new $deda11ebd5d0815e$var$LanguageState(field.context))
            });
        }
        if (this.chunkBudget > 0 && !(done && !viewportFirst)) this.scheduleWork();
        this.checkAsyncSchedule(field.context);
    }
    checkAsyncSchedule(cx) {
        if (cx.scheduleOn) {
            this.workScheduled++;
            cx.scheduleOn.then(()=>this.scheduleWork()).catch((err)=>(0, $1d528cc0e08a0656$export$f86b2a1a2ce291b3)(this.view.state, err)).then(()=>this.workScheduled--);
            cx.scheduleOn = null;
        }
    }
    destroy() {
        if (this.working) this.working();
    }
    isWorking() {
        return !!(this.working || this.workScheduled > 0);
    }
}, {
    eventHandlers: {
        focus () {
            this.scheduleWork();
        }
    }
});
/**
The facet used to associate a language with an editor state. Used
by `Language` object's `extension` property (so you don't need to
manually wrap your languages in this). Can be used to access the
current language on a state.
*/ const $deda11ebd5d0815e$export$789c912f57fe164c = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine (languages) {
        return languages.length ? languages[0] : null;
    },
    enables: (language)=>[
            $deda11ebd5d0815e$export$ce4fe1c9e6520c1a.state,
            $deda11ebd5d0815e$var$parseWorker,
            (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).contentAttributes.compute([
                language
            ], (state)=>{
                let lang = state.facet(language);
                return lang && lang.name ? {
                    "data-language": lang.name
                } : {};
            })
        ]
});
/**
This class bundles a [language](https://codemirror.net/6/docs/ref/#language.Language) with an
optional set of supporting extensions. Language packages are
encouraged to export a function that optionally takes a
configuration object and returns a `LanguageSupport` instance, as
the main way for client code to use the package.
*/ class $deda11ebd5d0815e$export$cbdefefa8a51dd3b {
    /**
    Create a language support object.
    */ constructor(/**
    The language object.
    */ language, /**
    An optional set of supporting extensions. When nesting a
    language in another language, the outer language is encouraged
    to include the supporting extensions for its inner languages
    in its own set of support extensions.
    */ support = []){
        this.language = language;
        this.support = support;
        this.extension = [
            language,
            support
        ];
    }
}
/**
Language descriptions are used to store metadata about languages
and to dynamically load them. Their main role is finding the
appropriate language for a filename or dynamically loading nested
parsers.
*/ class $deda11ebd5d0815e$export$50ab82debf88f71 {
    constructor(/**
    The name of this language.
    */ name, /**
    Alternative names for the mode (lowercased, includes `this.name`).
    */ alias, /**
    File extensions associated with this language.
    */ extensions, /**
    Optional filename pattern that should be associated with this
    language.
    */ filename, loadFunc, /**
    If the language has been loaded, this will hold its value.
    */ support){
        this.name = name;
        this.alias = alias;
        this.extensions = extensions;
        this.filename = filename;
        this.loadFunc = loadFunc;
        this.support = support;
        this.loading = null;
    }
    /**
    Start loading the the language. Will return a promise that
    resolves to a [`LanguageSupport`](https://codemirror.net/6/docs/ref/#language.LanguageSupport)
    object when the language successfully loads.
    */ load() {
        return this.loading || (this.loading = this.loadFunc().then((support)=>this.support = support, (err)=>{
            this.loading = null;
            throw err;
        }));
    }
    /**
    Create a language description.
    */ static of(spec) {
        let { load: load, support: support } = spec;
        if (!load) {
            if (!support) throw new RangeError("Must pass either 'load' or 'support' to LanguageDescription.of");
            load = ()=>Promise.resolve(support);
        }
        return new $deda11ebd5d0815e$export$50ab82debf88f71(spec.name, (spec.alias || []).concat(spec.name).map((s)=>s.toLowerCase()), spec.extensions || [], spec.filename, load, support);
    }
    /**
    Look for a language in the given array of descriptions that
    matches the filename. Will first match
    [`filename`](https://codemirror.net/6/docs/ref/#language.LanguageDescription.filename) patterns,
    and then [extensions](https://codemirror.net/6/docs/ref/#language.LanguageDescription.extensions),
    and return the first language that matches.
    */ static matchFilename(descs, filename) {
        for (let d of descs)if (d.filename && d.filename.test(filename)) return d;
        let ext = /\.([^.]+)$/.exec(filename);
        if (ext) {
            for (let d of descs)if (d.extensions.indexOf(ext[1]) > -1) return d;
        }
        return null;
    }
    /**
    Look for a language whose name or alias matches the the given
    name (case-insensitively). If `fuzzy` is true, and no direct
    matchs is found, this'll also search for a language whose name
    or alias occurs in the string (for names shorter than three
    characters, only when surrounded by non-word characters).
    */ static matchLanguageName(descs, name, fuzzy = true) {
        name = name.toLowerCase();
        for (let d of descs)if (d.alias.some((a)=>a == name)) return d;
        if (fuzzy) for (let d of descs)for (let a of d.alias){
            let found = name.indexOf(a);
            if (found > -1 && (a.length > 2 || !/\w/.test(name[found - 1]) && !/\w/.test(name[found + a.length]))) return d;
        }
        return null;
    }
}
/**
Facet that defines a way to provide a function that computes the
appropriate indentation depth, as a column number (see
[`indentString`](https://codemirror.net/6/docs/ref/#language.indentString)), at the start of a given
line. A return value of `null` indicates no indentation can be
determined, and the line should inherit the indentation of the one
above it. A return value of `undefined` defers to the next indent
service.
*/ const $deda11ebd5d0815e$export$5952625dce50d1f3 = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
/**
Facet for overriding the unit by which indentation happens. Should
be a string consisting entirely of the same whitespace character.
When not set, this defaults to 2 spaces.
*/ const $deda11ebd5d0815e$export$9e0d0c2ce4d3ceb5 = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine: (values)=>{
        if (!values.length) return "  ";
        let unit = values[0];
        if (!unit || /\S/.test(unit) || Array.from(unit).some((e)=>e != unit[0])) throw new Error("Invalid indent unit: " + JSON.stringify(values[0]));
        return unit;
    }
});
/**
Return the _column width_ of an indent unit in the state.
Determined by the [`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit)
facet, and [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) when that
contains tabs.
*/ function $deda11ebd5d0815e$export$ad3205d09311a797(state) {
    let unit = state.facet($deda11ebd5d0815e$export$9e0d0c2ce4d3ceb5);
    return unit.charCodeAt(0) == 9 ? state.tabSize * unit.length : unit.length;
}
/**
Create an indentation string that covers columns 0 to `cols`.
Will use tabs for as much of the columns as possible when the
[`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit) facet contains
tabs.
*/ function $deda11ebd5d0815e$export$db5a40e207b40576(state, cols) {
    let result = "", ts = state.tabSize, ch = state.facet($deda11ebd5d0815e$export$9e0d0c2ce4d3ceb5)[0];
    if (ch == "\t") {
        while(cols >= ts){
            result += "\t";
            cols -= ts;
        }
        ch = " ";
    }
    for(let i = 0; i < cols; i++)result += ch;
    return result;
}
/**
Get the indentation, as a column number, at the given position.
Will first consult any [indent services](https://codemirror.net/6/docs/ref/#language.indentService)
that are registered, and if none of those return an indentation,
this will check the syntax tree for the [indent node
prop](https://codemirror.net/6/docs/ref/#language.indentNodeProp) and use that if found. Returns a
number when an indentation could be determined, and null
otherwise.
*/ function $deda11ebd5d0815e$export$a2d3c9dbce6d2211(context, pos) {
    if (context instanceof (0, $6b8f387faea0a4dd$export$afa855cbfaff27f2)) context = new $deda11ebd5d0815e$export$eeab79349cc2f7c8(context);
    for (let service of context.state.facet($deda11ebd5d0815e$export$5952625dce50d1f3)){
        let result = service(context, pos);
        if (result !== undefined) return result;
    }
    let tree = $deda11ebd5d0815e$export$7fc98e56a4ca6be1(context.state);
    return tree.length >= pos ? $deda11ebd5d0815e$var$syntaxIndentation(context, tree, pos) : null;
}
/**
Create a change set that auto-indents all lines touched by the
given document range.
*/ function $deda11ebd5d0815e$export$2fc72a4ad8b85e40(state, from, to) {
    let updated = Object.create(null);
    let context = new $deda11ebd5d0815e$export$eeab79349cc2f7c8(state, {
        overrideIndentation: (start)=>{
            var _a;
            return (_a = updated[start]) !== null && _a !== void 0 ? _a : -1;
        }
    });
    let changes = [];
    for(let pos = from; pos <= to;){
        let line = state.doc.lineAt(pos);
        pos = line.to + 1;
        let indent = $deda11ebd5d0815e$export$a2d3c9dbce6d2211(context, line.from);
        if (indent == null) continue;
        if (!/\S/.test(line.text)) indent = 0;
        let cur = /^\s*/.exec(line.text)[0];
        let norm = $deda11ebd5d0815e$export$db5a40e207b40576(state, indent);
        if (cur != norm) {
            updated[line.from] = indent;
            changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
    }
    return state.changes(changes);
}
/**
Indentation contexts are used when calling [indentation
services](https://codemirror.net/6/docs/ref/#language.indentService). They provide helper utilities
useful in indentation logic, and can selectively override the
indentation reported for some lines.
*/ class $deda11ebd5d0815e$export$eeab79349cc2f7c8 {
    /**
    Create an indent context.
    */ constructor(/**
    The editor state.
    */ state, /**
    @internal
    */ options = {}){
        this.state = state;
        this.options = options;
        this.unit = $deda11ebd5d0815e$export$ad3205d09311a797(state);
    }
    /**
    Get a description of the line at the given position, taking
    [simulated line
    breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    into account. If there is such a break at `pos`, the `bias`
    argument determines whether the part of the line line before or
    after the break is used.
    */ lineAt(pos, bias = 1) {
        let line = this.state.doc.lineAt(pos);
        let { simulateBreak: simulateBreak, simulateDoubleBreak: simulateDoubleBreak } = this.options;
        if (simulateBreak != null && simulateBreak >= line.from && simulateBreak <= line.to) {
            if (simulateDoubleBreak && simulateBreak == pos) return {
                text: "",
                from: pos
            };
            else if (bias < 0 ? simulateBreak < pos : simulateBreak <= pos) return {
                text: line.text.slice(simulateBreak - line.from),
                from: simulateBreak
            };
            else return {
                text: line.text.slice(0, simulateBreak - line.from),
                from: line.from
            };
        }
        return line;
    }
    /**
    Get the text directly after `pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ textAfterPos(pos, bias = 1) {
        if (this.options.simulateDoubleBreak && pos == this.options.simulateBreak) return "";
        let { text: text, from: from } = this.lineAt(pos, bias);
        return text.slice(pos - from, Math.min(text.length, pos + 100 - from));
    }
    /**
    Find the column for the given position.
    */ column(pos, bias = 1) {
        let { text: text, from: from } = this.lineAt(pos, bias);
        let result = this.countColumn(text, pos - from);
        let override = this.options.overrideIndentation ? this.options.overrideIndentation(from) : -1;
        if (override > -1) result += override - this.countColumn(text, text.search(/\S|$/));
        return result;
    }
    /**
    Find the column position (taking tabs into account) of the given
    position in the given string.
    */ countColumn(line, pos = line.length) {
        return (0, $6b8f387faea0a4dd$export$20b4ab289374d0ac)(line, this.state.tabSize, pos);
    }
    /**
    Find the indentation column of the line at the given point.
    */ lineIndent(pos, bias = 1) {
        let { text: text, from: from } = this.lineAt(pos, bias);
        let override = this.options.overrideIndentation;
        if (override) {
            let overriden = override(from);
            if (overriden > -1) return overriden;
        }
        return this.countColumn(text, text.search(/\S|$/));
    }
    /**
    Returns the [simulated line
    break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    for this context, if any.
    */ get simulatedBreak() {
        return this.options.simulateBreak || null;
    }
}
/**
A syntax tree node prop used to associate indentation strategies
with node types. Such a strategy is a function from an indentation
context to a column number (see also
[`indentString`](https://codemirror.net/6/docs/ref/#language.indentString)) or null, where null
indicates that no definitive indentation can be determined.
*/ const $deda11ebd5d0815e$export$72c7d4c52b3c6460 = /*@__PURE__*/ new (0, $a7a41eb5193c1110$export$b8034b9bc18acd90)();
// Compute the indentation for a given position from the syntax tree.
function $deda11ebd5d0815e$var$syntaxIndentation(cx, ast, pos) {
    let stack = ast.resolveStack(pos);
    let inner = ast.resolveInner(pos, -1).resolve(pos, 0).enterUnfinishedNodesBefore(pos);
    if (inner != stack.node) {
        let add = [];
        for(let cur = inner; cur && !(cur.from < stack.node.from || cur.to > stack.node.to || cur.from == stack.node.from && cur.type == stack.node.type); cur = cur.parent)add.push(cur);
        for(let i = add.length - 1; i >= 0; i--)stack = {
            node: add[i],
            next: stack
        };
    }
    return $deda11ebd5d0815e$var$indentFor(stack, cx, pos);
}
function $deda11ebd5d0815e$var$indentFor(stack, cx, pos) {
    for(let cur = stack; cur; cur = cur.next){
        let strategy = $deda11ebd5d0815e$var$indentStrategy(cur.node);
        if (strategy) return strategy($deda11ebd5d0815e$export$8aaeb0848a33f7c3.create(cx, pos, cur));
    }
    return 0;
}
function $deda11ebd5d0815e$var$ignoreClosed(cx) {
    return cx.pos == cx.options.simulateBreak && cx.options.simulateDoubleBreak;
}
function $deda11ebd5d0815e$var$indentStrategy(tree) {
    let strategy = tree.type.prop($deda11ebd5d0815e$export$72c7d4c52b3c6460);
    if (strategy) return strategy;
    let first = tree.firstChild, close;
    if (first && (close = first.type.prop((0, $a7a41eb5193c1110$export$b8034b9bc18acd90).closedBy))) {
        let last = tree.lastChild, closed = last && close.indexOf(last.name) > -1;
        return (cx)=>$deda11ebd5d0815e$var$delimitedStrategy(cx, true, 1, undefined, closed && !$deda11ebd5d0815e$var$ignoreClosed(cx) ? last.from : undefined);
    }
    return tree.parent == null ? $deda11ebd5d0815e$var$topIndent : null;
}
function $deda11ebd5d0815e$var$topIndent() {
    return 0;
}
/**
Objects of this type provide context information and helper
methods to indentation functions registered on syntax nodes.
*/ class $deda11ebd5d0815e$export$8aaeb0848a33f7c3 extends $deda11ebd5d0815e$export$eeab79349cc2f7c8 {
    constructor(base, /**
    The position at which indentation is being computed.
    */ pos, /**
    @internal
    */ context){
        super(base.state, base.options);
        this.base = base;
        this.pos = pos;
        this.context = context;
    }
    /**
    The syntax tree node to which the indentation strategy
    applies.
    */ get node() {
        return this.context.node;
    }
    /**
    @internal
    */ static create(base, pos, context) {
        return new $deda11ebd5d0815e$export$8aaeb0848a33f7c3(base, pos, context);
    }
    /**
    Get the text directly after `this.pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ get textAfter() {
        return this.textAfterPos(this.pos);
    }
    /**
    Get the indentation at the reference line for `this.node`, which
    is the line on which it starts, unless there is a node that is
    _not_ a parent of this node covering the start of that line. If
    so, the line at the start of that node is tried, again skipping
    on if it is covered by another such node.
    */ get baseIndent() {
        return this.baseIndentFor(this.node);
    }
    /**
    Get the indentation for the reference line of the given node
    (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
    */ baseIndentFor(node) {
        let line = this.state.doc.lineAt(node.from);
        // Skip line starts that are covered by a sibling (or cousin, etc)
        for(;;){
            let atBreak = node.resolve(line.from);
            while(atBreak.parent && atBreak.parent.from == atBreak.from)atBreak = atBreak.parent;
            if ($deda11ebd5d0815e$var$isParent(atBreak, node)) break;
            line = this.state.doc.lineAt(atBreak.from);
        }
        return this.lineIndent(line.from);
    }
    /**
    Continue looking for indentations in the node's parent nodes,
    and return the result of that.
    */ continue() {
        return $deda11ebd5d0815e$var$indentFor(this.context.next, this.base, this.pos);
    }
}
function $deda11ebd5d0815e$var$isParent(parent, of) {
    for(let cur = of; cur; cur = cur.parent)if (parent == cur) return true;
    return false;
}
// Check whether a delimited node is aligned (meaning there are
// non-skipped nodes on the same line as the opening delimiter). And
// if so, return the opening token.
function $deda11ebd5d0815e$var$bracketedAligned(context) {
    let tree = context.node;
    let openToken = tree.childAfter(tree.from), last = tree.lastChild;
    if (!openToken) return null;
    let sim = context.options.simulateBreak;
    let openLine = context.state.doc.lineAt(openToken.from);
    let lineEnd = sim == null || sim <= openLine.from ? openLine.to : Math.min(openLine.to, sim);
    for(let pos = openToken.to;;){
        let next = tree.childAfter(pos);
        if (!next || next == last) return null;
        if (!next.type.isSkipped) {
            if (next.from >= lineEnd) return null;
            let space = /^ */.exec(openLine.text.slice(openToken.to - openLine.from))[0].length;
            return {
                from: openToken.from,
                to: openToken.to + space
            };
        }
        pos = next.to;
    }
}
/**
An indentation strategy for delimited (usually bracketed) nodes.
Will, by default, indent one unit more than the parent's base
indent unless the line starts with a closing token. When `align`
is true and there are non-skipped nodes on the node's opening
line, the content of the node will be aligned with the end of the
opening node, like this:

    foo(bar,
        baz)
*/ function $deda11ebd5d0815e$export$60e82ea306899488({ closing: closing, align: align = true, units: units = 1 }) {
    return (context)=>$deda11ebd5d0815e$var$delimitedStrategy(context, align, units, closing);
}
function $deda11ebd5d0815e$var$delimitedStrategy(context, align, units, closing, closedAt) {
    let after = context.textAfter, space = after.match(/^\s*/)[0].length;
    let closed = closing && after.slice(space, space + closing.length) == closing || closedAt == context.pos + space;
    let aligned = align ? $deda11ebd5d0815e$var$bracketedAligned(context) : null;
    if (aligned) return closed ? context.column(aligned.from) : context.column(aligned.to);
    return context.baseIndent + (closed ? 0 : context.unit * units);
}
/**
An indentation strategy that aligns a node's content to its base
indentation.
*/ const $deda11ebd5d0815e$export$4764c629086182f2 = (context)=>context.baseIndent;
/**
Creates an indentation strategy that, by default, indents
continued lines one unit more than the node's base indentation.
You can provide `except` to prevent indentation of lines that
match a pattern (for example `/^else\b/` in `if`/`else`
constructs), and you can change the amount of units used with the
`units` option.
*/ function $deda11ebd5d0815e$export$688ff433e7e7cc5c({ except: except, units: units = 1 } = {}) {
    return (context)=>{
        let matchExcept = except && except.test(context.textAfter);
        return context.baseIndent + (matchExcept ? 0 : units * context.unit);
    };
}
const $deda11ebd5d0815e$var$DontIndentBeyond = 200;
/**
Enables reindentation on input. When a language defines an
`indentOnInput` field in its [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt), which must hold a regular
expression, the line at the cursor will be reindented whenever new
text is typed and the input from the start of the line up to the
cursor matches that regexp.

To avoid unneccesary reindents, it is recommended to start the
regexp with `^` (usually followed by `\s*`), and end it with `$`.
For example, `/^\s*\}$/` will reindent when a closing brace is
added at the start of a line.
*/ function $deda11ebd5d0815e$export$9bcaf6e2125ee117() {
    return (0, $6b8f387faea0a4dd$export$afa855cbfaff27f2).transactionFilter.of((tr)=>{
        if (!tr.docChanged || !tr.isUserEvent("input.type") && !tr.isUserEvent("input.complete")) return tr;
        let rules = tr.startState.languageDataAt("indentOnInput", tr.startState.selection.main.head);
        if (!rules.length) return tr;
        let doc = tr.newDoc, { head: head } = tr.newSelection.main, line = doc.lineAt(head);
        if (head > line.from + $deda11ebd5d0815e$var$DontIndentBeyond) return tr;
        let lineStart = doc.sliceString(line.from, head);
        if (!rules.some((r)=>r.test(lineStart))) return tr;
        let { state: state } = tr, last = -1, changes = [];
        for (let { head: head } of state.selection.ranges){
            let line = state.doc.lineAt(head);
            if (line.from == last) continue;
            last = line.from;
            let indent = $deda11ebd5d0815e$export$a2d3c9dbce6d2211(state, line.from);
            if (indent == null) continue;
            let cur = /^\s*/.exec(line.text)[0];
            let norm = $deda11ebd5d0815e$export$db5a40e207b40576(state, indent);
            if (cur != norm) changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
        return changes.length ? [
            tr,
            {
                changes: changes,
                sequential: true
            }
        ] : tr;
    });
}
/**
A facet that registers a code folding service. When called with
the extent of a line, such a function should return a foldable
range that starts on that line (but continues beyond it), if one
can be found.
*/ const $deda11ebd5d0815e$export$40014037e3ef64a = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
/**
This node prop is used to associate folding information with
syntax node types. Given a syntax node, it should check whether
that tree is foldable and return the range that can be collapsed
when it is.
*/ const $deda11ebd5d0815e$export$9b075a85eb4377d8 = /*@__PURE__*/ new (0, $a7a41eb5193c1110$export$b8034b9bc18acd90)();
/**
[Fold](https://codemirror.net/6/docs/ref/#language.foldNodeProp) function that folds everything but
the first and the last child of a syntax node. Useful for nodes
that start and end with delimiters.
*/ function $deda11ebd5d0815e$export$48672beae16a681b(node) {
    let first = node.firstChild, last = node.lastChild;
    return first && first.to < last.from ? {
        from: first.to,
        to: last.type.isError ? node.to : last.from
    } : null;
}
function $deda11ebd5d0815e$var$syntaxFolding(state, start, end) {
    let tree = $deda11ebd5d0815e$export$7fc98e56a4ca6be1(state);
    if (tree.length < end) return null;
    let stack = tree.resolveStack(end, 1);
    let found = null;
    for(let iter = stack; iter; iter = iter.next){
        let cur = iter.node;
        if (cur.to <= end || cur.from > end) continue;
        if (found && cur.from < start) break;
        let prop = cur.type.prop($deda11ebd5d0815e$export$9b075a85eb4377d8);
        if (prop && (cur.to < tree.length - 50 || tree.length == state.doc.length || !$deda11ebd5d0815e$var$isUnfinished(cur))) {
            let value = prop(cur, state);
            if (value && value.from <= end && value.from >= start && value.to > end) found = value;
        }
    }
    return found;
}
function $deda11ebd5d0815e$var$isUnfinished(node) {
    let ch = node.lastChild;
    return ch && ch.to == node.to && ch.type.isError;
}
/**
Check whether the given line is foldable. First asks any fold
services registered through
[`foldService`](https://codemirror.net/6/docs/ref/#language.foldService), and if none of them return
a result, tries to query the [fold node
prop](https://codemirror.net/6/docs/ref/#language.foldNodeProp) of syntax nodes that cover the end
of the line.
*/ function $deda11ebd5d0815e$export$cbe8a3d55245b07d(state, lineStart, lineEnd) {
    for (let service of state.facet($deda11ebd5d0815e$export$40014037e3ef64a)){
        let result = service(state, lineStart, lineEnd);
        if (result) return result;
    }
    return $deda11ebd5d0815e$var$syntaxFolding(state, lineStart, lineEnd);
}
function $deda11ebd5d0815e$var$mapRange(range, mapping) {
    let from = mapping.mapPos(range.from, 1), to = mapping.mapPos(range.to, -1);
    return from >= to ? undefined : {
        from: from,
        to: to
    };
}
/**
State effect that can be attached to a transaction to fold the
given range. (You probably only need this in exceptional
circumstances—usually you'll just want to let
[`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode) and the [fold
gutter](https://codemirror.net/6/docs/ref/#language.foldGutter) create the transactions.)
*/ const $deda11ebd5d0815e$export$a123efe007ad265 = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define({
    map: $deda11ebd5d0815e$var$mapRange
});
/**
State effect that unfolds the given range (if it was folded).
*/ const $deda11ebd5d0815e$export$bf2507dc398fc1ab = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define({
    map: $deda11ebd5d0815e$var$mapRange
});
function $deda11ebd5d0815e$var$selectedLines(view) {
    let lines = [];
    for (let { head: head } of view.state.selection.ranges){
        if (lines.some((l)=>l.from <= head && l.to >= head)) continue;
        lines.push(view.lineBlockAt(head));
    }
    return lines;
}
/**
The state field that stores the folded ranges (as a [decoration
set](https://codemirror.net/6/docs/ref/#view.DecorationSet)). Can be passed to
[`EditorState.toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) and
[`fromJSON`](https://codemirror.net/6/docs/ref/#state.EditorState^fromJSON) to serialize the fold
state.
*/ const $deda11ebd5d0815e$export$6955fe1f7c578abb = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$34381b1ce2130245).define({
    create () {
        return (0, $1d528cc0e08a0656$export$10e30b733df217ea).none;
    },
    update (folded, tr) {
        if (tr.isUserEvent("delete")) tr.changes.iterChangedRanges((fromA, toA)=>folded = $deda11ebd5d0815e$var$clearTouchedFolds(folded, fromA, toA));
        folded = folded.map(tr.changes);
        for (let e of tr.effects){
            if (e.is($deda11ebd5d0815e$export$a123efe007ad265) && !$deda11ebd5d0815e$var$foldExists(folded, e.value.from, e.value.to)) {
                let { preparePlaceholder: preparePlaceholder } = tr.state.facet($deda11ebd5d0815e$var$foldConfig);
                let widget = !preparePlaceholder ? $deda11ebd5d0815e$var$foldWidget : (0, $1d528cc0e08a0656$export$10e30b733df217ea).replace({
                    widget: new $deda11ebd5d0815e$var$PreparedFoldWidget(preparePlaceholder(tr.state, e.value))
                });
                folded = folded.update({
                    add: [
                        widget.range(e.value.from, e.value.to)
                    ]
                });
            } else if (e.is($deda11ebd5d0815e$export$bf2507dc398fc1ab)) folded = folded.update({
                filter: (from, to)=>e.value.from != from || e.value.to != to,
                filterFrom: e.value.from,
                filterTo: e.value.to
            });
        }
        // Clear folded ranges that cover the selection head
        if (tr.selection) folded = $deda11ebd5d0815e$var$clearTouchedFolds(folded, tr.selection.main.head);
        return folded;
    },
    provide: (f)=>(0, $1d528cc0e08a0656$export$eece2fccabbb77c5).decorations.from(f),
    toJSON (folded, state) {
        let ranges = [];
        folded.between(0, state.doc.length, (from, to)=>{
            ranges.push(from, to);
        });
        return ranges;
    },
    fromJSON (value) {
        if (!Array.isArray(value) || value.length % 2) throw new RangeError("Invalid JSON for fold state");
        let ranges = [];
        for(let i = 0; i < value.length;){
            let from = value[i++], to = value[i++];
            if (typeof from != "number" || typeof to != "number") throw new RangeError("Invalid JSON for fold state");
            ranges.push($deda11ebd5d0815e$var$foldWidget.range(from, to));
        }
        return (0, $1d528cc0e08a0656$export$10e30b733df217ea).set(ranges, true);
    }
});
function $deda11ebd5d0815e$var$clearTouchedFolds(folded, from, to = from) {
    let touched = false;
    folded.between(from, to, (a, b)=>{
        if (a < to && b > from) touched = true;
    });
    return !touched ? folded : folded.update({
        filterFrom: from,
        filterTo: to,
        filter: (a, b)=>a >= to || b <= from
    });
}
/**
Get a [range set](https://codemirror.net/6/docs/ref/#state.RangeSet) containing the folded ranges
in the given state.
*/ function $deda11ebd5d0815e$export$2b3c199812391e05(state) {
    return state.field($deda11ebd5d0815e$export$6955fe1f7c578abb, false) || (0, $6b8f387faea0a4dd$export$34cb5241245008dd).empty;
}
function $deda11ebd5d0815e$var$findFold(state, from, to) {
    var _a;
    let found = null;
    (_a = state.field($deda11ebd5d0815e$export$6955fe1f7c578abb, false)) === null || _a === void 0 || _a.between(from, to, (from, to)=>{
        if (!found || found.from > from) found = {
            from: from,
            to: to
        };
    });
    return found;
}
function $deda11ebd5d0815e$var$foldExists(folded, from, to) {
    let found = false;
    folded.between(from, from, (a, b)=>{
        if (a == from && b == to) found = true;
    });
    return found;
}
function $deda11ebd5d0815e$var$maybeEnable(state, other) {
    return state.field($deda11ebd5d0815e$export$6955fe1f7c578abb, false) ? other : other.concat((0, $6b8f387faea0a4dd$export$95000d4efaa4321f).appendConfig.of($deda11ebd5d0815e$export$2c875b83a85d0f31()));
}
/**
Fold the lines that are selected, if possible.
*/ const $deda11ebd5d0815e$export$52e96be2adbea02a = (view)=>{
    for (let line of $deda11ebd5d0815e$var$selectedLines(view)){
        let range = $deda11ebd5d0815e$export$cbe8a3d55245b07d(view.state, line.from, line.to);
        if (range) {
            view.dispatch({
                effects: $deda11ebd5d0815e$var$maybeEnable(view.state, [
                    $deda11ebd5d0815e$export$a123efe007ad265.of(range),
                    $deda11ebd5d0815e$var$announceFold(view, range)
                ])
            });
            return true;
        }
    }
    return false;
};
/**
Unfold folded ranges on selected lines.
*/ const $deda11ebd5d0815e$export$f4cd5e9f2c073861 = (view)=>{
    if (!view.state.field($deda11ebd5d0815e$export$6955fe1f7c578abb, false)) return false;
    let effects = [];
    for (let line of $deda11ebd5d0815e$var$selectedLines(view)){
        let folded = $deda11ebd5d0815e$var$findFold(view.state, line.from, line.to);
        if (folded) effects.push($deda11ebd5d0815e$export$bf2507dc398fc1ab.of(folded), $deda11ebd5d0815e$var$announceFold(view, folded, false));
    }
    if (effects.length) view.dispatch({
        effects: effects
    });
    return effects.length > 0;
};
function $deda11ebd5d0815e$var$announceFold(view, range, fold = true) {
    let lineFrom = view.state.doc.lineAt(range.from).number, lineTo = view.state.doc.lineAt(range.to).number;
    return (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).announce.of(`${view.state.phrase(fold ? "Folded lines" : "Unfolded lines")} ${lineFrom} ${view.state.phrase("to")} ${lineTo}.`);
}
/**
Fold all top-level foldable ranges. Note that, in most cases,
folding information will depend on the [syntax
tree](https://codemirror.net/6/docs/ref/#language.syntaxTree), and folding everything may not work
reliably when the document hasn't been fully parsed (either
because the editor state was only just initialized, or because the
document is so big that the parser decided not to parse it
entirely).
*/ const $deda11ebd5d0815e$export$5396d9eaf1c0ba76 = (view)=>{
    let { state: state } = view, effects = [];
    for(let pos = 0; pos < state.doc.length;){
        let line = view.lineBlockAt(pos), range = $deda11ebd5d0815e$export$cbe8a3d55245b07d(state, line.from, line.to);
        if (range) effects.push($deda11ebd5d0815e$export$a123efe007ad265.of(range));
        pos = (range ? view.lineBlockAt(range.to) : line).to + 1;
    }
    if (effects.length) view.dispatch({
        effects: $deda11ebd5d0815e$var$maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Unfold all folded code.
*/ const $deda11ebd5d0815e$export$5671b24df569b27d = (view)=>{
    let field = view.state.field($deda11ebd5d0815e$export$6955fe1f7c578abb, false);
    if (!field || !field.size) return false;
    let effects = [];
    field.between(0, view.state.doc.length, (from, to)=>{
        effects.push($deda11ebd5d0815e$export$bf2507dc398fc1ab.of({
            from: from,
            to: to
        }));
    });
    view.dispatch({
        effects: effects
    });
    return true;
};
// Find the foldable region containing the given line, if one exists
function $deda11ebd5d0815e$var$foldableContainer(view, lineBlock) {
    // Look backwards through line blocks until we find a foldable region that
    // intersects with the line
    for(let line = lineBlock;;){
        let foldableRegion = $deda11ebd5d0815e$export$cbe8a3d55245b07d(view.state, line.from, line.to);
        if (foldableRegion && foldableRegion.to > lineBlock.from) return foldableRegion;
        if (!line.from) return null;
        line = view.lineBlockAt(line.from - 1);
    }
}
/**
Toggle folding at cursors. Unfolds if there is an existing fold
starting in that line, tries to find a foldable range around it
otherwise.
*/ const $deda11ebd5d0815e$export$b23e83f59d68c8f1 = (view)=>{
    let effects = [];
    for (let line of $deda11ebd5d0815e$var$selectedLines(view)){
        let folded = $deda11ebd5d0815e$var$findFold(view.state, line.from, line.to);
        if (folded) effects.push($deda11ebd5d0815e$export$bf2507dc398fc1ab.of(folded), $deda11ebd5d0815e$var$announceFold(view, folded, false));
        else {
            let foldRange = $deda11ebd5d0815e$var$foldableContainer(view, line);
            if (foldRange) effects.push($deda11ebd5d0815e$export$a123efe007ad265.of(foldRange), $deda11ebd5d0815e$var$announceFold(view, foldRange));
        }
    }
    if (effects.length > 0) view.dispatch({
        effects: $deda11ebd5d0815e$var$maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Default fold-related key bindings.

 - Ctrl-Shift-[ (Cmd-Alt-[ on macOS): [`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode).
 - Ctrl-Shift-] (Cmd-Alt-] on macOS): [`unfoldCode`](https://codemirror.net/6/docs/ref/#language.unfoldCode).
 - Ctrl-Alt-[: [`foldAll`](https://codemirror.net/6/docs/ref/#language.foldAll).
 - Ctrl-Alt-]: [`unfoldAll`](https://codemirror.net/6/docs/ref/#language.unfoldAll).
*/ const $deda11ebd5d0815e$export$39c52376a8936d67 = [
    {
        key: "Ctrl-Shift-[",
        mac: "Cmd-Alt-[",
        run: $deda11ebd5d0815e$export$52e96be2adbea02a
    },
    {
        key: "Ctrl-Shift-]",
        mac: "Cmd-Alt-]",
        run: $deda11ebd5d0815e$export$f4cd5e9f2c073861
    },
    {
        key: "Ctrl-Alt-[",
        run: $deda11ebd5d0815e$export$5396d9eaf1c0ba76
    },
    {
        key: "Ctrl-Alt-]",
        run: $deda11ebd5d0815e$export$5671b24df569b27d
    }
];
const $deda11ebd5d0815e$var$defaultConfig = {
    placeholderDOM: null,
    preparePlaceholder: null,
    placeholderText: "\u2026"
};
const $deda11ebd5d0815e$var$foldConfig = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine (values) {
        return (0, $6b8f387faea0a4dd$export$4e19c0b693794a7e)(values, $deda11ebd5d0815e$var$defaultConfig);
    }
});
/**
Create an extension that configures code folding.
*/ function $deda11ebd5d0815e$export$2c875b83a85d0f31(config) {
    let result = [
        $deda11ebd5d0815e$export$6955fe1f7c578abb,
        $deda11ebd5d0815e$var$baseTheme$1
    ];
    if (config) result.push($deda11ebd5d0815e$var$foldConfig.of(config));
    return result;
}
function $deda11ebd5d0815e$var$widgetToDOM(view, prepared) {
    let { state: state } = view, conf = state.facet($deda11ebd5d0815e$var$foldConfig);
    let onclick = (event)=>{
        let line = view.lineBlockAt(view.posAtDOM(event.target));
        let folded = $deda11ebd5d0815e$var$findFold(view.state, line.from, line.to);
        if (folded) view.dispatch({
            effects: $deda11ebd5d0815e$export$bf2507dc398fc1ab.of(folded)
        });
        event.preventDefault();
    };
    if (conf.placeholderDOM) return conf.placeholderDOM(view, onclick, prepared);
    let element = document.createElement("span");
    element.textContent = conf.placeholderText;
    element.setAttribute("aria-label", state.phrase("folded code"));
    element.title = state.phrase("unfold");
    element.className = "cm-foldPlaceholder";
    element.onclick = onclick;
    return element;
}
const $deda11ebd5d0815e$var$foldWidget = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$10e30b733df217ea).replace({
    widget: /*@__PURE__*/ new class extends (0, $1d528cc0e08a0656$export$95cdd842edb044c5) {
        toDOM(view) {
            return $deda11ebd5d0815e$var$widgetToDOM(view, null);
        }
    }
});
class $deda11ebd5d0815e$var$PreparedFoldWidget extends (0, $1d528cc0e08a0656$export$95cdd842edb044c5) {
    constructor(value){
        super();
        this.value = value;
    }
    eq(other) {
        return this.value == other.value;
    }
    toDOM(view) {
        return $deda11ebd5d0815e$var$widgetToDOM(view, this.value);
    }
}
const $deda11ebd5d0815e$var$foldGutterDefaults = {
    openText: "\u2304",
    closedText: "\u203A",
    markerDOM: null,
    domEventHandlers: {},
    foldingChanged: ()=>false
};
class $deda11ebd5d0815e$var$FoldMarker extends (0, $1d528cc0e08a0656$export$591ab4c909549043) {
    constructor(config, open){
        super();
        this.config = config;
        this.open = open;
    }
    eq(other) {
        return this.config == other.config && this.open == other.open;
    }
    toDOM(view) {
        if (this.config.markerDOM) return this.config.markerDOM(this.open);
        let span = document.createElement("span");
        span.textContent = this.open ? this.config.openText : this.config.closedText;
        span.title = view.state.phrase(this.open ? "Fold line" : "Unfold line");
        return span;
    }
}
/**
Create an extension that registers a fold gutter, which shows a
fold status indicator before foldable lines (which can be clicked
to fold or unfold the line).
*/ function $deda11ebd5d0815e$export$c4dcf64f741b6228(config = {}) {
    let fullConfig = {
        ...$deda11ebd5d0815e$var$foldGutterDefaults,
        ...config
    };
    let canFold = new $deda11ebd5d0815e$var$FoldMarker(fullConfig, true), canUnfold = new $deda11ebd5d0815e$var$FoldMarker(fullConfig, false);
    let markers = (0, $1d528cc0e08a0656$export$44d5eccfd62adda7).fromClass(class {
        constructor(view){
            this.from = view.viewport.from;
            this.markers = this.buildMarkers(view);
        }
        update(update) {
            if (update.docChanged || update.viewportChanged || update.startState.facet($deda11ebd5d0815e$export$789c912f57fe164c) != update.state.facet($deda11ebd5d0815e$export$789c912f57fe164c) || update.startState.field($deda11ebd5d0815e$export$6955fe1f7c578abb, false) != update.state.field($deda11ebd5d0815e$export$6955fe1f7c578abb, false) || $deda11ebd5d0815e$export$7fc98e56a4ca6be1(update.startState) != $deda11ebd5d0815e$export$7fc98e56a4ca6be1(update.state) || fullConfig.foldingChanged(update)) this.markers = this.buildMarkers(update.view);
        }
        buildMarkers(view) {
            let builder = new (0, $6b8f387faea0a4dd$export$89e09ce03c7e8594)();
            for (let line of view.viewportLineBlocks){
                let mark = $deda11ebd5d0815e$var$findFold(view.state, line.from, line.to) ? canUnfold : $deda11ebd5d0815e$export$cbe8a3d55245b07d(view.state, line.from, line.to) ? canFold : null;
                if (mark) builder.add(line.from, line.from, mark);
            }
            return builder.finish();
        }
    });
    let { domEventHandlers: domEventHandlers } = fullConfig;
    return [
        markers,
        (0, $1d528cc0e08a0656$export$f2b922cb4a245974)({
            class: "cm-foldGutter",
            markers (view) {
                var _a;
                return ((_a = view.plugin(markers)) === null || _a === void 0 ? void 0 : _a.markers) || (0, $6b8f387faea0a4dd$export$34cb5241245008dd).empty;
            },
            initialSpacer () {
                return new $deda11ebd5d0815e$var$FoldMarker(fullConfig, false);
            },
            domEventHandlers: {
                ...domEventHandlers,
                click: (view, line, event)=>{
                    if (domEventHandlers.click && domEventHandlers.click(view, line, event)) return true;
                    let folded = $deda11ebd5d0815e$var$findFold(view.state, line.from, line.to);
                    if (folded) {
                        view.dispatch({
                            effects: $deda11ebd5d0815e$export$bf2507dc398fc1ab.of(folded)
                        });
                        return true;
                    }
                    let range = $deda11ebd5d0815e$export$cbe8a3d55245b07d(view.state, line.from, line.to);
                    if (range) {
                        view.dispatch({
                            effects: $deda11ebd5d0815e$export$a123efe007ad265.of(range)
                        });
                        return true;
                    }
                    return false;
                }
            }
        }),
        $deda11ebd5d0815e$export$2c875b83a85d0f31()
    ];
}
const $deda11ebd5d0815e$var$baseTheme$1 = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).baseTheme({
    ".cm-foldPlaceholder": {
        backgroundColor: "#eee",
        border: "1px solid #ddd",
        color: "#888",
        borderRadius: ".2em",
        margin: "0 1px",
        padding: "0 1px",
        cursor: "pointer"
    },
    ".cm-foldGutter span": {
        padding: "0 1px",
        cursor: "pointer"
    }
});
/**
A highlight style associates CSS styles with higlighting
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag).
*/ class $deda11ebd5d0815e$export$4819f093bdd5b4a {
    constructor(/**
    The tag styles used to create this highlight style.
    */ specs, options){
        this.specs = specs;
        let modSpec;
        function def(spec) {
            let cls = (0, $efbdc34cfdde3fb8$export$b920c662d2efee20).newName();
            (modSpec || (modSpec = Object.create(null)))["." + cls] = spec;
            return cls;
        }
        const all = typeof options.all == "string" ? options.all : options.all ? def(options.all) : undefined;
        const scopeOpt = options.scope;
        this.scope = scopeOpt instanceof $deda11ebd5d0815e$export$ce4fe1c9e6520c1a ? (type)=>type.prop($deda11ebd5d0815e$export$27a2e78097f753f7) == scopeOpt.data : scopeOpt ? (type)=>type == scopeOpt : undefined;
        this.style = (0, $6b8758376c12ba5a$export$b7f6332ce20f80fb)(specs.map((style)=>({
                tag: style.tag,
                class: style.class || def(Object.assign({}, style, {
                    tag: null
                }))
            })), {
            all: all
        }).style;
        this.module = modSpec ? new (0, $efbdc34cfdde3fb8$export$b920c662d2efee20)(modSpec) : null;
        this.themeType = options.themeType;
    }
    /**
    Create a highlighter style that associates the given styles to
    the given tags. The specs must be objects that hold a style tag
    or array of tags in their `tag` property, and either a single
    `class` property providing a static CSS class (for highlighter
    that rely on external styling), or a
    [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
    set of CSS properties (which define the styling for those tags).
    
    The CSS rules created for a highlighter will be emitted in the
    order of the spec's properties. That means that for elements that
    have multiple tags associated with them, styles defined further
    down in the list will have a higher CSS precedence than styles
    defined earlier.
    */ static define(specs, options) {
        return new $deda11ebd5d0815e$export$4819f093bdd5b4a(specs, options || {});
    }
}
const $deda11ebd5d0815e$var$highlighterFacet = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
const $deda11ebd5d0815e$var$fallbackHighlighter = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine (values) {
        return values.length ? [
            values[0]
        ] : null;
    }
});
function $deda11ebd5d0815e$var$getHighlighters(state) {
    let main = state.facet($deda11ebd5d0815e$var$highlighterFacet);
    return main.length ? main : state.facet($deda11ebd5d0815e$var$fallbackHighlighter);
}
/**
Wrap a highlighter in an editor extension that uses it to apply
syntax highlighting to the editor content.

When multiple (non-fallback) styles are provided, the styling
applied is the union of the classes they emit.
*/ function $deda11ebd5d0815e$export$ec1b956ff3a16361(highlighter, options) {
    let ext = [
        $deda11ebd5d0815e$var$treeHighlighter
    ], themeType;
    if (highlighter instanceof $deda11ebd5d0815e$export$4819f093bdd5b4a) {
        if (highlighter.module) ext.push((0, $1d528cc0e08a0656$export$eece2fccabbb77c5).styleModule.of(highlighter.module));
        themeType = highlighter.themeType;
    }
    if (options === null || options === void 0 ? void 0 : options.fallback) ext.push($deda11ebd5d0815e$var$fallbackHighlighter.of(highlighter));
    else if (themeType) ext.push($deda11ebd5d0815e$var$highlighterFacet.computeN([
        (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).darkTheme
    ], (state)=>{
        return state.facet((0, $1d528cc0e08a0656$export$eece2fccabbb77c5).darkTheme) == (themeType == "dark") ? [
            highlighter
        ] : [];
    }));
    else ext.push($deda11ebd5d0815e$var$highlighterFacet.of(highlighter));
    return ext;
}
/**
Returns the CSS classes (if any) that the highlighters active in
the state would assign to the given style
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag) and
(optional) language
[scope](https://codemirror.net/6/docs/ref/#language.HighlightStyle^define^options.scope).
*/ function $deda11ebd5d0815e$export$8ca2b052028e8782(state, tags, scope) {
    let highlighters = $deda11ebd5d0815e$var$getHighlighters(state);
    let result = null;
    if (highlighters) {
        for (let highlighter of highlighters)if (!highlighter.scope || scope && highlighter.scope(scope)) {
            let cls = highlighter.style(tags);
            if (cls) result = result ? result + " " + cls : cls;
        }
    }
    return result;
}
class $deda11ebd5d0815e$var$TreeHighlighter {
    constructor(view){
        this.markCache = Object.create(null);
        this.tree = $deda11ebd5d0815e$export$7fc98e56a4ca6be1(view.state);
        this.decorations = this.buildDeco(view, $deda11ebd5d0815e$var$getHighlighters(view.state));
        this.decoratedTo = view.viewport.to;
    }
    update(update) {
        let tree = $deda11ebd5d0815e$export$7fc98e56a4ca6be1(update.state), highlighters = $deda11ebd5d0815e$var$getHighlighters(update.state);
        let styleChange = highlighters != $deda11ebd5d0815e$var$getHighlighters(update.startState);
        let { viewport: viewport } = update.view, decoratedToMapped = update.changes.mapPos(this.decoratedTo, 1);
        if (tree.length < viewport.to && !styleChange && tree.type == this.tree.type && decoratedToMapped >= viewport.to) {
            this.decorations = this.decorations.map(update.changes);
            this.decoratedTo = decoratedToMapped;
        } else if (tree != this.tree || update.viewportChanged || styleChange) {
            this.tree = tree;
            this.decorations = this.buildDeco(update.view, highlighters);
            this.decoratedTo = viewport.to;
        }
    }
    buildDeco(view, highlighters) {
        if (!highlighters || !this.tree.length) return (0, $1d528cc0e08a0656$export$10e30b733df217ea).none;
        let builder = new (0, $6b8f387faea0a4dd$export$89e09ce03c7e8594)();
        for (let { from: from, to: to } of view.visibleRanges)(0, $6b8758376c12ba5a$export$af82b3d076119fad)(this.tree, highlighters, (from, to, style)=>{
            builder.add(from, to, this.markCache[style] || (this.markCache[style] = (0, $1d528cc0e08a0656$export$10e30b733df217ea).mark({
                class: style
            })));
        }, from, to);
        return builder.finish();
    }
}
const $deda11ebd5d0815e$var$treeHighlighter = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$b92464a736444411).high(/*@__PURE__*/ (0, $1d528cc0e08a0656$export$44d5eccfd62adda7).fromClass($deda11ebd5d0815e$var$TreeHighlighter, {
    decorations: (v)=>v.decorations
}));
/**
A default highlight style (works well with light themes).
*/ const $deda11ebd5d0815e$export$bb02a6818dd48320 = /*@__PURE__*/ $deda11ebd5d0815e$export$4819f093bdd5b4a.define([
    {
        tag: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).meta,
        color: "#404740"
    },
    {
        tag: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).link,
        textDecoration: "underline"
    },
    {
        tag: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).heading,
        textDecoration: "underline",
        fontWeight: "bold"
    },
    {
        tag: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).emphasis,
        fontStyle: "italic"
    },
    {
        tag: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).strong,
        fontWeight: "bold"
    },
    {
        tag: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).strikethrough,
        textDecoration: "line-through"
    },
    {
        tag: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).keyword,
        color: "#708"
    },
    {
        tag: [
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).atom,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).bool,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).url,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).contentSeparator,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).labelName
        ],
        color: "#219"
    },
    {
        tag: [
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).literal,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).inserted
        ],
        color: "#164"
    },
    {
        tag: [
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).string,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).deleted
        ],
        color: "#a11"
    },
    {
        tag: [
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).regexp,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).escape,
            /*@__PURE__*/ (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).special((0, $6b8758376c12ba5a$export$8b7a896ae75accbf).string)
        ],
        color: "#e40"
    },
    {
        tag: /*@__PURE__*/ (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).definition((0, $6b8758376c12ba5a$export$8b7a896ae75accbf).variableName),
        color: "#00f"
    },
    {
        tag: /*@__PURE__*/ (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).local((0, $6b8758376c12ba5a$export$8b7a896ae75accbf).variableName),
        color: "#30a"
    },
    {
        tag: [
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).typeName,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).namespace
        ],
        color: "#085"
    },
    {
        tag: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).className,
        color: "#167"
    },
    {
        tag: [
            /*@__PURE__*/ (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).special((0, $6b8758376c12ba5a$export$8b7a896ae75accbf).variableName),
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).macroName
        ],
        color: "#256"
    },
    {
        tag: /*@__PURE__*/ (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).definition((0, $6b8758376c12ba5a$export$8b7a896ae75accbf).propertyName),
        color: "#00c"
    },
    {
        tag: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).comment,
        color: "#940"
    },
    {
        tag: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).invalid,
        color: "#f00"
    }
]);
const $deda11ebd5d0815e$var$baseTheme = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).baseTheme({
    "&.cm-focused .cm-matchingBracket": {
        backgroundColor: "#328c8252"
    },
    "&.cm-focused .cm-nonmatchingBracket": {
        backgroundColor: "#bb555544"
    }
});
const $deda11ebd5d0815e$var$DefaultScanDist = 10000, $deda11ebd5d0815e$var$DefaultBrackets = "()[]{}";
const $deda11ebd5d0815e$var$bracketMatchingConfig = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6b8f387faea0a4dd$export$4e19c0b693794a7e)(configs, {
            afterCursor: true,
            brackets: $deda11ebd5d0815e$var$DefaultBrackets,
            maxScanDistance: $deda11ebd5d0815e$var$DefaultScanDist,
            renderMatch: $deda11ebd5d0815e$var$defaultRenderMatch
        });
    }
});
const $deda11ebd5d0815e$var$matchingMark = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$10e30b733df217ea).mark({
    class: "cm-matchingBracket"
}), $deda11ebd5d0815e$var$nonmatchingMark = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$10e30b733df217ea).mark({
    class: "cm-nonmatchingBracket"
});
function $deda11ebd5d0815e$var$defaultRenderMatch(match) {
    let decorations = [];
    let mark = match.matched ? $deda11ebd5d0815e$var$matchingMark : $deda11ebd5d0815e$var$nonmatchingMark;
    decorations.push(mark.range(match.start.from, match.start.to));
    if (match.end) decorations.push(mark.range(match.end.from, match.end.to));
    return decorations;
}
const $deda11ebd5d0815e$var$bracketMatchingState = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$34381b1ce2130245).define({
    create () {
        return (0, $1d528cc0e08a0656$export$10e30b733df217ea).none;
    },
    update (deco, tr) {
        if (!tr.docChanged && !tr.selection) return deco;
        let decorations = [];
        let config = tr.state.facet($deda11ebd5d0815e$var$bracketMatchingConfig);
        for (let range of tr.state.selection.ranges){
            if (!range.empty) continue;
            let match = $deda11ebd5d0815e$export$3391942603e90cda(tr.state, range.head, -1, config) || range.head > 0 && $deda11ebd5d0815e$export$3391942603e90cda(tr.state, range.head - 1, 1, config) || config.afterCursor && ($deda11ebd5d0815e$export$3391942603e90cda(tr.state, range.head, 1, config) || range.head < tr.state.doc.length && $deda11ebd5d0815e$export$3391942603e90cda(tr.state, range.head + 1, -1, config));
            if (match) decorations = decorations.concat(config.renderMatch(match, tr.state));
        }
        return (0, $1d528cc0e08a0656$export$10e30b733df217ea).set(decorations, true);
    },
    provide: (f)=>(0, $1d528cc0e08a0656$export$eece2fccabbb77c5).decorations.from(f)
});
const $deda11ebd5d0815e$var$bracketMatchingUnique = [
    $deda11ebd5d0815e$var$bracketMatchingState,
    $deda11ebd5d0815e$var$baseTheme
];
/**
Create an extension that enables bracket matching. Whenever the
cursor is next to a bracket, that bracket and the one it matches
are highlighted. Or, when no matching bracket is found, another
highlighting style is used to indicate this.
*/ function $deda11ebd5d0815e$export$cef7edfd214be605(config = {}) {
    return [
        $deda11ebd5d0815e$var$bracketMatchingConfig.of(config),
        $deda11ebd5d0815e$var$bracketMatchingUnique
    ];
}
/**
When larger syntax nodes, such as HTML tags, are marked as
opening/closing, it can be a bit messy to treat the whole node as
a matchable bracket. This node prop allows you to define, for such
a node, a ‘handle’—the part of the node that is highlighted, and
that the cursor must be on to activate highlighting in the first
place.
*/ const $deda11ebd5d0815e$export$ca7d74cd5b9f1011 = /*@__PURE__*/ new (0, $a7a41eb5193c1110$export$b8034b9bc18acd90)();
function $deda11ebd5d0815e$var$matchingNodes(node, dir, brackets) {
    let byProp = node.prop(dir < 0 ? (0, $a7a41eb5193c1110$export$b8034b9bc18acd90).openedBy : (0, $a7a41eb5193c1110$export$b8034b9bc18acd90).closedBy);
    if (byProp) return byProp;
    if (node.name.length == 1) {
        let index = brackets.indexOf(node.name);
        if (index > -1 && index % 2 == (dir < 0 ? 1 : 0)) return [
            brackets[index + dir]
        ];
    }
    return null;
}
function $deda11ebd5d0815e$var$findHandle(node) {
    let hasHandle = node.type.prop($deda11ebd5d0815e$export$ca7d74cd5b9f1011);
    return hasHandle ? hasHandle(node.node) : node;
}
/**
Find the matching bracket for the token at `pos`, scanning
direction `dir`. Only the `brackets` and `maxScanDistance`
properties are used from `config`, if given. Returns null if no
bracket was found at `pos`, or a match result otherwise.
*/ function $deda11ebd5d0815e$export$3391942603e90cda(state, pos, dir, config = {}) {
    let maxScanDistance = config.maxScanDistance || $deda11ebd5d0815e$var$DefaultScanDist, brackets = config.brackets || $deda11ebd5d0815e$var$DefaultBrackets;
    let tree = $deda11ebd5d0815e$export$7fc98e56a4ca6be1(state), node = tree.resolveInner(pos, dir);
    for(let cur = node; cur; cur = cur.parent){
        let matches = $deda11ebd5d0815e$var$matchingNodes(cur.type, dir, brackets);
        if (matches && cur.from < cur.to) {
            let handle = $deda11ebd5d0815e$var$findHandle(cur);
            if (handle && (dir > 0 ? pos >= handle.from && pos < handle.to : pos > handle.from && pos <= handle.to)) return $deda11ebd5d0815e$var$matchMarkedBrackets(state, pos, dir, cur, handle, matches, brackets);
        }
    }
    return $deda11ebd5d0815e$var$matchPlainBrackets(state, pos, dir, tree, node.type, maxScanDistance, brackets);
}
function $deda11ebd5d0815e$var$matchMarkedBrackets(_state, _pos, dir, token, handle, matching, brackets) {
    let parent = token.parent, firstToken = {
        from: handle.from,
        to: handle.to
    };
    let depth = 0, cursor = parent === null || parent === void 0 ? void 0 : parent.cursor();
    if (cursor && (dir < 0 ? cursor.childBefore(token.from) : cursor.childAfter(token.to))) do if (dir < 0 ? cursor.to <= token.from : cursor.from >= token.to) {
        if (depth == 0 && matching.indexOf(cursor.type.name) > -1 && cursor.from < cursor.to) {
            let endHandle = $deda11ebd5d0815e$var$findHandle(cursor);
            return {
                start: firstToken,
                end: endHandle ? {
                    from: endHandle.from,
                    to: endHandle.to
                } : undefined,
                matched: true
            };
        } else if ($deda11ebd5d0815e$var$matchingNodes(cursor.type, dir, brackets)) depth++;
        else if ($deda11ebd5d0815e$var$matchingNodes(cursor.type, -dir, brackets)) {
            if (depth == 0) {
                let endHandle = $deda11ebd5d0815e$var$findHandle(cursor);
                return {
                    start: firstToken,
                    end: endHandle && endHandle.from < endHandle.to ? {
                        from: endHandle.from,
                        to: endHandle.to
                    } : undefined,
                    matched: false
                };
            }
            depth--;
        }
    }
    while (dir < 0 ? cursor.prevSibling() : cursor.nextSibling());
    return {
        start: firstToken,
        matched: false
    };
}
function $deda11ebd5d0815e$var$matchPlainBrackets(state, pos, dir, tree, tokenType, maxScanDistance, brackets) {
    let startCh = dir < 0 ? state.sliceDoc(pos - 1, pos) : state.sliceDoc(pos, pos + 1);
    let bracket = brackets.indexOf(startCh);
    if (bracket < 0 || bracket % 2 == 0 != dir > 0) return null;
    let startToken = {
        from: dir < 0 ? pos - 1 : pos,
        to: dir > 0 ? pos + 1 : pos
    };
    let iter = state.doc.iterRange(pos, dir > 0 ? state.doc.length : 0), depth = 0;
    for(let distance = 0; !iter.next().done && distance <= maxScanDistance;){
        let text = iter.value;
        if (dir < 0) distance += text.length;
        let basePos = pos + distance * dir;
        for(let pos = dir > 0 ? 0 : text.length - 1, end = dir > 0 ? text.length : -1; pos != end; pos += dir){
            let found = brackets.indexOf(text[pos]);
            if (found < 0 || tree.resolveInner(basePos + pos, 1).type != tokenType) continue;
            if (found % 2 == 0 == dir > 0) depth++;
            else if (depth == 1) return {
                start: startToken,
                end: {
                    from: basePos + pos,
                    to: basePos + pos + 1
                },
                matched: found >> 1 == bracket >> 1
            };
            else depth--;
        }
        if (dir > 0) distance += text.length;
    }
    return iter.done ? {
        start: startToken,
        matched: false
    } : null;
}
// Counts the column offset in a string, taking tabs into account.
// Used mostly to find indentation.
function $deda11ebd5d0815e$var$countCol(string, end, tabSize, startIndex = 0, startValue = 0) {
    if (end == null) {
        end = string.search(/[^\s\u00a0]/);
        if (end == -1) end = string.length;
    }
    let n = startValue;
    for(let i = startIndex; i < end; i++)if (string.charCodeAt(i) == 9) n += tabSize - n % tabSize;
    else n++;
    return n;
}
/**
Encapsulates a single line of input. Given to stream syntax code,
which uses it to tokenize the content.
*/ class $deda11ebd5d0815e$export$72a09304cc8c1940 {
    /**
    Create a stream.
    */ constructor(/**
    The line.
    */ string, tabSize, /**
    The current indent unit size.
    */ indentUnit, overrideIndent){
        this.string = string;
        this.tabSize = tabSize;
        this.indentUnit = indentUnit;
        this.overrideIndent = overrideIndent;
        /**
        The current position on the line.
        */ this.pos = 0;
        /**
        The start position of the current token.
        */ this.start = 0;
        this.lastColumnPos = 0;
        this.lastColumnValue = 0;
    }
    /**
    True if we are at the end of the line.
    */ eol() {
        return this.pos >= this.string.length;
    }
    /**
    True if we are at the start of the line.
    */ sol() {
        return this.pos == 0;
    }
    /**
    Get the next code unit after the current position, or undefined
    if we're at the end of the line.
    */ peek() {
        return this.string.charAt(this.pos) || undefined;
    }
    /**
    Read the next code unit and advance `this.pos`.
    */ next() {
        if (this.pos < this.string.length) return this.string.charAt(this.pos++);
    }
    /**
    Match the next character against the given string, regular
    expression, or predicate. Consume and return it if it matches.
    */ eat(match) {
        let ch = this.string.charAt(this.pos);
        let ok;
        if (typeof match == "string") ok = ch == match;
        else ok = ch && (match instanceof RegExp ? match.test(ch) : match(ch));
        if (ok) {
            ++this.pos;
            return ch;
        }
    }
    /**
    Continue matching characters that match the given string,
    regular expression, or predicate function. Return true if any
    characters were consumed.
    */ eatWhile(match) {
        let start = this.pos;
        while(this.eat(match));
        return this.pos > start;
    }
    /**
    Consume whitespace ahead of `this.pos`. Return true if any was
    found.
    */ eatSpace() {
        let start = this.pos;
        while(/[\s\u00a0]/.test(this.string.charAt(this.pos)))++this.pos;
        return this.pos > start;
    }
    /**
    Move to the end of the line.
    */ skipToEnd() {
        this.pos = this.string.length;
    }
    /**
    Move to directly before the given character, if found on the
    current line.
    */ skipTo(ch) {
        let found = this.string.indexOf(ch, this.pos);
        if (found > -1) {
            this.pos = found;
            return true;
        }
    }
    /**
    Move back `n` characters.
    */ backUp(n) {
        this.pos -= n;
    }
    /**
    Get the column position at `this.pos`.
    */ column() {
        if (this.lastColumnPos < this.start) {
            this.lastColumnValue = $deda11ebd5d0815e$var$countCol(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
            this.lastColumnPos = this.start;
        }
        return this.lastColumnValue;
    }
    /**
    Get the indentation column of the current line.
    */ indentation() {
        var _a;
        return (_a = this.overrideIndent) !== null && _a !== void 0 ? _a : $deda11ebd5d0815e$var$countCol(this.string, null, this.tabSize);
    }
    /**
    Match the input against the given string or regular expression
    (which should start with a `^`). Return true or the regexp match
    if it matches.
    
    Unless `consume` is set to `false`, this will move `this.pos`
    past the matched text.
    
    When matching a string `caseInsensitive` can be set to true to
    make the match case-insensitive.
    */ match(pattern, consume, caseInsensitive) {
        if (typeof pattern == "string") {
            let cased = (str)=>caseInsensitive ? str.toLowerCase() : str;
            let substr = this.string.substr(this.pos, pattern.length);
            if (cased(substr) == cased(pattern)) {
                if (consume !== false) this.pos += pattern.length;
                return true;
            } else return null;
        } else {
            let match = this.string.slice(this.pos).match(pattern);
            if (match && match.index > 0) return null;
            if (match && consume !== false) this.pos += match[0].length;
            return match;
        }
    }
    /**
    Get the current token.
    */ current() {
        return this.string.slice(this.start, this.pos);
    }
}
function $deda11ebd5d0815e$var$fullParser(spec) {
    return {
        name: spec.name || "",
        token: spec.token,
        blankLine: spec.blankLine || (()=>{}),
        startState: spec.startState || (()=>true),
        copyState: spec.copyState || $deda11ebd5d0815e$var$defaultCopyState,
        indent: spec.indent || (()=>null),
        languageData: spec.languageData || {},
        tokenTable: spec.tokenTable || $deda11ebd5d0815e$var$noTokens,
        mergeTokens: spec.mergeTokens !== false
    };
}
function $deda11ebd5d0815e$var$defaultCopyState(state) {
    if (typeof state != "object") return state;
    let newState = {};
    for(let prop in state){
        let val = state[prop];
        newState[prop] = val instanceof Array ? val.slice() : val;
    }
    return newState;
}
const $deda11ebd5d0815e$var$IndentedFrom = /*@__PURE__*/ new WeakMap();
/**
A [language](https://codemirror.net/6/docs/ref/#language.Language) class based on a CodeMirror
5-style [streaming parser](https://codemirror.net/6/docs/ref/#language.StreamParser).
*/ class $deda11ebd5d0815e$export$5ee3cc23916207d8 extends $deda11ebd5d0815e$export$ce4fe1c9e6520c1a {
    constructor(parser){
        let data = $deda11ebd5d0815e$export$b57f683f43553b99(parser.languageData);
        let p = $deda11ebd5d0815e$var$fullParser(parser), self;
        let impl = new class extends (0, $a7a41eb5193c1110$export$7acfa6ed01010e37) {
            createParse(input, fragments, ranges) {
                return new $deda11ebd5d0815e$var$Parse(self, input, fragments, ranges);
            }
        };
        super(data, impl, [], parser.name);
        this.topNode = $deda11ebd5d0815e$var$docID(data, this);
        self = this;
        this.streamParser = p;
        this.stateAfter = new (0, $a7a41eb5193c1110$export$b8034b9bc18acd90)({
            perNode: true
        });
        this.tokenTable = parser.tokenTable ? new $deda11ebd5d0815e$var$TokenTable(p.tokenTable) : $deda11ebd5d0815e$var$defaultTokenTable;
    }
    /**
    Define a stream language.
    */ static define(spec) {
        return new $deda11ebd5d0815e$export$5ee3cc23916207d8(spec);
    }
    /**
    @internal
    */ getIndent(cx) {
        let from = undefined;
        let { overrideIndentation: overrideIndentation } = cx.options;
        if (overrideIndentation) {
            from = $deda11ebd5d0815e$var$IndentedFrom.get(cx.state);
            if (from != null && from < cx.pos - 1e4) from = undefined;
        }
        let start = $deda11ebd5d0815e$var$findState(this, cx.node.tree, cx.node.from, cx.node.from, from !== null && from !== void 0 ? from : cx.pos), statePos, state;
        if (start) {
            state = start.state;
            statePos = start.pos + 1;
        } else {
            state = this.streamParser.startState(cx.unit);
            statePos = cx.node.from;
        }
        if (cx.pos - statePos > 10000 /* C.MaxIndentScanDist */ ) return null;
        while(statePos < cx.pos){
            let line = cx.state.doc.lineAt(statePos), end = Math.min(cx.pos, line.to);
            if (line.length) {
                let indentation = overrideIndentation ? overrideIndentation(line.from) : -1;
                let stream = new $deda11ebd5d0815e$export$72a09304cc8c1940(line.text, cx.state.tabSize, cx.unit, indentation < 0 ? undefined : indentation);
                while(stream.pos < end - line.from)$deda11ebd5d0815e$var$readToken(this.streamParser.token, stream, state);
            } else this.streamParser.blankLine(state, cx.unit);
            if (end == cx.pos) break;
            statePos = line.to + 1;
        }
        let line = cx.lineAt(cx.pos);
        if (overrideIndentation && from == null) $deda11ebd5d0815e$var$IndentedFrom.set(cx.state, line.from);
        return this.streamParser.indent(state, /^\s*(.*)/.exec(line.text)[1], cx);
    }
    get allowsNesting() {
        return false;
    }
}
function $deda11ebd5d0815e$var$findState(lang, tree, off, startPos, before) {
    let state = off >= startPos && off + tree.length <= before && tree.prop(lang.stateAfter);
    if (state) return {
        state: lang.streamParser.copyState(state),
        pos: off + tree.length
    };
    for(let i = tree.children.length - 1; i >= 0; i--){
        let child = tree.children[i], pos = off + tree.positions[i];
        let found = child instanceof (0, $a7a41eb5193c1110$export$7fbedc92909ed28e) && pos < before && $deda11ebd5d0815e$var$findState(lang, child, pos, startPos, before);
        if (found) return found;
    }
    return null;
}
function $deda11ebd5d0815e$var$cutTree(lang, tree, from, to, inside) {
    if (inside && from <= 0 && to >= tree.length) return tree;
    if (!inside && from == 0 && tree.type == lang.topNode) inside = true;
    for(let i = tree.children.length - 1; i >= 0; i--){
        let pos = tree.positions[i], child = tree.children[i], inner;
        if (pos < to && child instanceof (0, $a7a41eb5193c1110$export$7fbedc92909ed28e)) {
            if (!(inner = $deda11ebd5d0815e$var$cutTree(lang, child, from - pos, to - pos, inside))) break;
            return !inside ? inner : new (0, $a7a41eb5193c1110$export$7fbedc92909ed28e)(tree.type, tree.children.slice(0, i).concat(inner), tree.positions.slice(0, i + 1), pos + inner.length);
        }
    }
    return null;
}
function $deda11ebd5d0815e$var$findStartInFragments(lang, fragments, startPos, endPos, editorState) {
    for (let f of fragments){
        let from = f.from + (f.openStart ? 25 : 0), to = f.to - (f.openEnd ? 25 : 0);
        let found = from <= startPos && to > startPos && $deda11ebd5d0815e$var$findState(lang, f.tree, 0 - f.offset, startPos, to), tree;
        if (found && found.pos <= endPos && (tree = $deda11ebd5d0815e$var$cutTree(lang, f.tree, startPos + f.offset, found.pos + f.offset, false))) return {
            state: found.state,
            tree: tree
        };
    }
    return {
        state: lang.streamParser.startState(editorState ? $deda11ebd5d0815e$export$ad3205d09311a797(editorState) : 4),
        tree: (0, $a7a41eb5193c1110$export$7fbedc92909ed28e).empty
    };
}
class $deda11ebd5d0815e$var$Parse {
    constructor(lang, input, fragments, ranges){
        this.lang = lang;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.stoppedAt = null;
        this.chunks = [];
        this.chunkPos = [];
        this.chunk = [];
        this.chunkReused = undefined;
        this.rangeIndex = 0;
        this.to = ranges[ranges.length - 1].to;
        let context = $deda11ebd5d0815e$export$3fcb7c01ff2a41fa.get(), from = ranges[0].from;
        let { state: state, tree: tree } = $deda11ebd5d0815e$var$findStartInFragments(lang, fragments, from, this.to, context === null || context === void 0 ? void 0 : context.state);
        this.state = state;
        this.parsedPos = this.chunkStart = from + tree.length;
        for(let i = 0; i < tree.children.length; i++){
            this.chunks.push(tree.children[i]);
            this.chunkPos.push(tree.positions[i]);
        }
        if (context && this.parsedPos < context.viewport.from - 100000 /* C.MaxDistanceBeforeViewport */  && ranges.some((r)=>r.from <= context.viewport.from && r.to >= context.viewport.from)) {
            this.state = this.lang.streamParser.startState($deda11ebd5d0815e$export$ad3205d09311a797(context.state));
            context.skipUntilInView(this.parsedPos, context.viewport.from);
            this.parsedPos = context.viewport.from;
        }
        this.moveRangeIndex();
    }
    advance() {
        let context = $deda11ebd5d0815e$export$3fcb7c01ff2a41fa.get();
        let parseEnd = this.stoppedAt == null ? this.to : Math.min(this.to, this.stoppedAt);
        let end = Math.min(parseEnd, this.chunkStart + 2048 /* C.ChunkSize */ );
        if (context) end = Math.min(end, context.viewport.to);
        while(this.parsedPos < end)this.parseLine(context);
        if (this.chunkStart < this.parsedPos) this.finishChunk();
        if (this.parsedPos >= parseEnd) return this.finish();
        if (context && this.parsedPos >= context.viewport.to) {
            context.skipUntilInView(this.parsedPos, parseEnd);
            return this.finish();
        }
        return null;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
    }
    lineAfter(pos) {
        let chunk = this.input.chunk(pos);
        if (!this.input.lineChunks) {
            let eol = chunk.indexOf("\n");
            if (eol > -1) chunk = chunk.slice(0, eol);
        } else if (chunk == "\n") chunk = "";
        return pos + chunk.length <= this.to ? chunk : chunk.slice(0, this.to - pos);
    }
    nextLine() {
        let from = this.parsedPos, line = this.lineAfter(from), end = from + line.length;
        for(let index = this.rangeIndex;;){
            let rangeEnd = this.ranges[index].to;
            if (rangeEnd >= end) break;
            line = line.slice(0, rangeEnd - (end - line.length));
            index++;
            if (index == this.ranges.length) break;
            let rangeStart = this.ranges[index].from;
            let after = this.lineAfter(rangeStart);
            line += after;
            end = rangeStart + after.length;
        }
        return {
            line: line,
            end: end
        };
    }
    skipGapsTo(pos, offset, side) {
        for(;;){
            let end = this.ranges[this.rangeIndex].to, offPos = pos + offset;
            if (side > 0 ? end > offPos : end >= offPos) break;
            let start = this.ranges[++this.rangeIndex].from;
            offset += start - end;
        }
        return offset;
    }
    moveRangeIndex() {
        while(this.ranges[this.rangeIndex].to < this.parsedPos)this.rangeIndex++;
    }
    emitToken(id, from, to, offset) {
        let size = 4;
        if (this.ranges.length > 1) {
            offset = this.skipGapsTo(from, offset, 1);
            from += offset;
            let len0 = this.chunk.length;
            offset = this.skipGapsTo(to, offset, -1);
            to += offset;
            size += this.chunk.length - len0;
        }
        let last = this.chunk.length - 4;
        if (this.lang.streamParser.mergeTokens && size == 4 && last >= 0 && this.chunk[last] == id && this.chunk[last + 2] == from) this.chunk[last + 2] = to;
        else this.chunk.push(id, from, to, size);
        return offset;
    }
    parseLine(context) {
        let { line: line, end: end } = this.nextLine(), offset = 0, { streamParser: streamParser } = this.lang;
        let stream = new $deda11ebd5d0815e$export$72a09304cc8c1940(line, context ? context.state.tabSize : 4, context ? $deda11ebd5d0815e$export$ad3205d09311a797(context.state) : 2);
        if (stream.eol()) streamParser.blankLine(this.state, stream.indentUnit);
        else while(!stream.eol()){
            let token = $deda11ebd5d0815e$var$readToken(streamParser.token, stream, this.state);
            if (token) offset = this.emitToken(this.lang.tokenTable.resolve(token), this.parsedPos + stream.start, this.parsedPos + stream.pos, offset);
            if (stream.start > 10000 /* C.MaxLineLength */ ) break;
        }
        this.parsedPos = end;
        this.moveRangeIndex();
        if (this.parsedPos < this.to) this.parsedPos++;
    }
    finishChunk() {
        let tree = (0, $a7a41eb5193c1110$export$7fbedc92909ed28e).build({
            buffer: this.chunk,
            start: this.chunkStart,
            length: this.parsedPos - this.chunkStart,
            nodeSet: $deda11ebd5d0815e$var$nodeSet,
            topID: 0,
            maxBufferLength: 2048 /* C.ChunkSize */ ,
            reused: this.chunkReused
        });
        tree = new (0, $a7a41eb5193c1110$export$7fbedc92909ed28e)(tree.type, tree.children, tree.positions, tree.length, [
            [
                this.lang.stateAfter,
                this.lang.streamParser.copyState(this.state)
            ]
        ]);
        this.chunks.push(tree);
        this.chunkPos.push(this.chunkStart - this.ranges[0].from);
        this.chunk = [];
        this.chunkReused = undefined;
        this.chunkStart = this.parsedPos;
    }
    finish() {
        return new (0, $a7a41eb5193c1110$export$7fbedc92909ed28e)(this.lang.topNode, this.chunks, this.chunkPos, this.parsedPos - this.ranges[0].from).balance();
    }
}
function $deda11ebd5d0815e$var$readToken(token, stream, state) {
    stream.start = stream.pos;
    for(let i = 0; i < 10; i++){
        let result = token(stream, state);
        if (stream.pos > stream.start) return result;
    }
    throw new Error("Stream parser failed to advance stream.");
}
const $deda11ebd5d0815e$var$noTokens = /*@__PURE__*/ Object.create(null);
const $deda11ebd5d0815e$var$typeArray = [
    (0, $a7a41eb5193c1110$export$f06e977173f1857c).none
];
const $deda11ebd5d0815e$var$nodeSet = /*@__PURE__*/ new (0, $a7a41eb5193c1110$export$7fad5fb00d8de02c)($deda11ebd5d0815e$var$typeArray);
const $deda11ebd5d0815e$var$warned = [];
// Cache of node types by name and tags
const $deda11ebd5d0815e$var$byTag = /*@__PURE__*/ Object.create(null);
const $deda11ebd5d0815e$var$defaultTable = /*@__PURE__*/ Object.create(null);
for (let [legacyName, name] of [
    [
        "variable",
        "variableName"
    ],
    [
        "variable-2",
        "variableName.special"
    ],
    [
        "string-2",
        "string.special"
    ],
    [
        "def",
        "variableName.definition"
    ],
    [
        "tag",
        "tagName"
    ],
    [
        "attribute",
        "attributeName"
    ],
    [
        "type",
        "typeName"
    ],
    [
        "builtin",
        "variableName.standard"
    ],
    [
        "qualifier",
        "modifier"
    ],
    [
        "error",
        "invalid"
    ],
    [
        "header",
        "heading"
    ],
    [
        "property",
        "propertyName"
    ]
])$deda11ebd5d0815e$var$defaultTable[legacyName] = /*@__PURE__*/ $deda11ebd5d0815e$var$createTokenType($deda11ebd5d0815e$var$noTokens, name);
class $deda11ebd5d0815e$var$TokenTable {
    constructor(extra){
        this.extra = extra;
        this.table = Object.assign(Object.create(null), $deda11ebd5d0815e$var$defaultTable);
    }
    resolve(tag) {
        return !tag ? 0 : this.table[tag] || (this.table[tag] = $deda11ebd5d0815e$var$createTokenType(this.extra, tag));
    }
}
const $deda11ebd5d0815e$var$defaultTokenTable = /*@__PURE__*/ new $deda11ebd5d0815e$var$TokenTable($deda11ebd5d0815e$var$noTokens);
function $deda11ebd5d0815e$var$warnForPart(part, msg) {
    if ($deda11ebd5d0815e$var$warned.indexOf(part) > -1) return;
    $deda11ebd5d0815e$var$warned.push(part);
    console.warn(msg);
}
function $deda11ebd5d0815e$var$createTokenType(extra, tagStr) {
    let tags$1 = [];
    for (let name of tagStr.split(" ")){
        let found = [];
        for (let part of name.split(".")){
            let value = extra[part] || (0, $6b8758376c12ba5a$export$8b7a896ae75accbf)[part];
            if (!value) $deda11ebd5d0815e$var$warnForPart(part, `Unknown highlighting tag ${part}`);
            else if (typeof value == "function") {
                if (!found.length) $deda11ebd5d0815e$var$warnForPart(part, `Modifier ${part} used at start of tag`);
                else found = found.map(value);
            } else if (found.length) $deda11ebd5d0815e$var$warnForPart(part, `Tag ${part} used as modifier`);
            else found = Array.isArray(value) ? value : [
                value
            ];
        }
        for (let tag of found)tags$1.push(tag);
    }
    if (!tags$1.length) return 0;
    let name = tagStr.replace(/ /g, "_"), key = name + " " + tags$1.map((t)=>t.id);
    let known = $deda11ebd5d0815e$var$byTag[key];
    if (known) return known.id;
    let type = $deda11ebd5d0815e$var$byTag[key] = (0, $a7a41eb5193c1110$export$f06e977173f1857c).define({
        id: $deda11ebd5d0815e$var$typeArray.length,
        name: name,
        props: [
            (0, $6b8758376c12ba5a$export$c537e79bb7b94295)({
                [name]: tags$1
            })
        ]
    });
    $deda11ebd5d0815e$var$typeArray.push(type);
    return type.id;
}
function $deda11ebd5d0815e$var$docID(data, lang) {
    let type = (0, $a7a41eb5193c1110$export$f06e977173f1857c).define({
        id: $deda11ebd5d0815e$var$typeArray.length,
        name: "Document",
        props: [
            $deda11ebd5d0815e$export$27a2e78097f753f7.add(()=>data),
            $deda11ebd5d0815e$export$72c7d4c52b3c6460.add(()=>(cx)=>lang.getIndent(cx))
        ],
        top: true
    });
    $deda11ebd5d0815e$var$typeArray.push(type);
    return type;
}
function $deda11ebd5d0815e$var$buildForLine(line) {
    return line.length <= 4096 && /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/.test(line);
}
function $deda11ebd5d0815e$var$textHasRTL(text) {
    for(let i = text.iter(); !i.next().done;)if ($deda11ebd5d0815e$var$buildForLine(i.value)) return true;
    return false;
}
function $deda11ebd5d0815e$var$changeAddsRTL(change) {
    let added = false;
    change.iterChanges((fA, tA, fB, tB, ins)=>{
        if (!added && $deda11ebd5d0815e$var$textHasRTL(ins)) added = true;
    });
    return added;
}
const $deda11ebd5d0815e$var$alwaysIsolate = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
/**
Make sure nodes
[marked](https://lezer.codemirror.net/docs/ref/#common.NodeProp^isolate)
as isolating for bidirectional text are rendered in a way that
isolates them from the surrounding text.
*/ function $deda11ebd5d0815e$export$9c455d2bd760f210(options = {}) {
    let extensions = [
        $deda11ebd5d0815e$var$isolateMarks
    ];
    if (options.alwaysIsolate) extensions.push($deda11ebd5d0815e$var$alwaysIsolate.of(true));
    return extensions;
}
const $deda11ebd5d0815e$var$isolateMarks = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.always = view.state.facet($deda11ebd5d0815e$var$alwaysIsolate) || view.textDirection != (0, $1d528cc0e08a0656$export$cacd6541cfeeb6c1).LTR || view.state.facet((0, $1d528cc0e08a0656$export$eece2fccabbb77c5).perLineTextDirection);
        this.hasRTL = !this.always && $deda11ebd5d0815e$var$textHasRTL(view.state.doc);
        this.tree = $deda11ebd5d0815e$export$7fc98e56a4ca6be1(view.state);
        this.decorations = this.always || this.hasRTL ? $deda11ebd5d0815e$var$buildDeco(view, this.tree, this.always) : (0, $1d528cc0e08a0656$export$10e30b733df217ea).none;
    }
    update(update) {
        let always = update.state.facet($deda11ebd5d0815e$var$alwaysIsolate) || update.view.textDirection != (0, $1d528cc0e08a0656$export$cacd6541cfeeb6c1).LTR || update.state.facet((0, $1d528cc0e08a0656$export$eece2fccabbb77c5).perLineTextDirection);
        if (!always && !this.hasRTL && $deda11ebd5d0815e$var$changeAddsRTL(update.changes)) this.hasRTL = true;
        if (!always && !this.hasRTL) return;
        let tree = $deda11ebd5d0815e$export$7fc98e56a4ca6be1(update.state);
        if (always != this.always || tree != this.tree || update.docChanged || update.viewportChanged) {
            this.tree = tree;
            this.always = always;
            this.decorations = $deda11ebd5d0815e$var$buildDeco(update.view, tree, always);
        }
    }
}, {
    provide: (plugin)=>{
        function access(view) {
            var _a, _b;
            return (_b = (_a = view.plugin(plugin)) === null || _a === void 0 ? void 0 : _a.decorations) !== null && _b !== void 0 ? _b : (0, $1d528cc0e08a0656$export$10e30b733df217ea).none;
        }
        return [
            (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).outerDecorations.of(access),
            (0, $6b8f387faea0a4dd$export$b92464a736444411).lowest((0, $1d528cc0e08a0656$export$eece2fccabbb77c5).bidiIsolatedRanges.of(access))
        ];
    }
});
function $deda11ebd5d0815e$var$buildDeco(view, tree, always) {
    let deco = new (0, $6b8f387faea0a4dd$export$89e09ce03c7e8594)();
    let ranges = view.visibleRanges;
    if (!always) ranges = $deda11ebd5d0815e$var$clipRTLLines(ranges, view.state.doc);
    for (let { from: from, to: to } of ranges)tree.iterate({
        enter: (node)=>{
            let iso = node.type.prop((0, $a7a41eb5193c1110$export$b8034b9bc18acd90).isolate);
            if (iso) deco.add(node.from, node.to, $deda11ebd5d0815e$var$marks[iso]);
        },
        from: from,
        to: to
    });
    return deco.finish();
}
function $deda11ebd5d0815e$var$clipRTLLines(ranges, doc) {
    let cur = doc.iter(), pos = 0, result = [], last = null;
    for (let { from: from, to: to } of ranges){
        if (last && last.to > from) {
            from = last.to;
            if (from >= to) continue;
        }
        if (pos + cur.value.length < from) {
            cur.next(from - (pos + cur.value.length));
            pos = from;
        }
        for(;;){
            let start = pos, end = pos + cur.value.length;
            if (!cur.lineBreak && $deda11ebd5d0815e$var$buildForLine(cur.value)) {
                if (last && last.to > start - 10) last.to = Math.min(to, end);
                else result.push(last = {
                    from: start,
                    to: Math.min(to, end)
                });
            }
            if (end >= to) break;
            pos = end;
            cur.next();
        }
    }
    return result;
}
const $deda11ebd5d0815e$var$marks = {
    rtl: /*@__PURE__*/ (0, $1d528cc0e08a0656$export$10e30b733df217ea).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "rtl"
        },
        bidiIsolate: (0, $1d528cc0e08a0656$export$cacd6541cfeeb6c1).RTL
    }),
    ltr: /*@__PURE__*/ (0, $1d528cc0e08a0656$export$10e30b733df217ea).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "ltr"
        },
        bidiIsolate: (0, $1d528cc0e08a0656$export$cacd6541cfeeb6c1).LTR
    }),
    auto: /*@__PURE__*/ (0, $1d528cc0e08a0656$export$10e30b733df217ea).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "auto"
        },
        bidiIsolate: null
    })
};



/**
Comment or uncomment the current selection. Will use line comments
if available, otherwise falling back to block comments.
*/ const $6df8ca87402049ac$export$afbcdd0bff36c567 = (target)=>{
    let { state: state } = target, line = state.doc.lineAt(state.selection.main.from), config = $6df8ca87402049ac$var$getConfig(target.state, line.from);
    return config.line ? $6df8ca87402049ac$export$63a9abf96aaa3c5d(target) : config.block ? $6df8ca87402049ac$export$e88d9eff7cafcc34(target) : false;
};
function $6df8ca87402049ac$var$command(f, option) {
    return ({ state: state, dispatch: dispatch })=>{
        if (state.readOnly) return false;
        let tr = f(option, state);
        if (!tr) return false;
        dispatch(state.update(tr));
        return true;
    };
}
/**
Comment or uncomment the current selection using line comments.
The line comment syntax is taken from the
[`commentTokens`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt).
*/ const $6df8ca87402049ac$export$63a9abf96aaa3c5d = /*@__PURE__*/ $6df8ca87402049ac$var$command($6df8ca87402049ac$var$changeLineComment, 0 /* CommentOption.Toggle */ );
/**
Comment the current selection using line comments.
*/ const $6df8ca87402049ac$export$5d080f5a78d4f5b3 = /*@__PURE__*/ $6df8ca87402049ac$var$command($6df8ca87402049ac$var$changeLineComment, 1 /* CommentOption.Comment */ );
/**
Uncomment the current selection using line comments.
*/ const $6df8ca87402049ac$export$5a43b8c36509b6fd = /*@__PURE__*/ $6df8ca87402049ac$var$command($6df8ca87402049ac$var$changeLineComment, 2 /* CommentOption.Uncomment */ );
/**
Comment or uncomment the current selection using block comments.
The block comment syntax is taken from the
[`commentTokens`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt).
*/ const $6df8ca87402049ac$export$19d6fa84ce3a55ab = /*@__PURE__*/ $6df8ca87402049ac$var$command($6df8ca87402049ac$var$changeBlockComment, 0 /* CommentOption.Toggle */ );
/**
Comment the current selection using block comments.
*/ const $6df8ca87402049ac$export$f2ae215066c4835a = /*@__PURE__*/ $6df8ca87402049ac$var$command($6df8ca87402049ac$var$changeBlockComment, 1 /* CommentOption.Comment */ );
/**
Uncomment the current selection using block comments.
*/ const $6df8ca87402049ac$export$fddcfb23c3a05835 = /*@__PURE__*/ $6df8ca87402049ac$var$command($6df8ca87402049ac$var$changeBlockComment, 2 /* CommentOption.Uncomment */ );
/**
Comment or uncomment the lines around the current selection using
block comments.
*/ const $6df8ca87402049ac$export$e88d9eff7cafcc34 = /*@__PURE__*/ $6df8ca87402049ac$var$command((o, s)=>$6df8ca87402049ac$var$changeBlockComment(o, s, $6df8ca87402049ac$var$selectedLineRanges(s)), 0 /* CommentOption.Toggle */ );
function $6df8ca87402049ac$var$getConfig(state, pos) {
    let data = state.languageDataAt("commentTokens", pos, 1);
    return data.length ? data[0] : {};
}
const $6df8ca87402049ac$var$SearchMargin = 50;
/**
Determines if the given range is block-commented in the given
state.
*/ function $6df8ca87402049ac$var$findBlockComment(state, { open: open, close: close }, from, to) {
    let textBefore = state.sliceDoc(from - $6df8ca87402049ac$var$SearchMargin, from);
    let textAfter = state.sliceDoc(to, to + $6df8ca87402049ac$var$SearchMargin);
    let spaceBefore = /\s*$/.exec(textBefore)[0].length, spaceAfter = /^\s*/.exec(textAfter)[0].length;
    let beforeOff = textBefore.length - spaceBefore;
    if (textBefore.slice(beforeOff - open.length, beforeOff) == open && textAfter.slice(spaceAfter, spaceAfter + close.length) == close) return {
        open: {
            pos: from - spaceBefore,
            margin: spaceBefore && 1
        },
        close: {
            pos: to + spaceAfter,
            margin: spaceAfter && 1
        }
    };
    let startText, endText;
    if (to - from <= 2 * $6df8ca87402049ac$var$SearchMargin) startText = endText = state.sliceDoc(from, to);
    else {
        startText = state.sliceDoc(from, from + $6df8ca87402049ac$var$SearchMargin);
        endText = state.sliceDoc(to - $6df8ca87402049ac$var$SearchMargin, to);
    }
    let startSpace = /^\s*/.exec(startText)[0].length, endSpace = /\s*$/.exec(endText)[0].length;
    let endOff = endText.length - endSpace - close.length;
    if (startText.slice(startSpace, startSpace + open.length) == open && endText.slice(endOff, endOff + close.length) == close) return {
        open: {
            pos: from + startSpace + open.length,
            margin: /\s/.test(startText.charAt(startSpace + open.length)) ? 1 : 0
        },
        close: {
            pos: to - endSpace - close.length,
            margin: /\s/.test(endText.charAt(endOff - 1)) ? 1 : 0
        }
    };
    return null;
}
function $6df8ca87402049ac$var$selectedLineRanges(state) {
    let ranges = [];
    for (let r of state.selection.ranges){
        let fromLine = state.doc.lineAt(r.from);
        let toLine = r.to <= fromLine.to ? fromLine : state.doc.lineAt(r.to);
        if (toLine.from > fromLine.from && toLine.from == r.to) toLine = r.to == fromLine.to + 1 ? fromLine : state.doc.lineAt(r.to - 1);
        let last = ranges.length - 1;
        if (last >= 0 && ranges[last].to > fromLine.from) ranges[last].to = toLine.to;
        else ranges.push({
            from: fromLine.from + /^\s*/.exec(fromLine.text)[0].length,
            to: toLine.to
        });
    }
    return ranges;
}
// Performs toggle, comment and uncomment of block comments in
// languages that support them.
function $6df8ca87402049ac$var$changeBlockComment(option, state, ranges = state.selection.ranges) {
    let tokens = ranges.map((r)=>$6df8ca87402049ac$var$getConfig(state, r.from).block);
    if (!tokens.every((c)=>c)) return null;
    let comments = ranges.map((r, i)=>$6df8ca87402049ac$var$findBlockComment(state, tokens[i], r.from, r.to));
    if (option != 2 /* CommentOption.Uncomment */  && !comments.every((c)=>c)) return {
        changes: state.changes(ranges.map((range, i)=>{
            if (comments[i]) return [];
            return [
                {
                    from: range.from,
                    insert: tokens[i].open + " "
                },
                {
                    from: range.to,
                    insert: " " + tokens[i].close
                }
            ];
        }))
    };
    else if (option != 1 /* CommentOption.Comment */  && comments.some((c)=>c)) {
        let changes = [];
        for(let i = 0, comment; i < comments.length; i++)if (comment = comments[i]) {
            let token = tokens[i], { open: open, close: close } = comment;
            changes.push({
                from: open.pos - token.open.length,
                to: open.pos + open.margin
            }, {
                from: close.pos - close.margin,
                to: close.pos + token.close.length
            });
        }
        return {
            changes: changes
        };
    }
    return null;
}
// Performs toggle, comment and uncomment of line comments.
function $6df8ca87402049ac$var$changeLineComment(option, state, ranges = state.selection.ranges) {
    let lines = [];
    let prevLine = -1;
    for (let { from: from, to: to } of ranges){
        let startI = lines.length, minIndent = 1e9;
        let token = $6df8ca87402049ac$var$getConfig(state, from).line;
        if (!token) continue;
        for(let pos = from; pos <= to;){
            let line = state.doc.lineAt(pos);
            if (line.from > prevLine && (from == to || to > line.from)) {
                prevLine = line.from;
                let indent = /^\s*/.exec(line.text)[0].length;
                let empty = indent == line.length;
                let comment = line.text.slice(indent, indent + token.length) == token ? indent : -1;
                if (indent < line.text.length && indent < minIndent) minIndent = indent;
                lines.push({
                    line: line,
                    comment: comment,
                    token: token,
                    indent: indent,
                    empty: empty,
                    single: false
                });
            }
            pos = line.to + 1;
        }
        if (minIndent < 1e9) {
            for(let i = startI; i < lines.length; i++)if (lines[i].indent < lines[i].line.text.length) lines[i].indent = minIndent;
        }
        if (lines.length == startI + 1) lines[startI].single = true;
    }
    if (option != 2 /* CommentOption.Uncomment */  && lines.some((l)=>l.comment < 0 && (!l.empty || l.single))) {
        let changes = [];
        for (let { line: line, token: token, indent: indent, empty: empty, single: single } of lines)if (single || !empty) changes.push({
            from: line.from + indent,
            insert: token + " "
        });
        let changeSet = state.changes(changes);
        return {
            changes: changeSet,
            selection: state.selection.map(changeSet, 1)
        };
    } else if (option != 1 /* CommentOption.Comment */  && lines.some((l)=>l.comment >= 0)) {
        let changes = [];
        for (let { line: line, comment: comment, token: token } of lines)if (comment >= 0) {
            let from = line.from + comment, to = from + token.length;
            if (line.text[to - line.from] == " ") to++;
            changes.push({
                from: from,
                to: to
            });
        }
        return {
            changes: changes
        };
    }
    return null;
}
const $6df8ca87402049ac$var$fromHistory = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$9279461326b8700a).define();
/**
Transaction annotation that will prevent that transaction from
being combined with other transactions in the undo history. Given
`"before"`, it'll prevent merging with previous transactions. With
`"after"`, subsequent transactions won't be combined with this
one. With `"full"`, the transaction is isolated on both sides.
*/ const $6df8ca87402049ac$export$33e0bb25992f9954 = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$9279461326b8700a).define();
/**
This facet provides a way to register functions that, given a
transaction, provide a set of effects that the history should
store when inverting the transaction. This can be used to
integrate some kinds of effects in the history, so that they can
be undone (and redone again).
*/ const $6df8ca87402049ac$export$edb12867fb9b2023 = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define();
const $6df8ca87402049ac$var$historyConfig = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6b8f387faea0a4dd$export$4e19c0b693794a7e)(configs, {
            minDepth: 100,
            newGroupDelay: 500,
            joinToEvent: (_t, isAdjacent)=>isAdjacent
        }, {
            minDepth: Math.max,
            newGroupDelay: Math.min,
            joinToEvent: (a, b)=>(tr, adj)=>a(tr, adj) || b(tr, adj)
        });
    }
});
const $6df8ca87402049ac$var$historyField_ = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$34381b1ce2130245).define({
    create () {
        return $6df8ca87402049ac$var$HistoryState.empty;
    },
    update (state, tr) {
        let config = tr.state.facet($6df8ca87402049ac$var$historyConfig);
        let fromHist = tr.annotation($6df8ca87402049ac$var$fromHistory);
        if (fromHist) {
            let item = $6df8ca87402049ac$var$HistEvent.fromTransaction(tr, fromHist.selection), from = fromHist.side;
            let other = from == 0 /* BranchName.Done */  ? state.undone : state.done;
            if (item) other = $6df8ca87402049ac$var$updateBranch(other, other.length, config.minDepth, item);
            else other = $6df8ca87402049ac$var$addSelection(other, tr.startState.selection);
            return new $6df8ca87402049ac$var$HistoryState(from == 0 /* BranchName.Done */  ? fromHist.rest : other, from == 0 /* BranchName.Done */  ? other : fromHist.rest);
        }
        let isolate = tr.annotation($6df8ca87402049ac$export$33e0bb25992f9954);
        if (isolate == "full" || isolate == "before") state = state.isolate();
        if (tr.annotation((0, $6b8f387faea0a4dd$export$febc5573c75cefb0).addToHistory) === false) return !tr.changes.empty ? state.addMapping(tr.changes.desc) : state;
        let event = $6df8ca87402049ac$var$HistEvent.fromTransaction(tr);
        let time = tr.annotation((0, $6b8f387faea0a4dd$export$febc5573c75cefb0).time), userEvent = tr.annotation((0, $6b8f387faea0a4dd$export$febc5573c75cefb0).userEvent);
        if (event) state = state.addChanges(event, time, userEvent, config, tr);
        else if (tr.selection) state = state.addSelection(tr.startState.selection, time, userEvent, config.newGroupDelay);
        if (isolate == "full" || isolate == "after") state = state.isolate();
        return state;
    },
    toJSON (value) {
        return {
            done: value.done.map((e)=>e.toJSON()),
            undone: value.undone.map((e)=>e.toJSON())
        };
    },
    fromJSON (json) {
        return new $6df8ca87402049ac$var$HistoryState(json.done.map($6df8ca87402049ac$var$HistEvent.fromJSON), json.undone.map($6df8ca87402049ac$var$HistEvent.fromJSON));
    }
});
/**
Create a history extension with the given configuration.
*/ function $6df8ca87402049ac$export$55abd4691b317664(config = {}) {
    return [
        $6df8ca87402049ac$var$historyField_,
        $6df8ca87402049ac$var$historyConfig.of(config),
        (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).domEventHandlers({
            beforeinput (e, view) {
                let command = e.inputType == "historyUndo" ? $6df8ca87402049ac$export$21f930c44940fd98 : e.inputType == "historyRedo" ? $6df8ca87402049ac$export$1688e416fee0a49e : null;
                if (!command) return false;
                e.preventDefault();
                return command(view);
            }
        })
    ];
}
/**
The state field used to store the history data. Should probably
only be used when you want to
[serialize](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) or
[deserialize](https://codemirror.net/6/docs/ref/#state.EditorState^fromJSON) state objects in a way
that preserves history.
*/ const $6df8ca87402049ac$export$c00598b6ceeb3e9 = $6df8ca87402049ac$var$historyField_;
function $6df8ca87402049ac$var$cmd(side, selection) {
    return function({ state: state, dispatch: dispatch }) {
        if (!selection && state.readOnly) return false;
        let historyState = state.field($6df8ca87402049ac$var$historyField_, false);
        if (!historyState) return false;
        let tr = historyState.pop(side, state, selection);
        if (!tr) return false;
        dispatch(tr);
        return true;
    };
}
/**
Undo a single group of history events. Returns false if no group
was available.
*/ const $6df8ca87402049ac$export$21f930c44940fd98 = /*@__PURE__*/ $6df8ca87402049ac$var$cmd(0 /* BranchName.Done */ , false);
/**
Redo a group of history events. Returns false if no group was
available.
*/ const $6df8ca87402049ac$export$1688e416fee0a49e = /*@__PURE__*/ $6df8ca87402049ac$var$cmd(1 /* BranchName.Undone */ , false);
/**
Undo a change or selection change.
*/ const $6df8ca87402049ac$export$43103d47530fe49f = /*@__PURE__*/ $6df8ca87402049ac$var$cmd(0 /* BranchName.Done */ , true);
/**
Redo a change or selection change.
*/ const $6df8ca87402049ac$export$2d87af80f1777f20 = /*@__PURE__*/ $6df8ca87402049ac$var$cmd(1 /* BranchName.Undone */ , true);
function $6df8ca87402049ac$var$depth(side) {
    return function(state) {
        let histState = state.field($6df8ca87402049ac$var$historyField_, false);
        if (!histState) return 0;
        let branch = side == 0 /* BranchName.Done */  ? histState.done : histState.undone;
        return branch.length - (branch.length && !branch[0].changes ? 1 : 0);
    };
}
/**
The amount of undoable change events available in a given state.
*/ const $6df8ca87402049ac$export$f8a176c2b9a10bdb = /*@__PURE__*/ $6df8ca87402049ac$var$depth(0 /* BranchName.Done */ );
/**
The amount of redoable change events available in a given state.
*/ const $6df8ca87402049ac$export$3ffe6b288e7d941b = /*@__PURE__*/ $6df8ca87402049ac$var$depth(1 /* BranchName.Undone */ );
// History events store groups of changes or effects that need to be
// undone/redone together.
class $6df8ca87402049ac$var$HistEvent {
    constructor(// The changes in this event. Normal events hold at least one
    // change or effect. But it may be necessary to store selection
    // events before the first change, in which case a special type of
    // instance is created which doesn't hold any changes, with
    // changes == startSelection == undefined
    changes, // The effects associated with this event
    effects, // Accumulated mapping (from addToHistory==false) that should be
    // applied to events below this one.
    mapped, // The selection before this event
    startSelection, // Stores selection changes after this event, to be used for
    // selection undo/redo.
    selectionsAfter){
        this.changes = changes;
        this.effects = effects;
        this.mapped = mapped;
        this.startSelection = startSelection;
        this.selectionsAfter = selectionsAfter;
    }
    setSelAfter(after) {
        return new $6df8ca87402049ac$var$HistEvent(this.changes, this.effects, this.mapped, this.startSelection, after);
    }
    toJSON() {
        var _a, _b, _c;
        return {
            changes: (_a = this.changes) === null || _a === void 0 ? void 0 : _a.toJSON(),
            mapped: (_b = this.mapped) === null || _b === void 0 ? void 0 : _b.toJSON(),
            startSelection: (_c = this.startSelection) === null || _c === void 0 ? void 0 : _c.toJSON(),
            selectionsAfter: this.selectionsAfter.map((s)=>s.toJSON())
        };
    }
    static fromJSON(json) {
        return new $6df8ca87402049ac$var$HistEvent(json.changes && (0, $6b8f387faea0a4dd$export$29d7fbdcb1f8b71c).fromJSON(json.changes), [], json.mapped && (0, $6b8f387faea0a4dd$export$34b6a936f2bb06a2).fromJSON(json.mapped), json.startSelection && (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).fromJSON(json.startSelection), json.selectionsAfter.map((0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).fromJSON));
    }
    // This does not check `addToHistory` and such, it assumes the
    // transaction needs to be converted to an item. Returns null when
    // there are no changes or effects in the transaction.
    static fromTransaction(tr, selection) {
        let effects = $6df8ca87402049ac$var$none;
        for (let invert of tr.startState.facet($6df8ca87402049ac$export$edb12867fb9b2023)){
            let result = invert(tr);
            if (result.length) effects = effects.concat(result);
        }
        if (!effects.length && tr.changes.empty) return null;
        return new $6df8ca87402049ac$var$HistEvent(tr.changes.invert(tr.startState.doc), effects, undefined, selection || tr.startState.selection, $6df8ca87402049ac$var$none);
    }
    static selection(selections) {
        return new $6df8ca87402049ac$var$HistEvent(undefined, $6df8ca87402049ac$var$none, undefined, undefined, selections);
    }
}
function $6df8ca87402049ac$var$updateBranch(branch, to, maxLen, newEvent) {
    let start = to + 1 > maxLen + 20 ? to - maxLen - 1 : 0;
    let newBranch = branch.slice(start, to);
    newBranch.push(newEvent);
    return newBranch;
}
function $6df8ca87402049ac$var$isAdjacent(a, b) {
    let ranges = [], isAdjacent = false;
    a.iterChangedRanges((f, t)=>ranges.push(f, t));
    b.iterChangedRanges((_f, _t, f, t)=>{
        for(let i = 0; i < ranges.length;){
            let from = ranges[i++], to = ranges[i++];
            if (t >= from && f <= to) isAdjacent = true;
        }
    });
    return isAdjacent;
}
function $6df8ca87402049ac$var$eqSelectionShape(a, b) {
    return a.ranges.length == b.ranges.length && a.ranges.filter((r, i)=>r.empty != b.ranges[i].empty).length === 0;
}
function $6df8ca87402049ac$var$conc(a, b) {
    return !a.length ? b : !b.length ? a : a.concat(b);
}
const $6df8ca87402049ac$var$none = [];
const $6df8ca87402049ac$var$MaxSelectionsPerEvent = 200;
function $6df8ca87402049ac$var$addSelection(branch, selection) {
    if (!branch.length) return [
        $6df8ca87402049ac$var$HistEvent.selection([
            selection
        ])
    ];
    else {
        let lastEvent = branch[branch.length - 1];
        let sels = lastEvent.selectionsAfter.slice(Math.max(0, lastEvent.selectionsAfter.length - $6df8ca87402049ac$var$MaxSelectionsPerEvent));
        if (sels.length && sels[sels.length - 1].eq(selection)) return branch;
        sels.push(selection);
        return $6df8ca87402049ac$var$updateBranch(branch, branch.length - 1, 1e9, lastEvent.setSelAfter(sels));
    }
}
// Assumes the top item has one or more selectionAfter values
function $6df8ca87402049ac$var$popSelection(branch) {
    let last = branch[branch.length - 1];
    let newBranch = branch.slice();
    newBranch[branch.length - 1] = last.setSelAfter(last.selectionsAfter.slice(0, last.selectionsAfter.length - 1));
    return newBranch;
}
// Add a mapping to the top event in the given branch. If this maps
// away all the changes and effects in that item, drop it and
// propagate the mapping to the next item.
function $6df8ca87402049ac$var$addMappingToBranch(branch, mapping) {
    if (!branch.length) return branch;
    let length = branch.length, selections = $6df8ca87402049ac$var$none;
    while(length){
        let event = $6df8ca87402049ac$var$mapEvent(branch[length - 1], mapping, selections);
        if (event.changes && !event.changes.empty || event.effects.length) {
            let result = branch.slice(0, length);
            result[length - 1] = event;
            return result;
        } else {
            mapping = event.mapped;
            length--;
            selections = event.selectionsAfter;
        }
    }
    return selections.length ? [
        $6df8ca87402049ac$var$HistEvent.selection(selections)
    ] : $6df8ca87402049ac$var$none;
}
function $6df8ca87402049ac$var$mapEvent(event, mapping, extraSelections) {
    let selections = $6df8ca87402049ac$var$conc(event.selectionsAfter.length ? event.selectionsAfter.map((s)=>s.map(mapping)) : $6df8ca87402049ac$var$none, extraSelections);
    // Change-less events don't store mappings (they are always the last event in a branch)
    if (!event.changes) return $6df8ca87402049ac$var$HistEvent.selection(selections);
    let mappedChanges = event.changes.map(mapping), before = mapping.mapDesc(event.changes, true);
    let fullMapping = event.mapped ? event.mapped.composeDesc(before) : before;
    return new $6df8ca87402049ac$var$HistEvent(mappedChanges, (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).mapEffects(event.effects, mapping), fullMapping, event.startSelection.map(before), selections);
}
const $6df8ca87402049ac$var$joinableUserEvent = /^(input\.type|delete)($|\.)/;
class $6df8ca87402049ac$var$HistoryState {
    constructor(done, undone, prevTime = 0, prevUserEvent){
        this.done = done;
        this.undone = undone;
        this.prevTime = prevTime;
        this.prevUserEvent = prevUserEvent;
    }
    isolate() {
        return this.prevTime ? new $6df8ca87402049ac$var$HistoryState(this.done, this.undone) : this;
    }
    addChanges(event, time, userEvent, config, tr) {
        let done = this.done, lastEvent = done[done.length - 1];
        if (lastEvent && lastEvent.changes && !lastEvent.changes.empty && event.changes && (!userEvent || $6df8ca87402049ac$var$joinableUserEvent.test(userEvent)) && (!lastEvent.selectionsAfter.length && time - this.prevTime < config.newGroupDelay && config.joinToEvent(tr, $6df8ca87402049ac$var$isAdjacent(lastEvent.changes, event.changes)) || // For compose (but not compose.start) events, always join with previous event
        userEvent == "input.type.compose")) done = $6df8ca87402049ac$var$updateBranch(done, done.length - 1, config.minDepth, new $6df8ca87402049ac$var$HistEvent(event.changes.compose(lastEvent.changes), $6df8ca87402049ac$var$conc((0, $6b8f387faea0a4dd$export$95000d4efaa4321f).mapEffects(event.effects, lastEvent.changes), lastEvent.effects), lastEvent.mapped, lastEvent.startSelection, $6df8ca87402049ac$var$none));
        else done = $6df8ca87402049ac$var$updateBranch(done, done.length, config.minDepth, event);
        return new $6df8ca87402049ac$var$HistoryState(done, $6df8ca87402049ac$var$none, time, userEvent);
    }
    addSelection(selection, time, userEvent, newGroupDelay) {
        let last = this.done.length ? this.done[this.done.length - 1].selectionsAfter : $6df8ca87402049ac$var$none;
        if (last.length > 0 && time - this.prevTime < newGroupDelay && userEvent == this.prevUserEvent && userEvent && /^select($|\.)/.test(userEvent) && $6df8ca87402049ac$var$eqSelectionShape(last[last.length - 1], selection)) return this;
        return new $6df8ca87402049ac$var$HistoryState($6df8ca87402049ac$var$addSelection(this.done, selection), this.undone, time, userEvent);
    }
    addMapping(mapping) {
        return new $6df8ca87402049ac$var$HistoryState($6df8ca87402049ac$var$addMappingToBranch(this.done, mapping), $6df8ca87402049ac$var$addMappingToBranch(this.undone, mapping), this.prevTime, this.prevUserEvent);
    }
    pop(side, state, onlySelection) {
        let branch = side == 0 /* BranchName.Done */  ? this.done : this.undone;
        if (branch.length == 0) return null;
        let event = branch[branch.length - 1], selection = event.selectionsAfter[0] || state.selection;
        if (onlySelection && event.selectionsAfter.length) return state.update({
            selection: event.selectionsAfter[event.selectionsAfter.length - 1],
            annotations: $6df8ca87402049ac$var$fromHistory.of({
                side: side,
                rest: $6df8ca87402049ac$var$popSelection(branch),
                selection: selection
            }),
            userEvent: side == 0 /* BranchName.Done */  ? "select.undo" : "select.redo",
            scrollIntoView: true
        });
        else if (!event.changes) return null;
        else {
            let rest = branch.length == 1 ? $6df8ca87402049ac$var$none : branch.slice(0, branch.length - 1);
            if (event.mapped) rest = $6df8ca87402049ac$var$addMappingToBranch(rest, event.mapped);
            return state.update({
                changes: event.changes,
                selection: event.startSelection,
                effects: event.effects,
                annotations: $6df8ca87402049ac$var$fromHistory.of({
                    side: side,
                    rest: rest,
                    selection: selection
                }),
                filter: false,
                userEvent: side == 0 /* BranchName.Done */  ? "undo" : "redo",
                scrollIntoView: true
            });
        }
    }
}
$6df8ca87402049ac$var$HistoryState.empty = /*@__PURE__*/ new $6df8ca87402049ac$var$HistoryState($6df8ca87402049ac$var$none, $6df8ca87402049ac$var$none);
/**
Default key bindings for the undo history.

- Mod-z: [`undo`](https://codemirror.net/6/docs/ref/#commands.undo).
- Mod-y (Mod-Shift-z on macOS) + Ctrl-Shift-z on Linux: [`redo`](https://codemirror.net/6/docs/ref/#commands.redo).
- Mod-u: [`undoSelection`](https://codemirror.net/6/docs/ref/#commands.undoSelection).
- Alt-u (Mod-Shift-u on macOS): [`redoSelection`](https://codemirror.net/6/docs/ref/#commands.redoSelection).
*/ const $6df8ca87402049ac$export$ab4a28cb63e8a670 = [
    {
        key: "Mod-z",
        run: $6df8ca87402049ac$export$21f930c44940fd98,
        preventDefault: true
    },
    {
        key: "Mod-y",
        mac: "Mod-Shift-z",
        run: $6df8ca87402049ac$export$1688e416fee0a49e,
        preventDefault: true
    },
    {
        linux: "Ctrl-Shift-z",
        run: $6df8ca87402049ac$export$1688e416fee0a49e,
        preventDefault: true
    },
    {
        key: "Mod-u",
        run: $6df8ca87402049ac$export$43103d47530fe49f,
        preventDefault: true
    },
    {
        key: "Alt-u",
        mac: "Mod-Shift-u",
        run: $6df8ca87402049ac$export$2d87af80f1777f20,
        preventDefault: true
    }
];
function $6df8ca87402049ac$var$updateSel(sel, by) {
    return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).create(sel.ranges.map(by), sel.mainIndex);
}
function $6df8ca87402049ac$var$setSel(state, selection) {
    return state.update({
        selection: selection,
        scrollIntoView: true,
        userEvent: "select"
    });
}
function $6df8ca87402049ac$var$moveSel({ state: state, dispatch: dispatch }, how) {
    let selection = $6df8ca87402049ac$var$updateSel(state.selection, how);
    if (selection.eq(state.selection, true)) return false;
    dispatch($6df8ca87402049ac$var$setSel(state, selection));
    return true;
}
function $6df8ca87402049ac$var$rangeEnd(range, forward) {
    return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(forward ? range.to : range.from);
}
function $6df8ca87402049ac$var$cursorByChar(view, forward) {
    return $6df8ca87402049ac$var$moveSel(view, (range)=>range.empty ? view.moveByChar(range, forward) : $6df8ca87402049ac$var$rangeEnd(range, forward));
}
function $6df8ca87402049ac$var$ltrAtCursor(view) {
    return view.textDirectionAt(view.state.selection.main.head) == (0, $1d528cc0e08a0656$export$cacd6541cfeeb6c1).LTR;
}
/**
Move the selection one character to the left (which is backward in
left-to-right text, forward in right-to-left text).
*/ const $6df8ca87402049ac$export$3447f2b737925430 = (view)=>$6df8ca87402049ac$var$cursorByChar(view, !$6df8ca87402049ac$var$ltrAtCursor(view));
/**
Move the selection one character to the right.
*/ const $6df8ca87402049ac$export$e45941411d098b = (view)=>$6df8ca87402049ac$var$cursorByChar(view, $6df8ca87402049ac$var$ltrAtCursor(view));
/**
Move the selection one character forward.
*/ const $6df8ca87402049ac$export$25b7809021291927 = (view)=>$6df8ca87402049ac$var$cursorByChar(view, true);
/**
Move the selection one character backward.
*/ const $6df8ca87402049ac$export$6ddc33d0aa7a1b65 = (view)=>$6df8ca87402049ac$var$cursorByChar(view, false);
function $6df8ca87402049ac$var$byCharLogical(state, range, forward) {
    let pos = range.head, line = state.doc.lineAt(pos);
    if (pos == (forward ? line.to : line.from)) pos = forward ? Math.min(state.doc.length, line.to + 1) : Math.max(0, line.from - 1);
    else pos = line.from + (0, $6b8f387faea0a4dd$export$a0fa439fd515e1ed)(line.text, pos - line.from, forward);
    return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(pos, forward ? -1 : 1);
}
function $6df8ca87402049ac$var$moveByCharLogical(target, forward) {
    return $6df8ca87402049ac$var$moveSel(target, (range)=>range.empty ? $6df8ca87402049ac$var$byCharLogical(target.state, range, forward) : $6df8ca87402049ac$var$rangeEnd(range, forward));
}
/**
Move the selection one character forward, in logical
(non-text-direction-aware) string index order.
*/ const $6df8ca87402049ac$export$7ce32ef700b0ef27 = (target)=>$6df8ca87402049ac$var$moveByCharLogical(target, true);
/**
Move the selection one character backward, in logical string index
order.
*/ const $6df8ca87402049ac$export$a4c56edc7f7903df = (target)=>$6df8ca87402049ac$var$moveByCharLogical(target, false);
function $6df8ca87402049ac$var$cursorByGroup(view, forward) {
    return $6df8ca87402049ac$var$moveSel(view, (range)=>range.empty ? view.moveByGroup(range, forward) : $6df8ca87402049ac$var$rangeEnd(range, forward));
}
/**
Move the selection to the left across one group of word or
non-word (but also non-space) characters.
*/ const $6df8ca87402049ac$export$137fb1611fb38377 = (view)=>$6df8ca87402049ac$var$cursorByGroup(view, !$6df8ca87402049ac$var$ltrAtCursor(view));
/**
Move the selection one group to the right.
*/ const $6df8ca87402049ac$export$8fb2c619d55341b4 = (view)=>$6df8ca87402049ac$var$cursorByGroup(view, $6df8ca87402049ac$var$ltrAtCursor(view));
/**
Move the selection one group forward.
*/ const $6df8ca87402049ac$export$ce8d94762dbdebb8 = (view)=>$6df8ca87402049ac$var$cursorByGroup(view, true);
/**
Move the selection one group backward.
*/ const $6df8ca87402049ac$export$dd83d1d646f184d8 = (view)=>$6df8ca87402049ac$var$cursorByGroup(view, false);
function $6df8ca87402049ac$var$toGroupStart(view, pos, start) {
    let categorize = view.state.charCategorizer(pos);
    let cat = categorize(start), initial = cat != (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Space;
    return (next)=>{
        let nextCat = categorize(next);
        if (nextCat != (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Space) return initial && nextCat == cat;
        initial = false;
        return true;
    };
}
/**
Move the cursor one group forward in the default Windows style,
where it moves to the start of the next group.
*/ const $6df8ca87402049ac$export$c0e6054be0198e65 = (view)=>{
    return $6df8ca87402049ac$var$moveSel(view, (range)=>range.empty ? view.moveByChar(range, true, (start)=>$6df8ca87402049ac$var$toGroupStart(view, range.head, start)) : $6df8ca87402049ac$var$rangeEnd(range, true));
};
const $6df8ca87402049ac$var$segmenter = typeof Intl != "undefined" && Intl.Segmenter ? /*@__PURE__*/ new Intl.Segmenter(undefined, {
    granularity: "word"
}) : null;
function $6df8ca87402049ac$var$moveBySubword(view, range, forward) {
    let categorize = view.state.charCategorizer(range.from);
    let cat = (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Space, pos = range.from, steps = 0;
    let done = false, sawUpper = false, sawLower = false;
    let step = (next)=>{
        if (done) return false;
        pos += forward ? next.length : -next.length;
        let nextCat = categorize(next), ahead;
        if (nextCat == (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word && next.charCodeAt(0) < 128 && /[\W_]/.test(next)) nextCat = -1; // Treat word punctuation specially
        if (cat == (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Space) cat = nextCat;
        if (cat != nextCat) return false;
        if (cat == (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word) {
            if (next.toLowerCase() == next) {
                if (!forward && sawUpper) return false;
                sawLower = true;
            } else if (sawLower) {
                if (forward) return false;
                done = true;
            } else {
                if (sawUpper && forward && categorize(ahead = view.state.sliceDoc(pos, pos + 1)) == (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word && ahead.toLowerCase() == ahead) return false;
                sawUpper = true;
            }
        }
        steps++;
        return true;
    };
    let end = view.moveByChar(range, forward, (start)=>{
        step(start);
        return step;
    });
    if ($6df8ca87402049ac$var$segmenter && cat == (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word && end.from == range.from + steps * (forward ? 1 : -1)) {
        let from = Math.min(range.head, end.head), to = Math.max(range.head, end.head);
        let skipped = view.state.sliceDoc(from, to);
        if (skipped.length > 1 && /[\u4E00-\uffff]/.test(skipped)) {
            let segments = Array.from($6df8ca87402049ac$var$segmenter.segment(skipped));
            if (segments.length > 1) {
                if (forward) return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(range.head + segments[1].index, -1);
                return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(end.head + segments[segments.length - 1].index, 1);
            }
        }
    }
    return end;
}
function $6df8ca87402049ac$var$cursorBySubword(view, forward) {
    return $6df8ca87402049ac$var$moveSel(view, (range)=>range.empty ? $6df8ca87402049ac$var$moveBySubword(view, range, forward) : $6df8ca87402049ac$var$rangeEnd(range, forward));
}
/**
Move the selection one group or camel-case subword forward.
*/ const $6df8ca87402049ac$export$d969a5b0dca9c3e2 = (view)=>$6df8ca87402049ac$var$cursorBySubword(view, true);
/**
Move the selection one group or camel-case subword backward.
*/ const $6df8ca87402049ac$export$ade35f5607ad3d82 = (view)=>$6df8ca87402049ac$var$cursorBySubword(view, false);
function $6df8ca87402049ac$var$interestingNode(state, node, bracketProp) {
    if (node.type.prop(bracketProp)) return true;
    let len = node.to - node.from;
    return len && (len > 2 || /[^\s,.;:]/.test(state.sliceDoc(node.from, node.to))) || node.firstChild;
}
function $6df8ca87402049ac$var$moveBySyntax(state, start, forward) {
    let pos = (0, $deda11ebd5d0815e$export$7fc98e56a4ca6be1)(state).resolveInner(start.head);
    let bracketProp = forward ? (0, $a7a41eb5193c1110$export$b8034b9bc18acd90).closedBy : (0, $a7a41eb5193c1110$export$b8034b9bc18acd90).openedBy;
    // Scan forward through child nodes to see if there's an interesting
    // node ahead.
    for(let at = start.head;;){
        let next = forward ? pos.childAfter(at) : pos.childBefore(at);
        if (!next) break;
        if ($6df8ca87402049ac$var$interestingNode(state, next, bracketProp)) pos = next;
        else at = forward ? next.to : next.from;
    }
    let bracket = pos.type.prop(bracketProp), match, newPos;
    if (bracket && (match = forward ? (0, $deda11ebd5d0815e$export$3391942603e90cda)(state, pos.from, 1) : (0, $deda11ebd5d0815e$export$3391942603e90cda)(state, pos.to, -1)) && match.matched) newPos = forward ? match.end.to : match.end.from;
    else newPos = forward ? pos.to : pos.from;
    return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(newPos, forward ? -1 : 1);
}
/**
Move the cursor over the next syntactic element to the left.
*/ const $6df8ca87402049ac$export$1e53c014543c10bb = (view)=>$6df8ca87402049ac$var$moveSel(view, (range)=>$6df8ca87402049ac$var$moveBySyntax(view.state, range, !$6df8ca87402049ac$var$ltrAtCursor(view)));
/**
Move the cursor over the next syntactic element to the right.
*/ const $6df8ca87402049ac$export$62c6dc33f5d01e39 = (view)=>$6df8ca87402049ac$var$moveSel(view, (range)=>$6df8ca87402049ac$var$moveBySyntax(view.state, range, $6df8ca87402049ac$var$ltrAtCursor(view)));
function $6df8ca87402049ac$var$cursorByLine(view, forward) {
    return $6df8ca87402049ac$var$moveSel(view, (range)=>{
        if (!range.empty) return $6df8ca87402049ac$var$rangeEnd(range, forward);
        let moved = view.moveVertically(range, forward);
        return moved.head != range.head ? moved : view.moveToLineBoundary(range, forward);
    });
}
/**
Move the selection one line up.
*/ const $6df8ca87402049ac$export$fe179dad0485d99d = (view)=>$6df8ca87402049ac$var$cursorByLine(view, false);
/**
Move the selection one line down.
*/ const $6df8ca87402049ac$export$75f9b75ffb1a9dc5 = (view)=>$6df8ca87402049ac$var$cursorByLine(view, true);
function $6df8ca87402049ac$var$pageInfo(view) {
    let selfScroll = view.scrollDOM.clientHeight < view.scrollDOM.scrollHeight - 2;
    let marginTop = 0, marginBottom = 0, height;
    if (selfScroll) {
        for (let source of view.state.facet((0, $1d528cc0e08a0656$export$eece2fccabbb77c5).scrollMargins)){
            let margins = source(view);
            if (margins === null || margins === void 0 ? void 0 : margins.top) marginTop = Math.max(margins === null || margins === void 0 ? void 0 : margins.top, marginTop);
            if (margins === null || margins === void 0 ? void 0 : margins.bottom) marginBottom = Math.max(margins === null || margins === void 0 ? void 0 : margins.bottom, marginBottom);
        }
        height = view.scrollDOM.clientHeight - marginTop - marginBottom;
    } else height = (view.dom.ownerDocument.defaultView || window).innerHeight;
    return {
        marginTop: marginTop,
        marginBottom: marginBottom,
        selfScroll: selfScroll,
        height: Math.max(view.defaultLineHeight, height - 5)
    };
}
function $6df8ca87402049ac$var$cursorByPage(view, forward) {
    let page = $6df8ca87402049ac$var$pageInfo(view);
    let { state: state } = view, selection = $6df8ca87402049ac$var$updateSel(state.selection, (range)=>{
        return range.empty ? view.moveVertically(range, forward, page.height) : $6df8ca87402049ac$var$rangeEnd(range, forward);
    });
    if (selection.eq(state.selection)) return false;
    let effect;
    if (page.selfScroll) {
        let startPos = view.coordsAtPos(state.selection.main.head);
        let scrollRect = view.scrollDOM.getBoundingClientRect();
        let scrollTop = scrollRect.top + page.marginTop, scrollBottom = scrollRect.bottom - page.marginBottom;
        if (startPos && startPos.top > scrollTop && startPos.bottom < scrollBottom) effect = (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).scrollIntoView(selection.main.head, {
            y: "start",
            yMargin: startPos.top - scrollTop
        });
    }
    view.dispatch($6df8ca87402049ac$var$setSel(state, selection), {
        effects: effect
    });
    return true;
}
/**
Move the selection one page up.
*/ const $6df8ca87402049ac$export$546ec71a9f854193 = (view)=>$6df8ca87402049ac$var$cursorByPage(view, false);
/**
Move the selection one page down.
*/ const $6df8ca87402049ac$export$6e407c2072d437f4 = (view)=>$6df8ca87402049ac$var$cursorByPage(view, true);
function $6df8ca87402049ac$var$moveByLineBoundary(view, start, forward) {
    let line = view.lineBlockAt(start.head), moved = view.moveToLineBoundary(start, forward);
    if (moved.head == start.head && moved.head != (forward ? line.to : line.from)) moved = view.moveToLineBoundary(start, forward, false);
    if (!forward && moved.head == line.from && line.length) {
        let space = /^\s*/.exec(view.state.sliceDoc(line.from, Math.min(line.from + 100, line.to)))[0].length;
        if (space && start.head != line.from + space) moved = (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(line.from + space);
    }
    return moved;
}
/**
Move the selection to the next line wrap point, or to the end of
the line if there isn't one left on this line.
*/ const $6df8ca87402049ac$export$b59ae3b25af6ea13 = (view)=>$6df8ca87402049ac$var$moveSel(view, (range)=>$6df8ca87402049ac$var$moveByLineBoundary(view, range, true));
/**
Move the selection to previous line wrap point, or failing that to
the start of the line. If the line is indented, and the cursor
isn't already at the end of the indentation, this will move to the
end of the indentation instead of the start of the line.
*/ const $6df8ca87402049ac$export$64939ebc49b03818 = (view)=>$6df8ca87402049ac$var$moveSel(view, (range)=>$6df8ca87402049ac$var$moveByLineBoundary(view, range, false));
/**
Move the selection one line wrap point to the left.
*/ const $6df8ca87402049ac$export$515c8c77cfbd2e73 = (view)=>$6df8ca87402049ac$var$moveSel(view, (range)=>$6df8ca87402049ac$var$moveByLineBoundary(view, range, !$6df8ca87402049ac$var$ltrAtCursor(view)));
/**
Move the selection one line wrap point to the right.
*/ const $6df8ca87402049ac$export$912e453a1e062a62 = (view)=>$6df8ca87402049ac$var$moveSel(view, (range)=>$6df8ca87402049ac$var$moveByLineBoundary(view, range, $6df8ca87402049ac$var$ltrAtCursor(view)));
/**
Move the selection to the start of the line.
*/ const $6df8ca87402049ac$export$9c7dea99650bd512 = (view)=>$6df8ca87402049ac$var$moveSel(view, (range)=>(0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).from, 1));
/**
Move the selection to the end of the line.
*/ const $6df8ca87402049ac$export$2a3cdaf3ab2dcbf2 = (view)=>$6df8ca87402049ac$var$moveSel(view, (range)=>(0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).to, -1));
function $6df8ca87402049ac$var$toMatchingBracket(state, dispatch, extend) {
    let found = false, selection = $6df8ca87402049ac$var$updateSel(state.selection, (range)=>{
        let matching = (0, $deda11ebd5d0815e$export$3391942603e90cda)(state, range.head, -1) || (0, $deda11ebd5d0815e$export$3391942603e90cda)(state, range.head, 1) || range.head > 0 && (0, $deda11ebd5d0815e$export$3391942603e90cda)(state, range.head - 1, 1) || range.head < state.doc.length && (0, $deda11ebd5d0815e$export$3391942603e90cda)(state, range.head + 1, -1);
        if (!matching || !matching.end) return range;
        found = true;
        let head = matching.start.from == range.head ? matching.end.to : matching.end.from;
        return extend ? (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(range.anchor, head) : (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(head);
    });
    if (!found) return false;
    dispatch($6df8ca87402049ac$var$setSel(state, selection));
    return true;
}
/**
Move the selection to the bracket matching the one it is currently
on, if any.
*/ const $6df8ca87402049ac$export$e5a7e1f2d38b1f6a = ({ state: state, dispatch: dispatch })=>$6df8ca87402049ac$var$toMatchingBracket(state, dispatch, false);
/**
Extend the selection to the bracket matching the one the selection
head is currently on, if any.
*/ const $6df8ca87402049ac$export$a56168b85007a381 = ({ state: state, dispatch: dispatch })=>$6df8ca87402049ac$var$toMatchingBracket(state, dispatch, true);
function $6df8ca87402049ac$var$extendSel(target, how) {
    let selection = $6df8ca87402049ac$var$updateSel(target.state.selection, (range)=>{
        let head = how(range);
        return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(range.anchor, head.head, head.goalColumn, head.bidiLevel || undefined);
    });
    if (selection.eq(target.state.selection)) return false;
    target.dispatch($6df8ca87402049ac$var$setSel(target.state, selection));
    return true;
}
function $6df8ca87402049ac$var$selectByChar(view, forward) {
    return $6df8ca87402049ac$var$extendSel(view, (range)=>view.moveByChar(range, forward));
}
/**
Move the selection head one character to the left, while leaving
the anchor in place.
*/ const $6df8ca87402049ac$export$639be832433387f = (view)=>$6df8ca87402049ac$var$selectByChar(view, !$6df8ca87402049ac$var$ltrAtCursor(view));
/**
Move the selection head one character to the right.
*/ const $6df8ca87402049ac$export$49e3d65796d89132 = (view)=>$6df8ca87402049ac$var$selectByChar(view, $6df8ca87402049ac$var$ltrAtCursor(view));
/**
Move the selection head one character forward.
*/ const $6df8ca87402049ac$export$6a18f0ec4e3aa4ba = (view)=>$6df8ca87402049ac$var$selectByChar(view, true);
/**
Move the selection head one character backward.
*/ const $6df8ca87402049ac$export$1132822fa6924c1d = (view)=>$6df8ca87402049ac$var$selectByChar(view, false);
/**
Move the selection head one character forward by logical
(non-direction aware) string index order.
*/ const $6df8ca87402049ac$export$74309692c7a8e2d9 = (target)=>$6df8ca87402049ac$var$extendSel(target, (range)=>$6df8ca87402049ac$var$byCharLogical(target.state, range, true));
/**
Move the selection head one character backward by logical string
index order.
*/ const $6df8ca87402049ac$export$2bfcd2df135aa168 = (target)=>$6df8ca87402049ac$var$extendSel(target, (range)=>$6df8ca87402049ac$var$byCharLogical(target.state, range, false));
function $6df8ca87402049ac$var$selectByGroup(view, forward) {
    return $6df8ca87402049ac$var$extendSel(view, (range)=>view.moveByGroup(range, forward));
}
/**
Move the selection head one [group](https://codemirror.net/6/docs/ref/#commands.cursorGroupLeft) to
the left.
*/ const $6df8ca87402049ac$export$ef839611b4c2ba40 = (view)=>$6df8ca87402049ac$var$selectByGroup(view, !$6df8ca87402049ac$var$ltrAtCursor(view));
/**
Move the selection head one group to the right.
*/ const $6df8ca87402049ac$export$5ebbb4cf65fe8a74 = (view)=>$6df8ca87402049ac$var$selectByGroup(view, $6df8ca87402049ac$var$ltrAtCursor(view));
/**
Move the selection head one group forward.
*/ const $6df8ca87402049ac$export$53ddb317471acf76 = (view)=>$6df8ca87402049ac$var$selectByGroup(view, true);
/**
Move the selection head one group backward.
*/ const $6df8ca87402049ac$export$65a2ce60964fa778 = (view)=>$6df8ca87402049ac$var$selectByGroup(view, false);
/**
Move the selection head one group forward in the default Windows
style, skipping to the start of the next group.
*/ const $6df8ca87402049ac$export$5ea626eef31f242e = (view)=>{
    return $6df8ca87402049ac$var$extendSel(view, (range)=>view.moveByChar(range, true, (start)=>$6df8ca87402049ac$var$toGroupStart(view, range.head, start)));
};
function $6df8ca87402049ac$var$selectBySubword(view, forward) {
    return $6df8ca87402049ac$var$extendSel(view, (range)=>$6df8ca87402049ac$var$moveBySubword(view, range, forward));
}
/**
Move the selection head one group or camel-case subword forward.
*/ const $6df8ca87402049ac$export$c4f4d945a8760145 = (view)=>$6df8ca87402049ac$var$selectBySubword(view, true);
/**
Move the selection head one group or subword backward.
*/ const $6df8ca87402049ac$export$3a6caa1f1abce2e2 = (view)=>$6df8ca87402049ac$var$selectBySubword(view, false);
/**
Move the selection head over the next syntactic element to the left.
*/ const $6df8ca87402049ac$export$67b15be4414061b5 = (view)=>$6df8ca87402049ac$var$extendSel(view, (range)=>$6df8ca87402049ac$var$moveBySyntax(view.state, range, !$6df8ca87402049ac$var$ltrAtCursor(view)));
/**
Move the selection head over the next syntactic element to the right.
*/ const $6df8ca87402049ac$export$74aa476df7791ce = (view)=>$6df8ca87402049ac$var$extendSel(view, (range)=>$6df8ca87402049ac$var$moveBySyntax(view.state, range, $6df8ca87402049ac$var$ltrAtCursor(view)));
function $6df8ca87402049ac$var$selectByLine(view, forward) {
    return $6df8ca87402049ac$var$extendSel(view, (range)=>view.moveVertically(range, forward));
}
/**
Move the selection head one line up.
*/ const $6df8ca87402049ac$export$92aa693a1ecd7061 = (view)=>$6df8ca87402049ac$var$selectByLine(view, false);
/**
Move the selection head one line down.
*/ const $6df8ca87402049ac$export$bf847527697a3040 = (view)=>$6df8ca87402049ac$var$selectByLine(view, true);
function $6df8ca87402049ac$var$selectByPage(view, forward) {
    return $6df8ca87402049ac$var$extendSel(view, (range)=>view.moveVertically(range, forward, $6df8ca87402049ac$var$pageInfo(view).height));
}
/**
Move the selection head one page up.
*/ const $6df8ca87402049ac$export$61eab34d4ff5cbaf = (view)=>$6df8ca87402049ac$var$selectByPage(view, false);
/**
Move the selection head one page down.
*/ const $6df8ca87402049ac$export$a4c186a0dadaf91c = (view)=>$6df8ca87402049ac$var$selectByPage(view, true);
/**
Move the selection head to the next line boundary.
*/ const $6df8ca87402049ac$export$df223d0097d57a86 = (view)=>$6df8ca87402049ac$var$extendSel(view, (range)=>$6df8ca87402049ac$var$moveByLineBoundary(view, range, true));
/**
Move the selection head to the previous line boundary.
*/ const $6df8ca87402049ac$export$643176ee603b8e87 = (view)=>$6df8ca87402049ac$var$extendSel(view, (range)=>$6df8ca87402049ac$var$moveByLineBoundary(view, range, false));
/**
Move the selection head one line boundary to the left.
*/ const $6df8ca87402049ac$export$769cc61da74090c5 = (view)=>$6df8ca87402049ac$var$extendSel(view, (range)=>$6df8ca87402049ac$var$moveByLineBoundary(view, range, !$6df8ca87402049ac$var$ltrAtCursor(view)));
/**
Move the selection head one line boundary to the right.
*/ const $6df8ca87402049ac$export$de427496204690a6 = (view)=>$6df8ca87402049ac$var$extendSel(view, (range)=>$6df8ca87402049ac$var$moveByLineBoundary(view, range, $6df8ca87402049ac$var$ltrAtCursor(view)));
/**
Move the selection head to the start of the line.
*/ const $6df8ca87402049ac$export$a0e1e86f753956a4 = (view)=>$6df8ca87402049ac$var$extendSel(view, (range)=>(0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).from));
/**
Move the selection head to the end of the line.
*/ const $6df8ca87402049ac$export$bd34a38d148e23af = (view)=>$6df8ca87402049ac$var$extendSel(view, (range)=>(0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).to));
/**
Move the selection to the start of the document.
*/ const $6df8ca87402049ac$export$ff7ed6e6e1cb317f = ({ state: state, dispatch: dispatch })=>{
    dispatch($6df8ca87402049ac$var$setSel(state, {
        anchor: 0
    }));
    return true;
};
/**
Move the selection to the end of the document.
*/ const $6df8ca87402049ac$export$b12ef1671b2836da = ({ state: state, dispatch: dispatch })=>{
    dispatch($6df8ca87402049ac$var$setSel(state, {
        anchor: state.doc.length
    }));
    return true;
};
/**
Move the selection head to the start of the document.
*/ const $6df8ca87402049ac$export$aa525ee829cc26b = ({ state: state, dispatch: dispatch })=>{
    dispatch($6df8ca87402049ac$var$setSel(state, {
        anchor: state.selection.main.anchor,
        head: 0
    }));
    return true;
};
/**
Move the selection head to the end of the document.
*/ const $6df8ca87402049ac$export$fff0131cdd9694fe = ({ state: state, dispatch: dispatch })=>{
    dispatch($6df8ca87402049ac$var$setSel(state, {
        anchor: state.selection.main.anchor,
        head: state.doc.length
    }));
    return true;
};
/**
Select the entire document.
*/ const $6df8ca87402049ac$export$90aca4adda6ff0f5 = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update({
        selection: {
            anchor: 0,
            head: state.doc.length
        },
        userEvent: "select"
    }));
    return true;
};
/**
Expand the selection to cover entire lines.
*/ const $6df8ca87402049ac$export$e41c12847640c21 = ({ state: state, dispatch: dispatch })=>{
    let ranges = $6df8ca87402049ac$var$selectedLineBlocks(state).map(({ from: from, to: to })=>(0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(from, Math.min(to + 1, state.doc.length)));
    dispatch(state.update({
        selection: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).create(ranges),
        userEvent: "select"
    }));
    return true;
};
/**
Select the next syntactic construct that is larger than the
selection. Note that this will only work insofar as the language
[provider](https://codemirror.net/6/docs/ref/#language.language) you use builds up a full
syntax tree.
*/ const $6df8ca87402049ac$export$f38a48fa120d50ce = ({ state: state, dispatch: dispatch })=>{
    let selection = $6df8ca87402049ac$var$updateSel(state.selection, (range)=>{
        let tree = (0, $deda11ebd5d0815e$export$7fc98e56a4ca6be1)(state), stack = tree.resolveStack(range.from, 1);
        if (range.empty) {
            let stackBefore = tree.resolveStack(range.from, -1);
            if (stackBefore.node.from >= stack.node.from && stackBefore.node.to <= stack.node.to) stack = stackBefore;
        }
        for(let cur = stack; cur; cur = cur.next){
            let { node: node } = cur;
            if ((node.from < range.from && node.to >= range.to || node.to > range.to && node.from <= range.from) && cur.next) return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(node.to, node.from);
        }
        return range;
    });
    if (selection.eq(state.selection)) return false;
    dispatch($6df8ca87402049ac$var$setSel(state, selection));
    return true;
};
/**
Simplify the current selection. When multiple ranges are selected,
reduce it to its main range. Otherwise, if the selection is
non-empty, convert it to a cursor selection.
*/ const $6df8ca87402049ac$export$2f90cebc0d40abf = ({ state: state, dispatch: dispatch })=>{
    let cur = state.selection, selection = null;
    if (cur.ranges.length > 1) selection = (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).create([
        cur.main
    ]);
    else if (!cur.main.empty) selection = (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).create([
        (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(cur.main.head)
    ]);
    if (!selection) return false;
    dispatch($6df8ca87402049ac$var$setSel(state, selection));
    return true;
};
function $6df8ca87402049ac$var$deleteBy(target, by) {
    if (target.state.readOnly) return false;
    let event = "delete.selection", { state: state } = target;
    let changes = state.changeByRange((range)=>{
        let { from: from, to: to } = range;
        if (from == to) {
            let towards = by(range);
            if (towards < from) {
                event = "delete.backward";
                towards = $6df8ca87402049ac$var$skipAtomic(target, towards, false);
            } else if (towards > from) {
                event = "delete.forward";
                towards = $6df8ca87402049ac$var$skipAtomic(target, towards, true);
            }
            from = Math.min(from, towards);
            to = Math.max(to, towards);
        } else {
            from = $6df8ca87402049ac$var$skipAtomic(target, from, false);
            to = $6df8ca87402049ac$var$skipAtomic(target, to, true);
        }
        return from == to ? {
            range: range
        } : {
            changes: {
                from: from,
                to: to
            },
            range: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(from, from < range.head ? -1 : 1)
        };
    });
    if (changes.changes.empty) return false;
    target.dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: event,
        effects: event == "delete.selection" ? (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).announce.of(state.phrase("Selection deleted")) : undefined
    }));
    return true;
}
function $6df8ca87402049ac$var$skipAtomic(target, pos, forward) {
    if (target instanceof (0, $1d528cc0e08a0656$export$eece2fccabbb77c5)) for (let ranges of target.state.facet((0, $1d528cc0e08a0656$export$eece2fccabbb77c5).atomicRanges).map((f)=>f(target)))ranges.between(pos, pos, (from, to)=>{
        if (from < pos && to > pos) pos = forward ? to : from;
    });
    return pos;
}
const $6df8ca87402049ac$var$deleteByChar = (target, forward, byIndentUnit)=>$6df8ca87402049ac$var$deleteBy(target, (range)=>{
        let pos = range.from, { state: state } = target, line = state.doc.lineAt(pos), before, targetPos;
        if (byIndentUnit && !forward && pos > line.from && pos < line.from + 200 && !/[^ \t]/.test(before = line.text.slice(0, pos - line.from))) {
            if (before[before.length - 1] == "\t") return pos - 1;
            let col = (0, $6b8f387faea0a4dd$export$20b4ab289374d0ac)(before, state.tabSize), drop = col % (0, $deda11ebd5d0815e$export$ad3205d09311a797)(state) || (0, $deda11ebd5d0815e$export$ad3205d09311a797)(state);
            for(let i = 0; i < drop && before[before.length - 1 - i] == " "; i++)pos--;
            targetPos = pos;
        } else {
            targetPos = (0, $6b8f387faea0a4dd$export$a0fa439fd515e1ed)(line.text, pos - line.from, forward, forward) + line.from;
            if (targetPos == pos && line.number != (forward ? state.doc.lines : 1)) targetPos += forward ? 1 : -1;
            else if (!forward && /[\ufe00-\ufe0f]/.test(line.text.slice(targetPos - line.from, pos - line.from))) targetPos = (0, $6b8f387faea0a4dd$export$a0fa439fd515e1ed)(line.text, targetPos - line.from, false, false) + line.from;
        }
        return targetPos;
    });
/**
Delete the selection, or, for cursor selections, the character or
indentation unit before the cursor.
*/ const $6df8ca87402049ac$export$1e8a14efe7ca9a33 = (view)=>$6df8ca87402049ac$var$deleteByChar(view, false, true);
/**
Delete the selection or the character before the cursor. Does not
implement any extended behavior like deleting whole indentation
units in one go.
*/ const $6df8ca87402049ac$export$3365c1d7b1abe7df = (view)=>$6df8ca87402049ac$var$deleteByChar(view, false, false);
/**
Delete the selection or the character after the cursor.
*/ const $6df8ca87402049ac$export$d41683a0f042cb80 = (view)=>$6df8ca87402049ac$var$deleteByChar(view, true, false);
const $6df8ca87402049ac$var$deleteByGroup = (target, forward)=>$6df8ca87402049ac$var$deleteBy(target, (range)=>{
        let pos = range.head, { state: state } = target, line = state.doc.lineAt(pos);
        let categorize = state.charCategorizer(pos);
        for(let cat = null;;){
            if (pos == (forward ? line.to : line.from)) {
                if (pos == range.head && line.number != (forward ? state.doc.lines : 1)) pos += forward ? 1 : -1;
                break;
            }
            let next = (0, $6b8f387faea0a4dd$export$a0fa439fd515e1ed)(line.text, pos - line.from, forward) + line.from;
            let nextChar = line.text.slice(Math.min(pos, next) - line.from, Math.max(pos, next) - line.from);
            let nextCat = categorize(nextChar);
            if (cat != null && nextCat != cat) break;
            if (nextChar != " " || pos != range.head) cat = nextCat;
            pos = next;
        }
        return pos;
    });
/**
Delete the selection or backward until the end of the next
[group](https://codemirror.net/6/docs/ref/#view.EditorView.moveByGroup), only skipping groups of
whitespace when they consist of a single space.
*/ const $6df8ca87402049ac$export$3072f591ab219e94 = (target)=>$6df8ca87402049ac$var$deleteByGroup(target, false);
/**
Delete the selection or forward until the end of the next group.
*/ const $6df8ca87402049ac$export$56a4e2ef21b58242 = (target)=>$6df8ca87402049ac$var$deleteByGroup(target, true);
/**
Delete the selection, or, if it is a cursor selection, delete to
the end of the line. If the cursor is directly at the end of the
line, delete the line break after it.
*/ const $6df8ca87402049ac$export$ae3820c4ce0e9c92 = (view)=>$6df8ca87402049ac$var$deleteBy(view, (range)=>{
        let lineEnd = view.lineBlockAt(range.head).to;
        return range.head < lineEnd ? lineEnd : Math.min(view.state.doc.length, range.head + 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the start of the line. If the cursor is directly at the start of the
line, delete the line break before it.
*/ const $6df8ca87402049ac$export$dc80e21fb31e84a5 = (view)=>$6df8ca87402049ac$var$deleteBy(view, (range)=>{
        let lineStart = view.lineBlockAt(range.head).from;
        return range.head > lineStart ? lineStart : Math.max(0, range.head - 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the start of the line or the next line wrap before the cursor.
*/ const $6df8ca87402049ac$export$d1072494cede984a = (view)=>$6df8ca87402049ac$var$deleteBy(view, (range)=>{
        let lineStart = view.moveToLineBoundary(range, false).head;
        return range.head > lineStart ? lineStart : Math.max(0, range.head - 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the end of the line or the next line wrap after the cursor.
*/ const $6df8ca87402049ac$export$b87eb3a389c264a4 = (view)=>$6df8ca87402049ac$var$deleteBy(view, (range)=>{
        let lineStart = view.moveToLineBoundary(range, true).head;
        return range.head < lineStart ? lineStart : Math.min(view.state.doc.length, range.head + 1);
    });
/**
Delete all whitespace directly before a line end from the
document.
*/ const $6df8ca87402049ac$export$8acd3a9fe3872724 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = [];
    for(let pos = 0, prev = "", iter = state.doc.iter();;){
        iter.next();
        if (iter.lineBreak || iter.done) {
            let trailing = prev.search(/\s+$/);
            if (trailing > -1) changes.push({
                from: pos - (prev.length - trailing),
                to: pos
            });
            if (iter.done) break;
            prev = "";
        } else prev = iter.value;
        pos += iter.value.length;
    }
    if (!changes.length) return false;
    dispatch(state.update({
        changes: changes,
        userEvent: "delete"
    }));
    return true;
};
/**
Replace each selection range with a line break, leaving the cursor
on the line before the break.
*/ const $6df8ca87402049ac$export$a258d4581e1d5d3c = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = state.changeByRange((range)=>{
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: (0, $6b8f387faea0a4dd$export$5f1af8db9871e1d6).of([
                    "",
                    ""
                ])
            },
            range: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(range.from)
        };
    });
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Flip the characters before and after the cursor(s).
*/ const $6df8ca87402049ac$export$55467a37288e4063 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = state.changeByRange((range)=>{
        if (!range.empty || range.from == 0 || range.from == state.doc.length) return {
            range: range
        };
        let pos = range.from, line = state.doc.lineAt(pos);
        let from = pos == line.from ? pos - 1 : (0, $6b8f387faea0a4dd$export$a0fa439fd515e1ed)(line.text, pos - line.from, false) + line.from;
        let to = pos == line.to ? pos + 1 : (0, $6b8f387faea0a4dd$export$a0fa439fd515e1ed)(line.text, pos - line.from, true) + line.from;
        return {
            changes: {
                from: from,
                to: to,
                insert: state.doc.slice(pos, to).append(state.doc.slice(from, pos))
            },
            range: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(to)
        };
    });
    if (changes.changes.empty) return false;
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "move.character"
    }));
    return true;
};
function $6df8ca87402049ac$var$selectedLineBlocks(state) {
    let blocks = [], upto = -1;
    for (let range of state.selection.ranges){
        let startLine = state.doc.lineAt(range.from), endLine = state.doc.lineAt(range.to);
        if (!range.empty && range.to == endLine.from) endLine = state.doc.lineAt(range.to - 1);
        if (upto >= startLine.number) {
            let prev = blocks[blocks.length - 1];
            prev.to = endLine.to;
            prev.ranges.push(range);
        } else blocks.push({
            from: startLine.from,
            to: endLine.to,
            ranges: [
                range
            ]
        });
        upto = endLine.number + 1;
    }
    return blocks;
}
function $6df8ca87402049ac$var$moveLine(state, dispatch, forward) {
    if (state.readOnly) return false;
    let changes = [], ranges = [];
    for (let block of $6df8ca87402049ac$var$selectedLineBlocks(state)){
        if (forward ? block.to == state.doc.length : block.from == 0) continue;
        let nextLine = state.doc.lineAt(forward ? block.to + 1 : block.from - 1);
        let size = nextLine.length + 1;
        if (forward) {
            changes.push({
                from: block.to,
                to: nextLine.to
            }, {
                from: block.from,
                insert: nextLine.text + state.lineBreak
            });
            for (let r of block.ranges)ranges.push((0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(Math.min(state.doc.length, r.anchor + size), Math.min(state.doc.length, r.head + size)));
        } else {
            changes.push({
                from: nextLine.from,
                to: block.from
            }, {
                from: block.to,
                insert: state.lineBreak + nextLine.text
            });
            for (let r of block.ranges)ranges.push((0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(r.anchor - size, r.head - size));
        }
    }
    if (!changes.length) return false;
    dispatch(state.update({
        changes: changes,
        scrollIntoView: true,
        selection: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).create(ranges, state.selection.mainIndex),
        userEvent: "move.line"
    }));
    return true;
}
/**
Move the selected lines up one line.
*/ const $6df8ca87402049ac$export$c4eebaf75cfae23e = ({ state: state, dispatch: dispatch })=>$6df8ca87402049ac$var$moveLine(state, dispatch, false);
/**
Move the selected lines down one line.
*/ const $6df8ca87402049ac$export$ac19ae98a6fcd34c = ({ state: state, dispatch: dispatch })=>$6df8ca87402049ac$var$moveLine(state, dispatch, true);
function $6df8ca87402049ac$var$copyLine(state, dispatch, forward) {
    if (state.readOnly) return false;
    let changes = [];
    for (let block of $6df8ca87402049ac$var$selectedLineBlocks(state))if (forward) changes.push({
        from: block.from,
        insert: state.doc.slice(block.from, block.to) + state.lineBreak
    });
    else changes.push({
        from: block.to,
        insert: state.lineBreak + state.doc.slice(block.from, block.to)
    });
    dispatch(state.update({
        changes: changes,
        scrollIntoView: true,
        userEvent: "input.copyline"
    }));
    return true;
}
/**
Create a copy of the selected lines. Keep the selection in the top copy.
*/ const $6df8ca87402049ac$export$c3798d29213e527c = ({ state: state, dispatch: dispatch })=>$6df8ca87402049ac$var$copyLine(state, dispatch, false);
/**
Create a copy of the selected lines. Keep the selection in the bottom copy.
*/ const $6df8ca87402049ac$export$1ad385c375816d2f = ({ state: state, dispatch: dispatch })=>$6df8ca87402049ac$var$copyLine(state, dispatch, true);
/**
Delete selected lines.
*/ const $6df8ca87402049ac$export$aba0d4cd8923f1ae = (view)=>{
    if (view.state.readOnly) return false;
    let { state: state } = view, changes = state.changes($6df8ca87402049ac$var$selectedLineBlocks(state).map(({ from: from, to: to })=>{
        if (from > 0) from--;
        else if (to < state.doc.length) to++;
        return {
            from: from,
            to: to
        };
    }));
    let selection = $6df8ca87402049ac$var$updateSel(state.selection, (range)=>{
        let dist = undefined;
        if (view.lineWrapping) {
            let block = view.lineBlockAt(range.head), pos = view.coordsAtPos(range.head, range.assoc || 1);
            if (pos) dist = block.bottom + view.documentTop - pos.bottom + view.defaultLineHeight / 2;
        }
        return view.moveVertically(range, true, dist);
    }).map(changes);
    view.dispatch({
        changes: changes,
        selection: selection,
        scrollIntoView: true,
        userEvent: "delete.line"
    });
    return true;
};
/**
Replace the selection with a newline.
*/ const $6df8ca87402049ac$export$e7e1d174affeae8d = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update(state.replaceSelection(state.lineBreak), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Replace the selection with a newline and the same amount of
indentation as the line above.
*/ const $6df8ca87402049ac$export$8dc33eb9291e07ef = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update(state.changeByRange((range)=>{
        let indent = /^\s*/.exec(state.doc.lineAt(range.from).text)[0];
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: state.lineBreak + indent
            },
            range: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(range.from + indent.length + 1)
        };
    }), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
function $6df8ca87402049ac$var$isBetweenBrackets(state, pos) {
    if (/\(\)|\[\]|\{\}/.test(state.sliceDoc(pos - 1, pos + 1))) return {
        from: pos,
        to: pos
    };
    let context = (0, $deda11ebd5d0815e$export$7fc98e56a4ca6be1)(state).resolveInner(pos);
    let before = context.childBefore(pos), after = context.childAfter(pos), closedBy;
    if (before && after && before.to <= pos && after.from >= pos && (closedBy = before.type.prop((0, $a7a41eb5193c1110$export$b8034b9bc18acd90).closedBy)) && closedBy.indexOf(after.name) > -1 && state.doc.lineAt(before.to).from == state.doc.lineAt(after.from).from && !/\S/.test(state.sliceDoc(before.to, after.from))) return {
        from: before.to,
        to: after.from
    };
    return null;
}
/**
Replace the selection with a newline and indent the newly created
line(s). If the current line consists only of whitespace, this
will also delete that whitespace. When the cursor is between
matching brackets, an additional newline will be inserted after
the cursor.
*/ const $6df8ca87402049ac$export$668310d2b1aa07d5 = /*@__PURE__*/ $6df8ca87402049ac$var$newlineAndIndent(false);
/**
Create a blank, indented line below the current line.
*/ const $6df8ca87402049ac$export$2ff1ccbcf65d0770 = /*@__PURE__*/ $6df8ca87402049ac$var$newlineAndIndent(true);
function $6df8ca87402049ac$var$newlineAndIndent(atEof) {
    return ({ state: state, dispatch: dispatch })=>{
        if (state.readOnly) return false;
        let changes = state.changeByRange((range)=>{
            let { from: from, to: to } = range, line = state.doc.lineAt(from);
            let explode = !atEof && from == to && $6df8ca87402049ac$var$isBetweenBrackets(state, from);
            if (atEof) from = to = (to <= line.to ? line : state.doc.lineAt(to)).to;
            let cx = new (0, $deda11ebd5d0815e$export$eeab79349cc2f7c8)(state, {
                simulateBreak: from,
                simulateDoubleBreak: !!explode
            });
            let indent = (0, $deda11ebd5d0815e$export$a2d3c9dbce6d2211)(cx, from);
            if (indent == null) indent = (0, $6b8f387faea0a4dd$export$20b4ab289374d0ac)(/^\s*/.exec(state.doc.lineAt(from).text)[0], state.tabSize);
            while(to < line.to && /\s/.test(line.text[to - line.from]))to++;
            if (explode) ({ from: from, to: to } = explode);
            else if (from > line.from && from < line.from + 100 && !/\S/.test(line.text.slice(0, from))) from = line.from;
            let insert = [
                "",
                (0, $deda11ebd5d0815e$export$db5a40e207b40576)(state, indent)
            ];
            if (explode) insert.push((0, $deda11ebd5d0815e$export$db5a40e207b40576)(state, cx.lineIndent(line.from, -1)));
            return {
                changes: {
                    from: from,
                    to: to,
                    insert: (0, $6b8f387faea0a4dd$export$5f1af8db9871e1d6).of(insert)
                },
                range: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(from + 1 + insert[1].length)
            };
        });
        dispatch(state.update(changes, {
            scrollIntoView: true,
            userEvent: "input"
        }));
        return true;
    };
}
function $6df8ca87402049ac$var$changeBySelectedLine(state, f) {
    let atLine = -1;
    return state.changeByRange((range)=>{
        let changes = [];
        for(let pos = range.from; pos <= range.to;){
            let line = state.doc.lineAt(pos);
            if (line.number > atLine && (range.empty || range.to > line.from)) {
                f(line, changes, range);
                atLine = line.number;
            }
            pos = line.to + 1;
        }
        let changeSet = state.changes(changes);
        return {
            changes: changes,
            range: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(changeSet.mapPos(range.anchor, 1), changeSet.mapPos(range.head, 1))
        };
    });
}
/**
Auto-indent the selected lines. This uses the [indentation service
facet](https://codemirror.net/6/docs/ref/#language.indentService) as source for auto-indent
information.
*/ const $6df8ca87402049ac$export$ffcf50534fec79c3 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let updated = Object.create(null);
    let context = new (0, $deda11ebd5d0815e$export$eeab79349cc2f7c8)(state, {
        overrideIndentation: (start)=>{
            let found = updated[start];
            return found == null ? -1 : found;
        }
    });
    let changes = $6df8ca87402049ac$var$changeBySelectedLine(state, (line, changes, range)=>{
        let indent = (0, $deda11ebd5d0815e$export$a2d3c9dbce6d2211)(context, line.from);
        if (indent == null) return;
        if (!/\S/.test(line.text)) indent = 0;
        let cur = /^\s*/.exec(line.text)[0];
        let norm = (0, $deda11ebd5d0815e$export$db5a40e207b40576)(state, indent);
        if (cur != norm || range.from < line.from + cur.length) {
            updated[line.from] = indent;
            changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
    });
    if (!changes.changes.empty) dispatch(state.update(changes, {
        userEvent: "indent"
    }));
    return true;
};
/**
Add a [unit](https://codemirror.net/6/docs/ref/#language.indentUnit) of indentation to all selected
lines.
*/ const $6df8ca87402049ac$export$a61bf6a946ffc826 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    dispatch(state.update($6df8ca87402049ac$var$changeBySelectedLine(state, (line, changes)=>{
        changes.push({
            from: line.from,
            insert: state.facet((0, $deda11ebd5d0815e$export$9e0d0c2ce4d3ceb5))
        });
    }), {
        userEvent: "input.indent"
    }));
    return true;
};
/**
Remove a [unit](https://codemirror.net/6/docs/ref/#language.indentUnit) of indentation from all
selected lines.
*/ const $6df8ca87402049ac$export$e4b902122bfe67ae = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    dispatch(state.update($6df8ca87402049ac$var$changeBySelectedLine(state, (line, changes)=>{
        let space = /^\s*/.exec(line.text)[0];
        if (!space) return;
        let col = (0, $6b8f387faea0a4dd$export$20b4ab289374d0ac)(space, state.tabSize), keep = 0;
        let insert = (0, $deda11ebd5d0815e$export$db5a40e207b40576)(state, Math.max(0, col - (0, $deda11ebd5d0815e$export$ad3205d09311a797)(state)));
        while(keep < space.length && keep < insert.length && space.charCodeAt(keep) == insert.charCodeAt(keep))keep++;
        changes.push({
            from: line.from + keep,
            to: line.from + space.length,
            insert: insert.slice(keep)
        });
    }), {
        userEvent: "delete.dedent"
    }));
    return true;
};
/**
Enables or disables
[tab-focus mode](https://codemirror.net/6/docs/ref/#view.EditorView.setTabFocusMode). While on, this
prevents the editor's key bindings from capturing Tab or
Shift-Tab, making it possible for the user to move focus out of
the editor with the keyboard.
*/ const $6df8ca87402049ac$export$f118650570e71643 = (view)=>{
    view.setTabFocusMode();
    return true;
};
/**
Temporarily enables [tab-focus
mode](https://codemirror.net/6/docs/ref/#view.EditorView.setTabFocusMode) for two seconds or until
another key is pressed.
*/ const $6df8ca87402049ac$export$1f0650d3f23682c8 = (view)=>{
    view.setTabFocusMode(2000);
    return true;
};
/**
Insert a tab character at the cursor or, if something is selected,
use [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore) to indent the entire
selection.
*/ const $6df8ca87402049ac$export$89b2fa0b43bd10f8 = ({ state: state, dispatch: dispatch })=>{
    if (state.selection.ranges.some((r)=>!r.empty)) return $6df8ca87402049ac$export$a61bf6a946ffc826({
        state: state,
        dispatch: dispatch
    });
    dispatch(state.update(state.replaceSelection("\t"), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Array of key bindings containing the Emacs-style bindings that are
available on macOS by default.

 - Ctrl-b: [`cursorCharLeft`](https://codemirror.net/6/docs/ref/#commands.cursorCharLeft) ([`selectCharLeft`](https://codemirror.net/6/docs/ref/#commands.selectCharLeft) with Shift)
 - Ctrl-f: [`cursorCharRight`](https://codemirror.net/6/docs/ref/#commands.cursorCharRight) ([`selectCharRight`](https://codemirror.net/6/docs/ref/#commands.selectCharRight) with Shift)
 - Ctrl-p: [`cursorLineUp`](https://codemirror.net/6/docs/ref/#commands.cursorLineUp) ([`selectLineUp`](https://codemirror.net/6/docs/ref/#commands.selectLineUp) with Shift)
 - Ctrl-n: [`cursorLineDown`](https://codemirror.net/6/docs/ref/#commands.cursorLineDown) ([`selectLineDown`](https://codemirror.net/6/docs/ref/#commands.selectLineDown) with Shift)
 - Ctrl-a: [`cursorLineStart`](https://codemirror.net/6/docs/ref/#commands.cursorLineStart) ([`selectLineStart`](https://codemirror.net/6/docs/ref/#commands.selectLineStart) with Shift)
 - Ctrl-e: [`cursorLineEnd`](https://codemirror.net/6/docs/ref/#commands.cursorLineEnd) ([`selectLineEnd`](https://codemirror.net/6/docs/ref/#commands.selectLineEnd) with Shift)
 - Ctrl-d: [`deleteCharForward`](https://codemirror.net/6/docs/ref/#commands.deleteCharForward)
 - Ctrl-h: [`deleteCharBackward`](https://codemirror.net/6/docs/ref/#commands.deleteCharBackward)
 - Ctrl-k: [`deleteToLineEnd`](https://codemirror.net/6/docs/ref/#commands.deleteToLineEnd)
 - Ctrl-Alt-h: [`deleteGroupBackward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupBackward)
 - Ctrl-o: [`splitLine`](https://codemirror.net/6/docs/ref/#commands.splitLine)
 - Ctrl-t: [`transposeChars`](https://codemirror.net/6/docs/ref/#commands.transposeChars)
 - Ctrl-v: [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown)
 - Alt-v: [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp)
*/ const $6df8ca87402049ac$export$ef7c3246c722c48f = [
    {
        key: "Ctrl-b",
        run: $6df8ca87402049ac$export$3447f2b737925430,
        shift: $6df8ca87402049ac$export$639be832433387f,
        preventDefault: true
    },
    {
        key: "Ctrl-f",
        run: $6df8ca87402049ac$export$e45941411d098b,
        shift: $6df8ca87402049ac$export$49e3d65796d89132
    },
    {
        key: "Ctrl-p",
        run: $6df8ca87402049ac$export$fe179dad0485d99d,
        shift: $6df8ca87402049ac$export$92aa693a1ecd7061
    },
    {
        key: "Ctrl-n",
        run: $6df8ca87402049ac$export$75f9b75ffb1a9dc5,
        shift: $6df8ca87402049ac$export$bf847527697a3040
    },
    {
        key: "Ctrl-a",
        run: $6df8ca87402049ac$export$9c7dea99650bd512,
        shift: $6df8ca87402049ac$export$a0e1e86f753956a4
    },
    {
        key: "Ctrl-e",
        run: $6df8ca87402049ac$export$2a3cdaf3ab2dcbf2,
        shift: $6df8ca87402049ac$export$bd34a38d148e23af
    },
    {
        key: "Ctrl-d",
        run: $6df8ca87402049ac$export$d41683a0f042cb80
    },
    {
        key: "Ctrl-h",
        run: $6df8ca87402049ac$export$1e8a14efe7ca9a33
    },
    {
        key: "Ctrl-k",
        run: $6df8ca87402049ac$export$ae3820c4ce0e9c92
    },
    {
        key: "Ctrl-Alt-h",
        run: $6df8ca87402049ac$export$3072f591ab219e94
    },
    {
        key: "Ctrl-o",
        run: $6df8ca87402049ac$export$a258d4581e1d5d3c
    },
    {
        key: "Ctrl-t",
        run: $6df8ca87402049ac$export$55467a37288e4063
    },
    {
        key: "Ctrl-v",
        run: $6df8ca87402049ac$export$6e407c2072d437f4
    }
];
/**
An array of key bindings closely sticking to platform-standard or
widely used bindings. (This includes the bindings from
[`emacsStyleKeymap`](https://codemirror.net/6/docs/ref/#commands.emacsStyleKeymap), with their `key`
property changed to `mac`.)

 - ArrowLeft: [`cursorCharLeft`](https://codemirror.net/6/docs/ref/#commands.cursorCharLeft) ([`selectCharLeft`](https://codemirror.net/6/docs/ref/#commands.selectCharLeft) with Shift)
 - ArrowRight: [`cursorCharRight`](https://codemirror.net/6/docs/ref/#commands.cursorCharRight) ([`selectCharRight`](https://codemirror.net/6/docs/ref/#commands.selectCharRight) with Shift)
 - Ctrl-ArrowLeft (Alt-ArrowLeft on macOS): [`cursorGroupLeft`](https://codemirror.net/6/docs/ref/#commands.cursorGroupLeft) ([`selectGroupLeft`](https://codemirror.net/6/docs/ref/#commands.selectGroupLeft) with Shift)
 - Ctrl-ArrowRight (Alt-ArrowRight on macOS): [`cursorGroupRight`](https://codemirror.net/6/docs/ref/#commands.cursorGroupRight) ([`selectGroupRight`](https://codemirror.net/6/docs/ref/#commands.selectGroupRight) with Shift)
 - Cmd-ArrowLeft (on macOS): [`cursorLineStart`](https://codemirror.net/6/docs/ref/#commands.cursorLineStart) ([`selectLineStart`](https://codemirror.net/6/docs/ref/#commands.selectLineStart) with Shift)
 - Cmd-ArrowRight (on macOS): [`cursorLineEnd`](https://codemirror.net/6/docs/ref/#commands.cursorLineEnd) ([`selectLineEnd`](https://codemirror.net/6/docs/ref/#commands.selectLineEnd) with Shift)
 - ArrowUp: [`cursorLineUp`](https://codemirror.net/6/docs/ref/#commands.cursorLineUp) ([`selectLineUp`](https://codemirror.net/6/docs/ref/#commands.selectLineUp) with Shift)
 - ArrowDown: [`cursorLineDown`](https://codemirror.net/6/docs/ref/#commands.cursorLineDown) ([`selectLineDown`](https://codemirror.net/6/docs/ref/#commands.selectLineDown) with Shift)
 - Cmd-ArrowUp (on macOS): [`cursorDocStart`](https://codemirror.net/6/docs/ref/#commands.cursorDocStart) ([`selectDocStart`](https://codemirror.net/6/docs/ref/#commands.selectDocStart) with Shift)
 - Cmd-ArrowDown (on macOS): [`cursorDocEnd`](https://codemirror.net/6/docs/ref/#commands.cursorDocEnd) ([`selectDocEnd`](https://codemirror.net/6/docs/ref/#commands.selectDocEnd) with Shift)
 - Ctrl-ArrowUp (on macOS): [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp) ([`selectPageUp`](https://codemirror.net/6/docs/ref/#commands.selectPageUp) with Shift)
 - Ctrl-ArrowDown (on macOS): [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown) ([`selectPageDown`](https://codemirror.net/6/docs/ref/#commands.selectPageDown) with Shift)
 - PageUp: [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp) ([`selectPageUp`](https://codemirror.net/6/docs/ref/#commands.selectPageUp) with Shift)
 - PageDown: [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown) ([`selectPageDown`](https://codemirror.net/6/docs/ref/#commands.selectPageDown) with Shift)
 - Home: [`cursorLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.cursorLineBoundaryBackward) ([`selectLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.selectLineBoundaryBackward) with Shift)
 - End: [`cursorLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.cursorLineBoundaryForward) ([`selectLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.selectLineBoundaryForward) with Shift)
 - Ctrl-Home (Cmd-Home on macOS): [`cursorDocStart`](https://codemirror.net/6/docs/ref/#commands.cursorDocStart) ([`selectDocStart`](https://codemirror.net/6/docs/ref/#commands.selectDocStart) with Shift)
 - Ctrl-End (Cmd-Home on macOS): [`cursorDocEnd`](https://codemirror.net/6/docs/ref/#commands.cursorDocEnd) ([`selectDocEnd`](https://codemirror.net/6/docs/ref/#commands.selectDocEnd) with Shift)
 - Enter and Shift-Enter: [`insertNewlineAndIndent`](https://codemirror.net/6/docs/ref/#commands.insertNewlineAndIndent)
 - Ctrl-a (Cmd-a on macOS): [`selectAll`](https://codemirror.net/6/docs/ref/#commands.selectAll)
 - Backspace: [`deleteCharBackward`](https://codemirror.net/6/docs/ref/#commands.deleteCharBackward)
 - Delete: [`deleteCharForward`](https://codemirror.net/6/docs/ref/#commands.deleteCharForward)
 - Ctrl-Backspace (Alt-Backspace on macOS): [`deleteGroupBackward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupBackward)
 - Ctrl-Delete (Alt-Delete on macOS): [`deleteGroupForward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupForward)
 - Cmd-Backspace (macOS): [`deleteLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.deleteLineBoundaryBackward).
 - Cmd-Delete (macOS): [`deleteLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.deleteLineBoundaryForward).
*/ const $6df8ca87402049ac$export$ae5dfd95be821a1c = /*@__PURE__*/ [
    {
        key: "ArrowLeft",
        run: $6df8ca87402049ac$export$3447f2b737925430,
        shift: $6df8ca87402049ac$export$639be832433387f,
        preventDefault: true
    },
    {
        key: "Mod-ArrowLeft",
        mac: "Alt-ArrowLeft",
        run: $6df8ca87402049ac$export$137fb1611fb38377,
        shift: $6df8ca87402049ac$export$ef839611b4c2ba40,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowLeft",
        run: $6df8ca87402049ac$export$515c8c77cfbd2e73,
        shift: $6df8ca87402049ac$export$769cc61da74090c5,
        preventDefault: true
    },
    {
        key: "ArrowRight",
        run: $6df8ca87402049ac$export$e45941411d098b,
        shift: $6df8ca87402049ac$export$49e3d65796d89132,
        preventDefault: true
    },
    {
        key: "Mod-ArrowRight",
        mac: "Alt-ArrowRight",
        run: $6df8ca87402049ac$export$8fb2c619d55341b4,
        shift: $6df8ca87402049ac$export$5ebbb4cf65fe8a74,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowRight",
        run: $6df8ca87402049ac$export$912e453a1e062a62,
        shift: $6df8ca87402049ac$export$de427496204690a6,
        preventDefault: true
    },
    {
        key: "ArrowUp",
        run: $6df8ca87402049ac$export$fe179dad0485d99d,
        shift: $6df8ca87402049ac$export$92aa693a1ecd7061,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowUp",
        run: $6df8ca87402049ac$export$ff7ed6e6e1cb317f,
        shift: $6df8ca87402049ac$export$aa525ee829cc26b
    },
    {
        mac: "Ctrl-ArrowUp",
        run: $6df8ca87402049ac$export$546ec71a9f854193,
        shift: $6df8ca87402049ac$export$61eab34d4ff5cbaf
    },
    {
        key: "ArrowDown",
        run: $6df8ca87402049ac$export$75f9b75ffb1a9dc5,
        shift: $6df8ca87402049ac$export$bf847527697a3040,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowDown",
        run: $6df8ca87402049ac$export$b12ef1671b2836da,
        shift: $6df8ca87402049ac$export$fff0131cdd9694fe
    },
    {
        mac: "Ctrl-ArrowDown",
        run: $6df8ca87402049ac$export$6e407c2072d437f4,
        shift: $6df8ca87402049ac$export$a4c186a0dadaf91c
    },
    {
        key: "PageUp",
        run: $6df8ca87402049ac$export$546ec71a9f854193,
        shift: $6df8ca87402049ac$export$61eab34d4ff5cbaf
    },
    {
        key: "PageDown",
        run: $6df8ca87402049ac$export$6e407c2072d437f4,
        shift: $6df8ca87402049ac$export$a4c186a0dadaf91c
    },
    {
        key: "Home",
        run: $6df8ca87402049ac$export$64939ebc49b03818,
        shift: $6df8ca87402049ac$export$643176ee603b8e87,
        preventDefault: true
    },
    {
        key: "Mod-Home",
        run: $6df8ca87402049ac$export$ff7ed6e6e1cb317f,
        shift: $6df8ca87402049ac$export$aa525ee829cc26b
    },
    {
        key: "End",
        run: $6df8ca87402049ac$export$b59ae3b25af6ea13,
        shift: $6df8ca87402049ac$export$df223d0097d57a86,
        preventDefault: true
    },
    {
        key: "Mod-End",
        run: $6df8ca87402049ac$export$b12ef1671b2836da,
        shift: $6df8ca87402049ac$export$fff0131cdd9694fe
    },
    {
        key: "Enter",
        run: $6df8ca87402049ac$export$668310d2b1aa07d5,
        shift: $6df8ca87402049ac$export$668310d2b1aa07d5
    },
    {
        key: "Mod-a",
        run: $6df8ca87402049ac$export$90aca4adda6ff0f5
    },
    {
        key: "Backspace",
        run: $6df8ca87402049ac$export$1e8a14efe7ca9a33,
        shift: $6df8ca87402049ac$export$1e8a14efe7ca9a33
    },
    {
        key: "Delete",
        run: $6df8ca87402049ac$export$d41683a0f042cb80
    },
    {
        key: "Mod-Backspace",
        mac: "Alt-Backspace",
        run: $6df8ca87402049ac$export$3072f591ab219e94
    },
    {
        key: "Mod-Delete",
        mac: "Alt-Delete",
        run: $6df8ca87402049ac$export$56a4e2ef21b58242
    },
    {
        mac: "Mod-Backspace",
        run: $6df8ca87402049ac$export$d1072494cede984a
    },
    {
        mac: "Mod-Delete",
        run: $6df8ca87402049ac$export$b87eb3a389c264a4
    }
].concat(/*@__PURE__*/ $6df8ca87402049ac$export$ef7c3246c722c48f.map((b)=>({
        mac: b.key,
        run: b.run,
        shift: b.shift
    })));
/**
The default keymap. Includes all bindings from
[`standardKeymap`](https://codemirror.net/6/docs/ref/#commands.standardKeymap) plus the following:

- Alt-ArrowLeft (Ctrl-ArrowLeft on macOS): [`cursorSyntaxLeft`](https://codemirror.net/6/docs/ref/#commands.cursorSyntaxLeft) ([`selectSyntaxLeft`](https://codemirror.net/6/docs/ref/#commands.selectSyntaxLeft) with Shift)
- Alt-ArrowRight (Ctrl-ArrowRight on macOS): [`cursorSyntaxRight`](https://codemirror.net/6/docs/ref/#commands.cursorSyntaxRight) ([`selectSyntaxRight`](https://codemirror.net/6/docs/ref/#commands.selectSyntaxRight) with Shift)
- Alt-ArrowUp: [`moveLineUp`](https://codemirror.net/6/docs/ref/#commands.moveLineUp)
- Alt-ArrowDown: [`moveLineDown`](https://codemirror.net/6/docs/ref/#commands.moveLineDown)
- Shift-Alt-ArrowUp: [`copyLineUp`](https://codemirror.net/6/docs/ref/#commands.copyLineUp)
- Shift-Alt-ArrowDown: [`copyLineDown`](https://codemirror.net/6/docs/ref/#commands.copyLineDown)
- Escape: [`simplifySelection`](https://codemirror.net/6/docs/ref/#commands.simplifySelection)
- Ctrl-Enter (Cmd-Enter on macOS): [`insertBlankLine`](https://codemirror.net/6/docs/ref/#commands.insertBlankLine)
- Alt-l (Ctrl-l on macOS): [`selectLine`](https://codemirror.net/6/docs/ref/#commands.selectLine)
- Ctrl-i (Cmd-i on macOS): [`selectParentSyntax`](https://codemirror.net/6/docs/ref/#commands.selectParentSyntax)
- Ctrl-[ (Cmd-[ on macOS): [`indentLess`](https://codemirror.net/6/docs/ref/#commands.indentLess)
- Ctrl-] (Cmd-] on macOS): [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore)
- Ctrl-Alt-\\ (Cmd-Alt-\\ on macOS): [`indentSelection`](https://codemirror.net/6/docs/ref/#commands.indentSelection)
- Shift-Ctrl-k (Shift-Cmd-k on macOS): [`deleteLine`](https://codemirror.net/6/docs/ref/#commands.deleteLine)
- Shift-Ctrl-\\ (Shift-Cmd-\\ on macOS): [`cursorMatchingBracket`](https://codemirror.net/6/docs/ref/#commands.cursorMatchingBracket)
- Ctrl-/ (Cmd-/ on macOS): [`toggleComment`](https://codemirror.net/6/docs/ref/#commands.toggleComment).
- Shift-Alt-a: [`toggleBlockComment`](https://codemirror.net/6/docs/ref/#commands.toggleBlockComment).
- Ctrl-m (Alt-Shift-m on macOS): [`toggleTabFocusMode`](https://codemirror.net/6/docs/ref/#commands.toggleTabFocusMode).
*/ const $6df8ca87402049ac$export$ab2e8d0ac5d2b69e = /*@__PURE__*/ [
    {
        key: "Alt-ArrowLeft",
        mac: "Ctrl-ArrowLeft",
        run: $6df8ca87402049ac$export$1e53c014543c10bb,
        shift: $6df8ca87402049ac$export$67b15be4414061b5
    },
    {
        key: "Alt-ArrowRight",
        mac: "Ctrl-ArrowRight",
        run: $6df8ca87402049ac$export$62c6dc33f5d01e39,
        shift: $6df8ca87402049ac$export$74aa476df7791ce
    },
    {
        key: "Alt-ArrowUp",
        run: $6df8ca87402049ac$export$c4eebaf75cfae23e
    },
    {
        key: "Shift-Alt-ArrowUp",
        run: $6df8ca87402049ac$export$c3798d29213e527c
    },
    {
        key: "Alt-ArrowDown",
        run: $6df8ca87402049ac$export$ac19ae98a6fcd34c
    },
    {
        key: "Shift-Alt-ArrowDown",
        run: $6df8ca87402049ac$export$1ad385c375816d2f
    },
    {
        key: "Escape",
        run: $6df8ca87402049ac$export$2f90cebc0d40abf
    },
    {
        key: "Mod-Enter",
        run: $6df8ca87402049ac$export$2ff1ccbcf65d0770
    },
    {
        key: "Alt-l",
        mac: "Ctrl-l",
        run: $6df8ca87402049ac$export$e41c12847640c21
    },
    {
        key: "Mod-i",
        run: $6df8ca87402049ac$export$f38a48fa120d50ce,
        preventDefault: true
    },
    {
        key: "Mod-[",
        run: $6df8ca87402049ac$export$e4b902122bfe67ae
    },
    {
        key: "Mod-]",
        run: $6df8ca87402049ac$export$a61bf6a946ffc826
    },
    {
        key: "Mod-Alt-\\",
        run: $6df8ca87402049ac$export$ffcf50534fec79c3
    },
    {
        key: "Shift-Mod-k",
        run: $6df8ca87402049ac$export$aba0d4cd8923f1ae
    },
    {
        key: "Shift-Mod-\\",
        run: $6df8ca87402049ac$export$e5a7e1f2d38b1f6a
    },
    {
        key: "Mod-/",
        run: $6df8ca87402049ac$export$afbcdd0bff36c567
    },
    {
        key: "Alt-A",
        run: $6df8ca87402049ac$export$19d6fa84ce3a55ab
    },
    {
        key: "Ctrl-m",
        mac: "Shift-Alt-m",
        run: $6df8ca87402049ac$export$f118650570e71643
    }
].concat($6df8ca87402049ac$export$ae5dfd95be821a1c);
/**
A binding that binds Tab to [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore) and
Shift-Tab to [`indentLess`](https://codemirror.net/6/docs/ref/#commands.indentLess).
Please see the [Tab example](../../examples/tab/) before using
this.
*/ const $6df8ca87402049ac$export$893b77570f8af4da = {
    key: "Tab",
    run: $6df8ca87402049ac$export$a61bf6a946ffc826,
    shift: $6df8ca87402049ac$export$e4b902122bfe67ae
};








const $64f97a5f38975812$var$basicNormalize = typeof String.prototype.normalize == "function" ? (x)=>x.normalize("NFKD") : (x)=>x;
/**
A search cursor provides an iterator over text matches in a
document.
*/ class $64f97a5f38975812$export$4989b254f32490be {
    /**
    Create a text cursor. The query is the search string, `from` to
    `to` provides the region to search.
    
    When `normalize` is given, it will be called, on both the query
    string and the content it is matched against, before comparing.
    You can, for example, create a case-insensitive search by
    passing `s => s.toLowerCase()`.
    
    Text is always normalized with
    [`.normalize("NFKD")`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize)
    (when supported).
    */ constructor(text, query, from = 0, to = text.length, normalize, test){
        this.test = test;
        /**
        The current match (only holds a meaningful value after
        [`next`](https://codemirror.net/6/docs/ref/#search.SearchCursor.next) has been called and when
        `done` is false).
        */ this.value = {
            from: 0,
            to: 0
        };
        /**
        Whether the end of the iterated region has been reached.
        */ this.done = false;
        this.matches = [];
        this.buffer = "";
        this.bufferPos = 0;
        this.iter = text.iterRange(from, to);
        this.bufferStart = from;
        this.normalize = normalize ? (x)=>normalize($64f97a5f38975812$var$basicNormalize(x)) : $64f97a5f38975812$var$basicNormalize;
        this.query = this.normalize(query);
    }
    peek() {
        if (this.bufferPos == this.buffer.length) {
            this.bufferStart += this.buffer.length;
            this.iter.next();
            if (this.iter.done) return -1;
            this.bufferPos = 0;
            this.buffer = this.iter.value;
        }
        return (0, $6b8f387faea0a4dd$export$42977f40461e1360)(this.buffer, this.bufferPos);
    }
    /**
    Look for the next match. Updates the iterator's
    [`value`](https://codemirror.net/6/docs/ref/#search.SearchCursor.value) and
    [`done`](https://codemirror.net/6/docs/ref/#search.SearchCursor.done) properties. Should be called
    at least once before using the cursor.
    */ next() {
        while(this.matches.length)this.matches.pop();
        return this.nextOverlapping();
    }
    /**
    The `next` method will ignore matches that partially overlap a
    previous match. This method behaves like `next`, but includes
    such matches.
    */ nextOverlapping() {
        for(;;){
            let next = this.peek();
            if (next < 0) {
                this.done = true;
                return this;
            }
            let str = (0, $6b8f387faea0a4dd$export$73bfc63873071f74)(next), start = this.bufferStart + this.bufferPos;
            this.bufferPos += (0, $6b8f387faea0a4dd$export$a870abf234f6353c)(next);
            let norm = this.normalize(str);
            if (norm.length) for(let i = 0, pos = start;; i++){
                let code = norm.charCodeAt(i);
                let match = this.match(code, pos, this.bufferPos + this.bufferStart);
                if (i == norm.length - 1) {
                    if (match) {
                        this.value = match;
                        return this;
                    }
                    break;
                }
                if (pos == start && i < str.length && str.charCodeAt(i) == code) pos++;
            }
        }
    }
    match(code, pos, end) {
        let match = null;
        for(let i = 0; i < this.matches.length; i += 2){
            let index = this.matches[i], keep = false;
            if (this.query.charCodeAt(index) == code) {
                if (index == this.query.length - 1) match = {
                    from: this.matches[i + 1],
                    to: end
                };
                else {
                    this.matches[i]++;
                    keep = true;
                }
            }
            if (!keep) {
                this.matches.splice(i, 2);
                i -= 2;
            }
        }
        if (this.query.charCodeAt(0) == code) {
            if (this.query.length == 1) match = {
                from: pos,
                to: end
            };
            else this.matches.push(1, pos);
        }
        if (match && this.test && !this.test(match.from, match.to, this.buffer, this.bufferStart)) match = null;
        return match;
    }
}
if (typeof Symbol != "undefined") $64f97a5f38975812$export$4989b254f32490be.prototype[Symbol.iterator] = function() {
    return this;
};
const $64f97a5f38975812$var$empty = {
    from: -1,
    to: -1,
    match: /*@__PURE__*/ /.*/.exec("")
};
const $64f97a5f38975812$var$baseFlags = "gm" + (/x/.unicode == null ? "" : "u");
/**
This class is similar to [`SearchCursor`](https://codemirror.net/6/docs/ref/#search.SearchCursor)
but searches for a regular expression pattern instead of a plain
string.
*/ class $64f97a5f38975812$export$234e2283eb9dcd35 {
    /**
    Create a cursor that will search the given range in the given
    document. `query` should be the raw pattern (as you'd pass it to
    `new RegExp`).
    */ constructor(text, query, options, from = 0, to = text.length){
        this.text = text;
        this.to = to;
        this.curLine = "";
        /**
        Set to `true` when the cursor has reached the end of the search
        range.
        */ this.done = false;
        /**
        Will contain an object with the extent of the match and the
        match object when [`next`](https://codemirror.net/6/docs/ref/#search.RegExpCursor.next)
        sucessfully finds a match.
        */ this.value = $64f97a5f38975812$var$empty;
        if (/\\[sWDnr]|\n|\r|\[\^/.test(query)) return new $64f97a5f38975812$var$MultilineRegExpCursor(text, query, options, from, to);
        this.re = new RegExp(query, $64f97a5f38975812$var$baseFlags + ((options === null || options === void 0 ? void 0 : options.ignoreCase) ? "i" : ""));
        this.test = options === null || options === void 0 ? void 0 : options.test;
        this.iter = text.iter();
        let startLine = text.lineAt(from);
        this.curLineStart = startLine.from;
        this.matchPos = $64f97a5f38975812$var$toCharEnd(text, from);
        this.getLine(this.curLineStart);
    }
    getLine(skip) {
        this.iter.next(skip);
        if (this.iter.lineBreak) this.curLine = "";
        else {
            this.curLine = this.iter.value;
            if (this.curLineStart + this.curLine.length > this.to) this.curLine = this.curLine.slice(0, this.to - this.curLineStart);
            this.iter.next();
        }
    }
    nextLine() {
        this.curLineStart = this.curLineStart + this.curLine.length + 1;
        if (this.curLineStart > this.to) this.curLine = "";
        else this.getLine(0);
    }
    /**
    Move to the next match, if there is one.
    */ next() {
        for(let off = this.matchPos - this.curLineStart;;){
            this.re.lastIndex = off;
            let match = this.matchPos <= this.to && this.re.exec(this.curLine);
            if (match) {
                let from = this.curLineStart + match.index, to = from + match[0].length;
                this.matchPos = $64f97a5f38975812$var$toCharEnd(this.text, to + (from == to ? 1 : 0));
                if (from == this.curLineStart + this.curLine.length) this.nextLine();
                if ((from < to || from > this.value.to) && (!this.test || this.test(from, to, match))) {
                    this.value = {
                        from: from,
                        to: to,
                        match: match
                    };
                    return this;
                }
                off = this.matchPos - this.curLineStart;
            } else if (this.curLineStart + this.curLine.length < this.to) {
                this.nextLine();
                off = 0;
            } else {
                this.done = true;
                return this;
            }
        }
    }
}
const $64f97a5f38975812$var$flattened = /*@__PURE__*/ new WeakMap();
// Reusable (partially) flattened document strings
class $64f97a5f38975812$var$FlattenedDoc {
    constructor(from, text){
        this.from = from;
        this.text = text;
    }
    get to() {
        return this.from + this.text.length;
    }
    static get(doc, from, to) {
        let cached = $64f97a5f38975812$var$flattened.get(doc);
        if (!cached || cached.from >= to || cached.to <= from) {
            let flat = new $64f97a5f38975812$var$FlattenedDoc(from, doc.sliceString(from, to));
            $64f97a5f38975812$var$flattened.set(doc, flat);
            return flat;
        }
        if (cached.from == from && cached.to == to) return cached;
        let { text: text, from: cachedFrom } = cached;
        if (cachedFrom > from) {
            text = doc.sliceString(from, cachedFrom) + text;
            cachedFrom = from;
        }
        if (cached.to < to) text += doc.sliceString(cached.to, to);
        $64f97a5f38975812$var$flattened.set(doc, new $64f97a5f38975812$var$FlattenedDoc(cachedFrom, text));
        return new $64f97a5f38975812$var$FlattenedDoc(from, text.slice(from - cachedFrom, to - cachedFrom));
    }
}
class $64f97a5f38975812$var$MultilineRegExpCursor {
    constructor(text, query, options, from, to){
        this.text = text;
        this.to = to;
        this.done = false;
        this.value = $64f97a5f38975812$var$empty;
        this.matchPos = $64f97a5f38975812$var$toCharEnd(text, from);
        this.re = new RegExp(query, $64f97a5f38975812$var$baseFlags + ((options === null || options === void 0 ? void 0 : options.ignoreCase) ? "i" : ""));
        this.test = options === null || options === void 0 ? void 0 : options.test;
        this.flat = $64f97a5f38975812$var$FlattenedDoc.get(text, from, this.chunkEnd(from + 5000 /* Chunk.Base */ ));
    }
    chunkEnd(pos) {
        return pos >= this.to ? this.to : this.text.lineAt(pos).to;
    }
    next() {
        for(;;){
            let off = this.re.lastIndex = this.matchPos - this.flat.from;
            let match = this.re.exec(this.flat.text);
            // Skip empty matches directly after the last match
            if (match && !match[0] && match.index == off) {
                this.re.lastIndex = off + 1;
                match = this.re.exec(this.flat.text);
            }
            if (match) {
                let from = this.flat.from + match.index, to = from + match[0].length;
                // If a match goes almost to the end of a noncomplete chunk, try
                // again, since it'll likely be able to match more
                if ((this.flat.to >= this.to || match.index + match[0].length <= this.flat.text.length - 10) && (!this.test || this.test(from, to, match))) {
                    this.value = {
                        from: from,
                        to: to,
                        match: match
                    };
                    this.matchPos = $64f97a5f38975812$var$toCharEnd(this.text, to + (from == to ? 1 : 0));
                    return this;
                }
            }
            if (this.flat.to == this.to) {
                this.done = true;
                return this;
            }
            // Grow the flattened doc
            this.flat = $64f97a5f38975812$var$FlattenedDoc.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
        }
    }
}
if (typeof Symbol != "undefined") $64f97a5f38975812$export$234e2283eb9dcd35.prototype[Symbol.iterator] = $64f97a5f38975812$var$MultilineRegExpCursor.prototype[Symbol.iterator] = function() {
    return this;
};
function $64f97a5f38975812$var$validRegExp(source) {
    try {
        new RegExp(source, $64f97a5f38975812$var$baseFlags);
        return true;
    } catch (_a) {
        return false;
    }
}
function $64f97a5f38975812$var$toCharEnd(text, pos) {
    if (pos >= text.length) return pos;
    let line = text.lineAt(pos), next;
    while(pos < line.to && (next = line.text.charCodeAt(pos - line.from)) >= 0xDC00 && next < 0xE000)pos++;
    return pos;
}
function $64f97a5f38975812$var$createLineDialog(view) {
    let line = String(view.state.doc.lineAt(view.state.selection.main.head).number);
    let input = (0, $2a4351068134afec$export$2e2bcd8739ae039)("input", {
        class: "cm-textfield",
        name: "line",
        value: line
    });
    let dom = (0, $2a4351068134afec$export$2e2bcd8739ae039)("form", {
        class: "cm-gotoLine",
        onkeydown: (event)=>{
            if (event.keyCode == 27) {
                event.preventDefault();
                view.dispatch({
                    effects: $64f97a5f38975812$var$dialogEffect.of(false)
                });
                view.focus();
            } else if (event.keyCode == 13) {
                event.preventDefault();
                go();
            }
        },
        onsubmit: (event)=>{
            event.preventDefault();
            go();
        }
    }, (0, $2a4351068134afec$export$2e2bcd8739ae039)("label", view.state.phrase("Go to line"), ": ", input), " ", (0, $2a4351068134afec$export$2e2bcd8739ae039)("button", {
        class: "cm-button",
        type: "submit"
    }, view.state.phrase("go")), (0, $2a4351068134afec$export$2e2bcd8739ae039)("button", {
        name: "close",
        onclick: ()=>{
            view.dispatch({
                effects: $64f97a5f38975812$var$dialogEffect.of(false)
            });
            view.focus();
        },
        "aria-label": view.state.phrase("close"),
        type: "button"
    }, [
        "\xd7"
    ]));
    function go() {
        let match = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(input.value);
        if (!match) return;
        let { state: state } = view, startLine = state.doc.lineAt(state.selection.main.head);
        let [, sign, ln, cl, percent] = match;
        let col = cl ? +cl.slice(1) : 0;
        let line = ln ? +ln : startLine.number;
        if (ln && percent) {
            let pc = line / 100;
            if (sign) pc = pc * (sign == "-" ? -1 : 1) + startLine.number / state.doc.lines;
            line = Math.round(state.doc.lines * pc);
        } else if (ln && sign) line = line * (sign == "-" ? -1 : 1) + startLine.number;
        let docLine = state.doc.line(Math.max(1, Math.min(state.doc.lines, line)));
        let selection = (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(docLine.from + Math.max(0, Math.min(col, docLine.length)));
        view.dispatch({
            effects: [
                $64f97a5f38975812$var$dialogEffect.of(false),
                (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).scrollIntoView(selection.from, {
                    y: 'center'
                })
            ],
            selection: selection
        });
        view.focus();
    }
    return {
        dom: dom
    };
}
const $64f97a5f38975812$var$dialogEffect = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define();
const $64f97a5f38975812$var$dialogField = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$34381b1ce2130245).define({
    create () {
        return true;
    },
    update (value, tr) {
        for (let e of tr.effects)if (e.is($64f97a5f38975812$var$dialogEffect)) value = e.value;
        return value;
    },
    provide: (f)=>(0, $1d528cc0e08a0656$export$e89c3c9af31c1e3b).from(f, (val)=>val ? $64f97a5f38975812$var$createLineDialog : null)
});
/**
Command that shows a dialog asking the user for a line number, and
when a valid position is provided, moves the cursor to that line.

Supports line numbers, relative line offsets prefixed with `+` or
`-`, document percentages suffixed with `%`, and an optional
column position by adding `:` and a second number after the line
number.
*/ const $64f97a5f38975812$export$5d5b784f9a618ec3 = (view)=>{
    let panel = (0, $1d528cc0e08a0656$export$7361ed18ff57179e)(view, $64f97a5f38975812$var$createLineDialog);
    if (!panel) {
        let effects = [
            $64f97a5f38975812$var$dialogEffect.of(true)
        ];
        if (view.state.field($64f97a5f38975812$var$dialogField, false) == null) effects.push((0, $6b8f387faea0a4dd$export$95000d4efaa4321f).appendConfig.of([
            $64f97a5f38975812$var$dialogField,
            $64f97a5f38975812$var$baseTheme$1
        ]));
        view.dispatch({
            effects: effects
        });
        panel = (0, $1d528cc0e08a0656$export$7361ed18ff57179e)(view, $64f97a5f38975812$var$createLineDialog);
    }
    if (panel) panel.dom.querySelector("input").select();
    return true;
};
const $64f97a5f38975812$var$baseTheme$1 = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).baseTheme({
    ".cm-panel.cm-gotoLine": {
        padding: "2px 6px 4px",
        position: "relative",
        "& label": {
            fontSize: "80%"
        },
        "& [name=close]": {
            position: "absolute",
            top: "0",
            bottom: "0",
            right: "4px",
            backgroundColor: "inherit",
            border: "none",
            font: "inherit",
            padding: "0"
        }
    }
});
const $64f97a5f38975812$var$defaultHighlightOptions = {
    highlightWordAroundCursor: false,
    minSelectionLength: 1,
    maxMatches: 100,
    wholeWords: false
};
const $64f97a5f38975812$var$highlightConfig = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine (options) {
        return (0, $6b8f387faea0a4dd$export$4e19c0b693794a7e)(options, $64f97a5f38975812$var$defaultHighlightOptions, {
            highlightWordAroundCursor: (a, b)=>a || b,
            minSelectionLength: Math.min,
            maxMatches: Math.min
        });
    }
});
/**
This extension highlights text that matches the selection. It uses
the `"cm-selectionMatch"` class for the highlighting. When
`highlightWordAroundCursor` is enabled, the word at the cursor
itself will be highlighted with `"cm-selectionMatch-main"`.
*/ function $64f97a5f38975812$export$f14efe56171a2e02(options) {
    let ext = [
        $64f97a5f38975812$var$defaultTheme,
        $64f97a5f38975812$var$matchHighlighter
    ];
    if (options) ext.push($64f97a5f38975812$var$highlightConfig.of(options));
    return ext;
}
const $64f97a5f38975812$var$matchDeco = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$10e30b733df217ea).mark({
    class: "cm-selectionMatch"
});
const $64f97a5f38975812$var$mainMatchDeco = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$10e30b733df217ea).mark({
    class: "cm-selectionMatch cm-selectionMatch-main"
});
// Whether the characters directly outside the given positions are non-word characters
function $64f97a5f38975812$var$insideWordBoundaries(check, state, from, to) {
    return (from == 0 || check(state.sliceDoc(from - 1, from)) != (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word) && (to == state.doc.length || check(state.sliceDoc(to, to + 1)) != (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word);
}
// Whether the characters directly at the given positions are word characters
function $64f97a5f38975812$var$insideWord(check, state, from, to) {
    return check(state.sliceDoc(from, from + 1)) == (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word && check(state.sliceDoc(to - 1, to)) == (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word;
}
const $64f97a5f38975812$var$matchHighlighter = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.decorations = this.getDeco(view);
    }
    update(update) {
        if (update.selectionSet || update.docChanged || update.viewportChanged) this.decorations = this.getDeco(update.view);
    }
    getDeco(view) {
        let conf = view.state.facet($64f97a5f38975812$var$highlightConfig);
        let { state: state } = view, sel = state.selection;
        if (sel.ranges.length > 1) return (0, $1d528cc0e08a0656$export$10e30b733df217ea).none;
        let range = sel.main, query, check = null;
        if (range.empty) {
            if (!conf.highlightWordAroundCursor) return (0, $1d528cc0e08a0656$export$10e30b733df217ea).none;
            let word = state.wordAt(range.head);
            if (!word) return (0, $1d528cc0e08a0656$export$10e30b733df217ea).none;
            check = state.charCategorizer(range.head);
            query = state.sliceDoc(word.from, word.to);
        } else {
            let len = range.to - range.from;
            if (len < conf.minSelectionLength || len > 200) return (0, $1d528cc0e08a0656$export$10e30b733df217ea).none;
            if (conf.wholeWords) {
                query = state.sliceDoc(range.from, range.to); // TODO: allow and include leading/trailing space?
                check = state.charCategorizer(range.head);
                if (!($64f97a5f38975812$var$insideWordBoundaries(check, state, range.from, range.to) && $64f97a5f38975812$var$insideWord(check, state, range.from, range.to))) return (0, $1d528cc0e08a0656$export$10e30b733df217ea).none;
            } else {
                query = state.sliceDoc(range.from, range.to);
                if (!query) return (0, $1d528cc0e08a0656$export$10e30b733df217ea).none;
            }
        }
        let deco = [];
        for (let part of view.visibleRanges){
            let cursor = new $64f97a5f38975812$export$4989b254f32490be(state.doc, query, part.from, part.to);
            while(!cursor.next().done){
                let { from: from, to: to } = cursor.value;
                if (!check || $64f97a5f38975812$var$insideWordBoundaries(check, state, from, to)) {
                    if (range.empty && from <= range.from && to >= range.to) deco.push($64f97a5f38975812$var$mainMatchDeco.range(from, to));
                    else if (from >= range.to || to <= range.from) deco.push($64f97a5f38975812$var$matchDeco.range(from, to));
                    if (deco.length > conf.maxMatches) return (0, $1d528cc0e08a0656$export$10e30b733df217ea).none;
                }
            }
        }
        return (0, $1d528cc0e08a0656$export$10e30b733df217ea).set(deco);
    }
}, {
    decorations: (v)=>v.decorations
});
const $64f97a5f38975812$var$defaultTheme = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).baseTheme({
    ".cm-selectionMatch": {
        backgroundColor: "#99ff7780"
    },
    ".cm-searchMatch .cm-selectionMatch": {
        backgroundColor: "transparent"
    }
});
// Select the words around the cursors.
const $64f97a5f38975812$var$selectWord = ({ state: state, dispatch: dispatch })=>{
    let { selection: selection } = state;
    let newSel = (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).create(selection.ranges.map((range)=>state.wordAt(range.head) || (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(range.head)), selection.mainIndex);
    if (newSel.eq(selection)) return false;
    dispatch(state.update({
        selection: newSel
    }));
    return true;
};
// Find next occurrence of query relative to last cursor. Wrap around
// the document if there are no more matches.
function $64f97a5f38975812$var$findNextOccurrence(state, query) {
    let { main: main, ranges: ranges } = state.selection;
    let word = state.wordAt(main.head), fullWord = word && word.from == main.from && word.to == main.to;
    for(let cycled = false, cursor = new $64f97a5f38975812$export$4989b254f32490be(state.doc, query, ranges[ranges.length - 1].to);;){
        cursor.next();
        if (cursor.done) {
            if (cycled) return null;
            cursor = new $64f97a5f38975812$export$4989b254f32490be(state.doc, query, 0, Math.max(0, ranges[ranges.length - 1].from - 1));
            cycled = true;
        } else {
            if (cycled && ranges.some((r)=>r.from == cursor.value.from)) continue;
            if (fullWord) {
                let word = state.wordAt(cursor.value.from);
                if (!word || word.from != cursor.value.from || word.to != cursor.value.to) continue;
            }
            return cursor.value;
        }
    }
}
/**
Select next occurrence of the current selection. Expand selection
to the surrounding word when the selection is empty.
*/ const $64f97a5f38975812$export$dd0e64cebe05ee17 = ({ state: state, dispatch: dispatch })=>{
    let { ranges: ranges } = state.selection;
    if (ranges.some((sel)=>sel.from === sel.to)) return $64f97a5f38975812$var$selectWord({
        state: state,
        dispatch: dispatch
    });
    let searchedText = state.sliceDoc(ranges[0].from, ranges[0].to);
    if (state.selection.ranges.some((r)=>state.sliceDoc(r.from, r.to) != searchedText)) return false;
    let range = $64f97a5f38975812$var$findNextOccurrence(state, searchedText);
    if (!range) return false;
    dispatch(state.update({
        selection: state.selection.addRange((0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(range.from, range.to), false),
        effects: (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).scrollIntoView(range.to)
    }));
    return true;
};
const $64f97a5f38975812$var$searchConfigFacet = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6b8f387faea0a4dd$export$4e19c0b693794a7e)(configs, {
            top: false,
            caseSensitive: false,
            literal: false,
            regexp: false,
            wholeWord: false,
            createPanel: (view)=>new $64f97a5f38975812$var$SearchPanel(view),
            scrollToMatch: (range)=>(0, $1d528cc0e08a0656$export$eece2fccabbb77c5).scrollIntoView(range)
        });
    }
});
/**
Add search state to the editor configuration, and optionally
configure the search extension.
([`openSearchPanel`](https://codemirror.net/6/docs/ref/#search.openSearchPanel) will automatically
enable this if it isn't already on).
*/ function $64f97a5f38975812$export$d76128d007d19019(config) {
    return config ? [
        $64f97a5f38975812$var$searchConfigFacet.of(config),
        $64f97a5f38975812$var$searchExtensions
    ] : $64f97a5f38975812$var$searchExtensions;
}
/**
A search query. Part of the editor's search state.
*/ class $64f97a5f38975812$export$4bc63ef50ec3954e {
    /**
    Create a query object.
    */ constructor(config){
        this.search = config.search;
        this.caseSensitive = !!config.caseSensitive;
        this.literal = !!config.literal;
        this.regexp = !!config.regexp;
        this.replace = config.replace || "";
        this.valid = !!this.search && (!this.regexp || $64f97a5f38975812$var$validRegExp(this.search));
        this.unquoted = this.unquote(this.search);
        this.wholeWord = !!config.wholeWord;
    }
    /**
    @internal
    */ unquote(text) {
        return this.literal ? text : text.replace(/\\([nrt\\])/g, (_, ch)=>ch == "n" ? "\n" : ch == "r" ? "\r" : ch == "t" ? "\t" : "\\");
    }
    /**
    Compare this query to another query.
    */ eq(other) {
        return this.search == other.search && this.replace == other.replace && this.caseSensitive == other.caseSensitive && this.regexp == other.regexp && this.wholeWord == other.wholeWord;
    }
    /**
    @internal
    */ create() {
        return this.regexp ? new $64f97a5f38975812$var$RegExpQuery(this) : new $64f97a5f38975812$var$StringQuery(this);
    }
    /**
    Get a search cursor for this query, searching through the given
    range in the given state.
    */ getCursor(state, from = 0, to) {
        let st = state.doc ? state : (0, $6b8f387faea0a4dd$export$afa855cbfaff27f2).create({
            doc: state
        });
        if (to == null) to = st.doc.length;
        return this.regexp ? $64f97a5f38975812$var$regexpCursor(this, st, from, to) : $64f97a5f38975812$var$stringCursor(this, st, from, to);
    }
}
class $64f97a5f38975812$var$QueryType {
    constructor(spec){
        this.spec = spec;
    }
}
function $64f97a5f38975812$var$stringCursor(spec, state, from, to) {
    return new $64f97a5f38975812$export$4989b254f32490be(state.doc, spec.unquoted, from, to, spec.caseSensitive ? undefined : (x)=>x.toLowerCase(), spec.wholeWord ? $64f97a5f38975812$var$stringWordTest(state.doc, state.charCategorizer(state.selection.main.head)) : undefined);
}
function $64f97a5f38975812$var$stringWordTest(doc, categorizer) {
    return (from, to, buf, bufPos)=>{
        if (bufPos > from || bufPos + buf.length < to) {
            bufPos = Math.max(0, from - 2);
            buf = doc.sliceString(bufPos, Math.min(doc.length, to + 2));
        }
        return (categorizer($64f97a5f38975812$var$charBefore(buf, from - bufPos)) != (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word || categorizer($64f97a5f38975812$var$charAfter(buf, from - bufPos)) != (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word) && (categorizer($64f97a5f38975812$var$charAfter(buf, to - bufPos)) != (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word || categorizer($64f97a5f38975812$var$charBefore(buf, to - bufPos)) != (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word);
    };
}
class $64f97a5f38975812$var$StringQuery extends $64f97a5f38975812$var$QueryType {
    constructor(spec){
        super(spec);
    }
    nextMatch(state, curFrom, curTo) {
        let cursor = $64f97a5f38975812$var$stringCursor(this.spec, state, curTo, state.doc.length).nextOverlapping();
        if (cursor.done) {
            let end = Math.min(state.doc.length, curFrom + this.spec.unquoted.length);
            cursor = $64f97a5f38975812$var$stringCursor(this.spec, state, 0, end).nextOverlapping();
        }
        return cursor.done || cursor.value.from == curFrom && cursor.value.to == curTo ? null : cursor.value;
    }
    // Searching in reverse is, rather than implementing an inverted search
    // cursor, done by scanning chunk after chunk forward.
    prevMatchInRange(state, from, to) {
        for(let pos = to;;){
            let start = Math.max(from, pos - 10000 /* FindPrev.ChunkSize */  - this.spec.unquoted.length);
            let cursor = $64f97a5f38975812$var$stringCursor(this.spec, state, start, pos), range = null;
            while(!cursor.nextOverlapping().done)range = cursor.value;
            if (range) return range;
            if (start == from) return null;
            pos -= 10000 /* FindPrev.ChunkSize */ ;
        }
    }
    prevMatch(state, curFrom, curTo) {
        let found = this.prevMatchInRange(state, 0, curFrom);
        if (!found) found = this.prevMatchInRange(state, Math.max(0, curTo - this.spec.unquoted.length), state.doc.length);
        return found && (found.from != curFrom || found.to != curTo) ? found : null;
    }
    getReplacement(_result) {
        return this.spec.unquote(this.spec.replace);
    }
    matchAll(state, limit) {
        let cursor = $64f97a5f38975812$var$stringCursor(this.spec, state, 0, state.doc.length), ranges = [];
        while(!cursor.next().done){
            if (ranges.length >= limit) return null;
            ranges.push(cursor.value);
        }
        return ranges;
    }
    highlight(state, from, to, add) {
        let cursor = $64f97a5f38975812$var$stringCursor(this.spec, state, Math.max(0, from - this.spec.unquoted.length), Math.min(to + this.spec.unquoted.length, state.doc.length));
        while(!cursor.next().done)add(cursor.value.from, cursor.value.to);
    }
}
function $64f97a5f38975812$var$regexpCursor(spec, state, from, to) {
    return new $64f97a5f38975812$export$234e2283eb9dcd35(state.doc, spec.search, {
        ignoreCase: !spec.caseSensitive,
        test: spec.wholeWord ? $64f97a5f38975812$var$regexpWordTest(state.charCategorizer(state.selection.main.head)) : undefined
    }, from, to);
}
function $64f97a5f38975812$var$charBefore(str, index) {
    return str.slice((0, $6b8f387faea0a4dd$export$a0fa439fd515e1ed)(str, index, false), index);
}
function $64f97a5f38975812$var$charAfter(str, index) {
    return str.slice(index, (0, $6b8f387faea0a4dd$export$a0fa439fd515e1ed)(str, index));
}
function $64f97a5f38975812$var$regexpWordTest(categorizer) {
    return (_from, _to, match)=>!match[0].length || (categorizer($64f97a5f38975812$var$charBefore(match.input, match.index)) != (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word || categorizer($64f97a5f38975812$var$charAfter(match.input, match.index)) != (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word) && (categorizer($64f97a5f38975812$var$charAfter(match.input, match.index + match[0].length)) != (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word || categorizer($64f97a5f38975812$var$charBefore(match.input, match.index + match[0].length)) != (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word);
}
class $64f97a5f38975812$var$RegExpQuery extends $64f97a5f38975812$var$QueryType {
    nextMatch(state, curFrom, curTo) {
        let cursor = $64f97a5f38975812$var$regexpCursor(this.spec, state, curTo, state.doc.length).next();
        if (cursor.done) cursor = $64f97a5f38975812$var$regexpCursor(this.spec, state, 0, curFrom).next();
        return cursor.done ? null : cursor.value;
    }
    prevMatchInRange(state, from, to) {
        for(let size = 1;; size++){
            let start = Math.max(from, to - size * 10000 /* FindPrev.ChunkSize */ );
            let cursor = $64f97a5f38975812$var$regexpCursor(this.spec, state, start, to), range = null;
            while(!cursor.next().done)range = cursor.value;
            if (range && (start == from || range.from > start + 10)) return range;
            if (start == from) return null;
        }
    }
    prevMatch(state, curFrom, curTo) {
        return this.prevMatchInRange(state, 0, curFrom) || this.prevMatchInRange(state, curTo, state.doc.length);
    }
    getReplacement(result) {
        return this.spec.unquote(this.spec.replace).replace(/\$([$&]|\d+)/g, (m, i)=>{
            if (i == "&") return result.match[0];
            if (i == "$") return "$";
            for(let l = i.length; l > 0; l--){
                let n = +i.slice(0, l);
                if (n > 0 && n < result.match.length) return result.match[n] + i.slice(l);
            }
            return m;
        });
    }
    matchAll(state, limit) {
        let cursor = $64f97a5f38975812$var$regexpCursor(this.spec, state, 0, state.doc.length), ranges = [];
        while(!cursor.next().done){
            if (ranges.length >= limit) return null;
            ranges.push(cursor.value);
        }
        return ranges;
    }
    highlight(state, from, to, add) {
        let cursor = $64f97a5f38975812$var$regexpCursor(this.spec, state, Math.max(0, from - 250 /* RegExp.HighlightMargin */ ), Math.min(to + 250 /* RegExp.HighlightMargin */ , state.doc.length));
        while(!cursor.next().done)add(cursor.value.from, cursor.value.to);
    }
}
/**
A state effect that updates the current search query. Note that
this only has an effect if the search state has been initialized
(by including [`search`](https://codemirror.net/6/docs/ref/#search.search) in your configuration or
by running [`openSearchPanel`](https://codemirror.net/6/docs/ref/#search.openSearchPanel) at least
once).
*/ const $64f97a5f38975812$export$2cd1e14773f5e71b = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define();
const $64f97a5f38975812$var$togglePanel = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define();
const $64f97a5f38975812$var$searchState = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$34381b1ce2130245).define({
    create (state) {
        return new $64f97a5f38975812$var$SearchState($64f97a5f38975812$var$defaultQuery(state).create(), null);
    },
    update (value, tr) {
        for (let effect of tr.effects){
            if (effect.is($64f97a5f38975812$export$2cd1e14773f5e71b)) value = new $64f97a5f38975812$var$SearchState(effect.value.create(), value.panel);
            else if (effect.is($64f97a5f38975812$var$togglePanel)) value = new $64f97a5f38975812$var$SearchState(value.query, effect.value ? $64f97a5f38975812$var$createSearchPanel : null);
        }
        return value;
    },
    provide: (f)=>(0, $1d528cc0e08a0656$export$e89c3c9af31c1e3b).from(f, (val)=>val.panel)
});
/**
Get the current search query from an editor state.
*/ function $64f97a5f38975812$export$1664b92369554829(state) {
    let curState = state.field($64f97a5f38975812$var$searchState, false);
    return curState ? curState.query.spec : $64f97a5f38975812$var$defaultQuery(state);
}
/**
Query whether the search panel is open in the given editor state.
*/ function $64f97a5f38975812$export$453cecf1765eeb62(state) {
    var _a;
    return ((_a = state.field($64f97a5f38975812$var$searchState, false)) === null || _a === void 0 ? void 0 : _a.panel) != null;
}
class $64f97a5f38975812$var$SearchState {
    constructor(query, panel){
        this.query = query;
        this.panel = panel;
    }
}
const $64f97a5f38975812$var$matchMark = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$10e30b733df217ea).mark({
    class: "cm-searchMatch"
}), $64f97a5f38975812$var$selectedMatchMark = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$10e30b733df217ea).mark({
    class: "cm-searchMatch cm-searchMatch-selected"
});
const $64f97a5f38975812$var$searchHighlighter = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.view = view;
        this.decorations = this.highlight(view.state.field($64f97a5f38975812$var$searchState));
    }
    update(update) {
        let state = update.state.field($64f97a5f38975812$var$searchState);
        if (state != update.startState.field($64f97a5f38975812$var$searchState) || update.docChanged || update.selectionSet || update.viewportChanged) this.decorations = this.highlight(state);
    }
    highlight({ query: query, panel: panel }) {
        if (!panel || !query.spec.valid) return (0, $1d528cc0e08a0656$export$10e30b733df217ea).none;
        let { view: view } = this;
        let builder = new (0, $6b8f387faea0a4dd$export$89e09ce03c7e8594)();
        for(let i = 0, ranges = view.visibleRanges, l = ranges.length; i < l; i++){
            let { from: from, to: to } = ranges[i];
            while(i < l - 1 && to > ranges[i + 1].from - 500 /* RegExp.HighlightMargin */ )to = ranges[++i].to;
            query.highlight(view.state, from, to, (from, to)=>{
                let selected = view.state.selection.ranges.some((r)=>r.from == from && r.to == to);
                builder.add(from, to, selected ? $64f97a5f38975812$var$selectedMatchMark : $64f97a5f38975812$var$matchMark);
            });
        }
        return builder.finish();
    }
}, {
    decorations: (v)=>v.decorations
});
function $64f97a5f38975812$var$searchCommand(f) {
    return (view)=>{
        let state = view.state.field($64f97a5f38975812$var$searchState, false);
        return state && state.query.spec.valid ? f(view, state) : $64f97a5f38975812$export$8894af164d40b422(view);
    };
}
/**
Open the search panel if it isn't already open, and move the
selection to the first match after the current main selection.
Will wrap around to the start of the document when it reaches the
end.
*/ const $64f97a5f38975812$export$ebdf538520f8717 = /*@__PURE__*/ $64f97a5f38975812$var$searchCommand((view, { query: query })=>{
    let { to: to } = view.state.selection.main;
    let next = query.nextMatch(view.state, to, to);
    if (!next) return false;
    let selection = (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).single(next.from, next.to);
    let config = view.state.facet($64f97a5f38975812$var$searchConfigFacet);
    view.dispatch({
        selection: selection,
        effects: [
            $64f97a5f38975812$var$announceMatch(view, next),
            config.scrollToMatch(selection.main, view)
        ],
        userEvent: "select.search"
    });
    $64f97a5f38975812$var$selectSearchInput(view);
    return true;
});
/**
Move the selection to the previous instance of the search query,
before the current main selection. Will wrap past the start
of the document to start searching at the end again.
*/ const $64f97a5f38975812$export$eef4841c27f82c55 = /*@__PURE__*/ $64f97a5f38975812$var$searchCommand((view, { query: query })=>{
    let { state: state } = view, { from: from } = state.selection.main;
    let prev = query.prevMatch(state, from, from);
    if (!prev) return false;
    let selection = (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).single(prev.from, prev.to);
    let config = view.state.facet($64f97a5f38975812$var$searchConfigFacet);
    view.dispatch({
        selection: selection,
        effects: [
            $64f97a5f38975812$var$announceMatch(view, prev),
            config.scrollToMatch(selection.main, view)
        ],
        userEvent: "select.search"
    });
    $64f97a5f38975812$var$selectSearchInput(view);
    return true;
});
/**
Select all instances of the search query.
*/ const $64f97a5f38975812$export$5d21cfc86ff1ce1d = /*@__PURE__*/ $64f97a5f38975812$var$searchCommand((view, { query: query })=>{
    let ranges = query.matchAll(view.state, 1000);
    if (!ranges || !ranges.length) return false;
    view.dispatch({
        selection: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).create(ranges.map((r)=>(0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(r.from, r.to))),
        userEvent: "select.search.matches"
    });
    return true;
});
/**
Select all instances of the currently selected text.
*/ const $64f97a5f38975812$export$6f1c98d8556667b5 = ({ state: state, dispatch: dispatch })=>{
    let sel = state.selection;
    if (sel.ranges.length > 1 || sel.main.empty) return false;
    let { from: from, to: to } = sel.main;
    let ranges = [], main = 0;
    for(let cur = new $64f97a5f38975812$export$4989b254f32490be(state.doc, state.sliceDoc(from, to)); !cur.next().done;){
        if (ranges.length > 1000) return false;
        if (cur.value.from == from) main = ranges.length;
        ranges.push((0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(cur.value.from, cur.value.to));
    }
    dispatch(state.update({
        selection: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).create(ranges, main),
        userEvent: "select.search.matches"
    }));
    return true;
};
/**
Replace the current match of the search query.
*/ const $64f97a5f38975812$export$f9afe47535eaf3d2 = /*@__PURE__*/ $64f97a5f38975812$var$searchCommand((view, { query: query })=>{
    let { state: state } = view, { from: from, to: to } = state.selection.main;
    if (state.readOnly) return false;
    let match = query.nextMatch(state, from, from);
    if (!match) return false;
    let next = match;
    let changes = [], selection, replacement;
    let effects = [];
    if (next.from == from && next.to == to) {
        replacement = state.toText(query.getReplacement(next));
        changes.push({
            from: next.from,
            to: next.to,
            insert: replacement
        });
        next = query.nextMatch(state, next.from, next.to);
        effects.push((0, $1d528cc0e08a0656$export$eece2fccabbb77c5).announce.of(state.phrase("replaced match on line $", state.doc.lineAt(from).number) + "."));
    }
    let changeSet = view.state.changes(changes);
    if (next) {
        selection = (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).single(next.from, next.to).map(changeSet);
        effects.push($64f97a5f38975812$var$announceMatch(view, next));
        effects.push(state.facet($64f97a5f38975812$var$searchConfigFacet).scrollToMatch(selection.main, view));
    }
    view.dispatch({
        changes: changeSet,
        selection: selection,
        effects: effects,
        userEvent: "input.replace"
    });
    return true;
});
/**
Replace all instances of the search query with the given
replacement.
*/ const $64f97a5f38975812$export$b8b3234b4edfc4c2 = /*@__PURE__*/ $64f97a5f38975812$var$searchCommand((view, { query: query })=>{
    if (view.state.readOnly) return false;
    let changes = query.matchAll(view.state, 1e9).map((match)=>{
        let { from: from, to: to } = match;
        return {
            from: from,
            to: to,
            insert: query.getReplacement(match)
        };
    });
    if (!changes.length) return false;
    let announceText = view.state.phrase("replaced $ matches", changes.length) + ".";
    view.dispatch({
        changes: changes,
        effects: (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).announce.of(announceText),
        userEvent: "input.replace.all"
    });
    return true;
});
function $64f97a5f38975812$var$createSearchPanel(view) {
    return view.state.facet($64f97a5f38975812$var$searchConfigFacet).createPanel(view);
}
function $64f97a5f38975812$var$defaultQuery(state, fallback) {
    var _a, _b, _c, _d, _e;
    let sel = state.selection.main;
    let selText = sel.empty || sel.to > sel.from + 100 ? "" : state.sliceDoc(sel.from, sel.to);
    if (fallback && !selText) return fallback;
    let config = state.facet($64f97a5f38975812$var$searchConfigFacet);
    return new $64f97a5f38975812$export$4bc63ef50ec3954e({
        search: ((_a = fallback === null || fallback === void 0 ? void 0 : fallback.literal) !== null && _a !== void 0 ? _a : config.literal) ? selText : selText.replace(/\n/g, "\\n"),
        caseSensitive: (_b = fallback === null || fallback === void 0 ? void 0 : fallback.caseSensitive) !== null && _b !== void 0 ? _b : config.caseSensitive,
        literal: (_c = fallback === null || fallback === void 0 ? void 0 : fallback.literal) !== null && _c !== void 0 ? _c : config.literal,
        regexp: (_d = fallback === null || fallback === void 0 ? void 0 : fallback.regexp) !== null && _d !== void 0 ? _d : config.regexp,
        wholeWord: (_e = fallback === null || fallback === void 0 ? void 0 : fallback.wholeWord) !== null && _e !== void 0 ? _e : config.wholeWord
    });
}
function $64f97a5f38975812$var$getSearchInput(view) {
    let panel = (0, $1d528cc0e08a0656$export$7361ed18ff57179e)(view, $64f97a5f38975812$var$createSearchPanel);
    return panel && panel.dom.querySelector("[main-field]");
}
function $64f97a5f38975812$var$selectSearchInput(view) {
    let input = $64f97a5f38975812$var$getSearchInput(view);
    if (input && input == view.root.activeElement) input.select();
}
/**
Make sure the search panel is open and focused.
*/ const $64f97a5f38975812$export$8894af164d40b422 = (view)=>{
    let state = view.state.field($64f97a5f38975812$var$searchState, false);
    if (state && state.panel) {
        let searchInput = $64f97a5f38975812$var$getSearchInput(view);
        if (searchInput && searchInput != view.root.activeElement) {
            let query = $64f97a5f38975812$var$defaultQuery(view.state, state.query.spec);
            if (query.valid) view.dispatch({
                effects: $64f97a5f38975812$export$2cd1e14773f5e71b.of(query)
            });
            searchInput.focus();
            searchInput.select();
        }
    } else view.dispatch({
        effects: [
            $64f97a5f38975812$var$togglePanel.of(true),
            state ? $64f97a5f38975812$export$2cd1e14773f5e71b.of($64f97a5f38975812$var$defaultQuery(view.state, state.query.spec)) : (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).appendConfig.of($64f97a5f38975812$var$searchExtensions)
        ]
    });
    return true;
};
/**
Close the search panel.
*/ const $64f97a5f38975812$export$4c389f3929badbb8 = (view)=>{
    let state = view.state.field($64f97a5f38975812$var$searchState, false);
    if (!state || !state.panel) return false;
    let panel = (0, $1d528cc0e08a0656$export$7361ed18ff57179e)(view, $64f97a5f38975812$var$createSearchPanel);
    if (panel && panel.dom.contains(view.root.activeElement)) view.focus();
    view.dispatch({
        effects: $64f97a5f38975812$var$togglePanel.of(false)
    });
    return true;
};
/**
Default search-related key bindings.

 - Mod-f: [`openSearchPanel`](https://codemirror.net/6/docs/ref/#search.openSearchPanel)
 - F3, Mod-g: [`findNext`](https://codemirror.net/6/docs/ref/#search.findNext)
 - Shift-F3, Shift-Mod-g: [`findPrevious`](https://codemirror.net/6/docs/ref/#search.findPrevious)
 - Mod-Alt-g: [`gotoLine`](https://codemirror.net/6/docs/ref/#search.gotoLine)
 - Mod-d: [`selectNextOccurrence`](https://codemirror.net/6/docs/ref/#search.selectNextOccurrence)
*/ const $64f97a5f38975812$export$2dba96787cbe0a4a = [
    {
        key: "Mod-f",
        run: $64f97a5f38975812$export$8894af164d40b422,
        scope: "editor search-panel"
    },
    {
        key: "F3",
        run: $64f97a5f38975812$export$ebdf538520f8717,
        shift: $64f97a5f38975812$export$eef4841c27f82c55,
        scope: "editor search-panel",
        preventDefault: true
    },
    {
        key: "Mod-g",
        run: $64f97a5f38975812$export$ebdf538520f8717,
        shift: $64f97a5f38975812$export$eef4841c27f82c55,
        scope: "editor search-panel",
        preventDefault: true
    },
    {
        key: "Escape",
        run: $64f97a5f38975812$export$4c389f3929badbb8,
        scope: "editor search-panel"
    },
    {
        key: "Mod-Shift-l",
        run: $64f97a5f38975812$export$6f1c98d8556667b5
    },
    {
        key: "Mod-Alt-g",
        run: $64f97a5f38975812$export$5d5b784f9a618ec3
    },
    {
        key: "Mod-d",
        run: $64f97a5f38975812$export$dd0e64cebe05ee17,
        preventDefault: true
    }
];
class $64f97a5f38975812$var$SearchPanel {
    constructor(view){
        this.view = view;
        let query = this.query = view.state.field($64f97a5f38975812$var$searchState).query.spec;
        this.commit = this.commit.bind(this);
        this.searchField = (0, $2a4351068134afec$export$2e2bcd8739ae039)("input", {
            value: query.search,
            placeholder: $64f97a5f38975812$var$phrase(view, "Find"),
            "aria-label": $64f97a5f38975812$var$phrase(view, "Find"),
            class: "cm-textfield",
            name: "search",
            form: "",
            "main-field": "true",
            onchange: this.commit,
            onkeyup: this.commit
        });
        this.replaceField = (0, $2a4351068134afec$export$2e2bcd8739ae039)("input", {
            value: query.replace,
            placeholder: $64f97a5f38975812$var$phrase(view, "Replace"),
            "aria-label": $64f97a5f38975812$var$phrase(view, "Replace"),
            class: "cm-textfield",
            name: "replace",
            form: "",
            onchange: this.commit,
            onkeyup: this.commit
        });
        this.caseField = (0, $2a4351068134afec$export$2e2bcd8739ae039)("input", {
            type: "checkbox",
            name: "case",
            form: "",
            checked: query.caseSensitive,
            onchange: this.commit
        });
        this.reField = (0, $2a4351068134afec$export$2e2bcd8739ae039)("input", {
            type: "checkbox",
            name: "re",
            form: "",
            checked: query.regexp,
            onchange: this.commit
        });
        this.wordField = (0, $2a4351068134afec$export$2e2bcd8739ae039)("input", {
            type: "checkbox",
            name: "word",
            form: "",
            checked: query.wholeWord,
            onchange: this.commit
        });
        function button(name, onclick, content) {
            return (0, $2a4351068134afec$export$2e2bcd8739ae039)("button", {
                class: "cm-button",
                name: name,
                onclick: onclick,
                type: "button"
            }, content);
        }
        this.dom = (0, $2a4351068134afec$export$2e2bcd8739ae039)("div", {
            onkeydown: (e)=>this.keydown(e),
            class: "cm-search"
        }, [
            this.searchField,
            button("next", ()=>$64f97a5f38975812$export$ebdf538520f8717(view), [
                $64f97a5f38975812$var$phrase(view, "next")
            ]),
            button("prev", ()=>$64f97a5f38975812$export$eef4841c27f82c55(view), [
                $64f97a5f38975812$var$phrase(view, "previous")
            ]),
            button("select", ()=>$64f97a5f38975812$export$5d21cfc86ff1ce1d(view), [
                $64f97a5f38975812$var$phrase(view, "all")
            ]),
            (0, $2a4351068134afec$export$2e2bcd8739ae039)("label", null, [
                this.caseField,
                $64f97a5f38975812$var$phrase(view, "match case")
            ]),
            (0, $2a4351068134afec$export$2e2bcd8739ae039)("label", null, [
                this.reField,
                $64f97a5f38975812$var$phrase(view, "regexp")
            ]),
            (0, $2a4351068134afec$export$2e2bcd8739ae039)("label", null, [
                this.wordField,
                $64f97a5f38975812$var$phrase(view, "by word")
            ]),
            ...view.state.readOnly ? [] : [
                (0, $2a4351068134afec$export$2e2bcd8739ae039)("br"),
                this.replaceField,
                button("replace", ()=>$64f97a5f38975812$export$f9afe47535eaf3d2(view), [
                    $64f97a5f38975812$var$phrase(view, "replace")
                ]),
                button("replaceAll", ()=>$64f97a5f38975812$export$b8b3234b4edfc4c2(view), [
                    $64f97a5f38975812$var$phrase(view, "replace all")
                ])
            ],
            (0, $2a4351068134afec$export$2e2bcd8739ae039)("button", {
                name: "close",
                onclick: ()=>$64f97a5f38975812$export$4c389f3929badbb8(view),
                "aria-label": $64f97a5f38975812$var$phrase(view, "close"),
                type: "button"
            }, [
                "\xd7"
            ])
        ]);
    }
    commit() {
        let query = new $64f97a5f38975812$export$4bc63ef50ec3954e({
            search: this.searchField.value,
            caseSensitive: this.caseField.checked,
            regexp: this.reField.checked,
            wholeWord: this.wordField.checked,
            replace: this.replaceField.value
        });
        if (!query.eq(this.query)) {
            this.query = query;
            this.view.dispatch({
                effects: $64f97a5f38975812$export$2cd1e14773f5e71b.of(query)
            });
        }
    }
    keydown(e) {
        if ((0, $1d528cc0e08a0656$export$bce154f45536286e)(this.view, e, "search-panel")) e.preventDefault();
        else if (e.keyCode == 13 && e.target == this.searchField) {
            e.preventDefault();
            (e.shiftKey ? $64f97a5f38975812$export$eef4841c27f82c55 : $64f97a5f38975812$export$ebdf538520f8717)(this.view);
        } else if (e.keyCode == 13 && e.target == this.replaceField) {
            e.preventDefault();
            $64f97a5f38975812$export$f9afe47535eaf3d2(this.view);
        }
    }
    update(update) {
        for (let tr of update.transactions)for (let effect of tr.effects)if (effect.is($64f97a5f38975812$export$2cd1e14773f5e71b) && !effect.value.eq(this.query)) this.setQuery(effect.value);
    }
    setQuery(query) {
        this.query = query;
        this.searchField.value = query.search;
        this.replaceField.value = query.replace;
        this.caseField.checked = query.caseSensitive;
        this.reField.checked = query.regexp;
        this.wordField.checked = query.wholeWord;
    }
    mount() {
        this.searchField.select();
    }
    get pos() {
        return 80;
    }
    get top() {
        return this.view.state.facet($64f97a5f38975812$var$searchConfigFacet).top;
    }
}
function $64f97a5f38975812$var$phrase(view, phrase) {
    return view.state.phrase(phrase);
}
const $64f97a5f38975812$var$AnnounceMargin = 30;
const $64f97a5f38975812$var$Break = /[\s\.,:;?!]/;
function $64f97a5f38975812$var$announceMatch(view, { from: from, to: to }) {
    let line = view.state.doc.lineAt(from), lineEnd = view.state.doc.lineAt(to).to;
    let start = Math.max(line.from, from - $64f97a5f38975812$var$AnnounceMargin), end = Math.min(lineEnd, to + $64f97a5f38975812$var$AnnounceMargin);
    let text = view.state.sliceDoc(start, end);
    if (start != line.from) {
        for(let i = 0; i < $64f97a5f38975812$var$AnnounceMargin; i++)if (!$64f97a5f38975812$var$Break.test(text[i + 1]) && $64f97a5f38975812$var$Break.test(text[i])) {
            text = text.slice(i);
            break;
        }
    }
    if (end != lineEnd) {
        for(let i = text.length - 1; i > text.length - $64f97a5f38975812$var$AnnounceMargin; i--)if (!$64f97a5f38975812$var$Break.test(text[i - 1]) && $64f97a5f38975812$var$Break.test(text[i])) {
            text = text.slice(0, i);
            break;
        }
    }
    return (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).announce.of(`${view.state.phrase("current match")}. ${text} ${view.state.phrase("on line")} ${line.number}.`);
}
const $64f97a5f38975812$var$baseTheme = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).baseTheme({
    ".cm-panel.cm-search": {
        padding: "2px 6px 4px",
        position: "relative",
        "& [name=close]": {
            position: "absolute",
            top: "0",
            right: "4px",
            backgroundColor: "inherit",
            border: "none",
            font: "inherit",
            padding: 0,
            margin: 0
        },
        "& input, & button, & label": {
            margin: ".2em .6em .2em 0"
        },
        "& input[type=checkbox]": {
            marginRight: ".2em"
        },
        "& label": {
            fontSize: "80%",
            whiteSpace: "pre"
        }
    },
    "&light .cm-searchMatch": {
        backgroundColor: "#ffff0054"
    },
    "&dark .cm-searchMatch": {
        backgroundColor: "#00ffff8a"
    },
    "&light .cm-searchMatch-selected": {
        backgroundColor: "#ff6a0054"
    },
    "&dark .cm-searchMatch-selected": {
        backgroundColor: "#ff00ff8a"
    }
});
const $64f97a5f38975812$var$searchExtensions = [
    $64f97a5f38975812$var$searchState,
    /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$b92464a736444411).low($64f97a5f38975812$var$searchHighlighter),
    $64f97a5f38975812$var$baseTheme
];





/**
An instance of this is passed to completion source functions.
*/ class $3f3985386ff18e5c$export$7b73e80391102dce {
    /**
    Create a new completion context. (Mostly useful for testing
    completion sources—in the editor, the extension will create
    these for you.)
    */ constructor(/**
    The editor state that the completion happens in.
    */ state, /**
    The position at which the completion is happening.
    */ pos, /**
    Indicates whether completion was activated explicitly, or
    implicitly by typing. The usual way to respond to this is to
    only return completions when either there is part of a
    completable entity before the cursor, or `explicit` is true.
    */ explicit, /**
    The editor view. May be undefined if the context was created
    in a situation where there is no such view available, such as
    in synchronous updates via
    [`CompletionResult.update`](https://codemirror.net/6/docs/ref/#autocomplete.CompletionResult.update)
    or when called by test code.
    */ view){
        this.state = state;
        this.pos = pos;
        this.explicit = explicit;
        this.view = view;
        /**
        @internal
        */ this.abortListeners = [];
        /**
        @internal
        */ this.abortOnDocChange = false;
    }
    /**
    Get the extent, content, and (if there is a token) type of the
    token before `this.pos`.
    */ tokenBefore(types) {
        let token = (0, $deda11ebd5d0815e$export$7fc98e56a4ca6be1)(this.state).resolveInner(this.pos, -1);
        while(token && types.indexOf(token.name) < 0)token = token.parent;
        return token ? {
            from: token.from,
            to: this.pos,
            text: this.state.sliceDoc(token.from, this.pos),
            type: token.type
        } : null;
    }
    /**
    Get the match of the given expression directly before the
    cursor.
    */ matchBefore(expr) {
        let line = this.state.doc.lineAt(this.pos);
        let start = Math.max(line.from, this.pos - 250);
        let str = line.text.slice(start - line.from, this.pos - line.from);
        let found = str.search($3f3985386ff18e5c$var$ensureAnchor(expr, false));
        return found < 0 ? null : {
            from: start + found,
            to: this.pos,
            text: str.slice(found)
        };
    }
    /**
    Yields true when the query has been aborted. Can be useful in
    asynchronous queries to avoid doing work that will be ignored.
    */ get aborted() {
        return this.abortListeners == null;
    }
    /**
    Allows you to register abort handlers, which will be called when
    the query is
    [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
    
    By default, running queries will not be aborted for regular
    typing or backspacing, on the assumption that they are likely to
    return a result with a
    [`validFor`](https://codemirror.net/6/docs/ref/#autocomplete.CompletionResult.validFor) field that
    allows the result to be used after all. Passing `onDocChange:
    true` will cause this query to be aborted for any document
    change.
    */ addEventListener(type, listener, options) {
        if (type == "abort" && this.abortListeners) {
            this.abortListeners.push(listener);
            if (options && options.onDocChange) this.abortOnDocChange = true;
        }
    }
}
function $3f3985386ff18e5c$var$toSet(chars) {
    let flat = Object.keys(chars).join("");
    let words = /\w/.test(flat);
    if (words) flat = flat.replace(/\w/g, "");
    return `[${words ? "\\w" : ""}${flat.replace(/[^\w\s]/g, "\\$&")}]`;
}
function $3f3985386ff18e5c$var$prefixMatch(options) {
    let first = Object.create(null), rest = Object.create(null);
    for (let { label: label } of options){
        first[label[0]] = true;
        for(let i = 1; i < label.length; i++)rest[label[i]] = true;
    }
    let source = $3f3985386ff18e5c$var$toSet(first) + $3f3985386ff18e5c$var$toSet(rest) + "*$";
    return [
        new RegExp("^" + source),
        new RegExp(source)
    ];
}
/**
Given a a fixed array of options, return an autocompleter that
completes them.
*/ function $3f3985386ff18e5c$export$db0ee7d2648a0c4b(list) {
    let options = list.map((o)=>typeof o == "string" ? {
            label: o
        } : o);
    let [validFor, match] = options.every((o)=>/^\w+$/.test(o.label)) ? [
        /\w*$/,
        /\w+$/
    ] : $3f3985386ff18e5c$var$prefixMatch(options);
    return (context)=>{
        let token = context.matchBefore(match);
        return token || context.explicit ? {
            from: token ? token.from : context.pos,
            options: options,
            validFor: validFor
        } : null;
    };
}
/**
Wrap the given completion source so that it will only fire when the
cursor is in a syntax node with one of the given names.
*/ function $3f3985386ff18e5c$export$498fe7f50ed891b8(nodes, source) {
    return (context)=>{
        for(let pos = (0, $deda11ebd5d0815e$export$7fc98e56a4ca6be1)(context.state).resolveInner(context.pos, -1); pos; pos = pos.parent){
            if (nodes.indexOf(pos.name) > -1) return source(context);
            if (pos.type.isTop) break;
        }
        return null;
    };
}
/**
Wrap the given completion source so that it will not fire when the
cursor is in a syntax node with one of the given names.
*/ function $3f3985386ff18e5c$export$1dfdaeb1e91714c0(nodes, source) {
    return (context)=>{
        for(let pos = (0, $deda11ebd5d0815e$export$7fc98e56a4ca6be1)(context.state).resolveInner(context.pos, -1); pos; pos = pos.parent){
            if (nodes.indexOf(pos.name) > -1) return null;
            if (pos.type.isTop) break;
        }
        return source(context);
    };
}
class $3f3985386ff18e5c$var$Option {
    constructor(completion, source, match, score){
        this.completion = completion;
        this.source = source;
        this.match = match;
        this.score = score;
    }
}
function $3f3985386ff18e5c$var$cur(state) {
    return state.selection.main.from;
}
// Make sure the given regexp has a $ at its end and, if `start` is
// true, a ^ at its start.
function $3f3985386ff18e5c$var$ensureAnchor(expr, start) {
    var _a;
    let { source: source } = expr;
    let addStart = start && source[0] != "^", addEnd = source[source.length - 1] != "$";
    if (!addStart && !addEnd) return expr;
    return new RegExp(`${addStart ? "^" : ""}(?:${source})${addEnd ? "$" : ""}`, (_a = expr.flags) !== null && _a !== void 0 ? _a : expr.ignoreCase ? "i" : "");
}
/**
This annotation is added to transactions that are produced by
picking a completion.
*/ const $3f3985386ff18e5c$export$6c84d44c1ceeb831 = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$9279461326b8700a).define();
/**
Helper function that returns a transaction spec which inserts a
completion's text in the main selection range, and any other
selection range that has the same text in front of it.
*/ function $3f3985386ff18e5c$export$496ff43229d73eba(state, text, from, to) {
    let { main: main } = state.selection, fromOff = from - main.from, toOff = to - main.from;
    return Object.assign(Object.assign({}, state.changeByRange((range)=>{
        if (range != main && from != to && state.sliceDoc(range.from + fromOff, range.from + toOff) != state.sliceDoc(from, to)) return {
            range: range
        };
        let lines = state.toText(text);
        return {
            changes: {
                from: range.from + fromOff,
                to: to == main.from ? range.to : range.from + toOff,
                insert: lines
            },
            range: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(range.from + fromOff + lines.length)
        };
    })), {
        scrollIntoView: true,
        userEvent: "input.complete"
    });
}
const $3f3985386ff18e5c$var$SourceCache = /*@__PURE__*/ new WeakMap();
function $3f3985386ff18e5c$var$asSource(source) {
    if (!Array.isArray(source)) return source;
    let known = $3f3985386ff18e5c$var$SourceCache.get(source);
    if (!known) $3f3985386ff18e5c$var$SourceCache.set(source, known = $3f3985386ff18e5c$export$db0ee7d2648a0c4b(source));
    return known;
}
const $3f3985386ff18e5c$var$startCompletionEffect = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define();
const $3f3985386ff18e5c$var$closeCompletionEffect = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define();
// A pattern matcher for fuzzy completion matching. Create an instance
// once for a pattern, and then use that to match any number of
// completions.
class $3f3985386ff18e5c$var$FuzzyMatcher {
    constructor(pattern){
        this.pattern = pattern;
        this.chars = [];
        this.folded = [];
        // Buffers reused by calls to `match` to track matched character
        // positions.
        this.any = [];
        this.precise = [];
        this.byWord = [];
        this.score = 0;
        this.matched = [];
        for(let p = 0; p < pattern.length;){
            let char = (0, $6b8f387faea0a4dd$export$42977f40461e1360)(pattern, p), size = (0, $6b8f387faea0a4dd$export$a870abf234f6353c)(char);
            this.chars.push(char);
            let part = pattern.slice(p, p + size), upper = part.toUpperCase();
            this.folded.push((0, $6b8f387faea0a4dd$export$42977f40461e1360)(upper == part ? part.toLowerCase() : upper, 0));
            p += size;
        }
        this.astral = pattern.length != this.chars.length;
    }
    ret(score, matched) {
        this.score = score;
        this.matched = matched;
        return this;
    }
    // Matches a given word (completion) against the pattern (input).
    // Will return a boolean indicating whether there was a match and,
    // on success, set `this.score` to the score, `this.matched` to an
    // array of `from, to` pairs indicating the matched parts of `word`.
    //
    // The score is a number that is more negative the worse the match
    // is. See `Penalty` above.
    match(word) {
        if (this.pattern.length == 0) return this.ret(-100 /* Penalty.NotFull */ , []);
        if (word.length < this.pattern.length) return null;
        let { chars: chars, folded: folded, any: any, precise: precise, byWord: byWord } = this;
        // For single-character queries, only match when they occur right
        // at the start
        if (chars.length == 1) {
            let first = (0, $6b8f387faea0a4dd$export$42977f40461e1360)(word, 0), firstSize = (0, $6b8f387faea0a4dd$export$a870abf234f6353c)(first);
            let score = firstSize == word.length ? 0 : -100 /* Penalty.NotFull */ ;
            if (first == chars[0]) ;
            else if (first == folded[0]) score += -200 /* Penalty.CaseFold */ ;
            else return null;
            return this.ret(score, [
                0,
                firstSize
            ]);
        }
        let direct = word.indexOf(this.pattern);
        if (direct == 0) return this.ret(word.length == this.pattern.length ? 0 : -100 /* Penalty.NotFull */ , [
            0,
            this.pattern.length
        ]);
        let len = chars.length, anyTo = 0;
        if (direct < 0) {
            for(let i = 0, e = Math.min(word.length, 200); i < e && anyTo < len;){
                let next = (0, $6b8f387faea0a4dd$export$42977f40461e1360)(word, i);
                if (next == chars[anyTo] || next == folded[anyTo]) any[anyTo++] = i;
                i += (0, $6b8f387faea0a4dd$export$a870abf234f6353c)(next);
            }
            // No match, exit immediately
            if (anyTo < len) return null;
        }
        // This tracks the extent of the precise (non-folded, not
        // necessarily adjacent) match
        let preciseTo = 0;
        // Tracks whether there is a match that hits only characters that
        // appear to be starting words. `byWordFolded` is set to true when
        // a case folded character is encountered in such a match
        let byWordTo = 0, byWordFolded = false;
        // If we've found a partial adjacent match, these track its state
        let adjacentTo = 0, adjacentStart = -1, adjacentEnd = -1;
        let hasLower = /[a-z]/.test(word), wordAdjacent = true;
        // Go over the option's text, scanning for the various kinds of matches
        for(let i = 0, e = Math.min(word.length, 200), prevType = 0 /* Tp.NonWord */ ; i < e && byWordTo < len;){
            let next = (0, $6b8f387faea0a4dd$export$42977f40461e1360)(word, i);
            if (direct < 0) {
                if (preciseTo < len && next == chars[preciseTo]) precise[preciseTo++] = i;
                if (adjacentTo < len) {
                    if (next == chars[adjacentTo] || next == folded[adjacentTo]) {
                        if (adjacentTo == 0) adjacentStart = i;
                        adjacentEnd = i + 1;
                        adjacentTo++;
                    } else adjacentTo = 0;
                }
            }
            let ch, type = next < 0xff ? next >= 48 && next <= 57 || next >= 97 && next <= 122 ? 2 /* Tp.Lower */  : next >= 65 && next <= 90 ? 1 /* Tp.Upper */  : 0 /* Tp.NonWord */  : (ch = (0, $6b8f387faea0a4dd$export$73bfc63873071f74)(next)) != ch.toLowerCase() ? 1 /* Tp.Upper */  : ch != ch.toUpperCase() ? 2 /* Tp.Lower */  : 0 /* Tp.NonWord */ ;
            if (!i || type == 1 /* Tp.Upper */  && hasLower || prevType == 0 /* Tp.NonWord */  && type != 0 /* Tp.NonWord */ ) {
                if (chars[byWordTo] == next || folded[byWordTo] == next && (byWordFolded = true)) byWord[byWordTo++] = i;
                else if (byWord.length) wordAdjacent = false;
            }
            prevType = type;
            i += (0, $6b8f387faea0a4dd$export$a870abf234f6353c)(next);
        }
        if (byWordTo == len && byWord[0] == 0 && wordAdjacent) return this.result(-100 /* Penalty.ByWord */  + (byWordFolded ? -200 /* Penalty.CaseFold */  : 0), byWord, word);
        if (adjacentTo == len && adjacentStart == 0) return this.ret(-200 /* Penalty.CaseFold */  - word.length + (adjacentEnd == word.length ? 0 : -100 /* Penalty.NotFull */ ), [
            0,
            adjacentEnd
        ]);
        if (direct > -1) return this.ret(-700 /* Penalty.NotStart */  - word.length, [
            direct,
            direct + this.pattern.length
        ]);
        if (adjacentTo == len) return this.ret(-900 /* Penalty.NotStart */  - word.length, [
            adjacentStart,
            adjacentEnd
        ]);
        if (byWordTo == len) return this.result(-100 /* Penalty.ByWord */  + (byWordFolded ? -200 /* Penalty.CaseFold */  : 0) + -700 /* Penalty.NotStart */  + (wordAdjacent ? 0 : -1100 /* Penalty.Gap */ ), byWord, word);
        return chars.length == 2 ? null : this.result((any[0] ? -700 /* Penalty.NotStart */  : 0) + -200 /* Penalty.CaseFold */  + -1100 /* Penalty.Gap */ , any, word);
    }
    result(score, positions, word) {
        let result = [], i = 0;
        for (let pos of positions){
            let to = pos + (this.astral ? (0, $6b8f387faea0a4dd$export$a870abf234f6353c)((0, $6b8f387faea0a4dd$export$42977f40461e1360)(word, pos)) : 1);
            if (i && result[i - 1] == pos) result[i - 1] = to;
            else {
                result[i++] = pos;
                result[i++] = to;
            }
        }
        return this.ret(score - word.length, result);
    }
}
class $3f3985386ff18e5c$var$StrictMatcher {
    constructor(pattern){
        this.pattern = pattern;
        this.matched = [];
        this.score = 0;
        this.folded = pattern.toLowerCase();
    }
    match(word) {
        if (word.length < this.pattern.length) return null;
        let start = word.slice(0, this.pattern.length);
        let match = start == this.pattern ? 0 : start.toLowerCase() == this.folded ? -200 /* Penalty.CaseFold */  : null;
        if (match == null) return null;
        this.matched = [
            0,
            start.length
        ];
        this.score = match + (word.length == this.pattern.length ? 0 : -100 /* Penalty.NotFull */ );
        return this;
    }
}
const $3f3985386ff18e5c$var$completionConfig = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6b8f387faea0a4dd$export$4e19c0b693794a7e)(configs, {
            activateOnTyping: true,
            activateOnCompletion: ()=>false,
            activateOnTypingDelay: 100,
            selectOnOpen: true,
            override: null,
            closeOnBlur: true,
            maxRenderedOptions: 100,
            defaultKeymap: true,
            tooltipClass: ()=>"",
            optionClass: ()=>"",
            aboveCursor: false,
            icons: true,
            addToOptions: [],
            positionInfo: $3f3985386ff18e5c$var$defaultPositionInfo,
            filterStrict: false,
            compareCompletions: (a, b)=>a.label.localeCompare(b.label),
            interactionDelay: 75,
            updateSyncTime: 100
        }, {
            defaultKeymap: (a, b)=>a && b,
            closeOnBlur: (a, b)=>a && b,
            icons: (a, b)=>a && b,
            tooltipClass: (a, b)=>(c)=>$3f3985386ff18e5c$var$joinClass(a(c), b(c)),
            optionClass: (a, b)=>(c)=>$3f3985386ff18e5c$var$joinClass(a(c), b(c)),
            addToOptions: (a, b)=>a.concat(b),
            filterStrict: (a, b)=>a || b
        });
    }
});
function $3f3985386ff18e5c$var$joinClass(a, b) {
    return a ? b ? a + " " + b : a : b;
}
function $3f3985386ff18e5c$var$defaultPositionInfo(view, list, option, info, space, tooltip) {
    let rtl = view.textDirection == (0, $1d528cc0e08a0656$export$cacd6541cfeeb6c1).RTL, left = rtl, narrow = false;
    let side = "top", offset, maxWidth;
    let spaceLeft = list.left - space.left, spaceRight = space.right - list.right;
    let infoWidth = info.right - info.left, infoHeight = info.bottom - info.top;
    if (left && spaceLeft < Math.min(infoWidth, spaceRight)) left = false;
    else if (!left && spaceRight < Math.min(infoWidth, spaceLeft)) left = true;
    if (infoWidth <= (left ? spaceLeft : spaceRight)) {
        offset = Math.max(space.top, Math.min(option.top, space.bottom - infoHeight)) - list.top;
        maxWidth = Math.min(400 /* Info.Width */ , left ? spaceLeft : spaceRight);
    } else {
        narrow = true;
        maxWidth = Math.min(400 /* Info.Width */ , (rtl ? list.right : space.right - list.left) - 30 /* Info.Margin */ );
        let spaceBelow = space.bottom - list.bottom;
        if (spaceBelow >= infoHeight || spaceBelow > list.top) offset = option.bottom - list.top;
        else {
            side = "bottom";
            offset = list.bottom - option.top;
        }
    }
    let scaleY = (list.bottom - list.top) / tooltip.offsetHeight;
    let scaleX = (list.right - list.left) / tooltip.offsetWidth;
    return {
        style: `${side}: ${offset / scaleY}px; max-width: ${maxWidth / scaleX}px`,
        class: "cm-completionInfo-" + (narrow ? rtl ? "left-narrow" : "right-narrow" : left ? "left" : "right")
    };
}
function $3f3985386ff18e5c$var$optionContent(config) {
    let content = config.addToOptions.slice();
    if (config.icons) content.push({
        render (completion) {
            let icon = document.createElement("div");
            icon.classList.add("cm-completionIcon");
            if (completion.type) icon.classList.add(...completion.type.split(/\s+/g).map((cls)=>"cm-completionIcon-" + cls));
            icon.setAttribute("aria-hidden", "true");
            return icon;
        },
        position: 20
    });
    content.push({
        render (completion, _s, _v, match) {
            let labelElt = document.createElement("span");
            labelElt.className = "cm-completionLabel";
            let label = completion.displayLabel || completion.label, off = 0;
            for(let j = 0; j < match.length;){
                let from = match[j++], to = match[j++];
                if (from > off) labelElt.appendChild(document.createTextNode(label.slice(off, from)));
                let span = labelElt.appendChild(document.createElement("span"));
                span.appendChild(document.createTextNode(label.slice(from, to)));
                span.className = "cm-completionMatchedText";
                off = to;
            }
            if (off < label.length) labelElt.appendChild(document.createTextNode(label.slice(off)));
            return labelElt;
        },
        position: 50
    }, {
        render (completion) {
            if (!completion.detail) return null;
            let detailElt = document.createElement("span");
            detailElt.className = "cm-completionDetail";
            detailElt.textContent = completion.detail;
            return detailElt;
        },
        position: 80
    });
    return content.sort((a, b)=>a.position - b.position).map((a)=>a.render);
}
function $3f3985386ff18e5c$var$rangeAroundSelected(total, selected, max) {
    if (total <= max) return {
        from: 0,
        to: total
    };
    if (selected < 0) selected = 0;
    if (selected <= total >> 1) {
        let off = Math.floor(selected / max);
        return {
            from: off * max,
            to: (off + 1) * max
        };
    }
    let off = Math.floor((total - selected) / max);
    return {
        from: total - (off + 1) * max,
        to: total - off * max
    };
}
class $3f3985386ff18e5c$var$CompletionTooltip {
    constructor(view, stateField, applyCompletion){
        this.view = view;
        this.stateField = stateField;
        this.applyCompletion = applyCompletion;
        this.info = null;
        this.infoDestroy = null;
        this.placeInfoReq = {
            read: ()=>this.measureInfo(),
            write: (pos)=>this.placeInfo(pos),
            key: this
        };
        this.space = null;
        this.currentClass = "";
        let cState = view.state.field(stateField);
        let { options: options, selected: selected } = cState.open;
        let config = view.state.facet($3f3985386ff18e5c$var$completionConfig);
        this.optionContent = $3f3985386ff18e5c$var$optionContent(config);
        this.optionClass = config.optionClass;
        this.tooltipClass = config.tooltipClass;
        this.range = $3f3985386ff18e5c$var$rangeAroundSelected(options.length, selected, config.maxRenderedOptions);
        this.dom = document.createElement("div");
        this.dom.className = "cm-tooltip-autocomplete";
        this.updateTooltipClass(view.state);
        this.dom.addEventListener("mousedown", (e)=>{
            let { options: options } = view.state.field(stateField).open;
            for(let dom = e.target, match; dom && dom != this.dom; dom = dom.parentNode)if (dom.nodeName == "LI" && (match = /-(\d+)$/.exec(dom.id)) && +match[1] < options.length) {
                this.applyCompletion(view, options[+match[1]]);
                e.preventDefault();
                return;
            }
        });
        this.dom.addEventListener("focusout", (e)=>{
            let state = view.state.field(this.stateField, false);
            if (state && state.tooltip && view.state.facet($3f3985386ff18e5c$var$completionConfig).closeOnBlur && e.relatedTarget != view.contentDOM) view.dispatch({
                effects: $3f3985386ff18e5c$var$closeCompletionEffect.of(null)
            });
        });
        this.showOptions(options, cState.id);
    }
    mount() {
        this.updateSel();
    }
    showOptions(options, id) {
        if (this.list) this.list.remove();
        this.list = this.dom.appendChild(this.createListBox(options, id, this.range));
        this.list.addEventListener("scroll", ()=>{
            if (this.info) this.view.requestMeasure(this.placeInfoReq);
        });
    }
    update(update) {
        var _a;
        let cState = update.state.field(this.stateField);
        let prevState = update.startState.field(this.stateField);
        this.updateTooltipClass(update.state);
        if (cState != prevState) {
            let { options: options, selected: selected, disabled: disabled } = cState.open;
            if (!prevState.open || prevState.open.options != options) {
                this.range = $3f3985386ff18e5c$var$rangeAroundSelected(options.length, selected, update.state.facet($3f3985386ff18e5c$var$completionConfig).maxRenderedOptions);
                this.showOptions(options, cState.id);
            }
            this.updateSel();
            if (disabled != ((_a = prevState.open) === null || _a === void 0 ? void 0 : _a.disabled)) this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!disabled);
        }
    }
    updateTooltipClass(state) {
        let cls = this.tooltipClass(state);
        if (cls != this.currentClass) {
            for (let c of this.currentClass.split(" "))if (c) this.dom.classList.remove(c);
            for (let c of cls.split(" "))if (c) this.dom.classList.add(c);
            this.currentClass = cls;
        }
    }
    positioned(space) {
        this.space = space;
        if (this.info) this.view.requestMeasure(this.placeInfoReq);
    }
    updateSel() {
        let cState = this.view.state.field(this.stateField), open = cState.open;
        if (open.selected > -1 && open.selected < this.range.from || open.selected >= this.range.to) {
            this.range = $3f3985386ff18e5c$var$rangeAroundSelected(open.options.length, open.selected, this.view.state.facet($3f3985386ff18e5c$var$completionConfig).maxRenderedOptions);
            this.showOptions(open.options, cState.id);
        }
        if (this.updateSelectedOption(open.selected)) {
            this.destroyInfo();
            let { completion: completion } = open.options[open.selected];
            let { info: info } = completion;
            if (!info) return;
            let infoResult = typeof info === "string" ? document.createTextNode(info) : info(completion);
            if (!infoResult) return;
            if ("then" in infoResult) infoResult.then((obj)=>{
                if (obj && this.view.state.field(this.stateField, false) == cState) this.addInfoPane(obj, completion);
            }).catch((e)=>(0, $1d528cc0e08a0656$export$f86b2a1a2ce291b3)(this.view.state, e, "completion info"));
            else this.addInfoPane(infoResult, completion);
        }
    }
    addInfoPane(content, completion) {
        this.destroyInfo();
        let wrap = this.info = document.createElement("div");
        wrap.className = "cm-tooltip cm-completionInfo";
        if (content.nodeType != null) {
            wrap.appendChild(content);
            this.infoDestroy = null;
        } else {
            let { dom: dom, destroy: destroy } = content;
            wrap.appendChild(dom);
            this.infoDestroy = destroy || null;
        }
        this.dom.appendChild(wrap);
        this.view.requestMeasure(this.placeInfoReq);
    }
    updateSelectedOption(selected) {
        let set = null;
        for(let opt = this.list.firstChild, i = this.range.from; opt; opt = opt.nextSibling, i++){
            if (opt.nodeName != "LI" || !opt.id) i--; // A section header
            else if (i == selected) {
                if (!opt.hasAttribute("aria-selected")) {
                    opt.setAttribute("aria-selected", "true");
                    set = opt;
                }
            } else if (opt.hasAttribute("aria-selected")) opt.removeAttribute("aria-selected");
        }
        if (set) $3f3985386ff18e5c$var$scrollIntoView(this.list, set);
        return set;
    }
    measureInfo() {
        let sel = this.dom.querySelector("[aria-selected]");
        if (!sel || !this.info) return null;
        let listRect = this.dom.getBoundingClientRect();
        let infoRect = this.info.getBoundingClientRect();
        let selRect = sel.getBoundingClientRect();
        let space = this.space;
        if (!space) {
            let docElt = this.dom.ownerDocument.documentElement;
            space = {
                left: 0,
                top: 0,
                right: docElt.clientWidth,
                bottom: docElt.clientHeight
            };
        }
        if (selRect.top > Math.min(space.bottom, listRect.bottom) - 10 || selRect.bottom < Math.max(space.top, listRect.top) + 10) return null;
        return this.view.state.facet($3f3985386ff18e5c$var$completionConfig).positionInfo(this.view, listRect, selRect, infoRect, space, this.dom);
    }
    placeInfo(pos) {
        if (this.info) {
            if (pos) {
                if (pos.style) this.info.style.cssText = pos.style;
                this.info.className = "cm-tooltip cm-completionInfo " + (pos.class || "");
            } else this.info.style.cssText = "top: -1e6px";
        }
    }
    createListBox(options, id, range) {
        const ul = document.createElement("ul");
        ul.id = id;
        ul.setAttribute("role", "listbox");
        ul.setAttribute("aria-expanded", "true");
        ul.setAttribute("aria-label", this.view.state.phrase("Completions"));
        ul.addEventListener("mousedown", (e)=>{
            // Prevent focus change when clicking the scrollbar
            if (e.target == ul) e.preventDefault();
        });
        let curSection = null;
        for(let i = range.from; i < range.to; i++){
            let { completion: completion, match: match } = options[i], { section: section } = completion;
            if (section) {
                let name = typeof section == "string" ? section : section.name;
                if (name != curSection && (i > range.from || range.from == 0)) {
                    curSection = name;
                    if (typeof section != "string" && section.header) ul.appendChild(section.header(section));
                    else {
                        let header = ul.appendChild(document.createElement("completion-section"));
                        header.textContent = name;
                    }
                }
            }
            const li = ul.appendChild(document.createElement("li"));
            li.id = id + "-" + i;
            li.setAttribute("role", "option");
            let cls = this.optionClass(completion);
            if (cls) li.className = cls;
            for (let source of this.optionContent){
                let node = source(completion, this.view.state, this.view, match);
                if (node) li.appendChild(node);
            }
        }
        if (range.from) ul.classList.add("cm-completionListIncompleteTop");
        if (range.to < options.length) ul.classList.add("cm-completionListIncompleteBottom");
        return ul;
    }
    destroyInfo() {
        if (this.info) {
            if (this.infoDestroy) this.infoDestroy();
            this.info.remove();
            this.info = null;
        }
    }
    destroy() {
        this.destroyInfo();
    }
}
function $3f3985386ff18e5c$var$completionTooltip(stateField, applyCompletion) {
    return (view)=>new $3f3985386ff18e5c$var$CompletionTooltip(view, stateField, applyCompletion);
}
function $3f3985386ff18e5c$var$scrollIntoView(container, element) {
    let parent = container.getBoundingClientRect();
    let self = element.getBoundingClientRect();
    let scaleY = parent.height / container.offsetHeight;
    if (self.top < parent.top) container.scrollTop -= (parent.top - self.top) / scaleY;
    else if (self.bottom > parent.bottom) container.scrollTop += (self.bottom - parent.bottom) / scaleY;
}
// Used to pick a preferred option when two options with the same
// label occur in the result.
function $3f3985386ff18e5c$var$score(option) {
    return (option.boost || 0) * 100 + (option.apply ? 10 : 0) + (option.info ? 5 : 0) + (option.type ? 1 : 0);
}
function $3f3985386ff18e5c$var$sortOptions(active, state) {
    let options = [];
    let sections = null;
    let addOption = (option)=>{
        options.push(option);
        let { section: section } = option.completion;
        if (section) {
            if (!sections) sections = [];
            let name = typeof section == "string" ? section : section.name;
            if (!sections.some((s)=>s.name == name)) sections.push(typeof section == "string" ? {
                name: name
            } : section);
        }
    };
    let conf = state.facet($3f3985386ff18e5c$var$completionConfig);
    for (let a of active)if (a.hasResult()) {
        let getMatch = a.result.getMatch;
        if (a.result.filter === false) for (let option of a.result.options)addOption(new $3f3985386ff18e5c$var$Option(option, a.source, getMatch ? getMatch(option) : [], 1e9 - options.length));
        else {
            let pattern = state.sliceDoc(a.from, a.to), match;
            let matcher = conf.filterStrict ? new $3f3985386ff18e5c$var$StrictMatcher(pattern) : new $3f3985386ff18e5c$var$FuzzyMatcher(pattern);
            for (let option of a.result.options)if (match = matcher.match(option.label)) {
                let matched = !option.displayLabel ? match.matched : getMatch ? getMatch(option, match.matched) : [];
                addOption(new $3f3985386ff18e5c$var$Option(option, a.source, matched, match.score + (option.boost || 0)));
            }
        }
    }
    if (sections) {
        let sectionOrder = Object.create(null), pos = 0;
        let cmp = (a, b)=>{
            var _a, _b;
            return ((_a = a.rank) !== null && _a !== void 0 ? _a : 1e9) - ((_b = b.rank) !== null && _b !== void 0 ? _b : 1e9) || (a.name < b.name ? -1 : 1);
        };
        for (let s of sections.sort(cmp)){
            pos -= 1e5;
            sectionOrder[s.name] = pos;
        }
        for (let option of options){
            let { section: section } = option.completion;
            if (section) option.score += sectionOrder[typeof section == "string" ? section : section.name];
        }
    }
    let result = [], prev = null;
    let compare = conf.compareCompletions;
    for (let opt of options.sort((a, b)=>b.score - a.score || compare(a.completion, b.completion))){
        let cur = opt.completion;
        if (!prev || prev.label != cur.label || prev.detail != cur.detail || prev.type != null && cur.type != null && prev.type != cur.type || prev.apply != cur.apply || prev.boost != cur.boost) result.push(opt);
        else if ($3f3985386ff18e5c$var$score(opt.completion) > $3f3985386ff18e5c$var$score(prev)) result[result.length - 1] = opt;
        prev = opt.completion;
    }
    return result;
}
class $3f3985386ff18e5c$var$CompletionDialog {
    constructor(options, attrs, tooltip, timestamp, selected, disabled){
        this.options = options;
        this.attrs = attrs;
        this.tooltip = tooltip;
        this.timestamp = timestamp;
        this.selected = selected;
        this.disabled = disabled;
    }
    setSelected(selected, id) {
        return selected == this.selected || selected >= this.options.length ? this : new $3f3985386ff18e5c$var$CompletionDialog(this.options, $3f3985386ff18e5c$var$makeAttrs(id, selected), this.tooltip, this.timestamp, selected, this.disabled);
    }
    static build(active, state, id, prev, conf, didSetActive) {
        if (prev && !didSetActive && active.some((s)=>s.isPending)) return prev.setDisabled();
        let options = $3f3985386ff18e5c$var$sortOptions(active, state);
        if (!options.length) return prev && active.some((a)=>a.isPending) ? prev.setDisabled() : null;
        let selected = state.facet($3f3985386ff18e5c$var$completionConfig).selectOnOpen ? 0 : -1;
        if (prev && prev.selected != selected && prev.selected != -1) {
            let selectedValue = prev.options[prev.selected].completion;
            for(let i = 0; i < options.length; i++)if (options[i].completion == selectedValue) {
                selected = i;
                break;
            }
        }
        return new $3f3985386ff18e5c$var$CompletionDialog(options, $3f3985386ff18e5c$var$makeAttrs(id, selected), {
            pos: active.reduce((a, b)=>b.hasResult() ? Math.min(a, b.from) : a, 1e8),
            create: $3f3985386ff18e5c$var$createTooltip,
            above: conf.aboveCursor
        }, prev ? prev.timestamp : Date.now(), selected, false);
    }
    map(changes) {
        return new $3f3985386ff18e5c$var$CompletionDialog(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), {
            pos: changes.mapPos(this.tooltip.pos)
        }), this.timestamp, this.selected, this.disabled);
    }
    setDisabled() {
        return new $3f3985386ff18e5c$var$CompletionDialog(this.options, this.attrs, this.tooltip, this.timestamp, this.selected, true);
    }
}
class $3f3985386ff18e5c$var$CompletionState {
    constructor(active, id, open){
        this.active = active;
        this.id = id;
        this.open = open;
    }
    static start() {
        return new $3f3985386ff18e5c$var$CompletionState($3f3985386ff18e5c$var$none, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
    }
    update(tr) {
        let { state: state } = tr, conf = state.facet($3f3985386ff18e5c$var$completionConfig);
        let sources = conf.override || state.languageDataAt("autocomplete", $3f3985386ff18e5c$var$cur(state)).map($3f3985386ff18e5c$var$asSource);
        let active = sources.map((source)=>{
            let value = this.active.find((s)=>s.source == source) || new $3f3985386ff18e5c$var$ActiveSource(source, this.active.some((a)=>a.state != 0 /* State.Inactive */ ) ? 1 /* State.Pending */  : 0 /* State.Inactive */ );
            return value.update(tr, conf);
        });
        if (active.length == this.active.length && active.every((a, i)=>a == this.active[i])) active = this.active;
        let open = this.open, didSet = tr.effects.some((e)=>e.is($3f3985386ff18e5c$var$setActiveEffect));
        if (open && tr.docChanged) open = open.map(tr.changes);
        if (tr.selection || active.some((a)=>a.hasResult() && tr.changes.touchesRange(a.from, a.to)) || !$3f3985386ff18e5c$var$sameResults(active, this.active) || didSet) open = $3f3985386ff18e5c$var$CompletionDialog.build(active, state, this.id, open, conf, didSet);
        else if (open && open.disabled && !active.some((a)=>a.isPending)) open = null;
        if (!open && active.every((a)=>!a.isPending) && active.some((a)=>a.hasResult())) active = active.map((a)=>a.hasResult() ? new $3f3985386ff18e5c$var$ActiveSource(a.source, 0 /* State.Inactive */ ) : a);
        for (let effect of tr.effects)if (effect.is($3f3985386ff18e5c$var$setSelectedEffect)) open = open && open.setSelected(effect.value, this.id);
        return active == this.active && open == this.open ? this : new $3f3985386ff18e5c$var$CompletionState(active, this.id, open);
    }
    get tooltip() {
        return this.open ? this.open.tooltip : null;
    }
    get attrs() {
        return this.open ? this.open.attrs : this.active.length ? $3f3985386ff18e5c$var$baseAttrs : $3f3985386ff18e5c$var$noAttrs;
    }
}
function $3f3985386ff18e5c$var$sameResults(a, b) {
    if (a == b) return true;
    for(let iA = 0, iB = 0;;){
        while(iA < a.length && !a[iA].hasResult())iA++;
        while(iB < b.length && !b[iB].hasResult())iB++;
        let endA = iA == a.length, endB = iB == b.length;
        if (endA || endB) return endA == endB;
        if (a[iA++].result != b[iB++].result) return false;
    }
}
const $3f3985386ff18e5c$var$baseAttrs = {
    "aria-autocomplete": "list"
};
const $3f3985386ff18e5c$var$noAttrs = {};
function $3f3985386ff18e5c$var$makeAttrs(id, selected) {
    let result = {
        "aria-autocomplete": "list",
        "aria-haspopup": "listbox",
        "aria-controls": id
    };
    if (selected > -1) result["aria-activedescendant"] = id + "-" + selected;
    return result;
}
const $3f3985386ff18e5c$var$none = [];
function $3f3985386ff18e5c$var$getUpdateType(tr, conf) {
    if (tr.isUserEvent("input.complete")) {
        let completion = tr.annotation($3f3985386ff18e5c$export$6c84d44c1ceeb831);
        if (completion && conf.activateOnCompletion(completion)) return 12 /* UpdateType.Reset */ ;
    }
    let typing = tr.isUserEvent("input.type");
    return typing && conf.activateOnTyping ? 5 /* UpdateType.Typing */  : typing ? 1 /* UpdateType.Typing */  : tr.isUserEvent("delete.backward") ? 2 /* UpdateType.Backspacing */  : tr.selection ? 8 /* UpdateType.Reset */  : tr.docChanged ? 16 /* UpdateType.ResetIfTouching */  : 0 /* UpdateType.None */ ;
}
class $3f3985386ff18e5c$var$ActiveSource {
    constructor(source, state, explicit = false){
        this.source = source;
        this.state = state;
        this.explicit = explicit;
    }
    hasResult() {
        return false;
    }
    get isPending() {
        return this.state == 1 /* State.Pending */ ;
    }
    update(tr, conf) {
        let type = $3f3985386ff18e5c$var$getUpdateType(tr, conf), value = this;
        if (type & 8 /* UpdateType.Reset */  || type & 16 /* UpdateType.ResetIfTouching */  && this.touches(tr)) value = new $3f3985386ff18e5c$var$ActiveSource(value.source, 0 /* State.Inactive */ );
        if (type & 4 /* UpdateType.Activate */  && value.state == 0 /* State.Inactive */ ) value = new $3f3985386ff18e5c$var$ActiveSource(this.source, 1 /* State.Pending */ );
        value = value.updateFor(tr, type);
        for (let effect of tr.effects){
            if (effect.is($3f3985386ff18e5c$var$startCompletionEffect)) value = new $3f3985386ff18e5c$var$ActiveSource(value.source, 1 /* State.Pending */ , effect.value);
            else if (effect.is($3f3985386ff18e5c$var$closeCompletionEffect)) value = new $3f3985386ff18e5c$var$ActiveSource(value.source, 0 /* State.Inactive */ );
            else if (effect.is($3f3985386ff18e5c$var$setActiveEffect)) {
                for (let active of effect.value)if (active.source == value.source) value = active;
            }
        }
        return value;
    }
    updateFor(tr, type) {
        return this.map(tr.changes);
    }
    map(changes) {
        return this;
    }
    touches(tr) {
        return tr.changes.touchesRange($3f3985386ff18e5c$var$cur(tr.state));
    }
}
class $3f3985386ff18e5c$var$ActiveResult extends $3f3985386ff18e5c$var$ActiveSource {
    constructor(source, explicit, limit, result, from, to){
        super(source, 3 /* State.Result */ , explicit);
        this.limit = limit;
        this.result = result;
        this.from = from;
        this.to = to;
    }
    hasResult() {
        return true;
    }
    updateFor(tr, type) {
        var _a;
        if (!(type & 3 /* UpdateType.SimpleInteraction */ )) return this.map(tr.changes);
        let result = this.result;
        if (result.map && !tr.changes.empty) result = result.map(result, tr.changes);
        let from = tr.changes.mapPos(this.from), to = tr.changes.mapPos(this.to, 1);
        let pos = $3f3985386ff18e5c$var$cur(tr.state);
        if (pos > to || !result || type & 2 /* UpdateType.Backspacing */  && ($3f3985386ff18e5c$var$cur(tr.startState) == this.from || pos < this.limit)) return new $3f3985386ff18e5c$var$ActiveSource(this.source, type & 4 /* UpdateType.Activate */  ? 1 /* State.Pending */  : 0 /* State.Inactive */ );
        let limit = tr.changes.mapPos(this.limit);
        if ($3f3985386ff18e5c$var$checkValid(result.validFor, tr.state, from, to)) return new $3f3985386ff18e5c$var$ActiveResult(this.source, this.explicit, limit, result, from, to);
        if (result.update && (result = result.update(result, from, to, new $3f3985386ff18e5c$export$7b73e80391102dce(tr.state, pos, false)))) return new $3f3985386ff18e5c$var$ActiveResult(this.source, this.explicit, limit, result, result.from, (_a = result.to) !== null && _a !== void 0 ? _a : $3f3985386ff18e5c$var$cur(tr.state));
        return new $3f3985386ff18e5c$var$ActiveSource(this.source, 1 /* State.Pending */ , this.explicit);
    }
    map(mapping) {
        if (mapping.empty) return this;
        let result = this.result.map ? this.result.map(this.result, mapping) : this.result;
        if (!result) return new $3f3985386ff18e5c$var$ActiveSource(this.source, 0 /* State.Inactive */ );
        return new $3f3985386ff18e5c$var$ActiveResult(this.source, this.explicit, mapping.mapPos(this.limit), this.result, mapping.mapPos(this.from), mapping.mapPos(this.to, 1));
    }
    touches(tr) {
        return tr.changes.touchesRange(this.from, this.to);
    }
}
function $3f3985386ff18e5c$var$checkValid(validFor, state, from, to) {
    if (!validFor) return false;
    let text = state.sliceDoc(from, to);
    return typeof validFor == "function" ? validFor(text, from, to, state) : $3f3985386ff18e5c$var$ensureAnchor(validFor, true).test(text);
}
const $3f3985386ff18e5c$var$setActiveEffect = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define({
    map (sources, mapping) {
        return sources.map((s)=>s.map(mapping));
    }
});
const $3f3985386ff18e5c$var$setSelectedEffect = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define();
const $3f3985386ff18e5c$var$completionState = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$34381b1ce2130245).define({
    create () {
        return $3f3985386ff18e5c$var$CompletionState.start();
    },
    update (value, tr) {
        return value.update(tr);
    },
    provide: (f)=>[
            (0, $1d528cc0e08a0656$export$dba11b50e1aa3c12).from(f, (val)=>val.tooltip),
            (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).contentAttributes.from(f, (state)=>state.attrs)
        ]
});
function $3f3985386ff18e5c$var$applyCompletion(view, option) {
    const apply = option.completion.apply || option.completion.label;
    let result = view.state.field($3f3985386ff18e5c$var$completionState).active.find((a)=>a.source == option.source);
    if (!(result instanceof $3f3985386ff18e5c$var$ActiveResult)) return false;
    if (typeof apply == "string") view.dispatch(Object.assign(Object.assign({}, $3f3985386ff18e5c$export$496ff43229d73eba(view.state, apply, result.from, result.to)), {
        annotations: $3f3985386ff18e5c$export$6c84d44c1ceeb831.of(option.completion)
    }));
    else apply(view, option.completion, result.from, result.to);
    return true;
}
const $3f3985386ff18e5c$var$createTooltip = /*@__PURE__*/ $3f3985386ff18e5c$var$completionTooltip($3f3985386ff18e5c$var$completionState, $3f3985386ff18e5c$var$applyCompletion);
/**
Returns a command that moves the completion selection forward or
backward by the given amount.
*/ function $3f3985386ff18e5c$export$26f3a479ac65d653(forward, by = "option") {
    return (view)=>{
        let cState = view.state.field($3f3985386ff18e5c$var$completionState, false);
        if (!cState || !cState.open || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet($3f3985386ff18e5c$var$completionConfig).interactionDelay) return false;
        let step = 1, tooltip;
        if (by == "page" && (tooltip = (0, $1d528cc0e08a0656$export$46455b4476d4b8e1)(view, cState.open.tooltip))) step = Math.max(2, Math.floor(tooltip.dom.offsetHeight / tooltip.dom.querySelector("li").offsetHeight) - 1);
        let { length: length } = cState.open.options;
        let selected = cState.open.selected > -1 ? cState.open.selected + step * (forward ? 1 : -1) : forward ? 0 : length - 1;
        if (selected < 0) selected = by == "page" ? 0 : length - 1;
        else if (selected >= length) selected = by == "page" ? length - 1 : 0;
        view.dispatch({
            effects: $3f3985386ff18e5c$var$setSelectedEffect.of(selected)
        });
        return true;
    };
}
/**
Accept the current completion.
*/ const $3f3985386ff18e5c$export$537623a3380ccdae = (view)=>{
    let cState = view.state.field($3f3985386ff18e5c$var$completionState, false);
    if (view.state.readOnly || !cState || !cState.open || cState.open.selected < 0 || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet($3f3985386ff18e5c$var$completionConfig).interactionDelay) return false;
    return $3f3985386ff18e5c$var$applyCompletion(view, cState.open.options[cState.open.selected]);
};
/**
Explicitly start autocompletion.
*/ const $3f3985386ff18e5c$export$8a36416d28f82fd5 = (view)=>{
    let cState = view.state.field($3f3985386ff18e5c$var$completionState, false);
    if (!cState) return false;
    view.dispatch({
        effects: $3f3985386ff18e5c$var$startCompletionEffect.of(true)
    });
    return true;
};
/**
Close the currently active completion.
*/ const $3f3985386ff18e5c$export$bdc62126738c63ab = (view)=>{
    let cState = view.state.field($3f3985386ff18e5c$var$completionState, false);
    if (!cState || !cState.active.some((a)=>a.state != 0 /* State.Inactive */ )) return false;
    view.dispatch({
        effects: $3f3985386ff18e5c$var$closeCompletionEffect.of(null)
    });
    return true;
};
class $3f3985386ff18e5c$var$RunningQuery {
    constructor(active, context){
        this.active = active;
        this.context = context;
        this.time = Date.now();
        this.updates = [];
        // Note that 'undefined' means 'not done yet', whereas 'null' means
        // 'query returned null'.
        this.done = undefined;
    }
}
const $3f3985386ff18e5c$var$MaxUpdateCount = 50, $3f3985386ff18e5c$var$MinAbortTime = 1000;
const $3f3985386ff18e5c$var$completionPlugin = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.view = view;
        this.debounceUpdate = -1;
        this.running = [];
        this.debounceAccept = -1;
        this.pendingStart = false;
        this.composing = 0 /* CompositionState.None */ ;
        for (let active of view.state.field($3f3985386ff18e5c$var$completionState).active)if (active.isPending) this.startQuery(active);
    }
    update(update) {
        let cState = update.state.field($3f3985386ff18e5c$var$completionState);
        let conf = update.state.facet($3f3985386ff18e5c$var$completionConfig);
        if (!update.selectionSet && !update.docChanged && update.startState.field($3f3985386ff18e5c$var$completionState) == cState) return;
        let doesReset = update.transactions.some((tr)=>{
            let type = $3f3985386ff18e5c$var$getUpdateType(tr, conf);
            return type & 8 /* UpdateType.Reset */  || (tr.selection || tr.docChanged) && !(type & 3 /* UpdateType.SimpleInteraction */ );
        });
        for(let i = 0; i < this.running.length; i++){
            let query = this.running[i];
            if (doesReset || query.context.abortOnDocChange && update.docChanged || query.updates.length + update.transactions.length > $3f3985386ff18e5c$var$MaxUpdateCount && Date.now() - query.time > $3f3985386ff18e5c$var$MinAbortTime) {
                for (let handler of query.context.abortListeners)try {
                    handler();
                } catch (e) {
                    (0, $1d528cc0e08a0656$export$f86b2a1a2ce291b3)(this.view.state, e);
                }
                query.context.abortListeners = null;
                this.running.splice(i--, 1);
            } else query.updates.push(...update.transactions);
        }
        if (this.debounceUpdate > -1) clearTimeout(this.debounceUpdate);
        if (update.transactions.some((tr)=>tr.effects.some((e)=>e.is($3f3985386ff18e5c$var$startCompletionEffect)))) this.pendingStart = true;
        let delay = this.pendingStart ? 50 : conf.activateOnTypingDelay;
        this.debounceUpdate = cState.active.some((a)=>a.isPending && !this.running.some((q)=>q.active.source == a.source)) ? setTimeout(()=>this.startUpdate(), delay) : -1;
        if (this.composing != 0 /* CompositionState.None */ ) for (let tr of update.transactions){
            if (tr.isUserEvent("input.type")) this.composing = 2 /* CompositionState.Changed */ ;
            else if (this.composing == 2 /* CompositionState.Changed */  && tr.selection) this.composing = 3 /* CompositionState.ChangedAndMoved */ ;
        }
    }
    startUpdate() {
        this.debounceUpdate = -1;
        this.pendingStart = false;
        let { state: state } = this.view, cState = state.field($3f3985386ff18e5c$var$completionState);
        for (let active of cState.active)if (active.isPending && !this.running.some((r)=>r.active.source == active.source)) this.startQuery(active);
        if (this.running.length && cState.open && cState.open.disabled) this.debounceAccept = setTimeout(()=>this.accept(), this.view.state.facet($3f3985386ff18e5c$var$completionConfig).updateSyncTime);
    }
    startQuery(active) {
        let { state: state } = this.view, pos = $3f3985386ff18e5c$var$cur(state);
        let context = new $3f3985386ff18e5c$export$7b73e80391102dce(state, pos, active.explicit, this.view);
        let pending = new $3f3985386ff18e5c$var$RunningQuery(active, context);
        this.running.push(pending);
        Promise.resolve(active.source(context)).then((result)=>{
            if (!pending.context.aborted) {
                pending.done = result || null;
                this.scheduleAccept();
            }
        }, (err)=>{
            this.view.dispatch({
                effects: $3f3985386ff18e5c$var$closeCompletionEffect.of(null)
            });
            (0, $1d528cc0e08a0656$export$f86b2a1a2ce291b3)(this.view.state, err);
        });
    }
    scheduleAccept() {
        if (this.running.every((q)=>q.done !== undefined)) this.accept();
        else if (this.debounceAccept < 0) this.debounceAccept = setTimeout(()=>this.accept(), this.view.state.facet($3f3985386ff18e5c$var$completionConfig).updateSyncTime);
    }
    // For each finished query in this.running, try to create a result
    // or, if appropriate, restart the query.
    accept() {
        var _a;
        if (this.debounceAccept > -1) clearTimeout(this.debounceAccept);
        this.debounceAccept = -1;
        let updated = [];
        let conf = this.view.state.facet($3f3985386ff18e5c$var$completionConfig), cState = this.view.state.field($3f3985386ff18e5c$var$completionState);
        for(let i = 0; i < this.running.length; i++){
            let query = this.running[i];
            if (query.done === undefined) continue;
            this.running.splice(i--, 1);
            if (query.done) {
                let pos = $3f3985386ff18e5c$var$cur(query.updates.length ? query.updates[0].startState : this.view.state);
                let limit = Math.min(pos, query.done.from + (query.active.explicit ? 0 : 1));
                let active = new $3f3985386ff18e5c$var$ActiveResult(query.active.source, query.active.explicit, limit, query.done, query.done.from, (_a = query.done.to) !== null && _a !== void 0 ? _a : pos);
                // Replay the transactions that happened since the start of
                // the request and see if that preserves the result
                for (let tr of query.updates)active = active.update(tr, conf);
                if (active.hasResult()) {
                    updated.push(active);
                    continue;
                }
            }
            let current = cState.active.find((a)=>a.source == query.active.source);
            if (current && current.isPending) {
                if (query.done == null) {
                    // Explicitly failed. Should clear the pending status if it
                    // hasn't been re-set in the meantime.
                    let active = new $3f3985386ff18e5c$var$ActiveSource(query.active.source, 0 /* State.Inactive */ );
                    for (let tr of query.updates)active = active.update(tr, conf);
                    if (!active.isPending) updated.push(active);
                } else // Cleared by subsequent transactions. Restart.
                this.startQuery(current);
            }
        }
        if (updated.length || cState.open && cState.open.disabled) this.view.dispatch({
            effects: $3f3985386ff18e5c$var$setActiveEffect.of(updated)
        });
    }
}, {
    eventHandlers: {
        blur (event) {
            let state = this.view.state.field($3f3985386ff18e5c$var$completionState, false);
            if (state && state.tooltip && this.view.state.facet($3f3985386ff18e5c$var$completionConfig).closeOnBlur) {
                let dialog = state.open && (0, $1d528cc0e08a0656$export$46455b4476d4b8e1)(this.view, state.open.tooltip);
                if (!dialog || !dialog.dom.contains(event.relatedTarget)) setTimeout(()=>this.view.dispatch({
                        effects: $3f3985386ff18e5c$var$closeCompletionEffect.of(null)
                    }), 10);
            }
        },
        compositionstart () {
            this.composing = 1 /* CompositionState.Started */ ;
        },
        compositionend () {
            if (this.composing == 3 /* CompositionState.ChangedAndMoved */ ) // Safari fires compositionend events synchronously, possibly
            // from inside an update, so dispatch asynchronously to avoid reentrancy
            setTimeout(()=>this.view.dispatch({
                    effects: $3f3985386ff18e5c$var$startCompletionEffect.of(false)
                }), 20);
            this.composing = 0 /* CompositionState.None */ ;
        }
    }
});
const $3f3985386ff18e5c$var$windows = typeof navigator == "object" && /*@__PURE__*/ /Win/.test(navigator.platform);
const $3f3985386ff18e5c$var$commitCharacters = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$b92464a736444411).highest(/*@__PURE__*/ (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).domEventHandlers({
    keydown (event, view) {
        let field = view.state.field($3f3985386ff18e5c$var$completionState, false);
        if (!field || !field.open || field.open.disabled || field.open.selected < 0 || event.key.length > 1 || event.ctrlKey && !($3f3985386ff18e5c$var$windows && event.altKey) || event.metaKey) return false;
        let option = field.open.options[field.open.selected];
        let result = field.active.find((a)=>a.source == option.source);
        let commitChars = option.completion.commitCharacters || result.result.commitCharacters;
        if (commitChars && commitChars.indexOf(event.key) > -1) $3f3985386ff18e5c$var$applyCompletion(view, option);
        return false;
    }
}));
const $3f3985386ff18e5c$var$baseTheme = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).baseTheme({
    ".cm-tooltip.cm-tooltip-autocomplete": {
        "& > ul": {
            fontFamily: "monospace",
            whiteSpace: "nowrap",
            overflow: "hidden auto",
            maxWidth_fallback: "700px",
            maxWidth: "min(700px, 95vw)",
            minWidth: "250px",
            maxHeight: "10em",
            height: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            "& > li, & > completion-section": {
                padding: "1px 3px",
                lineHeight: 1.2
            },
            "& > li": {
                overflowX: "hidden",
                textOverflow: "ellipsis",
                cursor: "pointer"
            },
            "& > completion-section": {
                display: "list-item",
                borderBottom: "1px solid silver",
                paddingLeft: "0.5em",
                opacity: 0.7
            }
        }
    },
    "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
        background: "#17c",
        color: "white"
    },
    "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
        background: "#777"
    },
    "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
        background: "#347",
        color: "white"
    },
    "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
        background: "#444"
    },
    ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
        content: '"\xb7\xb7\xb7"',
        opacity: 0.5,
        display: "block",
        textAlign: "center"
    },
    ".cm-tooltip.cm-completionInfo": {
        position: "absolute",
        padding: "3px 9px",
        width: "max-content",
        maxWidth: `${400 /* Info.Width */ }px`,
        boxSizing: "border-box",
        whiteSpace: "pre-line"
    },
    ".cm-completionInfo.cm-completionInfo-left": {
        right: "100%"
    },
    ".cm-completionInfo.cm-completionInfo-right": {
        left: "100%"
    },
    ".cm-completionInfo.cm-completionInfo-left-narrow": {
        right: `${30 /* Info.Margin */ }px`
    },
    ".cm-completionInfo.cm-completionInfo-right-narrow": {
        left: `${30 /* Info.Margin */ }px`
    },
    "&light .cm-snippetField": {
        backgroundColor: "#00000022"
    },
    "&dark .cm-snippetField": {
        backgroundColor: "#ffffff22"
    },
    ".cm-snippetFieldPosition": {
        verticalAlign: "text-top",
        width: 0,
        height: "1.15em",
        display: "inline-block",
        margin: "0 -0.7px -.7em",
        borderLeft: "1.4px dotted #888"
    },
    ".cm-completionMatchedText": {
        textDecoration: "underline"
    },
    ".cm-completionDetail": {
        marginLeft: "0.5em",
        fontStyle: "italic"
    },
    ".cm-completionIcon": {
        fontSize: "90%",
        width: ".8em",
        display: "inline-block",
        textAlign: "center",
        paddingRight: ".6em",
        opacity: "0.6",
        boxSizing: "content-box"
    },
    ".cm-completionIcon-function, .cm-completionIcon-method": {
        "&:after": {
            content: "'\u0192'"
        }
    },
    ".cm-completionIcon-class": {
        "&:after": {
            content: "'\u25CB'"
        }
    },
    ".cm-completionIcon-interface": {
        "&:after": {
            content: "'\u25CC'"
        }
    },
    ".cm-completionIcon-variable": {
        "&:after": {
            content: "'\uD835\uDC65'"
        }
    },
    ".cm-completionIcon-constant": {
        "&:after": {
            content: "'\uD835\uDC36'"
        }
    },
    ".cm-completionIcon-type": {
        "&:after": {
            content: "'\uD835\uDC61'"
        }
    },
    ".cm-completionIcon-enum": {
        "&:after": {
            content: "'\u222A'"
        }
    },
    ".cm-completionIcon-property": {
        "&:after": {
            content: "'\u25A1'"
        }
    },
    ".cm-completionIcon-keyword": {
        "&:after": {
            content: "'\uD83D\uDD11\uFE0E'"
        } // Disable emoji rendering
    },
    ".cm-completionIcon-namespace": {
        "&:after": {
            content: "'\u25A2'"
        }
    },
    ".cm-completionIcon-text": {
        "&:after": {
            content: "'abc'",
            fontSize: "50%",
            verticalAlign: "middle"
        }
    }
});
class $3f3985386ff18e5c$var$FieldPos {
    constructor(field, line, from, to){
        this.field = field;
        this.line = line;
        this.from = from;
        this.to = to;
    }
}
class $3f3985386ff18e5c$var$FieldRange {
    constructor(field, from, to){
        this.field = field;
        this.from = from;
        this.to = to;
    }
    map(changes) {
        let from = changes.mapPos(this.from, -1, (0, $6b8f387faea0a4dd$export$39cf3280165f92aa).TrackDel);
        let to = changes.mapPos(this.to, 1, (0, $6b8f387faea0a4dd$export$39cf3280165f92aa).TrackDel);
        return from == null || to == null ? null : new $3f3985386ff18e5c$var$FieldRange(this.field, from, to);
    }
}
class $3f3985386ff18e5c$var$Snippet {
    constructor(lines, fieldPositions){
        this.lines = lines;
        this.fieldPositions = fieldPositions;
    }
    instantiate(state, pos) {
        let text = [], lineStart = [
            pos
        ];
        let lineObj = state.doc.lineAt(pos), baseIndent = /^\s*/.exec(lineObj.text)[0];
        for (let line of this.lines){
            if (text.length) {
                let indent = baseIndent, tabs = /^\t*/.exec(line)[0].length;
                for(let i = 0; i < tabs; i++)indent += state.facet((0, $deda11ebd5d0815e$export$9e0d0c2ce4d3ceb5));
                lineStart.push(pos + indent.length - tabs);
                line = indent + line.slice(tabs);
            }
            text.push(line);
            pos += line.length + 1;
        }
        let ranges = this.fieldPositions.map((pos)=>new $3f3985386ff18e5c$var$FieldRange(pos.field, lineStart[pos.line] + pos.from, lineStart[pos.line] + pos.to));
        return {
            text: text,
            ranges: ranges
        };
    }
    static parse(template) {
        let fields = [];
        let lines = [], positions = [], m;
        for (let line of template.split(/\r\n?|\n/)){
            while(m = /[#$]\{(?:(\d+)(?::([^}]*))?|((?:\\[{}]|[^}])*))\}/.exec(line)){
                let seq = m[1] ? +m[1] : null, rawName = m[2] || m[3] || "", found = -1;
                let name = rawName.replace(/\\[{}]/g, (m)=>m[1]);
                for(let i = 0; i < fields.length; i++)if (seq != null ? fields[i].seq == seq : name ? fields[i].name == name : false) found = i;
                if (found < 0) {
                    let i = 0;
                    while(i < fields.length && (seq == null || fields[i].seq != null && fields[i].seq < seq))i++;
                    fields.splice(i, 0, {
                        seq: seq,
                        name: name
                    });
                    found = i;
                    for (let pos of positions)if (pos.field >= found) pos.field++;
                }
                positions.push(new $3f3985386ff18e5c$var$FieldPos(found, lines.length, m.index, m.index + name.length));
                line = line.slice(0, m.index) + rawName + line.slice(m.index + m[0].length);
            }
            line = line.replace(/\\([{}])/g, (_, brace, index)=>{
                for (let pos of positions)if (pos.line == lines.length && pos.from > index) {
                    pos.from--;
                    pos.to--;
                }
                return brace;
            });
            lines.push(line);
        }
        return new $3f3985386ff18e5c$var$Snippet(lines, positions);
    }
}
let $3f3985386ff18e5c$var$fieldMarker = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$10e30b733df217ea).widget({
    widget: /*@__PURE__*/ new class extends (0, $1d528cc0e08a0656$export$95cdd842edb044c5) {
        toDOM() {
            let span = document.createElement("span");
            span.className = "cm-snippetFieldPosition";
            return span;
        }
        ignoreEvent() {
            return false;
        }
    }
});
let $3f3985386ff18e5c$var$fieldRange = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$10e30b733df217ea).mark({
    class: "cm-snippetField"
});
class $3f3985386ff18e5c$var$ActiveSnippet {
    constructor(ranges, active){
        this.ranges = ranges;
        this.active = active;
        this.deco = (0, $1d528cc0e08a0656$export$10e30b733df217ea).set(ranges.map((r)=>(r.from == r.to ? $3f3985386ff18e5c$var$fieldMarker : $3f3985386ff18e5c$var$fieldRange).range(r.from, r.to)));
    }
    map(changes) {
        let ranges = [];
        for (let r of this.ranges){
            let mapped = r.map(changes);
            if (!mapped) return null;
            ranges.push(mapped);
        }
        return new $3f3985386ff18e5c$var$ActiveSnippet(ranges, this.active);
    }
    selectionInsideField(sel) {
        return sel.ranges.every((range)=>this.ranges.some((r)=>r.field == this.active && r.from <= range.from && r.to >= range.to));
    }
}
const $3f3985386ff18e5c$var$setActive = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define({
    map (value, changes) {
        return value && value.map(changes);
    }
});
const $3f3985386ff18e5c$var$moveToField = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define();
const $3f3985386ff18e5c$var$snippetState = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$34381b1ce2130245).define({
    create () {
        return null;
    },
    update (value, tr) {
        for (let effect of tr.effects){
            if (effect.is($3f3985386ff18e5c$var$setActive)) return effect.value;
            if (effect.is($3f3985386ff18e5c$var$moveToField) && value) return new $3f3985386ff18e5c$var$ActiveSnippet(value.ranges, effect.value);
        }
        if (value && tr.docChanged) value = value.map(tr.changes);
        if (value && tr.selection && !value.selectionInsideField(tr.selection)) value = null;
        return value;
    },
    provide: (f)=>(0, $1d528cc0e08a0656$export$eece2fccabbb77c5).decorations.from(f, (val)=>val ? val.deco : (0, $1d528cc0e08a0656$export$10e30b733df217ea).none)
});
function $3f3985386ff18e5c$var$fieldSelection(ranges, field) {
    return (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).create(ranges.filter((r)=>r.field == field).map((r)=>(0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(r.from, r.to)));
}
/**
Convert a snippet template to a function that can
[apply](https://codemirror.net/6/docs/ref/#autocomplete.Completion.apply) it. Snippets are written
using syntax like this:

    "for (let ${index} = 0; ${index} < ${end}; ${index}++) {\n\t${}\n}"

Each `${}` placeholder (you may also use `#{}`) indicates a field
that the user can fill in. Its name, if any, will be the default
content for the field.

When the snippet is activated by calling the returned function,
the code is inserted at the given position. Newlines in the
template are indented by the indentation of the start line, plus
one [indent unit](https://codemirror.net/6/docs/ref/#language.indentUnit) per tab character after
the newline.

On activation, (all instances of) the first field are selected.
The user can move between fields with Tab and Shift-Tab as long as
the fields are active. Moving to the last field or moving the
cursor out of the current field deactivates the fields.

The order of fields defaults to textual order, but you can add
numbers to placeholders (`${1}` or `${1:defaultText}`) to provide
a custom order.

To include a literal `{` or `}` in your template, put a backslash
in front of it. This will be removed and the brace will not be
interpreted as indicating a placeholder.
*/ function $3f3985386ff18e5c$export$f77f1ac5bf251232(template) {
    let snippet = $3f3985386ff18e5c$var$Snippet.parse(template);
    return (editor, completion, from, to)=>{
        let { text: text, ranges: ranges } = snippet.instantiate(editor.state, from);
        let { main: main } = editor.state.selection;
        let spec = {
            changes: {
                from: from,
                to: to == main.from ? main.to : to,
                insert: (0, $6b8f387faea0a4dd$export$5f1af8db9871e1d6).of(text)
            },
            scrollIntoView: true,
            annotations: completion ? [
                $3f3985386ff18e5c$export$6c84d44c1ceeb831.of(completion),
                (0, $6b8f387faea0a4dd$export$febc5573c75cefb0).userEvent.of("input.complete")
            ] : undefined
        };
        if (ranges.length) spec.selection = $3f3985386ff18e5c$var$fieldSelection(ranges, 0);
        if (ranges.some((r)=>r.field > 0)) {
            let active = new $3f3985386ff18e5c$var$ActiveSnippet(ranges, 0);
            let effects = spec.effects = [
                $3f3985386ff18e5c$var$setActive.of(active)
            ];
            if (editor.state.field($3f3985386ff18e5c$var$snippetState, false) === undefined) effects.push((0, $6b8f387faea0a4dd$export$95000d4efaa4321f).appendConfig.of([
                $3f3985386ff18e5c$var$snippetState,
                $3f3985386ff18e5c$var$addSnippetKeymap,
                $3f3985386ff18e5c$var$snippetPointerHandler,
                $3f3985386ff18e5c$var$baseTheme
            ]));
        }
        editor.dispatch(editor.state.update(spec));
    };
}
function $3f3985386ff18e5c$var$moveField(dir) {
    return ({ state: state, dispatch: dispatch })=>{
        let active = state.field($3f3985386ff18e5c$var$snippetState, false);
        if (!active || dir < 0 && active.active == 0) return false;
        let next = active.active + dir, last = dir > 0 && !active.ranges.some((r)=>r.field == next + dir);
        dispatch(state.update({
            selection: $3f3985386ff18e5c$var$fieldSelection(active.ranges, next),
            effects: $3f3985386ff18e5c$var$setActive.of(last ? null : new $3f3985386ff18e5c$var$ActiveSnippet(active.ranges, next)),
            scrollIntoView: true
        }));
        return true;
    };
}
/**
A command that clears the active snippet, if any.
*/ const $3f3985386ff18e5c$export$4d00dce2599b1df3 = ({ state: state, dispatch: dispatch })=>{
    let active = state.field($3f3985386ff18e5c$var$snippetState, false);
    if (!active) return false;
    dispatch(state.update({
        effects: $3f3985386ff18e5c$var$setActive.of(null)
    }));
    return true;
};
/**
Move to the next snippet field, if available.
*/ const $3f3985386ff18e5c$export$d8da8fdad886df2f = /*@__PURE__*/ $3f3985386ff18e5c$var$moveField(1);
/**
Move to the previous snippet field, if available.
*/ const $3f3985386ff18e5c$export$8d02b23b64ec425c = /*@__PURE__*/ $3f3985386ff18e5c$var$moveField(-1);
/**
Check if there is an active snippet with a next field for
`nextSnippetField` to move to.
*/ function $3f3985386ff18e5c$export$9c250e449e4af222(state) {
    let active = state.field($3f3985386ff18e5c$var$snippetState, false);
    return !!(active && active.ranges.some((r)=>r.field == active.active + 1));
}
/**
Returns true if there is an active snippet and a previous field
for `prevSnippetField` to move to.
*/ function $3f3985386ff18e5c$export$ace2e22fa9996777(state) {
    let active = state.field($3f3985386ff18e5c$var$snippetState, false);
    return !!(active && active.active > 0);
}
const $3f3985386ff18e5c$var$defaultSnippetKeymap = [
    {
        key: "Tab",
        run: $3f3985386ff18e5c$export$d8da8fdad886df2f,
        shift: $3f3985386ff18e5c$export$8d02b23b64ec425c
    },
    {
        key: "Escape",
        run: $3f3985386ff18e5c$export$4d00dce2599b1df3
    }
];
/**
A facet that can be used to configure the key bindings used by
snippets. The default binds Tab to
[`nextSnippetField`](https://codemirror.net/6/docs/ref/#autocomplete.nextSnippetField), Shift-Tab to
[`prevSnippetField`](https://codemirror.net/6/docs/ref/#autocomplete.prevSnippetField), and Escape
to [`clearSnippet`](https://codemirror.net/6/docs/ref/#autocomplete.clearSnippet).
*/ const $3f3985386ff18e5c$export$1808c2f24fc99b36 = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine (maps) {
        return maps.length ? maps[0] : $3f3985386ff18e5c$var$defaultSnippetKeymap;
    }
});
const $3f3985386ff18e5c$var$addSnippetKeymap = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$b92464a736444411).highest(/*@__PURE__*/ (0, $1d528cc0e08a0656$export$5043418e2ef368d5).compute([
    $3f3985386ff18e5c$export$1808c2f24fc99b36
], (state)=>state.facet($3f3985386ff18e5c$export$1808c2f24fc99b36)));
/**
Create a completion from a snippet. Returns an object with the
properties from `completion`, plus an `apply` function that
applies the snippet.
*/ function $3f3985386ff18e5c$export$975ef56e648d23ad(template, completion) {
    return Object.assign(Object.assign({}, completion), {
        apply: $3f3985386ff18e5c$export$f77f1ac5bf251232(template)
    });
}
const $3f3985386ff18e5c$var$snippetPointerHandler = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).domEventHandlers({
    mousedown (event, view) {
        let active = view.state.field($3f3985386ff18e5c$var$snippetState, false), pos;
        if (!active || (pos = view.posAtCoords({
            x: event.clientX,
            y: event.clientY
        })) == null) return false;
        let match = active.ranges.find((r)=>r.from <= pos && r.to >= pos);
        if (!match || match.field == active.active) return false;
        view.dispatch({
            selection: $3f3985386ff18e5c$var$fieldSelection(active.ranges, match.field),
            effects: $3f3985386ff18e5c$var$setActive.of(active.ranges.some((r)=>r.field > match.field) ? new $3f3985386ff18e5c$var$ActiveSnippet(active.ranges, match.field) : null),
            scrollIntoView: true
        });
        return true;
    }
});
function $3f3985386ff18e5c$var$wordRE(wordChars) {
    let escaped = wordChars.replace(/[\]\-\\]/g, "\\$&");
    try {
        return new RegExp(`[\\p{Alphabetic}\\p{Number}_${escaped}]+`, "ug");
    } catch (_a) {
        return new RegExp(`[\w${escaped}]`, "g");
    }
}
function $3f3985386ff18e5c$var$mapRE(re, f) {
    return new RegExp(f(re.source), re.unicode ? "u" : "");
}
const $3f3985386ff18e5c$var$wordCaches = /*@__PURE__*/ Object.create(null);
function $3f3985386ff18e5c$var$wordCache(wordChars) {
    return $3f3985386ff18e5c$var$wordCaches[wordChars] || ($3f3985386ff18e5c$var$wordCaches[wordChars] = new WeakMap);
}
function $3f3985386ff18e5c$var$storeWords(doc, wordRE, result, seen, ignoreAt) {
    for(let lines = doc.iterLines(), pos = 0; !lines.next().done;){
        let { value: value } = lines, m;
        wordRE.lastIndex = 0;
        while(m = wordRE.exec(value))if (!seen[m[0]] && pos + m.index != ignoreAt) {
            result.push({
                type: "text",
                label: m[0]
            });
            seen[m[0]] = true;
            if (result.length >= 2000 /* C.MaxList */ ) return;
        }
        pos += value.length + 1;
    }
}
function $3f3985386ff18e5c$var$collectWords(doc, cache, wordRE, to, ignoreAt) {
    let big = doc.length >= 1000 /* C.MinCacheLen */ ;
    let cached = big && cache.get(doc);
    if (cached) return cached;
    let result = [], seen = Object.create(null);
    if (doc.children) {
        let pos = 0;
        for (let ch of doc.children){
            if (ch.length >= 1000 /* C.MinCacheLen */ ) {
                for (let c of $3f3985386ff18e5c$var$collectWords(ch, cache, wordRE, to - pos, ignoreAt - pos))if (!seen[c.label]) {
                    seen[c.label] = true;
                    result.push(c);
                }
            } else $3f3985386ff18e5c$var$storeWords(ch, wordRE, result, seen, ignoreAt - pos);
            pos += ch.length + 1;
        }
    } else $3f3985386ff18e5c$var$storeWords(doc, wordRE, result, seen, ignoreAt);
    if (big && result.length < 2000 /* C.MaxList */ ) cache.set(doc, result);
    return result;
}
/**
A completion source that will scan the document for words (using a
[character categorizer](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer)), and
return those as completions.
*/ const $3f3985386ff18e5c$export$a018df98be431a1 = (context)=>{
    let wordChars = context.state.languageDataAt("wordChars", context.pos).join("");
    let re = $3f3985386ff18e5c$var$wordRE(wordChars);
    let token = context.matchBefore($3f3985386ff18e5c$var$mapRE(re, (s)=>s + "$"));
    if (!token && !context.explicit) return null;
    let from = token ? token.from : context.pos;
    let options = $3f3985386ff18e5c$var$collectWords(context.state.doc, $3f3985386ff18e5c$var$wordCache(wordChars), re, 50000 /* C.Range */ , from);
    return {
        from: from,
        options: options,
        validFor: $3f3985386ff18e5c$var$mapRE(re, (s)=>"^" + s)
    };
};
const $3f3985386ff18e5c$var$defaults = {
    brackets: [
        "(",
        "[",
        "{",
        "'",
        '"'
    ],
    before: ")]}:;>",
    stringPrefixes: []
};
const $3f3985386ff18e5c$var$closeBracketEffect = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define({
    map (value, mapping) {
        let mapped = mapping.mapPos(value, -1, (0, $6b8f387faea0a4dd$export$39cf3280165f92aa).TrackAfter);
        return mapped == null ? undefined : mapped;
    }
});
const $3f3985386ff18e5c$var$closedBracket = /*@__PURE__*/ new class extends (0, $6b8f387faea0a4dd$export$d60f08ed93a48611) {
};
$3f3985386ff18e5c$var$closedBracket.startSide = 1;
$3f3985386ff18e5c$var$closedBracket.endSide = -1;
const $3f3985386ff18e5c$var$bracketState = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$34381b1ce2130245).define({
    create () {
        return (0, $6b8f387faea0a4dd$export$34cb5241245008dd).empty;
    },
    update (value, tr) {
        value = value.map(tr.changes);
        if (tr.selection) {
            let line = tr.state.doc.lineAt(tr.selection.main.head);
            value = value.update({
                filter: (from)=>from >= line.from && from <= line.to
            });
        }
        for (let effect of tr.effects)if (effect.is($3f3985386ff18e5c$var$closeBracketEffect)) value = value.update({
            add: [
                $3f3985386ff18e5c$var$closedBracket.range(effect.value, effect.value + 1)
            ]
        });
        return value;
    }
});
/**
Extension to enable bracket-closing behavior. When a closeable
bracket is typed, its closing bracket is immediately inserted
after the cursor. When closing a bracket directly in front of a
closing bracket inserted by the extension, the cursor moves over
that bracket.
*/ function $3f3985386ff18e5c$export$69e4e9d3300ff824() {
    return [
        $3f3985386ff18e5c$var$inputHandler,
        $3f3985386ff18e5c$var$bracketState
    ];
}
const $3f3985386ff18e5c$var$definedClosing = "()[]{}<>\xab\xbb\xbb\xab\uFF3B\uFF3D\uFF5B\uFF5D";
function $3f3985386ff18e5c$var$closing(ch) {
    for(let i = 0; i < $3f3985386ff18e5c$var$definedClosing.length; i += 2)if ($3f3985386ff18e5c$var$definedClosing.charCodeAt(i) == ch) return $3f3985386ff18e5c$var$definedClosing.charAt(i + 1);
    return (0, $6b8f387faea0a4dd$export$73bfc63873071f74)(ch < 128 ? ch : ch + 1);
}
function $3f3985386ff18e5c$var$config(state, pos) {
    return state.languageDataAt("closeBrackets", pos)[0] || $3f3985386ff18e5c$var$defaults;
}
const $3f3985386ff18e5c$var$android = typeof navigator == "object" && /*@__PURE__*/ /Android\b/.test(navigator.userAgent);
const $3f3985386ff18e5c$var$inputHandler = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).inputHandler.of((view, from, to, insert)=>{
    if (($3f3985386ff18e5c$var$android ? view.composing : view.compositionStarted) || view.state.readOnly) return false;
    let sel = view.state.selection.main;
    if (insert.length > 2 || insert.length == 2 && (0, $6b8f387faea0a4dd$export$a870abf234f6353c)((0, $6b8f387faea0a4dd$export$42977f40461e1360)(insert, 0)) == 1 || from != sel.from || to != sel.to) return false;
    let tr = $3f3985386ff18e5c$export$7ce1ae5219095222(view.state, insert);
    if (!tr) return false;
    view.dispatch(tr);
    return true;
});
/**
Command that implements deleting a pair of matching brackets when
the cursor is between them.
*/ const $3f3985386ff18e5c$export$5339d701ea89967c = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let conf = $3f3985386ff18e5c$var$config(state, state.selection.main.head);
    let tokens = conf.brackets || $3f3985386ff18e5c$var$defaults.brackets;
    let dont = null, changes = state.changeByRange((range)=>{
        if (range.empty) {
            let before = $3f3985386ff18e5c$var$prevChar(state.doc, range.head);
            for (let token of tokens){
                if (token == before && $3f3985386ff18e5c$var$nextChar(state.doc, range.head) == $3f3985386ff18e5c$var$closing((0, $6b8f387faea0a4dd$export$42977f40461e1360)(token, 0))) return {
                    changes: {
                        from: range.head - token.length,
                        to: range.head + token.length
                    },
                    range: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(range.head - token.length)
                };
            }
        }
        return {
            range: dont = range
        };
    });
    if (!dont) dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "delete.backward"
    }));
    return !dont;
};
/**
Close-brackets related key bindings. Binds Backspace to
[`deleteBracketPair`](https://codemirror.net/6/docs/ref/#autocomplete.deleteBracketPair).
*/ const $3f3985386ff18e5c$export$9477e95792b48f4a = [
    {
        key: "Backspace",
        run: $3f3985386ff18e5c$export$5339d701ea89967c
    }
];
/**
Implements the extension's behavior on text insertion. If the
given string counts as a bracket in the language around the
selection, and replacing the selection with it requires custom
behavior (inserting a closing version or skipping past a
previously-closed bracket), this function returns a transaction
representing that custom behavior. (You only need this if you want
to programmatically insert brackets—the
[`closeBrackets`](https://codemirror.net/6/docs/ref/#autocomplete.closeBrackets) extension will
take care of running this for user input.)
*/ function $3f3985386ff18e5c$export$7ce1ae5219095222(state, bracket) {
    let conf = $3f3985386ff18e5c$var$config(state, state.selection.main.head);
    let tokens = conf.brackets || $3f3985386ff18e5c$var$defaults.brackets;
    for (let tok of tokens){
        let closed = $3f3985386ff18e5c$var$closing((0, $6b8f387faea0a4dd$export$42977f40461e1360)(tok, 0));
        if (bracket == tok) return closed == tok ? $3f3985386ff18e5c$var$handleSame(state, tok, tokens.indexOf(tok + tok + tok) > -1, conf) : $3f3985386ff18e5c$var$handleOpen(state, tok, closed, conf.before || $3f3985386ff18e5c$var$defaults.before);
        if (bracket == closed && $3f3985386ff18e5c$var$closedBracketAt(state, state.selection.main.from)) return $3f3985386ff18e5c$var$handleClose(state, tok, closed);
    }
    return null;
}
function $3f3985386ff18e5c$var$closedBracketAt(state, pos) {
    let found = false;
    state.field($3f3985386ff18e5c$var$bracketState).between(0, state.doc.length, (from)=>{
        if (from == pos) found = true;
    });
    return found;
}
function $3f3985386ff18e5c$var$nextChar(doc, pos) {
    let next = doc.sliceString(pos, pos + 2);
    return next.slice(0, (0, $6b8f387faea0a4dd$export$a870abf234f6353c)((0, $6b8f387faea0a4dd$export$42977f40461e1360)(next, 0)));
}
function $3f3985386ff18e5c$var$prevChar(doc, pos) {
    let prev = doc.sliceString(pos - 2, pos);
    return (0, $6b8f387faea0a4dd$export$a870abf234f6353c)((0, $6b8f387faea0a4dd$export$42977f40461e1360)(prev, 0)) == prev.length ? prev : prev.slice(1);
}
function $3f3985386ff18e5c$var$handleOpen(state, open, close, closeBefore) {
    let dont = null, changes = state.changeByRange((range)=>{
        if (!range.empty) return {
            changes: [
                {
                    insert: open,
                    from: range.from
                },
                {
                    insert: close,
                    from: range.to
                }
            ],
            effects: $3f3985386ff18e5c$var$closeBracketEffect.of(range.to + open.length),
            range: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(range.anchor + open.length, range.head + open.length)
        };
        let next = $3f3985386ff18e5c$var$nextChar(state.doc, range.head);
        if (!next || /\s/.test(next) || closeBefore.indexOf(next) > -1) return {
            changes: {
                insert: open + close,
                from: range.head
            },
            effects: $3f3985386ff18e5c$var$closeBracketEffect.of(range.head + open.length),
            range: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(range.head + open.length)
        };
        return {
            range: dont = range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
function $3f3985386ff18e5c$var$handleClose(state, _open, close) {
    let dont = null, changes = state.changeByRange((range)=>{
        if (range.empty && $3f3985386ff18e5c$var$nextChar(state.doc, range.head) == close) return {
            changes: {
                from: range.head,
                to: range.head + close.length,
                insert: close
            },
            range: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(range.head + close.length)
        };
        return dont = {
            range: range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
// Handles cases where the open and close token are the same, and
// possibly triple quotes (as in `"""abc"""`-style quoting).
function $3f3985386ff18e5c$var$handleSame(state, token, allowTriple, config) {
    let stringPrefixes = config.stringPrefixes || $3f3985386ff18e5c$var$defaults.stringPrefixes;
    let dont = null, changes = state.changeByRange((range)=>{
        if (!range.empty) return {
            changes: [
                {
                    insert: token,
                    from: range.from
                },
                {
                    insert: token,
                    from: range.to
                }
            ],
            effects: $3f3985386ff18e5c$var$closeBracketEffect.of(range.to + token.length),
            range: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).range(range.anchor + token.length, range.head + token.length)
        };
        let pos = range.head, next = $3f3985386ff18e5c$var$nextChar(state.doc, pos), start;
        if (next == token) {
            if ($3f3985386ff18e5c$var$nodeStart(state, pos)) return {
                changes: {
                    insert: token + token,
                    from: pos
                },
                effects: $3f3985386ff18e5c$var$closeBracketEffect.of(pos + token.length),
                range: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(pos + token.length)
            };
            else if ($3f3985386ff18e5c$var$closedBracketAt(state, pos)) {
                let isTriple = allowTriple && state.sliceDoc(pos, pos + token.length * 3) == token + token + token;
                let content = isTriple ? token + token + token : token;
                return {
                    changes: {
                        from: pos,
                        to: pos + content.length,
                        insert: content
                    },
                    range: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(pos + content.length)
                };
            }
        } else if (allowTriple && state.sliceDoc(pos - 2 * token.length, pos) == token + token && (start = $3f3985386ff18e5c$var$canStartStringAt(state, pos - 2 * token.length, stringPrefixes)) > -1 && $3f3985386ff18e5c$var$nodeStart(state, start)) return {
            changes: {
                insert: token + token + token + token,
                from: pos
            },
            effects: $3f3985386ff18e5c$var$closeBracketEffect.of(pos + token.length),
            range: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(pos + token.length)
        };
        else if (state.charCategorizer(pos)(next) != (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word) {
            if ($3f3985386ff18e5c$var$canStartStringAt(state, pos, stringPrefixes) > -1 && !$3f3985386ff18e5c$var$probablyInString(state, pos, token, stringPrefixes)) return {
                changes: {
                    insert: token + token,
                    from: pos
                },
                effects: $3f3985386ff18e5c$var$closeBracketEffect.of(pos + token.length),
                range: (0, $6b8f387faea0a4dd$export$3bb1bd44aee62999).cursor(pos + token.length)
            };
        }
        return {
            range: dont = range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
function $3f3985386ff18e5c$var$nodeStart(state, pos) {
    let tree = (0, $deda11ebd5d0815e$export$7fc98e56a4ca6be1)(state).resolveInner(pos + 1);
    return tree.parent && tree.from == pos;
}
function $3f3985386ff18e5c$var$probablyInString(state, pos, quoteToken, prefixes) {
    let node = (0, $deda11ebd5d0815e$export$7fc98e56a4ca6be1)(state).resolveInner(pos, -1);
    let maxPrefix = prefixes.reduce((m, p)=>Math.max(m, p.length), 0);
    for(let i = 0; i < 5; i++){
        let start = state.sliceDoc(node.from, Math.min(node.to, node.from + quoteToken.length + maxPrefix));
        let quotePos = start.indexOf(quoteToken);
        if (!quotePos || quotePos > -1 && prefixes.indexOf(start.slice(0, quotePos)) > -1) {
            let first = node.firstChild;
            while(first && first.from == node.from && first.to - first.from > quoteToken.length + quotePos){
                if (state.sliceDoc(first.to - quoteToken.length, first.to) == quoteToken) return false;
                first = first.firstChild;
            }
            return true;
        }
        let parent = node.to == pos && node.parent;
        if (!parent) break;
        node = parent;
    }
    return false;
}
function $3f3985386ff18e5c$var$canStartStringAt(state, pos, prefixes) {
    let charCat = state.charCategorizer(pos);
    if (charCat(state.sliceDoc(pos - 1, pos)) != (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word) return pos;
    for (let prefix of prefixes){
        let start = pos - prefix.length;
        if (state.sliceDoc(start, pos) == prefix && charCat(state.sliceDoc(start - 1, start)) != (0, $6b8f387faea0a4dd$export$239a3d59567c1401).Word) return start;
    }
    return -1;
}
/**
Returns an extension that enables autocompletion.
*/ function $3f3985386ff18e5c$export$f95786d390465556(config = {}) {
    return [
        $3f3985386ff18e5c$var$commitCharacters,
        $3f3985386ff18e5c$var$completionState,
        $3f3985386ff18e5c$var$completionConfig.of(config),
        $3f3985386ff18e5c$var$completionPlugin,
        $3f3985386ff18e5c$var$completionKeymapExt,
        $3f3985386ff18e5c$var$baseTheme
    ];
}
/**
Basic keybindings for autocompletion.

 - Ctrl-Space (and Alt-\` on macOS): [`startCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.startCompletion)
 - Escape: [`closeCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.closeCompletion)
 - ArrowDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true)`
 - ArrowUp: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(false)`
 - PageDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true, "page")`
 - PageDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true, "page")`
 - Enter: [`acceptCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.acceptCompletion)
*/ const $3f3985386ff18e5c$export$2a3d759d156afab4 = [
    {
        key: "Ctrl-Space",
        run: $3f3985386ff18e5c$export$8a36416d28f82fd5
    },
    {
        mac: "Alt-`",
        run: $3f3985386ff18e5c$export$8a36416d28f82fd5
    },
    {
        key: "Escape",
        run: $3f3985386ff18e5c$export$bdc62126738c63ab
    },
    {
        key: "ArrowDown",
        run: /*@__PURE__*/ $3f3985386ff18e5c$export$26f3a479ac65d653(true)
    },
    {
        key: "ArrowUp",
        run: /*@__PURE__*/ $3f3985386ff18e5c$export$26f3a479ac65d653(false)
    },
    {
        key: "PageDown",
        run: /*@__PURE__*/ $3f3985386ff18e5c$export$26f3a479ac65d653(true, "page")
    },
    {
        key: "PageUp",
        run: /*@__PURE__*/ $3f3985386ff18e5c$export$26f3a479ac65d653(false, "page")
    },
    {
        key: "Enter",
        run: $3f3985386ff18e5c$export$537623a3380ccdae
    }
];
const $3f3985386ff18e5c$var$completionKeymapExt = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$b92464a736444411).highest(/*@__PURE__*/ (0, $1d528cc0e08a0656$export$5043418e2ef368d5).computeN([
    $3f3985386ff18e5c$var$completionConfig
], (state)=>state.facet($3f3985386ff18e5c$var$completionConfig).defaultKeymap ? [
        $3f3985386ff18e5c$export$2a3d759d156afab4
    ] : []));
/**
Get the current completion status. When completions are available,
this will return `"active"`. When completions are pending (in the
process of being queried), this returns `"pending"`. Otherwise, it
returns `null`.
*/ function $3f3985386ff18e5c$export$9eb35bf27959eae5(state) {
    let cState = state.field($3f3985386ff18e5c$var$completionState, false);
    return cState && cState.active.some((a)=>a.isPending) ? "pending" : cState && cState.active.some((a)=>a.state != 0 /* State.Inactive */ ) ? "active" : null;
}
const $3f3985386ff18e5c$var$completionArrayCache = /*@__PURE__*/ new WeakMap;
/**
Returns the available completions as an array.
*/ function $3f3985386ff18e5c$export$dc0f5d77fb0cbbf5(state) {
    var _a;
    let open = (_a = state.field($3f3985386ff18e5c$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    if (!open || open.disabled) return [];
    let completions = $3f3985386ff18e5c$var$completionArrayCache.get(open.options);
    if (!completions) $3f3985386ff18e5c$var$completionArrayCache.set(open.options, completions = open.options.map((o)=>o.completion));
    return completions;
}
/**
Return the currently selected completion, if any.
*/ function $3f3985386ff18e5c$export$8c322db2cd50d0f1(state) {
    var _a;
    let open = (_a = state.field($3f3985386ff18e5c$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    return open && !open.disabled && open.selected >= 0 ? open.options[open.selected].completion : null;
}
/**
Returns the currently selected position in the active completion
list, or null if no completions are active.
*/ function $3f3985386ff18e5c$export$93d3d3265e08d270(state) {
    var _a;
    let open = (_a = state.field($3f3985386ff18e5c$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    return open && !open.disabled && open.selected >= 0 ? open.selected : null;
}
/**
Create an effect that can be attached to a transaction to change
the currently selected completion.
*/ function $3f3985386ff18e5c$export$64a726c2de6175b8(index) {
    return $3f3985386ff18e5c$var$setSelectedEffect.of(index);
}






class $94204ecd11c1b792$var$SelectedDiagnostic {
    constructor(from, to, diagnostic){
        this.from = from;
        this.to = to;
        this.diagnostic = diagnostic;
    }
}
class $94204ecd11c1b792$var$LintState {
    constructor(diagnostics, panel, selected){
        this.diagnostics = diagnostics;
        this.panel = panel;
        this.selected = selected;
    }
    static init(diagnostics, panel, state) {
        // Filter the list of diagnostics for which to create markers
        let diagnosticFilter = state.facet($94204ecd11c1b792$var$lintConfig).markerFilter;
        if (diagnosticFilter) diagnostics = diagnosticFilter(diagnostics, state);
        let sorted = diagnostics.slice().sort((a, b)=>a.from - b.from || a.to - b.to);
        let deco = new (0, $6b8f387faea0a4dd$export$89e09ce03c7e8594)(), active = [], pos = 0;
        for(let i = 0;;){
            let next = i == sorted.length ? null : sorted[i];
            if (!next && !active.length) break;
            let from, to;
            if (active.length) {
                from = pos;
                to = active.reduce((p, d)=>Math.min(p, d.to), next && next.from > from ? next.from : 1e8);
            } else {
                from = next.from;
                to = next.to;
                active.push(next);
                i++;
            }
            while(i < sorted.length){
                let next = sorted[i];
                if (next.from == from && (next.to > next.from || next.to == from)) {
                    active.push(next);
                    i++;
                    to = Math.min(next.to, to);
                } else {
                    to = Math.min(next.from, to);
                    break;
                }
            }
            let sev = $94204ecd11c1b792$var$maxSeverity(active);
            if (active.some((d)=>d.from == d.to || d.from == d.to - 1 && state.doc.lineAt(d.from).to == d.from)) deco.add(from, from, (0, $1d528cc0e08a0656$export$10e30b733df217ea).widget({
                widget: new $94204ecd11c1b792$var$DiagnosticWidget(sev),
                diagnostics: active.slice()
            }));
            else {
                let markClass = active.reduce((c, d)=>d.markClass ? c + " " + d.markClass : c, "");
                deco.add(from, to, (0, $1d528cc0e08a0656$export$10e30b733df217ea).mark({
                    class: "cm-lintRange cm-lintRange-" + sev + markClass,
                    diagnostics: active.slice(),
                    inclusiveEnd: active.some((a)=>a.to > to)
                }));
            }
            pos = to;
            for(let i = 0; i < active.length; i++)if (active[i].to <= pos) active.splice(i--, 1);
        }
        let set = deco.finish();
        return new $94204ecd11c1b792$var$LintState(set, panel, $94204ecd11c1b792$var$findDiagnostic(set));
    }
}
function $94204ecd11c1b792$var$findDiagnostic(diagnostics, diagnostic = null, after = 0) {
    let found = null;
    diagnostics.between(after, 1e9, (from, to, { spec: spec })=>{
        if (diagnostic && spec.diagnostics.indexOf(diagnostic) < 0) return;
        if (!found) found = new $94204ecd11c1b792$var$SelectedDiagnostic(from, to, diagnostic || spec.diagnostics[0]);
        else if (spec.diagnostics.indexOf(found.diagnostic) < 0) return false;
        else found = new $94204ecd11c1b792$var$SelectedDiagnostic(found.from, to, found.diagnostic);
    });
    return found;
}
function $94204ecd11c1b792$var$hideTooltip(tr, tooltip) {
    let from = tooltip.pos, to = tooltip.end || from;
    let result = tr.state.facet($94204ecd11c1b792$var$lintConfig).hideOn(tr, from, to);
    if (result != null) return result;
    let line = tr.startState.doc.lineAt(tooltip.pos);
    return !!(tr.effects.some((e)=>e.is($94204ecd11c1b792$export$9c7976977981c7bf)) || tr.changes.touchesRange(line.from, Math.max(line.to, to)));
}
function $94204ecd11c1b792$var$maybeEnableLint(state, effects) {
    return state.field($94204ecd11c1b792$var$lintState, false) ? effects : effects.concat((0, $6b8f387faea0a4dd$export$95000d4efaa4321f).appendConfig.of($94204ecd11c1b792$var$lintExtensions));
}
/**
Returns a transaction spec which updates the current set of
diagnostics, and enables the lint extension if if wasn't already
active.
*/ function $94204ecd11c1b792$export$188c3c6ceeec4bb3(state, diagnostics) {
    return {
        effects: $94204ecd11c1b792$var$maybeEnableLint(state, [
            $94204ecd11c1b792$export$9c7976977981c7bf.of(diagnostics)
        ])
    };
}
/**
The state effect that updates the set of active diagnostics. Can
be useful when writing an extension that needs to track these.
*/ const $94204ecd11c1b792$export$9c7976977981c7bf = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define();
const $94204ecd11c1b792$var$togglePanel = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define();
const $94204ecd11c1b792$var$movePanelSelection = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define();
const $94204ecd11c1b792$var$lintState = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$34381b1ce2130245).define({
    create () {
        return new $94204ecd11c1b792$var$LintState((0, $1d528cc0e08a0656$export$10e30b733df217ea).none, null, null);
    },
    update (value, tr) {
        if (tr.docChanged && value.diagnostics.size) {
            let mapped = value.diagnostics.map(tr.changes), selected = null, panel = value.panel;
            if (value.selected) {
                let selPos = tr.changes.mapPos(value.selected.from, 1);
                selected = $94204ecd11c1b792$var$findDiagnostic(mapped, value.selected.diagnostic, selPos) || $94204ecd11c1b792$var$findDiagnostic(mapped, null, selPos);
            }
            if (!mapped.size && panel && tr.state.facet($94204ecd11c1b792$var$lintConfig).autoPanel) panel = null;
            value = new $94204ecd11c1b792$var$LintState(mapped, panel, selected);
        }
        for (let effect of tr.effects){
            if (effect.is($94204ecd11c1b792$export$9c7976977981c7bf)) {
                let panel = !tr.state.facet($94204ecd11c1b792$var$lintConfig).autoPanel ? value.panel : effect.value.length ? $94204ecd11c1b792$var$LintPanel.open : null;
                value = $94204ecd11c1b792$var$LintState.init(effect.value, panel, tr.state);
            } else if (effect.is($94204ecd11c1b792$var$togglePanel)) value = new $94204ecd11c1b792$var$LintState(value.diagnostics, effect.value ? $94204ecd11c1b792$var$LintPanel.open : null, value.selected);
            else if (effect.is($94204ecd11c1b792$var$movePanelSelection)) value = new $94204ecd11c1b792$var$LintState(value.diagnostics, value.panel, effect.value);
        }
        return value;
    },
    provide: (f)=>[
            (0, $1d528cc0e08a0656$export$e89c3c9af31c1e3b).from(f, (val)=>val.panel),
            (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).decorations.from(f, (s)=>s.diagnostics)
        ]
});
/**
Returns the number of active lint diagnostics in the given state.
*/ function $94204ecd11c1b792$export$31ce51ade4a789ff(state) {
    let lint = state.field($94204ecd11c1b792$var$lintState, false);
    return lint ? lint.diagnostics.size : 0;
}
const $94204ecd11c1b792$var$activeMark = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$10e30b733df217ea).mark({
    class: "cm-lintRange cm-lintRange-active"
});
function $94204ecd11c1b792$var$lintTooltip(view, pos, side) {
    let { diagnostics: diagnostics } = view.state.field($94204ecd11c1b792$var$lintState);
    let found, start = -1, end = -1;
    diagnostics.between(pos - (side < 0 ? 1 : 0), pos + (side > 0 ? 1 : 0), (from, to, { spec: spec })=>{
        if (pos >= from && pos <= to && (from == to || (pos > from || side > 0) && (pos < to || side < 0))) {
            found = spec.diagnostics;
            start = from;
            end = to;
            return false;
        }
    });
    let diagnosticFilter = view.state.facet($94204ecd11c1b792$var$lintConfig).tooltipFilter;
    if (found && diagnosticFilter) found = diagnosticFilter(found, view.state);
    if (!found) return null;
    return {
        pos: start,
        end: end,
        above: view.state.doc.lineAt(start).to < end,
        create () {
            return {
                dom: $94204ecd11c1b792$var$diagnosticsTooltip(view, found)
            };
        }
    };
}
function $94204ecd11c1b792$var$diagnosticsTooltip(view, diagnostics) {
    return (0, $2a4351068134afec$export$2e2bcd8739ae039)("ul", {
        class: "cm-tooltip-lint"
    }, diagnostics.map((d)=>$94204ecd11c1b792$var$renderDiagnostic(view, d, false)));
}
/**
Command to open and focus the lint panel.
*/ const $94204ecd11c1b792$export$5c4e65c70e8c34a7 = (view)=>{
    let field = view.state.field($94204ecd11c1b792$var$lintState, false);
    if (!field || !field.panel) view.dispatch({
        effects: $94204ecd11c1b792$var$maybeEnableLint(view.state, [
            $94204ecd11c1b792$var$togglePanel.of(true)
        ])
    });
    let panel = (0, $1d528cc0e08a0656$export$7361ed18ff57179e)(view, $94204ecd11c1b792$var$LintPanel.open);
    if (panel) panel.dom.querySelector(".cm-panel-lint ul").focus();
    return true;
};
/**
Command to close the lint panel, when open.
*/ const $94204ecd11c1b792$export$2ee372c3e690e3c3 = (view)=>{
    let field = view.state.field($94204ecd11c1b792$var$lintState, false);
    if (!field || !field.panel) return false;
    view.dispatch({
        effects: $94204ecd11c1b792$var$togglePanel.of(false)
    });
    return true;
};
/**
Move the selection to the next diagnostic.
*/ const $94204ecd11c1b792$export$79abb131646e1359 = (view)=>{
    let field = view.state.field($94204ecd11c1b792$var$lintState, false);
    if (!field) return false;
    let sel = view.state.selection.main, next = field.diagnostics.iter(sel.to + 1);
    if (!next.value) {
        next = field.diagnostics.iter(0);
        if (!next.value || next.from == sel.from && next.to == sel.to) return false;
    }
    view.dispatch({
        selection: {
            anchor: next.from,
            head: next.to
        },
        scrollIntoView: true
    });
    return true;
};
/**
Move the selection to the previous diagnostic.
*/ const $94204ecd11c1b792$export$f71c1dd1430b5cc1 = (view)=>{
    let { state: state } = view, field = state.field($94204ecd11c1b792$var$lintState, false);
    if (!field) return false;
    let sel = state.selection.main;
    let prevFrom, prevTo, lastFrom, lastTo;
    field.diagnostics.between(0, state.doc.length, (from, to)=>{
        if (to < sel.to && (prevFrom == null || prevFrom < from)) {
            prevFrom = from;
            prevTo = to;
        }
        if (lastFrom == null || from > lastFrom) {
            lastFrom = from;
            lastTo = to;
        }
    });
    if (lastFrom == null || prevFrom == null && lastFrom == sel.from) return false;
    view.dispatch({
        selection: {
            anchor: prevFrom !== null && prevFrom !== void 0 ? prevFrom : lastFrom,
            head: prevTo !== null && prevTo !== void 0 ? prevTo : lastTo
        },
        scrollIntoView: true
    });
    return true;
};
/**
A set of default key bindings for the lint functionality.

- Ctrl-Shift-m (Cmd-Shift-m on macOS): [`openLintPanel`](https://codemirror.net/6/docs/ref/#lint.openLintPanel)
- F8: [`nextDiagnostic`](https://codemirror.net/6/docs/ref/#lint.nextDiagnostic)
*/ const $94204ecd11c1b792$export$a21d7a0cde3cbb60 = [
    {
        key: "Mod-Shift-m",
        run: $94204ecd11c1b792$export$5c4e65c70e8c34a7,
        preventDefault: true
    },
    {
        key: "F8",
        run: $94204ecd11c1b792$export$79abb131646e1359
    }
];
const $94204ecd11c1b792$var$lintPlugin = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.view = view;
        this.timeout = -1;
        this.set = true;
        let { delay: delay } = view.state.facet($94204ecd11c1b792$var$lintConfig);
        this.lintTime = Date.now() + delay;
        this.run = this.run.bind(this);
        this.timeout = setTimeout(this.run, delay);
    }
    run() {
        clearTimeout(this.timeout);
        let now = Date.now();
        if (now < this.lintTime - 10) this.timeout = setTimeout(this.run, this.lintTime - now);
        else {
            this.set = false;
            let { state: state } = this.view, { sources: sources } = state.facet($94204ecd11c1b792$var$lintConfig);
            if (sources.length) $94204ecd11c1b792$var$batchResults(sources.map((s)=>Promise.resolve(s(this.view))), (annotations)=>{
                if (this.view.state.doc == state.doc) this.view.dispatch($94204ecd11c1b792$export$188c3c6ceeec4bb3(this.view.state, annotations.reduce((a, b)=>a.concat(b))));
            }, (error)=>{
                (0, $1d528cc0e08a0656$export$f86b2a1a2ce291b3)(this.view.state, error);
            });
        }
    }
    update(update) {
        let config = update.state.facet($94204ecd11c1b792$var$lintConfig);
        if (update.docChanged || config != update.startState.facet($94204ecd11c1b792$var$lintConfig) || config.needsRefresh && config.needsRefresh(update)) {
            this.lintTime = Date.now() + config.delay;
            if (!this.set) {
                this.set = true;
                this.timeout = setTimeout(this.run, config.delay);
            }
        }
    }
    force() {
        if (this.set) {
            this.lintTime = Date.now();
            this.run();
        }
    }
    destroy() {
        clearTimeout(this.timeout);
    }
});
function $94204ecd11c1b792$var$batchResults(promises, sink, error) {
    let collected = [], timeout = -1;
    for (let p of promises)p.then((value)=>{
        collected.push(value);
        clearTimeout(timeout);
        if (collected.length == promises.length) sink(collected);
        else timeout = setTimeout(()=>sink(collected), 200);
    }, error);
}
const $94204ecd11c1b792$var$lintConfig = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine (input) {
        return Object.assign({
            sources: input.map((i)=>i.source).filter((x)=>x != null)
        }, (0, $6b8f387faea0a4dd$export$4e19c0b693794a7e)(input.map((i)=>i.config), {
            delay: 750,
            markerFilter: null,
            tooltipFilter: null,
            needsRefresh: null,
            hideOn: ()=>null
        }, {
            needsRefresh: (a, b)=>!a ? b : !b ? a : (u)=>a(u) || b(u)
        }));
    }
});
/**
Given a diagnostic source, this function returns an extension that
enables linting with that source. It will be called whenever the
editor is idle (after its content changed). If `null` is given as
source, this only configures the lint extension.
*/ function $94204ecd11c1b792$export$8bb7ef7a8be4cb1c(source, config = {}) {
    return [
        $94204ecd11c1b792$var$lintConfig.of({
            source: source,
            config: config
        }),
        $94204ecd11c1b792$var$lintPlugin,
        $94204ecd11c1b792$var$lintExtensions
    ];
}
/**
Forces any linters [configured](https://codemirror.net/6/docs/ref/#lint.linter) to run when the
editor is idle to run right away.
*/ function $94204ecd11c1b792$export$e917f1893924e285(view) {
    let plugin = view.plugin($94204ecd11c1b792$var$lintPlugin);
    if (plugin) plugin.force();
}
function $94204ecd11c1b792$var$assignKeys(actions) {
    let assigned = [];
    if (actions) actions: for (let { name: name } of actions){
        for(let i = 0; i < name.length; i++){
            let ch = name[i];
            if (/[a-zA-Z]/.test(ch) && !assigned.some((c)=>c.toLowerCase() == ch.toLowerCase())) {
                assigned.push(ch);
                continue actions;
            }
        }
        assigned.push("");
    }
    return assigned;
}
function $94204ecd11c1b792$var$renderDiagnostic(view, diagnostic, inPanel) {
    var _a;
    let keys = inPanel ? $94204ecd11c1b792$var$assignKeys(diagnostic.actions) : [];
    return (0, $2a4351068134afec$export$2e2bcd8739ae039)("li", {
        class: "cm-diagnostic cm-diagnostic-" + diagnostic.severity
    }, (0, $2a4351068134afec$export$2e2bcd8739ae039)("span", {
        class: "cm-diagnosticText"
    }, diagnostic.renderMessage ? diagnostic.renderMessage(view) : diagnostic.message), (_a = diagnostic.actions) === null || _a === void 0 ? void 0 : _a.map((action, i)=>{
        let fired = false, click = (e)=>{
            e.preventDefault();
            if (fired) return;
            fired = true;
            let found = $94204ecd11c1b792$var$findDiagnostic(view.state.field($94204ecd11c1b792$var$lintState).diagnostics, diagnostic);
            if (found) action.apply(view, found.from, found.to);
        };
        let { name: name } = action, keyIndex = keys[i] ? name.indexOf(keys[i]) : -1;
        let nameElt = keyIndex < 0 ? name : [
            name.slice(0, keyIndex),
            (0, $2a4351068134afec$export$2e2bcd8739ae039)("u", name.slice(keyIndex, keyIndex + 1)),
            name.slice(keyIndex + 1)
        ];
        return (0, $2a4351068134afec$export$2e2bcd8739ae039)("button", {
            type: "button",
            class: "cm-diagnosticAction",
            onclick: click,
            onmousedown: click,
            "aria-label": ` Action: ${name}${keyIndex < 0 ? "" : ` (access key "${keys[i]})"`}.`
        }, nameElt);
    }), diagnostic.source && (0, $2a4351068134afec$export$2e2bcd8739ae039)("div", {
        class: "cm-diagnosticSource"
    }, diagnostic.source));
}
class $94204ecd11c1b792$var$DiagnosticWidget extends (0, $1d528cc0e08a0656$export$95cdd842edb044c5) {
    constructor(sev){
        super();
        this.sev = sev;
    }
    eq(other) {
        return other.sev == this.sev;
    }
    toDOM() {
        return (0, $2a4351068134afec$export$2e2bcd8739ae039)("span", {
            class: "cm-lintPoint cm-lintPoint-" + this.sev
        });
    }
}
class $94204ecd11c1b792$var$PanelItem {
    constructor(view, diagnostic){
        this.diagnostic = diagnostic;
        this.id = "item_" + Math.floor(Math.random() * 0xffffffff).toString(16);
        this.dom = $94204ecd11c1b792$var$renderDiagnostic(view, diagnostic, true);
        this.dom.id = this.id;
        this.dom.setAttribute("role", "option");
    }
}
class $94204ecd11c1b792$var$LintPanel {
    constructor(view){
        this.view = view;
        this.items = [];
        let onkeydown = (event)=>{
            if (event.keyCode == 27) {
                $94204ecd11c1b792$export$2ee372c3e690e3c3(this.view);
                this.view.focus();
            } else if (event.keyCode == 38 || event.keyCode == 33) this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
            else if (event.keyCode == 40 || event.keyCode == 34) this.moveSelection((this.selectedIndex + 1) % this.items.length);
            else if (event.keyCode == 36) this.moveSelection(0);
            else if (event.keyCode == 35) this.moveSelection(this.items.length - 1);
            else if (event.keyCode == 13) this.view.focus();
            else if (event.keyCode >= 65 && event.keyCode <= 90 && this.selectedIndex >= 0) {
                let { diagnostic: diagnostic } = this.items[this.selectedIndex], keys = $94204ecd11c1b792$var$assignKeys(diagnostic.actions);
                for(let i = 0; i < keys.length; i++)if (keys[i].toUpperCase().charCodeAt(0) == event.keyCode) {
                    let found = $94204ecd11c1b792$var$findDiagnostic(this.view.state.field($94204ecd11c1b792$var$lintState).diagnostics, diagnostic);
                    if (found) diagnostic.actions[i].apply(view, found.from, found.to);
                }
            } else return;
            event.preventDefault();
        };
        let onclick = (event)=>{
            for(let i = 0; i < this.items.length; i++)if (this.items[i].dom.contains(event.target)) this.moveSelection(i);
        };
        this.list = (0, $2a4351068134afec$export$2e2bcd8739ae039)("ul", {
            tabIndex: 0,
            role: "listbox",
            "aria-label": this.view.state.phrase("Diagnostics"),
            onkeydown: onkeydown,
            onclick: onclick
        });
        this.dom = (0, $2a4351068134afec$export$2e2bcd8739ae039)("div", {
            class: "cm-panel-lint"
        }, this.list, (0, $2a4351068134afec$export$2e2bcd8739ae039)("button", {
            type: "button",
            name: "close",
            "aria-label": this.view.state.phrase("close"),
            onclick: ()=>$94204ecd11c1b792$export$2ee372c3e690e3c3(this.view)
        }, "\xd7"));
        this.update();
    }
    get selectedIndex() {
        let selected = this.view.state.field($94204ecd11c1b792$var$lintState).selected;
        if (!selected) return -1;
        for(let i = 0; i < this.items.length; i++)if (this.items[i].diagnostic == selected.diagnostic) return i;
        return -1;
    }
    update() {
        let { diagnostics: diagnostics, selected: selected } = this.view.state.field($94204ecd11c1b792$var$lintState);
        let i = 0, needsSync = false, newSelectedItem = null;
        let seen = new Set();
        diagnostics.between(0, this.view.state.doc.length, (_start, _end, { spec: spec })=>{
            for (let diagnostic of spec.diagnostics){
                if (seen.has(diagnostic)) continue;
                seen.add(diagnostic);
                let found = -1, item;
                for(let j = i; j < this.items.length; j++)if (this.items[j].diagnostic == diagnostic) {
                    found = j;
                    break;
                }
                if (found < 0) {
                    item = new $94204ecd11c1b792$var$PanelItem(this.view, diagnostic);
                    this.items.splice(i, 0, item);
                    needsSync = true;
                } else {
                    item = this.items[found];
                    if (found > i) {
                        this.items.splice(i, found - i);
                        needsSync = true;
                    }
                }
                if (selected && item.diagnostic == selected.diagnostic) {
                    if (!item.dom.hasAttribute("aria-selected")) {
                        item.dom.setAttribute("aria-selected", "true");
                        newSelectedItem = item;
                    }
                } else if (item.dom.hasAttribute("aria-selected")) item.dom.removeAttribute("aria-selected");
                i++;
            }
        });
        while(i < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0)){
            needsSync = true;
            this.items.pop();
        }
        if (this.items.length == 0) {
            this.items.push(new $94204ecd11c1b792$var$PanelItem(this.view, {
                from: -1,
                to: -1,
                severity: "info",
                message: this.view.state.phrase("No diagnostics")
            }));
            needsSync = true;
        }
        if (newSelectedItem) {
            this.list.setAttribute("aria-activedescendant", newSelectedItem.id);
            this.view.requestMeasure({
                key: this,
                read: ()=>({
                        sel: newSelectedItem.dom.getBoundingClientRect(),
                        panel: this.list.getBoundingClientRect()
                    }),
                write: ({ sel: sel, panel: panel })=>{
                    let scaleY = panel.height / this.list.offsetHeight;
                    if (sel.top < panel.top) this.list.scrollTop -= (panel.top - sel.top) / scaleY;
                    else if (sel.bottom > panel.bottom) this.list.scrollTop += (sel.bottom - panel.bottom) / scaleY;
                }
            });
        } else if (this.selectedIndex < 0) this.list.removeAttribute("aria-activedescendant");
        if (needsSync) this.sync();
    }
    sync() {
        let domPos = this.list.firstChild;
        function rm() {
            let prev = domPos;
            domPos = prev.nextSibling;
            prev.remove();
        }
        for (let item of this.items)if (item.dom.parentNode == this.list) {
            while(domPos != item.dom)rm();
            domPos = item.dom.nextSibling;
        } else this.list.insertBefore(item.dom, domPos);
        while(domPos)rm();
    }
    moveSelection(selectedIndex) {
        if (this.selectedIndex < 0) return;
        let field = this.view.state.field($94204ecd11c1b792$var$lintState);
        let selection = $94204ecd11c1b792$var$findDiagnostic(field.diagnostics, this.items[selectedIndex].diagnostic);
        if (!selection) return;
        this.view.dispatch({
            selection: {
                anchor: selection.from,
                head: selection.to
            },
            scrollIntoView: true,
            effects: $94204ecd11c1b792$var$movePanelSelection.of(selection)
        });
    }
    static open(view) {
        return new $94204ecd11c1b792$var$LintPanel(view);
    }
}
function $94204ecd11c1b792$var$svg(content, attrs = `viewBox="0 0 40 40"`) {
    return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${attrs}>${encodeURIComponent(content)}</svg>')`;
}
function $94204ecd11c1b792$var$underline(color) {
    return $94204ecd11c1b792$var$svg(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${color}" fill="none" stroke-width=".7"/>`, `width="6" height="3"`);
}
const $94204ecd11c1b792$var$baseTheme = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).baseTheme({
    ".cm-diagnostic": {
        padding: "3px 6px 3px 8px",
        marginLeft: "-1px",
        display: "block",
        whiteSpace: "pre-wrap"
    },
    ".cm-diagnostic-error": {
        borderLeft: "5px solid #d11"
    },
    ".cm-diagnostic-warning": {
        borderLeft: "5px solid orange"
    },
    ".cm-diagnostic-info": {
        borderLeft: "5px solid #999"
    },
    ".cm-diagnostic-hint": {
        borderLeft: "5px solid #66d"
    },
    ".cm-diagnosticAction": {
        font: "inherit",
        border: "none",
        padding: "2px 4px",
        backgroundColor: "#444",
        color: "white",
        borderRadius: "3px",
        marginLeft: "8px",
        cursor: "pointer"
    },
    ".cm-diagnosticSource": {
        fontSize: "70%",
        opacity: .7
    },
    ".cm-lintRange": {
        backgroundPosition: "left bottom",
        backgroundRepeat: "repeat-x",
        paddingBottom: "0.7px"
    },
    ".cm-lintRange-error": {
        backgroundImage: /*@__PURE__*/ $94204ecd11c1b792$var$underline("#d11")
    },
    ".cm-lintRange-warning": {
        backgroundImage: /*@__PURE__*/ $94204ecd11c1b792$var$underline("orange")
    },
    ".cm-lintRange-info": {
        backgroundImage: /*@__PURE__*/ $94204ecd11c1b792$var$underline("#999")
    },
    ".cm-lintRange-hint": {
        backgroundImage: /*@__PURE__*/ $94204ecd11c1b792$var$underline("#66d")
    },
    ".cm-lintRange-active": {
        backgroundColor: "#ffdd9980"
    },
    ".cm-tooltip-lint": {
        padding: 0,
        margin: 0
    },
    ".cm-lintPoint": {
        position: "relative",
        "&:after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: "-2px",
            borderLeft: "3px solid transparent",
            borderRight: "3px solid transparent",
            borderBottom: "4px solid #d11"
        }
    },
    ".cm-lintPoint-warning": {
        "&:after": {
            borderBottomColor: "orange"
        }
    },
    ".cm-lintPoint-info": {
        "&:after": {
            borderBottomColor: "#999"
        }
    },
    ".cm-lintPoint-hint": {
        "&:after": {
            borderBottomColor: "#66d"
        }
    },
    ".cm-panel.cm-panel-lint": {
        position: "relative",
        "& ul": {
            maxHeight: "100px",
            overflowY: "auto",
            "& [aria-selected]": {
                backgroundColor: "#ddd",
                "& u": {
                    textDecoration: "underline"
                }
            },
            "&:focus [aria-selected]": {
                background_fallback: "#bdf",
                backgroundColor: "Highlight",
                color_fallback: "white",
                color: "HighlightText"
            },
            "& u": {
                textDecoration: "none"
            },
            padding: 0,
            margin: 0
        },
        "& [name=close]": {
            position: "absolute",
            top: "0",
            right: "2px",
            background: "inherit",
            border: "none",
            font: "inherit",
            padding: 0,
            margin: 0
        }
    }
});
function $94204ecd11c1b792$var$severityWeight(sev) {
    return sev == "error" ? 4 : sev == "warning" ? 3 : sev == "info" ? 2 : 1;
}
function $94204ecd11c1b792$var$maxSeverity(diagnostics) {
    let sev = "hint", weight = 1;
    for (let d of diagnostics){
        let w = $94204ecd11c1b792$var$severityWeight(d.severity);
        if (w > weight) {
            weight = w;
            sev = d.severity;
        }
    }
    return sev;
}
class $94204ecd11c1b792$var$LintGutterMarker extends (0, $1d528cc0e08a0656$export$591ab4c909549043) {
    constructor(diagnostics){
        super();
        this.diagnostics = diagnostics;
        this.severity = $94204ecd11c1b792$var$maxSeverity(diagnostics);
    }
    toDOM(view) {
        let elt = document.createElement("div");
        elt.className = "cm-lint-marker cm-lint-marker-" + this.severity;
        let diagnostics = this.diagnostics;
        let diagnosticsFilter = view.state.facet($94204ecd11c1b792$var$lintGutterConfig).tooltipFilter;
        if (diagnosticsFilter) diagnostics = diagnosticsFilter(diagnostics, view.state);
        if (diagnostics.length) elt.onmouseover = ()=>$94204ecd11c1b792$var$gutterMarkerMouseOver(view, elt, diagnostics);
        return elt;
    }
}
function $94204ecd11c1b792$var$trackHoverOn(view, marker) {
    let mousemove = (event)=>{
        let rect = marker.getBoundingClientRect();
        if (event.clientX > rect.left - 10 /* Hover.Margin */  && event.clientX < rect.right + 10 /* Hover.Margin */  && event.clientY > rect.top - 10 /* Hover.Margin */  && event.clientY < rect.bottom + 10 /* Hover.Margin */ ) return;
        for(let target = event.target; target; target = target.parentNode){
            if (target.nodeType == 1 && target.classList.contains("cm-tooltip-lint")) return;
        }
        window.removeEventListener("mousemove", mousemove);
        if (view.state.field($94204ecd11c1b792$var$lintGutterTooltip)) view.dispatch({
            effects: $94204ecd11c1b792$var$setLintGutterTooltip.of(null)
        });
    };
    window.addEventListener("mousemove", mousemove);
}
function $94204ecd11c1b792$var$gutterMarkerMouseOver(view, marker, diagnostics) {
    function hovered() {
        let line = view.elementAtHeight(marker.getBoundingClientRect().top + 5 - view.documentTop);
        const linePos = view.coordsAtPos(line.from);
        if (linePos) view.dispatch({
            effects: $94204ecd11c1b792$var$setLintGutterTooltip.of({
                pos: line.from,
                above: false,
                clip: false,
                create () {
                    return {
                        dom: $94204ecd11c1b792$var$diagnosticsTooltip(view, diagnostics),
                        getCoords: ()=>marker.getBoundingClientRect()
                    };
                }
            })
        });
        marker.onmouseout = marker.onmousemove = null;
        $94204ecd11c1b792$var$trackHoverOn(view, marker);
    }
    let { hoverTime: hoverTime } = view.state.facet($94204ecd11c1b792$var$lintGutterConfig);
    let hoverTimeout = setTimeout(hovered, hoverTime);
    marker.onmouseout = ()=>{
        clearTimeout(hoverTimeout);
        marker.onmouseout = marker.onmousemove = null;
    };
    marker.onmousemove = ()=>{
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(hovered, hoverTime);
    };
}
function $94204ecd11c1b792$var$markersForDiagnostics(doc, diagnostics) {
    let byLine = Object.create(null);
    for (let diagnostic of diagnostics){
        let line = doc.lineAt(diagnostic.from);
        (byLine[line.from] || (byLine[line.from] = [])).push(diagnostic);
    }
    let markers = [];
    for(let line in byLine)markers.push(new $94204ecd11c1b792$var$LintGutterMarker(byLine[line]).range(+line));
    return (0, $6b8f387faea0a4dd$export$34cb5241245008dd).of(markers, true);
}
const $94204ecd11c1b792$var$lintGutterExtension = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$f2b922cb4a245974)({
    class: "cm-gutter-lint",
    markers: (view)=>view.state.field($94204ecd11c1b792$var$lintGutterMarkers),
    widgetMarker: (view, widget, block)=>{
        let diagnostics = [];
        view.state.field($94204ecd11c1b792$var$lintGutterMarkers).between(block.from, block.to, (from, to, value)=>{
            if (from > block.from && from < block.to) diagnostics.push(...value.diagnostics);
        });
        return diagnostics.length ? new $94204ecd11c1b792$var$LintGutterMarker(diagnostics) : null;
    }
});
const $94204ecd11c1b792$var$lintGutterMarkers = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$34381b1ce2130245).define({
    create () {
        return (0, $6b8f387faea0a4dd$export$34cb5241245008dd).empty;
    },
    update (markers, tr) {
        markers = markers.map(tr.changes);
        let diagnosticFilter = tr.state.facet($94204ecd11c1b792$var$lintGutterConfig).markerFilter;
        for (let effect of tr.effects)if (effect.is($94204ecd11c1b792$export$9c7976977981c7bf)) {
            let diagnostics = effect.value;
            if (diagnosticFilter) diagnostics = diagnosticFilter(diagnostics || [], tr.state);
            markers = $94204ecd11c1b792$var$markersForDiagnostics(tr.state.doc, diagnostics.slice(0));
        }
        return markers;
    }
});
const $94204ecd11c1b792$var$setLintGutterTooltip = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).define();
const $94204ecd11c1b792$var$lintGutterTooltip = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$34381b1ce2130245).define({
    create () {
        return null;
    },
    update (tooltip, tr) {
        if (tooltip && tr.docChanged) tooltip = $94204ecd11c1b792$var$hideTooltip(tr, tooltip) ? null : Object.assign(Object.assign({}, tooltip), {
            pos: tr.changes.mapPos(tooltip.pos)
        });
        return tr.effects.reduce((t, e)=>e.is($94204ecd11c1b792$var$setLintGutterTooltip) ? e.value : t, tooltip);
    },
    provide: (field)=>(0, $1d528cc0e08a0656$export$dba11b50e1aa3c12).from(field)
});
const $94204ecd11c1b792$var$lintGutterTheme = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).baseTheme({
    ".cm-gutter-lint": {
        width: "1.4em",
        "& .cm-gutterElement": {
            padding: ".2em"
        }
    },
    ".cm-lint-marker": {
        width: "1em",
        height: "1em"
    },
    ".cm-lint-marker-info": {
        content: /*@__PURE__*/ $94204ecd11c1b792$var$svg(`<path fill="#aaf" stroke="#77e" stroke-width="6" stroke-linejoin="round" d="M5 5L35 5L35 35L5 35Z"/>`)
    },
    ".cm-lint-marker-warning": {
        content: /*@__PURE__*/ $94204ecd11c1b792$var$svg(`<path fill="#fe8" stroke="#fd7" stroke-width="6" stroke-linejoin="round" d="M20 6L37 35L3 35Z"/>`)
    },
    ".cm-lint-marker-error": {
        content: /*@__PURE__*/ $94204ecd11c1b792$var$svg(`<circle cx="20" cy="20" r="15" fill="#f87" stroke="#f43" stroke-width="6"/>`)
    }
});
const $94204ecd11c1b792$var$lintExtensions = [
    $94204ecd11c1b792$var$lintState,
    /*@__PURE__*/ (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).decorations.compute([
        $94204ecd11c1b792$var$lintState
    ], (state)=>{
        let { selected: selected, panel: panel } = state.field($94204ecd11c1b792$var$lintState);
        return !selected || !panel || selected.from == selected.to ? (0, $1d528cc0e08a0656$export$10e30b733df217ea).none : (0, $1d528cc0e08a0656$export$10e30b733df217ea).set([
            $94204ecd11c1b792$var$activeMark.range(selected.from, selected.to)
        ]);
    }),
    /*@__PURE__*/ (0, $1d528cc0e08a0656$export$69f8d9e63c4aa884)($94204ecd11c1b792$var$lintTooltip, {
        hideOn: $94204ecd11c1b792$var$hideTooltip
    }),
    $94204ecd11c1b792$var$baseTheme
];
const $94204ecd11c1b792$var$lintGutterConfig = /*@__PURE__*/ (0, $6b8f387faea0a4dd$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6b8f387faea0a4dd$export$4e19c0b693794a7e)(configs, {
            hoverTime: 300 /* Hover.Time */ ,
            markerFilter: null,
            tooltipFilter: null
        });
    }
});
/**
Returns an extension that installs a gutter showing markers for
each line that has diagnostics, which can be hovered over to see
the diagnostics.
*/ function $94204ecd11c1b792$export$3a68dabf7c007d32(config = {}) {
    return [
        $94204ecd11c1b792$var$lintGutterConfig.of(config),
        $94204ecd11c1b792$var$lintGutterMarkers,
        $94204ecd11c1b792$var$lintGutterExtension,
        $94204ecd11c1b792$var$lintGutterTheme,
        $94204ecd11c1b792$var$lintGutterTooltip
    ];
}
/**
Iterate over the marked diagnostics for the given editor state,
calling `f` for each of them. Note that, if the document changed
since the diagnostics were created, the `Diagnostic` object will
hold the original outdated position, whereas the `to` and `from`
arguments hold the diagnostic's current position.
*/ function $94204ecd11c1b792$export$7991d57589868fb2(state, f) {
    let lState = state.field($94204ecd11c1b792$var$lintState, false);
    if (lState && lState.diagnostics.size) {
        let pending = [], pendingStart = [], lastEnd = -1;
        for(let iter = (0, $6b8f387faea0a4dd$export$34cb5241245008dd).iter([
            lState.diagnostics
        ]);; iter.next()){
            for(let i = 0; i < pending.length; i++)if (!iter.value || iter.value.spec.diagnostics.indexOf(pending[i]) < 0) {
                f(pending[i], pendingStart[i], lastEnd);
                pending.splice(i, 1);
                pendingStart.splice(i--, 1);
            }
            if (!iter.value) break;
            for (let d of iter.value.spec.diagnostics)if (pending.indexOf(d) < 0) {
                pending.push(d);
                pendingStart.push(iter.from);
            }
            lastEnd = iter.to;
        }
    }
}


var $25c3541399b90999$export$f4f2465c1e83499c = function basicSetup(options) {
    if (options === void 0) options = {};
    var { crosshairCursor: initCrosshairCursor = false } = options;
    var keymaps = [];
    if (options.closeBracketsKeymap !== false) keymaps = keymaps.concat((0, $3f3985386ff18e5c$export$9477e95792b48f4a));
    if (options.defaultKeymap !== false) keymaps = keymaps.concat((0, $6df8ca87402049ac$export$ab2e8d0ac5d2b69e));
    if (options.searchKeymap !== false) keymaps = keymaps.concat((0, $64f97a5f38975812$export$2dba96787cbe0a4a));
    if (options.historyKeymap !== false) keymaps = keymaps.concat((0, $6df8ca87402049ac$export$ab4a28cb63e8a670));
    if (options.foldKeymap !== false) keymaps = keymaps.concat((0, $deda11ebd5d0815e$export$39c52376a8936d67));
    if (options.completionKeymap !== false) keymaps = keymaps.concat((0, $3f3985386ff18e5c$export$2a3d759d156afab4));
    if (options.lintKeymap !== false) keymaps = keymaps.concat((0, $94204ecd11c1b792$export$a21d7a0cde3cbb60));
    var extensions = [];
    if (options.lineNumbers !== false) extensions.push((0, $1d528cc0e08a0656$export$1a8cf111682eaa7d)());
    if (options.highlightActiveLineGutter !== false) extensions.push((0, $1d528cc0e08a0656$export$93b52f08bb2c759c)());
    if (options.highlightSpecialChars !== false) extensions.push((0, $1d528cc0e08a0656$export$76dc0899547f659c)());
    if (options.history !== false) extensions.push((0, $6df8ca87402049ac$export$55abd4691b317664)());
    if (options.foldGutter !== false) extensions.push((0, $deda11ebd5d0815e$export$c4dcf64f741b6228)());
    if (options.drawSelection !== false) extensions.push((0, $1d528cc0e08a0656$export$17a3d0ab3687347d)());
    if (options.dropCursor !== false) extensions.push((0, $1d528cc0e08a0656$export$b8e3092a3bfa2062)());
    if (options.allowMultipleSelections !== false) extensions.push((0, $6b8f387faea0a4dd$export$afa855cbfaff27f2).allowMultipleSelections.of(true));
    if (options.indentOnInput !== false) extensions.push((0, $deda11ebd5d0815e$export$9bcaf6e2125ee117)());
    if (options.syntaxHighlighting !== false) extensions.push((0, $deda11ebd5d0815e$export$ec1b956ff3a16361)((0, $deda11ebd5d0815e$export$bb02a6818dd48320), {
        fallback: true
    }));
    if (options.bracketMatching !== false) extensions.push((0, $deda11ebd5d0815e$export$cef7edfd214be605)());
    if (options.closeBrackets !== false) extensions.push((0, $3f3985386ff18e5c$export$69e4e9d3300ff824)());
    if (options.autocompletion !== false) extensions.push((0, $3f3985386ff18e5c$export$f95786d390465556)());
    if (options.rectangularSelection !== false) extensions.push((0, $1d528cc0e08a0656$export$dd482925db1aabd3)());
    if (initCrosshairCursor !== false) extensions.push((0, $1d528cc0e08a0656$export$9b6525222ac3b7fb)());
    if (options.highlightActiveLine !== false) extensions.push((0, $1d528cc0e08a0656$export$1a7e096bee9035c)());
    if (options.highlightSelectionMatches !== false) extensions.push((0, $64f97a5f38975812$export$f14efe56171a2e02)());
    if (options.tabSize && typeof options.tabSize === 'number') extensions.push((0, $deda11ebd5d0815e$export$9e0d0c2ce4d3ceb5).of(' '.repeat(options.tabSize)));
    return extensions.concat([
        (0, $1d528cc0e08a0656$export$5043418e2ef368d5).of(keymaps.flat())
    ]).filter(Boolean);
};
var $25c3541399b90999$export$def279f8e103ce59 = function minimalSetup(options) {
    if (options === void 0) options = {};
    var keymaps = [];
    if (options.defaultKeymap !== false) keymaps = keymaps.concat((0, $6df8ca87402049ac$export$ab2e8d0ac5d2b69e));
    if (options.historyKeymap !== false) keymaps = keymaps.concat((0, $6df8ca87402049ac$export$ab4a28cb63e8a670));
    var extensions = [];
    if (options.highlightSpecialChars !== false) extensions.push((0, $1d528cc0e08a0656$export$76dc0899547f659c)());
    if (options.history !== false) extensions.push((0, $6df8ca87402049ac$export$55abd4691b317664)());
    if (options.drawSelection !== false) extensions.push((0, $1d528cc0e08a0656$export$17a3d0ab3687347d)());
    if (options.syntaxHighlighting !== false) extensions.push((0, $deda11ebd5d0815e$export$ec1b956ff3a16361)((0, $deda11ebd5d0815e$export$bb02a6818dd48320), {
        fallback: true
    }));
    return extensions.concat([
        (0, $1d528cc0e08a0656$export$5043418e2ef368d5).of(keymaps.flat())
    ]).filter(Boolean);
};






// Using https://github.com/one-dark/vscode-one-dark-theme/ as reference for the colors
const $c1fd7a709a131ad1$var$chalky = "#e5c07b", $c1fd7a709a131ad1$var$coral = "#e06c75", $c1fd7a709a131ad1$var$cyan = "#56b6c2", $c1fd7a709a131ad1$var$invalid = "#ffffff", $c1fd7a709a131ad1$var$ivory = "#abb2bf", $c1fd7a709a131ad1$var$stone = "#7d8799", $c1fd7a709a131ad1$var$malibu = "#61afef", $c1fd7a709a131ad1$var$sage = "#98c379", $c1fd7a709a131ad1$var$whiskey = "#d19a66", $c1fd7a709a131ad1$var$violet = "#c678dd", $c1fd7a709a131ad1$var$darkBackground = "#21252b", $c1fd7a709a131ad1$var$highlightBackground = "#2c313a", $c1fd7a709a131ad1$var$background = "#282c34", $c1fd7a709a131ad1$var$tooltipBackground = "#353a42", $c1fd7a709a131ad1$var$selection = "#3E4451", $c1fd7a709a131ad1$var$cursor = "#528bff";
/**
The colors used in the theme, as CSS color strings.
*/ const $c1fd7a709a131ad1$export$35e9368ef982300f = {
    chalky: $c1fd7a709a131ad1$var$chalky,
    coral: $c1fd7a709a131ad1$var$coral,
    cyan: $c1fd7a709a131ad1$var$cyan,
    invalid: $c1fd7a709a131ad1$var$invalid,
    ivory: $c1fd7a709a131ad1$var$ivory,
    stone: $c1fd7a709a131ad1$var$stone,
    malibu: $c1fd7a709a131ad1$var$malibu,
    sage: $c1fd7a709a131ad1$var$sage,
    whiskey: $c1fd7a709a131ad1$var$whiskey,
    violet: $c1fd7a709a131ad1$var$violet,
    darkBackground: $c1fd7a709a131ad1$var$darkBackground,
    highlightBackground: $c1fd7a709a131ad1$var$highlightBackground,
    background: $c1fd7a709a131ad1$var$background,
    tooltipBackground: $c1fd7a709a131ad1$var$tooltipBackground,
    selection: $c1fd7a709a131ad1$var$selection,
    cursor: $c1fd7a709a131ad1$var$cursor
};
/**
The editor theme styles for One Dark.
*/ const $c1fd7a709a131ad1$export$71837134942a888d = /*@__PURE__*/ (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).theme({
    "&": {
        color: $c1fd7a709a131ad1$var$ivory,
        backgroundColor: $c1fd7a709a131ad1$var$background
    },
    ".cm-content": {
        caretColor: $c1fd7a709a131ad1$var$cursor
    },
    ".cm-cursor, .cm-dropCursor": {
        borderLeftColor: $c1fd7a709a131ad1$var$cursor
    },
    "&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": {
        backgroundColor: $c1fd7a709a131ad1$var$selection
    },
    ".cm-panels": {
        backgroundColor: $c1fd7a709a131ad1$var$darkBackground,
        color: $c1fd7a709a131ad1$var$ivory
    },
    ".cm-panels.cm-panels-top": {
        borderBottom: "2px solid black"
    },
    ".cm-panels.cm-panels-bottom": {
        borderTop: "2px solid black"
    },
    ".cm-searchMatch": {
        backgroundColor: "#72a1ff59",
        outline: "1px solid #457dff"
    },
    ".cm-searchMatch.cm-searchMatch-selected": {
        backgroundColor: "#6199ff2f"
    },
    ".cm-activeLine": {
        backgroundColor: "#6699ff0b"
    },
    ".cm-selectionMatch": {
        backgroundColor: "#aafe661a"
    },
    "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
        backgroundColor: "#bad0f847"
    },
    ".cm-gutters": {
        backgroundColor: $c1fd7a709a131ad1$var$background,
        color: $c1fd7a709a131ad1$var$stone,
        border: "none"
    },
    ".cm-activeLineGutter": {
        backgroundColor: $c1fd7a709a131ad1$var$highlightBackground
    },
    ".cm-foldPlaceholder": {
        backgroundColor: "transparent",
        border: "none",
        color: "#ddd"
    },
    ".cm-tooltip": {
        border: "none",
        backgroundColor: $c1fd7a709a131ad1$var$tooltipBackground
    },
    ".cm-tooltip .cm-tooltip-arrow:before": {
        borderTopColor: "transparent",
        borderBottomColor: "transparent"
    },
    ".cm-tooltip .cm-tooltip-arrow:after": {
        borderTopColor: $c1fd7a709a131ad1$var$tooltipBackground,
        borderBottomColor: $c1fd7a709a131ad1$var$tooltipBackground
    },
    ".cm-tooltip-autocomplete": {
        "& > ul > li[aria-selected]": {
            backgroundColor: $c1fd7a709a131ad1$var$highlightBackground,
            color: $c1fd7a709a131ad1$var$ivory
        }
    }
}, {
    dark: true
});
/**
The highlighting style for code in the One Dark theme.
*/ const $c1fd7a709a131ad1$export$e74990644b6794ed = /*@__PURE__*/ (0, $deda11ebd5d0815e$export$4819f093bdd5b4a).define([
    {
        tag: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).keyword,
        color: $c1fd7a709a131ad1$var$violet
    },
    {
        tag: [
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).name,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).deleted,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).character,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).propertyName,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).macroName
        ],
        color: $c1fd7a709a131ad1$var$coral
    },
    {
        tag: [
            /*@__PURE__*/ (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).function((0, $6b8758376c12ba5a$export$8b7a896ae75accbf).variableName),
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).labelName
        ],
        color: $c1fd7a709a131ad1$var$malibu
    },
    {
        tag: [
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).color,
            /*@__PURE__*/ (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).constant((0, $6b8758376c12ba5a$export$8b7a896ae75accbf).name),
            /*@__PURE__*/ (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).standard((0, $6b8758376c12ba5a$export$8b7a896ae75accbf).name)
        ],
        color: $c1fd7a709a131ad1$var$whiskey
    },
    {
        tag: [
            /*@__PURE__*/ (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).definition((0, $6b8758376c12ba5a$export$8b7a896ae75accbf).name),
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).separator
        ],
        color: $c1fd7a709a131ad1$var$ivory
    },
    {
        tag: [
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).typeName,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).className,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).number,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).changed,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).annotation,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).modifier,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).self,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).namespace
        ],
        color: $c1fd7a709a131ad1$var$chalky
    },
    {
        tag: [
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).operator,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).operatorKeyword,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).url,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).escape,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).regexp,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).link,
            /*@__PURE__*/ (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).special((0, $6b8758376c12ba5a$export$8b7a896ae75accbf).string)
        ],
        color: $c1fd7a709a131ad1$var$cyan
    },
    {
        tag: [
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).meta,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).comment
        ],
        color: $c1fd7a709a131ad1$var$stone
    },
    {
        tag: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).strong,
        fontWeight: "bold"
    },
    {
        tag: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).emphasis,
        fontStyle: "italic"
    },
    {
        tag: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).strikethrough,
        textDecoration: "line-through"
    },
    {
        tag: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).link,
        color: $c1fd7a709a131ad1$var$stone,
        textDecoration: "underline"
    },
    {
        tag: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).heading,
        fontWeight: "bold",
        color: $c1fd7a709a131ad1$var$coral
    },
    {
        tag: [
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).atom,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).bool,
            /*@__PURE__*/ (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).special((0, $6b8758376c12ba5a$export$8b7a896ae75accbf).variableName)
        ],
        color: $c1fd7a709a131ad1$var$whiskey
    },
    {
        tag: [
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).processingInstruction,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).string,
            (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).inserted
        ],
        color: $c1fd7a709a131ad1$var$sage
    },
    {
        tag: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).invalid,
        color: $c1fd7a709a131ad1$var$invalid
    }
]);
/**
Extension to enable the One Dark theme (both the editor theme and
the highlight style).
*/ const $c1fd7a709a131ad1$export$97539a48bdf87cbf = [
    $c1fd7a709a131ad1$export$71837134942a888d,
    /*@__PURE__*/ (0, $deda11ebd5d0815e$export$ec1b956ff3a16361)($c1fd7a709a131ad1$export$e74990644b6794ed)
];




var $a53a93d4ef348348$export$5c0bff399ffe03b = (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).theme({
    '&': {
        backgroundColor: '#fff'
    }
}, {
    dark: false
});


var $858a716c09684e6e$export$8c6170ff4f7af97d = function getDefaultExtensions(optios) {
    if (optios === void 0) optios = {};
    var { indentWithTab: defaultIndentWithTab = true, editable: editable = true, readOnly: readOnly = false, theme: theme = 'light', placeholder: placeholderStr = '', basicSetup: defaultBasicSetup = true } = optios;
    var getExtensions = [];
    if (defaultIndentWithTab) getExtensions.unshift((0, $1d528cc0e08a0656$export$5043418e2ef368d5).of([
        (0, $6df8ca87402049ac$export$893b77570f8af4da)
    ]));
    if (defaultBasicSetup) {
        if (typeof defaultBasicSetup === 'boolean') getExtensions.unshift((0, $25c3541399b90999$export$f4f2465c1e83499c)());
        else getExtensions.unshift((0, $25c3541399b90999$export$f4f2465c1e83499c)(defaultBasicSetup));
    }
    if (placeholderStr) getExtensions.unshift((0, $1d528cc0e08a0656$export$c7187bbd1a7a9244)(placeholderStr));
    switch(theme){
        case 'light':
            getExtensions.push((0, $a53a93d4ef348348$export$5c0bff399ffe03b));
            break;
        case 'dark':
            getExtensions.push((0, $c1fd7a709a131ad1$export$97539a48bdf87cbf));
            break;
        case 'none':
            break;
        default:
            getExtensions.push(theme);
            break;
    }
    if (editable === false) getExtensions.push((0, $1d528cc0e08a0656$export$eece2fccabbb77c5).editable.of(false));
    if (readOnly) getExtensions.push((0, $6b8f387faea0a4dd$export$afa855cbfaff27f2).readOnly.of(true));
    return [
        ...getExtensions
    ];
};


var $b0d6f9a3b48ec261$export$115663dc807a2e95 = (view)=>{
    return {
        line: view.state.doc.lineAt(view.state.selection.main.from),
        lineCount: view.state.doc.lines,
        lineBreak: view.state.lineBreak,
        length: view.state.doc.length,
        readOnly: view.state.readOnly,
        tabSize: view.state.tabSize,
        selection: view.state.selection,
        selectionAsSingle: view.state.selection.asSingle().main,
        ranges: view.state.selection.ranges,
        selectionCode: view.state.sliceDoc(view.state.selection.main.from, view.state.selection.main.to),
        selections: view.state.selection.ranges.map((r)=>view.state.sliceDoc(r.from, r.to)),
        selectedText: view.state.selection.ranges.some((r)=>!r.empty)
    };
};


// Setting / Unsetting timeouts for every keystroke was a significant overhead
// Inspired from https://github.com/iostreamer-X/timeout-latch
class $d087191e119d1503$export$2d12d9c467a84f85 {
    constructor(callback, timeoutMS){
        this.timeLeftMS = void 0;
        this.timeoutMS = void 0;
        this.isCancelled = false;
        this.isTimeExhausted = false;
        this.callbacks = [];
        this.timeLeftMS = timeoutMS;
        this.timeoutMS = timeoutMS;
        this.callbacks.push(callback);
    }
    tick() {
        if (!this.isCancelled && !this.isTimeExhausted) {
            this.timeLeftMS--;
            if (this.timeLeftMS <= 0) {
                this.isTimeExhausted = true;
                var callbacks = this.callbacks.slice();
                this.callbacks.length = 0;
                callbacks.forEach((callback)=>{
                    try {
                        callback();
                    } catch (error) {
                        console.error('TimeoutLatch callback error:', error);
                    }
                });
            }
        }
    }
    cancel() {
        this.isCancelled = true;
        this.callbacks.length = 0;
    }
    reset() {
        this.timeLeftMS = this.timeoutMS;
        this.isCancelled = false;
        this.isTimeExhausted = false;
    }
    get isDone() {
        return this.isCancelled || this.isTimeExhausted;
    }
}
class $d087191e119d1503$var$Scheduler {
    constructor(){
        this.interval = null;
        this.latches = new Set();
    }
    add(latch) {
        this.latches.add(latch);
        this.start();
    }
    remove(latch) {
        this.latches.delete(latch);
        if (this.latches.size === 0) this.stop();
    }
    start() {
        if (this.interval === null) this.interval = setInterval(()=>{
            this.latches.forEach((latch)=>{
                latch.tick();
                if (latch.isDone) this.remove(latch);
            });
        }, 1);
    }
    stop() {
        if (this.interval !== null) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }
}
var $d087191e119d1503$var$globalScheduler = null;
var $d087191e119d1503$export$5cff7ac265db316a = ()=>{
    if (typeof window === 'undefined') return new $d087191e119d1503$var$Scheduler();
    if (!$d087191e119d1503$var$globalScheduler) $d087191e119d1503$var$globalScheduler = new $d087191e119d1503$var$Scheduler();
    return $d087191e119d1503$var$globalScheduler;
};


var $47ef7861fa503f55$export$45aeca172c9785ae = (0, $6b8f387faea0a4dd$export$9279461326b8700a).define();
var $47ef7861fa503f55$var$TYPING_TIMOUT = 200; // ms
var $47ef7861fa503f55$var$emptyExtensions = [];
function $47ef7861fa503f55$export$6b2608dbc019b23d(props) {
    var { value: value, selection: selection, onChange: onChange, onStatistics: onStatistics, onCreateEditor: onCreateEditor, onUpdate: onUpdate, extensions: extensions = $47ef7861fa503f55$var$emptyExtensions, autoFocus: autoFocus, theme: theme = 'light', height: height = null, minHeight: minHeight = null, maxHeight: maxHeight = null, width: width = null, minWidth: minWidth = null, maxWidth: maxWidth = null, placeholder: placeholderStr = '', editable: editable = true, readOnly: readOnly = false, indentWithTab: defaultIndentWithTab = true, basicSetup: defaultBasicSetup = true, root: root, initialState: initialState } = props;
    var [container, setContainer] = (0, $3aPmr.useState)();
    var [view, setView] = (0, $3aPmr.useState)();
    var [state, setState] = (0, $3aPmr.useState)();
    var typingLatch = (0, $3aPmr.useState)(()=>({
            current: null
        }))[0];
    var pendingUpdate = (0, $3aPmr.useState)(()=>({
            current: null
        }))[0];
    var defaultThemeOption = (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).theme({
        '&': {
            height: height,
            minHeight: minHeight,
            maxHeight: maxHeight,
            width: width,
            minWidth: minWidth,
            maxWidth: maxWidth
        },
        '& .cm-scroller': {
            height: '100% !important'
        }
    });
    var updateListener = (0, $1d528cc0e08a0656$export$eece2fccabbb77c5).updateListener.of((vu)=>{
        if (vu.docChanged && typeof onChange === 'function' && // Fix echoing of the remote changes:
        // If transaction is market as remote we don't have to call `onChange` handler again
        !vu.transactions.some((tr)=>tr.annotation($47ef7861fa503f55$export$45aeca172c9785ae))) {
            if (typingLatch.current) typingLatch.current.reset();
            else {
                typingLatch.current = new (0, $d087191e119d1503$export$2d12d9c467a84f85)(()=>{
                    if (pendingUpdate.current) {
                        var forceUpdate = pendingUpdate.current;
                        pendingUpdate.current = null;
                        forceUpdate();
                    }
                    typingLatch.current = null;
                }, $47ef7861fa503f55$var$TYPING_TIMOUT);
                (0, $d087191e119d1503$export$5cff7ac265db316a)().add(typingLatch.current);
            }
            var doc = vu.state.doc;
            var _value = doc.toString();
            onChange(_value, vu);
        }
        onStatistics && onStatistics((0, $b0d6f9a3b48ec261$export$115663dc807a2e95)(vu));
    });
    var defaultExtensions = (0, $858a716c09684e6e$export$8c6170ff4f7af97d)({
        theme: theme,
        editable: editable,
        readOnly: readOnly,
        placeholder: placeholderStr,
        indentWithTab: defaultIndentWithTab,
        basicSetup: defaultBasicSetup
    });
    var getExtensions = [
        updateListener,
        defaultThemeOption,
        ...defaultExtensions
    ];
    if (onUpdate && typeof onUpdate === 'function') getExtensions.push((0, $1d528cc0e08a0656$export$eece2fccabbb77c5).updateListener.of(onUpdate));
    getExtensions = getExtensions.concat(extensions);
    (0, $3aPmr.useLayoutEffect)(()=>{
        if (container && !state) {
            var config = {
                doc: value,
                selection: selection,
                extensions: getExtensions
            };
            var stateCurrent = initialState ? (0, $6b8f387faea0a4dd$export$afa855cbfaff27f2).fromJSON(initialState.json, config, initialState.fields) : (0, $6b8f387faea0a4dd$export$afa855cbfaff27f2).create(config);
            setState(stateCurrent);
            if (!view) {
                var viewCurrent = new (0, $1d528cc0e08a0656$export$eece2fccabbb77c5)({
                    state: stateCurrent,
                    parent: container,
                    root: root
                });
                setView(viewCurrent);
                onCreateEditor && onCreateEditor(viewCurrent, stateCurrent);
            }
        }
        return ()=>{
            if (view) {
                setState(undefined);
                setView(undefined);
            }
        };
    }, [
        container,
        state
    ]);
    (0, $3aPmr.useEffect)(()=>{
        if (props.container) setContainer(props.container);
    }, [
        props.container
    ]);
    (0, $3aPmr.useEffect)(()=>()=>{
            if (view) {
                view.destroy();
                setView(undefined);
            }
            if (typingLatch.current) {
                typingLatch.current.cancel();
                typingLatch.current = null;
            }
        }, [
        view
    ]);
    (0, $3aPmr.useEffect)(()=>{
        if (autoFocus && view) view.focus();
    }, [
        autoFocus,
        view
    ]);
    (0, $3aPmr.useEffect)(()=>{
        if (view) view.dispatch({
            effects: (0, $6b8f387faea0a4dd$export$95000d4efaa4321f).reconfigure.of(getExtensions)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        theme,
        extensions,
        height,
        minHeight,
        maxHeight,
        width,
        minWidth,
        maxWidth,
        placeholderStr,
        editable,
        readOnly,
        defaultIndentWithTab,
        defaultBasicSetup,
        onChange,
        onUpdate
    ]);
    (0, $3aPmr.useEffect)(()=>{
        if (value === undefined) return;
        var currentValue = view ? view.state.doc.toString() : '';
        if (view && value !== currentValue) {
            var isTyping = typingLatch.current && !typingLatch.current.isDone;
            var forceUpdate = ()=>{
                if (view && value !== view.state.doc.toString()) view.dispatch({
                    changes: {
                        from: 0,
                        to: view.state.doc.toString().length,
                        insert: value || ''
                    },
                    annotations: [
                        $47ef7861fa503f55$export$45aeca172c9785ae.of(true)
                    ]
                });
            };
            if (!isTyping) forceUpdate();
            else pendingUpdate.current = forceUpdate;
        }
    }, [
        value,
        view
    ]);
    return {
        state: state,
        setState: setState,
        view: view,
        setView: setView,
        container: container,
        setContainer: setContainer
    };
}








var $9ba973d84ca2580a$var$_excluded = [
    "className",
    "value",
    "selection",
    "extensions",
    "onChange",
    "onStatistics",
    "onCreateEditor",
    "onUpdate",
    "autoFocus",
    "theme",
    "height",
    "minHeight",
    "maxHeight",
    "width",
    "minWidth",
    "maxWidth",
    "basicSetup",
    "placeholder",
    "indentWithTab",
    "editable",
    "readOnly",
    "root",
    "initialState"
];
var $9ba973d84ca2580a$var$ReactCodeMirror = /*#__PURE__*/ (0, $7ikhG.forwardRef)((props, ref)=>{
    var { className: className, value: value = '', selection: selection, extensions: extensions = [], onChange: onChange, onStatistics: onStatistics, onCreateEditor: onCreateEditor, onUpdate: onUpdate, autoFocus: autoFocus, theme: theme = 'light', height: height, minHeight: minHeight, maxHeight: maxHeight, width: width, minWidth: minWidth, maxWidth: maxWidth, basicSetup: basicSetup, placeholder: placeholder, indentWithTab: indentWithTab, editable: editable, readOnly: readOnly, root: root, initialState: initialState } = props, other = (0, (/*@__PURE__*/$parcel$interopDefault($30cb065ea47a1f86$exports)))(props, $9ba973d84ca2580a$var$_excluded);
    var editor = (0, $3aPmr.useRef)(null);
    var { state: state, view: view, container: container, setContainer: setContainer } = (0, $47ef7861fa503f55$export$6b2608dbc019b23d)({
        root: root,
        value: value,
        autoFocus: autoFocus,
        theme: theme,
        height: height,
        minHeight: minHeight,
        maxHeight: maxHeight,
        width: width,
        minWidth: minWidth,
        maxWidth: maxWidth,
        basicSetup: basicSetup,
        placeholder: placeholder,
        indentWithTab: indentWithTab,
        editable: editable,
        readOnly: readOnly,
        selection: selection,
        onChange: onChange,
        onStatistics: onStatistics,
        onCreateEditor: onCreateEditor,
        onUpdate: onUpdate,
        extensions: extensions,
        initialState: initialState
    });
    (0, $3aPmr.useImperativeHandle)(ref, ()=>({
            editor: editor.current,
            state: state,
            view: view
        }), [
        editor,
        container,
        state,
        view
    ]);
    var setEditorRef = (0, $3aPmr.useCallback)((el)=>{
        editor.current = el;
        setContainer(el);
    }, [
        setContainer
    ]);
    // check type of value
    if (typeof value !== 'string') throw new Error("value must be typeof string but got " + typeof value);
    var defaultClassNames = typeof theme === 'string' ? "cm-theme-" + theme : 'cm-theme';
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", (0, (/*@__PURE__*/$parcel$interopDefault($2d5b1ac1574da936$exports)))({
        ref: setEditorRef,
        className: "" + defaultClassNames + (className ? " " + className : '')
    }, other));
});
$9ba973d84ca2580a$var$ReactCodeMirror.displayName = 'CodeMirror';
var $9ba973d84ca2580a$export$2e2bcd8739ae039 = $9ba973d84ca2580a$var$ReactCodeMirror;



/**
A parse stack. These are used internally by the parser to track
parsing progress. They also provide some properties and methods
that external code such as a tokenizer can use to get information
about the parse state.
*/ class $0234adc01c271b5a$export$694e0d28c7ffc90c {
    /**
    @internal
    */ constructor(/**
    The parse that this stack is part of @internal
    */ p, /**
    Holds state, input pos, buffer index triplets for all but the
    top state @internal
    */ stack, /**
    The current parse state @internal
    */ state, // The position at which the next reduce should take place. This
    // can be less than `this.pos` when skipped expressions have been
    // added to the stack (which should be moved outside of the next
    // reduction)
    /**
    @internal
    */ reducePos, /**
    The input position up to which this stack has parsed.
    */ pos, /**
    The dynamic score of the stack, including dynamic precedence
    and error-recovery penalties
    @internal
    */ score, // The output buffer. Holds (type, start, end, size) quads
    // representing nodes created by the parser, where `size` is
    // amount of buffer array entries covered by this node.
    /**
    @internal
    */ buffer, // The base offset of the buffer. When stacks are split, the split
    // instance shared the buffer history with its parent up to
    // `bufferBase`, which is the absolute offset (including the
    // offset of previous splits) into the buffer at which this stack
    // starts writing.
    /**
    @internal
    */ bufferBase, /**
    @internal
    */ curContext, /**
    @internal
    */ lookAhead = 0, // A parent stack from which this was split off, if any. This is
    // set up so that it always points to a stack that has some
    // additional buffer content, never to a stack with an equal
    // `bufferBase`.
    /**
    @internal
    */ parent){
        this.p = p;
        this.stack = stack;
        this.state = state;
        this.reducePos = reducePos;
        this.pos = pos;
        this.score = score;
        this.buffer = buffer;
        this.bufferBase = bufferBase;
        this.curContext = curContext;
        this.lookAhead = lookAhead;
        this.parent = parent;
    }
    /**
    @internal
    */ toString() {
        return `[${this.stack.filter((_, i)=>i % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
    }
    // Start an empty stack
    /**
    @internal
    */ static start(p, state, pos = 0) {
        let cx = p.parser.context;
        return new $0234adc01c271b5a$export$694e0d28c7ffc90c(p, [], state, pos, pos, 0, [], 0, cx ? new $0234adc01c271b5a$var$StackContext(cx, cx.start) : null, 0, null);
    }
    /**
    The stack's current [context](#lr.ContextTracker) value, if
    any. Its type will depend on the context tracker's type
    parameter, or it will be `null` if there is no context
    tracker.
    */ get context() {
        return this.curContext ? this.curContext.context : null;
    }
    // Push a state onto the stack, tracking its start position as well
    // as the buffer base at that point.
    /**
    @internal
    */ pushState(state, start) {
        this.stack.push(this.state, start, this.bufferBase + this.buffer.length);
        this.state = state;
    }
    // Apply a reduce action
    /**
    @internal
    */ reduce(action) {
        var _a;
        let depth = action >> 19 /* Action.ReduceDepthShift */ , type = action & 65535 /* Action.ValueMask */ ;
        let { parser: parser } = this.p;
        let lookaheadRecord = this.reducePos < this.pos - 25 /* Lookahead.Margin */ ;
        if (lookaheadRecord) this.setLookAhead(this.pos);
        let dPrec = parser.dynamicPrecedence(type);
        if (dPrec) this.score += dPrec;
        if (depth == 0) {
            this.pushState(parser.getGoto(this.state, type, true), this.reducePos);
            // Zero-depth reductions are a special case—they add stuff to
            // the stack without popping anything off.
            if (type < parser.minRepeatTerm) this.storeNode(type, this.reducePos, this.reducePos, lookaheadRecord ? 8 : 4, true);
            this.reduceContext(type, this.reducePos);
            return;
        }
        // Find the base index into `this.stack`, content after which will
        // be dropped. Note that with `StayFlag` reductions we need to
        // consume two extra frames (the dummy parent node for the skipped
        // expression and the state that we'll be staying in, which should
        // be moved to `this.state`).
        let base = this.stack.length - (depth - 1) * 3 - (action & 262144 /* Action.StayFlag */  ? 6 : 0);
        let start = base ? this.stack[base - 2] : this.p.ranges[0].from, size = this.reducePos - start;
        // This is a kludge to try and detect overly deep left-associative
        // trees, which will not increase the parse stack depth and thus
        // won't be caught by the regular stack-depth limit check.
        if (size >= 2000 /* Recover.MinBigReduction */  && !((_a = this.p.parser.nodeSet.types[type]) === null || _a === void 0 ? void 0 : _a.isAnonymous)) {
            if (start == this.p.lastBigReductionStart) {
                this.p.bigReductionCount++;
                this.p.lastBigReductionSize = size;
            } else if (this.p.lastBigReductionSize < size) {
                this.p.bigReductionCount = 1;
                this.p.lastBigReductionStart = start;
                this.p.lastBigReductionSize = size;
            }
        }
        let bufferBase = base ? this.stack[base - 1] : 0, count = this.bufferBase + this.buffer.length - bufferBase;
        // Store normal terms or `R -> R R` repeat reductions
        if (type < parser.minRepeatTerm || action & 131072 /* Action.RepeatFlag */ ) {
            let pos = parser.stateFlag(this.state, 1 /* StateFlag.Skipped */ ) ? this.pos : this.reducePos;
            this.storeNode(type, start, pos, count + 4, true);
        }
        if (action & 262144 /* Action.StayFlag */ ) this.state = this.stack[base];
        else {
            let baseStateID = this.stack[base - 3];
            this.state = parser.getGoto(baseStateID, type, true);
        }
        while(this.stack.length > base)this.stack.pop();
        this.reduceContext(type, start);
    }
    // Shift a value into the buffer
    /**
    @internal
    */ storeNode(term, start, end, size = 4, mustSink = false) {
        if (term == 0 /* Term.Err */  && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
            // Try to omit/merge adjacent error nodes
            let cur = this, top = this.buffer.length;
            if (top == 0 && cur.parent) {
                top = cur.bufferBase - cur.parent.bufferBase;
                cur = cur.parent;
            }
            if (top > 0 && cur.buffer[top - 4] == 0 /* Term.Err */  && cur.buffer[top - 1] > -1) {
                if (start == end) return;
                if (cur.buffer[top - 2] >= start) {
                    cur.buffer[top - 2] = end;
                    return;
                }
            }
        }
        if (!mustSink || this.pos == end) this.buffer.push(term, start, end, size);
        else {
            let index = this.buffer.length;
            if (index > 0 && this.buffer[index - 4] != 0 /* Term.Err */ ) {
                let mustMove = false;
                for(let scan = index; scan > 0 && this.buffer[scan - 2] > end; scan -= 4)if (this.buffer[scan - 1] >= 0) {
                    mustMove = true;
                    break;
                }
                if (mustMove) while(index > 0 && this.buffer[index - 2] > end){
                    // Move this record forward
                    this.buffer[index] = this.buffer[index - 4];
                    this.buffer[index + 1] = this.buffer[index - 3];
                    this.buffer[index + 2] = this.buffer[index - 2];
                    this.buffer[index + 3] = this.buffer[index - 1];
                    index -= 4;
                    if (size > 4) size -= 4;
                }
            }
            this.buffer[index] = term;
            this.buffer[index + 1] = start;
            this.buffer[index + 2] = end;
            this.buffer[index + 3] = size;
        }
    }
    // Apply a shift action
    /**
    @internal
    */ shift(action, type, start, end) {
        if (action & 131072 /* Action.GotoFlag */ ) this.pushState(action & 65535 /* Action.ValueMask */ , this.pos);
        else if ((action & 262144 /* Action.StayFlag */ ) == 0) {
            let nextState = action, { parser: parser } = this.p;
            if (end > this.pos || type <= parser.maxNode) {
                this.pos = end;
                if (!parser.stateFlag(nextState, 1 /* StateFlag.Skipped */ )) this.reducePos = end;
            }
            this.pushState(nextState, start);
            this.shiftContext(type, start);
            if (type <= parser.maxNode) this.buffer.push(type, start, end, 4);
        } else {
            this.pos = end;
            this.shiftContext(type, start);
            if (type <= this.p.parser.maxNode) this.buffer.push(type, start, end, 4);
        }
    }
    // Apply an action
    /**
    @internal
    */ apply(action, next, nextStart, nextEnd) {
        if (action & 65536 /* Action.ReduceFlag */ ) this.reduce(action);
        else this.shift(action, next, nextStart, nextEnd);
    }
    // Add a prebuilt (reused) node into the buffer.
    /**
    @internal
    */ useNode(value, next) {
        let index = this.p.reused.length - 1;
        if (index < 0 || this.p.reused[index] != value) {
            this.p.reused.push(value);
            index++;
        }
        let start = this.pos;
        this.reducePos = this.pos = start + value.length;
        this.pushState(next, start);
        this.buffer.push(index, start, this.reducePos, -1 /* size == -1 means this is a reused value */ );
        if (this.curContext) this.updateContext(this.curContext.tracker.reuse(this.curContext.context, value, this, this.p.stream.reset(this.pos - value.length)));
    }
    // Split the stack. Due to the buffer sharing and the fact
    // that `this.stack` tends to stay quite shallow, this isn't very
    // expensive.
    /**
    @internal
    */ split() {
        let parent = this;
        let off = parent.buffer.length;
        // Because the top of the buffer (after this.pos) may be mutated
        // to reorder reductions and skipped tokens, and shared buffers
        // should be immutable, this copies any outstanding skipped tokens
        // to the new buffer, and puts the base pointer before them.
        while(off > 0 && parent.buffer[off - 2] > parent.reducePos)off -= 4;
        let buffer = parent.buffer.slice(off), base = parent.bufferBase + off;
        // Make sure parent points to an actual parent with content, if there is such a parent.
        while(parent && base == parent.bufferBase)parent = parent.parent;
        return new $0234adc01c271b5a$export$694e0d28c7ffc90c(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, buffer, base, this.curContext, this.lookAhead, parent);
    }
    // Try to recover from an error by 'deleting' (ignoring) one token.
    /**
    @internal
    */ recoverByDelete(next, nextEnd) {
        let isNode = next <= this.p.parser.maxNode;
        if (isNode) this.storeNode(next, this.pos, nextEnd, 4);
        this.storeNode(0 /* Term.Err */ , this.pos, nextEnd, isNode ? 8 : 4);
        this.pos = this.reducePos = nextEnd;
        this.score -= 190 /* Recover.Delete */ ;
    }
    /**
    Check if the given term would be able to be shifted (optionally
    after some reductions) on this stack. This can be useful for
    external tokenizers that want to make sure they only provide a
    given token when it applies.
    */ canShift(term) {
        for(let sim = new $0234adc01c271b5a$var$SimulatedStack(this);;){
            let action = this.p.parser.stateSlot(sim.state, 4 /* ParseState.DefaultReduce */ ) || this.p.parser.hasAction(sim.state, term);
            if (action == 0) return false;
            if ((action & 65536 /* Action.ReduceFlag */ ) == 0) return true;
            sim.reduce(action);
        }
    }
    // Apply up to Recover.MaxNext recovery actions that conceptually
    // inserts some missing token or rule.
    /**
    @internal
    */ recoverByInsert(next) {
        if (this.stack.length >= 300 /* Recover.MaxInsertStackDepth */ ) return [];
        let nextStates = this.p.parser.nextStates(this.state);
        if (nextStates.length > 8 || this.stack.length >= 120 /* Recover.DampenInsertStackDepth */ ) {
            let best = [];
            for(let i = 0, s; i < nextStates.length; i += 2)if ((s = nextStates[i + 1]) != this.state && this.p.parser.hasAction(s, next)) best.push(nextStates[i], s);
            if (this.stack.length < 120 /* Recover.DampenInsertStackDepth */ ) for(let i = 0; best.length < 8 && i < nextStates.length; i += 2){
                let s = nextStates[i + 1];
                if (!best.some((v, i)=>i & 1 && v == s)) best.push(nextStates[i], s);
            }
            nextStates = best;
        }
        let result = [];
        for(let i = 0; i < nextStates.length && result.length < 4 /* Recover.MaxNext */ ; i += 2){
            let s = nextStates[i + 1];
            if (s == this.state) continue;
            let stack = this.split();
            stack.pushState(s, this.pos);
            stack.storeNode(0 /* Term.Err */ , stack.pos, stack.pos, 4, true);
            stack.shiftContext(nextStates[i], this.pos);
            stack.reducePos = this.pos;
            stack.score -= 200 /* Recover.Insert */ ;
            result.push(stack);
        }
        return result;
    }
    // Force a reduce, if possible. Return false if that can't
    // be done.
    /**
    @internal
    */ forceReduce() {
        let { parser: parser } = this.p;
        let reduce = parser.stateSlot(this.state, 5 /* ParseState.ForcedReduce */ );
        if ((reduce & 65536 /* Action.ReduceFlag */ ) == 0) return false;
        if (!parser.validAction(this.state, reduce)) {
            let depth = reduce >> 19 /* Action.ReduceDepthShift */ , term = reduce & 65535 /* Action.ValueMask */ ;
            let target = this.stack.length - depth * 3;
            if (target < 0 || parser.getGoto(this.stack[target], term, false) < 0) {
                let backup = this.findForcedReduction();
                if (backup == null) return false;
                reduce = backup;
            }
            this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
            this.score -= 100 /* Recover.Reduce */ ;
        }
        this.reducePos = this.pos;
        this.reduce(reduce);
        return true;
    }
    /**
    Try to scan through the automaton to find some kind of reduction
    that can be applied. Used when the regular ForcedReduce field
    isn't a valid action. @internal
    */ findForcedReduction() {
        let { parser: parser } = this.p, seen = [];
        let explore = (state, depth)=>{
            if (seen.includes(state)) return;
            seen.push(state);
            return parser.allActions(state, (action)=>{
                if (action & 393216 /* Action.GotoFlag */ ) ;
                else if (action & 65536 /* Action.ReduceFlag */ ) {
                    let rDepth = (action >> 19 /* Action.ReduceDepthShift */ ) - depth;
                    if (rDepth > 1) {
                        let term = action & 65535 /* Action.ValueMask */ , target = this.stack.length - rDepth * 3;
                        if (target >= 0 && parser.getGoto(this.stack[target], term, false) >= 0) return rDepth << 19 /* Action.ReduceDepthShift */  | 65536 /* Action.ReduceFlag */  | term;
                    }
                } else {
                    let found = explore(action, depth + 1);
                    if (found != null) return found;
                }
            });
        };
        return explore(this.state, 0);
    }
    /**
    @internal
    */ forceAll() {
        while(!this.p.parser.stateFlag(this.state, 2 /* StateFlag.Accepting */ ))if (!this.forceReduce()) {
            this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
            break;
        }
        return this;
    }
    /**
    Check whether this state has no further actions (assumed to be a direct descendant of the
    top state, since any other states must be able to continue
    somehow). @internal
    */ get deadEnd() {
        if (this.stack.length != 3) return false;
        let { parser: parser } = this.p;
        return parser.data[parser.stateSlot(this.state, 1 /* ParseState.Actions */ )] == 65535 /* Seq.End */  && !parser.stateSlot(this.state, 4 /* ParseState.DefaultReduce */ );
    }
    /**
    Restart the stack (put it back in its start state). Only safe
    when this.stack.length == 3 (state is directly below the top
    state). @internal
    */ restart() {
        this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
        this.state = this.stack[0];
        this.stack.length = 0;
    }
    /**
    @internal
    */ sameState(other) {
        if (this.state != other.state || this.stack.length != other.stack.length) return false;
        for(let i = 0; i < this.stack.length; i += 3)if (this.stack[i] != other.stack[i]) return false;
        return true;
    }
    /**
    Get the parser used by this stack.
    */ get parser() {
        return this.p.parser;
    }
    /**
    Test whether a given dialect (by numeric ID, as exported from
    the terms file) is enabled.
    */ dialectEnabled(dialectID) {
        return this.p.parser.dialect.flags[dialectID];
    }
    shiftContext(term, start) {
        if (this.curContext) this.updateContext(this.curContext.tracker.shift(this.curContext.context, term, this, this.p.stream.reset(start)));
    }
    reduceContext(term, start) {
        if (this.curContext) this.updateContext(this.curContext.tracker.reduce(this.curContext.context, term, this, this.p.stream.reset(start)));
    }
    /**
    @internal
    */ emitContext() {
        let last = this.buffer.length - 1;
        if (last < 0 || this.buffer[last] != -3) this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
    }
    /**
    @internal
    */ emitLookAhead() {
        let last = this.buffer.length - 1;
        if (last < 0 || this.buffer[last] != -4) this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
    }
    updateContext(context) {
        if (context != this.curContext.context) {
            let newCx = new $0234adc01c271b5a$var$StackContext(this.curContext.tracker, context);
            if (newCx.hash != this.curContext.hash) this.emitContext();
            this.curContext = newCx;
        }
    }
    /**
    @internal
    */ setLookAhead(lookAhead) {
        if (lookAhead > this.lookAhead) {
            this.emitLookAhead();
            this.lookAhead = lookAhead;
        }
    }
    /**
    @internal
    */ close() {
        if (this.curContext && this.curContext.tracker.strict) this.emitContext();
        if (this.lookAhead > 0) this.emitLookAhead();
    }
}
class $0234adc01c271b5a$var$StackContext {
    constructor(tracker, context){
        this.tracker = tracker;
        this.context = context;
        this.hash = tracker.strict ? tracker.hash(context) : 0;
    }
}
// Used to cheaply run some reductions to scan ahead without mutating
// an entire stack
class $0234adc01c271b5a$var$SimulatedStack {
    constructor(start){
        this.start = start;
        this.state = start.state;
        this.stack = start.stack;
        this.base = this.stack.length;
    }
    reduce(action) {
        let term = action & 65535 /* Action.ValueMask */ , depth = action >> 19 /* Action.ReduceDepthShift */ ;
        if (depth == 0) {
            if (this.stack == this.start.stack) this.stack = this.stack.slice();
            this.stack.push(this.state, 0, 0);
            this.base += 3;
        } else this.base -= (depth - 1) * 3;
        let goto = this.start.p.parser.getGoto(this.stack[this.base - 3], term, true);
        this.state = goto;
    }
}
// This is given to `Tree.build` to build a buffer, and encapsulates
// the parent-stack-walking necessary to read the nodes.
class $0234adc01c271b5a$var$StackBufferCursor {
    constructor(stack, pos, index){
        this.stack = stack;
        this.pos = pos;
        this.index = index;
        this.buffer = stack.buffer;
        if (this.index == 0) this.maybeNext();
    }
    static create(stack, pos = stack.bufferBase + stack.buffer.length) {
        return new $0234adc01c271b5a$var$StackBufferCursor(stack, pos, pos - stack.bufferBase);
    }
    maybeNext() {
        let next = this.stack.parent;
        if (next != null) {
            this.index = this.stack.bufferBase - next.bufferBase;
            this.stack = next;
            this.buffer = next.buffer;
        }
    }
    get id() {
        return this.buffer[this.index - 4];
    }
    get start() {
        return this.buffer[this.index - 3];
    }
    get end() {
        return this.buffer[this.index - 2];
    }
    get size() {
        return this.buffer[this.index - 1];
    }
    next() {
        this.index -= 4;
        this.pos -= 4;
        if (this.index == 0) this.maybeNext();
    }
    fork() {
        return new $0234adc01c271b5a$var$StackBufferCursor(this.stack, this.pos, this.index);
    }
}
// See lezer-generator/src/encode.ts for comments about the encoding
// used here
function $0234adc01c271b5a$var$decodeArray(input, Type = Uint16Array) {
    if (typeof input != "string") return input;
    let array = null;
    for(let pos = 0, out = 0; pos < input.length;){
        let value = 0;
        for(;;){
            let next = input.charCodeAt(pos++), stop = false;
            if (next == 126 /* Encode.BigValCode */ ) {
                value = 65535 /* Encode.BigVal */ ;
                break;
            }
            if (next >= 92 /* Encode.Gap2 */ ) next--;
            if (next >= 34 /* Encode.Gap1 */ ) next--;
            let digit = next - 32 /* Encode.Start */ ;
            if (digit >= 46 /* Encode.Base */ ) {
                digit -= 46 /* Encode.Base */ ;
                stop = true;
            }
            value += digit;
            if (stop) break;
            value *= 46 /* Encode.Base */ ;
        }
        if (array) array[out++] = value;
        else array = new Type(value);
    }
    return array;
}
class $0234adc01c271b5a$var$CachedToken {
    constructor(){
        this.start = -1;
        this.value = -1;
        this.end = -1;
        this.extended = -1;
        this.lookAhead = 0;
        this.mask = 0;
        this.context = 0;
    }
}
const $0234adc01c271b5a$var$nullToken = new $0234adc01c271b5a$var$CachedToken;
/**
[Tokenizers](#lr.ExternalTokenizer) interact with the input
through this interface. It presents the input as a stream of
characters, tracking lookahead and hiding the complexity of
[ranges](#common.Parser.parse^ranges) from tokenizer code.
*/ class $0234adc01c271b5a$export$f22294a9362415e4 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ input, /**
    @internal
    */ ranges){
        this.input = input;
        this.ranges = ranges;
        /**
        @internal
        */ this.chunk = "";
        /**
        @internal
        */ this.chunkOff = 0;
        /**
        Backup chunk
        */ this.chunk2 = "";
        this.chunk2Pos = 0;
        /**
        The character code of the next code unit in the input, or -1
        when the stream is at the end of the input.
        */ this.next = -1;
        /**
        @internal
        */ this.token = $0234adc01c271b5a$var$nullToken;
        this.rangeIndex = 0;
        this.pos = this.chunkPos = ranges[0].from;
        this.range = ranges[0];
        this.end = ranges[ranges.length - 1].to;
        this.readNext();
    }
    /**
    @internal
    */ resolveOffset(offset, assoc) {
        let range = this.range, index = this.rangeIndex;
        let pos = this.pos + offset;
        while(pos < range.from){
            if (!index) return null;
            let next = this.ranges[--index];
            pos -= range.from - next.to;
            range = next;
        }
        while(assoc < 0 ? pos > range.to : pos >= range.to){
            if (index == this.ranges.length - 1) return null;
            let next = this.ranges[++index];
            pos += next.from - range.to;
            range = next;
        }
        return pos;
    }
    /**
    @internal
    */ clipPos(pos) {
        if (pos >= this.range.from && pos < this.range.to) return pos;
        for (let range of this.ranges)if (range.to > pos) return Math.max(pos, range.from);
        return this.end;
    }
    /**
    Look at a code unit near the stream position. `.peek(0)` equals
    `.next`, `.peek(-1)` gives you the previous character, and so
    on.
    
    Note that looking around during tokenizing creates dependencies
    on potentially far-away content, which may reduce the
    effectiveness incremental parsing—when looking forward—or even
    cause invalid reparses when looking backward more than 25 code
    units, since the library does not track lookbehind.
    */ peek(offset) {
        let idx = this.chunkOff + offset, pos, result;
        if (idx >= 0 && idx < this.chunk.length) {
            pos = this.pos + offset;
            result = this.chunk.charCodeAt(idx);
        } else {
            let resolved = this.resolveOffset(offset, 1);
            if (resolved == null) return -1;
            pos = resolved;
            if (pos >= this.chunk2Pos && pos < this.chunk2Pos + this.chunk2.length) result = this.chunk2.charCodeAt(pos - this.chunk2Pos);
            else {
                let i = this.rangeIndex, range = this.range;
                while(range.to <= pos)range = this.ranges[++i];
                this.chunk2 = this.input.chunk(this.chunk2Pos = pos);
                if (pos + this.chunk2.length > range.to) this.chunk2 = this.chunk2.slice(0, range.to - pos);
                result = this.chunk2.charCodeAt(0);
            }
        }
        if (pos >= this.token.lookAhead) this.token.lookAhead = pos + 1;
        return result;
    }
    /**
    Accept a token. By default, the end of the token is set to the
    current stream position, but you can pass an offset (relative to
    the stream position) to change that.
    */ acceptToken(token, endOffset = 0) {
        let end = endOffset ? this.resolveOffset(endOffset, -1) : this.pos;
        if (end == null || end < this.token.start) throw new RangeError("Token end out of bounds");
        this.token.value = token;
        this.token.end = end;
    }
    /**
    Accept a token ending at a specific given position.
    */ acceptTokenTo(token, endPos) {
        this.token.value = token;
        this.token.end = endPos;
    }
    getChunk() {
        if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
            let { chunk: chunk, chunkPos: chunkPos } = this;
            this.chunk = this.chunk2;
            this.chunkPos = this.chunk2Pos;
            this.chunk2 = chunk;
            this.chunk2Pos = chunkPos;
            this.chunkOff = this.pos - this.chunkPos;
        } else {
            this.chunk2 = this.chunk;
            this.chunk2Pos = this.chunkPos;
            let nextChunk = this.input.chunk(this.pos);
            let end = this.pos + nextChunk.length;
            this.chunk = end > this.range.to ? nextChunk.slice(0, this.range.to - this.pos) : nextChunk;
            this.chunkPos = this.pos;
            this.chunkOff = 0;
        }
    }
    readNext() {
        if (this.chunkOff >= this.chunk.length) {
            this.getChunk();
            if (this.chunkOff == this.chunk.length) return this.next = -1;
        }
        return this.next = this.chunk.charCodeAt(this.chunkOff);
    }
    /**
    Move the stream forward N (defaults to 1) code units. Returns
    the new value of [`next`](#lr.InputStream.next).
    */ advance(n = 1) {
        this.chunkOff += n;
        while(this.pos + n >= this.range.to){
            if (this.rangeIndex == this.ranges.length - 1) return this.setDone();
            n -= this.range.to - this.pos;
            this.range = this.ranges[++this.rangeIndex];
            this.pos = this.range.from;
        }
        this.pos += n;
        if (this.pos >= this.token.lookAhead) this.token.lookAhead = this.pos + 1;
        return this.readNext();
    }
    setDone() {
        this.pos = this.chunkPos = this.end;
        this.range = this.ranges[this.rangeIndex = this.ranges.length - 1];
        this.chunk = "";
        return this.next = -1;
    }
    /**
    @internal
    */ reset(pos, token) {
        if (token) {
            this.token = token;
            token.start = pos;
            token.lookAhead = pos + 1;
            token.value = token.extended = -1;
        } else this.token = $0234adc01c271b5a$var$nullToken;
        if (this.pos != pos) {
            this.pos = pos;
            if (pos == this.end) {
                this.setDone();
                return this;
            }
            while(pos < this.range.from)this.range = this.ranges[--this.rangeIndex];
            while(pos >= this.range.to)this.range = this.ranges[++this.rangeIndex];
            if (pos >= this.chunkPos && pos < this.chunkPos + this.chunk.length) this.chunkOff = pos - this.chunkPos;
            else {
                this.chunk = "";
                this.chunkOff = 0;
            }
            this.readNext();
        }
        return this;
    }
    /**
    @internal
    */ read(from, to) {
        if (from >= this.chunkPos && to <= this.chunkPos + this.chunk.length) return this.chunk.slice(from - this.chunkPos, to - this.chunkPos);
        if (from >= this.chunk2Pos && to <= this.chunk2Pos + this.chunk2.length) return this.chunk2.slice(from - this.chunk2Pos, to - this.chunk2Pos);
        if (from >= this.range.from && to <= this.range.to) return this.input.read(from, to);
        let result = "";
        for (let r of this.ranges){
            if (r.from >= to) break;
            if (r.to > from) result += this.input.read(Math.max(r.from, from), Math.min(r.to, to));
        }
        return result;
    }
}
/**
@internal
*/ class $0234adc01c271b5a$var$TokenGroup {
    constructor(data, id){
        this.data = data;
        this.id = id;
    }
    token(input, stack) {
        let { parser: parser } = stack.p;
        $0234adc01c271b5a$var$readToken(this.data, input, stack, this.id, parser.data, parser.tokenPrecTable);
    }
}
$0234adc01c271b5a$var$TokenGroup.prototype.contextual = $0234adc01c271b5a$var$TokenGroup.prototype.fallback = $0234adc01c271b5a$var$TokenGroup.prototype.extend = false;
/**
@hide
*/ class $0234adc01c271b5a$export$dbe55ed82366d5e9 {
    constructor(data, precTable, elseToken){
        this.precTable = precTable;
        this.elseToken = elseToken;
        this.data = typeof data == "string" ? $0234adc01c271b5a$var$decodeArray(data) : data;
    }
    token(input, stack) {
        let start = input.pos, skipped = 0;
        for(;;){
            let atEof = input.next < 0, nextPos = input.resolveOffset(1, 1);
            $0234adc01c271b5a$var$readToken(this.data, input, stack, 0, this.data, this.precTable);
            if (input.token.value > -1) break;
            if (this.elseToken == null) return;
            if (!atEof) skipped++;
            if (nextPos == null) break;
            input.reset(nextPos, input.token);
        }
        if (skipped) {
            input.reset(start, input.token);
            input.acceptToken(this.elseToken, skipped);
        }
    }
}
$0234adc01c271b5a$export$dbe55ed82366d5e9.prototype.contextual = $0234adc01c271b5a$var$TokenGroup.prototype.fallback = $0234adc01c271b5a$var$TokenGroup.prototype.extend = false;
/**
`@external tokens` declarations in the grammar should resolve to
an instance of this class.
*/ class $0234adc01c271b5a$export$6e56a42e94c6b2cb {
    /**
    Create a tokenizer. The first argument is the function that,
    given an input stream, scans for the types of tokens it
    recognizes at the stream's position, and calls
    [`acceptToken`](#lr.InputStream.acceptToken) when it finds
    one.
    */ constructor(/**
    @internal
    */ token, options = {}){
        this.token = token;
        this.contextual = !!options.contextual;
        this.fallback = !!options.fallback;
        this.extend = !!options.extend;
    }
}
// Tokenizer data is stored a big uint16 array containing, for each
// state:
//
//  - A group bitmask, indicating what token groups are reachable from
//    this state, so that paths that can only lead to tokens not in
//    any of the current groups can be cut off early.
//
//  - The position of the end of the state's sequence of accepting
//    tokens
//
//  - The number of outgoing edges for the state
//
//  - The accepting tokens, as (token id, group mask) pairs
//
//  - The outgoing edges, as (start character, end character, state
//    index) triples, with end character being exclusive
//
// This function interprets that data, running through a stream as
// long as new states with the a matching group mask can be reached,
// and updating `input.token` when it matches a token.
function $0234adc01c271b5a$var$readToken(data, input, stack, group, precTable, precOffset) {
    let state = 0, groupMask = 1 << group, { dialect: dialect } = stack.p.parser;
    scan: for(;;){
        if ((groupMask & data[state]) == 0) break;
        let accEnd = data[state + 1];
        // Check whether this state can lead to a token in the current group
        // Accept tokens in this state, possibly overwriting
        // lower-precedence / shorter tokens
        for(let i = state + 3; i < accEnd; i += 2)if ((data[i + 1] & groupMask) > 0) {
            let term = data[i];
            if (dialect.allows(term) && (input.token.value == -1 || input.token.value == term || $0234adc01c271b5a$var$overrides(term, input.token.value, precTable, precOffset))) {
                input.acceptToken(term);
                break;
            }
        }
        let next = input.next, low = 0, high = data[state + 2];
        // Special case for EOF
        if (input.next < 0 && high > low && data[accEnd + high * 3 - 3] == 65535 /* Seq.End */ ) {
            state = data[accEnd + high * 3 - 1];
            continue scan;
        }
        // Do a binary search on the state's edges
        for(; low < high;){
            let mid = low + high >> 1;
            let index = accEnd + mid + (mid << 1);
            let from = data[index], to = data[index + 1] || 0x10000;
            if (next < from) high = mid;
            else if (next >= to) low = mid + 1;
            else {
                state = data[index + 2];
                input.advance();
                continue scan;
            }
        }
        break;
    }
}
function $0234adc01c271b5a$var$findOffset(data, start, term) {
    for(let i = start, next; (next = data[i]) != 65535 /* Seq.End */ ; i++)if (next == term) return i - start;
    return -1;
}
function $0234adc01c271b5a$var$overrides(token, prev, tableData, tableOffset) {
    let iPrev = $0234adc01c271b5a$var$findOffset(tableData, tableOffset, prev);
    return iPrev < 0 || $0234adc01c271b5a$var$findOffset(tableData, tableOffset, token) < iPrev;
}
// Environment variable used to control console output
const $0234adc01c271b5a$var$verbose = false;
let $0234adc01c271b5a$var$stackIDs = null;
function $0234adc01c271b5a$var$cutAt(tree, pos, side) {
    let cursor = tree.cursor((0, $a7a41eb5193c1110$export$b0e28367f55837aa).IncludeAnonymous);
    cursor.moveTo(pos);
    for(;;){
        if (!(side < 0 ? cursor.childBefore(pos) : cursor.childAfter(pos))) for(;;){
            if ((side < 0 ? cursor.to < pos : cursor.from > pos) && !cursor.type.isError) return side < 0 ? Math.max(0, Math.min(cursor.to - 1, pos - 25 /* Lookahead.Margin */ )) : Math.min(tree.length, Math.max(cursor.from + 1, pos + 25 /* Lookahead.Margin */ ));
            if (side < 0 ? cursor.prevSibling() : cursor.nextSibling()) break;
            if (!cursor.parent()) return side < 0 ? 0 : tree.length;
        }
    }
}
class $0234adc01c271b5a$var$FragmentCursor {
    constructor(fragments, nodeSet){
        this.fragments = fragments;
        this.nodeSet = nodeSet;
        this.i = 0;
        this.fragment = null;
        this.safeFrom = -1;
        this.safeTo = -1;
        this.trees = [];
        this.start = [];
        this.index = [];
        this.nextFragment();
    }
    nextFragment() {
        let fr = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
        if (fr) {
            this.safeFrom = fr.openStart ? $0234adc01c271b5a$var$cutAt(fr.tree, fr.from + fr.offset, 1) - fr.offset : fr.from;
            this.safeTo = fr.openEnd ? $0234adc01c271b5a$var$cutAt(fr.tree, fr.to + fr.offset, -1) - fr.offset : fr.to;
            while(this.trees.length){
                this.trees.pop();
                this.start.pop();
                this.index.pop();
            }
            this.trees.push(fr.tree);
            this.start.push(-fr.offset);
            this.index.push(0);
            this.nextStart = this.safeFrom;
        } else this.nextStart = 1e9;
    }
    // `pos` must be >= any previously given `pos` for this cursor
    nodeAt(pos) {
        if (pos < this.nextStart) return null;
        while(this.fragment && this.safeTo <= pos)this.nextFragment();
        if (!this.fragment) return null;
        for(;;){
            let last = this.trees.length - 1;
            if (last < 0) {
                this.nextFragment();
                return null;
            }
            let top = this.trees[last], index = this.index[last];
            if (index == top.children.length) {
                this.trees.pop();
                this.start.pop();
                this.index.pop();
                continue;
            }
            let next = top.children[index];
            let start = this.start[last] + top.positions[index];
            if (start > pos) {
                this.nextStart = start;
                return null;
            }
            if (next instanceof (0, $a7a41eb5193c1110$export$7fbedc92909ed28e)) {
                if (start == pos) {
                    if (start < this.safeFrom) return null;
                    let end = start + next.length;
                    if (end <= this.safeTo) {
                        let lookAhead = next.prop((0, $a7a41eb5193c1110$export$b8034b9bc18acd90).lookAhead);
                        if (!lookAhead || end + lookAhead < this.fragment.to) return next;
                    }
                }
                this.index[last]++;
                if (start + next.length >= Math.max(this.safeFrom, pos)) {
                    this.trees.push(next);
                    this.start.push(start);
                    this.index.push(0);
                }
            } else {
                this.index[last]++;
                this.nextStart = start + next.length;
            }
        }
    }
}
class $0234adc01c271b5a$var$TokenCache {
    constructor(parser, stream){
        this.stream = stream;
        this.tokens = [];
        this.mainToken = null;
        this.actions = [];
        this.tokens = parser.tokenizers.map((_)=>new $0234adc01c271b5a$var$CachedToken);
    }
    getActions(stack) {
        let actionIndex = 0;
        let main = null;
        let { parser: parser } = stack.p, { tokenizers: tokenizers } = parser;
        let mask = parser.stateSlot(stack.state, 3 /* ParseState.TokenizerMask */ );
        let context = stack.curContext ? stack.curContext.hash : 0;
        let lookAhead = 0;
        for(let i = 0; i < tokenizers.length; i++){
            if ((1 << i & mask) == 0) continue;
            let tokenizer = tokenizers[i], token = this.tokens[i];
            if (main && !tokenizer.fallback) continue;
            if (tokenizer.contextual || token.start != stack.pos || token.mask != mask || token.context != context) {
                this.updateCachedToken(token, tokenizer, stack);
                token.mask = mask;
                token.context = context;
            }
            if (token.lookAhead > token.end + 25 /* Lookahead.Margin */ ) lookAhead = Math.max(token.lookAhead, lookAhead);
            if (token.value != 0 /* Term.Err */ ) {
                let startIndex = actionIndex;
                if (token.extended > -1) actionIndex = this.addActions(stack, token.extended, token.end, actionIndex);
                actionIndex = this.addActions(stack, token.value, token.end, actionIndex);
                if (!tokenizer.extend) {
                    main = token;
                    if (actionIndex > startIndex) break;
                }
            }
        }
        while(this.actions.length > actionIndex)this.actions.pop();
        if (lookAhead) stack.setLookAhead(lookAhead);
        if (!main && stack.pos == this.stream.end) {
            main = new $0234adc01c271b5a$var$CachedToken;
            main.value = stack.p.parser.eofTerm;
            main.start = main.end = stack.pos;
            actionIndex = this.addActions(stack, main.value, main.end, actionIndex);
        }
        this.mainToken = main;
        return this.actions;
    }
    getMainToken(stack) {
        if (this.mainToken) return this.mainToken;
        let main = new $0234adc01c271b5a$var$CachedToken, { pos: pos, p: p } = stack;
        main.start = pos;
        main.end = Math.min(pos + 1, p.stream.end);
        main.value = pos == p.stream.end ? p.parser.eofTerm : 0 /* Term.Err */ ;
        return main;
    }
    updateCachedToken(token, tokenizer, stack) {
        let start = this.stream.clipPos(stack.pos);
        tokenizer.token(this.stream.reset(start, token), stack);
        if (token.value > -1) {
            let { parser: parser } = stack.p;
            for(let i = 0; i < parser.specialized.length; i++)if (parser.specialized[i] == token.value) {
                let result = parser.specializers[i](this.stream.read(token.start, token.end), stack);
                if (result >= 0 && stack.p.parser.dialect.allows(result >> 1)) {
                    if ((result & 1) == 0 /* Specialize.Specialize */ ) token.value = result >> 1;
                    else token.extended = result >> 1;
                    break;
                }
            }
        } else {
            token.value = 0 /* Term.Err */ ;
            token.end = this.stream.clipPos(start + 1);
        }
    }
    putAction(action, token, end, index) {
        // Don't add duplicate actions
        for(let i = 0; i < index; i += 3)if (this.actions[i] == action) return index;
        this.actions[index++] = action;
        this.actions[index++] = token;
        this.actions[index++] = end;
        return index;
    }
    addActions(stack, token, end, index) {
        let { state: state } = stack, { parser: parser } = stack.p, { data: data } = parser;
        for(let set = 0; set < 2; set++)for(let i = parser.stateSlot(state, set ? 2 /* ParseState.Skip */  : 1 /* ParseState.Actions */ );; i += 3){
            if (data[i] == 65535 /* Seq.End */ ) {
                if (data[i + 1] == 1 /* Seq.Next */ ) i = $0234adc01c271b5a$var$pair(data, i + 2);
                else {
                    if (index == 0 && data[i + 1] == 2 /* Seq.Other */ ) index = this.putAction($0234adc01c271b5a$var$pair(data, i + 2), token, end, index);
                    break;
                }
            }
            if (data[i] == token) index = this.putAction($0234adc01c271b5a$var$pair(data, i + 1), token, end, index);
        }
        return index;
    }
}
class $0234adc01c271b5a$var$Parse {
    constructor(parser, input, fragments, ranges){
        this.parser = parser;
        this.input = input;
        this.ranges = ranges;
        this.recovering = 0;
        this.nextStackID = 0x2654; // ♔, ♕, ♖, ♗, ♘, ♙, ♠, ♡, ♢, ♣, ♤, ♥, ♦, ♧
        this.minStackPos = 0;
        this.reused = [];
        this.stoppedAt = null;
        this.lastBigReductionStart = -1;
        this.lastBigReductionSize = 0;
        this.bigReductionCount = 0;
        this.stream = new $0234adc01c271b5a$export$f22294a9362415e4(input, ranges);
        this.tokens = new $0234adc01c271b5a$var$TokenCache(parser, this.stream);
        this.topTerm = parser.top[1];
        let { from: from } = ranges[0];
        this.stacks = [
            $0234adc01c271b5a$export$694e0d28c7ffc90c.start(this, parser.top[0], from)
        ];
        this.fragments = fragments.length && this.stream.end - from > parser.bufferLength * 4 ? new $0234adc01c271b5a$var$FragmentCursor(fragments, parser.nodeSet) : null;
    }
    get parsedPos() {
        return this.minStackPos;
    }
    // Move the parser forward. This will process all parse stacks at
    // `this.pos` and try to advance them to a further position. If no
    // stack for such a position is found, it'll start error-recovery.
    //
    // When the parse is finished, this will return a syntax tree. When
    // not, it returns `null`.
    advance() {
        let stacks = this.stacks, pos = this.minStackPos;
        // This will hold stacks beyond `pos`.
        let newStacks = this.stacks = [];
        let stopped, stoppedTokens;
        // If a large amount of reductions happened with the same start
        // position, force the stack out of that production in order to
        // avoid creating a tree too deep to recurse through.
        // (This is an ugly kludge, because unfortunately there is no
        // straightforward, cheap way to check for this happening, due to
        // the history of reductions only being available in an
        // expensive-to-access format in the stack buffers.)
        if (this.bigReductionCount > 300 /* Rec.MaxLeftAssociativeReductionCount */  && stacks.length == 1) {
            let [s] = stacks;
            while(s.forceReduce() && s.stack.length && s.stack[s.stack.length - 2] >= this.lastBigReductionStart);
            this.bigReductionCount = this.lastBigReductionSize = 0;
        }
        // Keep advancing any stacks at `pos` until they either move
        // forward or can't be advanced. Gather stacks that can't be
        // advanced further in `stopped`.
        for(let i = 0; i < stacks.length; i++){
            let stack = stacks[i];
            for(;;){
                this.tokens.mainToken = null;
                if (stack.pos > pos) newStacks.push(stack);
                else if (this.advanceStack(stack, newStacks, stacks)) continue;
                else {
                    if (!stopped) {
                        stopped = [];
                        stoppedTokens = [];
                    }
                    stopped.push(stack);
                    let tok = this.tokens.getMainToken(stack);
                    stoppedTokens.push(tok.value, tok.end);
                }
                break;
            }
        }
        if (!newStacks.length) {
            let finished = stopped && $0234adc01c271b5a$var$findFinished(stopped);
            if (finished) {
                if ($0234adc01c271b5a$var$verbose) console.log("Finish with " + this.stackID(finished));
                return this.stackToTree(finished);
            }
            if (this.parser.strict) {
                if ($0234adc01c271b5a$var$verbose && stopped) console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none"));
                throw new SyntaxError("No parse at " + pos);
            }
            if (!this.recovering) this.recovering = 5 /* Rec.Distance */ ;
        }
        if (this.recovering && stopped) {
            let finished = this.stoppedAt != null && stopped[0].pos > this.stoppedAt ? stopped[0] : this.runRecovery(stopped, stoppedTokens, newStacks);
            if (finished) {
                if ($0234adc01c271b5a$var$verbose) console.log("Force-finish " + this.stackID(finished));
                return this.stackToTree(finished.forceAll());
            }
        }
        if (this.recovering) {
            let maxRemaining = this.recovering == 1 ? 1 : this.recovering * 3 /* Rec.MaxRemainingPerStep */ ;
            if (newStacks.length > maxRemaining) {
                newStacks.sort((a, b)=>b.score - a.score);
                while(newStacks.length > maxRemaining)newStacks.pop();
            }
            if (newStacks.some((s)=>s.reducePos > pos)) this.recovering--;
        } else if (newStacks.length > 1) {
            // Prune stacks that are in the same state, or that have been
            // running without splitting for a while, to avoid getting stuck
            // with multiple successful stacks running endlessly on.
            outer: for(let i = 0; i < newStacks.length - 1; i++){
                let stack = newStacks[i];
                for(let j = i + 1; j < newStacks.length; j++){
                    let other = newStacks[j];
                    if (stack.sameState(other) || stack.buffer.length > 500 /* Rec.MinBufferLengthPrune */  && other.buffer.length > 500 /* Rec.MinBufferLengthPrune */ ) {
                        if ((stack.score - other.score || stack.buffer.length - other.buffer.length) > 0) newStacks.splice(j--, 1);
                        else {
                            newStacks.splice(i--, 1);
                            continue outer;
                        }
                    }
                }
            }
            if (newStacks.length > 12 /* Rec.MaxStackCount */ ) newStacks.splice(12 /* Rec.MaxStackCount */ , newStacks.length - 12 /* Rec.MaxStackCount */ );
        }
        this.minStackPos = newStacks[0].pos;
        for(let i = 1; i < newStacks.length; i++)if (newStacks[i].pos < this.minStackPos) this.minStackPos = newStacks[i].pos;
        return null;
    }
    stopAt(pos) {
        if (this.stoppedAt != null && this.stoppedAt < pos) throw new RangeError("Can't move stoppedAt forward");
        this.stoppedAt = pos;
    }
    // Returns an updated version of the given stack, or null if the
    // stack can't advance normally. When `split` and `stacks` are
    // given, stacks split off by ambiguous operations will be pushed to
    // `split`, or added to `stacks` if they move `pos` forward.
    advanceStack(stack, stacks, split) {
        let start = stack.pos, { parser: parser } = this;
        let base = $0234adc01c271b5a$var$verbose ? this.stackID(stack) + " -> " : "";
        if (this.stoppedAt != null && start > this.stoppedAt) return stack.forceReduce() ? stack : null;
        if (this.fragments) {
            let strictCx = stack.curContext && stack.curContext.tracker.strict, cxHash = strictCx ? stack.curContext.hash : 0;
            for(let cached = this.fragments.nodeAt(start); cached;){
                let match = this.parser.nodeSet.types[cached.type.id] == cached.type ? parser.getGoto(stack.state, cached.type.id) : -1;
                if (match > -1 && cached.length && (!strictCx || (cached.prop((0, $a7a41eb5193c1110$export$b8034b9bc18acd90).contextHash) || 0) == cxHash)) {
                    stack.useNode(cached, match);
                    if ($0234adc01c271b5a$var$verbose) console.log(base + this.stackID(stack) + ` (via reuse of ${parser.getName(cached.type.id)})`);
                    return true;
                }
                if (!(cached instanceof (0, $a7a41eb5193c1110$export$7fbedc92909ed28e)) || cached.children.length == 0 || cached.positions[0] > 0) break;
                let inner = cached.children[0];
                if (inner instanceof (0, $a7a41eb5193c1110$export$7fbedc92909ed28e) && cached.positions[0] == 0) cached = inner;
                else break;
            }
        }
        let defaultReduce = parser.stateSlot(stack.state, 4 /* ParseState.DefaultReduce */ );
        if (defaultReduce > 0) {
            stack.reduce(defaultReduce);
            if ($0234adc01c271b5a$var$verbose) console.log(base + this.stackID(stack) + ` (via always-reduce ${parser.getName(defaultReduce & 65535 /* Action.ValueMask */ )})`);
            return true;
        }
        if (stack.stack.length >= 8400 /* Rec.CutDepth */ ) {
            while(stack.stack.length > 6000 /* Rec.CutTo */  && stack.forceReduce());
        }
        let actions = this.tokens.getActions(stack);
        for(let i = 0; i < actions.length;){
            let action = actions[i++], term = actions[i++], end = actions[i++];
            let last = i == actions.length || !split;
            let localStack = last ? stack : stack.split();
            let main = this.tokens.mainToken;
            localStack.apply(action, term, main ? main.start : localStack.pos, end);
            if ($0234adc01c271b5a$var$verbose) console.log(base + this.stackID(localStack) + ` (via ${(action & 65536 /* Action.ReduceFlag */ ) == 0 ? "shift" : `reduce of ${parser.getName(action & 65535 /* Action.ValueMask */ )}`} for ${parser.getName(term)} @ ${start}${localStack == stack ? "" : ", split"})`);
            if (last) return true;
            else if (localStack.pos > start) stacks.push(localStack);
            else split.push(localStack);
        }
        return false;
    }
    // Advance a given stack forward as far as it will go. Returns the
    // (possibly updated) stack if it got stuck, or null if it moved
    // forward and was given to `pushStackDedup`.
    advanceFully(stack, newStacks) {
        let pos = stack.pos;
        for(;;){
            if (!this.advanceStack(stack, null, null)) return false;
            if (stack.pos > pos) {
                $0234adc01c271b5a$var$pushStackDedup(stack, newStacks);
                return true;
            }
        }
    }
    runRecovery(stacks, tokens, newStacks) {
        let finished = null, restarted = false;
        for(let i = 0; i < stacks.length; i++){
            let stack = stacks[i], token = tokens[i << 1], tokenEnd = tokens[(i << 1) + 1];
            let base = $0234adc01c271b5a$var$verbose ? this.stackID(stack) + " -> " : "";
            if (stack.deadEnd) {
                if (restarted) continue;
                restarted = true;
                stack.restart();
                if ($0234adc01c271b5a$var$verbose) console.log(base + this.stackID(stack) + " (restarted)");
                let done = this.advanceFully(stack, newStacks);
                if (done) continue;
            }
            let force = stack.split(), forceBase = base;
            for(let j = 0; force.forceReduce() && j < 10 /* Rec.ForceReduceLimit */ ; j++){
                if ($0234adc01c271b5a$var$verbose) console.log(forceBase + this.stackID(force) + " (via force-reduce)");
                let done = this.advanceFully(force, newStacks);
                if (done) break;
                if ($0234adc01c271b5a$var$verbose) forceBase = this.stackID(force) + " -> ";
            }
            for (let insert of stack.recoverByInsert(token)){
                if ($0234adc01c271b5a$var$verbose) console.log(base + this.stackID(insert) + " (via recover-insert)");
                this.advanceFully(insert, newStacks);
            }
            if (this.stream.end > stack.pos) {
                if (tokenEnd == stack.pos) {
                    tokenEnd++;
                    token = 0 /* Term.Err */ ;
                }
                stack.recoverByDelete(token, tokenEnd);
                if ($0234adc01c271b5a$var$verbose) console.log(base + this.stackID(stack) + ` (via recover-delete ${this.parser.getName(token)})`);
                $0234adc01c271b5a$var$pushStackDedup(stack, newStacks);
            } else if (!finished || finished.score < stack.score) finished = stack;
        }
        return finished;
    }
    // Convert the stack's buffer to a syntax tree.
    stackToTree(stack) {
        stack.close();
        return (0, $a7a41eb5193c1110$export$7fbedc92909ed28e).build({
            buffer: $0234adc01c271b5a$var$StackBufferCursor.create(stack),
            nodeSet: this.parser.nodeSet,
            topID: this.topTerm,
            maxBufferLength: this.parser.bufferLength,
            reused: this.reused,
            start: this.ranges[0].from,
            length: stack.pos - this.ranges[0].from,
            minRepeatType: this.parser.minRepeatTerm
        });
    }
    stackID(stack) {
        let id = ($0234adc01c271b5a$var$stackIDs || ($0234adc01c271b5a$var$stackIDs = new WeakMap)).get(stack);
        if (!id) $0234adc01c271b5a$var$stackIDs.set(stack, id = String.fromCodePoint(this.nextStackID++));
        return id + stack;
    }
}
function $0234adc01c271b5a$var$pushStackDedup(stack, newStacks) {
    for(let i = 0; i < newStacks.length; i++){
        let other = newStacks[i];
        if (other.pos == stack.pos && other.sameState(stack)) {
            if (newStacks[i].score < stack.score) newStacks[i] = stack;
            return;
        }
    }
    newStacks.push(stack);
}
class $0234adc01c271b5a$var$Dialect {
    constructor(source, flags, disabled){
        this.source = source;
        this.flags = flags;
        this.disabled = disabled;
    }
    allows(term) {
        return !this.disabled || this.disabled[term] == 0;
    }
}
const $0234adc01c271b5a$var$id = (x)=>x;
/**
Context trackers are used to track stateful context (such as
indentation in the Python grammar, or parent elements in the XML
grammar) needed by external tokenizers. You declare them in a
grammar file as `@context exportName from "module"`.

Context values should be immutable, and can be updated (replaced)
on shift or reduce actions.

The export used in a `@context` declaration should be of this
type.
*/ class $0234adc01c271b5a$export$88193367295cc46b {
    /**
    Define a context tracker.
    */ constructor(spec){
        this.start = spec.start;
        this.shift = spec.shift || $0234adc01c271b5a$var$id;
        this.reduce = spec.reduce || $0234adc01c271b5a$var$id;
        this.reuse = spec.reuse || $0234adc01c271b5a$var$id;
        this.hash = spec.hash || (()=>0);
        this.strict = spec.strict !== false;
    }
}
/**
Holds the parse tables for a given grammar, as generated by
`lezer-generator`, and provides [methods](#common.Parser) to parse
content with.
*/ class $0234adc01c271b5a$export$60c033f4cf02b410 extends (0, $a7a41eb5193c1110$export$7acfa6ed01010e37) {
    /**
    @internal
    */ constructor(spec){
        super();
        /**
        @internal
        */ this.wrappers = [];
        if (spec.version != 14 /* File.Version */ ) throw new RangeError(`Parser version (${spec.version}) doesn't match runtime version (${14 /* File.Version */ })`);
        let nodeNames = spec.nodeNames.split(" ");
        this.minRepeatTerm = nodeNames.length;
        for(let i = 0; i < spec.repeatNodeCount; i++)nodeNames.push("");
        let topTerms = Object.keys(spec.topRules).map((r)=>spec.topRules[r][1]);
        let nodeProps = [];
        for(let i = 0; i < nodeNames.length; i++)nodeProps.push([]);
        function setProp(nodeID, prop, value) {
            nodeProps[nodeID].push([
                prop,
                prop.deserialize(String(value))
            ]);
        }
        if (spec.nodeProps) for (let propSpec of spec.nodeProps){
            let prop = propSpec[0];
            if (typeof prop == "string") prop = (0, $a7a41eb5193c1110$export$b8034b9bc18acd90)[prop];
            for(let i = 1; i < propSpec.length;){
                let next = propSpec[i++];
                if (next >= 0) setProp(next, prop, propSpec[i++]);
                else {
                    let value = propSpec[i + -next];
                    for(let j = -next; j > 0; j--)setProp(propSpec[i++], prop, value);
                    i++;
                }
            }
        }
        this.nodeSet = new (0, $a7a41eb5193c1110$export$7fad5fb00d8de02c)(nodeNames.map((name, i)=>(0, $a7a41eb5193c1110$export$f06e977173f1857c).define({
                name: i >= this.minRepeatTerm ? undefined : name,
                id: i,
                props: nodeProps[i],
                top: topTerms.indexOf(i) > -1,
                error: i == 0,
                skipped: spec.skippedNodes && spec.skippedNodes.indexOf(i) > -1
            })));
        if (spec.propSources) this.nodeSet = this.nodeSet.extend(...spec.propSources);
        this.strict = false;
        this.bufferLength = (0, $a7a41eb5193c1110$export$de305a849879ffa);
        let tokenArray = $0234adc01c271b5a$var$decodeArray(spec.tokenData);
        this.context = spec.context;
        this.specializerSpecs = spec.specialized || [];
        this.specialized = new Uint16Array(this.specializerSpecs.length);
        for(let i = 0; i < this.specializerSpecs.length; i++)this.specialized[i] = this.specializerSpecs[i].term;
        this.specializers = this.specializerSpecs.map($0234adc01c271b5a$var$getSpecializer);
        this.states = $0234adc01c271b5a$var$decodeArray(spec.states, Uint32Array);
        this.data = $0234adc01c271b5a$var$decodeArray(spec.stateData);
        this.goto = $0234adc01c271b5a$var$decodeArray(spec.goto);
        this.maxTerm = spec.maxTerm;
        this.tokenizers = spec.tokenizers.map((value)=>typeof value == "number" ? new $0234adc01c271b5a$var$TokenGroup(tokenArray, value) : value);
        this.topRules = spec.topRules;
        this.dialects = spec.dialects || {};
        this.dynamicPrecedences = spec.dynamicPrecedences || null;
        this.tokenPrecTable = spec.tokenPrec;
        this.termNames = spec.termNames || null;
        this.maxNode = this.nodeSet.types.length - 1;
        this.dialect = this.parseDialect();
        this.top = this.topRules[Object.keys(this.topRules)[0]];
    }
    createParse(input, fragments, ranges) {
        let parse = new $0234adc01c271b5a$var$Parse(this, input, fragments, ranges);
        for (let w of this.wrappers)parse = w(parse, input, fragments, ranges);
        return parse;
    }
    /**
    Get a goto table entry @internal
    */ getGoto(state, term, loose = false) {
        let table = this.goto;
        if (term >= table[0]) return -1;
        for(let pos = table[term + 1];;){
            let groupTag = table[pos++], last = groupTag & 1;
            let target = table[pos++];
            if (last && loose) return target;
            for(let end = pos + (groupTag >> 1); pos < end; pos++)if (table[pos] == state) return target;
            if (last) return -1;
        }
    }
    /**
    Check if this state has an action for a given terminal @internal
    */ hasAction(state, terminal) {
        let data = this.data;
        for(let set = 0; set < 2; set++)for(let i = this.stateSlot(state, set ? 2 /* ParseState.Skip */  : 1 /* ParseState.Actions */ ), next;; i += 3){
            if ((next = data[i]) == 65535 /* Seq.End */ ) {
                if (data[i + 1] == 1 /* Seq.Next */ ) next = data[i = $0234adc01c271b5a$var$pair(data, i + 2)];
                else if (data[i + 1] == 2 /* Seq.Other */ ) return $0234adc01c271b5a$var$pair(data, i + 2);
                else break;
            }
            if (next == terminal || next == 0 /* Term.Err */ ) return $0234adc01c271b5a$var$pair(data, i + 1);
        }
        return 0;
    }
    /**
    @internal
    */ stateSlot(state, slot) {
        return this.states[state * 6 /* ParseState.Size */  + slot];
    }
    /**
    @internal
    */ stateFlag(state, flag) {
        return (this.stateSlot(state, 0 /* ParseState.Flags */ ) & flag) > 0;
    }
    /**
    @internal
    */ validAction(state, action) {
        return !!this.allActions(state, (a)=>a == action ? true : null);
    }
    /**
    @internal
    */ allActions(state, action) {
        let deflt = this.stateSlot(state, 4 /* ParseState.DefaultReduce */ );
        let result = deflt ? action(deflt) : undefined;
        for(let i = this.stateSlot(state, 1 /* ParseState.Actions */ ); result == null; i += 3){
            if (this.data[i] == 65535 /* Seq.End */ ) {
                if (this.data[i + 1] == 1 /* Seq.Next */ ) i = $0234adc01c271b5a$var$pair(this.data, i + 2);
                else break;
            }
            result = action($0234adc01c271b5a$var$pair(this.data, i + 1));
        }
        return result;
    }
    /**
    Get the states that can follow this one through shift actions or
    goto jumps. @internal
    */ nextStates(state) {
        let result = [];
        for(let i = this.stateSlot(state, 1 /* ParseState.Actions */ );; i += 3){
            if (this.data[i] == 65535 /* Seq.End */ ) {
                if (this.data[i + 1] == 1 /* Seq.Next */ ) i = $0234adc01c271b5a$var$pair(this.data, i + 2);
                else break;
            }
            if ((this.data[i + 2] & 1) == 0) {
                let value = this.data[i + 1];
                if (!result.some((v, i)=>i & 1 && v == value)) result.push(this.data[i], value);
            }
        }
        return result;
    }
    /**
    Configure the parser. Returns a new parser instance that has the
    given settings modified. Settings not provided in `config` are
    kept from the original parser.
    */ configure(config) {
        // Hideous reflection-based kludge to make it easy to create a
        // slightly modified copy of a parser.
        let copy = Object.assign(Object.create($0234adc01c271b5a$export$60c033f4cf02b410.prototype), this);
        if (config.props) copy.nodeSet = this.nodeSet.extend(...config.props);
        if (config.top) {
            let info = this.topRules[config.top];
            if (!info) throw new RangeError(`Invalid top rule name ${config.top}`);
            copy.top = info;
        }
        if (config.tokenizers) copy.tokenizers = this.tokenizers.map((t)=>{
            let found = config.tokenizers.find((r)=>r.from == t);
            return found ? found.to : t;
        });
        if (config.specializers) {
            copy.specializers = this.specializers.slice();
            copy.specializerSpecs = this.specializerSpecs.map((s, i)=>{
                let found = config.specializers.find((r)=>r.from == s.external);
                if (!found) return s;
                let spec = Object.assign(Object.assign({}, s), {
                    external: found.to
                });
                copy.specializers[i] = $0234adc01c271b5a$var$getSpecializer(spec);
                return spec;
            });
        }
        if (config.contextTracker) copy.context = config.contextTracker;
        if (config.dialect) copy.dialect = this.parseDialect(config.dialect);
        if (config.strict != null) copy.strict = config.strict;
        if (config.wrap) copy.wrappers = copy.wrappers.concat(config.wrap);
        if (config.bufferLength != null) copy.bufferLength = config.bufferLength;
        return copy;
    }
    /**
    Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
    are registered for this parser.
    */ hasWrappers() {
        return this.wrappers.length > 0;
    }
    /**
    Returns the name associated with a given term. This will only
    work for all terms when the parser was generated with the
    `--names` option. By default, only the names of tagged terms are
    stored.
    */ getName(term) {
        return this.termNames ? this.termNames[term] : String(term <= this.maxNode && this.nodeSet.types[term].name || term);
    }
    /**
    The eof term id is always allocated directly after the node
    types. @internal
    */ get eofTerm() {
        return this.maxNode + 1;
    }
    /**
    The type of top node produced by the parser.
    */ get topNode() {
        return this.nodeSet.types[this.top[1]];
    }
    /**
    @internal
    */ dynamicPrecedence(term) {
        let prec = this.dynamicPrecedences;
        return prec == null ? 0 : prec[term] || 0;
    }
    /**
    @internal
    */ parseDialect(dialect) {
        let values = Object.keys(this.dialects), flags = values.map(()=>false);
        if (dialect) for (let part of dialect.split(" ")){
            let id = values.indexOf(part);
            if (id >= 0) flags[id] = true;
        }
        let disabled = null;
        for(let i = 0; i < values.length; i++)if (!flags[i]) for(let j = this.dialects[values[i]], id; (id = this.data[j++]) != 65535 /* Seq.End */ ;)(disabled || (disabled = new Uint8Array(this.maxTerm + 1)))[id] = 1;
        return new $0234adc01c271b5a$var$Dialect(dialect, flags, disabled);
    }
    /**
    Used by the output of the parser generator. Not available to
    user code. @hide
    */ static deserialize(spec) {
        return new $0234adc01c271b5a$export$60c033f4cf02b410(spec);
    }
}
function $0234adc01c271b5a$var$pair(data, off) {
    return data[off] | data[off + 1] << 16;
}
function $0234adc01c271b5a$var$findFinished(stacks) {
    let best = null;
    for (let stack of stacks){
        let stopped = stack.p.stoppedAt;
        if ((stack.pos == stack.p.stream.end || stopped != null && stack.pos > stopped) && stack.p.parser.stateFlag(stack.state, 2 /* StateFlag.Accepting */ ) && (!best || best.score < stack.score)) best = stack;
    }
    return best;
}
function $0234adc01c271b5a$var$getSpecializer(spec) {
    if (spec.external) {
        let mask = spec.extend ? 1 /* Specialize.Extend */  : 0 /* Specialize.Specialize */ ;
        return (value, stack)=>spec.external(value, stack) << 1 | mask;
    }
    return spec.get;
}



// This file was generated by lezer-generator. You probably shouldn't edit it.
const $48d37ad5e67ad3e0$var$printKeyword = 1, $48d37ad5e67ad3e0$var$indent = 194, $48d37ad5e67ad3e0$var$dedent = 195, $48d37ad5e67ad3e0$var$newline$1 = 196, $48d37ad5e67ad3e0$var$blankLineStart = 197, $48d37ad5e67ad3e0$var$newlineBracketed = 198, $48d37ad5e67ad3e0$var$eof = 199, $48d37ad5e67ad3e0$var$stringContent = 200, $48d37ad5e67ad3e0$var$Escape = 2, $48d37ad5e67ad3e0$var$replacementStart = 3, $48d37ad5e67ad3e0$var$stringEnd = 201, $48d37ad5e67ad3e0$var$ParenL = 24, $48d37ad5e67ad3e0$var$ParenthesizedExpression = 25, $48d37ad5e67ad3e0$var$TupleExpression = 49, $48d37ad5e67ad3e0$var$ComprehensionExpression = 50, $48d37ad5e67ad3e0$var$BracketL = 55, $48d37ad5e67ad3e0$var$ArrayExpression = 56, $48d37ad5e67ad3e0$var$ArrayComprehensionExpression = 57, $48d37ad5e67ad3e0$var$BraceL = 59, $48d37ad5e67ad3e0$var$DictionaryExpression = 60, $48d37ad5e67ad3e0$var$DictionaryComprehensionExpression = 61, $48d37ad5e67ad3e0$var$SetExpression = 62, $48d37ad5e67ad3e0$var$SetComprehensionExpression = 63, $48d37ad5e67ad3e0$var$ArgList = 65, $48d37ad5e67ad3e0$var$subscript = 238, $48d37ad5e67ad3e0$var$String$1 = 71, $48d37ad5e67ad3e0$var$stringStart = 241, $48d37ad5e67ad3e0$var$stringStartD = 242, $48d37ad5e67ad3e0$var$stringStartL = 243, $48d37ad5e67ad3e0$var$stringStartLD = 244, $48d37ad5e67ad3e0$var$stringStartR = 245, $48d37ad5e67ad3e0$var$stringStartRD = 246, $48d37ad5e67ad3e0$var$stringStartRL = 247, $48d37ad5e67ad3e0$var$stringStartRLD = 248, $48d37ad5e67ad3e0$var$FormatString = 72, $48d37ad5e67ad3e0$var$stringStartF = 249, $48d37ad5e67ad3e0$var$stringStartFD = 250, $48d37ad5e67ad3e0$var$stringStartFL = 251, $48d37ad5e67ad3e0$var$stringStartFLD = 252, $48d37ad5e67ad3e0$var$stringStartFR = 253, $48d37ad5e67ad3e0$var$stringStartFRD = 254, $48d37ad5e67ad3e0$var$stringStartFRL = 255, $48d37ad5e67ad3e0$var$stringStartFRLD = 256, $48d37ad5e67ad3e0$var$FormatReplacement = 73, $48d37ad5e67ad3e0$var$nestedFormatReplacement = 77, $48d37ad5e67ad3e0$var$importList = 263, $48d37ad5e67ad3e0$var$TypeParamList = 112, $48d37ad5e67ad3e0$var$ParamList = 130, $48d37ad5e67ad3e0$var$SequencePattern = 151, $48d37ad5e67ad3e0$var$MappingPattern = 152, $48d37ad5e67ad3e0$var$PatternArgList = 155;
const $48d37ad5e67ad3e0$var$newline = 10, $48d37ad5e67ad3e0$var$carriageReturn = 13, $48d37ad5e67ad3e0$var$space = 32, $48d37ad5e67ad3e0$var$tab = 9, $48d37ad5e67ad3e0$var$hash = 35, $48d37ad5e67ad3e0$var$parenOpen = 40, $48d37ad5e67ad3e0$var$dot = 46, $48d37ad5e67ad3e0$var$braceOpen = 123, $48d37ad5e67ad3e0$var$braceClose = 125, $48d37ad5e67ad3e0$var$singleQuote = 39, $48d37ad5e67ad3e0$var$doubleQuote = 34, $48d37ad5e67ad3e0$var$backslash = 92, $48d37ad5e67ad3e0$var$letter_o = 111, $48d37ad5e67ad3e0$var$letter_x = 120, $48d37ad5e67ad3e0$var$letter_N = 78, $48d37ad5e67ad3e0$var$letter_u = 117, $48d37ad5e67ad3e0$var$letter_U = 85;
const $48d37ad5e67ad3e0$var$bracketed = new Set([
    $48d37ad5e67ad3e0$var$ParenthesizedExpression,
    $48d37ad5e67ad3e0$var$TupleExpression,
    $48d37ad5e67ad3e0$var$ComprehensionExpression,
    $48d37ad5e67ad3e0$var$importList,
    $48d37ad5e67ad3e0$var$ArgList,
    $48d37ad5e67ad3e0$var$ParamList,
    $48d37ad5e67ad3e0$var$ArrayExpression,
    $48d37ad5e67ad3e0$var$ArrayComprehensionExpression,
    $48d37ad5e67ad3e0$var$subscript,
    $48d37ad5e67ad3e0$var$SetExpression,
    $48d37ad5e67ad3e0$var$SetComprehensionExpression,
    $48d37ad5e67ad3e0$var$FormatString,
    $48d37ad5e67ad3e0$var$FormatReplacement,
    $48d37ad5e67ad3e0$var$nestedFormatReplacement,
    $48d37ad5e67ad3e0$var$DictionaryExpression,
    $48d37ad5e67ad3e0$var$DictionaryComprehensionExpression,
    $48d37ad5e67ad3e0$var$SequencePattern,
    $48d37ad5e67ad3e0$var$MappingPattern,
    $48d37ad5e67ad3e0$var$PatternArgList,
    $48d37ad5e67ad3e0$var$TypeParamList
]);
function $48d37ad5e67ad3e0$var$isLineBreak(ch) {
    return ch == $48d37ad5e67ad3e0$var$newline || ch == $48d37ad5e67ad3e0$var$carriageReturn;
}
function $48d37ad5e67ad3e0$var$isHex(ch) {
    return ch >= 48 && ch <= 57 || ch >= 65 && ch <= 70 || ch >= 97 && ch <= 102;
}
const $48d37ad5e67ad3e0$var$newlines = new (0, $0234adc01c271b5a$export$6e56a42e94c6b2cb)((input, stack)=>{
    let prev;
    if (input.next < 0) input.acceptToken($48d37ad5e67ad3e0$var$eof);
    else if (stack.context.flags & $48d37ad5e67ad3e0$var$cx_Bracketed) {
        if ($48d37ad5e67ad3e0$var$isLineBreak(input.next)) input.acceptToken($48d37ad5e67ad3e0$var$newlineBracketed, 1);
    } else if (((prev = input.peek(-1)) < 0 || $48d37ad5e67ad3e0$var$isLineBreak(prev)) && stack.canShift($48d37ad5e67ad3e0$var$blankLineStart)) {
        let spaces = 0;
        while(input.next == $48d37ad5e67ad3e0$var$space || input.next == $48d37ad5e67ad3e0$var$tab){
            input.advance();
            spaces++;
        }
        if (input.next == $48d37ad5e67ad3e0$var$newline || input.next == $48d37ad5e67ad3e0$var$carriageReturn || input.next == $48d37ad5e67ad3e0$var$hash) input.acceptToken($48d37ad5e67ad3e0$var$blankLineStart, -spaces);
    } else if ($48d37ad5e67ad3e0$var$isLineBreak(input.next)) input.acceptToken($48d37ad5e67ad3e0$var$newline$1, 1);
}, {
    contextual: true
});
const $48d37ad5e67ad3e0$var$indentation = new (0, $0234adc01c271b5a$export$6e56a42e94c6b2cb)((input, stack)=>{
    let context = stack.context;
    if (context.flags) return;
    let prev = input.peek(-1);
    if (prev == $48d37ad5e67ad3e0$var$newline || prev == $48d37ad5e67ad3e0$var$carriageReturn) {
        let depth = 0, chars = 0;
        for(;;){
            if (input.next == $48d37ad5e67ad3e0$var$space) depth++;
            else if (input.next == $48d37ad5e67ad3e0$var$tab) depth += 8 - depth % 8;
            else break;
            input.advance();
            chars++;
        }
        if (depth != context.indent && input.next != $48d37ad5e67ad3e0$var$newline && input.next != $48d37ad5e67ad3e0$var$carriageReturn && input.next != $48d37ad5e67ad3e0$var$hash) {
            if (depth < context.indent) input.acceptToken($48d37ad5e67ad3e0$var$dedent, -chars);
            else input.acceptToken($48d37ad5e67ad3e0$var$indent);
        }
    }
});
// Flags used in Context objects
const $48d37ad5e67ad3e0$var$cx_Bracketed = 1, $48d37ad5e67ad3e0$var$cx_String = 2, $48d37ad5e67ad3e0$var$cx_DoubleQuote = 4, $48d37ad5e67ad3e0$var$cx_Long = 8, $48d37ad5e67ad3e0$var$cx_Raw = 16, $48d37ad5e67ad3e0$var$cx_Format = 32;
function $48d37ad5e67ad3e0$var$Context(parent, indent, flags) {
    this.parent = parent;
    this.indent = indent;
    this.flags = flags;
    this.hash = (parent ? parent.hash + parent.hash << 8 : 0) + indent + (indent << 4) + flags + (flags << 6);
}
const $48d37ad5e67ad3e0$var$topIndent = new $48d37ad5e67ad3e0$var$Context(null, 0, 0);
function $48d37ad5e67ad3e0$var$countIndent(space) {
    let depth = 0;
    for(let i = 0; i < space.length; i++)depth += space.charCodeAt(i) == $48d37ad5e67ad3e0$var$tab ? 8 - depth % 8 : 1;
    return depth;
}
const $48d37ad5e67ad3e0$var$stringFlags = new Map([
    [
        $48d37ad5e67ad3e0$var$stringStart,
        0
    ],
    [
        $48d37ad5e67ad3e0$var$stringStartD,
        $48d37ad5e67ad3e0$var$cx_DoubleQuote
    ],
    [
        $48d37ad5e67ad3e0$var$stringStartL,
        $48d37ad5e67ad3e0$var$cx_Long
    ],
    [
        $48d37ad5e67ad3e0$var$stringStartLD,
        $48d37ad5e67ad3e0$var$cx_Long | $48d37ad5e67ad3e0$var$cx_DoubleQuote
    ],
    [
        $48d37ad5e67ad3e0$var$stringStartR,
        $48d37ad5e67ad3e0$var$cx_Raw
    ],
    [
        $48d37ad5e67ad3e0$var$stringStartRD,
        $48d37ad5e67ad3e0$var$cx_Raw | $48d37ad5e67ad3e0$var$cx_DoubleQuote
    ],
    [
        $48d37ad5e67ad3e0$var$stringStartRL,
        $48d37ad5e67ad3e0$var$cx_Raw | $48d37ad5e67ad3e0$var$cx_Long
    ],
    [
        $48d37ad5e67ad3e0$var$stringStartRLD,
        $48d37ad5e67ad3e0$var$cx_Raw | $48d37ad5e67ad3e0$var$cx_Long | $48d37ad5e67ad3e0$var$cx_DoubleQuote
    ],
    [
        $48d37ad5e67ad3e0$var$stringStartF,
        $48d37ad5e67ad3e0$var$cx_Format
    ],
    [
        $48d37ad5e67ad3e0$var$stringStartFD,
        $48d37ad5e67ad3e0$var$cx_Format | $48d37ad5e67ad3e0$var$cx_DoubleQuote
    ],
    [
        $48d37ad5e67ad3e0$var$stringStartFL,
        $48d37ad5e67ad3e0$var$cx_Format | $48d37ad5e67ad3e0$var$cx_Long
    ],
    [
        $48d37ad5e67ad3e0$var$stringStartFLD,
        $48d37ad5e67ad3e0$var$cx_Format | $48d37ad5e67ad3e0$var$cx_Long | $48d37ad5e67ad3e0$var$cx_DoubleQuote
    ],
    [
        $48d37ad5e67ad3e0$var$stringStartFR,
        $48d37ad5e67ad3e0$var$cx_Format | $48d37ad5e67ad3e0$var$cx_Raw
    ],
    [
        $48d37ad5e67ad3e0$var$stringStartFRD,
        $48d37ad5e67ad3e0$var$cx_Format | $48d37ad5e67ad3e0$var$cx_Raw | $48d37ad5e67ad3e0$var$cx_DoubleQuote
    ],
    [
        $48d37ad5e67ad3e0$var$stringStartFRL,
        $48d37ad5e67ad3e0$var$cx_Format | $48d37ad5e67ad3e0$var$cx_Raw | $48d37ad5e67ad3e0$var$cx_Long
    ],
    [
        $48d37ad5e67ad3e0$var$stringStartFRLD,
        $48d37ad5e67ad3e0$var$cx_Format | $48d37ad5e67ad3e0$var$cx_Raw | $48d37ad5e67ad3e0$var$cx_Long | $48d37ad5e67ad3e0$var$cx_DoubleQuote
    ]
].map(([term, flags])=>[
        term,
        flags | $48d37ad5e67ad3e0$var$cx_String
    ]));
const $48d37ad5e67ad3e0$var$trackIndent = new (0, $0234adc01c271b5a$export$88193367295cc46b)({
    start: $48d37ad5e67ad3e0$var$topIndent,
    reduce (context, term, _, input) {
        if (context.flags & $48d37ad5e67ad3e0$var$cx_Bracketed && $48d37ad5e67ad3e0$var$bracketed.has(term) || (term == $48d37ad5e67ad3e0$var$String$1 || term == $48d37ad5e67ad3e0$var$FormatString) && context.flags & $48d37ad5e67ad3e0$var$cx_String) return context.parent;
        return context;
    },
    shift (context, term, stack, input) {
        if (term == $48d37ad5e67ad3e0$var$indent) return new $48d37ad5e67ad3e0$var$Context(context, $48d37ad5e67ad3e0$var$countIndent(input.read(input.pos, stack.pos)), 0);
        if (term == $48d37ad5e67ad3e0$var$dedent) return context.parent;
        if (term == $48d37ad5e67ad3e0$var$ParenL || term == $48d37ad5e67ad3e0$var$BracketL || term == $48d37ad5e67ad3e0$var$BraceL || term == $48d37ad5e67ad3e0$var$replacementStart) return new $48d37ad5e67ad3e0$var$Context(context, 0, $48d37ad5e67ad3e0$var$cx_Bracketed);
        if ($48d37ad5e67ad3e0$var$stringFlags.has(term)) return new $48d37ad5e67ad3e0$var$Context(context, 0, $48d37ad5e67ad3e0$var$stringFlags.get(term) | context.flags & $48d37ad5e67ad3e0$var$cx_Bracketed);
        return context;
    },
    hash (context) {
        return context.hash;
    }
});
const $48d37ad5e67ad3e0$var$legacyPrint = new (0, $0234adc01c271b5a$export$6e56a42e94c6b2cb)((input)=>{
    for(let i = 0; i < 5; i++){
        if (input.next != "print".charCodeAt(i)) return;
        input.advance();
    }
    if (/\w/.test(String.fromCharCode(input.next))) return;
    for(let off = 0;; off++){
        let next = input.peek(off);
        if (next == $48d37ad5e67ad3e0$var$space || next == $48d37ad5e67ad3e0$var$tab) continue;
        if (next != $48d37ad5e67ad3e0$var$parenOpen && next != $48d37ad5e67ad3e0$var$dot && next != $48d37ad5e67ad3e0$var$newline && next != $48d37ad5e67ad3e0$var$carriageReturn && next != $48d37ad5e67ad3e0$var$hash) input.acceptToken($48d37ad5e67ad3e0$var$printKeyword);
        return;
    }
});
const $48d37ad5e67ad3e0$var$strings = new (0, $0234adc01c271b5a$export$6e56a42e94c6b2cb)((input, stack)=>{
    let { flags: flags } = stack.context;
    let quote = flags & $48d37ad5e67ad3e0$var$cx_DoubleQuote ? $48d37ad5e67ad3e0$var$doubleQuote : $48d37ad5e67ad3e0$var$singleQuote;
    let long = (flags & $48d37ad5e67ad3e0$var$cx_Long) > 0;
    let escapes = !(flags & $48d37ad5e67ad3e0$var$cx_Raw);
    let format = (flags & $48d37ad5e67ad3e0$var$cx_Format) > 0;
    let start = input.pos;
    for(;;){
        if (input.next < 0) break;
        else if (format && input.next == $48d37ad5e67ad3e0$var$braceOpen) {
            if (input.peek(1) == $48d37ad5e67ad3e0$var$braceOpen) input.advance(2);
            else {
                if (input.pos == start) {
                    input.acceptToken($48d37ad5e67ad3e0$var$replacementStart, 1);
                    return;
                }
                break;
            }
        } else if (escapes && input.next == $48d37ad5e67ad3e0$var$backslash) {
            if (input.pos == start) {
                input.advance();
                let escaped = input.next;
                if (escaped >= 0) {
                    input.advance();
                    $48d37ad5e67ad3e0$var$skipEscape(input, escaped);
                }
                input.acceptToken($48d37ad5e67ad3e0$var$Escape);
                return;
            }
            break;
        } else if (input.next == $48d37ad5e67ad3e0$var$backslash && !escapes && input.peek(1) > -1) // Raw strings still ignore escaped quotes, weirdly.
        input.advance(2);
        else if (input.next == quote && (!long || input.peek(1) == quote && input.peek(2) == quote)) {
            if (input.pos == start) {
                input.acceptToken($48d37ad5e67ad3e0$var$stringEnd, long ? 3 : 1);
                return;
            }
            break;
        } else if (input.next == $48d37ad5e67ad3e0$var$newline) {
            if (long) input.advance();
            else if (input.pos == start) {
                input.acceptToken($48d37ad5e67ad3e0$var$stringEnd);
                return;
            }
            break;
        } else input.advance();
    }
    if (input.pos > start) input.acceptToken($48d37ad5e67ad3e0$var$stringContent);
});
function $48d37ad5e67ad3e0$var$skipEscape(input, ch) {
    if (ch == $48d37ad5e67ad3e0$var$letter_o) for(let i = 0; i < 2 && input.next >= 48 && input.next <= 55; i++)input.advance();
    else if (ch == $48d37ad5e67ad3e0$var$letter_x) for(let i = 0; i < 2 && $48d37ad5e67ad3e0$var$isHex(input.next); i++)input.advance();
    else if (ch == $48d37ad5e67ad3e0$var$letter_u) for(let i = 0; i < 4 && $48d37ad5e67ad3e0$var$isHex(input.next); i++)input.advance();
    else if (ch == $48d37ad5e67ad3e0$var$letter_U) for(let i = 0; i < 8 && $48d37ad5e67ad3e0$var$isHex(input.next); i++)input.advance();
    else if (ch == $48d37ad5e67ad3e0$var$letter_N) {
        if (input.next == $48d37ad5e67ad3e0$var$braceOpen) {
            input.advance();
            while(input.next >= 0 && input.next != $48d37ad5e67ad3e0$var$braceClose && input.next != $48d37ad5e67ad3e0$var$singleQuote && input.next != $48d37ad5e67ad3e0$var$doubleQuote && input.next != $48d37ad5e67ad3e0$var$newline)input.advance();
            if (input.next == $48d37ad5e67ad3e0$var$braceClose) input.advance();
        }
    }
}
const $48d37ad5e67ad3e0$var$pythonHighlighting = (0, $6b8758376c12ba5a$export$c537e79bb7b94295)({
    "async \"*\" \"**\" FormatConversion FormatSpec": (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).modifier,
    "for while if elif else try except finally return raise break continue with pass assert await yield match case": (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).controlKeyword,
    "in not and or is del": (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).operatorKeyword,
    "from def class global nonlocal lambda": (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).definitionKeyword,
    import: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).moduleKeyword,
    "with as print": (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).keyword,
    Boolean: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).bool,
    None: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).null,
    VariableName: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).variableName,
    "CallExpression/VariableName": (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).function((0, $6b8758376c12ba5a$export$8b7a896ae75accbf).variableName),
    "FunctionDefinition/VariableName": (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).function((0, $6b8758376c12ba5a$export$8b7a896ae75accbf).definition((0, $6b8758376c12ba5a$export$8b7a896ae75accbf).variableName)),
    "ClassDefinition/VariableName": (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).definition((0, $6b8758376c12ba5a$export$8b7a896ae75accbf).className),
    PropertyName: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).propertyName,
    "CallExpression/MemberExpression/PropertyName": (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).function((0, $6b8758376c12ba5a$export$8b7a896ae75accbf).propertyName),
    Comment: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).lineComment,
    Number: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).number,
    String: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).string,
    FormatString: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).special((0, $6b8758376c12ba5a$export$8b7a896ae75accbf).string),
    Escape: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).escape,
    UpdateOp: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).updateOperator,
    "ArithOp!": (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).arithmeticOperator,
    BitOp: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).bitwiseOperator,
    CompareOp: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).compareOperator,
    AssignOp: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).definitionOperator,
    Ellipsis: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).punctuation,
    At: (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).meta,
    "( )": (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).paren,
    "[ ]": (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).squareBracket,
    "{ }": (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).brace,
    ".": (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).derefOperator,
    ", ;": (0, $6b8758376c12ba5a$export$8b7a896ae75accbf).separator
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $48d37ad5e67ad3e0$var$spec_identifier = {
    __proto__: null,
    await: 44,
    or: 54,
    and: 56,
    in: 60,
    not: 62,
    is: 64,
    if: 70,
    else: 72,
    lambda: 76,
    yield: 94,
    from: 96,
    async: 102,
    for: 104,
    None: 162,
    True: 164,
    False: 164,
    del: 178,
    pass: 182,
    break: 186,
    continue: 190,
    return: 194,
    raise: 202,
    import: 206,
    as: 208,
    global: 212,
    nonlocal: 214,
    assert: 218,
    type: 223,
    elif: 236,
    while: 240,
    try: 246,
    except: 248,
    finally: 250,
    with: 254,
    def: 258,
    class: 268,
    match: 279,
    case: 285
};
const $48d37ad5e67ad3e0$export$8f49e4af10703ce3 = (0, $0234adc01c271b5a$export$60c033f4cf02b410).deserialize({
    version: 14,
    states: "##jO`QeOOP$}OSOOO&WQtO'#HUOOQS'#Co'#CoOOQS'#Cp'#CpO'vQdO'#CnO*UQtO'#HTOOQS'#HU'#HUOOQS'#DU'#DUOOQS'#HT'#HTO*rQdO'#D_O+VQdO'#DfO+gQdO'#DjO+zOWO'#DuO,VOWO'#DvO.[QtO'#GuOOQS'#Gu'#GuO'vQdO'#GtO0ZQtO'#GtOOQS'#Eb'#EbO0rQdO'#EcOOQS'#Gs'#GsO0|QdO'#GrOOQV'#Gr'#GrO1XQdO'#FYOOQS'#G^'#G^O1^QdO'#FXOOQV'#IS'#ISOOQV'#Gq'#GqOOQV'#Fq'#FqQ`QeOOO'vQdO'#CqO1lQdO'#C}O1sQdO'#DRO2RQdO'#HYO2cQtO'#EVO'vQdO'#EWOOQS'#EY'#EYOOQS'#E['#E[OOQS'#E^'#E^O2wQdO'#E`O3_QdO'#EdO3rQdO'#EfO3zQtO'#EfO1XQdO'#EiO0rQdO'#ElO1XQdO'#EnO0rQdO'#EtO0rQdO'#EwO4VQdO'#EyO4^QdO'#FOO4iQdO'#EzO0rQdO'#FOO1XQdO'#FQO1XQdO'#FVO4nQdO'#F[P4uOdO'#GpPOOO)CBd)CBdOOQS'#Ce'#CeOOQS'#Cf'#CfOOQS'#Cg'#CgOOQS'#Ch'#ChOOQS'#Ci'#CiOOQS'#Cj'#CjOOQS'#Cl'#ClO'vQdO,59OO'vQdO,59OO'vQdO,59OO'vQdO,59OO'vQdO,59OO'vQdO,59OO5TQdO'#DoOOQS,5:Y,5:YO5hQdO'#HdOOQS,5:],5:]O5uQ!fO,5:]O5zQtO,59YO1lQdO,59bO1lQdO,59bO1lQdO,59bO8jQdO,59bO8oQdO,59bO8vQdO,59jO8}QdO'#HTO:TQdO'#HSOOQS'#HS'#HSOOQS'#D['#D[O:lQdO,59aO'vQdO,59aO:zQdO,59aOOQS,59y,59yO;PQdO,5:RO'vQdO,5:ROOQS,5:Q,5:QO;_QdO,5:QO;dQdO,5:XO'vQdO,5:XO'vQdO,5:VOOQS,5:U,5:UO;uQdO,5:UO;zQdO,5:WOOOW'#Fy'#FyO<POWO,5:aOOQS,5:a,5:aO<[QdO'#HwOOOW'#Dw'#DwOOOW'#Fz'#FzO<lOWO,5:bOOQS,5:b,5:bOOQS'#F}'#F}O<zQtO,5:iO?lQtO,5=`O@VQ#xO,5=`O@vQtO,5=`OOQS,5:},5:}OA_QeO'#GWOBqQdO,5;^OOQV,5=^,5=^OB|QtO'#IPOCkQdO,5;tOOQS-E:[-E:[OOQV,5;s,5;sO4dQdO'#FQOOQV-E9o-E9oOCsQtO,59]OEzQtO,59iOFeQdO'#HVOFpQdO'#HVO1XQdO'#HVOF{QdO'#DTOGTQdO,59mOGYQdO'#HZO'vQdO'#HZO0rQdO,5=tOOQS,5=t,5=tO0rQdO'#EROOQS'#ES'#ESOGwQdO'#GPOHXQdO,58|OHXQdO,58|O*xQdO,5:oOHgQtO'#H]OOQS,5:r,5:rOOQS,5:z,5:zOHzQdO,5;OOI]QdO'#IOO1XQdO'#H}OOQS,5;Q,5;QOOQS'#GT'#GTOIqQtO,5;QOJPQdO,5;QOJUQdO'#IQOOQS,5;T,5;TOJdQdO'#H|OOQS,5;W,5;WOJuQdO,5;YO4iQdO,5;`O4iQdO,5;cOJ}QtO'#ITO'vQdO'#ITOKXQdO,5;eO4VQdO,5;eO0rQdO,5;jO1XQdO,5;lOK^QeO'#EuOLjQgO,5;fO!!kQdO'#IUO4iQdO,5;jO!!vQdO,5;lO!#OQdO,5;qO!#ZQtO,5;vO'vQdO,5;vPOOO,5=[,5=[P!#bOSO,5=[P!#jOdO,5=[O!&bQtO1G.jO!&iQtO1G.jO!)YQtO1G.jO!)dQtO1G.jO!+}QtO1G.jO!,bQtO1G.jO!,uQdO'#HcO!-TQtO'#GuO0rQdO'#HcO!-_QdO'#HbOOQS,5:Z,5:ZO!-gQdO,5:ZO!-lQdO'#HeO!-wQdO'#HeO!.[QdO,5>OOOQS'#Ds'#DsOOQS1G/w1G/wOOQS1G.|1G.|O!/[QtO1G.|O!/cQtO1G.|O1lQdO1G.|O!0OQdO1G/UOOQS'#DZ'#DZO0rQdO,59tOOQS1G.{1G.{O!0VQdO1G/eO!0gQdO1G/eO!0oQdO1G/fO'vQdO'#H[O!0tQdO'#H[O!0yQtO1G.{O!1ZQdO,59iO!2aQdO,5=zO!2qQdO,5=zO!2yQdO1G/mO!3OQtO1G/mOOQS1G/l1G/lO!3`QdO,5=uO!4VQdO,5=uO0rQdO1G/qO!4tQdO1G/sO!4yQtO1G/sO!5ZQtO1G/qOOQS1G/p1G/pOOQS1G/r1G/rOOOW-E9w-E9wOOQS1G/{1G/{O!5kQdO'#HxO0rQdO'#HxO!5|QdO,5>cOOOW-E9x-E9xOOQS1G/|1G/|OOQS-E9{-E9{O!6[Q#xO1G2zO!6{QtO1G2zO'vQdO,5<jOOQS,5<j,5<jOOQS-E9|-E9|OOQS,5<r,5<rOOQS-E:U-E:UOOQV1G0x1G0xO1XQdO'#GRO!7dQtO,5>kOOQS1G1`1G1`O!8RQdO1G1`OOQS'#DV'#DVO0rQdO,5=qOOQS,5=q,5=qO!8WQdO'#FrO!8cQdO,59oO!8kQdO1G/XO!8uQtO,5=uOOQS1G3`1G3`OOQS,5:m,5:mO!9fQdO'#GtOOQS,5<k,5<kOOQS-E9}-E9}O!9wQdO1G.hOOQS1G0Z1G0ZO!:VQdO,5=wO!:gQdO,5=wO0rQdO1G0jO0rQdO1G0jO!:xQdO,5>jO!;ZQdO,5>jO1XQdO,5>jO!;lQdO,5>iOOQS-E:R-E:RO!;qQdO1G0lO!;|QdO1G0lO!<RQdO,5>lO!<aQdO,5>lO!<oQdO,5>hO!=VQdO,5>hO!=hQdO'#EpO0rQdO1G0tO!=sQdO1G0tO!=xQgO1G0zO!AvQgO1G0}O!EqQdO,5>oO!E{QdO,5>oO!FTQtO,5>oO0rQdO1G1PO!F_QdO1G1PO4iQdO1G1UO!!vQdO1G1WOOQV,5;a,5;aO!FdQfO,5;aO!FiQgO1G1QO!JjQdO'#GZO4iQdO1G1QO4iQdO1G1QO!JzQdO,5>pO!KXQdO,5>pO1XQdO,5>pOOQV1G1U1G1UO!KaQdO'#FSO!KrQ!fO1G1WO!KzQdO1G1WOOQV1G1]1G1]O4iQdO1G1]O!LPQdO1G1]O!LXQdO'#F^OOQV1G1b1G1bO!#ZQtO1G1bPOOO1G2v1G2vP!L^OSO1G2vOOQS,5=},5=}OOQS'#Dp'#DpO0rQdO,5=}O!LfQdO,5=|O!LyQdO,5=|OOQS1G/u1G/uO!MRQdO,5>PO!McQdO,5>PO!MkQdO,5>PO!NOQdO,5>PO!N`QdO,5>POOQS1G3j1G3jOOQS7+$h7+$hO!8kQdO7+$pO#!RQdO1G.|O#!YQdO1G.|OOQS1G/`1G/`OOQS,5<`,5<`O'vQdO,5<`OOQS7+%P7+%PO#!aQdO7+%POOQS-E9r-E9rOOQS7+%Q7+%QO#!qQdO,5=vO'vQdO,5=vOOQS7+$g7+$gO#!vQdO7+%PO##OQdO7+%QO##TQdO1G3fOOQS7+%X7+%XO##eQdO1G3fO##mQdO7+%XOOQS,5<_,5<_O'vQdO,5<_O##rQdO1G3aOOQS-E9q-E9qO#$iQdO7+%]OOQS7+%_7+%_O#$wQdO1G3aO#%fQdO7+%_O#%kQdO1G3gO#%{QdO1G3gO#&TQdO7+%]O#&YQdO,5>dO#&sQdO,5>dO#&sQdO,5>dOOQS'#Dx'#DxO#'UO&jO'#DzO#'aO`O'#HyOOOW1G3}1G3}O#'fQdO1G3}O#'nQdO1G3}O#'yQ#xO7+(fO#(jQtO1G2UP#)TQdO'#GOOOQS,5<m,5<mOOQS-E:P-E:POOQS7+&z7+&zOOQS1G3]1G3]OOQS,5<^,5<^OOQS-E9p-E9pOOQS7+$s7+$sO#)bQdO,5=`O#){QdO,5=`O#*^QtO,5<aO#*qQdO1G3cOOQS-E9s-E9sOOQS7+&U7+&UO#+RQdO7+&UO#+aQdO,5<nO#+uQdO1G4UOOQS-E:Q-E:QO#,WQdO1G4UOOQS1G4T1G4TOOQS7+&W7+&WO#,iQdO7+&WOOQS,5<p,5<pO#,tQdO1G4WOOQS-E:S-E:SOOQS,5<l,5<lO#-SQdO1G4SOOQS-E:O-E:OO1XQdO'#EqO#-jQdO'#EqO#-uQdO'#IRO#-}QdO,5;[OOQS7+&`7+&`O0rQdO7+&`O#.SQgO7+&fO!JmQdO'#GXO4iQdO7+&fO4iQdO7+&iO#2QQtO,5<tO'vQdO,5<tO#2[QdO1G4ZOOQS-E:W-E:WO#2fQdO1G4ZO4iQdO7+&kO0rQdO7+&kOOQV7+&p7+&pO!KrQ!fO7+&rO!KzQdO7+&rO`QeO1G0{OOQV-E:X-E:XO4iQdO7+&lO4iQdO7+&lOOQV,5<u,5<uO#2nQdO,5<uO!JmQdO,5<uOOQV7+&l7+&lO#2yQgO7+&lO#6tQdO,5<vO#7PQdO1G4[OOQS-E:Y-E:YO#7^QdO1G4[O#7fQdO'#IWO#7tQdO'#IWO1XQdO'#IWOOQS'#IW'#IWO#8PQdO'#IVOOQS,5;n,5;nO#8XQdO,5;nO0rQdO'#FUOOQV7+&r7+&rO4iQdO7+&rOOQV7+&w7+&wO4iQdO7+&wO#8^QfO,5;xOOQV7+&|7+&|POOO7+(b7+(bO#8cQdO1G3iOOQS,5<c,5<cO#8qQdO1G3hOOQS-E9u-E9uO#9UQdO,5<dO#9aQdO,5<dO#9tQdO1G3kOOQS-E9v-E9vO#:UQdO1G3kO#:^QdO1G3kO#:nQdO1G3kO#:UQdO1G3kOOQS<<H[<<H[O#:yQtO1G1zOOQS<<Hk<<HkP#;WQdO'#FtO8vQdO1G3bO#;eQdO1G3bO#;jQdO<<HkOOQS<<Hl<<HlO#;zQdO7+)QOOQS<<Hs<<HsO#<[QtO1G1yP#<{QdO'#FsO#=YQdO7+)RO#=jQdO7+)RO#=rQdO<<HwO#=wQdO7+({OOQS<<Hy<<HyO#>nQdO,5<bO'vQdO,5<bOOQS-E9t-E9tOOQS<<Hw<<HwOOQS,5<g,5<gO0rQdO,5<gO#>sQdO1G4OOOQS-E9y-E9yO#?^QdO1G4OO<[QdO'#H{OOOO'#D{'#D{OOOO'#F|'#F|O#?oO&jO,5:fOOOW,5>e,5>eOOOW7+)i7+)iO#?zQdO7+)iO#@SQdO1G2zO#@mQdO1G2zP'vQdO'#FuO0rQdO<<IpO1XQdO1G2YP1XQdO'#GSO#AOQdO7+)pO#AaQdO7+)pOOQS<<Ir<<IrP1XQdO'#GUP0rQdO'#GQOOQS,5;],5;]O#ArQdO,5>mO#BQQdO,5>mOOQS1G0v1G0vOOQS<<Iz<<IzOOQV-E:V-E:VO4iQdO<<JQOOQV,5<s,5<sO4iQdO,5<sOOQV<<JQ<<JQOOQV<<JT<<JTO#BYQtO1G2`P#BdQdO'#GYO#BkQdO7+)uO#BuQgO<<JVO4iQdO<<JVOOQV<<J^<<J^O4iQdO<<J^O!KrQ!fO<<J^O#FpQgO7+&gOOQV<<JW<<JWO#FzQgO<<JWOOQV1G2a1G2aO1XQdO1G2aO#JuQdO1G2aO4iQdO<<JWO1XQdO1G2bP0rQdO'#G[O#KQQdO7+)vO#K_QdO7+)vOOQS'#FT'#FTO0rQdO,5>rO#KgQdO,5>rO#KrQdO,5>rO#K}QdO,5>qO#L`QdO,5>qOOQS1G1Y1G1YOOQS,5;p,5;pOOQV<<Jc<<JcO#LhQdO1G1dOOQS7+)T7+)TP#LmQdO'#FwO#L}QdO1G2OO#MbQdO1G2OO#MrQdO1G2OP#M}QdO'#FxO#N[QdO7+)VO#NlQdO7+)VO#NlQdO7+)VO#NtQdO7+)VO$ UQdO7+(|O8vQdO7+(|OOQSAN>VAN>VO$ oQdO<<LmOOQSAN>cAN>cO0rQdO1G1|O$!PQtO1G1|P$!ZQdO'#FvOOQS1G2R1G2RP$!hQdO'#F{O$!uQdO7+)jO$#`QdO,5>gOOOO-E9z-E9zOOOW<<MT<<MTO$#nQdO7+(fOOQSAN?[AN?[OOQS7+'t7+'tO$$XQdO<<M[OOQS,5<q,5<qO$$jQdO1G4XOOQS-E:T-E:TOOQVAN?lAN?lOOQV1G2_1G2_O4iQdOAN?qO$$xQgOAN?qOOQVAN?xAN?xO4iQdOAN?xOOQV<<JR<<JRO4iQdOAN?rO4iQdO7+'{OOQV7+'{7+'{O1XQdO7+'{OOQVAN?rAN?rOOQS7+'|7+'|O$(sQdO<<MbOOQS1G4^1G4^O0rQdO1G4^OOQS,5<w,5<wO$)QQdO1G4]OOQS-E:Z-E:ZOOQU'#G_'#G_O$)cQfO7+'OO$)nQdO'#F_O$*uQdO7+'jO$+VQdO7+'jOOQS7+'j7+'jO$+bQdO<<LqO$+rQdO<<LqO$+rQdO<<LqO$+zQdO'#H^OOQS<<Lh<<LhO$,UQdO<<LhOOQS7+'h7+'hOOQS'#D|'#D|OOOO1G4R1G4RO$,oQdO1G4RO$,wQdO1G4RP!=hQdO'#GVOOQVG25]G25]O4iQdOG25]OOQVG25dG25dOOQVG25^G25^OOQV<<Kg<<KgO4iQdO<<KgOOQS7+)x7+)xP$-SQdO'#G]OOQU-E:]-E:]OOQV<<Jj<<JjO$-vQtO'#FaOOQS'#Fc'#FcO$.WQdO'#FbO$.xQdO'#FbOOQS'#Fb'#FbO$.}QdO'#IYO$)nQdO'#FiO$)nQdO'#FiO$/fQdO'#FjO$)nQdO'#FkO$/mQdO'#IZOOQS'#IZ'#IZO$0[QdO,5;yOOQS<<KU<<KUO$0dQdO<<KUO$0tQdOANB]O$1UQdOANB]O$1^QdO'#H_OOQS'#H_'#H_O1sQdO'#DcO$1wQdO,5=xOOQSANBSANBSOOOO7+)m7+)mO$2`QdO7+)mOOQVLD*wLD*wOOQVANARANARO5uQ!fO'#GaO$2hQtO,5<SO$)nQdO'#FmOOQS,5<W,5<WOOQS'#Fd'#FdO$3YQdO,5;|O$3_QdO,5;|OOQS'#Fg'#FgO$)nQdO'#G`O$4PQdO,5<QO$4kQdO,5>tO$4{QdO,5>tO1XQdO,5<PO$5^QdO,5<TO$5cQdO,5<TO$)nQdO'#I[O$5hQdO'#I[O$5mQdO,5<UOOQS,5<V,5<VO0rQdO'#FpOOQU1G1e1G1eO4iQdO1G1eOOQSAN@pAN@pO$5rQdOG27wO$6SQdO,59}OOQS1G3d1G3dOOOO<<MX<<MXOOQS,5<{,5<{OOQS-E:_-E:_O$6XQtO'#FaO$6`QdO'#I]O$6nQdO'#I]O$6vQdO,5<XOOQS1G1h1G1hO$6{QdO1G1hO$7QQdO,5<zOOQS-E:^-E:^O$7lQdO,5=OO$8TQdO1G4`OOQS-E:b-E:bOOQS1G1k1G1kOOQS1G1o1G1oO$8eQdO,5>vO$)nQdO,5>vOOQS1G1p1G1pOOQS,5<[,5<[OOQU7+'P7+'PO$+zQdO1G/iO$)nQdO,5<YO$8sQdO,5>wO$8zQdO,5>wOOQS1G1s1G1sOOQS7+'S7+'SP$)nQdO'#GdO$9SQdO1G4bO$9^QdO1G4bO$9fQdO1G4bOOQS7+%T7+%TO$9tQdO1G1tO$:SQtO'#FaO$:ZQdO,5<}OOQS,5<},5<}O$:iQdO1G4cOOQS-E:a-E:aO$)nQdO,5<|O$:pQdO,5<|O$:uQdO7+)|OOQS-E:`-E:`O$;PQdO7+)|O$)nQdO,5<ZP$)nQdO'#GcO$;XQdO1G2hO$)nQdO1G2hP$;gQdO'#GbO$;nQdO<<MhO$;xQdO1G1uO$<WQdO7+(SO8vQdO'#C}O8vQdO,59bO8vQdO,59bO8vQdO,59bO$<fQtO,5=`O8vQdO1G.|O0rQdO1G/XO0rQdO7+$pP$<yQdO'#GOO'vQdO'#GtO$=WQdO,59bO$=]QdO,59bO$=dQdO,59mO$=iQdO1G/UO1sQdO'#DRO8vQdO,59j",
    stateData: "$>S~O%cOS%^OSSOS%]PQ~OPdOVaOfoOhYOopOs!POvqO!PrO!Q{O!T!SO!U!RO!XZO!][O!h`O!r`O!s`O!t`O!{tO!}uO#PvO#RwO#TxO#XyO#ZzO#^|O#_|O#a}O#c!OO#l!QO#o!TO#s!UO#u!VO#z!WO#}hO$P!XO%oRO%pRO%tSO%uWO&Z]O&[]O&]]O&^]O&_]O&`]O&a]O&b]O&c^O&d^O&e^O&f^O&g^O&h^O&i^O&j^O~O%]!YO~OV!aO_!aOa!bOh!iO!X!kO!f!mO%j![O%k!]O%l!^O%m!_O%n!_O%o!`O%p!`O%q!aO%r!aO%s!aO~Ok%xXl%xXm%xXn%xXo%xXp%xXs%xXz%xX{%xX!x%xX#g%xX%[%xX%_%xX%z%xXg%xX!T%xX!U%xX%{%xX!W%xX![%xX!Q%xX#[%xXt%xX!m%xX~P%SOfoOhYO!XZO!][O!h`O!r`O!s`O!t`O%oRO%pRO%tSO%uWO&Z]O&[]O&]]O&^]O&_]O&`]O&a]O&b]O&c^O&d^O&e^O&f^O&g^O&h^O&i^O&j^O~Oz%wX{%wX#g%wX%[%wX%_%wX%z%wX~Ok!pOl!qOm!oOn!oOo!rOp!sOs!tO!x%wX~P)pOV!zOg!|Oo0cOv0qO!PrO~P'vOV#OOo0cOv0qO!W#PO~P'vOV#SOa#TOo0cOv0qO![#UO~P'vOQ#XO%`#XO%a#ZO~OQ#^OR#[O%`#^O%a#`O~OV%iX_%iXa%iXh%iXk%iXl%iXm%iXn%iXo%iXp%iXs%iXz%iX!X%iX!f%iX%j%iX%k%iX%l%iX%m%iX%n%iX%o%iX%p%iX%q%iX%r%iX%s%iXg%iX!T%iX!U%iX~O&Z]O&[]O&]]O&^]O&_]O&`]O&a]O&b]O&c^O&d^O&e^O&f^O&g^O&h^O&i^O&j^O{%iX!x%iX#g%iX%[%iX%_%iX%z%iX%{%iX!W%iX![%iX!Q%iX#[%iXt%iX!m%iX~P,eOz#dO{%hX!x%hX#g%hX%[%hX%_%hX%z%hX~Oo0cOv0qO~P'vO#g#gO%[#iO%_#iO~O%uWO~O!T#nO#u!VO#z!WO#}hO~OopO~P'vOV#sOa#tO%uWO{wP~OV#xOo0cOv0qO!Q#yO~P'vO{#{O!x$QO%z#|O#g!yX%[!yX%_!yX~OV#xOo0cOv0qO#g#SX%[#SX%_#SX~P'vOo0cOv0qO#g#WX%[#WX%_#WX~P'vOh$WO%uWO~O!f$YO!r$YO%uWO~OV$eO~P'vO!U$gO#s$hO#u$iO~O{$jO~OV$qO~P'vOS$sO%[$rO%_$rO%c$tO~OV$}Oa$}Og%POo0cOv0qO~P'vOo0cOv0qO{%SO~P'vO&Y%UO~Oa!bOh!iO!X!kO!f!mOVba_bakbalbambanbaobapbasbazba{ba!xba#gba%[ba%_ba%jba%kba%lba%mba%nba%oba%pba%qba%rba%sba%zbagba!Tba!Uba%{ba!Wba![ba!Qba#[batba!mba~On%ZO~Oo%ZO~P'vOo0cO~P'vOk0eOl0fOm0dOn0dOo0mOp0nOs0rOg%wX!T%wX!U%wX%{%wX!W%wX![%wX!Q%wX#[%wX!m%wX~P)pO%{%]Og%vXz%vX!T%vX!U%vX!W%vX{%vX~Og%_Oz%`O!T%dO!U%cO~Og%_O~Oz%gO!T%dO!U%cO!W&SX~O!W%kO~Oz%lO{%nO!T%dO!U%cO![%}X~O![%rO~O![%sO~OQ#XO%`#XO%a%uO~OV%wOo0cOv0qO!PrO~P'vOQ#^OR#[O%`#^O%a%zO~OV!qa_!qaa!qah!qak!qal!qam!qan!qao!qap!qas!qaz!qa{!qa!X!qa!f!qa!x!qa#g!qa%[!qa%_!qa%j!qa%k!qa%l!qa%m!qa%n!qa%o!qa%p!qa%q!qa%r!qa%s!qa%z!qag!qa!T!qa!U!qa%{!qa!W!qa![!qa!Q!qa#[!qat!qa!m!qa~P#yOz%|O{%ha!x%ha#g%ha%[%ha%_%ha%z%ha~P%SOV&OOopOvqO{%ha!x%ha#g%ha%[%ha%_%ha%z%ha~P'vOz%|O{%ha!x%ha#g%ha%[%ha%_%ha%z%ha~OPdOVaOopOvqO!PrO!Q{O!{tO!}uO#PvO#RwO#TxO#XyO#ZzO#^|O#_|O#a}O#c!OO#g$zX%[$zX%_$zX~P'vO#g#gO%[&TO%_&TO~O!f&UOh&sX%[&sXz&sX#[&sX#g&sX%_&sX#Z&sXg&sX~Oh!iO%[&WO~Okealeameaneaoeapeaseazea{ea!xea#gea%[ea%_ea%zeagea!Tea!Uea%{ea!Wea![ea!Qea#[eatea!mea~P%SOsqazqa{qa#gqa%[qa%_qa%zqa~Ok!pOl!qOm!oOn!oOo!rOp!sO!xqa~PEcO%z&YOz%yX{%yX~O%uWOz%yX{%yX~Oz&]O{wX~O{&_O~Oz%lO#g%}X%[%}X%_%}Xg%}X{%}X![%}X!m%}X%z%}X~OV0lOo0cOv0qO!PrO~P'vO%z#|O#gUa%[Ua%_Ua~Oz&hO#g&PX%[&PX%_&PXn&PX~P%SOz&kO!Q&jO#g#Wa%[#Wa%_#Wa~Oz&lO#[&nO#g&rX%[&rX%_&rXg&rX~O!f$YO!r$YO#Z&qO%uWO~O#Z&qO~Oz&sO#g&tX%[&tX%_&tX~Oz&uO#g&pX%[&pX%_&pX{&pX~O!X&wO%z&xO~Oz&|On&wX~P%SOn'PO~OPdOVaOopOvqO!PrO!Q{O!{tO!}uO#PvO#RwO#TxO#XyO#ZzO#^|O#_|O#a}O#c!OO%['UO~P'vOt'YO#p'WO#q'XOP#naV#naf#nah#nao#nas#nav#na!P#na!Q#na!T#na!U#na!X#na!]#na!h#na!r#na!s#na!t#na!{#na!}#na#P#na#R#na#T#na#X#na#Z#na#^#na#_#na#a#na#c#na#l#na#o#na#s#na#u#na#z#na#}#na$P#na%X#na%o#na%p#na%t#na%u#na&Z#na&[#na&]#na&^#na&_#na&`#na&a#na&b#na&c#na&d#na&e#na&f#na&g#na&h#na&i#na&j#na%Z#na%_#na~Oz'ZO#[']O{&xX~Oh'_O!X&wO~Oh!iO{$jO!X&wO~O{'eO~P%SO%['hO%_'hO~OS'iO%['hO%_'hO~OV!aO_!aOa!bOh!iO!X!kO!f!mO%l!^O%m!_O%n!_O%o!`O%p!`O%q!aO%r!aO%s!aOkWilWimWinWioWipWisWizWi{Wi!xWi#gWi%[Wi%_Wi%jWi%zWigWi!TWi!UWi%{Wi!WWi![Wi!QWi#[WitWi!mWi~O%k!]O~P!#uO%kWi~P!#uOV!aO_!aOa!bOh!iO!X!kO!f!mO%o!`O%p!`O%q!aO%r!aO%s!aOkWilWimWinWioWipWisWizWi{Wi!xWi#gWi%[Wi%_Wi%jWi%kWi%lWi%zWigWi!TWi!UWi%{Wi!WWi![Wi!QWi#[WitWi!mWi~O%m!_O%n!_O~P!&pO%mWi%nWi~P!&pOa!bOh!iO!X!kO!f!mOkWilWimWinWioWipWisWizWi{Wi!xWi#gWi%[Wi%_Wi%jWi%kWi%lWi%mWi%nWi%oWi%pWi%zWigWi!TWi!UWi%{Wi!WWi![Wi!QWi#[WitWi!mWi~OV!aO_!aO%q!aO%r!aO%s!aO~P!)nOVWi_Wi%qWi%rWi%sWi~P!)nO!T%dO!U%cOg&VXz&VX~O%z'kO%{'kO~P,eOz'mOg&UX~Og'oO~Oz'pO{'rO!W&XX~Oo0cOv0qOz'pO{'sO!W&XX~P'vO!W'uO~Om!oOn!oOo!rOp!sOkjisjizji{ji!xji#gji%[ji%_ji%zji~Ol!qO~P!.aOlji~P!.aOk0eOl0fOm0dOn0dOo0mOp0nO~Ot'wO~P!/jOV'|Og'}Oo0cOv0qO~P'vOg'}Oz(OO~Og(QO~O!U(SO~Og(TOz(OO!T%dO!U%cO~P%SOk0eOl0fOm0dOn0dOo0mOp0nOgqa!Tqa!Uqa%{qa!Wqa![qa!Qqa#[qatqa!mqa~PEcOV'|Oo0cOv0qO!W&Sa~P'vOz(WO!W&Sa~O!W(XO~Oz(WO!T%dO!U%cO!W&Sa~P%SOV(]Oo0cOv0qO![%}a#g%}a%[%}a%_%}ag%}a{%}a!m%}a%z%}a~P'vOz(^O![%}a#g%}a%[%}a%_%}ag%}a{%}a!m%}a%z%}a~O![(aO~Oz(^O!T%dO!U%cO![%}a~P%SOz(dO!T%dO!U%cO![&Ta~P%SOz(gO{&lX![&lX!m&lX%z&lX~O{(kO![(mO!m(nO%z(jO~OV&OOopOvqO{%hi!x%hi#g%hi%[%hi%_%hi%z%hi~P'vOz(pO{%hi!x%hi#g%hi%[%hi%_%hi%z%hi~O!f&UOh&sa%[&saz&sa#[&sa#g&sa%_&sa#Z&sag&sa~O%[(uO~OV#sOa#tO%uWO~Oz&]O{wa~OopOvqO~P'vOz(^O#g%}a%[%}a%_%}ag%}a{%}a![%}a!m%}a%z%}a~P%SOz(zO#g%hX%[%hX%_%hX%z%hX~O%z#|O#gUi%[Ui%_Ui~O#g&Pa%[&Pa%_&Pan&Pa~P'vOz(}O#g&Pa%[&Pa%_&Pan&Pa~O%uWO#g&ra%[&ra%_&rag&ra~Oz)SO#g&ra%[&ra%_&rag&ra~Og)VO~OV)WOh$WO%uWO~O#Z)XO~O%uWO#g&ta%[&ta%_&ta~Oz)ZO#g&ta%[&ta%_&ta~Oo0cOv0qO#g&pa%[&pa%_&pa{&pa~P'vOz)^O#g&pa%[&pa%_&pa{&pa~OV)`Oa)`O%uWO~O%z)eO~Ot)hO#j)gOP#hiV#hif#hih#hio#his#hiv#hi!P#hi!Q#hi!T#hi!U#hi!X#hi!]#hi!h#hi!r#hi!s#hi!t#hi!{#hi!}#hi#P#hi#R#hi#T#hi#X#hi#Z#hi#^#hi#_#hi#a#hi#c#hi#l#hi#o#hi#s#hi#u#hi#z#hi#}#hi$P#hi%X#hi%o#hi%p#hi%t#hi%u#hi&Z#hi&[#hi&]#hi&^#hi&_#hi&`#hi&a#hi&b#hi&c#hi&d#hi&e#hi&f#hi&g#hi&h#hi&i#hi&j#hi%Z#hi%_#hi~Ot)iOP#kiV#kif#kih#kio#kis#kiv#ki!P#ki!Q#ki!T#ki!U#ki!X#ki!]#ki!h#ki!r#ki!s#ki!t#ki!{#ki!}#ki#P#ki#R#ki#T#ki#X#ki#Z#ki#^#ki#_#ki#a#ki#c#ki#l#ki#o#ki#s#ki#u#ki#z#ki#}#ki$P#ki%X#ki%o#ki%p#ki%t#ki%u#ki&Z#ki&[#ki&]#ki&^#ki&_#ki&`#ki&a#ki&b#ki&c#ki&d#ki&e#ki&f#ki&g#ki&h#ki&i#ki&j#ki%Z#ki%_#ki~OV)kOn&wa~P'vOz)lOn&wa~Oz)lOn&wa~P%SOn)pO~O%Y)tO~Ot)wO#p'WO#q)vOP#niV#nif#nih#nio#nis#niv#ni!P#ni!Q#ni!T#ni!U#ni!X#ni!]#ni!h#ni!r#ni!s#ni!t#ni!{#ni!}#ni#P#ni#R#ni#T#ni#X#ni#Z#ni#^#ni#_#ni#a#ni#c#ni#l#ni#o#ni#s#ni#u#ni#z#ni#}#ni$P#ni%X#ni%o#ni%p#ni%t#ni%u#ni&Z#ni&[#ni&]#ni&^#ni&_#ni&`#ni&a#ni&b#ni&c#ni&d#ni&e#ni&f#ni&g#ni&h#ni&i#ni&j#ni%Z#ni%_#ni~OV)zOo0cOv0qO{$jO~P'vOo0cOv0qO{&xa~P'vOz*OO{&xa~OV*SOa*TOg*WO%q*UO%uWO~O{$jO&{*YO~Oh'_O~Oh!iO{$jO~O%[*_O~O%[*aO%_*aO~OV$}Oa$}Oo0cOv0qOg&Ua~P'vOz*dOg&Ua~Oo0cOv0qO{*gO!W&Xa~P'vOz*hO!W&Xa~Oo0cOv0qOz*hO{*kO!W&Xa~P'vOo0cOv0qOz*hO!W&Xa~P'vOz*hO{*kO!W&Xa~Om0dOn0dOo0mOp0nOgjikjisjizji!Tji!Uji%{ji!Wji{ji![ji#gji%[ji%_ji!Qji#[jitji!mji%zji~Ol0fO~P!NkOlji~P!NkOV'|Og*pOo0cOv0qO~P'vOn*rO~Og*pOz*tO~Og*uO~OV'|Oo0cOv0qO!W&Si~P'vOz*vO!W&Si~O!W*wO~OV(]Oo0cOv0qO![%}i#g%}i%[%}i%_%}ig%}i{%}i!m%}i%z%}i~P'vOz*zO!T%dO!U%cO![&Ti~Oz*}O![%}i#g%}i%[%}i%_%}ig%}i{%}i!m%}i%z%}i~O![+OO~Oa+QOo0cOv0qO![&Ti~P'vOz*zO![&Ti~O![+SO~OV+UOo0cOv0qO{&la![&la!m&la%z&la~P'vOz+VO{&la![&la!m&la%z&la~O!]+YO&n+[O![!nX~O![+^O~O{(kO![+_O~O{(kO![+_O!m+`O~OV&OOopOvqO{%hq!x%hq#g%hq%[%hq%_%hq%z%hq~P'vOz$ri{$ri!x$ri#g$ri%[$ri%_$ri%z$ri~P%SOV&OOopOvqO~P'vOV&OOo0cOv0qO#g%ha%[%ha%_%ha%z%ha~P'vOz+aO#g%ha%[%ha%_%ha%z%ha~Oz$ia#g$ia%[$ia%_$ian$ia~P%SO#g&Pi%[&Pi%_&Pin&Pi~P'vOz+dO#g#Wq%[#Wq%_#Wq~O#[+eOz$va#g$va%[$va%_$vag$va~O%uWO#g&ri%[&ri%_&rig&ri~Oz+gO#g&ri%[&ri%_&rig&ri~OV+iOh$WO%uWO~O%uWO#g&ti%[&ti%_&ti~Oo0cOv0qO#g&pi%[&pi%_&pi{&pi~P'vO{#{Oz#eX!W#eX~Oz+mO!W&uX~O!W+oO~Ot+rO#j)gOP#hqV#hqf#hqh#hqo#hqs#hqv#hq!P#hq!Q#hq!T#hq!U#hq!X#hq!]#hq!h#hq!r#hq!s#hq!t#hq!{#hq!}#hq#P#hq#R#hq#T#hq#X#hq#Z#hq#^#hq#_#hq#a#hq#c#hq#l#hq#o#hq#s#hq#u#hq#z#hq#}#hq$P#hq%X#hq%o#hq%p#hq%t#hq%u#hq&Z#hq&[#hq&]#hq&^#hq&_#hq&`#hq&a#hq&b#hq&c#hq&d#hq&e#hq&f#hq&g#hq&h#hq&i#hq&j#hq%Z#hq%_#hq~On$|az$|a~P%SOV)kOn&wi~P'vOz+yOn&wi~Oz,TO{$jO#[,TO~O#q,VOP#nqV#nqf#nqh#nqo#nqs#nqv#nq!P#nq!Q#nq!T#nq!U#nq!X#nq!]#nq!h#nq!r#nq!s#nq!t#nq!{#nq!}#nq#P#nq#R#nq#T#nq#X#nq#Z#nq#^#nq#_#nq#a#nq#c#nq#l#nq#o#nq#s#nq#u#nq#z#nq#}#nq$P#nq%X#nq%o#nq%p#nq%t#nq%u#nq&Z#nq&[#nq&]#nq&^#nq&_#nq&`#nq&a#nq&b#nq&c#nq&d#nq&e#nq&f#nq&g#nq&h#nq&i#nq&j#nq%Z#nq%_#nq~O#[,WOz%Oa{%Oa~Oo0cOv0qO{&xi~P'vOz,YO{&xi~O{#{O%z,[Og&zXz&zX~O%uWOg&zXz&zX~Oz,`Og&yX~Og,bO~O%Y,eO~O!T%dO!U%cOg&Viz&Vi~OV$}Oa$}Oo0cOv0qOg&Ui~P'vO{,hOz$la!W$la~Oo0cOv0qO{,iOz$la!W$la~P'vOo0cOv0qO{*gO!W&Xi~P'vOz,lO!W&Xi~Oo0cOv0qOz,lO!W&Xi~P'vOz,lO{,oO!W&Xi~Og$hiz$hi!W$hi~P%SOV'|Oo0cOv0qO~P'vOn,qO~OV'|Og,rOo0cOv0qO~P'vOV'|Oo0cOv0qO!W&Sq~P'vOz$gi![$gi#g$gi%[$gi%_$gig$gi{$gi!m$gi%z$gi~P%SOV(]Oo0cOv0qO~P'vOa+QOo0cOv0qO![&Tq~P'vOz,sO![&Tq~O![,tO~OV(]Oo0cOv0qO![%}q#g%}q%[%}q%_%}qg%}q{%}q!m%}q%z%}q~P'vO{,uO~OV+UOo0cOv0qO{&li![&li!m&li%z&li~P'vOz,zO{&li![&li!m&li%z&li~O!]+YO&n+[O![!na~O{(kO![,}O~OV&OOo0cOv0qO#g%hi%[%hi%_%hi%z%hi~P'vOz-OO#g%hi%[%hi%_%hi%z%hi~O%uWO#g&rq%[&rq%_&rqg&rq~Oz-RO#g&rq%[&rq%_&rqg&rq~OV)`Oa)`O%uWO!W&ua~Oz-TO!W&ua~On$|iz$|i~P%SOV)kO~P'vOV)kOn&wq~P'vOt-XOP#myV#myf#myh#myo#mys#myv#my!P#my!Q#my!T#my!U#my!X#my!]#my!h#my!r#my!s#my!t#my!{#my!}#my#P#my#R#my#T#my#X#my#Z#my#^#my#_#my#a#my#c#my#l#my#o#my#s#my#u#my#z#my#}#my$P#my%X#my%o#my%p#my%t#my%u#my&Z#my&[#my&]#my&^#my&_#my&`#my&a#my&b#my&c#my&d#my&e#my&f#my&g#my&h#my&i#my&j#my%Z#my%_#my~O%Z-]O%_-]O~P`O#q-^OP#nyV#nyf#nyh#nyo#nys#nyv#ny!P#ny!Q#ny!T#ny!U#ny!X#ny!]#ny!h#ny!r#ny!s#ny!t#ny!{#ny!}#ny#P#ny#R#ny#T#ny#X#ny#Z#ny#^#ny#_#ny#a#ny#c#ny#l#ny#o#ny#s#ny#u#ny#z#ny#}#ny$P#ny%X#ny%o#ny%p#ny%t#ny%u#ny&Z#ny&[#ny&]#ny&^#ny&_#ny&`#ny&a#ny&b#ny&c#ny&d#ny&e#ny&f#ny&g#ny&h#ny&i#ny&j#ny%Z#ny%_#ny~Oz-aO{$jO#[-aO~Oo0cOv0qO{&xq~P'vOz-dO{&xq~O%z,[Og&zaz&za~O{#{Og&zaz&za~OV*SOa*TO%q*UO%uWOg&ya~Oz-hOg&ya~O$S-lO~OV$}Oa$}Oo0cOv0qO~P'vOo0cOv0qO{-mOz$li!W$li~P'vOo0cOv0qOz$li!W$li~P'vO{-mOz$li!W$li~Oo0cOv0qO{*gO~P'vOo0cOv0qO{*gO!W&Xq~P'vOz-pO!W&Xq~Oo0cOv0qOz-pO!W&Xq~P'vOs-sO!T%dO!U%cOg&Oq!W&Oq![&Oqz&Oq~P!/jOa+QOo0cOv0qO![&Ty~P'vOz$ji![$ji~P%SOa+QOo0cOv0qO~P'vOV+UOo0cOv0qO~P'vOV+UOo0cOv0qO{&lq![&lq!m&lq%z&lq~P'vO{(kO![-xO!m-yO%z-wO~OV&OOo0cOv0qO#g%hq%[%hq%_%hq%z%hq~P'vO%uWO#g&ry%[&ry%_&ryg&ry~OV)`Oa)`O%uWO!W&ui~Ot-}OP#m!RV#m!Rf#m!Rh#m!Ro#m!Rs#m!Rv#m!R!P#m!R!Q#m!R!T#m!R!U#m!R!X#m!R!]#m!R!h#m!R!r#m!R!s#m!R!t#m!R!{#m!R!}#m!R#P#m!R#R#m!R#T#m!R#X#m!R#Z#m!R#^#m!R#_#m!R#a#m!R#c#m!R#l#m!R#o#m!R#s#m!R#u#m!R#z#m!R#}#m!R$P#m!R%X#m!R%o#m!R%p#m!R%t#m!R%u#m!R&Z#m!R&[#m!R&]#m!R&^#m!R&_#m!R&`#m!R&a#m!R&b#m!R&c#m!R&d#m!R&e#m!R&f#m!R&g#m!R&h#m!R&i#m!R&j#m!R%Z#m!R%_#m!R~Oo0cOv0qO{&xy~P'vOV*SOa*TO%q*UO%uWOg&yi~O$S-lO%Z.VO%_.VO~OV.aOh._O!X.^O!].`O!h.YO!s.[O!t.[O%p.XO%uWO&Z]O&[]O&]]O&^]O&_]O&`]O&a]O&b]O~Oo0cOv0qOz$lq!W$lq~P'vO{.fOz$lq!W$lq~Oo0cOv0qO{*gO!W&Xy~P'vOz.gO!W&Xy~Oo0cOv.kO~P'vOs-sO!T%dO!U%cOg&Oy!W&Oy![&Oyz&Oy~P!/jO{(kO![.nO~O{(kO![.nO!m.oO~OV*SOa*TO%q*UO%uWO~Oh.tO!f.rOz$TX#[$TX%j$TXg$TX~Os$TX{$TX!W$TX![$TX~P$-bO%o.vO%p.vOs$UXz$UX{$UX#[$UX%j$UX!W$UXg$UX![$UX~O!h.xO~Oz.|O#[/OO%j.yOs&|X{&|X!W&|Xg&|X~Oa/RO~P$)zOh.tOs&}Xz&}X{&}X#[&}X%j&}X!W&}Xg&}X![&}X~Os/VO{$jO~Oo0cOv0qOz$ly!W$ly~P'vOo0cOv0qO{*gO!W&X!R~P'vOz/ZO!W&X!R~Og&RXs&RX!T&RX!U&RX!W&RX![&RXz&RX~P!/jOs-sO!T%dO!U%cOg&Qa!W&Qa![&Qaz&Qa~O{(kO![/^O~O!f.rOh$[as$[az$[a{$[a#[$[a%j$[a!W$[ag$[a![$[a~O!h/eO~O%o.vO%p.vOs$Uaz$Ua{$Ua#[$Ua%j$Ua!W$Uag$Ua![$Ua~O%j.yOs$Yaz$Ya{$Ya#[$Ya!W$Yag$Ya![$Ya~Os&|a{&|a!W&|ag&|a~P$)nOz/jOs&|a{&|a!W&|ag&|a~O!W/mO~Og/mO~O{/oO~O![/pO~Oo0cOv0qO{*gO!W&X!Z~P'vO{/sO~O%z/tO~P$-bOz/uO#[/OO%j.yOg'PX~Oz/uOg'PX~Og/wO~O!h/xO~O#[/OOs%Saz%Sa{%Sa%j%Sa!W%Sag%Sa![%Sa~O#[/OO%j.yOs%Waz%Wa{%Wa!W%Wag%Wa~Os&|i{&|i!W&|ig&|i~P$)nOz/zO#[/OO%j.yO!['Oa~Og'Pa~P$)nOz0SOg'Pa~Oa0UO!['Oi~P$)zOz0WO!['Oi~Oz0WO#[/OO%j.yO!['Oi~O#[/OO%j.yOg$biz$bi~O%z0ZO~P$-bO#[/OO%j.yOg%Vaz%Va~Og'Pi~P$)nO{0^O~Oa0UO!['Oq~P$)zOz0`O!['Oq~O#[/OO%j.yOz%Ui![%Ui~Oa0UO~P$)zOa0UO!['Oy~P$)zO#[/OO%j.yOg$ciz$ci~O#[/OO%j.yOz%Uq![%Uq~Oz+aO#g%ha%[%ha%_%ha%z%ha~P%SOV&OOo0cOv0qO~P'vOn0hO~Oo0hO~P'vO{0iO~Ot0jO~P!/jO&]&Z&j&h&i&g&f&d&e&c&b&`&a&_&^&[%u~",
    goto: "!=j'QPPPPPP'RP'Z*s+[+t,_,y-fP.SP'Z.r.r'ZPPP'Z2[PPPPPP2[5PPP5PP7b7k=sPP=v>h>kPP'Z'ZPP>zPP'Z'ZPP'Z'Z'Z'Z'Z?O?w'ZP?zP@QDXGuGyPG|HWH['ZPPPH_Hk'RP'R'RP'RP'RP'RP'RP'R'R'RP'RPP'RPP'RP'RPHqH}IVPI^IdPI^PI^I^PPPI^PKrPK{LVL]KrPI^LfPI^PLmLsPLwM]MzNeLwLwNkNxLwLwLwLw! ^! d! g! l! o! y!!P!!]!!o!!u!#P!#V!#s!#y!$P!$Z!$a!$g!$y!%T!%Z!%a!%k!%q!%w!%}!&T!&Z!&e!&k!&u!&{!'U!'[!'k!'s!'}!(UPPPPPPPPPPP!([!(_!(e!(n!(x!)TPPPPPPPPPPPP!-u!/Z!3^!6oPP!6w!7W!7a!8Y!8P!8c!8i!8l!8o!8r!8z!9jPPPPPPPPPPPPPPPPP!9m!9q!9wP!:]!:a!:m!:v!;S!;j!;m!;p!;v!;|!<S!<VP!<_!<h!=d!=g]eOn#g$j)t,P'}`OTYZ[adnoprtxy}!P!Q!R!U!X!c!d!e!f!g!h!i!k!o!p!q!s!t!z#O#S#T#[#d#g#x#y#{#}$Q$e$g$h$j$q$}%S%Z%^%`%c%g%l%n%w%|&O&Z&_&h&j&k&u&x&|'P'W'Z'l'm'p'r's'w'|(O(S(W(](^(d(g(p(r(z(})^)e)g)k)l)p)t)z*O*Y*d*g*h*k*q*r*t*v*y*z*}+Q+U+V+Y+a+c+d+k+x+y,P,X,Y,],g,h,i,k,l,o,q,s,u,w,y,z-O-d-f-m-p-s.f.g/V/Z/s0c0d0e0f0h0i0j0k0l0n0r{!cQ#c#p$R$d$p%e%j%p%q&`'O'g(q(|)j*o*x+w,v0g}!dQ#c#p$R$d$p$u%e%j%p%q&`'O'g(q(|)j*o*x+w,v0g!P!eQ#c#p$R$d$p$u$v%e%j%p%q&`'O'g(q(|)j*o*x+w,v0g!R!fQ#c#p$R$d$p$u$v$w%e%j%p%q&`'O'g(q(|)j*o*x+w,v0g!T!gQ#c#p$R$d$p$u$v$w$x%e%j%p%q&`'O'g(q(|)j*o*x+w,v0g!V!hQ#c#p$R$d$p$u$v$w$x$y%e%j%p%q&`'O'g(q(|)j*o*x+w,v0g!Z!hQ!n#c#p$R$d$p$u$v$w$x$y$z%e%j%p%q&`'O'g(q(|)j*o*x+w,v0g'}TOTYZ[adnoprtxy}!P!Q!R!U!X!c!d!e!f!g!h!i!k!o!p!q!s!t!z#O#S#T#[#d#g#x#y#{#}$Q$e$g$h$j$q$}%S%Z%^%`%c%g%l%n%w%|&O&Z&_&h&j&k&u&x&|'P'W'Z'l'm'p'r's'w'|(O(S(W(](^(d(g(p(r(z(})^)e)g)k)l)p)t)z*O*Y*d*g*h*k*q*r*t*v*y*z*}+Q+U+V+Y+a+c+d+k+x+y,P,X,Y,],g,h,i,k,l,o,q,s,u,w,y,z-O-d-f-m-p-s.f.g/V/Z/s0c0d0e0f0h0i0j0k0l0n0r&eVOYZ[dnprxy}!P!Q!U!i!k!o!p!q!s!t#[#d#g#y#{#}$Q$h$j$}%S%Z%^%`%g%l%n%w%|&Z&_&j&k&u&x'P'W'Z'l'm'p'r's'w(O(W(^(d(g(p(r(z)^)e)g)p)t)z*O*Y*d*g*h*k*q*r*t*v*y*z*}+U+V+Y+a+d+k,P,X,Y,],g,h,i,k,l,o,q,s,u,w,y,z-O-d-f-m-p-s.f.g/V/Z/s0c0d0e0f0h0i0j0k0n0r%oXOYZ[dnrxy}!P!Q!U!i!k#[#d#g#y#{#}$Q$h$j$}%S%^%`%g%l%n%w%|&Z&_&j&k&u&x'P'W'Z'l'm'p'r's'w(O(W(^(d(g(p(r(z)^)e)g)p)t)z*O*Y*d*g*h*k*q*t*v*y*z*}+U+V+Y+a+d+k,P,X,Y,],g,h,i,k,l,o,s,u,w,y,z-O-d-f-m-p.f.g/V/Z0i0j0kQ#vqQ/[.kR0o0q't`OTYZ[adnoprtxy}!P!Q!R!U!X!c!d!e!f!g!h!k!o!p!q!s!t!z#O#S#T#[#d#g#x#y#{#}$Q$e$g$h$j$q$}%S%Z%^%`%c%g%l%n%w%|&O&Z&_&h&j&k&u&x&|'P'W'Z'l'p'r's'w'|(O(S(W(](^(d(g(p(r(z(})^)e)g)k)l)p)t)z*O*Y*g*h*k*q*r*t*v*y*z*}+Q+U+V+Y+a+c+d+k+x+y,P,X,Y,],h,i,k,l,o,q,s,u,w,y,z-O-d-f-m-p-s.f.g/V/Z/s0c0d0e0f0h0i0j0k0l0n0rh#jhz{$W$Z&l&q)S)X+f+g-RW#rq&].k0qQ$]|Q$a!OQ$n!VQ$o!WW$|!i'm*d,gS&[#s#tQ'S$iQ(s&UQ)U&nU)Y&s)Z+jW)a&w+m-T-{Q*Q']W*R'_,`-h.TQ+l)`S,_*S*TQ-Q+eQ-_,TQ-c,WQ.R-al.W-l.^._.a.z.|/R/j/o/t/y0U0Z0^Q/S.`Q/a.tQ/l/OU0P/u0S0[X0V/z0W0_0`R&Z#r!_!wYZ!P!Q!k%S%`%g'p'r's(O(W)g*g*h*k*q*t*v,h,i,k,l,o-m-p.f.g/ZR%^!vQ!{YQ%x#[Q&d#}Q&g$QR,{+YT.j-s/s!Y!jQ!n#c#p$R$d$p$u$v$w$x$y$z%e%j%p%q&`'O'g(q(|)j*o*x+w,v0gQ&X#kQ'c$oR*^'dR'l$|Q%V!mR/_.r'|_OTYZ[adnoprtxy}!P!Q!R!U!X!c!d!e!f!g!h!i!k!o!p!q!s!t!z#O#S#T#[#d#g#x#y#{#}$Q$e$g$h$j$q$}%S%Z%^%`%c%g%l%n%w%|&O&Z&_&h&j&k&u&x&|'P'W'Z'l'm'p'r's'w'|(O(S(W(](^(d(g(p(r(z(})^)e)g)k)l)p)t)z*O*Y*d*g*h*k*q*r*t*v*y*z*}+Q+U+V+Y+a+c+d+k+x+y,P,X,Y,],g,h,i,k,l,o,q,s,u,w,y,z-O-d-f-m-p-s.f.g/V/Z/s0c0d0e0f0h0i0j0k0l0n0rS#a_#b!P.[-l.^._.`.a.t.z.|/R/j/o/t/u/y/z0S0U0W0Z0[0^0_0`'|_OTYZ[adnoprtxy}!P!Q!R!U!X!c!d!e!f!g!h!i!k!o!p!q!s!t!z#O#S#T#[#d#g#x#y#{#}$Q$e$g$h$j$q$}%S%Z%^%`%c%g%l%n%w%|&O&Z&_&h&j&k&u&x&|'P'W'Z'l'm'p'r's'w'|(O(S(W(](^(d(g(p(r(z(})^)e)g)k)l)p)t)z*O*Y*d*g*h*k*q*r*t*v*y*z*}+Q+U+V+Y+a+c+d+k+x+y,P,X,Y,],g,h,i,k,l,o,q,s,u,w,y,z-O-d-f-m-p-s.f.g/V/Z/s0c0d0e0f0h0i0j0k0l0n0rT#a_#bT#^^#_R(o%xa(l%x(n(o+`,{-y-z.oT+[(k+]R-z,{Q$PsQ+l)aQ,^*RR-e,_X#}s$O$P&fQ&y$aQ'a$nQ'd$oR)s'SQ)b&wV-S+m-T-{ZgOn$j)t,PXkOn)t,PQ$k!TQ&z$bQ&{$cQ'^$mQ'b$oQ)q'RQ)x'WQ){'XQ)|'YQ*Z'`S*]'c'dQ+s)gQ+u)hQ+v)iQ+z)oS+|)r*[Q,Q)vQ,R)wS,S)y)zQ,d*^Q-V+rQ-W+tQ-Y+{S-Z+},OQ-`,UQ-b,VQ-|-XQ.O-[Q.P-^Q.Q-_Q.p-}Q.q.RQ/W.dR/r/XWkOn)t,PR#mjQ'`$nS)r'S'aR,O)sQ,]*RR-f,^Q*['`Q+})rR-[,OZiOjn)t,PQ'f$pR*`'gT-j,e-ku.c-l.^._.a.t.z.|/R/j/o/t/u/y0S0U0Z0[0^t.c-l.^._.a.t.z.|/R/j/o/t/u/y0S0U0Z0[0^Q/S.`X0V/z0W0_0`!P.Z-l.^._.`.a.t.z.|/R/j/o/t/u/y/z0S0U0W0Z0[0^0_0`Q.w.YR/f.xg.z.].{/b/i/n/|0O0Q0]0a0bu.b-l.^._.a.t.z.|/R/j/o/t/u/y0S0U0Z0[0^X.u.W.b/a0PR/c.tV0R/u0S0[R/X.dQnOS#on,PR,P)tQ&^#uR(x&^S%m#R#wS(_%m(bT(b%p&`Q%a!yQ%h!}W(P%a%h(U(YQ(U%eR(Y%jQ&i$RR)O&iQ(e%qQ*{(`T+R(e*{Q'n%OR*e'nS'q%R%SY*i'q*j,m-q.hU*j'r's'tU,m*k*l*mS-q,n,oR.h-rQ#Y]R%t#YQ#_^R%y#_Q(h%vS+W(h+XR+X(iQ+](kR,|+]Q#b_R%{#bQ#ebQ%}#cW&Q#e%}({+bQ({&cR+b0gQ$OsS&e$O&fR&f$PQ&v$_R)_&vQ&V#jR(t&VQ&m$VS)T&m+hR+h)UQ$Z{R&p$ZQ&t$]R)[&tQ+n)bR-U+nQ#hfR&S#hQ)f&zR+q)fQ&}$dS)m&})nR)n'OQ'V$kR)u'VQ'[$lS*P'[,ZR,Z*QQ,a*VR-i,aWjOn)t,PR#ljQ-k,eR.U-kd.{.]/b/i/n/|0O0Q0]0a0bR/h.{U.s.W/a0PR/`.sQ/{/nS0X/{0YR0Y/|S/v/b/cR0T/vQ.}.]R/k.}R!ZPXmOn)t,PWlOn)t,PR'T$jYfOn$j)t,PR&R#g[sOn#g$j)t,PR&d#}&dQOYZ[dnprxy}!P!Q!U!i!k!o!p!q!s!t#[#d#g#y#{#}$Q$h$j$}%S%Z%^%`%g%l%n%w%|&Z&_&j&k&u&x'P'W'Z'l'm'p'r's'w(O(W(^(d(g(p(r(z)^)e)g)p)t)z*O*Y*d*g*h*k*q*r*t*v*y*z*}+U+V+Y+a+d+k,P,X,Y,],g,h,i,k,l,o,q,s,u,w,y,z-O-d-f-m-p-s.f.g/V/Z/s0c0d0e0f0h0i0j0k0n0rQ!nTQ#caQ#poU$Rt%c(SS$d!R$gQ$p!XQ$u!cQ$v!dQ$w!eQ$x!fQ$y!gQ$z!hQ%e!zQ%j#OQ%p#SQ%q#TQ&`#xQ'O$eQ'g$qQ(q&OU(|&h(}+cW)j&|)l+x+yQ*o'|Q*x(]Q+w)kQ,v+QR0g0lQ!yYQ!}ZQ$b!PQ$c!QQ%R!kQ't%S^'{%`%g(O(W*q*t*v^*f'p*h,k,l-p.g/ZQ*l'rQ*m'sQ+t)gQ,j*gQ,n*kQ-n,hQ-o,iQ-r,oQ.e-mR/Y.f[bOn#g$j)t,P!^!vYZ!P!Q!k%S%`%g'p'r's(O(W)g*g*h*k*q*t*v,h,i,k,l,o-m-p.f.g/ZQ#R[Q#fdS#wrxQ$UyW$_}$Q'P)pS$l!U$hW${!i'm*d,gS%v#[+Y`&P#d%|(p(r(z+a-O0kQ&a#yQ&b#{Q&c#}Q'j$}Q'z%^W([%l(^*y*}Q(`%nQ(i%wQ(v&ZS(y&_0iQ)P&jQ)Q&kU)]&u)^+kQ)d&xQ)y'WY)}'Z*O,X,Y-dQ*b'lS*n'w0jW+P(d*z,s,wW+T(g+V,y,zQ+p)eQ,U)zQ,c*YQ,x+UQ-P+dQ-e,]Q-v,uQ.S-fR/q/VhUOn#d#g$j%|&_'w(p(r)t,P%U!uYZ[drxy}!P!Q!U!i!k#[#y#{#}$Q$h$}%S%^%`%g%l%n%w&Z&j&k&u&x'P'W'Z'l'm'p'r's(O(W(^(d(g(z)^)e)g)p)z*O*Y*d*g*h*k*q*t*v*y*z*}+U+V+Y+a+d+k,X,Y,],g,h,i,k,l,o,s,u,w,y,z-O-d-f-m-p.f.g/V/Z0i0j0kQ#qpW%W!o!s0d0nQ%X!pQ%Y!qQ%[!tQ%f0cS'v%Z0hQ'x0eQ'y0fQ,p*rQ-u,qS.i-s/sR0p0rU#uq.k0qR(w&][cOn#g$j)t,PZ!xY#[#}$Q+YQ#W[Q#zrR$TxQ%b!yQ%i!}Q%o#RQ'j${Q(V%eQ(Z%jQ(c%pQ(f%qQ*|(`Q,f*bQ-t,pQ.m-uR/].lQ$StQ(R%cR*s(SQ.l-sR/}/sR#QZR#V[R%Q!iQ%O!iV*c'm*d,g!Z!lQ!n#c#p$R$d$p$u$v$w$x$y$z%e%j%p%q&`'O'g(q(|)j*o*x+w,v0gR%T!kT#]^#_Q%x#[R,{+YQ(m%xS+_(n(oQ,}+`Q-x,{S.n-y-zR/^.oT+Z(k+]Q$`}Q&g$QQ)o'PR+{)pQ$XzQ)W&qR+i)XQ$XzQ&o$WQ)W&qR+i)XQ#khW$Vz$W&q)XQ$[{Q&r$ZZ)R&l)S+f+g-RR$^|R)c&wXlOn)t,PQ$f!RR'Q$gQ$m!UR'R$hR*X'_Q*V'_V-g,`-h.TQ.d-lQ/P.^R/Q._U.]-l.^._Q/U.aQ/b.tQ/g.zU/i.|/j/yQ/n/RQ/|/oQ0O/tU0Q/u0S0[Q0]0UQ0a0ZR0b0^R/T.`R/d.t",
    nodeNames: "\u26A0 print Escape { Comment Script AssignStatement * BinaryExpression BitOp BitOp BitOp BitOp ArithOp ArithOp @ ArithOp ** UnaryExpression ArithOp BitOp AwaitExpression await ) ( ParenthesizedExpression BinaryExpression or and CompareOp in not is UnaryExpression ConditionalExpression if else LambdaExpression lambda ParamList VariableName AssignOp , : NamedExpression AssignOp YieldExpression yield from TupleExpression ComprehensionExpression async for LambdaExpression ] [ ArrayExpression ArrayComprehensionExpression } { DictionaryExpression DictionaryComprehensionExpression SetExpression SetComprehensionExpression CallExpression ArgList AssignOp MemberExpression . PropertyName Number String FormatString FormatReplacement FormatSelfDoc FormatConversion FormatSpec FormatReplacement FormatSelfDoc ContinuedString Ellipsis None Boolean TypeDef AssignOp UpdateStatement UpdateOp ExpressionStatement DeleteStatement del PassStatement pass BreakStatement break ContinueStatement continue ReturnStatement return YieldStatement PrintStatement RaiseStatement raise ImportStatement import as ScopeStatement global nonlocal AssertStatement assert TypeDefinition type TypeParamList TypeParam StatementGroup ; IfStatement Body elif WhileStatement while ForStatement TryStatement try except finally WithStatement with FunctionDefinition def ParamList AssignOp TypeDef ClassDefinition class DecoratedStatement Decorator At MatchStatement match MatchBody MatchClause case CapturePattern LiteralPattern ArithOp ArithOp AsPattern OrPattern LogicOp AttributePattern SequencePattern MappingPattern StarPattern ClassPattern PatternArgList KeywordPattern KeywordPattern Guard",
    maxTerm: 277,
    context: $48d37ad5e67ad3e0$var$trackIndent,
    nodeProps: [
        [
            "isolate",
            -5,
            4,
            71,
            72,
            73,
            77,
            ""
        ],
        [
            "group",
            -15,
            6,
            85,
            87,
            88,
            90,
            92,
            94,
            96,
            98,
            99,
            100,
            102,
            105,
            108,
            110,
            "Statement Statement",
            -22,
            8,
            18,
            21,
            25,
            40,
            49,
            50,
            56,
            57,
            60,
            61,
            62,
            63,
            64,
            67,
            70,
            71,
            72,
            79,
            80,
            81,
            82,
            "Expression",
            -10,
            114,
            116,
            119,
            121,
            122,
            126,
            128,
            133,
            135,
            138,
            "Statement",
            -9,
            143,
            144,
            147,
            148,
            150,
            151,
            152,
            153,
            154,
            "Pattern"
        ],
        [
            "openedBy",
            23,
            "(",
            54,
            "[",
            58,
            "{"
        ],
        [
            "closedBy",
            24,
            ")",
            55,
            "]",
            59,
            "}"
        ]
    ],
    propSources: [
        $48d37ad5e67ad3e0$var$pythonHighlighting
    ],
    skippedNodes: [
        0,
        4
    ],
    repeatNodeCount: 34,
    tokenData: "!2|~R!`OX%TXY%oY[%T[]%o]p%Tpq%oqr'ars)Yst*xtu%Tuv,dvw-hwx.Uxy/tyz0[z{0r{|2S|}2p}!O3W!O!P4_!P!Q:Z!Q!R;k!R![>_![!]Do!]!^Es!^!_FZ!_!`Gk!`!aHX!a!b%T!b!cIf!c!dJU!d!eK^!e!hJU!h!i!#f!i!tJU!t!u!,|!u!wJU!w!x!.t!x!}JU!}#O!0S#O#P&o#P#Q!0j#Q#R!1Q#R#SJU#S#T%T#T#UJU#U#VK^#V#YJU#Y#Z!#f#Z#fJU#f#g!,|#g#iJU#i#j!.t#j#oJU#o#p!1n#p#q!1s#q#r!2a#r#s!2f#s$g%T$g;'SJU;'S;=`KW<%lOJU`%YT&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%T`%lP;=`<%l%To%v]&n`%c_OX%TXY%oY[%T[]%o]p%Tpq%oq#O%T#O#P&o#P#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%To&tX&n`OY%TYZ%oZ]%T]^%o^#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tc'f[&n`O!_%T!_!`([!`#T%T#T#U(r#U#f%T#f#g(r#g#h(r#h#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tc(cTmR&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tc(yT!mR&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk)aV&n`&[ZOr%Trs)vs#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk){V&n`Or%Trs*bs#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk*iT&n`&^ZO#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%To+PZS_&n`OY*xYZ%TZ]*x]^%T^#o*x#o#p+r#p#q*x#q#r+r#r;'S*x;'S;=`,^<%lO*x_+wTS_OY+rZ]+r^;'S+r;'S;=`,W<%lO+r_,ZP;=`<%l+ro,aP;=`<%l*xj,kV%rQ&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tj-XT!xY&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tj-oV%lQ&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk.]V&n`&ZZOw%Twx.rx#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk.wV&n`Ow%Twx/^x#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk/eT&n`&]ZO#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk/{ThZ&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tc0cTgR&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk0yXVZ&n`Oz%Tz{1f{!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk1mVaR&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk2ZV%oZ&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tc2wTzR&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%To3_W%pZ&n`O!_%T!_!`-Q!`!a3w!a#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Td4OT&{S&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk4fX!fQ&n`O!O%T!O!P5R!P!Q%T!Q![6T![#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk5WV&n`O!O%T!O!P5m!P#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk5tT!rZ&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti6[a!hX&n`O!Q%T!Q![6T![!g%T!g!h7a!h!l%T!l!m9s!m#R%T#R#S6T#S#X%T#X#Y7a#Y#^%T#^#_9s#_#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti7fZ&n`O{%T{|8X|}%T}!O8X!O!Q%T!Q![8s![#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti8^V&n`O!Q%T!Q![8s![#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti8z]!hX&n`O!Q%T!Q![8s![!l%T!l!m9s!m#R%T#R#S8s#S#^%T#^#_9s#_#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti9zT!hX&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk:bX%qR&n`O!P%T!P!Q:}!Q!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tj;UV%sQ&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti;ro!hX&n`O!O%T!O!P=s!P!Q%T!Q![>_![!d%T!d!e?q!e!g%T!g!h7a!h!l%T!l!m9s!m!q%T!q!rA]!r!z%T!z!{Bq!{#R%T#R#S>_#S#U%T#U#V?q#V#X%T#X#Y7a#Y#^%T#^#_9s#_#c%T#c#dA]#d#l%T#l#mBq#m#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti=xV&n`O!Q%T!Q![6T![#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti>fc!hX&n`O!O%T!O!P=s!P!Q%T!Q![>_![!g%T!g!h7a!h!l%T!l!m9s!m#R%T#R#S>_#S#X%T#X#Y7a#Y#^%T#^#_9s#_#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti?vY&n`O!Q%T!Q!R@f!R!S@f!S#R%T#R#S@f#S#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti@mY!hX&n`O!Q%T!Q!R@f!R!S@f!S#R%T#R#S@f#S#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TiAbX&n`O!Q%T!Q!YA}!Y#R%T#R#SA}#S#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TiBUX!hX&n`O!Q%T!Q!YA}!Y#R%T#R#SA}#S#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TiBv]&n`O!Q%T!Q![Co![!c%T!c!iCo!i#R%T#R#SCo#S#T%T#T#ZCo#Z#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TiCv]!hX&n`O!Q%T!Q![Co![!c%T!c!iCo!i#R%T#R#SCo#S#T%T#T#ZCo#Z#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%ToDvV{_&n`O!_%T!_!`E]!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TcEdT%{R&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TkEzT#gZ&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TkFbXmR&n`O!^%T!^!_F}!_!`([!`!a([!a#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TjGUV%mQ&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TkGrV%zZ&n`O!_%T!_!`([!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TkH`WmR&n`O!_%T!_!`([!`!aHx!a#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TjIPV%nQ&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TkIoV_Q#}P&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%ToJ_]&n`&YS%uZO!Q%T!Q![JU![!c%T!c!}JU!}#R%T#R#SJU#S#T%T#T#oJU#p#q%T#r$g%T$g;'SJU;'S;=`KW<%lOJUoKZP;=`<%lJUoKge&n`&YS%uZOr%Trs)Ysw%Twx.Ux!Q%T!Q![JU![!c%T!c!tJU!t!uLx!u!}JU!}#R%T#R#SJU#S#T%T#T#fJU#f#gLx#g#oJU#p#q%T#r$g%T$g;'SJU;'S;=`KW<%lOJUoMRa&n`&YS%uZOr%TrsNWsw%Twx! vx!Q%T!Q![JU![!c%T!c!}JU!}#R%T#R#SJU#S#T%T#T#oJU#p#q%T#r$g%T$g;'SJU;'S;=`KW<%lOJUkN_V&n`&`ZOr%TrsNts#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TkNyV&n`Or%Trs! `s#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk! gT&n`&bZO#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk! }V&n`&_ZOw%Twx!!dx#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!!iV&n`Ow%Twx!#Ox#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!#VT&n`&aZO#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%To!#oe&n`&YS%uZOr%Trs!%Qsw%Twx!&px!Q%T!Q![JU![!c%T!c!tJU!t!u!(`!u!}JU!}#R%T#R#SJU#S#T%T#T#fJU#f#g!(`#g#oJU#p#q%T#r$g%T$g;'SJU;'S;=`KW<%lOJUk!%XV&n`&dZOr%Trs!%ns#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!%sV&n`Or%Trs!&Ys#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!&aT&n`&fZO#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!&wV&n`&cZOw%Twx!'^x#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!'cV&n`Ow%Twx!'xx#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!(PT&n`&eZO#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%To!(ia&n`&YS%uZOr%Trs!)nsw%Twx!+^x!Q%T!Q![JU![!c%T!c!}JU!}#R%T#R#SJU#S#T%T#T#oJU#p#q%T#r$g%T$g;'SJU;'S;=`KW<%lOJUk!)uV&n`&hZOr%Trs!*[s#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!*aV&n`Or%Trs!*vs#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!*}T&n`&jZO#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!+eV&n`&gZOw%Twx!+zx#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!,PV&n`Ow%Twx!,fx#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!,mT&n`&iZO#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%To!-Vi&n`&YS%uZOr%TrsNWsw%Twx! vx!Q%T!Q![JU![!c%T!c!dJU!d!eLx!e!hJU!h!i!(`!i!}JU!}#R%T#R#SJU#S#T%T#T#UJU#U#VLx#V#YJU#Y#Z!(`#Z#oJU#p#q%T#r$g%T$g;'SJU;'S;=`KW<%lOJUo!.}a&n`&YS%uZOr%Trs)Ysw%Twx.Ux!Q%T!Q![JU![!c%T!c!}JU!}#R%T#R#SJU#S#T%T#T#oJU#p#q%T#r$g%T$g;'SJU;'S;=`KW<%lOJUk!0ZT!XZ&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tc!0qT!WR&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tj!1XV%kQ&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%T~!1sO!]~k!1zV%jR&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%T~!2fO![~i!2mT%tX&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%T",
    tokenizers: [
        $48d37ad5e67ad3e0$var$legacyPrint,
        $48d37ad5e67ad3e0$var$indentation,
        $48d37ad5e67ad3e0$var$newlines,
        $48d37ad5e67ad3e0$var$strings,
        0,
        1,
        2,
        3,
        4
    ],
    topRules: {
        "Script": [
            0,
            5
        ]
    },
    specialized: [
        {
            term: 221,
            get: (value)=>$48d37ad5e67ad3e0$var$spec_identifier[value] || -1
        }
    ],
    tokenPrec: 7668
});





const $9b279a52b78ce875$var$cache = /*@__PURE__*/ new (0, $a7a41eb5193c1110$export$7f13b5dc44c541ae)();
const $9b279a52b78ce875$var$ScopeNodes = /*@__PURE__*/ new Set([
    "Script",
    "Body",
    "FunctionDefinition",
    "ClassDefinition",
    "LambdaExpression",
    "ForStatement",
    "MatchClause"
]);
function $9b279a52b78ce875$var$defID(type) {
    return (node, def, outer)=>{
        if (outer) return false;
        let id = node.node.getChild("VariableName");
        if (id) def(id, type);
        return true;
    };
}
const $9b279a52b78ce875$var$gatherCompletions = {
    FunctionDefinition: /*@__PURE__*/ $9b279a52b78ce875$var$defID("function"),
    ClassDefinition: /*@__PURE__*/ $9b279a52b78ce875$var$defID("class"),
    ForStatement (node, def, outer) {
        if (outer) for(let child = node.node.firstChild; child; child = child.nextSibling){
            if (child.name == "VariableName") def(child, "variable");
            else if (child.name == "in") break;
        }
    },
    ImportStatement (_node, def) {
        var _a, _b;
        let { node: node } = _node;
        let isFrom = ((_a = node.firstChild) === null || _a === void 0 ? void 0 : _a.name) == "from";
        for(let ch = node.getChild("import"); ch; ch = ch.nextSibling)if (ch.name == "VariableName" && ((_b = ch.nextSibling) === null || _b === void 0 ? void 0 : _b.name) != "as") def(ch, isFrom ? "variable" : "namespace");
    },
    AssignStatement (node, def) {
        for(let child = node.node.firstChild; child; child = child.nextSibling){
            if (child.name == "VariableName") def(child, "variable");
            else if (child.name == ":" || child.name == "AssignOp") break;
        }
    },
    ParamList (node, def) {
        for(let prev = null, child = node.node.firstChild; child; child = child.nextSibling){
            if (child.name == "VariableName" && (!prev || !/\*|AssignOp/.test(prev.name))) def(child, "variable");
            prev = child;
        }
    },
    CapturePattern: /*@__PURE__*/ $9b279a52b78ce875$var$defID("variable"),
    AsPattern: /*@__PURE__*/ $9b279a52b78ce875$var$defID("variable"),
    __proto__: null
};
function $9b279a52b78ce875$var$getScope(doc, node) {
    let cached = $9b279a52b78ce875$var$cache.get(node);
    if (cached) return cached;
    let completions = [], top = true;
    function def(node, type) {
        let name = doc.sliceString(node.from, node.to);
        completions.push({
            label: name,
            type: type
        });
    }
    node.cursor((0, $a7a41eb5193c1110$export$b0e28367f55837aa).IncludeAnonymous).iterate((node)=>{
        if (node.name) {
            let gather = $9b279a52b78ce875$var$gatherCompletions[node.name];
            if (gather && gather(node, def, top) || !top && $9b279a52b78ce875$var$ScopeNodes.has(node.name)) return false;
            top = false;
        } else if (node.to - node.from > 8192) {
            // Allow caching for bigger internal nodes
            for (let c of $9b279a52b78ce875$var$getScope(doc, node.node))completions.push(c);
            return false;
        }
    });
    $9b279a52b78ce875$var$cache.set(node, completions);
    return completions;
}
const $9b279a52b78ce875$var$Identifier = /^[\w\xa1-\uffff][\w\d\xa1-\uffff]*$/;
const $9b279a52b78ce875$var$dontComplete = [
    "String",
    "FormatString",
    "Comment",
    "PropertyName"
];
/**
Completion source that looks up locally defined names in
Python code.
*/ function $9b279a52b78ce875$export$a2e0a5b87b9b861c(context) {
    let inner = (0, $deda11ebd5d0815e$export$7fc98e56a4ca6be1)(context.state).resolveInner(context.pos, -1);
    if ($9b279a52b78ce875$var$dontComplete.indexOf(inner.name) > -1) return null;
    let isWord = inner.name == "VariableName" || inner.to - inner.from < 20 && $9b279a52b78ce875$var$Identifier.test(context.state.sliceDoc(inner.from, inner.to));
    if (!isWord && !context.explicit) return null;
    let options = [];
    for(let pos = inner; pos; pos = pos.parent)if ($9b279a52b78ce875$var$ScopeNodes.has(pos.name)) options = options.concat($9b279a52b78ce875$var$getScope(context.state.doc, pos));
    return {
        options: options,
        from: isWord ? inner.from : context.pos,
        validFor: $9b279a52b78ce875$var$Identifier
    };
}
const $9b279a52b78ce875$var$globals = /*@__PURE__*/ [
    "__annotations__",
    "__builtins__",
    "__debug__",
    "__doc__",
    "__import__",
    "__name__",
    "__loader__",
    "__package__",
    "__spec__",
    "False",
    "None",
    "True"
].map((n)=>({
        label: n,
        type: "constant"
    })).concat(/*@__PURE__*/ [
    "ArithmeticError",
    "AssertionError",
    "AttributeError",
    "BaseException",
    "BlockingIOError",
    "BrokenPipeError",
    "BufferError",
    "BytesWarning",
    "ChildProcessError",
    "ConnectionAbortedError",
    "ConnectionError",
    "ConnectionRefusedError",
    "ConnectionResetError",
    "DeprecationWarning",
    "EOFError",
    "Ellipsis",
    "EncodingWarning",
    "EnvironmentError",
    "Exception",
    "FileExistsError",
    "FileNotFoundError",
    "FloatingPointError",
    "FutureWarning",
    "GeneratorExit",
    "IOError",
    "ImportError",
    "ImportWarning",
    "IndentationError",
    "IndexError",
    "InterruptedError",
    "IsADirectoryError",
    "KeyError",
    "KeyboardInterrupt",
    "LookupError",
    "MemoryError",
    "ModuleNotFoundError",
    "NameError",
    "NotADirectoryError",
    "NotImplemented",
    "NotImplementedError",
    "OSError",
    "OverflowError",
    "PendingDeprecationWarning",
    "PermissionError",
    "ProcessLookupError",
    "RecursionError",
    "ReferenceError",
    "ResourceWarning",
    "RuntimeError",
    "RuntimeWarning",
    "StopAsyncIteration",
    "StopIteration",
    "SyntaxError",
    "SyntaxWarning",
    "SystemError",
    "SystemExit",
    "TabError",
    "TimeoutError",
    "TypeError",
    "UnboundLocalError",
    "UnicodeDecodeError",
    "UnicodeEncodeError",
    "UnicodeError",
    "UnicodeTranslateError",
    "UnicodeWarning",
    "UserWarning",
    "ValueError",
    "Warning",
    "ZeroDivisionError"
].map((n)=>({
        label: n,
        type: "type"
    }))).concat(/*@__PURE__*/ [
    "bool",
    "bytearray",
    "bytes",
    "classmethod",
    "complex",
    "float",
    "frozenset",
    "int",
    "list",
    "map",
    "memoryview",
    "object",
    "range",
    "set",
    "staticmethod",
    "str",
    "super",
    "tuple",
    "type"
].map((n)=>({
        label: n,
        type: "class"
    }))).concat(/*@__PURE__*/ [
    "abs",
    "aiter",
    "all",
    "anext",
    "any",
    "ascii",
    "bin",
    "breakpoint",
    "callable",
    "chr",
    "compile",
    "delattr",
    "dict",
    "dir",
    "divmod",
    "enumerate",
    "eval",
    "exec",
    "exit",
    "filter",
    "format",
    "getattr",
    "globals",
    "hasattr",
    "hash",
    "help",
    "hex",
    "id",
    "input",
    "isinstance",
    "issubclass",
    "iter",
    "len",
    "license",
    "locals",
    "max",
    "min",
    "next",
    "oct",
    "open",
    "ord",
    "pow",
    "print",
    "property",
    "quit",
    "repr",
    "reversed",
    "round",
    "setattr",
    "slice",
    "sorted",
    "sum",
    "vars",
    "zip"
].map((n)=>({
        label: n,
        type: "function"
    })));
const $9b279a52b78ce875$var$snippets = [
    /*@__PURE__*/ (0, $3f3985386ff18e5c$export$975ef56e648d23ad)("def ${name}(${params}):\n\t${}", {
        label: "def",
        detail: "function",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $3f3985386ff18e5c$export$975ef56e648d23ad)("for ${name} in ${collection}:\n\t${}", {
        label: "for",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $3f3985386ff18e5c$export$975ef56e648d23ad)("while ${}:\n\t${}", {
        label: "while",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $3f3985386ff18e5c$export$975ef56e648d23ad)("try:\n\t${}\nexcept ${error}:\n\t${}", {
        label: "try",
        detail: "/ except block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $3f3985386ff18e5c$export$975ef56e648d23ad)("if ${}:\n\t\n", {
        label: "if",
        detail: "block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $3f3985386ff18e5c$export$975ef56e648d23ad)("if ${}:\n\t${}\nelse:\n\t${}", {
        label: "if",
        detail: "/ else block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $3f3985386ff18e5c$export$975ef56e648d23ad)("class ${name}:\n\tdef __init__(self, ${params}):\n\t\t\t${}", {
        label: "class",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $3f3985386ff18e5c$export$975ef56e648d23ad)("import ${module}", {
        label: "import",
        detail: "statement",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $3f3985386ff18e5c$export$975ef56e648d23ad)("from ${module} import ${names}", {
        label: "from",
        detail: "import",
        type: "keyword"
    })
];
/**
Autocompletion for built-in Python globals and keywords.
*/ const $9b279a52b78ce875$export$e6aacc8077e6ec50 = /*@__PURE__*/ (0, $3f3985386ff18e5c$export$1dfdaeb1e91714c0)($9b279a52b78ce875$var$dontComplete, /*@__PURE__*/ (0, $3f3985386ff18e5c$export$db0ee7d2648a0c4b)(/*@__PURE__*/ $9b279a52b78ce875$var$globals.concat($9b279a52b78ce875$var$snippets)));
function $9b279a52b78ce875$var$innerBody(context) {
    let { node: node, pos: pos } = context;
    let lineIndent = context.lineIndent(pos, -1);
    let found = null;
    for(;;){
        let before = node.childBefore(pos);
        if (!before) break;
        else if (before.name == "Comment") pos = before.from;
        else if (before.name == "Body" || before.name == "MatchBody") {
            if (context.baseIndentFor(before) + context.unit <= lineIndent) found = before;
            node = before;
        } else if (before.name == "MatchClause") node = before;
        else if (before.type.is("Statement")) node = before;
        else break;
    }
    return found;
}
function $9b279a52b78ce875$var$indentBody(context, node) {
    let base = context.baseIndentFor(node);
    let line = context.lineAt(context.pos, -1), to = line.from + line.text.length;
    // Don't consider blank, deindented lines at the end of the
    // block part of the block
    if (/^\s*($|#)/.test(line.text) && context.node.to < to + 100 && !/\S/.test(context.state.sliceDoc(to, context.node.to)) && context.lineIndent(context.pos, -1) <= base) return null;
    // A normally deindenting keyword that appears at a higher
    // indentation than the block should probably be handled by the next
    // level
    if (/^\s*(else:|elif |except |finally:|case\s+[^=:]+:)/.test(context.textAfter) && context.lineIndent(context.pos, -1) > base) return null;
    return base + context.unit;
}
/**
A language provider based on the [Lezer Python
parser](https://github.com/lezer-parser/python), extended with
highlighting and indentation information.
*/ const $9b279a52b78ce875$export$14a84ed53f00030d = /*@__PURE__*/ (0, $deda11ebd5d0815e$export$b243968d9fb6db03).define({
    name: "python",
    parser: /*@__PURE__*/ (0, $48d37ad5e67ad3e0$export$8f49e4af10703ce3).configure({
        props: [
            /*@__PURE__*/ (0, $deda11ebd5d0815e$export$72c7d4c52b3c6460).add({
                Body: (context)=>{
                    var _a;
                    let body = /^\s*(#|$)/.test(context.textAfter) && $9b279a52b78ce875$var$innerBody(context) || context.node;
                    return (_a = $9b279a52b78ce875$var$indentBody(context, body)) !== null && _a !== void 0 ? _a : context.continue();
                },
                MatchBody: (context)=>{
                    var _a;
                    let inner = $9b279a52b78ce875$var$innerBody(context);
                    return (_a = $9b279a52b78ce875$var$indentBody(context, inner || context.node)) !== null && _a !== void 0 ? _a : context.continue();
                },
                IfStatement: (cx)=>/^\s*(else:|elif )/.test(cx.textAfter) ? cx.baseIndent : cx.continue(),
                "ForStatement WhileStatement": (cx)=>/^\s*else:/.test(cx.textAfter) ? cx.baseIndent : cx.continue(),
                TryStatement: (cx)=>/^\s*(except[ :]|finally:|else:)/.test(cx.textAfter) ? cx.baseIndent : cx.continue(),
                MatchStatement: (cx)=>{
                    if (/^\s*case /.test(cx.textAfter)) return cx.baseIndent + cx.unit;
                    return cx.continue();
                },
                "TupleExpression ComprehensionExpression ParamList ArgList ParenthesizedExpression": /*@__PURE__*/ (0, $deda11ebd5d0815e$export$60e82ea306899488)({
                    closing: ")"
                }),
                "DictionaryExpression DictionaryComprehensionExpression SetExpression SetComprehensionExpression": /*@__PURE__*/ (0, $deda11ebd5d0815e$export$60e82ea306899488)({
                    closing: "}"
                }),
                "ArrayExpression ArrayComprehensionExpression": /*@__PURE__*/ (0, $deda11ebd5d0815e$export$60e82ea306899488)({
                    closing: "]"
                }),
                MemberExpression: (cx)=>cx.baseIndent + cx.unit,
                "String FormatString": ()=>null,
                Script: (context)=>{
                    var _a;
                    let inner = $9b279a52b78ce875$var$innerBody(context);
                    return (_a = inner && $9b279a52b78ce875$var$indentBody(context, inner)) !== null && _a !== void 0 ? _a : context.continue();
                }
            }),
            /*@__PURE__*/ (0, $deda11ebd5d0815e$export$9b075a85eb4377d8).add({
                "ArrayExpression DictionaryExpression SetExpression TupleExpression": (0, $deda11ebd5d0815e$export$48672beae16a681b),
                Body: (node, state)=>({
                        from: node.from + 1,
                        to: node.to - (node.to == state.doc.length ? 0 : 1)
                    }),
                "String FormatString": (node, state)=>({
                        from: state.doc.lineAt(node.from).to,
                        to: node.to
                    })
            })
        ]
    }),
    languageData: {
        closeBrackets: {
            brackets: [
                "(",
                "[",
                "{",
                "'",
                '"',
                "'''",
                '"""'
            ],
            stringPrefixes: [
                "f",
                "fr",
                "rf",
                "r",
                "u",
                "b",
                "br",
                "rb",
                "F",
                "FR",
                "RF",
                "R",
                "U",
                "B",
                "BR",
                "RB"
            ]
        },
        commentTokens: {
            line: "#"
        },
        // Indent logic logic are triggered upon below input patterns
        indentOnInput: /^\s*([\}\]\)]|else:|elif |except |finally:|case\s+[^:]*:?)$/
    }
});
/**
Python language support.
*/ function $9b279a52b78ce875$export$3ccdad7705c71630() {
    return new (0, $deda11ebd5d0815e$export$cbdefefa8a51dd3b)($9b279a52b78ce875$export$14a84ed53f00030d, [
        $9b279a52b78ce875$export$14a84ed53f00030d.data.of({
            autocomplete: $9b279a52b78ce875$export$a2e0a5b87b9b861c
        }),
        $9b279a52b78ce875$export$14a84ed53f00030d.data.of({
            autocomplete: $9b279a52b78ce875$export$e6aacc8077e6ec50
        })
    ]);
}






var $7Do5B = parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");



function $8f75f835f3f62d38$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), o.forEach(function(r) {
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(e, r, t[r]);
        });
    }
    return e;
}









parcelRequire("7ikhG");
var $7Do5B = parcelRequire("7Do5B");

var $7ikhG = parcelRequire("7ikhG");
var $fb89ab44c0e57c1a$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $fb89ab44c0e57c1a$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$fb89ab44c0e57c1a$exports = $fb89ab44c0e57c1a$var$invariant;




var $8e849631b7a8ddb1$var$Manager = function() {
    function Manager() {
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, Manager);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(this, "refs", {});
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(Manager, [
        {
            key: "add",
            value: function add(collection, ref) {
                if (!this.refs[collection]) this.refs[collection] = [];
                this.refs[collection].push(ref);
            }
        },
        {
            key: "remove",
            value: function remove(collection, ref) {
                var index = this.getIndex(collection, ref);
                if (index !== -1) this.refs[collection].splice(index, 1);
            }
        },
        {
            key: "isActive",
            value: function isActive() {
                return this.active;
            }
        },
        {
            key: "getActive",
            value: function getActive() {
                var _this = this;
                return this.refs[this.active.collection].find(function(_ref) {
                    var node = _ref.node;
                    return node.sortableInfo.index == _this.active.index;
                });
            }
        },
        {
            key: "getIndex",
            value: function getIndex(collection, ref) {
                return this.refs[collection].indexOf(ref);
            }
        },
        {
            key: "getOrderedRefs",
            value: function getOrderedRefs() {
                var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;
                return this.refs[collection].sort($8e849631b7a8ddb1$var$sortByIndex);
            }
        }
    ]);
    return Manager;
}();
function $8e849631b7a8ddb1$var$sortByIndex(_ref2, _ref3) {
    var index1 = _ref2.node.sortableInfo.index;
    var index2 = _ref3.node.sortableInfo.index;
    return index1 - index2;
}
function $8e849631b7a8ddb1$export$5d49d615ad5ea2b0(array, from, to) {
    array = array.slice();
    array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
    return array;
}
function $8e849631b7a8ddb1$var$omit(obj, keysToOmit) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
        return acc;
    }, {});
}
var $8e849631b7a8ddb1$var$events = {
    end: [
        'touchend',
        'touchcancel',
        'mouseup'
    ],
    move: [
        'touchmove',
        'mousemove'
    ],
    start: [
        'touchstart',
        'mousedown'
    ]
};
var $8e849631b7a8ddb1$var$vendorPrefix = function() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return '';
    var styles = window.getComputedStyle(document.documentElement, '') || [
        '-moz-hidden-iframe'
    ];
    var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && [
        '',
        'o'
    ])[1];
    switch(pre){
        case 'ms':
            return 'ms';
        default:
            return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
    }
}();
function $8e849631b7a8ddb1$var$setInlineStyles(node, styles) {
    Object.keys(styles).forEach(function(key) {
        node.style[key] = styles[key];
    });
}
function $8e849631b7a8ddb1$var$setTranslate3d(node, translate) {
    node.style["".concat($8e849631b7a8ddb1$var$vendorPrefix, "Transform")] = translate == null ? '' : "translate3d(".concat(translate.x, "px,").concat(translate.y, "px,0)");
}
function $8e849631b7a8ddb1$var$setTransitionDuration(node, duration) {
    node.style["".concat($8e849631b7a8ddb1$var$vendorPrefix, "TransitionDuration")] = duration == null ? '' : "".concat(duration, "ms");
}
function $8e849631b7a8ddb1$var$closest(el, fn) {
    while(el){
        if (fn(el)) return el;
        el = el.parentNode;
    }
    return null;
}
function $8e849631b7a8ddb1$var$limit(min, max, value1) {
    return Math.max(min, Math.min(value1, max));
}
function $8e849631b7a8ddb1$var$getPixelValue(stringValue) {
    if (stringValue.substr(-2) === 'px') return parseFloat(stringValue);
    return 0;
}
function $8e849631b7a8ddb1$var$getElementMargin(element) {
    var style = window.getComputedStyle(element);
    return {
        bottom: $8e849631b7a8ddb1$var$getPixelValue(style.marginBottom),
        left: $8e849631b7a8ddb1$var$getPixelValue(style.marginLeft),
        right: $8e849631b7a8ddb1$var$getPixelValue(style.marginRight),
        top: $8e849631b7a8ddb1$var$getPixelValue(style.marginTop)
    };
}
function $8e849631b7a8ddb1$var$provideDisplayName(prefix, Component$$1) {
    var componentName = Component$$1.displayName || Component$$1.name;
    return componentName ? "".concat(prefix, "(").concat(componentName, ")") : prefix;
}
function $8e849631b7a8ddb1$var$getScrollAdjustedBoundingClientRect(node, scrollDelta) {
    var boundingClientRect = node.getBoundingClientRect();
    return {
        top: boundingClientRect.top + scrollDelta.top,
        left: boundingClientRect.left + scrollDelta.left
    };
}
function $8e849631b7a8ddb1$var$getPosition(event) {
    if (event.touches && event.touches.length) return {
        x: event.touches[0].pageX,
        y: event.touches[0].pageY
    };
    else if (event.changedTouches && event.changedTouches.length) return {
        x: event.changedTouches[0].pageX,
        y: event.changedTouches[0].pageY
    };
    else return {
        x: event.pageX,
        y: event.pageY
    };
}
function $8e849631b7a8ddb1$var$isTouchEvent(event) {
    return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
}
function $8e849631b7a8ddb1$var$getEdgeOffset(node, parent) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        left: 0,
        top: 0
    };
    if (!node) return undefined;
    var nodeOffset = {
        left: offset.left + node.offsetLeft,
        top: offset.top + node.offsetTop
    };
    if (node.parentNode === parent) return nodeOffset;
    return $8e849631b7a8ddb1$var$getEdgeOffset(node.parentNode, parent, nodeOffset);
}
function $8e849631b7a8ddb1$var$getTargetIndex(newIndex, prevIndex, oldIndex) {
    if (newIndex < oldIndex && newIndex > prevIndex) return newIndex - 1;
    else if (newIndex > oldIndex && newIndex < prevIndex) return newIndex + 1;
    else return newIndex;
}
function $8e849631b7a8ddb1$var$getLockPixelOffset(_ref) {
    var lockOffset = _ref.lockOffset, width = _ref.width, height = _ref.height;
    var offsetX = lockOffset;
    var offsetY = lockOffset;
    var unit = 'px';
    if (typeof lockOffset === 'string') {
        var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
        (0, (/*@__PURE__*/$parcel$interopDefault($fb89ab44c0e57c1a$exports)))(match !== null, 'lockOffset value should be a number or a string of a number followed by "px" or "%". Given %s', lockOffset);
        offsetX = parseFloat(lockOffset);
        offsetY = parseFloat(lockOffset);
        unit = match[1];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fb89ab44c0e57c1a$exports)))(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);
    if (unit === '%') {
        offsetX = offsetX * width / 100;
        offsetY = offsetY * height / 100;
    }
    return {
        x: offsetX,
        y: offsetY
    };
}
function $8e849631b7a8ddb1$var$getLockPixelOffsets(_ref2) {
    var height = _ref2.height, width = _ref2.width, lockOffset = _ref2.lockOffset;
    var offsets = Array.isArray(lockOffset) ? lockOffset : [
        lockOffset,
        lockOffset
    ];
    (0, (/*@__PURE__*/$parcel$interopDefault($fb89ab44c0e57c1a$exports)))(offsets.length === 2, "lockOffset prop of SortableContainer should be a single value or an array of exactly two values. Given %s", lockOffset);
    var _offsets = (0, $4a9275f4284d6709$export$2e2bcd8739ae039)(offsets, 2), minLockOffset = _offsets[0], maxLockOffset = _offsets[1];
    return [
        $8e849631b7a8ddb1$var$getLockPixelOffset({
            height: height,
            lockOffset: minLockOffset,
            width: width
        }),
        $8e849631b7a8ddb1$var$getLockPixelOffset({
            height: height,
            lockOffset: maxLockOffset,
            width: width
        })
    ];
}
function $8e849631b7a8ddb1$var$isScrollable(el) {
    var computedStyle = window.getComputedStyle(el);
    var overflowRegex = /(auto|scroll)/;
    var properties = [
        'overflow',
        'overflowX',
        'overflowY'
    ];
    return properties.find(function(property) {
        return overflowRegex.test(computedStyle[property]);
    });
}
function $8e849631b7a8ddb1$var$getScrollingParent(el) {
    if (!(el instanceof HTMLElement)) return null;
    else if ($8e849631b7a8ddb1$var$isScrollable(el)) return el;
    else return $8e849631b7a8ddb1$var$getScrollingParent(el.parentNode);
}
function $8e849631b7a8ddb1$var$getContainerGridGap(element) {
    var style = window.getComputedStyle(element);
    if (style.display === 'grid') return {
        x: $8e849631b7a8ddb1$var$getPixelValue(style.gridColumnGap),
        y: $8e849631b7a8ddb1$var$getPixelValue(style.gridRowGap)
    };
    return {
        x: 0,
        y: 0
    };
}
var $8e849631b7a8ddb1$var$KEYCODE = {
    TAB: 9,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
};
var $8e849631b7a8ddb1$var$NodeType = {
    Anchor: 'A',
    Button: 'BUTTON',
    Canvas: 'CANVAS',
    Input: 'INPUT',
    Option: 'OPTION',
    Textarea: 'TEXTAREA',
    Select: 'SELECT'
};
function $8e849631b7a8ddb1$var$cloneNode(node) {
    var selector = 'input, textarea, select, canvas, [contenteditable]';
    var fields = node.querySelectorAll(selector);
    var clonedNode = node.cloneNode(true);
    var clonedFields = (0, $e8694aff92b422dc$export$2e2bcd8739ae039)(clonedNode.querySelectorAll(selector));
    clonedFields.forEach(function(field, i) {
        if (field.type !== 'file') field.value = fields[i].value;
        if (field.type === 'radio' && field.name) field.name = "__sortableClone__".concat(field.name);
        if (field.tagName === $8e849631b7a8ddb1$var$NodeType.Canvas && fields[i].width > 0 && fields[i].height > 0) {
            var destCtx = field.getContext('2d');
            destCtx.drawImage(fields[i], 0, 0);
        }
    });
    return clonedNode;
}
function $8e849631b7a8ddb1$export$680929e2aec3ce89(WrappedComponent) {
    var _class, _temp;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        withRef: false
    };
    return _temp = _class = function(_React$Component) {
        (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(WithSortableHandle, _React$Component);
        function WithSortableHandle() {
            var _getPrototypeOf2;
            var _this;
            (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, WithSortableHandle);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = (0, $c345de07753d2fca$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(WithSortableHandle)).call.apply(_getPrototypeOf2, [
                this
            ].concat(args)));
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "wrappedInstance", (0, $7Do5B.createRef)());
            return _this;
        }
        (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(WithSortableHandle, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var node = (0, $7ikhG.findDOMNode)(this);
                    node.sortableHandle = true;
                }
            },
            {
                key: "getWrappedInstance",
                value: function getWrappedInstance() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($fb89ab44c0e57c1a$exports)))(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
                    return this.wrappedInstance.current;
                }
            },
            {
                key: "render",
                value: function render() {
                    var ref = config.withRef ? this.wrappedInstance : null;
                    return (0, $7Do5B.createElement)(WrappedComponent, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
                        ref: ref
                    }, this.props));
                }
            }
        ]);
        return WithSortableHandle;
    }((0, $7Do5B.Component)), (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(_class, "displayName", $8e849631b7a8ddb1$var$provideDisplayName('sortableHandle', WrappedComponent)), _temp;
}
function $8e849631b7a8ddb1$var$isSortableHandle(node) {
    return node.sortableHandle != null;
}
var $8e849631b7a8ddb1$var$AutoScroller = function() {
    function AutoScroller(container, onScrollCallback) {
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, AutoScroller);
        this.container = container;
        this.onScrollCallback = onScrollCallback;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(AutoScroller, [
        {
            key: "clear",
            value: function clear() {
                if (this.interval == null) return;
                clearInterval(this.interval);
                this.interval = null;
            }
        },
        {
            key: "update",
            value: function update(_ref) {
                var _this = this;
                var translate = _ref.translate, minTranslate = _ref.minTranslate, maxTranslate = _ref.maxTranslate, width = _ref.width, height = _ref.height;
                var direction = {
                    x: 0,
                    y: 0
                };
                var speed = {
                    x: 1,
                    y: 1
                };
                var acceleration = {
                    x: 10,
                    y: 10
                };
                var _this$container = this.container, scrollTop = _this$container.scrollTop, scrollLeft = _this$container.scrollLeft, scrollHeight = _this$container.scrollHeight, scrollWidth = _this$container.scrollWidth, clientHeight = _this$container.clientHeight, clientWidth = _this$container.clientWidth;
                var isTop = scrollTop === 0;
                var isBottom = scrollHeight - scrollTop - clientHeight === 0;
                var isLeft = scrollLeft === 0;
                var isRight = scrollWidth - scrollLeft - clientWidth === 0;
                if (translate.y >= maxTranslate.y - height / 2 && !isBottom) {
                    direction.y = 1;
                    speed.y = acceleration.y * Math.abs((maxTranslate.y - height / 2 - translate.y) / height);
                } else if (translate.x >= maxTranslate.x - width / 2 && !isRight) {
                    direction.x = 1;
                    speed.x = acceleration.x * Math.abs((maxTranslate.x - width / 2 - translate.x) / width);
                } else if (translate.y <= minTranslate.y + height / 2 && !isTop) {
                    direction.y = -1;
                    speed.y = acceleration.y * Math.abs((translate.y - height / 2 - minTranslate.y) / height);
                } else if (translate.x <= minTranslate.x + width / 2 && !isLeft) {
                    direction.x = -1;
                    speed.x = acceleration.x * Math.abs((translate.x - width / 2 - minTranslate.x) / width);
                }
                if (this.interval) {
                    this.clear();
                    this.isAutoScrolling = false;
                }
                if (direction.x !== 0 || direction.y !== 0) this.interval = setInterval(function() {
                    _this.isAutoScrolling = true;
                    var offset = {
                        left: speed.x * direction.x,
                        top: speed.y * direction.y
                    };
                    _this.container.scrollTop += offset.top;
                    _this.container.scrollLeft += offset.left;
                    _this.onScrollCallback(offset);
                }, 5);
            }
        }
    ]);
    return AutoScroller;
}();
function $8e849631b7a8ddb1$var$defaultGetHelperDimensions(_ref) {
    var node = _ref.node;
    return {
        height: node.offsetHeight,
        width: node.offsetWidth
    };
}
function $8e849631b7a8ddb1$var$defaultShouldCancelStart(event) {
    var interactiveElements = [
        $8e849631b7a8ddb1$var$NodeType.Input,
        $8e849631b7a8ddb1$var$NodeType.Textarea,
        $8e849631b7a8ddb1$var$NodeType.Select,
        $8e849631b7a8ddb1$var$NodeType.Option,
        $8e849631b7a8ddb1$var$NodeType.Button
    ];
    if (interactiveElements.indexOf(event.target.tagName) !== -1) return true;
    if ($8e849631b7a8ddb1$var$closest(event.target, function(el) {
        return el.contentEditable === 'true';
    })) return true;
    return false;
}
var $8e849631b7a8ddb1$var$propTypes = {
    axis: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOf([
        'x',
        'y',
        'xy'
    ]),
    contentWindow: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).any,
    disableAutoscroll: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool,
    distance: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
    getContainer: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
    getHelperDimensions: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
    helperClass: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    helperContainer: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
        typeof HTMLElement === 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).any : (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).instanceOf(HTMLElement)
    ]),
    hideSortableGhost: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool,
    keyboardSortingTransitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
    lockAxis: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    lockOffset: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string
        ]))
    ]),
    lockToContainerEdges: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool,
    onSortEnd: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
    onSortMove: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
    onSortOver: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
    onSortStart: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
    pressDelay: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
    pressThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
    keyCodes: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).shape({
        lift: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number),
        drop: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number),
        cancel: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number),
        up: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number),
        down: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number)
    }),
    shouldCancelStart: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
    transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
    updateBeforeSortStart: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).func,
    useDragHandle: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool,
    useWindowAsScrollContainer: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool
};
var $8e849631b7a8ddb1$var$defaultKeyCodes = {
    lift: [
        $8e849631b7a8ddb1$var$KEYCODE.SPACE
    ],
    drop: [
        $8e849631b7a8ddb1$var$KEYCODE.SPACE
    ],
    cancel: [
        $8e849631b7a8ddb1$var$KEYCODE.ESC
    ],
    up: [
        $8e849631b7a8ddb1$var$KEYCODE.UP,
        $8e849631b7a8ddb1$var$KEYCODE.LEFT
    ],
    down: [
        $8e849631b7a8ddb1$var$KEYCODE.DOWN,
        $8e849631b7a8ddb1$var$KEYCODE.RIGHT
    ]
};
var $8e849631b7a8ddb1$var$defaultProps = {
    axis: 'y',
    disableAutoscroll: false,
    distance: 0,
    getHelperDimensions: $8e849631b7a8ddb1$var$defaultGetHelperDimensions,
    hideSortableGhost: true,
    lockOffset: '50%',
    lockToContainerEdges: false,
    pressDelay: 0,
    pressThreshold: 5,
    keyCodes: $8e849631b7a8ddb1$var$defaultKeyCodes,
    shouldCancelStart: $8e849631b7a8ddb1$var$defaultShouldCancelStart,
    transitionDuration: 300,
    useWindowAsScrollContainer: false
};
var $8e849631b7a8ddb1$var$omittedProps = Object.keys($8e849631b7a8ddb1$var$propTypes);
function $8e849631b7a8ddb1$var$validateProps(props) {
    (0, (/*@__PURE__*/$parcel$interopDefault($fb89ab44c0e57c1a$exports)))(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');
}
function $8e849631b7a8ddb1$var$_finallyRethrows(body, finalizer) {
    try {
        var result = body();
    } catch (e) {
        return finalizer(true, e);
    }
    if (result && result.then) return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
    return finalizer(false, value);
}
var $8e849631b7a8ddb1$var$SortableContext = (0, $7Do5B.createContext)({
    manager: {}
});
function $8e849631b7a8ddb1$export$a4b10e5599330dd0(WrappedComponent) {
    var _class, _temp;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        withRef: false
    };
    return _temp = _class = function(_React$Component) {
        (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(WithSortableContainer, _React$Component);
        function WithSortableContainer(props) {
            var _this;
            (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, WithSortableContainer);
            _this = (0, $c345de07753d2fca$export$2e2bcd8739ae039)(this, (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(WithSortableContainer).call(this, props));
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "state", {});
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "handleStart", function(event) {
                var _this$props = _this.props, distance = _this$props.distance, shouldCancelStart = _this$props.shouldCancelStart;
                if (event.button === 2 || shouldCancelStart(event)) return;
                _this.touched = true;
                _this.position = $8e849631b7a8ddb1$var$getPosition(event);
                var node = $8e849631b7a8ddb1$var$closest(event.target, function(el) {
                    return el.sortableInfo != null;
                });
                if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
                    var useDragHandle = _this.props.useDragHandle;
                    var _node$sortableInfo = node.sortableInfo, index = _node$sortableInfo.index, collection = _node$sortableInfo.collection, disabled = _node$sortableInfo.disabled;
                    if (disabled) return;
                    if (useDragHandle && !$8e849631b7a8ddb1$var$closest(event.target, $8e849631b7a8ddb1$var$isSortableHandle)) return;
                    _this.manager.active = {
                        collection: collection,
                        index: index
                    };
                    if (!$8e849631b7a8ddb1$var$isTouchEvent(event) && event.target.tagName === $8e849631b7a8ddb1$var$NodeType.Anchor) event.preventDefault();
                    if (!distance) {
                        if (_this.props.pressDelay === 0) _this.handlePress(event);
                        else _this.pressTimer = setTimeout(function() {
                            return _this.handlePress(event);
                        }, _this.props.pressDelay);
                    }
                }
            });
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "nodeIsChild", function(node) {
                return node.sortableInfo.manager === _this.manager;
            });
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "handleMove", function(event) {
                var _this$props2 = _this.props, distance = _this$props2.distance, pressThreshold = _this$props2.pressThreshold;
                if (!_this.state.sorting && _this.touched && !_this._awaitingUpdateBeforeSortStart) {
                    var position = $8e849631b7a8ddb1$var$getPosition(event);
                    var delta = {
                        x: _this.position.x - position.x,
                        y: _this.position.y - position.y
                    };
                    var combinedDelta = Math.abs(delta.x) + Math.abs(delta.y);
                    _this.delta = delta;
                    if (!distance && (!pressThreshold || combinedDelta >= pressThreshold)) {
                        clearTimeout(_this.cancelTimer);
                        _this.cancelTimer = setTimeout(_this.cancel, 0);
                    } else if (distance && combinedDelta >= distance && _this.manager.isActive()) _this.handlePress(event);
                }
            });
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "handleEnd", function() {
                _this.touched = false;
                _this.cancel();
            });
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "cancel", function() {
                var distance = _this.props.distance;
                var sorting = _this.state.sorting;
                if (!sorting) {
                    if (!distance) clearTimeout(_this.pressTimer);
                    _this.manager.active = null;
                }
            });
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "handlePress", function(event) {
                try {
                    var active = _this.manager.getActive();
                    var _temp6 = function() {
                        if (active) {
                            var _temp7 = function _temp7() {
                                var index = _node.sortableInfo.index;
                                var margin = $8e849631b7a8ddb1$var$getElementMargin(_node);
                                var gridGap = $8e849631b7a8ddb1$var$getContainerGridGap(_this.container);
                                var containerBoundingRect = _this.scrollContainer.getBoundingClientRect();
                                var dimensions = _getHelperDimensions({
                                    index: index,
                                    node: _node,
                                    collection: _collection
                                });
                                _this.node = _node;
                                _this.margin = margin;
                                _this.gridGap = gridGap;
                                _this.width = dimensions.width;
                                _this.height = dimensions.height;
                                _this.marginOffset = {
                                    x: _this.margin.left + _this.margin.right + _this.gridGap.x,
                                    y: Math.max(_this.margin.top, _this.margin.bottom, _this.gridGap.y)
                                };
                                _this.boundingClientRect = _node.getBoundingClientRect();
                                _this.containerBoundingRect = containerBoundingRect;
                                _this.index = index;
                                _this.newIndex = index;
                                _this.axis = {
                                    x: _axis.indexOf('x') >= 0,
                                    y: _axis.indexOf('y') >= 0
                                };
                                _this.offsetEdge = $8e849631b7a8ddb1$var$getEdgeOffset(_node, _this.container);
                                if (_isKeySorting) _this.initialOffset = $8e849631b7a8ddb1$var$getPosition((0, $8f75f835f3f62d38$export$2e2bcd8739ae039)({}, event, {
                                    pageX: _this.boundingClientRect.left,
                                    pageY: _this.boundingClientRect.top
                                }));
                                else _this.initialOffset = $8e849631b7a8ddb1$var$getPosition(event);
                                _this.initialScroll = {
                                    left: _this.scrollContainer.scrollLeft,
                                    top: _this.scrollContainer.scrollTop
                                };
                                _this.initialWindowScroll = {
                                    left: window.pageXOffset,
                                    top: window.pageYOffset
                                };
                                _this.helper = _this.helperContainer.appendChild($8e849631b7a8ddb1$var$cloneNode(_node));
                                $8e849631b7a8ddb1$var$setInlineStyles(_this.helper, {
                                    boxSizing: 'border-box',
                                    height: "".concat(_this.height, "px"),
                                    left: "".concat(_this.boundingClientRect.left - margin.left, "px"),
                                    pointerEvents: 'none',
                                    position: 'fixed',
                                    top: "".concat(_this.boundingClientRect.top - margin.top, "px"),
                                    width: "".concat(_this.width, "px")
                                });
                                if (_isKeySorting) _this.helper.focus();
                                if (_hideSortableGhost) {
                                    _this.sortableGhost = _node;
                                    $8e849631b7a8ddb1$var$setInlineStyles(_node, {
                                        opacity: 0,
                                        visibility: 'hidden'
                                    });
                                }
                                _this.minTranslate = {};
                                _this.maxTranslate = {};
                                if (_isKeySorting) {
                                    var _ref = _useWindowAsScrollContainer ? {
                                        top: 0,
                                        left: 0,
                                        width: _this.contentWindow.innerWidth,
                                        height: _this.contentWindow.innerHeight
                                    } : _this.containerBoundingRect, containerTop = _ref.top, containerLeft = _ref.left, containerWidth = _ref.width, containerHeight = _ref.height;
                                    var containerBottom = containerTop + containerHeight;
                                    var containerRight = containerLeft + containerWidth;
                                    if (_this.axis.x) {
                                        _this.minTranslate.x = containerLeft - _this.boundingClientRect.left;
                                        _this.maxTranslate.x = containerRight - (_this.boundingClientRect.left + _this.width);
                                    }
                                    if (_this.axis.y) {
                                        _this.minTranslate.y = containerTop - _this.boundingClientRect.top;
                                        _this.maxTranslate.y = containerBottom - (_this.boundingClientRect.top + _this.height);
                                    }
                                } else {
                                    if (_this.axis.x) {
                                        _this.minTranslate.x = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
                                        _this.maxTranslate.x = (_useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
                                    }
                                    if (_this.axis.y) {
                                        _this.minTranslate.y = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
                                        _this.maxTranslate.y = (_useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
                                    }
                                }
                                if (_helperClass) _helperClass.split(' ').forEach(function(className) {
                                    return _this.helper.classList.add(className);
                                });
                                _this.listenerNode = event.touches ? event.target : _this.contentWindow;
                                if (_isKeySorting) {
                                    _this.listenerNode.addEventListener('wheel', _this.handleKeyEnd, true);
                                    _this.listenerNode.addEventListener('mousedown', _this.handleKeyEnd, true);
                                    _this.listenerNode.addEventListener('keydown', _this.handleKeyDown);
                                } else {
                                    $8e849631b7a8ddb1$var$events.move.forEach(function(eventName) {
                                        return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
                                    });
                                    $8e849631b7a8ddb1$var$events.end.forEach(function(eventName) {
                                        return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
                                    });
                                }
                                _this.setState({
                                    sorting: true,
                                    sortingIndex: index
                                });
                                if (_onSortStart) _onSortStart({
                                    node: _node,
                                    index: index,
                                    collection: _collection,
                                    isKeySorting: _isKeySorting,
                                    nodes: _this.manager.getOrderedRefs(),
                                    helper: _this.helper
                                }, event);
                                if (_isKeySorting) _this.keyMove(0);
                            };
                            var _this$props3 = _this.props, _axis = _this$props3.axis, _getHelperDimensions = _this$props3.getHelperDimensions, _helperClass = _this$props3.helperClass, _hideSortableGhost = _this$props3.hideSortableGhost, updateBeforeSortStart = _this$props3.updateBeforeSortStart, _onSortStart = _this$props3.onSortStart, _useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
                            var _node = active.node, _collection = active.collection;
                            var _isKeySorting = _this.manager.isKeySorting;
                            var _temp8 = function() {
                                if (typeof updateBeforeSortStart === 'function') {
                                    _this._awaitingUpdateBeforeSortStart = true;
                                    var _temp9 = $8e849631b7a8ddb1$var$_finallyRethrows(function() {
                                        var index = _node.sortableInfo.index;
                                        return Promise.resolve(updateBeforeSortStart({
                                            collection: _collection,
                                            index: index,
                                            node: _node,
                                            isKeySorting: _isKeySorting
                                        }, event)).then(function() {});
                                    }, function(_wasThrown, _result) {
                                        _this._awaitingUpdateBeforeSortStart = false;
                                        if (_wasThrown) throw _result;
                                        return _result;
                                    });
                                    if (_temp9 && _temp9.then) return _temp9.then(function() {});
                                }
                            }();
                            return _temp8 && _temp8.then ? _temp8.then(_temp7) : _temp7(_temp8);
                        }
                    }();
                    return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function() {}) : void 0);
                } catch (e) {
                    return Promise.reject(e);
                }
            });
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "handleSortMove", function(event) {
                var onSortMove = _this.props.onSortMove;
                if (typeof event.preventDefault === 'function' && event.cancelable) event.preventDefault();
                _this.updateHelperPosition(event);
                _this.animateNodes();
                _this.autoscroll();
                if (onSortMove) onSortMove(event);
            });
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "handleSortEnd", function(event) {
                var _this$props4 = _this.props, hideSortableGhost = _this$props4.hideSortableGhost, onSortEnd = _this$props4.onSortEnd;
                var _this$manager = _this.manager, collection = _this$manager.active.collection, isKeySorting = _this$manager.isKeySorting;
                var nodes = _this.manager.getOrderedRefs();
                if (_this.listenerNode) {
                    if (isKeySorting) {
                        _this.listenerNode.removeEventListener('wheel', _this.handleKeyEnd, true);
                        _this.listenerNode.removeEventListener('mousedown', _this.handleKeyEnd, true);
                        _this.listenerNode.removeEventListener('keydown', _this.handleKeyDown);
                    } else {
                        $8e849631b7a8ddb1$var$events.move.forEach(function(eventName) {
                            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
                        });
                        $8e849631b7a8ddb1$var$events.end.forEach(function(eventName) {
                            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
                        });
                    }
                }
                _this.helper.parentNode.removeChild(_this.helper);
                if (hideSortableGhost && _this.sortableGhost) $8e849631b7a8ddb1$var$setInlineStyles(_this.sortableGhost, {
                    opacity: '',
                    visibility: ''
                });
                for(var i = 0, len = nodes.length; i < len; i++){
                    var _node2 = nodes[i];
                    var el = _node2.node;
                    _node2.edgeOffset = null;
                    _node2.boundingClientRect = null;
                    $8e849631b7a8ddb1$var$setTranslate3d(el, null);
                    $8e849631b7a8ddb1$var$setTransitionDuration(el, null);
                    _node2.translate = null;
                }
                _this.autoScroller.clear();
                _this.manager.active = null;
                _this.manager.isKeySorting = false;
                _this.setState({
                    sorting: false,
                    sortingIndex: null
                });
                if (typeof onSortEnd === 'function') onSortEnd({
                    collection: collection,
                    newIndex: _this.newIndex,
                    oldIndex: _this.index,
                    isKeySorting: isKeySorting,
                    nodes: nodes
                }, event);
                _this.touched = false;
            });
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "autoscroll", function() {
                var disableAutoscroll = _this.props.disableAutoscroll;
                var isKeySorting = _this.manager.isKeySorting;
                if (disableAutoscroll) {
                    _this.autoScroller.clear();
                    return;
                }
                if (isKeySorting) {
                    var translate = (0, $8f75f835f3f62d38$export$2e2bcd8739ae039)({}, _this.translate);
                    var scrollX = 0;
                    var scrollY = 0;
                    if (_this.axis.x) {
                        translate.x = Math.min(_this.maxTranslate.x, Math.max(_this.minTranslate.x, _this.translate.x));
                        scrollX = _this.translate.x - translate.x;
                    }
                    if (_this.axis.y) {
                        translate.y = Math.min(_this.maxTranslate.y, Math.max(_this.minTranslate.y, _this.translate.y));
                        scrollY = _this.translate.y - translate.y;
                    }
                    _this.translate = translate;
                    $8e849631b7a8ddb1$var$setTranslate3d(_this.helper, _this.translate);
                    _this.scrollContainer.scrollLeft += scrollX;
                    _this.scrollContainer.scrollTop += scrollY;
                    return;
                }
                _this.autoScroller.update({
                    height: _this.height,
                    maxTranslate: _this.maxTranslate,
                    minTranslate: _this.minTranslate,
                    translate: _this.translate,
                    width: _this.width
                });
            });
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "onAutoScroll", function(offset) {
                _this.translate.x += offset.left;
                _this.translate.y += offset.top;
                _this.animateNodes();
            });
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "handleKeyDown", function(event) {
                var keyCode = event.keyCode;
                var _this$props5 = _this.props, shouldCancelStart = _this$props5.shouldCancelStart, _this$props5$keyCodes = _this$props5.keyCodes, customKeyCodes = _this$props5$keyCodes === void 0 ? {} : _this$props5$keyCodes;
                var keyCodes = (0, $8f75f835f3f62d38$export$2e2bcd8739ae039)({}, $8e849631b7a8ddb1$var$defaultKeyCodes, customKeyCodes);
                if (_this.manager.active && !_this.manager.isKeySorting || !_this.manager.active && (!keyCodes.lift.includes(keyCode) || shouldCancelStart(event) || !_this.isValidSortingTarget(event))) return;
                event.stopPropagation();
                event.preventDefault();
                if (keyCodes.lift.includes(keyCode) && !_this.manager.active) _this.keyLift(event);
                else if (keyCodes.drop.includes(keyCode) && _this.manager.active) _this.keyDrop(event);
                else if (keyCodes.cancel.includes(keyCode)) {
                    _this.newIndex = _this.manager.active.index;
                    _this.keyDrop(event);
                } else if (keyCodes.up.includes(keyCode)) _this.keyMove(-1);
                else if (keyCodes.down.includes(keyCode)) _this.keyMove(1);
            });
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "keyLift", function(event) {
                var target = event.target;
                var node = $8e849631b7a8ddb1$var$closest(target, function(el) {
                    return el.sortableInfo != null;
                });
                var _node$sortableInfo2 = node.sortableInfo, index = _node$sortableInfo2.index, collection = _node$sortableInfo2.collection;
                _this.initialFocusedNode = target;
                _this.manager.isKeySorting = true;
                _this.manager.active = {
                    index: index,
                    collection: collection
                };
                _this.handlePress(event);
            });
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "keyMove", function(shift) {
                var nodes = _this.manager.getOrderedRefs();
                var lastIndex = nodes[nodes.length - 1].node.sortableInfo.index;
                var newIndex = _this.newIndex + shift;
                var prevIndex = _this.newIndex;
                if (newIndex < 0 || newIndex > lastIndex) return;
                _this.prevIndex = prevIndex;
                _this.newIndex = newIndex;
                var targetIndex = $8e849631b7a8ddb1$var$getTargetIndex(_this.newIndex, _this.prevIndex, _this.index);
                var target = nodes.find(function(_ref2) {
                    var node = _ref2.node;
                    return node.sortableInfo.index === targetIndex;
                });
                var targetNode = target.node;
                var scrollDelta = _this.containerScrollDelta;
                var targetBoundingClientRect = target.boundingClientRect || $8e849631b7a8ddb1$var$getScrollAdjustedBoundingClientRect(targetNode, scrollDelta);
                var targetTranslate = target.translate || {
                    x: 0,
                    y: 0
                };
                var targetPosition = {
                    top: targetBoundingClientRect.top + targetTranslate.y - scrollDelta.top,
                    left: targetBoundingClientRect.left + targetTranslate.x - scrollDelta.left
                };
                var shouldAdjustForSize = prevIndex < newIndex;
                var sizeAdjustment = {
                    x: shouldAdjustForSize && _this.axis.x ? targetNode.offsetWidth - _this.width : 0,
                    y: shouldAdjustForSize && _this.axis.y ? targetNode.offsetHeight - _this.height : 0
                };
                _this.handleSortMove({
                    pageX: targetPosition.left + sizeAdjustment.x,
                    pageY: targetPosition.top + sizeAdjustment.y,
                    ignoreTransition: shift === 0
                });
            });
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "keyDrop", function(event) {
                _this.handleSortEnd(event);
                if (_this.initialFocusedNode) _this.initialFocusedNode.focus();
            });
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "handleKeyEnd", function(event) {
                if (_this.manager.active) _this.keyDrop(event);
            });
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "isValidSortingTarget", function(event) {
                var useDragHandle = _this.props.useDragHandle;
                var target = event.target;
                var node = $8e849631b7a8ddb1$var$closest(target, function(el) {
                    return el.sortableInfo != null;
                });
                return node && node.sortableInfo && !node.sortableInfo.disabled && (useDragHandle ? $8e849631b7a8ddb1$var$isSortableHandle(target) : target.sortableInfo);
            });
            var manager = new $8e849631b7a8ddb1$var$Manager();
            $8e849631b7a8ddb1$var$validateProps(props);
            _this.manager = manager;
            _this.wrappedInstance = (0, $7Do5B.createRef)();
            _this.sortableContextValue = {
                manager: manager
            };
            _this.events = {
                end: _this.handleEnd,
                move: _this.handleMove,
                start: _this.handleStart
            };
            return _this;
        }
        (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(WithSortableContainer, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this2 = this;
                    var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
                    var container = this.getContainer();
                    Promise.resolve(container).then(function(containerNode) {
                        _this2.container = containerNode;
                        _this2.document = _this2.container.ownerDocument || document;
                        var contentWindow = _this2.props.contentWindow || _this2.document.defaultView || window;
                        _this2.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
                        _this2.scrollContainer = useWindowAsScrollContainer ? _this2.document.scrollingElement || _this2.document.documentElement : $8e849631b7a8ddb1$var$getScrollingParent(_this2.container) || _this2.container;
                        _this2.autoScroller = new $8e849631b7a8ddb1$var$AutoScroller(_this2.scrollContainer, _this2.onAutoScroll);
                        Object.keys(_this2.events).forEach(function(key) {
                            return $8e849631b7a8ddb1$var$events[key].forEach(function(eventName) {
                                return _this2.container.addEventListener(eventName, _this2.events[key], false);
                            });
                        });
                        _this2.container.addEventListener('keydown', _this2.handleKeyDown);
                    });
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    var _this3 = this;
                    if (this.helper && this.helper.parentNode) this.helper.parentNode.removeChild(this.helper);
                    if (!this.container) return;
                    Object.keys(this.events).forEach(function(key) {
                        return $8e849631b7a8ddb1$var$events[key].forEach(function(eventName) {
                            return _this3.container.removeEventListener(eventName, _this3.events[key]);
                        });
                    });
                    this.container.removeEventListener('keydown', this.handleKeyDown);
                }
            },
            {
                key: "updateHelperPosition",
                value: function updateHelperPosition(event) {
                    var _this$props6 = this.props, lockAxis = _this$props6.lockAxis, lockOffset = _this$props6.lockOffset, lockToContainerEdges = _this$props6.lockToContainerEdges, transitionDuration = _this$props6.transitionDuration, _this$props6$keyboard = _this$props6.keyboardSortingTransitionDuration, keyboardSortingTransitionDuration = _this$props6$keyboard === void 0 ? transitionDuration : _this$props6$keyboard;
                    var isKeySorting = this.manager.isKeySorting;
                    var ignoreTransition = event.ignoreTransition;
                    var offset = $8e849631b7a8ddb1$var$getPosition(event);
                    var translate = {
                        x: offset.x - this.initialOffset.x,
                        y: offset.y - this.initialOffset.y
                    };
                    translate.y -= window.pageYOffset - this.initialWindowScroll.top;
                    translate.x -= window.pageXOffset - this.initialWindowScroll.left;
                    this.translate = translate;
                    if (lockToContainerEdges) {
                        var _getLockPixelOffsets = $8e849631b7a8ddb1$var$getLockPixelOffsets({
                            height: this.height,
                            lockOffset: lockOffset,
                            width: this.width
                        }), _getLockPixelOffsets2 = (0, $4a9275f4284d6709$export$2e2bcd8739ae039)(_getLockPixelOffsets, 2), minLockOffset = _getLockPixelOffsets2[0], maxLockOffset = _getLockPixelOffsets2[1];
                        var minOffset = {
                            x: this.width / 2 - minLockOffset.x,
                            y: this.height / 2 - minLockOffset.y
                        };
                        var maxOffset = {
                            x: this.width / 2 - maxLockOffset.x,
                            y: this.height / 2 - maxLockOffset.y
                        };
                        translate.x = $8e849631b7a8ddb1$var$limit(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
                        translate.y = $8e849631b7a8ddb1$var$limit(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
                    }
                    if (lockAxis === 'x') translate.y = 0;
                    else if (lockAxis === 'y') translate.x = 0;
                    if (isKeySorting && keyboardSortingTransitionDuration && !ignoreTransition) $8e849631b7a8ddb1$var$setTransitionDuration(this.helper, keyboardSortingTransitionDuration);
                    $8e849631b7a8ddb1$var$setTranslate3d(this.helper, translate);
                }
            },
            {
                key: "animateNodes",
                value: function animateNodes() {
                    var _this$props7 = this.props, transitionDuration = _this$props7.transitionDuration, hideSortableGhost = _this$props7.hideSortableGhost, onSortOver = _this$props7.onSortOver;
                    var containerScrollDelta = this.containerScrollDelta, windowScrollDelta = this.windowScrollDelta;
                    var nodes = this.manager.getOrderedRefs();
                    var sortingOffset = {
                        left: this.offsetEdge.left + this.translate.x + containerScrollDelta.left,
                        top: this.offsetEdge.top + this.translate.y + containerScrollDelta.top
                    };
                    var isKeySorting = this.manager.isKeySorting;
                    var prevIndex = this.newIndex;
                    this.newIndex = null;
                    for(var i = 0, len = nodes.length; i < len; i++){
                        var _node3 = nodes[i].node;
                        var index = _node3.sortableInfo.index;
                        var width = _node3.offsetWidth;
                        var height = _node3.offsetHeight;
                        var offset = {
                            height: this.height > height ? height / 2 : this.height / 2,
                            width: this.width > width ? width / 2 : this.width / 2
                        };
                        var mustShiftBackward = isKeySorting && index > this.index && index <= prevIndex;
                        var mustShiftForward = isKeySorting && index < this.index && index >= prevIndex;
                        var translate = {
                            x: 0,
                            y: 0
                        };
                        var edgeOffset = nodes[i].edgeOffset;
                        if (!edgeOffset) {
                            edgeOffset = $8e849631b7a8ddb1$var$getEdgeOffset(_node3, this.container);
                            nodes[i].edgeOffset = edgeOffset;
                            if (isKeySorting) nodes[i].boundingClientRect = $8e849631b7a8ddb1$var$getScrollAdjustedBoundingClientRect(_node3, containerScrollDelta);
                        }
                        var nextNode = i < nodes.length - 1 && nodes[i + 1];
                        var prevNode = i > 0 && nodes[i - 1];
                        if (nextNode && !nextNode.edgeOffset) {
                            nextNode.edgeOffset = $8e849631b7a8ddb1$var$getEdgeOffset(nextNode.node, this.container);
                            if (isKeySorting) nextNode.boundingClientRect = $8e849631b7a8ddb1$var$getScrollAdjustedBoundingClientRect(nextNode.node, containerScrollDelta);
                        }
                        if (index === this.index) {
                            if (hideSortableGhost) {
                                this.sortableGhost = _node3;
                                $8e849631b7a8ddb1$var$setInlineStyles(_node3, {
                                    opacity: 0,
                                    visibility: 'hidden'
                                });
                            }
                            continue;
                        }
                        if (transitionDuration) $8e849631b7a8ddb1$var$setTransitionDuration(_node3, transitionDuration);
                        if (this.axis.x) {
                            if (this.axis.y) {
                                if (mustShiftForward || index < this.index && (sortingOffset.left + windowScrollDelta.left - offset.width <= edgeOffset.left && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height || sortingOffset.top + windowScrollDelta.top + offset.height <= edgeOffset.top)) {
                                    translate.x = this.width + this.marginOffset.x;
                                    if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                                        if (nextNode) {
                                            translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                                            translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                                        }
                                    }
                                    if (this.newIndex === null) this.newIndex = index;
                                } else if (mustShiftBackward || index > this.index && (sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top || sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top + height)) {
                                    translate.x = -(this.width + this.marginOffset.x);
                                    if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                                        if (prevNode) {
                                            translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                                            translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                                        }
                                    }
                                    this.newIndex = index;
                                }
                            } else {
                                if (mustShiftBackward || index > this.index && sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left) {
                                    translate.x = -(this.width + this.marginOffset.x);
                                    this.newIndex = index;
                                } else if (mustShiftForward || index < this.index && sortingOffset.left + windowScrollDelta.left <= edgeOffset.left + offset.width) {
                                    translate.x = this.width + this.marginOffset.x;
                                    if (this.newIndex == null) this.newIndex = index;
                                }
                            }
                        } else if (this.axis.y) {
                            if (mustShiftBackward || index > this.index && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top) {
                                translate.y = -(this.height + this.marginOffset.y);
                                this.newIndex = index;
                            } else if (mustShiftForward || index < this.index && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height) {
                                translate.y = this.height + this.marginOffset.y;
                                if (this.newIndex == null) this.newIndex = index;
                            }
                        }
                        $8e849631b7a8ddb1$var$setTranslate3d(_node3, translate);
                        nodes[i].translate = translate;
                    }
                    if (this.newIndex == null) this.newIndex = this.index;
                    if (isKeySorting) this.newIndex = prevIndex;
                    var oldIndex = isKeySorting ? this.prevIndex : prevIndex;
                    if (onSortOver && this.newIndex !== oldIndex) onSortOver({
                        collection: this.manager.active.collection,
                        index: this.index,
                        newIndex: this.newIndex,
                        oldIndex: oldIndex,
                        isKeySorting: isKeySorting,
                        nodes: nodes,
                        helper: this.helper
                    });
                }
            },
            {
                key: "getWrappedInstance",
                value: function getWrappedInstance() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($fb89ab44c0e57c1a$exports)))(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
                    return this.wrappedInstance.current;
                }
            },
            {
                key: "getContainer",
                value: function getContainer() {
                    var getContainer = this.props.getContainer;
                    if (typeof getContainer !== 'function') return (0, $7ikhG.findDOMNode)(this);
                    return getContainer(config.withRef ? this.getWrappedInstance() : undefined);
                }
            },
            {
                key: "render",
                value: function render() {
                    var ref = config.withRef ? this.wrappedInstance : null;
                    return (0, $7Do5B.createElement)($8e849631b7a8ddb1$var$SortableContext.Provider, {
                        value: this.sortableContextValue
                    }, (0, $7Do5B.createElement)(WrappedComponent, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
                        ref: ref
                    }, $8e849631b7a8ddb1$var$omit(this.props, $8e849631b7a8ddb1$var$omittedProps))));
                }
            },
            {
                key: "helperContainer",
                get: function get() {
                    var helperContainer = this.props.helperContainer;
                    if (typeof helperContainer === 'function') return helperContainer();
                    return this.props.helperContainer || this.document.body;
                }
            },
            {
                key: "containerScrollDelta",
                get: function get() {
                    var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
                    if (useWindowAsScrollContainer) return {
                        left: 0,
                        top: 0
                    };
                    return {
                        left: this.scrollContainer.scrollLeft - this.initialScroll.left,
                        top: this.scrollContainer.scrollTop - this.initialScroll.top
                    };
                }
            },
            {
                key: "windowScrollDelta",
                get: function get() {
                    return {
                        left: this.contentWindow.pageXOffset - this.initialWindowScroll.left,
                        top: this.contentWindow.pageYOffset - this.initialWindowScroll.top
                    };
                }
            }
        ]);
        return WithSortableContainer;
    }((0, $7Do5B.Component)), (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(_class, "displayName", $8e849631b7a8ddb1$var$provideDisplayName('sortableList', WrappedComponent)), (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(_class, "defaultProps", $8e849631b7a8ddb1$var$defaultProps), (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(_class, "propTypes", $8e849631b7a8ddb1$var$propTypes), _temp;
}
var $8e849631b7a8ddb1$var$propTypes$1 = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number.isRequired,
    collection: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string
    ]),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool
};
var $8e849631b7a8ddb1$var$omittedProps$1 = Object.keys($8e849631b7a8ddb1$var$propTypes$1);
function $8e849631b7a8ddb1$export$58d1e4fb0d207bf7(WrappedComponent) {
    var _class, _temp;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        withRef: false
    };
    return _temp = _class = function(_React$Component) {
        (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(WithSortableElement, _React$Component);
        function WithSortableElement() {
            var _getPrototypeOf2;
            var _this;
            (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, WithSortableElement);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = (0, $c345de07753d2fca$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(WithSortableElement)).call.apply(_getPrototypeOf2, [
                this
            ].concat(args)));
            (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this)), "wrappedInstance", (0, $7Do5B.createRef)());
            return _this;
        }
        (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(WithSortableElement, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.register();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.node) {
                        if (prevProps.index !== this.props.index) this.node.sortableInfo.index = this.props.index;
                        if (prevProps.disabled !== this.props.disabled) this.node.sortableInfo.disabled = this.props.disabled;
                    }
                    if (prevProps.collection !== this.props.collection) {
                        this.unregister(prevProps.collection);
                        this.register();
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.unregister();
                }
            },
            {
                key: "register",
                value: function register() {
                    var _this$props = this.props, collection = _this$props.collection, disabled = _this$props.disabled, index = _this$props.index;
                    var node = (0, $7ikhG.findDOMNode)(this);
                    node.sortableInfo = {
                        collection: collection,
                        disabled: disabled,
                        index: index,
                        manager: this.context.manager
                    };
                    this.node = node;
                    this.ref = {
                        node: node
                    };
                    this.context.manager.add(collection, this.ref);
                }
            },
            {
                key: "unregister",
                value: function unregister() {
                    var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.collection;
                    this.context.manager.remove(collection, this.ref);
                }
            },
            {
                key: "getWrappedInstance",
                value: function getWrappedInstance() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($fb89ab44c0e57c1a$exports)))(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
                    return this.wrappedInstance.current;
                }
            },
            {
                key: "render",
                value: function render() {
                    var ref = config.withRef ? this.wrappedInstance : null;
                    return (0, $7Do5B.createElement)(WrappedComponent, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
                        ref: ref
                    }, $8e849631b7a8ddb1$var$omit(this.props, $8e849631b7a8ddb1$var$omittedProps$1)));
                }
            }
        ]);
        return WithSortableElement;
    }((0, $7Do5B.Component)), (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(_class, "displayName", $8e849631b7a8ddb1$var$provideDisplayName('sortableElement', WrappedComponent)), (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(_class, "contextType", $8e849631b7a8ddb1$var$SortableContext), (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(_class, "propTypes", $8e849631b7a8ddb1$var$propTypes$1), (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(_class, "defaultProps", {
        collection: 0
    }), _temp;
}


function $2f6640a2c8663b11$export$79f3cf326dbd2413(array, fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < array.length) {
        const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;
        const [item] = array.splice(fromIndex, 1);
        array.splice(endIndex, 0, item);
    }
}
function $2f6640a2c8663b11$export$874a2b636708da2d(array, fromIndex, toIndex) {
    array = [
        ...array
    ];
    $2f6640a2c8663b11$export$79f3cf326dbd2413(array, fromIndex, toIndex);
    return array;
}






var $7Do5B = parcelRequire("7Do5B");
parcelRequire("7Do5B");

const $847f4fd944f587cf$var$Modal = (props)=>{
    const { active: active, title: title, onClose: _, class: klass, children: children, actions: actions = true } = props;
    const handleClose = ()=>{
        if (props.onClose) props.onClose();
    };
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
        ...props,
        class: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))("modal", {
            "is-active": active
        }, klass),
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                class: "modal-background"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                class: "modal-card",
                style: props.customStyle,
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                        class: "modal-card-head",
                        children: [
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                class: "modal-card-title",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                class: "delete",
                                "aria-label": "close",
                                onClick: handleClose
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("section", {
                        class: "modal-card-body",
                        children: children
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("footer", {
                        class: "modal-card-foot",
                        children: actions && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                    form: "form",
                                    type: "submit",
                                    class: "button is-success",
                                    children: "Guardar"
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                    class: "button",
                                    onClick: handleClose,
                                    children: "Cancelar"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $847f4fd944f587cf$export$2e2bcd8739ae039 = $847f4fd944f587cf$var$Modal;




function $fb18d5c1de8a02b4$var$copyTextToClipboard(text) {
    if (!navigator.clipboard) return;
    navigator.clipboard.writeText(text).then(function() {
        console.log("Async: Copying to clipboard was successful!");
    }, function(err) {
        console.error("Async: Could not copy text: ", err);
    });
}
const $fb18d5c1de8a02b4$var$SortableItem = (0, $8e849631b7a8ddb1$export$58d1e4fb0d207bf7)((props)=>{
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
        class: "panel-block is-clickable",
        style: {
            display: "flex",
            justifyContent: "space-between"
        },
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                class: "truncate-text",
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                        class: "panel-icon",
                        style: {
                            marginRight: "1.3em"
                        },
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                            class: "material-icons",
                            children: "list"
                        })
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                        class: "",
                        children: [
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                label: props.value.label,
                                className: "custom-class"
                            }),
                            "ID: ",
                            props.sortIndex,
                            " ",
                            props.value.label
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $f28553f68a34bb68$export$a6c7ac8248d6e38a), {
                        class: "button is-small is-rounded",
                        href: `/headers?id=${props.value.header_id}&s=${props.value.label}`,
                        target: "_blank",
                        children: [
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                label: "Abrir cabecera",
                                className: "custom-class"
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                class: "material-icons",
                                style: {
                                    fontSize: 12
                                },
                                children: "content_paste"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                        onClick: props.onGrouped,
                        class: `button ${props.value.grouped ? "is-link" : ""} is-small is-rounded`,
                        style: {
                            marginLeft: ".5em",
                            padding: "5px 8px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                label: "Agrupar",
                                className: "custom-class"
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                class: "material-icons",
                                style: {
                                    fontSize: 12
                                },
                                children: "groups"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                        onClick: props.onHidden,
                        class: `button is-small is-rounded ${props.value.visible ? "" : "is-link"}`,
                        style: {
                            marginLeft: ".5em",
                            padding: "5px 8px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                label: "Ocultar",
                                className: "custom-class"
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                class: "material-icons",
                                style: {
                                    fontSize: 12
                                },
                                children: "visibility"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                        onClick: props.onDelete,
                        class: "button is-small is-rounded",
                        style: {
                            marginLeft: ".5em",
                            padding: "5px 8px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                label: "Eliminar",
                                className: "custom-class"
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                style: {
                                    fontSize: 12
                                },
                                class: "material-icons",
                                children: "close"
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
const $fb18d5c1de8a02b4$var$SortableList = (0, $8e849631b7a8ddb1$export$a4b10e5599330dd0)(({ items: items, onDelete: onDelete, onGrouped: onGrouped, onHidden: onHidden })=>{
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("ul", {
        class: "panel",
        children: items.length ? items.map((value, index)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)($fb18d5c1de8a02b4$var$SortableItem, {
                index: index,
                value: value,
                sortIndex: index,
                onGrouped: ()=>onGrouped(index),
                onHidden: ()=>onHidden(index),
                onDelete: ()=>onDelete(index)
            }, `item-${value}`)) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
            class: "panel-block",
            children: "No hay cabeceras agregadas"
        })
    });
});
const $fb18d5c1de8a02b4$var$SortableHeader = ({ value: items = [], onChange: onChange })=>{
    const [currentOption, setCurrentOption] = (0, $3aPmr.useState)(null);
    const onSortEnd = ({ oldIndex: oldIndex, newIndex: newIndex })=>{
        let newItems = (0, $2f6640a2c8663b11$export$874a2b636708da2d)(items, oldIndex, newIndex).map((el, index)=>({
                ...el,
                order: index + 1
            }));
        onChange(newItems);
    };
    const onDelete = (index)=>{
        let newItems = items.filter((item, i)=>i != index);
        onChange(newItems);
    // onChange(newItems.map((el, index) => ({ ...el, order: index + 1 })));
    };
    const onHidden = (index)=>{
        let newItems = items;
        newItems[index].visible = !newItems[index].visible;
        // newItems[index].grouped = false;
        onChange(newItems);
    };
    const onGrouped = (index)=>{
        let newItems = items;
        newItems[index].grouped = !newItems[index].grouped;
        newItems[index].visible = !newItems[index].grouped;
        onChange(newItems);
    };
    const loadOptions = async (search, loadedOptions, { page: page })=>{
        const response = await (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/headers/?q=${search}&page=${page}`);
        const responseJSON = await response.json();
        const options = responseJSON.records.map((el)=>({
                value: el.id,
                label: el.name
            }));
        return {
            options: options,
            hasMore: responseJSON.total_pages > responseJSON.page,
            additional: {
                page: page + 1
            }
        };
    };
    const addOption = ()=>{
        const item = {
            header_id: currentOption.value,
            label: currentOption.label,
            visible: true,
            grouped: false
        };
        onChange([
            ...items,
            item
        ].map((el, index)=>({
                ...el,
                order: index + 1
            })));
        setCurrentOption(null);
    };
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                className: "columns",
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        className: "column is-6",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ea3e1723cd1809aa$export$62ae509949bd1704), {
                            isClearable: true,
                            loadOptions: loadOptions,
                            additional: {
                                page: 1
                            },
                            value: currentOption,
                            onChange: setCurrentOption
                        })
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        className: "column is-6 field is-grouped",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                disabled: !currentOption,
                                onClick: addOption,
                                type: "button",
                                class: "button is-link",
                                children: "Agregar"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                style: {
                    maxHeight: "300px",
                    overflowY: "auto",
                    marginBottom: "20px"
                },
                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)($fb18d5c1de8a02b4$var$SortableList, {
                    onDelete: onDelete,
                    onGrouped: onGrouped,
                    onHidden: onHidden,
                    distance: 1,
                    items: items,
                    onSortEnd: onSortEnd,
                    helper: "test"
                })
            })
        ]
    });
};
var $fb18d5c1de8a02b4$export$2e2bcd8739ae039 = $fb18d5c1de8a02b4$var$SortableHeader;



var $7Do5B = parcelRequire("7Do5B");
parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");



const $3268a80f60e81387$var$FilterItem = ({ value: value, onDelete: onDelete, onChangeAction: onChangeAction })=>{
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
        class: "field has-addons",
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                class: "control",
                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                    class: "select",
                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("select", {
                        value: value.action,
                        onChange: (ev)=>{
                            onChangeAction(ev.target.value);
                        },
                        children: [
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("option", {
                                value: "default",
                                children: "Por defecto"
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("option", {
                                value: "required",
                                children: "Requerido"
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("option", {
                                value: "required_actived",
                                children: "Requerido Activo"
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("option", {
                                value: "required_main_actived",
                                children: "Requerido Principal"
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("option", {
                                value: "sent",
                                children: "En request"
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("option", {
                                value: "sent_main",
                                children: "En request Principal"
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("option", {
                                value: "main",
                                children: "Principal"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                class: "control is-expanded",
                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                    class: "input",
                    type: "text",
                    readonly: true,
                    value: value.label
                })
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                class: "control",
                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                    onClick: onDelete,
                    class: "button is-danger",
                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                        class: "material-icons",
                        children: "delete"
                    })
                })
            })
        ]
    });
};
const $3268a80f60e81387$var$FilterSelector = ({ value: items = [], onChange: onChange })=>{
    const [currentOption, setCurrentOption] = (0, $3aPmr.useState)(null);
    // const [items, setItems] = useState([]);
    const loadOptions = async (search, loadedOptions, { page: page })=>{
        const response = await (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/filters/?q=${search}&page=${page}`);
        const responseJSON = await response.json();
        const options = responseJSON.records.map((el)=>({
                value: el.id,
                label: el.parameter_name
            }));
        return {
            options: options,
            hasMore: responseJSON.total_pages > responseJSON.page,
            additional: {
                page: page + 1
            }
        };
    };
    const addOption = ()=>{
        let item = {
            filter_id: currentOption.value,
            label: currentOption.label,
            action: "sent"
        };
        const isFound = items.some((el)=>el.filter_id === item.filter_id);
        if (!isFound) {
            onChange([
                ...items,
                item
            ]);
            // setItems((items) => [...items, item]);
            setCurrentOption(null);
        }
    };
    const handleChangeAction = (index, val)=>{
        const copyItems = items.slice();
        copyItems[index].action = val;
        onChange(copyItems);
    };
    const handleDelete = (index)=>{
        onChange(items.filter((item, i)=>i != index));
    };
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                class: "columns",
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        className: "column is-6",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ea3e1723cd1809aa$export$62ae509949bd1704), {
                            isClearable: true,
                            loadOptions: loadOptions,
                            additional: {
                                page: 1
                            },
                            value: currentOption,
                            onChange: setCurrentOption
                        })
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        className: "column is-6",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                            disabled: !currentOption,
                            type: "button",
                            class: "button is-link",
                            onClick: addOption,
                            children: "Agregar"
                        })
                    })
                ]
            }),
            items.map((item, index)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)($3268a80f60e81387$var$FilterItem, {
                    value: item,
                    index: index,
                    onChangeAction: (val)=>handleChangeAction(index, val),
                    onDelete: ()=>handleDelete(index)
                }))
        ]
    });
};
var $3268a80f60e81387$export$2e2bcd8739ae039 = $3268a80f60e81387$var$FilterSelector;



parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");



const $41f55b004dc4fc40$var$Select = ({ options: options, disabled: disabled = false, onChange: onChange, value: value })=>{
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
        class: "select",
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("select", {
            value: value,
            onChange: onChange,
            disabled: disabled,
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("option", {
                    disabled: true,
                    selected: true,
                    value: "",
                    children: "Seleccionar"
                }),
                options.map((item)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("option", {
                        value: item.label,
                        children: item.label
                    }))
            ]
        })
    });
};
const $41f55b004dc4fc40$var$Translations = (props)=>{
    const { onChange: onChange, value: values = [] } = props;
    const [options, setOptions] = (0, $3aPmr.useState)([]);
    const [langKey, setLang] = (0, $3aPmr.useState)("");
    const [inputValue, setInputValue] = (0, $3aPmr.useState)("");
    const recursiveSequential = async ({ page: page })=>{
        const json = await loadOptions({
            page: page
        });
        setOptions((prev)=>[
                ...prev,
                ...json.options
            ]);
        if (json.hasMore) return recursiveSequential({
            page: page + 1
        });
    };
    const loadOptions = async ({ page: page })=>{
        const response = await (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/languages/?page=${page}`);
        const responseJSON = await response.json();
        const options = responseJSON.records.map((el)=>({
                value: el.id,
                label: `${el.key}`
            }));
        return {
            options: options,
            hasMore: responseJSON.total_pages > responseJSON.page,
            additional: {
                page: page + 1
            }
        };
    };
    const onAddLanguage = ()=>{
        if (langKey && inputValue && !values.find((el)=>el.lang === langKey)) {
            const item = {
                lang: langKey,
                value: inputValue
            };
            /* setData((prev) => [...prev, item]); */ if (onChange instanceof Function) onChange([
                ...values,
                item
            ]);
            setLang("");
            setInputValue("");
        }
    };
    const handleDelete = (item)=>{
        /* setData((prev) => prev.filter((el) => el.lang != item.lang)); */ onChange(values.filter((el)=>el.lang != item.lang));
    };
    (0, $3aPmr.useEffect)(()=>{
        recursiveSequential({
            page: 1
        });
    }, []);
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                class: "field has-addons has-addons-centered",
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                        class: "control",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)($41f55b004dc4fc40$var$Select, {
                            value: langKey,
                            onChange: (ev)=>setLang(ev.target.value),
                            options: options.filter((i)=>{
                                if (values.some((e)=>e.lang === i.label)) return false;
                                return true;
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                        class: "control",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                            class: "input",
                            type: "text",
                            value: inputValue,
                            onChange: (ev)=>setInputValue(ev.target.value)
                        })
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                        class: "control",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                            class: "button is-link",
                            onClick: onAddLanguage,
                            children: "Agregar"
                        })
                    })
                ]
            }),
            values.map((item, index)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "field has-addons has-addons-centered",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)($41f55b004dc4fc40$var$Select, {
                                value: item.lang,
                                disabled: true,
                                options: options
                            })
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                class: "input",
                                value: item.value,
                                type: "text",
                                onChange: (ev)=>{
                                    values[index].value = ev.target.value;
                                    onChange(values);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                class: "button is-danger",
                                onClick: ()=>{
                                    handleDelete(item);
                                },
                                children: "Eliminar"
                            })
                        })
                    ]
                }))
        ]
    });
};
var $41f55b004dc4fc40$export$2e2bcd8739ae039 = $41f55b004dc4fc40$var$Translations;







const $6121a41e444fe2dd$var$allowedFormats = [
    {
        label: "PDF",
        value: "pdf"
    },
    {
        label: "CSV",
        value: "csv"
    },
    {
        label: "XLSX",
        value: "xlsx"
    },
    {
        label: "TXT",
        value: "txt"
    }
];
const $6121a41e444fe2dd$var$typeOptions = [
    {
        label: "Common",
        value: "common"
    },
    {
        label: "Tiempo y Asistencia",
        value: "tyasist"
    },
    {
        label: "Acceso",
        value: "acceso"
    },
    {
        label: "Visitantes",
        value: "visitantes"
    }
];
const $6121a41e444fe2dd$var$asciiCharsOptions = [
    {
        label: "Nada",
        value: "0"
    },
    {
        label: ",",
        value: "44"
    },
    {
        label: ";",
        value: "59"
    },
    {
        label: "Tabulacion",
        value: "9"
    }
];
const $6121a41e444fe2dd$var$yesnoOptions = [
    {
        label: "Si",
        value: true
    },
    {
        label: "No",
        value: false
    }
];
const $6121a41e444fe2dd$var$orientationPdfOptions = [
    {
        label: "Vertical",
        value: "vertical"
    },
    {
        label: "Horizontal",
        value: "horizontal"
    }
];
const $6121a41e444fe2dd$var$srcCodePython = `def _clean_data(session, cleaned_data, form):
    cleaned = cleaned_data.copy()
    return cleaned
`;
const $6121a41e444fe2dd$var$srcTitlePython = `async def _clean_data(session, cleaned_data, form):
    cleaned = cleaned_data.copy()
    # await t(session, form.lang, "since", "01-04-2022", "01-04-2022")
    # // Returns since/desde 01-04-2022 to 01-04-2022
    cleaned['report_title'] = "Titulo personalizado"
    return cleaned
`;
function $6121a41e444fe2dd$var$toTitleCase(str) {
    return str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}
const $6121a41e444fe2dd$var$CreateReportPage = ({ id: id })=>{
    const { register: register, handleSubmit: handleSubmit, reset: reset, setValue: setValue, getValues: getValues, control: control, watch: watch, formState: { errors: errors } } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        defaultValues: {
            has_func_callable: false,
            db_master: false,
            func_str: $6121a41e444fe2dd$var$srcCodePython
        }
    });
    const [clientsRecord, setClients] = (0, $3aPmr.useState)([]);
    const [modulesRecord, setModules] = (0, $3aPmr.useState)([]);
    const [titleGroupedModal, setTitleGroupedModal] = (0, $3aPmr.useState)(false);
    const [footerTitleModal, setFooterTitleModal] = (0, $3aPmr.useState)(false);
    const [customTitleRangeModal, setCustomTitleRangeModal] = (0, $3aPmr.useState)(false);
    const [functionModal, setFunctionModal] = (0, $3aPmr.useState)(false);
    const { has_func_callable: has_func_callable = false, allowed_formats: allowed_formats = [], headers: headers = [] } = watch();
    const isAddMode = !id;
    const loadOptions = async (search, loadedOptions, { page: page })=>{
        const response = await (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/clients/?q=${search}&page=${page}`);
        const responseJSON = await response.json();
        const options = responseJSON.records.map((el)=>({
                value: el.id_client,
                label: el.client
            }));
        setClients((prev)=>[
                ...prev,
                ...options
            ]);
        return {
            options: options,
            hasMore: responseJSON.total_pages > responseJSON.page,
            additional: {
                page: page + 1
            }
        };
    };
    const loadOptionsTags = async (search, loadedOptions, { page: page })=>{
        const response = await (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/subtags/?q=${search}&page=${page}`);
        const responseJSON = await response.json();
        const options = responseJSON.records.map((el)=>({
                value: el.id,
                label: el.name
            }));
        return {
            options: options,
            hasMore: responseJSON.total_pages > responseJSON.page,
            additional: {
                page: page + 1
            }
        };
    };
    const loadOptionsComponents = async (search, loadedOptions, { page: page })=>{
        const response = await (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/components/?q=${search}&page=${page}`);
        const responseJSON = await response.json();
        const options = responseJSON.records.map((el)=>({
                value: el.id,
                label: el.name
            }));
        return {
            options: options,
            hasMore: responseJSON.total_pages > responseJSON.page,
            additional: {
                page: page + 1
            }
        };
    };
    const loadOptionsParentReports = async (search, loadedOptions, { page: page })=>{
        const response = await (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/parent-reports/?q=${search}&page=${page}`);
        const responseJSON = await response.json();
        const options = responseJSON.records.map((el)=>({
                value: el.id,
                label: el.name
            }));
        return {
            options: options,
            hasMore: responseJSON.total_pages > responseJSON.page,
            additional: {
                page: page + 1
            }
        };
    };
    const addTag = (field, name, key)=>{
        const newTagName = $6121a41e444fe2dd$var$toTitleCase(name.replaceAll("_", " ")).replaceAll(" ", "");
        field.onChange(`${field.value || ""} {{ ${newTagName}.${key} }}`);
    };
    const loadOptionsModules = async (search, loadedOptions, { page: page })=>{
        const response = await (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/modules/?q=${search}&page=${page}`);
        const responseJSON = await response.json();
        const options = responseJSON.records.map((el)=>({
                value: el.id,
                label: el.name
            }));
        setModules(options);
        return {
            options: options,
            hasMore: responseJSON.total_pages > responseJSON.page,
            additional: {
                page: page + 1
            }
        };
    };
    const onSubmit = (data)=>{
        data.group_by = data.headers?.filter((el)=>el.grouped).map((el)=>el.header_id);
        data.subtags = data.subtags?.length ? data.subtags.map((i)=>i.value) : [];
        // data.parent_report = data.parents?.length ? data.parent_report.value : null
        data.parent_report = data.parent_report?.value;
        data.main_filter_id = data.main_filter_id?.value;
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/reports/${isAddMode ? "" : id}`, {
            method: isAddMode ? "POST" : "PUT",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            if (id) window.location = "/reports/" + id;
            else (0, $8ea79db61ca199dd$export$4cb887bfde2d34ca)("/", true);
        }).catch((error)=>{
            console.log(error);
        });
    };
    (0, $3aPmr.useEffect)(()=>{
        if (!isAddMode) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/reports/${id}`).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            let data = {
                ...res
            };
            data.headers = data.headers.map((el)=>({
                    order: el.order,
                    id: el.id,
                    header_id: el.header.id,
                    label: el.header.name,
                    visible: el.visible,
                    grouped: data.group_by?.includes(el.header.id)
                }));
            data.secondary_filters = data.secondary_filters.map((el)=>({
                    value: el.id,
                    label: el.name
                }));
            data.filters = data.filters.map((el)=>({
                    id: el.id,
                    filter_id: el.filter_id,
                    action: el.action,
                    label: `ID: ${el.filter_id} ${el.filter.parameter_name}`
                }));
            data.subtags = data.subtags.map((el)=>({
                    value: el.id,
                    label: el.name
                }));
            data.parent_report = data.parents.length ? {
                label: data.parents[0].name,
                value: data.parents[0].id
            } : null;
            data.main_filter_id = !!data.main_filter_id ? {
                label: data.main_filter.name,
                value: data.main_filter.id
            } : null;
            setClients((prev)=>[
                    ...prev,
                    ...data.clients_allowed.map((el)=>({
                            label: el.name,
                            value: el.client_pk
                        })),
                    ...data.clients_not_allowed.map((el)=>({
                            label: el.name,
                            value: el.client_pk
                        }))
                ]);
            setClients((prev)=>prev.filter((value, index, self)=>self.map((x)=>x.value).indexOf(value.value) == index));
            data.clients_allowed = data.clients_allowed.map((el)=>el.client_pk);
            data.clients_not_allowed = data.clients_not_allowed.map((el)=>el.client_pk);
            reset(data);
        });
    }, []);
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $96253dbc841a0a6f$export$2e2bcd8739ae039), {
        breadcrumbs: [
            "Reportes",
            "Crear"
        ],
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("form", {
            onSubmit: handleSubmit(onSubmit),
            class: "columns",
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "column is-7",
                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "card events-card",
                        style: {
                            marginBottom: "2rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                class: "card-header",
                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                    class: "card-header-title",
                                    children: "Reporte"
                                })
                            }),
                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                className: "card-content",
                                children: [
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "field",
                                        children: [
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                class: "label",
                                                children: "Nombre"
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                class: "control",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                                    ...register("name"),
                                                    class: "input",
                                                    type: "text",
                                                    placeholder: "",
                                                    required: true
                                                })
                                            }),
                                            errors.name && errors.name.type === "required" && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "help is-danger",
                                                children: "This is required"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "field",
                                        children: [
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                class: "label",
                                                children: "Tabla SQL"
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                class: "control",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("textarea", {
                                                    ...register("table_sql"),
                                                    class: "textarea",
                                                    placeholder: "e.g. Hello world"
                                                })
                                            }),
                                            errors.table_sql && errors.table_sql.type === "required" && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "help is-danger",
                                                children: "This is required"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "field",
                                        children: [
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                class: "label",
                                                children: "Complemento"
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                class: "control",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("textarea", {
                                                    ...register("complement"),
                                                    class: "textarea",
                                                    placeholder: ""
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "columns",
                                        children: [
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-6",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    class: "field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            class: "label",
                                                            children: "Formatos permitidos"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            class: "control",
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                                name: "allowed_formats",
                                                                control: control,
                                                                rules: {
                                                                    required: true
                                                                },
                                                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $305d4b79df7521f3$export$2e2bcd8739ae039), {
                                                                        isMulti: true,
                                                                        options: $6121a41e444fe2dd$var$allowedFormats,
                                                                        value: $6121a41e444fe2dd$var$allowedFormats.filter((c)=>field.value?.includes(c.value)),
                                                                        onChange: (val)=>{
                                                                            field.onChange(val?.map((el)=>el.value));
                                                                        }
                                                                    })
                                                            })
                                                        }),
                                                        errors.allowed_formats && errors.allowed_formats.type === "required" && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                            class: "help is-danger",
                                                            children: "This is required"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-6",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    class: "field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            class: "label",
                                                            children: "DB Master"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            class: "control",
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                                name: "db_master",
                                                                control: control,
                                                                rules: {
                                                                    required: false
                                                                },
                                                                defaultValue: false,
                                                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $305d4b79df7521f3$export$2e2bcd8739ae039), {
                                                                        options: $6121a41e444fe2dd$var$yesnoOptions,
                                                                        value: $6121a41e444fe2dd$var$yesnoOptions.find((c)=>c.value === field.value),
                                                                        onChange: (val)=>field.onChange(val.value)
                                                                    })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "columns",
                                        children: [
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-6",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    class: "field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            class: "label",
                                                            children: "Separador TXT"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            class: "control",
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                                name: "separator_txt",
                                                                control: control,
                                                                rules: {
                                                                    required: allowed_formats?.includes("txt")
                                                                },
                                                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $305d4b79df7521f3$export$2e2bcd8739ae039), {
                                                                        isDisabled: !allowed_formats?.includes("txt"),
                                                                        options: $6121a41e444fe2dd$var$asciiCharsOptions,
                                                                        value: $6121a41e444fe2dd$var$asciiCharsOptions.find((c)=>c.value === field.value),
                                                                        onChange: (val)=>field.onChange(val.value)
                                                                    })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-6",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    class: "field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            class: "label",
                                                            children: "Orientaci\xf3n del PDF"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            class: "control",
                                                            children: [
                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                                    name: "orientation_pdf",
                                                                    control: control,
                                                                    rules: {
                                                                        required: allowed_formats?.includes("pdf")
                                                                    },
                                                                    render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $305d4b79df7521f3$export$2e2bcd8739ae039), {
                                                                            isDisabled: !allowed_formats?.includes("pdf"),
                                                                            options: $6121a41e444fe2dd$var$orientationPdfOptions,
                                                                            value: $6121a41e444fe2dd$var$orientationPdfOptions.find((c)=>c.value === field.value),
                                                                            onChange: (val)=>field.onChange(val.value)
                                                                        })
                                                                }),
                                                                errors.orientation_pdf && errors.orientation_pdf.type === "required" && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                    class: "help is-danger",
                                                                    children: "This is required"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "columns is-multiline",
                                        children: [
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-6",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    class: "field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            class: "label",
                                                            children: "Enumerar filas"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            class: "control",
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                                name: "enumerate_rows",
                                                                control: control,
                                                                rules: {
                                                                    required: false
                                                                },
                                                                defaultValue: false,
                                                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $305d4b79df7521f3$export$2e2bcd8739ae039), {
                                                                        options: $6121a41e444fe2dd$var$yesnoOptions,
                                                                        value: $6121a41e444fe2dd$var$yesnoOptions.find((c)=>c.value === field.value),
                                                                        onChange: (val)=>field.onChange(val.value)
                                                                    })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-6",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    className: "field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            class: "label",
                                                            children: "Tipo de modulo"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            className: "control",
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                                name: "modulesreport_id",
                                                                control: control,
                                                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ea3e1723cd1809aa$export$62ae509949bd1704), {
                                                                        inputRef: field.ref,
                                                                        defaultOptions: true,
                                                                        isClearable: true,
                                                                        loadOptions: loadOptionsModules,
                                                                        additional: {
                                                                            page: 1
                                                                        },
                                                                        styles: {
                                                                            menuPortal: (base)=>({
                                                                                    ...base,
                                                                                    zIndex: 9999
                                                                                })
                                                                        },
                                                                        menuPortalTarget: document.body,
                                                                        value: modulesRecord.find((c)=>c.value === field.value) || null,
                                                                        onChange: (val)=>field.onChange(val?.value)
                                                                    })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-6",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    class: "field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            class: "label",
                                                            children: "Funcion personalizada"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            class: "control",
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                                name: "has_func_callable",
                                                                control: control,
                                                                rules: {
                                                                    required: false
                                                                },
                                                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $305d4b79df7521f3$export$2e2bcd8739ae039), {
                                                                        options: $6121a41e444fe2dd$var$yesnoOptions,
                                                                        value: $6121a41e444fe2dd$var$yesnoOptions.find((c)=>c.value === field.value),
                                                                        onChange: (val)=>field.onChange(val.value)
                                                                    })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                        className: "field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                                class: "label",
                                                                children: "Funcion personalizada"
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                className: "control",
                                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                    class: "button is-link is-small",
                                                                    onClick: ()=>setFunctionModal(true),
                                                                    children: "Editar funcion personalizada"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $847f4fd944f587cf$export$2e2bcd8739ae039), {
                                                        title: "Editando funcion personalizada",
                                                        active: functionModal,
                                                        onClose: ()=>setFunctionModal(false),
                                                        actions: false,
                                                        customStyle: {
                                                            width: "940px"
                                                        },
                                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                            name: "func_str",
                                                            control: control,
                                                            defaultValue: $6121a41e444fe2dd$var$srcCodePython,
                                                            render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $9ba973d84ca2580a$export$2e2bcd8739ae039), {
                                                                            editable: has_func_callable,
                                                                            height: "400px",
                                                                            value: field.value,
                                                                            extensions: [
                                                                                (0, $9b279a52b78ce875$export$3ccdad7705c71630)()
                                                                            ],
                                                                            onChange: (value, viewUpdate)=>{
                                                                                field.onChange(value);
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                            class: "tags field",
                                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                onClick: ()=>{
                                                                                    field.onChange($6121a41e444fe2dd$var$srcTitlePython);
                                                                                },
                                                                                className: "tag is-link",
                                                                                children: "Funcion con titulo personalizado"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-12",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    className: "field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            class: "label",
                                                            children: "Clientes permitidos"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            className: "control",
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                                name: "clients_allowed",
                                                                control: control,
                                                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ea3e1723cd1809aa$export$62ae509949bd1704), {
                                                                        inputRef: field.ref,
                                                                        isMulti: true,
                                                                        isClearable: true,
                                                                        defaultOptions: true,
                                                                        placeholder: "Todos",
                                                                        loadOptions: loadOptions,
                                                                        additional: {
                                                                            page: 1
                                                                        },
                                                                        styles: {
                                                                            menuPortal: (base)=>({
                                                                                    ...base,
                                                                                    zIndex: 9999
                                                                                })
                                                                        },
                                                                        menuPortalTarget: document.body,
                                                                        value: clientsRecord.filter((value, index, self)=>self.map((x)=>x.value).indexOf(value.value) == index).filter((c)=>{
                                                                            return field.value?.includes(c.value);
                                                                        }),
                                                                        onChange: (val)=>{
                                                                            if (val == null) field.onChange([]);
                                                                            else field.onChange(val?.map((el)=>el.value));
                                                                        }
                                                                    })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-12",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    className: "field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            class: "label",
                                                            children: "Ocultar a clientes"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            className: "control",
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                                name: "clients_not_allowed",
                                                                control: control,
                                                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ea3e1723cd1809aa$export$62ae509949bd1704), {
                                                                        inputRef: field.ref,
                                                                        isMulti: true,
                                                                        isClearable: true,
                                                                        defaultOptions: true,
                                                                        placeholder: "Ninguno",
                                                                        loadOptions: loadOptions,
                                                                        additional: {
                                                                            page: 1
                                                                        },
                                                                        styles: {
                                                                            menuPortal: (base)=>({
                                                                                    ...base,
                                                                                    zIndex: 9999
                                                                                })
                                                                        },
                                                                        menuPortalTarget: document.body,
                                                                        value: clientsRecord.filter((value, index, self)=>self.map((x)=>x.value).indexOf(value.value) == index).filter((c)=>{
                                                                            return field.value?.includes(c.value);
                                                                        }),
                                                                        onChange: (val)=>{
                                                                            if (val == null) field.onChange([]);
                                                                            else field.onChange(val?.map((el)=>el.value));
                                                                        }
                                                                    })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-6",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    className: "field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            class: "label",
                                                            children: "Antiguo ID"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            class: "control",
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                                                ...register("old_id", {
                                                                    valueAsNumber: true
                                                                }),
                                                                class: "input",
                                                                type: "number",
                                                                placeholder: ""
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-6",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    className: "field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            class: "label",
                                                            children: "Total de sumas"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            class: "control",
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                                name: "has_total_sums",
                                                                control: control,
                                                                rules: {
                                                                    required: false
                                                                },
                                                                defaultValue: false,
                                                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $305d4b79df7521f3$export$2e2bcd8739ae039), {
                                                                        options: $6121a41e444fe2dd$var$yesnoOptions,
                                                                        value: $6121a41e444fe2dd$var$yesnoOptions.find((c)=>c.value === field.value),
                                                                        onChange: (val)=>field.onChange(val.value)
                                                                    })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-6",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    className: "field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            class: "label",
                                                            children: "Fuente monoespaceada"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            class: "control",
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                                name: "has_monospaced_font",
                                                                control: control,
                                                                rules: {
                                                                    required: false
                                                                },
                                                                defaultValue: false,
                                                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $305d4b79df7521f3$export$2e2bcd8739ae039), {
                                                                        options: $6121a41e444fe2dd$var$yesnoOptions,
                                                                        value: $6121a41e444fe2dd$var$yesnoOptions.find((c)=>c.value === field.value),
                                                                        onChange: (val)=>field.onChange(val.value)
                                                                    })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-6",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    class: "field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            class: "label",
                                                            children: "Activo"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            class: "control",
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                                name: "active",
                                                                control: control,
                                                                rules: {
                                                                    required: false
                                                                },
                                                                defaultValue: true,
                                                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $305d4b79df7521f3$export$2e2bcd8739ae039), {
                                                                        options: $6121a41e444fe2dd$var$yesnoOptions,
                                                                        value: $6121a41e444fe2dd$var$yesnoOptions.find((c)=>c.value === field.value),
                                                                        onChange: (val)=>field.onChange(val.value)
                                                                    })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-6",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    className: "field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            class: "label",
                                                            children: "Tipos de etiqueta"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            className: "control",
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                                name: "subtags",
                                                                control: control,
                                                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ea3e1723cd1809aa$export$62ae509949bd1704), {
                                                                        inputRef: field.ref,
                                                                        isMulti: true,
                                                                        isClearable: true,
                                                                        defaultOptions: true,
                                                                        placeholder: "Todos",
                                                                        loadOptions: loadOptionsTags,
                                                                        additional: {
                                                                            page: 1
                                                                        },
                                                                        styles: {
                                                                            menuPortal: (base)=>({
                                                                                    ...base,
                                                                                    zIndex: 9999
                                                                                })
                                                                        },
                                                                        menuPortalTarget: document.body,
                                                                        ...field
                                                                    })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-6",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    className: "field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            class: "label",
                                                            children: "Padre de reporte"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            className: "control",
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                                name: "parent_report",
                                                                control: control,
                                                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ea3e1723cd1809aa$export$62ae509949bd1704), {
                                                                        inputRef: field.ref,
                                                                        isMulti: false,
                                                                        isClearable: true,
                                                                        defaultOptions: true,
                                                                        placeholder: "Seleccione",
                                                                        loadOptions: loadOptionsParentReports,
                                                                        additional: {
                                                                            page: 1
                                                                        },
                                                                        styles: {
                                                                            menuPortal: (base)=>({
                                                                                    ...base,
                                                                                    zIndex: 9999
                                                                                })
                                                                        },
                                                                        menuPortalTarget: document.body,
                                                                        ...field
                                                                    })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-6",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    className: "field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            class: "label",
                                                            children: "Filtro principal"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            className: "control",
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                                name: "main_filter_id",
                                                                control: control,
                                                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ea3e1723cd1809aa$export$62ae509949bd1704), {
                                                                        inputRef: field.ref,
                                                                        isMulti: false,
                                                                        isClearable: true,
                                                                        defaultOptions: true,
                                                                        placeholder: "Seleccione",
                                                                        loadOptions: loadOptionsComponents,
                                                                        additional: {
                                                                            page: 1
                                                                        },
                                                                        styles: {
                                                                            menuPortal: (base)=>({
                                                                                    ...base,
                                                                                    zIndex: 9999
                                                                                })
                                                                        },
                                                                        menuPortalTarget: document.body,
                                                                        ...field
                                                                    })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-6",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    className: "field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            class: "label",
                                                            children: "Filtro secundarios"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            className: "control",
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                                name: "secondary_filters",
                                                                control: control,
                                                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ea3e1723cd1809aa$export$62ae509949bd1704), {
                                                                        inputRef: field.ref,
                                                                        isMulti: true,
                                                                        isClearable: true,
                                                                        defaultOptions: true,
                                                                        placeholder: "Seleccione",
                                                                        loadOptions: loadOptionsComponents,
                                                                        additional: {
                                                                            page: 1
                                                                        },
                                                                        styles: {
                                                                            menuPortal: (base)=>({
                                                                                    ...base,
                                                                                    zIndex: 9999
                                                                                })
                                                                        },
                                                                        menuPortalTarget: document.body,
                                                                        ...field
                                                                    })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column is-6",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    class: "field",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                                            class: "label",
                                                            children: "Orden"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                            class: "control",
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                                                ...register("order", {
                                                                    valueAsNumber: true
                                                                }),
                                                                class: "input",
                                                                type: "number",
                                                                placeholder: ""
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "field columns",
                                        children: [
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                                    type: "submit",
                                                    class: "button is-link",
                                                    children: "Guardar"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                className: "column",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                                    class: "button is-link p10",
                                                    onClick: ()=>{
                                                        (0, $8ea79db61ca199dd$export$4cb887bfde2d34ca)("/", true);
                                                    },
                                                    children: "Cancelar"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "column is-6",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card events-card",
                            style: {
                                marginBottom: "2rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                        class: "card-header-title",
                                        children: "Cabeceras"
                                    })
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "card-content",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                            name: "headers",
                                            control: control,
                                            rules: {
                                                required: true
                                            },
                                            defaultValue: [],
                                            render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $fb18d5c1de8a02b4$export$2e2bcd8739ae039), {
                                                        value: field.value,
                                                        onChange: field.onChange
                                                    })
                                                })
                                        }),
                                        errors.headers && errors.headers.type === "required" && /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                            class: "help is-danger",
                                            children: "This is required"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                            className: "control field",
                                            children: [
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                    name: "total_custom_title",
                                                    control: control,
                                                    rules: {
                                                        required: false
                                                    },
                                                    defaultValue: "",
                                                    render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $847f4fd944f587cf$export$2e2bcd8739ae039), {
                                                            title: "Editando titiulo de total de rango",
                                                            active: customTitleRangeModal,
                                                            actions: false,
                                                            onClose: ()=>setCustomTitleRangeModal(false),
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                className: "columns is-multiline",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                        className: "column",
                                                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("textarea", {
                                                                            class: "textarea",
                                                                            placeholder: "e.g. Hello world",
                                                                            value: field.value,
                                                                            onChange: field.onChange
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                        className: "column is-12",
                                                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                            class: "tags",
                                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                onClick: ()=>{
                                                                                    field.onChange(field.value + `{{ "key"|t }}`);
                                                                                },
                                                                                class: "tag is-primary",
                                                                                children: "Insertar traduccion"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                    name: "custom_group_title",
                                                    control: control,
                                                    rules: {
                                                        required: false
                                                    },
                                                    defaultValue: "",
                                                    render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $847f4fd944f587cf$export$2e2bcd8739ae039), {
                                                            title: "Editando titulo de cabecera",
                                                            active: titleGroupedModal,
                                                            actions: false,
                                                            onClose: ()=>setTitleGroupedModal(false),
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                className: "columns is-multiline",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                        className: "column",
                                                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("textarea", {
                                                                            class: "textarea",
                                                                            placeholder: "e.g. Hello world",
                                                                            value: field.value,
                                                                            onChange: field.onChange
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                        className: "column is-12",
                                                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                            class: "tags",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                    onClick: ()=>{
                                                                                        field.onChange(field.value + "//t");
                                                                                    },
                                                                                    class: "tag is-primary",
                                                                                    children: "Nueva columna"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                    onClick: ()=>{
                                                                                        field.onChange(field.value + `{{ "key"|t }}`);
                                                                                    },
                                                                                    class: "tag is-primary",
                                                                                    children: "Insertar traduccion"
                                                                                }),
                                                                                headers.map((el)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                                class: "tag is-link",
                                                                                                onClick: ()=>addTag(field, el.label, "label"),
                                                                                                children: [
                                                                                                    el.label,
                                                                                                    ".Label"
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                                class: "tag is-warning",
                                                                                                onClick: ()=>addTag(field, el.label, "value"),
                                                                                                children: [
                                                                                                    el.label,
                                                                                                    ".Value"
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }))
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                                    name: "footer_custom_title",
                                                    control: control,
                                                    rules: {
                                                        required: false
                                                    },
                                                    defaultValue: "",
                                                    render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $847f4fd944f587cf$export$2e2bcd8739ae039), {
                                                            title: "Editando titulo de pie de pagina",
                                                            active: footerTitleModal,
                                                            actions: false,
                                                            onClose: ()=>setFooterTitleModal(false),
                                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                className: "columns is-multiline",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                        className: "column",
                                                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("textarea", {
                                                                            class: "textarea",
                                                                            placeholder: "e.g. Hello world",
                                                                            value: field.value,
                                                                            onChange: field.onChange
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                        className: "column is-12",
                                                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                                            class: "tags",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                    onClick: ()=>{
                                                                                        field.onChange(field.value + `{{ "key"|t }}`);
                                                                                    },
                                                                                    class: "tag is-primary",
                                                                                    children: "Insertar traduccion"
                                                                                }),
                                                                                headers.filter((el)=>el.grouped).map((el)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $7Do5B.Fragment), {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                                class: "tag is-link",
                                                                                                onClick: ()=>addTag(field, el.label, "label"),
                                                                                                children: [
                                                                                                    el.label,
                                                                                                    ".Label"
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                                class: "tag is-warning",
                                                                                                onClick: ()=>addTag(field, el.label, "value"),
                                                                                                children: [
                                                                                                    el.label,
                                                                                                    ".Value"
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }))
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    className: "buttons",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                            onClick: ()=>{
                                                                if (headers.some((item)=>item.grouped)) setTitleGroupedModal((prev)=>!prev);
                                                            },
                                                            class: "button is-link",
                                                            disabled: !headers.some((item)=>item.grouped),
                                                            children: [
                                                                "Titulo de cabecera",
                                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                    label: "Editar titulo de las columnas agrupadas"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                            onClick: ()=>setFooterTitleModal(true),
                                                            class: "button is-link",
                                                            children: "Titulo de pie de pagina"
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                            onClick: ()=>setCustomTitleRangeModal(true),
                                                            class: "button is-link",
                                                            children: "Titulo de total del rango"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card events-card",
                            style: {
                                marginBottom: "2rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                        class: "card-header-title",
                                        children: "Filtros"
                                    })
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "card-content",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                        name: "filters",
                                        control: control,
                                        render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $3268a80f60e81387$export$2e2bcd8739ae039), {
                                                value: field.value,
                                                onChange: (val)=>{
                                                    field.onChange(val);
                                                }
                                            })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card events-card",
                            style: {
                                marginBottom: "2rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                        class: "card-header-title",
                                        children: "Traducciones"
                                    })
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    className: "card-content",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                        name: "translations",
                                        control: control,
                                        render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $41f55b004dc4fc40$export$2e2bcd8739ae039), {
                                                ...field
                                            })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $6121a41e444fe2dd$export$2e2bcd8739ae039 = $6121a41e444fe2dd$var$CreateReportPage;



parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");





parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");






const $5bc413fc82d0bdf2$var$options = [
    {
        label: "int",
        value: "int"
    },
    {
        label: "string",
        value: "string"
    },
    {
        label: "date",
        value: "date"
    },
    {
        label: "datetime",
        value: "datetime"
    },
    {
        label: "time",
        value: "time"
    },
    {
        label: "fulltime",
        value: "fulltime"
    },
    {
        label: "float",
        value: "float"
    },
    {
        label: "temperatura",
        value: "temperature"
    },
    {
        label: "Unidades de conversion Km/Mi",
        value: "units_of_length"
    },
    {
        label: "Horas calculadas",
        value: "estimated_time"
    }
];
const $5bc413fc82d0bdf2$var$yesnoOptions = [
    {
        label: "Si",
        value: true
    },
    {
        label: "No",
        value: false
    }
];
const $5bc413fc82d0bdf2$var$HeaderModal = ({ activeModal: activeModal, handleClose: handleClose, reloadPage: reloadPage, id: id = null })=>{
    const { register: register, handleSubmit: handleSubmit, reset: reset, setValue: setValue, getValues: getValues, control: control, watch: watch } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        defaultValues: {
            display_type: "string"
        }
    });
    const [data, setData] = (0, $3aPmr.useState)("");
    const [langs, setLanguages] = (0, $3aPmr.useState)([]);
    const isAddMode = !id;
    const display_type = watch("display_type");
    window.reset = reset;
    (0, $3aPmr.useEffect)(()=>{
        reset();
        if (!isAddMode) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/headers/${id}`).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            const fields = [
                "name",
                "value",
                "display_type",
                "translations",
                "countable",
                "truncable_text",
                "truncable_text_length",
                "width_pdf",
                "custom_template"
            ];
            fields.forEach((field)=>setValue(field, res[field]));
        });
    }, [
        id,
        activeModal
    ]);
    const onSubmit = (data)=>{
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/headers/${isAddMode ? "" : id}`, {
            method: isAddMode ? "POST" : "PUT",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            reset();
            reloadPage();
            handleClose();
        }).catch((error)=>{
            console.log(error);
        });
    };
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $847f4fd944f587cf$export$2e2bcd8739ae039), {
        active: activeModal,
        onClose: handleClose,
        title: isAddMode ? "Crear cabecera" : "Editar cabecera",
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("form", {
            id: "form",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Nombre"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                ...register("name"),
                                class: "input",
                                type: "text",
                                placeholder: "",
                                required: true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "SQL"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                ...register("value"),
                                class: "input",
                                type: "text",
                                placeholder: "",
                                required: true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "columns",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "column is-6",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                class: "field",
                                children: [
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                        class: "label",
                                        children: "Tipo de datos"
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "control",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                            name: "display_type",
                                            control: control,
                                            rules: {
                                                required: true
                                            },
                                            render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $305d4b79df7521f3$export$2e2bcd8739ae039), {
                                                    options: $5bc413fc82d0bdf2$var$options,
                                                    styles: {
                                                        menuPortal: (base)=>({
                                                                ...base,
                                                                zIndex: 9999
                                                            })
                                                    },
                                                    menuPortalTarget: document.body,
                                                    value: $5bc413fc82d0bdf2$var$options.find((c)=>c.value === field.value),
                                                    onChange: (val)=>{
                                                        field.onChange(val.value);
                                                        if (![
                                                            "int",
                                                            "float",
                                                            "estimated_time"
                                                        ].includes(val.value)) {
                                                            console.log('se cambio');
                                                            setValue("countable", false);
                                                        }
                                                    }
                                                })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "column is-6",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                        class: "label",
                                        children: "Ancho de columna en PDF"
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "control",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                            ...register("width_pdf"),
                                            class: "input",
                                            type: "text",
                                            placeholder: ""
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "columns",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "column is-6",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                        class: "label",
                                        children: "Permitir truncar el texto"
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "control",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                            name: "truncable_text",
                                            defaultValue: false,
                                            control: control,
                                            rules: {},
                                            render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $305d4b79df7521f3$export$2e2bcd8739ae039), {
                                                    options: $5bc413fc82d0bdf2$var$yesnoOptions,
                                                    styles: {
                                                        menuPortal: (base)=>({
                                                                ...base,
                                                                zIndex: 9999
                                                            })
                                                    },
                                                    menuPortalTarget: document.body,
                                                    value: $5bc413fc82d0bdf2$var$yesnoOptions.find((c)=>c.value === field.value),
                                                    onChange: (val)=>field.onChange(val.value)
                                                })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "column is-6",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                        class: "label",
                                        children: "Tama\xf1o permitido para truncar"
                                    }),
                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        className: "control",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                            ...register("truncable_text_length"),
                                            class: "input",
                                            type: "text",
                                            placeholder: ""
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Sumar columna"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                name: "countable",
                                defaultValue: false,
                                control: control,
                                rules: {},
                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $305d4b79df7521f3$export$2e2bcd8739ae039), {
                                        isDisabled: ![
                                            "int",
                                            "float",
                                            "estimated_time"
                                        ].includes(display_type),
                                        options: $5bc413fc82d0bdf2$var$yesnoOptions,
                                        styles: {
                                            menuPortal: (base)=>({
                                                    ...base,
                                                    zIndex: 9999
                                                })
                                        },
                                        menuPortalTarget: document.body,
                                        value: $5bc413fc82d0bdf2$var$yesnoOptions.find((c)=>c.value === field.value),
                                        onChange: (val)=>field.onChange(val.value)
                                    })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Plantilla"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("textarea", {
                                ...register("custom_template"),
                                class: "textarea",
                                placeholder: "e.g. Hello world"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Traducciones"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                name: "translations",
                                control: control,
                                rules: {
                                    required: false
                                },
                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $41f55b004dc4fc40$export$2e2bcd8739ae039), {
                                        ...field
                                    })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $5bc413fc82d0bdf2$export$2e2bcd8739ae039 = $5bc413fc82d0bdf2$var$HeaderModal;



parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");






const $a92b537b44943631$var$ReportAssociatedModal = ({ activeModal: activeModal, handleClose: handleClose, headerId: headerId = null })=>{
    const [items, setData] = (0, $3aPmr.useState)([]);
    (0, $3aPmr.useEffect)(()=>{
        if (headerId) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/headers/${headerId}/list-reports`).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            setData(res);
        });
    }, [
        headerId
    ]);
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $847f4fd944f587cf$export$2e2bcd8739ae039), {
        actions: false,
        active: activeModal,
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
            class: "content",
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("h3", {
                    children: "Reportes asociados:"
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("ul", {
                    children: items.map((el)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                    href: `/reports/${el.id}`,
                                    children: [
                                        "ID: ",
                                        el.id,
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                    children: [
                                        " ",
                                        el.name
                                    ]
                                })
                            ]
                        }))
                })
            ]
        })
    });
};
var $a92b537b44943631$export$2e2bcd8739ae039 = $a92b537b44943631$var$ReportAssociatedModal;




function $c8a2791dfdeb5f9f$var$getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
    if (!results) return "";
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
const $c8a2791dfdeb5f9f$var$Headers = ()=>{
    const [data, setData] = (0, $3aPmr.useState)({
        records: [],
        total: 0,
        per_page: 20
    });
    const [query, setQuery] = (0, $3aPmr.useState)($c8a2791dfdeb5f9f$var$getParameterByName("s"));
    const [page, setCurrentPage] = (0, $3aPmr.useState)(1);
    const [activeModal, setActiveModal] = (0, $3aPmr.useState)($c8a2791dfdeb5f9f$var$getParameterByName("id") ? !!$c8a2791dfdeb5f9f$var$getParameterByName("s") : false);
    const [activeModalReports, setActiveModalReports] = (0, $3aPmr.useState)(false);
    const [activeId, setActiveId] = (0, $3aPmr.useState)($c8a2791dfdeb5f9f$var$getParameterByName("id"));
    const [activeHeaderId, setActiveHeaderId] = (0, $3aPmr.useState)(null);
    const debouncedSearchTerm = (0, $f51453fda9f7f538$export$21805fee57372823)(query, 500);
    const handleClose = ()=>{
        setActiveModal(false);
        setActiveId(null);
    };
    const handleDelete = (id)=>{
        let result = confirm("\xbfEst\xe1 seguro de querer eliminar este objeto? ");
        if (result) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/headers/${id}`, {
            method: "DELETE"
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            fetchData();
        });
    };
    const fetchData = ()=>{
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/headers?page=${page}&q=${debouncedSearchTerm}`).then((resp)=>{
            if (resp.ok) return resp.json();
            throw new Error("something went wrong while requesting posts");
        }).then((data)=>setData(data));
    };
    const cloneHeader = (id)=>{
        let result = confirm("\xbfEst\xe1s seguro de querer clonar este objeto? ");
        if (result) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/headers/${id}/clone`, {
            method: "POST"
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            fetchData();
        });
    };
    (0, $3aPmr.useEffect)(()=>{
        setCurrentPage(1);
        fetchData();
    }, [
        debouncedSearchTerm
    ]);
    (0, $3aPmr.useEffect)(()=>{
        fetchData();
    }, [
        page
    ]);
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $96253dbc841a0a6f$export$2e2bcd8739ae039), {
        breadcrumbs: [
            "Cabeceras"
        ],
        searchBar: (e)=>setQuery(e.target.value),
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $5bc413fc82d0bdf2$export$2e2bcd8739ae039), {
                activeModal: activeModal,
                handleClose: handleClose,
                reloadPage: fetchData,
                id: activeId
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $a92b537b44943631$export$2e2bcd8739ae039), {
                activeModal: activeModalReports,
                handleClose: ()=>setActiveModalReports(false),
                headerId: activeHeaderId
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                className: "columns is-multiline",
                style: {
                    margin: "1rem 0"
                },
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-12",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card events-card",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                            class: "card-header-title",
                                            children: "Cabeceras"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            class: "card-header-icon",
                                            "aria-label": "more options",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                    class: "fa fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "card-table",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "content",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("table", {
                                            class: "table is-fullwidth is-striped",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tbody", {
                                                children: data.records.length ? data.records.map((item)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                width: "5%"
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                children: item.name
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                class: "level-right actions",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-info is-light",
                                                                        onClick: ()=>{
                                                                            setActiveHeaderId(item.id);
                                                                            setActiveModalReports(true);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Ver reportes asociados",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "description"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-warning is-light",
                                                                        onClick: ()=>cloneHeader(item.id),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Clonar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "repeat"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-link",
                                                                        onClick: ()=>{
                                                                            setActiveId(item.id);
                                                                            setActiveModal(true);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Editar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "edit_note"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-danger",
                                                                        onClick: ()=>{
                                                                            handleDelete(item.id);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Eliminar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "delete"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, item.id)) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    style: "text-align: center;",
                                                    children: "No hay datos para mostrar"
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("footer", {
                                    class: "card-footer",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                        onClick: ()=>setActiveModal(true),
                                        class: "card-footer-item",
                                        children: "Crear cabecera"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-12",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                            class: "card-header-title",
                                            children: "Paginas"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            class: "card-header-icon",
                                            "aria-label": "more options",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                    class: "fa fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "card-content",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $22b2f8f41c3b0593$export$2e2bcd8739ae039), {
                                            total: data.total,
                                            page: page,
                                            setCurrentPage: setCurrentPage,
                                            pageSize: data.per_page
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $c8a2791dfdeb5f9f$export$2e2bcd8739ae039 = $c8a2791dfdeb5f9f$var$Headers;



parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");





parcelRequire("7Do5B");



var $3aPmr = parcelRequire("3aPmr");




const $158f02cc7468eabf$var$options = [
    {
        value: "date",
        label: "Date"
    },
    {
        value: "int",
        label: "Integer"
    },
    {
        value: "replace",
        label: "Replace"
    },
    {
        value: "string",
        label: "String"
    }
];
const $158f02cc7468eabf$var$FilterModal = ({ activeModal: activeModal, handleClose: handleClose, reloadPage: reloadPage, id: id = null })=>{
    const { register: register, handleSubmit: handleSubmit, reset: reset, setValue: setValue, getValues: getValues, control: control } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)();
    const [data, setData] = (0, $3aPmr.useState)("");
    const [componentsRecord, setComponents] = (0, $3aPmr.useState)([]);
    const isAddMode = !id;
    (0, $3aPmr.useEffect)(()=>{
        reset({
            parameter_name: "",
            parameter_sql: "",
            display_type: "",
            component_id: ""
        });
        if (!isAddMode) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/filters/${id}`).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            const fields = [
                "parameter_name",
                "parameter_sql",
                "display_type",
                "component_id"
            ];
            fields.forEach((field)=>setValue(field, res[field]));
            if (res.component_id) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/components/${res.component_id}`).then((res)=>{
                if (res.ok) return res.json();
                return Promise.reject(res);
            }).then((res)=>{
                // setComponents((prev) => [{ label: res.name, value: res.id }]);
                setValue("component_id", {
                    label: res.name,
                    value: res.id
                });
            });
        });
    }, [
        id
    ]);
    const loadOptions = async (search, loadedOptions, { page: page })=>{
        const response = await (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/components/?q=${search}&page=${page}`);
        const responseJSON = await response.json();
        const options = responseJSON.records.map((el)=>({
                value: el.id,
                label: el.name
            }));
        setComponents((prev)=>[
                ...prev,
                options
            ]);
        return {
            options: options,
            hasMore: responseJSON.total_pages > responseJSON.page,
            additional: {
                page: page + 1
            }
        };
    };
    const onSubmit = (data)=>{
        data.component_id = data.component_id?.value ? data.component_id.value : null;
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/filters/${isAddMode ? "" : id}`, {
            method: isAddMode ? "POST" : "PUT",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            reset();
            reloadPage();
            handleClose();
        }).catch((error)=>{
            console.log(error);
        });
    };
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $847f4fd944f587cf$export$2e2bcd8739ae039), {
        active: activeModal,
        onClose: handleClose,
        title: isAddMode ? "Crear filtro" : "Editar filtro",
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("form", {
            id: "form",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Nombre"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                ...register("parameter_name"),
                                class: "input",
                                type: "text",
                                placeholder: "",
                                required: true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "SQL"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                ...register("parameter_sql"),
                                class: "input",
                                type: "text",
                                placeholder: "",
                                required: true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "columns",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "field column is-6",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                    class: "label",
                                    children: "Tipo de dato"
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "control",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                        name: "display_type",
                                        control: control,
                                        rules: {
                                            required: true
                                        },
                                        render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $305d4b79df7521f3$export$2e2bcd8739ae039), {
                                                inputRef: field.ref,
                                                options: $158f02cc7468eabf$var$options,
                                                styles: {
                                                    menuPortal: (base)=>({
                                                            ...base,
                                                            zIndex: 9999
                                                        })
                                                },
                                                menuPortalTarget: document.body,
                                                value: $158f02cc7468eabf$var$options.find((c)=>c.value === field.value),
                                                onChange: (val)=>field.onChange(val.value)
                                            })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "field column is-6",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                    class: "label",
                                    children: "Componente"
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "control",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                        name: "component_id",
                                        control: control,
                                        render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ea3e1723cd1809aa$export$62ae509949bd1704), {
                                                inputRef: field.ref,
                                                isClearable: true,
                                                loadOptions: loadOptions,
                                                additional: {
                                                    page: 1
                                                },
                                                styles: {
                                                    menuPortal: (base)=>({
                                                            ...base,
                                                            zIndex: 9999
                                                        })
                                                },
                                                menuPortalTarget: document.body,
                                                ...field
                                            })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $158f02cc7468eabf$export$2e2bcd8739ae039 = $158f02cc7468eabf$var$FilterModal;




parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");






const $2f24114b4be594c2$var$ReportAssociatedModal = ({ activeModal: activeModal, handleClose: handleClose, filterId: filterId = null })=>{
    const [items, setData] = (0, $3aPmr.useState)([]);
    (0, $3aPmr.useEffect)(()=>{
        if (filterId) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/filters/${filterId}/list-reports`).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            setData(res);
        });
    }, [
        filterId
    ]);
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $847f4fd944f587cf$export$2e2bcd8739ae039), {
        actions: false,
        active: activeModal,
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
            class: "content",
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("h3", {
                    children: "Reportes asociados:"
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("ul", {
                    children: items.map((el)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("li", {
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                    href: `/reports/${el.id}`,
                                    children: [
                                        "ID: ",
                                        el.id,
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                    children: [
                                        " ",
                                        el.name
                                    ]
                                })
                            ]
                        }))
                })
            ]
        })
    });
};
var $2f24114b4be594c2$export$2e2bcd8739ae039 = $2f24114b4be594c2$var$ReportAssociatedModal;



const $f87035bfae577eb4$var$Filters = ()=>{
    const [data, setData] = (0, $3aPmr.useState)({
        records: [],
        total: 0,
        per_page: 20
    });
    const [query, setQuery] = (0, $3aPmr.useState)("");
    const [page, setCurrentPage] = (0, $3aPmr.useState)(1);
    const [activeModal, setActiveModal] = (0, $3aPmr.useState)(false);
    const [activeModalReports, setActiveModalReports] = (0, $3aPmr.useState)(false);
    const [activeId, setActiveId] = (0, $3aPmr.useState)(null);
    const [activeFilterId, setActiveFilterId] = (0, $3aPmr.useState)(null);
    const debouncedSearchTerm = (0, $f51453fda9f7f538$export$21805fee57372823)(query, 500);
    const handleClose = ()=>{
        setActiveModal(false);
        setActiveId(null);
    };
    const handleDelete = (id)=>{
        let result = confirm("\xbfEst\xe1 seguro de querer eliminar este objeto? ");
        if (result) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/filters/${id}`, {
            method: "DELETE"
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            fetchData();
        });
    };
    const fetchData = ()=>{
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/filters?page=${page}&q=${debouncedSearchTerm}`).then((resp)=>{
            if (resp.ok) return resp.json();
            throw new Error("something went wrong while requesting posts");
        }).then((data)=>setData(data));
    };
    (0, $3aPmr.useEffect)(()=>{
        setCurrentPage(1);
        fetchData();
    }, [
        debouncedSearchTerm
    ]);
    (0, $3aPmr.useEffect)(()=>{
        fetchData();
    }, [
        page
    ]);
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $96253dbc841a0a6f$export$2e2bcd8739ae039), {
        breadcrumbs: [
            "Filtros"
        ],
        searchBar: (e)=>setQuery(e.target.value),
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $158f02cc7468eabf$export$2e2bcd8739ae039), {
                activeModal: activeModal,
                handleClose: handleClose,
                reloadPage: fetchData,
                id: activeId
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $2f24114b4be594c2$export$2e2bcd8739ae039), {
                activeModal: activeModalReports,
                handleClose: ()=>setActiveModalReports(false),
                filterId: activeFilterId
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                className: "columns is-multiline",
                style: {
                    margin: "1rem 0"
                },
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-12",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card events-card",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                            class: "card-header-title",
                                            children: "Filtros"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            class: "card-header-icon",
                                            "aria-label": "more options",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                    class: "fa fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "card-table",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "content",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("table", {
                                            class: "table is-fullwidth is-striped",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tbody", {
                                                children: data.records.length ? data.records.map((item)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                width: "5%"
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                children: item.id
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                children: item.parameter_name
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                class: "level-right actions",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-info is-light",
                                                                        onClick: ()=>{
                                                                            setActiveFilterId(item.id);
                                                                            setActiveModalReports(true);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Ver reportes asociados",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "description"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-link",
                                                                        onClick: ()=>{
                                                                            setActiveId(item.id);
                                                                            setActiveModal(true);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Editar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "edit_note"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-danger",
                                                                        onClick: ()=>{
                                                                            handleDelete(item.id);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Eliminar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "delete"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, item.id)) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    style: "text-align: center;",
                                                    children: "No hay datos para mostrar"
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("footer", {
                                    class: "card-footer",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                        onClick: ()=>setActiveModal(true),
                                        class: "card-footer-item",
                                        children: "Crear filtro"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-12",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                            class: "card-header-title",
                                            children: "Paginas"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            class: "card-header-icon",
                                            "aria-label": "more options",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                    class: "fa fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "card-content",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $22b2f8f41c3b0593$export$2e2bcd8739ae039), {
                                            total: data.total,
                                            page: page,
                                            setCurrentPage: setCurrentPage,
                                            pageSize: data.per_page
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $f87035bfae577eb4$export$2e2bcd8739ae039 = $f87035bfae577eb4$var$Filters;



parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");





parcelRequire("7Do5B");



var $3aPmr = parcelRequire("3aPmr");


const $fb0002c275d22cc7$var$ComponentModal = ({ activeModal: activeModal, handleClose: handleClose, reloadPage: reloadPage, id: id = null })=>{
    const { register: register, handleSubmit: handleSubmit, reset: reset, setValue: setValue, getValues: getValues } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)();
    const [data, setData] = (0, $3aPmr.useState)("");
    const isAddMode = !id;
    (0, $3aPmr.useEffect)(()=>{
        reset();
        if (!isAddMode) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/components/${id}`).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            const fields = [
                "name"
            ];
            fields.forEach((field)=>setValue(field, res[field]));
        });
    }, [
        id
    ]);
    const onSubmit = (data)=>{
        const url = "";
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/components/${isAddMode ? "" : id}`, {
            method: isAddMode ? "POST" : "PUT",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            reset();
            reloadPage();
            handleClose();
        }).catch((error)=>{
            console.log(error);
        });
    };
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $847f4fd944f587cf$export$2e2bcd8739ae039), {
        active: activeModal,
        onClose: handleClose,
        title: isAddMode ? "Crear componente" : "Editar componente",
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("form", {
            id: "form",
            onSubmit: handleSubmit(onSubmit),
            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                class: "field",
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                        class: "label",
                        children: "Nombre"
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "control",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                            ...register("name"),
                            class: "input",
                            type: "text",
                            placeholder: "",
                            required: true
                        })
                    })
                ]
            })
        })
    });
};
var $fb0002c275d22cc7$export$2e2bcd8739ae039 = $fb0002c275d22cc7$var$ComponentModal;




const $23c087672af69edd$var$Components = ()=>{
    const [data, setData] = (0, $3aPmr.useState)({
        records: [],
        total: 0,
        per_page: 20
    });
    const [query, setQuery] = (0, $3aPmr.useState)("");
    const [page, setCurrentPage] = (0, $3aPmr.useState)(1);
    const [activeModal, setActiveModal] = (0, $3aPmr.useState)(false);
    const [activeId, setActiveId] = (0, $3aPmr.useState)(null);
    const debouncedSearchTerm = (0, $f51453fda9f7f538$export$21805fee57372823)(query, 500);
    const handleClose = ()=>{
        setActiveModal(false);
        setActiveId(null);
    };
    const handleDelete = (id)=>{
        let result = confirm("\xbfEst\xe1 seguro de querer eliminar este objeto? ");
        if (result) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/components/${id}`, {
            method: "DELETE"
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            fetchData();
        });
    };
    const fetchData = ()=>{
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/components/?page=${page}&q=${debouncedSearchTerm}`).then((resp)=>{
            if (resp.ok) return resp.json();
            throw new Error("something went wrong while requesting posts");
        }).then((data)=>setData(data));
    };
    (0, $3aPmr.useEffect)(()=>{
        setCurrentPage(1);
        fetchData();
    }, [
        debouncedSearchTerm
    ]);
    (0, $3aPmr.useEffect)(()=>{
        fetchData();
    }, [
        page
    ]);
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $96253dbc841a0a6f$export$2e2bcd8739ae039), {
        breadcrumbs: [
            "Componentes"
        ],
        searchBar: (e)=>setQuery(e.target.value),
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $fb0002c275d22cc7$export$2e2bcd8739ae039), {
                activeModal: activeModal,
                handleClose: handleClose,
                reloadPage: fetchData,
                id: activeId
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                className: "columns is-multiline",
                style: {
                    margin: "1rem 0"
                },
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-12",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card events-card",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                            class: "card-header-title",
                                            children: "Componentes"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            class: "card-header-icon",
                                            "aria-label": "more options",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                    class: "fa fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "card-table",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "content",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("table", {
                                            class: "table is-fullwidth is-striped",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tbody", {
                                                children: data.records.length ? data.records.map((item)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                width: "5%"
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                children: item.name
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                class: "level-right actions",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-link",
                                                                        onClick: ()=>{
                                                                            setActiveId(item.id);
                                                                            setActiveModal(true);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Editar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "edit_note"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-danger",
                                                                        onClick: ()=>{
                                                                            handleDelete(item.id);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Eliminar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "delete"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, item.id)) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    style: "text-align: center;",
                                                    children: "No hay datos para mostrar"
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("footer", {
                                    class: "card-footer",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                        onClick: ()=>setActiveModal(true),
                                        class: "card-footer-item",
                                        children: "Crear componente"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-12",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                            class: "card-header-title",
                                            children: "Paginas"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            class: "card-header-icon",
                                            "aria-label": "more options",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                    class: "fa fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "card-content",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $22b2f8f41c3b0593$export$2e2bcd8739ae039), {
                                            total: data.total,
                                            page: page,
                                            setCurrentPage: setCurrentPage,
                                            pageSize: data.per_page
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $23c087672af69edd$export$2e2bcd8739ae039 = $23c087672af69edd$var$Components;



parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");





parcelRequire("7Do5B");



var $3aPmr = parcelRequire("3aPmr");


const $3b1f794d9886a47a$var$ModuleModal = ({ activeModal: activeModal, handleClose: handleClose, reloadPage: reloadPage, id: id = null })=>{
    const { register: register, handleSubmit: handleSubmit, reset: reset, setValue: setValue, getValues: getValues } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)();
    const [data, setData] = (0, $3aPmr.useState)("");
    const isAddMode = !id;
    (0, $3aPmr.useEffect)(()=>{
        reset();
        if (!isAddMode) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/modules/${id}`).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            const fields = [
                "name"
            ];
            fields.forEach((field)=>setValue(field, res[field]));
        });
    }, [
        id
    ]);
    const onSubmit = (data)=>{
        const url = "";
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/modules/${isAddMode ? "" : id}`, {
            method: isAddMode ? "POST" : "PUT",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            reset();
            reloadPage();
            handleClose();
        }).catch((error)=>{
            console.log(error);
        });
    };
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $847f4fd944f587cf$export$2e2bcd8739ae039), {
        active: activeModal,
        onClose: handleClose,
        title: isAddMode ? "Crear modulo" : "Editar modulo",
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("form", {
            id: "form",
            onSubmit: handleSubmit(onSubmit),
            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                class: "field",
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                        class: "label",
                        children: "Nombre"
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "control",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                            ...register("name"),
                            class: "input",
                            type: "text",
                            placeholder: "",
                            required: true
                        })
                    })
                ]
            })
        })
    });
};
var $3b1f794d9886a47a$export$2e2bcd8739ae039 = $3b1f794d9886a47a$var$ModuleModal;




const $239abe524f91bfbc$var$Modules = ()=>{
    const [data, setData] = (0, $3aPmr.useState)({
        records: [],
        total: 0,
        per_page: 20
    });
    const [query, setQuery] = (0, $3aPmr.useState)("");
    const [page, setCurrentPage] = (0, $3aPmr.useState)(1);
    const [activeModal, setActiveModal] = (0, $3aPmr.useState)(false);
    const [activeId, setActiveId] = (0, $3aPmr.useState)(null);
    const debouncedSearchTerm = (0, $f51453fda9f7f538$export$21805fee57372823)(query, 500);
    const handleClose = ()=>{
        setActiveModal(false);
        setActiveId(null);
    };
    const handleDelete = (id)=>{
        let result = confirm("\xbfEst\xe1 seguro de querer eliminar este objeto? ");
        if (result) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/modules/${id}`, {
            method: "DELETE"
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            fetchData();
        });
    };
    const fetchData = ()=>{
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/modules/?page=${page}&q=${debouncedSearchTerm}`).then((resp)=>{
            if (resp.ok) return resp.json();
            throw new Error("something went wrong while requesting posts");
        }).then((data)=>setData(data));
    };
    (0, $3aPmr.useEffect)(()=>{
        setCurrentPage(1);
        fetchData();
    }, [
        debouncedSearchTerm
    ]);
    (0, $3aPmr.useEffect)(()=>{
        fetchData();
    }, [
        page
    ]);
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $96253dbc841a0a6f$export$2e2bcd8739ae039), {
        breadcrumbs: [
            "Modulos"
        ],
        searchBar: (e)=>setQuery(e.target.value),
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $3b1f794d9886a47a$export$2e2bcd8739ae039), {
                activeModal: activeModal,
                handleClose: handleClose,
                reloadPage: fetchData,
                id: activeId
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                className: "columns is-multiline",
                style: {
                    margin: "1rem 0"
                },
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-12",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card events-card",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                            class: "card-header-title",
                                            children: "Modulos"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            class: "card-header-icon",
                                            "aria-label": "more options",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                    class: "fa fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "card-table",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "content",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("table", {
                                            class: "table is-fullwidth is-striped",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tbody", {
                                                children: data.records.length ? data.records.map((item)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                width: "5%"
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                children: item.name
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                class: "level-right actions",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-link",
                                                                        onClick: ()=>{
                                                                            setActiveId(item.id);
                                                                            setActiveModal(true);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Editar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "edit_note"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-danger",
                                                                        onClick: ()=>{
                                                                            handleDelete(item.id);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Eliminar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "delete"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, item.id)) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    style: "text-align: center;",
                                                    children: "No hay datos para mostrar"
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("footer", {
                                    class: "card-footer",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                        onClick: ()=>setActiveModal(true),
                                        class: "card-footer-item",
                                        children: "Crear modulo"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-12",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                            class: "card-header-title",
                                            children: "Paginas"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            class: "card-header-icon",
                                            "aria-label": "more options",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                    class: "fa fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "card-content",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $22b2f8f41c3b0593$export$2e2bcd8739ae039), {
                                            total: data.total,
                                            page: page,
                                            setCurrentPage: setCurrentPage,
                                            pageSize: data.per_page
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $239abe524f91bfbc$export$2e2bcd8739ae039 = $239abe524f91bfbc$var$Modules;



parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");





parcelRequire("7Do5B");



var $3aPmr = parcelRequire("3aPmr");


const $ea2de75e2ac165b9$var$LanguageModal = ({ activeModal: activeModal, handleClose: handleClose, reloadPage: reloadPage, id: id = null })=>{
    const { register: register, handleSubmit: handleSubmit, reset: reset, setValue: setValue, getValues: getValues } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)();
    const [data, setData] = (0, $3aPmr.useState)("");
    const isAddMode = !id;
    (0, $3aPmr.useEffect)(()=>{
        reset();
        if (!isAddMode) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/languages/${id}`).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            const fields = [
                "name",
                "key"
            ];
            fields.forEach((field)=>setValue(field, res[field]));
        });
    }, [
        id
    ]);
    const onSubmit = (data)=>{
        const url = "";
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/languages/${isAddMode ? "" : id}`, {
            method: isAddMode ? "POST" : "PUT",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            reset();
            reloadPage();
            handleClose();
        }).catch((error)=>{
            console.log(error);
        });
    };
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $847f4fd944f587cf$export$2e2bcd8739ae039), {
        active: activeModal,
        onClose: handleClose,
        title: isAddMode ? "Crear idioma" : "Editar idioma",
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("form", {
            id: "form",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Clave"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                ...register("key"),
                                class: "input",
                                type: "text",
                                placeholder: "",
                                required: true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Nombre"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                ...register("name"),
                                class: "input",
                                type: "text",
                                placeholder: "",
                                required: true
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $ea2de75e2ac165b9$export$2e2bcd8739ae039 = $ea2de75e2ac165b9$var$LanguageModal;




const $3f823b58b57b959d$var$Languages = ()=>{
    const [data, setData] = (0, $3aPmr.useState)({
        records: [],
        total: 0,
        per_page: 20
    });
    const [query, setQuery] = (0, $3aPmr.useState)("");
    const [page, setCurrentPage] = (0, $3aPmr.useState)(1);
    const [activeModal, setActiveModal] = (0, $3aPmr.useState)(false);
    const [activeId, setActiveId] = (0, $3aPmr.useState)(null);
    const debouncedSearchTerm = (0, $f51453fda9f7f538$export$21805fee57372823)(query, 500);
    const handleClose = ()=>{
        setActiveModal(false);
        setActiveId(null);
    };
    const fetchData = ()=>{
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/languages/?page=${page}&q=${debouncedSearchTerm}`).then((resp)=>{
            if (resp.ok) return resp.json();
            throw new Error("something went wrong while requesting posts");
        }).then((data)=>setData(data));
    };
    const handleDelete = (id)=>{
        let result = confirm("\xbfEst\xe1 seguro de querer eliminar este objeto? ");
        if (result) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/languages/${id}`, {
            method: "DELETE"
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            fetchData();
        });
    };
    (0, $3aPmr.useEffect)(()=>{
        setCurrentPage(1);
        fetchData();
    }, [
        debouncedSearchTerm
    ]);
    (0, $3aPmr.useEffect)(()=>{
        fetchData();
    }, [
        page
    ]);
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $96253dbc841a0a6f$export$2e2bcd8739ae039), {
        breadcrumbs: [
            "Idiomas"
        ],
        searchBar: (e)=>setQuery(e.target.value),
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ea2de75e2ac165b9$export$2e2bcd8739ae039), {
                activeModal: activeModal,
                handleClose: handleClose,
                reloadPage: fetchData,
                id: activeId
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                className: "columns is-multiline",
                style: {
                    margin: "1rem 0"
                },
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-12",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card events-card",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                            class: "card-header-title",
                                            children: "Idiomas"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            class: "card-header-icon",
                                            "aria-label": "more options",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                    class: "fa fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "card-table",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "content",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("table", {
                                            class: "table is-fullwidth is-striped",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tbody", {
                                                children: data.records.length ? data.records.map((item)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                children: item.key
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                children: item.name
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                class: "level-right actions",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-link",
                                                                        onClick: ()=>{
                                                                            setActiveId(item.id);
                                                                            setActiveModal(true);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Editar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "edit_note"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-danger",
                                                                        onClick: ()=>{
                                                                            handleDelete(item.id);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Eliminar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "delete"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, item.id)) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    style: "text-align: center;",
                                                    children: "No hay datos para mostrar"
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("footer", {
                                    class: "card-footer",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                        onClick: ()=>setActiveModal(true),
                                        class: "card-footer-item",
                                        children: "Crear idioma"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-12",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                            class: "card-header-title",
                                            children: "Paginas"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            class: "card-header-icon",
                                            "aria-label": "more options",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                    class: "fa fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "card-content",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $22b2f8f41c3b0593$export$2e2bcd8739ae039), {
                                            total: data.total,
                                            page: page,
                                            setCurrentPage: setCurrentPage,
                                            pageSize: data.per_page
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $3f823b58b57b959d$export$2e2bcd8739ae039 = $3f823b58b57b959d$var$Languages;



parcelRequire("7Do5B");




const $678b6c90cdf41276$var$LoginPage = ()=>{
    const { register: register, handleSubmit: handleSubmit, reset: reset, setValue: setValue, getValues: getValues } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)();
    const onSubmit = (data)=>{
        fetch(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/auth/login`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            (0, $c683ce1247b5bc0f$export$596d806903d1f59e)(res);
            (0, $8ea79db61ca199dd$export$4cb887bfde2d34ca)("/", true);
        }).catch((err)=>{
            alert("Username or password incorrect");
        });
    };
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("section", {
        class: "hero is-primary is-fullheight",
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
            class: "hero-body",
            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                class: "container",
                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "columns is-centered",
                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-5-tablet is-4-desktop is-3-widescreen",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("form", {
                            onSubmit: handleSubmit(onSubmit),
                            class: "box",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "field",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                            for: "",
                                            class: "label",
                                            children: "Email"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                            class: "control has-icons-left",
                                            children: [
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                                    ...register("email"),
                                                    type: "email",
                                                    placeholder: "",
                                                    class: "input",
                                                    required: true
                                                }),
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                    class: "icon is-small is-left",
                                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                        class: "material-icons",
                                                        children: "perm_identity"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "field",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                                            for: "",
                                            class: "label",
                                            children: "Password"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                            class: "control has-icons-left",
                                            children: [
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                                    type: "password",
                                                    ...register("password"),
                                                    placeholder: "*******",
                                                    class: "input",
                                                    required: true
                                                }),
                                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                    class: "icon is-small is-left",
                                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                        class: "material-icons",
                                                        children: "lock"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "field",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("button", {
                                        class: "button is-success",
                                        children: "Login"
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
var $678b6c90cdf41276$export$2e2bcd8739ae039 = $678b6c90cdf41276$var$LoginPage;



parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");








var $3aPmr = parcelRequire("3aPmr");



const $aacc4cd8aed88ca6$var$defaultValues = {
    lang: "",
    original: "",
    value: ""
};
const $aacc4cd8aed88ca6$var$WordModal = ({ activeModal: activeModal, handleClose: handleClose, reloadPage: reloadPage, id: id = null })=>{
    const { register: register, handleSubmit: handleSubmit, reset: reset, setValue: setValue, getValues: getValues, control: control } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)();
    const [data, setData] = (0, $3aPmr.useState)("");
    const [languagesRecord, setLanguages] = (0, $3aPmr.useState)([]);
    const isAddMode = !id;
    const loadOptions = async (search, loadedOptions, { page: page })=>{
        const response = await (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/languages/?q=${search}&page=${page}`);
        const responseJSON = await response.json();
        const options = responseJSON.records.map((el)=>({
                value: el.key,
                label: el.name
            }));
        setLanguages(options);
        return {
            options: options,
            hasMore: responseJSON.total_pages > responseJSON.page,
            additional: {
                page: page + 1
            }
        };
    };
    (0, $3aPmr.useEffect)(()=>{
        reset($aacc4cd8aed88ca6$var$defaultValues);
        if (!isAddMode) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/words/${id}`).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            reset(res);
        });
    }, [
        id,
        activeModal
    ]);
    const onSubmit = (data)=>{
        const url = "";
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/words/${isAddMode ? "" : id}`, {
            method: isAddMode ? "POST" : "PUT",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            reset();
            reloadPage();
            handleClose();
        }).catch((error)=>{
            console.log(error);
        });
    };
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $847f4fd944f587cf$export$2e2bcd8739ae039), {
        active: activeModal,
        onClose: handleClose,
        title: isAddMode ? "Crear palabra" : "Editar palabra",
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("form", {
            id: "form",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Idioma"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                name: "lang",
                                control: control,
                                rules: {
                                    required: true
                                },
                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ea3e1723cd1809aa$export$62ae509949bd1704), {
                                        inputRef: field.ref,
                                        isClearable: true,
                                        loadOptions: loadOptions,
                                        defaultOptions: true,
                                        additional: {
                                            page: 1
                                        },
                                        styles: {
                                            menuPortal: (base)=>({
                                                    ...base,
                                                    zIndex: 9999
                                                })
                                        },
                                        menuPortalTarget: document.body,
                                        value: languagesRecord.find((c)=>c.value === field.value) || null,
                                        onChange: (val)=>field.onChange(val?.value)
                                    })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Palabra"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                ...register("original"),
                                class: "input",
                                type: "text",
                                placeholder: "",
                                required: true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Traduccion"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                ...register("value"),
                                class: "input",
                                type: "text",
                                placeholder: "",
                                required: true
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $aacc4cd8aed88ca6$export$2e2bcd8739ae039 = $aacc4cd8aed88ca6$var$WordModal;




const $141b77e5e3cca606$var$Words = ()=>{
    const [data, setData] = (0, $3aPmr.useState)({
        records: [],
        total: 0,
        per_page: 20
    });
    const [query, setQuery] = (0, $3aPmr.useState)("");
    const [page, setCurrentPage] = (0, $3aPmr.useState)(1);
    const [activeModal, setActiveModal] = (0, $3aPmr.useState)(false);
    const [activeId, setActiveId] = (0, $3aPmr.useState)(null);
    const debouncedSearchTerm = (0, $f51453fda9f7f538$export$21805fee57372823)(query, 500);
    const handleClose = ()=>{
        setActiveModal(false);
        setActiveId(null);
    };
    const fetchData = ()=>{
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/words/?page=${page}&q=${debouncedSearchTerm}`).then((resp)=>{
            if (resp.ok) return resp.json();
            throw new Error("something went wrong while requesting posts");
        }).then((data)=>setData(data));
    };
    const handleDelete = (id)=>{
        let result = confirm("\xbfEst\xe1 seguro de querer eliminar este objeto? ");
        if (result) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/words/${id}`, {
            method: "DELETE"
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            fetchData();
        });
    };
    (0, $3aPmr.useEffect)(()=>{
        setCurrentPage(1);
        fetchData();
    }, [
        debouncedSearchTerm
    ]);
    (0, $3aPmr.useEffect)(()=>{
        fetchData();
    }, [
        page
    ]);
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $96253dbc841a0a6f$export$2e2bcd8739ae039), {
        breadcrumbs: [
            "Idiomas"
        ],
        searchBar: (e)=>setQuery(e.target.value),
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $aacc4cd8aed88ca6$export$2e2bcd8739ae039), {
                activeModal: activeModal,
                handleClose: handleClose,
                reloadPage: fetchData,
                id: activeId
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                className: "columns is-multiline",
                style: {
                    margin: "1rem 0"
                },
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-12",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card events-card",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                            class: "card-header-title",
                                            children: "Palabras"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            class: "card-header-icon",
                                            "aria-label": "more options",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                    class: "fa fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "card-table",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "content",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("table", {
                                            class: "table is-fullwidth is-striped",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tbody", {
                                                children: data.records.length ? data.records.map((item)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                children: item.lang
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                children: item.original
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                children: item.value
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                class: "level-right actions",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-link",
                                                                        onClick: ()=>{
                                                                            setActiveId(item.id);
                                                                            setActiveModal(true);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Editar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "edit_note"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-danger",
                                                                        onClick: ()=>{
                                                                            handleDelete(item.id);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Eliminar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "delete"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, item.id)) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    style: "text-align: center;",
                                                    children: "No hay datos para mostrar"
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("footer", {
                                    class: "card-footer",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                        onClick: ()=>setActiveModal(true),
                                        class: "card-footer-item",
                                        children: "Crear palabra"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-12",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                            class: "card-header-title",
                                            children: "Paginas"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            class: "card-header-icon",
                                            "aria-label": "more options",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                    class: "fa fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "card-content",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $22b2f8f41c3b0593$export$2e2bcd8739ae039), {
                                            total: data.total,
                                            page: page,
                                            setCurrentPage: setCurrentPage,
                                            pageSize: data.per_page
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $141b77e5e3cca606$export$2e2bcd8739ae039 = $141b77e5e3cca606$var$Words;



parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");







const $8a660de9be0cb0e5$var$Stats = ()=>{
    const [data, setData] = (0, $3aPmr.useState)({
        records: [],
        total: 0,
        per_page: 20
    });
    const [query, setQuery] = (0, $3aPmr.useState)("");
    const [page, setCurrentPage] = (0, $3aPmr.useState)(1);
    const [activeModal, setActiveModal] = (0, $3aPmr.useState)(false);
    const [activeId, setActiveId] = (0, $3aPmr.useState)(null);
    const debouncedSearchTerm = (0, $f51453fda9f7f538$export$21805fee57372823)(query, 500);
    const [clientId, setClientId] = (0, $3aPmr.useState)("");
    const [reportName, setReportName] = (0, $3aPmr.useState)("");
    const handleClose = ()=>{
        setActiveModal(false);
        setActiveId(null);
    };
    const fetchData = ()=>{
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/stats/most-used-reports?client_id=${clientId}&report=${reportName}`).then((resp)=>{
            if (resp.ok) return resp.json();
            throw new Error("something went wrong while requesting posts");
        }).then((data)=>setData(data));
    };
    const loadOptions = async (search, loadedOptions, { page: page })=>{
        const response = await (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/clients/?q=${search}&page=${page}`);
        const responseJSON = await response.json();
        const options = responseJSON.records.map((el)=>({
                value: el.id_client,
                label: el.client
            }));
        return {
            options: options,
            hasMore: responseJSON.total_pages > responseJSON.page,
            additional: {
                page: page + 1
            }
        };
    };
    const loadReportsOptions = async (search, loadedOptions, { page: page })=>{
        const response = await (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/reports/?q=${search}&page=${page}`);
        const responseJSON = await response.json();
        const options = responseJSON.records.map((el)=>({
                value: el.name,
                label: el.name
            }));
        return {
            options: options,
            hasMore: responseJSON.total_pages > responseJSON.page,
            additional: {
                page: page + 1
            }
        };
    };
    (0, $3aPmr.useEffect)(()=>{
        setCurrentPage(1);
        fetchData();
    }, [
        debouncedSearchTerm,
        clientId,
        reportName
    ]);
    (0, $3aPmr.useEffect)(()=>{
        fetchData();
    }, [
        page
    ]);
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $96253dbc841a0a6f$export$2e2bcd8739ae039), {
        breadcrumbs: [
            "Idiomas"
        ],
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
            className: "columns is-multiline",
            style: {
                margin: "1rem 0"
            },
            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                class: "column is-12",
                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "card events-card",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                            class: "card-header",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                    class: "card-header-title",
                                    children: "Reportes mas descargados"
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                    style: {
                                        width: "40%"
                                    },
                                    class: "card-header-icon",
                                    "aria-label": "more options",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ea3e1723cd1809aa$export$62ae509949bd1704), {
                                            isClearable: true,
                                            loadOptions: loadOptions,
                                            additional: {
                                                page: 1
                                            },
                                            // styles={{
                                            //   menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            // }}
                                            menuPortalTarget: document.body,
                                            onChange: (val)=>{
                                                if (val != null) setClientId(val?.value);
                                                else setClientId("");
                                            },
                                            placeholder: "Filtrar por cliente",
                                            styles: {
                                                container: (provided, state)=>({
                                                        ...provided,
                                                        width: "100%"
                                                    })
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ea3e1723cd1809aa$export$62ae509949bd1704), {
                                            isClearable: true,
                                            loadOptions: loadReportsOptions,
                                            additional: {
                                                page: 1
                                            },
                                            styles: {
                                                menuPortal: (base)=>({
                                                        ...base,
                                                        zIndex: 9999
                                                    })
                                            },
                                            menuPortalTarget: document.body,
                                            onChange: (val)=>{
                                                if (val != null) setReportName(val?.value);
                                                else setReportName("");
                                            },
                                            placeholder: "Filtrar por reporte",
                                            styles: {
                                                container: (provided, state)=>({
                                                        ...provided,
                                                        width: "100%",
                                                        marginLeft: '1rem'
                                                    })
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card-table",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                class: "content",
                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("table", {
                                    class: "table is-fullwidth is-striped",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("thead", {
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                        children: "Nombre"
                                                    }),
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                        children: "Cliente"
                                                    }),
                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                        children: "Veces descargados"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tbody", {
                                            children: data.records.length ? data.records.map((item)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                            children: item.name
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                            children: item.client
                                                        }),
                                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                            children: item.cnt
                                                        })
                                                    ]
                                                }, item.id)) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                style: "text-align: center;",
                                                children: "No hay datos para mostrar"
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("footer", {
                            class: "card-footer",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                style: {
                                    height: 40
                                }
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $8a660de9be0cb0e5$export$2e2bcd8739ae039 = $8a660de9be0cb0e5$var$Stats;



parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");





parcelRequire("7Do5B");




var $3aPmr = parcelRequire("3aPmr");


const $75fbb3e6694a28c1$var$TagModal = ({ activeModal: activeModal, handleClose: handleClose, reloadPage: reloadPage, id: id = null })=>{
    const { register: register, handleSubmit: handleSubmit, reset: reset, setValue: setValue, getValues: getValues, control: control } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)();
    const [data, setData] = (0, $3aPmr.useState)("");
    const isAddMode = !id;
    (0, $3aPmr.useEffect)(()=>{
        reset();
        if (!isAddMode) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/tags/${id}`).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            const fields = [
                "name",
                "icon",
                "translations",
                "order"
            ];
            fields.forEach((field)=>setValue(field, res[field]));
        });
    }, [
        id
    ]);
    const onSubmit = (data)=>{
        const url = "";
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/tags/${isAddMode ? "" : id}`, {
            method: isAddMode ? "POST" : "PUT",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            reset();
            reloadPage();
            handleClose();
        }).catch((error)=>{
            console.log(error);
        });
    };
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $847f4fd944f587cf$export$2e2bcd8739ae039), {
        active: activeModal,
        onClose: handleClose,
        title: isAddMode ? "Crear etiqueta" : "Editar etiqueta",
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("form", {
            id: "form",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Nombre"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                ...register("name"),
                                class: "input",
                                type: "text",
                                placeholder: "",
                                required: true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Icon"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                ...register("icon"),
                                class: "input",
                                type: "text",
                                placeholder: ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Orden"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                ...register("order", {
                                    valueAsNumber: true
                                }),
                                class: "input",
                                type: "number",
                                placeholder: ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Traducciones"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                name: "translations",
                                control: control,
                                rules: {
                                    required: false
                                },
                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $41f55b004dc4fc40$export$2e2bcd8739ae039), {
                                        ...field
                                    })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $75fbb3e6694a28c1$export$2e2bcd8739ae039 = $75fbb3e6694a28c1$var$TagModal;




const $151af9dadeb0a6d9$var$Tags = ()=>{
    const [data, setData] = (0, $3aPmr.useState)({
        records: [],
        total: 0,
        per_page: 20
    });
    const [query, setQuery] = (0, $3aPmr.useState)("");
    const [page, setCurrentPage] = (0, $3aPmr.useState)(1);
    const [activeModal, setActiveModal] = (0, $3aPmr.useState)(false);
    const [activeId, setActiveId] = (0, $3aPmr.useState)(null);
    const debouncedSearchTerm = (0, $f51453fda9f7f538$export$21805fee57372823)(query, 500);
    const handleClose = ()=>{
        setActiveModal(false);
        setActiveId(null);
    };
    const handleDelete = (id)=>{
        let result = confirm("\xbfEst\xe1 seguro de querer eliminar este objeto? ");
        if (result) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/subtags/${id}`, {
            method: "DELETE"
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            fetchData();
        });
    };
    const fetchData = ()=>{
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/tags/?page=${page}&q=${debouncedSearchTerm}`).then((resp)=>{
            if (resp.ok) return resp.json();
            throw new Error("something went wrong while requesting posts");
        }).then((data)=>setData(data));
    };
    (0, $3aPmr.useEffect)(()=>{
        setCurrentPage(1);
        fetchData();
    }, [
        debouncedSearchTerm
    ]);
    (0, $3aPmr.useEffect)(()=>{
        fetchData();
    }, [
        page
    ]);
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $96253dbc841a0a6f$export$2e2bcd8739ae039), {
        breadcrumbs: [
            "Etiquetas"
        ],
        searchBar: (e)=>setQuery(e.target.value),
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $75fbb3e6694a28c1$export$2e2bcd8739ae039), {
                activeModal: activeModal,
                handleClose: handleClose,
                reloadPage: fetchData,
                id: activeId
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                className: "columns is-multiline",
                style: {
                    margin: "1rem 0"
                },
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-12",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card events-card",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                            class: "card-header-title",
                                            children: "Etiquetas"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            class: "card-header-icon",
                                            "aria-label": "more options",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                    class: "fa fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "card-table",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "content",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("table", {
                                            class: "table is-fullwidth is-striped",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tbody", {
                                                children: data.records.length ? data.records.map((item)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                width: "5%"
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                children: item.name
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                class: "level-right actions",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-link",
                                                                        onClick: ()=>{
                                                                            setActiveId(item.id);
                                                                            setActiveModal(true);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Editar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "edit_note"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-danger",
                                                                        onClick: ()=>{
                                                                            handleDelete(item.id);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Eliminar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "delete"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, item.id)) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    style: "text-align: center;",
                                                    children: "No hay datos para mostrar"
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("footer", {
                                    class: "card-footer",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                        onClick: ()=>setActiveModal(true),
                                        class: "card-footer-item",
                                        children: "Crear etiqueta"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-12",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                            class: "card-header-title",
                                            children: "Paginas"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            class: "card-header-icon",
                                            "aria-label": "more options",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                    class: "fa fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "card-content",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $22b2f8f41c3b0593$export$2e2bcd8739ae039), {
                                            total: data.total,
                                            page: page,
                                            setCurrentPage: setCurrentPage,
                                            pageSize: data.per_page
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $151af9dadeb0a6d9$export$2e2bcd8739ae039 = $151af9dadeb0a6d9$var$Tags;



parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");





parcelRequire("7Do5B");




var $3aPmr = parcelRequire("3aPmr");



const $dc59f077aa110947$var$SubTagModal = ({ activeModal: activeModal, handleClose: handleClose, reloadPage: reloadPage, id: id = null })=>{
    const { register: register, handleSubmit: handleSubmit, reset: reset, setValue: setValue, getValues: getValues, control: control } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)();
    const [data, setData] = (0, $3aPmr.useState)("");
    const isAddMode = !id;
    (0, $3aPmr.useEffect)(()=>{
        reset({
            name: '',
            tag_id: ''
        });
        if (!isAddMode) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/subtags/${id}`).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            const fields = [
                "name",
                "icon",
                "translations",
                "order"
            ];
            fields.forEach((field)=>setValue(field, res[field]));
            if (res.tag_id) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/tags/${res.tag_id}`).then((res)=>{
                if (res.ok) return res.json();
                return Promise.reject(res);
            }).then((res)=>{
                // setComponents((prev) => [{ label: res.name, value: res.id }]);
                setValue("tag_id", {
                    label: res.name,
                    value: res.id
                });
            });
        });
    }, [
        id
    ]);
    const loadOptions = async (search, loadedOptions, { page: page })=>{
        const response = await (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/tags/?q=${search}&page=${page}`);
        const responseJSON = await response.json();
        const options = responseJSON.records.map((el)=>({
                value: el.id,
                label: el.name
            }));
        return {
            options: options,
            hasMore: responseJSON.total_pages > responseJSON.page,
            additional: {
                page: page + 1
            }
        };
    };
    const onSubmit = (data)=>{
        const url = "";
        data.tag_id = data.tag_id?.value ? data.tag_id.value : null;
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/subtags/${isAddMode ? "" : id}`, {
            method: isAddMode ? "POST" : "PUT",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            reset();
            reloadPage();
            handleClose();
        }).catch((error)=>{
            console.log(error);
        });
    };
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $847f4fd944f587cf$export$2e2bcd8739ae039), {
        active: activeModal,
        onClose: handleClose,
        title: isAddMode ? "Crear etiqueta" : "Editar etiqueta",
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("form", {
            id: "form",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Nombre"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                ...register("name"),
                                class: "input",
                                type: "text",
                                placeholder: "",
                                required: true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Icon"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                ...register("icon"),
                                class: "input",
                                type: "text",
                                placeholder: ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Etiqueta"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                name: "tag_id",
                                control: control,
                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ea3e1723cd1809aa$export$62ae509949bd1704), {
                                        inputRef: field.ref,
                                        isClearable: true,
                                        loadOptions: loadOptions,
                                        additional: {
                                            page: 1
                                        },
                                        styles: {
                                            menuPortal: (base)=>({
                                                    ...base,
                                                    zIndex: 9999
                                                })
                                        },
                                        menuPortalTarget: document.body,
                                        ...field
                                    })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Orden"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                ...register("order", {
                                    valueAsNumber: true
                                }),
                                class: "input",
                                type: "number",
                                placeholder: ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Traducciones"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                name: "translations",
                                control: control,
                                rules: {
                                    required: false
                                },
                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $41f55b004dc4fc40$export$2e2bcd8739ae039), {
                                        ...field
                                    })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $dc59f077aa110947$export$2e2bcd8739ae039 = $dc59f077aa110947$var$SubTagModal;




const $86c976f2ba6d02dd$var$SubTags = ()=>{
    const [data, setData] = (0, $3aPmr.useState)({
        records: [],
        total: 0,
        per_page: 20
    });
    const [query, setQuery] = (0, $3aPmr.useState)("");
    const [page, setCurrentPage] = (0, $3aPmr.useState)(1);
    const [activeModal, setActiveModal] = (0, $3aPmr.useState)(false);
    const [activeId, setActiveId] = (0, $3aPmr.useState)(null);
    const debouncedSearchTerm = (0, $f51453fda9f7f538$export$21805fee57372823)(query, 500);
    const handleClose = ()=>{
        setActiveModal(false);
        setActiveId(null);
    };
    const handleDelete = (id)=>{
        let result = confirm("\xbfEst\xe1 seguro de querer eliminar este objeto? ");
        if (result) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/subtags/${id}`, {
            method: "DELETE"
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            fetchData();
        });
    };
    const fetchData = ()=>{
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${(0, $9058870313d532dc$export$2d48554cdda41283)}/api/subtags/?page=${page}&q=${debouncedSearchTerm}`).then((resp)=>{
            if (resp.ok) return resp.json();
            throw new Error("something went wrong while requesting posts");
        }).then((data)=>setData(data));
    };
    (0, $3aPmr.useEffect)(()=>{
        setCurrentPage(1);
        fetchData();
    }, [
        debouncedSearchTerm
    ]);
    (0, $3aPmr.useEffect)(()=>{
        fetchData();
    }, [
        page
    ]);
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $96253dbc841a0a6f$export$2e2bcd8739ae039), {
        breadcrumbs: [
            "Etiquetas"
        ],
        searchBar: (e)=>setQuery(e.target.value),
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $dc59f077aa110947$export$2e2bcd8739ae039), {
                activeModal: activeModal,
                handleClose: handleClose,
                reloadPage: fetchData,
                id: activeId
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                className: "columns is-multiline",
                style: {
                    margin: "1rem 0"
                },
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-12",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card events-card",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                            class: "card-header-title",
                                            children: "Etiquetas"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            class: "card-header-icon",
                                            "aria-label": "more options",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                    class: "fa fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "card-table",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "content",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("table", {
                                            class: "table is-fullwidth is-striped",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tbody", {
                                                children: data.records.length ? data.records.map((item)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                width: "5%"
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                children: item.name
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                children: item.tag?.name
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                class: "level-right actions",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-link",
                                                                        onClick: ()=>{
                                                                            setActiveId(item.id);
                                                                            setActiveModal(true);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Editar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "edit_note"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-danger",
                                                                        onClick: ()=>{
                                                                            handleDelete(item.id);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Eliminar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "delete"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, item.id)) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    style: "text-align: center;",
                                                    children: "No hay datos para mostrar"
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("footer", {
                                    class: "card-footer",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                        onClick: ()=>setActiveModal(true),
                                        class: "card-footer-item",
                                        children: "Crear tipo etiqueta"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-12",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                            class: "card-header-title",
                                            children: "Paginas"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            class: "card-header-icon",
                                            "aria-label": "more options",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                    class: "fa fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "card-content",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $22b2f8f41c3b0593$export$2e2bcd8739ae039), {
                                            total: data.total,
                                            page: page,
                                            setCurrentPage: setCurrentPage,
                                            pageSize: data.per_page
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $86c976f2ba6d02dd$export$2e2bcd8739ae039 = $86c976f2ba6d02dd$var$SubTags;



parcelRequire("7Do5B");

var $3aPmr = parcelRequire("3aPmr");





parcelRequire("7Do5B");



var $3aPmr = parcelRequire("3aPmr");




const $d8a8822a841f2294$var$ParentReportModal = ({ activeModal: activeModal, handleClose: handleClose, reloadPage: reloadPage, id: id = null })=>{
    const { register: register, handleSubmit: handleSubmit, reset: reset, setValue: setValue, getValues: getValues, control: control } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)();
    const [data, setData] = (0, $3aPmr.useState)("");
    const [componentsRecord, setComponents] = (0, $3aPmr.useState)([]);
    const isAddMode = !id;
    (0, $3aPmr.useEffect)(()=>{
        reset({
            name: "",
            translations: [],
            icon: "",
            reports: []
        });
        if (!isAddMode) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${BASE_AUTH_URL}/api/parent-reports/${id}`).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            let data = {
                ...res
            };
            data.reports = data.reports.map((el)=>({
                    value: el.id,
                    label: `${el.id}: ${el.name}`
                }));
            reset(data);
        });
    }, [
        id
    ]);
    const loadOptionsReports = async (search, loadedOptions, { page: page })=>{
        const response = await (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${BASE_AUTH_URL}/api/reports/?q=${search}&page=${page}`);
        const responseJSON = await response.json();
        const options = responseJSON.records.map((el)=>({
                value: el.id,
                label: `${el.id}: ${el.name}`
            }));
        return {
            options: options,
            hasMore: responseJSON.total_pages > responseJSON.page,
            additional: {
                page: page + 1
            }
        };
    };
    const onSubmit = (data)=>{
        data.reports = data.reports ? data.reports.map((i)=>i.value) : [];
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${BASE_AUTH_URL}/api/parent-reports/${isAddMode ? "" : id}`, {
            method: isAddMode ? "POST" : "PUT",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            reset();
            reloadPage();
            handleClose();
        }).catch((error)=>{
            console.log(error);
        });
    };
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $847f4fd944f587cf$export$2e2bcd8739ae039), {
        active: activeModal,
        onClose: handleClose,
        title: isAddMode ? "Crear reporte padre" : "Editar reporte padre",
        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("form", {
            id: "form",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Nombre"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                ...register("name"),
                                class: "input",
                                type: "text",
                                placeholder: "",
                                required: true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Reportes a agrupar"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            className: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                                name: "reports",
                                control: control,
                                render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ea3e1723cd1809aa$export$62ae509949bd1704), {
                                        inputRef: field.ref,
                                        isMulti: true,
                                        isClearable: true,
                                        defaultOptions: true,
                                        placeholder: "Seleccione",
                                        loadOptions: loadOptionsReports,
                                        additional: {
                                            page: 1
                                        },
                                        styles: {
                                            menuPortal: (base)=>({
                                                    ...base,
                                                    zIndex: 9999
                                                })
                                        },
                                        menuPortalTarget: document.body,
                                        ...field
                                    })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    class: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Icon"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "control",
                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("input", {
                                ...register("icon"),
                                class: "input",
                                type: "text",
                                placeholder: ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                    className: "field",
                    children: [
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("label", {
                            class: "label",
                            children: "Traducciones"
                        }),
                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $ee9f4a2880885da1$export$bd0bf19f25da8474), {
                            name: "translations",
                            control: control,
                            render: ({ field: field })=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $41f55b004dc4fc40$export$2e2bcd8739ae039), {
                                    ...field
                                })
                        })
                    ]
                })
            ]
        })
    });
};
var $d8a8822a841f2294$export$2e2bcd8739ae039 = $d8a8822a841f2294$var$ParentReportModal;



// import ReportAssociatedModal from "./ReportAssociatedModal";
const $966f847869826ce7$var$ParentReport = ()=>{
    const [data, setData] = (0, $3aPmr.useState)({
        records: [],
        total: 0,
        per_page: 20
    });
    const [query, setQuery] = (0, $3aPmr.useState)("");
    const [page, setCurrentPage] = (0, $3aPmr.useState)(1);
    const [activeModal, setActiveModal] = (0, $3aPmr.useState)(false);
    const [activeModalReports, setActiveModalReports] = (0, $3aPmr.useState)(false);
    const [activeId, setActiveId] = (0, $3aPmr.useState)(null);
    const [activeFilterId, setActiveFilterId] = (0, $3aPmr.useState)(null);
    const debouncedSearchTerm = (0, $f51453fda9f7f538$export$21805fee57372823)(query, 500);
    const handleClose = ()=>{
        setActiveModal(false);
        setActiveId(null);
    };
    const handleDelete = (id)=>{
        let result = confirm("\xbfEst\xe1 seguro de querer eliminar este objeto? ");
        if (result) (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${BASE_AUTH_URL}/api/parent-reports/${id}`, {
            method: "DELETE"
        }).then((res)=>{
            if (res.ok) return res.json();
            return Promise.reject(res);
        }).then((res)=>{
            fetchData();
        });
    };
    const fetchData = ()=>{
        (0, $c683ce1247b5bc0f$export$7d6f1c8842f9f527)(`${BASE_AUTH_URL}/api/parent-reports?page=${page}&q=${debouncedSearchTerm}`).then((resp)=>{
            if (resp.ok) return resp.json();
            throw new Error("something went wrong while requesting posts");
        }).then((data)=>setData(data));
    };
    (0, $3aPmr.useEffect)(()=>{
        setCurrentPage(1);
        fetchData();
    }, [
        debouncedSearchTerm
    ]);
    (0, $3aPmr.useEffect)(()=>{
        fetchData();
    }, [
        page
    ]);
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $96253dbc841a0a6f$export$2e2bcd8739ae039), {
        breadcrumbs: [
            "Reporte padres"
        ],
        searchBar: (e)=>setQuery(e.target.value),
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $d8a8822a841f2294$export$2e2bcd8739ae039), {
                activeModal: activeModal,
                handleClose: handleClose,
                reloadPage: fetchData,
                id: activeId
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                className: "columns is-multiline",
                style: {
                    margin: "1rem 0"
                },
                children: [
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-12",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card events-card",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                            class: "card-header-title",
                                            children: "Reporte padres"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            class: "card-header-icon",
                                            "aria-label": "more options",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                    class: "fa fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "card-table",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "content",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("table", {
                                            class: "table is-fullwidth is-striped",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tbody", {
                                                children: data.records.length ? data.records.map((item)=>/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                width: "5%"
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                children: item.id
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                children: item.name
                                                            }),
                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("td", {
                                                                class: "level-right actions",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-link",
                                                                        onClick: ()=>{
                                                                            setActiveId(item.id);
                                                                            setActiveModal(true);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Editar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "edit_note"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                                                        class: "button is-small is-danger",
                                                                        onClick: ()=>{
                                                                            handleDelete(item.id);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $974023f5106cfc4f$export$2e2bcd8739ae039), {
                                                                                label: "Eliminar",
                                                                                className: "custom-class"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                                                class: "material-icons",
                                                                                children: "delete"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, item.id)) : /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                                    style: "text-align: center;",
                                                    children: "No hay datos para mostrar"
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("footer", {
                                    class: "card-footer",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                        onClick: ()=>setActiveModal(true),
                                        class: "card-footer-item",
                                        children: "Crear reporte padre"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                        class: "column is-12",
                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                            class: "card",
                            children: [
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("header", {
                                    class: "card-header",
                                    children: [
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("p", {
                                            class: "card-header-title",
                                            children: "Paginas"
                                        }),
                                        /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("a", {
                                            href: "#",
                                            class: "card-header-icon",
                                            "aria-label": "more options",
                                            children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("span", {
                                                class: "icon",
                                                children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("i", {
                                                    class: "fa fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                    class: "card-content",
                                    children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)("div", {
                                        class: "",
                                        children: /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $22b2f8f41c3b0593$export$2e2bcd8739ae039), {
                                            total: data.total,
                                            page: page,
                                            setCurrentPage: setCurrentPage,
                                            pageSize: data.per_page
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $966f847869826ce7$export$2e2bcd8739ae039 = $966f847869826ce7$var$ParentReport;




const $9620bbb19fa433cf$var$App = ()=>{
    const [logged, user] = (0, $c683ce1247b5bc0f$export$1d39dc5b47e56ff0)();
    window.route = (0, $8ea79db61ca199dd$export$4cb887bfde2d34ca);
    const handleRoute = async (e)=>{
        switch(e.url){
            case "/login":
                if (logged) window.location = "/";
                break;
            default:
                if (!logged) window.location = "/login";
                break;
        }
    };
    return /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $8ea79db61ca199dd$export$55185c17a0fcbe46), {
        onChange: handleRoute,
        children: [
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $839564c0329102fb$export$2e2bcd8739ae039), {
                path: "/"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $6121a41e444fe2dd$export$2e2bcd8739ae039), {
                path: "/reports/create"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $6121a41e444fe2dd$export$2e2bcd8739ae039), {
                path: "/reports/:id"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $c8a2791dfdeb5f9f$export$2e2bcd8739ae039), {
                path: "/headers"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $f87035bfae577eb4$export$2e2bcd8739ae039), {
                path: "/filters"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $23c087672af69edd$export$2e2bcd8739ae039), {
                path: "/components"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $239abe524f91bfbc$export$2e2bcd8739ae039), {
                path: "/modules"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $3f823b58b57b959d$export$2e2bcd8739ae039), {
                path: "/languages"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $141b77e5e3cca606$export$2e2bcd8739ae039), {
                path: "/words"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $678b6c90cdf41276$export$2e2bcd8739ae039), {
                path: "/login"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $8a660de9be0cb0e5$export$2e2bcd8739ae039), {
                path: "/stats"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $151af9dadeb0a6d9$export$2e2bcd8739ae039), {
                path: "/tags"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $86c976f2ba6d02dd$export$2e2bcd8739ae039), {
                path: "/subtags"
            }),
            /*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)((0, $966f847869826ce7$export$2e2bcd8739ae039), {
                path: "/parent-reports"
            })
        ]
    });
};
if (typeof window != "undefined") (0, $7Do5B.render)(/*#__PURE__*/ (0, $eb3c8b789a252a22$export$34b9dba7ce09269b)($9620bbb19fa433cf$var$App, {}), document.body);


//# sourceMappingURL=frontend.cd1de136.js.map
